(() => {

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirede76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirede76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ed1Y9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9nxiT = parcelRequire("9nxiT");

var $f05NK = parcelRequire("f05NK");

var $jJcuV = parcelRequire("jJcuV");

var $dJMCu = parcelRequire("dJMCu");

var $2BhuU = parcelRequire("2BhuU");

var $3pcOx = parcelRequire("3pcOx");

var $lRCeh = parcelRequire("lRCeh");

var $3Yf0L = parcelRequire("3Yf0L");

var $evhDU = parcelRequire("evhDU");

var $kEMy6 = parcelRequire("kEMy6");

var $7aZG6 = parcelRequire("7aZG6");

var $a6Ys8 = parcelRequire("a6Ys8");

var $N7Tmw = parcelRequire("N7Tmw");

var $k6VdG = parcelRequire("k6VdG");

var $i8C0r = parcelRequire("i8C0r");

var $2cngX = parcelRequire("2cngX");

var $gCYmH = parcelRequire("gCYmH");

var $8CHry = parcelRequire("8CHry");

var $2dzy9 = parcelRequire("2dzy9");

var $I6lHc = parcelRequire("I6lHc");

var $aWGVj = parcelRequire("aWGVj");

var $1APeO = parcelRequire("1APeO");

var $gIF8m = parcelRequire("gIF8m");

var $jbCp4 = parcelRequire("jbCp4");

var $aPqYD = parcelRequire("aPqYD");

var $e2vD1 = parcelRequire("e2vD1");

var $b0iHJ = parcelRequire("b0iHJ");

var $7aPAx = parcelRequire("7aPAx");

var $5ukQO = parcelRequire("5ukQO");

var $4nmYL = parcelRequire("4nmYL");

var $d8ZGm = parcelRequire("d8ZGm");

var $hv9ui = parcelRequire("hv9ui");

var $WeqOl = parcelRequire("WeqOl");

var $64qGE = parcelRequire("64qGE");

var $enbOh = parcelRequire("enbOh");

var $imTzm = parcelRequire("imTzm");

var $fZWeW = parcelRequire("fZWeW");

var $jFQNE = parcelRequire("jFQNE");

var $5OzGJ = parcelRequire("5OzGJ");

var $fe1rL = parcelRequire("fe1rL");

var $5aMPP = parcelRequire("5aMPP");

var $8Zztp = parcelRequire("8Zztp");

var $1TQ1B = parcelRequire("1TQ1B");

var $iTLX9 = parcelRequire("iTLX9");

var $jk159 = parcelRequire("jk159");

var $frwYY = parcelRequire("frwYY");

var $cp5Iu = parcelRequire("cp5Iu");

var $6dWkJ = parcelRequire("6dWkJ");

var $9cJmP = parcelRequire("9cJmP");

var $kYm42 = parcelRequire("kYm42");

var $9jzbe = parcelRequire("9jzbe");

var $1r6fB = parcelRequire("1r6fB");

var $jGglq = parcelRequire("jGglq");

var $dktGB = parcelRequire("dktGB");

var $9zDKz = parcelRequire("9zDKz");

var $2aD4H = parcelRequire("2aD4H");

var $bVGYr = parcelRequire("bVGYr");

var $28n4F = parcelRequire("28n4F");

var $eY9yC = parcelRequire("eY9yC");

var $d49ib = parcelRequire("d49ib");

var $3Kc8d = parcelRequire("3Kc8d");

var $liFOz = parcelRequire("liFOz");

var $1WaGZ = parcelRequire("1WaGZ");

var $jOAeS = parcelRequire("jOAeS");

var $9LdTh = parcelRequire("9LdTh");

var $2fKva = parcelRequire("2fKva");

var $71aIk = parcelRequire("71aIk");

var $j5zO3 = parcelRequire("j5zO3");

var $cRLD0 = parcelRequire("cRLD0");

var $dZBM3 = parcelRequire("dZBM3");

var $9cy9e = parcelRequire("9cy9e");

var $fSMJB = parcelRequire("fSMJB");

var $j1udx = parcelRequire("j1udx");

var $fifp5 = parcelRequire("fifp5");

var $j5pZS = parcelRequire("j5pZS");

var $iMQu3 = parcelRequire("iMQu3");

var $CBTQ9 = parcelRequire("CBTQ9");

var $2vt6q = parcelRequire("2vt6q");

var $8wtnp = parcelRequire("8wtnp");

var $eS4SN = parcelRequire("eS4SN");

var $3Uk1I = parcelRequire("3Uk1I");

var $cg7BP = parcelRequire("cg7BP");

var $a4GKN = parcelRequire("a4GKN");

var $bBt1V = parcelRequire("bBt1V");

var $aO2R9 = parcelRequire("aO2R9");

var $aNBhO = parcelRequire("aNBhO");

var $7GCmi = parcelRequire("7GCmi");

var $d6car = parcelRequire("d6car");

var $ltJYC = parcelRequire("ltJYC");

var $bSxUW = parcelRequire("bSxUW");

var $kaBsx = parcelRequire("kaBsx");

var $krArI = parcelRequire("krArI");

var $1LKse = parcelRequire("1LKse");

var $73dnt = parcelRequire("73dnt");

var $j4ReY = parcelRequire("j4ReY");

var $6D6aY = parcelRequire("6D6aY");

var $jvme1 = parcelRequire("jvme1");

var $avYn4 = parcelRequire("avYn4");

var $1qWJ6 = parcelRequire("1qWJ6");

var $eLbXf = parcelRequire("eLbXf");

var $5m5Jk = parcelRequire("5m5Jk");

var $kj7kP = parcelRequire("kj7kP");

var $wmosz = parcelRequire("wmosz");

var $kuI03 = parcelRequire("kuI03");

var $88VYb = parcelRequire("88VYb");

var $4F8JB = parcelRequire("4F8JB");

var $1hqpt = parcelRequire("1hqpt");

var $iIaFt = parcelRequire("iIaFt");

var $3tSid = parcelRequire("3tSid");

var $kjL8z = parcelRequire("kjL8z");

var $49QLh = parcelRequire("49QLh");

var $il8gQ = parcelRequire("il8gQ");

var $ijRD7 = parcelRequire("ijRD7");

var $39Wab = parcelRequire("39Wab");

var $gtIHY = parcelRequire("gtIHY");

var $c34Je = parcelRequire("c34Je");

var $gwBtZ = parcelRequire("gwBtZ");

var $99stL = parcelRequire("99stL");

var $f3q6O = parcelRequire("f3q6O");

var $3COzy = parcelRequire("3COzy");

var $acdDE = parcelRequire("acdDE");

var $1hzu4 = parcelRequire("1hzu4");

var $he37X = parcelRequire("he37X");

var $7OqzK = parcelRequire("7OqzK");

var $9fWDF = parcelRequire("9fWDF");

var $617mT = parcelRequire("617mT");

var $66leG = parcelRequire("66leG");

var $fdTwu = parcelRequire("fdTwu");

var $bbV3P = parcelRequire("bbV3P");

var $ecsQy = parcelRequire("ecsQy");

var $dVZms = parcelRequire("dVZms");

var $h5NbM = parcelRequire("h5NbM");

var $bL5Rk = parcelRequire("bL5Rk");

var $l008j = parcelRequire("l008j");

var $h7TA9 = parcelRequire("h7TA9");

var $43wkw = parcelRequire("43wkw");

var $gCbFP = parcelRequire("gCbFP");

var $iHmco = parcelRequire("iHmco");

var $6O0Z2 = parcelRequire("6O0Z2");

var $cAIWv = parcelRequire("cAIWv");

var $IRlr7 = parcelRequire("IRlr7");

var $720Iz = parcelRequire("720Iz");

var $7b6bE = parcelRequire("7b6bE");

var $doSiu = parcelRequire("doSiu");

var $gA0uF = parcelRequire("gA0uF");

var $9gcfE = parcelRequire("9gcfE");

var $kwHFm = parcelRequire("kwHFm");

var $jDmEx = parcelRequire("jDmEx");
module.exports.registerSpanErrorInstrumentation = $9nxiT.registerSpanErrorInstrumentation;
module.exports.getCapturedScopesOnSpan = $f05NK.getCapturedScopesOnSpan;
module.exports.markSpanForOtelSourceInference = $f05NK.markSpanForOtelSourceInference;
module.exports.setCapturedScopesOnSpan = $f05NK.setCapturedScopesOnSpan;
module.exports.spanShouldInferOtelSource = $f05NK.spanShouldInferOtelSource;
module.exports.TRACING_DEFAULTS = $jJcuV.TRACING_DEFAULTS;
module.exports.startIdleSpan = $jJcuV.startIdleSpan;
module.exports.SentrySpan = $dJMCu.SentrySpan;
module.exports.SentryNonRecordingSpan = $2BhuU.SentryNonRecordingSpan;
module.exports.SPAN_STATUS_ERROR = $3pcOx.SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $3pcOx.SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $3pcOx.SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $3pcOx.getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $3pcOx.setHttpStatus;
module.exports.SUPPRESS_TRACING_KEY = $lRCeh.SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $lRCeh.continueTrace;
module.exports.isTracingSuppressed = $lRCeh.isTracingSuppressed;
module.exports.startInactiveSpan = $lRCeh.startInactiveSpan;
module.exports.startNewTrace = $lRCeh.startNewTrace;
module.exports.startSpan = $lRCeh.startSpan;
module.exports.startSpanManual = $lRCeh.startSpanManual;
module.exports.suppressTracing = $lRCeh.suppressTracing;
module.exports.withActiveSpan = $lRCeh.withActiveSpan;
module.exports.bindScopeToEmitter = $3Yf0L.bindScopeToEmitter;
module.exports.getDynamicSamplingContextFromClient = $evhDU.getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $evhDU.getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $evhDU.getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $evhDU.spanToBaggageHeader;
module.exports.setMeasurement = $kEMy6.setMeasurement;
module.exports.timedEventsToMeasurements = $kEMy6.timedEventsToMeasurements;
module.exports.sampleSpan = $7aZG6.sampleSpan;
module.exports.logSpanEnd = $a6Ys8.logSpanEnd;
module.exports.logSpanStart = $a6Ys8.logSpanStart;
module.exports.captureSpan = $N7Tmw.captureSpan;
module.exports.safeSetSpanJSONAttributes = $N7Tmw.safeSetSpanJSONAttributes;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $k6VdG.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $k6VdG.SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $k6VdG.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $k6VdG.SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $k6VdG.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $k6VdG.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $k6VdG.SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = $k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $k6VdG.SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $k6VdG.SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $k6VdG.SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $k6VdG.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $k6VdG.SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $k6VdG.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
module.exports.createEventEnvelope = $i8C0r.createEventEnvelope;
module.exports.createSessionEnvelope = $i8C0r.createSessionEnvelope;
module.exports.createSpanEnvelope = $i8C0r.createSpanEnvelope;
module.exports.addEventProcessor = $2cngX.addEventProcessor;
module.exports.captureCheckIn = $2cngX.captureCheckIn;
module.exports.captureEvent = $2cngX.captureEvent;
module.exports.captureException = $2cngX.captureException;
module.exports.captureMessage = $2cngX.captureMessage;
module.exports.captureSession = $2cngX.captureSession;
module.exports.close = $2cngX.close;
module.exports.endSession = $2cngX.endSession;
module.exports.flush = $2cngX.flush;
module.exports.isEnabled = $2cngX.isEnabled;
module.exports.isInitialized = $2cngX.isInitialized;
module.exports.lastEventId = $2cngX.lastEventId;
module.exports.setAttribute = $2cngX.setAttribute;
module.exports.setAttributes = $2cngX.setAttributes;
module.exports.setContext = $2cngX.setContext;
module.exports.setConversationId = $2cngX.setConversationId;
module.exports.setExtra = $2cngX.setExtra;
module.exports.setExtras = $2cngX.setExtras;
module.exports.setTag = $2cngX.setTag;
module.exports.setTags = $2cngX.setTags;
module.exports.setUser = $2cngX.setUser;
module.exports.startSession = $2cngX.startSession;
module.exports.withMonitor = $2cngX.withMonitor;
module.exports.getClient = $gCYmH.getClient;
module.exports.getCurrentScope = $gCYmH.getCurrentScope;
module.exports.getExternalPropagationContext = $gCYmH.getExternalPropagationContext;
module.exports.getGlobalScope = $gCYmH.getGlobalScope;
module.exports.getIsolationScope = $gCYmH.getIsolationScope;
module.exports.getTraceContextFromScope = $gCYmH.getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $gCYmH.hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $gCYmH.registerExternalPropagationContext;
module.exports.withIsolationScope = $gCYmH.withIsolationScope;
module.exports.withScope = $gCYmH.withScope;
module.exports.getDefaultCurrentScope = $8CHry.getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $8CHry.getDefaultIsolationScope;
module.exports.getAsyncContextStrategy = $2dzy9.getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $2dzy9.setAsyncContextStrategy;
module.exports._INTERNAL_createTracingChannelBinding = $I6lHc._INTERNAL_createTracingChannelBinding;
module.exports.waitForTracingChannelBinding = $I6lHc.waitForTracingChannelBinding;
module.exports.getGlobalSingleton = $aWGVj.getGlobalSingleton;
module.exports.getMainCarrier = $aWGVj.getMainCarrier;
module.exports.closeSession = $1APeO.closeSession;
module.exports.makeSession = $1APeO.makeSession;
module.exports.updateSession = $1APeO.updateSession;
module.exports.Scope = $gIF8m.Scope;
module.exports.notifyEventProcessors = $jbCp4.notifyEventProcessors;
module.exports.SENTRY_API_VERSION = $aPqYD.SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $aPqYD.getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $aPqYD.getReportDialogEndpoint;
module.exports.Client = $e2vD1.Client;
module.exports.initAndBind = $b0iHJ.initAndBind;
module.exports.setCurrentClient = $b0iHJ.setCurrentClient;
module.exports.createTransport = $7aPAx.createTransport;
module.exports.makeOfflineTransport = $5ukQO.makeOfflineTransport;
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $4nmYL.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.makeMultiplexedTransport = $4nmYL.makeMultiplexedTransport;
module.exports.addIntegration = $d8ZGm.addIntegration;
module.exports.defineIntegration = $d8ZGm.defineIntegration;
module.exports.extendIntegration = $d8ZGm.extendIntegration;
module.exports.getIntegrationsToSetup = $d8ZGm.getIntegrationsToSetup;
module.exports.installedIntegrations = $d8ZGm.installedIntegrations;
module.exports._INTERNAL_clearAiProviderSkips = $hv9ui._INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $hv9ui._INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $hv9ui._INTERNAL_skipAiProviderWrapping;
module.exports._INTERNAL_filterKeyValueData = $WeqOl.filterKeyValueData;
module.exports._INTERNAL_filterCookies = $64qGE.filterCookies;
module.exports._INTERNAL_filterQueryParams = $enbOh.filterQueryParams;
module.exports.envToBool = $imTzm.envToBool;
module.exports.applyScopeDataToEvent = $fZWeW.applyScopeDataToEvent;
module.exports.getCombinedScopeData = $fZWeW.getCombinedScopeData;
module.exports.mergeScopeData = $fZWeW.mergeScopeData;
module.exports.prepareEvent = $jFQNE.prepareEvent;
module.exports.createCheckInEnvelope = $5OzGJ.createCheckInEnvelope;
module.exports.hasSpansEnabled = $fe1rL.hasSpansEnabled;
module.exports.isStreamedBeforeSendSpanCallback = $5aMPP.isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $5aMPP.withStreamedSpan;
module.exports.isSentryRequestUrl = $8Zztp.isSentryRequestUrl;
module.exports.handleCallbackErrors = $1TQ1B.handleCallbackErrors;
module.exports.fmt = $iTLX9.fmt;
module.exports.parameterize = $iTLX9.parameterize;
module.exports.handleTunnelRequest = $jk159.handleTunnelRequest;
module.exports.addAutoIpAddressToSession = $frwYY.addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $frwYY.addAutoIpAddressToUser;
module.exports.INTERNAL_getSegmentSpan = $cp5Iu.INTERNAL_getSegmentSpan;
module.exports.addChildSpanToSpan = $cp5Iu.addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $cp5Iu.convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $cp5Iu.getActiveSpan;
module.exports.getRootSpan = $cp5Iu.getRootSpan;
module.exports.getSpanDescendants = $cp5Iu.getSpanDescendants;
module.exports.getStatusMessage = $cp5Iu.getStatusMessage;
module.exports.spanIsSampled = $cp5Iu.spanIsSampled;
module.exports.spanTimeInputToSeconds = $cp5Iu.spanTimeInputToSeconds;
module.exports.spanToJSON = $cp5Iu.spanToJSON;
module.exports.spanToStreamedSpanJSON = $cp5Iu.spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $cp5Iu.spanToTraceContext;
module.exports.spanToTraceHeader = $cp5Iu.spanToTraceHeader;
module.exports.updateSpanName = $cp5Iu.updateSpanName;
module.exports._INTERNAL_setSpanForScope = $6dWkJ._setSpanForScope;
module.exports.parseSampleRate = $9cJmP.parseSampleRate;
module.exports.applySdkMetadata = $kYm42.applySdkMetadata;
module.exports.getTraceData = $9jzbe.getTraceData;
module.exports.shouldPropagateTraceForUrl = $1r6fB.shouldPropagateTraceForUrl;
module.exports.getTraceMetaTags = $jGglq.getTraceMetaTags;
module.exports.debounce = $dktGB.debounce;
module.exports.derefWeakRef = $9zDKz.derefWeakRef;
module.exports.makeWeakRef = $9zDKz.makeWeakRef;
module.exports.shouldIgnoreSpan = $2aD4H.shouldIgnoreSpan;
module.exports.MAX_BODY_BYTE_LENGTH = $bVGYr.MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $bVGYr.captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $bVGYr.extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $bVGYr.getMaxBodyByteLength;
module.exports.headersToDict = $bVGYr.headersToDict;
module.exports.httpHeadersToSpanAttributes = $bVGYr.httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $bVGYr.httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $bVGYr.winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $bVGYr.winterCGRequestToRequestData;
module.exports.DEFAULT_ENVIRONMENT = $28n4F.DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $28n4F.DEV_ENVIRONMENT;
module.exports.SPAN_KIND = $eY9yC.SPAN_KIND;
module.exports.spanKindToName = $eY9yC.spanKindToName;
module.exports.addBreadcrumb = $d49ib.addBreadcrumb;
module.exports.functionToStringIntegration = $3Kc8d.functionToStringIntegration;
module.exports.eventFiltersIntegration = $liFOz.eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $liFOz.inboundFiltersIntegration;
module.exports.linkedErrorsIntegration = $1WaGZ.linkedErrorsIntegration;
module.exports.moduleMetadataIntegration = $jOAeS.moduleMetadataIntegration;
module.exports.requestDataIntegration = $9LdTh.requestDataIntegration;
module.exports.captureConsoleIntegration = $2fKva.captureConsoleIntegration;
module.exports.dedupeIntegration = $71aIk.dedupeIntegration;
module.exports.extraErrorDataIntegration = $j5zO3.extraErrorDataIntegration;
module.exports.rewriteFramesIntegration = $cRLD0.rewriteFramesIntegration;
module.exports.instrumentSupabaseClient = $dZBM3.instrumentSupabaseClient;
module.exports.supabaseIntegration = $dZBM3.supabaseIntegration;
module.exports.zodErrorsIntegration = $9cy9e.zodErrorsIntegration;
module.exports.thirdPartyErrorFilterIntegration = $fSMJB.thirdPartyErrorFilterIntegration;
module.exports.consoleIntegration = $j1udx.consoleIntegration;
module.exports.featureFlagsIntegration = $fifp5.featureFlagsIntegration;
module.exports.growthbookIntegration = $j5pZS.growthbookIntegration;
module.exports.conversationIdIntegration = $iMQu3.conversationIdIntegration;
module.exports.profiler = $CBTQ9.profiler;
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $2vt6q._INTERNAL_getTracingHeadersForFetchRequest;
module.exports.instrumentFetchRequest = $2vt6q.instrumentFetchRequest;
module.exports.captureFeedback = $8wtnp.captureFeedback;
module.exports._INTERNAL_captureLog = $eS4SN._INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $eS4SN._INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $eS4SN._INTERNAL_flushLogsBuffer;
module.exports.logger = $3Uk1I;
module.exports.consoleLoggingIntegration = $cg7BP.consoleLoggingIntegration;
module.exports._INTERNAL_captureMetric = $a4GKN._INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $a4GKN._INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $a4GKN._INTERNAL_flushMetricsBuffer;
module.exports.metrics = $bBt1V;
module.exports.createConsolaReporter = $aO2R9.createConsolaReporter;
module.exports.addVercelAiProcessors = $aNBhO.addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $aNBhO.getProviderMetadataAttributes;
module.exports.getTruncatedJsonString = $7GCmi.getTruncatedJsonString;
module.exports.shouldEnableTruncation = $7GCmi.shouldEnableTruncation;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $d6car.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $d6car.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports._INTERNAL_cleanupToolCallSpanContext = $ltJYC._INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $ltJYC._INTERNAL_getSpanContextForToolCallId;
module.exports._INTERNAL_toolCallSpanContextMap = $bSxUW.toolCallSpanContextMap;
module.exports.instrumentOpenAiClient = $kaBsx.instrumentOpenAiClient;
module.exports.OPENAI_INTEGRATION_NAME = $krArI.OPENAI_INTEGRATION_NAME;
module.exports.instrumentAnthropicAiClient = $1LKse.instrumentAnthropicAiClient;
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $73dnt.ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.instrumentGoogleGenAIClient = $j4ReY.instrumentGoogleGenAIClient;
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $6D6aY.GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.createLangChainCallbackHandler = $jvme1.createLangChainCallbackHandler;
module.exports._INTERNAL_mergeLangChainCallbackHandler = $avYn4._INTERNAL_mergeLangChainCallbackHandler;
module.exports.LANGCHAIN_INTEGRATION_NAME = $1qWJ6.LANGCHAIN_INTEGRATION_NAME;
module.exports.instrumentCreateReactAgent = $eLbXf.instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $eLbXf.instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $eLbXf.instrumentStateGraphCompile;
module.exports.LANGGRAPH_INTEGRATION_NAME = $5m5Jk.LANGGRAPH_INTEGRATION_NAME;
module.exports.SpanBuffer = $kj7kP.SpanBuffer;
module.exports.hasSpanStreamingEnabled = $wmosz.hasSpanStreamingEnabled;
module.exports.spanStreamingIntegration = $kuI03.spanStreamingIntegration;
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $88VYb._INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $88VYb._INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $88VYb._INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $88VYb._INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $88VYb._INTERNAL_insertFlagToScope;
module.exports.applyAggregateErrorsToEvent = $4F8JB.applyAggregateErrorsToEvent;
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $1hqpt.getBreadcrumbLogLevelFromHttpStatusCode;
module.exports.dsnFromString = $iIaFt.dsnFromString;
module.exports.dsnToString = $iIaFt.dsnToString;
module.exports.makeDsn = $iIaFt.makeDsn;
module.exports.SentryError = $3tSid.SentryError;
module.exports.GLOBAL_OBJ = $kjL8z.GLOBAL_OBJ;
module.exports.addConsoleInstrumentationFilter = $49QLh.addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $49QLh.addConsoleInstrumentationHandler;
module.exports.addFetchEndInstrumentationHandler = $il8gQ.addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $il8gQ.addFetchInstrumentationHandler;
module.exports.addGlobalErrorInstrumentationHandler = $ijRD7.addGlobalErrorInstrumentationHandler;
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $39Wab.addGlobalUnhandledRejectionInstrumentationHandler;
module.exports.addHandler = $gtIHY.addHandler;
module.exports.maybeInstrument = $gtIHY.maybeInstrument;
module.exports.resetInstrumentationHandlers = $gtIHY.resetInstrumentationHandlers;
module.exports.triggerHandlers = $gtIHY.triggerHandlers;
module.exports.isDOMError = $c34Je.isDOMError;
module.exports.isDOMException = $c34Je.isDOMException;
module.exports.isElement = $c34Je.isElement;
module.exports.isError = $c34Je.isError;
module.exports.isErrorEvent = $c34Je.isErrorEvent;
module.exports.isEvent = $c34Je.isEvent;
module.exports.isInstanceOf = $c34Je.isInstanceOf;
module.exports.isParameterizedString = $c34Je.isParameterizedString;
module.exports.isPlainObject = $c34Je.isPlainObject;
module.exports.isPrimitive = $c34Je.isPrimitive;
module.exports.isRegExp = $c34Je.isRegExp;
module.exports.isString = $c34Je.isString;
module.exports.isSyntheticEvent = $c34Je.isSyntheticEvent;
module.exports.isThenable = $c34Je.isThenable;
module.exports.isVueViewModel = $c34Je.isVueViewModel;
module.exports.isBrowser = $gwBtZ.isBrowser;
module.exports.CONSOLE_LEVELS = $99stL.CONSOLE_LEVELS;
module.exports.consoleSandbox = $99stL.consoleSandbox;
module.exports.debug = $99stL.debug;
module.exports.originalConsoleMethods = $99stL.originalConsoleMethods;
module.exports.addContextToFrame = $f3q6O.addContextToFrame;
module.exports.addExceptionMechanism = $f3q6O.addExceptionMechanism;
module.exports.addExceptionTypeValue = $f3q6O.addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $f3q6O.checkOrSetAlreadyCaught;
module.exports.getEventDescription = $f3q6O.getEventDescription;
module.exports.isAlreadyCaptured = $f3q6O.isAlreadyCaptured;
module.exports.parseSemver = $f3q6O.parseSemver;
module.exports.uuid4 = $f3q6O.uuid4;
module.exports.normalize = $3COzy.normalize;
module.exports.normalizeToSize = $3COzy.normalizeToSize;
module.exports.normalizeUrlToBase = $3COzy.normalizeUrlToBase;
module.exports.setNormalizeStringifier = $3COzy.setNormalizeStringifier;
module.exports.setNormalizationDepthOverrideHint = $acdDE.setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $acdDE.setSkipNormalizationHint;
module.exports.addNonEnumerableProperty = $1hzu4.addNonEnumerableProperty;
module.exports.convertToPlainObject = $1hzu4.convertToPlainObject;
module.exports.dropUndefinedKeys = $1hzu4.dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $1hzu4.extractExceptionKeysForMessage;
module.exports.fill = $1hzu4.fill;
module.exports.getOriginalFunction = $1hzu4.getOriginalFunction;
module.exports.markFunctionWrapped = $1hzu4.markFunctionWrapped;
module.exports.objectify = $1hzu4.objectify;
module.exports.basename = $he37X.basename;
module.exports.dirname = $he37X.dirname;
module.exports.isAbsolute = $he37X.isAbsolute;
module.exports.join = $he37X.join;
module.exports.normalizePath = $he37X.normalizePath;
module.exports.relative = $he37X.relative;
module.exports.resolve = $he37X.resolve;
module.exports.SENTRY_BUFFER_FULL_ERROR = $7OqzK.SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $7OqzK.makePromiseBuffer;
module.exports.severityLevelFromString = $9fWDF.severityLevelFromString;
module.exports.replaceExports = $617mT.replaceExports;
module.exports.UNKNOWN_FUNCTION = $66leG.UNKNOWN_FUNCTION;
module.exports.createStackParser = $66leG.createStackParser;
module.exports.getFramesFromEvent = $66leG.getFramesFromEvent;
module.exports.getFunctionName = $66leG.getFunctionName;
module.exports.stackParserFromStackParserOptions = $66leG.stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $66leG.stripSentryFramesAndReverse;
module.exports.isMatchingPattern = $fdTwu.isMatchingPattern;
module.exports.safeJoin = $fdTwu.safeJoin;
module.exports.snipLine = $fdTwu.snipLine;
module.exports.stringMatchesSomePattern = $fdTwu.stringMatchesSomePattern;
module.exports.truncate = $fdTwu.truncate;
module.exports.isNativeFunction = $bbV3P.isNativeFunction;
module.exports.supportsDOMError = $bbV3P.supportsDOMError;
module.exports.supportsDOMException = $bbV3P.supportsDOMException;
module.exports.supportsErrorEvent = $bbV3P.supportsErrorEvent;
module.exports.supportsFetch = $bbV3P.supportsFetch;
module.exports.supportsHistory = $bbV3P.supportsHistory;
module.exports.supportsNativeFetch = $bbV3P.supportsNativeFetch;
module.exports.supportsReferrerPolicy = $bbV3P.supportsReferrerPolicy;
module.exports.supportsReportingObserver = $bbV3P.supportsReportingObserver;
module.exports.SyncPromise = $ecsQy.SyncPromise;
module.exports.rejectedSyncPromise = $ecsQy.rejectedSyncPromise;
module.exports.resolvedSyncPromise = $ecsQy.resolvedSyncPromise;
module.exports.browserPerformanceTimeOrigin = $dVZms.browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $dVZms.dateTimestampInSeconds;
module.exports.timestampInSeconds = $dVZms.timestampInSeconds;
module.exports.TRACEPARENT_REGEXP = $h5NbM.TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $h5NbM.extractTraceparentData;
module.exports.generateSentryTraceHeader = $h5NbM.generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $h5NbM.generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $h5NbM.propagationContextFromHeaders;
module.exports.shouldContinueTrace = $h5NbM.shouldContinueTrace;
module.exports.getSDKSource = $bL5Rk.getSDKSource;
module.exports.isBrowserBundle = $bL5Rk.isBrowserBundle;
module.exports.addItemToEnvelope = $l008j.addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $l008j.createAttachmentEnvelopeItem;
module.exports.createEnvelope = $l008j.createEnvelope;
module.exports.createEventEnvelopeHeaders = $l008j.createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $l008j.createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $l008j.envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $l008j.envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $l008j.forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $l008j.getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $l008j.parseEnvelope;
module.exports.serializeEnvelope = $l008j.serializeEnvelope;
module.exports.createClientReportEnvelope = $h7TA9.createClientReportEnvelope;
module.exports.DEFAULT_RETRY_AFTER = $43wkw.DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $43wkw.disabledUntil;
module.exports.isRateLimited = $43wkw.isRateLimited;
module.exports.parseRetryAfterHeader = $43wkw.parseRetryAfterHeader;
module.exports.updateRateLimits = $43wkw.updateRateLimits;
module.exports.MAX_BAGGAGE_STRING_LENGTH = $gCbFP.MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $gCbFP.SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $gCbFP.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $gCbFP.baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $gCbFP.dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $gCbFP.mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $gCbFP.objectToBaggageHeader;
module.exports.parseBaggageHeader = $gCbFP.parseBaggageHeader;
module.exports.getHttpSpanDetailsFromUrlObject = $iHmco.getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $iHmco.getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $iHmco.getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $iHmco.isURLObjectRelative;
module.exports.parseStringToURLObject = $iHmco.parseStringToURLObject;
module.exports.parseUrl = $iHmco.parseUrl;
module.exports.stripDataUrlContent = $iHmco.stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $iHmco.stripUrlQueryAndFragment;
module.exports._INTERNAL_enhanceErrorWithSentryInfo = $6O0Z2._enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $6O0Z2.eventFromMessage;
module.exports.eventFromUnknownInput = $6O0Z2.eventFromUnknownInput;
module.exports.exceptionFromError = $6O0Z2.exceptionFromError;
module.exports.parseStackFrames = $6O0Z2.parseStackFrames;
module.exports.LRUMap = $cAIWv.LRUMap;
module.exports.generateSpanId = $IRlr7.generateSpanId;
module.exports.generateTraceId = $IRlr7.generateTraceId;
module.exports.SDK_VERSION = $720Iz.SDK_VERSION;
module.exports.getDebugImagesForResources = $7b6bE.getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $7b6bE.getFilenameToDebugIdMap;
module.exports.getFilenameToMetadataMap = $doSiu.getFilenameToMetadataMap;
module.exports.escapeStringForRegex = $gA0uF.escapeStringForRegex;
module.exports._INTERNAL_safeDateNow = $9gcfE.safeDateNow;
module.exports._INTERNAL_safeMathRandom = $9gcfE.safeMathRandom;
module.exports._INTERNAL_withRandomSafeContext = $9gcfE.withRandomSafeContext;
module.exports.getComponentName = $kwHFm.getComponentName;
module.exports.getLocationHref = $kwHFm.getLocationHref;
module.exports.htmlTreeAsString = $kwHFm.htmlTreeAsString;
module.exports.instrumentLangChainEmbeddings = $jDmEx.instrumentLangChainEmbeddings;

});
parcelRegister("9nxiT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $ijRD7 = parcelRequire("ijRD7");

var $39Wab = parcelRequire("39Wab");

var $99stL = parcelRequire("99stL");

var $cp5Iu = parcelRequire("cp5Iu");

var $3pcOx = parcelRequire("3pcOx");
let $6d401873da8d81f4$var$errorsInstrumented = false;
function $6d401873da8d81f4$var$registerSpanErrorInstrumentation() {
    if ($6d401873da8d81f4$var$errorsInstrumented) return;
    function errorCallback() {
        const activeSpan = $cp5Iu.getActiveSpan();
        const rootSpan = activeSpan && $cp5Iu.getRootSpan(activeSpan);
        if (rootSpan) {
            const message = "internal_error";
            $7piqH.DEBUG_BUILD && $99stL.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: $3pcOx.SPAN_STATUS_ERROR,
                message: message
            });
        }
    }
    $6d401873da8d81f4$var$errorsInstrumented = true;
    $ijRD7.addGlobalErrorInstrumentationHandler(errorCallback);
    $39Wab.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
module.exports.registerSpanErrorInstrumentation = $6d401873da8d81f4$var$registerSpanErrorInstrumentation;

});
parcelRegister("7piqH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $564929f57baa1229$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports.DEBUG_BUILD = $564929f57baa1229$var$DEBUG_BUILD;

});

parcelRegister("ijRD7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kjL8z = parcelRequire("kjL8z");

var $gtIHY = parcelRequire("gtIHY");
let $d5639a226ecd18e3$var$_oldOnErrorHandler = null;
function $d5639a226ecd18e3$var$addGlobalErrorInstrumentationHandler(handler) {
    const type = "error";
    $gtIHY.addHandler(type, handler);
    $gtIHY.maybeInstrument(type, $d5639a226ecd18e3$var$instrumentError);
}
function $d5639a226ecd18e3$var$instrumentError() {
    $d5639a226ecd18e3$var$_oldOnErrorHandler = $kjL8z.GLOBAL_OBJ.onerror;
    $kjL8z.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        $gtIHY.triggerHandlers("error", handlerData);
        if ($d5639a226ecd18e3$var$_oldOnErrorHandler) return $d5639a226ecd18e3$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $kjL8z.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalErrorInstrumentationHandler = $d5639a226ecd18e3$var$addGlobalErrorInstrumentationHandler;

});
parcelRegister("kjL8z", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ecaa25755696effd$var$GLOBAL_OBJ = globalThis;
module.exports.GLOBAL_OBJ = $ecaa25755696effd$var$GLOBAL_OBJ;

});

parcelRegister("gtIHY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $66leG = parcelRequire("66leG");
const $bff208ead4c60696$var$handlers = {};
const $bff208ead4c60696$var$instrumented = {};
function $bff208ead4c60696$var$addHandler(type, handler) {
    $bff208ead4c60696$var$handlers[type] = $bff208ead4c60696$var$handlers[type] || [];
    $bff208ead4c60696$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $bff208ead4c60696$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $bff208ead4c60696$var$resetInstrumentationHandlers() {
    Object.keys($bff208ead4c60696$var$handlers).forEach((key)=>{
        $bff208ead4c60696$var$handlers[key] = void 0;
    });
}
function $bff208ead4c60696$var$maybeInstrument(type, instrumentFn) {
    if (!$bff208ead4c60696$var$instrumented[type]) {
        $bff208ead4c60696$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            $7piqH.DEBUG_BUILD && $99stL.debug.error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $bff208ead4c60696$var$triggerHandlers(type, data) {
    const typeHandlers = type && $bff208ead4c60696$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        $7piqH.DEBUG_BUILD && $99stL.debug.error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${$66leG.getFunctionName(handler)}
Error:`, e);
    }
}
module.exports.addHandler = $bff208ead4c60696$var$addHandler;
module.exports.maybeInstrument = $bff208ead4c60696$var$maybeInstrument;
module.exports.resetInstrumentationHandlers = $bff208ead4c60696$var$resetInstrumentationHandlers;
module.exports.triggerHandlers = $bff208ead4c60696$var$triggerHandlers;

});
parcelRegister("99stL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aWGVj = parcelRequire("aWGVj");

var $7piqH = parcelRequire("7piqH");

var $kjL8z = parcelRequire("kjL8z");
const $6a9b0ba9abdb05c2$var$CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $6a9b0ba9abdb05c2$var$PREFIX = "Sentry Logger ";
const $6a9b0ba9abdb05c2$var$originalConsoleMethods = {};
function $6a9b0ba9abdb05c2$var$consoleSandbox(callback) {
    if (!("console" in $kjL8z.GLOBAL_OBJ)) return callback();
    const console = $kjL8z.GLOBAL_OBJ.console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($6a9b0ba9abdb05c2$var$originalConsoleMethods);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $6a9b0ba9abdb05c2$var$originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $6a9b0ba9abdb05c2$var$enable() {
    $6a9b0ba9abdb05c2$var$_getLoggerSettings().enabled = true;
}
function $6a9b0ba9abdb05c2$var$disable() {
    $6a9b0ba9abdb05c2$var$_getLoggerSettings().enabled = false;
}
function $6a9b0ba9abdb05c2$var$isEnabled() {
    return $6a9b0ba9abdb05c2$var$_getLoggerSettings().enabled;
}
function $6a9b0ba9abdb05c2$var$log(...args) {
    $6a9b0ba9abdb05c2$var$_maybeLog("log", ...args);
}
function $6a9b0ba9abdb05c2$var$warn(...args) {
    $6a9b0ba9abdb05c2$var$_maybeLog("warn", ...args);
}
function $6a9b0ba9abdb05c2$var$error(...args) {
    $6a9b0ba9abdb05c2$var$_maybeLog("error", ...args);
}
function $6a9b0ba9abdb05c2$var$_maybeLog(level, ...args) {
    if (!$7piqH.DEBUG_BUILD) return;
    if ($6a9b0ba9abdb05c2$var$isEnabled()) $6a9b0ba9abdb05c2$var$consoleSandbox(()=>{
        $kjL8z.GLOBAL_OBJ.console[level](`${$6a9b0ba9abdb05c2$var$PREFIX}[${level}]:`, ...args);
    });
}
function $6a9b0ba9abdb05c2$var$_getLoggerSettings() {
    if (!$7piqH.DEBUG_BUILD) return {
        enabled: false
    };
    return $aWGVj.getGlobalSingleton("loggerSettings", ()=>({
            enabled: false
        }));
}
const $6a9b0ba9abdb05c2$var$debug = {
    enable: /** Enable logging. */ $6a9b0ba9abdb05c2$var$enable,
    disable: /** Disable logging. */ $6a9b0ba9abdb05c2$var$disable,
    isEnabled: /** Check if logging is enabled. */ $6a9b0ba9abdb05c2$var$isEnabled,
    log: /** Log a message. */ $6a9b0ba9abdb05c2$var$log,
    warn: /** Log a warning. */ $6a9b0ba9abdb05c2$var$warn,
    error: /** Log an error. */ $6a9b0ba9abdb05c2$var$error
};
module.exports.CONSOLE_LEVELS = $6a9b0ba9abdb05c2$var$CONSOLE_LEVELS;
module.exports.consoleSandbox = $6a9b0ba9abdb05c2$var$consoleSandbox;
module.exports.debug = $6a9b0ba9abdb05c2$var$debug;
module.exports.originalConsoleMethods = $6a9b0ba9abdb05c2$var$originalConsoleMethods;

});
parcelRegister("aWGVj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $720Iz = parcelRequire("720Iz");

var $kjL8z = parcelRequire("kjL8z");
function $7f809dd5a59527d9$var$getMainCarrier() {
    $7f809dd5a59527d9$var$getSentryCarrier($kjL8z.GLOBAL_OBJ);
    return $kjL8z.GLOBAL_OBJ;
}
function $7f809dd5a59527d9$var$getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || $720Iz.SDK_VERSION;
    return __SENTRY__[$720Iz.SDK_VERSION] = __SENTRY__[$720Iz.SDK_VERSION] || {};
}
function $7f809dd5a59527d9$var$getGlobalSingleton(name, creator, obj = $kjL8z.GLOBAL_OBJ) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[$720Iz.SDK_VERSION] = __SENTRY__[$720Iz.SDK_VERSION] || {};
    return carrier[name] || (carrier[name] = creator());
}
module.exports.getGlobalSingleton = $7f809dd5a59527d9$var$getGlobalSingleton;
module.exports.getMainCarrier = $7f809dd5a59527d9$var$getMainCarrier;
module.exports.getSentryCarrier = $7f809dd5a59527d9$var$getSentryCarrier;

});
parcelRegister("720Iz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $51e946dc04c97071$var$SDK_VERSION = "10.63.0";
module.exports.SDK_VERSION = $51e946dc04c97071$var$SDK_VERSION;

});



parcelRegister("66leG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $4713c6a0dfdcf2ef$var$STACKTRACE_FRAME_LIMIT = 50;
const $4713c6a0dfdcf2ef$var$UNKNOWN_FUNCTION = "?";
const $4713c6a0dfdcf2ef$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4713c6a0dfdcf2ef$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $4713c6a0dfdcf2ef$var$createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $4713c6a0dfdcf2ef$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4713c6a0dfdcf2ef$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4713c6a0dfdcf2ef$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $4713c6a0dfdcf2ef$var$stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
function $4713c6a0dfdcf2ef$var$stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return $4713c6a0dfdcf2ef$var$createStackParser(...stackParser);
    return stackParser;
}
function $4713c6a0dfdcf2ef$var$stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($4713c6a0dfdcf2ef$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($4713c6a0dfdcf2ef$var$STRIP_FRAME_REGEXP.test($4713c6a0dfdcf2ef$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($4713c6a0dfdcf2ef$var$STRIP_FRAME_REGEXP.test($4713c6a0dfdcf2ef$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $4713c6a0dfdcf2ef$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $4713c6a0dfdcf2ef$var$getLastStackFrame(localStack).filename,
            function: frame.function || $4713c6a0dfdcf2ef$var$UNKNOWN_FUNCTION
        }));
}
function $4713c6a0dfdcf2ef$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $4713c6a0dfdcf2ef$var$defaultFunctionName = "<anonymous>";
function $4713c6a0dfdcf2ef$var$getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return $4713c6a0dfdcf2ef$var$defaultFunctionName;
        return fn.name || $4713c6a0dfdcf2ef$var$defaultFunctionName;
    } catch  {
        return $4713c6a0dfdcf2ef$var$defaultFunctionName;
    }
}
function $4713c6a0dfdcf2ef$var$getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $4713c6a0dfdcf2ef$var$normalizeStackTracePath(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}
module.exports.UNKNOWN_FUNCTION = $4713c6a0dfdcf2ef$var$UNKNOWN_FUNCTION;
module.exports.createStackParser = $4713c6a0dfdcf2ef$var$createStackParser;
module.exports.getFramesFromEvent = $4713c6a0dfdcf2ef$var$getFramesFromEvent;
module.exports.getFunctionName = $4713c6a0dfdcf2ef$var$getFunctionName;
module.exports.normalizeStackTracePath = $4713c6a0dfdcf2ef$var$normalizeStackTracePath;
module.exports.stackParserFromStackParserOptions = $4713c6a0dfdcf2ef$var$stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $4713c6a0dfdcf2ef$var$stripSentryFramesAndReverse;

});



parcelRegister("39Wab", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kjL8z = parcelRequire("kjL8z");

var $gtIHY = parcelRequire("gtIHY");
let $24cf545e14e689d1$var$_oldOnUnhandledRejectionHandler = null;
function $24cf545e14e689d1$var$addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = "unhandledrejection";
    $gtIHY.addHandler(type, handler);
    $gtIHY.maybeInstrument(type, $24cf545e14e689d1$var$instrumentUnhandledRejection);
}
function $24cf545e14e689d1$var$instrumentUnhandledRejection() {
    $24cf545e14e689d1$var$_oldOnUnhandledRejectionHandler = $kjL8z.GLOBAL_OBJ.onunhandledrejection;
    $kjL8z.GLOBAL_OBJ.onunhandledrejection = function(e) {
        const handlerData = e;
        $gtIHY.triggerHandlers("unhandledrejection", handlerData);
        if ($24cf545e14e689d1$var$_oldOnUnhandledRejectionHandler) return $24cf545e14e689d1$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $kjL8z.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $24cf545e14e689d1$var$addGlobalUnhandledRejectionInstrumentationHandler;

});

parcelRegister("cp5Iu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2dzy9 = parcelRequire("2dzy9");

var $9Db3P = parcelRequire("9Db3P");

var $aWGVj = parcelRequire("aWGVj");

var $gCYmH = parcelRequire("gCYmH");

var $k6VdG = parcelRequire("k6VdG");

var $3pcOx = parcelRequire("3pcOx");

var $f05NK = parcelRequire("f05NK");

var $1hzu4 = parcelRequire("1hzu4");

var $IRlr7 = parcelRequire("IRlr7");

var $dVZms = parcelRequire("dVZms");

var $h5NbM = parcelRequire("h5NbM");

var $99stL = parcelRequire("99stL");

var $6dWkJ = parcelRequire("6dWkJ");
const $907c41093836e5c2$var$TRACE_FLAG_NONE = 0;
const $907c41093836e5c2$var$TRACE_FLAG_SAMPLED = 1;
let $907c41093836e5c2$var$hasShownSpanDropWarning = false;
function $907c41093836e5c2$var$spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $907c41093836e5c2$var$spanToJSON(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $907c41093836e5c2$var$spanToTraceContext(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $907c41093836e5c2$var$spanToJSON(span).parent_span_id;
    const scope = $f05NK.getCapturedScopesOnSpan(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || $IRlr7.generateSpanId() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $907c41093836e5c2$var$spanToTraceHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $907c41093836e5c2$var$spanIsSampled(span);
    return $h5NbM.generateSentryTraceHeader(traceId, spanId, sampled);
}
function $907c41093836e5c2$var$spanToTraceparentHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $907c41093836e5c2$var$spanIsSampled(span);
    return $h5NbM.generateTraceparentHeader(traceId, spanId, sampled);
}
function $907c41093836e5c2$var$convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $907c41093836e5c2$var$TRACE_FLAG_SAMPLED,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $907c41093836e5c2$var$getStreamedSpanLinks(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $907c41093836e5c2$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }));
    else return void 0;
}
function $907c41093836e5c2$var$spanTimeInputToSeconds(input) {
    if (typeof input === "number") return $907c41093836e5c2$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $907c41093836e5c2$var$ensureTimestampInSeconds(input.getTime());
    return $dVZms.timestampInSeconds();
}
function $907c41093836e5c2$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $907c41093836e5c2$var$spanToJSON(span) {
    if ($907c41093836e5c2$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($907c41093836e5c2$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $907c41093836e5c2$var$getOtelParentSpanId(span),
            start_timestamp: $907c41093836e5c2$var$spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $907c41093836e5c2$var$spanTimeInputToSeconds(endTime) || void 0,
            status: $907c41093836e5c2$var$getStatusMessage(status),
            op: attributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $907c41093836e5c2$var$convertSpanLinksForEnvelope(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $907c41093836e5c2$var$spanToStreamedSpanJSON(span) {
    if ($907c41093836e5c2$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($907c41093836e5c2$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $907c41093836e5c2$var$getOtelParentSpanId(span),
            start_timestamp: $907c41093836e5c2$var$spanTimeInputToSeconds(startTime),
            end_timestamp: $907c41093836e5c2$var$spanTimeInputToSeconds(endTime),
            is_segment: span === $907c41093836e5c2$var$INTERNAL_getSegmentSpan(span),
            status: $907c41093836e5c2$var$getSimpleStatus(status),
            attributes: $907c41093836e5c2$var$addStatusMessageAttribute(attributes, status),
            links: $907c41093836e5c2$var$getStreamedSpanLinks(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $907c41093836e5c2$var$INTERNAL_getSegmentSpan(span)
    };
}
function $907c41093836e5c2$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $907c41093836e5c2$var$streamedSpanJsonToSerializedSpan(spanJson) {
    return {
        ...spanJson,
        attributes: $9Db3P.serializeAttributes(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: $9Db3P.serializeAttributes(link.attributes)
            }))
    };
}
function $907c41093836e5c2$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $907c41093836e5c2$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $907c41093836e5c2$var$spanIsSampled(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $907c41093836e5c2$var$TRACE_FLAG_SAMPLED;
}
function $907c41093836e5c2$var$getStatusMessage(status) {
    if (!status || status.code === $3pcOx.SPAN_STATUS_UNSET) return void 0;
    if (status.code === $3pcOx.SPAN_STATUS_OK) return "ok";
    return status.message || "internal_error";
}
function $907c41093836e5c2$var$getSimpleStatus(status) {
    return !status || status.code === $3pcOx.SPAN_STATUS_OK || status.code === $3pcOx.SPAN_STATUS_UNSET || status.message === "cancelled" ? "ok" : "error";
}
function $907c41093836e5c2$var$addStatusMessageAttribute(attributes, status) {
    const statusMessage = $907c41093836e5c2$var$getSimpleStatus(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE]: statusMessage
        },
        ...attributes
    };
}
const $907c41093836e5c2$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $907c41093836e5c2$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $907c41093836e5c2$var$addChildSpanToSpan(span, childSpan) {
    const rootSpan = span[$907c41093836e5c2$var$ROOT_SPAN_FIELD] || span;
    $1hzu4.addNonEnumerableProperty(childSpan, $907c41093836e5c2$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$907c41093836e5c2$var$CHILD_SPANS_FIELD]) span[$907c41093836e5c2$var$CHILD_SPANS_FIELD].add(childSpan);
    else $1hzu4.addNonEnumerableProperty(span, $907c41093836e5c2$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $907c41093836e5c2$var$removeChildSpanFromSpan(span, childSpan) {
    if (span[$907c41093836e5c2$var$CHILD_SPANS_FIELD]) span[$907c41093836e5c2$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $907c41093836e5c2$var$getSpanDescendants(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($907c41093836e5c2$var$spanIsSampled(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$907c41093836e5c2$var$CHILD_SPANS_FIELD] ? Array.from(span2[$907c41093836e5c2$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $907c41093836e5c2$var$getRootSpan = $907c41093836e5c2$var$INTERNAL_getSegmentSpan;
function $907c41093836e5c2$var$INTERNAL_getSegmentSpan(span) {
    return span[$907c41093836e5c2$var$ROOT_SPAN_FIELD] || span;
}
function $907c41093836e5c2$var$getActiveSpan() {
    const carrier$1 = $aWGVj.getMainCarrier();
    const acs = $2dzy9.getAsyncContextStrategy(carrier$1);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return $6dWkJ._getSpanForScope($gCYmH.getCurrentScope());
}
function $907c41093836e5c2$var$showSpanDropWarning() {
    if (!$907c41093836e5c2$var$hasShownSpanDropWarning) {
        $99stL.consoleSandbox(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $907c41093836e5c2$var$hasShownSpanDropWarning = true;
    }
}
function $907c41093836e5c2$var$updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
    });
}
module.exports.INTERNAL_getSegmentSpan = $907c41093836e5c2$var$INTERNAL_getSegmentSpan;
module.exports.TRACE_FLAG_NONE = $907c41093836e5c2$var$TRACE_FLAG_NONE;
module.exports.TRACE_FLAG_SAMPLED = $907c41093836e5c2$var$TRACE_FLAG_SAMPLED;
module.exports.addChildSpanToSpan = $907c41093836e5c2$var$addChildSpanToSpan;
module.exports.addStatusMessageAttribute = $907c41093836e5c2$var$addStatusMessageAttribute;
module.exports.convertSpanLinksForEnvelope = $907c41093836e5c2$var$convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $907c41093836e5c2$var$getActiveSpan;
module.exports.getRootSpan = $907c41093836e5c2$var$getRootSpan;
module.exports.getSimpleStatus = $907c41093836e5c2$var$getSimpleStatus;
module.exports.getSpanDescendants = $907c41093836e5c2$var$getSpanDescendants;
module.exports.getStatusMessage = $907c41093836e5c2$var$getStatusMessage;
module.exports.getStreamedSpanLinks = $907c41093836e5c2$var$getStreamedSpanLinks;
module.exports.removeChildSpanFromSpan = $907c41093836e5c2$var$removeChildSpanFromSpan;
module.exports.showSpanDropWarning = $907c41093836e5c2$var$showSpanDropWarning;
module.exports.spanIsSampled = $907c41093836e5c2$var$spanIsSampled;
module.exports.spanTimeInputToSeconds = $907c41093836e5c2$var$spanTimeInputToSeconds;
module.exports.spanToJSON = $907c41093836e5c2$var$spanToJSON;
module.exports.spanToStreamedSpanJSON = $907c41093836e5c2$var$spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $907c41093836e5c2$var$spanToTraceContext;
module.exports.spanToTraceHeader = $907c41093836e5c2$var$spanToTraceHeader;
module.exports.spanToTraceparentHeader = $907c41093836e5c2$var$spanToTraceparentHeader;
module.exports.spanToTransactionTraceContext = $907c41093836e5c2$var$spanToTransactionTraceContext;
module.exports.streamedSpanJsonToSerializedSpan = $907c41093836e5c2$var$streamedSpanJsonToSerializedSpan;
module.exports.updateSpanName = $907c41093836e5c2$var$updateSpanName;

});
parcelRegister("2dzy9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aWGVj = parcelRequire("aWGVj");

var $fS7BC = parcelRequire("fS7BC");
function $19d85f25982770e1$var$setAsyncContextStrategy(strategy) {
    const registry = $aWGVj.getMainCarrier();
    const sentry = $aWGVj.getSentryCarrier(registry);
    sentry.acs = strategy;
}
function $19d85f25982770e1$var$getAsyncContextStrategy(carrier$1) {
    const sentry = $aWGVj.getSentryCarrier(carrier$1);
    if (sentry.acs) return sentry.acs;
    return $fS7BC.getStackAsyncContextStrategy();
}
module.exports.getAsyncContextStrategy = $19d85f25982770e1$var$getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $19d85f25982770e1$var$setAsyncContextStrategy;

});
parcelRegister("fS7BC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8CHry = parcelRequire("8CHry");

var $gIF8m = parcelRequire("gIF8m");

var $l17Xm = parcelRequire("l17Xm");

var $c34Je = parcelRequire("c34Je");

var $aWGVj = parcelRequire("aWGVj");
class $b8e1cc831ff9080f$var$AsyncContextStack {
    constructor(scope$1, isolationScope){
        let assignedScope;
        if (!scope$1) assignedScope = new $gIF8m.Scope();
        else assignedScope = scope$1;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new $gIF8m.Scope();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ($c34Je.isThenable(maybePromiseResult)) return $l17Xm.chainAndCopyPromiseLike(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $b8e1cc831ff9080f$var$getAsyncContextStack() {
    const registry = $aWGVj.getMainCarrier();
    const sentry = $aWGVj.getSentryCarrier(registry);
    return sentry.stack = sentry.stack || new $b8e1cc831ff9080f$var$AsyncContextStack($8CHry.getDefaultCurrentScope(), $8CHry.getDefaultIsolationScope());
}
function $b8e1cc831ff9080f$var$withScope(callback) {
    return $b8e1cc831ff9080f$var$getAsyncContextStack().withScope(callback);
}
function $b8e1cc831ff9080f$var$withSetScope(scope, callback) {
    const stack = $b8e1cc831ff9080f$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $b8e1cc831ff9080f$var$withIsolationScope(callback) {
    return $b8e1cc831ff9080f$var$getAsyncContextStack().withScope(()=>{
        return callback($b8e1cc831ff9080f$var$getAsyncContextStack().getIsolationScope());
    });
}
function $b8e1cc831ff9080f$var$getStackAsyncContextStrategy() {
    return {
        withIsolationScope: $b8e1cc831ff9080f$var$withIsolationScope,
        withScope: $b8e1cc831ff9080f$var$withScope,
        withSetScope: $b8e1cc831ff9080f$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $b8e1cc831ff9080f$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$b8e1cc831ff9080f$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$b8e1cc831ff9080f$var$getAsyncContextStack().getIsolationScope()
    };
}
module.exports.AsyncContextStack = $b8e1cc831ff9080f$var$AsyncContextStack;
module.exports.getStackAsyncContextStrategy = $b8e1cc831ff9080f$var$getStackAsyncContextStrategy;

});
parcelRegister("8CHry", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aWGVj = parcelRequire("aWGVj");

var $gIF8m = parcelRequire("gIF8m");
function $64739249f3f8e3d1$var$getDefaultCurrentScope() {
    return $aWGVj.getGlobalSingleton("defaultCurrentScope", ()=>new $gIF8m.Scope());
}
function $64739249f3f8e3d1$var$getDefaultIsolationScope() {
    return $aWGVj.getGlobalSingleton("defaultIsolationScope", ()=>new $gIF8m.Scope());
}
module.exports.getDefaultCurrentScope = $64739249f3f8e3d1$var$getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $64739249f3f8e3d1$var$getDefaultIsolationScope;

});
parcelRegister("gIF8m", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $1APeO = parcelRequire("1APeO");

var $99stL = parcelRequire("99stL");

var $c34Je = parcelRequire("c34Je");

var $b85dT = parcelRequire("b85dT");

var $f3q6O = parcelRequire("f3q6O");

var $IRlr7 = parcelRequire("IRlr7");

var $9gcfE = parcelRequire("9gcfE");

var $6dWkJ = parcelRequire("6dWkJ");

var $fdTwu = parcelRequire("fdTwu");

var $dVZms = parcelRequire("dVZms");
const $c2c0a9b758ce53ac$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $c2c0a9b758ce53ac$var$Scope {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: $IRlr7.generateTraceId(),
            sampleRand: $9gcfE.safeMathRandom()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $c2c0a9b758ce53ac$var$Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        $6dWkJ._setSpanForScope(newScope, $6dWkJ._getSpanForScope(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) $1APeO.updateSession(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $c2c0a9b758ce53ac$var$Scope ? scopeToMerge.getScopeData() : $c34Je.isPlainObject(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        $6dWkJ._setSpanForScope(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: $IRlr7.generateTraceId(),
            sampleRand: $9gcfE.safeMathRandom()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $c2c0a9b758ce53ac$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: $dVZms.dateTimestampInSeconds(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? $fdTwu.truncate(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: $6dWkJ._getSpanForScope(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = $b85dT.merge(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || $f3q6O.uuid4();
        if (!this._client) {
            $7piqH.DEBUG_BUILD && $99stL.debug.warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || $f3q6O.uuid4();
        if (!this._client) {
            $7piqH.DEBUG_BUILD && $99stL.debug.warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || $f3q6O.uuid4();
        if (!this._client) {
            $7piqH.DEBUG_BUILD && $99stL.debug.warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
module.exports.Scope = $c2c0a9b758ce53ac$var$Scope;

});
parcelRegister("1APeO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3q6O = parcelRequire("f3q6O");

var $dVZms = parcelRequire("dVZms");
function $1290e606e649f60f$var$makeSession(context) {
    const startingTime = $dVZms.timestampInSeconds();
    const session = {
        sid: $f3q6O.uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$1290e606e649f60f$var$sessionToJSON(session)
    };
    if (context) $1290e606e649f60f$var$updateSession(session, context);
    return session;
}
function $1290e606e649f60f$var$updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || $dVZms.timestampInSeconds();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : $f3q6O.uuid4();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $1290e606e649f60f$var$closeSession(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $1290e606e649f60f$var$updateSession(session, context);
}
function $1290e606e649f60f$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}
module.exports.closeSession = $1290e606e649f60f$var$closeSession;
module.exports.makeSession = $1290e606e649f60f$var$makeSession;
module.exports.updateSession = $1290e606e649f60f$var$updateSession;

});
parcelRegister("f3q6O", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1hzu4 = parcelRequire("1hzu4");

var $9gcfE = parcelRequire("9gcfE");

var $fdTwu = parcelRequire("fdTwu");

var $kjL8z = parcelRequire("kjL8z");
function $af5b637ded20c5f9$var$getCrypto() {
    const gbl = $kjL8z.GLOBAL_OBJ;
    return gbl.crypto || gbl.msCrypto;
}
let $af5b637ded20c5f9$var$emptyUuid;
function $af5b637ded20c5f9$var$getRandomByte() {
    return $9gcfE.safeMathRandom() * 16;
}
function $af5b637ded20c5f9$var$uuid4(crypto = $af5b637ded20c5f9$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return $9gcfE.withRandomSafeContext(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$af5b637ded20c5f9$var$emptyUuid) $af5b637ded20c5f9$var$emptyUuid = "10000000100040008000100000000000";
    return $af5b637ded20c5f9$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($af5b637ded20c5f9$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $af5b637ded20c5f9$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $af5b637ded20c5f9$var$getEventDescription(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $af5b637ded20c5f9$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $af5b637ded20c5f9$var$addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $af5b637ded20c5f9$var$addExceptionMechanism(event, newMechanism) {
    const firstException = $af5b637ded20c5f9$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $af5b637ded20c5f9$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $af5b637ded20c5f9$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $af5b637ded20c5f9$var$parseSemver(input) {
    const match = input.match($af5b637ded20c5f9$var$SEMVER_REGEXP) || [];
    const major = $af5b637ded20c5f9$var$_parseInt(match[1]);
    const minor = $af5b637ded20c5f9$var$_parseInt(match[2]);
    const patch = $af5b637ded20c5f9$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $af5b637ded20c5f9$var$addContextToFrame(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>$fdTwu.snipLine(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = $fdTwu.snipLine(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>$fdTwu.snipLine(line, 0));
}
function $af5b637ded20c5f9$var$checkOrSetAlreadyCaught(exception) {
    if ($af5b637ded20c5f9$var$isAlreadyCaptured(exception)) return true;
    try {
        $1hzu4.addNonEnumerableProperty(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $af5b637ded20c5f9$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}
module.exports.addContextToFrame = $af5b637ded20c5f9$var$addContextToFrame;
module.exports.addExceptionMechanism = $af5b637ded20c5f9$var$addExceptionMechanism;
module.exports.addExceptionTypeValue = $af5b637ded20c5f9$var$addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $af5b637ded20c5f9$var$checkOrSetAlreadyCaught;
module.exports.getEventDescription = $af5b637ded20c5f9$var$getEventDescription;
module.exports.isAlreadyCaptured = $af5b637ded20c5f9$var$isAlreadyCaptured;
module.exports.parseSemver = $af5b637ded20c5f9$var$parseSemver;
module.exports.uuid4 = $af5b637ded20c5f9$var$uuid4;

});
parcelRegister("1hzu4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $c34Je = parcelRequire("c34Je");
function $0ef2e75fbe313e90$var$fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $0ef2e75fbe313e90$var$markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        $7piqH.DEBUG_BUILD && $99stL.debug.log(`Failed to replace method "${name}" in object`, source);
    }
}
function $0ef2e75fbe313e90$var$addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        $7piqH.DEBUG_BUILD && $99stL.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $0ef2e75fbe313e90$var$markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $0ef2e75fbe313e90$var$addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $0ef2e75fbe313e90$var$wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($0ef2e75fbe313e90$var$getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $0ef2e75fbe313e90$var$markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $0ef2e75fbe313e90$var$getOriginalFunction(func) {
    return func.__sentry_original__;
}
function $0ef2e75fbe313e90$var$convertToPlainObject(value) {
    if ($c34Je.isError(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$0ef2e75fbe313e90$var$getOwnProperties(value)
    };
    if ($c34Je.isEvent(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$0ef2e75fbe313e90$var$getOwnProperties(value)
        };
    }
    return value;
}
function $0ef2e75fbe313e90$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $0ef2e75fbe313e90$var$extractExceptionKeysForMessage(exception) {
    const keys = Object.keys($0ef2e75fbe313e90$var$convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $0ef2e75fbe313e90$var$dropUndefinedKeys(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $0ef2e75fbe313e90$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $0ef2e75fbe313e90$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($0ef2e75fbe313e90$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($0ef2e75fbe313e90$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $0ef2e75fbe313e90$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $0ef2e75fbe313e90$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $0ef2e75fbe313e90$var$objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case $c34Je.isPrimitive(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports.addNonEnumerableProperty = $0ef2e75fbe313e90$var$addNonEnumerableProperty;
module.exports.convertToPlainObject = $0ef2e75fbe313e90$var$convertToPlainObject;
module.exports.dropUndefinedKeys = $0ef2e75fbe313e90$var$dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $0ef2e75fbe313e90$var$extractExceptionKeysForMessage;
module.exports.fill = $0ef2e75fbe313e90$var$fill;
module.exports.getOriginalFunction = $0ef2e75fbe313e90$var$getOriginalFunction;
module.exports.markFunctionWrapped = $0ef2e75fbe313e90$var$markFunctionWrapped;
module.exports.objectify = $0ef2e75fbe313e90$var$objectify;
module.exports.wrapMethod = $0ef2e75fbe313e90$var$wrapMethod;

});
parcelRegister("c34Je", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $8c596ed3c7416485$var$objectToString = Object.prototype.toString;
function $8c596ed3c7416485$var$isError(wat) {
    switch($8c596ed3c7416485$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $8c596ed3c7416485$var$isInstanceOf(wat, Error);
    }
}
function $8c596ed3c7416485$var$isBuiltin(wat, className) {
    return $8c596ed3c7416485$var$objectToString.call(wat) === `[object ${className}]`;
}
function $8c596ed3c7416485$var$isErrorEvent(wat) {
    return $8c596ed3c7416485$var$isBuiltin(wat, "ErrorEvent");
}
function $8c596ed3c7416485$var$isDOMError(wat) {
    return $8c596ed3c7416485$var$isBuiltin(wat, "DOMError");
}
function $8c596ed3c7416485$var$isDOMException(wat) {
    return $8c596ed3c7416485$var$isBuiltin(wat, "DOMException");
}
function $8c596ed3c7416485$var$isString(wat) {
    return $8c596ed3c7416485$var$isBuiltin(wat, "String");
}
function $8c596ed3c7416485$var$isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $8c596ed3c7416485$var$isPrimitive(wat) {
    return wat === null || $8c596ed3c7416485$var$isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $8c596ed3c7416485$var$isPlainObject(wat) {
    return $8c596ed3c7416485$var$isBuiltin(wat, "Object");
}
function $8c596ed3c7416485$var$isEvent(wat) {
    return typeof Event !== "undefined" && $8c596ed3c7416485$var$isInstanceOf(wat, Event);
}
function $8c596ed3c7416485$var$isElement(wat) {
    return typeof Element !== "undefined" && $8c596ed3c7416485$var$isInstanceOf(wat, Element);
}
function $8c596ed3c7416485$var$isRegExp(wat) {
    return $8c596ed3c7416485$var$isBuiltin(wat, "RegExp");
}
function $8c596ed3c7416485$var$isThenable(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $8c596ed3c7416485$var$isSyntheticEvent(wat) {
    return $8c596ed3c7416485$var$isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $8c596ed3c7416485$var$isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $8c596ed3c7416485$var$isVueViewModel(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $8c596ed3c7416485$var$isRequest(request) {
    return typeof Request !== "undefined" && $8c596ed3c7416485$var$isInstanceOf(request, Request);
}
module.exports.isDOMError = $8c596ed3c7416485$var$isDOMError;
module.exports.isDOMException = $8c596ed3c7416485$var$isDOMException;
module.exports.isElement = $8c596ed3c7416485$var$isElement;
module.exports.isError = $8c596ed3c7416485$var$isError;
module.exports.isErrorEvent = $8c596ed3c7416485$var$isErrorEvent;
module.exports.isEvent = $8c596ed3c7416485$var$isEvent;
module.exports.isInstanceOf = $8c596ed3c7416485$var$isInstanceOf;
module.exports.isParameterizedString = $8c596ed3c7416485$var$isParameterizedString;
module.exports.isPlainObject = $8c596ed3c7416485$var$isPlainObject;
module.exports.isPrimitive = $8c596ed3c7416485$var$isPrimitive;
module.exports.isRegExp = $8c596ed3c7416485$var$isRegExp;
module.exports.isRequest = $8c596ed3c7416485$var$isRequest;
module.exports.isString = $8c596ed3c7416485$var$isString;
module.exports.isSyntheticEvent = $8c596ed3c7416485$var$isSyntheticEvent;
module.exports.isThenable = $8c596ed3c7416485$var$isThenable;
module.exports.isVueViewModel = $8c596ed3c7416485$var$isVueViewModel;

});


parcelRegister("9gcfE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kjL8z = parcelRequire("kjL8z");
let $6bdf1c8db265bb10$var$RESOLVED_RUNNER;
function $6bdf1c8db265bb10$var$withRandomSafeContext(cb) {
    if ($6bdf1c8db265bb10$var$RESOLVED_RUNNER !== void 0) return $6bdf1c8db265bb10$var$RESOLVED_RUNNER ? $6bdf1c8db265bb10$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = $kjL8z.GLOBAL_OBJ;
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $6bdf1c8db265bb10$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $6bdf1c8db265bb10$var$RESOLVED_RUNNER(cb);
    }
    $6bdf1c8db265bb10$var$RESOLVED_RUNNER = null;
    return cb();
}
function $6bdf1c8db265bb10$var$safeMathRandom() {
    return $6bdf1c8db265bb10$var$withRandomSafeContext(()=>Math.random());
}
function $6bdf1c8db265bb10$var$safeDateNow() {
    return $6bdf1c8db265bb10$var$withRandomSafeContext(()=>Date.now());
}
module.exports.safeDateNow = $6bdf1c8db265bb10$var$safeDateNow;
module.exports.safeMathRandom = $6bdf1c8db265bb10$var$safeMathRandom;
module.exports.withRandomSafeContext = $6bdf1c8db265bb10$var$withRandomSafeContext;

});

parcelRegister("fdTwu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $c34Je = parcelRequire("c34Je");

var $3COzy = parcelRequire("3COzy");
function $b15323a1a84d9fb9$var$truncate(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $b15323a1a84d9fb9$var$snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $b15323a1a84d9fb9$var$safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ($c34Je.isPrimitive(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push($3COzy.stringifyValue(void 0, value));
    }
    return output.join(delimiter);
}
function $b15323a1a84d9fb9$var$isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!$c34Je.isString(value)) return false;
    if ($c34Je.isRegExp(pattern)) return pattern.test(value);
    if ($c34Je.isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $b15323a1a84d9fb9$var$stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($b15323a1a84d9fb9$var$isMatchingPattern(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}
module.exports.isMatchingPattern = $b15323a1a84d9fb9$var$isMatchingPattern;
module.exports.safeJoin = $b15323a1a84d9fb9$var$safeJoin;
module.exports.snipLine = $b15323a1a84d9fb9$var$snipLine;
module.exports.stringMatchesSomePattern = $b15323a1a84d9fb9$var$stringMatchesSomePattern;
module.exports.truncate = $b15323a1a84d9fb9$var$truncate;

});
parcelRegister("3COzy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $acdDE = parcelRequire("acdDE");

var $1hzu4 = parcelRequire("1hzu4");

var $66leG = parcelRequire("66leG");
let $2a3c2658aa7506df$var$stringifier;
function $2a3c2658aa7506df$var$setNormalizeStringifier(newStringifier) {
    $2a3c2658aa7506df$var$stringifier = newStringifier;
}
function $2a3c2658aa7506df$var$normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        return $2a3c2658aa7506df$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $2a3c2658aa7506df$var$normalizeToSize(object, depth = 3, maxSize = 102400) {
    const normalized = $2a3c2658aa7506df$var$normalize(object, depth);
    if ($2a3c2658aa7506df$var$jsonSize(normalized) > maxSize) return $2a3c2658aa7506df$var$normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
function $2a3c2658aa7506df$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $2a3c2658aa7506df$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $2a3c2658aa7506df$var$stringifyValue(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ($acdDE.hasSkipNormalizationHint(value)) return value;
    const overrideDepth = $acdDE.getNormalizationDepthOverrideHint(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $2a3c2658aa7506df$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = $1hzu4.convertToPlainObject(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $2a3c2658aa7506df$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $2a3c2658aa7506df$var$stringifyValue(key, value) {
    try {
        if ($2a3c2658aa7506df$var$stringifier) {
            const stringified = $2a3c2658aa7506df$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${$66leG.getFunctionName(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $2a3c2658aa7506df$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $2a3c2658aa7506df$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $2a3c2658aa7506df$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $2a3c2658aa7506df$var$jsonSize(value) {
    return $2a3c2658aa7506df$var$utf8Length(JSON.stringify(value));
}
function $2a3c2658aa7506df$var$normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $2a3c2658aa7506df$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports.normalize = $2a3c2658aa7506df$var$normalize;
module.exports.normalizeToSize = $2a3c2658aa7506df$var$normalizeToSize;
module.exports.normalizeUrlToBase = $2a3c2658aa7506df$var$normalizeUrlToBase;
module.exports.setNormalizeStringifier = $2a3c2658aa7506df$var$setNormalizeStringifier;
module.exports.stringifyValue = $2a3c2658aa7506df$var$stringifyValue;

});
parcelRegister("acdDE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1hzu4 = parcelRequire("1hzu4");
const $76c59ab89608b6eb$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $76c59ab89608b6eb$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $76c59ab89608b6eb$var$setSkipNormalizationHint(obj) {
    $1hzu4.addNonEnumerableProperty(obj, $76c59ab89608b6eb$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $76c59ab89608b6eb$var$setNormalizationDepthOverrideHint(obj, depth) {
    $1hzu4.addNonEnumerableProperty(obj, $76c59ab89608b6eb$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $76c59ab89608b6eb$var$hasSkipNormalizationHint(value) {
    return Boolean(value[$76c59ab89608b6eb$var$SENTRY_SKIP_NORMALIZATION]);
}
function $76c59ab89608b6eb$var$getNormalizationDepthOverrideHint(value) {
    const v = value[$76c59ab89608b6eb$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}
module.exports.getNormalizationDepthOverrideHint = $76c59ab89608b6eb$var$getNormalizationDepthOverrideHint;
module.exports.hasSkipNormalizationHint = $76c59ab89608b6eb$var$hasSkipNormalizationHint;
module.exports.setNormalizationDepthOverrideHint = $76c59ab89608b6eb$var$setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $76c59ab89608b6eb$var$setSkipNormalizationHint;

});




parcelRegister("dVZms", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9gcfE = parcelRequire("9gcfE");

var $kjL8z = parcelRequire("kjL8z");
const $a250324ba4f734b4$var$ONE_SECOND_IN_MS = 1e3;
function $a250324ba4f734b4$var$dateTimestampInSeconds() {
    return $9gcfE.safeDateNow() / $a250324ba4f734b4$var$ONE_SECOND_IN_MS;
}
function $a250324ba4f734b4$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = $kjL8z.GLOBAL_OBJ;
    if (!performance?.now || !performance.timeOrigin) return $a250324ba4f734b4$var$dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + $9gcfE.withRandomSafeContext(()=>performance.now())) / $a250324ba4f734b4$var$ONE_SECOND_IN_MS;
    };
}
let $a250324ba4f734b4$var$_cachedTimestampInSeconds;
function $a250324ba4f734b4$var$timestampInSeconds() {
    const func = $a250324ba4f734b4$var$_cachedTimestampInSeconds ?? ($a250324ba4f734b4$var$_cachedTimestampInSeconds = $a250324ba4f734b4$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $a250324ba4f734b4$var$cachedTimeOrigin = null;
function $a250324ba4f734b4$var$getBrowserTimeOrigin() {
    const { performance: performance } = $kjL8z.GLOBAL_OBJ;
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = $9gcfE.withRandomSafeContext(()=>performance.now());
    const dateNow = $9gcfE.safeDateNow();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $a250324ba4f734b4$var$browserPerformanceTimeOrigin() {
    if ($a250324ba4f734b4$var$cachedTimeOrigin === null) $a250324ba4f734b4$var$cachedTimeOrigin = $a250324ba4f734b4$var$getBrowserTimeOrigin();
    return $a250324ba4f734b4$var$cachedTimeOrigin;
}
module.exports.browserPerformanceTimeOrigin = $a250324ba4f734b4$var$browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $a250324ba4f734b4$var$dateTimestampInSeconds;
module.exports.timestampInSeconds = $a250324ba4f734b4$var$timestampInSeconds;

});


parcelRegister("b85dT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $81a47e3dd103d8aa$var$merge(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $81a47e3dd103d8aa$var$merge(output[key], mergeObj[key], levels - 1);
    return output;
}
module.exports.merge = $81a47e3dd103d8aa$var$merge;

});

parcelRegister("IRlr7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3q6O = parcelRequire("f3q6O");
function $086d7d54e8ae4945$var$generateTraceId() {
    return $f3q6O.uuid4();
}
function $086d7d54e8ae4945$var$generateSpanId() {
    return $f3q6O.uuid4().substring(16);
}
module.exports.generateSpanId = $086d7d54e8ae4945$var$generateSpanId;
module.exports.generateTraceId = $086d7d54e8ae4945$var$generateTraceId;

});

parcelRegister("6dWkJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1hzu4 = parcelRequire("1hzu4");

var $9zDKz = parcelRequire("9zDKz");
const $488134c402222e6b$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $488134c402222e6b$var$_setSpanForScope(scope, span) {
    if (span) $1hzu4.addNonEnumerableProperty(scope, $488134c402222e6b$var$SCOPE_SPAN_FIELD, $9zDKz.makeWeakRef(span));
    else delete scope[$488134c402222e6b$var$SCOPE_SPAN_FIELD];
}
function $488134c402222e6b$var$_getSpanForScope(scope) {
    return $9zDKz.derefWeakRef(scope[$488134c402222e6b$var$SCOPE_SPAN_FIELD]);
}
module.exports._getSpanForScope = $488134c402222e6b$var$_getSpanForScope;
module.exports._setSpanForScope = $488134c402222e6b$var$_setSpanForScope;

});
parcelRegister("9zDKz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kjL8z = parcelRequire("kjL8z");
function $6f86378003e80784$var$makeWeakRef(value) {
    try {
        const WeakRefImpl = $kjL8z.GLOBAL_OBJ.WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $6f86378003e80784$var$derefWeakRef(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}
module.exports.derefWeakRef = $6f86378003e80784$var$derefWeakRef;
module.exports.makeWeakRef = $6f86378003e80784$var$makeWeakRef;

});




parcelRegister("l17Xm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $f4cfdcf5f87f8bb5$var$isActualPromise = (p)=>p instanceof Promise && !p[$f4cfdcf5f87f8bb5$var$kChainedCopy];
const $f4cfdcf5f87f8bb5$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $f4cfdcf5f87f8bb5$var$chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $f4cfdcf5f87f8bb5$var$isActualPromise(chained) && $f4cfdcf5f87f8bb5$var$isActualPromise(original) ? chained : $f4cfdcf5f87f8bb5$var$copyProps(original, chained);
};
const $f4cfdcf5f87f8bb5$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$f4cfdcf5f87f8bb5$var$kChainedCopy]: true
    });
    return chained;
};
module.exports.chainAndCopyPromiseLike = $f4cfdcf5f87f8bb5$var$chainAndCopyPromiseLike;

});



parcelRegister("9Db3P", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $c34Je = parcelRequire("c34Je");
function $703056052be5947d$var$isAttributeObject(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $703056052be5947d$var$attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value: value, unit: unit } = $703056052be5947d$var$isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $703056052be5947d$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $703056052be5947d$var$serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $703056052be5947d$var$attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $703056052be5947d$var$estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $703056052be5947d$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ($c34Je.isPrimitive(val)) weight += $703056052be5947d$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $703056052be5947d$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $703056052be5947d$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}
module.exports.attributeValueToTypedAttributeValue = $703056052be5947d$var$attributeValueToTypedAttributeValue;
module.exports.estimateTypedAttributesSizeInBytes = $703056052be5947d$var$estimateTypedAttributesSizeInBytes;
module.exports.isAttributeObject = $703056052be5947d$var$isAttributeObject;
module.exports.serializeAttributes = $703056052be5947d$var$serializeAttributes;

});

parcelRegister("gCYmH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2dzy9 = parcelRequire("2dzy9");

var $aWGVj = parcelRequire("aWGVj");

var $gIF8m = parcelRequire("gIF8m");

var $IRlr7 = parcelRequire("IRlr7");
let $c1af0535c34cf0a6$var$_externalPropagationContextProvider;
function $c1af0535c34cf0a6$var$registerExternalPropagationContext(fn) {
    $c1af0535c34cf0a6$var$_externalPropagationContextProvider = fn;
}
function $c1af0535c34cf0a6$var$getExternalPropagationContext() {
    return $c1af0535c34cf0a6$var$_externalPropagationContextProvider?.();
}
function $c1af0535c34cf0a6$var$hasExternalPropagationContext() {
    return $c1af0535c34cf0a6$var$_externalPropagationContextProvider !== void 0;
}
function $c1af0535c34cf0a6$var$getCurrentScope() {
    const carrier$1 = $aWGVj.getMainCarrier();
    const acs = $2dzy9.getAsyncContextStrategy(carrier$1);
    return acs.getCurrentScope();
}
function $c1af0535c34cf0a6$var$getIsolationScope() {
    const carrier$1 = $aWGVj.getMainCarrier();
    const acs = $2dzy9.getAsyncContextStrategy(carrier$1);
    return acs.getIsolationScope();
}
function $c1af0535c34cf0a6$var$getGlobalScope() {
    return $aWGVj.getGlobalSingleton("globalScope", ()=>new $gIF8m.Scope());
}
function $c1af0535c34cf0a6$var$withScope(...rest) {
    const carrier$1 = $aWGVj.getMainCarrier();
    const acs = $2dzy9.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $c1af0535c34cf0a6$var$withIsolationScope(...rest) {
    const carrier$1 = $aWGVj.getMainCarrier();
    const acs = $2dzy9.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $c1af0535c34cf0a6$var$getClient() {
    return $c1af0535c34cf0a6$var$getCurrentScope().getClient();
}
function $c1af0535c34cf0a6$var$getTraceContextFromScope(scope) {
    const externalContext = $c1af0535c34cf0a6$var$getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext$1 = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext$1;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || $IRlr7.generateSpanId()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}
module.exports.getClient = $c1af0535c34cf0a6$var$getClient;
module.exports.getCurrentScope = $c1af0535c34cf0a6$var$getCurrentScope;
module.exports.getExternalPropagationContext = $c1af0535c34cf0a6$var$getExternalPropagationContext;
module.exports.getGlobalScope = $c1af0535c34cf0a6$var$getGlobalScope;
module.exports.getIsolationScope = $c1af0535c34cf0a6$var$getIsolationScope;
module.exports.getTraceContextFromScope = $c1af0535c34cf0a6$var$getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $c1af0535c34cf0a6$var$hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $c1af0535c34cf0a6$var$registerExternalPropagationContext;
module.exports.withIsolationScope = $c1af0535c34cf0a6$var$withIsolationScope;
module.exports.withScope = $c1af0535c34cf0a6$var$withScope;

});

parcelRegister("k6VdG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = "sentry.status.message";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
const $ea40c0d9bbcf0fd4$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
const $ea40c0d9bbcf0fd4$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $ea40c0d9bbcf0fd4$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $ea40c0d9bbcf0fd4$var$SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $ea40c0d9bbcf0fd4$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;

});

parcelRegister("3pcOx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $27ada588f42ee2bc$var$SPAN_STATUS_UNSET = 0;
const $27ada588f42ee2bc$var$SPAN_STATUS_OK = 1;
const $27ada588f42ee2bc$var$SPAN_STATUS_ERROR = 2;
function $27ada588f42ee2bc$var$getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $27ada588f42ee2bc$var$SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
                message: "not_found"
            };
        case 409:
            return {
                code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
                message: "already_exists"
            };
        case 413:
            return {
                code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
                message: "cancelled"
            };
        default:
            return {
                code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
                message: "unavailable"
            };
        case 504:
            return {
                code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
                message: "internal_error"
            };
    }
    return {
        code: $27ada588f42ee2bc$var$SPAN_STATUS_ERROR,
        message: "internal_error"
    };
}
function $27ada588f42ee2bc$var$setHttpStatus(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $27ada588f42ee2bc$var$getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}
module.exports.SPAN_STATUS_ERROR = $27ada588f42ee2bc$var$SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $27ada588f42ee2bc$var$SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $27ada588f42ee2bc$var$SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $27ada588f42ee2bc$var$getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $27ada588f42ee2bc$var$setHttpStatus;

});

parcelRegister("f05NK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1hzu4 = parcelRequire("1hzu4");

var $9zDKz = parcelRequire("9zDKz");
const $aebb5b283f0f599b$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $aebb5b283f0f599b$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $aebb5b283f0f599b$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
function $aebb5b283f0f599b$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        $1hzu4.addNonEnumerableProperty(span, $aebb5b283f0f599b$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $9zDKz.makeWeakRef(isolationScope));
        $1hzu4.addNonEnumerableProperty(span, $aebb5b283f0f599b$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $aebb5b283f0f599b$var$getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$aebb5b283f0f599b$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $9zDKz.derefWeakRef(spanWithScopes[$aebb5b283f0f599b$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $aebb5b283f0f599b$var$markSpanForOtelSourceInference(span) {
    $1hzu4.addNonEnumerableProperty(span, $aebb5b283f0f599b$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $aebb5b283f0f599b$var$spanShouldInferOtelSource(span) {
    return span[$aebb5b283f0f599b$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
module.exports.getCapturedScopesOnSpan = $aebb5b283f0f599b$var$getCapturedScopesOnSpan;
module.exports.markSpanForOtelSourceInference = $aebb5b283f0f599b$var$markSpanForOtelSourceInference;
module.exports.setCapturedScopesOnSpan = $aebb5b283f0f599b$var$setCapturedScopesOnSpan;
module.exports.spanShouldInferOtelSource = $aebb5b283f0f599b$var$spanShouldInferOtelSource;

});

parcelRegister("h5NbM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $99stL = parcelRequire("99stL");

var $gCbFP = parcelRequire("gCbFP");

var $iIaFt = parcelRequire("iIaFt");

var $9cJmP = parcelRequire("9cJmP");

var $IRlr7 = parcelRequire("IRlr7");

var $9gcfE = parcelRequire("9gcfE");
const $c7190f348ee1a3d2$var$TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $c7190f348ee1a3d2$var$extractTraceparentData(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($c7190f348ee1a3d2$var$TRACEPARENT_REGEXP);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $c7190f348ee1a3d2$var$propagationContextFromHeaders(sentryTrace, baggage$1) {
    const traceparentData = $c7190f348ee1a3d2$var$extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = $gCbFP.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (!traceparentData?.traceId) return {
        traceId: $IRlr7.generateTraceId(),
        sampleRand: $9gcfE.safeMathRandom()
    };
    const sampleRand = $c7190f348ee1a3d2$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $c7190f348ee1a3d2$var$generateSentryTraceHeader(traceId = $IRlr7.generateTraceId(), spanId = $IRlr7.generateSpanId(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $c7190f348ee1a3d2$var$generateTraceparentHeader(traceId = $IRlr7.generateTraceId(), spanId = $IRlr7.generateSpanId(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $c7190f348ee1a3d2$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = $9cJmP.parseSampleRate(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = $9cJmP.parseSampleRate(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    $9gcfE.safeMathRandom() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + $9gcfE.safeMathRandom() * (1 - parsedSampleRate);
    else return $9gcfE.safeMathRandom();
}
function $c7190f348ee1a3d2$var$shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = $iIaFt.extractOrgIdFromClient(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        $99stL.debug.log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            $99stL.debug.log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}
module.exports.TRACEPARENT_REGEXP = $c7190f348ee1a3d2$var$TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $c7190f348ee1a3d2$var$extractTraceparentData;
module.exports.generateSentryTraceHeader = $c7190f348ee1a3d2$var$generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $c7190f348ee1a3d2$var$generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $c7190f348ee1a3d2$var$propagationContextFromHeaders;
module.exports.shouldContinueTrace = $c7190f348ee1a3d2$var$shouldContinueTrace;

});
parcelRegister("gCbFP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $c34Je = parcelRequire("c34Je");
const $c189401a91691e28$var$SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const $c189401a91691e28$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
const $c189401a91691e28$var$MAX_BAGGAGE_STRING_LENGTH = 8192;
function $c189401a91691e28$var$baggageHeaderToDynamicSamplingContext(baggageHeader) {
    const baggageObject = $c189401a91691e28$var$parseBaggageHeader(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($c189401a91691e28$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice($c189401a91691e28$var$SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $c189401a91691e28$var$dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$c189401a91691e28$var$SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $c189401a91691e28$var$objectToBaggageHeader(sentryPrefixedDSC);
}
function $c189401a91691e28$var$parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !$c34Je.isString(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $c189401a91691e28$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $c189401a91691e28$var$baggageHeaderToObject(baggageHeader);
}
function $c189401a91691e28$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $c189401a91691e28$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $c189401a91691e28$var$MAX_BAGGAGE_STRING_LENGTH) {
            $7piqH.DEBUG_BUILD && $99stL.debug.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $c189401a91691e28$var$mergeBaggageHeaders(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $c189401a91691e28$var$parseBaggageHeader(existing);
    const incomingEntries = $c189401a91691e28$var$parseBaggageHeader(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($c189401a91691e28$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($c189401a91691e28$var$SENTRY_BAGGAGE_KEY_PREFIX)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $c189401a91691e28$var$objectToBaggageHeader(merged);
}
module.exports.MAX_BAGGAGE_STRING_LENGTH = $c189401a91691e28$var$MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $c189401a91691e28$var$SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $c189401a91691e28$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $c189401a91691e28$var$baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $c189401a91691e28$var$dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $c189401a91691e28$var$mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $c189401a91691e28$var$objectToBaggageHeader;
module.exports.parseBaggageHeader = $c189401a91691e28$var$parseBaggageHeader;

});

parcelRegister("iIaFt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");
const $d9f49c7ca763c0c7$var$ORG_ID_REGEX = /^o(\d+)\./;
const $d9f49c7ca763c0c7$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $d9f49c7ca763c0c7$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $d9f49c7ca763c0c7$var$dsnToString(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $d9f49c7ca763c0c7$var$dsnFromString(str) {
    const match = $d9f49c7ca763c0c7$var$DSN_REGEX.exec(str);
    if (!match) {
        $99stL.consoleSandbox(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $d9f49c7ca763c0c7$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $d9f49c7ca763c0c7$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $d9f49c7ca763c0c7$var$validateDsn(dsn) {
    if (!$7piqH.DEBUG_BUILD) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            $99stL.debug.error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        $99stL.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$d9f49c7ca763c0c7$var$isValidProtocol(protocol)) {
        $99stL.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        $99stL.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $d9f49c7ca763c0c7$var$extractOrgIdFromDsnHost(host) {
    const match = host.match($d9f49c7ca763c0c7$var$ORG_ID_REGEX);
    return match?.[1];
}
function $d9f49c7ca763c0c7$var$extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $d9f49c7ca763c0c7$var$extractOrgIdFromDsnHost(host);
    return org_id;
}
function $d9f49c7ca763c0c7$var$makeDsn(from) {
    const components = typeof from === "string" ? $d9f49c7ca763c0c7$var$dsnFromString(from) : $d9f49c7ca763c0c7$var$dsnFromComponents(from);
    if (!components || !$d9f49c7ca763c0c7$var$validateDsn(components)) return void 0;
    return components;
}
module.exports.dsnFromString = $d9f49c7ca763c0c7$var$dsnFromString;
module.exports.dsnToString = $d9f49c7ca763c0c7$var$dsnToString;
module.exports.extractOrgIdFromClient = $d9f49c7ca763c0c7$var$extractOrgIdFromClient;
module.exports.extractOrgIdFromDsnHost = $d9f49c7ca763c0c7$var$extractOrgIdFromDsnHost;
module.exports.makeDsn = $d9f49c7ca763c0c7$var$makeDsn;

});

parcelRegister("9cJmP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6b386d02c672e038$var$parseSampleRate(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}
module.exports.parseSampleRate = $6b386d02c672e038$var$parseSampleRate;

});




parcelRegister("jJcuV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $k6VdG = parcelRequire("k6VdG");

var $99stL = parcelRequire("99stL");

var $fe1rL = parcelRequire("fe1rL");

var $2aD4H = parcelRequire("2aD4H");

var $6dWkJ = parcelRequire("6dWkJ");

var $cp5Iu = parcelRequire("cp5Iu");

var $dVZms = parcelRequire("dVZms");

var $2BhuU = parcelRequire("2BhuU");

var $dJMCu = parcelRequire("dJMCu");

var $3pcOx = parcelRequire("3pcOx");

var $lRCeh = parcelRequire("lRCeh");

var $f05NK = parcelRequire("f05NK");
const $e5cbea1a87a61244$var$TRACING_DEFAULTS = {
    idleTimeout: 1e3,
    finalTimeout: 3e4,
    childSpanTimeout: 15e3
};
const $e5cbea1a87a61244$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $e5cbea1a87a61244$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $e5cbea1a87a61244$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $e5cbea1a87a61244$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function $e5cbea1a87a61244$var$startIdleSpan(startSpanOptions, options = {}) {
    const activities = /* @__PURE__ */ new Map();
    let _finished = false;
    let _idleTimeoutID;
    let _finishReason = $e5cbea1a87a61244$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $e5cbea1a87a61244$var$TRACING_DEFAULTS.idleTimeout, finalTimeout: finalTimeout = $e5cbea1a87a61244$var$TRACING_DEFAULTS.finalTimeout, childSpanTimeout: childSpanTimeout = $e5cbea1a87a61244$var$TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = $gCYmH.getClient();
    const scope = $gCYmH.getCurrentScope();
    if (!client || !$fe1rL.hasSpansEnabled()) {
        const span2 = new $2BhuU.SentryNonRecordingSpan({
            traceId: scope.getPropagationContext().traceId
        });
        $f05NK.setCapturedScopesOnSpan(span2, scope, $gCYmH.getIsolationScope());
        return span2;
    }
    const previousActiveSpan = $cp5Iu.getActiveSpan();
    const span = $e5cbea1a87a61244$var$_startIdleSpan(startSpanOptions);
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            if ($2BhuU.spanIsNonRecordingSpan(thisArg)) return;
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || $dVZms.timestampInSeconds();
            const spanEndTimestamp = $cp5Iu.spanTimeInputToSeconds(timestamp);
            const spans = $cp5Iu.getSpanDescendants(span).filter((child)=>child !== span);
            const spanJson = $cp5Iu.spanToJSON(span);
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = $cp5Iu.spanToJSON(current);
                if (!currentSpanJson.timestamp) return acc;
                if (ignoreSpans && $2aD4H.shouldIgnoreSpan({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, void 0);
            const spanStartTimestamp = spanJson.start_timestamp;
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = void 0;
        }
    }
    function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $e5cbea1a87a61244$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $e5cbea1a87a61244$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = $dVZms.timestampInSeconds();
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
    }
    function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = $dVZms.timestampInSeconds();
            _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        $6dWkJ._setSpanForScope(scope, previousActiveSpan);
        const spanJSON = $cp5Iu.spanToJSON(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute($k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: $3pcOx.SPAN_STATUS_OK
        });
        $99stL.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = $cp5Iu.getSpanDescendants(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: $3pcOx.SPAN_STATUS_ERROR,
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                $7piqH.DEBUG_BUILD && $99stL.debug.log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
            }
            const childSpanJSON = $cp5Iu.spanToJSON(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if ($7piqH.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
                if (!spanStartedBeforeIdleSpanEnd) $99stL.debug.log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) $99stL.debug.log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                $cp5Iu.removeChildSpanFromSpan(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        if (_finished || startedSpan === span || !!$cp5Iu.spanToJSON(startedSpan).timestamp || startedSpan instanceof $dJMCu.SentrySpan && startedSpan.isStandaloneSpan()) return;
        const allSpans = $cp5Iu.getSpanDescendants(span);
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: $3pcOx.SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            });
            _finishReason = $e5cbea1a87a61244$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $e5cbea1a87a61244$var$_startIdleSpan(options) {
    const span = $lRCeh.startInactiveSpan(options);
    $6dWkJ._setSpanForScope($gCYmH.getCurrentScope(), span);
    $7piqH.DEBUG_BUILD && $99stL.debug.log("[Tracing] Started span is an idle span");
    return span;
}
module.exports.TRACING_DEFAULTS = $e5cbea1a87a61244$var$TRACING_DEFAULTS;
module.exports.startIdleSpan = $e5cbea1a87a61244$var$startIdleSpan;

});
parcelRegister("fe1rL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");
function $b159491d902ad1e6$var$hasSpansEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || $gCYmH.getClient()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
module.exports.hasSpansEnabled = $b159491d902ad1e6$var$hasSpansEnabled;

});

parcelRegister("2aD4H", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $fdTwu = parcelRequire("fdTwu");
function $194ad3681c7ea29a$var$logIgnoredSpan(droppedSpan) {
    $99stL.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $194ad3681c7ea29a$var$shouldIgnoreSpan(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($194ad3681c7ea29a$var$isStringOrRegExp(pattern)) {
            if (span.description && $fdTwu.isMatchingPattern(span.description, pattern)) {
                $7piqH.DEBUG_BUILD && $194ad3681c7ea29a$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && $fdTwu.isMatchingPattern(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && $fdTwu.isMatchingPattern(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$194ad3681c7ea29a$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            $7piqH.DEBUG_BUILD && $194ad3681c7ea29a$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $194ad3681c7ea29a$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return $fdTwu.isMatchingPattern(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $194ad3681c7ea29a$var$reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $194ad3681c7ea29a$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}
module.exports.reparentChildSpans = $194ad3681c7ea29a$var$reparentChildSpans;
module.exports.shouldIgnoreSpan = $194ad3681c7ea29a$var$shouldIgnoreSpan;

});

parcelRegister("2BhuU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1hzu4 = parcelRequire("1hzu4");

var $IRlr7 = parcelRequire("IRlr7");

var $cp5Iu = parcelRequire("cp5Iu");
const $1e4c9c17ec3c0b6a$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $1e4c9c17ec3c0b6a$var$SentryNonRecordingSpan {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $IRlr7.generateTraceId();
        this._spanId = spanContext.spanId || $IRlr7.generateSpanId();
        this.dropReason = spanContext.dropReason;
        $1hzu4.addNonEnumerableProperty(this, $1e4c9c17ec3c0b6a$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: $cp5Iu.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $1e4c9c17ec3c0b6a$var$spanIsNonRecordingSpan(span) {
    return !!span && span[$1e4c9c17ec3c0b6a$var$NON_RECORDING_SPAN_FIELD] === true;
}
module.exports.SentryNonRecordingSpan = $1e4c9c17ec3c0b6a$var$SentryNonRecordingSpan;
module.exports.spanIsNonRecordingSpan = $1e4c9c17ec3c0b6a$var$spanIsNonRecordingSpan;

});

parcelRegister("dJMCu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $i8C0r = parcelRequire("i8C0r");

var $k6VdG = parcelRequire("k6VdG");

var $99stL = parcelRequire("99stL");

var $IRlr7 = parcelRequire("IRlr7");

var $cp5Iu = parcelRequire("cp5Iu");

var $dVZms = parcelRequire("dVZms");

var $evhDU = parcelRequire("evhDU");

var $a6Ys8 = parcelRequire("a6Ys8");

var $kEMy6 = parcelRequire("kEMy6");

var $wmosz = parcelRequire("wmosz");

var $f05NK = parcelRequire("f05NK");
const $a0053132c8c0bc9c$var$MAX_SPAN_COUNT = 1e3;
class $a0053132c8c0bc9c$var$SentrySpan {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $IRlr7.generateTraceId();
        this._spanId = spanContext.spanId || $IRlr7.generateSpanId();
        this._startTime = spanContext.startTimestamp || $dVZms.timestampInSeconds();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "manual",
            [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? $cp5Iu.TRACE_FLAG_SAMPLED : $cp5Iu.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = $cp5Iu.spanTimeInputToSeconds(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        if (!$f05NK.spanShouldInferOtelSource(this)) this.setAttribute($k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) return;
        this._endTime = $cp5Iu.spanTimeInputToSeconds(endTimestamp);
        $a6Ys8.logSpanEnd(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: $cp5Iu.getStatusMessage(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[$k6VdG.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[$k6VdG.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: $kEMy6.timedEventsToMeasurements(this._events),
            is_segment: this._isStandaloneSpan && $cp5Iu.getRootSpan(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? $cp5Iu.getRootSpan(this).spanContext().spanId : void 0,
            links: $cp5Iu.convertSpanLinksForEnvelope(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === $cp5Iu.getRootSpan(this),
            status: $cp5Iu.getSimpleStatus(this._status),
            attributes: $cp5Iu.addStatusMessageAttribute(this._attributes, this._status),
            links: $cp5Iu.getStreamedSpanLinks(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        $7piqH.DEBUG_BUILD && $99stL.debug.log("[Tracing] Adding an event to span:", name);
        const time$1 = $a0053132c8c0bc9c$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || $dVZms.timestampInSeconds();
        const attributes = $a0053132c8c0bc9c$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: $cp5Iu.spanTimeInputToSeconds(time$1),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = $gCYmH.getClient();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const isSegmentSpan = this._isStandaloneSpan || this === $cp5Iu.getRootSpan(this);
        if (!isSegmentSpan) return;
        if (this._isStandaloneSpan) {
            if (this._sampled) $a0053132c8c0bc9c$var$sendSpanEnvelope($i8C0r.createSpanEnvelope([
                this
            ], client));
            else {
                $7piqH.DEBUG_BUILD && $99stL.debug.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        } else if (client && $wmosz.hasSpanStreamingEnabled(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = $f05NK.getCapturedScopesOnSpan(this).scope || $gCYmH.getCurrentScope();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        if (!$a0053132c8c0bc9c$var$isFullFinishedSpan($cp5Iu.spanToJSON(this))) return void 0;
        if (!this._name) {
            $7piqH.DEBUG_BUILD && $99stL.debug.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = $f05NK.getCapturedScopesOnSpan(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        const finishedSpans = $cp5Iu.getSpanDescendants(this).filter((span)=>span !== this && !$a0053132c8c0bc9c$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>$cp5Iu.spanToJSON(span)).filter($a0053132c8c0bc9c$var$isFullFinishedSpan);
        const source = this._attributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        delete this._attributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: $cp5Iu.spanToTransactionTraceContext(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $a0053132c8c0bc9c$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $a0053132c8c0bc9c$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: $evhDU.getDynamicSamplingContextFromSpan(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = $kEMy6.timedEventsToMeasurements(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            $7piqH.DEBUG_BUILD && $99stL.debug.log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $a0053132c8c0bc9c$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $a0053132c8c0bc9c$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $a0053132c8c0bc9c$var$isStandaloneSpan(span) {
    return span instanceof $a0053132c8c0bc9c$var$SentrySpan && span.isStandaloneSpan();
}
function $a0053132c8c0bc9c$var$sendSpanEnvelope(envelope) {
    const client = $gCYmH.getClient();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}
module.exports.SentrySpan = $a0053132c8c0bc9c$var$SentrySpan;

});
parcelRegister("i8C0r", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $evhDU = parcelRequire("evhDU");

var $5aMPP = parcelRequire("5aMPP");

var $iIaFt = parcelRequire("iIaFt");

var $l008j = parcelRequire("l008j");

var $9gcfE = parcelRequire("9gcfE");

var $2aD4H = parcelRequire("2aD4H");

var $cp5Iu = parcelRequire("cp5Iu");
function $d34674974a8309ef$var$_enhanceEventWithSdkInfo(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $d34674974a8309ef$var$createSessionEnvelope(session, dsn$1, metadata, tunnel) {
    const sdkInfo = $l008j.getSdkMetadataForEnvelopeHeader(metadata);
    const envelopeHeaders = {
        sent_at: new Date($9gcfE.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $iIaFt.dsnToString(dsn$1)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return $l008j.createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
function $d34674974a8309ef$var$createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = $l008j.getSdkMetadataForEnvelopeHeader(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $d34674974a8309ef$var$_enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = $l008j.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return $l008j.createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
function $d34674974a8309ef$var$createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = $evhDU.getDynamicSamplingContextFromSpan(spans[0]);
    const dsn$1 = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date($9gcfE.safeDateNow()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn$1 && {
            dsn: $iIaFt.dsnToString(dsn$1)
        }
    };
    const { beforeSendSpan: beforeSendSpan$1, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = $cp5Iu.spanToJSON(span);
        return !$2aD4H.shouldIgnoreSpan({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan$1 ? (span)=>{
        const spanJson = $cp5Iu.spanToJSON(span);
        const processedSpan = !$5aMPP.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
        if (!processedSpan) {
            $cp5Iu.showSpanDropWarning();
            return spanJson;
        }
        return processedSpan;
    } : $cp5Iu.spanToJSON;
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push($l008j.createSpanEnvelopeItem(spanJson));
    }
    return $l008j.createEnvelope(headers, items);
}
module.exports._enhanceEventWithSdkInfo = $d34674974a8309ef$var$_enhanceEventWithSdkInfo;
module.exports.createEventEnvelope = $d34674974a8309ef$var$createEventEnvelope;
module.exports.createSessionEnvelope = $d34674974a8309ef$var$createSessionEnvelope;
module.exports.createSpanEnvelope = $d34674974a8309ef$var$createSpanEnvelope;

});
parcelRegister("evhDU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $28n4F = parcelRequire("28n4F");

var $gCYmH = parcelRequire("gCYmH");

var $k6VdG = parcelRequire("k6VdG");

var $gCbFP = parcelRequire("gCbFP");

var $iIaFt = parcelRequire("iIaFt");

var $fe1rL = parcelRequire("fe1rL");

var $1hzu4 = parcelRequire("1hzu4");

var $cp5Iu = parcelRequire("cp5Iu");

var $2BhuU = parcelRequire("2BhuU");

var $f05NK = parcelRequire("f05NK");
const $a8f1a56546130dc8$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $a8f1a56546130dc8$var$freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    $1hzu4.addNonEnumerableProperty(spanWithMaybeDsc, $a8f1a56546130dc8$var$FROZEN_DSC_FIELD, dsc);
}
function $a8f1a56546130dc8$var$getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || $28n4F.DEFAULT_ENVIRONMENT,
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: $iIaFt.extractOrgIdFromClient(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $a8f1a56546130dc8$var$getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $a8f1a56546130dc8$var$getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
function $a8f1a56546130dc8$var$getDynamicSamplingContextFromSpan(span) {
    const client = $gCYmH.getClient();
    if (!client) return {};
    const rootSpan = $cp5Iu.getRootSpan(span);
    const rootSpanJson = $cp5Iu.spanToJSON(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$a8f1a56546130dc8$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    if ($2BhuU.spanIsNonRecordingSpan(rootSpan) && !$fe1rL.hasSpansEnabled(client.getOptions())) {
        const capturedScope = $f05NK.getCapturedScopesOnSpan(rootSpan).scope;
        if (capturedScope) return applyLocalSampleRateToDsc({
            ...$a8f1a56546130dc8$var$getDynamicSamplingContextFromScope(client, capturedScope)
        });
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && $gCbFP.baggageHeaderToDynamicSamplingContext(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $a8f1a56546130dc8$var$getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    const source = rootSpanAttributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.span.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ($fe1rL.hasSpansEnabled()) {
        dsc.sampled = String($cp5Iu.spanIsSampled(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        $f05NK.getCapturedScopesOnSpan(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $a8f1a56546130dc8$var$spanToBaggageHeader(span) {
    const dsc = $a8f1a56546130dc8$var$getDynamicSamplingContextFromSpan(span);
    return $gCbFP.dynamicSamplingContextToSentryBaggageHeader(dsc);
}
module.exports.freezeDscOnSpan = $a8f1a56546130dc8$var$freezeDscOnSpan;
module.exports.getDynamicSamplingContextFromClient = $a8f1a56546130dc8$var$getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $a8f1a56546130dc8$var$getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $a8f1a56546130dc8$var$getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $a8f1a56546130dc8$var$spanToBaggageHeader;

});
parcelRegister("28n4F", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $18de3a3840e4f319$var$DEFAULT_ENVIRONMENT = "production";
const $18de3a3840e4f319$var$DEV_ENVIRONMENT = "development";
module.exports.DEFAULT_ENVIRONMENT = $18de3a3840e4f319$var$DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $18de3a3840e4f319$var$DEV_ENVIRONMENT;

});


parcelRegister("5aMPP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1hzu4 = parcelRequire("1hzu4");
function $3c43c488e1b45f81$var$withStreamedSpan(callback) {
    $1hzu4.addNonEnumerableProperty(callback, "_streamed", true);
    return callback;
}
function $3c43c488e1b45f81$var$isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}
module.exports.isStreamedBeforeSendSpanCallback = $3c43c488e1b45f81$var$isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $3c43c488e1b45f81$var$withStreamedSpan;

});

parcelRegister("l008j", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aWGVj = parcelRequire("aWGVj");

var $iIaFt = parcelRequire("iIaFt");

var $3COzy = parcelRequire("3COzy");

var $9gcfE = parcelRequire("9gcfE");

var $kjL8z = parcelRequire("kjL8z");
function $f499b37824ebef46$var$createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $f499b37824ebef46$var$addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $f499b37824ebef46$var$forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $f499b37824ebef46$var$envelopeContainsItemType(envelope, types) {
    return $f499b37824ebef46$var$forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
function $f499b37824ebef46$var$encodeUTF8(input) {
    const carrier$1 = $aWGVj.getSentryCarrier($kjL8z.GLOBAL_OBJ);
    return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $f499b37824ebef46$var$decodeUTF8(input) {
    const carrier$1 = $aWGVj.getSentryCarrier($kjL8z.GLOBAL_OBJ);
    return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $f499b37824ebef46$var$serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $f499b37824ebef46$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $f499b37824ebef46$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify($3COzy.normalize(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $f499b37824ebef46$var$concatBuffers(parts);
}
function $f499b37824ebef46$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $f499b37824ebef46$var$parseEnvelope(env) {
    let buffer = typeof env === "string" ? $f499b37824ebef46$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($f499b37824ebef46$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $f499b37824ebef46$var$createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $f499b37824ebef46$var$createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === "string" ? $f499b37824ebef46$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $f499b37824ebef46$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $f499b37824ebef46$var$_isOverriddenType(type) {
    return type in $f499b37824ebef46$var$DATA_CATEGORY_OVERRIDES;
}
function $f499b37824ebef46$var$envelopeItemTypeToDataCategory(type) {
    return $f499b37824ebef46$var$_isOverriddenType(type) ? $f499b37824ebef46$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $f499b37824ebef46$var$getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $f499b37824ebef46$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date($9gcfE.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $iIaFt.dsnToString(dsn$1)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}
module.exports.addItemToEnvelope = $f499b37824ebef46$var$addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $f499b37824ebef46$var$createAttachmentEnvelopeItem;
module.exports.createEnvelope = $f499b37824ebef46$var$createEnvelope;
module.exports.createEventEnvelopeHeaders = $f499b37824ebef46$var$createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $f499b37824ebef46$var$createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $f499b37824ebef46$var$envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $f499b37824ebef46$var$envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $f499b37824ebef46$var$forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $f499b37824ebef46$var$getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $f499b37824ebef46$var$parseEnvelope;
module.exports.serializeEnvelope = $f499b37824ebef46$var$serializeEnvelope;

});


parcelRegister("a6Ys8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $cp5Iu = parcelRequire("cp5Iu");
function $75c95b95c929e94a$var$logSpanStart(span) {
    if (!$7piqH.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = $cp5Iu.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = $cp5Iu.spanIsSampled(span);
    const rootSpan = $cp5Iu.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = $cp5Iu.spanToJSON(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    $99stL.debug.log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $75c95b95c929e94a$var$logSpanEnd(span) {
    if (!$7piqH.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = $cp5Iu.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = $cp5Iu.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    $99stL.debug.log(msg);
}
module.exports.logSpanEnd = $75c95b95c929e94a$var$logSpanEnd;
module.exports.logSpanStart = $75c95b95c929e94a$var$logSpanStart;

});

parcelRegister("kEMy6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $k6VdG = parcelRequire("k6VdG");

var $99stL = parcelRequire("99stL");

var $cp5Iu = parcelRequire("cp5Iu");
function $f09d33e291c7440e$var$setMeasurement(name, value, unit, activeSpan = $cp5Iu.getActiveSpan()) {
    const rootSpan = activeSpan && $cp5Iu.getRootSpan(activeSpan);
    if (rootSpan) {
        $7piqH.DEBUG_BUILD && $99stL.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
            [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
        });
    }
}
function $f09d33e291c7440e$var$timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}
module.exports.setMeasurement = $f09d33e291c7440e$var$setMeasurement;
module.exports.timedEventsToMeasurements = $f09d33e291c7440e$var$timedEventsToMeasurements;

});

parcelRegister("wmosz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $06145c2893f6dfc8$var$hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === "stream";
}
module.exports.hasSpanStreamingEnabled = $06145c2893f6dfc8$var$hasSpanStreamingEnabled;

});


parcelRegister("lRCeh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2dzy9 = parcelRequire("2dzy9");

var $aWGVj = parcelRequire("aWGVj");

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $k6VdG = parcelRequire("k6VdG");

var $gCbFP = parcelRequire("gCbFP");

var $99stL = parcelRequire("99stL");

var $1TQ1B = parcelRequire("1TQ1B");

var $fe1rL = parcelRequire("fe1rL");

var $2aD4H = parcelRequire("2aD4H");

var $wmosz = parcelRequire("wmosz");

var $9cJmP = parcelRequire("9cJmP");

var $IRlr7 = parcelRequire("IRlr7");

var $9gcfE = parcelRequire("9gcfE");

var $6dWkJ = parcelRequire("6dWkJ");

var $cp5Iu = parcelRequire("cp5Iu");

var $h5NbM = parcelRequire("h5NbM");

var $evhDU = parcelRequire("evhDU");

var $a6Ys8 = parcelRequire("a6Ys8");

var $7aZG6 = parcelRequire("7aZG6");

var $2BhuU = parcelRequire("2BhuU");

var $dJMCu = parcelRequire("dJMCu");

var $3pcOx = parcelRequire("3pcOx");

var $f05NK = parcelRequire("f05NK");
const $feac33c41f7a1a39$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
function $feac33c41f7a1a39$var$startSpan(options, callback) {
    const acs = $feac33c41f7a1a39$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $feac33c41f7a1a39$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $gCYmH.withScope(customForkedScope, ()=>{
        const wrapper = $feac33c41f7a1a39$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $gCYmH.getCurrentScope();
            const parentSpan = $feac33c41f7a1a39$var$getParentSpan(scope, customParentSpan);
            const client = $gCYmH.getClient();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $feac33c41f7a1a39$var$startMissingRequiredParentSpan(scope, client) : $feac33c41f7a1a39$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$feac33c41f7a1a39$var$_isIgnoredSpan(activeSpan) || !parentSpan) $6dWkJ._setSpanForScope(scope, activeSpan);
            return $1TQ1B.handleCallbackErrors(()=>callback(activeSpan), ()=>{
                const { status: status } = $cp5Iu.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $3pcOx.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $feac33c41f7a1a39$var$startSpanManual(options, callback) {
    const acs = $feac33c41f7a1a39$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $feac33c41f7a1a39$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $gCYmH.withScope(customForkedScope, ()=>{
        const wrapper = $feac33c41f7a1a39$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $gCYmH.getCurrentScope();
            const parentSpan = $feac33c41f7a1a39$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $feac33c41f7a1a39$var$startMissingRequiredParentSpan(scope, $gCYmH.getClient()) : $feac33c41f7a1a39$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$feac33c41f7a1a39$var$_isIgnoredSpan(activeSpan) || !parentSpan) $6dWkJ._setSpanForScope(scope, activeSpan);
            return $1TQ1B.handleCallbackErrors(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = $cp5Iu.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $3pcOx.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            });
        });
    });
}
function $feac33c41f7a1a39$var$startInactiveSpan(options) {
    const acs = $feac33c41f7a1a39$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $feac33c41f7a1a39$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>$gCYmH.withScope(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$feac33c41f7a1a39$var$withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = $gCYmH.getCurrentScope();
        const parentSpan = $feac33c41f7a1a39$var$getParentSpan(scope, customParentSpan);
        const client = $gCYmH.getClient();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $feac33c41f7a1a39$var$startMissingRequiredParentSpan(scope, client);
        return $feac33c41f7a1a39$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $feac33c41f7a1a39$var$continueTrace = (options, callback)=>{
    const carrier$1 = $aWGVj.getMainCarrier();
    const acs = $2dzy9.getAsyncContextStrategy(carrier$1);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage$1 } = options;
    const client = $gCYmH.getClient();
    const incomingDsc = $gCbFP.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (client && !$h5NbM.shouldContinueTrace(client, incomingDsc?.org_id)) return $feac33c41f7a1a39$var$startNewTrace(callback);
    return $gCYmH.withScope((scope)=>{
        const propagationContext = $h5NbM.propagationContextFromHeaders(sentryTrace, baggage$1);
        scope.setPropagationContext(propagationContext);
        $6dWkJ._setSpanForScope(scope, void 0);
        return callback();
    });
};
function $feac33c41f7a1a39$var$withActiveSpan(span, callback) {
    const acs = $feac33c41f7a1a39$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return $gCYmH.withScope((scope)=>{
        $6dWkJ._setSpanForScope(scope, span || void 0);
        return callback(scope);
    });
}
function $feac33c41f7a1a39$var$suppressTracing(callback) {
    const acs = $feac33c41f7a1a39$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return $gCYmH.withScope((scope)=>{
        scope.setSDKProcessingMetadata({
            [$feac33c41f7a1a39$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$feac33c41f7a1a39$var$SUPPRESS_TRACING_KEY]: void 0
        });
        return res;
    });
}
function $feac33c41f7a1a39$var$isTracingSuppressed(scope = $gCYmH.getCurrentScope()) {
    const acs = $feac33c41f7a1a39$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$feac33c41f7a1a39$var$SUPPRESS_TRACING_KEY] === true;
}
function $feac33c41f7a1a39$var$startNewTrace(callback) {
    const acs = $feac33c41f7a1a39$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return $gCYmH.withScope((scope)=>{
        scope.setPropagationContext({
            traceId: $IRlr7.generateTraceId(),
            sampleRand: $9gcfE.safeMathRandom()
        });
        $7piqH.DEBUG_BUILD && $99stL.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $feac33c41f7a1a39$var$withActiveSpan(null, callback);
    });
}
function $feac33c41f7a1a39$var$startMissingRequiredParentSpan(scope, client) {
    client?.recordDroppedEvent("no_parent_span", "span");
    const span = new $2BhuU.SentryNonRecordingSpan({
        traceId: scope.getPropagationContext().traceId
    });
    $f05NK.setCapturedScopesOnSpan(span, scope, $gCYmH.getIsolationScope());
    return span;
}
function $feac33c41f7a1a39$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = $gCYmH.getIsolationScope();
    if (!$fe1rL.hasSpansEnabled()) {
        const scopePropagationContext = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new $2BhuU.SentryNonRecordingSpan({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) $cp5Iu.addChildSpanToSpan(parentSpan, span2);
        $f05NK.setCapturedScopesOnSpan(span2, scope, isolationScope);
        return span2;
    }
    const client = $gCYmH.getClient();
    if ($feac33c41f7a1a39$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$feac33c41f7a1a39$var$isTracingSuppressed(scope)) client?.recordDroppedEvent("ignored", "span");
        const ignoredSpan = new $2BhuU.SentryNonRecordingSpan({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
        $f05NK.setCapturedScopesOnSpan(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $feac33c41f7a1a39$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        $cp5Iu.addChildSpanToSpan(parentSpan, span);
    } else if (parentSpan) {
        const dsc = $evhDU.getDynamicSamplingContextFromSpan(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = $cp5Iu.spanIsSampled(parentSpan);
        span = $feac33c41f7a1a39$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        $evhDU.freezeDscOnSpan(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $feac33c41f7a1a39$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        if (dsc) $evhDU.freezeDscOnSpan(span, dsc);
    }
    $a6Ys8.logSpanStart(span);
    return span;
}
function $feac33c41f7a1a39$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = $cp5Iu.spanTimeInputToSeconds(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $feac33c41f7a1a39$var$getAcs() {
    const carrier$1 = $aWGVj.getMainCarrier();
    return $2dzy9.getAsyncContextStrategy(carrier$1);
}
function $feac33c41f7a1a39$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    const client = $gCYmH.getClient();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const _isTracingSuppressed = $feac33c41f7a1a39$var$isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [
        false
    ] : $7aZG6.sampleSpan(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: $9cJmP.parseSampleRate(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new $dJMCu.SentrySpan({
        ...spanArguments,
        attributes: {
            [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
            [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !_isTracingSuppressed) {
        $7piqH.DEBUG_BUILD && $99stL.debug.log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", $wmosz.hasSpanStreamingEnabled(client) ? "span" : "transaction");
    }
    $f05NK.setCapturedScopesOnSpan(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $feac33c41f7a1a39$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const _isTracingSuppressed = $feac33c41f7a1a39$var$isTracingSuppressed(scope);
    const sampled = _isTracingSuppressed ? false : $cp5Iu.spanIsSampled(parentSpan);
    const childSpan = sampled ? new $dJMCu.SentrySpan({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new $2BhuU.SentryNonRecordingSpan({
        traceId: traceId
    });
    $cp5Iu.addChildSpanToSpan(parentSpan, childSpan);
    $f05NK.setCapturedScopesOnSpan(childSpan, scope, isolationScope);
    const client = $gCYmH.getClient();
    if (!client) return childSpan;
    if ($wmosz.hasSpanStreamingEnabled(client) && $2BhuU.spanIsNonRecordingSpan(childSpan)) {
        if ($2BhuU.spanIsNonRecordingSpan(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $feac33c41f7a1a39$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = $6dWkJ._getSpanForScope(scope);
    if (!span) return void 0;
    const client = $gCYmH.getClient();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return $cp5Iu.getRootSpan(span);
    return span;
}
function $feac33c41f7a1a39$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $feac33c41f7a1a39$var$withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
function $feac33c41f7a1a39$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !$wmosz.hasSpanStreamingEnabled(client) || !ignoreSpans?.length) return false;
    return $2aD4H.shouldIgnoreSpan({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $feac33c41f7a1a39$var$_isIgnoredSpan(span) {
    return $2BhuU.spanIsNonRecordingSpan(span) && span.dropReason === "ignored";
}
module.exports.SUPPRESS_TRACING_KEY = $feac33c41f7a1a39$var$SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $feac33c41f7a1a39$var$continueTrace;
module.exports.isTracingSuppressed = $feac33c41f7a1a39$var$isTracingSuppressed;
module.exports.startInactiveSpan = $feac33c41f7a1a39$var$startInactiveSpan;
module.exports.startNewTrace = $feac33c41f7a1a39$var$startNewTrace;
module.exports.startSpan = $feac33c41f7a1a39$var$startSpan;
module.exports.startSpanManual = $feac33c41f7a1a39$var$startSpanManual;
module.exports.suppressTracing = $feac33c41f7a1a39$var$suppressTracing;
module.exports.withActiveSpan = $feac33c41f7a1a39$var$withActiveSpan;

});
parcelRegister("1TQ1B", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $l17Xm = parcelRequire("l17Xm");

var $c34Je = parcelRequire("c34Je");
function $16234888382e9fa1$var$handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $16234888382e9fa1$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $16234888382e9fa1$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ($c34Je.isThenable(value)) return $l17Xm.chainAndCopyPromiseLike(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}
module.exports.handleCallbackErrors = $16234888382e9fa1$var$handleCallbackErrors;

});

parcelRegister("7aZG6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $fe1rL = parcelRequire("fe1rL");

var $9cJmP = parcelRequire("9cJmP");
function $53994f87f9a25410$var$sampleSpan(options, samplingContext, sampleRand) {
    if (!$fe1rL.hasSpansEnabled(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = $9cJmP.parseSampleRate(sampleRate);
    if (parsedSampleRate === void 0) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        $7piqH.DEBUG_BUILD && $99stL.debug.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) $7piqH.DEBUG_BUILD && $99stL.debug.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}
module.exports.sampleSpan = $53994f87f9a25410$var$sampleSpan;

});



parcelRegister("3Yf0L", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");
const $2e429e9f78dbc700$var$ADD_LISTENER_METHODS = [
    "addListener",
    "on",
    "once",
    "prependListener",
    "prependOnceListener",
    "addEventListener"
];
const $2e429e9f78dbc700$var$REMOVE_LISTENER_METHODS = [
    "removeListener",
    "off",
    "removeEventListener"
];
const $2e429e9f78dbc700$var$SCOPE_BOUND_LISTENERS = /* @__PURE__ */ Symbol("SentryScopeBoundListeners");
let $2e429e9f78dbc700$var$registeringWrapper;
function $2e429e9f78dbc700$var$isReentrantWrapperRegistration(listener) {
    return $2e429e9f78dbc700$var$registeringWrapper !== void 0 && (listener === $2e429e9f78dbc700$var$registeringWrapper || listener.listener === $2e429e9f78dbc700$var$registeringWrapper);
}
function $2e429e9f78dbc700$var$bindScopeToEmitter(emitter, scope = $gCYmH.getCurrentScope()) {
    const ee = emitter;
    if ($2e429e9f78dbc700$var$getPatchMap(ee)) return emitter;
    $2e429e9f78dbc700$var$createPatchMap(ee);
    for (const methodName of $2e429e9f78dbc700$var$ADD_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $2e429e9f78dbc700$var$patchAddListener(ee, ee[methodName], scope);
    }
    for (const methodName of $2e429e9f78dbc700$var$REMOVE_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $2e429e9f78dbc700$var$patchRemoveListener(ee, ee[methodName]);
    }
    if (typeof ee.removeAllListeners === "function") ee.removeAllListeners = $2e429e9f78dbc700$var$patchRemoveAllListeners(ee, ee.removeAllListeners);
    return emitter;
}
function $2e429e9f78dbc700$var$bindListenerToScope(listener, scope) {
    return function(...args) {
        return $gCYmH.withScope(scope, ()=>listener.apply(this, args));
    };
}
function $2e429e9f78dbc700$var$isBoundListener(listener) {
    return typeof listener === "function";
}
function $2e429e9f78dbc700$var$patchAddListener(ee, original, scope) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        if (!$2e429e9f78dbc700$var$isBoundListener(listener) || $2e429e9f78dbc700$var$isReentrantWrapperRegistration(listener)) return original.apply(this, args);
        const map = $2e429e9f78dbc700$var$getPatchMap(ee) || $2e429e9f78dbc700$var$createPatchMap(ee);
        let listeners = map.get(event);
        if (!listeners) {
            listeners = /* @__PURE__ */ new WeakMap();
            map.set(event, listeners);
        }
        let boundListener = listeners.get(listener);
        if (!boundListener) {
            boundListener = $2e429e9f78dbc700$var$bindListenerToScope(listener, scope);
            listeners.set(listener, boundListener);
        }
        const previous = $2e429e9f78dbc700$var$registeringWrapper;
        $2e429e9f78dbc700$var$registeringWrapper = boundListener;
        try {
            return original.call(this, event, boundListener, ...rest);
        } finally{
            $2e429e9f78dbc700$var$registeringWrapper = previous;
        }
    };
}
function $2e429e9f78dbc700$var$patchRemoveListener(ee, original) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        const boundListener = $2e429e9f78dbc700$var$isBoundListener(listener) ? $2e429e9f78dbc700$var$getPatchMap(ee)?.get(event)?.get(listener) : void 0;
        if (!boundListener) return original.apply(this, args);
        return original.call(this, event, boundListener, ...rest);
    };
}
function $2e429e9f78dbc700$var$patchRemoveAllListeners(ee, original) {
    return function(...args) {
        const map = $2e429e9f78dbc700$var$getPatchMap(ee);
        if (map) {
            if (args.length === 0) $2e429e9f78dbc700$var$createPatchMap(ee);
            else {
                const event = args[0];
                map.delete(event);
            }
        }
        return original.apply(this, args);
    };
}
function $2e429e9f78dbc700$var$createPatchMap(ee) {
    const map = /* @__PURE__ */ new Map();
    ee[$2e429e9f78dbc700$var$SCOPE_BOUND_LISTENERS] = map;
    return map;
}
function $2e429e9f78dbc700$var$getPatchMap(ee) {
    return ee[$2e429e9f78dbc700$var$SCOPE_BOUND_LISTENERS];
}
module.exports.bindScopeToEmitter = $2e429e9f78dbc700$var$bindScopeToEmitter;

});

parcelRegister("N7Tmw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k6VdG = parcelRequire("k6VdG");

var $fZWeW = parcelRequire("fZWeW");

var $cp5Iu = parcelRequire("cp5Iu");

var $f05NK = parcelRequire("f05NK");

var $5aMPP = parcelRequire("5aMPP");

var $fjylI = parcelRequire("fjylI");

var $28n4F = parcelRequire("28n4F");
function $093ab2e4839349ad$var$captureSpan(span, client) {
    const spanJSON = $cp5Iu.spanToStreamedSpanJSON(span);
    const segmentSpan = $cp5Iu.INTERNAL_getSegmentSpan(span);
    const serializedSegmentSpan = $cp5Iu.spanToStreamedSpanJSON(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = $f05NK.getCapturedScopesOnSpan(span);
    const finalScopeData = $fZWeW.getCombinedScopeData(spanIsolationScope, spanScope);
    $093ab2e4839349ad$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    client.emit("preprocessSpan", spanJSON, {
        spanKind: spanKind
    });
    if (spanJSON.is_segment) {
        $093ab2e4839349ad$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $093ab2e4839349ad$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
    const processedSpan = beforeSendSpan$1 && $5aMPP.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? $093ab2e4839349ad$var$applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanNameSource) $093ab2e4839349ad$var$safeSetSpanJSONAttributes(processedSpan, {
        // Purposefully not using a constant defined here like in other attributes:
        // This will be the name for SEMANTIC_ATTRIBUTE_SENTRY_SOURCE in v11
        "sentry.span.source": spanNameSource
    });
    return {
        ...$cp5Iu.streamedSpanJsonToSerializedSpan(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $093ab2e4839349ad$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = $fjylI.scopeContextsToSpanAttributes(scopeData.contexts);
    $093ab2e4839349ad$var$safeSetSpanJSONAttributes(segmentSpanJSON, contextAttributes);
}
function $093ab2e4839349ad$var$safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $093ab2e4839349ad$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $093ab2e4839349ad$var$safeSetSpanJSONAttributes(segmentSpanJSON, {
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS]: integrationNames
    });
}
function $093ab2e4839349ad$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $093ab2e4839349ad$var$safeSetSpanJSONAttributes(spanJSON, {
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment || $28n4F.DEFAULT_ENVIRONMENT,
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME]: sdk?.sdk?.name,
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION]: sdk?.sdk?.version,
        [$k6VdG.SEMANTIC_ATTRIBUTE_USER_ID]: scopeData.user?.id,
        [$k6VdG.SEMANTIC_ATTRIBUTE_USER_EMAIL]: scopeData.user?.email,
        [$k6VdG.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: scopeData.user?.ip_address,
        [$k6VdG.SEMANTIC_ATTRIBUTE_USER_USERNAME]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $093ab2e4839349ad$var$applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        $cp5Iu.showSpanDropWarning();
        return span;
    }
    return modifedSpan;
}
module.exports.applyBeforeSendSpanCallback = $093ab2e4839349ad$var$applyBeforeSendSpanCallback;
module.exports.captureSpan = $093ab2e4839349ad$var$captureSpan;
module.exports.safeSetSpanJSONAttributes = $093ab2e4839349ad$var$safeSetSpanJSONAttributes;

});
parcelRegister("fZWeW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $evhDU = parcelRequire("evhDU");

var $b85dT = parcelRequire("b85dT");

var $cp5Iu = parcelRequire("cp5Iu");
function $ba59bac27a52a49b$var$applyScopeDataToEvent(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $ba59bac27a52a49b$var$applyDataToEvent(event, data);
    if (span) $ba59bac27a52a49b$var$applySpanToEvent(event, span);
    $ba59bac27a52a49b$var$applyFingerprintToEvent(event, fingerprint);
    $ba59bac27a52a49b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $ba59bac27a52a49b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $ba59bac27a52a49b$var$mergeScopeData(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $ba59bac27a52a49b$var$mergeAndOverwriteScopeData(data, "extra", extra);
    $ba59bac27a52a49b$var$mergeAndOverwriteScopeData(data, "tags", tags);
    $ba59bac27a52a49b$var$mergeAndOverwriteScopeData(data, "attributes", attributes);
    $ba59bac27a52a49b$var$mergeAndOverwriteScopeData(data, "user", user);
    $ba59bac27a52a49b$var$mergeAndOverwriteScopeData(data, "contexts", contexts);
    data.sdkProcessingMetadata = $b85dT.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $ba59bac27a52a49b$var$mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = $b85dT.merge(data[prop], mergeVal, 1);
}
function $ba59bac27a52a49b$var$getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = $gCYmH.getGlobalScope().getScopeData();
    isolationScope && $ba59bac27a52a49b$var$mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && $ba59bac27a52a49b$var$mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $ba59bac27a52a49b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $ba59bac27a52a49b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $ba59bac27a52a49b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $ba59bac27a52a49b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: $cp5Iu.spanToTraceContext(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: $evhDU.getDynamicSamplingContextFromSpan(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = $cp5Iu.getRootSpan(span);
    const transactionName = $cp5Iu.spanToJSON(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $ba59bac27a52a49b$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}
module.exports.applyScopeDataToEvent = $ba59bac27a52a49b$var$applyScopeDataToEvent;
module.exports.getCombinedScopeData = $ba59bac27a52a49b$var$getCombinedScopeData;
module.exports.mergeAndOverwriteScopeData = $ba59bac27a52a49b$var$mergeAndOverwriteScopeData;
module.exports.mergeScopeData = $ba59bac27a52a49b$var$mergeScopeData;

});

parcelRegister("fjylI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b263466eb7c03ed4$var$scopeContextsToSpanAttributes(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}
module.exports.scopeContextsToSpanAttributes = $b263466eb7c03ed4$var$scopeContextsToSpanAttributes;

});


parcelRegister("2cngX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $1APeO = parcelRequire("1APeO");

var $lRCeh = parcelRequire("lRCeh");

var $99stL = parcelRequire("99stL");

var $c34Je = parcelRequire("c34Je");

var $f3q6O = parcelRequire("f3q6O");

var $jFQNE = parcelRequire("jFQNE");

var $fZWeW = parcelRequire("fZWeW");

var $dVZms = parcelRequire("dVZms");

var $kjL8z = parcelRequire("kjL8z");
function $199ec12cb31978e9$var$captureException(exception, hint) {
    return $gCYmH.getCurrentScope().captureException(exception, $jFQNE.parseEventHintOrCaptureContext(hint));
}
function $199ec12cb31978e9$var$captureMessage(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return $gCYmH.getCurrentScope().captureMessage(message, level, hint);
}
function $199ec12cb31978e9$var$captureEvent(event, hint) {
    return $gCYmH.getCurrentScope().captureEvent(event, hint);
}
function $199ec12cb31978e9$var$setContext(name, context) {
    $gCYmH.getIsolationScope().setContext(name, context);
}
function $199ec12cb31978e9$var$setExtras(extras) {
    $gCYmH.getIsolationScope().setExtras(extras);
}
function $199ec12cb31978e9$var$setExtra(key, extra) {
    $gCYmH.getIsolationScope().setExtra(key, extra);
}
function $199ec12cb31978e9$var$setTags(tags) {
    $gCYmH.getIsolationScope().setTags(tags);
}
function $199ec12cb31978e9$var$setTag(key, value) {
    $gCYmH.getIsolationScope().setTag(key, value);
}
function $199ec12cb31978e9$var$setAttributes(attributes) {
    $gCYmH.getIsolationScope().setAttributes(attributes);
}
function $199ec12cb31978e9$var$setAttribute(key, value) {
    $gCYmH.getIsolationScope().setAttribute(key, value);
}
function $199ec12cb31978e9$var$setUser(user) {
    $gCYmH.getIsolationScope().setUser(user);
}
function $199ec12cb31978e9$var$setConversationId(conversationId) {
    $gCYmH.getIsolationScope().setConversationId(conversationId);
}
function $199ec12cb31978e9$var$lastEventId() {
    return $gCYmH.getIsolationScope().lastEventId();
}
function $199ec12cb31978e9$var$captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = $gCYmH.getCurrentScope();
    const client = $gCYmH.getClient();
    if (!client) $7piqH.DEBUG_BUILD && $99stL.debug.warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) $7piqH.DEBUG_BUILD && $99stL.debug.warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return $f3q6O.uuid4();
}
function $199ec12cb31978e9$var$withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $199ec12cb31978e9$var$captureCheckIn({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = $dVZms.timestampInSeconds();
        function finishCheckIn(status) {
            $199ec12cb31978e9$var$captureCheckIn({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: $dVZms.timestampInSeconds() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ($c34Je.isThenable(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return $gCYmH.withIsolationScope(()=>upsertMonitorConfig?.isolateTrace ? $lRCeh.startNewTrace(runCallback) : runCallback());
}
async function $199ec12cb31978e9$var$flush(timeout) {
    const client = $gCYmH.getClient();
    if (client) return client.flush(timeout);
    $7piqH.DEBUG_BUILD && $99stL.debug.warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $199ec12cb31978e9$var$close(timeout) {
    const client = $gCYmH.getClient();
    if (client) return client.close(timeout);
    $7piqH.DEBUG_BUILD && $99stL.debug.warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $199ec12cb31978e9$var$isInitialized() {
    return !!$gCYmH.getClient();
}
function $199ec12cb31978e9$var$isEnabled() {
    const client = $gCYmH.getClient();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $199ec12cb31978e9$var$addEventProcessor(callback) {
    $gCYmH.getIsolationScope().addEventProcessor(callback);
}
function $199ec12cb31978e9$var$startSession(context) {
    const isolationScope = $gCYmH.getIsolationScope();
    const { user: user } = $fZWeW.getCombinedScopeData(isolationScope, $gCYmH.getCurrentScope());
    const { userAgent: userAgent } = $kjL8z.GLOBAL_OBJ.navigator || {};
    const session$1 = $1APeO.makeSession({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") $1APeO.updateSession(currentSession, {
        status: "exited"
    });
    $199ec12cb31978e9$var$endSession();
    isolationScope.setSession(session$1);
    return session$1;
}
function $199ec12cb31978e9$var$endSession() {
    const isolationScope = $gCYmH.getIsolationScope();
    const currentScope = $gCYmH.getCurrentScope();
    const session$1 = currentScope.getSession() || isolationScope.getSession();
    if (session$1) $1APeO.closeSession(session$1);
    $199ec12cb31978e9$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $199ec12cb31978e9$var$_sendSessionUpdate() {
    const isolationScope = $gCYmH.getIsolationScope();
    const client = $gCYmH.getClient();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $199ec12cb31978e9$var$captureSession(end = false) {
    if (end) {
        $199ec12cb31978e9$var$endSession();
        return;
    }
    $199ec12cb31978e9$var$_sendSessionUpdate();
}
module.exports.addEventProcessor = $199ec12cb31978e9$var$addEventProcessor;
module.exports.captureCheckIn = $199ec12cb31978e9$var$captureCheckIn;
module.exports.captureEvent = $199ec12cb31978e9$var$captureEvent;
module.exports.captureException = $199ec12cb31978e9$var$captureException;
module.exports.captureMessage = $199ec12cb31978e9$var$captureMessage;
module.exports.captureSession = $199ec12cb31978e9$var$captureSession;
module.exports.close = $199ec12cb31978e9$var$close;
module.exports.endSession = $199ec12cb31978e9$var$endSession;
module.exports.flush = $199ec12cb31978e9$var$flush;
module.exports.isEnabled = $199ec12cb31978e9$var$isEnabled;
module.exports.isInitialized = $199ec12cb31978e9$var$isInitialized;
module.exports.lastEventId = $199ec12cb31978e9$var$lastEventId;
module.exports.setAttribute = $199ec12cb31978e9$var$setAttribute;
module.exports.setAttributes = $199ec12cb31978e9$var$setAttributes;
module.exports.setContext = $199ec12cb31978e9$var$setContext;
module.exports.setConversationId = $199ec12cb31978e9$var$setConversationId;
module.exports.setExtra = $199ec12cb31978e9$var$setExtra;
module.exports.setExtras = $199ec12cb31978e9$var$setExtras;
module.exports.setTag = $199ec12cb31978e9$var$setTag;
module.exports.setTags = $199ec12cb31978e9$var$setTags;
module.exports.setUser = $199ec12cb31978e9$var$setUser;
module.exports.startSession = $199ec12cb31978e9$var$startSession;
module.exports.withMonitor = $199ec12cb31978e9$var$withMonitor;

});
parcelRegister("jFQNE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $28n4F = parcelRequire("28n4F");

var $jbCp4 = parcelRequire("jbCp4");

var $gIF8m = parcelRequire("gIF8m");

var $7b6bE = parcelRequire("7b6bE");

var $f3q6O = parcelRequire("f3q6O");

var $3COzy = parcelRequire("3COzy");

var $fZWeW = parcelRequire("fZWeW");

var $fdTwu = parcelRequire("fdTwu");

var $ecsQy = parcelRequire("ecsQy");

var $dVZms = parcelRequire("dVZms");
function $e52acd958f2d19b5$var$prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || $f3q6O.uuid4(),
        timestamp: event.timestamp || $dVZms.dateTimestampInSeconds()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $e52acd958f2d19b5$var$applyClientOptions(prepared, options);
    $e52acd958f2d19b5$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $e52acd958f2d19b5$var$applyDebugIds(prepared, options.stackParser);
    const finalScope = $e52acd958f2d19b5$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) $f3q6O.addExceptionMechanism(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = $fZWeW.getCombinedScopeData(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    $fZWeW.applyScopeDataToEvent(prepared, data);
    const eventProcessors$1 = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? $ecsQy.resolvedSyncPromise(prepared) : $jbCp4.notifyEventProcessors(eventProcessors$1, prepared, hint);
    return result.then((evt)=>{
        if (evt) $e52acd958f2d19b5$var$applyDebugMeta(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $e52acd958f2d19b5$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $e52acd958f2d19b5$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || $28n4F.DEFAULT_ENVIRONMENT;
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = $fdTwu.truncate(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = $fdTwu.truncate(exception.value, maxValueLength);
    });
}
function $e52acd958f2d19b5$var$applyDebugIds(event, stackParser) {
    const filenameDebugIdMap = $7b6bE.getFilenameToDebugIdMap(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $e52acd958f2d19b5$var$applyDebugMeta(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $e52acd958f2d19b5$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $e52acd958f2d19b5$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: $3COzy.normalize(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: $3COzy.normalize(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: $3COzy.normalize(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: $3COzy.normalize(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = $3COzy.normalize(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: $3COzy.normalize(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = $3COzy.normalize(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $e52acd958f2d19b5$var$getFinalScope(scope$1, captureContext) {
    if (!captureContext) return scope$1;
    const finalScope = scope$1 ? scope$1.clone() : new $gIF8m.Scope();
    finalScope.update(captureContext);
    return finalScope;
}
function $e52acd958f2d19b5$var$parseEventHintOrCaptureContext(hint) {
    if (!hint) return void 0;
    if ($e52acd958f2d19b5$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($e52acd958f2d19b5$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $e52acd958f2d19b5$var$hintIsScopeOrFunction(hint) {
    return hint instanceof $gIF8m.Scope || typeof hint === "function";
}
const $e52acd958f2d19b5$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $e52acd958f2d19b5$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$e52acd958f2d19b5$var$captureContextKeys.includes(key));
}
module.exports.applyClientOptions = $e52acd958f2d19b5$var$applyClientOptions;
module.exports.applyDebugIds = $e52acd958f2d19b5$var$applyDebugIds;
module.exports.applyDebugMeta = $e52acd958f2d19b5$var$applyDebugMeta;
module.exports.parseEventHintOrCaptureContext = $e52acd958f2d19b5$var$parseEventHintOrCaptureContext;
module.exports.prepareEvent = $e52acd958f2d19b5$var$prepareEvent;

});
parcelRegister("jbCp4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $c34Je = parcelRequire("c34Je");

var $ecsQy = parcelRequire("ecsQy");
function $df7cd584e18a69c8$var$notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = $df7cd584e18a69c8$var$_notifyEventProcessors(event, hint, processors, index);
        return $c34Je.isThenable(result) ? result : $ecsQy.resolvedSyncPromise(result);
    } catch (error) {
        return $ecsQy.rejectedSyncPromise(error);
    }
}
function $df7cd584e18a69c8$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    $7piqH.DEBUG_BUILD && result === null && $99stL.debug.log(`Event processor "${processor.id || "?"}" dropped event`);
    if ($c34Je.isThenable(result)) return result.then((final)=>$df7cd584e18a69c8$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $df7cd584e18a69c8$var$_notifyEventProcessors(result, hint, processors, index + 1);
}
module.exports.notifyEventProcessors = $df7cd584e18a69c8$var$notifyEventProcessors;

});
parcelRegister("ecsQy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $c34Je = parcelRequire("c34Je");
const $a568900735bfb287$var$STATE_PENDING = 0;
const $a568900735bfb287$var$STATE_RESOLVED = 1;
const $a568900735bfb287$var$STATE_REJECTED = 2;
function $a568900735bfb287$var$resolvedSyncPromise(value) {
    return new $a568900735bfb287$var$SyncPromise((resolve)=>{
        resolve(value);
    });
}
function $a568900735bfb287$var$rejectedSyncPromise(reason) {
    return new $a568900735bfb287$var$SyncPromise((_, reject)=>{
        reject(reason);
    });
}
class $a568900735bfb287$var$SyncPromise {
    constructor(executor){
        this._state = $a568900735bfb287$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $a568900735bfb287$var$SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $a568900735bfb287$var$SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $a568900735bfb287$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $a568900735bfb287$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $a568900735bfb287$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $a568900735bfb287$var$STATE_PENDING) return;
            if ($c34Je.isThenable(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($a568900735bfb287$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($a568900735bfb287$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}
module.exports.SyncPromise = $a568900735bfb287$var$SyncPromise;
module.exports.rejectedSyncPromise = $a568900735bfb287$var$rejectedSyncPromise;
module.exports.resolvedSyncPromise = $a568900735bfb287$var$resolvedSyncPromise;

});


parcelRegister("7b6bE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $66leG = parcelRequire("66leG");

var $kjL8z = parcelRequire("kjL8z");
let $539e5c146e32fba1$var$parsedStackResults;
let $539e5c146e32fba1$var$lastSentryKeysCount;
let $539e5c146e32fba1$var$lastNativeKeysCount;
let $539e5c146e32fba1$var$cachedFilenameDebugIds;
function $539e5c146e32fba1$var$getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = $kjL8z.GLOBAL_OBJ._sentryDebugIds;
    const nativeDebugIdMap = $kjL8z.GLOBAL_OBJ._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($539e5c146e32fba1$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $539e5c146e32fba1$var$lastSentryKeysCount && nativeDebugIdKeys.length === $539e5c146e32fba1$var$lastNativeKeysCount) return $539e5c146e32fba1$var$cachedFilenameDebugIds;
    $539e5c146e32fba1$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $539e5c146e32fba1$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $539e5c146e32fba1$var$cachedFilenameDebugIds = {};
    if (!$539e5c146e32fba1$var$parsedStackResults) $539e5c146e32fba1$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $539e5c146e32fba1$var$parsedStackResults?.[key];
            if (result && $539e5c146e32fba1$var$cachedFilenameDebugIds && debugId) {
                $539e5c146e32fba1$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($539e5c146e32fba1$var$parsedStackResults) $539e5c146e32fba1$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $539e5c146e32fba1$var$cachedFilenameDebugIds && $539e5c146e32fba1$var$parsedStackResults) {
                        $539e5c146e32fba1$var$cachedFilenameDebugIds[filename] = debugId;
                        $539e5c146e32fba1$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $539e5c146e32fba1$var$cachedFilenameDebugIds;
}
function $539e5c146e32fba1$var$getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = $539e5c146e32fba1$var$getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = $66leG.normalizeStackTracePath(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}
module.exports.getDebugImagesForResources = $539e5c146e32fba1$var$getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $539e5c146e32fba1$var$getFilenameToDebugIdMap;

});



parcelRegister("I6lHc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aWGVj = parcelRequire("aWGVj");

var $6dWkJ = parcelRequire("6dWkJ");

var $5QSoE = parcelRequire("5QSoE");

var $2dzy9 = parcelRequire("2dzy9");
function $084908f0fc4d07b0$var$waitForTracingChannelBinding(callback, retries = 1) {
    const binding = $2dzy9.getAsyncContextStrategy($aWGVj.getMainCarrier()).getTracingChannelBinding?.();
    if (binding) {
        callback();
        return;
    }
    if (!retries) return;
    $5QSoE.safeUnref(setTimeout(()=>{
        $084908f0fc4d07b0$var$waitForTracingChannelBinding(callback, retries - 1);
    }, 1));
}
function $084908f0fc4d07b0$var$_INTERNAL_createTracingChannelBinding(asyncLocalStorage, getScopes) {
    return {
        asyncLocalStorage: asyncLocalStorage,
        getStoreWithActiveSpan: (span)=>{
            const { scope: scope, isolationScope: isolationScope } = getScopes();
            const activeScope = scope.clone();
            $6dWkJ._setSpanForScope(activeScope, span);
            return {
                scope: activeScope,
                isolationScope: isolationScope
            };
        }
    };
}
module.exports._INTERNAL_createTracingChannelBinding = $084908f0fc4d07b0$var$_INTERNAL_createTracingChannelBinding;
module.exports.waitForTracingChannelBinding = $084908f0fc4d07b0$var$waitForTracingChannelBinding;

});
parcelRegister("5QSoE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $01197be389394856$var$safeUnref(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}
module.exports.safeUnref = $01197be389394856$var$safeUnref;

});


parcelRegister("aPqYD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iIaFt = parcelRequire("iIaFt");
const $7e2397e501cc0a6f$var$SENTRY_API_VERSION = "7";
function $7e2397e501cc0a6f$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $7e2397e501cc0a6f$var$_getIngestEndpoint(dsn) {
    return `${$7e2397e501cc0a6f$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $7e2397e501cc0a6f$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $7e2397e501cc0a6f$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $7e2397e501cc0a6f$var$getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$7e2397e501cc0a6f$var$_getIngestEndpoint(dsn)}?${$7e2397e501cc0a6f$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $7e2397e501cc0a6f$var$getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn$1 = $iIaFt.makeDsn(dsnLike);
    if (!dsn$1) return "";
    const endpoint = `${$7e2397e501cc0a6f$var$getBaseApiEndpoint(dsn$1)}embed/error-page/`;
    let encodedOptions = `dsn=${$iIaFt.dsnToString(dsn$1)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
module.exports.SENTRY_API_VERSION = $7e2397e501cc0a6f$var$SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $7e2397e501cc0a6f$var$getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $7e2397e501cc0a6f$var$getReportDialogEndpoint;

});

parcelRegister("e2vD1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aPqYD = parcelRequire("aPqYD");

var $28n4F = parcelRequire("28n4F");

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $i8C0r = parcelRequire("i8C0r");

var $d8ZGm = parcelRequire("d8ZGm");

var $eS4SN = parcelRequire("eS4SN");

var $a4GKN = parcelRequire("a4GKN");

var $1APeO = parcelRequire("1APeO");

var $evhDU = parcelRequire("evhDU");

var $5aMPP = parcelRequire("5aMPP");

var $e6FYR = parcelRequire("e6FYR");

var $7aPAx = parcelRequire("7aPAx");

var $h7TA9 = parcelRequire("h7TA9");

var $99stL = parcelRequire("99stL");

var $iIaFt = parcelRequire("iIaFt");

var $l008j = parcelRequire("l008j");

var $bFwZV = parcelRequire("bFwZV");

var $c34Je = parcelRequire("c34Je");

var $b85dT = parcelRequire("b85dT");

var $f3q6O = parcelRequire("f3q6O");

var $9cJmP = parcelRequire("9cJmP");

var $jFQNE = parcelRequire("jFQNE");

var $7OqzK = parcelRequire("7OqzK");

var $9gcfE = parcelRequire("9gcfE");

var $2aD4H = parcelRequire("2aD4H");

var $cp5Iu = parcelRequire("cp5Iu");

var $ecsQy = parcelRequire("ecsQy");

var $5QSoE = parcelRequire("5QSoE");

var $d6H88 = parcelRequire("d6H88");

var $lqHyX = parcelRequire("lqHyX");
const $a389c958d9925849$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $a389c958d9925849$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $a389c958d9925849$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $a389c958d9925849$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $a389c958d9925849$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $a389c958d9925849$var$_makeInternalError(message) {
    return {
        message: message,
        [$a389c958d9925849$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $a389c958d9925849$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$a389c958d9925849$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $a389c958d9925849$var$_isInternalError(error) {
    return !!error && typeof error === "object" && $a389c958d9925849$var$INTERNAL_ERROR_SYMBOL in error;
}
function $a389c958d9925849$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === "object" && $a389c958d9925849$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $a389c958d9925849$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            const flushInterval = client.getOptions()._flushInterval ?? $a389c958d9925849$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = $5QSoE.safeUnref(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $a389c958d9925849$var$Client {
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = $7OqzK.makePromiseBuffer(options.transportOptions?.bufferSize ?? $7aPAx.DEFAULT_TRANSPORT_BUFFER_SIZE);
        this._dataCollection = $lqHyX.resolveDataCollectionOptions(options);
        if (options.dsn) this._dsn = $iIaFt.makeDsn(options.dsn);
        else $7piqH.DEBUG_BUILD && $99stL.debug.warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = $aPqYD.getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        if (this._options.enableLogs) $a389c958d9925849$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $a389c958d9925849$var$estimateLogSizeInBytes, $eS4SN._INTERNAL_flushLogsBuffer);
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        if (enableMetrics) $a389c958d9925849$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $a389c958d9925849$var$estimateMetricSizeInBytes, $a4GKN._INTERNAL_flushMetricsBuffer);
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = $f3q6O.uuid4();
        if ($f3q6O.checkOrSetAlreadyCaught(exception)) {
            $7piqH.DEBUG_BUILD && $99stL.debug.log($a389c958d9925849$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: $f3q6O.uuid4(),
            ...hint
        };
        const eventMessage = $c34Je.isParameterizedString(message) ? message : String(message);
        const isMessage = $c34Je.isPrimitive(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = $f3q6O.uuid4();
        if (hint?.originalException && $f3q6O.checkOrSetAlreadyCaught(hint.originalException)) {
            $7piqH.DEBUG_BUILD && $99stL.debug.log($a389c958d9925849$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $a389c958d9925849$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session$1) {
        this.sendSession(session$1);
        $1APeO.updateSession(session$1, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        $eS4SN._INTERNAL_flushLogsBuffer(this);
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration$1) {
        const isAlreadyInstalled = this._integrations[integration$1.name];
        if (!isAlreadyInstalled && integration$1.beforeSetup) integration$1.beforeSetup(this);
        $d8ZGm.setupIntegration(this, integration$1, this._integrations);
        if (!isAlreadyInstalled) $d8ZGm.afterSetupIntegrations(this, [
            integration$1
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = $e6FYR.extractGenAiSpansFromEvent(event, this);
        let env = $i8C0r.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = $l008j.addItemToEnvelope(env, $l008j.createAttachmentEnvelopeItem(attachment));
        if (genAiSpanItem) env = $l008j.addItemToEnvelope(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = $28n4F.DEFAULT_ENVIRONMENT } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                $7piqH.DEBUG_BUILD && $99stL.debug.warn($a389c958d9925849$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                $7piqH.DEBUG_BUILD && $99stL.debug.warn($a389c958d9925849$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = $i8C0r.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            $7piqH.DEBUG_BUILD && $99stL.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            $7piqH.DEBUG_BUILD && $99stL.debug.error("Error while sending envelope:", reason);
            return {};
        }
        $7piqH.DEBUG_BUILD && $99stL.debug.error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = $d8ZGm.setupIntegrations(this, integrations);
        $d8ZGm.afterSetupIntegrations(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session$1, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session$1.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            $1APeO.updateSession(session$1, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session$1.errors || Number(errored || crashed)
            });
            this.captureSession(session$1);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return $jFQNE.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...$gCYmH.getTraceContextFromScope(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext$1 = $evhDU.getDynamicSamplingContextFromScope(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext$1,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = $gCYmH.getCurrentScope(), isolationScope = $gCYmH.getIsolationScope()) {
        if ($7piqH.DEBUG_BUILD && $a389c958d9925849$var$isErrorEvent(event)) $99stL.debug.log(`Captured error event \`${$bFwZV.getPossibleEventMessages(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if ($7piqH.DEBUG_BUILD) {
                if ($a389c958d9925849$var$_isDoNotSendEventError(reason)) $99stL.debug.log(reason.message);
                else if ($a389c958d9925849$var$_isInternalError(reason)) $99stL.debug.warn(reason.message);
                else $99stL.debug.warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $a389c958d9925849$var$isTransactionEvent(event);
        const isError = $a389c958d9925849$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : $9cJmP.parseSampleRate(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && $9gcfE.safeMathRandom() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return $ecsQy.rejectedSyncPromise($a389c958d9925849$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $a389c958d9925849$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $a389c958d9925849$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $a389c958d9925849$var$processBeforeSend(this, options, prepared, hint);
            return $a389c958d9925849$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $a389c958d9925849$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($a389c958d9925849$var$_isDoNotSendEventError(reason) || $a389c958d9925849$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $a389c958d9925849$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === $7OqzK.SENTRY_BUFFER_FULL_ERROR) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        $7piqH.DEBUG_BUILD && $99stL.debug.log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            $7piqH.DEBUG_BUILD && $99stL.debug.log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            $7piqH.DEBUG_BUILD && $99stL.debug.log("No dsn provided, will not send outcomes");
            return;
        }
        $7piqH.DEBUG_BUILD && $99stL.debug.log("Sending outcomes:", outcomes);
        const envelope = $h7TA9.createClientReportEnvelope(outcomes, this._options.tunnel && $iIaFt.dsnToString(this._dsn));
        this.sendEnvelope(envelope);
    }
}
function $a389c958d9925849$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $a389c958d9925849$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ($c34Je.isThenable(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!$c34Je.isPlainObject(event) && event !== null) throw $a389c958d9925849$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $a389c958d9925849$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!$c34Je.isPlainObject(beforeSendResult) && beforeSendResult !== null) throw $a389c958d9925849$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $a389c958d9925849$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan$1 = !$5aMPP.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($a389c958d9925849$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($a389c958d9925849$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan$1 || ignoreSpans) {
            const rootSpanJson = $d6H88.convertTransactionEventToSpanJson(processedEvent);
            if (ignoreSpans?.length && $2aD4H.shouldIgnoreSpan({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan$1) {
                const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
                if (!processedRootSpanJson) $cp5Iu.showSpanDropWarning();
                else processedEvent = $b85dT.merge(event, $d6H88.convertSpanJsonToTransactionEvent(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if (ignoreSpans?.length && $2aD4H.shouldIgnoreSpan({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        $2aD4H.reparentChildSpans(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan$1) {
                        const processedSpan = beforeSendSpan$1(span);
                        if (!processedSpan) {
                            $cp5Iu.showSpanDropWarning();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $a389c958d9925849$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $a389c958d9925849$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $a389c958d9925849$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $a389c958d9925849$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $a389c958d9925849$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $a389c958d9925849$var$estimateAttributesSizeInBytes(log.attributes);
}
function $a389c958d9925849$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $a389c958d9925849$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ($c34Je.isPrimitive(value)) weight += $a389c958d9925849$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $a389c958d9925849$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}
module.exports.Client = $a389c958d9925849$var$Client;

});
parcelRegister("d8ZGm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");
const $991bde879458436a$var$installedIntegrations = [];
function $991bde879458436a$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $991bde879458436a$var$getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $991bde879458436a$var$filterDuplicates(integrations);
}
function $991bde879458436a$var$setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $991bde879458436a$var$setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $991bde879458436a$var$afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $991bde879458436a$var$setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        $7piqH.DEBUG_BUILD && $99stL.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$991bde879458436a$var$installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $991bde879458436a$var$installedIntegrations.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    $7piqH.DEBUG_BUILD && $99stL.debug.log(`Integration installed: ${integration.name}`);
}
function $991bde879458436a$var$addIntegration(integration) {
    const client = $gCYmH.getClient();
    if (!client) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $991bde879458436a$var$defineIntegration(fn) {
    return fn;
}
function $991bde879458436a$var$extendIntegration(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}
module.exports.addIntegration = $991bde879458436a$var$addIntegration;
module.exports.afterSetupIntegrations = $991bde879458436a$var$afterSetupIntegrations;
module.exports.defineIntegration = $991bde879458436a$var$defineIntegration;
module.exports.extendIntegration = $991bde879458436a$var$extendIntegration;
module.exports.getIntegrationsToSetup = $991bde879458436a$var$getIntegrationsToSetup;
module.exports.installedIntegrations = $991bde879458436a$var$installedIntegrations;
module.exports.setupIntegration = $991bde879458436a$var$setupIntegration;
module.exports.setupIntegrations = $991bde879458436a$var$setupIntegrations;

});

parcelRegister("eS4SN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Db3P = parcelRequire("9Db3P");

var $aWGVj = parcelRequire("aWGVj");

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $c34Je = parcelRequire("c34Je");

var $fZWeW = parcelRequire("fZWeW");

var $6dWkJ = parcelRequire("6dWkJ");

var $dVZms = parcelRequire("dVZms");

var $438Kj = parcelRequire("438Kj");

var $c7TfL = parcelRequire("c7TfL");

var $aiMRG = parcelRequire("aiMRG");

var $hbtCP = parcelRequire("hbtCP");
const $ad39e56f2f8c1177$var$MAX_LOG_BUFFER_SIZE = 100;
function $ad39e56f2f8c1177$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $ad39e56f2f8c1177$var$_INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = $ad39e56f2f8c1177$var$_getBufferMap();
    const logBuffer = $ad39e56f2f8c1177$var$_INTERNAL_getLogBuffer(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $ad39e56f2f8c1177$var$MAX_LOG_BUFFER_SIZE) {
        $ad39e56f2f8c1177$var$_INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $ad39e56f2f8c1177$var$_INTERNAL_captureLog(beforeLog, currentScope = $gCYmH.getCurrentScope(), captureSerializedLog = $ad39e56f2f8c1177$var$_INTERNAL_captureSerializedLog) {
    const client = currentScope?.getClient() ?? $gCYmH.getClient();
    if (!client) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = $c7TfL._getTraceInfoFromScope(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = $fZWeW.getCombinedScopeData($gCYmH.getIsolationScope(), currentScope);
    $ad39e56f2f8c1177$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $ad39e56f2f8c1177$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $ad39e56f2f8c1177$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $ad39e56f2f8c1177$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $ad39e56f2f8c1177$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $ad39e56f2f8c1177$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $ad39e56f2f8c1177$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $ad39e56f2f8c1177$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $ad39e56f2f8c1177$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ($c34Je.isParameterizedString(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = $6dWkJ._getSpanForScope(currentScope);
    $ad39e56f2f8c1177$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? $99stL.consoleSandbox(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = $dVZms.timestampInSeconds();
    const sequenceAttr = $438Kj.getSequenceAttribute(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $ad39e56f2f8c1177$var$_removeLoneSurrogates(String(message)),
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? $aiMRG.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
        attributes: $ad39e56f2f8c1177$var$sanitizeLogAttributes({
            ...$9Db3P.serializeAttributes(scopeAttributes),
            ...$9Db3P.serializeAttributes(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $ad39e56f2f8c1177$var$_INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $ad39e56f2f8c1177$var$_INTERNAL_getLogBuffer(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $hbtCP.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $ad39e56f2f8c1177$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope$1);
}
function $ad39e56f2f8c1177$var$_INTERNAL_getLogBuffer(client) {
    return $ad39e56f2f8c1177$var$_getBufferMap().get(client);
}
function $ad39e56f2f8c1177$var$_getBufferMap() {
    return $aWGVj.getGlobalSingleton("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $ad39e56f2f8c1177$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $ad39e56f2f8c1177$var$_removeLoneSurrogates(key);
        if (attr.type === "string") sanitized[sanitizedKey] = {
            ...attr,
            value: $ad39e56f2f8c1177$var$_removeLoneSurrogates(attr.value)
        };
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $ad39e56f2f8c1177$var$_removeLoneSurrogates(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}
module.exports._INTERNAL_captureLog = $ad39e56f2f8c1177$var$_INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $ad39e56f2f8c1177$var$_INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $ad39e56f2f8c1177$var$_INTERNAL_flushLogsBuffer;
module.exports._INTERNAL_getLogBuffer = $ad39e56f2f8c1177$var$_INTERNAL_getLogBuffer;
module.exports._removeLoneSurrogates = $ad39e56f2f8c1177$var$_removeLoneSurrogates;

});
parcelRegister("438Kj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $2f2e3a03cbfbc1f7$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $2f2e3a03cbfbc1f7$var$_sequenceNumber = 0;
let $2f2e3a03cbfbc1f7$var$_previousTimestampMs;
function $2f2e3a03cbfbc1f7$var$getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($2f2e3a03cbfbc1f7$var$_previousTimestampMs !== void 0 && nowMs !== $2f2e3a03cbfbc1f7$var$_previousTimestampMs) $2f2e3a03cbfbc1f7$var$_sequenceNumber = 0;
    const value = $2f2e3a03cbfbc1f7$var$_sequenceNumber;
    $2f2e3a03cbfbc1f7$var$_sequenceNumber++;
    $2f2e3a03cbfbc1f7$var$_previousTimestampMs = nowMs;
    return {
        key: $2f2e3a03cbfbc1f7$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}
module.exports.getSequenceAttribute = $2f2e3a03cbfbc1f7$var$getSequenceAttribute;

});

parcelRegister("c7TfL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $evhDU = parcelRequire("evhDU");

var $cp5Iu = parcelRequire("cp5Iu");
function $8d40ffa342ea807d$var$_getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return $gCYmH.withScope(scope, ()=>{
        const span = $cp5Iu.getActiveSpan();
        const traceContext = span ? $cp5Iu.spanToTraceContext(span) : $gCYmH.getTraceContextFromScope(scope);
        const dynamicSamplingContext$1 = span ? $evhDU.getDynamicSamplingContextFromSpan(span) : $evhDU.getDynamicSamplingContextFromScope(client, scope);
        return [
            dynamicSamplingContext$1,
            traceContext
        ];
    });
}
module.exports._getTraceInfoFromScope = $8d40ffa342ea807d$var$_getTraceInfoFromScope;

});

parcelRegister("aiMRG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $78017d5a3cd591e8$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};
module.exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = $78017d5a3cd591e8$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER;

});

parcelRegister("hbtCP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iIaFt = parcelRequire("iIaFt");

var $l008j = parcelRequire("l008j");

var $gwBtZ = parcelRequire("gwBtZ");
function $c82a71b579062996$var$createLogContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            version: 2,
            ...$gwBtZ.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $c82a71b579062996$var$createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $iIaFt.dsnToString(dsn$1);
    return $l008j.createEnvelope(headers, [
        $c82a71b579062996$var$createLogContainerEnvelopeItem(logs, inferUserData)
    ]);
}
module.exports.createLogContainerEnvelopeItem = $c82a71b579062996$var$createLogContainerEnvelopeItem;
module.exports.createLogEnvelope = $c82a71b579062996$var$createLogEnvelope;

});
parcelRegister("gwBtZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6aokB = parcelRequire("6aokB");

var $kjL8z = parcelRequire("kjL8z");
function $c07cb5c87ed73c50$var$isBrowser() {
    return typeof window !== "undefined" && (!$6aokB.isNodeEnv() || $c07cb5c87ed73c50$var$isElectronNodeRenderer());
}
function $c07cb5c87ed73c50$var$isElectronNodeRenderer() {
    const process = $kjL8z.GLOBAL_OBJ.process;
    return process?.type === "renderer";
}
module.exports.isBrowser = $c07cb5c87ed73c50$var$isBrowser;

});
parcelRegister("6aokB", function(module, exports) {
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bL5Rk = parcelRequire("bL5Rk");
function isNodeEnv() {
    return !$bL5Rk.isBrowserBundle() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}
exports.isNodeEnv = isNodeEnv;
exports.loadModule = loadModule;

});
parcelRegister("bL5Rk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $88f8a0f8f717cc1a$var$isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $88f8a0f8f717cc1a$var$getSDKSource() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}
module.exports.getSDKSource = $88f8a0f8f717cc1a$var$getSDKSource;
module.exports.isBrowserBundle = $88f8a0f8f717cc1a$var$isBrowserBundle;

});





parcelRegister("a4GKN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Db3P = parcelRequire("9Db3P");

var $aWGVj = parcelRequire("aWGVj");

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $fZWeW = parcelRequire("fZWeW");

var $6dWkJ = parcelRequire("6dWkJ");

var $dVZms = parcelRequire("dVZms");

var $438Kj = parcelRequire("438Kj");

var $c7TfL = parcelRequire("c7TfL");

var $0zSu3 = parcelRequire("0zSu3");
const $755b71175bea748f$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $755b71175bea748f$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $755b71175bea748f$var$_INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = $755b71175bea748f$var$_getBufferMap();
    const metricBuffer = $755b71175bea748f$var$_INTERNAL_getMetricBuffer(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $755b71175bea748f$var$MAX_METRIC_BUFFER_SIZE) {
        $755b71175bea748f$var$_INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $755b71175bea748f$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $755b71175bea748f$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $755b71175bea748f$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $755b71175bea748f$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $755b71175bea748f$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $755b71175bea748f$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $755b71175bea748f$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $755b71175bea748f$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $755b71175bea748f$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $755b71175bea748f$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $755b71175bea748f$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = $c7TfL._getTraceInfoFromScope(client, currentScope);
    const span = $6dWkJ._getSpanForScope(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = $dVZms.timestampInSeconds();
    const sequenceAttr = $438Kj.getSequenceAttribute(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...$9Db3P.serializeAttributes(scopeAttributes),
            ...$9Db3P.serializeAttributes(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $755b71175bea748f$var$_INTERNAL_captureMetric(beforeMetric, options) {
    const currentScope = options?.scope ?? $gCYmH.getCurrentScope();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $755b71175bea748f$var$_INTERNAL_captureSerializedMetric;
    const client = currentScope?.getClient() ?? $gCYmH.getClient();
    if (!client) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = $fZWeW.getCombinedScopeData($gCYmH.getIsolationScope(), currentScope);
    const enrichedMetric = $755b71175bea748f$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        $7piqH.DEBUG_BUILD && $99stL.debug.log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $755b71175bea748f$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    $7piqH.DEBUG_BUILD && $99stL.debug.log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $755b71175bea748f$var$_INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $755b71175bea748f$var$_INTERNAL_getMetricBuffer(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $0zSu3.createMetricEnvelope(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $755b71175bea748f$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope$1);
}
function $755b71175bea748f$var$_INTERNAL_getMetricBuffer(client) {
    return $755b71175bea748f$var$_getBufferMap().get(client);
}
function $755b71175bea748f$var$_getBufferMap() {
    return $aWGVj.getGlobalSingleton("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
module.exports._INTERNAL_captureMetric = $755b71175bea748f$var$_INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $755b71175bea748f$var$_INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $755b71175bea748f$var$_INTERNAL_flushMetricsBuffer;
module.exports._INTERNAL_getMetricBuffer = $755b71175bea748f$var$_INTERNAL_getMetricBuffer;

});
parcelRegister("0zSu3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iIaFt = parcelRequire("iIaFt");

var $l008j = parcelRequire("l008j");

var $gwBtZ = parcelRequire("gwBtZ");
function $001bd4c78104bdaf$var$createMetricContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...$gwBtZ.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $001bd4c78104bdaf$var$createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $iIaFt.dsnToString(dsn$1);
    return $l008j.createEnvelope(headers, [
        $001bd4c78104bdaf$var$createMetricContainerEnvelopeItem(metrics, inferUserData)
    ]);
}
module.exports.createMetricContainerEnvelopeItem = $001bd4c78104bdaf$var$createMetricContainerEnvelopeItem;
module.exports.createMetricEnvelope = $001bd4c78104bdaf$var$createMetricEnvelope;

});


parcelRegister("e6FYR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gwBtZ = parcelRequire("gwBtZ");

var $wmosz = parcelRequire("wmosz");

var $2RIfc = parcelRequire("2RIfc");
function $a45230baa2036c98$var$extractGenAiSpansFromEvent(event, client) {
    if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || client.getOptions().streamGenAiSpans === false || $wmosz.hasSpanStreamingEnabled(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith("gen_ai.")) genAiSpans.push($2RIfc.spanJsonToSerializedStreamedSpan(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$gwBtZ.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}
module.exports.extractGenAiSpansFromEvent = $a45230baa2036c98$var$extractGenAiSpansFromEvent;

});
parcelRegister("2RIfc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cp5Iu = parcelRequire("cp5Iu");
function $2162d9fab221c95c$var$spanJsonToSerializedStreamedSpan(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return $cp5Iu.streamedSpanJsonToSerializedSpan(streamedSpan);
}
module.exports.spanJsonToSerializedStreamedSpan = $2162d9fab221c95c$var$spanJsonToSerializedStreamedSpan;

});


parcelRegister("7aPAx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $l008j = parcelRequire("l008j");

var $7OqzK = parcelRequire("7OqzK");

var $43wkw = parcelRequire("43wkw");
const $53917beaae8adab6$var$DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
function $53917beaae8adab6$var$createTransport(options, makeRequest, buffer = $7OqzK.makePromiseBuffer(options.bufferSize || $53917beaae8adab6$var$DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope$1) {
        const filteredEnvelopeItems = [];
        $l008j.forEachEnvelopeItem(envelope$1, (item, type)=>{
            const dataCategory = $l008j.envelopeItemTypeToDataCategory(type);
            if ($43wkw.isRateLimited(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = $l008j.createEnvelope(envelope$1[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ($l008j.envelopeContainsItemType(filteredEnvelope, [
                "client_report"
            ])) {
                $7piqH.DEBUG_BUILD && $99stL.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            $l008j.forEachEnvelopeItem(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, $l008j.envelopeItemTypeToDataCategory(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: $l008j.serializeEnvelope(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    $7piqH.DEBUG_BUILD && $99stL.debug.error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ($7piqH.DEBUG_BUILD && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) $99stL.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = $43wkw.updateRateLimits(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                $7piqH.DEBUG_BUILD && $99stL.debug.error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === $7OqzK.SENTRY_BUFFER_FULL_ERROR) {
                $7piqH.DEBUG_BUILD && $99stL.debug.error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
module.exports.DEFAULT_TRANSPORT_BUFFER_SIZE = $53917beaae8adab6$var$DEFAULT_TRANSPORT_BUFFER_SIZE;
module.exports.createTransport = $53917beaae8adab6$var$createTransport;

});
parcelRegister("7OqzK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ecsQy = parcelRequire("ecsQy");

var $5QSoE = parcelRequire("5QSoE");
const $5b01d14bf25ff4e5$var$SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $5b01d14bf25ff4e5$var$makePromiseBuffer(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return $ecsQy.rejectedSyncPromise($5b01d14bf25ff4e5$var$SENTRY_BUFFER_FULL_ERROR);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return $ecsQy.resolvedSyncPromise(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>$5QSoE.safeUnref(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}
module.exports.SENTRY_BUFFER_FULL_ERROR = $5b01d14bf25ff4e5$var$SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $5b01d14bf25ff4e5$var$makePromiseBuffer;

});

parcelRegister("43wkw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9gcfE = parcelRequire("9gcfE");
const $2f408552dbccbd95$var$DEFAULT_RETRY_AFTER = 60000;
function $2f408552dbccbd95$var$parseRetryAfterHeader(header, now = $9gcfE.safeDateNow()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $2f408552dbccbd95$var$DEFAULT_RETRY_AFTER;
}
function $2f408552dbccbd95$var$disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $2f408552dbccbd95$var$isRateLimited(limits, dataCategory, now = $9gcfE.safeDateNow()) {
    return $2f408552dbccbd95$var$disabledUntil(limits, dataCategory) > now;
}
function $2f408552dbccbd95$var$updateRateLimits(limits, { statusCode: statusCode, headers: headers }, now = $9gcfE.safeDateNow()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $2f408552dbccbd95$var$parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
module.exports.DEFAULT_RETRY_AFTER = $2f408552dbccbd95$var$DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $2f408552dbccbd95$var$disabledUntil;
module.exports.isRateLimited = $2f408552dbccbd95$var$isRateLimited;
module.exports.parseRetryAfterHeader = $2f408552dbccbd95$var$parseRetryAfterHeader;
module.exports.updateRateLimits = $2f408552dbccbd95$var$updateRateLimits;

});


parcelRegister("h7TA9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $l008j = parcelRequire("l008j");

var $dVZms = parcelRequire("dVZms");
function $c77e348c09b6ec2f$var$createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || $dVZms.dateTimestampInSeconds(),
            discarded_events: discarded_events
        }
    ];
    return $l008j.createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports.createClientReportEnvelope = $c77e348c09b6ec2f$var$createClientReportEnvelope;

});

parcelRegister("bFwZV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $87ed1eb5d14d1483$var$getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {}
    return possibleMessages;
}
module.exports.getPossibleEventMessages = $87ed1eb5d14d1483$var$getPossibleEventMessages;

});

parcelRegister("d6H88", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k6VdG = parcelRequire("k6VdG");
function $98ad4aada0c89f84$var$convertTransactionEventToSpanJson(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[$k6VdG.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[$k6VdG.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
function $98ad4aada0c89f84$var$convertSpanJsonToTransactionEvent(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [$k6VdG.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [$k6VdG.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}
module.exports.convertSpanJsonToTransactionEvent = $98ad4aada0c89f84$var$convertSpanJsonToTransactionEvent;
module.exports.convertTransactionEventToSpanJson = $98ad4aada0c89f84$var$convertTransactionEventToSpanJson;

});

parcelRegister("lqHyX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $51hJX = parcelRequire("51hJX");
const $f99dd15866893733$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    queryParams: true,
    genAI: {
        inputs: true,
        outputs: true
    },
    stackFrameVariables: true,
    frameContextLines: 5
};
function $f99dd15866893733$var$resolveDataCollectionOptions(options) {
    const base = options.dataCollection != null ? $f99dd15866893733$var$DEFAULTS : $51hJX.defaultPiiToCollectionOptions(options.sendDefaultPii);
    const dc = options.dataCollection ?? {};
    return {
        userInfo: dc.userInfo ?? base.userInfo,
        cookies: dc.cookies ?? base.cookies,
        httpHeaders: {
            request: dc.httpHeaders?.request ?? base.httpHeaders.request,
            response: dc.httpHeaders?.response ?? base.httpHeaders.response
        },
        httpBodies: dc.httpBodies ?? base.httpBodies,
        queryParams: dc.queryParams ?? base.queryParams,
        genAI: {
            inputs: dc.genAI?.inputs ?? base.genAI.inputs,
            outputs: dc.genAI?.outputs ?? base.genAI.outputs
        },
        stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
        frameContextLines: dc.frameContextLines ?? base.frameContextLines
    };
}
module.exports.resolveDataCollectionOptions = $f99dd15866893733$var$resolveDataCollectionOptions;

});
parcelRegister("51hJX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gICTy = parcelRequire("gICTy");
function $3a7ace9c02c4791f$var$defaultPiiToCollectionOptions(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        queryParams: true,
        genAI: {
            inputs: true,
            outputs: true
        },
        stackFrameVariables: true,
        frameContextLines: 7
    } : {
        userInfo: false,
        cookies: {
            deny: $gICTy.PII_HEADER_SNIPPETS
        },
        httpHeaders: {
            request: {
                deny: $gICTy.PII_HEADER_SNIPPETS
            },
            response: {
                deny: $gICTy.PII_HEADER_SNIPPETS
            }
        },
        httpBodies: [],
        queryParams: {
            deny: $gICTy.PII_HEADER_SNIPPETS
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        stackFrameVariables: true,
        frameContextLines: 7
    };
}
module.exports.defaultPiiToCollectionOptions = $3a7ace9c02c4791f$var$defaultPiiToCollectionOptions;

});
parcelRegister("gICTy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $c2beed240d1811a8$var$FILTERED_VALUE = "[Filtered]";
const $c2beed240d1811a8$var$PII_HEADER_SNIPPETS = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $c2beed240d1811a8$var$SENSITIVE_KEY_SNIPPETS = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $c2beed240d1811a8$var$SENSITIVE_COOKIE_NAME_SNIPPETS = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];
module.exports.FILTERED_VALUE = $c2beed240d1811a8$var$FILTERED_VALUE;
module.exports.PII_HEADER_SNIPPETS = $c2beed240d1811a8$var$PII_HEADER_SNIPPETS;
module.exports.SENSITIVE_COOKIE_NAME_SNIPPETS = $c2beed240d1811a8$var$SENSITIVE_COOKIE_NAME_SNIPPETS;
module.exports.SENSITIVE_KEY_SNIPPETS = $c2beed240d1811a8$var$SENSITIVE_KEY_SNIPPETS;

});




parcelRegister("b0iHJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");
function $802e341467a02f1e$var$initAndBind(clientClass, options) {
    if (options.debug === true) {
        if ($7piqH.DEBUG_BUILD) $99stL.debug.enable();
        else $99stL.consoleSandbox(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = $gCYmH.getCurrentScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $802e341467a02f1e$var$setCurrentClient(client);
    client.init();
    return client;
}
function $802e341467a02f1e$var$setCurrentClient(client) {
    $gCYmH.getCurrentScope().setClient(client);
}
module.exports.initAndBind = $802e341467a02f1e$var$initAndBind;
module.exports.setCurrentClient = $802e341467a02f1e$var$setCurrentClient;

});

parcelRegister("5ukQO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $l008j = parcelRequire("l008j");

var $9gcfE = parcelRequire("9gcfE");

var $43wkw = parcelRequire("43wkw");

var $5QSoE = parcelRequire("5QSoE");
const $3fefeda1895f0322$var$MIN_DELAY = 100;
const $3fefeda1895f0322$var$START_DELAY = 5e3;
const $3fefeda1895f0322$var$MAX_DELAY = 36e5;
function $3fefeda1895f0322$var$makeOfflineTransport(createTransport) {
    function log(...args) {
        $7piqH.DEBUG_BUILD && $99stL.debug.log("[Offline]:", ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error("No `createStore` function was provided");
        const store = options.createStore(options);
        let retryDelay = $3fefeda1895f0322$var$START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay2) {
            if ($l008j.envelopeContainsItemType(env, [
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay2);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = $5QSoE.safeUnref(setTimeout(async ()=>{
                flushTimer = void 0;
                const found = await store.shift();
                if (found) {
                    log("Attempting to send previously queued event");
                    found[0].sent_at = new Date($9gcfE.safeDateNow()).toISOString();
                    send(found, true).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $3fefeda1895f0322$var$MAX_DELAY);
        }
        async function send(envelope$1, isRetry = false) {
            if (!isRetry && $l008j.envelopeContainsItemType(envelope$1, [
                "replay_event",
                "replay_recording"
            ])) {
                await store.push(envelope$1);
                flushIn($3fefeda1895f0322$var$MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope$1) === false) throw new Error("Envelope not sent because `shouldSend` callback returned false");
                const result = await transport.send(envelope$1);
                let delay = $3fefeda1895f0322$var$MIN_DELAY;
                if (result) {
                    if (result.headers?.["retry-after"]) delay = $43wkw.parseRetryAfterHeader(result.headers["retry-after"]);
                    else if (result.headers?.["x-sentry-rate-limits"]) delay = 6e4;
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $3fefeda1895f0322$var$START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope$1, e, retryDelay)) {
                    if (isRetry) await store.unshift(envelope$1);
                    else await store.push(envelope$1);
                    flushWithBackOff();
                    log("Error sending. Event queued.", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                if (timeout === void 0) {
                    retryDelay = $3fefeda1895f0322$var$START_DELAY;
                    flushIn($3fefeda1895f0322$var$MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}
module.exports.MIN_DELAY = $3fefeda1895f0322$var$MIN_DELAY;
module.exports.START_DELAY = $3fefeda1895f0322$var$START_DELAY;
module.exports.makeOfflineTransport = $3fefeda1895f0322$var$makeOfflineTransport;

});

parcelRegister("4nmYL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aPqYD = parcelRequire("aPqYD");

var $iIaFt = parcelRequire("iIaFt");

var $l008j = parcelRequire("l008j");
const $32fb228b85f7f5db$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY = "MULTIPLEXED_TRANSPORT_EXTRA_KEY";
function $32fb228b85f7f5db$var$eventFromEnvelope(env, types) {
    let event;
    $l008j.forEachEnvelopeItem(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : void 0;
        return !!event;
    });
    return event;
}
function $32fb228b85f7f5db$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $32fb228b85f7f5db$var$eventFromEnvelope(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
function $32fb228b85f7f5db$var$overrideDsn(envelope$1, dsn) {
    return $l008j.createEnvelope(dsn ? {
        ...envelope$1[0],
        dsn: dsn
    } : envelope$1[0], envelope$1[1]);
}
function $32fb228b85f7f5db$var$makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = /* @__PURE__ */ new Map();
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[$32fb228b85f7f5db$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[$32fb228b85f7f5db$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[$32fb228b85f7f5db$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn$1, release) {
            const key = release ? `${dsn$1}:${release}` : dsn$1;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = $iIaFt.dsnFromString(dsn$1);
                if (!validatedDsn) return void 0;
                const url = $aPqYD.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
                transport = release ? $32fb228b85f7f5db$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn$1,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    "event"
                ];
                return $32fb228b85f7f5db$var$eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, void 0);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            const transportsWithFallback = transports.length ? transports : [
                [
                    "",
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($32fb228b85f7f5db$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $32fb228b85f7f5db$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.eventFromEnvelope = $32fb228b85f7f5db$var$eventFromEnvelope;
module.exports.makeMultiplexedTransport = $32fb228b85f7f5db$var$makeMultiplexedTransport;

});

parcelRegister("hv9ui", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");
const $cbdcb0f7099f7e92$var$SKIPPED_AI_PROVIDERS = /* @__PURE__ */ new Set();
function $cbdcb0f7099f7e92$var$_INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach((module)=>{
        $cbdcb0f7099f7e92$var$SKIPPED_AI_PROVIDERS.add(module);
        $7piqH.DEBUG_BUILD && $99stL.debug.log(`AI provider "${module}" wrapping will be skipped`);
    });
}
function $cbdcb0f7099f7e92$var$_INTERNAL_shouldSkipAiProviderWrapping(module) {
    return $cbdcb0f7099f7e92$var$SKIPPED_AI_PROVIDERS.has(module);
}
function $cbdcb0f7099f7e92$var$_INTERNAL_clearAiProviderSkips() {
    $cbdcb0f7099f7e92$var$SKIPPED_AI_PROVIDERS.clear();
    $7piqH.DEBUG_BUILD && $99stL.debug.log("Cleared AI provider skip registrations");
}
module.exports._INTERNAL_clearAiProviderSkips = $cbdcb0f7099f7e92$var$_INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $cbdcb0f7099f7e92$var$_INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $cbdcb0f7099f7e92$var$_INTERNAL_skipAiProviderWrapping;

});

parcelRegister("WeqOl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gICTy = parcelRequire("gICTy");
function $0af09cad34f35d0c$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $0af09cad34f35d0c$var$filterKeyValueData(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const denySnippets = additionalDenyTerms != null ? [
        ...$gICTy.SENSITIVE_KEY_SNIPPETS,
        ...additionalDenyTerms
    ] : $gICTy.SENSITIVE_KEY_SNIPPETS;
    const result = {};
    if (behavior === true) {
        for (const key of Object.keys(data))result[key] = $0af09cad34f35d0c$var$isSensitiveKey(key.toLowerCase(), denySnippets) ? $gICTy.FILTERED_VALUE : data[key];
        return result;
    }
    if ("deny" in behavior) {
        const lowerTerms2 = behavior.deny.map((t)=>t.toLowerCase());
        for (const key of Object.keys(data)){
            const lower = key.toLowerCase();
            const isDenied = $0af09cad34f35d0c$var$isSensitiveKey(lower, denySnippets) || lowerTerms2.some((term)=>lower.includes(term));
            result[key] = isDenied ? $gICTy.FILTERED_VALUE : data[key];
        }
        return result;
    }
    const lowerTerms = behavior.allow.map((t)=>t.toLowerCase());
    for (const key of Object.keys(data)){
        const lower = key.toLowerCase();
        if ($0af09cad34f35d0c$var$isSensitiveKey(lower, denySnippets)) result[key] = $gICTy.FILTERED_VALUE;
        else {
            const isAllowed = lowerTerms.some((term)=>lower.includes(term));
            result[key] = isAllowed ? data[key] : $gICTy.FILTERED_VALUE;
        }
    }
    return result;
}
module.exports.filterKeyValueData = $0af09cad34f35d0c$var$filterKeyValueData;

});

parcelRegister("64qGE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lDesI = parcelRequire("lDesI");

var $gICTy = parcelRequire("gICTy");

var $WeqOl = parcelRequire("WeqOl");
function $46b7d148b11cb572$var$filterCookies(cookieString, behavior) {
    if (behavior === false) return {};
    try {
        const parsed = $lDesI.parseCookie(cookieString);
        if (Object.keys(parsed).length === 0) return {};
        return $WeqOl.filterKeyValueData(parsed, behavior, $gICTy.SENSITIVE_COOKIE_NAME_SNIPPETS);
    } catch  {
        return $gICTy.FILTERED_VALUE;
    }
}
module.exports.filterCookies = $46b7d148b11cb572$var$filterCookies;

});
parcelRegister("lDesI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $fbf8755d72f4dbd4$var$parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        if (void 0 === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            if (val.charCodeAt(0) === 34) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch  {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}
module.exports.parseCookie = $fbf8755d72f4dbd4$var$parseCookie;

});


parcelRegister("enbOh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gICTy = parcelRequire("gICTy");

var $WeqOl = parcelRequire("WeqOl");
function $a76c5fe74d0e7ec4$var$filterQueryParams(queryString, behavior) {
    if (behavior === false) return {};
    try {
        const params = new URLSearchParams(queryString);
        const parsed = {};
        params.forEach((value, key)=>{
            parsed[key] = value;
        });
        if (Object.keys(parsed).length === 0) return {};
        return $WeqOl.filterKeyValueData(parsed, behavior);
    } catch  {
        return $gICTy.FILTERED_VALUE;
    }
}
module.exports.filterQueryParams = $a76c5fe74d0e7ec4$var$filterQueryParams;

});

parcelRegister("imTzm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $d5f562fab1b411ea$var$FALSY_ENV_VALUES = /* @__PURE__ */ new Set([
    "false",
    "f",
    "n",
    "no",
    "off",
    "0"
]);
const $d5f562fab1b411ea$var$TRUTHY_ENV_VALUES = /* @__PURE__ */ new Set([
    "true",
    "t",
    "y",
    "yes",
    "on",
    "1"
]);
function $d5f562fab1b411ea$var$envToBool(value, options) {
    const normalized = String(value).toLowerCase();
    if ($d5f562fab1b411ea$var$FALSY_ENV_VALUES.has(normalized)) return false;
    if ($d5f562fab1b411ea$var$TRUTHY_ENV_VALUES.has(normalized)) return true;
    return options?.strict ? null : Boolean(value);
}
module.exports.FALSY_ENV_VALUES = $d5f562fab1b411ea$var$FALSY_ENV_VALUES;
module.exports.TRUTHY_ENV_VALUES = $d5f562fab1b411ea$var$TRUTHY_ENV_VALUES;
module.exports.envToBool = $d5f562fab1b411ea$var$envToBool;

});

parcelRegister("5OzGJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iIaFt = parcelRequire("iIaFt");

var $l008j = parcelRequire("l008j");

var $9gcfE = parcelRequire("9gcfE");
function $43bd4e34822ab3b0$var$createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
    const headers = {
        sent_at: new Date($9gcfE.safeDateNow()).toISOString()
    };
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $iIaFt.dsnToString(dsn$1);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    const item = $43bd4e34822ab3b0$var$createCheckInEnvelopeItem(checkIn);
    return $l008j.createEnvelope(headers, [
        item
    ]);
}
function $43bd4e34822ab3b0$var$createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: "check_in"
    };
    return [
        checkInHeaders,
        checkIn
    ];
}
module.exports.createCheckInEnvelope = $43bd4e34822ab3b0$var$createCheckInEnvelope;

});

parcelRegister("8Zztp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iHmco = parcelRequire("iHmco");
function $68bf897ddfecdf27$var$isSentryRequestUrl(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $68bf897ddfecdf27$var$checkDsn(url, dsn) || $68bf897ddfecdf27$var$checkTunnel(url, tunnel);
}
function $68bf897ddfecdf27$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $68bf897ddfecdf27$var$removeTrailingSlash(url) === $68bf897ddfecdf27$var$removeTrailingSlash(tunnel);
}
function $68bf897ddfecdf27$var$checkDsn(url$1, dsn) {
    const urlParts = $iHmco.parseStringToURLObject(url$1);
    if (!urlParts || $iHmco.isURLObjectRelative(urlParts)) return false;
    if (!dsn) return false;
    return $68bf897ddfecdf27$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $68bf897ddfecdf27$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $68bf897ddfecdf27$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
module.exports.isSentryRequestUrl = $68bf897ddfecdf27$var$isSentryRequestUrl;

});
parcelRegister("iHmco", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k6VdG = parcelRequire("k6VdG");
const $d9cd7667d0a581b3$var$DEFAULT_BASE_URL = "thismessage:/";
function $d9cd7667d0a581b3$var$isURLObjectRelative(url) {
    return "isRelative" in url;
}
function $d9cd7667d0a581b3$var$parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $d9cd7667d0a581b3$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $d9cd7667d0a581b3$var$getSanitizedUrlStringFromUrlObject(url) {
    if ($d9cd7667d0a581b3$var$isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $d9cd7667d0a581b3$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $d9cd7667d0a581b3$var$getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $d9cd7667d0a581b3$var$getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
    }
    if (request?.method) attributes[$k6VdG.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
        }
        if (!$d9cd7667d0a581b3$var$isURLObjectRelative(urlObject)) {
            attributes[$k6VdG.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $d9cd7667d0a581b3$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $d9cd7667d0a581b3$var$parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $d9cd7667d0a581b3$var$stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $d9cd7667d0a581b3$var$getSanitizedUrlString(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $d9cd7667d0a581b3$var$stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}
module.exports.getHttpSpanDetailsFromUrlObject = $d9cd7667d0a581b3$var$getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $d9cd7667d0a581b3$var$getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $d9cd7667d0a581b3$var$getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $d9cd7667d0a581b3$var$isURLObjectRelative;
module.exports.parseStringToURLObject = $d9cd7667d0a581b3$var$parseStringToURLObject;
module.exports.parseUrl = $d9cd7667d0a581b3$var$parseUrl;
module.exports.stripDataUrlContent = $d9cd7667d0a581b3$var$stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $d9cd7667d0a581b3$var$stripUrlQueryAndFragment;

});


parcelRegister("iTLX9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $dc228f8a804b590c$var$parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
const $dc228f8a804b590c$var$fmt = $dc228f8a804b590c$var$parameterize;
module.exports.fmt = $dc228f8a804b590c$var$fmt;
module.exports.parameterize = $dc228f8a804b590c$var$parameterize;

});

parcelRegister("jk159", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aPqYD = parcelRequire("aPqYD");

var $99stL = parcelRequire("99stL");

var $iIaFt = parcelRequire("iIaFt");

var $l008j = parcelRequire("l008j");
async function $e110b9777eae8c62$var$handleTunnelRequest(options) {
    const { request: request, allowedDsns: allowedDsns } = options;
    if (allowedDsns.length === 0) return new Response("Tunnel not configured", {
        status: 500
    });
    const body = new Uint8Array(await request.arrayBuffer());
    let envelopeHeader;
    try {
        [envelopeHeader] = $l008j.parseEnvelope(body);
    } catch  {
        return new Response("Invalid envelope", {
            status: 400
        });
    }
    if (!envelopeHeader) return new Response("Invalid envelope: missing header", {
        status: 400
    });
    const dsn$1 = envelopeHeader.dsn;
    if (!dsn$1) return new Response("Invalid envelope: missing DSN", {
        status: 400
    });
    const isAllowed = allowedDsns.some((allowed)=>allowed === dsn$1);
    if (!isAllowed) {
        $99stL.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
        return new Response("DSN not allowed", {
            status: 403
        });
    }
    const dsnComponents = $iIaFt.makeDsn(dsn$1);
    if (!dsnComponents) {
        $99stL.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
        return new Response("Invalid DSN", {
            status: 403
        });
    }
    const sentryIngestUrl = $aPqYD.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
    try {
        return await fetch(sentryIngestUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-sentry-envelope"
            },
            body: body
        });
    } catch (error) {
        $99stL.debug.error("Sentry tunnel: failed to forward envelope", error);
        return new Response("Failed to forward envelope to Sentry", {
            status: 500
        });
    }
}
module.exports.handleTunnelRequest = $e110b9777eae8c62$var$handleTunnelRequest;

});

parcelRegister("frwYY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b3e2f63ee586156d$var$addAutoIpAddressToUser(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === void 0) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
function $b3e2f63ee586156d$var$addAutoIpAddressToSession(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === void 0) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}
module.exports.addAutoIpAddressToSession = $b3e2f63ee586156d$var$addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $b3e2f63ee586156d$var$addAutoIpAddressToUser;

});

parcelRegister("kYm42", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $720Iz = parcelRequire("720Iz");
function $f44a86be948e9677$var$applySdkMetadata(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: $720Iz.SDK_VERSION
            }));
        sdk.version = $720Iz.SDK_VERSION;
    }
}
module.exports.applySdkMetadata = $f44a86be948e9677$var$applySdkMetadata;

});

parcelRegister("9jzbe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2dzy9 = parcelRequire("2dzy9");

var $aWGVj = parcelRequire("aWGVj");

var $gCYmH = parcelRequire("gCYmH");

var $2cngX = parcelRequire("2cngX");

var $99stL = parcelRequire("99stL");

var $cp5Iu = parcelRequire("cp5Iu");

var $fe1rL = parcelRequire("fe1rL");

var $2BhuU = parcelRequire("2BhuU");

var $evhDU = parcelRequire("evhDU");

var $gCbFP = parcelRequire("gCbFP");

var $h5NbM = parcelRequire("h5NbM");
function $6c812d74954355b1$var$getTraceData(options = {}) {
    const client = options.client || $gCYmH.getClient();
    if (!$2cngX.isEnabled() || !client) return {};
    const carrier$1 = $aWGVj.getMainCarrier();
    const acs = $2dzy9.getAsyncContextStrategy(carrier$1);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || $gCYmH.getCurrentScope();
    const span = options.span || $cp5Iu.getActiveSpan();
    const isTwpPlaceholder = $2BhuU.spanIsNonRecordingSpan(span) && !$fe1rL.hasSpansEnabled(client.getOptions());
    if (!span && $gCYmH.hasExternalPropagationContext()) return {};
    const sentryTrace = span && !isTwpPlaceholder ? $cp5Iu.spanToTraceHeader(span) : $6c812d74954355b1$var$scopeToTraceHeader(scope);
    const dsc = span ? $evhDU.getDynamicSamplingContextFromSpan(span) : $evhDU.getDynamicSamplingContextFromScope(client, scope);
    const baggage$1 = $gCbFP.dynamicSamplingContextToSentryBaggageHeader(dsc);
    const isValidSentryTraceHeader = $h5NbM.TRACEPARENT_REGEXP.test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        $99stL.debug.warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    const traceData = {
        "sentry-trace": sentryTrace,
        baggage: baggage$1
    };
    if (options.propagateTraceparent) traceData.traceparent = span && !isTwpPlaceholder ? $cp5Iu.spanToTraceparentHeader(span) : $6c812d74954355b1$var$scopeToTraceparentHeader(scope);
    return traceData;
}
function $6c812d74954355b1$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $h5NbM.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
}
function $6c812d74954355b1$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $h5NbM.generateTraceparentHeader(traceId, propagationSpanId, sampled);
}
module.exports.getTraceData = $6c812d74954355b1$var$getTraceData;

});

parcelRegister("1r6fB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $fdTwu = parcelRequire("fdTwu");
const $10bd2950cd1f3a02$var$NOT_PROPAGATED_MESSAGE = "[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:";
function $10bd2950cd1f3a02$var$shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
    if (typeof url !== "string" || !tracePropagationTargets) return true;
    const cachedDecision = decisionMap?.get(url);
    if (cachedDecision !== void 0) {
        $7piqH.DEBUG_BUILD && !cachedDecision && $99stL.debug.log($10bd2950cd1f3a02$var$NOT_PROPAGATED_MESSAGE, url);
        return cachedDecision;
    }
    const decision = $fdTwu.stringMatchesSomePattern(url, tracePropagationTargets);
    decisionMap?.set(url, decision);
    $7piqH.DEBUG_BUILD && !decision && $99stL.debug.log($10bd2950cd1f3a02$var$NOT_PROPAGATED_MESSAGE, url);
    return decision;
}
module.exports.shouldPropagateTraceForUrl = $10bd2950cd1f3a02$var$shouldPropagateTraceForUrl;

});

parcelRegister("jGglq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9jzbe = parcelRequire("9jzbe");
function $e53e9e473f8b6ed9$var$getTraceMetaTags(traceData$1) {
    return Object.entries(traceData$1 || $9jzbe.getTraceData()).map(([key, value])=>`<meta name="${key}" content="${value}"/>`).join("\n");
}
module.exports.getTraceMetaTags = $e53e9e473f8b6ed9$var$getTraceMetaTags;

});

parcelRegister("dktGB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $9b442bafdbdbc0da$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $9b442bafdbdbc0da$var$debounce;

});

parcelRegister("bVGYr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $51hJX = parcelRequire("51hJX");

var $gICTy = parcelRequire("gICTy");

var $WeqOl = parcelRequire("WeqOl");

var $5QSoE = parcelRequire("5QSoE");
const $8af65a4e96f0feec$var$MAX_BODY_BYTE_LENGTH = 1048576;
const $8af65a4e96f0feec$var$TEXT_CONTENT_TYPES = [
    "text/",
    "application/json",
    "application/x-www-form-urlencoded",
    "application/xml",
    "application/graphql"
];
function $8af65a4e96f0feec$var$getMaxBodyByteLength(maxRequestBodySize) {
    if (maxRequestBodySize === "small") return 1e3;
    if (maxRequestBodySize === "medium") return 1e4;
    return $8af65a4e96f0feec$var$MAX_BODY_BYTE_LENGTH;
}
function $8af65a4e96f0feec$var$winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") headers[key] = value;
        });
    } catch  {}
    return headers;
}
function $8af65a4e96f0feec$var$headersToDict(reqHeaders) {
    const headers = /* @__PURE__ */ Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(([key, value])=>{
            if (typeof value === "string") headers[key] = value;
            else if (typeof value === "number") headers[key] = String(value);
        });
    } catch  {}
    return headers;
}
function $8af65a4e96f0feec$var$winterCGRequestToRequestData(req) {
    const headers = $8af65a4e96f0feec$var$winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: $8af65a4e96f0feec$var$extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
function $8af65a4e96f0feec$var$isTextualContentType(contentType) {
    if (!contentType) return false;
    const lowerContentType = contentType.toLowerCase();
    return $8af65a4e96f0feec$var$TEXT_CONTENT_TYPES.some((type)=>lowerContentType.includes(type));
}
async function $8af65a4e96f0feec$var$captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
    try {
        const contentType = request.headers.get("content-type");
        if (!$8af65a4e96f0feec$var$isTextualContentType(contentType)) {
            $7piqH.DEBUG_BUILD && $99stL.debug.log("Skipping body capture for non-textual content type:", contentType);
            return;
        }
        if (!request.body) return;
        const contentLength = request.headers.get("content-length");
        const maxBodySize = $8af65a4e96f0feec$var$getMaxBodyByteLength(maxRequestBodySize);
        if (contentLength) {
            const length = parseInt(contentLength, 10);
            if (!isNaN(length) && length > $8af65a4e96f0feec$var$MAX_BODY_BYTE_LENGTH) {
                $7piqH.DEBUG_BUILD && $99stL.debug.log("Skipping body capture: body too large", length);
                return;
            }
        }
        const clonedRequest = request.clone();
        const bodyPromise = clonedRequest.text();
        const timeoutPromise = new Promise((resolve)=>{
            $5QSoE.safeUnref(setTimeout(()=>resolve(null), 2e3));
        });
        const body = await Promise.race([
            bodyPromise,
            timeoutPromise
        ]);
        if (body === null) {
            $7piqH.DEBUG_BUILD && $99stL.debug.log("Timeout reading request body");
            return;
        }
        if (!body) return;
        const encoder = new TextEncoder();
        const bytes = encoder.encode(body);
        const bodyByteLength = bytes.length;
        let truncatedBody;
        if (bodyByteLength > maxBodySize) {
            const decoder = new TextDecoder();
            truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
        } else truncatedBody = body;
        isolationScope.setSDKProcessingMetadata({
            normalizedRequest: {
                data: truncatedBody
            }
        });
        $7piqH.DEBUG_BUILD && $99stL.debug.log("Captured request body:", bodyByteLength, "bytes");
    } catch (error) {
        $7piqH.DEBUG_BUILD && $99stL.debug.error("Error capturing request body:", error);
    }
}
function $8af65a4e96f0feec$var$httpRequestToRequestData(request) {
    const headers = request.headers || {};
    const forwardedHost = typeof headers["x-forwarded-host"] === "string" ? headers["x-forwarded-host"] : void 0;
    const host = forwardedHost || (typeof headers.host === "string" ? headers.host : void 0);
    const forwardedProto = typeof headers["x-forwarded-proto"] === "string" ? headers["x-forwarded-proto"] : void 0;
    const protocol = forwardedProto || request.protocol || (request.socket?.encrypted ? "https" : "http");
    const url = request.url || "";
    const absoluteUrl = $8af65a4e96f0feec$var$getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    const data = request.body || void 0;
    const cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: $8af65a4e96f0feec$var$extractQueryParamsFromUrl(url),
        headers: $8af65a4e96f0feec$var$headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function $8af65a4e96f0feec$var$getAbsoluteUrl({ url: url, protocol: protocol, host: host }) {
    if (url?.startsWith("http")) return url;
    if (url && host) return `${protocol}://${host}${url}`;
    return void 0;
}
function $8af65a4e96f0feec$var$httpHeadersToSpanAttributes(headers, dataCollection = false, lifecycle = "request") {
    const resolvedDataCollection = typeof dataCollection === "boolean" ? $51hJX.defaultPiiToCollectionOptions(dataCollection) : dataCollection;
    const headerBehavior = lifecycle === "request" ? resolvedDataCollection.httpHeaders.request : resolvedDataCollection.httpHeaders.response;
    const cookieBehavior = resolvedDataCollection.cookies;
    const prefix = `http.${lifecycle}.header.`;
    const spanAttributes = {};
    try {
        const regularHeaders = {};
        for (const [key, value] of Object.entries(headers)){
            if (value == null) continue;
            const lowerKey = key.toLowerCase();
            const isCookieHeader = lowerKey === "cookie" || lowerKey === "set-cookie";
            if (isCookieHeader) {
                if (cookieBehavior === false) continue;
                if (typeof value === "string" && value !== "") {
                    const parsed = $8af65a4e96f0feec$var$parseCookieHeader(value, lowerKey === "set-cookie");
                    const filtered = $WeqOl.filterKeyValueData(parsed, cookieBehavior, $gICTy.SENSITIVE_COOKIE_NAME_SNIPPETS);
                    for (const [cookieKey, cookieValue] of Object.entries(filtered))spanAttributes[`${prefix}${$8af65a4e96f0feec$var$normalizeAttributeKey(lowerKey)}.${$8af65a4e96f0feec$var$normalizeAttributeKey(cookieKey)}`] = cookieValue;
                } else spanAttributes[`${prefix}${$8af65a4e96f0feec$var$normalizeAttributeKey(lowerKey)}`] = $gICTy.FILTERED_VALUE;
            } else {
                if (headerBehavior === false) continue;
                if (Array.isArray(value)) regularHeaders[lowerKey] = value.map((v)=>v != null ? String(v) : v).join(";");
                else if (typeof value === "string") regularHeaders[lowerKey] = value;
            }
        }
        if (headerBehavior !== false) {
            const filtered = $WeqOl.filterKeyValueData(regularHeaders, headerBehavior);
            for (const [headerKey, headerValue] of Object.entries(filtered))spanAttributes[`${prefix}${$8af65a4e96f0feec$var$normalizeAttributeKey(headerKey)}`] = headerValue;
        }
    } catch  {}
    return spanAttributes;
}
function $8af65a4e96f0feec$var$normalizeAttributeKey(key) {
    return key.replace(/-/g, "_");
}
function $8af65a4e96f0feec$var$parseCookieHeader(value, isSetCookie) {
    const semicolonIndex = value.indexOf(";");
    const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
    const cookies = isSetCookie ? [
        cookieString
    ] : cookieString.split("; ");
    const result = {};
    for (const cookie of cookies){
        const equalSignIndex = cookie.indexOf("=");
        const cookieKey = (equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie).toLowerCase();
        const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : "";
        result[cookieKey] = cookieValue;
    }
    return result;
}
function $8af65a4e96f0feec$var$extractQueryParamsFromUrl(url) {
    if (!url) return;
    try {
        const queryParams = new URL(url, "http://s.io").search.slice(1);
        return queryParams.length ? queryParams : void 0;
    } catch  {
        return void 0;
    }
}
module.exports.MAX_BODY_BYTE_LENGTH = $8af65a4e96f0feec$var$MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $8af65a4e96f0feec$var$captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $8af65a4e96f0feec$var$extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $8af65a4e96f0feec$var$getMaxBodyByteLength;
module.exports.headersToDict = $8af65a4e96f0feec$var$headersToDict;
module.exports.httpHeadersToSpanAttributes = $8af65a4e96f0feec$var$httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $8af65a4e96f0feec$var$httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $8af65a4e96f0feec$var$winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $8af65a4e96f0feec$var$winterCGRequestToRequestData;

});

parcelRegister("eY9yC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ae5e152fd7558fb4$var$SPAN_KIND = {
    INTERNAL: 0,
    SERVER: 1,
    CLIENT: 2,
    PRODUCER: 3,
    CONSUMER: 4
};
const $ae5e152fd7558fb4$var$SPAN_KIND_NAME = {
    [$ae5e152fd7558fb4$var$SPAN_KIND.INTERNAL]: "INTERNAL",
    [$ae5e152fd7558fb4$var$SPAN_KIND.SERVER]: "SERVER",
    [$ae5e152fd7558fb4$var$SPAN_KIND.CLIENT]: "CLIENT",
    [$ae5e152fd7558fb4$var$SPAN_KIND.PRODUCER]: "PRODUCER",
    [$ae5e152fd7558fb4$var$SPAN_KIND.CONSUMER]: "CONSUMER"
};
function $ae5e152fd7558fb4$var$spanKindToName(kind) {
    return $ae5e152fd7558fb4$var$SPAN_KIND_NAME[kind];
}
module.exports.SPAN_KIND = $ae5e152fd7558fb4$var$SPAN_KIND;
module.exports.spanKindToName = $ae5e152fd7558fb4$var$spanKindToName;

});

parcelRegister("d49ib", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $99stL = parcelRequire("99stL");

var $dVZms = parcelRequire("dVZms");
const $9832db512c5167c1$var$DEFAULT_BREADCRUMBS = 100;
function $9832db512c5167c1$var$addBreadcrumb(breadcrumb, hint) {
    const client = $gCYmH.getClient();
    const isolationScope = $gCYmH.getIsolationScope();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $9832db512c5167c1$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = $dVZms.dateTimestampInSeconds();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? $99stL.consoleSandbox(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
module.exports.addBreadcrumb = $9832db512c5167c1$var$addBreadcrumb;

});

parcelRegister("3Kc8d", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $d8ZGm = parcelRequire("d8ZGm");

var $1hzu4 = parcelRequire("1hzu4");
let $2b9f1407dd27f91b$var$originalFunctionToString;
const $2b9f1407dd27f91b$var$INTEGRATION_NAME = "FunctionToString";
const $2b9f1407dd27f91b$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $2b9f1407dd27f91b$var$_functionToStringIntegration = ()=>{
    return {
        name: $2b9f1407dd27f91b$var$INTEGRATION_NAME,
        setupOnce () {
            $2b9f1407dd27f91b$var$originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = $1hzu4.getOriginalFunction(this);
                    const context = $2b9f1407dd27f91b$var$SETUP_CLIENTS.has($gCYmH.getClient()) && originalFunction !== void 0 ? originalFunction : this;
                    return $2b9f1407dd27f91b$var$originalFunctionToString.apply(context, args);
                };
            } catch  {}
        },
        setup (client) {
            $2b9f1407dd27f91b$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $2b9f1407dd27f91b$var$functionToStringIntegration = $d8ZGm.defineIntegration($2b9f1407dd27f91b$var$_functionToStringIntegration);
module.exports.functionToStringIntegration = $2b9f1407dd27f91b$var$functionToStringIntegration;

});

parcelRegister("liFOz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $d8ZGm = parcelRequire("d8ZGm");

var $99stL = parcelRequire("99stL");

var $bFwZV = parcelRequire("bFwZV");

var $f3q6O = parcelRequire("f3q6O");

var $fdTwu = parcelRequire("fdTwu");
const $f81bb6f1bec1c66e$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /^Java exception was raised during method invocation$/
];
const $f81bb6f1bec1c66e$var$INTEGRATION_NAME = "EventFilters";
const $f81bb6f1bec1c66e$var$eventFiltersIntegration = $d8ZGm.defineIntegration((options = {})=>{
    let mergedOptions;
    return {
        name: $f81bb6f1bec1c66e$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $f81bb6f1bec1c66e$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $f81bb6f1bec1c66e$var$_mergeOptions(options, clientOptions);
            }
            return $f81bb6f1bec1c66e$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $f81bb6f1bec1c66e$var$inboundFiltersIntegration = $d8ZGm.defineIntegration((options = {})=>{
    return {
        ...$f81bb6f1bec1c66e$var$eventFiltersIntegration(options),
        name: "InboundFilters"
    };
});
function $f81bb6f1bec1c66e$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $f81bb6f1bec1c66e$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $f81bb6f1bec1c66e$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($f81bb6f1bec1c66e$var$_isIgnoredError(event, options.ignoreErrors)) {
            $7piqH.DEBUG_BUILD && $99stL.debug.warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${$f3q6O.getEventDescription(event)}`);
            return true;
        }
        if ($f81bb6f1bec1c66e$var$_isUselessError(event)) {
            $7piqH.DEBUG_BUILD && $99stL.debug.warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${$f3q6O.getEventDescription(event)}`);
            return true;
        }
        if ($f81bb6f1bec1c66e$var$_isDeniedUrl(event, options.denyUrls)) {
            $7piqH.DEBUG_BUILD && $99stL.debug.warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${$f3q6O.getEventDescription(event)}.
Url: ${$f81bb6f1bec1c66e$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$f81bb6f1bec1c66e$var$_isAllowedUrl(event, options.allowUrls)) {
            $7piqH.DEBUG_BUILD && $99stL.debug.warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${$f3q6O.getEventDescription(event)}.
Url: ${$f81bb6f1bec1c66e$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($f81bb6f1bec1c66e$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            $7piqH.DEBUG_BUILD && $99stL.debug.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${$f3q6O.getEventDescription(event)}`);
            return true;
        }
    }
    return false;
}
function $f81bb6f1bec1c66e$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return $bFwZV.getPossibleEventMessages(event).some((message)=>$fdTwu.stringMatchesSomePattern(message, ignoreErrors));
}
function $f81bb6f1bec1c66e$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? $fdTwu.stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function $f81bb6f1bec1c66e$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $f81bb6f1bec1c66e$var$_getEventFilterUrl(event);
    return !url ? false : $fdTwu.stringMatchesSomePattern(url, denyUrls);
}
function $f81bb6f1bec1c66e$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $f81bb6f1bec1c66e$var$_getEventFilterUrl(event);
    return !url ? true : $fdTwu.stringMatchesSomePattern(url, allowUrls);
}
function $f81bb6f1bec1c66e$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $f81bb6f1bec1c66e$var$_getEventFilterUrl(event) {
    try {
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $f81bb6f1bec1c66e$var$_getLastValidUrl(frames) : null;
    } catch  {
        $7piqH.DEBUG_BUILD && $99stL.debug.error(`Cannot extract url for event ${$f3q6O.getEventDescription(event)}`);
        return null;
    }
}
function $f81bb6f1bec1c66e$var$_isUselessError(event) {
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}
module.exports.eventFiltersIntegration = $f81bb6f1bec1c66e$var$eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $f81bb6f1bec1c66e$var$inboundFiltersIntegration;

});

parcelRegister("1WaGZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d8ZGm = parcelRequire("d8ZGm");

var $4F8JB = parcelRequire("4F8JB");

var $6O0Z2 = parcelRequire("6O0Z2");
const $16938088dcd83190$var$DEFAULT_KEY = "cause";
const $16938088dcd83190$var$DEFAULT_LIMIT = 5;
const $16938088dcd83190$var$INTEGRATION_NAME = "LinkedErrors";
const $16938088dcd83190$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $16938088dcd83190$var$DEFAULT_LIMIT;
    const key = options.key || $16938088dcd83190$var$DEFAULT_KEY;
    return {
        name: $16938088dcd83190$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            $4F8JB.applyAggregateErrorsToEvent($6O0Z2.exceptionFromError, options2.stackParser, key, limit, event, hint);
        }
    };
};
const $16938088dcd83190$var$linkedErrorsIntegration = $d8ZGm.defineIntegration($16938088dcd83190$var$_linkedErrorsIntegration);
module.exports.linkedErrorsIntegration = $16938088dcd83190$var$linkedErrorsIntegration;

});
parcelRegister("4F8JB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $c34Je = parcelRequire("c34Je");
function $3651c43f66757137$var$applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !$c34Je.isInstanceOf(hint.originalException, Error)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $3651c43f66757137$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $3651c43f66757137$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ($c34Je.isInstanceOf(error[key], Error)) {
        $3651c43f66757137$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $3651c43f66757137$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $3651c43f66757137$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($3651c43f66757137$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ($c34Je.isInstanceOf(childError, Error)) {
            $3651c43f66757137$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $3651c43f66757137$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $3651c43f66757137$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $3651c43f66757137$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $3651c43f66757137$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$3651c43f66757137$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $3651c43f66757137$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
module.exports.applyAggregateErrorsToEvent = $3651c43f66757137$var$applyAggregateErrorsToEvent;

});

parcelRegister("6O0Z2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $c34Je = parcelRequire("c34Je");

var $f3q6O = parcelRequire("f3q6O");

var $3COzy = parcelRequire("3COzy");

var $1hzu4 = parcelRequire("1hzu4");
function $4f482ce287c6b9cd$var$parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $4f482ce287c6b9cd$var$hasSentryFetchUrlHost(error) {
    return $c34Je.isError(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $4f482ce287c6b9cd$var$_enhanceErrorWithSentryInfo(error) {
    if ($4f482ce287c6b9cd$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $4f482ce287c6b9cd$var$exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $4f482ce287c6b9cd$var$_enhanceErrorWithSentryInfo(error)
    };
    const frames = $4f482ce287c6b9cd$var$parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $4f482ce287c6b9cd$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return void 0;
}
function $4f482ce287c6b9cd$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = $1hzu4.extractExceptionKeysForMessage(exception);
    if ($c34Je.isErrorEvent(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $4f482ce287c6b9cd$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $4f482ce287c6b9cd$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $4f482ce287c6b9cd$var$getException(client, mechanism, exception, hint) {
    if ($c34Je.isError(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ($c34Je.isPlainObject(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: $3COzy.normalizeToSize(exception, normalizeDepth)
        };
        const errorFromProp = $4f482ce287c6b9cd$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $4f482ce287c6b9cd$var$getMessageForObject(exception);
        const ex2 = hint?.syntheticException || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $4f482ce287c6b9cd$var$eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $4f482ce287c6b9cd$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $4f482ce287c6b9cd$var$exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    $f3q6O.addExceptionTypeValue(event, void 0, void 0);
    $f3q6O.addExceptionMechanism(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
function $4f482ce287c6b9cd$var$eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $4f482ce287c6b9cd$var$parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            $f3q6O.addExceptionMechanism(event, {
                synthetic: true
            });
        }
    }
    if ($c34Je.isParameterizedString(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
module.exports._enhanceErrorWithSentryInfo = $4f482ce287c6b9cd$var$_enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $4f482ce287c6b9cd$var$eventFromMessage;
module.exports.eventFromUnknownInput = $4f482ce287c6b9cd$var$eventFromUnknownInput;
module.exports.exceptionFromError = $4f482ce287c6b9cd$var$exceptionFromError;
module.exports.parseStackFrames = $4f482ce287c6b9cd$var$parseStackFrames;

});


parcelRegister("jOAeS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d8ZGm = parcelRequire("d8ZGm");

var $doSiu = parcelRequire("doSiu");

var $l008j = parcelRequire("l008j");
const $e6cecc21b9fae4c6$var$moduleMetadataIntegration = $d8ZGm.defineIntegration(()=>{
    return {
        name: "ModuleMetadata",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $l008j.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $doSiu.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $doSiu.addMetadataToStackFrames(stackParser, event);
            });
        }
    };
});
module.exports.moduleMetadataIntegration = $e6cecc21b9fae4c6$var$moduleMetadataIntegration;

});
parcelRegister("doSiu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kjL8z = parcelRequire("kjL8z");
const $9c17a29189ac8369$var$filenameMetadataMap = /* @__PURE__ */ new Map();
const $9c17a29189ac8369$var$parsedStacks = /* @__PURE__ */ new Set();
function $9c17a29189ac8369$var$getFilenameToMetadataMap(parser) {
    if (!$kjL8z.GLOBAL_OBJ._sentryModuleMetadata) return {};
    const filenameMap = {};
    for (const stack of Object.keys($kjL8z.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $kjL8z.GLOBAL_OBJ._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $9c17a29189ac8369$var$ensureMetadataStacksAreParsed(parser) {
    if (!$kjL8z.GLOBAL_OBJ._sentryModuleMetadata) return;
    for (const stack of Object.keys($kjL8z.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $kjL8z.GLOBAL_OBJ._sentryModuleMetadata[stack];
        if ($9c17a29189ac8369$var$parsedStacks.has(stack)) continue;
        $9c17a29189ac8369$var$parsedStacks.add(stack);
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            $9c17a29189ac8369$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
function $9c17a29189ac8369$var$getMetadataForUrl(parser, filename) {
    $9c17a29189ac8369$var$ensureMetadataStacksAreParsed(parser);
    return $9c17a29189ac8369$var$filenameMetadataMap.get(filename);
}
function $9c17a29189ac8369$var$addMetadataToStackFrames(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $9c17a29189ac8369$var$getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
function $9c17a29189ac8369$var$stripMetadataFromStackFrames(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}
module.exports.addMetadataToStackFrames = $9c17a29189ac8369$var$addMetadataToStackFrames;
module.exports.getFilenameToMetadataMap = $9c17a29189ac8369$var$getFilenameToMetadataMap;
module.exports.getMetadataForUrl = $9c17a29189ac8369$var$getMetadataForUrl;
module.exports.stripMetadataFromStackFrames = $9c17a29189ac8369$var$stripMetadataFromStackFrames;

});


parcelRegister("9LdTh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $d8ZGm = parcelRequire("d8ZGm");

var $k6VdG = parcelRequire("k6VdG");

var $lDesI = parcelRequire("lDesI");

var $bVGYr = parcelRequire("bVGYr");

var $9TBl7 = parcelRequire("9TBl7");

var $N7Tmw = parcelRequire("N7Tmw");
const $71b3473bd3dda9e7$var$INTEGRATION_NAME = "RequestData";
const $71b3473bd3dda9e7$var$_requestDataIntegration = (options = {})=>{
    function resolveIncludeAndDataCollection(client) {
        const dc = client.getDataCollectionOptions();
        const dataCollection = {
            ...dc,
            ...options.include?.cookies === true && dc.cookies === false && {
                cookies: true
            },
            ...options.include?.headers === true && dc.httpHeaders.request === false && {
                httpHeaders: {
                    ...dc.httpHeaders,
                    request: true
                }
            }
        };
        return {
            dataCollection: dataCollection,
            include: {
                cookies: dataCollection.cookies !== false,
                // Always attach body data that's already on the scope — dataCollection.httpBodies gates write-time, not read-time
                data: true,
                headers: dataCollection.httpHeaders.request !== false,
                ip: dataCollection.userInfo,
                query_string: dataCollection.queryParams !== false,
                // No dataCollection equivalent — URL is always included
                url: true,
                ...options.include
            }
        };
    }
    return {
        name: $71b3473bd3dda9e7$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = event;
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            const { include: include } = resolveIncludeAndDataCollection(client);
            if (normalizedRequest) $71b3473bd3dda9e7$var$addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, include);
            return event;
        },
        processSegmentSpan (span, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = $gCYmH.getIsolationScope().getScopeData();
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            if (!normalizedRequest) return;
            const { include: include, dataCollection: dataCollection } = resolveIncludeAndDataCollection(client);
            $71b3473bd3dda9e7$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection);
        }
    };
};
const $71b3473bd3dda9e7$var$requestDataIntegration = $d8ZGm.defineIntegration($71b3473bd3dda9e7$var$_requestDataIntegration);
function $71b3473bd3dda9e7$var$addNormalizedRequestDataToEvent(event, req, additionalData, include) {
    event.request = {
        ...event.request,
        ...$71b3473bd3dda9e7$var$extractNormalizedRequestData(req, include)
    };
    if (include.ip) {
        const ip = req.headers && $9TBl7.getClientIPAddress(req.headers) || additionalData.ipAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
}
function $71b3473bd3dda9e7$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection) {
    const requestData = $71b3473bd3dda9e7$var$extractNormalizedRequestData(normalizedRequest, include);
    const attributes = {};
    if (requestData.url) attributes["url.full"] = requestData.url;
    if (requestData.method) attributes["http.request.method"] = requestData.method;
    if (requestData.query_string) attributes["url.query"] = $71b3473bd3dda9e7$var$normalizeQueryString(requestData.query_string);
    $N7Tmw.safeSetSpanJSONAttributes(span, attributes);
    if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
        const cookieString = Object.entries(requestData.cookies).map(([name, value])=>`${name}=${value}`).join("; ");
        const cookieAttributes = $bVGYr.httpHeadersToSpanAttributes({
            cookie: cookieString
        }, dataCollection, "request");
        $N7Tmw.safeSetSpanJSONAttributes(span, cookieAttributes);
    }
    if (requestData.headers) {
        const headerAttributes = $bVGYr.httpHeadersToSpanAttributes(requestData.headers, dataCollection, "request");
        $N7Tmw.safeSetSpanJSONAttributes(span, headerAttributes);
    }
    if (requestData.data != null) {
        const serialized = typeof requestData.data === "string" ? requestData.data : JSON.stringify(requestData.data);
        if (serialized) $N7Tmw.safeSetSpanJSONAttributes(span, {
            "http.request.body.data": serialized
        });
    }
    if (include.ip) {
        const ip = normalizedRequest.headers && $9TBl7.getClientIPAddress(normalizedRequest.headers) || ipAddress || void 0;
        if (ip) $N7Tmw.safeSetSpanJSONAttributes(span, {
            [$k6VdG.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip
        });
    }
}
function $71b3473bd3dda9e7$var$extractNormalizedRequestData(normalizedRequest, include) {
    const requestData = {};
    const headers = {
        ...normalizedRequest.headers
    };
    if (include.headers) {
        requestData.headers = headers;
        if (!include.cookies) delete headers.cookie;
        if (!include.ip) {
            const ipHeaderNamesLower = new Set($9TBl7.ipHeaderNames.map((name)=>name.toLowerCase()));
            for (const key of Object.keys(headers))if (ipHeaderNamesLower.has(key.toLowerCase())) delete headers[key];
        }
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        const cookies = normalizedRequest.cookies || (headers?.cookie ? $lDesI.parseCookie(headers.cookie) : void 0);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}
function $71b3473bd3dda9e7$var$normalizeQueryString(queryString) {
    if (typeof queryString === "string") return queryString || void 0;
    const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
    const result = pairs.map(([key, value])=>`${key}=${value}`).join("&");
    return result || void 0;
}
module.exports.requestDataIntegration = $71b3473bd3dda9e7$var$requestDataIntegration;

});
parcelRegister("9TBl7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $734636f9a144dee6$var$ipHeaderNames = [
    "X-Client-IP",
    "X-Forwarded-For",
    "Fly-Client-IP",
    "CF-Connecting-IP",
    "Fastly-Client-Ip",
    "True-Client-Ip",
    "X-Real-IP",
    "X-Cluster-Client-IP",
    "X-Forwarded",
    "Forwarded-For",
    "Forwarded",
    "X-Vercel-Forwarded-For"
];
function $734636f9a144dee6$var$getClientIPAddress(headers) {
    const lowerCaseHeaders = {};
    for (const key of Object.keys(headers))lowerCaseHeaders[key.toLowerCase()] = headers[key];
    const headerValues = $734636f9a144dee6$var$ipHeaderNames.map((headerName)=>{
        const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue.join(";") : rawValue;
        if (headerName === "Forwarded") return $734636f9a144dee6$var$parseForwardedHeader(value);
        return value?.split(",").map((v)=>v.trim());
    });
    const flattenedHeaderValues = headerValues.reduce((acc, val)=>{
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    const ipAddress = flattenedHeaderValues.find((ip)=>ip !== null && $734636f9a144dee6$var$isIP(ip));
    return ipAddress || null;
}
function $734636f9a144dee6$var$parseForwardedHeader(value) {
    if (!value) return null;
    for (const part of value.split(";")){
        if (part.startsWith("for=")) return part.slice(4);
    }
    return null;
}
function $734636f9a144dee6$var$isIP(str) {
    const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}
module.exports.getClientIPAddress = $734636f9a144dee6$var$getClientIPAddress;
module.exports.ipHeaderNames = $734636f9a144dee6$var$ipHeaderNames;

});


parcelRegister("2fKva", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $2cngX = parcelRequire("2cngX");

var $49QLh = parcelRequire("49QLh");

var $d8ZGm = parcelRequire("d8ZGm");

var $99stL = parcelRequire("99stL");

var $f3q6O = parcelRequire("f3q6O");

var $9fWDF = parcelRequire("9fWDF");

var $fdTwu = parcelRequire("fdTwu");

var $kjL8z = parcelRequire("kjL8z");
const $1a410dc22f14e28f$var$INTEGRATION_NAME = "CaptureConsole";
const $1a410dc22f14e28f$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || $99stL.CONSOLE_LEVELS;
    const handled = options.handled ?? true;
    return {
        name: $1a410dc22f14e28f$var$INTEGRATION_NAME,
        setup (client) {
            if (!("console" in $kjL8z.GLOBAL_OBJ)) return;
            $49QLh.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($gCYmH.getClient() !== client || !levels.includes(level)) return;
                $1a410dc22f14e28f$var$consoleHandler(args, level, handled);
            });
        }
    };
};
const $1a410dc22f14e28f$var$captureConsoleIntegration = $d8ZGm.defineIntegration($1a410dc22f14e28f$var$_captureConsoleIntegration);
function $1a410dc22f14e28f$var$consoleHandler(args, level, handled) {
    const severityLevel = $9fWDF.severityLevelFromString(level);
    const syntheticException = new Error();
    const captureContext = {
        level: $9fWDF.severityLevelFromString(level),
        extra: {
            arguments: args
        }
    };
    $gCYmH.withScope((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            $f3q6O.addExceptionMechanism(event, {
                handled: handled,
                type: "auto.core.capture_console"
            });
            return event;
        });
        if (level === "assert") {
            if (!args[0]) {
                const message2 = `Assertion failed: ${$fdTwu.safeJoin(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                scope.captureMessage(message2, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            $2cngX.captureException(error, captureContext);
            return;
        }
        const message = $fdTwu.safeJoin(args, " ");
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}
module.exports.captureConsoleIntegration = $1a410dc22f14e28f$var$captureConsoleIntegration;

});
parcelRegister("49QLh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $1hzu4 = parcelRequire("1hzu4");

var $fdTwu = parcelRequire("fdTwu");

var $kjL8z = parcelRequire("kjL8z");

var $gtIHY = parcelRequire("gtIHY");
const $3070ee06911d9fce$var$_filter = /* @__PURE__ */ new Set([]);
function $3070ee06911d9fce$var$addConsoleInstrumentationHandler(handler) {
    const type = "console";
    const removeHandler = $gtIHY.addHandler(type, handler);
    $gtIHY.maybeInstrument(type, $3070ee06911d9fce$var$instrumentConsole);
    return removeHandler;
}
function $3070ee06911d9fce$var$addConsoleInstrumentationFilter(filter) {
    for (const f of filter)$3070ee06911d9fce$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$3070ee06911d9fce$var$_filter.delete(f);
    };
}
function $3070ee06911d9fce$var$instrumentConsole() {
    if (!("console" in $kjL8z.GLOBAL_OBJ)) return;
    $99stL.CONSOLE_LEVELS.forEach(function(level) {
        if (!(level in $kjL8z.GLOBAL_OBJ.console)) return;
        $1hzu4.fill($kjL8z.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            $99stL.originalConsoleMethods[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = $99stL.originalConsoleMethods[level];
                const isFiltered = $3070ee06911d9fce$var$_filter.size && typeof firstArg === "string" && $fdTwu.stringMatchesSomePattern(firstArg, $3070ee06911d9fce$var$_filter);
                if (!isFiltered) $gtIHY.triggerHandlers("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || $7piqH.DEBUG_BUILD && $99stL.debug.isEnabled()) log?.apply($kjL8z.GLOBAL_OBJ.console, args);
            };
        });
    });
}
module.exports.addConsoleInstrumentationFilter = $3070ee06911d9fce$var$addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $3070ee06911d9fce$var$addConsoleInstrumentationHandler;

});

parcelRegister("9fWDF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6bd3003897cf9753$var$severityLevelFromString(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}
module.exports.severityLevelFromString = $6bd3003897cf9753$var$severityLevelFromString;

});


parcelRegister("71aIk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $d8ZGm = parcelRequire("d8ZGm");

var $99stL = parcelRequire("99stL");

var $66leG = parcelRequire("66leG");
const $51c0eff6dd06302f$var$INTEGRATION_NAME = "Dedupe";
const $51c0eff6dd06302f$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $51c0eff6dd06302f$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($51c0eff6dd06302f$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    $7piqH.DEBUG_BUILD && $99stL.debug.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {}
            return previousEvent = currentEvent;
        }
    };
};
const $51c0eff6dd06302f$var$dedupeIntegration = $d8ZGm.defineIntegration($51c0eff6dd06302f$var$_dedupeIntegration);
function $51c0eff6dd06302f$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($51c0eff6dd06302f$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($51c0eff6dd06302f$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $51c0eff6dd06302f$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$51c0eff6dd06302f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$51c0eff6dd06302f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $51c0eff6dd06302f$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $51c0eff6dd06302f$var$_getExceptionFromEvent(previousEvent);
    const currentException = $51c0eff6dd06302f$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$51c0eff6dd06302f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$51c0eff6dd06302f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $51c0eff6dd06302f$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $66leG.getFramesFromEvent(currentEvent);
    let previousFrames = $66leG.getFramesFromEvent(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $51c0eff6dd06302f$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $51c0eff6dd06302f$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}
module.exports._shouldDropEvent = $51c0eff6dd06302f$var$_shouldDropEvent;
module.exports.dedupeIntegration = $51c0eff6dd06302f$var$dedupeIntegration;

});

parcelRegister("j5zO3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $d8ZGm = parcelRequire("d8ZGm");

var $99stL = parcelRequire("99stL");

var $c34Je = parcelRequire("c34Je");

var $3COzy = parcelRequire("3COzy");

var $acdDE = parcelRequire("acdDE");

var $fdTwu = parcelRequire("fdTwu");
const $de5a42555c972fab$var$INTEGRATION_NAME = "ExtraErrorData";
const $de5a42555c972fab$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $de5a42555c972fab$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $de5a42555c972fab$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $de5a42555c972fab$var$extraErrorDataIntegration = $d8ZGm.defineIntegration($de5a42555c972fab$var$_extraErrorDataIntegration);
function $de5a42555c972fab$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !$c34Je.isError(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $de5a42555c972fab$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = $3COzy.normalize(errorData, depth);
        if ($c34Je.isPlainObject(normalizedErrorData)) {
            $acdDE.setSkipNormalizationHint(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
function $de5a42555c972fab$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = $c34Je.isError(value) || typeof value === "string" ? maxValueLength ? $fdTwu.truncate(`${value}`, maxValueLength) : `${value}` : value;
        }
        if (captureErrorCause && error.cause !== void 0) {
            if ($c34Je.isError(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $de5a42555c972fab$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = $c34Je.isError(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        $7piqH.DEBUG_BUILD && $99stL.debug.error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}
module.exports.extraErrorDataIntegration = $de5a42555c972fab$var$extraErrorDataIntegration;

});

parcelRegister("cRLD0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d8ZGm = parcelRequire("d8ZGm");

var $he37X = parcelRequire("he37X");

var $kjL8z = parcelRequire("kjL8z");
const $95df614042f95ad8$var$INTEGRATION_NAME = "RewriteFrames";
const $95df614042f95ad8$var$rewriteFramesIntegration = $d8ZGm.defineIntegration((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in $kjL8z.GLOBAL_OBJ && !!$kjL8z.GLOBAL_OBJ.window;
    const iteratee = options.iteratee || $95df614042f95ad8$var$generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: $95df614042f95ad8$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
function $95df614042f95ad8$var$generateIteratee({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "").replace(/\\/g, "/") : frame.filename;
            const base = root ? $he37X.relative(root, filename) : $he37X.basename(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}
module.exports.generateIteratee = $95df614042f95ad8$var$generateIteratee;
module.exports.rewriteFramesIntegration = $95df614042f95ad8$var$rewriteFramesIntegration;

});
parcelRegister("he37X", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c8a62b7d94a7fd6b$var$normalizeArray(parts, allowAboveRoot) {
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
const $c8a62b7d94a7fd6b$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
function $c8a62b7d94a7fd6b$var$splitPath(filename) {
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $c8a62b7d94a7fd6b$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
function $c8a62b7d94a7fd6b$var$resolve(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    resolvedPath = $c8a62b7d94a7fd6b$var$normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
function $c8a62b7d94a7fd6b$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $c8a62b7d94a7fd6b$var$relative(from, to) {
    from = $c8a62b7d94a7fd6b$var$resolve(from).slice(1);
    to = $c8a62b7d94a7fd6b$var$resolve(to).slice(1);
    const fromParts = $c8a62b7d94a7fd6b$var$trim(from.split("/"));
    const toParts = $c8a62b7d94a7fd6b$var$trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
function $c8a62b7d94a7fd6b$var$normalizePath(path) {
    const isPathAbsolute = $c8a62b7d94a7fd6b$var$isAbsolute(path);
    const trailingSlash = path.slice(-1) === "/";
    let normalizedPath = $c8a62b7d94a7fd6b$var$normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
function $c8a62b7d94a7fd6b$var$isAbsolute(path) {
    return path.charAt(0) === "/";
}
function $c8a62b7d94a7fd6b$var$join(...args) {
    return $c8a62b7d94a7fd6b$var$normalizePath(args.join("/"));
}
function $c8a62b7d94a7fd6b$var$dirname(path) {
    const result = $c8a62b7d94a7fd6b$var$splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) return ".";
    if (dir) dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
function $c8a62b7d94a7fd6b$var$basename(path, ext) {
    let f = $c8a62b7d94a7fd6b$var$splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}
module.exports.basename = $c8a62b7d94a7fd6b$var$basename;
module.exports.dirname = $c8a62b7d94a7fd6b$var$dirname;
module.exports.isAbsolute = $c8a62b7d94a7fd6b$var$isAbsolute;
module.exports.join = $c8a62b7d94a7fd6b$var$join;
module.exports.normalizePath = $c8a62b7d94a7fd6b$var$normalizePath;
module.exports.relative = $c8a62b7d94a7fd6b$var$relative;
module.exports.resolve = $c8a62b7d94a7fd6b$var$resolve;

});


parcelRegister("dZBM3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d49ib = parcelRequire("d49ib");

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $2cngX = parcelRequire("2cngX");

var $d8ZGm = parcelRequire("d8ZGm");

var $k6VdG = parcelRequire("k6VdG");

var $99stL = parcelRequire("99stL");

var $f3q6O = parcelRequire("f3q6O");

var $c34Je = parcelRequire("c34Je");

var $3pcOx = parcelRequire("3pcOx");

var $lRCeh = parcelRequire("lRCeh");
const $a2fe4607f114cf0b$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    "reauthenticate",
    "signInAnonymously",
    "signInWithOAuth",
    "signInWithIdToken",
    "signInWithOtp",
    "signInWithPassword",
    "signInWithSSO",
    "signOut",
    "signUp",
    "verifyOtp"
];
const $a2fe4607f114cf0b$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    "createUser",
    "deleteUser",
    "listUsers",
    "getUserById",
    "updateUserById",
    "inviteUserByEmail"
];
const $a2fe4607f114cf0b$var$FILTER_MAPPINGS = {
    eq: "eq",
    neq: "neq",
    gt: "gt",
    gte: "gte",
    lt: "lt",
    lte: "lte",
    like: "like",
    "like(all)": "likeAllOf",
    "like(any)": "likeAnyOf",
    ilike: "ilike",
    "ilike(all)": "ilikeAllOf",
    "ilike(any)": "ilikeAnyOf",
    is: "is",
    in: "in",
    cs: "contains",
    cd: "containedBy",
    sr: "rangeGt",
    nxl: "rangeGte",
    sl: "rangeLt",
    nxr: "rangeLte",
    adj: "rangeAdjacent",
    ov: "overlaps",
    fts: "",
    plfts: "plain",
    phfts: "phrase",
    wfts: "websearch",
    not: "not"
};
const $a2fe4607f114cf0b$var$DB_OPERATIONS_TO_INSTRUMENT = [
    "select",
    "insert",
    "upsert",
    "update",
    "delete"
];
function $a2fe4607f114cf0b$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {}
}
function $a2fe4607f114cf0b$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
function $a2fe4607f114cf0b$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return void 0;
}
function $a2fe4607f114cf0b$var$hasMutationBodyForDescription(rawBody, plainBody) {
    return $a2fe4607f114cf0b$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== void 0;
}
function $a2fe4607f114cf0b$var$extractOperation(method, headers = {}) {
    switch(method){
        case "GET":
            return "select";
        case "POST":
            if (headers["Prefer"]?.includes("resolution=")) return "upsert";
            else return "insert";
        case "PATCH":
            return "update";
        case "DELETE":
            return "delete";
        default:
            return "<unknown-op>";
    }
}
function $a2fe4607f114cf0b$var$translateFiltersIntoMethods(key, query) {
    if (query === "" || query === "*") return "select(*)";
    if (key === "select") return `select(${query})`;
    if (key === "or" || key.endsWith(".or")) return `${key}${query}`;
    const [filter, ...value] = query.split(".");
    let method;
    if (filter?.startsWith("fts")) method = "textSearch";
    else if (filter?.startsWith("plfts")) method = "textSearch[plain]";
    else if (filter?.startsWith("phfts")) method = "textSearch[phrase]";
    else if (filter?.startsWith("wfts")) method = "textSearch[websearch]";
    else method = filter && $a2fe4607f114cf0b$var$FILTER_MAPPINGS[filter] || "filter";
    return `${method}(${key}, ${value.join(".")})`;
}
function $a2fe4607f114cf0b$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return $lRCeh.startSpan({
                name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
                attributes: {
                    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db",
                    "db.system": "postgresql",
                    "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if (res && typeof res === "object" && "error" in res && res.error) {
                        span.setStatus({
                            code: $3pcOx.SPAN_STATUS_ERROR
                        });
                        $2cngX.captureException(res.error, {
                            mechanism: {
                                handled: false,
                                type: "auto.db.supabase.auth"
                            }
                        });
                    } else span.setStatus({
                        code: $3pcOx.SPAN_STATUS_OK
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: $3pcOx.SPAN_STATUS_ERROR
                    });
                    span.end();
                    $2cngX.captureException(err, {
                        mechanism: {
                            handled: false,
                            type: "auto.db.supabase.auth"
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $a2fe4607f114cf0b$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $a2fe4607f114cf0b$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $a2fe4607f114cf0b$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === "function") supabaseClientInstance.auth[operation] = $a2fe4607f114cf0b$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $a2fe4607f114cf0b$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === "function") supabaseClientInstance.auth.admin[operation] = $a2fe4607f114cf0b$var$instrumentAuthOperation(authOperation, true);
    }
    $a2fe4607f114cf0b$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $a2fe4607f114cf0b$var$instrumentSupabaseClientConstructor(SupabaseClient, _options) {
    if ($a2fe4607f114cf0b$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $a2fe4607f114cf0b$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options);
            return rv;
        }
    });
    $a2fe4607f114cf0b$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $a2fe4607f114cf0b$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options) {
    if ($a2fe4607f114cf0b$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $a2fe4607f114cf0b$var$DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = $a2fe4607f114cf0b$var$extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== "string") return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split("/");
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())queryItems.push($a2fe4607f114cf0b$var$translateFiltersIntoMethods(key, value));
            const body = /* @__PURE__ */ Object.create(null);
            if ($c34Je.isPlainObject(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const client = $gCYmH.getClient();
            const shouldSendData = _options.sendOperationData ?? client?.getDataCollectionOptions().userInfo === true;
            const bodyPayload = $a2fe4607f114cf0b$var$getMutationBodyPayloadForTelemetry(typedThis.body, body);
            const mutationPart = operation === "select" ? "" : `${operation}${$a2fe4607f114cf0b$var$hasMutationBodyForDescription(typedThis.body, body) ? "(...) " : ""}`;
            const queryPart = shouldSendData ? queryItems.join(" ") : queryItems.length > 0 ? "[redacted]" : "";
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(" ");
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                "db.table": table,
                "db.schema": typedThis.schema,
                "db.url": typedThis.url.origin,
                "db.sdk": typedThis.headers["X-Client-Info"],
                "db.system": "postgresql",
                "db.operation": operation,
                [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
            };
            if (queryItems.length && shouldSendData) attributes["db.query"] = queryItems;
            if (bodyPayload !== void 0 && shouldSendData) attributes["db.body"] = bodyPayload;
            return $lRCeh.startSpan({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === "object" && "status" in res) $3pcOx.setHttpStatus(span, res.status || 500);
                        span.end();
                    }
                    if (res?.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && shouldSendData) supabaseContext.query = queryItems;
                        if (bodyPayload !== void 0 && shouldSendData) supabaseContext.body = bodyPayload;
                        $2cngX.captureException(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                $f3q6O.addExceptionMechanism(e, {
                                    handled: false,
                                    type: "auto.db.supabase.postgres"
                                });
                                return e;
                            });
                            scope.setContext("supabase", supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: "supabase",
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && shouldSendData) data.query = queryItems;
                    if (bodyPayload !== void 0 && shouldSendData) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    $d49ib.addBreadcrumb(breadcrumb);
                    return res;
                }, (err)=>{
                    if (span) {
                        $3pcOx.setHttpStatus(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $a2fe4607f114cf0b$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $a2fe4607f114cf0b$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options) {
    for (const operation of $a2fe4607f114cf0b$var$DB_OPERATIONS_TO_INSTRUMENT){
        if ($a2fe4607f114cf0b$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                $7piqH.DEBUG_BUILD && $99stL.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $a2fe4607f114cf0b$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options);
                return rv;
            }
        });
        $a2fe4607f114cf0b$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $a2fe4607f114cf0b$var$instrumentSupabaseClient = (supabaseClient, options = {})=>{
    if (!supabaseClient) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("Supabase integration was not installed because no Supabase client was provided.");
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $a2fe4607f114cf0b$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor, options);
    $a2fe4607f114cf0b$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $a2fe4607f114cf0b$var$INTEGRATION_NAME = "Supabase";
const $a2fe4607f114cf0b$var$_supabaseIntegration = (supabaseClient, options)=>{
    return {
        setupOnce () {
            $a2fe4607f114cf0b$var$instrumentSupabaseClient(supabaseClient, options);
        },
        name: $a2fe4607f114cf0b$var$INTEGRATION_NAME
    };
};
const $a2fe4607f114cf0b$var$supabaseIntegration = $d8ZGm.defineIntegration((options)=>{
    return $a2fe4607f114cf0b$var$_supabaseIntegration(options.supabaseClient, {
        sendOperationData: options.sendOperationData
    });
});
module.exports.DB_OPERATIONS_TO_INSTRUMENT = $a2fe4607f114cf0b$var$DB_OPERATIONS_TO_INSTRUMENT;
module.exports.FILTER_MAPPINGS = $a2fe4607f114cf0b$var$FILTER_MAPPINGS;
module.exports.extractOperation = $a2fe4607f114cf0b$var$extractOperation;
module.exports.instrumentSupabaseClient = $a2fe4607f114cf0b$var$instrumentSupabaseClient;
module.exports.supabaseIntegration = $a2fe4607f114cf0b$var$supabaseIntegration;
module.exports.translateFiltersIntoMethods = $a2fe4607f114cf0b$var$translateFiltersIntoMethods;

});

parcelRegister("9cy9e", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d8ZGm = parcelRequire("d8ZGm");

var $c34Je = parcelRequire("c34Je");

var $fdTwu = parcelRequire("fdTwu");
const $6b2fb920bea2d9ee$var$DEFAULT_LIMIT = 10;
const $6b2fb920bea2d9ee$var$INTEGRATION_NAME = "ZodErrors";
function $6b2fb920bea2d9ee$var$originalExceptionIsZodError(originalException) {
    return $c34Je.isError(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
}
function $6b2fb920bea2d9ee$var$flattenIssue(issue) {
    return {
        ...issue,
        path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : void 0,
        keys: "keys" in issue ? JSON.stringify(issue.keys) : void 0,
        unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : void 0
    };
}
function $6b2fb920bea2d9ee$var$flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === "number") return "<array>";
        else return p;
    }).join(".");
}
function $6b2fb920bea2d9ee$var$formatIssueMessage(zodError) {
    const errorKeyMap = /* @__PURE__ */ new Set();
    for (const iss of zodError.issues){
        const issuePath = $6b2fb920bea2d9ee$var$flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        let rootExpectedType = "variable";
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== void 0 && "expected" in iss && typeof iss.expected === "string") rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${$fdTwu.truncate(errorKeys.join(", "), 100)}`;
}
function $6b2fb920bea2d9ee$var$applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$6b2fb920bea2d9ee$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($6b2fb920bea2d9ee$var$flattenIssue);
        if (saveZodIssuesAsAttachment) {
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: "zod_issues.json",
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $6b2fb920bea2d9ee$var$formatIssueMessage(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                "zoderror.issues": flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        return {
            ...event,
            extra: {
                ...event.extra,
                "zoderrors sentry integration parse error": {
                    message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
                    error: e instanceof Error ? `${e.name}: ${e.message}
${e.stack}` : "unknown"
                }
            }
        };
    }
}
const $6b2fb920bea2d9ee$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $6b2fb920bea2d9ee$var$DEFAULT_LIMIT;
    return {
        name: $6b2fb920bea2d9ee$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $6b2fb920bea2d9ee$var$applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
const $6b2fb920bea2d9ee$var$zodErrorsIntegration = $d8ZGm.defineIntegration($6b2fb920bea2d9ee$var$_zodErrorsIntegration);
module.exports.applyZodErrorsToEvent = $6b2fb920bea2d9ee$var$applyZodErrorsToEvent;
module.exports.flattenIssue = $6b2fb920bea2d9ee$var$flattenIssue;
module.exports.flattenIssuePath = $6b2fb920bea2d9ee$var$flattenIssuePath;
module.exports.formatIssueMessage = $6b2fb920bea2d9ee$var$formatIssueMessage;
module.exports.zodErrorsIntegration = $6b2fb920bea2d9ee$var$zodErrorsIntegration;

});

parcelRegister("fSMJB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d8ZGm = parcelRequire("d8ZGm");

var $doSiu = parcelRequire("doSiu");

var $l008j = parcelRequire("l008j");

var $66leG = parcelRequire("66leG");

var $kjL8z = parcelRequire("kjL8z");
const $b901b3d8774f4965$var$thirdPartyErrorFilterIntegration = $d8ZGm.defineIntegration((options)=>{
    return {
        name: "ThirdPartyErrorsFilter",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $l008j.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $doSiu.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $doSiu.addMetadataToStackFrames(stackParser, event);
            });
        },
        preprocessEvent (event) {
            if (options.ignoreSentryInternalFrames && ($kjL8z.GLOBAL_OBJ._sentryWrappedDepth ?? 0) > 0) event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                insideSentryWrapped: true
            };
        },
        processEvent (event) {
            const insideSentryWrapped = options.ignoreSentryInternalFrames ? event.sdkProcessingMetadata?.insideSentryWrapped === true && event.exception?.values?.length === 1 : false;
            const frameKeys = $b901b3d8774f4965$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames, insideSentryWrapped);
            if (frameKeys) {
                const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
function $b901b3d8774f4965$var$isSentryInternalFrame(frame, frameIndex, insideSentryWrapped) {
    if (frameIndex !== 0) return false;
    if (insideSentryWrapped && $b901b3d8774f4965$var$isLikelyMinifiedSentryWrappedFrame(frame)) return true;
    if (frame.function === "sentryWrapped") return true;
    if (!frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes("sentry") || !frame.filename.includes("helpers") || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($b901b3d8774f4965$var$SENTRY_INTERNAL_FN_APPLY)) return false;
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes($b901b3d8774f4965$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $b901b3d8774f4965$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames, insideSentryWrapped) {
    const frames = $66leG.getFramesFromEvent(event);
    if (!frames) return void 0;
    return frames.filter((frame, index)=>{
        if (!frame.filename) return false;
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        return !ignoreSentryInternalFrames || !$b901b3d8774f4965$var$isSentryInternalFrame(frame, index, !!insideSentryWrapped);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($b901b3d8774f4965$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($b901b3d8774f4965$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
function $b901b3d8774f4965$var$isLikelyMinifiedSentryWrappedFrame(frame) {
    return !frame.context_line && !frame.pre_context && !!frame.function && frame.function.length <= 2;
}
const $b901b3d8774f4965$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";
const $b901b3d8774f4965$var$SENTRY_INTERNAL_COMMENT = "Attempt to invoke user-land function";
const $b901b3d8774f4965$var$SENTRY_INTERNAL_FN_APPLY = "fn.apply(this, wrappedArguments)";
module.exports.thirdPartyErrorFilterIntegration = $b901b3d8774f4965$var$thirdPartyErrorFilterIntegration;

});

parcelRegister("j1udx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d49ib = parcelRequire("d49ib");

var $gCYmH = parcelRequire("gCYmH");

var $49QLh = parcelRequire("49QLh");

var $d8ZGm = parcelRequire("d8ZGm");

var $99stL = parcelRequire("99stL");

var $9fWDF = parcelRequire("9fWDF");

var $fdTwu = parcelRequire("fdTwu");

var $kjL8z = parcelRequire("kjL8z");
const $dd958cd69e664c8e$var$INTEGRATION_NAME = "Console";
const $dd958cd69e664c8e$var$consoleIntegration = $d8ZGm.defineIntegration((options = {})=>{
    const levels = new Set(options.levels || $99stL.CONSOLE_LEVELS);
    return {
        name: $dd958cd69e664c8e$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = $49QLh.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($gCYmH.getClient() !== client || !levels.has(level)) return;
                $dd958cd69e664c8e$var$addConsoleBreadcrumb(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe2 = $49QLh.addConsoleInstrumentationFilter(options.filter);
                client.registerCleanup(unsubscribe2);
            }
        }
    };
});
function $dd958cd69e664c8e$var$addConsoleBreadcrumb(level, args) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: args,
            logger: "console"
        },
        level: $9fWDF.severityLevelFromString(level),
        message: $dd958cd69e664c8e$var$formatConsoleArgs(args)
    };
    if (level === "assert") {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$dd958cd69e664c8e$var$formatConsoleArgs(assertionArgs)}` : "Assertion failed";
            breadcrumb.data.arguments = assertionArgs;
        } else return;
    }
    $d49ib.addBreadcrumb(breadcrumb, {
        input: args,
        level: level
    });
}
function $dd958cd69e664c8e$var$formatConsoleArgs(values) {
    return "util" in $kjL8z.GLOBAL_OBJ && typeof $kjL8z.GLOBAL_OBJ.util.format === "function" ? $kjL8z.GLOBAL_OBJ.util.format(...values) : $fdTwu.safeJoin(values, " ");
}
module.exports.addConsoleBreadcrumb = $dd958cd69e664c8e$var$addConsoleBreadcrumb;
module.exports.consoleIntegration = $dd958cd69e664c8e$var$consoleIntegration;

});

parcelRegister("fifp5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d8ZGm = parcelRequire("d8ZGm");

var $88VYb = parcelRequire("88VYb");
const $b2247c4dadb928ba$var$featureFlagsIntegration = $d8ZGm.defineIntegration(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return $88VYb._INTERNAL_copyFlagsFromScopeToEvent(event);
        },
        addFeatureFlag (name, value) {
            $88VYb._INTERNAL_insertFlagToScope(name, value);
            $88VYb._INTERNAL_addFeatureFlagToActiveSpan(name, value);
        }
    };
});
module.exports.featureFlagsIntegration = $b2247c4dadb928ba$var$featureFlagsIntegration;

});
parcelRegister("88VYb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $cp5Iu = parcelRequire("cp5Iu");
const $5edc09a3b40771b8$var$_INTERNAL_FLAG_BUFFER_SIZE = 100;
const $5edc09a3b40771b8$var$_INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const $5edc09a3b40771b8$var$SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
function $5edc09a3b40771b8$var$_INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) return event;
    const scope = $gCYmH.getCurrentScope();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === void 0) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
function $5edc09a3b40771b8$var$_INTERNAL_insertFlagToScope(name, value, maxSize = $5edc09a3b40771b8$var$_INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = $gCYmH.getCurrentScope().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $5edc09a3b40771b8$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
function $5edc09a3b40771b8$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        $7piqH.DEBUG_BUILD && $99stL.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) flags.splice(index, 1);
    if (flags.length === maxSize) flags.shift();
    flags.push({
        flag: name,
        result: value
    });
}
function $5edc09a3b40771b8$var$_INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = $5edc09a3b40771b8$var$_INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== "boolean") return;
    const span = $cp5Iu.getActiveSpan();
    if (!span) return;
    const attributes = $cp5Iu.spanToJSON(span).data;
    if (`${$5edc09a3b40771b8$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$5edc09a3b40771b8$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($5edc09a3b40771b8$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$5edc09a3b40771b8$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $5edc09a3b40771b8$var$_INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $5edc09a3b40771b8$var$_INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $5edc09a3b40771b8$var$_INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $5edc09a3b40771b8$var$_INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $5edc09a3b40771b8$var$_INTERNAL_insertFlagToScope;
module.exports._INTERNAL_insertToFlagBuffer = $5edc09a3b40771b8$var$_INTERNAL_insertToFlagBuffer;

});


parcelRegister("j5pZS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d8ZGm = parcelRequire("d8ZGm");

var $88VYb = parcelRequire("88VYb");

var $1hzu4 = parcelRequire("1hzu4");
const $de52a66acadf63b7$var$growthbookIntegration = $d8ZGm.defineIntegration(({ growthbookClass: growthbookClass })=>{
    return {
        name: "GrowthBook",
        setupOnce () {
            const proto = growthbookClass.prototype;
            if (typeof proto.isOn === "function") $1hzu4.fill(proto, "isOn", $de52a66acadf63b7$var$_wrapAndCaptureBooleanResult);
            if (typeof proto.getFeatureValue === "function") $1hzu4.fill(proto, "getFeatureValue", $de52a66acadf63b7$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return $88VYb._INTERNAL_copyFlagsFromScopeToEvent(event);
        }
    };
});
function $de52a66acadf63b7$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === "string" && typeof result === "boolean") {
            $88VYb._INTERNAL_insertFlagToScope(flagName, result);
            $88VYb._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
        }
        return result;
    };
}
module.exports.growthbookIntegration = $de52a66acadf63b7$var$growthbookIntegration;

});

parcelRegister("iMQu3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $d8ZGm = parcelRequire("d8ZGm");

var $k6VdG = parcelRequire("k6VdG");

var $cp5Iu = parcelRequire("cp5Iu");
const $dad56be1691fedc3$var$INTEGRATION_NAME = "ConversationId";
const $dad56be1691fedc3$var$_conversationIdIntegration = ()=>{
    return {
        name: $dad56be1691fedc3$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = $gCYmH.getCurrentScope().getScopeData();
                const isolationScopeData = $gCYmH.getIsolationScope().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = $cp5Iu.spanToJSON(span);
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute($k6VdG.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
                }
            });
        }
    };
};
const $dad56be1691fedc3$var$conversationIdIntegration = $d8ZGm.defineIntegration($dad56be1691fedc3$var$_conversationIdIntegration);
module.exports.conversationIdIntegration = $dad56be1691fedc3$var$conversationIdIntegration;

});

parcelRegister("CBTQ9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");
function $0740f2ce02effd1d$var$isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration["_profiler"] !== "undefined" && typeof integration["_profiler"]["start"] === "function" && typeof integration["_profiler"]["stop"] === "function";
}
function $0740f2ce02effd1d$var$startProfiler() {
    const client = $gCYmH.getClient();
    if (!client) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$0740f2ce02effd1d$var$isProfilingIntegrationWithProfiler(integration)) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.start();
}
function $0740f2ce02effd1d$var$stopProfiler() {
    const client = $gCYmH.getClient();
    if (!client) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$0740f2ce02effd1d$var$isProfilingIntegrationWithProfiler(integration)) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.stop();
}
const $0740f2ce02effd1d$var$profiler = {
    startProfiler: $0740f2ce02effd1d$var$startProfiler,
    stopProfiler: $0740f2ce02effd1d$var$stopProfiler
};
module.exports.profiler = $0740f2ce02effd1d$var$profiler;

});

parcelRegister("2vt6q", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $k6VdG = parcelRequire("k6VdG");

var $cp5Iu = parcelRequire("cp5Iu");

var $3pcOx = parcelRequire("3pcOx");

var $c34Je = parcelRequire("c34Je");

var $fe1rL = parcelRequire("fe1rL");

var $2BhuU = parcelRequire("2BhuU");

var $gCbFP = parcelRequire("gCbFP");

var $wmosz = parcelRequire("wmosz");

var $lRCeh = parcelRequire("lRCeh");

var $9jzbe = parcelRequire("9jzbe");

var $iHmco = parcelRequire("iHmco");
function $1d350d2ed642b912$var$instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return void 0;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = $fe1rL.hasSpansEnabled() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult) {
                $1d350d2ed642b912$var$endSpan(span2, handlerData);
                $1d350d2ed642b912$var$_callOnRequestSpanEnd(span2, handlerData, spanOriginOrOptions);
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const { spanOrigin: spanOrigin = "auto.http.browser", propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = $gCYmH.getClient();
    const hasParent = !!$cp5Iu.getActiveSpan();
    const shouldEmitSpan = hasParent || !!client && $wmosz.hasSpanStreamingEnabled(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? $lRCeh.startInactiveSpan($1d350d2ed642b912$var$getSpanStartOptions(url, method, spanOrigin)) : new $2BhuU.SentryNonRecordingSpan();
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $1d350d2ed642b912$var$_INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        $fe1rL.hasSpansEnabled() && shouldEmitSpan ? span : void 0, propagateTraceparent);
        if (headers) {
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
function $1d350d2ed642b912$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
function $1d350d2ed642b912$var$_INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = $9jzbe.getTraceData({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    if (!sentryTrace) return void 0;
    const originalHeaders = fetchOptionsObj.headers || ($c34Je.isRequest(request) ? request.headers : void 0);
    if (!originalHeaders) return {
        ...traceHeaders
    };
    else if ($1d350d2ed642b912$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$1d350d2ed642b912$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($1d350d2ed642b912$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === "traceparent")) newHeaders.push([
            "traceparent",
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && typeof header[1] === "string" && $1d350d2ed642b912$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
        const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$1d350d2ed642b912$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $1d350d2ed642b912$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : void 0
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $1d350d2ed642b912$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        $3pcOx.setHttpStatus(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: $3pcOx.SPAN_STATUS_ERROR,
        message: "internal_error"
    });
    span.end();
}
function $1d350d2ed642b912$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith($gCbFP.SENTRY_BAGGAGE_KEY_PREFIX));
}
function $1d350d2ed642b912$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && $c34Je.isInstanceOf(headers, Headers);
}
function $1d350d2ed642b912$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === "string");
}
function $1d350d2ed642b912$var$getSpanStartOptions(url$1, method, spanOrigin) {
    if (url$1.startsWith("data:")) {
        const sanitizedUrl2 = $iHmco.stripDataUrlContent(url$1);
        return {
            name: `${method} ${sanitizedUrl2}`,
            attributes: $1d350d2ed642b912$var$getFetchSpanAttributes(url$1, void 0, method, spanOrigin)
        };
    }
    const parsedUrl = $iHmco.parseStringToURLObject(url$1);
    const sanitizedUrl = parsedUrl ? $iHmco.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $1d350d2ed642b912$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin)
    };
}
function $1d350d2ed642b912$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: $iHmco.stripDataUrlContent(url$1),
        type: "fetch",
        "http.method": method,
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client"
    };
    if (parsedUrl) {
        if (!$iHmco.isURLObjectRelative(parsedUrl)) {
            attributes["http.url"] = $iHmco.stripDataUrlContent(parsedUrl.href);
            attributes["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes["http.fragment"] = parsedUrl.hash;
    }
    return attributes;
}
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $1d350d2ed642b912$var$_INTERNAL_getTracingHeadersForFetchRequest;
module.exports._callOnRequestSpanEnd = $1d350d2ed642b912$var$_callOnRequestSpanEnd;
module.exports.instrumentFetchRequest = $1d350d2ed642b912$var$instrumentFetchRequest;

});

parcelRegister("8wtnp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");
function $6348197b54a48410$var$captureFeedback(params, hint = {}, scope = $gCYmH.getCurrentScope()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = scope?.getClient() || $gCYmH.getClient();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}
module.exports.captureFeedback = $6348197b54a48410$var$captureFeedback;

});

parcelRegister("3Uk1I", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eS4SN = parcelRequire("eS4SN");

var $iTLX9 = parcelRequire("iTLX9");
function $2d8622f3368de755$var$captureLog(level, message, attributes, scope, severityNumber) {
    $eS4SN._INTERNAL_captureLog({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
function $2d8622f3368de755$var$trace(message, attributes, { scope: scope } = {}) {
    $2d8622f3368de755$var$captureLog("trace", message, attributes, scope);
}
function $2d8622f3368de755$var$debug(message, attributes, { scope: scope } = {}) {
    $2d8622f3368de755$var$captureLog("debug", message, attributes, scope);
}
function $2d8622f3368de755$var$info(message, attributes, { scope: scope } = {}) {
    $2d8622f3368de755$var$captureLog("info", message, attributes, scope);
}
function $2d8622f3368de755$var$warn(message, attributes, { scope: scope } = {}) {
    $2d8622f3368de755$var$captureLog("warn", message, attributes, scope);
}
function $2d8622f3368de755$var$error(message, attributes, { scope: scope } = {}) {
    $2d8622f3368de755$var$captureLog("error", message, attributes, scope);
}
function $2d8622f3368de755$var$fatal(message, attributes, { scope: scope } = {}) {
    $2d8622f3368de755$var$captureLog("fatal", message, attributes, scope);
}
module.exports.fmt = $iTLX9.fmt;
module.exports.debug = $2d8622f3368de755$var$debug;
module.exports.error = $2d8622f3368de755$var$error;
module.exports.fatal = $2d8622f3368de755$var$fatal;
module.exports.info = $2d8622f3368de755$var$info;
module.exports.trace = $2d8622f3368de755$var$trace;
module.exports.warn = $2d8622f3368de755$var$warn;

});

parcelRegister("cg7BP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $7piqH = parcelRequire("7piqH");

var $49QLh = parcelRequire("49QLh");

var $d8ZGm = parcelRequire("d8ZGm");

var $k6VdG = parcelRequire("k6VdG");

var $99stL = parcelRequire("99stL");

var $c34Je = parcelRequire("c34Je");

var $3COzy = parcelRequire("3COzy");

var $eS4SN = parcelRequire("eS4SN");

var $8RK3b = parcelRequire("8RK3b");
const $8ecce1b0d8bfbf95$var$INTEGRATION_NAME = "ConsoleLogs";
const $8ecce1b0d8bfbf95$var$DEFAULT_ATTRIBUTES = {
    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.log.console"
};
const $8ecce1b0d8bfbf95$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || $99stL.CONSOLE_LEVELS;
    return {
        name: $8ecce1b0d8bfbf95$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            if (!enableLogs) {
                $7piqH.DEBUG_BUILD && $99stL.debug.warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            const unsubscribe = $49QLh.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($gCYmH.getClient() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === "assert") {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$8RK3b.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        $eS4SN._INTERNAL_captureLog({
                            level: "error",
                            message: assertionMessage,
                            attributes: $8ecce1b0d8bfbf95$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                const attributes = {
                    ...$8ecce1b0d8bfbf95$var$DEFAULT_ATTRIBUTES
                };
                if ($c34Je.isPlainObject(firstArg)) {
                    Object.assign(attributes, $3COzy.normalize(firstArg, normalizeDepth, normalizeMaxBreadth));
                    const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
                    const remainingArgs = args.slice(remainingArgsStartIndex);
                    remainingArgs.forEach((arg, index)=>{
                        attributes[`sentry.message.parameter.${index}`] = $3COzy.normalize(arg, normalizeDepth, normalizeMaxBreadth);
                    });
                } else {
                    const shouldGenerateTemplate = followingArgs.length > 0 && typeof firstArg === "string" && !$8RK3b.hasConsoleSubstitutions(firstArg);
                    if (shouldGenerateTemplate) {
                        const templateAttrs = $8RK3b.createConsoleTemplateAttributes(firstArg, followingArgs);
                        for (const [key, value] of Object.entries(templateAttrs))attributes[key] = key.startsWith("sentry.message.parameter.") ? $3COzy.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
                    }
                }
                $eS4SN._INTERNAL_captureLog({
                    level: isLevelLog ? "info" : level,
                    message: $8RK3b.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : void 0,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
const $8ecce1b0d8bfbf95$var$consoleLoggingIntegration = $d8ZGm.defineIntegration($8ecce1b0d8bfbf95$var$_consoleLoggingIntegration);
module.exports.consoleLoggingIntegration = $8ecce1b0d8bfbf95$var$consoleLoggingIntegration;

});
parcelRegister("8RK3b", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $c34Je = parcelRequire("c34Je");

var $3COzy = parcelRequire("3COzy");

var $kjL8z = parcelRequire("kjL8z");
function $6746fe9719fa298a$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in $kjL8z.GLOBAL_OBJ && typeof $kjL8z.GLOBAL_OBJ.util.format === "function" ? $kjL8z.GLOBAL_OBJ.util.format(...values) : $6746fe9719fa298a$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
function $6746fe9719fa298a$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>$c34Je.isPrimitive(value) ? String(value) : JSON.stringify($3COzy.normalize(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}
function $6746fe9719fa298a$var$hasConsoleSubstitutions(str) {
    return /%[sdifocO]/.test(str);
}
function $6746fe9719fa298a$var$createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    const template = new Array(followingArgs.length).fill("{}").join(" ");
    attributes["sentry.message.template"] = `${firstArg} ${template}`;
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}
module.exports.createConsoleTemplateAttributes = $6746fe9719fa298a$var$createConsoleTemplateAttributes;
module.exports.formatConsoleArgs = $6746fe9719fa298a$var$formatConsoleArgs;
module.exports.hasConsoleSubstitutions = $6746fe9719fa298a$var$hasConsoleSubstitutions;
module.exports.safeJoinConsoleArgs = $6746fe9719fa298a$var$safeJoinConsoleArgs;

});


parcelRegister("bBt1V", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $a4GKN = parcelRequire("a4GKN");
function $8729ab2900600c0b$var$captureMetric(type, name, value, options) {
    $a4GKN._INTERNAL_captureMetric({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
function $8729ab2900600c0b$var$count(name, value = 1, options) {
    $8729ab2900600c0b$var$captureMetric("counter", name, value, options);
}
function $8729ab2900600c0b$var$gauge(name, value, options) {
    $8729ab2900600c0b$var$captureMetric("gauge", name, value, options);
}
function $8729ab2900600c0b$var$distribution(name, value, options) {
    $8729ab2900600c0b$var$captureMetric("distribution", name, value, options);
}
module.exports.count = $8729ab2900600c0b$var$count;
module.exports.distribution = $8729ab2900600c0b$var$distribution;
module.exports.gauge = $8729ab2900600c0b$var$gauge;

});

parcelRegister("aO2R9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $eS4SN = parcelRequire("eS4SN");

var $8RK3b = parcelRequire("8RK3b");

var $c34Je = parcelRequire("c34Je");

var $3COzy = parcelRequire("3COzy");
const $7de0ca131eee39f3$var$DEFAULT_CAPTURED_LEVELS = [
    "trace",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
];
function $7de0ca131eee39f3$var$createConsolaReporter(options = {}) {
    const levels = new Set(options.levels ?? $7de0ca131eee39f3$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date, ...rest } = logObj;
            const client = providedClient || $gCYmH.getClient();
            if (!client) return;
            const logSeverityLevel = $7de0ca131eee39f3$var$getLogSeverityLevel(type, level);
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            const attributes = {};
            for (const [key, value] of Object.entries(rest))attributes[key] = $3COzy.normalize(value, normalizeDepth, normalizeMaxBreadth);
            attributes["sentry.origin"] = "auto.log.consola";
            if (tag) attributes["consola.tag"] = tag;
            if (type) attributes["consola.type"] = type;
            if (level != null && typeof level === "number") attributes["consola.level"] = level;
            const extractionResult = $7de0ca131eee39f3$var$processExtractedAttributes($7de0ca131eee39f3$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            $eS4SN._INTERNAL_captureLog({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && $8RK3b.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || "",
                attributes: attributes
            });
        }
    };
}
const $7de0ca131eee39f3$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: "trace",
    fatal: "fatal",
    error: "error",
    warn: "warn",
    log: "info",
    info: "info",
    success: "info",
    fail: "error",
    ready: "info",
    start: "info",
    box: "info",
    debug: "debug",
    trace: "trace",
    verbose: "debug",
    // Custom types that might exist
    critical: "fatal",
    notice: "info"
};
const $7de0ca131eee39f3$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: "fatal",
    // Fatal and Error
    1: "warn",
    // Warnings
    2: "info",
    // Normal logs
    3: "info",
    // Informational logs, success, fail, ready, start, ...
    4: "debug",
    // Debug logs
    5: "trace"
};
function $7de0ca131eee39f3$var$getLogSeverityLevel(type, level) {
    if (type === "verbose") return "debug";
    if (type === "silent") return "trace";
    if (type) {
        const mappedLevel = $7de0ca131eee39f3$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    if (typeof level === "number") {
        const mappedLevel = $7de0ca131eee39f3$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    return "info";
}
function $7de0ca131eee39f3$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ""
    };
    const message = $8RK3b.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ($c34Je.isPlainObject(firstArg)) {
        const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === "string" && !$8RK3b.hasConsoleSubstitutions(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : void 0,
            messageParameters: shouldAddTemplateAttr ? followingArgs : void 0
        };
    }
}
function $7de0ca131eee39f3$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = $8RK3b.createConsoleTemplateAttributes(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith("sentry.message.parameter.") ? $3COzy.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = $3COzy.normalize(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...$3COzy.normalize(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}
module.exports.createConsolaReporter = $7de0ca131eee39f3$var$createConsolaReporter;

});

parcelRegister("aNBhO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $k6VdG = parcelRequire("k6VdG");

var $7GCmi = parcelRequire("7GCmi");

var $cp5Iu = parcelRequire("cp5Iu");

var $d6car = parcelRequire("d6car");

var $bSxUW = parcelRequire("bSxUW");

var $wmosz = parcelRequire("wmosz");

var $ltJYC = parcelRequire("ltJYC");

var $3dAhG = parcelRequire("3dAhG");
function $7dcb674693d4175c$var$onVercelAiSpanStart(span) {
    const { data: attributes, description: name } = $cp5Iu.spanToJSON(span);
    if (!name) return;
    if (attributes[$3dAhG.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[$3dAhG.AI_TOOL_CALL_ID_ATTRIBUTE] && name === "ai.toolCall") {
        $7dcb674693d4175c$var$processToolCallSpan(span, attributes);
        return;
    }
    if (!attributes[$3dAhG.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith("ai.")) return;
    const client = $gCYmH.getClient();
    const integration = client?.getIntegrationByName("VercelAI");
    const enableTruncation = $7GCmi.shouldEnableTruncation(integration?.options?.enableTruncation);
    $7dcb674693d4175c$var$processGenerateSpan(span, name, attributes, enableTruncation);
}
function $7dcb674693d4175c$var$vercelAiEventProcessor(event) {
    if (event.type === "transaction" && event.spans) {
        const tokenAccumulator = /* @__PURE__ */ new Map();
        for (const span of event.spans){
            $7dcb674693d4175c$var$processEndedVercelAiSpan(span);
            $ltJYC.accumulateTokensForParent(span, tokenAccumulator);
        }
        $ltJYC.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
        const trace = event.contexts?.trace;
        if (trace?.op === "gen_ai.invoke_agent") $ltJYC.applyAccumulatedTokens(trace, tokenAccumulator);
    }
    return event;
}
function $7dcb674693d4175c$var$normalizeFinishReason(finishReason) {
    if (typeof finishReason !== "string") return "stop";
    switch(finishReason){
        case "tool-calls":
            return "tool_call";
        case "stop":
        case "length":
        case "content_filter":
        case "error":
            return finishReason;
        default:
            return finishReason;
    }
}
function $7dcb674693d4175c$var$buildOutputMessages(attributes) {
    const responseText = attributes[$3dAhG.AI_RESPONSE_TEXT_ATTRIBUTE];
    const responseToolCalls = attributes[$3dAhG.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
    const finishReason = attributes[$3dAhG.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
    if (responseText == null && responseToolCalls == null) return;
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (responseToolCalls != null) try {
        const toolCalls = typeof responseToolCalls === "string" ? JSON.parse(responseToolCalls) : responseToolCalls;
        if (Array.isArray(toolCalls)) {
            for (const toolCall of toolCalls){
                const args = toolCall.input ?? toolCall.args;
                parts.push({
                    type: "tool_call",
                    id: toolCall.toolCallId,
                    name: toolCall.toolName,
                    // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
                    // which would cause the property to be omitted from the final JSON output
                    arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
                });
            }
            delete attributes[$3dAhG.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
        }
    } catch  {}
    if (parts.length > 0) {
        const outputMessage = {
            role: "assistant",
            parts: parts,
            finish_reason: $7dcb674693d4175c$var$normalizeFinishReason(finishReason)
        };
        attributes[$d6car.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([
            outputMessage
        ]);
        delete attributes[$3dAhG.AI_RESPONSE_TEXT_ATTRIBUTE];
    }
}
function $7dcb674693d4175c$var$processVercelAiSpanAttributes(attributes) {
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, $d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, $d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, $d6car.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
    $7dcb674693d4175c$var$renameAttributeKey(attributes, "ai.usage.inputTokens", $d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $7dcb674693d4175c$var$renameAttributeKey(attributes, "ai.usage.outputTokens", $d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_USAGE_TOKENS_ATTRIBUTE, $d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $7dcb674693d4175c$var$renameAttributeKey(attributes, "ai.response.avgOutputTokensPerSecond", "ai.response.avgCompletionTokensPerSecond");
    const inputTokensAreCacheInclusive = Object.keys(attributes).some((key)=>key.startsWith($3dAhG.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX));
    if (!inputTokensAreCacheInclusive && typeof attributes[$d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number" && typeof attributes[$d6car.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === "number") attributes[$d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[$d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[$d6car.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
    if (typeof attributes[$d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number") {
        const outputTokens = typeof attributes[$d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === "number" ? attributes[$d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
        attributes[$d6car.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[$d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    }
    if (attributes[$3dAhG.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$3dAhG.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[$3dAhG.AI_PROMPT_TOOLS_ATTRIBUTE] = $ltJYC.convertAvailableToolsToJsonString(attributes[$3dAhG.AI_PROMPT_TOOLS_ATTRIBUTE]);
    if (attributes[$3dAhG.OPERATION_NAME_ATTRIBUTE]) {
        const rawOperationName = attributes[$3dAhG.AI_OPERATION_ID_ATTRIBUTE] ? attributes[$3dAhG.AI_OPERATION_ID_ATTRIBUTE] : attributes[$3dAhG.OPERATION_NAME_ATTRIBUTE];
        const operationName = $bSxUW.SPAN_TO_OPERATION_NAME.get(rawOperationName) ?? rawOperationName;
        attributes[$d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
        delete attributes[$3dAhG.OPERATION_NAME_ATTRIBUTE];
    }
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_PROMPT_MESSAGES_ATTRIBUTE, $d6car.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
    $7dcb674693d4175c$var$buildOutputMessages(attributes);
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_RESPONSE_OBJECT_ATTRIBUTE, "gen_ai.response.object");
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_PROMPT_TOOLS_ATTRIBUTE, "gen_ai.request.available_tools");
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_TOOL_CALL_ARGS_ATTRIBUTE, $d6car.GEN_AI_TOOL_INPUT_ATTRIBUTE);
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_TOOL_CALL_RESULT_ATTRIBUTE, $d6car.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_SCHEMA_ATTRIBUTE, "gen_ai.request.schema");
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_MODEL_ID_ATTRIBUTE, $d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
    if (Array.isArray(attributes[$3dAhG.AI_VALUES_ATTRIBUTE])) {
        const parsed = attributes[$3dAhG.AI_VALUES_ATTRIBUTE].map((v)=>{
            try {
                return JSON.parse(v);
            } catch  {
                return v;
            }
        });
        attributes[$d6car.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
    }
    $7dcb674693d4175c$var$addProviderMetadataToAttributes(attributes);
    for (const key of Object.keys(attributes)){
        if (Array.isArray(attributes[key])) attributes[key] = JSON.stringify(attributes[key]);
        if (key.startsWith("ai.")) $7dcb674693d4175c$var$renameAttributeKey(attributes, key, `vercel.${key}`);
    }
}
function $7dcb674693d4175c$var$processEndedVercelAiSpan(span) {
    const { data: attributes, origin: origin } = span;
    if (origin !== "auto.vercelai.otel") return;
    if (span.status && span.status !== "ok") span.status = "internal_error";
    $7dcb674693d4175c$var$processVercelAiSpanAttributes(attributes);
}
function $7dcb674693d4175c$var$processVercelAiStreamedSpan(span) {
    const attributes = span.attributes;
    if (attributes?.[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] !== "auto.vercelai.otel") return;
    $7dcb674693d4175c$var$processVercelAiSpanAttributes(attributes);
    if (attributes[$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "gen_ai.execute_tool" && span.parent_span_id) {
        const descriptions = $bSxUW.toolDescriptionMap.get(span.parent_span_id);
        if (descriptions) {
            const toolName = attributes[$d6car.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const desc = descriptions.get(toolName);
                if (desc) attributes[$d6car.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
            }
        }
    }
    $bSxUW.toolDescriptionMap.delete(span.span_id);
}
function $7dcb674693d4175c$var$renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        delete attributes[oldKey];
    }
}
function $7dcb674693d4175c$var$processToolCallSpan(span, attributes) {
    span.setAttribute($k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    span.setAttribute($k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP, "gen_ai.execute_tool");
    span.setAttribute($d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE, "execute_tool");
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_TOOL_CALL_NAME_ATTRIBUTE, $d6car.GEN_AI_TOOL_NAME_ATTRIBUTE);
    $7dcb674693d4175c$var$renameAttributeKey(attributes, $3dAhG.AI_TOOL_CALL_ID_ATTRIBUTE, $d6car.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
    const toolCallId = attributes[$d6car.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
    if (typeof toolCallId === "string") $bSxUW.toolCallSpanContextMap.set(toolCallId, span.spanContext());
    if (!attributes[$d6car.GEN_AI_TOOL_TYPE_ATTRIBUTE]) span.setAttribute($d6car.GEN_AI_TOOL_TYPE_ATTRIBUTE, "function");
    const toolName = attributes[$d6car.GEN_AI_TOOL_NAME_ATTRIBUTE];
    if (toolName) span.updateName(`execute_tool ${toolName}`);
}
function $7dcb674693d4175c$var$processGenerateSpan(span, name, attributes, enableTruncation) {
    span.setAttribute($k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    const nameWthoutAi = name.replace("ai.", "");
    span.setAttribute("ai.pipeline.name", nameWthoutAi);
    span.updateName(nameWthoutAi);
    const functionId = attributes[$3dAhG.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === "string") span.setAttribute("gen_ai.function_id", functionId);
    $ltJYC.requestMessagesFromPrompt(span, attributes, enableTruncation);
    if (attributes[$3dAhG.AI_MODEL_ID_ATTRIBUTE] && !attributes[$d6car.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute($d6car.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[$3dAhG.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute("ai.streaming", name.includes("stream"));
    const operationName = $bSxUW.SPAN_TO_OPERATION_NAME.get(name);
    if (operationName) span.setAttribute($k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
    else if (name.startsWith("ai.stream")) span.setAttribute($k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP, "ai.run");
    if (operationName === "invoke_agent") {
        if (functionId && typeof functionId === "string") span.updateName(`invoke_agent ${functionId}`);
        else span.updateName("invoke_agent");
        return;
    }
    const modelId = attributes[$3dAhG.AI_MODEL_ID_ATTRIBUTE];
    if (modelId && operationName) span.updateName(`${operationName} ${modelId}`);
    const client = $gCYmH.getClient();
    if (client && $wmosz.hasSpanStreamingEnabled(client) && attributes[$3dAhG.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$3dAhG.AI_PROMPT_TOOLS_ATTRIBUTE])) {
        const descriptions = /* @__PURE__ */ new Map();
        for (const toolStr of attributes[$3dAhG.AI_PROMPT_TOOLS_ATTRIBUTE])try {
            const parsed = typeof toolStr === "string" ? JSON.parse(toolStr) : toolStr;
            if (parsed?.name && parsed?.description) descriptions.set(parsed.name, parsed.description);
        } catch  {}
        if (descriptions.size > 0) {
            const parentSpanId = $cp5Iu.spanToJSON(span).parent_span_id;
            if (parentSpanId) $bSxUW.toolDescriptionMap.set(parentSpanId, descriptions);
        }
    }
}
function $7dcb674693d4175c$var$addVercelAiProcessors(client) {
    client.on("spanStart", $7dcb674693d4175c$var$onVercelAiSpanStart);
    client.addEventProcessor(Object.assign($7dcb674693d4175c$var$vercelAiEventProcessor, {
        id: "VercelAiEventProcessor"
    }));
    client.on("processSpan", (span)=>{
        $7dcb674693d4175c$var$processVercelAiStreamedSpan(span);
    });
}
function $7dcb674693d4175c$var$getProviderMetadataAttributes(providerMetadata) {
    const attributes = {};
    if (!providerMetadata || typeof providerMetadata !== "object") return attributes;
    const metadata = providerMetadata;
    const openaiMetadata = metadata.openai ?? metadata.azure;
    if (openaiMetadata) {
        $7dcb674693d4175c$var$setAttributeIfDefined(attributes, $d6car.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, openaiMetadata.cachedPromptTokens);
        $7dcb674693d4175c$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.reasoning", openaiMetadata.reasoningTokens);
        $7dcb674693d4175c$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_accepted", openaiMetadata.acceptedPredictionTokens);
        $7dcb674693d4175c$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_rejected", openaiMetadata.rejectedPredictionTokens);
        $7dcb674693d4175c$var$setAttributeIfDefined(attributes, $d6car.GEN_AI_CONVERSATION_ID_ATTRIBUTE, openaiMetadata.responseId);
    }
    if (metadata.anthropic) {
        const cachedInputTokens = metadata.anthropic.usage?.cache_read_input_tokens ?? metadata.anthropic.cacheReadInputTokens;
        $7dcb674693d4175c$var$setAttributeIfDefined(attributes, $d6car.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
        const cacheWriteInputTokens = metadata.anthropic.usage?.cache_creation_input_tokens ?? metadata.anthropic.cacheCreationInputTokens;
        $7dcb674693d4175c$var$setAttributeIfDefined(attributes, $d6car.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
    }
    if (metadata.bedrock?.usage) {
        $7dcb674693d4175c$var$setAttributeIfDefined(attributes, $d6car.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.bedrock.usage.cacheReadInputTokens);
        $7dcb674693d4175c$var$setAttributeIfDefined(attributes, $d6car.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, metadata.bedrock.usage.cacheWriteInputTokens);
    }
    if (metadata.deepseek) {
        $7dcb674693d4175c$var$setAttributeIfDefined(attributes, $d6car.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.deepseek.promptCacheHitTokens);
        $7dcb674693d4175c$var$setAttributeIfDefined(attributes, "gen_ai.usage.input_tokens.cache_miss", metadata.deepseek.promptCacheMissTokens);
    }
    return attributes;
}
function $7dcb674693d4175c$var$addProviderMetadataToAttributes(attributes) {
    const providerMetadata = attributes[$3dAhG.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (!providerMetadata) return;
    try {
        const derived = $7dcb674693d4175c$var$getProviderMetadataAttributes(JSON.parse(providerMetadata));
        for (const [key, value] of Object.entries(derived)){
            if (key === $d6car.GEN_AI_CONVERSATION_ID_ATTRIBUTE && attributes[key]) continue;
            attributes[key] = value;
        }
    } catch  {}
}
function $7dcb674693d4175c$var$setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}
module.exports.addVercelAiProcessors = $7dcb674693d4175c$var$addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $7dcb674693d4175c$var$getProviderMetadataAttributes;
module.exports.processVercelAiSpanAttributes = $7dcb674693d4175c$var$processVercelAiSpanAttributes;

});
parcelRegister("7GCmi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2cngX = parcelRequire("2cngX");

var $gCYmH = parcelRequire("gCYmH");

var $wmosz = parcelRequire("wmosz");

var $c34Je = parcelRequire("c34Je");

var $d6car = parcelRequire("d6car");

var $6dzcX = parcelRequire("6dzcX");
function $598a35dbaeab4270$var$resolveAIRecordingOptions(options) {
    const genAI = $gCYmH.getClient()?.getDataCollectionOptions().genAI;
    return {
        ...options,
        recordInputs: options?.recordInputs ?? genAI?.inputs ?? false,
        recordOutputs: options?.recordOutputs ?? genAI?.outputs ?? false
    };
}
function $598a35dbaeab4270$var$shouldEnableTruncation(enableTruncation) {
    if (enableTruncation !== void 0) return enableTruncation;
    const client = $gCYmH.getClient();
    if (!client) return true;
    return !$wmosz.hasSpanStreamingEnabled(client) && client.getOptions().streamGenAiSpans === false;
}
function $598a35dbaeab4270$var$buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
function $598a35dbaeab4270$var$setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== void 0) span.setAttributes({
        [$d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: promptTokens
    });
    if (completionTokens !== void 0) span.setAttributes({
        [$d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: completionTokens
    });
    if (promptTokens !== void 0 || completionTokens !== void 0 || cachedInputTokens !== void 0 || cachedOutputTokens !== void 0) {
        const totalTokens = (promptTokens ?? 0) + (completionTokens ?? 0) + (cachedInputTokens ?? 0) + (cachedOutputTokens ?? 0);
        span.setAttributes({
            [$d6car.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: totalTokens
        });
    }
}
function $598a35dbaeab4270$var$endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [$d6car.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
    };
    if (state.responseId) attrs[$d6car.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[$d6car.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    if (state.promptTokens !== void 0) attrs[$d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
    if (state.completionTokens !== void 0) attrs[$d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
    if (state.totalTokens !== void 0) attrs[$d6car.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
    else if (state.promptTokens !== void 0 || state.completionTokens !== void 0 || state.cacheCreationInputTokens !== void 0 || state.cacheReadInputTokens !== void 0) attrs[$d6car.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (state.promptTokens ?? 0) + (state.completionTokens ?? 0) + (state.cacheCreationInputTokens ?? 0) + (state.cacheReadInputTokens ?? 0);
    if (state.finishReasons.length) attrs[$d6car.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[$d6car.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join("");
    if (recordOutputs && state.toolCalls.length) attrs[$d6car.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
function $598a35dbaeab4270$var$getJsonString(value) {
    if (typeof value === "string") return value;
    return JSON.stringify(value);
}
function $598a35dbaeab4270$var$getTruncatedJsonString(value) {
    if (typeof value === "string") return $6dzcX.truncateGenAiStringInput(value);
    if (Array.isArray(value)) {
        const truncatedMessages = $6dzcX.truncateGenAiMessages(value);
        return JSON.stringify(truncatedMessages);
    }
    return JSON.stringify(value);
}
function $598a35dbaeab4270$var$extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === "object" && "role" in msg && msg.role === "system");
    if (systemMessageIndex === -1) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === "string" ? systemMessage.content : systemMessage.content !== void 0 ? JSON.stringify(systemMessage.content) : void 0;
    if (!systemContent) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: "text",
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}
async function $598a35dbaeab4270$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType) {
    const safeOriginalWithResponse = originalWithResponse.catch((error)=>{
        $2cngX.captureException(error, {
            mechanism: {
                handled: false,
                type: mechanismType
            }
        });
        throw error;
    });
    const instrumentedResult = await instrumentedPromise;
    const originalWrapper = await safeOriginalWithResponse;
    if (originalWrapper && typeof originalWrapper === "object" && "data" in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
function $598a35dbaeab4270$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise, mechanismType) {
    if (!$c34Je.isThenable(originalPromiseLike)) return instrumentedPromise;
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            if (prop === "withResponse" && typeof value === "function") return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $598a35dbaeab4270$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType);
            };
            return typeof value === "function" ? value.bind(source) : value;
        }
    });
}
module.exports.buildMethodPath = $598a35dbaeab4270$var$buildMethodPath;
module.exports.endStreamSpan = $598a35dbaeab4270$var$endStreamSpan;
module.exports.extractSystemInstructions = $598a35dbaeab4270$var$extractSystemInstructions;
module.exports.getJsonString = $598a35dbaeab4270$var$getJsonString;
module.exports.getTruncatedJsonString = $598a35dbaeab4270$var$getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $598a35dbaeab4270$var$resolveAIRecordingOptions;
module.exports.setTokenUsageAttributes = $598a35dbaeab4270$var$setTokenUsageAttributes;
module.exports.shouldEnableTruncation = $598a35dbaeab4270$var$shouldEnableTruncation;
module.exports.wrapPromiseWithMethods = $598a35dbaeab4270$var$wrapPromiseWithMethods;

});
parcelRegister("d6car", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $98954616923abd69$var$GEN_AI_PROMPT_ATTRIBUTE = "gen_ai.prompt";
const $98954616923abd69$var$GEN_AI_SYSTEM_ATTRIBUTE = "gen_ai.system";
const $98954616923abd69$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE = "gen_ai.request.model";
const $98954616923abd69$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE = "gen_ai.request.stream";
const $98954616923abd69$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = "gen_ai.request.temperature";
const $98954616923abd69$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = "gen_ai.request.max_tokens";
const $98954616923abd69$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = "gen_ai.request.frequency_penalty";
const $98954616923abd69$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = "gen_ai.request.presence_penalty";
const $98954616923abd69$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE = "gen_ai.request.top_p";
const $98954616923abd69$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE = "gen_ai.request.top_k";
const $98954616923abd69$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = "gen_ai.request.encoding_format";
const $98954616923abd69$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = "gen_ai.request.dimensions";
const $98954616923abd69$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = "gen_ai.response.finish_reasons";
const $98954616923abd69$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE = "gen_ai.response.model";
const $98954616923abd69$var$GEN_AI_RESPONSE_ID_ATTRIBUTE = "gen_ai.response.id";
const $98954616923abd69$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = "gen_ai.response.stop_reason";
const $98954616923abd69$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.input_tokens";
const $98954616923abd69$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.output_tokens";
const $98954616923abd69$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = "gen_ai.usage.total_tokens";
const $98954616923abd69$var$GEN_AI_OPERATION_NAME_ATTRIBUTE = "gen_ai.operation.name";
const $98954616923abd69$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = "sentry.sdk_meta.gen_ai.input.messages.original_length";
const $98954616923abd69$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE = "gen_ai.input.messages";
const $98954616923abd69$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = "gen_ai.output.messages";
const $98954616923abd69$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = "gen_ai.system_instructions";
const $98954616923abd69$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE = "gen_ai.response.text";
const $98954616923abd69$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = "gen_ai.request.available_tools";
const $98954616923abd69$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = "gen_ai.response.streaming";
const $98954616923abd69$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "gen_ai.response.tool_calls";
const $98954616923abd69$var$GEN_AI_AGENT_NAME_ATTRIBUTE = "gen_ai.agent.name";
const $98954616923abd69$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE = "gen_ai.pipeline.name";
const $98954616923abd69$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
const $98954616923abd69$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_creation_input_tokens";
const $98954616923abd69$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_read_input_tokens";
const $98954616923abd69$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = "gen_ai.usage.input_tokens.cache_write";
const $98954616923abd69$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = "gen_ai.usage.input_tokens.cached";
const $98954616923abd69$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = "gen_ai.invoke_agent";
const $98954616923abd69$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = "gen_ai.embeddings.input";
const $98954616923abd69$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = "gen_ai.embeddings";
const $98954616923abd69$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = "gen_ai.execute_tool";
const $98954616923abd69$var$GEN_AI_TOOL_NAME_ATTRIBUTE = "gen_ai.tool.name";
const $98954616923abd69$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE = "gen_ai.tool.call.id";
const $98954616923abd69$var$GEN_AI_TOOL_TYPE_ATTRIBUTE = "gen_ai.tool.type";
const $98954616923abd69$var$GEN_AI_TOOL_INPUT_ATTRIBUTE = "gen_ai.tool.input";
const $98954616923abd69$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE = "gen_ai.tool.output";
const $98954616923abd69$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = "gen_ai.tool.description";
module.exports.GEN_AI_AGENT_NAME_ATTRIBUTE = $98954616923abd69$var$GEN_AI_AGENT_NAME_ATTRIBUTE;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $98954616923abd69$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = $98954616923abd69$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = $98954616923abd69$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = $98954616923abd69$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = $98954616923abd69$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $98954616923abd69$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = $98954616923abd69$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = $98954616923abd69$var$GEN_AI_OPERATION_NAME_ATTRIBUTE;
module.exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = $98954616923abd69$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = $98954616923abd69$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE;
module.exports.GEN_AI_PROMPT_ATTRIBUTE = $98954616923abd69$var$GEN_AI_PROMPT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = $98954616923abd69$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = $98954616923abd69$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = $98954616923abd69$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = $98954616923abd69$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = $98954616923abd69$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $98954616923abd69$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = $98954616923abd69$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = $98954616923abd69$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = $98954616923abd69$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = $98954616923abd69$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = $98954616923abd69$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = $98954616923abd69$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = $98954616923abd69$var$GEN_AI_RESPONSE_ID_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = $98954616923abd69$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = $98954616923abd69$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = $98954616923abd69$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = $98954616923abd69$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $98954616923abd69$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_ATTRIBUTE = $98954616923abd69$var$GEN_AI_SYSTEM_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $98954616923abd69$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = $98954616923abd69$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = $98954616923abd69$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
module.exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = $98954616923abd69$var$GEN_AI_TOOL_INPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_NAME_ATTRIBUTE = $98954616923abd69$var$GEN_AI_TOOL_NAME_ATTRIBUTE;
module.exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = $98954616923abd69$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = $98954616923abd69$var$GEN_AI_TOOL_TYPE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = $98954616923abd69$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = $98954616923abd69$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = $98954616923abd69$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = $98954616923abd69$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = $98954616923abd69$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = $98954616923abd69$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = $98954616923abd69$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;

});

parcelRegister("6dzcX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4Sb4S = parcelRequire("4Sb4S");
const $486f448e360e59da$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 2e4;
const $486f448e360e59da$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
const $486f448e360e59da$var$jsonBytes = (value)=>{
    return $486f448e360e59da$var$utf8Bytes(JSON.stringify(value));
};
function $486f448e360e59da$var$truncateTextByBytes(text, maxBytes) {
    if ($486f448e360e59da$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = "";
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $486f448e360e59da$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
function $486f448e360e59da$var$getItemText(item) {
    if (typeof item === "string") return item;
    if ("text" in item && typeof item.text === "string") return item.text;
    return "";
}
function $486f448e360e59da$var$withItemText(item, text) {
    if (typeof item === "string") return text;
    return {
        ...item,
        text: text
    };
}
function $486f448e360e59da$var$isContentMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && typeof message.content === "string";
}
function $486f448e360e59da$var$isContentArrayMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && Array.isArray(message.content);
}
function $486f448e360e59da$var$isPartsMessage(message) {
    return message !== null && typeof message === "object" && "parts" in message && Array.isArray(message.parts) && message.parts.length > 0;
}
function $486f448e360e59da$var$truncateContentMessage(message, maxBytes) {
    const emptyMessage = {
        ...message,
        content: ""
    };
    const overhead = $486f448e360e59da$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $486f448e360e59da$var$truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
function $486f448e360e59da$var$getArrayItems(message) {
    if ("parts" in message && Array.isArray(message.parts)) return {
        key: "parts",
        items: message.parts
    };
    if ("content" in message && Array.isArray(message.content)) return {
        key: "content",
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
function $486f448e360e59da$var$truncateArrayMessage(message, maxBytes) {
    const { key: key, items: items } = $486f448e360e59da$var$getArrayItems(message);
    if (key === null || items.length === 0) return [];
    const emptyItems = items.map((item)=>$486f448e360e59da$var$withItemText(item, ""));
    const overhead = $486f448e360e59da$var$jsonBytes({
        ...message,
        [key]: emptyItems
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    const includedItems = [];
    for (const item of items){
        const text = $486f448e360e59da$var$getItemText(item);
        const textSize = $486f448e360e59da$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            const truncated = $486f448e360e59da$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push($486f448e360e59da$var$withItemText(item, truncated));
            break;
        } else break;
    }
    if (includedItems.length <= 0) return [];
    else return [
        {
            ...message,
            [key]: includedItems
        }
    ];
}
function $486f448e360e59da$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    if (typeof message === "string") {
        const truncated = $486f448e360e59da$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== "object") return [];
    if ($486f448e360e59da$var$isContentMessage(message)) return $486f448e360e59da$var$truncateContentMessage(message, maxBytes);
    if ($486f448e360e59da$var$isContentArrayMessage(message) || $486f448e360e59da$var$isPartsMessage(message)) return $486f448e360e59da$var$truncateArrayMessage(message, maxBytes);
    return [];
}
function $486f448e360e59da$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = void 0;
        if (!!message && typeof message === "object") {
            if ($486f448e360e59da$var$isContentArrayMessage(message)) newMessage = {
                ...message,
                content: $486f448e360e59da$var$stripInlineMediaFromMessages(message.content)
            };
            else if ("content" in message && $4Sb4S.isContentMedia(message.content)) newMessage = {
                ...message,
                content: $4Sb4S.stripInlineMediaFromSingleMessage(message.content)
            };
            if ($486f448e360e59da$var$isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: $486f448e360e59da$var$stripInlineMediaFromMessages(message.parts)
            };
            if ($4Sb4S.isContentMedia(newMessage)) newMessage = $4Sb4S.stripInlineMediaFromSingleMessage(newMessage);
            else if ($4Sb4S.isContentMedia(message)) newMessage = $4Sb4S.stripInlineMediaFromSingleMessage(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
function $486f448e360e59da$var$truncateMessagesByBytes(messages, maxBytes) {
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    const effectiveMaxBytes = maxBytes - 2;
    const lastMessage = messages[messages.length - 1];
    const stripped = $486f448e360e59da$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    const messageBytes = $486f448e360e59da$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    return $486f448e360e59da$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
function $486f448e360e59da$var$truncateGenAiMessages(messages) {
    return $486f448e360e59da$var$truncateMessagesByBytes(messages, $486f448e360e59da$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
function $486f448e360e59da$var$truncateGenAiStringInput(input) {
    return $486f448e360e59da$var$truncateTextByBytes(input, $486f448e360e59da$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
module.exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = $486f448e360e59da$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
module.exports.truncateGenAiMessages = $486f448e360e59da$var$truncateGenAiMessages;
module.exports.truncateGenAiStringInput = $486f448e360e59da$var$truncateGenAiStringInput;

});
parcelRegister("4Sb4S", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $38c4cc5df3693051$var$isContentMedia(part) {
    if (!part || typeof part !== "object") return false;
    return $38c4cc5df3693051$var$isContentMediaSource(part) || $38c4cc5df3693051$var$hasInlineData(part) || $38c4cc5df3693051$var$hasImageUrl(part) || $38c4cc5df3693051$var$hasInputAudio(part) || $38c4cc5df3693051$var$hasFileData(part) || $38c4cc5df3693051$var$hasMediaTypeData(part) || $38c4cc5df3693051$var$hasVercelFileData(part) || $38c4cc5df3693051$var$hasVercelImageData(part) || $38c4cc5df3693051$var$hasBlobOrBase64Type(part) || $38c4cc5df3693051$var$hasB64Json(part) || $38c4cc5df3693051$var$hasImageGenerationResult(part) || $38c4cc5df3693051$var$hasDataUri(part);
}
function $38c4cc5df3693051$var$hasImageUrl(part) {
    if (!("image_url" in part)) return false;
    if (typeof part.image_url === "string") return part.image_url.startsWith("data:");
    return $38c4cc5df3693051$var$hasNestedImageUrl(part);
}
function $38c4cc5df3693051$var$hasNestedImageUrl(part) {
    return "image_url" in part && !!part.image_url && typeof part.image_url === "object" && "url" in part.image_url && typeof part.image_url.url === "string" && part.image_url.url.startsWith("data:");
}
function $38c4cc5df3693051$var$isContentMediaSource(part) {
    return "type" in part && typeof part.type === "string" && "source" in part && $38c4cc5df3693051$var$isContentMedia(part.source);
}
function $38c4cc5df3693051$var$hasInlineData(part) {
    return "inlineData" in part && !!part.inlineData && typeof part.inlineData === "object" && "data" in part.inlineData && typeof part.inlineData.data === "string";
}
function $38c4cc5df3693051$var$hasInputAudio(part) {
    return "type" in part && part.type === "input_audio" && "input_audio" in part && !!part.input_audio && typeof part.input_audio === "object" && "data" in part.input_audio && typeof part.input_audio.data === "string";
}
function $38c4cc5df3693051$var$hasFileData(part) {
    return "type" in part && part.type === "file" && "file" in part && !!part.file && typeof part.file === "object" && "file_data" in part.file && typeof part.file.file_data === "string";
}
function $38c4cc5df3693051$var$hasMediaTypeData(part) {
    return "media_type" in part && typeof part.media_type === "string" && "data" in part;
}
function $38c4cc5df3693051$var$hasVercelFileData(part) {
    return "type" in part && part.type === "file" && "mediaType" in part && typeof part.mediaType === "string" && "data" in part && typeof part.data === "string" && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith("http://") && !part.data.startsWith("https://");
}
function $38c4cc5df3693051$var$hasVercelImageData(part) {
    return "type" in part && part.type === "image" && "image" in part && typeof part.image === "string" && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith("http://") && !part.image.startsWith("https://");
}
function $38c4cc5df3693051$var$hasBlobOrBase64Type(part) {
    return "type" in part && (part.type === "blob" || part.type === "base64");
}
function $38c4cc5df3693051$var$hasB64Json(part) {
    return "b64_json" in part;
}
function $38c4cc5df3693051$var$hasImageGenerationResult(part) {
    return "type" in part && "result" in part && part.type === "image_generation";
}
function $38c4cc5df3693051$var$hasDataUri(part) {
    return "uri" in part && typeof part.uri === "string" && part.uri.startsWith("data:");
}
const $38c4cc5df3693051$var$REMOVED_STRING = "[Blob substitute]";
const $38c4cc5df3693051$var$MEDIA_FIELDS = [
    "image_url",
    "data",
    "content",
    "b64_json",
    "result",
    "uri",
    "image"
];
function $38c4cc5df3693051$var$stripInlineMediaFromSingleMessage(part) {
    const strip = {
        ...part
    };
    if ($38c4cc5df3693051$var$isContentMedia(strip.source)) strip.source = $38c4cc5df3693051$var$stripInlineMediaFromSingleMessage(strip.source);
    if ($38c4cc5df3693051$var$hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: $38c4cc5df3693051$var$REMOVED_STRING
    };
    if ($38c4cc5df3693051$var$hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: $38c4cc5df3693051$var$REMOVED_STRING
    };
    if ($38c4cc5df3693051$var$hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: $38c4cc5df3693051$var$REMOVED_STRING
    };
    if ($38c4cc5df3693051$var$hasFileData(part)) strip.file = {
        ...part.file,
        file_data: $38c4cc5df3693051$var$REMOVED_STRING
    };
    for (const field of $38c4cc5df3693051$var$MEDIA_FIELDS)if (typeof strip[field] === "string") strip[field] = $38c4cc5df3693051$var$REMOVED_STRING;
    return strip;
}
module.exports.isContentMedia = $38c4cc5df3693051$var$isContentMedia;
module.exports.stripInlineMediaFromSingleMessage = $38c4cc5df3693051$var$stripInlineMediaFromSingleMessage;

});



parcelRegister("bSxUW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $8a5f0c226edc97bd$var$toolCallSpanContextMap = /* @__PURE__ */ new Map();
const $8a5f0c226edc97bd$var$toolDescriptionMap = /* @__PURE__ */ new Map();
const $8a5f0c226edc97bd$var$SPAN_TO_OPERATION_NAME = /* @__PURE__ */ new Map([
    [
        "ai.generateText",
        "invoke_agent"
    ],
    [
        "ai.streamText",
        "invoke_agent"
    ],
    [
        "ai.generateObject",
        "invoke_agent"
    ],
    [
        "ai.streamObject",
        "invoke_agent"
    ],
    [
        "ai.generateText.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamText.doStream",
        "generate_content"
    ],
    [
        "ai.generateObject.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamObject.doStream",
        "generate_content"
    ],
    [
        "ai.embed.doEmbed",
        "embeddings"
    ],
    [
        "ai.embedMany.doEmbed",
        "embeddings"
    ],
    [
        "ai.rerank.doRerank",
        "rerank"
    ],
    [
        "ai.toolCall",
        "execute_tool"
    ]
]);
module.exports.SPAN_TO_OPERATION_NAME = $8a5f0c226edc97bd$var$SPAN_TO_OPERATION_NAME;
module.exports.toolCallSpanContextMap = $8a5f0c226edc97bd$var$toolCallSpanContextMap;
module.exports.toolDescriptionMap = $8a5f0c226edc97bd$var$toolDescriptionMap;

});

parcelRegister("ltJYC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d6car = parcelRequire("d6car");

var $7GCmi = parcelRequire("7GCmi");

var $bSxUW = parcelRequire("bSxUW");

var $3dAhG = parcelRequire("3dAhG");
function $fa2ff868e0aa0736$var$accumulateTokensForParent(span, tokenAccumulator) {
    const parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    const inputTokens = span.data[$d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    const outputTokens = span.data[$d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === "number" || typeof outputTokens === "number") {
        const existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === "number") existing.inputTokens += inputTokens;
        if (typeof outputTokens === "number") existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
function $fa2ff868e0aa0736$var$applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[$d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[$d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data["gen_ai.usage.total_tokens"] = accumulated.inputTokens + accumulated.outputTokens;
}
function $fa2ff868e0aa0736$var$buildToolDescriptionMap(spans) {
    const toolDescriptions = /* @__PURE__ */ new Map();
    for (const span of spans){
        const availableTools = span.data[$d6car.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
        if (typeof availableTools !== "string") continue;
        try {
            const tools = JSON.parse(availableTools);
            for (const tool of tools)if (tool.name && tool.description && !toolDescriptions.has(tool.name)) toolDescriptions.set(tool.name, tool.description);
        } catch  {}
    }
    return toolDescriptions;
}
function $fa2ff868e0aa0736$var$applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
    const toolDescriptions = $fa2ff868e0aa0736$var$buildToolDescriptionMap(spans);
    for (const span of spans){
        if (span.op === "gen_ai.execute_tool") {
            const toolName = span.data[$d6car.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const description = toolDescriptions.get(toolName);
                if (description) span.data[$d6car.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
            }
        }
        if (span.op === "gen_ai.invoke_agent") $fa2ff868e0aa0736$var$applyAccumulatedTokens(span, tokenAccumulator);
    }
}
function $fa2ff868e0aa0736$var$_INTERNAL_getSpanContextForToolCallId(toolCallId) {
    return $bSxUW.toolCallSpanContextMap.get(toolCallId);
}
function $fa2ff868e0aa0736$var$_INTERNAL_cleanupToolCallSpanContext(toolCallId) {
    $bSxUW.toolCallSpanContextMap.delete(toolCallId);
}
function $fa2ff868e0aa0736$var$convertAvailableToolsToJsonString(tools) {
    const toolObjects = tools.map((tool)=>{
        if (typeof tool === "string") try {
            return JSON.parse(tool);
        } catch  {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}
function $fa2ff868e0aa0736$var$filterMessagesArray(input) {
    return input.filter((m)=>!!m && typeof m === "object" && "role" in m && "content" in m);
}
function $fa2ff868e0aa0736$var$convertUserInputToMessagesFormat(userInput) {
    try {
        const p = JSON.parse(userInput);
        if (!!p && typeof p === "object") {
            let { messages: messages } = p;
            const { prompt: prompt, system: system } = p;
            const result = [];
            if (typeof system === "string") result.push({
                role: "system",
                content: system
            });
            if (typeof messages === "string") try {
                messages = JSON.parse(messages);
            } catch  {}
            if (Array.isArray(messages)) {
                result.push(...$fa2ff868e0aa0736$var$filterMessagesArray(messages));
                return result;
            }
            if (Array.isArray(prompt)) {
                result.push(...$fa2ff868e0aa0736$var$filterMessagesArray(prompt));
                return result;
            }
            if (typeof prompt === "string") result.push({
                role: "user",
                content: prompt
            });
            if (result.length > 0) return result;
        }
    } catch  {}
    return [];
}
function $fa2ff868e0aa0736$var$requestMessagesFromPrompt(span, attributes, enableTruncation) {
    if (typeof attributes[$3dAhG.AI_PROMPT_ATTRIBUTE] === "string" && !attributes[$d6car.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[$3dAhG.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
        const userInput = attributes[$3dAhG.AI_PROMPT_ATTRIBUTE];
        const messages = $fa2ff868e0aa0736$var$convertUserInputToMessagesFormat(userInput);
        if (messages.length) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $7GCmi.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($d6car.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $7GCmi.getTruncatedJsonString(filteredMessages) : $7GCmi.getJsonString(filteredMessages);
            span.setAttributes({
                [$3dAhG.AI_PROMPT_ATTRIBUTE]: messagesJson,
                [$d6car.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$d6car.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } else if (typeof attributes[$3dAhG.AI_PROMPT_MESSAGES_ATTRIBUTE] === "string") {
        const originalMessagesJson = attributes[$3dAhG.AI_PROMPT_MESSAGES_ATTRIBUTE];
        try {
            const messages = JSON.parse(originalMessagesJson);
            if (Array.isArray(messages)) {
                const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $7GCmi.extractSystemInstructions(messages);
                if (systemInstructions) span.setAttribute($d6car.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                const messagesJson = !enableTruncation && filteredMessages === messages ? originalMessagesJson : enableTruncation ? $7GCmi.getTruncatedJsonString(filteredMessages) : $7GCmi.getJsonString(filteredMessages);
                span.setAttributes({
                    [$3dAhG.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$d6car.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$d6car.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                });
            }
        } catch  {}
    }
}
module.exports._INTERNAL_cleanupToolCallSpanContext = $fa2ff868e0aa0736$var$_INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $fa2ff868e0aa0736$var$_INTERNAL_getSpanContextForToolCallId;
module.exports.accumulateTokensForParent = $fa2ff868e0aa0736$var$accumulateTokensForParent;
module.exports.applyAccumulatedTokens = $fa2ff868e0aa0736$var$applyAccumulatedTokens;
module.exports.applyToolDescriptionsAndTokens = $fa2ff868e0aa0736$var$applyToolDescriptionsAndTokens;
module.exports.convertAvailableToolsToJsonString = $fa2ff868e0aa0736$var$convertAvailableToolsToJsonString;
module.exports.convertUserInputToMessagesFormat = $fa2ff868e0aa0736$var$convertUserInputToMessagesFormat;
module.exports.requestMessagesFromPrompt = $fa2ff868e0aa0736$var$requestMessagesFromPrompt;

});
parcelRegister("3dAhG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $257ebb431a17cf08$var$OPERATION_NAME_ATTRIBUTE = "operation.name";
const $257ebb431a17cf08$var$AI_OPERATION_ID_ATTRIBUTE = "ai.operationId";
const $257ebb431a17cf08$var$AI_PROMPT_ATTRIBUTE = "ai.prompt";
const $257ebb431a17cf08$var$AI_SCHEMA_ATTRIBUTE = "ai.schema";
const $257ebb431a17cf08$var$AI_RESPONSE_OBJECT_ATTRIBUTE = "ai.response.object";
const $257ebb431a17cf08$var$AI_VALUES_ATTRIBUTE = "ai.values";
const $257ebb431a17cf08$var$AI_RESPONSE_TEXT_ATTRIBUTE = "ai.response.text";
const $257ebb431a17cf08$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "ai.response.toolCalls";
const $257ebb431a17cf08$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE = "ai.response.finishReason";
const $257ebb431a17cf08$var$AI_PROMPT_MESSAGES_ATTRIBUTE = "ai.prompt.messages";
const $257ebb431a17cf08$var$AI_PROMPT_TOOLS_ATTRIBUTE = "ai.prompt.tools";
const $257ebb431a17cf08$var$AI_MODEL_ID_ATTRIBUTE = "ai.model.id";
const $257ebb431a17cf08$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = "ai.response.providerMetadata";
const $257ebb431a17cf08$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = "ai.usage.cachedInputTokens";
const $257ebb431a17cf08$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = "ai.usage.inputTokenDetails.";
const $257ebb431a17cf08$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = "ai.telemetry.functionId";
const $257ebb431a17cf08$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = "ai.usage.completionTokens";
const $257ebb431a17cf08$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = "ai.usage.promptTokens";
const $257ebb431a17cf08$var$AI_USAGE_TOKENS_ATTRIBUTE = "ai.usage.tokens";
const $257ebb431a17cf08$var$AI_TOOL_CALL_NAME_ATTRIBUTE = "ai.toolCall.name";
const $257ebb431a17cf08$var$AI_TOOL_CALL_ID_ATTRIBUTE = "ai.toolCall.id";
const $257ebb431a17cf08$var$AI_TOOL_CALL_ARGS_ATTRIBUTE = "ai.toolCall.args";
const $257ebb431a17cf08$var$AI_TOOL_CALL_RESULT_ATTRIBUTE = "ai.toolCall.result";
module.exports.AI_MODEL_ID_ATTRIBUTE = $257ebb431a17cf08$var$AI_MODEL_ID_ATTRIBUTE;
module.exports.AI_OPERATION_ID_ATTRIBUTE = $257ebb431a17cf08$var$AI_OPERATION_ID_ATTRIBUTE;
module.exports.AI_PROMPT_ATTRIBUTE = $257ebb431a17cf08$var$AI_PROMPT_ATTRIBUTE;
module.exports.AI_PROMPT_MESSAGES_ATTRIBUTE = $257ebb431a17cf08$var$AI_PROMPT_MESSAGES_ATTRIBUTE;
module.exports.AI_PROMPT_TOOLS_ATTRIBUTE = $257ebb431a17cf08$var$AI_PROMPT_TOOLS_ATTRIBUTE;
module.exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = $257ebb431a17cf08$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
module.exports.AI_RESPONSE_OBJECT_ATTRIBUTE = $257ebb431a17cf08$var$AI_RESPONSE_OBJECT_ATTRIBUTE;
module.exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = $257ebb431a17cf08$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
module.exports.AI_RESPONSE_TEXT_ATTRIBUTE = $257ebb431a17cf08$var$AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $257ebb431a17cf08$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.AI_SCHEMA_ATTRIBUTE = $257ebb431a17cf08$var$AI_SCHEMA_ATTRIBUTE;
module.exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = $257ebb431a17cf08$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = $257ebb431a17cf08$var$AI_TOOL_CALL_ARGS_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ID_ATTRIBUTE = $257ebb431a17cf08$var$AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_NAME_ATTRIBUTE = $257ebb431a17cf08$var$AI_TOOL_CALL_NAME_ATTRIBUTE;
module.exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = $257ebb431a17cf08$var$AI_TOOL_CALL_RESULT_ATTRIBUTE;
module.exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = $257ebb431a17cf08$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = $257ebb431a17cf08$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = $257ebb431a17cf08$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX;
module.exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = $257ebb431a17cf08$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_TOKENS_ATTRIBUTE = $257ebb431a17cf08$var$AI_USAGE_TOKENS_ATTRIBUTE;
module.exports.AI_VALUES_ATTRIBUTE = $257ebb431a17cf08$var$AI_VALUES_ATTRIBUTE;
module.exports.OPERATION_NAME_ATTRIBUTE = $257ebb431a17cf08$var$OPERATION_NAME_ATTRIBUTE;

});



parcelRegister("kaBsx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $2cngX = parcelRequire("2cngX");

var $k6VdG = parcelRequire("k6VdG");

var $99stL = parcelRequire("99stL");

var $3pcOx = parcelRequire("3pcOx");

var $lRCeh = parcelRequire("lRCeh");

var $d6car = parcelRequire("d6car");

var $7GCmi = parcelRequire("7GCmi");

var $krArI = parcelRequire("krArI");

var $9iSq2 = parcelRequire("9iSq2");

var $aUGnO = parcelRequire("aUGnO");
function $eaf1cc791e7a0f0a$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === "object";
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: "web_search_options",
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return void 0;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        $7piqH.DEBUG_BUILD && $99stL.debug.error("Failed to serialize OpenAI tools:", error);
        return void 0;
    }
}
function $eaf1cc791e7a0f0a$var$extractRequestAttributes(args, operationName) {
    const attributes = {
        [$d6car.GEN_AI_SYSTEM_ATTRIBUTE]: "openai",
        [$d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.openai"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        const availableTools = $eaf1cc791e7a0f0a$var$extractAvailableTools(params);
        if (availableTools) attributes[$d6car.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, $aUGnO.extractRequestParameters(params));
    } else attributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $eaf1cc791e7a0f0a$var$addRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings" && "input" in params) {
        const input = params.input;
        if (input == null) return;
        if (typeof input === "string" && input.length === 0) return;
        if (Array.isArray(input) && input.length === 0) return;
        span.setAttribute($d6car.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === "string" ? input : JSON.stringify(input));
        return;
    }
    const src = "input" in params ? params.input : "messages" in params ? params.messages : void 0;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $7GCmi.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($d6car.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
    span.setAttribute($d6car.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $7GCmi.getTruncatedJsonString(filteredMessages) : $7GCmi.getJsonString(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute($d6car.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
    else span.setAttribute($d6car.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
}
function $eaf1cc791e7a0f0a$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || "unknown";
        const requestAttributes = $eaf1cc791e7a0f0a$var$extractRequestAttributes(args, operationName);
        const model = requestAttributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
        const params = args[0];
        const isStreamRequested = params && typeof params === "object" && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult2;
            const instrumentedPromise2 = $lRCeh.startSpanManual(spanConfig, (span)=>{
                originalResult2 = originalMethod.apply(context, args);
                if (options.recordInputs && params) $eaf1cc791e7a0f0a$var$addRequestAttributes(span, params, operationName, $7GCmi.shouldEnableTruncation(options.enableTruncation));
                return (async ()=>{
                    try {
                        const result = await originalResult2;
                        return $9iSq2.instrumentStream(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: $3pcOx.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        $2cngX.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.openai.stream",
                                data: {
                                    function: methodPath
                                }
                            }
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $7GCmi.wrapPromiseWithMethods(originalResult2, instrumentedPromise2, "auto.ai.openai");
        }
        let originalResult;
        const instrumentedPromise = $lRCeh.startSpan(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $eaf1cc791e7a0f0a$var$addRequestAttributes(span, params, operationName, $7GCmi.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                $aUGnO.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            }, (error)=>{
                $2cngX.captureException(error, {
                    mechanism: {
                        handled: false,
                        type: "auto.ai.openai",
                        data: {
                            function: methodPath
                        }
                    }
                });
                throw error;
            });
        });
        return $7GCmi.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.openai");
    };
}
function $eaf1cc791e7a0f0a$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $7GCmi.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $krArI.OPENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $eaf1cc791e7a0f0a$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $eaf1cc791e7a0f0a$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $eaf1cc791e7a0f0a$var$instrumentOpenAiClient(client, options) {
    return $eaf1cc791e7a0f0a$var$createDeepProxy(client, "", $7GCmi.resolveAIRecordingOptions(options));
}
module.exports.instrumentOpenAiClient = $eaf1cc791e7a0f0a$var$instrumentOpenAiClient;

});
parcelRegister("krArI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ee2299a9a6d26ea7$var$OPENAI_INTEGRATION_NAME = "OpenAI";
const $ee2299a9a6d26ea7$var$OPENAI_METHOD_REGISTRY = {
    "responses.create": {
        operation: "chat"
    },
    "chat.completions.create": {
        operation: "chat"
    },
    "embeddings.create": {
        operation: "embeddings"
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    "conversations.create": {
        operation: "chat"
    }
};
const $ee2299a9a6d26ea7$var$RESPONSES_TOOL_CALL_EVENT_TYPES = [
    "response.output_item.added",
    "response.function_call_arguments.delta",
    "response.function_call_arguments.done",
    "response.output_item.done"
];
const $ee2299a9a6d26ea7$var$RESPONSE_EVENT_TYPES = [
    "response.created",
    "response.in_progress",
    "response.failed",
    "response.completed",
    "response.incomplete",
    "response.queued",
    "response.output_text.delta",
    ...$ee2299a9a6d26ea7$var$RESPONSES_TOOL_CALL_EVENT_TYPES
];
module.exports.OPENAI_INTEGRATION_NAME = $ee2299a9a6d26ea7$var$OPENAI_INTEGRATION_NAME;
module.exports.OPENAI_METHOD_REGISTRY = $ee2299a9a6d26ea7$var$OPENAI_METHOD_REGISTRY;
module.exports.RESPONSES_TOOL_CALL_EVENT_TYPES = $ee2299a9a6d26ea7$var$RESPONSES_TOOL_CALL_EVENT_TYPES;
module.exports.RESPONSE_EVENT_TYPES = $ee2299a9a6d26ea7$var$RESPONSE_EVENT_TYPES;

});

parcelRegister("9iSq2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2cngX = parcelRequire("2cngX");

var $3pcOx = parcelRequire("3pcOx");

var $7GCmi = parcelRequire("7GCmi");

var $krArI = parcelRequire("krArI");

var $aUGnO = parcelRequire("aUGnO");
function $6c6001f52c1a3d15$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === void 0 || !toolCall.function) continue;
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ""
            }
        };
        else {
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
function $6c6001f52c1a3d15$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    if (chunk.usage) {
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            if (choice.delta?.tool_calls) $6c6001f52c1a3d15$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
function $6c6001f52c1a3d15$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === "object")) {
        state.eventTypes.push("unknown:non-object");
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: $3pcOx.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $2cngX.captureException(streamEvent, {
            mechanism: {
                handled: false,
                type: "auto.ai.openai.stream-response"
            }
        });
        return;
    }
    if (!("type" in streamEvent)) return;
    const event = streamEvent;
    if (!$krArI.RESPONSE_EVENT_TYPES.includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    if (recordOutputs) {
        if (event.type === "response.output_item.done" && "item" in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === "response.output_text.delta" && "delta" in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ("response" in event) {
        const { response: response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        if (response.usage) {
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
async function* $6c6001f52c1a3d15$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ($aUGnO.isChatCompletionChunk(event)) $6c6001f52c1a3d15$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ($aUGnO.isResponsesApiStreamEvent(event)) $6c6001f52c1a3d15$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        $7GCmi.endStreamSpan(span, {
            ...state,
            toolCalls: allToolCalls
        }, recordOutputs);
    }
}
module.exports.instrumentStream = $6c6001f52c1a3d15$var$instrumentStream;

});
parcelRegister("aUGnO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d6car = parcelRequire("d6car");
function $7f2002bebbabc9cd$var$isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === "object" && "type" in event && typeof event.type === "string" && event.type.startsWith("response.");
}
function $7f2002bebbabc9cd$var$isChatCompletionChunk(event) {
    return event !== null && typeof event === "object" && "object" in event && event.object === "chat.completion.chunk";
}
function $7f2002bebbabc9cd$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object") return;
    const response = result;
    const attrs = {};
    if (typeof response.id === "string") attrs[$d6car.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    if (typeof response.model === "string") attrs[$d6car.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    if (response.object === "conversation" && typeof response.id === "string") attrs[$d6car.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    if (response.usage && typeof response.usage === "object") {
        const usage = response.usage;
        const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
        if (typeof inputTokens === "number") attrs[$d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        const outputTokens = usage.completion_tokens ?? usage.output_tokens;
        if (typeof outputTokens === "number") attrs[$d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === "number") attrs[$d6car.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
    }
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === "string");
        if (finishReasons.length > 0) attrs[$d6car.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return message?.content || "";
            });
            attrs[$d6car.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message?.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[$d6car.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    if (typeof response.status === "string") {
        if (!attrs[$d6car.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[$d6car.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        if (typeof response.output_text === "string" && !attrs[$d6car.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[$d6car.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[$d6car.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>item?.type === "function_call");
            if (functionCalls.length > 0) attrs[$d6car.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
function $7f2002bebbabc9cd$var$extractConversationId(params) {
    if ("conversation" in params && typeof params.conversation === "string") return params.conversation;
    if ("previous_response_id" in params && typeof params.previous_response_id === "string") return params.previous_response_id;
    return void 0;
}
function $7f2002bebbabc9cd$var$extractRequestParameters(params) {
    const attributes = {
        [$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: params.model ?? "unknown"
    };
    if ("temperature" in params) attributes[$d6car.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ("top_p" in params) attributes[$d6car.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ("frequency_penalty" in params) attributes[$d6car.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ("presence_penalty" in params) attributes[$d6car.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ("stream" in params) attributes[$d6car.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ("encoding_format" in params) attributes[$d6car.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ("dimensions" in params) attributes[$d6car.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    const conversationId = $7f2002bebbabc9cd$var$extractConversationId(params);
    if (conversationId) attributes[$d6car.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}
module.exports.addResponseAttributes = $7f2002bebbabc9cd$var$addResponseAttributes;
module.exports.extractRequestParameters = $7f2002bebbabc9cd$var$extractRequestParameters;
module.exports.isChatCompletionChunk = $7f2002bebbabc9cd$var$isChatCompletionChunk;
module.exports.isResponsesApiStreamEvent = $7f2002bebbabc9cd$var$isResponsesApiStreamEvent;

});



parcelRegister("1LKse", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2cngX = parcelRequire("2cngX");

var $k6VdG = parcelRequire("k6VdG");

var $3pcOx = parcelRequire("3pcOx");

var $lRCeh = parcelRequire("lRCeh");

var $d6car = parcelRequire("d6car");

var $7GCmi = parcelRequire("7GCmi");

var $73dnt = parcelRequire("73dnt");

var $estj4 = parcelRequire("estj4");

var $ijaxF = parcelRequire("ijaxF");
function $149e3713aa5ba7c8$var$extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [$d6car.GEN_AI_SYSTEM_ATTRIBUTE]: "anthropic",
        [$d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.anthropic"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[$d6car.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        attributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? "unknown";
        if ("temperature" in params) attributes[$d6car.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ("top_p" in params) attributes[$d6car.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ("stream" in params) attributes[$d6car.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ("top_k" in params) attributes[$d6car.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ("frequency_penalty" in params) attributes[$d6car.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ("max_tokens" in params) attributes[$d6car.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === "models.retrieve" || methodPath === "models.get") attributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $149e3713aa5ba7c8$var$addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = $ijaxF.messagesFromParams(params);
    $ijaxF.setMessagesAttribute(span, messages, enableTruncation);
    if ("prompt" in params) span.setAttributes({
        [$d6car.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt)
    });
}
function $149e3713aa5ba7c8$var$addContentAttributes(span, response) {
    if ("content" in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [$d6car.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item)=>item.text).filter((text)=>!!text).join("")
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === "tool_use" || item.type === "server_tool_use") toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [$d6car.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls)
            });
        }
    }
    if ("completion" in response) span.setAttributes({
        [$d6car.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion
    });
    if ("input_tokens" in response) span.setAttributes({
        [$d6car.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens)
    });
}
function $149e3713aa5ba7c8$var$addMetadataAttributes(span, response) {
    if ("id" in response && "model" in response) {
        span.setAttributes({
            [$d6car.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
            [$d6car.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
        });
        if ("usage" in response && response.usage) $7GCmi.setTokenUsageAttributes(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
function $149e3713aa5ba7c8$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if ("type" in response && response.type === "error") {
        $ijaxF.handleResponseError(span, response);
        return;
    }
    if (recordOutputs) $149e3713aa5ba7c8$var$addContentAttributes(span, response);
    $149e3713aa5ba7c8$var$addMetadataAttributes(span, response);
}
function $149e3713aa5ba7c8$var$handleStreamingError(error, span, methodPath) {
    $2cngX.captureException(error, {
        mechanism: {
            handled: false,
            type: "auto.ai.anthropic",
            data: {
                function: methodPath
            }
        }
    });
    if (span.isRecording()) {
        span.setStatus({
            code: $3pcOx.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        span.end();
    }
    throw error;
}
function $149e3713aa5ba7c8$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = $lRCeh.startSpanManual(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $149e3713aa5ba7c8$var$addPrivateRequestAttributes(span, params, $7GCmi.shouldEnableTruncation(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    return $estj4.instrumentAsyncIterableStream(result, span, options.recordOutputs ?? false);
                } catch (error) {
                    return $149e3713aa5ba7c8$var$handleStreamingError(error, span, methodPath);
                }
            })();
        });
        return $7GCmi.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
    } else return $lRCeh.startSpanManual(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $149e3713aa5ba7c8$var$addPrivateRequestAttributes(span, params, $7GCmi.shouldEnableTruncation(options.enableTruncation));
            const messageStream = target.apply(context, args);
            return $estj4.instrumentMessageStream(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            return $149e3713aa5ba7c8$var$handleStreamingError(error, span, methodPath);
        }
    });
}
function $149e3713aa5ba7c8$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const requestAttributes = $149e3713aa5ba7c8$var$extractRequestAttributes(args, methodPath, operationName);
            const model = requestAttributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            const params = typeof args[0] === "object" ? args[0] : void 0;
            const isStreamRequested = Boolean(params?.stream);
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (isStreamRequested || isStreamingMethod) return $149e3713aa5ba7c8$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = $lRCeh.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(context, args);
                if (options.recordInputs && params) $149e3713aa5ba7c8$var$addPrivateRequestAttributes(span, params, $7GCmi.shouldEnableTruncation(options.enableTruncation));
                return originalResult.then((result)=>{
                    $149e3713aa5ba7c8$var$addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                }, (error)=>{
                    $2cngX.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.anthropic",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    throw error;
                });
            });
            return $7GCmi.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
        }
    });
}
function $149e3713aa5ba7c8$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $7GCmi.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $73dnt.ANTHROPIC_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $149e3713aa5ba7c8$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $149e3713aa5ba7c8$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $149e3713aa5ba7c8$var$instrumentAnthropicAiClient(anthropicAiClient, options) {
    return $149e3713aa5ba7c8$var$createDeepProxy(anthropicAiClient, "", $7GCmi.resolveAIRecordingOptions(options));
}
module.exports.instrumentAnthropicAiClient = $149e3713aa5ba7c8$var$instrumentAnthropicAiClient;

});
parcelRegister("73dnt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $522330b761b38910$var$ANTHROPIC_AI_INTEGRATION_NAME = "Anthropic_AI";
const $522330b761b38910$var$ANTHROPIC_METHOD_REGISTRY = {
    "messages.create": {
        operation: "chat"
    },
    "messages.stream": {
        operation: "chat",
        streaming: true
    },
    "messages.countTokens": {
        operation: "chat"
    },
    "models.get": {
        operation: "models"
    },
    "completions.create": {
        operation: "chat"
    },
    "models.retrieve": {
        operation: "models"
    },
    "beta.messages.create": {
        operation: "chat"
    }
};
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $522330b761b38910$var$ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.ANTHROPIC_METHOD_REGISTRY = $522330b761b38910$var$ANTHROPIC_METHOD_REGISTRY;

});

parcelRegister("estj4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2cngX = parcelRequire("2cngX");

var $3pcOx = parcelRequire("3pcOx");

var $7GCmi = parcelRequire("7GCmi");

var $ijaxF = parcelRequire("ijaxF");
function $a86a69e7e29f2d64$var$isErrorEvent(event, span) {
    if ("type" in event && typeof event.type === "string") {
        if (event.type === "error") {
            span.setStatus({
                code: $3pcOx.SPAN_STATUS_ERROR,
                message: $ijaxF.mapAnthropicErrorToStatusMessage(event.error?.type)
            });
            $2cngX.captureException(event.error, {
                mechanism: {
                    handled: false,
                    type: "auto.ai.anthropic.anthropic_error"
                }
            });
            return true;
        }
    }
    return false;
}
function $a86a69e7e29f2d64$var$handleMessageMetadata(event, state) {
    if (event.type === "message_delta" && event.usage) {
        if ("output_tokens" in event.usage && typeof event.usage.output_tokens === "number") state.completionTokens = event.usage.output_tokens;
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.stop_reason) state.finishReasons.push(message.stop_reason);
        if (message.usage) {
            if (typeof message.usage.input_tokens === "number") state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === "number") state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === "number") state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
function $a86a69e7e29f2d64$var$handleContentBlockStart(event, state) {
    if (event.type !== "content_block_start" || typeof event.index !== "number" || !event.content_block) return;
    if (event.content_block.type === "tool_use" || event.content_block.type === "server_tool_use") state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
function $a86a69e7e29f2d64$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== "content_block_delta" || !event.delta) return;
    if (typeof event.index === "number" && "partial_json" in event.delta && typeof event.delta.partial_json === "string") {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    if (recordOutputs && typeof event.delta.text === "string") state.responseTexts.push(event.delta.text);
}
function $a86a69e7e29f2d64$var$handleContentBlockStop(event, state) {
    if (event.type !== "content_block_stop" || typeof event.index !== "number") return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join("");
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: "tool_use",
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    delete state.activeToolBlocks[event.index];
}
function $a86a69e7e29f2d64$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === "object")) return;
    const isError = $a86a69e7e29f2d64$var$isErrorEvent(event, span);
    if (isError) return;
    $a86a69e7e29f2d64$var$handleMessageMetadata(event, state);
    $a86a69e7e29f2d64$var$handleContentBlockStart(event, state);
    $a86a69e7e29f2d64$var$handleContentBlockDelta(event, state, recordOutputs);
    $a86a69e7e29f2d64$var$handleContentBlockStop(event, state);
}
async function* $a86a69e7e29f2d64$var$instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $a86a69e7e29f2d64$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        $7GCmi.endStreamSpan(span, state, recordOutputs);
    }
}
function $a86a69e7e29f2d64$var$instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on("streamEvent", (event)=>{
        $a86a69e7e29f2d64$var$processEvent(event, state, recordOutputs, span);
    });
    stream.on("message", ()=>{
        $7GCmi.endStreamSpan(span, state, recordOutputs);
    });
    stream.on("error", (error)=>{
        $2cngX.captureException(error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.stream_error"
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: $3pcOx.SPAN_STATUS_ERROR,
                message: "internal_error"
            });
            span.end();
        }
    });
    return stream;
}
module.exports.instrumentAsyncIterableStream = $a86a69e7e29f2d64$var$instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $a86a69e7e29f2d64$var$instrumentMessageStream;

});
parcelRegister("ijaxF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2cngX = parcelRequire("2cngX");

var $3pcOx = parcelRequire("3pcOx");

var $d6car = parcelRequire("d6car");

var $7GCmi = parcelRequire("7GCmi");
function $d5422dc08d2c0d81$var$setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $7GCmi.extractSystemInstructions(messages);
    if (systemInstructions) span.setAttributes({
        [$d6car.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [$d6car.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $7GCmi.getTruncatedJsonString(filteredMessages) : $7GCmi.getJsonString(filteredMessages),
        [$d6car.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
    });
}
const $d5422dc08d2c0d81$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: "invalid_argument",
    authentication_error: "unauthenticated",
    permission_error: "permission_denied",
    not_found_error: "not_found",
    request_too_large: "failed_precondition",
    rate_limit_error: "resource_exhausted",
    api_error: "internal_error",
    overloaded_error: "unavailable"
};
function $d5422dc08d2c0d81$var$mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return "internal_error";
    return $d5422dc08d2c0d81$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || "internal_error";
}
function $d5422dc08d2c0d81$var$handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: $3pcOx.SPAN_STATUS_ERROR,
            message: $d5422dc08d2c0d81$var$mapAnthropicErrorToStatusMessage(response.error.type)
        });
        $2cngX.captureException(response.error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.anthropic_error"
            }
        });
    }
}
function $d5422dc08d2c0d81$var$messagesFromParams(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === "string" ? [
        {
            role: "system",
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : void 0;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}
module.exports.handleResponseError = $d5422dc08d2c0d81$var$handleResponseError;
module.exports.mapAnthropicErrorToStatusMessage = $d5422dc08d2c0d81$var$mapAnthropicErrorToStatusMessage;
module.exports.messagesFromParams = $d5422dc08d2c0d81$var$messagesFromParams;
module.exports.setMessagesAttribute = $d5422dc08d2c0d81$var$setMessagesAttribute;

});



parcelRegister("j4ReY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2cngX = parcelRequire("2cngX");

var $k6VdG = parcelRequire("k6VdG");

var $3pcOx = parcelRequire("3pcOx");

var $lRCeh = parcelRequire("lRCeh");

var $1TQ1B = parcelRequire("1TQ1B");

var $d6car = parcelRequire("d6car");

var $7GCmi = parcelRequire("7GCmi");

var $6D6aY = parcelRequire("6D6aY");

var $c8iaM = parcelRequire("c8iaM");

var $b2FFd = parcelRequire("b2FFd");
function $de37b07ccb7254a1$var$extractModel(params, context) {
    if ("model" in params && typeof params.model === "string") return params.model;
    if (context && typeof context === "object") {
        const contextObj = context;
        if ("model" in contextObj && typeof contextObj.model === "string") return contextObj.model;
        if ("modelVersion" in contextObj && typeof contextObj.modelVersion === "string") return contextObj.modelVersion;
    }
    return "unknown";
}
function $de37b07ccb7254a1$var$extractConfigAttributes(config) {
    const attributes = {};
    if ("temperature" in config && typeof config.temperature === "number") attributes[$d6car.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ("topP" in config && typeof config.topP === "number") attributes[$d6car.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ("topK" in config && typeof config.topK === "number") attributes[$d6car.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ("maxOutputTokens" in config && typeof config.maxOutputTokens === "number") attributes[$d6car.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ("frequencyPenalty" in config && typeof config.frequencyPenalty === "number") attributes[$d6car.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ("presencePenalty" in config && typeof config.presencePenalty === "number") attributes[$d6car.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
function $de37b07ccb7254a1$var$extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [$d6car.GEN_AI_SYSTEM_ATTRIBUTE]: $6D6aY.GOOGLE_GENAI_SYSTEM_NAME,
        [$d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.google_genai"
    };
    if (params) {
        attributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $de37b07ccb7254a1$var$extractModel(params, context);
        if ("config" in params && typeof params.config === "object" && params.config) {
            const config = params.config;
            Object.assign(attributes, $de37b07ccb7254a1$var$extractConfigAttributes(config));
            if ("tools" in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[$d6car.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $de37b07ccb7254a1$var$extractModel({}, context);
    return attributes;
}
function $de37b07ccb7254a1$var$addPrivateRequestAttributes(span, params, isEmbeddings, enableTruncation) {
    if (isEmbeddings) {
        const contents = params.contents;
        if (contents != null) span.setAttribute($d6car.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof contents === "string" ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    if ("config" in params && params.config && typeof params.config === "object" && "systemInstruction" in params.config && params.config.systemInstruction) messages.push(...$b2FFd.contentUnionToMessages(params.config.systemInstruction, "system"));
    if ("history" in params) messages.push(...$b2FFd.contentUnionToMessages(params.history, "user"));
    if ("contents" in params) messages.push(...$b2FFd.contentUnionToMessages(params.contents, "user"));
    if ("message" in params) messages.push(...$b2FFd.contentUnionToMessages(params.message, "user"));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $7GCmi.extractSystemInstructions(messages);
        if (systemInstructions) span.setAttribute($d6car.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [$d6car.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
            [$d6car.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $7GCmi.getTruncatedJsonString(filteredMessages) : $7GCmi.getJsonString(filteredMessages)
        });
    }
}
function $de37b07ccb7254a1$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if (response.modelVersion) span.setAttribute($d6car.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
    if (response.usageMetadata && typeof response.usageMetadata === "object") {
        const usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === "number") span.setAttributes({
            [$d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: usage.promptTokenCount
        });
        if (typeof usage.candidatesTokenCount === "number") span.setAttributes({
            [$d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: usage.candidatesTokenCount
        });
        if (typeof usage.totalTokenCount === "number") span.setAttributes({
            [$d6car.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: usage.totalTokenCount
        });
    }
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === "string" ? part.text : "").filter((text)=>text.length > 0).join("");
            return "";
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [$d6car.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join("")
        });
    }
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [$d6car.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
        });
    }
}
function $de37b07ccb7254a1$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === "embeddings";
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const params = args[0];
            const requestAttributes = $de37b07ccb7254a1$var$extractRequestAttributes(operationName, params, context);
            const model = requestAttributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            if (instrumentedMethod.streaming) return $lRCeh.startSpanManual({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $de37b07ccb7254a1$var$addPrivateRequestAttributes(span, params, isEmbeddings, $7GCmi.shouldEnableTruncation(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return $c8iaM.instrumentStream(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: $3pcOx.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $2cngX.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    span.end();
                    throw error;
                }
            });
            return $lRCeh.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $de37b07ccb7254a1$var$addPrivateRequestAttributes(span, params, isEmbeddings, $7GCmi.shouldEnableTruncation(options.enableTruncation));
                return $1TQ1B.handleCallbackErrors(()=>target.apply(context, args), (error)=>{
                    $2cngX.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, ()=>{}, (result)=>{
                    if (!isEmbeddings) $de37b07ccb7254a1$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
function $de37b07ccb7254a1$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = $7GCmi.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $6D6aY.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) {
                const wrappedMethod = instrumentedMethod.operation ? $de37b07ccb7254a1$var$instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === "object") return $de37b07ccb7254a1$var$createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === "function") return value.bind(t);
            if (value && typeof value === "object") return $de37b07ccb7254a1$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $de37b07ccb7254a1$var$instrumentGoogleGenAIClient(client, options) {
    return $de37b07ccb7254a1$var$createDeepProxy(client, "", $7GCmi.resolveAIRecordingOptions(options));
}
module.exports.extractModel = $de37b07ccb7254a1$var$extractModel;
module.exports.instrumentGoogleGenAIClient = $de37b07ccb7254a1$var$instrumentGoogleGenAIClient;

});
parcelRegister("6D6aY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $4d3b2d05afd0b896$var$GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
const $4d3b2d05afd0b896$var$GOOGLE_GENAI_METHOD_REGISTRY = {
    "models.generateContent": {
        operation: "generate_content"
    },
    "models.generateContentStream": {
        operation: "generate_content",
        streaming: true
    },
    "models.embedContent": {
        operation: "embeddings"
    },
    "chats.create": {
        proxyResultPath: "chat"
    },
    "chat.sendMessage": {
        operation: "chat"
    },
    "chat.sendMessageStream": {
        operation: "chat",
        streaming: true
    }
};
const $4d3b2d05afd0b896$var$GOOGLE_GENAI_SYSTEM_NAME = "google_genai";
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $4d3b2d05afd0b896$var$GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.GOOGLE_GENAI_METHOD_REGISTRY = $4d3b2d05afd0b896$var$GOOGLE_GENAI_METHOD_REGISTRY;
module.exports.GOOGLE_GENAI_SYSTEM_NAME = $4d3b2d05afd0b896$var$GOOGLE_GENAI_SYSTEM_NAME;

});

parcelRegister("c8iaM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2cngX = parcelRequire("2cngX");

var $3pcOx = parcelRequire("3pcOx");

var $7GCmi = parcelRequire("7GCmi");
function $02478dbe961bf1c9$var$isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: $3pcOx.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $2cngX.captureException(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: "auto.ai.google_genai"
            }
        });
        return true;
    }
    return false;
}
function $02478dbe961bf1c9$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === "string") state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === "string") state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === "number") state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === "number") state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === "number") state.totalTokens = usage.totalTokenCount;
    }
}
function $02478dbe961bf1c9$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: "function",
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
function $02478dbe961bf1c9$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $02478dbe961bf1c9$var$isErrorChunk(chunk, span)) return;
    $02478dbe961bf1c9$var$handleResponseMetadata(chunk, state);
    $02478dbe961bf1c9$var$handleCandidateContent(chunk, state, recordOutputs);
}
async function* $02478dbe961bf1c9$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $02478dbe961bf1c9$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        $7GCmi.endStreamSpan(span, state, recordOutputs);
    }
}
module.exports.instrumentStream = $02478dbe961bf1c9$var$instrumentStream;

});

parcelRegister("b2FFd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $80a03326ef09aa7b$var$contentUnionToMessages(content, role = "user") {
    if (typeof content === "string") return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content2)=>$80a03326ef09aa7b$var$contentUnionToMessages(content2, role));
    if (typeof content !== "object" || !content) return [];
    if ("role" in content && typeof content.role === "string") return [
        content
    ];
    if ("parts" in content) return [
        {
            ...content,
            role: role
        }
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}
module.exports.contentUnionToMessages = $80a03326ef09aa7b$var$contentUnionToMessages;

});


parcelRegister("jvme1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2cngX = parcelRequire("2cngX");

var $k6VdG = parcelRequire("k6VdG");

var $3pcOx = parcelRequire("3pcOx");

var $lRCeh = parcelRequire("lRCeh");

var $d6car = parcelRequire("d6car");

var $7GCmi = parcelRequire("7GCmi");

var $1qWJ6 = parcelRequire("1qWJ6");

var $avYn4 = parcelRequire("avYn4");
function $e3322708103b2f92$var$createLangChainCallbackHandler(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = $7GCmi.resolveAIRecordingOptions(options);
    const enableTruncation = $7GCmi.shouldEnableTruncation(options.enableTruncation);
    const spanMap = /* @__PURE__ */ new Map();
    const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_secrets: void 0,
        lc_attributes: void 0,
        lc_aliases: void 0,
        lc_serializable_keys: void 0,
        lc_id: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_kwargs: {},
        name: "SentryCallbackHandler",
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = $avYn4.getInvocationParams(tags);
            const attributes = $avYn4.extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $lRCeh.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$avYn4.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = $avYn4.getInvocationParams(tags);
            const attributes = $avYn4.extractChatModelRequestAttributes(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = $avYn4.extractToolDefinitions(extraParams);
            if (toolDefsJson) attributes[$d6car.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $lRCeh.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$avYn4.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = $avYn4.extractLlmResponseAttributes(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $3pcOx.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $2cngX.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$1qWJ6.LANGCHAIN_ORIGIN}.llm_error_handler`
                }
            });
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const chainName = runName || chain.name || "unknown_chain";
            const attributes = {
                [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.langchain",
                "langchain.chain.name": chainName
            };
            if (recordInputs) attributes["langchain.chain.inputs"] = JSON.stringify(inputs);
            $lRCeh.startSpanManual({
                name: `chain ${chainName}`,
                op: "gen_ai.invoke_agent",
                attributes: {
                    ...attributes,
                    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.invoke_agent"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) span.setAttributes({
                    "langchain.chain.outputs": JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $3pcOx.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $2cngX.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$1qWJ6.LANGCHAIN_ORIGIN}.chain_error_handler`
                }
            });
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const toolName = runName || tool.name || "unknown_tool";
            const attributes = {
                ...$avYn4.getAgentNameFromMetadata(metadata),
                [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $1qWJ6.LANGCHAIN_ORIGIN,
                [$d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                [$d6car.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
            };
            if (recordInputs) attributes[$d6car.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            $lRCeh.startSpanManual({
                name: `execute_tool ${toolName}`,
                op: "gen_ai.execute_tool",
                attributes: {
                    ...attributes,
                    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.execute_tool"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) {
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === "object" && "content" in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [$d6car.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === "string" ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $3pcOx.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $2cngX.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$1qWJ6.LANGCHAIN_ORIGIN}.tool_error_handler`
                }
            });
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        }
    };
    return handler;
}
module.exports.createLangChainCallbackHandler = $e3322708103b2f92$var$createLangChainCallbackHandler;

});
parcelRegister("1qWJ6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $10b5c6041cb20c30$var$LANGCHAIN_INTEGRATION_NAME = "LangChain";
const $10b5c6041cb20c30$var$LANGCHAIN_ORIGIN = "auto.ai.langchain";
const $10b5c6041cb20c30$var$ROLE_MAP = {
    human: "user",
    ai: "assistant",
    assistant: "assistant",
    system: "system",
    function: "function",
    tool: "tool"
};
module.exports.LANGCHAIN_INTEGRATION_NAME = $10b5c6041cb20c30$var$LANGCHAIN_INTEGRATION_NAME;
module.exports.LANGCHAIN_ORIGIN = $10b5c6041cb20c30$var$LANGCHAIN_ORIGIN;
module.exports.ROLE_MAP = $10b5c6041cb20c30$var$ROLE_MAP;

});

parcelRegister("avYn4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k6VdG = parcelRequire("k6VdG");

var $d6car = parcelRequire("d6car");

var $4Sb4S = parcelRequire("4Sb4S");

var $7GCmi = parcelRequire("7GCmi");

var $1qWJ6 = parcelRequire("1qWJ6");
const $7a7ba117385fd6c6$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
const $7a7ba117385fd6c6$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
function $7a7ba117385fd6c6$var$asString(v) {
    if (typeof v === "string") return v;
    try {
        return JSON.stringify(v);
    } catch  {
        return String(v);
    }
}
function $7a7ba117385fd6c6$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === "object" && $4Sb4S.isContentMedia(part) ? $4Sb4S.stripInlineMediaFromSingleMessage(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return $7a7ba117385fd6c6$var$asString(v);
}
function $7a7ba117385fd6c6$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return $1qWJ6.ROLE_MAP[normalized] ?? normalized;
}
function $7a7ba117385fd6c6$var$normalizeRoleNameFromCtor(name) {
    if (name.includes("System")) return "system";
    if (name.includes("Human")) return "user";
    if (name.includes("AI") || name.includes("Assistant")) return "assistant";
    if (name.includes("Function")) return "function";
    if (name.includes("Tool")) return "tool";
    return "user";
}
function $7a7ba117385fd6c6$var$getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return void 0;
    return tags.invocation_params;
}
function $7a7ba117385fd6c6$var$normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        const maybeGetType = message._getType;
        if (typeof maybeGetType === "function") {
            const messageType = maybeGetType.call(message);
            return {
                role: $7a7ba117385fd6c6$var$normalizeMessageRole(messageType),
                content: $7a7ba117385fd6c6$var$normalizeContent(message.content)
            };
        }
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : "";
            const role = typeof messageType === "string" ? $7a7ba117385fd6c6$var$normalizeRoleNameFromCtor(messageType) : "user";
            return {
                role: $7a7ba117385fd6c6$var$normalizeMessageRole(role),
                content: $7a7ba117385fd6c6$var$normalizeContent(message.kwargs?.content)
            };
        }
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $7a7ba117385fd6c6$var$normalizeMessageRole(role),
                content: $7a7ba117385fd6c6$var$normalizeContent(message.content)
            };
        }
        if (message.role) return {
            role: $7a7ba117385fd6c6$var$normalizeMessageRole(String(message.role)),
            content: $7a7ba117385fd6c6$var$normalizeContent(message.content)
        };
        const ctor = message.constructor?.name;
        if (ctor && ctor !== "Object") return {
            role: $7a7ba117385fd6c6$var$normalizeMessageRole($7a7ba117385fd6c6$var$normalizeRoleNameFromCtor(ctor)),
            content: $7a7ba117385fd6c6$var$normalizeContent(message.content)
        };
        return {
            role: "user",
            content: $7a7ba117385fd6c6$var$normalizeContent(message.content)
        };
    });
}
function $7a7ba117385fd6c6$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    const kwargs = "kwargs" in serialized ? serialized.kwargs : void 0;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
    if (invocationParams && "stream" in invocationParams) $7a7ba117385fd6c6$var$setIfDefined(attrs, $d6car.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
    return attrs;
}
function $7a7ba117385fd6c6$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [$d6car.GEN_AI_SYSTEM_ATTRIBUTE]: $7a7ba117385fd6c6$var$asString(system ?? "langchain"),
        [$d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "chat",
        [$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: $7a7ba117385fd6c6$var$asString(modelName),
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $1qWJ6.LANGCHAIN_ORIGIN,
        ...$7a7ba117385fd6c6$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
function $7a7ba117385fd6c6$var$extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $7a7ba117385fd6c6$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $7a7ba117385fd6c6$var$setIfDefined(attrs, $d6car.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
        const messages = prompts.map((p)=>({
                role: "user",
                content: p
            }));
        $7a7ba117385fd6c6$var$setIfDefined(attrs, $d6car.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $7GCmi.getTruncatedJsonString(messages) : $7GCmi.getJsonString(messages));
    }
    return attrs;
}
function $7a7ba117385fd6c6$var$extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $7a7ba117385fd6c6$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $7a7ba117385fd6c6$var$normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $7GCmi.extractSystemInstructions(normalized);
        if (systemInstructions) $7a7ba117385fd6c6$var$setIfDefined(attrs, $d6car.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $7a7ba117385fd6c6$var$setIfDefined(attrs, $d6car.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
        $7a7ba117385fd6c6$var$setIfDefined(attrs, $d6car.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $7GCmi.getTruncatedJsonString(filteredMessages) : $7GCmi.getJsonString(filteredMessages));
    }
    return attrs;
}
function $7a7ba117385fd6c6$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg?.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            const content = gen.message?.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === "tool_use") toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) $7a7ba117385fd6c6$var$setIfDefined(attrs, $d6car.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, $7a7ba117385fd6c6$var$asString(toolCalls));
}
function $7a7ba117385fd6c6$var$addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, tokenUsage.promptTokens);
        $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, tokenUsage.completionTokens);
        $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.input_tokens);
        $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, anthropicUsage.output_tokens);
        const input = Number(anthropicUsage.input_tokens);
        const output = Number(anthropicUsage.output_tokens);
        const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, total);
        if (anthropicUsage.cache_creation_input_tokens !== void 0) $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== void 0) $7a7ba117385fd6c6$var$setNumberIfDefined(attrs, $d6car.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_read_input_tokens);
    }
}
function $7a7ba117385fd6c6$var$extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === "string");
        if (finishReasons.length > 0) $7a7ba117385fd6c6$var$setIfDefined(attrs, $d6car.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, $7a7ba117385fd6c6$var$asString(finishReasons));
        $7a7ba117385fd6c6$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === "string");
            if (texts.length > 0) $7a7ba117385fd6c6$var$setIfDefined(attrs, $d6car.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, $7a7ba117385fd6c6$var$asString(texts));
        }
    }
    $7a7ba117385fd6c6$var$addTokenUsageAttributes(llmResult.llmOutput, attrs);
    const llmOutput = llmResult.llmOutput;
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) $7a7ba117385fd6c6$var$setIfDefined(attrs, $d6car.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) $7a7ba117385fd6c6$var$setIfDefined(attrs, $d6car.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) $7a7ba117385fd6c6$var$setIfDefined(attrs, $d6car.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, $7a7ba117385fd6c6$var$asString(stopReason));
    return attrs;
}
function $7a7ba117385fd6c6$var$getAgentNameFromMetadata(metadata) {
    const attrs = {};
    const agentName = metadata?.lc_agent_name;
    if (typeof agentName === "string") attrs[$d6car.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function $7a7ba117385fd6c6$var$extractToolDefinitions(extraParams) {
    const tools = extraParams?.invocation_params?.tools ?? extraParams?.options?.tools;
    if (!Array.isArray(tools) || tools.length === 0) return void 0;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        return {
            type: "function",
            name: tool.name ?? fn?.name ?? "",
            description: tool.description ?? fn?.description
        };
    });
    return JSON.stringify(toolDefs);
}
function $7a7ba117385fd6c6$var$isCallbackManager(value) {
    if (!value || typeof value !== "object") return false;
    const candidate = value;
    return typeof candidate.addHandler === "function" && typeof candidate.copy === "function";
}
function $7a7ba117385fd6c6$var$isSentryHandler(handler) {
    return typeof handler === "object" && handler?.name === "SentryCallbackHandler";
}
function $7a7ba117385fd6c6$var$containsSentryHandler(handlers) {
    return handlers.some($7a7ba117385fd6c6$var$isSentryHandler);
}
function $7a7ba117385fd6c6$var$_INTERNAL_mergeLangChainCallbackHandler(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if ($7a7ba117385fd6c6$var$isCallbackManager(existing)) {
        if ($7a7ba117385fd6c6$var$containsSentryHandler(existing.handlers ?? [])) return existing;
        const copied = existing.copy();
        copied.addHandler(sentryHandler, true);
        return copied;
    }
    const handlers = Array.isArray(existing) ? existing : [
        existing
    ];
    if ($7a7ba117385fd6c6$var$containsSentryHandler(handlers)) return existing;
    return [
        ...handlers,
        sentryHandler
    ];
}
module.exports._INTERNAL_mergeLangChainCallbackHandler = $7a7ba117385fd6c6$var$_INTERNAL_mergeLangChainCallbackHandler;
module.exports.extractChatModelRequestAttributes = $7a7ba117385fd6c6$var$extractChatModelRequestAttributes;
module.exports.extractLLMRequestAttributes = $7a7ba117385fd6c6$var$extractLLMRequestAttributes;
module.exports.extractLlmResponseAttributes = $7a7ba117385fd6c6$var$extractLlmResponseAttributes;
module.exports.extractToolDefinitions = $7a7ba117385fd6c6$var$extractToolDefinitions;
module.exports.getAgentNameFromMetadata = $7a7ba117385fd6c6$var$getAgentNameFromMetadata;
module.exports.getInvocationParams = $7a7ba117385fd6c6$var$getInvocationParams;
module.exports.normalizeLangChainMessages = $7a7ba117385fd6c6$var$normalizeLangChainMessages;

});


parcelRegister("eLbXf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2cngX = parcelRequire("2cngX");

var $k6VdG = parcelRequire("k6VdG");

var $3pcOx = parcelRequire("3pcOx");

var $lRCeh = parcelRequire("lRCeh");

var $d6car = parcelRequire("d6car");

var $7GCmi = parcelRequire("7GCmi");

var $jvme1 = parcelRequire("jvme1");

var $avYn4 = parcelRequire("avYn4");

var $5m5Jk = parcelRequire("5m5Jk");

var $66igy = parcelRequire("66igy");
let $abeeba6906ab29c7$var$_insideCreateReactAgent = false;
const $abeeba6906ab29c7$var$SENTRY_PATCHED = "__sentry_patched__";
function $abeeba6906ab29c7$var$instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, $abeeba6906ab29c7$var$SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = $jvme1.createLangChainCallbackHandler(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            if ($abeeba6906ab29c7$var$_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return $lRCeh.startSpan({
                op: "gen_ai.create_agent",
                name: "create_agent",
                attributes: {
                    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $5m5Jk.LANGGRAPH_ORIGIN,
                    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.create_agent",
                    [$d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "create_agent"
                }
            }, (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    if (compileOptions?.name && typeof compileOptions.name === "string") {
                        span.setAttribute($d6car.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === "function") compiledGraph.invoke = $abeeba6906ab29c7$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, void 0, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: $3pcOx.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $2cngX.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, $abeeba6906ab29c7$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $abeeba6906ab29c7$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            const modelName = llm?.modelName ?? llm?.model;
            return $lRCeh.startSpan({
                op: "gen_ai.invoke_agent",
                name: "invoke_agent",
                attributes: {
                    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $5m5Jk.LANGGRAPH_ORIGIN,
                    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $d6car.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
                    [$d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "invoke_agent"
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === "string") {
                        span.setAttribute($d6car.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
                        span.setAttribute($d6car.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute($d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
                    const config = args.length > 1 ? args[1] : void 0;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === "string") span.setAttribute($d6car.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
                    if (sentryCallbackHandler) {
                        const invokeConfig = args[1] ?? {};
                        args[1] = invokeConfig;
                        const existingMetadata = invokeConfig.metadata ?? {};
                        invokeConfig.metadata = {
                            ...existingMetadata,
                            __sentry_langgraph__: true,
                            ...typeof graphName === "string" ? {
                                lc_agent_name: graphName
                            } : {}
                        };
                        invokeConfig.callbacks = $avYn4._INTERNAL_mergeLangChainCallbackHandler(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    const tools = $66igy.extractToolsFromCompiledGraph(graphInstance);
                    if (tools) span.setAttribute($d6car.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = $avYn4.normalizeLangChainMessages(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $7GCmi.extractSystemInstructions(normalizedMessages);
                        if (systemInstructions) span.setAttribute($d6car.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                        const enableTruncation = $7GCmi.shouldEnableTruncation(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [$d6car.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $7GCmi.getTruncatedJsonString(filteredMessages) : $7GCmi.getJsonString(filteredMessages),
                            [$d6car.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                        });
                    }
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) $66igy.setResponseAttributes(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: $3pcOx.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $2cngX.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
}
function $abeeba6906ab29c7$var$instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, $abeeba6906ab29c7$var$SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = $7GCmi.resolveAIRecordingOptions(options);
    const sentryHandler = $jvme1.createLangChainCallbackHandler(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = $66igy.extractLLMFromParams(args);
            const agentName = $66igy.extractAgentNameFromParams(args);
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) $66igy.wrapToolsWithSpans(params.tools, resolvedOptions, agentName ?? void 0);
            $abeeba6906ab29c7$var$_insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                $abeeba6906ab29c7$var$_insideCreateReactAgent = false;
            }
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === "function") {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = $abeeba6906ab29c7$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, $abeeba6906ab29c7$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $abeeba6906ab29c7$var$instrumentLangGraph(stateGraph, options) {
    stateGraph.compile = $abeeba6906ab29c7$var$instrumentStateGraphCompile(stateGraph.compile, $7GCmi.resolveAIRecordingOptions(options));
    return stateGraph;
}
module.exports.instrumentCreateReactAgent = $abeeba6906ab29c7$var$instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $abeeba6906ab29c7$var$instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $abeeba6906ab29c7$var$instrumentStateGraphCompile;

});
parcelRegister("5m5Jk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $3e6373b634191c62$var$LANGGRAPH_INTEGRATION_NAME = "LangGraph";
const $3e6373b634191c62$var$LANGGRAPH_ORIGIN = "auto.ai.langgraph";
module.exports.LANGGRAPH_INTEGRATION_NAME = $3e6373b634191c62$var$LANGGRAPH_INTEGRATION_NAME;
module.exports.LANGGRAPH_ORIGIN = $3e6373b634191c62$var$LANGGRAPH_ORIGIN;

});

parcelRegister("66igy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2cngX = parcelRequire("2cngX");

var $k6VdG = parcelRequire("k6VdG");

var $3pcOx = parcelRequire("3pcOx");

var $lRCeh = parcelRequire("lRCeh");

var $d6car = parcelRequire("d6car");

var $avYn4 = parcelRequire("avYn4");

var $5m5Jk = parcelRequire("5m5Jk");
function $471178dd15659f73$var$extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== "object" || !arg || !("llm" in arg) || !arg.llm || typeof arg.llm !== "object") return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== "string" && typeof llm.model !== "string") return null;
    return llm;
}
function $471178dd15659f73$var$extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === "object" && !!arg && "name" in arg && typeof arg.name === "string") return arg.name;
    return null;
}
function $471178dd15659f73$var$wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = "__sentry_tool_wrapped__";
    for (const tool of tools){
        if (!tool || typeof tool !== "object") continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== "function" || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === "string" ? t.name : "unknown_tool";
        const toolDescription = typeof t.description === "string" ? t.description : void 0;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                const spanAttributes = {
                    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $5m5Jk.LANGGRAPH_ORIGIN,
                    [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $d6car.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    [$d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                    [$d6car.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
                    [$d6car.GEN_AI_TOOL_TYPE_ATTRIBUTE]: "function"
                };
                const callConfig = args[1];
                const callAgentName = callConfig?.metadata?.lc_agent_name ?? agentName;
                if (typeof callAgentName === "string") spanAttributes[$d6car.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[$d6car.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                const input = args[0];
                if (typeof input === "object" && !!input) {
                    if ("id" in input && typeof input.id === "string") spanAttributes[$d6car.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = "args" in input && typeof input.args === "object" ? input.args : input;
                        try {
                            spanAttributes[$d6car.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch  {}
                    }
                }
                return $lRCeh.startSpan({
                    op: $d6car.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === "object" && "content" in resultObj ? resultObj.content : result;
                            span.setAttribute($d6car.GEN_AI_TOOL_OUTPUT_ATTRIBUTE, typeof content === "string" ? content : JSON.stringify(content));
                        } catch  {}
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: $3pcOx.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        $2cngX.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.langgraph.error"
                            }
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
function $471178dd15659f73$var$extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === "object") {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
function $471178dd15659f73$var$extractTokenUsageFromMessage(message) {
    const msg = message;
    let inputTokens = 0;
    let outputTokens = 0;
    let totalTokens = 0;
    if (msg.usage_metadata && typeof msg.usage_metadata === "object") {
        const usage = msg.usage_metadata;
        if (typeof usage.input_tokens === "number") inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === "number") outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === "number") totalTokens = usage.total_tokens;
        return {
            inputTokens: inputTokens,
            outputTokens: outputTokens,
            totalTokens: totalTokens
        };
    }
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.tokenUsage && typeof metadata.tokenUsage === "object") {
            const tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === "number") inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === "number") outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === "number") totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens: inputTokens,
        outputTokens: outputTokens,
        totalTokens: totalTokens
    };
}
function $471178dd15659f73$var$extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === "string") span.setAttribute($d6car.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === "string") span.setAttribute($d6car.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [
            metadata.finish_reason
        ]);
    }
}
function $471178dd15659f73$var$extractToolsFromCompiledGraph(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
function $471178dd15659f73$var$setResponseAttributes(span, inputMessages, result) {
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    const toolCalls = $471178dd15659f73$var$extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute($d6car.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
    const normalizedNewMessages = $avYn4.normalizeLangChainMessages(newMessages);
    span.setAttribute($d6car.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    for (const message of newMessages){
        const tokens = $471178dd15659f73$var$extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        $471178dd15659f73$var$extractModelMetadata(span, message);
    }
    if (totalInputTokens > 0) span.setAttribute($d6car.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute($d6car.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
    if (totalTokens > 0) span.setAttribute($d6car.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
}
module.exports.extractAgentNameFromParams = $471178dd15659f73$var$extractAgentNameFromParams;
module.exports.extractLLMFromParams = $471178dd15659f73$var$extractLLMFromParams;
module.exports.extractModelMetadata = $471178dd15659f73$var$extractModelMetadata;
module.exports.extractTokenUsageFromMessage = $471178dd15659f73$var$extractTokenUsageFromMessage;
module.exports.extractToolCalls = $471178dd15659f73$var$extractToolCalls;
module.exports.extractToolsFromCompiledGraph = $471178dd15659f73$var$extractToolsFromCompiledGraph;
module.exports.setResponseAttributes = $471178dd15659f73$var$setResponseAttributes;
module.exports.wrapToolsWithSpans = $471178dd15659f73$var$wrapToolsWithSpans;

});


parcelRegister("kj7kP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $5QSoE = parcelRequire("5QSoE");

var $evhDU = parcelRequire("evhDU");

var $flPEp = parcelRequire("flPEp");

var $5YGlj = parcelRequire("5YGlj");
const $ec8b45968d6f8233$var$MAX_SPANS_PER_ENVELOPE = 1e3;
const $ec8b45968d6f8233$var$MAX_TRACE_WEIGHT_IN_BYTES = 5e6;
class $ec8b45968d6f8233$var$SpanBuffer {
    constructor(client, options){
        this._traceBuckets = /* @__PURE__ */ new Map();
        this._client = client;
        const { maxSpanLimit: maxSpanLimit, flushInterval: flushInterval, maxTraceWeightInBytes: maxTraceWeightInBytes } = options ?? {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= $ec8b45968d6f8233$var$MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : $ec8b45968d6f8233$var$MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5e3;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : $ec8b45968d6f8233$var$MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on("flush", ()=>{
            this.drain();
        });
        this._client.on("close", ()=>{
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: /* @__PURE__ */ new Set(),
                size: 0,
                timeout: $5QSoE.safeUnref(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += $5YGlj.estimateSerializedSpanSizeInBytes(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        $7piqH.DEBUG_BUILD && $99stL.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = spans[0]?._segmentSpan;
        if (!segmentSpan) {
            $7piqH.DEBUG_BUILD && $99stL.debug.warn("No segment span reference found on span JSON, cannot compute DSC");
            this._removeTrace(traceId);
            return;
        }
        const dsc = $evhDU.getDynamicSamplingContextFromSpan(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            const { _segmentSpan: _segmentSpan, ...cleanSpanJSON } = spanJSON;
            return cleanSpanJSON;
        });
        const envelope$1 = $flPEp.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
        $7piqH.DEBUG_BUILD && $99stL.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope$1).then(null, (reason)=>{
            $7piqH.DEBUG_BUILD && $99stL.debug.error("Error while sending streamed span envelope:", reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
}
module.exports.SpanBuffer = $ec8b45968d6f8233$var$SpanBuffer;

});
parcelRegister("flPEp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iIaFt = parcelRequire("iIaFt");

var $l008j = parcelRequire("l008j");

var $gwBtZ = parcelRequire("gwBtZ");

var $9gcfE = parcelRequire("9gcfE");
function $b2d0e1ecad740717$var$createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn$1 = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = $l008j.getSdkMetadataForEnvelopeHeader(options._metadata);
    const headers = {
        sent_at: new Date($9gcfE.safeDateNow()).toISOString(),
        ...$b2d0e1ecad740717$var$dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk: sdk
        },
        ...!!tunnel && dsn$1 && {
            dsn: $iIaFt.dsnToString(dsn$1)
        }
    };
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    const spanContainer = [
        {
            type: "span",
            item_count: serializedSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$gwBtZ.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: serializedSpans
        }
    ];
    return $l008j.createEnvelope(headers, [
        spanContainer
    ]);
}
function $b2d0e1ecad740717$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}
module.exports.createStreamedSpanEnvelope = $b2d0e1ecad740717$var$createStreamedSpanEnvelope;

});

parcelRegister("5YGlj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Db3P = parcelRequire("9Db3P");
function $45a366c1843dc338$var$estimateSerializedSpanSizeInBytes(span) {
    let weight = 156;
    weight += span.name.length * 2;
    weight += $9Db3P.estimateTypedAttributesSizeInBytes(span.attributes);
    if (span.links && span.links.length > 0) {
        const firstLink = span.links[0];
        const attributes$1 = firstLink?.attributes;
        const linkWeight = 100 + (attributes$1 ? $9Db3P.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}
module.exports.estimateSerializedSpanSizeInBytes = $45a366c1843dc338$var$estimateSerializedSpanSizeInBytes;

});


parcelRegister("kuI03", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $d8ZGm = parcelRequire("d8ZGm");

var $5aMPP = parcelRequire("5aMPP");

var $N7Tmw = parcelRequire("N7Tmw");

var $wmosz = parcelRequire("wmosz");

var $kj7kP = parcelRequire("kj7kP");

var $99stL = parcelRequire("99stL");

var $cp5Iu = parcelRequire("cp5Iu");
const $eeb8bd790b86e071$var$spanStreamingIntegration = $d8ZGm.defineIntegration(()=>{
    return {
        name: "SpanStreaming",
        setup (client) {
            const initialMessage = "SpanStreaming integration requires";
            const fallbackMsg = "Falling back to static trace lifecycle.";
            const clientOptions = client.getOptions();
            if (!$wmosz.hasSpanStreamingEnabled(client)) {
                clientOptions.traceLifecycle = "static";
                $7piqH.DEBUG_BUILD && $99stL.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan$1 = clientOptions.beforeSendSpan;
            if (beforeSendSpan$1 && !$5aMPP.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
                clientOptions.traceLifecycle = "static";
                $7piqH.DEBUG_BUILD && $99stL.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new $kj7kP.SpanBuffer(client);
            client.on("afterSpanEnd", (span)=>{
                if (!$cp5Iu.spanIsSampled(span)) return;
                buffer.add($N7Tmw.captureSpan(span, client));
            });
        }
    };
});
module.exports.spanStreamingIntegration = $eeb8bd790b86e071$var$spanStreamingIntegration;

});

parcelRegister("1hqpt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $0eebdd70e4ae28be$var$getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $0eebdd70e4ae28be$var$getBreadcrumbLogLevelFromHttpStatusCode;

});

parcelRegister("3tSid", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $288e31f67ebda903$var$SentryError extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}
module.exports.SentryError = $288e31f67ebda903$var$SentryError;

});

parcelRegister("il8gQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCYmH = parcelRequire("gCYmH");

var $c34Je = parcelRequire("c34Je");

var $1hzu4 = parcelRequire("1hzu4");

var $bbV3P = parcelRequire("bbV3P");

var $dVZms = parcelRequire("dVZms");

var $kjL8z = parcelRequire("kjL8z");

var $gtIHY = parcelRequire("gtIHY");
function $d5a09a8619635fb7$var$addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = $gtIHY.addHandler(type, handler);
    $gtIHY.maybeInstrument(type, ()=>$d5a09a8619635fb7$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $d5a09a8619635fb7$var$addFetchEndInstrumentationHandler(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = $gtIHY.addHandler(type, handler);
    $gtIHY.maybeInstrument(type, ()=>$d5a09a8619635fb7$var$instrumentFetch($d5a09a8619635fb7$var$streamHandler));
    return removeHandler;
}
function $d5a09a8619635fb7$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !$bbV3P.supportsNativeFetch()) return;
    $1hzu4.fill($kjL8z.GLOBAL_OBJ, "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $d5a09a8619635fb7$var$parseFetchArgs(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: $dVZms.timestampInSeconds() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $d5a09a8619635fb7$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) $gtIHY.triggerHandlers("fetch", {
                ...handlerData
            });
            return originalFetch.apply($kjL8z.GLOBAL_OBJ, args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else $gtIHY.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $dVZms.timestampInSeconds() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                $gtIHY.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $dVZms.timestampInSeconds() * 1e3,
                    error: error
                });
                if ($c34Je.isError(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    $1hzu4.addNonEnumerableProperty(error, "framesToPop", 1);
                }
                const client = $gCYmH.getClient();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else $1hzu4.addNonEnumerableProperty(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $d5a09a8619635fb7$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $d5a09a8619635fb7$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $d5a09a8619635fb7$var$resolveResponse(clonedResponseForResolving, ()=>{
        $gtIHY.triggerHandlers("fetch-body-resolved", {
            endTimestamp: $dVZms.timestampInSeconds() * 1e3,
            response: response
        });
    });
}
function $d5a09a8619635fb7$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $d5a09a8619635fb7$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($d5a09a8619635fb7$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $d5a09a8619635fb7$var$parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $d5a09a8619635fb7$var$getUrlFromResource(resource),
            method: $d5a09a8619635fb7$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            $c34Je.isRequest(resource) && $d5a09a8619635fb7$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $d5a09a8619635fb7$var$getUrlFromResource(arg),
        method: $d5a09a8619635fb7$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $d5a09a8619635fb7$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ($c34Je.isRequest(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}
module.exports.addFetchEndInstrumentationHandler = $d5a09a8619635fb7$var$addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $d5a09a8619635fb7$var$addFetchInstrumentationHandler;
module.exports.parseFetchArgs = $d5a09a8619635fb7$var$parseFetchArgs;

});
parcelRegister("bbV3P", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piqH = parcelRequire("7piqH");

var $99stL = parcelRequire("99stL");

var $kjL8z = parcelRequire("kjL8z");
const $825cfbe0805feeaf$var$WINDOW = $kjL8z.GLOBAL_OBJ;
function $825cfbe0805feeaf$var$supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $825cfbe0805feeaf$var$supportsDOMError() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $825cfbe0805feeaf$var$supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $825cfbe0805feeaf$var$supportsHistory() {
    return "history" in $825cfbe0805feeaf$var$WINDOW && !!$825cfbe0805feeaf$var$WINDOW.history;
}
const $825cfbe0805feeaf$var$supportsFetch = $825cfbe0805feeaf$var$_isFetchSupported;
function $825cfbe0805feeaf$var$_isFetchSupported() {
    if (!("fetch" in $825cfbe0805feeaf$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $825cfbe0805feeaf$var$isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $825cfbe0805feeaf$var$supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$825cfbe0805feeaf$var$_isFetchSupported()) return false;
    if ($825cfbe0805feeaf$var$isNativeFunction($825cfbe0805feeaf$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $825cfbe0805feeaf$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $825cfbe0805feeaf$var$isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        $7piqH.DEBUG_BUILD && $99stL.debug.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $825cfbe0805feeaf$var$supportsReportingObserver() {
    return "ReportingObserver" in $825cfbe0805feeaf$var$WINDOW;
}
function $825cfbe0805feeaf$var$supportsReferrerPolicy() {
    if (!$825cfbe0805feeaf$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}
module.exports.isNativeFunction = $825cfbe0805feeaf$var$isNativeFunction;
module.exports.supportsDOMError = $825cfbe0805feeaf$var$supportsDOMError;
module.exports.supportsDOMException = $825cfbe0805feeaf$var$supportsDOMException;
module.exports.supportsErrorEvent = $825cfbe0805feeaf$var$supportsErrorEvent;
module.exports.supportsFetch = $825cfbe0805feeaf$var$supportsFetch;
module.exports.supportsHistory = $825cfbe0805feeaf$var$supportsHistory;
module.exports.supportsNativeFetch = $825cfbe0805feeaf$var$supportsNativeFetch;
module.exports.supportsReferrerPolicy = $825cfbe0805feeaf$var$supportsReferrerPolicy;
module.exports.supportsReportingObserver = $825cfbe0805feeaf$var$supportsReportingObserver;

});


parcelRegister("617mT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $46188d3f3b11cf46$var$replaceExports(exports1, exportName, wrappedConstructor) {
    const original = exports1[exportName];
    if (typeof original !== "function") return;
    try {
        exports1[exportName] = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    if (exports1.default === original) try {
        exports1.default = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, "default", {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}
module.exports.replaceExports = $46188d3f3b11cf46$var$replaceExports;

});

parcelRegister("cAIWv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $92abb57c37198083$var$LRUMap {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = /* @__PURE__ */ new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === void 0) return void 0;
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) {
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}
module.exports.LRUMap = $92abb57c37198083$var$LRUMap;

});

parcelRegister("gA0uF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c120642d335375db$var$escapeStringForRegex(regexString) {
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
module.exports.escapeStringForRegex = $c120642d335375db$var$escapeStringForRegex;

});

parcelRegister("kwHFm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $c34Je = parcelRequire("c34Je");

var $kjL8z = parcelRequire("kjL8z");
const $ef18aaf708e6a21c$var$WINDOW = $kjL8z.GLOBAL_OBJ;
const $ef18aaf708e6a21c$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $ef18aaf708e6a21c$var$htmlTreeAsString(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $ef18aaf708e6a21c$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $ef18aaf708e6a21c$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $ef18aaf708e6a21c$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($ef18aaf708e6a21c$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && $c34Je.isString(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $ef18aaf708e6a21c$var$getLocationHref() {
    try {
        return $ef18aaf708e6a21c$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $ef18aaf708e6a21c$var$getComponentName(elem, maxTraverseHeight = 5) {
    if (!$ef18aaf708e6a21c$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
module.exports.getComponentName = $ef18aaf708e6a21c$var$getComponentName;
module.exports.getLocationHref = $ef18aaf708e6a21c$var$getLocationHref;
module.exports.htmlTreeAsString = $ef18aaf708e6a21c$var$htmlTreeAsString;

});

parcelRegister("jDmEx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2cngX = parcelRequire("2cngX");

var $k6VdG = parcelRequire("k6VdG");

var $lRCeh = parcelRequire("lRCeh");

var $d6car = parcelRequire("d6car");

var $7GCmi = parcelRequire("7GCmi");

var $1qWJ6 = parcelRequire("1qWJ6");
function $e4b33b3ee2e66ded$var$inferSystemFromInstance(instance) {
    const name = instance.constructor?.name ?? "";
    if (name.includes("OpenAI")) return "openai";
    if (name.includes("Google")) return "google_genai";
    if (name.includes("Mistral")) return "mistralai";
    if (name.includes("Vertex")) return "google_vertexai";
    if (name.includes("Bedrock")) return "aws_bedrock";
    if (name.includes("Ollama")) return "ollama";
    if (name.includes("Cloudflare")) return "cloudflare";
    if (name.includes("Cohere")) return "cohere";
    return "langchain";
}
function $e4b33b3ee2e66ded$var$extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance ?? {};
    const attributes = {
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $1qWJ6.LANGCHAIN_ORIGIN,
        [$k6VdG.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $d6car.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        [$d6car.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "embeddings",
        [$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: embeddingsInstance.model ?? "unknown"
    };
    attributes[$d6car.GEN_AI_SYSTEM_ATTRIBUTE] = $e4b33b3ee2e66ded$var$inferSystemFromInstance(embeddingsInstance);
    if ("dimensions" in embeddingsInstance) attributes[$d6car.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ("encodingFormat" in embeddingsInstance) attributes[$d6car.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
function $e4b33b3ee2e66ded$var$instrumentEmbeddingMethod(originalMethod, options = {}) {
    const { recordInputs: recordInputs } = $7GCmi.resolveAIRecordingOptions(options);
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const attributes = $e4b33b3ee2e66ded$var$extractEmbeddingAttributes(thisArg);
            const modelName = attributes[$d6car.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
            if (recordInputs) {
                const input = args[0];
                if (input != null) attributes[$d6car.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === "string" ? input : JSON.stringify(input);
            }
            return $lRCeh.startSpan({
                name: `embeddings ${modelName}`,
                op: $d6car.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
                attributes: attributes
            }, ()=>{
                return Reflect.apply(target, thisArg, args).then(void 0, (error)=>{
                    $2cngX.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langchain"
                        }
                    });
                    throw error;
                });
            });
        }
    });
}
function $e4b33b3ee2e66ded$var$instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === "function") embeddingsInstance.embedQuery = $e4b33b3ee2e66ded$var$instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === "function") embeddingsInstance.embedDocuments = $e4b33b3ee2e66ded$var$instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}
module.exports.instrumentEmbeddingMethod = $e4b33b3ee2e66ded$var$instrumentEmbeddingMethod;
module.exports.instrumentLangChainEmbeddings = $e4b33b3ee2e66ded$var$instrumentLangChainEmbeddings;

});


parcelRegister("kGgTb", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);

var $efMmY = parcelRequire("efMmY");
function isNodeEnv() {
    return !(0, $efMmY.isBrowserBundle)() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}

});
parcelRegister("efMmY", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $a607fc93dd8e6599$export$2928c40372e623c0);
function $a607fc93dd8e6599$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $a607fc93dd8e6599$export$8ad33f488b1ab046() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}

});


parcelRegister("hg3q4", function(module, exports) {
"use strict";

var $hYfPi = parcelRequire("hYfPi");
var $c906955787c780e8$var$httpResponseHandler = function httpResponseHandler(callback, decodeResponseBody) {
    if (decodeResponseBody === void 0) decodeResponseBody = false;
    return function(err, response, responseBody) {
        // if the XHR failed, return that error
        if (err) {
            callback(err);
            return;
        } // if the HTTP status code is 4xx or 5xx, the request also failed
        if (response.statusCode >= 400 && response.statusCode <= 599) {
            var cause = responseBody;
            if (decodeResponseBody) {
                if ($hYfPi.TextDecoder) {
                    var charset = $c906955787c780e8$var$getCharset(response.headers && response.headers['content-type']);
                    try {
                        cause = new TextDecoder(charset).decode(responseBody);
                    } catch (e) {}
                } else cause = String.fromCharCode.apply(null, new Uint8Array(responseBody));
            }
            callback({
                cause: cause
            });
            return;
        } // otherwise, request succeeded
        callback(null, responseBody);
    };
};
function $c906955787c780e8$var$getCharset(contentTypeHeader) {
    if (contentTypeHeader === void 0) contentTypeHeader = '';
    return contentTypeHeader.toLowerCase().split(';').reduce(function(charset, contentType) {
        var _contentType$split = contentType.split('='), type = _contentType$split[0], value = _contentType$split[1];
        if (type.trim() === 'charset') return value.trim();
        return charset;
    }, 'utf-8');
}
module.exports = $c906955787c780e8$var$httpResponseHandler;

});
parcelRegister("hYfPi", function(module, exports) {
var $d154510a897fbed3$var$win;
if (typeof window !== "undefined") $d154510a897fbed3$var$win = window;
else if (typeof $parcel$global !== "undefined") $d154510a897fbed3$var$win = $parcel$global;
else if (typeof self !== "undefined") $d154510a897fbed3$var$win = self;
else $d154510a897fbed3$var$win = {};
module.exports = $d154510a897fbed3$var$win;

});


parcelRegister("dDY2O", function(module, exports) {
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* -*- Mode: Java; tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- */ /* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */ 
var $01r8O = parcelRequire("01r8O");
var $9eed7e76e82af8ff$var$_objCreate = Object.create || function() {
    function F() {}
    return function(o) {
        if (arguments.length !== 1) throw new Error('Object.create shim only accepts one parameter.');
        F.prototype = o;
        return new F();
    };
}();
// Creates a new ParserError object from an errorData object. The errorData
// object should have default code and message properties. The default message
// property can be overriden by passing in a message parameter.
// See ParsingError.Errors below for acceptable errors.
function $9eed7e76e82af8ff$var$ParsingError(errorData, message) {
    this.name = "ParsingError";
    this.code = errorData.code;
    this.message = message || errorData.message;
}
$9eed7e76e82af8ff$var$ParsingError.prototype = $9eed7e76e82af8ff$var$_objCreate(Error.prototype);
$9eed7e76e82af8ff$var$ParsingError.prototype.constructor = $9eed7e76e82af8ff$var$ParsingError;
// ParsingError metadata for acceptable ParsingErrors.
$9eed7e76e82af8ff$var$ParsingError.Errors = {
    BadSignature: {
        code: 0,
        message: "Malformed WebVTT signature."
    },
    BadTimeStamp: {
        code: 1,
        message: "Malformed time stamp."
    }
};
// Try to parse input as a time stamp.
function $9eed7e76e82af8ff$var$parseTimeStamp(input) {
    function computeSeconds(h, m, s, f) {
        return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
    }
    var m = input.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
    if (!m) return null;
    if (m[3]) // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
    else if (m[1] > 59) // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[1], m[2], 0, m[4]);
    else // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
    return computeSeconds(0, m[1], m[2], m[4]);
}
// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
function $9eed7e76e82af8ff$var$Settings() {
    this.values = $9eed7e76e82af8ff$var$_objCreate(null);
}
$9eed7e76e82af8ff$var$Settings.prototype = {
    // Only accept the first assignment to any key.
    set: function(k, v) {
        if (!this.get(k) && v !== "") this.values[k] = v;
    },
    // Return the value for a key, or a default value.
    // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
    // a number of possible default values as properties where 'defaultKey' is
    // the key of the property that will be chosen; otherwise it's assumed to be
    // a single value.
    get: function(k, dflt, defaultKey) {
        if (defaultKey) return this.has(k) ? this.values[k] : dflt[defaultKey];
        return this.has(k) ? this.values[k] : dflt;
    },
    // Check whether we have a value for a key.
    has: function(k) {
        return k in this.values;
    },
    // Accept a setting if its one of the given alternatives.
    alt: function(k, v, a) {
        for(var n = 0; n < a.length; ++n)if (v === a[n]) {
            this.set(k, v);
            break;
        }
    },
    // Accept a setting if its a valid (signed) integer.
    integer: function(k, v) {
        if (/^-?\d+$/.test(v)) this.set(k, parseInt(v, 10));
    },
    // Accept a setting if its a valid percentage.
    percent: function(k, v) {
        var m;
        if (m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/)) {
            v = parseFloat(v);
            if (v >= 0 && v <= 100) {
                this.set(k, v);
                return true;
            }
        }
        return false;
    }
};
// Helper function to parse input into groups separated by 'groupDelim', and
// interprete each group as a key/value pair separated by 'keyValueDelim'.
function $9eed7e76e82af8ff$var$parseOptions(input, callback, keyValueDelim, groupDelim) {
    var groups = groupDelim ? input.split(groupDelim) : [
        input
    ];
    for(var i in groups){
        if (typeof groups[i] !== "string") continue;
        var kv = groups[i].split(keyValueDelim);
        if (kv.length !== 2) continue;
        var k = kv[0].trim();
        var v = kv[1].trim();
        callback(k, v);
    }
}
function $9eed7e76e82af8ff$var$parseCue(input, cue, regionList) {
    // Remember the original input if we need to throw an error.
    var oInput = input;
    // 4.1 WebVTT timestamp
    function consumeTimeStamp() {
        var ts = $9eed7e76e82af8ff$var$parseTimeStamp(input);
        if (ts === null) throw new $9eed7e76e82af8ff$var$ParsingError($9eed7e76e82af8ff$var$ParsingError.Errors.BadTimeStamp, "Malformed timestamp: " + oInput);
        // Remove time stamp from input.
        input = input.replace(/^[^\sa-zA-Z-]+/, "");
        return ts;
    }
    // 4.4.2 WebVTT cue settings
    function consumeCueSettings(input, cue) {
        var settings = new $9eed7e76e82af8ff$var$Settings();
        $9eed7e76e82af8ff$var$parseOptions(input, function(k, v) {
            switch(k){
                case "region":
                    // Find the last region we parsed with the same region id.
                    for(var i = regionList.length - 1; i >= 0; i--)if (regionList[i].id === v) {
                        settings.set(k, regionList[i].region);
                        break;
                    }
                    break;
                case "vertical":
                    settings.alt(k, v, [
                        "rl",
                        "lr"
                    ]);
                    break;
                case "line":
                    var vals = v.split(","), vals0 = vals[0];
                    settings.integer(k, vals0);
                    settings.percent(k, vals0) && settings.set("snapToLines", false);
                    settings.alt(k, vals0, [
                        "auto"
                    ]);
                    if (vals.length === 2) settings.alt("lineAlign", vals[1], [
                        "start",
                        "center",
                        "end"
                    ]);
                    break;
                case "position":
                    vals = v.split(",");
                    settings.percent(k, vals[0]);
                    if (vals.length === 2) settings.alt("positionAlign", vals[1], [
                        "start",
                        "center",
                        "end"
                    ]);
                    break;
                case "size":
                    settings.percent(k, v);
                    break;
                case "align":
                    settings.alt(k, v, [
                        "start",
                        "center",
                        "end",
                        "left",
                        "right"
                    ]);
                    break;
            }
        }, /:/, /\s/);
        // Apply default values for any missing fields.
        cue.region = settings.get("region", null);
        cue.vertical = settings.get("vertical", "");
        try {
            cue.line = settings.get("line", "auto");
        } catch (e) {}
        cue.lineAlign = settings.get("lineAlign", "start");
        cue.snapToLines = settings.get("snapToLines", true);
        cue.size = settings.get("size", 100);
        // Safari still uses the old middle value and won't accept center
        try {
            cue.align = settings.get("align", "center");
        } catch (e) {
            cue.align = settings.get("align", "middle");
        }
        try {
            cue.position = settings.get("position", "auto");
        } catch (e) {
            cue.position = settings.get("position", {
                start: 0,
                left: 0,
                center: 50,
                middle: 50,
                end: 100,
                right: 100
            }, cue.align);
        }
        cue.positionAlign = settings.get("positionAlign", {
            start: "start",
            left: "start",
            center: "center",
            middle: "center",
            end: "end",
            right: "end"
        }, cue.align);
    }
    function skipWhitespace() {
        input = input.replace(/^\s+/, "");
    }
    // 4.1 WebVTT cue timings.
    skipWhitespace();
    cue.startTime = consumeTimeStamp(); // (1) collect cue start time
    skipWhitespace();
    if (input.substr(0, 3) !== "-->") throw new $9eed7e76e82af8ff$var$ParsingError($9eed7e76e82af8ff$var$ParsingError.Errors.BadTimeStamp, "Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
    input = input.substr(3);
    skipWhitespace();
    cue.endTime = consumeTimeStamp(); // (5) collect cue end time
    // 4.1 WebVTT cue settings list.
    skipWhitespace();
    consumeCueSettings(input, cue);
}
// When evaluating this file as part of a Webpack bundle for server
// side rendering, `document` is an empty object.
var $9eed7e76e82af8ff$var$TEXTAREA_ELEMENT = $01r8O.createElement && $01r8O.createElement("textarea");
var $9eed7e76e82af8ff$var$TAG_NAME = {
    c: "span",
    i: "i",
    b: "b",
    u: "u",
    ruby: "ruby",
    rt: "rt",
    v: "span",
    lang: "span"
};
// 5.1 default text color
// 5.2 default text background color is equivalent to text color with bg_ prefix
var $9eed7e76e82af8ff$var$DEFAULT_COLOR_CLASS = {
    white: 'rgba(255,255,255,1)',
    lime: 'rgba(0,255,0,1)',
    cyan: 'rgba(0,255,255,1)',
    red: 'rgba(255,0,0,1)',
    yellow: 'rgba(255,255,0,1)',
    magenta: 'rgba(255,0,255,1)',
    blue: 'rgba(0,0,255,1)',
    black: 'rgba(0,0,0,1)'
};
var $9eed7e76e82af8ff$var$TAG_ANNOTATION = {
    v: "title",
    lang: "lang"
};
var $9eed7e76e82af8ff$var$NEEDS_PARENT = {
    rt: "ruby"
};
// Parse content into a document fragment.
function $9eed7e76e82af8ff$var$parseContent(window, input) {
    function nextToken() {
        // Check for end-of-string.
        if (!input) return null;
        // Consume 'n' characters from the input.
        function consume(result) {
            input = input.substr(result.length);
            return result;
        }
        var m = input.match(/^([^<]*)(<[^>]*>?)?/);
        // If there is some text before the next tag, return it, otherwise return
        // the tag.
        return consume(m[1] ? m[1] : m[2]);
    }
    function unescape(s) {
        $9eed7e76e82af8ff$var$TEXTAREA_ELEMENT.innerHTML = s;
        s = $9eed7e76e82af8ff$var$TEXTAREA_ELEMENT.textContent;
        $9eed7e76e82af8ff$var$TEXTAREA_ELEMENT.textContent = "";
        return s;
    }
    function shouldAdd(current, element) {
        return !$9eed7e76e82af8ff$var$NEEDS_PARENT[element.localName] || $9eed7e76e82af8ff$var$NEEDS_PARENT[element.localName] === current.localName;
    }
    // Create an element for this tag.
    function createElement(type, annotation) {
        var tagName = $9eed7e76e82af8ff$var$TAG_NAME[type];
        if (!tagName) return null;
        var element = window.document.createElement(tagName);
        var name = $9eed7e76e82af8ff$var$TAG_ANNOTATION[type];
        if (name && annotation) element[name] = annotation.trim();
        return element;
    }
    var rootDiv = window.document.createElement("div"), current = rootDiv, t, tagStack = [];
    while((t = nextToken()) !== null){
        if (t[0] === '<') {
            if (t[1] === "/") {
                // If the closing tag matches, move back up to the parent node.
                if (tagStack.length && tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
                    tagStack.pop();
                    current = current.parentNode;
                }
                continue;
            }
            var ts = $9eed7e76e82af8ff$var$parseTimeStamp(t.substr(1, t.length - 2));
            var node;
            if (ts) {
                // Timestamps are lead nodes as well.
                node = window.document.createProcessingInstruction("timestamp", ts);
                current.appendChild(node);
                continue;
            }
            var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
            // If we can't parse the tag, skip to the next tag.
            if (!m) continue;
            // Try to construct an element, and ignore the tag if we couldn't.
            node = createElement(m[1], m[3]);
            if (!node) continue;
            // Determine if the tag should be added based on the context of where it
            // is placed in the cuetext.
            if (!shouldAdd(current, node)) continue;
            // Set the class list (as a list of classes, separated by space).
            if (m[2]) {
                var classes = m[2].split('.');
                classes.forEach(function(cl) {
                    var bgColor = /^bg_/.test(cl);
                    // slice out `bg_` if it's a background color
                    var colorName = bgColor ? cl.slice(3) : cl;
                    if ($9eed7e76e82af8ff$var$DEFAULT_COLOR_CLASS.hasOwnProperty(colorName)) {
                        var propName = bgColor ? 'background-color' : 'color';
                        var propValue = $9eed7e76e82af8ff$var$DEFAULT_COLOR_CLASS[colorName];
                        node.style[propName] = propValue;
                    }
                });
                node.className = classes.join(' ');
            }
            // Append the node to the current node, and enter the scope of the new
            // node.
            tagStack.push(m[1]);
            current.appendChild(node);
            current = node;
            continue;
        }
        // Text nodes are leaf nodes.
        current.appendChild(window.document.createTextNode(unescape(t)));
    }
    return rootDiv;
}
// This is a list of all the Unicode characters that have a strong
// right-to-left category. What this means is that these characters are
// written right-to-left for sure. It was generated by pulling all the strong
// right-to-left characters out of the Unicode data table. That table can
// found at: http://www.unicode.org/Public/UNIDATA/UnicodeData.txt
var $9eed7e76e82af8ff$var$strongRTLRanges = [
    [
        0x5be,
        0x5be
    ],
    [
        0x5c0,
        0x5c0
    ],
    [
        0x5c3,
        0x5c3
    ],
    [
        0x5c6,
        0x5c6
    ],
    [
        0x5d0,
        0x5ea
    ],
    [
        0x5f0,
        0x5f4
    ],
    [
        0x608,
        0x608
    ],
    [
        0x60b,
        0x60b
    ],
    [
        0x60d,
        0x60d
    ],
    [
        0x61b,
        0x61b
    ],
    [
        0x61e,
        0x64a
    ],
    [
        0x66d,
        0x66f
    ],
    [
        0x671,
        0x6d5
    ],
    [
        0x6e5,
        0x6e6
    ],
    [
        0x6ee,
        0x6ef
    ],
    [
        0x6fa,
        0x70d
    ],
    [
        0x70f,
        0x710
    ],
    [
        0x712,
        0x72f
    ],
    [
        0x74d,
        0x7a5
    ],
    [
        0x7b1,
        0x7b1
    ],
    [
        0x7c0,
        0x7ea
    ],
    [
        0x7f4,
        0x7f5
    ],
    [
        0x7fa,
        0x7fa
    ],
    [
        0x800,
        0x815
    ],
    [
        0x81a,
        0x81a
    ],
    [
        0x824,
        0x824
    ],
    [
        0x828,
        0x828
    ],
    [
        0x830,
        0x83e
    ],
    [
        0x840,
        0x858
    ],
    [
        0x85e,
        0x85e
    ],
    [
        0x8a0,
        0x8a0
    ],
    [
        0x8a2,
        0x8ac
    ],
    [
        0x200f,
        0x200f
    ],
    [
        0xfb1d,
        0xfb1d
    ],
    [
        0xfb1f,
        0xfb28
    ],
    [
        0xfb2a,
        0xfb36
    ],
    [
        0xfb38,
        0xfb3c
    ],
    [
        0xfb3e,
        0xfb3e
    ],
    [
        0xfb40,
        0xfb41
    ],
    [
        0xfb43,
        0xfb44
    ],
    [
        0xfb46,
        0xfbc1
    ],
    [
        0xfbd3,
        0xfd3d
    ],
    [
        0xfd50,
        0xfd8f
    ],
    [
        0xfd92,
        0xfdc7
    ],
    [
        0xfdf0,
        0xfdfc
    ],
    [
        0xfe70,
        0xfe74
    ],
    [
        0xfe76,
        0xfefc
    ],
    [
        0x10800,
        0x10805
    ],
    [
        0x10808,
        0x10808
    ],
    [
        0x1080a,
        0x10835
    ],
    [
        0x10837,
        0x10838
    ],
    [
        0x1083c,
        0x1083c
    ],
    [
        0x1083f,
        0x10855
    ],
    [
        0x10857,
        0x1085f
    ],
    [
        0x10900,
        0x1091b
    ],
    [
        0x10920,
        0x10939
    ],
    [
        0x1093f,
        0x1093f
    ],
    [
        0x10980,
        0x109b7
    ],
    [
        0x109be,
        0x109bf
    ],
    [
        0x10a00,
        0x10a00
    ],
    [
        0x10a10,
        0x10a13
    ],
    [
        0x10a15,
        0x10a17
    ],
    [
        0x10a19,
        0x10a33
    ],
    [
        0x10a40,
        0x10a47
    ],
    [
        0x10a50,
        0x10a58
    ],
    [
        0x10a60,
        0x10a7f
    ],
    [
        0x10b00,
        0x10b35
    ],
    [
        0x10b40,
        0x10b55
    ],
    [
        0x10b58,
        0x10b72
    ],
    [
        0x10b78,
        0x10b7f
    ],
    [
        0x10c00,
        0x10c48
    ],
    [
        0x1ee00,
        0x1ee03
    ],
    [
        0x1ee05,
        0x1ee1f
    ],
    [
        0x1ee21,
        0x1ee22
    ],
    [
        0x1ee24,
        0x1ee24
    ],
    [
        0x1ee27,
        0x1ee27
    ],
    [
        0x1ee29,
        0x1ee32
    ],
    [
        0x1ee34,
        0x1ee37
    ],
    [
        0x1ee39,
        0x1ee39
    ],
    [
        0x1ee3b,
        0x1ee3b
    ],
    [
        0x1ee42,
        0x1ee42
    ],
    [
        0x1ee47,
        0x1ee47
    ],
    [
        0x1ee49,
        0x1ee49
    ],
    [
        0x1ee4b,
        0x1ee4b
    ],
    [
        0x1ee4d,
        0x1ee4f
    ],
    [
        0x1ee51,
        0x1ee52
    ],
    [
        0x1ee54,
        0x1ee54
    ],
    [
        0x1ee57,
        0x1ee57
    ],
    [
        0x1ee59,
        0x1ee59
    ],
    [
        0x1ee5b,
        0x1ee5b
    ],
    [
        0x1ee5d,
        0x1ee5d
    ],
    [
        0x1ee5f,
        0x1ee5f
    ],
    [
        0x1ee61,
        0x1ee62
    ],
    [
        0x1ee64,
        0x1ee64
    ],
    [
        0x1ee67,
        0x1ee6a
    ],
    [
        0x1ee6c,
        0x1ee72
    ],
    [
        0x1ee74,
        0x1ee77
    ],
    [
        0x1ee79,
        0x1ee7c
    ],
    [
        0x1ee7e,
        0x1ee7e
    ],
    [
        0x1ee80,
        0x1ee89
    ],
    [
        0x1ee8b,
        0x1ee9b
    ],
    [
        0x1eea1,
        0x1eea3
    ],
    [
        0x1eea5,
        0x1eea9
    ],
    [
        0x1eeab,
        0x1eebb
    ],
    [
        0x10fffd,
        0x10fffd
    ]
];
function $9eed7e76e82af8ff$var$isStrongRTLChar(charCode) {
    for(var i = 0; i < $9eed7e76e82af8ff$var$strongRTLRanges.length; i++){
        var currentRange = $9eed7e76e82af8ff$var$strongRTLRanges[i];
        if (charCode >= currentRange[0] && charCode <= currentRange[1]) return true;
    }
    return false;
}
function $9eed7e76e82af8ff$var$determineBidi(cueDiv) {
    var nodeStack = [], text = "", charCode;
    if (!cueDiv || !cueDiv.childNodes) return "ltr";
    function pushNodes(nodeStack, node) {
        for(var i = node.childNodes.length - 1; i >= 0; i--)nodeStack.push(node.childNodes[i]);
    }
    function nextTextNode(nodeStack) {
        if (!nodeStack || !nodeStack.length) return null;
        var node = nodeStack.pop(), text = node.textContent || node.innerText;
        if (text) {
            // TODO: This should match all unicode type B characters (paragraph
            // separator characters). See issue #115.
            var m = text.match(/^.*(\n|\r)/);
            if (m) {
                nodeStack.length = 0;
                return m[0];
            }
            return text;
        }
        if (node.tagName === "ruby") return nextTextNode(nodeStack);
        if (node.childNodes) {
            pushNodes(nodeStack, node);
            return nextTextNode(nodeStack);
        }
    }
    pushNodes(nodeStack, cueDiv);
    while(text = nextTextNode(nodeStack))for(var i = 0; i < text.length; i++){
        charCode = text.charCodeAt(i);
        if ($9eed7e76e82af8ff$var$isStrongRTLChar(charCode)) return "rtl";
    }
    return "ltr";
}
function $9eed7e76e82af8ff$var$computeLinePos(cue) {
    if (typeof cue.line === "number" && (cue.snapToLines || cue.line >= 0 && cue.line <= 100)) return cue.line;
    if (!cue.track || !cue.track.textTrackList || !cue.track.textTrackList.mediaElement) return -1;
    var track = cue.track, trackList = track.textTrackList, count = 0;
    for(var i = 0; i < trackList.length && trackList[i] !== track; i++)if (trackList[i].mode === "showing") count++;
    return ++count * -1;
}
function $9eed7e76e82af8ff$var$StyleBox() {}
// Apply styles to a div. If there is no div passed then it defaults to the
// div on 'this'.
$9eed7e76e82af8ff$var$StyleBox.prototype.applyStyles = function(styles, div) {
    div = div || this.div;
    for(var prop in styles)if (styles.hasOwnProperty(prop)) div.style[prop] = styles[prop];
};
$9eed7e76e82af8ff$var$StyleBox.prototype.formatStyle = function(val, unit) {
    return val === 0 ? 0 : val + unit;
};
// Constructs the computed display state of the cue (a div). Places the div
// into the overlay which should be a block level element (usually a div).
function $9eed7e76e82af8ff$var$CueStyleBox(window, cue, styleOptions) {
    $9eed7e76e82af8ff$var$StyleBox.call(this);
    this.cue = cue;
    // Parse our cue's text into a DOM tree rooted at 'cueDiv'. This div will
    // have inline positioning and will function as the cue background box.
    this.cueDiv = $9eed7e76e82af8ff$var$parseContent(window, cue.text);
    var styles = {
        color: "rgba(255, 255, 255, 1)",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        position: "relative",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: "inline",
        writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
        unicodeBidi: "plaintext"
    };
    this.applyStyles(styles, this.cueDiv);
    // Create an absolutely positioned div that will be used to position the cue
    // div. Note, all WebVTT cue-setting alignments are equivalent to the CSS
    // mirrors of them except middle instead of center on Safari.
    this.div = window.document.createElement("div");
    styles = {
        direction: $9eed7e76e82af8ff$var$determineBidi(this.cueDiv),
        writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
        unicodeBidi: "plaintext",
        textAlign: cue.align === "middle" ? "center" : cue.align,
        font: styleOptions.font,
        whiteSpace: "pre-line",
        position: "absolute"
    };
    this.applyStyles(styles);
    this.div.appendChild(this.cueDiv);
    // Calculate the distance from the reference edge of the viewport to the text
    // position of the cue box. The reference edge will be resolved later when
    // the box orientation styles are applied.
    var textPos = 0;
    switch(cue.positionAlign){
        case "start":
        case "line-left":
            textPos = cue.position;
            break;
        case "center":
            textPos = cue.position - cue.size / 2;
            break;
        case "end":
        case "line-right":
            textPos = cue.position - cue.size;
            break;
    }
    // Horizontal box orientation; textPos is the distance from the left edge of the
    // area to the left edge of the box and cue.size is the distance extending to
    // the right from there.
    if (cue.vertical === "") this.applyStyles({
        left: this.formatStyle(textPos, "%"),
        width: this.formatStyle(cue.size, "%")
    });
    else this.applyStyles({
        top: this.formatStyle(textPos, "%"),
        height: this.formatStyle(cue.size, "%")
    });
    this.move = function(box) {
        this.applyStyles({
            top: this.formatStyle(box.top, "px"),
            bottom: this.formatStyle(box.bottom, "px"),
            left: this.formatStyle(box.left, "px"),
            right: this.formatStyle(box.right, "px"),
            height: this.formatStyle(box.height, "px"),
            width: this.formatStyle(box.width, "px")
        });
    };
}
$9eed7e76e82af8ff$var$CueStyleBox.prototype = $9eed7e76e82af8ff$var$_objCreate($9eed7e76e82af8ff$var$StyleBox.prototype);
$9eed7e76e82af8ff$var$CueStyleBox.prototype.constructor = $9eed7e76e82af8ff$var$CueStyleBox;
// Represents the co-ordinates of an Element in a way that we can easily
// compute things with such as if it overlaps or intersects with another Element.
// Can initialize it with either a StyleBox or another BoxPosition.
function $9eed7e76e82af8ff$var$BoxPosition(obj) {
    // Either a BoxPosition was passed in and we need to copy it, or a StyleBox
    // was passed in and we need to copy the results of 'getBoundingClientRect'
    // as the object returned is readonly. All co-ordinate values are in reference
    // to the viewport origin (top left).
    var lh, height, width, top;
    if (obj.div) {
        height = obj.div.offsetHeight;
        width = obj.div.offsetWidth;
        top = obj.div.offsetTop;
        var rects = (rects = obj.div.childNodes) && (rects = rects[0]) && rects.getClientRects && rects.getClientRects();
        obj = obj.div.getBoundingClientRect();
        // In certain cases the outter div will be slightly larger then the sum of
        // the inner div's lines. This could be due to bold text, etc, on some platforms.
        // In this case we should get the average line height and use that. This will
        // result in the desired behaviour.
        lh = rects ? Math.max(rects[0] && rects[0].height || 0, obj.height / rects.length) : 0;
    }
    this.left = obj.left;
    this.right = obj.right;
    this.top = obj.top || top;
    this.height = obj.height || height;
    this.bottom = obj.bottom || top + (obj.height || height);
    this.width = obj.width || width;
    this.lineHeight = lh !== undefined ? lh : obj.lineHeight;
}
// Move the box along a particular axis. Optionally pass in an amount to move
// the box. If no amount is passed then the default is the line height of the
// box.
$9eed7e76e82af8ff$var$BoxPosition.prototype.move = function(axis, toMove) {
    toMove = toMove !== undefined ? toMove : this.lineHeight;
    switch(axis){
        case "+x":
            this.left += toMove;
            this.right += toMove;
            break;
        case "-x":
            this.left -= toMove;
            this.right -= toMove;
            break;
        case "+y":
            this.top += toMove;
            this.bottom += toMove;
            break;
        case "-y":
            this.top -= toMove;
            this.bottom -= toMove;
            break;
    }
};
// Check if this box overlaps another box, b2.
$9eed7e76e82af8ff$var$BoxPosition.prototype.overlaps = function(b2) {
    return this.left < b2.right && this.right > b2.left && this.top < b2.bottom && this.bottom > b2.top;
};
// Check if this box overlaps any other boxes in boxes.
$9eed7e76e82af8ff$var$BoxPosition.prototype.overlapsAny = function(boxes) {
    for(var i = 0; i < boxes.length; i++){
        if (this.overlaps(boxes[i])) return true;
    }
    return false;
};
// Check if this box is within another box.
$9eed7e76e82af8ff$var$BoxPosition.prototype.within = function(container) {
    return this.top >= container.top && this.bottom <= container.bottom && this.left >= container.left && this.right <= container.right;
};
// Check if this box is entirely within the container or it is overlapping
// on the edge opposite of the axis direction passed. For example, if "+x" is
// passed and the box is overlapping on the left edge of the container, then
// return true.
$9eed7e76e82af8ff$var$BoxPosition.prototype.overlapsOppositeAxis = function(container, axis) {
    switch(axis){
        case "+x":
            return this.left < container.left;
        case "-x":
            return this.right > container.right;
        case "+y":
            return this.top < container.top;
        case "-y":
            return this.bottom > container.bottom;
    }
};
// Find the percentage of the area that this box is overlapping with another
// box.
$9eed7e76e82af8ff$var$BoxPosition.prototype.intersectPercentage = function(b2) {
    var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)), y = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)), intersectArea = x * y;
    return intersectArea / (this.height * this.width);
};
// Convert the positions from this box to CSS compatible positions using
// the reference container's positions. This has to be done because this
// box's positions are in reference to the viewport origin, whereas, CSS
// values are in referecne to their respective edges.
$9eed7e76e82af8ff$var$BoxPosition.prototype.toCSSCompatValues = function(reference) {
    return {
        top: this.top - reference.top,
        bottom: reference.bottom - this.bottom,
        left: this.left - reference.left,
        right: reference.right - this.right,
        height: this.height,
        width: this.width
    };
};
// Get an object that represents the box's position without anything extra.
// Can pass a StyleBox, HTMLElement, or another BoxPositon.
$9eed7e76e82af8ff$var$BoxPosition.getSimpleBoxPosition = function(obj) {
    var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
    var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
    var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;
    obj = obj.div ? obj.div.getBoundingClientRect() : obj.tagName ? obj.getBoundingClientRect() : obj;
    var ret = {
        left: obj.left,
        right: obj.right,
        top: obj.top || top,
        height: obj.height || height,
        bottom: obj.bottom || top + (obj.height || height),
        width: obj.width || width
    };
    return ret;
};
// Move a StyleBox to its specified, or next best, position. The containerBox
// is the box that contains the StyleBox, such as a div. boxPositions are
// a list of other boxes that the styleBox can't overlap with.
function $9eed7e76e82af8ff$var$moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {
    // Find the best position for a cue box, b, on the video. The axis parameter
    // is a list of axis, the order of which, it will move the box along. For example:
    // Passing ["+x", "-x"] will move the box first along the x axis in the positive
    // direction. If it doesn't find a good position for it there it will then move
    // it along the x axis in the negative direction.
    function findBestPosition(b, axis) {
        var bestPosition, specifiedPosition = new $9eed7e76e82af8ff$var$BoxPosition(b), percentage = 1; // Highest possible so the first thing we get is better.
        for(var i = 0; i < axis.length; i++){
            while(b.overlapsOppositeAxis(containerBox, axis[i]) || b.within(containerBox) && b.overlapsAny(boxPositions))b.move(axis[i]);
            // We found a spot where we aren't overlapping anything. This is our
            // best position.
            if (b.within(containerBox)) return b;
            var p = b.intersectPercentage(containerBox);
            // If we're outside the container box less then we were on our last try
            // then remember this position as the best position.
            if (percentage > p) {
                bestPosition = new $9eed7e76e82af8ff$var$BoxPosition(b);
                percentage = p;
            }
            // Reset the box position to the specified position.
            b = new $9eed7e76e82af8ff$var$BoxPosition(specifiedPosition);
        }
        return bestPosition || specifiedPosition;
    }
    var boxPosition = new $9eed7e76e82af8ff$var$BoxPosition(styleBox), cue = styleBox.cue, linePos = $9eed7e76e82af8ff$var$computeLinePos(cue), axis = [];
    // If we have a line number to align the cue to.
    if (cue.snapToLines) {
        var size;
        switch(cue.vertical){
            case "":
                axis = [
                    "+y",
                    "-y"
                ];
                size = "height";
                break;
            case "rl":
                axis = [
                    "+x",
                    "-x"
                ];
                size = "width";
                break;
            case "lr":
                axis = [
                    "-x",
                    "+x"
                ];
                size = "width";
                break;
        }
        var step = boxPosition.lineHeight, position = step * Math.round(linePos), maxPosition = containerBox[size] + step, initialAxis = axis[0];
        // If the specified intial position is greater then the max position then
        // clamp the box to the amount of steps it would take for the box to
        // reach the max position.
        if (Math.abs(position) > maxPosition) {
            position = position < 0 ? -1 : 1;
            position *= Math.ceil(maxPosition / step) * step;
        }
        // If computed line position returns negative then line numbers are
        // relative to the bottom of the video instead of the top. Therefore, we
        // need to increase our initial position by the length or width of the
        // video, depending on the writing direction, and reverse our axis directions.
        if (linePos < 0) {
            position += cue.vertical === "" ? containerBox.height : containerBox.width;
            axis = axis.reverse();
        }
        // Move the box to the specified position. This may not be its best
        // position.
        boxPosition.move(initialAxis, position);
    } else {
        // If we have a percentage line value for the cue.
        var calculatedPercentage = boxPosition.lineHeight / containerBox.height * 100;
        switch(cue.lineAlign){
            case "center":
                linePos -= calculatedPercentage / 2;
                break;
            case "end":
                linePos -= calculatedPercentage;
                break;
        }
        // Apply initial line position to the cue box.
        switch(cue.vertical){
            case "":
                styleBox.applyStyles({
                    top: styleBox.formatStyle(linePos, "%")
                });
                break;
            case "rl":
                styleBox.applyStyles({
                    left: styleBox.formatStyle(linePos, "%")
                });
                break;
            case "lr":
                styleBox.applyStyles({
                    right: styleBox.formatStyle(linePos, "%")
                });
                break;
        }
        axis = [
            "+y",
            "-x",
            "+x",
            "-y"
        ];
        // Get the box position again after we've applied the specified positioning
        // to it.
        boxPosition = new $9eed7e76e82af8ff$var$BoxPosition(styleBox);
    }
    var bestPosition = findBestPosition(boxPosition, axis);
    styleBox.move(bestPosition.toCSSCompatValues(containerBox));
}
function $9eed7e76e82af8ff$var$WebVTT() {
// Nothing
}
// Helper to allow strings to be decoded instead of the default binary utf8 data.
$9eed7e76e82af8ff$var$WebVTT.StringDecoder = function() {
    return {
        decode: function(data) {
            if (!data) return "";
            if (typeof data !== "string") throw new Error("Error - expected string data.");
            return decodeURIComponent(encodeURIComponent(data));
        }
    };
};
$9eed7e76e82af8ff$var$WebVTT.convertCueToDOMTree = function(window, cuetext) {
    if (!window || !cuetext) return null;
    return $9eed7e76e82af8ff$var$parseContent(window, cuetext);
};
var $9eed7e76e82af8ff$var$FONT_SIZE_PERCENT = 0.05;
var $9eed7e76e82af8ff$var$FONT_STYLE = "sans-serif";
var $9eed7e76e82af8ff$var$CUE_BACKGROUND_PADDING = "1.5%";
// Runs the processing model over the cues and regions passed to it.
// @param overlay A block level element (usually a div) that the computed cues
//                and regions will be placed into.
$9eed7e76e82af8ff$var$WebVTT.processCues = function(window, cues, overlay) {
    if (!window || !cues || !overlay) return null;
    // Remove all previous children.
    while(overlay.firstChild)overlay.removeChild(overlay.firstChild);
    var paddedOverlay = window.document.createElement("div");
    paddedOverlay.style.position = "absolute";
    paddedOverlay.style.left = "0";
    paddedOverlay.style.right = "0";
    paddedOverlay.style.top = "0";
    paddedOverlay.style.bottom = "0";
    paddedOverlay.style.margin = $9eed7e76e82af8ff$var$CUE_BACKGROUND_PADDING;
    overlay.appendChild(paddedOverlay);
    // Determine if we need to compute the display states of the cues. This could
    // be the case if a cue's state has been changed since the last computation or
    // if it has not been computed yet.
    function shouldCompute(cues) {
        for(var i = 0; i < cues.length; i++){
            if (cues[i].hasBeenReset || !cues[i].displayState) return true;
        }
        return false;
    }
    // We don't need to recompute the cues' display states. Just reuse them.
    if (!shouldCompute(cues)) {
        for(var i = 0; i < cues.length; i++)paddedOverlay.appendChild(cues[i].displayState);
        return;
    }
    var boxPositions = [], containerBox = $9eed7e76e82af8ff$var$BoxPosition.getSimpleBoxPosition(paddedOverlay), fontSize = Math.round(containerBox.height * $9eed7e76e82af8ff$var$FONT_SIZE_PERCENT * 100) / 100;
    var styleOptions = {
        font: fontSize + "px " + $9eed7e76e82af8ff$var$FONT_STYLE
    };
    (function() {
        var styleBox, cue;
        for(var i = 0; i < cues.length; i++){
            cue = cues[i];
            // Compute the intial position and styles of the cue div.
            styleBox = new $9eed7e76e82af8ff$var$CueStyleBox(window, cue, styleOptions);
            paddedOverlay.appendChild(styleBox.div);
            // Move the cue div to it's correct line position.
            $9eed7e76e82af8ff$var$moveBoxToLinePosition(window, styleBox, containerBox, boxPositions);
            // Remember the computed div so that we don't have to recompute it later
            // if we don't have too.
            cue.displayState = styleBox.div;
            boxPositions.push($9eed7e76e82af8ff$var$BoxPosition.getSimpleBoxPosition(styleBox));
        }
    })();
};
$9eed7e76e82af8ff$var$WebVTT.Parser = function(window, vttjs, decoder) {
    if (!decoder) {
        decoder = vttjs;
        vttjs = {};
    }
    if (!vttjs) vttjs = {};
    this.window = window;
    this.vttjs = vttjs;
    this.state = "INITIAL";
    this.buffer = "";
    this.decoder = decoder || new TextDecoder("utf8");
    this.regionList = [];
};
$9eed7e76e82af8ff$var$WebVTT.Parser.prototype = {
    // If the error is a ParsingError then report it to the consumer if
    // possible. If it's not a ParsingError then throw it like normal.
    reportOrThrowError: function(e) {
        if (e instanceof $9eed7e76e82af8ff$var$ParsingError) this.onparsingerror && this.onparsingerror(e);
        else throw e;
    },
    parse: function(data) {
        var self = this;
        // If there is no data then we won't decode it, but will just try to parse
        // whatever is in buffer already. This may occur in circumstances, for
        // example when flush() is called.
        if (data) // Try to decode the data that we received.
        self.buffer += self.decoder.decode(data, {
            stream: true
        });
        function collectNextLine() {
            var buffer = self.buffer;
            var pos = 0;
            while(pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n')++pos;
            var line = buffer.substr(0, pos);
            // Advance the buffer early in case we fail below.
            if (buffer[pos] === '\r') ++pos;
            if (buffer[pos] === '\n') ++pos;
            self.buffer = buffer.substr(pos);
            return line;
        }
        // 3.4 WebVTT region and WebVTT region settings syntax
        function parseRegion(input) {
            var settings = new $9eed7e76e82af8ff$var$Settings();
            $9eed7e76e82af8ff$var$parseOptions(input, function(k, v) {
                switch(k){
                    case "id":
                        settings.set(k, v);
                        break;
                    case "width":
                        settings.percent(k, v);
                        break;
                    case "lines":
                        settings.integer(k, v);
                        break;
                    case "regionanchor":
                    case "viewportanchor":
                        var xy = v.split(',');
                        if (xy.length !== 2) break;
                        // We have to make sure both x and y parse, so use a temporary
                        // settings object here.
                        var anchor = new $9eed7e76e82af8ff$var$Settings();
                        anchor.percent("x", xy[0]);
                        anchor.percent("y", xy[1]);
                        if (!anchor.has("x") || !anchor.has("y")) break;
                        settings.set(k + "X", anchor.get("x"));
                        settings.set(k + "Y", anchor.get("y"));
                        break;
                    case "scroll":
                        settings.alt(k, v, [
                            "up"
                        ]);
                        break;
                }
            }, /=/, /\s/);
            // Create the region, using default values for any values that were not
            // specified.
            if (settings.has("id")) {
                var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
                region.width = settings.get("width", 100);
                region.lines = settings.get("lines", 3);
                region.regionAnchorX = settings.get("regionanchorX", 0);
                region.regionAnchorY = settings.get("regionanchorY", 100);
                region.viewportAnchorX = settings.get("viewportanchorX", 0);
                region.viewportAnchorY = settings.get("viewportanchorY", 100);
                region.scroll = settings.get("scroll", "");
                // Register the region.
                self.onregion && self.onregion(region);
                // Remember the VTTRegion for later in case we parse any VTTCues that
                // reference it.
                self.regionList.push({
                    id: settings.get("id"),
                    region: region
                });
            }
        }
        // draft-pantos-http-live-streaming-20
        // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
        // 3.5 WebVTT
        function parseTimestampMap(input) {
            var settings = new $9eed7e76e82af8ff$var$Settings();
            $9eed7e76e82af8ff$var$parseOptions(input, function(k, v) {
                switch(k){
                    case "MPEGT":
                        settings.integer(k + 'S', v);
                        break;
                    case "LOCA":
                        settings.set(k + 'L', $9eed7e76e82af8ff$var$parseTimeStamp(v));
                        break;
                }
            }, /[^\d]:/, /,/);
            self.ontimestampmap && self.ontimestampmap({
                "MPEGTS": settings.get("MPEGTS"),
                "LOCAL": settings.get("LOCAL")
            });
        }
        // 3.2 WebVTT metadata header syntax
        function parseHeader(input) {
            if (input.match(/X-TIMESTAMP-MAP/)) // This line contains HLS X-TIMESTAMP-MAP metadata
            $9eed7e76e82af8ff$var$parseOptions(input, function(k, v) {
                switch(k){
                    case "X-TIMESTAMP-MAP":
                        parseTimestampMap(v);
                        break;
                }
            }, /=/);
            else $9eed7e76e82af8ff$var$parseOptions(input, function(k, v) {
                switch(k){
                    case "Region":
                        // 3.3 WebVTT region metadata header syntax
                        parseRegion(v);
                        break;
                }
            }, /:/);
        }
        // 5.1 WebVTT file parsing.
        try {
            var line;
            if (self.state === "INITIAL") {
                // We can't start parsing until we have the first line.
                if (!/\r\n|\n/.test(self.buffer)) return this;
                line = collectNextLine();
                var m = line.match(/^WEBVTT([ \t].*)?$/);
                if (!m || !m[0]) throw new $9eed7e76e82af8ff$var$ParsingError($9eed7e76e82af8ff$var$ParsingError.Errors.BadSignature);
                self.state = "HEADER";
            }
            var alreadyCollectedLine = false;
            while(self.buffer){
                // We can't parse a line until we have the full line.
                if (!/\r\n|\n/.test(self.buffer)) return this;
                if (!alreadyCollectedLine) line = collectNextLine();
                else alreadyCollectedLine = false;
                switch(self.state){
                    case "HEADER":
                        // 13-18 - Allow a header (metadata) under the WEBVTT line.
                        if (/:/.test(line)) parseHeader(line);
                        else if (!line) // An empty line terminates the header and starts the body (cues).
                        self.state = "ID";
                        continue;
                    case "NOTE":
                        // Ignore NOTE blocks.
                        if (!line) self.state = "ID";
                        continue;
                    case "ID":
                        // Check for the start of NOTE blocks.
                        if (/^NOTE($|[ \t])/.test(line)) {
                            self.state = "NOTE";
                            break;
                        }
                        // 19-29 - Allow any number of line terminators, then initialize new cue values.
                        if (!line) continue;
                        self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
                        // Safari still uses the old middle value and won't accept center
                        try {
                            self.cue.align = "center";
                        } catch (e) {
                            self.cue.align = "middle";
                        }
                        self.state = "CUE";
                        // 30-39 - Check if self line contains an optional identifier or timing data.
                        if (line.indexOf("-->") === -1) {
                            self.cue.id = line;
                            continue;
                        }
                    // Process line as start of a cue.
                    /*falls through*/ case "CUE":
                        // 40 - Collect cue timings and settings.
                        try {
                            $9eed7e76e82af8ff$var$parseCue(line, self.cue, self.regionList);
                        } catch (e) {
                            self.reportOrThrowError(e);
                            // In case of an error ignore rest of the cue.
                            self.cue = null;
                            self.state = "BADCUE";
                            continue;
                        }
                        self.state = "CUETEXT";
                        continue;
                    case "CUETEXT":
                        var hasSubstring = line.indexOf("-->") !== -1;
                        // 34 - If we have an empty line then report the cue.
                        // 35 - If we have the special substring '-->' then report the cue,
                        // but do not collect the line as we need to process the current
                        // one as a new cue.
                        if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                            // We are done parsing self cue.
                            self.oncue && self.oncue(self.cue);
                            self.cue = null;
                            self.state = "ID";
                            continue;
                        }
                        if (self.cue.text) self.cue.text += "\n";
                        self.cue.text += line.replace(/\u2028/g, '\n').replace(/u2029/g, '\n');
                        continue;
                    case "BADCUE":
                        // 54-62 - Collect and discard the remaining cue.
                        if (!line) self.state = "ID";
                        continue;
                }
            }
        } catch (e) {
            self.reportOrThrowError(e);
            // If we are currently parsing a cue, report what we have.
            if (self.state === "CUETEXT" && self.cue && self.oncue) self.oncue(self.cue);
            self.cue = null;
            // Enter BADWEBVTT state if header was not parsed correctly otherwise
            // another exception occurred so enter BADCUE state.
            self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
        }
        return this;
    },
    flush: function() {
        var self = this;
        try {
            // Finish decoding the stream.
            self.buffer += self.decoder.decode();
            // Synthesize the end of the current cue or region.
            if (self.cue || self.state === "HEADER") {
                self.buffer += "\n\n";
                self.parse();
            }
            // If we've flushed, parsed, and we're still on the INITIAL state then
            // that means we don't have enough of the stream to parse the first
            // line.
            if (self.state === "INITIAL") throw new $9eed7e76e82af8ff$var$ParsingError($9eed7e76e82af8ff$var$ParsingError.Errors.BadSignature);
        } catch (e) {
            self.reportOrThrowError(e);
        }
        self.onflush && self.onflush();
        return this;
    }
};
module.exports = $9eed7e76e82af8ff$var$WebVTT;

});
parcelRegister("01r8O", function(module, exports) {
var $004525c9b60ca03e$var$topLevel = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : {};

var $foUwZ = parcelRequire("foUwZ");
var $004525c9b60ca03e$var$doccy;
if (typeof document !== 'undefined') $004525c9b60ca03e$var$doccy = document;
else {
    $004525c9b60ca03e$var$doccy = $004525c9b60ca03e$var$topLevel['__GLOBAL_DOCUMENT_CACHE@4'];
    if (!$004525c9b60ca03e$var$doccy) $004525c9b60ca03e$var$doccy = $004525c9b60ca03e$var$topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = $foUwZ;
}
module.exports = $004525c9b60ca03e$var$doccy;

});
parcelRegister("foUwZ", function(module, exports) {
"use strict";

});



parcelRegister("49bT6", function(module, exports) {
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $305139579860a2cf$var$autoKeyword = "auto";
var $305139579860a2cf$var$directionSetting = {
    "": 1,
    "lr": 1,
    "rl": 1
};
var $305139579860a2cf$var$alignSetting = {
    "start": 1,
    "center": 1,
    "end": 1,
    "left": 1,
    "right": 1,
    "auto": 1,
    "line-left": 1,
    "line-right": 1
};
function $305139579860a2cf$var$findDirectionSetting(value) {
    if (typeof value !== "string") return false;
    var dir = $305139579860a2cf$var$directionSetting[value.toLowerCase()];
    return dir ? value.toLowerCase() : false;
}
function $305139579860a2cf$var$findAlignSetting(value) {
    if (typeof value !== "string") return false;
    var align = $305139579860a2cf$var$alignSetting[value.toLowerCase()];
    return align ? value.toLowerCase() : false;
}
function $305139579860a2cf$var$VTTCue(startTime, endTime, text) {
    /**
   * Shim implementation specific properties. These properties are not in
   * the spec.
   */ // Lets us know when the VTTCue's data has changed in such a way that we need
    // to recompute its display state. This lets us compute its display state
    // lazily.
    this.hasBeenReset = false;
    /**
   * VTTCue and TextTrackCue properties
   * http://dev.w3.org/html5/webvtt/#vttcue-interface
   */ var _id = "";
    var _pauseOnExit = false;
    var _startTime = startTime;
    var _endTime = endTime;
    var _text = text;
    var _region = null;
    var _vertical = "";
    var _snapToLines = true;
    var _line = "auto";
    var _lineAlign = "start";
    var _position = "auto";
    var _positionAlign = "auto";
    var _size = 100;
    var _align = "center";
    Object.defineProperties(this, {
        "id": {
            enumerable: true,
            get: function() {
                return _id;
            },
            set: function(value) {
                _id = "" + value;
            }
        },
        "pauseOnExit": {
            enumerable: true,
            get: function() {
                return _pauseOnExit;
            },
            set: function(value) {
                _pauseOnExit = !!value;
            }
        },
        "startTime": {
            enumerable: true,
            get: function() {
                return _startTime;
            },
            set: function(value) {
                if (typeof value !== "number") throw new TypeError("Start time must be set to a number.");
                _startTime = value;
                this.hasBeenReset = true;
            }
        },
        "endTime": {
            enumerable: true,
            get: function() {
                return _endTime;
            },
            set: function(value) {
                if (typeof value !== "number") throw new TypeError("End time must be set to a number.");
                _endTime = value;
                this.hasBeenReset = true;
            }
        },
        "text": {
            enumerable: true,
            get: function() {
                return _text;
            },
            set: function(value) {
                _text = "" + value;
                this.hasBeenReset = true;
            }
        },
        "region": {
            enumerable: true,
            get: function() {
                return _region;
            },
            set: function(value) {
                _region = value;
                this.hasBeenReset = true;
            }
        },
        "vertical": {
            enumerable: true,
            get: function() {
                return _vertical;
            },
            set: function(value) {
                var setting = $305139579860a2cf$var$findDirectionSetting(value);
                // Have to check for false because the setting an be an empty string.
                if (setting === false) throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
                _vertical = setting;
                this.hasBeenReset = true;
            }
        },
        "snapToLines": {
            enumerable: true,
            get: function() {
                return _snapToLines;
            },
            set: function(value) {
                _snapToLines = !!value;
                this.hasBeenReset = true;
            }
        },
        "line": {
            enumerable: true,
            get: function() {
                return _line;
            },
            set: function(value) {
                if (typeof value !== "number" && value !== $305139579860a2cf$var$autoKeyword) throw new SyntaxError("Line: an invalid number or illegal string was specified.");
                _line = value;
                this.hasBeenReset = true;
            }
        },
        "lineAlign": {
            enumerable: true,
            get: function() {
                return _lineAlign;
            },
            set: function(value) {
                var setting = $305139579860a2cf$var$findAlignSetting(value);
                if (!setting) console.warn("lineAlign: an invalid or illegal string was specified.");
                else {
                    _lineAlign = setting;
                    this.hasBeenReset = true;
                }
            }
        },
        "position": {
            enumerable: true,
            get: function() {
                return _position;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error("Position must be between 0 and 100.");
                _position = value;
                this.hasBeenReset = true;
            }
        },
        "positionAlign": {
            enumerable: true,
            get: function() {
                return _positionAlign;
            },
            set: function(value) {
                var setting = $305139579860a2cf$var$findAlignSetting(value);
                if (!setting) console.warn("positionAlign: an invalid or illegal string was specified.");
                else {
                    _positionAlign = setting;
                    this.hasBeenReset = true;
                }
            }
        },
        "size": {
            enumerable: true,
            get: function() {
                return _size;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error("Size must be between 0 and 100.");
                _size = value;
                this.hasBeenReset = true;
            }
        },
        "align": {
            enumerable: true,
            get: function() {
                return _align;
            },
            set: function(value) {
                var setting = $305139579860a2cf$var$findAlignSetting(value);
                if (!setting) throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
                _align = setting;
                this.hasBeenReset = true;
            }
        }
    });
    /**
   * Other <track> spec defined properties
   */ // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
    this.displayState = undefined;
}
/**
 * VTTCue methods
 */ $305139579860a2cf$var$VTTCue.prototype.getCueAsHTML = function() {
    // Assume WebVTT.convertCueToDOMTree is on the global.
    return WebVTT.convertCueToDOMTree(window, this.text);
};
module.exports = $305139579860a2cf$var$VTTCue;

});

parcelRegister("5KZYH", function(module, exports) {
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $4311532e0af17905$var$scrollSetting = {
    "": true,
    "up": true
};
function $4311532e0af17905$var$findScrollSetting(value) {
    if (typeof value !== "string") return false;
    var scroll = $4311532e0af17905$var$scrollSetting[value.toLowerCase()];
    return scroll ? value.toLowerCase() : false;
}
function $4311532e0af17905$var$isValidPercentValue(value) {
    return typeof value === "number" && value >= 0 && value <= 100;
}
// VTTRegion shim http://dev.w3.org/html5/webvtt/#vttregion-interface
function $4311532e0af17905$var$VTTRegion() {
    var _width = 100;
    var _lines = 3;
    var _regionAnchorX = 0;
    var _regionAnchorY = 100;
    var _viewportAnchorX = 0;
    var _viewportAnchorY = 100;
    var _scroll = "";
    Object.defineProperties(this, {
        "width": {
            enumerable: true,
            get: function() {
                return _width;
            },
            set: function(value) {
                if (!$4311532e0af17905$var$isValidPercentValue(value)) throw new Error("Width must be between 0 and 100.");
                _width = value;
            }
        },
        "lines": {
            enumerable: true,
            get: function() {
                return _lines;
            },
            set: function(value) {
                if (typeof value !== "number") throw new TypeError("Lines must be set to a number.");
                _lines = value;
            }
        },
        "regionAnchorY": {
            enumerable: true,
            get: function() {
                return _regionAnchorY;
            },
            set: function(value) {
                if (!$4311532e0af17905$var$isValidPercentValue(value)) throw new Error("RegionAnchorX must be between 0 and 100.");
                _regionAnchorY = value;
            }
        },
        "regionAnchorX": {
            enumerable: true,
            get: function() {
                return _regionAnchorX;
            },
            set: function(value) {
                if (!$4311532e0af17905$var$isValidPercentValue(value)) throw new Error("RegionAnchorY must be between 0 and 100.");
                _regionAnchorX = value;
            }
        },
        "viewportAnchorY": {
            enumerable: true,
            get: function() {
                return _viewportAnchorY;
            },
            set: function(value) {
                if (!$4311532e0af17905$var$isValidPercentValue(value)) throw new Error("ViewportAnchorY must be between 0 and 100.");
                _viewportAnchorY = value;
            }
        },
        "viewportAnchorX": {
            enumerable: true,
            get: function() {
                return _viewportAnchorX;
            },
            set: function(value) {
                if (!$4311532e0af17905$var$isValidPercentValue(value)) throw new Error("ViewportAnchorX must be between 0 and 100.");
                _viewportAnchorX = value;
            }
        },
        "scroll": {
            enumerable: true,
            get: function() {
                return _scroll;
            },
            set: function(value) {
                var setting = $4311532e0af17905$var$findScrollSetting(value);
                // Have to check for false as an empty string is a legal value.
                if (setting === false) console.warn("Scroll: an invalid or illegal string was specified.");
                else _scroll = setting;
            }
        }
    });
}
module.exports = $4311532e0af17905$var$VTTRegion;

});

parcelRegister("bXM4z", function(module, exports) {

$parcel$export(module.exports, "DOMParser", () => $8b5a7ea4344bd18e$export$1059c6e7d2ce5669, (v) => $8b5a7ea4344bd18e$export$1059c6e7d2ce5669 = v);
var $8b5a7ea4344bd18e$export$181392475aa39887;
var $8b5a7ea4344bd18e$export$ba13e0e2f19e61a1;
var $8b5a7ea4344bd18e$export$1059c6e7d2ce5669;

var $ghxvC = parcelRequire("ghxvC");

var $cCG51 = parcelRequire("cCG51");

var $8eLdI = parcelRequire("8eLdI");

var $5ZAyY = parcelRequire("5ZAyY");
var $8b5a7ea4344bd18e$var$DOMImplementation = $cCG51.DOMImplementation;
var $8b5a7ea4344bd18e$var$NAMESPACE = $ghxvC.NAMESPACE;
var $8b5a7ea4344bd18e$var$ParseError = $5ZAyY.ParseError;
var $8b5a7ea4344bd18e$var$XMLReader = $5ZAyY.XMLReader;
/**
 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
 *
 * > XML parsed entities are often stored in computer files which,
 * > for editing convenience, are organized into lines.
 * > These lines are typically separated by some combination
 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
 * >
 * > To simplify the tasks of applications, the XML processor must behave
 * > as if it normalized all line breaks in external parsed entities (including the document entity)
 * > on input, before parsing, by translating all of the following to a single #xA character:
 * >
 * > 1. the two-character sequence #xD #xA
 * > 2. the two-character sequence #xD #x85
 * > 3. the single character #x85
 * > 4. the single character #x2028
 * > 5. any #xD character that is not immediately followed by #xA or #x85.
 *
 * @param {string} input
 * @returns {string}
 */ function $8b5a7ea4344bd18e$var$normalizeLineEndings(input) {
    return input.replace(/\r[\n\u0085]/g, '\n').replace(/[\r\u0085\u2028]/g, '\n');
}
/**
 * @typedef Locator
 * @property {number} [columnNumber]
 * @property {number} [lineNumber]
 */ /**
 * @typedef DOMParserOptions
 * @property {DOMHandler} [domBuilder]
 * @property {Function} [errorHandler]
 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
 * 						defaults to `normalizeLineEndings`
 * @property {Locator} [locator]
 * @property {Record<string, string>} [xmlns]
 *
 * @see normalizeLineEndings
 */ /**
 * The DOMParser interface provides the ability to parse XML or HTML source code
 * from a string into a DOM `Document`.
 *
 * _xmldom is different from the spec in that it allows an `options` parameter,
 * to override the default behavior._
 *
 * @param {DOMParserOptions} [options]
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
 */ function $8b5a7ea4344bd18e$var$DOMParser(options) {
    this.options = options || {
        locator: {}
    };
}
$8b5a7ea4344bd18e$var$DOMParser.prototype.parseFromString = function(source, mimeType) {
    var options = this.options;
    var sax = new $8b5a7ea4344bd18e$var$XMLReader();
    var domBuilder = options.domBuilder || new $8b5a7ea4344bd18e$var$DOMHandler(); //contentHandler and LexicalHandler
    var errorHandler = options.errorHandler;
    var locator = options.locator;
    var defaultNSMap = options.xmlns || {};
    var isHTML = /\/x?html?$/.test(mimeType); //mimeType.toLowerCase().indexOf('html') > -1;
    var entityMap = isHTML ? $8eLdI.HTML_ENTITIES : $8eLdI.XML_ENTITIES;
    if (locator) domBuilder.setDocumentLocator(locator);
    sax.errorHandler = $8b5a7ea4344bd18e$var$buildErrorHandler(errorHandler, domBuilder, locator);
    sax.domBuilder = options.domBuilder || domBuilder;
    if (isHTML) defaultNSMap[''] = $8b5a7ea4344bd18e$var$NAMESPACE.HTML;
    defaultNSMap.xml = defaultNSMap.xml || $8b5a7ea4344bd18e$var$NAMESPACE.XML;
    var normalize = options.normalizeLineEndings || $8b5a7ea4344bd18e$var$normalizeLineEndings;
    if (source && typeof source === 'string') sax.parse(normalize(source), defaultNSMap, entityMap);
    else sax.errorHandler.error('invalid doc source');
    return domBuilder.doc;
};
function $8b5a7ea4344bd18e$var$buildErrorHandler(errorImpl, domBuilder, locator) {
    if (!errorImpl) {
        if (domBuilder instanceof $8b5a7ea4344bd18e$var$DOMHandler) return domBuilder;
        errorImpl = domBuilder;
    }
    var errorHandler = {};
    var isCallback = errorImpl instanceof Function;
    locator = locator || {};
    function build(key) {
        var fn = errorImpl[key];
        if (!fn && isCallback) fn = errorImpl.length == 2 ? function(msg) {
            errorImpl(key, msg);
        } : errorImpl;
        errorHandler[key] = fn && function(msg) {
            fn('[xmldom ' + key + ']\t' + msg + $8b5a7ea4344bd18e$var$_locator(locator));
        } || function() {};
    }
    build('warning');
    build('error');
    build('fatalError');
    return errorHandler;
}
//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */ function $8b5a7ea4344bd18e$var$DOMHandler() {
    this.cdata = false;
}
function $8b5a7ea4344bd18e$var$position(locator, node) {
    node.lineNumber = locator.lineNumber;
    node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */ $8b5a7ea4344bd18e$var$DOMHandler.prototype = {
    startDocument: function() {
        this.doc = new $8b5a7ea4344bd18e$var$DOMImplementation().createDocument(null, null, null);
        if (this.locator) this.doc.documentURI = this.locator.systemId;
    },
    startElement: function(namespaceURI, localName, qName, attrs) {
        var doc = this.doc;
        var el = doc.createElementNS(namespaceURI, qName || localName);
        var len = attrs.length;
        $8b5a7ea4344bd18e$var$appendElement(this, el);
        this.currentElement = el;
        this.locator && $8b5a7ea4344bd18e$var$position(this.locator, el);
        for(var i = 0; i < len; i++){
            var namespaceURI = attrs.getURI(i);
            var value = attrs.getValue(i);
            var qName = attrs.getQName(i);
            var attr = doc.createAttributeNS(namespaceURI, qName);
            this.locator && $8b5a7ea4344bd18e$var$position(attrs.getLocator(i), attr);
            attr.value = attr.nodeValue = value;
            el.setAttributeNode(attr);
        }
    },
    endElement: function(namespaceURI, localName, qName) {
        var current = this.currentElement;
        var tagName = current.tagName;
        this.currentElement = current.parentNode;
    },
    startPrefixMapping: function(prefix, uri) {},
    endPrefixMapping: function(prefix) {},
    processingInstruction: function(target, data) {
        var ins = this.doc.createProcessingInstruction(target, data);
        this.locator && $8b5a7ea4344bd18e$var$position(this.locator, ins);
        $8b5a7ea4344bd18e$var$appendElement(this, ins);
    },
    ignorableWhitespace: function(ch, start, length) {},
    characters: function(chars, start, length) {
        chars = $8b5a7ea4344bd18e$var$_toString.apply(this, arguments);
        //console.log(chars)
        if (chars) {
            if (this.cdata) var charNode = this.doc.createCDATASection(chars);
            else var charNode = this.doc.createTextNode(chars);
            if (this.currentElement) this.currentElement.appendChild(charNode);
            else if (/^\s*$/.test(chars)) this.doc.appendChild(charNode);
            this.locator && $8b5a7ea4344bd18e$var$position(this.locator, charNode);
        }
    },
    skippedEntity: function(name) {},
    endDocument: function() {
        this.doc.normalize();
    },
    setDocumentLocator: function(locator) {
        if (this.locator = locator) locator.lineNumber = 0;
    },
    //LexicalHandler
    comment: function(chars, start, length) {
        chars = $8b5a7ea4344bd18e$var$_toString.apply(this, arguments);
        var comm = this.doc.createComment(chars);
        this.locator && $8b5a7ea4344bd18e$var$position(this.locator, comm);
        $8b5a7ea4344bd18e$var$appendElement(this, comm);
    },
    startCDATA: function() {
        //used in characters() methods
        this.cdata = true;
    },
    endCDATA: function() {
        this.cdata = false;
    },
    startDTD: function(name, publicId, systemId) {
        var impl = this.doc.implementation;
        if (impl && impl.createDocumentType) {
            var dt = impl.createDocumentType(name, publicId, systemId);
            this.locator && $8b5a7ea4344bd18e$var$position(this.locator, dt);
            $8b5a7ea4344bd18e$var$appendElement(this, dt);
            this.doc.doctype = dt;
        }
    },
    /**
	 * @see org.xml.sax.ErrorHandler
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
	 */ warning: function(error) {
        console.warn('[xmldom warning]\t' + error, $8b5a7ea4344bd18e$var$_locator(this.locator));
    },
    error: function(error) {
        console.error('[xmldom error]\t' + error, $8b5a7ea4344bd18e$var$_locator(this.locator));
    },
    fatalError: function(error) {
        throw new $8b5a7ea4344bd18e$var$ParseError(error, this.locator);
    }
};
function $8b5a7ea4344bd18e$var$_locator(l) {
    if (l) return '\n@' + (l.systemId || '') + '#[line:' + l.lineNumber + ',col:' + l.columnNumber + ']';
}
function $8b5a7ea4344bd18e$var$_toString(chars, start, length) {
    if (typeof chars == 'string') return chars.substr(start, length);
    else {
        if (chars.length >= start + length || start) return new java.lang.String(chars, start, length) + '';
        return chars;
    }
}
/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */ "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(key) {
    $8b5a7ea4344bd18e$var$DOMHandler.prototype[key] = function() {
        return null;
    };
});
/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */ function $8b5a7ea4344bd18e$var$appendElement(hander, node) {
    if (!hander.currentElement) hander.doc.appendChild(node);
    else hander.currentElement.appendChild(node);
} //appendChild and setAttributeNS are preformance key
$8b5a7ea4344bd18e$export$181392475aa39887 = $8b5a7ea4344bd18e$var$DOMHandler;
$8b5a7ea4344bd18e$export$ba13e0e2f19e61a1 = $8b5a7ea4344bd18e$var$normalizeLineEndings;
$8b5a7ea4344bd18e$export$1059c6e7d2ce5669 = $8b5a7ea4344bd18e$var$DOMParser;

});
parcelRegister("ghxvC", function(module, exports) {

$parcel$export(module.exports, "find", () => $030f19b5f1555355$export$71aa6c912b956294, (v) => $030f19b5f1555355$export$71aa6c912b956294 = v);
$parcel$export(module.exports, "freeze", () => $030f19b5f1555355$export$792f3d81ea979f55, (v) => $030f19b5f1555355$export$792f3d81ea979f55 = v);
$parcel$export(module.exports, "NAMESPACE", () => $030f19b5f1555355$export$6aad947bda0f3f46, (v) => $030f19b5f1555355$export$6aad947bda0f3f46 = v);
var $030f19b5f1555355$export$e6e34fd1f2686227;
var $030f19b5f1555355$export$71aa6c912b956294;
var $030f19b5f1555355$export$792f3d81ea979f55;
var $030f19b5f1555355$export$c6cb9dd1e3ada1aa;
var $030f19b5f1555355$export$6aad947bda0f3f46;
'use strict';
/**
 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
 *
 * Works with anything that has a `length` property and index access properties, including NodeList.
 *
 * @template {unknown} T
 * @param {Array<T> | ({length:number, [number]: T})} list
 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
 * 				allows injecting a custom implementation in tests
 * @returns {T | undefined}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
 */ function $030f19b5f1555355$var$find(list, predicate, ac) {
    if (ac === undefined) ac = Array.prototype;
    if (list && typeof ac.find === 'function') return ac.find.call(list, predicate);
    for(var i = 0; i < list.length; i++)if (Object.prototype.hasOwnProperty.call(list, i)) {
        var item = list[i];
        if (predicate.call(undefined, item, i, list)) return item;
    }
}
/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */ function $030f19b5f1555355$var$freeze(object, oc) {
    if (oc === undefined) oc = Object;
    return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object;
}
/**
 * Since we can not rely on `Object.assign` we provide a simplified version
 * that is sufficient for our needs.
 *
 * @param {Object} target
 * @param {Object | null | undefined} source
 *
 * @returns {Object} target
 * @throws TypeError if target is not an object
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
 */ function $030f19b5f1555355$var$assign(target, source) {
    if (target === null || typeof target !== 'object') throw new TypeError('target is not an object');
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    return target;
}
/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */ var $030f19b5f1555355$var$MIME_TYPE = $030f19b5f1555355$var$freeze({
    /**
	 * `text/html`, the only mime type that triggers treating an XML document as HTML.
	 *
	 * @see DOMParser.SupportedType.isHTML
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
	 */ HTML: 'text/html',
    /**
	 * Helper method to check a mime type if it indicates an HTML document
	 *
	 * @param {string} [value]
	 * @returns {boolean}
	 *
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */ isHTML: function(value) {
        return value === $030f19b5f1555355$var$MIME_TYPE.HTML;
    },
    /**
	 * `application/xml`, the standard mime type for XML documents.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
	 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_APPLICATION: 'application/xml',
    /**
	 * `text/html`, an alias for `application/xml`.
	 *
	 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
	 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_TEXT: 'text/xml',
    /**
	 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
	 * but is parsed as an XML document.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
	 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
	 */ XML_XHTML_APPLICATION: 'application/xhtml+xml',
    /**
	 * `image/svg+xml`,
	 *
	 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
	 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
	 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
	 */ XML_SVG_IMAGE: 'image/svg+xml'
});
/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */ var $030f19b5f1555355$var$NAMESPACE = $030f19b5f1555355$var$freeze({
    /**
	 * The XHTML namespace.
	 *
	 * @see http://www.w3.org/1999/xhtml
	 */ HTML: 'http://www.w3.org/1999/xhtml',
    /**
	 * Checks if `uri` equals `NAMESPACE.HTML`.
	 *
	 * @param {string} [uri]
	 *
	 * @see NAMESPACE.HTML
	 */ isHTML: function(uri) {
        return uri === $030f19b5f1555355$var$NAMESPACE.HTML;
    },
    /**
	 * The SVG namespace.
	 *
	 * @see http://www.w3.org/2000/svg
	 */ SVG: 'http://www.w3.org/2000/svg',
    /**
	 * The `xml:` namespace.
	 *
	 * @see http://www.w3.org/XML/1998/namespace
	 */ XML: 'http://www.w3.org/XML/1998/namespace',
    /**
	 * The `xmlns:` namespace
	 *
	 * @see https://www.w3.org/2000/xmlns/
	 */ XMLNS: 'http://www.w3.org/2000/xmlns/'
});
$030f19b5f1555355$export$e6e34fd1f2686227 = $030f19b5f1555355$var$assign;
$030f19b5f1555355$export$71aa6c912b956294 = $030f19b5f1555355$var$find;
$030f19b5f1555355$export$792f3d81ea979f55 = $030f19b5f1555355$var$freeze;
$030f19b5f1555355$export$c6cb9dd1e3ada1aa = $030f19b5f1555355$var$MIME_TYPE;
$030f19b5f1555355$export$6aad947bda0f3f46 = $030f19b5f1555355$var$NAMESPACE;

});

parcelRegister("cCG51", function(module, exports) {

$parcel$export(module.exports, "DOMImplementation", () => $9309ace163a8dad0$export$455426655eab1d48, (v) => $9309ace163a8dad0$export$455426655eab1d48 = v);
$parcel$export(module.exports, "XMLSerializer", () => $9309ace163a8dad0$export$64f0bed4ae6f0f24, (v) => $9309ace163a8dad0$export$64f0bed4ae6f0f24 = v);
//if(typeof require == 'function'){
var $9309ace163a8dad0$export$d1d99cf900472499;
var $9309ace163a8dad0$export$fe58bcf938607f6a;
var $9309ace163a8dad0$export$455426655eab1d48;
var $9309ace163a8dad0$export$db77ccec0bb4ccac;
var $9309ace163a8dad0$export$85c928794f8d04d4;
var $9309ace163a8dad0$export$79b41aa5d56abdff;
var $9309ace163a8dad0$export$5118471ee5d5453b;
var $9309ace163a8dad0$export$64f0bed4ae6f0f24;

var $ghxvC = parcelRequire("ghxvC");
var $9309ace163a8dad0$var$find = $ghxvC.find;
var $9309ace163a8dad0$var$NAMESPACE = $ghxvC.NAMESPACE;
/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */ function $9309ace163a8dad0$var$notEmptyString(input) {
    return input !== '';
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */ function $9309ace163a8dad0$var$splitOnASCIIWhitespace(input) {
    // U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
    return input ? input.split(/[\t\n\f\r ]+/).filter($9309ace163a8dad0$var$notEmptyString) : [];
}
/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */ function $9309ace163a8dad0$var$orderedSetReducer(current, element) {
    if (!current.hasOwnProperty(element)) current[element] = true;
    return current;
}
/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */ function $9309ace163a8dad0$var$toOrderedSet(input) {
    if (!input) return [];
    var list = $9309ace163a8dad0$var$splitOnASCIIWhitespace(input);
    return Object.keys(list.reduce($9309ace163a8dad0$var$orderedSetReducer, {}));
}
/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */ function $9309ace163a8dad0$var$arrayIncludes(list) {
    return function(element) {
        return list && list.indexOf(element) !== -1;
    };
}
function $9309ace163a8dad0$var$copy(src, dest) {
    for(var p in src)if (Object.prototype.hasOwnProperty.call(src, p)) dest[p] = src[p];
}
/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */ function $9309ace163a8dad0$var$_extends(Class, Super) {
    var pt = Class.prototype;
    if (!(pt instanceof Super)) {
        function t() {}
        t.prototype = Super.prototype;
        t = new t();
        $9309ace163a8dad0$var$copy(pt, t);
        Class.prototype = pt = t;
    }
    if (pt.constructor != Class) {
        if (typeof Class != 'function') console.error("unknown Class:" + Class);
        pt.constructor = Class;
    }
}
// Node Types
var $9309ace163a8dad0$var$NodeType = {};
var $9309ace163a8dad0$var$ELEMENT_NODE = $9309ace163a8dad0$var$NodeType.ELEMENT_NODE = 1;
var $9309ace163a8dad0$var$ATTRIBUTE_NODE = $9309ace163a8dad0$var$NodeType.ATTRIBUTE_NODE = 2;
var $9309ace163a8dad0$var$TEXT_NODE = $9309ace163a8dad0$var$NodeType.TEXT_NODE = 3;
var $9309ace163a8dad0$var$CDATA_SECTION_NODE = $9309ace163a8dad0$var$NodeType.CDATA_SECTION_NODE = 4;
var $9309ace163a8dad0$var$ENTITY_REFERENCE_NODE = $9309ace163a8dad0$var$NodeType.ENTITY_REFERENCE_NODE = 5;
var $9309ace163a8dad0$var$ENTITY_NODE = $9309ace163a8dad0$var$NodeType.ENTITY_NODE = 6;
var $9309ace163a8dad0$var$PROCESSING_INSTRUCTION_NODE = $9309ace163a8dad0$var$NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var $9309ace163a8dad0$var$COMMENT_NODE = $9309ace163a8dad0$var$NodeType.COMMENT_NODE = 8;
var $9309ace163a8dad0$var$DOCUMENT_NODE = $9309ace163a8dad0$var$NodeType.DOCUMENT_NODE = 9;
var $9309ace163a8dad0$var$DOCUMENT_TYPE_NODE = $9309ace163a8dad0$var$NodeType.DOCUMENT_TYPE_NODE = 10;
var $9309ace163a8dad0$var$DOCUMENT_FRAGMENT_NODE = $9309ace163a8dad0$var$NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var $9309ace163a8dad0$var$NOTATION_NODE = $9309ace163a8dad0$var$NodeType.NOTATION_NODE = 12;
// ExceptionCode
var $9309ace163a8dad0$var$ExceptionCode = {};
var $9309ace163a8dad0$var$ExceptionMessage = {};
var $9309ace163a8dad0$var$INDEX_SIZE_ERR = $9309ace163a8dad0$var$ExceptionCode.INDEX_SIZE_ERR = ($9309ace163a8dad0$var$ExceptionMessage[1] = "Index size error", 1);
var $9309ace163a8dad0$var$DOMSTRING_SIZE_ERR = $9309ace163a8dad0$var$ExceptionCode.DOMSTRING_SIZE_ERR = ($9309ace163a8dad0$var$ExceptionMessage[2] = "DOMString size error", 2);
var $9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR = $9309ace163a8dad0$var$ExceptionCode.HIERARCHY_REQUEST_ERR = ($9309ace163a8dad0$var$ExceptionMessage[3] = "Hierarchy request error", 3);
var $9309ace163a8dad0$var$WRONG_DOCUMENT_ERR = $9309ace163a8dad0$var$ExceptionCode.WRONG_DOCUMENT_ERR = ($9309ace163a8dad0$var$ExceptionMessage[4] = "Wrong document", 4);
var $9309ace163a8dad0$var$INVALID_CHARACTER_ERR = $9309ace163a8dad0$var$ExceptionCode.INVALID_CHARACTER_ERR = ($9309ace163a8dad0$var$ExceptionMessage[5] = "Invalid character", 5);
var $9309ace163a8dad0$var$NO_DATA_ALLOWED_ERR = $9309ace163a8dad0$var$ExceptionCode.NO_DATA_ALLOWED_ERR = ($9309ace163a8dad0$var$ExceptionMessage[6] = "No data allowed", 6);
var $9309ace163a8dad0$var$NO_MODIFICATION_ALLOWED_ERR = $9309ace163a8dad0$var$ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ($9309ace163a8dad0$var$ExceptionMessage[7] = "No modification allowed", 7);
var $9309ace163a8dad0$var$NOT_FOUND_ERR = $9309ace163a8dad0$var$ExceptionCode.NOT_FOUND_ERR = ($9309ace163a8dad0$var$ExceptionMessage[8] = "Not found", 8);
var $9309ace163a8dad0$var$NOT_SUPPORTED_ERR = $9309ace163a8dad0$var$ExceptionCode.NOT_SUPPORTED_ERR = ($9309ace163a8dad0$var$ExceptionMessage[9] = "Not supported", 9);
var $9309ace163a8dad0$var$INUSE_ATTRIBUTE_ERR = $9309ace163a8dad0$var$ExceptionCode.INUSE_ATTRIBUTE_ERR = ($9309ace163a8dad0$var$ExceptionMessage[10] = "Attribute in use", 10);
//level2
var $9309ace163a8dad0$var$INVALID_STATE_ERR = $9309ace163a8dad0$var$ExceptionCode.INVALID_STATE_ERR = ($9309ace163a8dad0$var$ExceptionMessage[11] = "Invalid state", 11);
var $9309ace163a8dad0$var$SYNTAX_ERR = $9309ace163a8dad0$var$ExceptionCode.SYNTAX_ERR = ($9309ace163a8dad0$var$ExceptionMessage[12] = "Syntax error", 12);
var $9309ace163a8dad0$var$INVALID_MODIFICATION_ERR = $9309ace163a8dad0$var$ExceptionCode.INVALID_MODIFICATION_ERR = ($9309ace163a8dad0$var$ExceptionMessage[13] = "Invalid modification", 13);
var $9309ace163a8dad0$var$NAMESPACE_ERR = $9309ace163a8dad0$var$ExceptionCode.NAMESPACE_ERR = ($9309ace163a8dad0$var$ExceptionMessage[14] = "Invalid namespace", 14);
var $9309ace163a8dad0$var$INVALID_ACCESS_ERR = $9309ace163a8dad0$var$ExceptionCode.INVALID_ACCESS_ERR = ($9309ace163a8dad0$var$ExceptionMessage[15] = "Invalid access", 15);
/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */ function $9309ace163a8dad0$var$DOMException(code, message) {
    if (message instanceof Error) var error = message;
    else {
        error = this;
        Error.call(this, $9309ace163a8dad0$var$ExceptionMessage[code]);
        this.message = $9309ace163a8dad0$var$ExceptionMessage[code];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $9309ace163a8dad0$var$DOMException);
    }
    error.code = code;
    if (message) this.message = this.message + ": " + message;
    return error;
}
$9309ace163a8dad0$var$DOMException.prototype = Error.prototype;
$9309ace163a8dad0$var$copy($9309ace163a8dad0$var$ExceptionCode, $9309ace163a8dad0$var$DOMException);
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */ function $9309ace163a8dad0$var$NodeList() {}
$9309ace163a8dad0$var$NodeList.prototype = {
    /**
	 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
	 * @standard level1
	 */ length: 0,
    /**
	 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
	 * @standard level1
	 * @param index  unsigned long
	 *   Index into the collection.
	 * @return Node
	 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
	 */ item: function(index) {
        return index >= 0 && index < this.length ? this[index] : null;
    },
    toString: function(isHTML, nodeFilter, options) {
        var requireWellFormed = !!options && !!options.requireWellFormed;
        for(var buf = [], i = 0; i < this.length; i++)$9309ace163a8dad0$var$serializeToString(this[i], buf, isHTML, nodeFilter, null, requireWellFormed);
        return buf.join('');
    },
    /**
	 * @private
	 * @param {function (Node):boolean} predicate
	 * @returns {Node[]}
	 */ filter: function(predicate) {
        return Array.prototype.filter.call(this, predicate);
    },
    /**
	 * @private
	 * @param {Node} item
	 * @returns {number}
	 */ indexOf: function(item) {
        return Array.prototype.indexOf.call(this, item);
    }
};
function $9309ace163a8dad0$var$LiveNodeList(node, refresh) {
    this._node = node;
    this._refresh = refresh;
    $9309ace163a8dad0$var$_updateLiveList(this);
}
function $9309ace163a8dad0$var$_updateLiveList(list) {
    var inc = list._node._inc || list._node.ownerDocument._inc;
    if (list._inc !== inc) {
        var ls = list._refresh(list._node);
        $9309ace163a8dad0$var$__set__(list, 'length', ls.length);
        if (!list.$$length || ls.length < list.$$length) {
            for(var i = ls.length; i in list; i++)if (Object.prototype.hasOwnProperty.call(list, i)) delete list[i];
        }
        $9309ace163a8dad0$var$copy(ls, list);
        list._inc = inc;
    }
}
$9309ace163a8dad0$var$LiveNodeList.prototype.item = function(i) {
    $9309ace163a8dad0$var$_updateLiveList(this);
    return this[i] || null;
};
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$LiveNodeList, $9309ace163a8dad0$var$NodeList);
/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities
 */ function $9309ace163a8dad0$var$NamedNodeMap() {}
function $9309ace163a8dad0$var$_findNodeIndex(list, node) {
    var i = list.length;
    while(i--){
        if (list[i] === node) return i;
    }
}
function $9309ace163a8dad0$var$_addNamedNode(el, list, newAttr, oldAttr) {
    if (oldAttr) list[$9309ace163a8dad0$var$_findNodeIndex(list, oldAttr)] = newAttr;
    else list[list.length++] = newAttr;
    if (el) {
        newAttr.ownerElement = el;
        var doc = el.ownerDocument;
        if (doc) {
            oldAttr && $9309ace163a8dad0$var$_onRemoveAttribute(doc, el, oldAttr);
            $9309ace163a8dad0$var$_onAddAttribute(doc, el, newAttr);
        }
    }
}
function $9309ace163a8dad0$var$_removeNamedNode(el, list, attr) {
    //console.log('remove attr:'+attr)
    var i = $9309ace163a8dad0$var$_findNodeIndex(list, attr);
    if (i >= 0) {
        var lastIndex = list.length - 1;
        while(i < lastIndex)list[i] = list[++i];
        list.length = lastIndex;
        if (el) {
            var doc = el.ownerDocument;
            if (doc) {
                $9309ace163a8dad0$var$_onRemoveAttribute(doc, el, attr);
                attr.ownerElement = null;
            }
        }
    } else throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$NOT_FOUND_ERR, new Error(el.tagName + '@' + attr));
}
$9309ace163a8dad0$var$NamedNodeMap.prototype = {
    length: 0,
    item: $9309ace163a8dad0$var$NodeList.prototype.item,
    getNamedItem: function(key) {
        //		if(key.indexOf(':')>0 || key == 'xmlns'){
        //			return null;
        //		}
        //console.log()
        var i = this.length;
        while(i--){
            var attr = this[i];
            //console.log(attr.nodeName,key)
            if (attr.nodeName == key) return attr;
        }
    },
    setNamedItem: function(attr) {
        var el = attr.ownerElement;
        if (el && el != this._ownerElement) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$INUSE_ATTRIBUTE_ERR);
        var oldAttr = this.getNamedItem(attr.nodeName);
        $9309ace163a8dad0$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ setNamedItemNS: function(attr) {
        var el = attr.ownerElement, oldAttr;
        if (el && el != this._ownerElement) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$INUSE_ATTRIBUTE_ERR);
        oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
        $9309ace163a8dad0$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ removeNamedItem: function(key) {
        var attr = this.getNamedItem(key);
        $9309ace163a8dad0$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    //for level2
    removeNamedItemNS: function(namespaceURI, localName) {
        var attr = this.getNamedItemNS(namespaceURI, localName);
        $9309ace163a8dad0$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    getNamedItemNS: function(namespaceURI, localName) {
        var i = this.length;
        while(i--){
            var node = this[i];
            if (node.localName == localName && node.namespaceURI == namespaceURI) return node;
        }
        return null;
    }
};
/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */ function $9309ace163a8dad0$var$DOMImplementation() {}
$9309ace163a8dad0$var$DOMImplementation.prototype = {
    /**
	 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
	 * The different implementations fairly diverged in what kind of features were reported.
	 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
	 *
	 * @deprecated It is deprecated and modern browsers return true in all cases.
	 *
	 * @param {string} feature
	 * @param {string} [version]
	 * @returns {boolean} always true
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
	 */ hasFeature: function(feature, version) {
        return true;
    },
    /**
	 * Creates an XML Document object of the specified type with its document element.
	 *
	 * __It behaves slightly different from the description in the living standard__:
	 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
	 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string|null} namespaceURI
	 * @param {string} qualifiedName
	 * @param {DocumentType=null} doctype
	 * @returns {Document}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocument: function(namespaceURI, qualifiedName, doctype) {
        var doc = new $9309ace163a8dad0$var$Document();
        doc.implementation = this;
        doc.childNodes = new $9309ace163a8dad0$var$NodeList();
        doc.doctype = doctype || null;
        if (doctype) doc.appendChild(doctype);
        if (qualifiedName) {
            var root = doc.createElementNS(namespaceURI, qualifiedName);
            doc.appendChild(root);
        }
        return doc;
    },
    /**
	 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
	 *
	 * __This implementation differs from the specification:__
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * Note: `internalSubset` can only be introduced via a direct property write to `node.internalSubset` after creation.
	 * Creation-time validation of `publicId`, `systemId` is not enforced.
	 * The serializer-level check covers all mutation vectors, including direct property writes.
	 * `internalSubset` is only serialized as `[ ... ]` when both `publicId` and `systemId` are
	 * absent (empty or `'.'`) — if either external identifier is present, `internalSubset` is
	 * silently omitted from the serialized output.
	 *
	 * @param {string} qualifiedName
	 * @param {string} [publicId]
	 * The external subset public identifier. Stored verbatim including surrounding quotes.
	 * When serialized with `requireWellFormed: true` (via the 4th-parameter options object),
	 * throws `DOMException` with code `INVALID_STATE_ERR` if the value is non-empty and does
	 * not match the XML `PubidLiteral` production (W3C DOM Parsing §3.2.1.3; XML 1.0 [12]).
	 * @param {string} [systemId]
	 * The external subset system identifier. Stored verbatim including surrounding quotes.
	 * When serialized with `requireWellFormed: true`, throws `DOMException` with code
	 * `INVALID_STATE_ERR` if the value is non-empty and does not match the XML `SystemLiteral`
	 * production (W3C DOM Parsing §3.2.1.3; XML 1.0 [11]).
	 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
	 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocumentType: function(qualifiedName, publicId, systemId) {
        var node = new $9309ace163a8dad0$var$DocumentType();
        node.name = qualifiedName;
        node.nodeName = qualifiedName;
        node.publicId = publicId || '';
        node.systemId = systemId || '';
        return node;
    }
};
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */ function $9309ace163a8dad0$var$Node() {}
$9309ace163a8dad0$var$Node.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    // Modified in DOM Level 2:
    insertBefore: function(newChild, refChild) {
        return $9309ace163a8dad0$var$_insertBefore(this, newChild, refChild);
    },
    replaceChild: function(newChild, oldChild) {
        $9309ace163a8dad0$var$_insertBefore(this, newChild, oldChild, $9309ace163a8dad0$var$assertPreReplacementValidityInDocument);
        if (oldChild) this.removeChild(oldChild);
    },
    removeChild: function(oldChild) {
        return $9309ace163a8dad0$var$_removeChild(this, oldChild);
    },
    appendChild: function(newChild) {
        return this.insertBefore(newChild, null);
    },
    hasChildNodes: function() {
        return this.firstChild != null;
    },
    cloneNode: function(deep) {
        return $9309ace163a8dad0$var$cloneNode(this.ownerDocument || this, this, deep);
    },
    // Modified in DOM Level 2:
    /**
	 * Puts the specified node and all of its subtree into a "normalized" form. In a normalized
	 * subtree, no text nodes in the subtree are empty and there are no adjacent text nodes.
	 *
	 * Specifically, this method merges any adjacent text nodes (i.e., nodes for which `nodeType`
	 * is `TEXT_NODE`) into a single node with the combined data. It also removes any empty text
	 * nodes.
	 *
	 * This method iteratively traverses all child nodes to normalize all descendant nodes within
	 * the subtree.
	 *
	 * @throws {DOMException}
	 * May throw a DOMException if operations within removeChild or appendData (which are
	 * potentially invoked in this method) do not meet their specific constraints.
	 * @see {@link Node.removeChild}
	 * @see {@link CharacterData.appendData}
	 * @see ../docs/walk-dom.md.
	 */ normalize: function() {
        $9309ace163a8dad0$var$walkDOM(this, null, {
            enter: function(node) {
                // Merge adjacent text children of node before walkDOM schedules them.
                // walkDOM reads lastChild/previousSibling after enter returns, so the
                // surviving post-merge children are what it descends into.
                var child = node.firstChild;
                while(child){
                    var next = child.nextSibling;
                    if (next !== null && next.nodeType === $9309ace163a8dad0$var$TEXT_NODE && child.nodeType === $9309ace163a8dad0$var$TEXT_NODE) {
                        node.removeChild(next);
                        child.appendData(next.data);
                    // Do not advance child: re-check new nextSibling for another text run
                    } else child = next;
                }
                return true; // descend into surviving children
            }
        });
    },
    // Introduced in DOM Level 2:
    isSupported: function(feature, version) {
        return this.ownerDocument.implementation.hasFeature(feature, version);
    },
    // Introduced in DOM Level 2:
    hasAttributes: function() {
        return this.attributes.length > 0;
    },
    /**
	 * Look up the prefix associated to the given namespace URI, starting from this node.
	 * **The default namespace declarations are ignored by this method.**
	 * See Namespace Prefix Lookup for details on the algorithm used by this method.
	 *
	 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
	 *
	 * @param {string | null} namespaceURI
	 * @returns {string | null}
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
	 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
	 * @see https://github.com/xmldom/xmldom/issues/322
	 */ lookupPrefix: function(namespaceURI) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) for(var n in map){
                if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) return n;
            }
            el = el.nodeType == $9309ace163a8dad0$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI: function(prefix) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) {
                if (Object.prototype.hasOwnProperty.call(map, prefix)) return map[prefix];
            }
            el = el.nodeType == $9309ace163a8dad0$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace: function(namespaceURI) {
        var prefix = this.lookupPrefix(namespaceURI);
        return prefix == null;
    }
};
function $9309ace163a8dad0$var$_xmlEncoder(c) {
    return c == '<' && '&lt;' || c == '>' && '&gt;' || c == '&' && '&amp;' || c == '"' && '&quot;' || '&#' + c.charCodeAt() + ';';
}
$9309ace163a8dad0$var$copy($9309ace163a8dad0$var$NodeType, $9309ace163a8dad0$var$Node);
$9309ace163a8dad0$var$copy($9309ace163a8dad0$var$NodeType, $9309ace163a8dad0$var$Node.prototype);
/**
 * @param {Node} node
 * Root of the subtree to visit.
 * @param {function(Node): boolean} callback
 * Called for each node in depth-first pre-order. Return a truthy value to stop traversal early.
 * @return {boolean} `true` if traversal was aborted by the callback, `false` otherwise.
 */ function $9309ace163a8dad0$var$_visitNode(node, callback) {
    return $9309ace163a8dad0$var$walkDOM(node, null, {
        enter: function(n) {
            return callback(n) ? $9309ace163a8dad0$var$walkDOM.STOP : true;
        }
    }) === $9309ace163a8dad0$var$walkDOM.STOP;
}
/**
 * Depth-first pre/post-order DOM tree walker.
 *
 * Visits every node in the subtree rooted at `node`. For each node:
 *
 * 1. Calls `callbacks.enter(node, context)` before descending into the node's children. The
 * return value becomes the `context` passed to each child's `enter` call and to the matching
 * `exit` call.
 * 2. If `enter` returns `null` or `undefined`, the node's children are skipped;
 * sibling traversal continues normally.
 * 3. If `enter` returns `walkDOM.STOP`, the entire traversal is aborted immediately — no
 * further `enter` or `exit` calls are made.
 * 4. `lastChild` and `previousSibling` are read **after** `enter` returns, so `enter` may
 * safely modify the node's own child list before the walker descends. Modifying siblings of
 * the current node or any other part of the tree produces unpredictable results: nodes already
 * queued on the stack are visited regardless of DOM changes, and newly inserted nodes outside
 * the current child list are never visited.
 * 5. Calls `callbacks.exit(node, context)` (if provided) after all of a node's children have
 * been visited, passing the same `context` that `enter`
 * returned for that node.
 *
 * This implementation uses an explicit stack and does not recurse — it is safe on arbitrarily
 * deep trees.
 *
 * @param {Node} node
 * Root of the subtree to walk.
 * @param {*} context
 * Initial context value passed to the root node's `enter`.
 * @param {{ enter: function(Node, *): *, exit?: function(Node, *): void }} callbacks
 * @returns {void | walkDOM.STOP}
 * @see ../docs/walk-dom.md.
 */ function $9309ace163a8dad0$var$walkDOM(node, context, callbacks) {
    // Each stack frame is {node, context, phase}:
    //   walkDOM.ENTER — call enter, then push children
    //   walkDOM.EXIT  — call exit
    var stack = [
        {
            node: node,
            context: context,
            phase: $9309ace163a8dad0$var$walkDOM.ENTER
        }
    ];
    while(stack.length > 0){
        var frame = stack.pop();
        if (frame.phase === $9309ace163a8dad0$var$walkDOM.ENTER) {
            var childContext = callbacks.enter(frame.node, frame.context);
            if (childContext === $9309ace163a8dad0$var$walkDOM.STOP) return $9309ace163a8dad0$var$walkDOM.STOP;
            // Push exit frame before children so it fires after all children are processed (Last In First Out)
            stack.push({
                node: frame.node,
                context: childContext,
                phase: $9309ace163a8dad0$var$walkDOM.EXIT
            });
            if (childContext === null || childContext === undefined) continue; // skip children
            // lastChild is read after enter returns, so enter may modify the child list.
            var child = frame.node.lastChild;
            // Traverse from lastChild backwards so that pushing onto the stack
            // naturally yields firstChild on top (processed first).
            while(child){
                stack.push({
                    node: child,
                    context: childContext,
                    phase: $9309ace163a8dad0$var$walkDOM.ENTER
                });
                child = child.previousSibling;
            }
        } else // frame.phase === walkDOM.EXIT
        if (callbacks.exit) callbacks.exit(frame.node, frame.context);
    }
}
/**
 * Sentinel value returned from a `walkDOM` `enter` callback to abort the entire traversal
 * immediately.
 *
 * @type {symbol}
 */ $9309ace163a8dad0$var$walkDOM.STOP = Symbol('walkDOM.STOP');
/**
 * Phase constant for a stack frame that has not yet been visited.
 * The `enter` callback is called and children are scheduled.
 *
 * @type {number}
 */ $9309ace163a8dad0$var$walkDOM.ENTER = 0;
/**
 * Phase constant for a stack frame whose subtree has been fully visited.
 * The `exit` callback is called.
 *
 * @type {number}
 */ $9309ace163a8dad0$var$walkDOM.EXIT = 1;
function $9309ace163a8dad0$var$Document() {
    this.ownerDocument = this;
}
function $9309ace163a8dad0$var$_onAddAttribute(doc, el, newAttr) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $9309ace163a8dad0$var$NAMESPACE.XMLNS) //update namespace
    el._nsMap[newAttr.prefix ? newAttr.localName : ''] = newAttr.value;
}
function $9309ace163a8dad0$var$_onRemoveAttribute(doc, el, newAttr, remove) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $9309ace163a8dad0$var$NAMESPACE.XMLNS) //update namespace
    delete el._nsMap[newAttr.prefix ? newAttr.localName : ''];
}
/**
 * Updates `el.childNodes`, updating the indexed items and it's `length`.
 * Passing `newChild` means it will be appended.
 * Otherwise it's assumed that an item has been removed,
 * and `el.firstNode` and it's `.nextSibling` are used
 * to walk the current list of child nodes.
 *
 * @param {Document} doc
 * @param {Node} el
 * @param {Node} [newChild]
 * @private
 */ function $9309ace163a8dad0$var$_onUpdateChild(doc, el, newChild) {
    if (doc && doc._inc) {
        doc._inc++;
        //update childNodes
        var cs = el.childNodes;
        if (newChild) cs[cs.length++] = newChild;
        else {
            var child = el.firstChild;
            var i = 0;
            while(child){
                cs[i++] = child;
                child = child.nextSibling;
            }
            cs.length = i;
            delete cs[cs.length];
        }
    }
}
/**
 * Removes the connections between `parentNode` and `child`
 * and any existing `child.previousSibling` or `child.nextSibling`.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 *
 * @param {Node} parentNode
 * @param {Node} child
 * @returns {Node} the child that was removed.
 * @private
 */ function $9309ace163a8dad0$var$_removeChild(parentNode, child) {
    var previous = child.previousSibling;
    var next = child.nextSibling;
    if (previous) previous.nextSibling = next;
    else parentNode.firstChild = next;
    if (next) next.previousSibling = previous;
    else parentNode.lastChild = previous;
    child.parentNode = null;
    child.previousSibling = null;
    child.nextSibling = null;
    $9309ace163a8dad0$var$_onUpdateChild(parentNode.ownerDocument, parentNode);
    return child;
}
/**
 * Returns `true` if `node` can be a parent for insertion.
 * @param {Node} node
 * @returns {boolean}
 */ function $9309ace163a8dad0$var$hasValidParentNodeType(node) {
    return node && (node.nodeType === $9309ace163a8dad0$var$Node.DOCUMENT_NODE || node.nodeType === $9309ace163a8dad0$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $9309ace163a8dad0$var$Node.ELEMENT_NODE);
}
/**
 * Returns `true` if `node` can be inserted according to it's `nodeType`.
 * @param {Node} node
 * @returns {boolean}
 */ function $9309ace163a8dad0$var$hasInsertableNodeType(node) {
    return node && ($9309ace163a8dad0$var$isElementNode(node) || $9309ace163a8dad0$var$isTextNode(node) || $9309ace163a8dad0$var$isDocTypeNode(node) || node.nodeType === $9309ace163a8dad0$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $9309ace163a8dad0$var$Node.COMMENT_NODE || node.nodeType === $9309ace163a8dad0$var$Node.PROCESSING_INSTRUCTION_NODE);
}
/**
 * Returns true if `node` is a DOCTYPE node
 * @param {Node} node
 * @returns {boolean}
 */ function $9309ace163a8dad0$var$isDocTypeNode(node) {
    return node && node.nodeType === $9309ace163a8dad0$var$Node.DOCUMENT_TYPE_NODE;
}
/**
 * Returns true if the node is an element
 * @param {Node} node
 * @returns {boolean}
 */ function $9309ace163a8dad0$var$isElementNode(node) {
    return node && node.nodeType === $9309ace163a8dad0$var$Node.ELEMENT_NODE;
}
/**
 * Returns true if `node` is a text node
 * @param {Node} node
 * @returns {boolean}
 */ function $9309ace163a8dad0$var$isTextNode(node) {
    return node && node.nodeType === $9309ace163a8dad0$var$Node.TEXT_NODE;
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Document} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $9309ace163a8dad0$var$isElementInsertionPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    if ($9309ace163a8dad0$var$find(parentChildNodes, $9309ace163a8dad0$var$isElementNode) || $9309ace163a8dad0$var$isDocTypeNode(child)) return false;
    var docTypeNode = $9309ace163a8dad0$var$find(parentChildNodes, $9309ace163a8dad0$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Node} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $9309ace163a8dad0$var$isElementReplacementPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    function hasElementChildThatIsNotChild(node) {
        return $9309ace163a8dad0$var$isElementNode(node) && node !== child;
    }
    if ($9309ace163a8dad0$var$find(parentChildNodes, hasElementChildThatIsNotChild)) return false;
    var docTypeNode = $9309ace163a8dad0$var$find(parentChildNodes, $9309ace163a8dad0$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * @private
 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
 *
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $9309ace163a8dad0$var$assertPreInsertionValidity1to5(parent, node, child) {
    // 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
    if (!$9309ace163a8dad0$var$hasValidParentNodeType(parent)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'Unexpected parent node type ' + parent.nodeType);
    // 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
    // not implemented!
    // 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
    if (child && child.parentNode !== parent) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$NOT_FOUND_ERR, 'child not in parent');
    if (// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !$9309ace163a8dad0$var$hasInsertableNodeType(node) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    $9309ace163a8dad0$var$isDocTypeNode(node) && parent.nodeType !== $9309ace163a8dad0$var$Node.DOCUMENT_NODE) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'Unexpected node type ' + node.nodeType + ' for parent node type ' + parent.nodeType);
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $9309ace163a8dad0$var$assertPreInsertionValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $9309ace163a8dad0$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($9309ace163a8dad0$var$isElementNode);
        // If node has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $9309ace163a8dad0$var$find(nodeChildNodes, $9309ace163a8dad0$var$isTextNode)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
        // Otherwise, if `node` has one element child and either `parent` has an element child,
        // `child` is a doctype, or `child` is non-null and a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$9309ace163a8dad0$var$isElementInsertionPossible(parent, child)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
    // Element
    if ($9309ace163a8dad0$var$isElementNode(node)) {
        // `parent` has an element child, `child` is a doctype,
        // or `child` is non-null and a doctype is following `child`.
        if (!$9309ace163a8dad0$var$isElementInsertionPossible(parent, child)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
    // DocumentType
    if ($9309ace163a8dad0$var$isDocTypeNode(node)) {
        // `parent` has a doctype child,
        if ($9309ace163a8dad0$var$find(parentChildNodes, $9309ace163a8dad0$var$isDocTypeNode)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
        var parentElementChild = $9309ace163a8dad0$var$find(parentChildNodes, $9309ace163a8dad0$var$isElementNode);
        // `child` is non-null and an element is preceding `child`,
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
        // or `child` is null and `parent` has an element child.
        if (!child && parentElementChild) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'Doctype can not be appended since element is present');
    }
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $9309ace163a8dad0$var$assertPreReplacementValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $9309ace163a8dad0$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($9309ace163a8dad0$var$isElementNode);
        // If `node` has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $9309ace163a8dad0$var$find(nodeChildNodes, $9309ace163a8dad0$var$isTextNode)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
        // Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$9309ace163a8dad0$var$isElementReplacementPossible(parent, child)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
    // Element
    if ($9309ace163a8dad0$var$isElementNode(node)) {
        // `parent` has an element child that is not `child` or a doctype is following `child`.
        if (!$9309ace163a8dad0$var$isElementReplacementPossible(parent, child)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
    // DocumentType
    if ($9309ace163a8dad0$var$isDocTypeNode(node)) {
        function hasDoctypeChildThatIsNotChild(node) {
            return $9309ace163a8dad0$var$isDocTypeNode(node) && node !== child;
        }
        // `parent` has a doctype child that is not `child`,
        if ($9309ace163a8dad0$var$find(parentChildNodes, hasDoctypeChildThatIsNotChild)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
        var parentElementChild = $9309ace163a8dad0$var$find(parentChildNodes, $9309ace163a8dad0$var$isElementNode);
        // or an element is preceding `child`.
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
    }
}
/**
 * @private
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $9309ace163a8dad0$var$_insertBefore(parent, node, child, _inDocumentAssertion) {
    // To ensure pre-insertion validity of a node into a parent before a child, run these steps:
    $9309ace163a8dad0$var$assertPreInsertionValidity1to5(parent, node, child);
    // If parent is a document, and any of the statements below, switched on the interface node implements,
    // are true, then throw a "HierarchyRequestError" DOMException.
    if (parent.nodeType === $9309ace163a8dad0$var$Node.DOCUMENT_NODE) (_inDocumentAssertion || $9309ace163a8dad0$var$assertPreInsertionValidityInDocument)(parent, node, child);
    var cp = node.parentNode;
    if (cp) cp.removeChild(node); //remove and update
    if (node.nodeType === $9309ace163a8dad0$var$DOCUMENT_FRAGMENT_NODE) {
        var newFirst = node.firstChild;
        if (newFirst == null) return node;
        var newLast = node.lastChild;
    } else newFirst = newLast = node;
    var pre = child ? child.previousSibling : parent.lastChild;
    newFirst.previousSibling = pre;
    newLast.nextSibling = child;
    if (pre) pre.nextSibling = newFirst;
    else parent.firstChild = newFirst;
    if (child == null) parent.lastChild = newLast;
    else child.previousSibling = newLast;
    do {
        newFirst.parentNode = parent;
        // Update ownerDocument for each node being inserted
        var targetDoc = parent.ownerDocument || parent;
        $9309ace163a8dad0$var$_updateOwnerDocument(newFirst, targetDoc);
    }while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
    $9309ace163a8dad0$var$_onUpdateChild(parent.ownerDocument || parent, parent);
    //console.log(parent.lastChild.nextSibling == null)
    if (node.nodeType == $9309ace163a8dad0$var$DOCUMENT_FRAGMENT_NODE) node.firstChild = node.lastChild = null;
    return node;
}
/**
 * Recursively updates the ownerDocument property for a node and all its descendants
 * @param {Node} node
 * @param {Document} newOwnerDocument
 * @private
 */ function $9309ace163a8dad0$var$_updateOwnerDocument(node, newOwnerDocument) {
    if (node.ownerDocument === newOwnerDocument) return;
    node.ownerDocument = newOwnerDocument;
    // Update attributes if this is an element
    if (node.nodeType === $9309ace163a8dad0$var$ELEMENT_NODE && node.attributes) for(var i = 0; i < node.attributes.length; i++){
        var attr = node.attributes.item(i);
        if (attr) attr.ownerDocument = newOwnerDocument;
    }
    // Recursively update child nodes
    var child = node.firstChild;
    while(child){
        $9309ace163a8dad0$var$_updateOwnerDocument(child, newOwnerDocument);
        child = child.nextSibling;
    }
}
/**
 * Appends `newChild` to `parentNode`.
 * If `newChild` is already connected to a `parentNode` it is first removed from it.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 * @param {Node} parentNode
 * @param {Node} newChild
 * @returns {Node}
 * @private
 */ function $9309ace163a8dad0$var$_appendSingleChild(parentNode, newChild) {
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    newChild.parentNode = parentNode;
    newChild.previousSibling = parentNode.lastChild;
    newChild.nextSibling = null;
    if (newChild.previousSibling) newChild.previousSibling.nextSibling = newChild;
    else parentNode.firstChild = newChild;
    parentNode.lastChild = newChild;
    $9309ace163a8dad0$var$_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
    // Update ownerDocument for the new child and all its descendants
    var targetDoc = parentNode.ownerDocument || parentNode;
    $9309ace163a8dad0$var$_updateOwnerDocument(newChild, targetDoc);
    return newChild;
}
$9309ace163a8dad0$var$Document.prototype = {
    //implementation : null,
    nodeName: '#document',
    nodeType: $9309ace163a8dad0$var$DOCUMENT_NODE,
    /**
	 * The DocumentType node of the document.
	 *
	 * @readonly
	 * @type DocumentType
	 */ doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function(newChild, refChild) {
        if (newChild.nodeType == $9309ace163a8dad0$var$DOCUMENT_FRAGMENT_NODE) {
            var child = newChild.firstChild;
            while(child){
                var next = child.nextSibling;
                this.insertBefore(child, refChild);
                child = next;
            }
            return newChild;
        }
        $9309ace163a8dad0$var$_insertBefore(this, newChild, refChild);
        $9309ace163a8dad0$var$_updateOwnerDocument(newChild, this);
        if (this.documentElement === null && newChild.nodeType === $9309ace163a8dad0$var$ELEMENT_NODE) this.documentElement = newChild;
        return newChild;
    },
    removeChild: function(oldChild) {
        if (this.documentElement == oldChild) this.documentElement = null;
        return $9309ace163a8dad0$var$_removeChild(this, oldChild);
    },
    replaceChild: function(newChild, oldChild) {
        //raises
        $9309ace163a8dad0$var$_insertBefore(this, newChild, oldChild, $9309ace163a8dad0$var$assertPreReplacementValidityInDocument);
        $9309ace163a8dad0$var$_updateOwnerDocument(newChild, this);
        if (oldChild) this.removeChild(oldChild);
        if ($9309ace163a8dad0$var$isElementNode(newChild)) this.documentElement = newChild;
    },
    // Introduced in DOM Level 2:
    importNode: function(importedNode, deep) {
        return $9309ace163a8dad0$var$importNode(this, importedNode, deep);
    },
    // Introduced in DOM Level 2:
    getElementById: function(id) {
        var rtv = null;
        $9309ace163a8dad0$var$_visitNode(this.documentElement, function(node) {
            if (node.nodeType == $9309ace163a8dad0$var$ELEMENT_NODE) {
                if (node.getAttribute('id') == id) {
                    rtv = node;
                    return true;
                }
            }
        });
        return rtv;
    },
    /**
	 * The `getElementsByClassName` method of `Document` interface returns an array-like object
	 * of all child elements which have **all** of the given class name(s).
	 *
	 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
	 *
	 *
	 * Warning: This is a live LiveNodeList.
	 * Changes in the DOM will reflect in the array as the changes occur.
	 * If an element selected by this array no longer qualifies for the selector,
	 * it will automatically be removed. Be aware of this for iteration purposes.
	 *
	 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
	 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
	 */ getElementsByClassName: function(classNames) {
        var classNamesSet = $9309ace163a8dad0$var$toOrderedSet(classNames);
        return new $9309ace163a8dad0$var$LiveNodeList(this, function(base) {
            var ls = [];
            if (classNamesSet.length > 0) $9309ace163a8dad0$var$_visitNode(base.documentElement, function(node) {
                if (node !== base && node.nodeType === $9309ace163a8dad0$var$ELEMENT_NODE) {
                    var nodeClassNames = node.getAttribute('class');
                    // can be null if the attribute does not exist
                    if (nodeClassNames) {
                        // before splitting and iterating just compare them for the most common case
                        var matches = classNames === nodeClassNames;
                        if (!matches) {
                            var nodeClassNamesSet = $9309ace163a8dad0$var$toOrderedSet(nodeClassNames);
                            matches = classNamesSet.every($9309ace163a8dad0$var$arrayIncludes(nodeClassNamesSet));
                        }
                        if (matches) ls.push(node);
                    }
                }
            });
            return ls;
        });
    },
    //document factory method:
    createElement: function(tagName) {
        var node = new $9309ace163a8dad0$var$Element();
        node.ownerDocument = this;
        node.nodeName = tagName;
        node.tagName = tagName;
        node.localName = tagName;
        node.childNodes = new $9309ace163a8dad0$var$NodeList();
        var attrs = node.attributes = new $9309ace163a8dad0$var$NamedNodeMap();
        attrs._ownerElement = node;
        return node;
    },
    createDocumentFragment: function() {
        var node = new $9309ace163a8dad0$var$DocumentFragment();
        node.ownerDocument = this;
        node.childNodes = new $9309ace163a8dad0$var$NodeList();
        return node;
    },
    createTextNode: function(data) {
        var node = new $9309ace163a8dad0$var$Text();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createComment: function(data) {
        var node = new $9309ace163a8dad0$var$Comment();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    /**
	 * Returns a new CDATASection node whose data is `data`.
	 *
	 * __This implementation differs from the specification:__
	 * - calling this method on an HTML document does not throw `NotSupportedError`.
	 *
	 * @param {string} data
	 * @returns {CDATASection}
	 * @throws DOMException with code `INVALID_CHARACTER_ERR` if `data` contains `"]]>"`.
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/createCDATASection
	 * @see https://dom.spec.whatwg.org/#dom-document-createcdatasection
	 */ createCDATASection: function(data) {
        if (data.indexOf(']]>') !== -1) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$INVALID_CHARACTER_ERR, 'data contains "]]>"');
        var node = new $9309ace163a8dad0$var$CDATASection();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    /**
	 * Returns a ProcessingInstruction node whose target is target and data is data.
	 *
	 * __This implementation differs from the specification:__
	 * - it does not do any input validation on the arguments and doesn't throw "InvalidCharacterError".
	 *
	 * Note: When the resulting document is serialized with `requireWellFormed: true`, the
	 * serializer throws with code `INVALID_STATE_ERR` if `.data` contains `?>` (W3C DOM Parsing
	 * §3.2.1.7). Without that option the data is emitted verbatim.
	 *
	 * @param {string} target
	 * @param {string} data
	 * @returns {ProcessingInstruction}
	 * @see https://developer.mozilla.org/docs/Web/API/Document/createProcessingInstruction
	 * @see https://dom.spec.whatwg.org/#dom-document-createprocessinginstruction
	 * @see https://www.w3.org/TR/DOM-Parsing/#dfn-concept-serialize-xml §3.2.1.7
	 */ createProcessingInstruction: function(target, data) {
        var node = new $9309ace163a8dad0$var$ProcessingInstruction();
        node.ownerDocument = this;
        node.tagName = node.nodeName = node.target = target;
        node.nodeValue = node.data = data;
        return node;
    },
    createAttribute: function(name) {
        var node = new $9309ace163a8dad0$var$Attr();
        node.ownerDocument = this;
        node.name = name;
        node.nodeName = name;
        node.localName = name;
        node.specified = true;
        return node;
    },
    createEntityReference: function(name) {
        var node = new $9309ace163a8dad0$var$EntityReference();
        node.ownerDocument = this;
        node.nodeName = name;
        return node;
    },
    // Introduced in DOM Level 2:
    createElementNS: function(namespaceURI, qualifiedName) {
        var node = new $9309ace163a8dad0$var$Element();
        var pl = qualifiedName.split(':');
        var attrs = node.attributes = new $9309ace163a8dad0$var$NamedNodeMap();
        node.childNodes = new $9309ace163a8dad0$var$NodeList();
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.tagName = qualifiedName;
        node.namespaceURI = namespaceURI;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        attrs._ownerElement = node;
        return node;
    },
    // Introduced in DOM Level 2:
    createAttributeNS: function(namespaceURI, qualifiedName) {
        var node = new $9309ace163a8dad0$var$Attr();
        var pl = qualifiedName.split(':');
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.name = qualifiedName;
        node.namespaceURI = namespaceURI;
        node.specified = true;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        return node;
    }
};
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$Document, $9309ace163a8dad0$var$Node);
function $9309ace163a8dad0$var$Element() {
    this._nsMap = {};
}
$9309ace163a8dad0$var$Element.prototype = {
    nodeType: $9309ace163a8dad0$var$ELEMENT_NODE,
    hasAttribute: function(name) {
        return this.getAttributeNode(name) != null;
    },
    getAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        return attr && attr.value || '';
    },
    getAttributeNode: function(name) {
        return this.attributes.getNamedItem(name);
    },
    setAttribute: function(name, value) {
        var attr = this.ownerDocument.createAttribute(name);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    removeAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        attr && this.removeAttributeNode(attr);
    },
    //four real opeartion method
    appendChild: function(newChild) {
        if (newChild.nodeType === $9309ace163a8dad0$var$DOCUMENT_FRAGMENT_NODE) return this.insertBefore(newChild, null);
        else return $9309ace163a8dad0$var$_appendSingleChild(this, newChild);
    },
    setAttributeNode: function(newAttr) {
        return this.attributes.setNamedItem(newAttr);
    },
    setAttributeNodeNS: function(newAttr) {
        return this.attributes.setNamedItemNS(newAttr);
    },
    removeAttributeNode: function(oldAttr) {
        //console.log(this == oldAttr.ownerElement)
        return this.attributes.removeNamedItem(oldAttr.nodeName);
    },
    //get real attribute name,and remove it by removeAttributeNode
    removeAttributeNS: function(namespaceURI, localName) {
        var old = this.getAttributeNodeNS(namespaceURI, localName);
        old && this.removeAttributeNode(old);
    },
    hasAttributeNS: function(namespaceURI, localName) {
        return this.getAttributeNodeNS(namespaceURI, localName) != null;
    },
    getAttributeNS: function(namespaceURI, localName) {
        var attr = this.getAttributeNodeNS(namespaceURI, localName);
        return attr && attr.value || '';
    },
    setAttributeNS: function(namespaceURI, qualifiedName, value) {
        var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    getAttributeNodeNS: function(namespaceURI, localName) {
        return this.attributes.getNamedItemNS(namespaceURI, localName);
    },
    getElementsByTagName: function(tagName) {
        return new $9309ace163a8dad0$var$LiveNodeList(this, function(base) {
            var ls = [];
            $9309ace163a8dad0$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType == $9309ace163a8dad0$var$ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)) ls.push(node);
            });
            return ls;
        });
    },
    getElementsByTagNameNS: function(namespaceURI, localName) {
        return new $9309ace163a8dad0$var$LiveNodeList(this, function(base) {
            var ls = [];
            $9309ace163a8dad0$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType === $9309ace163a8dad0$var$ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)) ls.push(node);
            });
            return ls;
        });
    }
};
$9309ace163a8dad0$var$Document.prototype.getElementsByTagName = $9309ace163a8dad0$var$Element.prototype.getElementsByTagName;
$9309ace163a8dad0$var$Document.prototype.getElementsByTagNameNS = $9309ace163a8dad0$var$Element.prototype.getElementsByTagNameNS;
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$Element, $9309ace163a8dad0$var$Node);
function $9309ace163a8dad0$var$Attr() {}
$9309ace163a8dad0$var$Attr.prototype.nodeType = $9309ace163a8dad0$var$ATTRIBUTE_NODE;
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$Attr, $9309ace163a8dad0$var$Node);
function $9309ace163a8dad0$var$CharacterData() {}
$9309ace163a8dad0$var$CharacterData.prototype = {
    data: '',
    substringData: function(offset, count) {
        return this.data.substring(offset, offset + count);
    },
    appendData: function(text) {
        text = this.data + text;
        this.nodeValue = this.data = text;
        this.length = text.length;
    },
    insertData: function(offset, text) {
        this.replaceData(offset, 0, text);
    },
    appendChild: function(newChild) {
        throw new Error($9309ace163a8dad0$var$ExceptionMessage[$9309ace163a8dad0$var$HIERARCHY_REQUEST_ERR]);
    },
    deleteData: function(offset, count) {
        this.replaceData(offset, count, "");
    },
    replaceData: function(offset, count, text) {
        var start = this.data.substring(0, offset);
        var end = this.data.substring(offset + count);
        text = start + text + end;
        this.nodeValue = this.data = text;
        this.length = text.length;
    }
};
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$CharacterData, $9309ace163a8dad0$var$Node);
function $9309ace163a8dad0$var$Text() {}
$9309ace163a8dad0$var$Text.prototype = {
    nodeName: "#text",
    nodeType: $9309ace163a8dad0$var$TEXT_NODE,
    splitText: function(offset) {
        var text = this.data;
        var newText = text.substring(offset);
        text = text.substring(0, offset);
        this.data = this.nodeValue = text;
        this.length = text.length;
        var newNode = this.ownerDocument.createTextNode(newText);
        if (this.parentNode) this.parentNode.insertBefore(newNode, this.nextSibling);
        return newNode;
    }
};
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$Text, $9309ace163a8dad0$var$CharacterData);
function $9309ace163a8dad0$var$Comment() {}
$9309ace163a8dad0$var$Comment.prototype = {
    nodeName: "#comment",
    nodeType: $9309ace163a8dad0$var$COMMENT_NODE
};
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$Comment, $9309ace163a8dad0$var$CharacterData);
function $9309ace163a8dad0$var$CDATASection() {}
$9309ace163a8dad0$var$CDATASection.prototype = {
    nodeName: "#cdata-section",
    nodeType: $9309ace163a8dad0$var$CDATA_SECTION_NODE
};
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$CDATASection, $9309ace163a8dad0$var$CharacterData);
/**
 * Represents a DocumentType node (the `<!DOCTYPE ...>` declaration).
 *
 * `publicId`, `systemId`, and `internalSubset` are plain own-property assignments.
 * xmldom does not enforce the `readonly` constraint declared by the WHATWG DOM spec —
 * direct property writes succeed silently. Values are serialized verbatim when
 * `requireWellFormed` is false (the default). When the serializer is invoked with
 * `requireWellFormed: true` (via the 4th-parameter options object), it validates each
 * field and throws `DOMException` with code `INVALID_STATE_ERR` on invalid values.
 *
 * @class
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DocumentType MDN
 */ function $9309ace163a8dad0$var$DocumentType() {}
$9309ace163a8dad0$var$DocumentType.prototype.nodeType = $9309ace163a8dad0$var$DOCUMENT_TYPE_NODE;
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$DocumentType, $9309ace163a8dad0$var$Node);
function $9309ace163a8dad0$var$Notation() {}
$9309ace163a8dad0$var$Notation.prototype.nodeType = $9309ace163a8dad0$var$NOTATION_NODE;
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$Notation, $9309ace163a8dad0$var$Node);
function $9309ace163a8dad0$var$Entity() {}
$9309ace163a8dad0$var$Entity.prototype.nodeType = $9309ace163a8dad0$var$ENTITY_NODE;
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$Entity, $9309ace163a8dad0$var$Node);
function $9309ace163a8dad0$var$EntityReference() {}
$9309ace163a8dad0$var$EntityReference.prototype.nodeType = $9309ace163a8dad0$var$ENTITY_REFERENCE_NODE;
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$EntityReference, $9309ace163a8dad0$var$Node);
function $9309ace163a8dad0$var$DocumentFragment() {}
$9309ace163a8dad0$var$DocumentFragment.prototype.nodeName = "#document-fragment";
$9309ace163a8dad0$var$DocumentFragment.prototype.nodeType = $9309ace163a8dad0$var$DOCUMENT_FRAGMENT_NODE;
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$DocumentFragment, $9309ace163a8dad0$var$Node);
function $9309ace163a8dad0$var$ProcessingInstruction() {}
$9309ace163a8dad0$var$ProcessingInstruction.prototype.nodeType = $9309ace163a8dad0$var$PROCESSING_INSTRUCTION_NODE;
$9309ace163a8dad0$var$_extends($9309ace163a8dad0$var$ProcessingInstruction, $9309ace163a8dad0$var$Node);
function $9309ace163a8dad0$var$XMLSerializer() {}
/**
 * Returns the result of serializing `node` to XML.
 *
 * When `options.requireWellFormed` is `true`, the serializer throws for content that would
 * produce ill-formed XML.
 *
 * __This implementation differs from the specification:__
 * - CDATASection nodes whose data contains `]]>` are serialized by splitting the section
 *   at each `]]>` occurrence (following W3C DOM Level 3 Core `split-cdata-sections`
 *   default behaviour) unless `requireWellFormed` is `true`.
 * - when `requireWellFormed` is `true`, `DOMException` with code `INVALID_STATE_ERR`
 *   is only thrown to prevent injection vectors, not for all the spec mandated checks.
 *
 * @param {Node} node
 * @param {boolean} [isHtml]
 * @param {function} [nodeFilter]
 * @param {Object} [options]
 * @param {boolean} [options.requireWellFormed=false]
 * When `true`, throws for content that would produce ill-formed XML.
 * @returns {string}
 * @throws {DOMException}
 * With code `INVALID_STATE_ERR` when `requireWellFormed` is `true` and:
 * - a CDATASection node's data contains `"]]>"`,
 * - a Comment node's data contains `"-->"` (bare `"--"` does not throw on this branch),
 * - a ProcessingInstruction's data contains `"?>"`,
 * - a DocumentType's `publicId` is non-empty and does not match the XML `PubidLiteral`
 *   production,
 * - a DocumentType's `systemId` is non-empty and does not match the XML `SystemLiteral`
 *   production, or
 * - a DocumentType's `internalSubset` contains `"]>"`.
 * Note: xmldom does not enforce `readonly` on DocumentType fields — direct property
 * writes succeed and are covered by the serializer-level checks above.
 * @see https://html.spec.whatwg.org/#dom-xmlserializer-serializetostring
 * @see https://w3c.github.io/DOM-Parsing/#xml-serialization
 * @see https://github.com/w3c/DOM-Parsing/issues/84
 */ $9309ace163a8dad0$var$XMLSerializer.prototype.serializeToString = function(node, isHtml, nodeFilter, options) {
    return $9309ace163a8dad0$var$nodeSerializeToString.call(node, isHtml, nodeFilter, options);
};
$9309ace163a8dad0$var$Node.prototype.toString = $9309ace163a8dad0$var$nodeSerializeToString;
function $9309ace163a8dad0$var$nodeSerializeToString(isHtml, nodeFilter, options) {
    var requireWellFormed = !!options && !!options.requireWellFormed;
    var buf = [];
    var refNode = this.nodeType == 9 && this.documentElement || this;
    var prefix = refNode.prefix;
    var uri = refNode.namespaceURI;
    if (uri && prefix == null) {
        //console.log(prefix)
        var prefix = refNode.lookupPrefix(uri);
        if (prefix == null) //isHTML = true;
        var visibleNamespaces = [
            {
                namespace: uri,
                prefix: null
            }
        ];
    }
    $9309ace163a8dad0$var$serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces, requireWellFormed);
    //console.log('###',this.nodeType,uri,prefix,buf.join(''))
    return buf.join('');
}
function $9309ace163a8dad0$var$needNamespaceDefine(node, isHTML, visibleNamespaces) {
    var prefix = node.prefix || '';
    var uri = node.namespaceURI;
    // According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
    // and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
    // > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
    // in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
    // and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
    // > [...] Furthermore, the attribute value [...] must not be an empty string.
    // so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
    if (!uri) return false;
    if (prefix === "xml" && uri === $9309ace163a8dad0$var$NAMESPACE.XML || uri === $9309ace163a8dad0$var$NAMESPACE.XMLNS) return false;
    var i = visibleNamespaces.length;
    while(i--){
        var ns = visibleNamespaces[i];
        // get namespace prefix
        if (ns.prefix === prefix) return ns.namespace !== uri;
    }
    return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * > The replacement text of any entity referred to directly or indirectly
 * > in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
 * @see https://www.w3.org/TR/xml11/#NT-AttValue
 *
 * Literal whitespace other than space that appear in attribute values
 * are serialized as their entity references, so they will be preserved.
 * (In contrast to whitespace literals in the input which are normalized to spaces)
 * @see https://www.w3.org/TR/xml11/#AVNormalize
 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
 */ function $9309ace163a8dad0$var$addSerializedAttribute(buf, qualifiedName, value) {
    buf.push(' ', qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, $9309ace163a8dad0$var$_xmlEncoder), '"');
}
function $9309ace163a8dad0$var$serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces, requireWellFormed) {
    if (!visibleNamespaces) visibleNamespaces = [];
    $9309ace163a8dad0$var$walkDOM(node, {
        ns: visibleNamespaces,
        isHTML: isHTML
    }, {
        enter: function(n, ctx) {
            var ns = ctx.ns;
            var html = ctx.isHTML;
            if (nodeFilter) {
                n = nodeFilter(n);
                if (n) {
                    if (typeof n == 'string') {
                        buf.push(n);
                        return null;
                    }
                } else return null;
            }
            switch(n.nodeType){
                case $9309ace163a8dad0$var$ELEMENT_NODE:
                    var attrs = n.attributes;
                    var len = attrs.length;
                    var nodeName = n.tagName;
                    html = $9309ace163a8dad0$var$NAMESPACE.isHTML(n.namespaceURI) || html;
                    var prefixedNodeName = nodeName;
                    if (!html && !n.prefix && n.namespaceURI) {
                        var defaultNS;
                        // lookup current default ns from `xmlns` attribute
                        for(var ai = 0; ai < attrs.length; ai++)if (attrs.item(ai).name === 'xmlns') {
                            defaultNS = attrs.item(ai).value;
                            break;
                        }
                        if (!defaultNS) // lookup current default ns in visibleNamespaces
                        for(var nsi = ns.length - 1; nsi >= 0; nsi--){
                            var nsEntry = ns[nsi];
                            if (nsEntry.prefix === '' && nsEntry.namespace === n.namespaceURI) {
                                defaultNS = nsEntry.namespace;
                                break;
                            }
                        }
                        if (defaultNS !== n.namespaceURI) for(var nsi = ns.length - 1; nsi >= 0; nsi--){
                            var nsEntry = ns[nsi];
                            if (nsEntry.namespace === n.namespaceURI) {
                                if (nsEntry.prefix) prefixedNodeName = nsEntry.prefix + ':' + nodeName;
                                break;
                            }
                        }
                    }
                    buf.push('<', prefixedNodeName);
                    // Build a fresh namespace snapshot for this element's children.
                    // The slice prevents sibling elements from inheriting each other's declarations.
                    var childNs = ns.slice();
                    for(var i = 0; i < len; i++){
                        var attr = attrs.item(i);
                        if (attr.prefix == 'xmlns') childNs.push({
                            prefix: attr.localName,
                            namespace: attr.value
                        });
                        else if (attr.nodeName == 'xmlns') childNs.push({
                            prefix: '',
                            namespace: attr.value
                        });
                    }
                    for(var i = 0; i < len; i++){
                        var attr = attrs.item(i);
                        if ($9309ace163a8dad0$var$needNamespaceDefine(attr, html, childNs)) {
                            var attrPrefix = attr.prefix || '';
                            var uri = attr.namespaceURI;
                            $9309ace163a8dad0$var$addSerializedAttribute(buf, attrPrefix ? 'xmlns:' + attrPrefix : 'xmlns', uri);
                            childNs.push({
                                prefix: attrPrefix,
                                namespace: uri
                            });
                        }
                        // Apply nodeFilter and serialize the attribute.
                        var filteredAttr = nodeFilter ? nodeFilter(attr) : attr;
                        if (filteredAttr) {
                            if (typeof filteredAttr === 'string') buf.push(filteredAttr);
                            else $9309ace163a8dad0$var$addSerializedAttribute(buf, filteredAttr.name, filteredAttr.value);
                        }
                    }
                    // add namespace for current node
                    if (nodeName === prefixedNodeName && $9309ace163a8dad0$var$needNamespaceDefine(n, html, childNs)) {
                        var nodePrefix = n.prefix || '';
                        var uri = n.namespaceURI;
                        $9309ace163a8dad0$var$addSerializedAttribute(buf, nodePrefix ? 'xmlns:' + nodePrefix : 'xmlns', uri);
                        childNs.push({
                            prefix: nodePrefix,
                            namespace: uri
                        });
                    }
                    var child = n.firstChild;
                    if (child || html && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
                        buf.push('>');
                        if (html && /^script$/i.test(nodeName)) {
                            // Inline serialization for <script> children; return null to skip walkDOM descent.
                            while(child){
                                if (child.data) buf.push(child.data);
                                else $9309ace163a8dad0$var$serializeToString(child, buf, html, nodeFilter, childNs.slice(), requireWellFormed);
                                child = child.nextSibling;
                            }
                            buf.push('</', nodeName, '>');
                            return null;
                        }
                        // Return child context; walkDOM descends and exit emits the closing tag.
                        return {
                            ns: childNs,
                            isHTML: html,
                            tag: prefixedNodeName
                        };
                    } else {
                        buf.push('/>');
                        return null;
                    }
                case $9309ace163a8dad0$var$DOCUMENT_NODE:
                case $9309ace163a8dad0$var$DOCUMENT_FRAGMENT_NODE:
                    // Descend into children; exit is a no-op (tag is null).
                    return {
                        ns: ns.slice(),
                        isHTML: html,
                        tag: null
                    };
                case $9309ace163a8dad0$var$ATTRIBUTE_NODE:
                    $9309ace163a8dad0$var$addSerializedAttribute(buf, n.name, n.value);
                    return null;
                case $9309ace163a8dad0$var$TEXT_NODE:
                    /**
					 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
					 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
					 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
					 * `&amp;` and `&lt;` respectively.
					 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
					 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
					 * when that string is not marking the end of a CDATA section.
					 *
					 * In the content of elements, character data is any string of characters
					 * which does not contain the start-delimiter of any markup
					 * and does not include the CDATA-section-close delimiter, `]]>`.
					 *
					 * @see https://www.w3.org/TR/xml/#NT-CharData
					 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
					 */ buf.push(n.data.replace(/[<&>]/g, $9309ace163a8dad0$var$_xmlEncoder));
                    return null;
                case $9309ace163a8dad0$var$CDATA_SECTION_NODE:
                    if (requireWellFormed && n.data.indexOf(']]>') !== -1) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$INVALID_STATE_ERR, 'The CDATASection data contains "]]>"');
                    buf.push('<![CDATA[', n.data.replace(/]]>/g, ']]]]><![CDATA[>'), ']]>');
                    return null;
                case $9309ace163a8dad0$var$COMMENT_NODE:
                    if (requireWellFormed && n.data.indexOf('-->') !== -1) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$INVALID_STATE_ERR, 'The comment node data contains "-->"');
                    buf.push('<!--', n.data, '-->');
                    return null;
                case $9309ace163a8dad0$var$DOCUMENT_TYPE_NODE:
                    if (requireWellFormed) {
                        if (n.publicId && !/^("[\x20\r\na-zA-Z0-9\-()+,.\/:=?;!*#@$_%']*"|'[\x20\r\na-zA-Z0-9\-()+,.\/:=?;!*#@$_%'"]*')$/.test(n.publicId)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$INVALID_STATE_ERR, 'DocumentType publicId is not a valid PubidLiteral');
                        if (n.systemId && !/^("[^"]*"|'[^']*')$/.test(n.systemId)) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$INVALID_STATE_ERR, 'DocumentType systemId is not a valid SystemLiteral');
                        if (n.internalSubset && n.internalSubset.indexOf(']>') !== -1) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$INVALID_STATE_ERR, 'DocumentType internalSubset contains "]>"');
                    }
                    var pubid = n.publicId;
                    var sysid = n.systemId;
                    buf.push('<!DOCTYPE ', n.name);
                    if (pubid) {
                        buf.push(' PUBLIC ', pubid);
                        if (sysid && sysid != '.') buf.push(' ', sysid);
                        buf.push('>');
                    } else if (sysid && sysid != '.') buf.push(' SYSTEM ', sysid, '>');
                    else {
                        var sub = n.internalSubset;
                        if (sub) buf.push(' [', sub, ']');
                        buf.push('>');
                    }
                    return null;
                case $9309ace163a8dad0$var$PROCESSING_INSTRUCTION_NODE:
                    if (requireWellFormed && n.data.indexOf('?>') !== -1) throw new $9309ace163a8dad0$var$DOMException($9309ace163a8dad0$var$INVALID_STATE_ERR, 'The ProcessingInstruction data contains "?>"');
                    buf.push('<?', n.target, ' ', n.data, '?>');
                    return null;
                case $9309ace163a8dad0$var$ENTITY_REFERENCE_NODE:
                    buf.push('&', n.nodeName, ';');
                    return null;
                //case ENTITY_NODE:
                //case NOTATION_NODE:
                default:
                    buf.push('??', n.nodeName);
                    return null;
            }
        },
        exit: function(n, childCtx) {
            if (childCtx && childCtx.tag) buf.push('</', childCtx.tag, '>');
        }
    });
}
/**
 * Imports a node from a different document into `doc`, creating a new copy.
 * Delegates to {@link walkDOM} for traversal. Each node in the subtree is shallow-cloned,
 * stamped with `doc` as its `ownerDocument`, and detached (`parentNode` set to `null`).
 * Children are imported recursively when `deep` is `true`; for {@link Attr} nodes `deep` is
 * always forced to `true`
 * because an attribute's value lives in a child text node.
 *
 * @param {Document} doc
 * The document that will own the imported node.
 * @param {Node} node
 * The node to import.
 * @param {boolean} deep
 * If `true`, descendants are imported recursively.
 * @returns {Node}
 * The newly imported node, now owned by `doc`.
 */ function $9309ace163a8dad0$var$importNode(doc, node, deep) {
    var destRoot;
    $9309ace163a8dad0$var$walkDOM(node, null, {
        enter: function(srcNode, destParent) {
            // Shallow-clone the node and stamp it into the target document.
            var destNode = srcNode.cloneNode(false);
            destNode.ownerDocument = doc;
            destNode.parentNode = null;
            // capture as the root of the imported subtree or attach to parent.
            if (destParent === null) destRoot = destNode;
            else destParent.appendChild(destNode);
            // ATTRIBUTE_NODE must always be imported deeply: its value lives in a child text node.
            var shouldDeep = srcNode.nodeType === $9309ace163a8dad0$var$ATTRIBUTE_NODE || deep;
            return shouldDeep ? destNode : null;
        }
    });
    return destRoot;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function $9309ace163a8dad0$var$cloneNode(doc, node, deep) {
    var destRoot;
    $9309ace163a8dad0$var$walkDOM(node, null, {
        enter: function(srcNode, destParent) {
            // 1. Create a blank node of the same type and copy all scalar own properties.
            var destNode = new srcNode.constructor();
            for(var n in srcNode)if (Object.prototype.hasOwnProperty.call(srcNode, n)) {
                var v = srcNode[n];
                if (typeof v != 'object') {
                    if (v != destNode[n]) destNode[n] = v;
                }
            }
            if (srcNode.childNodes) destNode.childNodes = new $9309ace163a8dad0$var$NodeList();
            destNode.ownerDocument = doc;
            // 2. Handle node-type-specific setup.
            //    Attributes are not DOM children, so they are cloned inline here
            //    rather than by walkDOM descent.
            //    ATTRIBUTE_NODE forces deep=true so its own children are walked.
            var shouldDeep = deep;
            switch(destNode.nodeType){
                case $9309ace163a8dad0$var$ELEMENT_NODE:
                    var attrs = srcNode.attributes;
                    var attrs2 = destNode.attributes = new $9309ace163a8dad0$var$NamedNodeMap();
                    var len = attrs.length;
                    attrs2._ownerElement = destNode;
                    for(var i = 0; i < len; i++)destNode.setAttributeNode($9309ace163a8dad0$var$cloneNode(doc, attrs.item(i), true));
                    break;
                case $9309ace163a8dad0$var$ATTRIBUTE_NODE:
                    shouldDeep = true;
            }
            // 3. Attach to parent, or capture as the root of the cloned subtree.
            if (destParent !== null) destParent.appendChild(destNode);
            else destRoot = destNode;
            // 4. Return destNode as the context for children (causes walkDOM to descend),
            //    or null to skip children (shallow clone).
            return shouldDeep ? destNode : null;
        }
    });
    return destRoot;
}
function $9309ace163a8dad0$var$__set__(object, key, value) {
    object[key] = value;
}
//do dynamic
try {
    if (Object.defineProperty) {
        Object.defineProperty($9309ace163a8dad0$var$LiveNodeList.prototype, 'length', {
            get: function() {
                $9309ace163a8dad0$var$_updateLiveList(this);
                return this.$$length;
            }
        });
        /**
		 * The text content of this node and its descendants.
		 *
		 * Setting `textContent` on an element or document fragment replaces all child nodes with a
		 * single text node; on other nodes it sets `data`, `value`, and `nodeValue` directly.
		 *
		 * @type {string | null}
		 * @see {@link https://dom.spec.whatwg.org/#dom-node-textcontent}
		 */ Object.defineProperty($9309ace163a8dad0$var$Node.prototype, 'textContent', {
            get: function() {
                if (this.nodeType === $9309ace163a8dad0$var$ELEMENT_NODE || this.nodeType === $9309ace163a8dad0$var$DOCUMENT_FRAGMENT_NODE) {
                    var buf = [];
                    $9309ace163a8dad0$var$walkDOM(this, null, {
                        enter: function(n) {
                            if (n.nodeType === $9309ace163a8dad0$var$ELEMENT_NODE || n.nodeType === $9309ace163a8dad0$var$DOCUMENT_FRAGMENT_NODE) return true; // enter children
                            if (n.nodeType === $9309ace163a8dad0$var$PROCESSING_INSTRUCTION_NODE || n.nodeType === $9309ace163a8dad0$var$COMMENT_NODE) return null; // excluded from text content
                            buf.push(n.nodeValue);
                        }
                    });
                    return buf.join('');
                }
                return this.nodeValue;
            },
            set: function(data) {
                switch(this.nodeType){
                    case $9309ace163a8dad0$var$ELEMENT_NODE:
                    case $9309ace163a8dad0$var$DOCUMENT_FRAGMENT_NODE:
                        while(this.firstChild)this.removeChild(this.firstChild);
                        if (data || String(data)) this.appendChild(this.ownerDocument.createTextNode(data));
                        break;
                    default:
                        this.data = data;
                        this.value = data;
                        this.nodeValue = data;
                }
            }
        });
        $9309ace163a8dad0$var$__set__ = function(object, key, value) {
            //console.log(value)
            object['$$' + key] = value;
        };
    }
} catch (e) {}
$9309ace163a8dad0$export$d1d99cf900472499 = $9309ace163a8dad0$var$DocumentType;
$9309ace163a8dad0$export$fe58bcf938607f6a = $9309ace163a8dad0$var$DOMException;
$9309ace163a8dad0$export$455426655eab1d48 = $9309ace163a8dad0$var$DOMImplementation;
$9309ace163a8dad0$export$db77ccec0bb4ccac = $9309ace163a8dad0$var$Element;
$9309ace163a8dad0$export$85c928794f8d04d4 = $9309ace163a8dad0$var$Node;
$9309ace163a8dad0$export$79b41aa5d56abdff = $9309ace163a8dad0$var$NodeList;
$9309ace163a8dad0$export$5118471ee5d5453b = $9309ace163a8dad0$var$walkDOM;
$9309ace163a8dad0$export$64f0bed4ae6f0f24 = $9309ace163a8dad0$var$XMLSerializer; //}

});

parcelRegister("8eLdI", function(module, exports) {

$parcel$export(module.exports, "XML_ENTITIES", () => $5ff4427c87009307$export$91f0e5ff03dc84f, (v) => $5ff4427c87009307$export$91f0e5ff03dc84f = v);
$parcel$export(module.exports, "HTML_ENTITIES", () => $5ff4427c87009307$export$b7e4d4631df36afa, (v) => $5ff4427c87009307$export$b7e4d4631df36afa = v);
/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */ var $5ff4427c87009307$export$91f0e5ff03dc84f;
/**
 * A map of all entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://html.spec.whatwg.org/entities.json JSON
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */ var $5ff4427c87009307$export$b7e4d4631df36afa;
/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */ var $5ff4427c87009307$export$79451380caed3f98;
'use strict';

var $ghxvC = parcelRequire("ghxvC");
var $5ff4427c87009307$require$freeze = $ghxvC.freeze;
$5ff4427c87009307$export$91f0e5ff03dc84f = $5ff4427c87009307$require$freeze({
    amp: '&',
    apos: "'",
    gt: '>',
    lt: '<',
    quot: '"'
});
$5ff4427c87009307$export$b7e4d4631df36afa = $5ff4427c87009307$require$freeze({
    Aacute: '\u00C1',
    aacute: '\u00E1',
    Abreve: '\u0102',
    abreve: '\u0103',
    ac: '\u223E',
    acd: '\u223F',
    acE: '\u223E\u0333',
    Acirc: '\u00C2',
    acirc: '\u00E2',
    acute: '\u00B4',
    Acy: '\u0410',
    acy: '\u0430',
    AElig: '\u00C6',
    aelig: '\u00E6',
    af: '\u2061',
    Afr: '\uD835\uDD04',
    afr: '\uD835\uDD1E',
    Agrave: '\u00C0',
    agrave: '\u00E0',
    alefsym: '\u2135',
    aleph: '\u2135',
    Alpha: '\u0391',
    alpha: '\u03B1',
    Amacr: '\u0100',
    amacr: '\u0101',
    amalg: '\u2A3F',
    AMP: '\u0026',
    amp: '\u0026',
    And: '\u2A53',
    and: '\u2227',
    andand: '\u2A55',
    andd: '\u2A5C',
    andslope: '\u2A58',
    andv: '\u2A5A',
    ang: '\u2220',
    ange: '\u29A4',
    angle: '\u2220',
    angmsd: '\u2221',
    angmsdaa: '\u29A8',
    angmsdab: '\u29A9',
    angmsdac: '\u29AA',
    angmsdad: '\u29AB',
    angmsdae: '\u29AC',
    angmsdaf: '\u29AD',
    angmsdag: '\u29AE',
    angmsdah: '\u29AF',
    angrt: '\u221F',
    angrtvb: '\u22BE',
    angrtvbd: '\u299D',
    angsph: '\u2222',
    angst: '\u00C5',
    angzarr: '\u237C',
    Aogon: '\u0104',
    aogon: '\u0105',
    Aopf: '\uD835\uDD38',
    aopf: '\uD835\uDD52',
    ap: '\u2248',
    apacir: '\u2A6F',
    apE: '\u2A70',
    ape: '\u224A',
    apid: '\u224B',
    apos: '\u0027',
    ApplyFunction: '\u2061',
    approx: '\u2248',
    approxeq: '\u224A',
    Aring: '\u00C5',
    aring: '\u00E5',
    Ascr: '\uD835\uDC9C',
    ascr: '\uD835\uDCB6',
    Assign: '\u2254',
    ast: '\u002A',
    asymp: '\u2248',
    asympeq: '\u224D',
    Atilde: '\u00C3',
    atilde: '\u00E3',
    Auml: '\u00C4',
    auml: '\u00E4',
    awconint: '\u2233',
    awint: '\u2A11',
    backcong: '\u224C',
    backepsilon: '\u03F6',
    backprime: '\u2035',
    backsim: '\u223D',
    backsimeq: '\u22CD',
    Backslash: '\u2216',
    Barv: '\u2AE7',
    barvee: '\u22BD',
    Barwed: '\u2306',
    barwed: '\u2305',
    barwedge: '\u2305',
    bbrk: '\u23B5',
    bbrktbrk: '\u23B6',
    bcong: '\u224C',
    Bcy: '\u0411',
    bcy: '\u0431',
    bdquo: '\u201E',
    becaus: '\u2235',
    Because: '\u2235',
    because: '\u2235',
    bemptyv: '\u29B0',
    bepsi: '\u03F6',
    bernou: '\u212C',
    Bernoullis: '\u212C',
    Beta: '\u0392',
    beta: '\u03B2',
    beth: '\u2136',
    between: '\u226C',
    Bfr: '\uD835\uDD05',
    bfr: '\uD835\uDD1F',
    bigcap: '\u22C2',
    bigcirc: '\u25EF',
    bigcup: '\u22C3',
    bigodot: '\u2A00',
    bigoplus: '\u2A01',
    bigotimes: '\u2A02',
    bigsqcup: '\u2A06',
    bigstar: '\u2605',
    bigtriangledown: '\u25BD',
    bigtriangleup: '\u25B3',
    biguplus: '\u2A04',
    bigvee: '\u22C1',
    bigwedge: '\u22C0',
    bkarow: '\u290D',
    blacklozenge: '\u29EB',
    blacksquare: '\u25AA',
    blacktriangle: '\u25B4',
    blacktriangledown: '\u25BE',
    blacktriangleleft: '\u25C2',
    blacktriangleright: '\u25B8',
    blank: '\u2423',
    blk12: '\u2592',
    blk14: '\u2591',
    blk34: '\u2593',
    block: '\u2588',
    bne: '\u003D\u20E5',
    bnequiv: '\u2261\u20E5',
    bNot: '\u2AED',
    bnot: '\u2310',
    Bopf: '\uD835\uDD39',
    bopf: '\uD835\uDD53',
    bot: '\u22A5',
    bottom: '\u22A5',
    bowtie: '\u22C8',
    boxbox: '\u29C9',
    boxDL: '\u2557',
    boxDl: '\u2556',
    boxdL: '\u2555',
    boxdl: '\u2510',
    boxDR: '\u2554',
    boxDr: '\u2553',
    boxdR: '\u2552',
    boxdr: '\u250C',
    boxH: '\u2550',
    boxh: '\u2500',
    boxHD: '\u2566',
    boxHd: '\u2564',
    boxhD: '\u2565',
    boxhd: '\u252C',
    boxHU: '\u2569',
    boxHu: '\u2567',
    boxhU: '\u2568',
    boxhu: '\u2534',
    boxminus: '\u229F',
    boxplus: '\u229E',
    boxtimes: '\u22A0',
    boxUL: '\u255D',
    boxUl: '\u255C',
    boxuL: '\u255B',
    boxul: '\u2518',
    boxUR: '\u255A',
    boxUr: '\u2559',
    boxuR: '\u2558',
    boxur: '\u2514',
    boxV: '\u2551',
    boxv: '\u2502',
    boxVH: '\u256C',
    boxVh: '\u256B',
    boxvH: '\u256A',
    boxvh: '\u253C',
    boxVL: '\u2563',
    boxVl: '\u2562',
    boxvL: '\u2561',
    boxvl: '\u2524',
    boxVR: '\u2560',
    boxVr: '\u255F',
    boxvR: '\u255E',
    boxvr: '\u251C',
    bprime: '\u2035',
    Breve: '\u02D8',
    breve: '\u02D8',
    brvbar: '\u00A6',
    Bscr: '\u212C',
    bscr: '\uD835\uDCB7',
    bsemi: '\u204F',
    bsim: '\u223D',
    bsime: '\u22CD',
    bsol: '\u005C',
    bsolb: '\u29C5',
    bsolhsub: '\u27C8',
    bull: '\u2022',
    bullet: '\u2022',
    bump: '\u224E',
    bumpE: '\u2AAE',
    bumpe: '\u224F',
    Bumpeq: '\u224E',
    bumpeq: '\u224F',
    Cacute: '\u0106',
    cacute: '\u0107',
    Cap: '\u22D2',
    cap: '\u2229',
    capand: '\u2A44',
    capbrcup: '\u2A49',
    capcap: '\u2A4B',
    capcup: '\u2A47',
    capdot: '\u2A40',
    CapitalDifferentialD: '\u2145',
    caps: '\u2229\uFE00',
    caret: '\u2041',
    caron: '\u02C7',
    Cayleys: '\u212D',
    ccaps: '\u2A4D',
    Ccaron: '\u010C',
    ccaron: '\u010D',
    Ccedil: '\u00C7',
    ccedil: '\u00E7',
    Ccirc: '\u0108',
    ccirc: '\u0109',
    Cconint: '\u2230',
    ccups: '\u2A4C',
    ccupssm: '\u2A50',
    Cdot: '\u010A',
    cdot: '\u010B',
    cedil: '\u00B8',
    Cedilla: '\u00B8',
    cemptyv: '\u29B2',
    cent: '\u00A2',
    CenterDot: '\u00B7',
    centerdot: '\u00B7',
    Cfr: '\u212D',
    cfr: '\uD835\uDD20',
    CHcy: '\u0427',
    chcy: '\u0447',
    check: '\u2713',
    checkmark: '\u2713',
    Chi: '\u03A7',
    chi: '\u03C7',
    cir: '\u25CB',
    circ: '\u02C6',
    circeq: '\u2257',
    circlearrowleft: '\u21BA',
    circlearrowright: '\u21BB',
    circledast: '\u229B',
    circledcirc: '\u229A',
    circleddash: '\u229D',
    CircleDot: '\u2299',
    circledR: '\u00AE',
    circledS: '\u24C8',
    CircleMinus: '\u2296',
    CirclePlus: '\u2295',
    CircleTimes: '\u2297',
    cirE: '\u29C3',
    cire: '\u2257',
    cirfnint: '\u2A10',
    cirmid: '\u2AEF',
    cirscir: '\u29C2',
    ClockwiseContourIntegral: '\u2232',
    CloseCurlyDoubleQuote: '\u201D',
    CloseCurlyQuote: '\u2019',
    clubs: '\u2663',
    clubsuit: '\u2663',
    Colon: '\u2237',
    colon: '\u003A',
    Colone: '\u2A74',
    colone: '\u2254',
    coloneq: '\u2254',
    comma: '\u002C',
    commat: '\u0040',
    comp: '\u2201',
    compfn: '\u2218',
    complement: '\u2201',
    complexes: '\u2102',
    cong: '\u2245',
    congdot: '\u2A6D',
    Congruent: '\u2261',
    Conint: '\u222F',
    conint: '\u222E',
    ContourIntegral: '\u222E',
    Copf: '\u2102',
    copf: '\uD835\uDD54',
    coprod: '\u2210',
    Coproduct: '\u2210',
    COPY: '\u00A9',
    copy: '\u00A9',
    copysr: '\u2117',
    CounterClockwiseContourIntegral: '\u2233',
    crarr: '\u21B5',
    Cross: '\u2A2F',
    cross: '\u2717',
    Cscr: '\uD835\uDC9E',
    cscr: '\uD835\uDCB8',
    csub: '\u2ACF',
    csube: '\u2AD1',
    csup: '\u2AD0',
    csupe: '\u2AD2',
    ctdot: '\u22EF',
    cudarrl: '\u2938',
    cudarrr: '\u2935',
    cuepr: '\u22DE',
    cuesc: '\u22DF',
    cularr: '\u21B6',
    cularrp: '\u293D',
    Cup: '\u22D3',
    cup: '\u222A',
    cupbrcap: '\u2A48',
    CupCap: '\u224D',
    cupcap: '\u2A46',
    cupcup: '\u2A4A',
    cupdot: '\u228D',
    cupor: '\u2A45',
    cups: '\u222A\uFE00',
    curarr: '\u21B7',
    curarrm: '\u293C',
    curlyeqprec: '\u22DE',
    curlyeqsucc: '\u22DF',
    curlyvee: '\u22CE',
    curlywedge: '\u22CF',
    curren: '\u00A4',
    curvearrowleft: '\u21B6',
    curvearrowright: '\u21B7',
    cuvee: '\u22CE',
    cuwed: '\u22CF',
    cwconint: '\u2232',
    cwint: '\u2231',
    cylcty: '\u232D',
    Dagger: '\u2021',
    dagger: '\u2020',
    daleth: '\u2138',
    Darr: '\u21A1',
    dArr: '\u21D3',
    darr: '\u2193',
    dash: '\u2010',
    Dashv: '\u2AE4',
    dashv: '\u22A3',
    dbkarow: '\u290F',
    dblac: '\u02DD',
    Dcaron: '\u010E',
    dcaron: '\u010F',
    Dcy: '\u0414',
    dcy: '\u0434',
    DD: '\u2145',
    dd: '\u2146',
    ddagger: '\u2021',
    ddarr: '\u21CA',
    DDotrahd: '\u2911',
    ddotseq: '\u2A77',
    deg: '\u00B0',
    Del: '\u2207',
    Delta: '\u0394',
    delta: '\u03B4',
    demptyv: '\u29B1',
    dfisht: '\u297F',
    Dfr: '\uD835\uDD07',
    dfr: '\uD835\uDD21',
    dHar: '\u2965',
    dharl: '\u21C3',
    dharr: '\u21C2',
    DiacriticalAcute: '\u00B4',
    DiacriticalDot: '\u02D9',
    DiacriticalDoubleAcute: '\u02DD',
    DiacriticalGrave: '\u0060',
    DiacriticalTilde: '\u02DC',
    diam: '\u22C4',
    Diamond: '\u22C4',
    diamond: '\u22C4',
    diamondsuit: '\u2666',
    diams: '\u2666',
    die: '\u00A8',
    DifferentialD: '\u2146',
    digamma: '\u03DD',
    disin: '\u22F2',
    div: '\u00F7',
    divide: '\u00F7',
    divideontimes: '\u22C7',
    divonx: '\u22C7',
    DJcy: '\u0402',
    djcy: '\u0452',
    dlcorn: '\u231E',
    dlcrop: '\u230D',
    dollar: '\u0024',
    Dopf: '\uD835\uDD3B',
    dopf: '\uD835\uDD55',
    Dot: '\u00A8',
    dot: '\u02D9',
    DotDot: '\u20DC',
    doteq: '\u2250',
    doteqdot: '\u2251',
    DotEqual: '\u2250',
    dotminus: '\u2238',
    dotplus: '\u2214',
    dotsquare: '\u22A1',
    doublebarwedge: '\u2306',
    DoubleContourIntegral: '\u222F',
    DoubleDot: '\u00A8',
    DoubleDownArrow: '\u21D3',
    DoubleLeftArrow: '\u21D0',
    DoubleLeftRightArrow: '\u21D4',
    DoubleLeftTee: '\u2AE4',
    DoubleLongLeftArrow: '\u27F8',
    DoubleLongLeftRightArrow: '\u27FA',
    DoubleLongRightArrow: '\u27F9',
    DoubleRightArrow: '\u21D2',
    DoubleRightTee: '\u22A8',
    DoubleUpArrow: '\u21D1',
    DoubleUpDownArrow: '\u21D5',
    DoubleVerticalBar: '\u2225',
    DownArrow: '\u2193',
    Downarrow: '\u21D3',
    downarrow: '\u2193',
    DownArrowBar: '\u2913',
    DownArrowUpArrow: '\u21F5',
    DownBreve: '\u0311',
    downdownarrows: '\u21CA',
    downharpoonleft: '\u21C3',
    downharpoonright: '\u21C2',
    DownLeftRightVector: '\u2950',
    DownLeftTeeVector: '\u295E',
    DownLeftVector: '\u21BD',
    DownLeftVectorBar: '\u2956',
    DownRightTeeVector: '\u295F',
    DownRightVector: '\u21C1',
    DownRightVectorBar: '\u2957',
    DownTee: '\u22A4',
    DownTeeArrow: '\u21A7',
    drbkarow: '\u2910',
    drcorn: '\u231F',
    drcrop: '\u230C',
    Dscr: '\uD835\uDC9F',
    dscr: '\uD835\uDCB9',
    DScy: '\u0405',
    dscy: '\u0455',
    dsol: '\u29F6',
    Dstrok: '\u0110',
    dstrok: '\u0111',
    dtdot: '\u22F1',
    dtri: '\u25BF',
    dtrif: '\u25BE',
    duarr: '\u21F5',
    duhar: '\u296F',
    dwangle: '\u29A6',
    DZcy: '\u040F',
    dzcy: '\u045F',
    dzigrarr: '\u27FF',
    Eacute: '\u00C9',
    eacute: '\u00E9',
    easter: '\u2A6E',
    Ecaron: '\u011A',
    ecaron: '\u011B',
    ecir: '\u2256',
    Ecirc: '\u00CA',
    ecirc: '\u00EA',
    ecolon: '\u2255',
    Ecy: '\u042D',
    ecy: '\u044D',
    eDDot: '\u2A77',
    Edot: '\u0116',
    eDot: '\u2251',
    edot: '\u0117',
    ee: '\u2147',
    efDot: '\u2252',
    Efr: '\uD835\uDD08',
    efr: '\uD835\uDD22',
    eg: '\u2A9A',
    Egrave: '\u00C8',
    egrave: '\u00E8',
    egs: '\u2A96',
    egsdot: '\u2A98',
    el: '\u2A99',
    Element: '\u2208',
    elinters: '\u23E7',
    ell: '\u2113',
    els: '\u2A95',
    elsdot: '\u2A97',
    Emacr: '\u0112',
    emacr: '\u0113',
    empty: '\u2205',
    emptyset: '\u2205',
    EmptySmallSquare: '\u25FB',
    emptyv: '\u2205',
    EmptyVerySmallSquare: '\u25AB',
    emsp: '\u2003',
    emsp13: '\u2004',
    emsp14: '\u2005',
    ENG: '\u014A',
    eng: '\u014B',
    ensp: '\u2002',
    Eogon: '\u0118',
    eogon: '\u0119',
    Eopf: '\uD835\uDD3C',
    eopf: '\uD835\uDD56',
    epar: '\u22D5',
    eparsl: '\u29E3',
    eplus: '\u2A71',
    epsi: '\u03B5',
    Epsilon: '\u0395',
    epsilon: '\u03B5',
    epsiv: '\u03F5',
    eqcirc: '\u2256',
    eqcolon: '\u2255',
    eqsim: '\u2242',
    eqslantgtr: '\u2A96',
    eqslantless: '\u2A95',
    Equal: '\u2A75',
    equals: '\u003D',
    EqualTilde: '\u2242',
    equest: '\u225F',
    Equilibrium: '\u21CC',
    equiv: '\u2261',
    equivDD: '\u2A78',
    eqvparsl: '\u29E5',
    erarr: '\u2971',
    erDot: '\u2253',
    Escr: '\u2130',
    escr: '\u212F',
    esdot: '\u2250',
    Esim: '\u2A73',
    esim: '\u2242',
    Eta: '\u0397',
    eta: '\u03B7',
    ETH: '\u00D0',
    eth: '\u00F0',
    Euml: '\u00CB',
    euml: '\u00EB',
    euro: '\u20AC',
    excl: '\u0021',
    exist: '\u2203',
    Exists: '\u2203',
    expectation: '\u2130',
    ExponentialE: '\u2147',
    exponentiale: '\u2147',
    fallingdotseq: '\u2252',
    Fcy: '\u0424',
    fcy: '\u0444',
    female: '\u2640',
    ffilig: '\uFB03',
    fflig: '\uFB00',
    ffllig: '\uFB04',
    Ffr: '\uD835\uDD09',
    ffr: '\uD835\uDD23',
    filig: '\uFB01',
    FilledSmallSquare: '\u25FC',
    FilledVerySmallSquare: '\u25AA',
    fjlig: '\u0066\u006A',
    flat: '\u266D',
    fllig: '\uFB02',
    fltns: '\u25B1',
    fnof: '\u0192',
    Fopf: '\uD835\uDD3D',
    fopf: '\uD835\uDD57',
    ForAll: '\u2200',
    forall: '\u2200',
    fork: '\u22D4',
    forkv: '\u2AD9',
    Fouriertrf: '\u2131',
    fpartint: '\u2A0D',
    frac12: '\u00BD',
    frac13: '\u2153',
    frac14: '\u00BC',
    frac15: '\u2155',
    frac16: '\u2159',
    frac18: '\u215B',
    frac23: '\u2154',
    frac25: '\u2156',
    frac34: '\u00BE',
    frac35: '\u2157',
    frac38: '\u215C',
    frac45: '\u2158',
    frac56: '\u215A',
    frac58: '\u215D',
    frac78: '\u215E',
    frasl: '\u2044',
    frown: '\u2322',
    Fscr: '\u2131',
    fscr: '\uD835\uDCBB',
    gacute: '\u01F5',
    Gamma: '\u0393',
    gamma: '\u03B3',
    Gammad: '\u03DC',
    gammad: '\u03DD',
    gap: '\u2A86',
    Gbreve: '\u011E',
    gbreve: '\u011F',
    Gcedil: '\u0122',
    Gcirc: '\u011C',
    gcirc: '\u011D',
    Gcy: '\u0413',
    gcy: '\u0433',
    Gdot: '\u0120',
    gdot: '\u0121',
    gE: '\u2267',
    ge: '\u2265',
    gEl: '\u2A8C',
    gel: '\u22DB',
    geq: '\u2265',
    geqq: '\u2267',
    geqslant: '\u2A7E',
    ges: '\u2A7E',
    gescc: '\u2AA9',
    gesdot: '\u2A80',
    gesdoto: '\u2A82',
    gesdotol: '\u2A84',
    gesl: '\u22DB\uFE00',
    gesles: '\u2A94',
    Gfr: '\uD835\uDD0A',
    gfr: '\uD835\uDD24',
    Gg: '\u22D9',
    gg: '\u226B',
    ggg: '\u22D9',
    gimel: '\u2137',
    GJcy: '\u0403',
    gjcy: '\u0453',
    gl: '\u2277',
    gla: '\u2AA5',
    glE: '\u2A92',
    glj: '\u2AA4',
    gnap: '\u2A8A',
    gnapprox: '\u2A8A',
    gnE: '\u2269',
    gne: '\u2A88',
    gneq: '\u2A88',
    gneqq: '\u2269',
    gnsim: '\u22E7',
    Gopf: '\uD835\uDD3E',
    gopf: '\uD835\uDD58',
    grave: '\u0060',
    GreaterEqual: '\u2265',
    GreaterEqualLess: '\u22DB',
    GreaterFullEqual: '\u2267',
    GreaterGreater: '\u2AA2',
    GreaterLess: '\u2277',
    GreaterSlantEqual: '\u2A7E',
    GreaterTilde: '\u2273',
    Gscr: '\uD835\uDCA2',
    gscr: '\u210A',
    gsim: '\u2273',
    gsime: '\u2A8E',
    gsiml: '\u2A90',
    Gt: '\u226B',
    GT: '\u003E',
    gt: '\u003E',
    gtcc: '\u2AA7',
    gtcir: '\u2A7A',
    gtdot: '\u22D7',
    gtlPar: '\u2995',
    gtquest: '\u2A7C',
    gtrapprox: '\u2A86',
    gtrarr: '\u2978',
    gtrdot: '\u22D7',
    gtreqless: '\u22DB',
    gtreqqless: '\u2A8C',
    gtrless: '\u2277',
    gtrsim: '\u2273',
    gvertneqq: '\u2269\uFE00',
    gvnE: '\u2269\uFE00',
    Hacek: '\u02C7',
    hairsp: '\u200A',
    half: '\u00BD',
    hamilt: '\u210B',
    HARDcy: '\u042A',
    hardcy: '\u044A',
    hArr: '\u21D4',
    harr: '\u2194',
    harrcir: '\u2948',
    harrw: '\u21AD',
    Hat: '\u005E',
    hbar: '\u210F',
    Hcirc: '\u0124',
    hcirc: '\u0125',
    hearts: '\u2665',
    heartsuit: '\u2665',
    hellip: '\u2026',
    hercon: '\u22B9',
    Hfr: '\u210C',
    hfr: '\uD835\uDD25',
    HilbertSpace: '\u210B',
    hksearow: '\u2925',
    hkswarow: '\u2926',
    hoarr: '\u21FF',
    homtht: '\u223B',
    hookleftarrow: '\u21A9',
    hookrightarrow: '\u21AA',
    Hopf: '\u210D',
    hopf: '\uD835\uDD59',
    horbar: '\u2015',
    HorizontalLine: '\u2500',
    Hscr: '\u210B',
    hscr: '\uD835\uDCBD',
    hslash: '\u210F',
    Hstrok: '\u0126',
    hstrok: '\u0127',
    HumpDownHump: '\u224E',
    HumpEqual: '\u224F',
    hybull: '\u2043',
    hyphen: '\u2010',
    Iacute: '\u00CD',
    iacute: '\u00ED',
    ic: '\u2063',
    Icirc: '\u00CE',
    icirc: '\u00EE',
    Icy: '\u0418',
    icy: '\u0438',
    Idot: '\u0130',
    IEcy: '\u0415',
    iecy: '\u0435',
    iexcl: '\u00A1',
    iff: '\u21D4',
    Ifr: '\u2111',
    ifr: '\uD835\uDD26',
    Igrave: '\u00CC',
    igrave: '\u00EC',
    ii: '\u2148',
    iiiint: '\u2A0C',
    iiint: '\u222D',
    iinfin: '\u29DC',
    iiota: '\u2129',
    IJlig: '\u0132',
    ijlig: '\u0133',
    Im: '\u2111',
    Imacr: '\u012A',
    imacr: '\u012B',
    image: '\u2111',
    ImaginaryI: '\u2148',
    imagline: '\u2110',
    imagpart: '\u2111',
    imath: '\u0131',
    imof: '\u22B7',
    imped: '\u01B5',
    Implies: '\u21D2',
    in: '\u2208',
    incare: '\u2105',
    infin: '\u221E',
    infintie: '\u29DD',
    inodot: '\u0131',
    Int: '\u222C',
    int: '\u222B',
    intcal: '\u22BA',
    integers: '\u2124',
    Integral: '\u222B',
    intercal: '\u22BA',
    Intersection: '\u22C2',
    intlarhk: '\u2A17',
    intprod: '\u2A3C',
    InvisibleComma: '\u2063',
    InvisibleTimes: '\u2062',
    IOcy: '\u0401',
    iocy: '\u0451',
    Iogon: '\u012E',
    iogon: '\u012F',
    Iopf: '\uD835\uDD40',
    iopf: '\uD835\uDD5A',
    Iota: '\u0399',
    iota: '\u03B9',
    iprod: '\u2A3C',
    iquest: '\u00BF',
    Iscr: '\u2110',
    iscr: '\uD835\uDCBE',
    isin: '\u2208',
    isindot: '\u22F5',
    isinE: '\u22F9',
    isins: '\u22F4',
    isinsv: '\u22F3',
    isinv: '\u2208',
    it: '\u2062',
    Itilde: '\u0128',
    itilde: '\u0129',
    Iukcy: '\u0406',
    iukcy: '\u0456',
    Iuml: '\u00CF',
    iuml: '\u00EF',
    Jcirc: '\u0134',
    jcirc: '\u0135',
    Jcy: '\u0419',
    jcy: '\u0439',
    Jfr: '\uD835\uDD0D',
    jfr: '\uD835\uDD27',
    jmath: '\u0237',
    Jopf: '\uD835\uDD41',
    jopf: '\uD835\uDD5B',
    Jscr: '\uD835\uDCA5',
    jscr: '\uD835\uDCBF',
    Jsercy: '\u0408',
    jsercy: '\u0458',
    Jukcy: '\u0404',
    jukcy: '\u0454',
    Kappa: '\u039A',
    kappa: '\u03BA',
    kappav: '\u03F0',
    Kcedil: '\u0136',
    kcedil: '\u0137',
    Kcy: '\u041A',
    kcy: '\u043A',
    Kfr: '\uD835\uDD0E',
    kfr: '\uD835\uDD28',
    kgreen: '\u0138',
    KHcy: '\u0425',
    khcy: '\u0445',
    KJcy: '\u040C',
    kjcy: '\u045C',
    Kopf: '\uD835\uDD42',
    kopf: '\uD835\uDD5C',
    Kscr: '\uD835\uDCA6',
    kscr: '\uD835\uDCC0',
    lAarr: '\u21DA',
    Lacute: '\u0139',
    lacute: '\u013A',
    laemptyv: '\u29B4',
    lagran: '\u2112',
    Lambda: '\u039B',
    lambda: '\u03BB',
    Lang: '\u27EA',
    lang: '\u27E8',
    langd: '\u2991',
    langle: '\u27E8',
    lap: '\u2A85',
    Laplacetrf: '\u2112',
    laquo: '\u00AB',
    Larr: '\u219E',
    lArr: '\u21D0',
    larr: '\u2190',
    larrb: '\u21E4',
    larrbfs: '\u291F',
    larrfs: '\u291D',
    larrhk: '\u21A9',
    larrlp: '\u21AB',
    larrpl: '\u2939',
    larrsim: '\u2973',
    larrtl: '\u21A2',
    lat: '\u2AAB',
    lAtail: '\u291B',
    latail: '\u2919',
    late: '\u2AAD',
    lates: '\u2AAD\uFE00',
    lBarr: '\u290E',
    lbarr: '\u290C',
    lbbrk: '\u2772',
    lbrace: '\u007B',
    lbrack: '\u005B',
    lbrke: '\u298B',
    lbrksld: '\u298F',
    lbrkslu: '\u298D',
    Lcaron: '\u013D',
    lcaron: '\u013E',
    Lcedil: '\u013B',
    lcedil: '\u013C',
    lceil: '\u2308',
    lcub: '\u007B',
    Lcy: '\u041B',
    lcy: '\u043B',
    ldca: '\u2936',
    ldquo: '\u201C',
    ldquor: '\u201E',
    ldrdhar: '\u2967',
    ldrushar: '\u294B',
    ldsh: '\u21B2',
    lE: '\u2266',
    le: '\u2264',
    LeftAngleBracket: '\u27E8',
    LeftArrow: '\u2190',
    Leftarrow: '\u21D0',
    leftarrow: '\u2190',
    LeftArrowBar: '\u21E4',
    LeftArrowRightArrow: '\u21C6',
    leftarrowtail: '\u21A2',
    LeftCeiling: '\u2308',
    LeftDoubleBracket: '\u27E6',
    LeftDownTeeVector: '\u2961',
    LeftDownVector: '\u21C3',
    LeftDownVectorBar: '\u2959',
    LeftFloor: '\u230A',
    leftharpoondown: '\u21BD',
    leftharpoonup: '\u21BC',
    leftleftarrows: '\u21C7',
    LeftRightArrow: '\u2194',
    Leftrightarrow: '\u21D4',
    leftrightarrow: '\u2194',
    leftrightarrows: '\u21C6',
    leftrightharpoons: '\u21CB',
    leftrightsquigarrow: '\u21AD',
    LeftRightVector: '\u294E',
    LeftTee: '\u22A3',
    LeftTeeArrow: '\u21A4',
    LeftTeeVector: '\u295A',
    leftthreetimes: '\u22CB',
    LeftTriangle: '\u22B2',
    LeftTriangleBar: '\u29CF',
    LeftTriangleEqual: '\u22B4',
    LeftUpDownVector: '\u2951',
    LeftUpTeeVector: '\u2960',
    LeftUpVector: '\u21BF',
    LeftUpVectorBar: '\u2958',
    LeftVector: '\u21BC',
    LeftVectorBar: '\u2952',
    lEg: '\u2A8B',
    leg: '\u22DA',
    leq: '\u2264',
    leqq: '\u2266',
    leqslant: '\u2A7D',
    les: '\u2A7D',
    lescc: '\u2AA8',
    lesdot: '\u2A7F',
    lesdoto: '\u2A81',
    lesdotor: '\u2A83',
    lesg: '\u22DA\uFE00',
    lesges: '\u2A93',
    lessapprox: '\u2A85',
    lessdot: '\u22D6',
    lesseqgtr: '\u22DA',
    lesseqqgtr: '\u2A8B',
    LessEqualGreater: '\u22DA',
    LessFullEqual: '\u2266',
    LessGreater: '\u2276',
    lessgtr: '\u2276',
    LessLess: '\u2AA1',
    lesssim: '\u2272',
    LessSlantEqual: '\u2A7D',
    LessTilde: '\u2272',
    lfisht: '\u297C',
    lfloor: '\u230A',
    Lfr: '\uD835\uDD0F',
    lfr: '\uD835\uDD29',
    lg: '\u2276',
    lgE: '\u2A91',
    lHar: '\u2962',
    lhard: '\u21BD',
    lharu: '\u21BC',
    lharul: '\u296A',
    lhblk: '\u2584',
    LJcy: '\u0409',
    ljcy: '\u0459',
    Ll: '\u22D8',
    ll: '\u226A',
    llarr: '\u21C7',
    llcorner: '\u231E',
    Lleftarrow: '\u21DA',
    llhard: '\u296B',
    lltri: '\u25FA',
    Lmidot: '\u013F',
    lmidot: '\u0140',
    lmoust: '\u23B0',
    lmoustache: '\u23B0',
    lnap: '\u2A89',
    lnapprox: '\u2A89',
    lnE: '\u2268',
    lne: '\u2A87',
    lneq: '\u2A87',
    lneqq: '\u2268',
    lnsim: '\u22E6',
    loang: '\u27EC',
    loarr: '\u21FD',
    lobrk: '\u27E6',
    LongLeftArrow: '\u27F5',
    Longleftarrow: '\u27F8',
    longleftarrow: '\u27F5',
    LongLeftRightArrow: '\u27F7',
    Longleftrightarrow: '\u27FA',
    longleftrightarrow: '\u27F7',
    longmapsto: '\u27FC',
    LongRightArrow: '\u27F6',
    Longrightarrow: '\u27F9',
    longrightarrow: '\u27F6',
    looparrowleft: '\u21AB',
    looparrowright: '\u21AC',
    lopar: '\u2985',
    Lopf: '\uD835\uDD43',
    lopf: '\uD835\uDD5D',
    loplus: '\u2A2D',
    lotimes: '\u2A34',
    lowast: '\u2217',
    lowbar: '\u005F',
    LowerLeftArrow: '\u2199',
    LowerRightArrow: '\u2198',
    loz: '\u25CA',
    lozenge: '\u25CA',
    lozf: '\u29EB',
    lpar: '\u0028',
    lparlt: '\u2993',
    lrarr: '\u21C6',
    lrcorner: '\u231F',
    lrhar: '\u21CB',
    lrhard: '\u296D',
    lrm: '\u200E',
    lrtri: '\u22BF',
    lsaquo: '\u2039',
    Lscr: '\u2112',
    lscr: '\uD835\uDCC1',
    Lsh: '\u21B0',
    lsh: '\u21B0',
    lsim: '\u2272',
    lsime: '\u2A8D',
    lsimg: '\u2A8F',
    lsqb: '\u005B',
    lsquo: '\u2018',
    lsquor: '\u201A',
    Lstrok: '\u0141',
    lstrok: '\u0142',
    Lt: '\u226A',
    LT: '\u003C',
    lt: '\u003C',
    ltcc: '\u2AA6',
    ltcir: '\u2A79',
    ltdot: '\u22D6',
    lthree: '\u22CB',
    ltimes: '\u22C9',
    ltlarr: '\u2976',
    ltquest: '\u2A7B',
    ltri: '\u25C3',
    ltrie: '\u22B4',
    ltrif: '\u25C2',
    ltrPar: '\u2996',
    lurdshar: '\u294A',
    luruhar: '\u2966',
    lvertneqq: '\u2268\uFE00',
    lvnE: '\u2268\uFE00',
    macr: '\u00AF',
    male: '\u2642',
    malt: '\u2720',
    maltese: '\u2720',
    Map: '\u2905',
    map: '\u21A6',
    mapsto: '\u21A6',
    mapstodown: '\u21A7',
    mapstoleft: '\u21A4',
    mapstoup: '\u21A5',
    marker: '\u25AE',
    mcomma: '\u2A29',
    Mcy: '\u041C',
    mcy: '\u043C',
    mdash: '\u2014',
    mDDot: '\u223A',
    measuredangle: '\u2221',
    MediumSpace: '\u205F',
    Mellintrf: '\u2133',
    Mfr: '\uD835\uDD10',
    mfr: '\uD835\uDD2A',
    mho: '\u2127',
    micro: '\u00B5',
    mid: '\u2223',
    midast: '\u002A',
    midcir: '\u2AF0',
    middot: '\u00B7',
    minus: '\u2212',
    minusb: '\u229F',
    minusd: '\u2238',
    minusdu: '\u2A2A',
    MinusPlus: '\u2213',
    mlcp: '\u2ADB',
    mldr: '\u2026',
    mnplus: '\u2213',
    models: '\u22A7',
    Mopf: '\uD835\uDD44',
    mopf: '\uD835\uDD5E',
    mp: '\u2213',
    Mscr: '\u2133',
    mscr: '\uD835\uDCC2',
    mstpos: '\u223E',
    Mu: '\u039C',
    mu: '\u03BC',
    multimap: '\u22B8',
    mumap: '\u22B8',
    nabla: '\u2207',
    Nacute: '\u0143',
    nacute: '\u0144',
    nang: '\u2220\u20D2',
    nap: '\u2249',
    napE: '\u2A70\u0338',
    napid: '\u224B\u0338',
    napos: '\u0149',
    napprox: '\u2249',
    natur: '\u266E',
    natural: '\u266E',
    naturals: '\u2115',
    nbsp: '\u00A0',
    nbump: '\u224E\u0338',
    nbumpe: '\u224F\u0338',
    ncap: '\u2A43',
    Ncaron: '\u0147',
    ncaron: '\u0148',
    Ncedil: '\u0145',
    ncedil: '\u0146',
    ncong: '\u2247',
    ncongdot: '\u2A6D\u0338',
    ncup: '\u2A42',
    Ncy: '\u041D',
    ncy: '\u043D',
    ndash: '\u2013',
    ne: '\u2260',
    nearhk: '\u2924',
    neArr: '\u21D7',
    nearr: '\u2197',
    nearrow: '\u2197',
    nedot: '\u2250\u0338',
    NegativeMediumSpace: '\u200B',
    NegativeThickSpace: '\u200B',
    NegativeThinSpace: '\u200B',
    NegativeVeryThinSpace: '\u200B',
    nequiv: '\u2262',
    nesear: '\u2928',
    nesim: '\u2242\u0338',
    NestedGreaterGreater: '\u226B',
    NestedLessLess: '\u226A',
    NewLine: '\u000A',
    nexist: '\u2204',
    nexists: '\u2204',
    Nfr: '\uD835\uDD11',
    nfr: '\uD835\uDD2B',
    ngE: '\u2267\u0338',
    nge: '\u2271',
    ngeq: '\u2271',
    ngeqq: '\u2267\u0338',
    ngeqslant: '\u2A7E\u0338',
    nges: '\u2A7E\u0338',
    nGg: '\u22D9\u0338',
    ngsim: '\u2275',
    nGt: '\u226B\u20D2',
    ngt: '\u226F',
    ngtr: '\u226F',
    nGtv: '\u226B\u0338',
    nhArr: '\u21CE',
    nharr: '\u21AE',
    nhpar: '\u2AF2',
    ni: '\u220B',
    nis: '\u22FC',
    nisd: '\u22FA',
    niv: '\u220B',
    NJcy: '\u040A',
    njcy: '\u045A',
    nlArr: '\u21CD',
    nlarr: '\u219A',
    nldr: '\u2025',
    nlE: '\u2266\u0338',
    nle: '\u2270',
    nLeftarrow: '\u21CD',
    nleftarrow: '\u219A',
    nLeftrightarrow: '\u21CE',
    nleftrightarrow: '\u21AE',
    nleq: '\u2270',
    nleqq: '\u2266\u0338',
    nleqslant: '\u2A7D\u0338',
    nles: '\u2A7D\u0338',
    nless: '\u226E',
    nLl: '\u22D8\u0338',
    nlsim: '\u2274',
    nLt: '\u226A\u20D2',
    nlt: '\u226E',
    nltri: '\u22EA',
    nltrie: '\u22EC',
    nLtv: '\u226A\u0338',
    nmid: '\u2224',
    NoBreak: '\u2060',
    NonBreakingSpace: '\u00A0',
    Nopf: '\u2115',
    nopf: '\uD835\uDD5F',
    Not: '\u2AEC',
    not: '\u00AC',
    NotCongruent: '\u2262',
    NotCupCap: '\u226D',
    NotDoubleVerticalBar: '\u2226',
    NotElement: '\u2209',
    NotEqual: '\u2260',
    NotEqualTilde: '\u2242\u0338',
    NotExists: '\u2204',
    NotGreater: '\u226F',
    NotGreaterEqual: '\u2271',
    NotGreaterFullEqual: '\u2267\u0338',
    NotGreaterGreater: '\u226B\u0338',
    NotGreaterLess: '\u2279',
    NotGreaterSlantEqual: '\u2A7E\u0338',
    NotGreaterTilde: '\u2275',
    NotHumpDownHump: '\u224E\u0338',
    NotHumpEqual: '\u224F\u0338',
    notin: '\u2209',
    notindot: '\u22F5\u0338',
    notinE: '\u22F9\u0338',
    notinva: '\u2209',
    notinvb: '\u22F7',
    notinvc: '\u22F6',
    NotLeftTriangle: '\u22EA',
    NotLeftTriangleBar: '\u29CF\u0338',
    NotLeftTriangleEqual: '\u22EC',
    NotLess: '\u226E',
    NotLessEqual: '\u2270',
    NotLessGreater: '\u2278',
    NotLessLess: '\u226A\u0338',
    NotLessSlantEqual: '\u2A7D\u0338',
    NotLessTilde: '\u2274',
    NotNestedGreaterGreater: '\u2AA2\u0338',
    NotNestedLessLess: '\u2AA1\u0338',
    notni: '\u220C',
    notniva: '\u220C',
    notnivb: '\u22FE',
    notnivc: '\u22FD',
    NotPrecedes: '\u2280',
    NotPrecedesEqual: '\u2AAF\u0338',
    NotPrecedesSlantEqual: '\u22E0',
    NotReverseElement: '\u220C',
    NotRightTriangle: '\u22EB',
    NotRightTriangleBar: '\u29D0\u0338',
    NotRightTriangleEqual: '\u22ED',
    NotSquareSubset: '\u228F\u0338',
    NotSquareSubsetEqual: '\u22E2',
    NotSquareSuperset: '\u2290\u0338',
    NotSquareSupersetEqual: '\u22E3',
    NotSubset: '\u2282\u20D2',
    NotSubsetEqual: '\u2288',
    NotSucceeds: '\u2281',
    NotSucceedsEqual: '\u2AB0\u0338',
    NotSucceedsSlantEqual: '\u22E1',
    NotSucceedsTilde: '\u227F\u0338',
    NotSuperset: '\u2283\u20D2',
    NotSupersetEqual: '\u2289',
    NotTilde: '\u2241',
    NotTildeEqual: '\u2244',
    NotTildeFullEqual: '\u2247',
    NotTildeTilde: '\u2249',
    NotVerticalBar: '\u2224',
    npar: '\u2226',
    nparallel: '\u2226',
    nparsl: '\u2AFD\u20E5',
    npart: '\u2202\u0338',
    npolint: '\u2A14',
    npr: '\u2280',
    nprcue: '\u22E0',
    npre: '\u2AAF\u0338',
    nprec: '\u2280',
    npreceq: '\u2AAF\u0338',
    nrArr: '\u21CF',
    nrarr: '\u219B',
    nrarrc: '\u2933\u0338',
    nrarrw: '\u219D\u0338',
    nRightarrow: '\u21CF',
    nrightarrow: '\u219B',
    nrtri: '\u22EB',
    nrtrie: '\u22ED',
    nsc: '\u2281',
    nsccue: '\u22E1',
    nsce: '\u2AB0\u0338',
    Nscr: '\uD835\uDCA9',
    nscr: '\uD835\uDCC3',
    nshortmid: '\u2224',
    nshortparallel: '\u2226',
    nsim: '\u2241',
    nsime: '\u2244',
    nsimeq: '\u2244',
    nsmid: '\u2224',
    nspar: '\u2226',
    nsqsube: '\u22E2',
    nsqsupe: '\u22E3',
    nsub: '\u2284',
    nsubE: '\u2AC5\u0338',
    nsube: '\u2288',
    nsubset: '\u2282\u20D2',
    nsubseteq: '\u2288',
    nsubseteqq: '\u2AC5\u0338',
    nsucc: '\u2281',
    nsucceq: '\u2AB0\u0338',
    nsup: '\u2285',
    nsupE: '\u2AC6\u0338',
    nsupe: '\u2289',
    nsupset: '\u2283\u20D2',
    nsupseteq: '\u2289',
    nsupseteqq: '\u2AC6\u0338',
    ntgl: '\u2279',
    Ntilde: '\u00D1',
    ntilde: '\u00F1',
    ntlg: '\u2278',
    ntriangleleft: '\u22EA',
    ntrianglelefteq: '\u22EC',
    ntriangleright: '\u22EB',
    ntrianglerighteq: '\u22ED',
    Nu: '\u039D',
    nu: '\u03BD',
    num: '\u0023',
    numero: '\u2116',
    numsp: '\u2007',
    nvap: '\u224D\u20D2',
    nVDash: '\u22AF',
    nVdash: '\u22AE',
    nvDash: '\u22AD',
    nvdash: '\u22AC',
    nvge: '\u2265\u20D2',
    nvgt: '\u003E\u20D2',
    nvHarr: '\u2904',
    nvinfin: '\u29DE',
    nvlArr: '\u2902',
    nvle: '\u2264\u20D2',
    nvlt: '\u003C\u20D2',
    nvltrie: '\u22B4\u20D2',
    nvrArr: '\u2903',
    nvrtrie: '\u22B5\u20D2',
    nvsim: '\u223C\u20D2',
    nwarhk: '\u2923',
    nwArr: '\u21D6',
    nwarr: '\u2196',
    nwarrow: '\u2196',
    nwnear: '\u2927',
    Oacute: '\u00D3',
    oacute: '\u00F3',
    oast: '\u229B',
    ocir: '\u229A',
    Ocirc: '\u00D4',
    ocirc: '\u00F4',
    Ocy: '\u041E',
    ocy: '\u043E',
    odash: '\u229D',
    Odblac: '\u0150',
    odblac: '\u0151',
    odiv: '\u2A38',
    odot: '\u2299',
    odsold: '\u29BC',
    OElig: '\u0152',
    oelig: '\u0153',
    ofcir: '\u29BF',
    Ofr: '\uD835\uDD12',
    ofr: '\uD835\uDD2C',
    ogon: '\u02DB',
    Ograve: '\u00D2',
    ograve: '\u00F2',
    ogt: '\u29C1',
    ohbar: '\u29B5',
    ohm: '\u03A9',
    oint: '\u222E',
    olarr: '\u21BA',
    olcir: '\u29BE',
    olcross: '\u29BB',
    oline: '\u203E',
    olt: '\u29C0',
    Omacr: '\u014C',
    omacr: '\u014D',
    Omega: '\u03A9',
    omega: '\u03C9',
    Omicron: '\u039F',
    omicron: '\u03BF',
    omid: '\u29B6',
    ominus: '\u2296',
    Oopf: '\uD835\uDD46',
    oopf: '\uD835\uDD60',
    opar: '\u29B7',
    OpenCurlyDoubleQuote: '\u201C',
    OpenCurlyQuote: '\u2018',
    operp: '\u29B9',
    oplus: '\u2295',
    Or: '\u2A54',
    or: '\u2228',
    orarr: '\u21BB',
    ord: '\u2A5D',
    order: '\u2134',
    orderof: '\u2134',
    ordf: '\u00AA',
    ordm: '\u00BA',
    origof: '\u22B6',
    oror: '\u2A56',
    orslope: '\u2A57',
    orv: '\u2A5B',
    oS: '\u24C8',
    Oscr: '\uD835\uDCAA',
    oscr: '\u2134',
    Oslash: '\u00D8',
    oslash: '\u00F8',
    osol: '\u2298',
    Otilde: '\u00D5',
    otilde: '\u00F5',
    Otimes: '\u2A37',
    otimes: '\u2297',
    otimesas: '\u2A36',
    Ouml: '\u00D6',
    ouml: '\u00F6',
    ovbar: '\u233D',
    OverBar: '\u203E',
    OverBrace: '\u23DE',
    OverBracket: '\u23B4',
    OverParenthesis: '\u23DC',
    par: '\u2225',
    para: '\u00B6',
    parallel: '\u2225',
    parsim: '\u2AF3',
    parsl: '\u2AFD',
    part: '\u2202',
    PartialD: '\u2202',
    Pcy: '\u041F',
    pcy: '\u043F',
    percnt: '\u0025',
    period: '\u002E',
    permil: '\u2030',
    perp: '\u22A5',
    pertenk: '\u2031',
    Pfr: '\uD835\uDD13',
    pfr: '\uD835\uDD2D',
    Phi: '\u03A6',
    phi: '\u03C6',
    phiv: '\u03D5',
    phmmat: '\u2133',
    phone: '\u260E',
    Pi: '\u03A0',
    pi: '\u03C0',
    pitchfork: '\u22D4',
    piv: '\u03D6',
    planck: '\u210F',
    planckh: '\u210E',
    plankv: '\u210F',
    plus: '\u002B',
    plusacir: '\u2A23',
    plusb: '\u229E',
    pluscir: '\u2A22',
    plusdo: '\u2214',
    plusdu: '\u2A25',
    pluse: '\u2A72',
    PlusMinus: '\u00B1',
    plusmn: '\u00B1',
    plussim: '\u2A26',
    plustwo: '\u2A27',
    pm: '\u00B1',
    Poincareplane: '\u210C',
    pointint: '\u2A15',
    Popf: '\u2119',
    popf: '\uD835\uDD61',
    pound: '\u00A3',
    Pr: '\u2ABB',
    pr: '\u227A',
    prap: '\u2AB7',
    prcue: '\u227C',
    prE: '\u2AB3',
    pre: '\u2AAF',
    prec: '\u227A',
    precapprox: '\u2AB7',
    preccurlyeq: '\u227C',
    Precedes: '\u227A',
    PrecedesEqual: '\u2AAF',
    PrecedesSlantEqual: '\u227C',
    PrecedesTilde: '\u227E',
    preceq: '\u2AAF',
    precnapprox: '\u2AB9',
    precneqq: '\u2AB5',
    precnsim: '\u22E8',
    precsim: '\u227E',
    Prime: '\u2033',
    prime: '\u2032',
    primes: '\u2119',
    prnap: '\u2AB9',
    prnE: '\u2AB5',
    prnsim: '\u22E8',
    prod: '\u220F',
    Product: '\u220F',
    profalar: '\u232E',
    profline: '\u2312',
    profsurf: '\u2313',
    prop: '\u221D',
    Proportion: '\u2237',
    Proportional: '\u221D',
    propto: '\u221D',
    prsim: '\u227E',
    prurel: '\u22B0',
    Pscr: '\uD835\uDCAB',
    pscr: '\uD835\uDCC5',
    Psi: '\u03A8',
    psi: '\u03C8',
    puncsp: '\u2008',
    Qfr: '\uD835\uDD14',
    qfr: '\uD835\uDD2E',
    qint: '\u2A0C',
    Qopf: '\u211A',
    qopf: '\uD835\uDD62',
    qprime: '\u2057',
    Qscr: '\uD835\uDCAC',
    qscr: '\uD835\uDCC6',
    quaternions: '\u210D',
    quatint: '\u2A16',
    quest: '\u003F',
    questeq: '\u225F',
    QUOT: '\u0022',
    quot: '\u0022',
    rAarr: '\u21DB',
    race: '\u223D\u0331',
    Racute: '\u0154',
    racute: '\u0155',
    radic: '\u221A',
    raemptyv: '\u29B3',
    Rang: '\u27EB',
    rang: '\u27E9',
    rangd: '\u2992',
    range: '\u29A5',
    rangle: '\u27E9',
    raquo: '\u00BB',
    Rarr: '\u21A0',
    rArr: '\u21D2',
    rarr: '\u2192',
    rarrap: '\u2975',
    rarrb: '\u21E5',
    rarrbfs: '\u2920',
    rarrc: '\u2933',
    rarrfs: '\u291E',
    rarrhk: '\u21AA',
    rarrlp: '\u21AC',
    rarrpl: '\u2945',
    rarrsim: '\u2974',
    Rarrtl: '\u2916',
    rarrtl: '\u21A3',
    rarrw: '\u219D',
    rAtail: '\u291C',
    ratail: '\u291A',
    ratio: '\u2236',
    rationals: '\u211A',
    RBarr: '\u2910',
    rBarr: '\u290F',
    rbarr: '\u290D',
    rbbrk: '\u2773',
    rbrace: '\u007D',
    rbrack: '\u005D',
    rbrke: '\u298C',
    rbrksld: '\u298E',
    rbrkslu: '\u2990',
    Rcaron: '\u0158',
    rcaron: '\u0159',
    Rcedil: '\u0156',
    rcedil: '\u0157',
    rceil: '\u2309',
    rcub: '\u007D',
    Rcy: '\u0420',
    rcy: '\u0440',
    rdca: '\u2937',
    rdldhar: '\u2969',
    rdquo: '\u201D',
    rdquor: '\u201D',
    rdsh: '\u21B3',
    Re: '\u211C',
    real: '\u211C',
    realine: '\u211B',
    realpart: '\u211C',
    reals: '\u211D',
    rect: '\u25AD',
    REG: '\u00AE',
    reg: '\u00AE',
    ReverseElement: '\u220B',
    ReverseEquilibrium: '\u21CB',
    ReverseUpEquilibrium: '\u296F',
    rfisht: '\u297D',
    rfloor: '\u230B',
    Rfr: '\u211C',
    rfr: '\uD835\uDD2F',
    rHar: '\u2964',
    rhard: '\u21C1',
    rharu: '\u21C0',
    rharul: '\u296C',
    Rho: '\u03A1',
    rho: '\u03C1',
    rhov: '\u03F1',
    RightAngleBracket: '\u27E9',
    RightArrow: '\u2192',
    Rightarrow: '\u21D2',
    rightarrow: '\u2192',
    RightArrowBar: '\u21E5',
    RightArrowLeftArrow: '\u21C4',
    rightarrowtail: '\u21A3',
    RightCeiling: '\u2309',
    RightDoubleBracket: '\u27E7',
    RightDownTeeVector: '\u295D',
    RightDownVector: '\u21C2',
    RightDownVectorBar: '\u2955',
    RightFloor: '\u230B',
    rightharpoondown: '\u21C1',
    rightharpoonup: '\u21C0',
    rightleftarrows: '\u21C4',
    rightleftharpoons: '\u21CC',
    rightrightarrows: '\u21C9',
    rightsquigarrow: '\u219D',
    RightTee: '\u22A2',
    RightTeeArrow: '\u21A6',
    RightTeeVector: '\u295B',
    rightthreetimes: '\u22CC',
    RightTriangle: '\u22B3',
    RightTriangleBar: '\u29D0',
    RightTriangleEqual: '\u22B5',
    RightUpDownVector: '\u294F',
    RightUpTeeVector: '\u295C',
    RightUpVector: '\u21BE',
    RightUpVectorBar: '\u2954',
    RightVector: '\u21C0',
    RightVectorBar: '\u2953',
    ring: '\u02DA',
    risingdotseq: '\u2253',
    rlarr: '\u21C4',
    rlhar: '\u21CC',
    rlm: '\u200F',
    rmoust: '\u23B1',
    rmoustache: '\u23B1',
    rnmid: '\u2AEE',
    roang: '\u27ED',
    roarr: '\u21FE',
    robrk: '\u27E7',
    ropar: '\u2986',
    Ropf: '\u211D',
    ropf: '\uD835\uDD63',
    roplus: '\u2A2E',
    rotimes: '\u2A35',
    RoundImplies: '\u2970',
    rpar: '\u0029',
    rpargt: '\u2994',
    rppolint: '\u2A12',
    rrarr: '\u21C9',
    Rrightarrow: '\u21DB',
    rsaquo: '\u203A',
    Rscr: '\u211B',
    rscr: '\uD835\uDCC7',
    Rsh: '\u21B1',
    rsh: '\u21B1',
    rsqb: '\u005D',
    rsquo: '\u2019',
    rsquor: '\u2019',
    rthree: '\u22CC',
    rtimes: '\u22CA',
    rtri: '\u25B9',
    rtrie: '\u22B5',
    rtrif: '\u25B8',
    rtriltri: '\u29CE',
    RuleDelayed: '\u29F4',
    ruluhar: '\u2968',
    rx: '\u211E',
    Sacute: '\u015A',
    sacute: '\u015B',
    sbquo: '\u201A',
    Sc: '\u2ABC',
    sc: '\u227B',
    scap: '\u2AB8',
    Scaron: '\u0160',
    scaron: '\u0161',
    sccue: '\u227D',
    scE: '\u2AB4',
    sce: '\u2AB0',
    Scedil: '\u015E',
    scedil: '\u015F',
    Scirc: '\u015C',
    scirc: '\u015D',
    scnap: '\u2ABA',
    scnE: '\u2AB6',
    scnsim: '\u22E9',
    scpolint: '\u2A13',
    scsim: '\u227F',
    Scy: '\u0421',
    scy: '\u0441',
    sdot: '\u22C5',
    sdotb: '\u22A1',
    sdote: '\u2A66',
    searhk: '\u2925',
    seArr: '\u21D8',
    searr: '\u2198',
    searrow: '\u2198',
    sect: '\u00A7',
    semi: '\u003B',
    seswar: '\u2929',
    setminus: '\u2216',
    setmn: '\u2216',
    sext: '\u2736',
    Sfr: '\uD835\uDD16',
    sfr: '\uD835\uDD30',
    sfrown: '\u2322',
    sharp: '\u266F',
    SHCHcy: '\u0429',
    shchcy: '\u0449',
    SHcy: '\u0428',
    shcy: '\u0448',
    ShortDownArrow: '\u2193',
    ShortLeftArrow: '\u2190',
    shortmid: '\u2223',
    shortparallel: '\u2225',
    ShortRightArrow: '\u2192',
    ShortUpArrow: '\u2191',
    shy: '\u00AD',
    Sigma: '\u03A3',
    sigma: '\u03C3',
    sigmaf: '\u03C2',
    sigmav: '\u03C2',
    sim: '\u223C',
    simdot: '\u2A6A',
    sime: '\u2243',
    simeq: '\u2243',
    simg: '\u2A9E',
    simgE: '\u2AA0',
    siml: '\u2A9D',
    simlE: '\u2A9F',
    simne: '\u2246',
    simplus: '\u2A24',
    simrarr: '\u2972',
    slarr: '\u2190',
    SmallCircle: '\u2218',
    smallsetminus: '\u2216',
    smashp: '\u2A33',
    smeparsl: '\u29E4',
    smid: '\u2223',
    smile: '\u2323',
    smt: '\u2AAA',
    smte: '\u2AAC',
    smtes: '\u2AAC\uFE00',
    SOFTcy: '\u042C',
    softcy: '\u044C',
    sol: '\u002F',
    solb: '\u29C4',
    solbar: '\u233F',
    Sopf: '\uD835\uDD4A',
    sopf: '\uD835\uDD64',
    spades: '\u2660',
    spadesuit: '\u2660',
    spar: '\u2225',
    sqcap: '\u2293',
    sqcaps: '\u2293\uFE00',
    sqcup: '\u2294',
    sqcups: '\u2294\uFE00',
    Sqrt: '\u221A',
    sqsub: '\u228F',
    sqsube: '\u2291',
    sqsubset: '\u228F',
    sqsubseteq: '\u2291',
    sqsup: '\u2290',
    sqsupe: '\u2292',
    sqsupset: '\u2290',
    sqsupseteq: '\u2292',
    squ: '\u25A1',
    Square: '\u25A1',
    square: '\u25A1',
    SquareIntersection: '\u2293',
    SquareSubset: '\u228F',
    SquareSubsetEqual: '\u2291',
    SquareSuperset: '\u2290',
    SquareSupersetEqual: '\u2292',
    SquareUnion: '\u2294',
    squarf: '\u25AA',
    squf: '\u25AA',
    srarr: '\u2192',
    Sscr: '\uD835\uDCAE',
    sscr: '\uD835\uDCC8',
    ssetmn: '\u2216',
    ssmile: '\u2323',
    sstarf: '\u22C6',
    Star: '\u22C6',
    star: '\u2606',
    starf: '\u2605',
    straightepsilon: '\u03F5',
    straightphi: '\u03D5',
    strns: '\u00AF',
    Sub: '\u22D0',
    sub: '\u2282',
    subdot: '\u2ABD',
    subE: '\u2AC5',
    sube: '\u2286',
    subedot: '\u2AC3',
    submult: '\u2AC1',
    subnE: '\u2ACB',
    subne: '\u228A',
    subplus: '\u2ABF',
    subrarr: '\u2979',
    Subset: '\u22D0',
    subset: '\u2282',
    subseteq: '\u2286',
    subseteqq: '\u2AC5',
    SubsetEqual: '\u2286',
    subsetneq: '\u228A',
    subsetneqq: '\u2ACB',
    subsim: '\u2AC7',
    subsub: '\u2AD5',
    subsup: '\u2AD3',
    succ: '\u227B',
    succapprox: '\u2AB8',
    succcurlyeq: '\u227D',
    Succeeds: '\u227B',
    SucceedsEqual: '\u2AB0',
    SucceedsSlantEqual: '\u227D',
    SucceedsTilde: '\u227F',
    succeq: '\u2AB0',
    succnapprox: '\u2ABA',
    succneqq: '\u2AB6',
    succnsim: '\u22E9',
    succsim: '\u227F',
    SuchThat: '\u220B',
    Sum: '\u2211',
    sum: '\u2211',
    sung: '\u266A',
    Sup: '\u22D1',
    sup: '\u2283',
    sup1: '\u00B9',
    sup2: '\u00B2',
    sup3: '\u00B3',
    supdot: '\u2ABE',
    supdsub: '\u2AD8',
    supE: '\u2AC6',
    supe: '\u2287',
    supedot: '\u2AC4',
    Superset: '\u2283',
    SupersetEqual: '\u2287',
    suphsol: '\u27C9',
    suphsub: '\u2AD7',
    suplarr: '\u297B',
    supmult: '\u2AC2',
    supnE: '\u2ACC',
    supne: '\u228B',
    supplus: '\u2AC0',
    Supset: '\u22D1',
    supset: '\u2283',
    supseteq: '\u2287',
    supseteqq: '\u2AC6',
    supsetneq: '\u228B',
    supsetneqq: '\u2ACC',
    supsim: '\u2AC8',
    supsub: '\u2AD4',
    supsup: '\u2AD6',
    swarhk: '\u2926',
    swArr: '\u21D9',
    swarr: '\u2199',
    swarrow: '\u2199',
    swnwar: '\u292A',
    szlig: '\u00DF',
    Tab: '\u0009',
    target: '\u2316',
    Tau: '\u03A4',
    tau: '\u03C4',
    tbrk: '\u23B4',
    Tcaron: '\u0164',
    tcaron: '\u0165',
    Tcedil: '\u0162',
    tcedil: '\u0163',
    Tcy: '\u0422',
    tcy: '\u0442',
    tdot: '\u20DB',
    telrec: '\u2315',
    Tfr: '\uD835\uDD17',
    tfr: '\uD835\uDD31',
    there4: '\u2234',
    Therefore: '\u2234',
    therefore: '\u2234',
    Theta: '\u0398',
    theta: '\u03B8',
    thetasym: '\u03D1',
    thetav: '\u03D1',
    thickapprox: '\u2248',
    thicksim: '\u223C',
    ThickSpace: '\u205F\u200A',
    thinsp: '\u2009',
    ThinSpace: '\u2009',
    thkap: '\u2248',
    thksim: '\u223C',
    THORN: '\u00DE',
    thorn: '\u00FE',
    Tilde: '\u223C',
    tilde: '\u02DC',
    TildeEqual: '\u2243',
    TildeFullEqual: '\u2245',
    TildeTilde: '\u2248',
    times: '\u00D7',
    timesb: '\u22A0',
    timesbar: '\u2A31',
    timesd: '\u2A30',
    tint: '\u222D',
    toea: '\u2928',
    top: '\u22A4',
    topbot: '\u2336',
    topcir: '\u2AF1',
    Topf: '\uD835\uDD4B',
    topf: '\uD835\uDD65',
    topfork: '\u2ADA',
    tosa: '\u2929',
    tprime: '\u2034',
    TRADE: '\u2122',
    trade: '\u2122',
    triangle: '\u25B5',
    triangledown: '\u25BF',
    triangleleft: '\u25C3',
    trianglelefteq: '\u22B4',
    triangleq: '\u225C',
    triangleright: '\u25B9',
    trianglerighteq: '\u22B5',
    tridot: '\u25EC',
    trie: '\u225C',
    triminus: '\u2A3A',
    TripleDot: '\u20DB',
    triplus: '\u2A39',
    trisb: '\u29CD',
    tritime: '\u2A3B',
    trpezium: '\u23E2',
    Tscr: '\uD835\uDCAF',
    tscr: '\uD835\uDCC9',
    TScy: '\u0426',
    tscy: '\u0446',
    TSHcy: '\u040B',
    tshcy: '\u045B',
    Tstrok: '\u0166',
    tstrok: '\u0167',
    twixt: '\u226C',
    twoheadleftarrow: '\u219E',
    twoheadrightarrow: '\u21A0',
    Uacute: '\u00DA',
    uacute: '\u00FA',
    Uarr: '\u219F',
    uArr: '\u21D1',
    uarr: '\u2191',
    Uarrocir: '\u2949',
    Ubrcy: '\u040E',
    ubrcy: '\u045E',
    Ubreve: '\u016C',
    ubreve: '\u016D',
    Ucirc: '\u00DB',
    ucirc: '\u00FB',
    Ucy: '\u0423',
    ucy: '\u0443',
    udarr: '\u21C5',
    Udblac: '\u0170',
    udblac: '\u0171',
    udhar: '\u296E',
    ufisht: '\u297E',
    Ufr: '\uD835\uDD18',
    ufr: '\uD835\uDD32',
    Ugrave: '\u00D9',
    ugrave: '\u00F9',
    uHar: '\u2963',
    uharl: '\u21BF',
    uharr: '\u21BE',
    uhblk: '\u2580',
    ulcorn: '\u231C',
    ulcorner: '\u231C',
    ulcrop: '\u230F',
    ultri: '\u25F8',
    Umacr: '\u016A',
    umacr: '\u016B',
    uml: '\u00A8',
    UnderBar: '\u005F',
    UnderBrace: '\u23DF',
    UnderBracket: '\u23B5',
    UnderParenthesis: '\u23DD',
    Union: '\u22C3',
    UnionPlus: '\u228E',
    Uogon: '\u0172',
    uogon: '\u0173',
    Uopf: '\uD835\uDD4C',
    uopf: '\uD835\uDD66',
    UpArrow: '\u2191',
    Uparrow: '\u21D1',
    uparrow: '\u2191',
    UpArrowBar: '\u2912',
    UpArrowDownArrow: '\u21C5',
    UpDownArrow: '\u2195',
    Updownarrow: '\u21D5',
    updownarrow: '\u2195',
    UpEquilibrium: '\u296E',
    upharpoonleft: '\u21BF',
    upharpoonright: '\u21BE',
    uplus: '\u228E',
    UpperLeftArrow: '\u2196',
    UpperRightArrow: '\u2197',
    Upsi: '\u03D2',
    upsi: '\u03C5',
    upsih: '\u03D2',
    Upsilon: '\u03A5',
    upsilon: '\u03C5',
    UpTee: '\u22A5',
    UpTeeArrow: '\u21A5',
    upuparrows: '\u21C8',
    urcorn: '\u231D',
    urcorner: '\u231D',
    urcrop: '\u230E',
    Uring: '\u016E',
    uring: '\u016F',
    urtri: '\u25F9',
    Uscr: '\uD835\uDCB0',
    uscr: '\uD835\uDCCA',
    utdot: '\u22F0',
    Utilde: '\u0168',
    utilde: '\u0169',
    utri: '\u25B5',
    utrif: '\u25B4',
    uuarr: '\u21C8',
    Uuml: '\u00DC',
    uuml: '\u00FC',
    uwangle: '\u29A7',
    vangrt: '\u299C',
    varepsilon: '\u03F5',
    varkappa: '\u03F0',
    varnothing: '\u2205',
    varphi: '\u03D5',
    varpi: '\u03D6',
    varpropto: '\u221D',
    vArr: '\u21D5',
    varr: '\u2195',
    varrho: '\u03F1',
    varsigma: '\u03C2',
    varsubsetneq: '\u228A\uFE00',
    varsubsetneqq: '\u2ACB\uFE00',
    varsupsetneq: '\u228B\uFE00',
    varsupsetneqq: '\u2ACC\uFE00',
    vartheta: '\u03D1',
    vartriangleleft: '\u22B2',
    vartriangleright: '\u22B3',
    Vbar: '\u2AEB',
    vBar: '\u2AE8',
    vBarv: '\u2AE9',
    Vcy: '\u0412',
    vcy: '\u0432',
    VDash: '\u22AB',
    Vdash: '\u22A9',
    vDash: '\u22A8',
    vdash: '\u22A2',
    Vdashl: '\u2AE6',
    Vee: '\u22C1',
    vee: '\u2228',
    veebar: '\u22BB',
    veeeq: '\u225A',
    vellip: '\u22EE',
    Verbar: '\u2016',
    verbar: '\u007C',
    Vert: '\u2016',
    vert: '\u007C',
    VerticalBar: '\u2223',
    VerticalLine: '\u007C',
    VerticalSeparator: '\u2758',
    VerticalTilde: '\u2240',
    VeryThinSpace: '\u200A',
    Vfr: '\uD835\uDD19',
    vfr: '\uD835\uDD33',
    vltri: '\u22B2',
    vnsub: '\u2282\u20D2',
    vnsup: '\u2283\u20D2',
    Vopf: '\uD835\uDD4D',
    vopf: '\uD835\uDD67',
    vprop: '\u221D',
    vrtri: '\u22B3',
    Vscr: '\uD835\uDCB1',
    vscr: '\uD835\uDCCB',
    vsubnE: '\u2ACB\uFE00',
    vsubne: '\u228A\uFE00',
    vsupnE: '\u2ACC\uFE00',
    vsupne: '\u228B\uFE00',
    Vvdash: '\u22AA',
    vzigzag: '\u299A',
    Wcirc: '\u0174',
    wcirc: '\u0175',
    wedbar: '\u2A5F',
    Wedge: '\u22C0',
    wedge: '\u2227',
    wedgeq: '\u2259',
    weierp: '\u2118',
    Wfr: '\uD835\uDD1A',
    wfr: '\uD835\uDD34',
    Wopf: '\uD835\uDD4E',
    wopf: '\uD835\uDD68',
    wp: '\u2118',
    wr: '\u2240',
    wreath: '\u2240',
    Wscr: '\uD835\uDCB2',
    wscr: '\uD835\uDCCC',
    xcap: '\u22C2',
    xcirc: '\u25EF',
    xcup: '\u22C3',
    xdtri: '\u25BD',
    Xfr: '\uD835\uDD1B',
    xfr: '\uD835\uDD35',
    xhArr: '\u27FA',
    xharr: '\u27F7',
    Xi: '\u039E',
    xi: '\u03BE',
    xlArr: '\u27F8',
    xlarr: '\u27F5',
    xmap: '\u27FC',
    xnis: '\u22FB',
    xodot: '\u2A00',
    Xopf: '\uD835\uDD4F',
    xopf: '\uD835\uDD69',
    xoplus: '\u2A01',
    xotime: '\u2A02',
    xrArr: '\u27F9',
    xrarr: '\u27F6',
    Xscr: '\uD835\uDCB3',
    xscr: '\uD835\uDCCD',
    xsqcup: '\u2A06',
    xuplus: '\u2A04',
    xutri: '\u25B3',
    xvee: '\u22C1',
    xwedge: '\u22C0',
    Yacute: '\u00DD',
    yacute: '\u00FD',
    YAcy: '\u042F',
    yacy: '\u044F',
    Ycirc: '\u0176',
    ycirc: '\u0177',
    Ycy: '\u042B',
    ycy: '\u044B',
    yen: '\u00A5',
    Yfr: '\uD835\uDD1C',
    yfr: '\uD835\uDD36',
    YIcy: '\u0407',
    yicy: '\u0457',
    Yopf: '\uD835\uDD50',
    yopf: '\uD835\uDD6A',
    Yscr: '\uD835\uDCB4',
    yscr: '\uD835\uDCCE',
    YUcy: '\u042E',
    yucy: '\u044E',
    Yuml: '\u0178',
    yuml: '\u00FF',
    Zacute: '\u0179',
    zacute: '\u017A',
    Zcaron: '\u017D',
    zcaron: '\u017E',
    Zcy: '\u0417',
    zcy: '\u0437',
    Zdot: '\u017B',
    zdot: '\u017C',
    zeetrf: '\u2128',
    ZeroWidthSpace: '\u200B',
    Zeta: '\u0396',
    zeta: '\u03B6',
    Zfr: '\u2128',
    zfr: '\uD835\uDD37',
    ZHcy: '\u0416',
    zhcy: '\u0436',
    zigrarr: '\u21DD',
    Zopf: '\u2124',
    zopf: '\uD835\uDD6B',
    Zscr: '\uD835\uDCB5',
    zscr: '\uD835\uDCCF',
    zwj: '\u200D',
    zwnj: '\u200C'
});
$5ff4427c87009307$export$79451380caed3f98 = $5ff4427c87009307$export$b7e4d4631df36afa;

});

parcelRegister("5ZAyY", function(module, exports) {

$parcel$export(module.exports, "XMLReader", () => $45cf02eb60fe7a20$export$ccbc9f9f018333e9, (v) => $45cf02eb60fe7a20$export$ccbc9f9f018333e9 = v);
$parcel$export(module.exports, "ParseError", () => $45cf02eb60fe7a20$export$f9c837a54db411d, (v) => $45cf02eb60fe7a20$export$f9c837a54db411d = v);
var $45cf02eb60fe7a20$export$ccbc9f9f018333e9;
var $45cf02eb60fe7a20$export$f9c837a54db411d;

var $ghxvC = parcelRequire("ghxvC");
var $45cf02eb60fe7a20$require$NAMESPACE = $ghxvC.NAMESPACE;
//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var $45cf02eb60fe7a20$var$nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/ //\u10000-\uEFFFF
;
var $45cf02eb60fe7a20$var$nameChar = new RegExp("[\\-\\.0-9" + $45cf02eb60fe7a20$var$nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var $45cf02eb60fe7a20$var$tagNamePattern = new RegExp('^' + $45cf02eb60fe7a20$var$nameStartChar.source + $45cf02eb60fe7a20$var$nameChar.source + '*(?:\:' + $45cf02eb60fe7a20$var$nameStartChar.source + $45cf02eb60fe7a20$var$nameChar.source + '*)?$');
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var $45cf02eb60fe7a20$var$S_TAG = 0; //tag name offerring
var $45cf02eb60fe7a20$var$S_ATTR = 1; //attr name offerring
var $45cf02eb60fe7a20$var$S_ATTR_SPACE = 2; //attr name end and space offer
var $45cf02eb60fe7a20$var$S_EQ = 3; //=space?
var $45cf02eb60fe7a20$var$S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var $45cf02eb60fe7a20$var$S_ATTR_END = 5; //attr value end and no space(quot end)
var $45cf02eb60fe7a20$var$S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var $45cf02eb60fe7a20$var$S_TAG_CLOSE = 7; //closed el<el />
/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */ function $45cf02eb60fe7a20$var$ParseError(message, locator) {
    this.message = message;
    this.locator = locator;
    if (Error.captureStackTrace) Error.captureStackTrace(this, $45cf02eb60fe7a20$var$ParseError);
}
$45cf02eb60fe7a20$var$ParseError.prototype = new Error();
$45cf02eb60fe7a20$var$ParseError.prototype.name = $45cf02eb60fe7a20$var$ParseError.name;
function $45cf02eb60fe7a20$var$XMLReader() {}
$45cf02eb60fe7a20$var$XMLReader.prototype = {
    parse: function(source, defaultNSMap, entityMap) {
        var domBuilder = this.domBuilder;
        domBuilder.startDocument();
        $45cf02eb60fe7a20$var$_copy(defaultNSMap, defaultNSMap = {});
        $45cf02eb60fe7a20$var$parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
        domBuilder.endDocument();
    }
};
function $45cf02eb60fe7a20$var$parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
    function fixedFromCharCode(code) {
        // String.prototype.fromCharCode does not supports
        // > 2 bytes unicode chars directly
        if (code > 0xffff) {
            code -= 0x10000;
            var surrogate1 = 0xd800 + (code >> 10), surrogate2 = 0xdc00 + (code & 0x3ff);
            return String.fromCharCode(surrogate1, surrogate2);
        } else return String.fromCharCode(code);
    }
    function entityReplacer(a) {
        var k = a.slice(1, -1);
        if (Object.hasOwnProperty.call(entityMap, k)) return entityMap[k];
        else if (k.charAt(0) === '#') return fixedFromCharCode(parseInt(k.substr(1).replace('x', '0x')));
        else {
            errorHandler.error('entity not found:' + a);
            return a;
        }
    }
    function appendText(end) {
        if (end > start) {
            var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
            locator && position(start);
            domBuilder.characters(xt, 0, end - start);
            start = end;
        }
    }
    function position(p, m) {
        while(p >= lineEnd && (m = linePattern.exec(source))){
            lineStart = m.index;
            lineEnd = lineStart + m[0].length;
            locator.lineNumber++;
        //console.log('line++:',locator,startPos,endPos)
        }
        locator.columnNumber = p - lineStart + 1;
    }
    var lineStart = 0;
    var lineEnd = 0;
    var linePattern = /.*(?:\r\n?|\n)|.*$/g;
    var locator = domBuilder.locator;
    var parseStack = [
        {
            currentNSMap: defaultNSMapCopy
        }
    ];
    var closeMap = {};
    var start = 0;
    while(true){
        try {
            var tagStart = source.indexOf('<', start);
            if (tagStart < 0) {
                if (!source.substr(start).match(/^\s*$/)) {
                    var doc = domBuilder.doc;
                    var text = doc.createTextNode(source.substr(start));
                    doc.appendChild(text);
                    domBuilder.currentElement = text;
                }
                return;
            }
            if (tagStart > start) appendText(tagStart);
            switch(source.charAt(tagStart + 1)){
                case '/':
                    var end = source.indexOf('>', tagStart + 3);
                    var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
                    var config = parseStack.pop();
                    if (end < 0) {
                        tagName = source.substring(tagStart + 2).replace(/[\s<].*/, '');
                        errorHandler.error("end tag name: " + tagName + ' is not complete:' + config.tagName);
                        end = tagStart + 1 + tagName.length;
                    } else if (tagName.match(/\s</)) {
                        tagName = tagName.replace(/[\s<].*/, '');
                        errorHandler.error("end tag name: " + tagName + ' maybe not complete');
                        end = tagStart + 1 + tagName.length;
                    }
                    var localNSMap = config.localNSMap;
                    var endMatch = config.tagName == tagName;
                    var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
                    if (endIgnoreCaseMach) {
                        domBuilder.endElement(config.uri, config.localName, tagName);
                        if (localNSMap) {
                            for(var prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
                        }
                        if (!endMatch) errorHandler.fatalError("end tag name: " + tagName + ' is not match the current start tagName:' + config.tagName); // No known test case
                    } else parseStack.push(config);
                    end++;
                    break;
                // end elment
                case '?':
                    locator && position(tagStart);
                    end = $45cf02eb60fe7a20$var$parseInstruction(source, tagStart, domBuilder);
                    break;
                case '!':
                    locator && position(tagStart);
                    end = $45cf02eb60fe7a20$var$parseDCC(source, tagStart, domBuilder, errorHandler);
                    break;
                default:
                    locator && position(tagStart);
                    var el = new $45cf02eb60fe7a20$var$ElementAttributes();
                    var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
                    //elStartEnd
                    var end = $45cf02eb60fe7a20$var$parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
                    var len = el.length;
                    if (!el.closed && $45cf02eb60fe7a20$var$fixSelfClosed(source, end, el.tagName, closeMap)) {
                        el.closed = true;
                        if (!entityMap.nbsp) errorHandler.warning('unclosed xml attribute');
                    }
                    if (locator && len) {
                        var locator2 = $45cf02eb60fe7a20$var$copyLocator(locator, {});
                        //try{//attribute position fixed
                        for(var i = 0; i < len; i++){
                            var a = el[i];
                            position(a.offset);
                            a.locator = $45cf02eb60fe7a20$var$copyLocator(locator, {});
                        }
                        domBuilder.locator = locator2;
                        if ($45cf02eb60fe7a20$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                        domBuilder.locator = locator;
                    } else if ($45cf02eb60fe7a20$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                    if ($45cf02eb60fe7a20$require$NAMESPACE.isHTML(el.uri) && !el.closed) end = $45cf02eb60fe7a20$var$parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
                    else end++;
            }
        } catch (e) {
            if (e instanceof $45cf02eb60fe7a20$var$ParseError) throw e;
            errorHandler.error('element parse error: ' + e);
            end = -1;
        }
        if (end > start) start = end;
        else //TODO: 这里有可能sax回退，有位置错误风险
        appendText(Math.max(tagStart, start) + 1);
    }
}
function $45cf02eb60fe7a20$var$copyLocator(f, t) {
    t.lineNumber = f.lineNumber;
    t.columnNumber = f.columnNumber;
    return t;
}
/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */ function $45cf02eb60fe7a20$var$parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
    /**
	 * @param {string} qname
	 * @param {string} value
	 * @param {number} startIndex
	 */ function addAttribute(qname, value, startIndex) {
        if (el.attributeNames.hasOwnProperty(qname)) errorHandler.fatalError('Attribute ' + qname + ' redefined');
        el.addValue(qname, // @see https://www.w3.org/TR/xml/#AVNormalize
        // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
        // - recursive replacement of (DTD) entity references
        // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
        value.replace(/[\t\n\r]/g, ' ').replace(/&#?\w+;/g, entityReplacer), startIndex);
    }
    var attrName;
    var value;
    var p = ++start;
    var s = $45cf02eb60fe7a20$var$S_TAG; //status
    while(true){
        var c = source.charAt(p);
        switch(c){
            case '=':
                if (s === $45cf02eb60fe7a20$var$S_ATTR) {
                    attrName = source.slice(start, p);
                    s = $45cf02eb60fe7a20$var$S_EQ;
                } else if (s === $45cf02eb60fe7a20$var$S_ATTR_SPACE) s = $45cf02eb60fe7a20$var$S_EQ;
                else //fatalError: equal must after attrName or space after attrName
                throw new Error('attribute equal must after attrName'); // No known test case
                break;
            case '\'':
            case '"':
                if (s === $45cf02eb60fe7a20$var$S_EQ || s === $45cf02eb60fe7a20$var$S_ATTR //|| s == S_ATTR_SPACE
                ) {
                    if (s === $45cf02eb60fe7a20$var$S_ATTR) {
                        errorHandler.warning('attribute value must after "="');
                        attrName = source.slice(start, p);
                    }
                    start = p + 1;
                    p = source.indexOf(c, start);
                    if (p > 0) {
                        value = source.slice(start, p);
                        addAttribute(attrName, value, start - 1);
                        s = $45cf02eb60fe7a20$var$S_ATTR_END;
                    } else //fatalError: no end quot match
                    throw new Error('attribute value no end \'' + c + '\' match');
                } else if (s == $45cf02eb60fe7a20$var$S_ATTR_NOQUOT_VALUE) {
                    value = source.slice(start, p);
                    addAttribute(attrName, value, start);
                    errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ')!!');
                    start = p + 1;
                    s = $45cf02eb60fe7a20$var$S_ATTR_END;
                } else //fatalError: no equal before
                throw new Error('attribute value must after "="'); // No known test case
                break;
            case '/':
                switch(s){
                    case $45cf02eb60fe7a20$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $45cf02eb60fe7a20$var$S_ATTR_END:
                    case $45cf02eb60fe7a20$var$S_TAG_SPACE:
                    case $45cf02eb60fe7a20$var$S_TAG_CLOSE:
                        s = $45cf02eb60fe7a20$var$S_TAG_CLOSE;
                        el.closed = true;
                    case $45cf02eb60fe7a20$var$S_ATTR_NOQUOT_VALUE:
                    case $45cf02eb60fe7a20$var$S_ATTR:
                        break;
                    case $45cf02eb60fe7a20$var$S_ATTR_SPACE:
                        el.closed = true;
                        break;
                    //case S_EQ:
                    default:
                        throw new Error("attribute invalid close char('/')") // No known test case
                        ;
                }
                break;
            case '':
                errorHandler.error('unexpected end of input');
                if (s == $45cf02eb60fe7a20$var$S_TAG) el.setTagName(source.slice(start, p));
                return p;
            case '>':
                switch(s){
                    case $45cf02eb60fe7a20$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $45cf02eb60fe7a20$var$S_ATTR_END:
                    case $45cf02eb60fe7a20$var$S_TAG_SPACE:
                    case $45cf02eb60fe7a20$var$S_TAG_CLOSE:
                        break; //normal
                    case $45cf02eb60fe7a20$var$S_ATTR_NOQUOT_VALUE:
                    case $45cf02eb60fe7a20$var$S_ATTR:
                        value = source.slice(start, p);
                        if (value.slice(-1) === '/') {
                            el.closed = true;
                            value = value.slice(0, -1);
                        }
                    case $45cf02eb60fe7a20$var$S_ATTR_SPACE:
                        if (s === $45cf02eb60fe7a20$var$S_ATTR_SPACE) value = attrName;
                        if (s == $45cf02eb60fe7a20$var$S_ATTR_NOQUOT_VALUE) {
                            errorHandler.warning('attribute "' + value + '" missed quot(")!');
                            addAttribute(attrName, value, start);
                        } else {
                            if (!$45cf02eb60fe7a20$require$NAMESPACE.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
                            addAttribute(value, value, start);
                        }
                        break;
                    case $45cf02eb60fe7a20$var$S_EQ:
                        throw new Error('attribute value missed!!');
                }
                //			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
                return p;
            /*xml space '\x20' | #x9 | #xD | #xA; */ case '\u0080':
                c = ' ';
            default:
                if (c <= ' ') switch(s){
                    case $45cf02eb60fe7a20$var$S_TAG:
                        el.setTagName(source.slice(start, p)); //tagName
                        s = $45cf02eb60fe7a20$var$S_TAG_SPACE;
                        break;
                    case $45cf02eb60fe7a20$var$S_ATTR:
                        attrName = source.slice(start, p);
                        s = $45cf02eb60fe7a20$var$S_ATTR_SPACE;
                        break;
                    case $45cf02eb60fe7a20$var$S_ATTR_NOQUOT_VALUE:
                        var value = source.slice(start, p);
                        errorHandler.warning('attribute "' + value + '" missed quot(")!!');
                        addAttribute(attrName, value, start);
                    case $45cf02eb60fe7a20$var$S_ATTR_END:
                        s = $45cf02eb60fe7a20$var$S_TAG_SPACE;
                        break;
                }
                else //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
                //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
                switch(s){
                    //case S_TAG:void();break;
                    //case S_ATTR:void();break;
                    //case S_ATTR_NOQUOT_VALUE:void();break;
                    case $45cf02eb60fe7a20$var$S_ATTR_SPACE:
                        var tagName = el.tagName;
                        if (!$45cf02eb60fe7a20$require$NAMESPACE.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
                        addAttribute(attrName, attrName, start);
                        start = p;
                        s = $45cf02eb60fe7a20$var$S_ATTR;
                        break;
                    case $45cf02eb60fe7a20$var$S_ATTR_END:
                        errorHandler.warning('attribute space is required"' + attrName + '"!!');
                    case $45cf02eb60fe7a20$var$S_TAG_SPACE:
                        s = $45cf02eb60fe7a20$var$S_ATTR;
                        start = p;
                        break;
                    case $45cf02eb60fe7a20$var$S_EQ:
                        s = $45cf02eb60fe7a20$var$S_ATTR_NOQUOT_VALUE;
                        start = p;
                        break;
                    case $45cf02eb60fe7a20$var$S_TAG_CLOSE:
                        throw new Error("elements closed character '/' and '>' must be connected to");
                }
        } //end outer switch
        //console.log('p++',p)
        p++;
    }
}
/**
 * @return true if has new namespace define
 */ function $45cf02eb60fe7a20$var$appendElement(el, domBuilder, currentNSMap) {
    var tagName = el.tagName;
    var localNSMap = null;
    //var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
    var i = el.length;
    while(i--){
        var a = el[i];
        var qName = a.qName;
        var value = a.value;
        var nsp = qName.indexOf(':');
        if (nsp > 0) {
            var prefix = a.prefix = qName.slice(0, nsp);
            var localName = qName.slice(nsp + 1);
            var nsPrefix = prefix === 'xmlns' && localName;
        } else {
            localName = qName;
            prefix = null;
            nsPrefix = qName === 'xmlns' && '';
        }
        //can not set prefix,because prefix !== ''
        a.localName = localName;
        //prefix == null for no ns prefix attribute
        if (nsPrefix !== false) {
            if (localNSMap == null) {
                localNSMap = {};
                //console.log(currentNSMap,0)
                $45cf02eb60fe7a20$var$_copy(currentNSMap, currentNSMap = {});
            //console.log(currentNSMap,1)
            }
            currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
            a.uri = $45cf02eb60fe7a20$require$NAMESPACE.XMLNS;
            domBuilder.startPrefixMapping(nsPrefix, value);
        }
    }
    var i = el.length;
    while(i--){
        a = el[i];
        var prefix = a.prefix;
        if (prefix) {
            if (prefix === 'xml') a.uri = $45cf02eb60fe7a20$require$NAMESPACE.XML;
            if (prefix !== 'xmlns') a.uri = currentNSMap[prefix || ''];
        }
    }
    var nsp = tagName.indexOf(':');
    if (nsp > 0) {
        prefix = el.prefix = tagName.slice(0, nsp);
        localName = el.localName = tagName.slice(nsp + 1);
    } else {
        prefix = null; //important!!
        localName = el.localName = tagName;
    }
    //no prefix element has default namespace
    var ns = el.uri = currentNSMap[prefix || ''];
    domBuilder.startElement(ns, localName, tagName, el);
    //endPrefixMapping and startPrefixMapping have not any help for dom builder
    //localNSMap = null
    if (el.closed) {
        domBuilder.endElement(ns, localName, tagName);
        if (localNSMap) {
            for(prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
        }
    } else {
        el.currentNSMap = currentNSMap;
        el.localNSMap = localNSMap;
        //parseStack.push(el);
        return true;
    }
}
function $45cf02eb60fe7a20$var$parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
    if (/^(?:script|textarea)$/i.test(tagName)) {
        var elEndStart = source.indexOf('</' + tagName + '>', elStartEnd);
        var text = source.substring(elStartEnd + 1, elEndStart);
        if (/[&<]/.test(text)) {
            if (/^script$/i.test(tagName)) {
                //if(!/\]\]>/.test(text)){
                //lexHandler.startCDATA();
                domBuilder.characters(text, 0, text.length);
                //lexHandler.endCDATA();
                return elEndStart;
            //}
            } //}else{//text area
            text = text.replace(/&#?\w+;/g, entityReplacer);
            domBuilder.characters(text, 0, text.length);
            return elEndStart;
        //}
        }
    }
    return elStartEnd + 1;
}
function $45cf02eb60fe7a20$var$fixSelfClosed(source, elStartEnd, tagName, closeMap) {
    //if(tagName in closeMap){
    var pos = closeMap[tagName];
    if (pos == null) {
        //console.log(tagName)
        pos = source.lastIndexOf('</' + tagName + '>');
        if (pos < elStartEnd) pos = source.lastIndexOf('</' + tagName);
        closeMap[tagName] = pos;
    }
    return pos < elStartEnd;
//}
}
function $45cf02eb60fe7a20$var$_copy(source, target) {
    for(var n in source)if (Object.prototype.hasOwnProperty.call(source, n)) target[n] = source[n];
}
function $45cf02eb60fe7a20$var$parseDCC(source, start, domBuilder, errorHandler) {
    var next = source.charAt(start + 2);
    switch(next){
        case '-':
            if (source.charAt(start + 3) === '-') {
                var end = source.indexOf('-->', start + 4);
                //append comment source.substring(4,end)//<!--
                if (end > start) {
                    domBuilder.comment(source, start + 4, end - start - 4);
                    return end + 3;
                } else {
                    errorHandler.error("Unclosed comment");
                    return -1;
                }
            } else //error
            return -1;
        default:
            if (source.substr(start + 3, 6) == 'CDATA[') {
                var end = source.indexOf(']]>', start + 9);
                domBuilder.startCDATA();
                domBuilder.characters(source, start + 9, end - start - 9);
                domBuilder.endCDATA();
                return end + 3;
            }
            //<!DOCTYPE
            //startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
            var matchs = $45cf02eb60fe7a20$var$split(source, start);
            var len = matchs.length;
            if (len > 1 && /!doctype/i.test(matchs[0][0])) {
                var name = matchs[1][0];
                var pubid = false;
                var sysid = false;
                if (len > 3) {
                    if (/^public$/i.test(matchs[2][0])) {
                        pubid = matchs[3][0];
                        sysid = len > 4 && matchs[4][0];
                    } else if (/^system$/i.test(matchs[2][0])) sysid = matchs[3][0];
                }
                var lastMatch = matchs[len - 1];
                domBuilder.startDTD(name, pubid, sysid);
                domBuilder.endDTD();
                return lastMatch.index + lastMatch[0].length;
            }
    }
    return -1;
}
function $45cf02eb60fe7a20$var$parseInstruction(source, start, domBuilder) {
    var end = source.indexOf('?>', start);
    if (end) {
        var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)$/);
        if (match) {
            var len = match[0].length;
            domBuilder.processingInstruction(match[1], match[2]);
            return end + 2;
        } else return -1;
    }
    return -1;
}
function $45cf02eb60fe7a20$var$ElementAttributes() {
    this.attributeNames = {};
}
$45cf02eb60fe7a20$var$ElementAttributes.prototype = {
    setTagName: function(tagName) {
        if (!$45cf02eb60fe7a20$var$tagNamePattern.test(tagName)) throw new Error('invalid tagName:' + tagName);
        this.tagName = tagName;
    },
    addValue: function(qName, value, offset) {
        if (!$45cf02eb60fe7a20$var$tagNamePattern.test(qName)) throw new Error('invalid attribute:' + qName);
        this.attributeNames[qName] = this.length;
        this[this.length++] = {
            qName: qName,
            value: value,
            offset: offset
        };
    },
    length: 0,
    getLocalName: function(i) {
        return this[i].localName;
    },
    getLocator: function(i) {
        return this[i].locator;
    },
    getQName: function(i) {
        return this[i].qName;
    },
    getURI: function(i) {
        return this[i].uri;
    },
    getValue: function(i) {
        return this[i].value;
    }
};
function $45cf02eb60fe7a20$var$split(source, start) {
    var match;
    var buf = [];
    var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
    reg.lastIndex = start;
    reg.exec(source); //skip <
    while(match = reg.exec(source)){
        buf.push(match);
        if (match[1]) return buf;
    }
}
$45cf02eb60fe7a20$export$ccbc9f9f018333e9 = $45cf02eb60fe7a20$var$XMLReader;
$45cf02eb60fe7a20$export$f9c837a54db411d = $45cf02eb60fe7a20$var$ParseError;

});


'use strict';
'use strict';
var $919480ddf8d46973$exports = {};
'use strict';
var $7affcbe90b95b867$exports = {};
'use strict';
var $7affcbe90b95b867$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$7affcbe90b95b867$exports = // eslint-disable-next-line es/no-global-this -- safe
$7affcbe90b95b867$var$check(typeof globalThis == 'object' && globalThis) || $7affcbe90b95b867$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$7affcbe90b95b867$var$check(typeof self == 'object' && self) || $7affcbe90b95b867$var$check(typeof $parcel$global == 'object' && $parcel$global) || $7affcbe90b95b867$var$check(typeof $7affcbe90b95b867$exports == 'object' && $7affcbe90b95b867$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $5ad39d6a4458ad36$export$2d1720544b23b823;
'use strict';
var $7907d2968707607f$exports = {};
'use strict';
var $ba0ddb8815ecd04b$exports = {};
'use strict';
$ba0ddb8815ecd04b$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$7907d2968707607f$exports = !$ba0ddb8815ecd04b$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $80836a5803145698$exports = {};
'use strict';
var $971381254da1976c$exports = {};
'use strict';

$971381254da1976c$exports = !$ba0ddb8815ecd04b$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $80836a5803145698$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$80836a5803145698$exports = $971381254da1976c$exports ? $80836a5803145698$var$call.bind($80836a5803145698$var$call) : function() {
    return $80836a5803145698$var$call.apply($80836a5803145698$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $709aac0b5687473f$export$2d1720544b23b823;
'use strict';
var $709aac0b5687473f$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $709aac0b5687473f$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $709aac0b5687473f$var$NASHORN_BUG = $709aac0b5687473f$var$getOwnPropertyDescriptor && !$709aac0b5687473f$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$709aac0b5687473f$export$2d1720544b23b823 = $709aac0b5687473f$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $709aac0b5687473f$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $709aac0b5687473f$var$$propertyIsEnumerable;


var $5136b7f7a7a44c69$exports = {};
'use strict';
$5136b7f7a7a44c69$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $276e457d9531c658$exports = {};
'use strict';
var $4eafe20337492ed2$exports = {};
'use strict';
var $d3c77ff52b42c214$exports = {};
'use strict';

var $d3c77ff52b42c214$var$FunctionPrototype = Function.prototype;
var $d3c77ff52b42c214$var$call = $d3c77ff52b42c214$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $d3c77ff52b42c214$var$uncurryThisWithBind = $971381254da1976c$exports && $d3c77ff52b42c214$var$FunctionPrototype.bind.bind($d3c77ff52b42c214$var$call, $d3c77ff52b42c214$var$call);
$d3c77ff52b42c214$exports = $971381254da1976c$exports ? $d3c77ff52b42c214$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $d3c77ff52b42c214$var$call.apply(fn, arguments);
    };
};



var $75e4f1be0fe59337$exports = {};
'use strict';

var $75e4f1be0fe59337$var$toString = $d3c77ff52b42c214$exports({}.toString);
var $75e4f1be0fe59337$var$stringSlice = $d3c77ff52b42c214$exports(''.slice);
$75e4f1be0fe59337$exports = function(it) {
    return $75e4f1be0fe59337$var$stringSlice($75e4f1be0fe59337$var$toString(it), 8, -1);
};


var $4eafe20337492ed2$var$$Object = Object;
var $4eafe20337492ed2$var$split = $d3c77ff52b42c214$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$4eafe20337492ed2$exports = $ba0ddb8815ecd04b$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$4eafe20337492ed2$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $75e4f1be0fe59337$exports(it) === 'String' ? $4eafe20337492ed2$var$split(it, '') : $4eafe20337492ed2$var$$Object(it);
} : $4eafe20337492ed2$var$$Object;


var $309a09ecff9761f0$exports = {};
'use strict';
var $a285f99128a68ac7$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$a285f99128a68ac7$exports = function(it) {
    return it === null || it === undefined;
};


var $309a09ecff9761f0$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$309a09ecff9761f0$exports = function(it) {
    if ($a285f99128a68ac7$exports(it)) throw new $309a09ecff9761f0$var$$TypeError("Can't call method on " + it);
    return it;
};


$276e457d9531c658$exports = function(it) {
    return $4eafe20337492ed2$exports($309a09ecff9761f0$exports(it));
};


var $710791c2bc91cd8b$exports = {};
'use strict';
var $2225082c596381a9$exports = {};
'use strict';

var $8b2e8e1bd3f4b0b6$exports = {};
'use strict';
var $d914ef1aeb8832b3$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $d914ef1aeb8832b3$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$d914ef1aeb8832b3$exports = typeof $d914ef1aeb8832b3$var$documentAll == 'undefined' && $d914ef1aeb8832b3$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $d914ef1aeb8832b3$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


$8b2e8e1bd3f4b0b6$exports = function(it) {
    return typeof it == 'object' ? it !== null : $d914ef1aeb8832b3$exports(it);
};


var $b8c3ec56df24625b$exports = {};
'use strict';
var $07a1d91bf69eb000$exports = {};
'use strict';


var $07a1d91bf69eb000$var$aFunction = function(argument) {
    return $d914ef1aeb8832b3$exports(argument) ? argument : undefined;
};
$07a1d91bf69eb000$exports = function(namespace, method) {
    return arguments.length < 2 ? $07a1d91bf69eb000$var$aFunction($7affcbe90b95b867$exports[namespace]) : $7affcbe90b95b867$exports[namespace] && $7affcbe90b95b867$exports[namespace][method];
};



var $a32f92374330146a$exports = {};
'use strict';

$a32f92374330146a$exports = $d3c77ff52b42c214$exports({}.isPrototypeOf);


var $73f20e6a3cd2391f$exports = {};
'use strict';
var $fb76e6df2fd6fd87$exports = {};
'use strict';
var $f8a10eec33b084aa$exports = {};
'use strict';

var $21be10dc6d84de4f$exports = {};
'use strict';

var $21be10dc6d84de4f$var$navigator = $7affcbe90b95b867$exports.navigator;
var $21be10dc6d84de4f$var$userAgent = $21be10dc6d84de4f$var$navigator && $21be10dc6d84de4f$var$navigator.userAgent;
$21be10dc6d84de4f$exports = $21be10dc6d84de4f$var$userAgent ? String($21be10dc6d84de4f$var$userAgent) : '';


var $f8a10eec33b084aa$var$process = $7affcbe90b95b867$exports.process;
var $f8a10eec33b084aa$var$Deno = $7affcbe90b95b867$exports.Deno;
var $f8a10eec33b084aa$var$versions = $f8a10eec33b084aa$var$process && $f8a10eec33b084aa$var$process.versions || $f8a10eec33b084aa$var$Deno && $f8a10eec33b084aa$var$Deno.version;
var $f8a10eec33b084aa$var$v8 = $f8a10eec33b084aa$var$versions && $f8a10eec33b084aa$var$versions.v8;
var $f8a10eec33b084aa$var$match, $f8a10eec33b084aa$var$version;
if ($f8a10eec33b084aa$var$v8) {
    $f8a10eec33b084aa$var$match = $f8a10eec33b084aa$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $f8a10eec33b084aa$var$version = $f8a10eec33b084aa$var$match[0] > 0 && $f8a10eec33b084aa$var$match[0] < 4 ? 1 : +($f8a10eec33b084aa$var$match[0] + $f8a10eec33b084aa$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$f8a10eec33b084aa$var$version && $21be10dc6d84de4f$exports) {
    $f8a10eec33b084aa$var$match = $21be10dc6d84de4f$exports.match(/Edge\/(\d+)/);
    if (!$f8a10eec33b084aa$var$match || $f8a10eec33b084aa$var$match[1] >= 74) {
        $f8a10eec33b084aa$var$match = $21be10dc6d84de4f$exports.match(/Chrome\/(\d+)/);
        if ($f8a10eec33b084aa$var$match) $f8a10eec33b084aa$var$version = +$f8a10eec33b084aa$var$match[1];
    }
}
$f8a10eec33b084aa$exports = $f8a10eec33b084aa$var$version;




var $fb76e6df2fd6fd87$var$$String = $7affcbe90b95b867$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$fb76e6df2fd6fd87$exports = !!Object.getOwnPropertySymbols && !$ba0ddb8815ecd04b$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$fb76e6df2fd6fd87$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $f8a10eec33b084aa$exports && $f8a10eec33b084aa$exports < 41;
});


$73f20e6a3cd2391f$exports = $fb76e6df2fd6fd87$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $b8c3ec56df24625b$var$$Object = Object;
$b8c3ec56df24625b$exports = $73f20e6a3cd2391f$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $07a1d91bf69eb000$exports('Symbol');
    return $d914ef1aeb8832b3$exports($Symbol) && $a32f92374330146a$exports($Symbol.prototype, $b8c3ec56df24625b$var$$Object(it));
};


var $a35c416529663b04$exports = {};
'use strict';
var $355c3a6273d7d9cd$exports = {};
'use strict';

var $b2b04273828de434$exports = {};
'use strict';
var $b2b04273828de434$var$$String = String;
$b2b04273828de434$exports = function(argument) {
    try {
        return $b2b04273828de434$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $355c3a6273d7d9cd$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$355c3a6273d7d9cd$exports = function(argument) {
    if ($d914ef1aeb8832b3$exports(argument)) return argument;
    throw new $355c3a6273d7d9cd$var$$TypeError($b2b04273828de434$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$a35c416529663b04$exports = function(V, P) {
    var func = V[P];
    return $a285f99128a68ac7$exports(func) ? undefined : $355c3a6273d7d9cd$exports(func);
};


var $ebb5e69a13765664$exports = {};
'use strict';



var $ebb5e69a13765664$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$ebb5e69a13765664$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $d914ef1aeb8832b3$exports(fn = input.toString) && !$8b2e8e1bd3f4b0b6$exports(val = $80836a5803145698$exports(fn, input))) return val;
    if ($d914ef1aeb8832b3$exports(fn = input.valueOf) && !$8b2e8e1bd3f4b0b6$exports(val = $80836a5803145698$exports(fn, input))) return val;
    if (pref !== 'string' && $d914ef1aeb8832b3$exports(fn = input.toString) && !$8b2e8e1bd3f4b0b6$exports(val = $80836a5803145698$exports(fn, input))) return val;
    throw new $ebb5e69a13765664$var$$TypeError("Can't convert object to primitive value");
};


var $779ed8fd005cf63a$exports = {};
'use strict';

var $971cc668032d8964$exports = {};
'use strict';
var $190a669e4fc5d088$exports = {};
'use strict';
var $1e3494e809d1b95c$exports = {};
'use strict';
$1e3494e809d1b95c$exports = false;



var $f3452fc9184e06ab$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $f3452fc9184e06ab$var$defineProperty = Object.defineProperty;
$f3452fc9184e06ab$exports = function(key, value) {
    try {
        $f3452fc9184e06ab$var$defineProperty($7affcbe90b95b867$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $7affcbe90b95b867$exports[key] = value;
    }
    return value;
};


var $190a669e4fc5d088$var$SHARED = '__core-js_shared__';
var $190a669e4fc5d088$var$store = $190a669e4fc5d088$exports = $7affcbe90b95b867$exports[$190a669e4fc5d088$var$SHARED] || $f3452fc9184e06ab$exports($190a669e4fc5d088$var$SHARED, {});
($190a669e4fc5d088$var$store.versions || ($190a669e4fc5d088$var$store.versions = [])).push({
    version: '3.49.0',
    mode: $1e3494e809d1b95c$exports ? 'pure' : 'global',
    copyright: "\xa9 2013\u20132025 Denis Pushkarev (zloirock.ru), 2025\u20132026 CoreJS Company (core-js.io). All rights reserved.",
    license: 'https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


$971cc668032d8964$exports = function(key, value) {
    return $190a669e4fc5d088$exports[key] || ($190a669e4fc5d088$exports[key] = value || {});
};


var $b1e383a38b6d64a4$exports = {};
'use strict';

var $06736605350d9203$exports = {};
'use strict';

var $06736605350d9203$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$06736605350d9203$exports = function(argument) {
    return $06736605350d9203$var$$Object($309a09ecff9761f0$exports(argument));
};


var $b1e383a38b6d64a4$var$hasOwnProperty = $d3c77ff52b42c214$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$b1e383a38b6d64a4$exports = Object.hasOwn || function hasOwn(it, key) {
    return $b1e383a38b6d64a4$var$hasOwnProperty($06736605350d9203$exports(it), key);
};


var $0ca1d1e6e9f050b6$exports = {};
'use strict';

var $0ca1d1e6e9f050b6$var$id = 0;
var $0ca1d1e6e9f050b6$var$postfix = Math.random();
var $0ca1d1e6e9f050b6$var$toString = $d3c77ff52b42c214$exports(1.1.toString);
$0ca1d1e6e9f050b6$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $0ca1d1e6e9f050b6$var$toString(++$0ca1d1e6e9f050b6$var$id + $0ca1d1e6e9f050b6$var$postfix, 36);
};




var $779ed8fd005cf63a$var$Symbol = $7affcbe90b95b867$exports.Symbol;
var $779ed8fd005cf63a$var$WellKnownSymbolsStore = $971cc668032d8964$exports('wks');
var $779ed8fd005cf63a$var$createWellKnownSymbol = $73f20e6a3cd2391f$exports ? $779ed8fd005cf63a$var$Symbol['for'] || $779ed8fd005cf63a$var$Symbol : $779ed8fd005cf63a$var$Symbol && $779ed8fd005cf63a$var$Symbol.withoutSetter || $0ca1d1e6e9f050b6$exports;
$779ed8fd005cf63a$exports = function(name) {
    if (!$b1e383a38b6d64a4$exports($779ed8fd005cf63a$var$WellKnownSymbolsStore, name)) $779ed8fd005cf63a$var$WellKnownSymbolsStore[name] = $fb76e6df2fd6fd87$exports && $b1e383a38b6d64a4$exports($779ed8fd005cf63a$var$Symbol, name) ? $779ed8fd005cf63a$var$Symbol[name] : $779ed8fd005cf63a$var$createWellKnownSymbol('Symbol.' + name);
    return $779ed8fd005cf63a$var$WellKnownSymbolsStore[name];
};


var $2225082c596381a9$var$$TypeError = TypeError;
var $2225082c596381a9$var$TO_PRIMITIVE = $779ed8fd005cf63a$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$2225082c596381a9$exports = function(input, pref) {
    if (!$8b2e8e1bd3f4b0b6$exports(input) || $b8c3ec56df24625b$exports(input)) return input;
    var exoticToPrim = $a35c416529663b04$exports(input, $2225082c596381a9$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $80836a5803145698$exports(exoticToPrim, input, pref);
        if (!$8b2e8e1bd3f4b0b6$exports(result) || $b8c3ec56df24625b$exports(result)) return result;
        throw new $2225082c596381a9$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $ebb5e69a13765664$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$710791c2bc91cd8b$exports = function(argument) {
    var key = $2225082c596381a9$exports(argument, 'string');
    return $b8c3ec56df24625b$exports(key) ? key : key + '';
};



var $3ca48fbe8b4c1467$exports = {};
'use strict';


var $25483c852b28875d$exports = {};
'use strict';


var $25483c852b28875d$var$document = $7affcbe90b95b867$exports.document;
// typeof document.createElement is 'object' in old IE
var $25483c852b28875d$var$EXISTS = $8b2e8e1bd3f4b0b6$exports($25483c852b28875d$var$document) && $8b2e8e1bd3f4b0b6$exports($25483c852b28875d$var$document.createElement);
$25483c852b28875d$exports = function(it) {
    return $25483c852b28875d$var$EXISTS ? $25483c852b28875d$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$3ca48fbe8b4c1467$exports = !$7907d2968707607f$exports && !$ba0ddb8815ecd04b$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($25483c852b28875d$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5ad39d6a4458ad36$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$5ad39d6a4458ad36$export$2d1720544b23b823 = $7907d2968707607f$exports ? $5ad39d6a4458ad36$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $276e457d9531c658$exports(O);
    P = $710791c2bc91cd8b$exports(P);
    if ($3ca48fbe8b4c1467$exports) try {
        return $5ad39d6a4458ad36$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($b1e383a38b6d64a4$exports(O, P)) return $5136b7f7a7a44c69$exports(!$80836a5803145698$exports($709aac0b5687473f$export$2d1720544b23b823, O, P), O[P]);
};


var $919480ddf8d46973$require$getOwnPropertyDescriptor = $5ad39d6a4458ad36$export$2d1720544b23b823;
var $b8d5e2520123b597$exports = {};
'use strict';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $1598fc8a0c2c06ea$export$2d1720544b23b823;
'use strict';


var $02d26f3199380d65$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$02d26f3199380d65$exports = $7907d2968707607f$exports && $ba0ddb8815ecd04b$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $d8135a025f8b2a5b$exports = {};
'use strict';

var $d8135a025f8b2a5b$var$$String = String;
var $d8135a025f8b2a5b$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$d8135a025f8b2a5b$exports = function(argument) {
    if ($8b2e8e1bd3f4b0b6$exports(argument)) return argument;
    throw new $d8135a025f8b2a5b$var$$TypeError($d8135a025f8b2a5b$var$$String(argument) + ' is not an object');
};



var $1598fc8a0c2c06ea$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $1598fc8a0c2c06ea$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1598fc8a0c2c06ea$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $1598fc8a0c2c06ea$var$ENUMERABLE = 'enumerable';
var $1598fc8a0c2c06ea$var$CONFIGURABLE = 'configurable';
var $1598fc8a0c2c06ea$var$WRITABLE = 'writable';
$1598fc8a0c2c06ea$export$2d1720544b23b823 = $7907d2968707607f$exports ? $02d26f3199380d65$exports ? function defineProperty(O, P, Attributes) {
    $d8135a025f8b2a5b$exports(O);
    P = $710791c2bc91cd8b$exports(P);
    $d8135a025f8b2a5b$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $1598fc8a0c2c06ea$var$WRITABLE in Attributes && !Attributes[$1598fc8a0c2c06ea$var$WRITABLE]) {
        var current = $1598fc8a0c2c06ea$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$1598fc8a0c2c06ea$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $1598fc8a0c2c06ea$var$CONFIGURABLE in Attributes ? Attributes[$1598fc8a0c2c06ea$var$CONFIGURABLE] : current[$1598fc8a0c2c06ea$var$CONFIGURABLE],
                enumerable: $1598fc8a0c2c06ea$var$ENUMERABLE in Attributes ? Attributes[$1598fc8a0c2c06ea$var$ENUMERABLE] : current[$1598fc8a0c2c06ea$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $1598fc8a0c2c06ea$var$$defineProperty(O, P, Attributes);
} : $1598fc8a0c2c06ea$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $d8135a025f8b2a5b$exports(O);
    P = $710791c2bc91cd8b$exports(P);
    $d8135a025f8b2a5b$exports(Attributes);
    if ($3ca48fbe8b4c1467$exports) try {
        return $1598fc8a0c2c06ea$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $1598fc8a0c2c06ea$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



$b8d5e2520123b597$exports = $7907d2968707607f$exports ? function(object, key, value) {
    return $1598fc8a0c2c06ea$export$2d1720544b23b823(object, key, $5136b7f7a7a44c69$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $3b1976c267785763$exports = {};
'use strict';


var $5eef4d1704841b36$exports = {};
'use strict';





var $f6be469d0657daf3$exports = {};
'use strict';


var $f6be469d0657daf3$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $f6be469d0657daf3$var$getDescriptor = $7907d2968707607f$exports && Object.getOwnPropertyDescriptor;
var $f6be469d0657daf3$var$EXISTS = $b1e383a38b6d64a4$exports($f6be469d0657daf3$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $f6be469d0657daf3$var$PROPER = $f6be469d0657daf3$var$EXISTS && (function something() {}).name === 'something';
var $f6be469d0657daf3$var$CONFIGURABLE = $f6be469d0657daf3$var$EXISTS && (!$7907d2968707607f$exports || $7907d2968707607f$exports && $f6be469d0657daf3$var$getDescriptor($f6be469d0657daf3$var$FunctionPrototype, 'name').configurable);
$f6be469d0657daf3$exports = {
    EXISTS: $f6be469d0657daf3$var$EXISTS,
    PROPER: $f6be469d0657daf3$var$PROPER,
    CONFIGURABLE: $f6be469d0657daf3$var$CONFIGURABLE
};


var $5eef4d1704841b36$require$CONFIGURABLE_FUNCTION_NAME = $f6be469d0657daf3$exports.CONFIGURABLE;
var $fe84ecf9bab26b8c$exports = {};
'use strict';



var $fe84ecf9bab26b8c$var$functionToString = $d3c77ff52b42c214$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$d914ef1aeb8832b3$exports($190a669e4fc5d088$exports.inspectSource)) $190a669e4fc5d088$exports.inspectSource = function(it) {
    return $fe84ecf9bab26b8c$var$functionToString(it);
};
$fe84ecf9bab26b8c$exports = $190a669e4fc5d088$exports.inspectSource;


var $3e6271fc7de38b24$exports = {};
'use strict';
var $97ec6e29d36d8193$exports = {};
'use strict';


var $97ec6e29d36d8193$var$WeakMap = $7affcbe90b95b867$exports.WeakMap;
$97ec6e29d36d8193$exports = $d914ef1aeb8832b3$exports($97ec6e29d36d8193$var$WeakMap) && /native code/.test(String($97ec6e29d36d8193$var$WeakMap));







var $49ebc115d857df93$exports = {};
'use strict';


var $49ebc115d857df93$var$keys = $971cc668032d8964$exports('keys');
$49ebc115d857df93$exports = function(key) {
    return $49ebc115d857df93$var$keys[key] || ($49ebc115d857df93$var$keys[key] = $0ca1d1e6e9f050b6$exports(key));
};


var $80dc022279e502e5$exports = {};
'use strict';
$80dc022279e502e5$exports = {};


var $3e6271fc7de38b24$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $3e6271fc7de38b24$var$TypeError = $7affcbe90b95b867$exports.TypeError;
var $3e6271fc7de38b24$var$WeakMap = $7affcbe90b95b867$exports.WeakMap;
var $3e6271fc7de38b24$var$set, $3e6271fc7de38b24$var$get, $3e6271fc7de38b24$var$has;
var $3e6271fc7de38b24$var$enforce = function(it) {
    return $3e6271fc7de38b24$var$has(it) ? $3e6271fc7de38b24$var$get(it) : $3e6271fc7de38b24$var$set(it, {});
};
var $3e6271fc7de38b24$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$8b2e8e1bd3f4b0b6$exports(it) || (state = $3e6271fc7de38b24$var$get(it)).type !== TYPE) throw new $3e6271fc7de38b24$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($97ec6e29d36d8193$exports || $190a669e4fc5d088$exports.state) {
    var $3e6271fc7de38b24$var$store = $190a669e4fc5d088$exports.state || ($190a669e4fc5d088$exports.state = new $3e6271fc7de38b24$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $3e6271fc7de38b24$var$store.get = $3e6271fc7de38b24$var$store.get;
    $3e6271fc7de38b24$var$store.has = $3e6271fc7de38b24$var$store.has;
    $3e6271fc7de38b24$var$store.set = $3e6271fc7de38b24$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $3e6271fc7de38b24$var$set = function(it, metadata) {
        if ($3e6271fc7de38b24$var$store.has(it)) throw new $3e6271fc7de38b24$var$TypeError($3e6271fc7de38b24$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3e6271fc7de38b24$var$store.set(it, metadata);
        return metadata;
    };
    $3e6271fc7de38b24$var$get = function(it) {
        return $3e6271fc7de38b24$var$store.get(it) || {};
    };
    $3e6271fc7de38b24$var$has = function(it) {
        return $3e6271fc7de38b24$var$store.has(it);
    };
} else {
    var $3e6271fc7de38b24$var$STATE = $49ebc115d857df93$exports('state');
    $80dc022279e502e5$exports[$3e6271fc7de38b24$var$STATE] = true;
    $3e6271fc7de38b24$var$set = function(it, metadata) {
        if ($b1e383a38b6d64a4$exports(it, $3e6271fc7de38b24$var$STATE)) throw new $3e6271fc7de38b24$var$TypeError($3e6271fc7de38b24$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $b8d5e2520123b597$exports(it, $3e6271fc7de38b24$var$STATE, metadata);
        return metadata;
    };
    $3e6271fc7de38b24$var$get = function(it) {
        return $b1e383a38b6d64a4$exports(it, $3e6271fc7de38b24$var$STATE) ? it[$3e6271fc7de38b24$var$STATE] : {};
    };
    $3e6271fc7de38b24$var$has = function(it) {
        return $b1e383a38b6d64a4$exports(it, $3e6271fc7de38b24$var$STATE);
    };
}
$3e6271fc7de38b24$exports = {
    set: $3e6271fc7de38b24$var$set,
    get: $3e6271fc7de38b24$var$get,
    has: $3e6271fc7de38b24$var$has,
    enforce: $3e6271fc7de38b24$var$enforce,
    getterFor: $3e6271fc7de38b24$var$getterFor
};


var $5eef4d1704841b36$var$enforceInternalState = $3e6271fc7de38b24$exports.enforce;
var $5eef4d1704841b36$var$getInternalState = $3e6271fc7de38b24$exports.get;
var $5eef4d1704841b36$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $5eef4d1704841b36$var$defineProperty = Object.defineProperty;
var $5eef4d1704841b36$var$stringSlice = $d3c77ff52b42c214$exports(''.slice);
var $5eef4d1704841b36$var$replace = $d3c77ff52b42c214$exports(''.replace);
var $5eef4d1704841b36$var$join = $d3c77ff52b42c214$exports([].join);
var $5eef4d1704841b36$var$CONFIGURABLE_LENGTH = $7907d2968707607f$exports && !$ba0ddb8815ecd04b$exports(function() {
    return $5eef4d1704841b36$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $5eef4d1704841b36$var$TEMPLATE = String(String).split('String');
var $5eef4d1704841b36$var$makeBuiltIn = $5eef4d1704841b36$exports = function(value, name, options) {
    if ($5eef4d1704841b36$var$stringSlice($5eef4d1704841b36$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $5eef4d1704841b36$var$replace($5eef4d1704841b36$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$b1e383a38b6d64a4$exports(value, 'name') || $5eef4d1704841b36$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($7907d2968707607f$exports) $5eef4d1704841b36$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($5eef4d1704841b36$var$CONFIGURABLE_LENGTH && options && $b1e383a38b6d64a4$exports(options, 'arity') && value.length !== options.arity) $5eef4d1704841b36$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $b1e383a38b6d64a4$exports(options, 'constructor') && options.constructor) {
            if ($7907d2968707607f$exports) $5eef4d1704841b36$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $5eef4d1704841b36$var$enforceInternalState(value);
    if (!$b1e383a38b6d64a4$exports(state, 'source')) state.source = $5eef4d1704841b36$var$join($5eef4d1704841b36$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $5eef4d1704841b36$var$makeBuiltIn(function toString() {
    return $d914ef1aeb8832b3$exports(this) && $5eef4d1704841b36$var$getInternalState(this).source || $fe84ecf9bab26b8c$exports(this);
}, 'toString');



$3b1976c267785763$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($d914ef1aeb8832b3$exports(value)) $5eef4d1704841b36$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $f3452fc9184e06ab$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $1598fc8a0c2c06ea$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $3533981f54ef4572$exports = {};
'use strict';

var $ab1a4183ca7926ca$exports = {};
'use strict';


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $952c83331f331e1f$export$2d1720544b23b823;
'use strict';
var $c5db1b6764613cc0$exports = {};
'use strict';



var $e2aa1319bea84c47$exports = {};
'use strict';

var $1d248630178c6a02$exports = {};
'use strict';
var $93e4d0e9a2ab7877$exports = {};
'use strict';
var $59e78816de00fec8$exports = {};
'use strict';
var $59e78816de00fec8$var$ceil = Math.ceil;
var $59e78816de00fec8$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$59e78816de00fec8$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $59e78816de00fec8$var$floor : $59e78816de00fec8$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$93e4d0e9a2ab7877$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $59e78816de00fec8$exports(number);
};


var $1d248630178c6a02$var$max = Math.max;
var $1d248630178c6a02$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$1d248630178c6a02$exports = function(index, length) {
    var integer = $93e4d0e9a2ab7877$exports(index);
    return integer < 0 ? $1d248630178c6a02$var$max(integer + length, 0) : $1d248630178c6a02$var$min(integer, length);
};


var $196bccd37bcf1489$exports = {};
'use strict';
var $11f5b663dedebbbb$exports = {};
'use strict';

var $11f5b663dedebbbb$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$11f5b663dedebbbb$exports = function(argument) {
    var len = $93e4d0e9a2ab7877$exports(argument);
    return len > 0 ? $11f5b663dedebbbb$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$196bccd37bcf1489$exports = function(obj) {
    return $11f5b663dedebbbb$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $e2aa1319bea84c47$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $276e457d9531c658$exports($this);
        var length = $196bccd37bcf1489$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $1d248630178c6a02$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$e2aa1319bea84c47$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $e2aa1319bea84c47$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $e2aa1319bea84c47$var$createMethod(false)
};


var $c5db1b6764613cc0$require$indexOf = $e2aa1319bea84c47$exports.indexOf;

var $c5db1b6764613cc0$var$push = $d3c77ff52b42c214$exports([].push);
$c5db1b6764613cc0$exports = function(object, names) {
    var O = $276e457d9531c658$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$b1e383a38b6d64a4$exports($80dc022279e502e5$exports, key) && $b1e383a38b6d64a4$exports(O, key) && $c5db1b6764613cc0$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($b1e383a38b6d64a4$exports(O, key = names[i++])) ~$c5db1b6764613cc0$require$indexOf(result, key) || $c5db1b6764613cc0$var$push(result, key);
    return result;
};


var $1d7d075cf7a7c01f$exports = {};
'use strict';
// IE8- don't enum bug keys
$1d7d075cf7a7c01f$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $952c83331f331e1f$var$hiddenKeys = $1d7d075cf7a7c01f$exports.concat('length', 'prototype');
$952c83331f331e1f$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $c5db1b6764613cc0$exports(O, $952c83331f331e1f$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $a3e60205222ed2af$export$2d1720544b23b823;
'use strict';
$a3e60205222ed2af$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $ab1a4183ca7926ca$var$concat = $d3c77ff52b42c214$exports([].concat);
// all object keys, includes non-enumerable and symbols
$ab1a4183ca7926ca$exports = $07a1d91bf69eb000$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $952c83331f331e1f$export$2d1720544b23b823($d8135a025f8b2a5b$exports(it));
    var getOwnPropertySymbols = $a3e60205222ed2af$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $ab1a4183ca7926ca$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$3533981f54ef4572$exports = function(target, source, exceptions) {
    var keys = $ab1a4183ca7926ca$exports(source);
    var defineProperty = $1598fc8a0c2c06ea$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $5ad39d6a4458ad36$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$b1e383a38b6d64a4$exports(target, key) && !(exceptions && $b1e383a38b6d64a4$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $45502abf8a242efe$exports = {};
'use strict';


var $45502abf8a242efe$var$replacement = /#|\.prototype\./;
var $45502abf8a242efe$var$isForced = function(feature, detection) {
    var value = $45502abf8a242efe$var$data[$45502abf8a242efe$var$normalize(feature)];
    return value === $45502abf8a242efe$var$POLYFILL ? true : value === $45502abf8a242efe$var$NATIVE ? false : $d914ef1aeb8832b3$exports(detection) ? $ba0ddb8815ecd04b$exports(detection) : !!detection;
};
var $45502abf8a242efe$var$normalize = $45502abf8a242efe$var$isForced.normalize = function(string) {
    return String(string).replace($45502abf8a242efe$var$replacement, '.').toLowerCase();
};
var $45502abf8a242efe$var$data = $45502abf8a242efe$var$isForced.data = {};
var $45502abf8a242efe$var$NATIVE = $45502abf8a242efe$var$isForced.NATIVE = 'N';
var $45502abf8a242efe$var$POLYFILL = $45502abf8a242efe$var$isForced.POLYFILL = 'P';
$45502abf8a242efe$exports = $45502abf8a242efe$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $919480ddf8d46973$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $7affcbe90b95b867$exports;
    else if (STATIC) target = $7affcbe90b95b867$exports[TARGET] || $f3452fc9184e06ab$exports(TARGET, {});
    else target = $7affcbe90b95b867$exports[TARGET] && $7affcbe90b95b867$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $919480ddf8d46973$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $45502abf8a242efe$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $3533981f54ef4572$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $b8d5e2520123b597$exports(sourceProperty, 'sham', true);
        $3b1976c267785763$exports(target, key, sourceProperty, options);
    }
};



var $b7b020597530f0e6$exports = {};
'use strict';

var $0cc8dd021c43d48c$exports = {};
'use strict';

var $0cc8dd021c43d48c$var$FunctionPrototype = Function.prototype;
var $0cc8dd021c43d48c$var$apply = $0cc8dd021c43d48c$var$FunctionPrototype.apply;
var $0cc8dd021c43d48c$var$call = $0cc8dd021c43d48c$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
$0cc8dd021c43d48c$exports = typeof Reflect == 'object' && Reflect.apply || ($971381254da1976c$exports ? $0cc8dd021c43d48c$var$call.bind($0cc8dd021c43d48c$var$apply) : function() {
    return $0cc8dd021c43d48c$var$call.apply($0cc8dd021c43d48c$var$apply, arguments);
});


var $47cb1fc4121485ab$exports = {};
'use strict';
var $754bf5332aee014e$exports = {};
'use strict';


$754bf5332aee014e$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($75e4f1be0fe59337$exports(fn) === 'Function') return $d3c77ff52b42c214$exports(fn);
};




var $47cb1fc4121485ab$var$bind = $754bf5332aee014e$exports($754bf5332aee014e$exports.bind);
// optional / simple context binding
$47cb1fc4121485ab$exports = function(fn, that) {
    $355c3a6273d7d9cd$exports(fn);
    return that === undefined ? fn : $971381254da1976c$exports ? $47cb1fc4121485ab$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $61a45a7c734e28f6$exports = {};
'use strict';

$61a45a7c734e28f6$exports = $07a1d91bf69eb000$exports('document', 'documentElement');


var $2b15c39c0b842235$exports = {};
'use strict';

$2b15c39c0b842235$exports = $d3c77ff52b42c214$exports([].slice);



var $31029377292c5609$exports = {};
'use strict';
var $31029377292c5609$var$$TypeError = TypeError;
$31029377292c5609$exports = function(passed, required) {
    if (passed < required) throw new $31029377292c5609$var$$TypeError('Not enough arguments');
    return passed;
};


var $5bc2991e058838aa$exports = {};
'use strict';

$5bc2991e058838aa$exports = /ipad|iphone|ipod/i.test($21be10dc6d84de4f$exports) && /applewebkit/i.test($21be10dc6d84de4f$exports);


var $46e82e2d4aaae850$exports = {};
'use strict';
var $bf830be77b604067$exports = {};
'use strict';



var $bf830be77b604067$var$userAgentStartsWith = function(string) {
    return $21be10dc6d84de4f$exports.slice(0, string.length) === string;
};
$bf830be77b604067$exports = function() {
    if ($bf830be77b604067$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($bf830be77b604067$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($bf830be77b604067$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($bf830be77b604067$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($7affcbe90b95b867$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($7affcbe90b95b867$exports.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($75e4f1be0fe59337$exports($7affcbe90b95b867$exports.process) === 'process') return 'NODE';
    if ($7affcbe90b95b867$exports.window && $7affcbe90b95b867$exports.document) return 'BROWSER';
    return 'REST';
}();


$46e82e2d4aaae850$exports = $bf830be77b604067$exports === 'NODE';


var $b7b020597530f0e6$var$set = $7affcbe90b95b867$exports.setImmediate;
var $b7b020597530f0e6$var$clear = $7affcbe90b95b867$exports.clearImmediate;
var $b7b020597530f0e6$var$process = $7affcbe90b95b867$exports.process;
var $b7b020597530f0e6$var$Dispatch = $7affcbe90b95b867$exports.Dispatch;
var $b7b020597530f0e6$var$Function = $7affcbe90b95b867$exports.Function;
var $b7b020597530f0e6$var$MessageChannel = $7affcbe90b95b867$exports.MessageChannel;
var $b7b020597530f0e6$var$String = $7affcbe90b95b867$exports.String;
var $b7b020597530f0e6$var$counter = 0;
var $b7b020597530f0e6$var$queue = {};
var $b7b020597530f0e6$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $b7b020597530f0e6$var$$location, $b7b020597530f0e6$var$defer, $b7b020597530f0e6$var$channel, $b7b020597530f0e6$var$port;
$ba0ddb8815ecd04b$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $b7b020597530f0e6$var$$location = $7affcbe90b95b867$exports.location;
});
var $b7b020597530f0e6$var$run = function(id) {
    if ($b1e383a38b6d64a4$exports($b7b020597530f0e6$var$queue, id)) {
        var fn = $b7b020597530f0e6$var$queue[id];
        delete $b7b020597530f0e6$var$queue[id];
        fn();
    }
};
var $b7b020597530f0e6$var$runner = function(id) {
    return function() {
        $b7b020597530f0e6$var$run(id);
    };
};
var $b7b020597530f0e6$var$eventListener = function(event) {
    $b7b020597530f0e6$var$run(event.data);
};
var $b7b020597530f0e6$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $7affcbe90b95b867$exports.postMessage($b7b020597530f0e6$var$String(id), $b7b020597530f0e6$var$$location.protocol + '//' + $b7b020597530f0e6$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$b7b020597530f0e6$var$set || !$b7b020597530f0e6$var$clear) {
    $b7b020597530f0e6$var$set = function setImmediate(handler) {
        $31029377292c5609$exports(arguments.length, 1);
        var fn = $d914ef1aeb8832b3$exports(handler) ? handler : $b7b020597530f0e6$var$Function(handler);
        var args = $2b15c39c0b842235$exports(arguments, 1);
        $b7b020597530f0e6$var$queue[++$b7b020597530f0e6$var$counter] = function() {
            $0cc8dd021c43d48c$exports(fn, undefined, args);
        };
        $b7b020597530f0e6$var$defer($b7b020597530f0e6$var$counter);
        return $b7b020597530f0e6$var$counter;
    };
    $b7b020597530f0e6$var$clear = function clearImmediate(id) {
        delete $b7b020597530f0e6$var$queue[id];
    };
    // Node.js 0.8-
    if ($46e82e2d4aaae850$exports) $b7b020597530f0e6$var$defer = function(id) {
        $b7b020597530f0e6$var$process.nextTick($b7b020597530f0e6$var$runner(id));
    };
    else if ($b7b020597530f0e6$var$Dispatch && $b7b020597530f0e6$var$Dispatch.now) $b7b020597530f0e6$var$defer = function(id) {
        $b7b020597530f0e6$var$Dispatch.now($b7b020597530f0e6$var$runner(id));
    };
    else if ($b7b020597530f0e6$var$MessageChannel && !$5bc2991e058838aa$exports) {
        $b7b020597530f0e6$var$channel = new $b7b020597530f0e6$var$MessageChannel();
        $b7b020597530f0e6$var$port = $b7b020597530f0e6$var$channel.port2;
        $b7b020597530f0e6$var$channel.port1.onmessage = $b7b020597530f0e6$var$eventListener;
        $b7b020597530f0e6$var$defer = $47cb1fc4121485ab$exports($b7b020597530f0e6$var$port.postMessage, $b7b020597530f0e6$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($7affcbe90b95b867$exports.addEventListener && $d914ef1aeb8832b3$exports($7affcbe90b95b867$exports.postMessage) && !$7affcbe90b95b867$exports.importScripts && $b7b020597530f0e6$var$$location && $b7b020597530f0e6$var$$location.protocol !== 'file:' && !$ba0ddb8815ecd04b$exports($b7b020597530f0e6$var$globalPostMessageDefer)) {
        $b7b020597530f0e6$var$defer = $b7b020597530f0e6$var$globalPostMessageDefer;
        $7affcbe90b95b867$exports.addEventListener('message', $b7b020597530f0e6$var$eventListener, false);
    // IE8-
    } else if ($b7b020597530f0e6$var$ONREADYSTATECHANGE in $25483c852b28875d$exports('script')) $b7b020597530f0e6$var$defer = function(id) {
        $61a45a7c734e28f6$exports.appendChild($25483c852b28875d$exports('script'))[$b7b020597530f0e6$var$ONREADYSTATECHANGE] = function() {
            $61a45a7c734e28f6$exports.removeChild(this);
            $b7b020597530f0e6$var$run(id);
        };
    };
    else $b7b020597530f0e6$var$defer = function(id) {
        setTimeout($b7b020597530f0e6$var$runner(id), 0);
    };
}
$b7b020597530f0e6$exports = {
    set: $b7b020597530f0e6$var$set,
    clear: $b7b020597530f0e6$var$clear
};


var $f6338971f51412e0$require$clearImmediate = $b7b020597530f0e6$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$919480ddf8d46973$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $7affcbe90b95b867$exports.clearImmediate !== $f6338971f51412e0$require$clearImmediate
}, {
    clearImmediate: $f6338971f51412e0$require$clearImmediate
});


'use strict';



var $02c771b65d988788$require$setTask = $b7b020597530f0e6$exports.set;
var $589801fec98054b1$exports = {};
'use strict';







var $589801fec98054b1$var$Function = $7affcbe90b95b867$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $589801fec98054b1$var$WRAP = /MSIE .\./.test($21be10dc6d84de4f$exports) || $bf830be77b604067$exports === 'BUN' && function() {
    var version = $7affcbe90b95b867$exports.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$589801fec98054b1$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $589801fec98054b1$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $31029377292c5609$exports(arguments.length, 1) > firstParamIndex;
        var fn = $d914ef1aeb8832b3$exports(handler) ? handler : $589801fec98054b1$var$Function(handler);
        var params = boundArgs ? $2b15c39c0b842235$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $0cc8dd021c43d48c$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $02c771b65d988788$var$setImmediate = $7affcbe90b95b867$exports.setImmediate ? $589801fec98054b1$exports($02c771b65d988788$require$setTask, false) : $02c771b65d988788$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$919480ddf8d46973$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $7affcbe90b95b867$exports.setImmediate !== $02c771b65d988788$var$setImmediate
}, {
    setImmediate: $02c771b65d988788$var$setImmediate
});




var $b6943471375d1c2a$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b6943471375d1c2a$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $b6943471375d1c2a$exports));
try {
    regeneratorRuntime = $b6943471375d1c2a$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $b6943471375d1c2a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($b6943471375d1c2a$var$runtime);
}



var $9409895355f874f2$exports = {};
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

$9409895355f874f2$exports = (parcelRequire("ed1Y9"));


const $8f04fbb427feaa8c$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $e4764a498cbbb40b$export$31499a9cd224b78c = "10.63.0";


const $83d83aff34c1a47f$export$f1a6cdb1459e81d1 = globalThis;


function $ef23ecc2ba89fe5e$export$19eade501500c6c1() {
    $ef23ecc2ba89fe5e$export$c8bfa33e4e8ae492((0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1));
    return 0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1;
}
function $ef23ecc2ba89fe5e$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $e4764a498cbbb40b$export$31499a9cd224b78c);
    return __SENTRY__[0, $e4764a498cbbb40b$export$31499a9cd224b78c] = __SENTRY__[0, $e4764a498cbbb40b$export$31499a9cd224b78c] || {};
}
function $ef23ecc2ba89fe5e$export$7e223ec222791509(name, creator, obj = (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $e4764a498cbbb40b$export$31499a9cd224b78c] = __SENTRY__[0, $e4764a498cbbb40b$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}




const $9e6aad2ab33fde86$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $9e6aad2ab33fde86$var$PREFIX = "Sentry Logger ";
const $9e6aad2ab33fde86$export$77c4ce905194557b = {};
function $9e6aad2ab33fde86$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($9e6aad2ab33fde86$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $9e6aad2ab33fde86$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $9e6aad2ab33fde86$var$enable() {
    $9e6aad2ab33fde86$var$_getLoggerSettings().enabled = true;
}
function $9e6aad2ab33fde86$var$disable() {
    $9e6aad2ab33fde86$var$_getLoggerSettings().enabled = false;
}
function $9e6aad2ab33fde86$var$isEnabled() {
    return $9e6aad2ab33fde86$var$_getLoggerSettings().enabled;
}
function $9e6aad2ab33fde86$var$log(...args) {
    $9e6aad2ab33fde86$var$_maybeLog("log", ...args);
}
function $9e6aad2ab33fde86$var$warn(...args) {
    $9e6aad2ab33fde86$var$_maybeLog("warn", ...args);
}
function $9e6aad2ab33fde86$var$error(...args) {
    $9e6aad2ab33fde86$var$_maybeLog("error", ...args);
}
function $9e6aad2ab33fde86$var$_maybeLog(level, ...args) {
    if (!(0, $8f04fbb427feaa8c$export$16a28057038b10ef)) return;
    if ($9e6aad2ab33fde86$var$isEnabled()) $9e6aad2ab33fde86$export$cda52e2a8927a2ca(()=>{
        (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1).console[level](`${$9e6aad2ab33fde86$var$PREFIX}[${level}]:`, ...args);
    });
}
function $9e6aad2ab33fde86$var$_getLoggerSettings() {
    if (!(0, $8f04fbb427feaa8c$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $ef23ecc2ba89fe5e$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $9e6aad2ab33fde86$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $9e6aad2ab33fde86$var$enable,
    disable: /** Disable logging. */ $9e6aad2ab33fde86$var$disable,
    isEnabled: /** Check if logging is enabled. */ $9e6aad2ab33fde86$var$isEnabled,
    log: /** Log a message. */ $9e6aad2ab33fde86$var$log,
    warn: /** Log a warning. */ $9e6aad2ab33fde86$var$warn,
    error: /** Log an error. */ $9e6aad2ab33fde86$var$error
};


const $8988df7479b3af76$var$STACKTRACE_FRAME_LIMIT = 50;
const $8988df7479b3af76$export$27c7e15d453fc0ac = "?";
const $8988df7479b3af76$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $8988df7479b3af76$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $8988df7479b3af76$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $8988df7479b3af76$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($8988df7479b3af76$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $8988df7479b3af76$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $8988df7479b3af76$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $8988df7479b3af76$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $8988df7479b3af76$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $8988df7479b3af76$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($8988df7479b3af76$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($8988df7479b3af76$var$STRIP_FRAME_REGEXP.test($8988df7479b3af76$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($8988df7479b3af76$var$STRIP_FRAME_REGEXP.test($8988df7479b3af76$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $8988df7479b3af76$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $8988df7479b3af76$var$getLastStackFrame(localStack).filename,
            function: frame.function || $8988df7479b3af76$export$27c7e15d453fc0ac
        }));
}
function $8988df7479b3af76$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $8988df7479b3af76$var$defaultFunctionName = "<anonymous>";
function $8988df7479b3af76$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $8988df7479b3af76$var$defaultFunctionName;
        return fn.name || $8988df7479b3af76$var$defaultFunctionName;
    } catch  {
        return $8988df7479b3af76$var$defaultFunctionName;
    }
}
function $8988df7479b3af76$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $8988df7479b3af76$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


const $3cffafffc6e2c7bd$var$handlers = {};
const $3cffafffc6e2c7bd$var$instrumented = {};
function $3cffafffc6e2c7bd$export$a4e09611e30da72e(type, handler) {
    $3cffafffc6e2c7bd$var$handlers[type] = $3cffafffc6e2c7bd$var$handlers[type] || [];
    $3cffafffc6e2c7bd$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $3cffafffc6e2c7bd$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $3cffafffc6e2c7bd$export$b17eab759a1cb5fe() {
    Object.keys($3cffafffc6e2c7bd$var$handlers).forEach((key)=>{
        $3cffafffc6e2c7bd$var$handlers[key] = void 0;
    });
}
function $3cffafffc6e2c7bd$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$3cffafffc6e2c7bd$var$instrumented[type]) {
        $3cffafffc6e2c7bd$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $3cffafffc6e2c7bd$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $3cffafffc6e2c7bd$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $8988df7479b3af76$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}



const $f679a4ba87c0a16b$var$objectToString = Object.prototype.toString;
function $f679a4ba87c0a16b$export$e6127cc7fe7395c3(wat) {
    switch($f679a4ba87c0a16b$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $f679a4ba87c0a16b$export$49034edbe6b62415(wat, Error);
    }
}
function $f679a4ba87c0a16b$var$isBuiltin(wat, className) {
    return $f679a4ba87c0a16b$var$objectToString.call(wat) === `[object ${className}]`;
}
function $f679a4ba87c0a16b$export$9f9636d330b71954(wat) {
    return $f679a4ba87c0a16b$var$isBuiltin(wat, "ErrorEvent");
}
function $f679a4ba87c0a16b$export$ef9e2056653f0c8e(wat) {
    return $f679a4ba87c0a16b$var$isBuiltin(wat, "DOMError");
}
function $f679a4ba87c0a16b$export$12e869b2a583f783(wat) {
    return $f679a4ba87c0a16b$var$isBuiltin(wat, "DOMException");
}
function $f679a4ba87c0a16b$export$844ec244b1367d54(wat) {
    return $f679a4ba87c0a16b$var$isBuiltin(wat, "String");
}
function $f679a4ba87c0a16b$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $f679a4ba87c0a16b$export$c3825b437cbdea5c(wat) {
    return wat === null || $f679a4ba87c0a16b$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $f679a4ba87c0a16b$export$53b83ca8eaab0383(wat) {
    return $f679a4ba87c0a16b$var$isBuiltin(wat, "Object");
}
function $f679a4ba87c0a16b$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $f679a4ba87c0a16b$export$49034edbe6b62415(wat, Event);
}
function $f679a4ba87c0a16b$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $f679a4ba87c0a16b$export$49034edbe6b62415(wat, Element);
}
function $f679a4ba87c0a16b$export$49841c62b9eff15(wat) {
    return $f679a4ba87c0a16b$var$isBuiltin(wat, "RegExp");
}
function $f679a4ba87c0a16b$export$f5b060c2914b97c8(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $f679a4ba87c0a16b$export$bc2894c7158efbac(wat) {
    return $f679a4ba87c0a16b$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $f679a4ba87c0a16b$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $f679a4ba87c0a16b$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $f679a4ba87c0a16b$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $f679a4ba87c0a16b$export$49034edbe6b62415(request, Request);
}


function $c23193fe738c8aae$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $c23193fe738c8aae$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $c23193fe738c8aae$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $c23193fe738c8aae$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $c23193fe738c8aae$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $c23193fe738c8aae$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($c23193fe738c8aae$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $c23193fe738c8aae$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $c23193fe738c8aae$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $c23193fe738c8aae$export$62ff257738bf57f5(value) {
    if ((0, $f679a4ba87c0a16b$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$c23193fe738c8aae$var$getOwnProperties(value)
    };
    if ((0, $f679a4ba87c0a16b$export$9671ea99bd126ace)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$c23193fe738c8aae$var$getOwnProperties(value)
        };
    }
    return value;
}
function $c23193fe738c8aae$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $c23193fe738c8aae$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($c23193fe738c8aae$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $c23193fe738c8aae$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $c23193fe738c8aae$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $c23193fe738c8aae$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($c23193fe738c8aae$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($c23193fe738c8aae$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $c23193fe738c8aae$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $c23193fe738c8aae$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $c23193fe738c8aae$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $f679a4ba87c0a16b$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




const $5d3204b815cde265$var$WINDOW = (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1);
function $5d3204b815cde265$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $5d3204b815cde265$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $5d3204b815cde265$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $5d3204b815cde265$export$67fc34576016d6ec() {
    return "history" in $5d3204b815cde265$var$WINDOW && !!$5d3204b815cde265$var$WINDOW.history;
}
const $5d3204b815cde265$export$edf3cb81fd7d2a3e = $5d3204b815cde265$var$_isFetchSupported;
function $5d3204b815cde265$var$_isFetchSupported() {
    if (!("fetch" in $5d3204b815cde265$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $5d3204b815cde265$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $5d3204b815cde265$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$5d3204b815cde265$var$_isFetchSupported()) return false;
    if ($5d3204b815cde265$export$d5f608b368e73f38($5d3204b815cde265$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $5d3204b815cde265$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $5d3204b815cde265$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $5d3204b815cde265$export$531055a6c684a70a() {
    return "ReportingObserver" in $5d3204b815cde265$var$WINDOW;
}
function $5d3204b815cde265$export$2d308b428295192f() {
    if (!$5d3204b815cde265$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}



const $f1ead4edfaa283d7$export$56d8a8a25bd48b81 = (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1);


let $c1a8a7f184186a3b$var$lastHref;
function $c1a8a7f184186a3b$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $3cffafffc6e2c7bd$export$a4e09611e30da72e)(type, handler);
    (0, $3cffafffc6e2c7bd$export$e18d6c5462c01368)(type, $c1a8a7f184186a3b$export$d9b613a6254a184e);
}
function $c1a8a7f184186a3b$export$d9b613a6254a184e() {
    (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).location.href;
        const from = $c1a8a7f184186a3b$var$lastHref;
        $c1a8a7f184186a3b$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $3cffafffc6e2c7bd$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $5d3204b815cde265$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $c1a8a7f184186a3b$var$lastHref;
                const to = $c1a8a7f184186a3b$var$getAbsoluteUrl(String(url));
                $c1a8a7f184186a3b$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $3cffafffc6e2c7bd$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $c23193fe738c8aae$export$9563e054e6f787fb)((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $c23193fe738c8aae$export$9563e054e6f787fb)((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $c1a8a7f184186a3b$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}


let $471396d0ee2af783$var$RESOLVED_RUNNER;
function $471396d0ee2af783$export$ff239213cb80e2da(cb) {
    if ($471396d0ee2af783$var$RESOLVED_RUNNER !== void 0) return $471396d0ee2af783$var$RESOLVED_RUNNER ? $471396d0ee2af783$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $471396d0ee2af783$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $471396d0ee2af783$var$RESOLVED_RUNNER(cb);
    }
    $471396d0ee2af783$var$RESOLVED_RUNNER = null;
    return cb();
}
function $471396d0ee2af783$export$9869d72de32a3917() {
    return $471396d0ee2af783$export$ff239213cb80e2da(()=>Math.random());
}
function $471396d0ee2af783$export$65b1bada40c91b34() {
    return $471396d0ee2af783$export$ff239213cb80e2da(()=>Date.now());
}



const $7fd3d32b8c514972$var$ONE_SECOND_IN_MS = 1e3;
function $7fd3d32b8c514972$export$7740643b9eeaf0c4() {
    return (0, $471396d0ee2af783$export$65b1bada40c91b34)() / $7fd3d32b8c514972$var$ONE_SECOND_IN_MS;
}
function $7fd3d32b8c514972$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1);
    if (!performance?.now || !performance.timeOrigin) return $7fd3d32b8c514972$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $471396d0ee2af783$export$ff239213cb80e2da)(()=>performance.now())) / $7fd3d32b8c514972$var$ONE_SECOND_IN_MS;
    };
}
let $7fd3d32b8c514972$var$_cachedTimestampInSeconds;
function $7fd3d32b8c514972$export$ee52dced521e3e18() {
    const func = $7fd3d32b8c514972$var$_cachedTimestampInSeconds ?? ($7fd3d32b8c514972$var$_cachedTimestampInSeconds = $7fd3d32b8c514972$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $7fd3d32b8c514972$var$cachedTimeOrigin = null;
function $7fd3d32b8c514972$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1);
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $471396d0ee2af783$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $471396d0ee2af783$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $7fd3d32b8c514972$export$baf075a948ffc0bf() {
    if ($7fd3d32b8c514972$var$cachedTimeOrigin === null) $7fd3d32b8c514972$var$cachedTimeOrigin = $7fd3d32b8c514972$var$getBrowserTimeOrigin();
    return $7fd3d32b8c514972$var$cachedTimeOrigin;
}








const $b273176bc3dce019$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $b273176bc3dce019$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $b273176bc3dce019$export$280812de8e91ea53(obj) {
    (0, $c23193fe738c8aae$export$e73679ffaf56810e)(obj, $b273176bc3dce019$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $b273176bc3dce019$export$610d1422c4bdc4c1(obj, depth) {
    (0, $c23193fe738c8aae$export$e73679ffaf56810e)(obj, $b273176bc3dce019$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $b273176bc3dce019$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$b273176bc3dce019$var$SENTRY_SKIP_NORMALIZATION]);
}
function $b273176bc3dce019$export$fe95a19841c4b155(value) {
    const v = value[$b273176bc3dce019$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}




let $7041ced124b506ec$var$stringifier;
function $7041ced124b506ec$export$575c40989754ba4d(newStringifier) {
    $7041ced124b506ec$var$stringifier = newStringifier;
}
function $7041ced124b506ec$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $7041ced124b506ec$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $7041ced124b506ec$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $7041ced124b506ec$export$a3295358bff77e(object, depth);
    if ($7041ced124b506ec$var$jsonSize(normalized) > maxSize) return $7041ced124b506ec$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $7041ced124b506ec$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $7041ced124b506ec$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $7041ced124b506ec$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $b273176bc3dce019$export$c8d26b7b28f926c7)(value)) return value;
    const overrideDepth = (0, $b273176bc3dce019$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $7041ced124b506ec$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $c23193fe738c8aae$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $7041ced124b506ec$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $7041ced124b506ec$export$a110e5bc79f44a84(key, value) {
    try {
        if ($7041ced124b506ec$var$stringifier) {
            const stringified = $7041ced124b506ec$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $8988df7479b3af76$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $7041ced124b506ec$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $7041ced124b506ec$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $7041ced124b506ec$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $7041ced124b506ec$var$jsonSize(value) {
    return $7041ced124b506ec$var$utf8Length(JSON.stringify(value));
}
function $7041ced124b506ec$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $7041ced124b506ec$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $3caf4858e68d282c$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $3caf4858e68d282c$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $3caf4858e68d282c$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $f679a4ba87c0a16b$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $7041ced124b506ec$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $3caf4858e68d282c$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $f679a4ba87c0a16b$export$844ec244b1367d54)(value)) return false;
    if ((0, $f679a4ba87c0a16b$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $f679a4ba87c0a16b$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $3caf4858e68d282c$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($3caf4858e68d282c$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $c0e4bdc3ef402b05$var$getCrypto() {
    const gbl = (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $c0e4bdc3ef402b05$var$emptyUuid;
function $c0e4bdc3ef402b05$var$getRandomByte() {
    return (0, $471396d0ee2af783$export$9869d72de32a3917)() * 16;
}
function $c0e4bdc3ef402b05$export$19f53698e68b2496(crypto = $c0e4bdc3ef402b05$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return (0, $471396d0ee2af783$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$c0e4bdc3ef402b05$var$emptyUuid) $c0e4bdc3ef402b05$var$emptyUuid = "10000000100040008000100000000000";
    return $c0e4bdc3ef402b05$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($c0e4bdc3ef402b05$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $c0e4bdc3ef402b05$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $c0e4bdc3ef402b05$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $c0e4bdc3ef402b05$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $c0e4bdc3ef402b05$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $c0e4bdc3ef402b05$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $c0e4bdc3ef402b05$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $c0e4bdc3ef402b05$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $c0e4bdc3ef402b05$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $c0e4bdc3ef402b05$export$d364f2020ab30578(input) {
    const match = input.match($c0e4bdc3ef402b05$var$SEMVER_REGEXP) || [];
    const major = $c0e4bdc3ef402b05$var$_parseInt(match[1]);
    const minor = $c0e4bdc3ef402b05$var$_parseInt(match[2]);
    const patch = $c0e4bdc3ef402b05$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $c0e4bdc3ef402b05$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $3caf4858e68d282c$export$4215662d762d6f9d)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $3caf4858e68d282c$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $3caf4858e68d282c$export$4215662d762d6f9d)(line, 0));
}
function $c0e4bdc3ef402b05$export$6de4ffac6a2f1098(exception) {
    if ($c0e4bdc3ef402b05$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $c23193fe738c8aae$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $c0e4bdc3ef402b05$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}



function $9d73d4280a03e010$export$14a186326edbb264(context) {
    const startingTime = (0, $7fd3d32b8c514972$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $c0e4bdc3ef402b05$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$9d73d4280a03e010$var$sessionToJSON(session)
    };
    if (context) $9d73d4280a03e010$export$531818e825e774db(session, context);
    return session;
}
function $9d73d4280a03e010$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $7fd3d32b8c514972$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : (0, $c0e4bdc3ef402b05$export$19f53698e68b2496)();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $9d73d4280a03e010$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $9d73d4280a03e010$export$531818e825e774db(session, context);
}
function $9d73d4280a03e010$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




function $b3952ffec1caf1fa$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $b3952ffec1caf1fa$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




function $8e3165bfbe89a619$export$dc6d7ea554bcce10() {
    return (0, $c0e4bdc3ef402b05$export$19f53698e68b2496)();
}
function $8e3165bfbe89a619$export$295213bc4d0c54ad() {
    return (0, $c0e4bdc3ef402b05$export$19f53698e68b2496)().substring(16);
}





function $0d953159e9111e5c$export$f0b98edec95fcb33(value) {
    try {
        const WeakRefImpl = (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $0d953159e9111e5c$export$a0592ad8c3586cf(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}


const $5069cf84161adda7$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $5069cf84161adda7$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $c23193fe738c8aae$export$e73679ffaf56810e)(scope, $5069cf84161adda7$var$SCOPE_SPAN_FIELD, (0, $0d953159e9111e5c$export$f0b98edec95fcb33)(span));
    else delete scope[$5069cf84161adda7$var$SCOPE_SPAN_FIELD];
}
function $5069cf84161adda7$export$91f063ebb8eff307(scope) {
    return (0, $0d953159e9111e5c$export$a0592ad8c3586cf)(scope[$5069cf84161adda7$var$SCOPE_SPAN_FIELD]);
}




const $faf680ce05d95b15$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $faf680ce05d95b15$export$775b6bb06e53a214 {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $8e3165bfbe89a619$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $471396d0ee2af783$export$9869d72de32a3917)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $faf680ce05d95b15$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $5069cf84161adda7$export$3f25fa50c18e20ca)(newScope, (0, $5069cf84161adda7$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) (0, $9d73d4280a03e010$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $faf680ce05d95b15$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $f679a4ba87c0a16b$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        (0, $5069cf84161adda7$export$3f25fa50c18e20ca)(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $8e3165bfbe89a619$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $471396d0ee2af783$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $faf680ce05d95b15$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $7fd3d32b8c514972$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $3caf4858e68d282c$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $5069cf84161adda7$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $b3952ffec1caf1fa$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $c0e4bdc3ef402b05$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $c0e4bdc3ef402b05$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $c0e4bdc3ef402b05$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


function $f0ab743e7340580f$export$6f1b9191db9c4d5() {
    return (0, $ef23ecc2ba89fe5e$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $faf680ce05d95b15$export$775b6bb06e53a214)());
}
function $f0ab743e7340580f$export$de9862929b76bf57() {
    return (0, $ef23ecc2ba89fe5e$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $faf680ce05d95b15$export$775b6bb06e53a214)());
}



const $11febc130f3b1527$var$isActualPromise = (p)=>p instanceof Promise && !p[$11febc130f3b1527$var$kChainedCopy];
const $11febc130f3b1527$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $11febc130f3b1527$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $11febc130f3b1527$var$isActualPromise(chained) && $11febc130f3b1527$var$isActualPromise(original) ? chained : $11febc130f3b1527$var$copyProps(original, chained);
};
const $11febc130f3b1527$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$11febc130f3b1527$var$kChainedCopy]: true
    });
    return chained;
};




class $99462dba2e3c848f$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $faf680ce05d95b15$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $faf680ce05d95b15$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $f679a4ba87c0a16b$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $11febc130f3b1527$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $99462dba2e3c848f$var$getAsyncContextStack() {
    const registry = (0, $ef23ecc2ba89fe5e$export$19eade501500c6c1)();
    const sentry = (0, $ef23ecc2ba89fe5e$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $99462dba2e3c848f$export$d36ec451f120cfba((0, $f0ab743e7340580f$export$6f1b9191db9c4d5)(), (0, $f0ab743e7340580f$export$de9862929b76bf57)());
}
function $99462dba2e3c848f$var$withScope(callback) {
    return $99462dba2e3c848f$var$getAsyncContextStack().withScope(callback);
}
function $99462dba2e3c848f$var$withSetScope(scope, callback) {
    const stack = $99462dba2e3c848f$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $99462dba2e3c848f$var$withIsolationScope(callback) {
    return $99462dba2e3c848f$var$getAsyncContextStack().withScope(()=>{
        return callback($99462dba2e3c848f$var$getAsyncContextStack().getIsolationScope());
    });
}
function $99462dba2e3c848f$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $99462dba2e3c848f$var$withIsolationScope,
        withScope: $99462dba2e3c848f$var$withScope,
        withSetScope: $99462dba2e3c848f$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $99462dba2e3c848f$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$99462dba2e3c848f$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$99462dba2e3c848f$var$getAsyncContextStack().getIsolationScope()
    };
}


function $8848f3a74c4e0a42$export$774ae0e6b6e444ca(strategy) {
    const registry = (0, $ef23ecc2ba89fe5e$export$19eade501500c6c1)();
    const sentry = (0, $ef23ecc2ba89fe5e$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
function $8848f3a74c4e0a42$export$f639b0c2752203be(carrier) {
    const sentry = (0, $ef23ecc2ba89fe5e$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    return (0, $99462dba2e3c848f$export$329d4d4d54e42710)();
}



function $7a7124256e71c67f$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $7a7124256e71c67f$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $7a7124256e71c67f$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $7a7124256e71c67f$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $7a7124256e71c67f$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $7a7124256e71c67f$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $7a7124256e71c67f$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $7a7124256e71c67f$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $f679a4ba87c0a16b$export$c3825b437cbdea5c)(val)) weight += $7a7124256e71c67f$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $7a7124256e71c67f$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $7a7124256e71c67f$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}







let $0f6c045e0dbe9a1e$var$_externalPropagationContextProvider;
function $0f6c045e0dbe9a1e$export$b5defb3466e9689b(fn) {
    $0f6c045e0dbe9a1e$var$_externalPropagationContextProvider = fn;
}
function $0f6c045e0dbe9a1e$export$92547f779c920a71() {
    return $0f6c045e0dbe9a1e$var$_externalPropagationContextProvider?.();
}
function $0f6c045e0dbe9a1e$export$53f0ae651a1c4298() {
    return $0f6c045e0dbe9a1e$var$_externalPropagationContextProvider !== void 0;
}
function $0f6c045e0dbe9a1e$export$c7be4b0125a10cba() {
    const carrier = (0, $ef23ecc2ba89fe5e$export$19eade501500c6c1)();
    const acs = (0, $8848f3a74c4e0a42$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
function $0f6c045e0dbe9a1e$export$68f3af03034c9e90() {
    const carrier = (0, $ef23ecc2ba89fe5e$export$19eade501500c6c1)();
    const acs = (0, $8848f3a74c4e0a42$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
function $0f6c045e0dbe9a1e$export$aa55d5ab8e05984f() {
    return (0, $ef23ecc2ba89fe5e$export$7e223ec222791509)("globalScope", ()=>new (0, $faf680ce05d95b15$export$775b6bb06e53a214)());
}
function $0f6c045e0dbe9a1e$export$ec58d9285c204497(...rest) {
    const carrier = (0, $ef23ecc2ba89fe5e$export$19eade501500c6c1)();
    const acs = (0, $8848f3a74c4e0a42$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $0f6c045e0dbe9a1e$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $ef23ecc2ba89fe5e$export$19eade501500c6c1)();
    const acs = (0, $8848f3a74c4e0a42$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c() {
    return $0f6c045e0dbe9a1e$export$c7be4b0125a10cba().getClient();
}
function $0f6c045e0dbe9a1e$export$1e83db7ee4876dc4(scope) {
    const externalContext = $0f6c045e0dbe9a1e$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $8e3165bfbe89a619$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}


const $1862405160dfc8ac$export$d7a7d984b0791405 = "sentry.source";
const $1862405160dfc8ac$export$ccfe0a40627cc34b = "sentry.sample_rate";
const $1862405160dfc8ac$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
const $1862405160dfc8ac$export$1a413bd9a88fdb09 = "sentry.op";
const $1862405160dfc8ac$export$cca8dd30f57f805e = "sentry.origin";
const $1862405160dfc8ac$export$d9e02c0285078f88 = "sentry.status.message";
const $1862405160dfc8ac$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
const $1862405160dfc8ac$export$f5f95cff026507b5 = "sentry.measurement_unit";
const $1862405160dfc8ac$export$69cd5c610c7bb96a = "sentry.measurement_value";
const $1862405160dfc8ac$export$f5cefb258679b29e = "sentry.release";
const $1862405160dfc8ac$export$d1b1dbb47f5ba57c = "sentry.environment";
const $1862405160dfc8ac$export$4626f2be16112c1c = "sentry.segment.name";
const $1862405160dfc8ac$export$25fa4a1832d3736a = "sentry.segment.id";
const $1862405160dfc8ac$export$87a4807042e1f1bb = "sentry.sdk.name";
const $1862405160dfc8ac$export$301ebe936458e291 = "sentry.sdk.version";
const $1862405160dfc8ac$export$bd847b1cc92ae587 = "sentry.sdk.integrations";
const $1862405160dfc8ac$export$1f9cc1d34ea098a0 = "user.id";
const $1862405160dfc8ac$export$b7466609ef46c07e = "user.email";
const $1862405160dfc8ac$export$8d592bdaea63b930 = "user.ip_address";
const $1862405160dfc8ac$export$c05ee933d3f74b2b = "user.name";
const $1862405160dfc8ac$export$165ce9a229f6f050 = "sentry.custom_span_name";
const $1862405160dfc8ac$export$1efec95406bbe327 = "sentry.profile_id";
const $1862405160dfc8ac$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $1862405160dfc8ac$export$b016f89ac1066ec = "cache.hit";
const $1862405160dfc8ac$export$3110e4c3f4386399 = "cache.key";
const $1862405160dfc8ac$export$86be76deee227ff2 = "cache.item_size";
const $1862405160dfc8ac$export$be7a251980e7e946 = "http.request.method";
const $1862405160dfc8ac$export$25dfd73e0e32c6e1 = "url.full";
const $1862405160dfc8ac$export$ff77b5fd5b2d627b = "sentry.link.type";
const $1862405160dfc8ac$export$71a4a707257f2774 = "gen_ai.conversation.id";


const $9ae89fdb2b85f9c1$export$136e25984ba4a383 = 0;
const $9ae89fdb2b85f9c1$export$58f7963109c806fc = 1;
const $9ae89fdb2b85f9c1$export$f966a0446ece71e = 2;
function $9ae89fdb2b85f9c1$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $9ae89fdb2b85f9c1$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $9ae89fdb2b85f9c1$export$f966a0446ece71e,
        message: "internal_error"
    };
}
function $9ae89fdb2b85f9c1$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $9ae89fdb2b85f9c1$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}




const $9874d7f0a9b0b77c$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $9874d7f0a9b0b77c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $9874d7f0a9b0b77c$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
function $9874d7f0a9b0b77c$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $c23193fe738c8aae$export$e73679ffaf56810e)(span, $9874d7f0a9b0b77c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $0d953159e9111e5c$export$f0b98edec95fcb33)(isolationScope));
        (0, $c23193fe738c8aae$export$e73679ffaf56810e)(span, $9874d7f0a9b0b77c$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $9874d7f0a9b0b77c$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$9874d7f0a9b0b77c$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $0d953159e9111e5c$export$a0592ad8c3586cf)(spanWithScopes[$9874d7f0a9b0b77c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $9874d7f0a9b0b77c$export$d135494e80cbbcae(span) {
    (0, $c23193fe738c8aae$export$e73679ffaf56810e)(span, $9874d7f0a9b0b77c$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $9874d7f0a9b0b77c$export$2e69b79005fc86eb(span) {
    return span[$9874d7f0a9b0b77c$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}









const $c76e826c05d33ccc$export$6e69537d67fa20f = "sentry-";
const $c76e826c05d33ccc$export$eb0401070c617ea5 = /^sentry-/;
const $c76e826c05d33ccc$export$bdd844ddb2def819 = 8192;
function $c76e826c05d33ccc$export$5b96ee2c8421f107(baggageHeader) {
    const baggageObject = $c76e826c05d33ccc$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($c76e826c05d33ccc$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($c76e826c05d33ccc$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $c76e826c05d33ccc$export$56766feef403f365(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$c76e826c05d33ccc$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $c76e826c05d33ccc$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
function $c76e826c05d33ccc$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $f679a4ba87c0a16b$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $c76e826c05d33ccc$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $c76e826c05d33ccc$var$baggageHeaderToObject(baggageHeader);
}
function $c76e826c05d33ccc$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $c76e826c05d33ccc$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $c76e826c05d33ccc$export$bdd844ddb2def819) {
            (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $c76e826c05d33ccc$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $c76e826c05d33ccc$export$397de414d189db00(existing);
    const incomingEntries = $c76e826c05d33ccc$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($c76e826c05d33ccc$export$6e69537d67fa20f)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($c76e826c05d33ccc$export$6e69537d67fa20f)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $c76e826c05d33ccc$export$12a7349a29a6e3c2(merged);
}




const $f86e5540c296bee0$var$ORG_ID_REGEX = /^o(\d+)\./;
const $f86e5540c296bee0$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $f86e5540c296bee0$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $f86e5540c296bee0$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $f86e5540c296bee0$export$b892860177f70a30(str) {
    const match = $f86e5540c296bee0$var$DSN_REGEX.exec(str);
    if (!match) {
        (0, $9e6aad2ab33fde86$export$cda52e2a8927a2ca)(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $f86e5540c296bee0$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $f86e5540c296bee0$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $f86e5540c296bee0$var$validateDsn(dsn) {
    if (!(0, $8f04fbb427feaa8c$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $9e6aad2ab33fde86$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $9e6aad2ab33fde86$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$f86e5540c296bee0$var$isValidProtocol(protocol)) {
        (0, $9e6aad2ab33fde86$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $9e6aad2ab33fde86$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $f86e5540c296bee0$export$5914f4e7748c29c9(host) {
    const match = host.match($f86e5540c296bee0$var$ORG_ID_REGEX);
    return match?.[1];
}
function $f86e5540c296bee0$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $f86e5540c296bee0$export$5914f4e7748c29c9(host);
    return org_id;
}
function $f86e5540c296bee0$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $f86e5540c296bee0$export$b892860177f70a30(from) : $f86e5540c296bee0$var$dsnFromComponents(from);
    if (!components || !$f86e5540c296bee0$var$validateDsn(components)) return void 0;
    return components;
}


function $42b96f8c46608c69$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}




const $22176dd1fe3ca274$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $22176dd1fe3ca274$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($22176dd1fe3ca274$export$394a210812ba3012);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $22176dd1fe3ca274$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $22176dd1fe3ca274$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $c76e826c05d33ccc$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $8e3165bfbe89a619$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $471396d0ee2af783$export$9869d72de32a3917)()
    };
    const sampleRand = $22176dd1fe3ca274$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $22176dd1fe3ca274$export$f35d907436da45cf(traceId = (0, $8e3165bfbe89a619$export$dc6d7ea554bcce10)(), spanId = (0, $8e3165bfbe89a619$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $22176dd1fe3ca274$export$1aff3752542747dd(traceId = (0, $8e3165bfbe89a619$export$dc6d7ea554bcce10)(), spanId = (0, $8e3165bfbe89a619$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $22176dd1fe3ca274$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = (0, $42b96f8c46608c69$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = (0, $42b96f8c46608c69$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    (0, $471396d0ee2af783$export$9869d72de32a3917)() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + (0, $471396d0ee2af783$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else return (0, $471396d0ee2af783$export$9869d72de32a3917)();
}
function $22176dd1fe3ca274$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $f86e5540c296bee0$export$b7ac9b8efa4bb595)(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




const $df43a4967084dd30$export$208d5b368507fb8b = 0;
const $df43a4967084dd30$export$eb571cd9b5d98de8 = 1;
let $df43a4967084dd30$var$hasShownSpanDropWarning = false;
function $df43a4967084dd30$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $df43a4967084dd30$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $df43a4967084dd30$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $df43a4967084dd30$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $9874d7f0a9b0b77c$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $8e3165bfbe89a619$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $df43a4967084dd30$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $df43a4967084dd30$export$5caecac1caaf3a71(span);
    return (0, $22176dd1fe3ca274$export$f35d907436da45cf)(traceId, spanId, sampled);
}
function $df43a4967084dd30$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $df43a4967084dd30$export$5caecac1caaf3a71(span);
    return (0, $22176dd1fe3ca274$export$1aff3752542747dd)(traceId, spanId, sampled);
}
function $df43a4967084dd30$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $df43a4967084dd30$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $df43a4967084dd30$export$9015adcf158ef3a5(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $df43a4967084dd30$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return void 0;
}
function $df43a4967084dd30$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $df43a4967084dd30$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $df43a4967084dd30$var$ensureTimestampInSeconds(input.getTime());
    return (0, $7fd3d32b8c514972$export$ee52dced521e3e18)();
}
function $df43a4967084dd30$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $df43a4967084dd30$export$92d8c23565496537(span) {
    if ($df43a4967084dd30$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($df43a4967084dd30$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $df43a4967084dd30$var$getOtelParentSpanId(span),
            start_timestamp: $df43a4967084dd30$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $df43a4967084dd30$export$3f7581298f56c6d7(endTime) || void 0,
            status: $df43a4967084dd30$export$e238a77ea3a8cd66(status),
            op: attributes[0, $1862405160dfc8ac$export$1a413bd9a88fdb09],
            origin: attributes[0, $1862405160dfc8ac$export$cca8dd30f57f805e],
            links: $df43a4967084dd30$export$cb3e3a12e0eec16c(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $df43a4967084dd30$export$db0cad9e44f67af8(span) {
    if ($df43a4967084dd30$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($df43a4967084dd30$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $df43a4967084dd30$var$getOtelParentSpanId(span),
            start_timestamp: $df43a4967084dd30$export$3f7581298f56c6d7(startTime),
            end_timestamp: $df43a4967084dd30$export$3f7581298f56c6d7(endTime),
            is_segment: span === $df43a4967084dd30$export$7a3106f345d83bb6(span),
            status: $df43a4967084dd30$export$d3856a3187d34821(status),
            attributes: $df43a4967084dd30$export$1464a9cb828ba99f(attributes, status),
            links: $df43a4967084dd30$export$9015adcf158ef3a5(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $df43a4967084dd30$export$7a3106f345d83bb6(span)
    };
}
function $df43a4967084dd30$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $df43a4967084dd30$export$5402aa553bcf35f3(spanJson) {
    return {
        ...spanJson,
        attributes: (0, $7a7124256e71c67f$export$4954cae66e755861)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, $7a7124256e71c67f$export$4954cae66e755861)(link.attributes)
            }))
    };
}
function $df43a4967084dd30$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $df43a4967084dd30$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $df43a4967084dd30$export$5caecac1caaf3a71(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $df43a4967084dd30$export$eb571cd9b5d98de8;
}
function $df43a4967084dd30$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $9ae89fdb2b85f9c1$export$136e25984ba4a383)) return void 0;
    if (status.code === (0, $9ae89fdb2b85f9c1$export$58f7963109c806fc)) return "ok";
    return status.message || "internal_error";
}
function $df43a4967084dd30$export$d3856a3187d34821(status) {
    return !status || status.code === (0, $9ae89fdb2b85f9c1$export$58f7963109c806fc) || status.code === (0, $9ae89fdb2b85f9c1$export$136e25984ba4a383) || status.message === "cancelled" ? "ok" : "error";
}
function $df43a4967084dd30$export$1464a9cb828ba99f(attributes, status) {
    const statusMessage = $df43a4967084dd30$export$d3856a3187d34821(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [(0, $1862405160dfc8ac$export$d9e02c0285078f88)]: statusMessage
        },
        ...attributes
    };
}
const $df43a4967084dd30$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $df43a4967084dd30$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $df43a4967084dd30$export$81397d924722cc65(span, childSpan) {
    const rootSpan = span[$df43a4967084dd30$var$ROOT_SPAN_FIELD] || span;
    (0, $c23193fe738c8aae$export$e73679ffaf56810e)(childSpan, $df43a4967084dd30$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$df43a4967084dd30$var$CHILD_SPANS_FIELD]) span[$df43a4967084dd30$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $c23193fe738c8aae$export$e73679ffaf56810e)(span, $df43a4967084dd30$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $df43a4967084dd30$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$df43a4967084dd30$var$CHILD_SPANS_FIELD]) span[$df43a4967084dd30$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $df43a4967084dd30$export$340c5c8a13ffc680(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($df43a4967084dd30$export$5caecac1caaf3a71(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$df43a4967084dd30$var$CHILD_SPANS_FIELD] ? Array.from(span2[$df43a4967084dd30$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $df43a4967084dd30$export$c4c6a79b1260ca1b = $df43a4967084dd30$export$7a3106f345d83bb6;
function $df43a4967084dd30$export$7a3106f345d83bb6(span) {
    return span[$df43a4967084dd30$var$ROOT_SPAN_FIELD] || span;
}
function $df43a4967084dd30$export$1be426a8e585c83e() {
    const carrier = (0, $ef23ecc2ba89fe5e$export$19eade501500c6c1)();
    const acs = (0, $8848f3a74c4e0a42$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $5069cf84161adda7$export$91f063ebb8eff307)((0, $0f6c045e0dbe9a1e$export$c7be4b0125a10cba)());
}
function $df43a4967084dd30$export$d11691ff45a3e535() {
    if (!$df43a4967084dd30$var$hasShownSpanDropWarning) {
        (0, $9e6aad2ab33fde86$export$cda52e2a8927a2ca)(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $df43a4967084dd30$var$hasShownSpanDropWarning = true;
    }
}
function $df43a4967084dd30$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $1862405160dfc8ac$export$d7a7d984b0791405)]: "custom",
        [(0, $1862405160dfc8ac$export$165ce9a229f6f050)]: name
    });
}



const $2a58bfa7403ced33$var$WINDOW = (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1);
const $2a58bfa7403ced33$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $2a58bfa7403ced33$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $2a58bfa7403ced33$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $2a58bfa7403ced33$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $2a58bfa7403ced33$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($2a58bfa7403ced33$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $f679a4ba87c0a16b$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $2a58bfa7403ced33$export$1cfafeee2987818b() {
    try {
        return $2a58bfa7403ced33$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $2a58bfa7403ced33$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    if (!$2a58bfa7403ced33$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


const $94f1796ac223aa5a$var$DEFAULT_BASE_URL = "thismessage:/";
function $94f1796ac223aa5a$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
function $94f1796ac223aa5a$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $94f1796ac223aa5a$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $94f1796ac223aa5a$export$5339fcdc8e2a427c(url) {
    if ($94f1796ac223aa5a$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $94f1796ac223aa5a$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $94f1796ac223aa5a$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $94f1796ac223aa5a$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $1862405160dfc8ac$export$d7a7d984b0791405)]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $1862405160dfc8ac$export$d7a7d984b0791405] = "route";
    }
    if (request?.method) attributes[0, $1862405160dfc8ac$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $1862405160dfc8ac$export$d7a7d984b0791405] = "route";
        }
        if (!$94f1796ac223aa5a$export$e258e13805402ba7(urlObject)) {
            attributes[0, $1862405160dfc8ac$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $94f1796ac223aa5a$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $94f1796ac223aa5a$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $94f1796ac223aa5a$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $94f1796ac223aa5a$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $94f1796ac223aa5a$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}





function $19ca9956040f2a7a$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $df43a4967084dd30$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $df43a4967084dd30$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $1862405160dfc8ac$export$69cd5c610c7bb96a)]: value,
            [(0, $1862405160dfc8ac$export$f5f95cff026507b5)]: unit
        });
    }
}
function $19ca9956040f2a7a$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $1862405160dfc8ac$export$f5f95cff026507b5];
        const value = attributes[0, $1862405160dfc8ac$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



const $5e6d95e419314f14$var$DEFAULT_MAX_STRING_LENGTH = 80;
const $5e6d95e419314f14$var$accessors = {};
try {
    if (typeof Node !== "undefined") $5e6d95e419314f14$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $5e6d95e419314f14$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $5e6d95e419314f14$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $5e6d95e419314f14$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $5e6d95e419314f14$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $5e6d95e419314f14$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch  {}
function $5e6d95e419314f14$var$_safeRead(el, prop, arg) {
    const fn = $5e6d95e419314f14$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch  {}
    const val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $5e6d95e419314f14$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $5e6d95e419314f14$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $5e6d95e419314f14$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $5e6d95e419314f14$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $5e6d95e419314f14$var$_htmlElementAsString(el, keyAttrs) {
    const out = [];
    const tagName = $5e6d95e419314f14$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            const dataset = $5e6d95e419314f14$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return dataset["sentryComponent"];
                if (dataset["sentryElement"]) return dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>$5e6d95e419314f14$var$_safeRead(el, "getAttribute", keyAttr)).map((keyAttr)=>[
            keyAttr,
            $5e6d95e419314f14$var$_safeRead(el, "getAttribute", keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        const id = $5e6d95e419314f14$var$_safeRead(el, "id");
        if (id) out.push(`#${id}`);
        const className = $5e6d95e419314f14$var$_safeRead(el, "className");
        if (className && (0, $f679a4ba87c0a16b$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = $5e6d95e419314f14$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}




const $d0c2be10ad9299aa$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






const $d50f6292060853cb$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $d50f6292060853cb$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue ?? 0);
                if (delta || prevValue === void 0) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $d50f6292060853cb$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};




const $33f6602c6a93459c$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


const $8fb242506f12dabe$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $33f6602c6a93459c$export$6431553786c94949)();
    return navEntry?.activationStart ?? 0;
};



function $eb610c99fc404582$export$26d3d892edc56833(type, listener, options) {
    if ((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document) (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $eb610c99fc404582$export$324d7b4b46528191(type, listener, options) {
    if ((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document) (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


let $aabf50baf39dd628$var$firstHiddenTime = -1;
const $aabf50baf39dd628$var$onHiddenFunctions = /* @__PURE__ */ new Set();
const $aabf50baf39dd628$var$initHiddenTime = ()=>{
    return (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document?.visibilityState === "hidden" && !(0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document?.prerendering ? 0 : Infinity;
};
const $aabf50baf39dd628$var$onVisibilityUpdate = (event)=>{
    if ($aabf50baf39dd628$var$isPageHidden(event) && $aabf50baf39dd628$var$firstHiddenTime > -1) {
        if (event.type === "visibilitychange" || event.type === "pagehide") for (const onHiddenFunction of $aabf50baf39dd628$var$onHiddenFunctions)onHiddenFunction();
        if (!isFinite($aabf50baf39dd628$var$firstHiddenTime)) {
            $aabf50baf39dd628$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
            (0, $eb610c99fc404582$export$324d7b4b46528191)("prerenderingchange", $aabf50baf39dd628$var$onVisibilityUpdate, true);
        }
    }
};
const $aabf50baf39dd628$export$443f86b2c77012c4 = ()=>{
    if ((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document && $aabf50baf39dd628$var$firstHiddenTime < 0) {
        const activationStart = (0, $8fb242506f12dabe$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document.prerendering ? globalThis.performance.getEntriesByType("visibility-state").filter((e)=>e.name === "hidden" && e.startTime > activationStart)[0]?.startTime : void 0;
        $aabf50baf39dd628$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $aabf50baf39dd628$var$initHiddenTime();
        (0, $eb610c99fc404582$export$26d3d892edc56833)("visibilitychange", $aabf50baf39dd628$var$onVisibilityUpdate, true);
        (0, $eb610c99fc404582$export$26d3d892edc56833)("pagehide", $aabf50baf39dd628$var$onVisibilityUpdate, true);
        (0, $eb610c99fc404582$export$26d3d892edc56833)("prerenderingchange", $aabf50baf39dd628$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $aabf50baf39dd628$var$firstHiddenTime;
        },
        onHidden (cb) {
            $aabf50baf39dd628$var$onHiddenFunctions.add(cb);
        }
    };
};
function $aabf50baf39dd628$var$isPageHidden(event) {
    return event.type === "pagehide" || (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document?.visibilityState === "hidden";
}



const $956c19c3a9eab8c1$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};




const $e544ef88d12867fc$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $33f6602c6a93459c$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document?.prerendering || (0, $8fb242506f12dabe$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document?.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    const entries = [];
    return {
        name: name,
        value: value,
        rating: "good",
        // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
        delta: 0,
        entries: entries,
        id: (0, $956c19c3a9eab8c1$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


const $1de665ebcb8f473f$var$instanceMap = /* @__PURE__ */ new WeakMap();
function $1de665ebcb8f473f$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    try {
        if (!$1de665ebcb8f473f$var$instanceMap.get(identityObj)) $1de665ebcb8f473f$var$instanceMap.set(identityObj, new ClassObj());
        return $1de665ebcb8f473f$var$instanceMap.get(identityObj);
    } catch (_e) {
        return new ClassObj();
    }
}


class $4115a86686114597$export$4050f7f955e19aa0 {
    constructor(){
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionValue = 0;
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1e3 && entry.startTime - firstSessionEntry.startTime < 5e3) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        this._onAfterProcessingUnexpectedShift?.(entry);
    }
}


const $354b46617e9b2d88$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch  {}
    return;
};


const $0ae8f6fdfc40e933$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};








const $29e12016032abf49$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document?.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


const $82e651db0bf95b6e$export$e610c735b5510cec = [
    1800,
    3e3
];
const $82e651db0bf95b6e$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $29e12016032abf49$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $aabf50baf39dd628$export$443f86b2c77012c4)();
        const metric = (0, $e544ef88d12867fc$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === "first-contentful-paint") {
                po.disconnect();
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $8fb242506f12dabe$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $354b46617e9b2d88$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $d50f6292060853cb$export$17679dccdd551979)(onReport, metric, $82e651db0bf95b6e$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


const $037423963135f95a$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
const $037423963135f95a$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    (0, $82e651db0bf95b6e$export$fe3c86b74e15d5de)((0, $0ae8f6fdfc40e933$export$b841d51e31c12bab)(()=>{
        const metric = (0, $e544ef88d12867fc$export$3c29b44508a0612b)("CLS", 0);
        let report;
        const visibilityWatcher = (0, $aabf50baf39dd628$export$443f86b2c77012c4)();
        const layoutShiftManager = (0, $1de665ebcb8f473f$export$7c74c9b2462ddb3c)(opts, (0, $4115a86686114597$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $354b46617e9b2d88$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $d50f6292060853cb$export$17679dccdd551979)(onReport, metric, $037423963135f95a$export$3f20d8e089ac35b2, opts.reportAllChanges);
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81)?.setTimeout?.(report);
        }
    }));
};







let $e07e7854f951c324$var$interactionCountEstimate = 0;
let $e07e7854f951c324$var$minKnownInteractionId = Infinity;
let $e07e7854f951c324$var$maxKnownInteractionId = 0;
const $e07e7854f951c324$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $e07e7854f951c324$var$minKnownInteractionId = Math.min($e07e7854f951c324$var$minKnownInteractionId, e.interactionId);
            $e07e7854f951c324$var$maxKnownInteractionId = Math.max($e07e7854f951c324$var$maxKnownInteractionId, e.interactionId);
            $e07e7854f951c324$var$interactionCountEstimate = $e07e7854f951c324$var$maxKnownInteractionId ? ($e07e7854f951c324$var$maxKnownInteractionId - $e07e7854f951c324$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $e07e7854f951c324$var$po;
const $e07e7854f951c324$export$8a962f2683a476d1 = ()=>{
    return $e07e7854f951c324$var$po ? $e07e7854f951c324$var$interactionCountEstimate : performance.interactionCount || 0;
};
const $e07e7854f951c324$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $e07e7854f951c324$var$po) return;
    $e07e7854f951c324$var$po = (0, $354b46617e9b2d88$export$d1203567a167490e)("event", $e07e7854f951c324$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


const $0ea417265e927ba2$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
let $0ea417265e927ba2$var$prevInteractionCount = 0;
const $0ea417265e927ba2$var$getInteractionCountForNavigation = ()=>{
    return (0, $e07e7854f951c324$export$8a962f2683a476d1)() - $0ea417265e927ba2$var$prevInteractionCount;
};
class $0ea417265e927ba2$export$aaa80641d584351c {
    constructor(){
        /**
     * A list of longest interactions on the page (by latency) sorted so the
     * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
     * long.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionList = [];
        /**
     * A mapping of longest interactions by their interaction ID.
     * This is used for faster lookup.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionMap = /* @__PURE__ */ new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $0ea417265e927ba2$var$prevInteractionCount = (0, $e07e7854f951c324$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($0ea417265e927ba2$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
        if (!(entry.interactionId || entry.entryType === "first-input")) return;
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        if (interaction || this._longestInteractionList.length < $0ea417265e927ba2$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            if (interaction) {
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $0ea417265e927ba2$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($0ea417265e927ba2$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction2 of removedInteractions)this._longestInteractionMap.delete(interaction2.id);
            }
            this._onAfterProcessingINPCandidate?.(interaction);
        }
    }
}








const $f522d837479c7fe8$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).requestIdleCallback || (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).setTimeout;
    if ((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb();
    else {
        cb = (0, $0ae8f6fdfc40e933$export$b841d51e31c12bab)(cb);
        (0, $eb610c99fc404582$export$26d3d892edc56833)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $eb610c99fc404582$export$26d3d892edc56833)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            (0, $eb610c99fc404582$export$324d7b4b46528191)("visibilitychange", cb, {
                capture: true
            });
            (0, $eb610c99fc404582$export$324d7b4b46528191)("pagehide", cb, {
                capture: true
            });
        });
    }
};


const $f4f31fce52c7f7e6$export$7f4cb060ded9173c = [
    200,
    500
];
const $f4f31fce52c7f7e6$var$DEFAULT_DURATION_THRESHOLD = 40;
const $f4f31fce52c7f7e6$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) return;
    const visibilityWatcher = (0, $aabf50baf39dd628$export$443f86b2c77012c4)();
    (0, $29e12016032abf49$export$8bdb38a5671b594e)(()=>{
        (0, $e07e7854f951c324$export$67d90cda6b78a2eb)();
        const metric = (0, $e544ef88d12867fc$export$3c29b44508a0612b)("INP");
        let report;
        const interactionManager = (0, $1de665ebcb8f473f$export$7c74c9b2462ddb3c)(opts, (0, $0ea417265e927ba2$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            (0, $f522d837479c7fe8$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $354b46617e9b2d88$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold ?? $f4f31fce52c7f7e6$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $d50f6292060853cb$export$17679dccdd551979)(onReport, metric, $f4f31fce52c7f7e6$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            po.observe({
                type: "first-input",
                buffered: true
            });
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};








class $ff62c3caa8e2f6b4$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
    }
}






const $eea7693a18c2e4f9$export$948521ca5b0e1b17 = [
    2500,
    4e3
];
const $eea7693a18c2e4f9$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $29e12016032abf49$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $aabf50baf39dd628$export$443f86b2c77012c4)();
        const metric = (0, $e544ef88d12867fc$export$3c29b44508a0612b)("LCP");
        let report;
        const lcpEntryManager = (0, $1de665ebcb8f473f$export$7c74c9b2462ddb3c)(opts, (0, $ff62c3caa8e2f6b4$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            if (!opts.reportAllChanges) entries = entries.slice(-1);
            for (const entry of entries){
                lcpEntryManager._processEntry(entry);
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $8fb242506f12dabe$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $354b46617e9b2d88$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $d50f6292060853cb$export$17679dccdd551979)(onReport, metric, $eea7693a18c2e4f9$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $0ae8f6fdfc40e933$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            const stopListeningWrapper = (event)=>{
                if (event.isTrusted) {
                    (0, $f522d837479c7fe8$export$d3314d5863fc1fef)(stopListening);
                    (0, $eb610c99fc404582$export$324d7b4b46528191)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            for (const type of [
                "keydown",
                "click",
                "visibilitychange"
            ])(0, $eb610c99fc404582$export$26d3d892edc56833)(type, stopListeningWrapper, {
                capture: true
            });
        }
    });
};









const $5f91baa83d53b445$export$65c59ea8064668fc = [
    800,
    1800
];
const $5f91baa83d53b445$var$whenReady = (callback)=>{
    if ((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document?.prerendering) (0, $29e12016032abf49$export$8bdb38a5671b594e)(()=>$5f91baa83d53b445$var$whenReady(callback));
    else if ((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document?.readyState !== "complete") addEventListener("load", ()=>$5f91baa83d53b445$var$whenReady(callback), true);
    else setTimeout(callback);
};
const $5f91baa83d53b445$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $e544ef88d12867fc$export$3c29b44508a0612b)("TTFB");
    const report = (0, $d50f6292060853cb$export$17679dccdd551979)(onReport, metric, $5f91baa83d53b445$export$65c59ea8064668fc, opts.reportAllChanges);
    $5f91baa83d53b445$var$whenReady(()=>{
        const navigationEntry = (0, $33f6602c6a93459c$export$6431553786c94949)();
        if (navigationEntry) {
            metric.value = Math.max(navigationEntry.responseStart - (0, $8fb242506f12dabe$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $1449edf82ca167da$var$handlers = {};
const $1449edf82ca167da$var$instrumented = {};
let $1449edf82ca167da$var$_previousCls;
let $1449edf82ca167da$var$_previousLcp;
let $1449edf82ca167da$var$_previousTtfb;
let $1449edf82ca167da$var$_previousInp;
function $1449edf82ca167da$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $1449edf82ca167da$var$addMetricObserver("cls", callback, $1449edf82ca167da$var$instrumentCls, $1449edf82ca167da$var$_previousCls, stopOnCallback);
}
function $1449edf82ca167da$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $1449edf82ca167da$var$addMetricObserver("lcp", callback, $1449edf82ca167da$var$instrumentLcp, $1449edf82ca167da$var$_previousLcp, stopOnCallback);
}
function $1449edf82ca167da$export$699d9529c099a797(callback) {
    return $1449edf82ca167da$var$addMetricObserver("ttfb", callback, $1449edf82ca167da$var$instrumentTtfb, $1449edf82ca167da$var$_previousTtfb);
}
function $1449edf82ca167da$export$da3b76aa2022cbd7(callback) {
    return $1449edf82ca167da$var$addMetricObserver("inp", callback, $1449edf82ca167da$var$instrumentInp, $1449edf82ca167da$var$_previousInp);
}
function $1449edf82ca167da$export$69816c1a049f8db6(type, callback) {
    $1449edf82ca167da$var$addHandler(type, callback);
    if (!$1449edf82ca167da$var$instrumented[type]) {
        $1449edf82ca167da$var$instrumentPerformanceObserver(type);
        $1449edf82ca167da$var$instrumented[type] = true;
    }
    return $1449edf82ca167da$var$getCleanupCallback(type, callback);
}
function $1449edf82ca167da$var$triggerHandlers(type, data) {
    const typeHandlers = $1449edf82ca167da$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $d0c2be10ad9299aa$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $8988df7479b3af76$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}
function $1449edf82ca167da$var$instrumentCls() {
    return (0, $037423963135f95a$export$a7873055838e5ad8)((metric)=>{
        $1449edf82ca167da$var$triggerHandlers("cls", {
            metric: metric
        });
        $1449edf82ca167da$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $1449edf82ca167da$var$instrumentLcp() {
    return (0, $eea7693a18c2e4f9$export$947b1626ab8d5632)((metric)=>{
        $1449edf82ca167da$var$triggerHandlers("lcp", {
            metric: metric
        });
        $1449edf82ca167da$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $1449edf82ca167da$var$instrumentTtfb() {
    return (0, $5f91baa83d53b445$export$33a01e6c5f2c7e33)((metric)=>{
        $1449edf82ca167da$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $1449edf82ca167da$var$_previousTtfb = metric;
    });
}
function $1449edf82ca167da$var$instrumentInp() {
    return (0, $f4f31fce52c7f7e6$export$7df4b36ecaed99e1)((metric)=>{
        $1449edf82ca167da$var$triggerHandlers("inp", {
            metric: metric
        });
        $1449edf82ca167da$var$_previousInp = metric;
    });
}
function $1449edf82ca167da$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $1449edf82ca167da$var$addHandler(type, callback);
    let stopListening;
    if (!$1449edf82ca167da$var$instrumented[type]) {
        stopListening = instrumentFn();
        $1449edf82ca167da$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $1449edf82ca167da$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : void 0);
}
function $1449edf82ca167da$var$instrumentPerformanceObserver(type) {
    const options = {};
    if (type === "event") options.durationThreshold = 0;
    (0, $354b46617e9b2d88$export$d1203567a167490e)(type, (entries)=>{
        $1449edf82ca167da$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $1449edf82ca167da$var$addHandler(type, handler) {
    $1449edf82ca167da$var$handlers[type] = $1449edf82ca167da$var$handlers[type] || [];
    $1449edf82ca167da$var$handlers[type].push(handler);
}
function $1449edf82ca167da$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $1449edf82ca167da$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
function $1449edf82ca167da$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}











function $96ed9f30a92638d3$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $96ed9f30a92638d3$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $96ed9f30a92638d3$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $f679a4ba87c0a16b$export$f5b060c2914b97c8)(value)) return (0, $11febc130f3b1527$export$64da0f40b0f924ba)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}



function $3e1535e5d6df7e72$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}





function $f6286a56bcdbf1ff$var$logIgnoredSpan(droppedSpan) {
    (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $f6286a56bcdbf1ff$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($f6286a56bcdbf1ff$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $3caf4858e68d282c$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && $f6286a56bcdbf1ff$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $3caf4858e68d282c$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $3caf4858e68d282c$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$f6286a56bcdbf1ff$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && $f6286a56bcdbf1ff$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $f6286a56bcdbf1ff$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $3caf4858e68d282c$export$cdded5b28a5f8c6d)(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $f6286a56bcdbf1ff$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $f6286a56bcdbf1ff$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}


function $f0e2713f202b6494$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}








const $357c24d077a33b0f$export$849dbeeeda01ae98 = "production";
const $357c24d077a33b0f$export$6829f580e78306fa = "development";












const $0f9490ef3285da64$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $0f9490ef3285da64$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $8e3165bfbe89a619$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $8e3165bfbe89a619$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
        (0, $c23193fe738c8aae$export$e73679ffaf56810e)(this, $0f9490ef3285da64$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $df43a4967084dd30$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $0f9490ef3285da64$export$61cc547d99783aa7(span) {
    return !!span && span[$0f9490ef3285da64$var$NON_RECORDING_SPAN_FIELD] === true;
}



const $abea3dd41b8b0d86$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $abea3dd41b8b0d86$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $c23193fe738c8aae$export$e73679ffaf56810e)(spanWithMaybeDsc, $abea3dd41b8b0d86$var$FROZEN_DSC_FIELD, dsc);
}
function $abea3dd41b8b0d86$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || (0, $357c24d077a33b0f$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $f86e5540c296bee0$export$b7ac9b8efa4bb595)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $abea3dd41b8b0d86$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $abea3dd41b8b0d86$export$366bad00d6815eed(propagationContext.traceId, client);
}
function $abea3dd41b8b0d86$export$a117f995597e25df(span) {
    const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $df43a4967084dd30$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $df43a4967084dd30$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $1862405160dfc8ac$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $1862405160dfc8ac$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$abea3dd41b8b0d86$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    if ((0, $0f9490ef3285da64$export$61cc547d99783aa7)(rootSpan) && !(0, $3e1535e5d6df7e72$export$1f70765132c3c225)(client.getOptions())) {
        const capturedScope = (0, $9874d7f0a9b0b77c$export$c08fbc656a245d03)(rootSpan).scope;
        if (capturedScope) return applyLocalSampleRateToDsc({
            ...$abea3dd41b8b0d86$export$89ef1736f08c6b2b(client, capturedScope)
        });
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && (0, $c76e826c05d33ccc$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $abea3dd41b8b0d86$export$366bad00d6815eed(span.spanContext().traceId, client);
    const source = rootSpanAttributes[0, $1862405160dfc8ac$export$d7a7d984b0791405] ?? rootSpanAttributes["sentry.span.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ((0, $3e1535e5d6df7e72$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $df43a4967084dd30$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $9874d7f0a9b0b77c$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $abea3dd41b8b0d86$export$95cf936fdacaff7b(span) {
    const dsc = $abea3dd41b8b0d86$export$a117f995597e25df(span);
    return (0, $c76e826c05d33ccc$export$56766feef403f365)(dsc);
}





function $04e3826c4d1fee68$export$2f3d84e767c9592b(span) {
    if (!(0, $8f04fbb427feaa8c$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $df43a4967084dd30$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $df43a4967084dd30$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $df43a4967084dd30$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = (0, $df43a4967084dd30$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $04e3826c4d1fee68$export$b77c830667a4d630(span) {
    if (!(0, $8f04fbb427feaa8c$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $df43a4967084dd30$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $df43a4967084dd30$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(msg);
}






function $99329f8601e86a9f$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    if (!(0, $3e1535e5d6df7e72$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = (0, $42b96f8c46608c69$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === void 0) {
        (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}







function $a4d11cf5ef15c7e5$export$d3f49b33a1f44720(callback) {
    (0, $c23193fe738c8aae$export$e73679ffaf56810e)(callback, "_streamed", true);
    return callback;
}
function $a4d11cf5ef15c7e5$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}








function $4ec61e8ce1d14b13$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $4ec61e8ce1d14b13$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $4ec61e8ce1d14b13$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $4ec61e8ce1d14b13$export$604a45d95a155e2b(envelope, types) {
    return $4ec61e8ce1d14b13$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
function $4ec61e8ce1d14b13$var$encodeUTF8(input) {
    const carrier = (0, $ef23ecc2ba89fe5e$export$c8bfa33e4e8ae492)((0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $4ec61e8ce1d14b13$var$decodeUTF8(input) {
    const carrier = (0, $ef23ecc2ba89fe5e$export$c8bfa33e4e8ae492)((0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $4ec61e8ce1d14b13$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $4ec61e8ce1d14b13$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $4ec61e8ce1d14b13$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify((0, $7041ced124b506ec$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $4ec61e8ce1d14b13$var$concatBuffers(parts);
}
function $4ec61e8ce1d14b13$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $4ec61e8ce1d14b13$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $4ec61e8ce1d14b13$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($4ec61e8ce1d14b13$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $4ec61e8ce1d14b13$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $4ec61e8ce1d14b13$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $4ec61e8ce1d14b13$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $4ec61e8ce1d14b13$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $4ec61e8ce1d14b13$var$_isOverriddenType(type) {
    return type in $4ec61e8ce1d14b13$var$DATA_CATEGORY_OVERRIDES;
}
function $4ec61e8ce1d14b13$export$b11169581eeaf237(type) {
    return $4ec61e8ce1d14b13$var$_isOverriddenType(type) ? $4ec61e8ce1d14b13$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $4ec61e8ce1d14b13$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $4ec61e8ce1d14b13$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date((0, $471396d0ee2af783$export$65b1bada40c91b34)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f86e5540c296bee0$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}





function $f69ce05b28b9b25f$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $f69ce05b28b9b25f$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $4ec61e8ce1d14b13$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date((0, $471396d0ee2af783$export$65b1bada40c91b34)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f86e5540c296bee0$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $4ec61e8ce1d14b13$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
function $f69ce05b28b9b25f$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $4ec61e8ce1d14b13$export$d369f3b2758f6743)(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $f69ce05b28b9b25f$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $4ec61e8ce1d14b13$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $4ec61e8ce1d14b13$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
function $f69ce05b28b9b25f$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = (0, $abea3dd41b8b0d86$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date((0, $471396d0ee2af783$export$65b1bada40c91b34)()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f86e5540c296bee0$export$44d472fbb931a776)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = (0, $df43a4967084dd30$export$92d8c23565496537)(span);
        return !(0, $f6286a56bcdbf1ff$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $df43a4967084dd30$export$92d8c23565496537)(span);
        const processedSpan = !(0, $a4d11cf5ef15c7e5$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $df43a4967084dd30$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $df43a4967084dd30$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $4ec61e8ce1d14b13$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $4ec61e8ce1d14b13$export$f93f7f385160c44e)(headers, items);
}












const $6bdd57941a2df54a$var$MAX_SPAN_COUNT = 1e3;
class $6bdd57941a2df54a$export$a92149b045260d9f {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $8e3165bfbe89a619$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $8e3165bfbe89a619$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $7fd3d32b8c514972$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "manual",
            [(0, $1862405160dfc8ac$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $df43a4967084dd30$export$eb571cd9b5d98de8) : (0, $df43a4967084dd30$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $df43a4967084dd30$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        if (!(0, $9874d7f0a9b0b77c$export$2e69b79005fc86eb)(this)) this.setAttribute((0, $1862405160dfc8ac$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) return;
        this._endTime = (0, $df43a4967084dd30$export$3f7581298f56c6d7)(endTimestamp);
        (0, $04e3826c4d1fee68$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $1862405160dfc8ac$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $df43a4967084dd30$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $1862405160dfc8ac$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $1862405160dfc8ac$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $1862405160dfc8ac$export$fea48ba9f4550879],
            measurements: (0, $19ca9956040f2a7a$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $df43a4967084dd30$export$c4c6a79b1260ca1b)(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? (0, $df43a4967084dd30$export$c4c6a79b1260ca1b)(this).spanContext().spanId : void 0,
            links: (0, $df43a4967084dd30$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, $df43a4967084dd30$export$c4c6a79b1260ca1b)(this),
            status: (0, $df43a4967084dd30$export$d3856a3187d34821)(this._status),
            attributes: (0, $df43a4967084dd30$export$1464a9cb828ba99f)(this._attributes, this._status),
            links: (0, $df43a4967084dd30$export$9015adcf158ef3a5)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log("[Tracing] Adding an event to span:", name);
        const time = $6bdd57941a2df54a$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $7fd3d32b8c514972$export$ee52dced521e3e18)();
        const attributes = $6bdd57941a2df54a$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $df43a4967084dd30$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $df43a4967084dd30$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        if (this._isStandaloneSpan) {
            if (this._sampled) $6bdd57941a2df54a$var$sendSpanEnvelope((0, $f69ce05b28b9b25f$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        } else if (client && (0, $f0e2713f202b6494$export$6ea47215d699c04a)(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $9874d7f0a9b0b77c$export$c08fbc656a245d03)(this).scope || (0, $0f6c045e0dbe9a1e$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        if (!$6bdd57941a2df54a$var$isFullFinishedSpan((0, $df43a4967084dd30$export$92d8c23565496537)(this))) return void 0;
        if (!this._name) {
            (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $9874d7f0a9b0b77c$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        const finishedSpans = (0, $df43a4967084dd30$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$6bdd57941a2df54a$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $df43a4967084dd30$export$92d8c23565496537)(span)).filter($6bdd57941a2df54a$var$isFullFinishedSpan);
        const source = this._attributes[0, $1862405160dfc8ac$export$d7a7d984b0791405];
        delete this._attributes[0, $1862405160dfc8ac$export$165ce9a229f6f050];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[0, $1862405160dfc8ac$export$165ce9a229f6f050];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: (0, $df43a4967084dd30$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $6bdd57941a2df54a$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $6bdd57941a2df54a$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $abea3dd41b8b0d86$export$a117f995597e25df)(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $19ca9956040f2a7a$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $6bdd57941a2df54a$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $6bdd57941a2df54a$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $6bdd57941a2df54a$var$isStandaloneSpan(span) {
    return span instanceof $6bdd57941a2df54a$export$a92149b045260d9f && span.isStandaloneSpan();
}
function $6bdd57941a2df54a$var$sendSpanEnvelope(envelope) {
    const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}




const $29816c6c42c9aa8e$export$61ab4e30f2201736 = "__SENTRY_SUPPRESS_TRACING__";
function $29816c6c42c9aa8e$export$a1bd95187356f372(options, callback) {
    const acs = $29816c6c42c9aa8e$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $29816c6c42c9aa8e$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $0f6c045e0dbe9a1e$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $29816c6c42c9aa8e$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $0f6c045e0dbe9a1e$export$c7be4b0125a10cba)();
            const parentSpan = $29816c6c42c9aa8e$var$getParentSpan(scope, customParentSpan);
            const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $29816c6c42c9aa8e$var$startMissingRequiredParentSpan(scope, client) : $29816c6c42c9aa8e$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$29816c6c42c9aa8e$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $5069cf84161adda7$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $96ed9f30a92638d3$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                const { status: status } = (0, $df43a4967084dd30$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $9ae89fdb2b85f9c1$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $29816c6c42c9aa8e$export$c10292ad04b92aea(options, callback) {
    const acs = $29816c6c42c9aa8e$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $29816c6c42c9aa8e$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $0f6c045e0dbe9a1e$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $29816c6c42c9aa8e$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $0f6c045e0dbe9a1e$export$c7be4b0125a10cba)();
            const parentSpan = $29816c6c42c9aa8e$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $29816c6c42c9aa8e$var$startMissingRequiredParentSpan(scope, (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)()) : $29816c6c42c9aa8e$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$29816c6c42c9aa8e$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $5069cf84161adda7$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $96ed9f30a92638d3$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = (0, $df43a4967084dd30$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $9ae89fdb2b85f9c1$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
function $29816c6c42c9aa8e$export$63dbba021a6b4047(options) {
    const acs = $29816c6c42c9aa8e$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $29816c6c42c9aa8e$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>(0, $0f6c045e0dbe9a1e$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$29816c6c42c9aa8e$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $0f6c045e0dbe9a1e$export$c7be4b0125a10cba)();
        const parentSpan = $29816c6c42c9aa8e$var$getParentSpan(scope, customParentSpan);
        const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $29816c6c42c9aa8e$var$startMissingRequiredParentSpan(scope, client);
        return $29816c6c42c9aa8e$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $29816c6c42c9aa8e$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $ef23ecc2ba89fe5e$export$19eade501500c6c1)();
    const acs = (0, $8848f3a74c4e0a42$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $c76e826c05d33ccc$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $22176dd1fe3ca274$export$18811bc99eefceaa)(client, incomingDsc?.org_id)) return $29816c6c42c9aa8e$export$f90b03291402f553(callback);
    return (0, $0f6c045e0dbe9a1e$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $22176dd1fe3ca274$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $5069cf84161adda7$export$3f25fa50c18e20ca)(scope, void 0);
        return callback();
    });
};
function $29816c6c42c9aa8e$export$e57ac09b143d92a2(span, callback) {
    const acs = $29816c6c42c9aa8e$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $0f6c045e0dbe9a1e$export$ec58d9285c204497)((scope)=>{
        (0, $5069cf84161adda7$export$3f25fa50c18e20ca)(scope, span || void 0);
        return callback(scope);
    });
}
function $29816c6c42c9aa8e$export$869298f9835abc68(callback) {
    const acs = $29816c6c42c9aa8e$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $0f6c045e0dbe9a1e$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$29816c6c42c9aa8e$export$61ab4e30f2201736]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$29816c6c42c9aa8e$export$61ab4e30f2201736]: void 0
        });
        return res;
    });
}
function $29816c6c42c9aa8e$export$7d5f2376f7cf513(scope = (0, $0f6c045e0dbe9a1e$export$c7be4b0125a10cba)()) {
    const acs = $29816c6c42c9aa8e$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$29816c6c42c9aa8e$export$61ab4e30f2201736] === true;
}
function $29816c6c42c9aa8e$export$f90b03291402f553(callback) {
    const acs = $29816c6c42c9aa8e$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $0f6c045e0dbe9a1e$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $8e3165bfbe89a619$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $471396d0ee2af783$export$9869d72de32a3917)()
        });
        (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $29816c6c42c9aa8e$export$e57ac09b143d92a2(null, callback);
    });
}
function $29816c6c42c9aa8e$var$startMissingRequiredParentSpan(scope, client) {
    client?.recordDroppedEvent("no_parent_span", "span");
    const span = new (0, $0f9490ef3285da64$export$d6636b700b76c516)({
        traceId: scope.getPropagationContext().traceId
    });
    (0, $9874d7f0a9b0b77c$export$cddb4027e3b0dd66)(span, scope, (0, $0f6c045e0dbe9a1e$export$68f3af03034c9e90)());
    return span;
}
function $29816c6c42c9aa8e$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = (0, $0f6c045e0dbe9a1e$export$68f3af03034c9e90)();
    if (!(0, $3e1535e5d6df7e72$export$1f70765132c3c225)()) {
        const scopePropagationContext = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new (0, $0f9490ef3285da64$export$d6636b700b76c516)({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) (0, $df43a4967084dd30$export$81397d924722cc65)(parentSpan, span2);
        (0, $9874d7f0a9b0b77c$export$cddb4027e3b0dd66)(span2, scope, isolationScope);
        return span2;
    }
    const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
    if ($29816c6c42c9aa8e$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$29816c6c42c9aa8e$export$7d5f2376f7cf513(scope)) client?.recordDroppedEvent("ignored", "span");
        const ignoredSpan = new (0, $0f9490ef3285da64$export$d6636b700b76c516)({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
        (0, $9874d7f0a9b0b77c$export$cddb4027e3b0dd66)(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $29816c6c42c9aa8e$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        (0, $df43a4967084dd30$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        const dsc = (0, $abea3dd41b8b0d86$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $df43a4967084dd30$export$5caecac1caaf3a71)(parentSpan);
        span = $29816c6c42c9aa8e$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        (0, $abea3dd41b8b0d86$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $29816c6c42c9aa8e$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        if (dsc) (0, $abea3dd41b8b0d86$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $04e3826c4d1fee68$export$2f3d84e767c9592b)(span);
    return span;
}
function $29816c6c42c9aa8e$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $df43a4967084dd30$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $29816c6c42c9aa8e$var$getAcs() {
    const carrier = (0, $ef23ecc2ba89fe5e$export$19eade501500c6c1)();
    return (0, $8848f3a74c4e0a42$export$f639b0c2752203be)(carrier);
}
function $29816c6c42c9aa8e$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const _isTracingSuppressed = $29816c6c42c9aa8e$export$7d5f2376f7cf513(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [
        false
    ] : (0, $99329f8601e86a9f$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: (0, $42b96f8c46608c69$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $6bdd57941a2df54a$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $1862405160dfc8ac$export$d7a7d984b0791405)]: "custom",
            [(0, $1862405160dfc8ac$export$ccfe0a40627cc34b)]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !_isTracingSuppressed) {
        (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", (0, $f0e2713f202b6494$export$6ea47215d699c04a)(client) ? "span" : "transaction");
    }
    (0, $9874d7f0a9b0b77c$export$cddb4027e3b0dd66)(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $29816c6c42c9aa8e$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const _isTracingSuppressed = $29816c6c42c9aa8e$export$7d5f2376f7cf513(scope);
    const sampled = _isTracingSuppressed ? false : (0, $df43a4967084dd30$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $6bdd57941a2df54a$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $0f9490ef3285da64$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $df43a4967084dd30$export$81397d924722cc65)(parentSpan, childSpan);
    (0, $9874d7f0a9b0b77c$export$cddb4027e3b0dd66)(childSpan, scope, isolationScope);
    const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $f0e2713f202b6494$export$6ea47215d699c04a)(client) && (0, $0f9490ef3285da64$export$61cc547d99783aa7)(childSpan)) {
        if ((0, $0f9490ef3285da64$export$61cc547d99783aa7)(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $29816c6c42c9aa8e$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = (0, $5069cf84161adda7$export$91f063ebb8eff307)(scope);
    if (!span) return void 0;
    const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $df43a4967084dd30$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $29816c6c42c9aa8e$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $29816c6c42c9aa8e$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}
function $29816c6c42c9aa8e$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !(0, $f0e2713f202b6494$export$6ea47215d699c04a)(client) || !ignoreSpans?.length) return false;
    return (0, $f6286a56bcdbf1ff$export$5d569ac97c389400)({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[0, $1862405160dfc8ac$export$1a413bd9a88fdb09] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $29816c6c42c9aa8e$var$_isIgnoredSpan(span) {
    return (0, $0f9490ef3285da64$export$61cc547d99783aa7)(span) && span.dropReason === "ignored";
}





const $69b2f43c3ef5b1ce$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb(event);
    };
    (0, $eb610c99fc404582$export$26d3d892edc56833)("visibilitychange", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
    (0, $eb610c99fc404582$export$26d3d892edc56833)("pagehide", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
};


function $ad434fe292fc323a$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
function $ad434fe292fc323a$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $df43a4967084dd30$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    return (0, $29816c6c42c9aa8e$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $29816c6c42c9aa8e$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
function $ad434fe292fc323a$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    const { userInfo: userInfo } = client.getDataCollectionOptions();
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId();
    const scope = (0, $0f6c045e0dbe9a1e$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== void 0 ? user.email || user.id || user.ip_address : void 0;
    let profileId;
    try {
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {}
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || void 0,
        profile_id: profileId || void 0,
        replay_id: replayId || void 0,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        "client.address": userInfo ? "{{auto}}" : void 0,
        ...passedAttributes
    };
    return (0, $29816c6c42c9aa8e$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
function $ad434fe292fc323a$export$f72a13c439a30cab() {
    return (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).addEventListener && (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).performance;
}
function $ad434fe292fc323a$export$b4785dbd4a81b33f(time) {
    return time / 1e3;
}
function $ad434fe292fc323a$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) name = _name;
    return {
        name: name,
        version: version
    };
}
function $ad434fe292fc323a$export$c7533a7b4a9f2e94(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch  {
        return false;
    }
}
function $ad434fe292fc323a$export$382ad360b45665ab(client, collectorCallback) {
    let pageloadSpan;
    let collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpan) collectorCallback(event, pageloadSpan.spanContext().spanId, pageloadSpan);
        collected = true;
    }
    (0, $69b2f43c3ef5b1ce$export$91ec2be6fdd8f1b4)(()=>{
        _runCollectorCallbackOnce("pagehide");
    });
    const unsubscribeStartNavigation = client.on("beforeStartNavigationSpan", (_, options)=>{
        if (!options?.isRedirect) {
            _runCollectorCallbackOnce("navigation");
            unsubscribeStartNavigation();
            unsubscribeAfterStartPageLoadSpan();
        }
    });
    const unsubscribeAfterStartPageLoadSpan = client.on("afterStartPageLoadSpan", (span)=>{
        pageloadSpan = span;
        unsubscribeAfterStartPageLoadSpan();
    });
}


function $2252367e15d93a97$export$585bab03c6c18c45(client) {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    if (!(0, $ad434fe292fc323a$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $1449edf82ca167da$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, $ad434fe292fc323a$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $2252367e15d93a97$export$910bd4e865129f07(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
function $2252367e15d93a97$export$910bd4e865129f07(clsValue, entry, pageloadSpanId, reportEvent) {
    (0, $d0c2be10ad9299aa$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(((0, $7fd3d32b8c514972$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $7fd3d32b8c514972$export$ee52dced521e3e18)();
    const routeName = (0, $0f6c045e0dbe9a1e$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $5e6d95e419314f14$export$5647df6b7814ac86)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {
        [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "auto.http.browser.cls",
        [(0, $1862405160dfc8ac$export$1a413bd9a88fdb09)]: "ui.webvital.cls",
        [(0, $1862405160dfc8ac$export$fea48ba9f4550879)]: 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`cls.source.${index + 1}`] = (0, $5e6d95e419314f14$export$5647df6b7814ac86)(source.node);
    });
    const span = (0, $ad434fe292fc323a$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("cls", {
            [(0, $1862405160dfc8ac$export$f5f95cff026507b5)]: "",
            [(0, $1862405160dfc8ac$export$69cd5c610c7bb96a)]: clsValue
        });
        span.end(startTime);
    }
}








const $dd06a7be1492d124$export$ccce4d286bdc973b = 6e4;
function $dd06a7be1492d124$export$e59775b7d17699ba(lcpValue) {
    return lcpValue != null && lcpValue > 0 && lcpValue <= $dd06a7be1492d124$export$ccce4d286bdc973b;
}
function $dd06a7be1492d124$export$485112b2cb5f79dc(client) {
    let standaloneLcpValue = 0;
    let standaloneLcpEntry;
    if (!(0, $ad434fe292fc323a$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $1449edf82ca167da$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !$dd06a7be1492d124$export$e59775b7d17699ba(metric.value)) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, $ad434fe292fc323a$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $dd06a7be1492d124$export$1c28dab7ad4ec937(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
function $dd06a7be1492d124$export$1c28dab7ad4ec937(lcpValue, entry, pageloadSpanId, reportEvent) {
    if (!$dd06a7be1492d124$export$e59775b7d17699ba(lcpValue)) return;
    (0, $d0c2be10ad9299aa$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const startTime = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(((0, $7fd3d32b8c514972$export$baf075a948ffc0bf)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $0f6c045e0dbe9a1e$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $5e6d95e419314f14$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    const attributes = {
        [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "auto.http.browser.lcp",
        [(0, $1862405160dfc8ac$export$1a413bd9a88fdb09)]: "ui.webvital.lcp",
        [(0, $1862405160dfc8ac$export$fea48ba9f4550879)]: 0,
        // LCP is a point-in-time metric
        // attach the pageload span id to the LCP span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry) {
        entry.element && (attributes["lcp.element"] = (0, $5e6d95e419314f14$export$5647df6b7814ac86)(entry.element));
        entry.id && (attributes["lcp.id"] = entry.id);
        entry.url && (attributes["lcp.url"] = entry.url);
        entry.loadTime != null && (attributes["lcp.loadTime"] = entry.loadTime);
        entry.renderTime != null && (attributes["lcp.renderTime"] = entry.renderTime);
        entry.size != null && (attributes["lcp.size"] = entry.size);
    }
    const span = (0, $ad434fe292fc323a$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("lcp", {
            [(0, $1862405160dfc8ac$export$f5f95cff026507b5)]: "millisecond",
            [(0, $1862405160dfc8ac$export$69cd5c610c7bb96a)]: lcpValue
        });
        span.end(startTime);
    }
}




function $c202b31065218a3f$var$getAbsoluteTime(time) {
    return time ? (((0, $7fd3d32b8c514972$export$baf075a948ffc0bf)() || performance.timeOrigin) + time) / 1e3 : time;
}
function $c202b31065218a3f$export$ec50b091612e7e00(resourceTiming) {
    const timingSpanData = {};
    if (resourceTiming.nextHopProtocol != void 0) {
        const { name: name, version: version } = (0, $ad434fe292fc323a$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
        timingSpanData["network.protocol.version"] = version;
        timingSpanData["network.protocol.name"] = name;
    }
    if (!((0, $7fd3d32b8c514972$export$baf075a948ffc0bf)() || (0, $ad434fe292fc323a$export$f72a13c439a30cab)()?.timeOrigin)) return timingSpanData;
    return $c202b31065218a3f$var$dropUndefinedKeysFromObject({
        ...timingSpanData,
        "http.request.redirect_start": $c202b31065218a3f$var$getAbsoluteTime(resourceTiming.redirectStart),
        "http.request.redirect_end": $c202b31065218a3f$var$getAbsoluteTime(resourceTiming.redirectEnd),
        "http.request.worker_start": $c202b31065218a3f$var$getAbsoluteTime(resourceTiming.workerStart),
        "http.request.fetch_start": $c202b31065218a3f$var$getAbsoluteTime(resourceTiming.fetchStart),
        "http.request.domain_lookup_start": $c202b31065218a3f$var$getAbsoluteTime(resourceTiming.domainLookupStart),
        "http.request.domain_lookup_end": $c202b31065218a3f$var$getAbsoluteTime(resourceTiming.domainLookupEnd),
        "http.request.connect_start": $c202b31065218a3f$var$getAbsoluteTime(resourceTiming.connectStart),
        "http.request.secure_connection_start": $c202b31065218a3f$var$getAbsoluteTime(resourceTiming.secureConnectionStart),
        "http.request.connection_end": $c202b31065218a3f$var$getAbsoluteTime(resourceTiming.connectEnd),
        "http.request.request_start": $c202b31065218a3f$var$getAbsoluteTime(resourceTiming.requestStart),
        "http.request.response_start": $c202b31065218a3f$var$getAbsoluteTime(resourceTiming.responseStart),
        "http.request.response_end": $c202b31065218a3f$var$getAbsoluteTime(resourceTiming.responseEnd),
        // For TTFB we actually want the relative time from timeOrigin to responseStart
        // This way, TTFB always measures the "first page load" experience.
        // see: https://web.dev/articles/ttfb#measure-resource-requests
        "http.request.time_to_first_byte": resourceTiming.responseStart != null ? resourceTiming.responseStart / 1e3 : void 0
    });
}
function $c202b31065218a3f$var$dropUndefinedKeysFromObject(attrs) {
    return Object.fromEntries(Object.entries(attrs).filter(([, value])=>value != null));
}







const $92deb0c4826a806b$var$MAX_INT_AS_BYTES = 2147483647;
let $92deb0c4826a806b$var$_performanceCursor = 0;
let $92deb0c4826a806b$var$_measurements = {};
let $92deb0c4826a806b$var$_lcpEntry;
let $92deb0c4826a806b$var$_clsEntry;
function $92deb0c4826a806b$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans, recordLcpStandaloneSpans: recordLcpStandaloneSpans, client: client }) {
    const performance = (0, $ad434fe292fc323a$export$f72a13c439a30cab)();
    if (performance && (0, $7fd3d32b8c514972$export$baf075a948ffc0bf)()) {
        if (performance.mark) (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const lcpCleanupCallback = recordLcpStandaloneSpans ? (0, $dd06a7be1492d124$export$485112b2cb5f79dc)(client) : recordLcpStandaloneSpans === false ? $92deb0c4826a806b$var$_trackLCP() : void 0;
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $2252367e15d93a97$export$585bab03c6c18c45)(client) : recordClsStandaloneSpans === false ? $92deb0c4826a806b$var$_trackCLS() : void 0;
        const ttfbCleanupCallback = $92deb0c4826a806b$var$_trackTtfb();
        const fpFcpCleanupCallback = $92deb0c4826a806b$var$_trackFpFcp();
        return ()=>{
            ttfbCleanupCallback();
            fpFcpCleanupCallback();
            lcpCleanupCallback?.();
            clsCleanupCallback?.();
        };
    }
    return ()=>void 0;
}
function $92deb0c4826a806b$export$f396d19077034ad2() {
    (0, $1449edf82ca167da$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        const parent = (0, $df43a4967084dd30$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $df43a4967084dd30$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)((0, $7fd3d32b8c514972$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $ad434fe292fc323a$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-task",
                attributes: {
                    [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
        }
    });
}
function $92deb0c4826a806b$export$5b823ab2ccbc801d() {
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $df43a4967084dd30$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)((0, $7fd3d32b8c514972$export$baf075a948ffc0bf)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $df43a4967084dd30$export$92d8c23565496537)(parent);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            (0, $ad434fe292fc323a$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
function $92deb0c4826a806b$export$e27543e0976315e4() {
    (0, $1449edf82ca167da$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        const parent = (0, $df43a4967084dd30$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)((0, $7fd3d32b8c514972$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $5e6d95e419314f14$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $2a58bfa7403ced33$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            (0, $ad434fe292fc323a$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
function $92deb0c4826a806b$var$_trackCLS() {
    return (0, $1449edf82ca167da$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $92deb0c4826a806b$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $92deb0c4826a806b$var$_clsEntry = entry;
    }, true);
}
function $92deb0c4826a806b$var$_trackLCP() {
    return (0, $1449edf82ca167da$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $dd06a7be1492d124$export$e59775b7d17699ba)(metric.value)) return;
        $92deb0c4826a806b$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $92deb0c4826a806b$var$_lcpEntry = entry;
    }, true);
}
function $92deb0c4826a806b$var$_trackTtfb() {
    return (0, $1449edf82ca167da$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $92deb0c4826a806b$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
function $92deb0c4826a806b$var$_trackFpFcp() {
    return (0, $1449edf82ca167da$export$69816c1a049f8db6)("paint", ({ entries: entries })=>{
        const firstHidden = (0, $aabf50baf39dd628$export$443f86b2c77012c4)();
        for (const entry of entries){
            const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
            if (entry.name === "first-paint" && shouldRecord) $92deb0c4826a806b$var$_measurements["fp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
            if (entry.name === "first-contentful-paint" && shouldRecord) $92deb0c4826a806b$var$_measurements["fcp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
        }
    });
}
function $92deb0c4826a806b$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $ad434fe292fc323a$export$f72a13c439a30cab)();
    const origin = (0, $7fd3d32b8c514972$export$baf075a948ffc0bf)();
    if (!performance?.getEntries || !origin) return;
    const { spanStreamingEnabled: spanStreamingEnabled, ignorePerformanceApiSpans: ignorePerformanceApiSpans, ignoreResourceSpans: ignoreResourceSpans } = options;
    const timeOrigin = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $df43a4967084dd30$export$92d8c23565496537)(span);
    performanceEntries.slice($92deb0c4826a806b$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $92deb0c4826a806b$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                $92deb0c4826a806b$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans);
                break;
            case "resource":
                $92deb0c4826a806b$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, ignoreResourceSpans);
                break;
        }
    });
    $92deb0c4826a806b$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $92deb0c4826a806b$var$_trackNavigator(span, spanStreamingEnabled);
}
function $92deb0c4826a806b$export$d14e394b690acc17(span, options) {
    const origin = (0, $7fd3d32b8c514972$export$baf075a948ffc0bf)();
    if (!(0, $ad434fe292fc323a$export$f72a13c439a30cab)()?.getEntries || !origin) {
        $92deb0c4826a806b$var$resetWebVitalState();
        return;
    }
    const { spanStreamingEnabled: spanStreamingEnabled, recordClsOnPageloadSpan: recordClsOnPageloadSpan, recordLcpOnPageloadSpan: recordLcpOnPageloadSpan } = options;
    const timeOrigin = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(origin);
    if ((0, $df43a4967084dd30$export$92d8c23565496537)(span).op === "pageload") {
        $92deb0c4826a806b$var$_addTtfbRequestTimeToMeasurements($92deb0c4826a806b$var$_measurements);
        if (spanStreamingEnabled) {
            const setAttr = (shortWebVitalName, value, customAttrName)=>{
                const attrKey = customAttrName ?? `browser.web_vital.${shortWebVitalName}.value`;
                span.setAttribute(attrKey, value);
                (0, $d0c2be10ad9299aa$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log("Setting web vital attribute", {
                    [attrKey]: value
                }, "on pageload span");
            };
            [
                "ttfb",
                "fp",
                "fcp"
            ].forEach((measurementName)=>{
                if ($92deb0c4826a806b$var$_measurements[measurementName]) setAttr(measurementName, $92deb0c4826a806b$var$_measurements[measurementName].value);
            });
            if ($92deb0c4826a806b$var$_measurements["ttfb.requestTime"]) setAttr("ttfb.requestTime", $92deb0c4826a806b$var$_measurements["ttfb.requestTime"].value, "browser.web_vital.ttfb.request_time");
        } else {
            if (!recordClsOnPageloadSpan) delete $92deb0c4826a806b$var$_measurements.cls;
            if (!recordLcpOnPageloadSpan) delete $92deb0c4826a806b$var$_measurements.lcp;
            Object.entries($92deb0c4826a806b$var$_measurements).forEach(([measurementName, measurement])=>{
                (0, $19ca9956040f2a7a$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit, span);
            });
            $92deb0c4826a806b$var$_setWebVitalAttributes(span, options);
        }
        span.setAttribute(spanStreamingEnabled ? "browser.performance.time_origin" : "performance.timeOrigin", timeOrigin);
        span.setAttribute(spanStreamingEnabled ? "browser.performance.navigation.activation_start" : "performance.activationStart", (0, $8fb242506f12dabe$export$d3e828b3c7b5b845)());
    }
    $92deb0c4826a806b$var$resetWebVitalState();
}
function $92deb0c4826a806b$var$resetWebVitalState() {
    $92deb0c4826a806b$var$_lcpEntry = void 0;
    $92deb0c4826a806b$var$_clsEntry = void 0;
    $92deb0c4826a806b$var$_measurements = {};
}
function $92deb0c4826a806b$var$isReact19MeasureEntry(entry) {
    if (entry?.entryType !== "measure") return;
    try {
        return entry.detail.devtools.track === "Components \u269B";
    } catch  {
        return;
    }
}
function $92deb0c4826a806b$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ($92deb0c4826a806b$var$isReact19MeasureEntry(entry)) return;
    if ([
        "mark",
        "measure"
    ].includes(entry.entryType) && (0, $3caf4858e68d282c$export$a7a5ec66062ea5d)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $33f6602c6a93459c$export$6431553786c94949)(false);
    const requestTime = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    $92deb0c4826a806b$var$_addDetailToSpanAttributes(attributes, entry);
    if (measureStartTimestamp <= measureEndTimestamp) (0, $ad434fe292fc323a$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $92deb0c4826a806b$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        const detail = performanceMeasure.detail;
        if (!detail) return;
        if (typeof detail === "object") {
            for (const [key, value] of Object.entries(detail)){
                if (value && (0, $f679a4ba87c0a16b$export$c3825b437cbdea5c)(value)) attributes[`sentry.browser.measure.detail.${key}`] = value;
                else if (value !== void 0) try {
                    attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
                } catch  {}
            }
            return;
        }
        if ((0, $f679a4ba87c0a16b$export$c3825b437cbdea5c)(detail)) {
            attributes["sentry.browser.measure.detail"] = detail;
            return;
        }
        try {
            attributes["sentry.browser.measure.detail"] = JSON.stringify(detail);
        } catch  {}
    } catch  {}
}
function $92deb0c4826a806b$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $92deb0c4826a806b$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $92deb0c4826a806b$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
    $92deb0c4826a806b$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
    $92deb0c4826a806b$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $92deb0c4826a806b$var$_addRequest(span, entry, timeOrigin);
}
function $92deb0c4826a806b$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $92deb0c4826a806b$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $ad434fe292fc323a$export$7567a67bdb69a23d)(span, timeOrigin + (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics",
            ...event === "redirect" && entry.redirectCount != null ? {
                "http.redirect_count": entry.redirectCount
            } : {}
        }
    });
}
function $92deb0c4826a806b$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === "secureConnection") return "connectEnd";
    if (event === "fetch") return "domainLookupStart";
    return `${event}End`;
}
function $92deb0c4826a806b$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        (0, $ad434fe292fc323a$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: {
                [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
        (0, $ad434fe292fc323a$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: {
                [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
    }
}
function $92deb0c4826a806b$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other";
    if (ignoredResourceSpanOps?.includes(op)) return;
    const attributes = {
        [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    const parsedUrl = (0, $94f1796ac223aa5a$export$7a5253c0f62e0150)(resourceUrl);
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop();
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).location.origin);
    attributes[0, $1862405160dfc8ac$export$25dfd73e0e32c6e1] = resourceUrl;
    $92deb0c4826a806b$export$6ce741ceee01ab2f(entry, attributes, [
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
        [
            "responseStatus",
            "http.response.status_code"
        ],
        [
            "transferSize",
            "http.response_transfer_size"
        ],
        [
            "encodedBodySize",
            "http.response_content_length"
        ],
        [
            "decodedBodySize",
            "http.decoded_response_content_length"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
        [
            "renderBlockingStatus",
            "resource.render_blocking_status"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
        [
            "deliveryType",
            "http.response_delivery_type"
        ]
    ]);
    const attributesWithResourceTiming = {
        ...attributes,
        ...(0, $c202b31065218a3f$export$ec50b091612e7e00)(entry)
    };
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $ad434fe292fc323a$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).location.origin, ""),
        op: op,
        attributes: attributesWithResourceTiming
    });
}
function $92deb0c4826a806b$var$_trackNavigator(span, spanStreamingEnabled) {
    const navigator = (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute(spanStreamingEnabled ? "network.connection.effective_type" : "effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute(spanStreamingEnabled ? "network.connection.type" : "connectionType", connection.type);
        if ((0, $ad434fe292fc323a$export$27169ccae1b439e3)(connection.rtt)) {
            if (spanStreamingEnabled) span.setAttribute("network.connection.rtt", connection.rtt);
            else if ((0, $df43a4967084dd30$export$92d8c23565496537)(span).op === "pageload") (0, $19ca9956040f2a7a$export$7cc31b475d33a706)("connection.rtt", connection.rtt, "millisecond");
        }
    }
    if ((0, $ad434fe292fc323a$export$27169ccae1b439e3)(navigator.deviceMemory)) {
        if (spanStreamingEnabled) span.setAttribute("device.memory.estimated_capacity", navigator.deviceMemory);
        else span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    }
    if ((0, $ad434fe292fc323a$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) {
        if (spanStreamingEnabled) span.setAttribute("device.processor_count", navigator.hardwareConcurrency);
        else span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
    }
}
function $92deb0c4826a806b$var$_setWebVitalAttributes(span, options) {
    if ($92deb0c4826a806b$var$_lcpEntry && options.recordLcpOnPageloadSpan) {
        if ($92deb0c4826a806b$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $5e6d95e419314f14$export$5647df6b7814ac86)($92deb0c4826a806b$var$_lcpEntry.element));
        if ($92deb0c4826a806b$var$_lcpEntry.id) span.setAttribute("lcp.id", $92deb0c4826a806b$var$_lcpEntry.id);
        if ($92deb0c4826a806b$var$_lcpEntry.url) span.setAttribute("lcp.url", $92deb0c4826a806b$var$_lcpEntry.url.trim().slice(0, 200));
        if ($92deb0c4826a806b$var$_lcpEntry.loadTime != null) span.setAttribute("lcp.loadTime", $92deb0c4826a806b$var$_lcpEntry.loadTime);
        if ($92deb0c4826a806b$var$_lcpEntry.renderTime != null) span.setAttribute("lcp.renderTime", $92deb0c4826a806b$var$_lcpEntry.renderTime);
        span.setAttribute("lcp.size", $92deb0c4826a806b$var$_lcpEntry.size);
    }
    if ($92deb0c4826a806b$var$_clsEntry?.sources && options.recordClsOnPageloadSpan) $92deb0c4826a806b$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $5e6d95e419314f14$export$5647df6b7814ac86)(source.node)));
}
function $92deb0c4826a806b$export$6ce741ceee01ab2f(entry, attributes, properties) {
    properties.forEach(([entryKey, attributeKey])=>{
        const entryVal = entry[entryKey];
        if (entryVal != null && (typeof entryVal === "number" && entryVal < $92deb0c4826a806b$var$MAX_INT_AS_BYTES || typeof entryVal === "string")) attributes[attributeKey] = entryVal;
    });
}
function $92deb0c4826a806b$var$_addTtfbRequestTimeToMeasurements(_measurements2) {
    const navEntry = (0, $33f6602c6a93459c$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements2["ttfb.requestTime"] = {
        value: responseStart - requestStart,
        unit: "millisecond"
    };
}


const $35bf7e39ff9440e2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $53aee3b1e0ad0f44$export$56d8a8a25bd48b81 = (0, $9409895355f874f2$exports.GLOBAL_OBJ);
let $53aee3b1e0ad0f44$var$ignoreOnError = 0;
function $53aee3b1e0ad0f44$export$b79738ab10c590b2() {
    return $53aee3b1e0ad0f44$var$ignoreOnError > 0;
}
function $53aee3b1e0ad0f44$export$1265a142ff5ba165() {
    $53aee3b1e0ad0f44$var$ignoreOnError++;
    setTimeout(()=>{
        $53aee3b1e0ad0f44$var$ignoreOnError--;
    });
}
function $53aee3b1e0ad0f44$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            const wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $9409895355f874f2$exports.getOriginalFunction)(fn)) return fn;
    } catch  {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $9409895355f874f2$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $9409895355f874f2$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$53aee3b1e0ad0f44$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $53aee3b1e0ad0f44$export$1265a142ff5ba165();
            (0, $9409895355f874f2$exports.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $9409895355f874f2$exports.addExceptionTypeValue)(event, void 0, void 0);
                        (0, $9409895355f874f2$exports.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $9409895355f874f2$exports.captureException)(ex);
            });
            throw ex;
        } finally{
            (0, $9409895355f874f2$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $9409895355f874f2$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {}
    (0, $9409895355f874f2$exports.markFunctionWrapped)(sentryWrapped, fn);
    (0, $9409895355f874f2$exports.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {}
    return sentryWrapped;
}
function $53aee3b1e0ad0f44$export$a3c4a8453e8936f0() {
    const url = (0, $9409895355f874f2$exports.getLocationHref)();
    const { referrer: referrer } = $53aee3b1e0ad0f44$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $53aee3b1e0ad0f44$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}









function $e8c3a70b551d8630$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = (0, $3cffafffc6e2c7bd$export$a4e09611e30da72e)(type, handler);
    (0, $3cffafffc6e2c7bd$export$e18d6c5462c01368)(type, ()=>$e8c3a70b551d8630$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $e8c3a70b551d8630$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = (0, $3cffafffc6e2c7bd$export$a4e09611e30da72e)(type, handler);
    (0, $3cffafffc6e2c7bd$export$e18d6c5462c01368)(type, ()=>$e8c3a70b551d8630$var$instrumentFetch($e8c3a70b551d8630$var$streamHandler));
    return removeHandler;
}
function $e8c3a70b551d8630$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $5d3204b815cde265$export$c82d238e23c40b21)()) return;
    (0, $c23193fe738c8aae$export$9563e054e6f787fb)((0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $e8c3a70b551d8630$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $7fd3d32b8c514972$export$ee52dced521e3e18)() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $e8c3a70b551d8630$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) (0, $3cffafffc6e2c7bd$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            return originalFetch.apply((0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $3cffafffc6e2c7bd$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $7fd3d32b8c514972$export$ee52dced521e3e18)() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $3cffafffc6e2c7bd$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $7fd3d32b8c514972$export$ee52dced521e3e18)() * 1e3,
                    error: error
                });
                if ((0, $f679a4ba87c0a16b$export$e6127cc7fe7395c3)(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    (0, $c23193fe738c8aae$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else (0, $c23193fe738c8aae$export$e73679ffaf56810e)(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $e8c3a70b551d8630$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $e8c3a70b551d8630$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $e8c3a70b551d8630$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $3cffafffc6e2c7bd$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $7fd3d32b8c514972$export$ee52dced521e3e18)() * 1e3,
            response: response
        });
    });
}
function $e8c3a70b551d8630$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $e8c3a70b551d8630$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($e8c3a70b551d8630$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $e8c3a70b551d8630$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $e8c3a70b551d8630$var$getUrlFromResource(resource),
            method: $e8c3a70b551d8630$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            (0, $f679a4ba87c0a16b$export$6d3d1f317d7cda57)(resource) && $e8c3a70b551d8630$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $e8c3a70b551d8630$var$getUrlFromResource(arg),
        method: $e8c3a70b551d8630$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $e8c3a70b551d8630$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $f679a4ba87c0a16b$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}




const $49bad331543abbdb$export$b14a8888f80a0b3e = [];
function $49bad331543abbdb$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $49bad331543abbdb$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $49bad331543abbdb$var$filterDuplicates(integrations);
}
function $49bad331543abbdb$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $49bad331543abbdb$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $49bad331543abbdb$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $49bad331543abbdb$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$49bad331543abbdb$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $49bad331543abbdb$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
function $49bad331543abbdb$export$2d8f5188773bcddd(integration) {
    const client = (0, $0f6c045e0dbe9a1e$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $8f04fbb427feaa8c$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $49bad331543abbdb$export$2323046b9414659f(fn) {
    return fn;
}
function $49bad331543abbdb$export$92d0786473d2c0a1(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}


const $994f36905db521c3$var$responseToStreamSpan = /* @__PURE__ */ new WeakMap();
const $994f36905db521c3$var$responseToFallbackTimeout = /* @__PURE__ */ new WeakMap();
const $994f36905db521c3$var$STREAM_RESOLVE_FALLBACK_MS = 9e4;
const $994f36905db521c3$var$STREAMING_CONTENT_TYPES = [
    "text/event-stream",
    "application/x-ndjson",
    "application/stream+json"
];
const $994f36905db521c3$export$b49e0d1a48dc8754 = (0, $49bad331543abbdb$export$2323046b9414659f)(()=>{
    return {
        name: "FetchStreamPerformance",
        setup () {
            (0, $e8c3a70b551d8630$export$1a79663eb318fe6a)((handlerData)=>{
                if (handlerData.response) {
                    const streamSpan = $994f36905db521c3$var$responseToStreamSpan.get(handlerData.response);
                    if (streamSpan && handlerData.endTimestamp) {
                        streamSpan.end(handlerData.endTimestamp);
                        const fallbackTimeout = $994f36905db521c3$var$responseToFallbackTimeout.get(handlerData.response);
                        if (fallbackTimeout) clearTimeout(fallbackTimeout);
                    }
                }
            });
            (0, $e8c3a70b551d8630$export$f75d3c772c923df0)((handlerData)=>{
                if (handlerData.endTimestamp && handlerData.response) {
                    const contentType = handlerData.response.headers?.get("content-type") || "";
                    if (handlerData.response.headers?.get("content-length") || !$994f36905db521c3$var$STREAMING_CONTENT_TYPES.some((t)=>contentType.startsWith(t))) return;
                    const url = handlerData.fetchData?.url || "";
                    const method = handlerData.fetchData?.method || "GET";
                    const parsedUrl = (0, $94f1796ac223aa5a$export$2004d912a9ead694)(url);
                    const sanitizedUrl = url.startsWith("data:") ? (0, $94f1796ac223aa5a$export$8abd806fcaf234fa)(url) : parsedUrl ? (0, $94f1796ac223aa5a$export$5339fcdc8e2a427c)(parsedUrl) : url;
                    const streamSpan = (0, $29816c6c42c9aa8e$export$63dbba021a6b4047)({
                        name: `${method} ${sanitizedUrl}`,
                        startTime: handlerData.endTimestamp,
                        attributes: {
                            url: (0, $94f1796ac223aa5a$export$8abd806fcaf234fa)(url),
                            "http.method": method,
                            type: "fetch",
                            [(0, $1862405160dfc8ac$export$1a413bd9a88fdb09)]: "http.client.stream",
                            [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "auto.http.browser.stream"
                        }
                    });
                    $994f36905db521c3$var$responseToStreamSpan.set(handlerData.response, streamSpan);
                    const fallbackTimeout = setTimeout(()=>{
                        if (streamSpan.isRecording()) streamSpan.end();
                    }, $994f36905db521c3$var$STREAM_RESOLVE_FALLBACK_MS);
                    $994f36905db521c3$var$responseToFallbackTimeout.set(handlerData.response, fallbackTimeout);
                }
            });
        }
    };
});




var $kGgTb = parcelRequire("kGgTb");

function $d0f44c43f09b3f54$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" && (!(0, $kGgTb.isNodeEnv)() || $d0f44c43f09b3f54$var$isElectronNodeRenderer());
}
function $d0f44c43f09b3f54$var$isElectronNodeRenderer() {
    const process = (0, $83d83aff34c1a47f$export$f1a6cdb1459e81d1).process;
    return process?.type === "renderer";
}






const $1233a31d72349d15$var$LAST_INTERACTIONS = [];
const $1233a31d72349d15$var$INTERACTIONS_SPAN_MAP = /* @__PURE__ */ new Map();
const $1233a31d72349d15$var$ELEMENT_NAME_TIMESTAMP_MAP = /* @__PURE__ */ new Map();
const $1233a31d72349d15$export$619786413bcce1e1 = 60;
function $1233a31d72349d15$export$f17d06681a4744a3() {
    const performance = (0, $ad434fe292fc323a$export$f72a13c439a30cab)();
    if (performance && (0, $7fd3d32b8c514972$export$baf075a948ffc0bf)()) {
        const inpCallback = $1233a31d72349d15$export$eeab203db0ed99a9();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>void 0;
}
const $1233a31d72349d15$export$7cd941f925ded42f = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
function $1233a31d72349d15$export$eeab203db0ed99a9() {
    return (0, $1449edf82ca167da$export$da3b76aa2022cbd7)($1233a31d72349d15$export$7bcb98fe01441521);
}
const $1233a31d72349d15$export$7bcb98fe01441521 = ({ metric: metric })=>{
    if (metric.value == void 0) return;
    const duration = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(metric.value);
    if (duration > $1233a31d72349d15$export$619786413bcce1e1) return;
    const entry = metric.entries.find((entry2)=>entry2.duration === metric.value && $1233a31d72349d15$export$7cd941f925ded42f[entry2.name]);
    if (!entry) return;
    const { interactionId: interactionId } = entry;
    const interactionType = $1233a31d72349d15$export$7cd941f925ded42f[entry.name];
    const startTime = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)((0, $7fd3d32b8c514972$export$baf075a948ffc0bf)() + entry.startTime);
    const activeSpan = (0, $df43a4967084dd30$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $df43a4967084dd30$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const cachedInteractionContext = interactionId != null ? $1233a31d72349d15$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
    const spanToUse = cachedInteractionContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $df43a4967084dd30$export$92d8c23565496537)(spanToUse).description : (0, $0f6c045e0dbe9a1e$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedInteractionContext?.elementName || (0, $5e6d95e419314f14$export$5647df6b7814ac86)(entry.target);
    const attributes = {
        [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: "auto.http.browser.inp",
        [(0, $1862405160dfc8ac$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
        [(0, $1862405160dfc8ac$export$fea48ba9f4550879)]: entry.duration
    };
    const span = (0, $ad434fe292fc323a$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("inp", {
            [(0, $1862405160dfc8ac$export$f5f95cff026507b5)]: "millisecond",
            [(0, $1862405160dfc8ac$export$69cd5c610c7bb96a)]: metric.value
        });
        span.end(startTime + duration);
    }
};
function $1233a31d72349d15$export$e4a670d077ebcfef(interactionId) {
    return interactionId != null ? $1233a31d72349d15$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
}
function $1233a31d72349d15$export$e4e04d43e223cce2() {
    const interactionEvents = Object.keys($1233a31d72349d15$export$7cd941f925ded42f);
    if ((0, $d0f44c43f09b3f54$export$4e09c449d6c407f7)()) interactionEvents.forEach((eventType)=>{
        (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).addEventListener(eventType, captureElementFromEvent, {
            capture: true,
            passive: true
        });
    });
    function captureElementFromEvent(event) {
        const target = event.target;
        if (!target) return;
        const elementName = (0, $5e6d95e419314f14$export$5647df6b7814ac86)(target);
        const timestamp = Math.round(event.timeStamp);
        $1233a31d72349d15$var$ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
        if ($1233a31d72349d15$var$ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
            const firstKey = $1233a31d72349d15$var$ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
            if (firstKey !== void 0) $1233a31d72349d15$var$ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
        }
    }
    function resolveElementNameFromEntry(entry) {
        const timestamp = Math.round(entry.startTime);
        let elementName = $1233a31d72349d15$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
        if (!elementName) for(let offset = -5; offset <= 5; offset++){
            const nearbyName = $1233a31d72349d15$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
            if (nearbyName) {
                elementName = nearbyName;
                break;
            }
        }
        return elementName || "<unknown>";
    }
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $df43a4967084dd30$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $df43a4967084dd30$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $1449edf82ca167da$export$7affb50b622d8714)(entry)) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            if ($1233a31d72349d15$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            const elementName = entry.target ? (0, $5e6d95e419314f14$export$5647df6b7814ac86)(entry.target) : resolveElementNameFromEntry(entry);
            if ($1233a31d72349d15$var$LAST_INTERACTIONS.length > 10) {
                const last = $1233a31d72349d15$var$LAST_INTERACTIONS.shift();
                $1233a31d72349d15$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            $1233a31d72349d15$var$LAST_INTERACTIONS.push(interactionId);
            $1233a31d72349d15$var$INTERACTIONS_SPAN_MAP.set(interactionId, {
                span: activeRootSpan,
                elementName: elementName
            });
        });
    };
    (0, $1449edf82ca167da$export$69816c1a049f8db6)("event", handleEntries);
    (0, $1449edf82ca167da$export$69816c1a049f8db6)("first-input", handleEntries);
}









function $6e89357d986ee982$export$f4adb23e57c1dac6(options) {
    const { name: name, op: op, origin: origin, metricName: metricName, value: value, attributes: passedAttributes, parentSpan: parentSpan, reportEvent: reportEvent, startTime: startTime, endTime: endTime } = options;
    const routeName = (0, $0f6c045e0dbe9a1e$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const attributes = {
        [(0, $1862405160dfc8ac$export$cca8dd30f57f805e)]: origin,
        [(0, $1862405160dfc8ac$export$1a413bd9a88fdb09)]: op,
        [(0, $1862405160dfc8ac$export$fea48ba9f4550879)]: 0,
        [`browser.web_vital.${metricName}.value`]: value,
        "sentry.transaction": routeName,
        // Web vital score calculation relies on the user agent
        "user_agent.original": (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).navigator?.userAgent,
        ...passedAttributes
    };
    if (parentSpan && (0, $df43a4967084dd30$export$db0cad9e44f67af8)(parentSpan).attributes?.[0, $1862405160dfc8ac$export$1a413bd9a88fdb09] === "pageload") attributes["sentry.pageload.span_id"] = parentSpan.spanContext().spanId;
    if (reportEvent) attributes[`browser.web_vital.${metricName}.report_event`] = reportEvent;
    const span = (0, $29816c6c42c9aa8e$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        parentSpan: // if we have a pageload span, we let the web vital span start as its parent. This ensures that
        // it is not started as a segment span, without having to manually set it to a "standalone" v2 span
        // that has `segment: false` but no actual parent span.
        parentSpan
    });
    if (span) span.end(endTime ?? startTime);
}
function $6e89357d986ee982$export$73747c030e2325c0(client) {
    let lcpValue = 0;
    let lcpEntry;
    if (!(0, $ad434fe292fc323a$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $1449edf82ca167da$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $dd06a7be1492d124$export$e59775b7d17699ba)(metric.value)) return;
        lcpValue = metric.value;
        lcpEntry = entry;
    }, true);
    (0, $ad434fe292fc323a$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $6e89357d986ee982$export$1adcb85d073cd594(lcpValue, lcpEntry, pageloadSpan, reportEvent);
        cleanupLcpHandler();
    });
}
function $6e89357d986ee982$export$1adcb85d073cd594(lcpValue, entry, pageloadSpan, reportEvent) {
    if (!(0, $dd06a7be1492d124$export$e59775b7d17699ba)(lcpValue)) return;
    (0, $d0c2be10ad9299aa$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const performanceTimeOrigin = (0, $7fd3d32b8c514972$export$baf075a948ffc0bf)() || 0;
    const timeOrigin = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(performanceTimeOrigin);
    const endTime = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(performanceTimeOrigin + (entry?.startTime || 0));
    const name = entry ? (0, $5e6d95e419314f14$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    const attributes = {};
    entry?.element && (attributes["browser.web_vital.lcp.element"] = (0, $5e6d95e419314f14$export$5647df6b7814ac86)(entry.element));
    entry?.id && (attributes["browser.web_vital.lcp.id"] = entry.id);
    entry?.url && (attributes["browser.web_vital.lcp.url"] = entry.url);
    entry?.loadTime != null && (attributes["browser.web_vital.lcp.load_time"] = entry.loadTime);
    entry?.renderTime != null && (attributes["browser.web_vital.lcp.render_time"] = entry.renderTime);
    entry?.size != null && (attributes["browser.web_vital.lcp.size"] = entry.size);
    $6e89357d986ee982$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.lcp",
        origin: "auto.http.browser.lcp",
        metricName: "lcp",
        value: lcpValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: timeOrigin,
        endTime: endTime
    });
}
function $6e89357d986ee982$export$f2ca9ed704743eb2(client) {
    let clsValue = 0;
    let clsEntry;
    if (!(0, $ad434fe292fc323a$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $1449edf82ca167da$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        clsValue = metric.value;
        clsEntry = entry;
    }, true);
    (0, $ad434fe292fc323a$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $6e89357d986ee982$export$736c846d4f7aff83(clsValue, clsEntry, pageloadSpan, reportEvent);
        cleanupClsHandler();
    });
}
function $6e89357d986ee982$export$736c846d4f7aff83(clsValue, entry, pageloadSpan, reportEvent) {
    (0, $d0c2be10ad9299aa$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(((0, $7fd3d32b8c514972$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $7fd3d32b8c514972$export$ee52dced521e3e18)();
    const name = entry ? (0, $5e6d95e419314f14$export$5647df6b7814ac86)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {};
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`browser.web_vital.cls.source.${index + 1}`] = (0, $5e6d95e419314f14$export$5647df6b7814ac86)(source.node);
    });
    $6e89357d986ee982$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.cls",
        origin: "auto.http.browser.cls",
        metricName: "cls",
        value: clsValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: startTime
    });
}
function $6e89357d986ee982$export$4a8cbc644515d57b() {
    const performance = (0, $ad434fe292fc323a$export$f72a13c439a30cab)();
    if (!performance || !(0, $7fd3d32b8c514972$export$baf075a948ffc0bf)()) return;
    const onInp = ({ metric: metric })=>{
        if (metric.value == null) return;
        const duration = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(metric.value);
        if (duration > (0, $1233a31d72349d15$export$619786413bcce1e1)) return;
        const entry = metric.entries.find((e)=>e.duration === metric.value && (0, $1233a31d72349d15$export$7cd941f925ded42f)[e.name]);
        if (!entry) return;
        $6e89357d986ee982$export$bd315e549441b68a(metric.value, entry);
    };
    (0, $1449edf82ca167da$export$da3b76aa2022cbd7)(onInp);
}
function $6e89357d986ee982$export$bd315e549441b68a(inpValue, entry) {
    (0, $d0c2be10ad9299aa$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).log(`Sending INP span (${inpValue})`);
    const startTime = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)((0, $7fd3d32b8c514972$export$baf075a948ffc0bf)() + entry.startTime);
    const duration = (0, $ad434fe292fc323a$export$b4785dbd4a81b33f)(inpValue);
    const interactionType = (0, $1233a31d72349d15$export$7cd941f925ded42f)[entry.name];
    const cachedContext = (0, $1233a31d72349d15$export$e4a670d077ebcfef)(entry.interactionId);
    const activeSpan = (0, $df43a4967084dd30$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $df43a4967084dd30$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const spanToUse = cachedContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $df43a4967084dd30$export$db0cad9e44f67af8)(spanToUse).name : (0, $0f6c045e0dbe9a1e$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedContext?.elementName || (0, $5e6d95e419314f14$export$5647df6b7814ac86)(entry.target);
    $6e89357d986ee982$export$f4adb23e57c1dac6({
        name: name,
        op: `ui.interaction.${interactionType}`,
        origin: "auto.http.browser.inp",
        metricName: "inp",
        value: inpValue,
        attributes: {
            [(0, $1862405160dfc8ac$export$fea48ba9f4550879)]: entry.duration,
            "sentry.transaction": routeName
        },
        startTime: startTime,
        endTime: startTime + duration,
        parentSpan: spanToUse
    });
}


const $fb7c652f29fd39d3$export$8748555bacc7091c = "WebVitals";
const $fb7c652f29fd39d3$export$1ab4995602e8adaa = (0, $9409895355f874f2$exports.defineIntegration)((options = {})=>{
    const ignored = new Set(options.ignore ?? []);
    return {
        name: $fb7c652f29fd39d3$export$8748555bacc7091c,
        setup (client) {
            const spanStreamingEnabled = (0, $9409895355f874f2$exports.hasSpanStreamingEnabled)(client);
            const { enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans } = options._experiments ?? {};
            const recordClsStandaloneSpans = spanStreamingEnabled || ignored.has("cls") ? void 0 : enableStandaloneClsSpans || false;
            const recordLcpStandaloneSpans = spanStreamingEnabled || ignored.has("lcp") ? void 0 : enableStandaloneLcpSpans || false;
            const finalizeWebVitals = (0, $92deb0c4826a806b$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: recordClsStandaloneSpans,
                recordLcpStandaloneSpans: recordLcpStandaloneSpans,
                client: client
            });
            const pageloadSpans = /* @__PURE__ */ new WeakSet();
            client.on("afterStartPageLoadSpan", (span)=>{
                pageloadSpans.add(span);
            });
            client.on("spanEnd", (span)=>{
                if (!pageloadSpans.delete(span)) return;
                finalizeWebVitals();
                (0, $92deb0c4826a806b$export$d14e394b690acc17)(span, {
                    // CLS/LCP are recorded as pageload span measurements only when they're neither
                    // tracked as standalone spans nor handled by span streaming (and not ignored).
                    recordClsOnPageloadSpan: recordClsStandaloneSpans === false,
                    recordLcpOnPageloadSpan: recordLcpStandaloneSpans === false,
                    spanStreamingEnabled: spanStreamingEnabled
                });
            });
            if (spanStreamingEnabled) {
                if (!ignored.has("lcp")) (0, $6e89357d986ee982$export$73747c030e2325c0)(client);
                if (!ignored.has("cls")) (0, $6e89357d986ee982$export$f2ca9ed704743eb2)(client);
                if (!ignored.has("inp")) (0, $6e89357d986ee982$export$4a8cbc644515d57b)();
            } else if (!ignored.has("inp")) (0, $1233a31d72349d15$export$f17d06681a4744a3)();
        },
        afterAllSetup () {
            if (!ignored.has("inp")) (0, $1233a31d72349d15$export$e4e04d43e223cce2)();
        }
    };
});





function $c3eb9c7b0aad709b$export$6f18f55521af71a1() {
    if ((0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).document) (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $9409895355f874f2$exports.getActiveSpan)();
        if (!activeSpan) return;
        const rootSpan = (0, $9409895355f874f2$exports.getRootSpan)(activeSpan);
        if ((0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $9409895355f874f2$exports.spanToJSON)(rootSpan);
            if (0, $35bf7e39ff9440e2$export$16a28057038b10ef) (0, $9409895355f874f2$exports.debug).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            if (!status) rootSpan.setStatus({
                code: (0, $9409895355f874f2$exports.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $35bf7e39ff9440e2$export$16a28057038b10ef) && (0, $9409895355f874f2$exports.debug).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}














const $e773850256c2e990$export$c8d616af96ac729f = 3600;
const $e773850256c2e990$export$16b6aa13b3c0f075 = "sentry_previous_trace";
const $e773850256c2e990$export$237518aee8726f02 = "sentry.previous_trace";
function $e773850256c2e990$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === "session-storage";
    let inMemoryPreviousTraceInfo = useSessionStorage ? $e773850256c2e990$export$ef546bba8a402d99() : void 0;
    client.on("spanStart", (span)=>{
        if ((0, $9409895355f874f2$exports.getRootSpan)(span) !== span) return;
        const oldPropagationContext = (0, $9409895355f874f2$exports.getCurrentScope)().getPropagationContext();
        inMemoryPreviousTraceInfo = $e773850256c2e990$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $e773850256c2e990$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) client.on("beforeSampling", (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $9409895355f874f2$exports.getCurrentScope)();
        const currentPropagationContext = scope.getPropagationContext();
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext({
            ...currentPropagationContext,
            dsc: {
                ...currentPropagationContext.dsc,
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($e773850256c2e990$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            },
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        });
        mutableSamplingContextData.parentSampled = $e773850256c2e990$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = {
            ...mutableSamplingContextData.spanAttributes,
            [(0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE)]: inMemoryPreviousTraceInfo.sampleRate
        };
    });
}
function $e773850256c2e990$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $9409895355f874f2$exports.spanToJSON)(span);
    function getSampleRate() {
        try {
            const oldSampleRate = Number(spanJson.data?.[0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? oldPropagationContext.dsc?.sample_rate);
            return Number.isNaN(oldSampleRate) ? 0 : oldSampleRate;
        } catch  {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) return previousTraceInfo;
    if (Date.now() / 1e3 - previousTraceInfo.startTimestamp <= $e773850256c2e990$export$c8d616af96ac729f) {
        if (0, $35bf7e39ff9440e2$export$16a28057038b10ef) (0, $9409895355f874f2$exports.debug).log(`Adding previous_trace \`${JSON.stringify(previousTraceSpanCtx)}\` link to span \`${JSON.stringify({
            op: spanJson.op,
            ...span.spanContext()
        })}\``);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $9409895355f874f2$exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE)]: "previous_trace"
            }
        });
        span.setAttribute($e773850256c2e990$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$e773850256c2e990$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
function $e773850256c2e990$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).sessionStorage.setItem($e773850256c2e990$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        (0, $35bf7e39ff9440e2$export$16a28057038b10ef) && (0, $9409895355f874f2$exports.debug).warn("Could not store previous trace in sessionStorage", e);
    }
}
function $e773850256c2e990$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).sessionStorage?.getItem($e773850256c2e990$export$16b6aa13b3c0f075);
        return JSON.parse(previousTraceInfo);
    } catch  {
        return void 0;
    }
}
function $e773850256c2e990$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 1;
}





const $74592dea4a298c94$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $74592dea4a298c94$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $3cffafffc6e2c7bd$export$a4e09611e30da72e)(type, handler);
    (0, $3cffafffc6e2c7bd$export$e18d6c5462c01368)(type, $74592dea4a298c94$export$c67d533bf77cbf54);
}
function $74592dea4a298c94$export$c67d533bf77cbf54() {
    if (!(0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            const virtualError = new Error();
            const startTimestamp = (0, $7fd3d32b8c514972$export$ee52dced521e3e18)() * 1e3;
            const method = (0, $f679a4ba87c0a16b$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $74592dea4a298c94$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$74592dea4a298c94$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$74592dea4a298c94$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {}
                    const handlerData = {
                        endTimestamp: (0, $7fd3d32b8c514972$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $3cffafffc6e2c7bd$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$74592dea4a298c94$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $f679a4ba87c0a16b$export$844ec244b1367d54)(header) && (0, $f679a4ba87c0a16b$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$74592dea4a298c94$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $7fd3d32b8c514972$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $3cffafffc6e2c7bd$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $74592dea4a298c94$var$parseXhrUrlArg(url) {
    if ((0, $f679a4ba87c0a16b$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch  {}
    return void 0;
}



const $e146e3c24c844b54$export$363d064b9116000e = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
function $e146e3c24c844b54$export$2f1b0f57f243f270(formData) {
    return new URLSearchParams(formData).toString();
}
function $e146e3c24c844b54$export$945a2d5364608d5(body, _debug = (0, $9e6aad2ab33fde86$export$1c9f709888824e05)) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $e146e3c24c844b54$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        (0, $d0c2be10ad9299aa$export$16a28057038b10ef) && _debug.error(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    (0, $d0c2be10ad9299aa$export$16a28057038b10ef) && _debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $e146e3c24c844b54$export$ad44edf8012ec314(fetchArgs = []) {
    if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === "object" && "body" in fetchArgs[1]) return fetchArgs[1].body;
    if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
        const request = fetchArgs[0];
        const originalBody = request[$e146e3c24c844b54$export$363d064b9116000e];
        if (originalBody !== void 0) return originalBody;
        return void 0;
    }
    return void 0;
}
function $e146e3c24c844b54$export$ce71c337afb62ea(xhr) {
    let headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $d0c2be10ad9299aa$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).error(error, "Failed to get xhr response headers", xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}



function $c922f428989600af$export$8193ac587e359dc0(baggageHeader) {
    return baggageHeader.split(",").some((value)=>value.trim().startsWith("sentry-"));
}
function $c922f428989600af$export$f2a087db7564c909(url) {
    try {
        const parsed = new URL(url, (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch  {
        return void 0;
    }
}
function $c922f428989600af$export$5803eedf1027ce61(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
function $c922f428989600af$export$9dc5b8b2fb320da0(headers) {
    try {
        return new Headers(headers);
    } catch  {
        return void 0;
    }
}


const $1bd3fa3e643a28e3$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
function $1bd3fa3e643a28e3$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$1bd3fa3e643a28e3$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$1bd3fa3e643a28e3$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    const propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) (0, $9409895355f874f2$exports.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, $9409895355f874f2$exports.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
            propagateTraceparent: propagateTraceparent,
            onRequestSpanEnd: onRequestSpanEnd
        });
        if (createdSpan) {
            const fullUrl = (0, $c922f428989600af$export$f2a087db7564c909)(handlerData.fetchData.url);
            const host = fullUrl ? (0, $9409895355f874f2$exports.parseUrl)(fullUrl).host : void 0;
            const sanitizedFullUrl = fullUrl ? (0, $9409895355f874f2$exports.stripDataUrlContent)(fullUrl) : void 0;
            createdSpan.setAttributes({
                "http.url": sanitizedFullUrl,
                // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
                // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
                "url.full": sanitizedFullUrl,
                "server.address": host
            });
            if (enableHTTPTimings) $1bd3fa3e643a28e3$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: handlerData.headers
            });
        }
    });
    if (traceXHR) (0, $74592dea4a298c94$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $1bd3fa3e643a28e3$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent, onRequestSpanEnd);
        if (createdSpan) {
            if (enableHTTPTimings) $1bd3fa3e643a28e3$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: (0, $c922f428989600af$export$9dc5b8b2fb320da0)(handlerData.xhr.__sentry_xhr_v3__?.request_headers)
            });
        }
    });
}
const $1bd3fa3e643a28e3$var$HTTP_TIMING_WAIT_MS = 300;
function $1bd3fa3e643a28e3$var$addHTTPTimings(span, client) {
    const { url: url } = (0, $9409895355f874f2$exports.spanToJSON)(span).data;
    if (!url || typeof url !== "string") return;
    let onEntryFound = ()=>void setTimeout(unsubscribePerformanceObsever);
    if ((0, $9409895355f874f2$exports.hasSpanStreamingEnabled)(client)) {
        const originalEnd = span.end.bind(span);
        span.end = (endTimestamp)=>{
            const capturedEndTimestamp = endTimestamp ?? (0, $9409895355f874f2$exports.timestampInSeconds)();
            let isEnded = false;
            const endSpanAndCleanup = ()=>{
                if (isEnded) return;
                isEnded = true;
                setTimeout(unsubscribePerformanceObsever);
                originalEnd(capturedEndTimestamp);
                clearTimeout(fallbackTimeout);
            };
            onEntryFound = endSpanAndCleanup;
            const fallbackTimeout = setTimeout(endSpanAndCleanup, $1bd3fa3e643a28e3$var$HTTP_TIMING_WAIT_MS);
        };
    }
    const unsubscribePerformanceObsever = (0, $1449edf82ca167da$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ((0, $c922f428989600af$export$5803eedf1027ce61)(entry) && entry.name.endsWith(url)) {
                span.setAttributes((0, $c202b31065218a3f$export$ec50b091612e7e00)(entry));
                onEntryFound();
            }
        });
    });
}
function $1bd3fa3e643a28e3$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    const href = (0, $9409895355f874f2$exports.getLocationHref)();
    if (!href) {
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $9409895355f874f2$exports.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch  {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $9409895355f874f2$exports.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $9409895355f874f2$exports.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
function $1bd3fa3e643a28e3$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders2, spans, propagateTraceparent, onRequestSpanEnd) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $74592dea4a298c94$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return void 0;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $9409895355f874f2$exports.hasSpansEnabled)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult && sentryXhrData.status_code !== void 0) {
                (0, $9409895355f874f2$exports.setHttpStatus)(span2, sentryXhrData.status_code);
                span2.end();
                onRequestSpanEnd?.(span2, {
                    headers: (0, $c922f428989600af$export$9dc5b8b2fb320da0)((0, $e146e3c24c844b54$export$ce71c337afb62ea)(xhr)),
                    error: handlerData.error
                });
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const fullUrl = (0, $c922f428989600af$export$f2a087db7564c909)(url);
    const parsedUrl = fullUrl ? (0, $9409895355f874f2$exports.parseUrl)(fullUrl) : (0, $9409895355f874f2$exports.parseUrl)(url);
    const sanitizedFullUrl = fullUrl ? (0, $9409895355f874f2$exports.stripDataUrlContent)(fullUrl) : void 0;
    const urlForSpanName = (0, $9409895355f874f2$exports.stripDataUrlContent)((0, $9409895355f874f2$exports.stripUrlQueryAndFragment)(url));
    const client = (0, $9409895355f874f2$exports.getClient)();
    const hasParent = !!(0, $9409895355f874f2$exports.getActiveSpan)();
    const shouldEmitSpan = hasParent || !!client && (0, $9409895355f874f2$exports.hasSpanStreamingEnabled)(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? (0, $9409895355f874f2$exports.startInactiveSpan)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: (0, $9409895355f874f2$exports.stripDataUrlContent)(url),
            type: "xhr",
            "http.method": method,
            "http.url": sanitizedFullUrl,
            // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
            // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
            "url.full": sanitizedFullUrl,
            "server.address": parsedUrl?.host,
            [(0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser",
            [(0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "http.client",
            ...parsedUrl?.search && {
                "http.query": parsedUrl?.search
            },
            ...parsedUrl?.hash && {
                "http.fragment": parsedUrl?.hash
            }
        }
    }) : new (0, $9409895355f874f2$exports.SentryNonRecordingSpan)();
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders2(url)) $1bd3fa3e643a28e3$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $9409895355f874f2$exports.hasSpansEnabled)() && shouldEmitSpan ? span : void 0, propagateTraceparent);
    if (client) client.emit("beforeOutgoingRequestSpan", span, handlerData);
    return span;
}
function $1bd3fa3e643a28e3$var$addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    const { "sentry-trace": sentryTrace, baggage: baggage, traceparent: traceparent } = (0, $9409895355f874f2$exports.getTraceData)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    if (sentryTrace) $1bd3fa3e643a28e3$var$setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function $1bd3fa3e643a28e3$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
    if (originalHeaders?.["sentry-trace"] || !xhr.setRequestHeader) return;
    try {
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (traceparentHeader && !originalHeaders?.["traceparent"]) xhr.setRequestHeader("traceparent", traceparentHeader);
        if (sentryBaggageHeader) {
            const originalBaggageHeader = originalHeaders?.["baggage"];
            if (!originalBaggageHeader || !(0, $c922f428989600af$export$8193ac587e359dc0)(originalBaggageHeader)) xhr.setRequestHeader("baggage", sentryBaggageHeader);
        }
    } catch  {}
}


const $dbc03a1d427b8584$export$bbd2089f30bd3708 = "BrowserTracing";
const $dbc03a1d427b8584$var$BOT_USER_AGENT_RE = /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i;
function $dbc03a1d427b8584$export$e189d11d152c4191() {
    const nav = (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).navigator;
    if (!nav?.userAgent) return false;
    return $dbc03a1d427b8584$var$BOT_USER_AGENT_RE.test(nav.userAgent);
}
const $dbc03a1d427b8584$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $9409895355f874f2$exports.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: "in-memory",
    consistentTraceSampling: false,
    enableReportPageLoaded: false,
    _experiments: {},
    ...(0, $1bd3fa3e643a28e3$export$cc17fb3c0bc95cd7)
};
const $dbc03a1d427b8584$export$b4109253475213e9 = (options = {})=>{
    if ("enableElementTiming" in options) (0, $9409895355f874f2$exports.consoleSandbox)(()=>{
        console.warn("[Sentry] `enableElementTiming` is deprecated and no longer has any effect. Use the standalone `elementTimingIntegration` instead.");
    });
    const latestRoute = {
        name: void 0,
        source: void 0
    };
    const optionalWindowDocument = (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).document;
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: // eslint-disable-next-line typescript/no-deprecated
    trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, detectRedirects: detectRedirects, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, enableReportPageLoaded: enableReportPageLoaded, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$dbc03a1d427b8584$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ...options
    };
    const _isBot = $dbc03a1d427b8584$export$e189d11d152c4191();
    let lastInteractionTimestamp;
    let _pageloadSpan;
    function _createRouteSpan(client, startSpanOptions, makeActive = true) {
        const isPageloadSpan = startSpanOptions.op === "pageload";
        const initialSpanName = startSpanOptions.name;
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        if (initialSpanName !== finalStartSpanOptions.name) {
            attributes[0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "custom";
            finalStartSpanOptions.attributes = attributes;
        }
        if (!makeActive) {
            const now = (0, $9409895355f874f2$exports.dateTimestampInSeconds)();
            (0, $9409895355f874f2$exports.startInactiveSpan)({
                ...finalStartSpanOptions,
                startTime: now
            }).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        const idleSpan = (0, $9409895355f874f2$exports.startIdleSpan)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadSpan,
            beforeSpanEnd: (span)=>{
                (0, $92deb0c4826a806b$export$5f8fa6b3467a7443)(span, {
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans,
                    spanStreamingEnabled: (0, $9409895355f874f2$exports.hasSpanStreamingEnabled)(client)
                });
                $dbc03a1d427b8584$var$setActiveIdleSpan(client, void 0);
                const scope = (0, $9409895355f874f2$exports.getCurrentScope)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $9409895355f874f2$exports.spanIsSampled)(idleSpan),
                    dsc: (0, $9409895355f874f2$exports.getDynamicSamplingContextFromSpan)(span)
                });
                if (isPageloadSpan) _pageloadSpan = void 0;
            },
            trimIdleSpanEndTimestamp: !enableReportPageLoaded
        });
        if (isPageloadSpan && enableReportPageLoaded) _pageloadSpan = idleSpan;
        $dbc03a1d427b8584$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                "interactive",
                "complete"
            ].includes(optionalWindowDocument.readyState)) {
                client.emit("idleSpanEnableAutoFinish", idleSpan);
                optionalWindowDocument.removeEventListener("readystatechange", emitFinish);
            }
        }
        if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
            optionalWindowDocument.addEventListener("readystatechange", emitFinish);
            emitFinish();
        }
    }
    return {
        name: $dbc03a1d427b8584$export$bbd2089f30bd3708,
        setup (client) {
            if (_isBot) {
                (0, $35bf7e39ff9440e2$export$16a28057038b10ef) && (0, $9409895355f874f2$exports.debug).log("[Tracing] Skipping browserTracingIntegration setup for bot user agent.");
                return;
            }
            (0, $9409895355f874f2$exports.registerSpanErrorInstrumentation)();
            if (enableLongAnimationFrame && (0, $9409895355f874f2$exports.GLOBAL_OBJ).PerformanceObserver && PerformanceObserver.supportedEntryTypes?.includes("long-animation-frame")) (0, $92deb0c4826a806b$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $92deb0c4826a806b$export$f396d19077034ad2)();
            if (enableInteractions) (0, $92deb0c4826a806b$export$e27543e0976315e4)();
            if (detectRedirects && optionalWindowDocument) {
                const interactionHandler = ()=>{
                    lastInteractionTimestamp = (0, $9409895355f874f2$exports.timestampInSeconds)();
                };
                addEventListener("click", interactionHandler, {
                    capture: true
                });
                addEventListener("keydown", interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                const activeSpan = $dbc03a1d427b8584$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $9409895355f874f2$exports.spanToJSON)(activeSpan).timestamp) {
                    (0, $35bf7e39ff9440e2$export$16a28057038b10ef) && (0, $9409895355f874f2$exports.debug).log(`[Tracing] Finishing current active span with op: ${(0, $9409895355f874f2$exports.spanToJSON)(activeSpan).op}`);
                    activeSpan.setAttribute((0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "cancelled");
                    activeSpan.end();
                }
            }
            client.on("startNavigationSpan", (startSpanOptions, navigationOptions)=>{
                if ((0, $9409895355f874f2$exports.getClient)() !== client) return;
                if (navigationOptions?.isRedirect) {
                    (0, $35bf7e39ff9440e2$export$16a28057038b10ef) && (0, $9409895355f874f2$exports.debug).warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span.");
                    _createRouteSpan(client, {
                        op: "navigation.redirect",
                        ...startSpanOptions
                    }, false);
                    return;
                }
                lastInteractionTimestamp = void 0;
                maybeEndActiveSpan();
                (0, $9409895355f874f2$exports.getIsolationScope)().setPropagationContext({
                    traceId: (0, $9409895355f874f2$exports.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $9409895355f874f2$exports.hasSpansEnabled)() ? void 0 : (0, $9409895355f874f2$exports.generateSpanId)()
                });
                const scope = (0, $9409895355f874f2$exports.getCurrentScope)();
                scope.setPropagationContext({
                    traceId: (0, $9409895355f874f2$exports.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $9409895355f874f2$exports.hasSpansEnabled)() ? void 0 : (0, $9409895355f874f2$exports.generateSpanId)()
                });
                scope.setSDKProcessingMetadata({
                    normalizedRequest: void 0
                });
                _createRouteSpan(client, {
                    op: "navigation",
                    ...startSpanOptions,
                    // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
                    parentSpan: null,
                    forceTransaction: true
                });
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $9409895355f874f2$exports.getClient)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $dbc03a1d427b8584$export$f147b32b03c9cf11("sentry-trace") || $dbc03a1d427b8584$export$5bb9693b37f7c2ae("sentry-trace");
                const baggage = traceOptions.baggage || $dbc03a1d427b8584$export$f147b32b03c9cf11("baggage") || $dbc03a1d427b8584$export$5bb9693b37f7c2ae("baggage");
                const propagationContext = (0, $9409895355f874f2$exports.propagationContextFromHeaders)(sentryTrace, baggage);
                const scope = (0, $9409895355f874f2$exports.getCurrentScope)();
                scope.setPropagationContext(propagationContext);
                if (!(0, $9409895355f874f2$exports.hasSpansEnabled)()) scope.getPropagationContext().propagationSpanId = (0, $9409895355f874f2$exports.generateSpanId)();
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $53aee3b1e0ad0f44$export$a3c4a8453e8936f0)()
                });
                _createRouteSpan(client, {
                    op: "pageload",
                    ...startSpanOptions
                });
            });
            client.on("endPageloadSpan", ()=>{
                if (enableReportPageLoaded && _pageloadSpan) {
                    _pageloadSpan.setAttribute((0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "reportPageLoaded");
                    _pageloadSpan.end();
                }
            });
        },
        afterAllSetup (client) {
            if (_isBot) return;
            if (client.addIntegration && !client.getIntegrationByName?.((0, $fb7c652f29fd39d3$export$8748555bacc7091c))) client.addIntegration((0, $fb7c652f29fd39d3$export$1ab4995602e8adaa)({
                ignore: enableInp ? [] : [
                    "inp"
                ],
                _experiments: {
                    enableStandaloneClsSpans: enableStandaloneClsSpans,
                    enableStandaloneLcpSpans: enableStandaloneLcpSpans
                }
            }));
            let startingUrl = (0, $9409895355f874f2$exports.getLocationHref)();
            if (linkPreviousTrace !== "off") (0, $e773850256c2e990$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $9409895355f874f2$exports.browserPerformanceTimeOrigin)();
                    $dbc03a1d427b8584$export$aa44a07f82af519f(client, {
                        name: (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1e3 : void 0,
                        attributes: {
                            [(0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                            [(0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.browser"
                        }
                    });
                }
                if (instrumentNavigation) (0, $c1a8a7f184186a3b$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    if (from === void 0 && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = void 0;
                        return;
                    }
                    startingUrl = void 0;
                    const parsed = (0, $9409895355f874f2$exports.parseStringToURLObject)(to);
                    const activeSpan = $dbc03a1d427b8584$var$getActiveIdleSpan(client);
                    const navigationIsRedirect = activeSpan && detectRedirects && $dbc03a1d427b8584$var$isRedirect(activeSpan, lastInteractionTimestamp);
                    $dbc03a1d427b8584$export$7d159749bd9969ad(client, {
                        name: parsed?.pathname || (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).location.pathname,
                        attributes: {
                            [(0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                            [(0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.browser"
                        }
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, $c3eb9c7b0aad709b$export$6f18f55521af71a1)();
            if (enableInteractions) $dbc03a1d427b8584$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            (0, $1bd3fa3e643a28e3$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart,
                onRequestSpanEnd: onRequestSpanEnd
            });
            if (trackFetchStreamPerformance) client.addIntegration((0, $994f36905db521c3$export$b49e0d1a48dc8754)());
        }
    };
};
function $dbc03a1d427b8584$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $9409895355f874f2$exports.getCurrentScope)().setTransactionName(spanOptions.name);
    const pageloadSpan = $dbc03a1d427b8584$var$getActiveIdleSpan(client);
    if (pageloadSpan) client.emit("afterStartPageLoadSpan", pageloadSpan);
    return pageloadSpan;
}
function $dbc03a1d427b8584$export$7d159749bd9969ad(client, spanOptions, options) {
    const { url: url, isRedirect: isRedirect2 } = options || {};
    client.emit("beforeStartNavigationSpan", spanOptions, {
        isRedirect: isRedirect2
    });
    client.emit("startNavigationSpan", spanOptions, {
        isRedirect: isRedirect2
    });
    const scope = (0, $9409895355f874f2$exports.getCurrentScope)();
    scope.setTransactionName(spanOptions.name);
    if (url && !isRedirect2) scope.setSDKProcessingMetadata({
        normalizedRequest: {
            ...(0, $53aee3b1e0ad0f44$export$a3c4a8453e8936f0)(),
            url: url
        }
    });
    return $dbc03a1d427b8584$var$getActiveIdleSpan(client);
}
function $dbc03a1d427b8584$export$f147b32b03c9cf11(metaName) {
    const optionalWindowDocument = (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute("content") || void 0;
}
function $dbc03a1d427b8584$export$5bb9693b37f7c2ae(name) {
    const navigation = (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    const entry = navigation?.serverTiming?.find((entry2)=>entry2.name === name);
    return entry?.description;
}
function $dbc03a1d427b8584$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    const optionalWindowDocument = (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeIdleSpan = $dbc03a1d427b8584$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $9409895355f874f2$exports.spanToJSON)(activeIdleSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $35bf7e39ff9440e2$export$16a28057038b10ef) && (0, $9409895355f874f2$exports.debug).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return void 0;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = void 0;
        }
        if (!latestRoute.name) {
            (0, $35bf7e39ff9440e2$export$16a28057038b10ef) && (0, $9409895355f874f2$exports.debug).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return void 0;
        }
        inflightInteractionSpan = (0, $9409895355f874f2$exports.startIdleSpan)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener("click", registerInteractionTransaction, {
        capture: true
    });
}
const $dbc03a1d427b8584$var$ACTIVE_IDLE_SPAN_PROPERTY = "_sentry_idleSpan";
function $dbc03a1d427b8584$var$getActiveIdleSpan(client) {
    return client[$dbc03a1d427b8584$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $dbc03a1d427b8584$var$setActiveIdleSpan(client, span) {
    (0, $9409895355f874f2$exports.addNonEnumerableProperty)(client, $dbc03a1d427b8584$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}
const $dbc03a1d427b8584$var$REDIRECT_THRESHOLD = 1.5;
function $dbc03a1d427b8584$var$isRedirect(activeSpan, lastInteractionTimestamp) {
    const spanData = (0, $9409895355f874f2$exports.spanToJSON)(activeSpan);
    const now = (0, $9409895355f874f2$exports.dateTimestampInSeconds)();
    const startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > $dbc03a1d427b8584$var$REDIRECT_THRESHOLD) return false;
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= $dbc03a1d427b8584$var$REDIRECT_THRESHOLD) return false;
    return true;
}




function $31abd4af4ca88bbe$export$a6c2d27607295951(stackParser, ex) {
    const frames = $31abd4af4ca88bbe$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $31abd4af4ca88bbe$export$2e9ae379995d99e3(ex),
        value: $31abd4af4ca88bbe$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $31abd4af4ca88bbe$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $9409895355f874f2$exports.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const errorFromProp = $31abd4af4ca88bbe$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $9409895355f874f2$exports.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $31abd4af4ca88bbe$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $9409895355f874f2$exports.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $31abd4af4ca88bbe$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $31abd4af4ca88bbe$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $31abd4af4ca88bbe$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $31abd4af4ca88bbe$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $31abd4af4ca88bbe$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $31abd4af4ca88bbe$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $31abd4af4ca88bbe$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {}
    return [];
}
const $31abd4af4ca88bbe$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $31abd4af4ca88bbe$var$getSkipFirstStackStringLines(ex) {
    if (ex && $31abd4af4ca88bbe$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $31abd4af4ca88bbe$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $31abd4af4ca88bbe$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $31abd4af4ca88bbe$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    if (!name && $31abd4af4ca88bbe$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $31abd4af4ca88bbe$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($31abd4af4ca88bbe$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $9409895355f874f2$exports._INTERNAL_enhanceErrorWithSentryInfo)(message.error);
    return (0, $9409895355f874f2$exports._INTERNAL_enhanceErrorWithSentryInfo)(ex);
}
function $31abd4af4ca88bbe$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $31abd4af4ca88bbe$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $9409895355f874f2$exports.addExceptionMechanism)(event);
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $9409895355f874f2$exports.resolvedSyncPromise)(event);
}
function $31abd4af4ca88bbe$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $31abd4af4ca88bbe$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $9409895355f874f2$exports.resolvedSyncPromise)(event);
}
function $31abd4af4ca88bbe$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $9409895355f874f2$exports.isErrorEvent)(exception) && exception.error) {
        const errorEvent = exception;
        return $31abd4af4ca88bbe$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $9409895355f874f2$exports.isDOMError)(exception) || (0, $9409895355f874f2$exports.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            event = $31abd4af4ca88bbe$var$eventFromError(stackParser, exception);
            const firstException = event.exception?.values?.[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $31abd4af4ca88bbe$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $9409895355f874f2$exports.addExceptionMechanism)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $9409895355f874f2$exports.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $31abd4af4ca88bbe$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $9409895355f874f2$exports.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $9409895355f874f2$exports.isError)(exception)) return $31abd4af4ca88bbe$var$eventFromError(stackParser, exception);
    if ((0, $9409895355f874f2$exports.isPlainObject)(exception) || (0, $9409895355f874f2$exports.isEvent)(exception)) {
        const objectException = exception;
        event = $31abd4af4ca88bbe$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $9409895355f874f2$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    event = $31abd4af4ca88bbe$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $9409895355f874f2$exports.addExceptionTypeValue)(event, `${exception}`, void 0);
    (0, $9409895355f874f2$exports.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $31abd4af4ca88bbe$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $31abd4af4ca88bbe$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $9409895355f874f2$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $9409895355f874f2$exports.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $31abd4af4ca88bbe$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $9409895355f874f2$exports.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $9409895355f874f2$exports.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $9409895355f874f2$exports.isEvent)(exception)) {
        const className = $31abd4af4ca88bbe$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $31abd4af4ca88bbe$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $31abd4af4ca88bbe$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((v)=>v instanceof Error);
}



class $2d9314519f9e35d8$export$1df9218a526d318d extends (0, $9409895355f874f2$exports.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $2d9314519f9e35d8$export$4e107b20a7f977(options);
        const sdkSource = (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $9409895355f874f2$exports.getSDKSource)();
        (0, $9409895355f874f2$exports.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        const { sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments, enableMetrics: enableMetricsOption } = this._options;
        const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
        if ((0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs || enableMetrics)) (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $9409895355f874f2$exports._INTERNAL_flushLogsBuffer)(this);
                if (enableMetrics) (0, $9409895355f874f2$exports._INTERNAL_flushMetricsBuffer)(this);
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $9409895355f874f2$exports.addAutoIpAddressToSession));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $31abd4af4ca88bbe$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $31abd4af4ca88bbe$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
function $2d9314519f9e35d8$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}





const $faa2a3943cad7423$var$DEBOUNCE_DURATION = 1e3;
let $faa2a3943cad7423$var$debounceTimerID;
let $faa2a3943cad7423$var$lastCapturedEventType;
let $faa2a3943cad7423$var$lastCapturedEventTargetId;
function $faa2a3943cad7423$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $3cffafffc6e2c7bd$export$a4e09611e30da72e)(type, handler);
    (0, $3cffafffc6e2c7bd$export$e18d6c5462c01368)(type, $faa2a3943cad7423$export$3014bbf0af0e1d4a);
}
function $faa2a3943cad7423$export$3014bbf0af0e1d4a() {
    if (!(0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $3cffafffc6e2c7bd$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $faa2a3943cad7423$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $c23193fe738c8aae$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $faa2a3943cad7423$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $c23193fe738c8aae$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $faa2a3943cad7423$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $faa2a3943cad7423$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $faa2a3943cad7423$var$lastCapturedEventTargetId) return false;
    } catch  {}
    return true;
}
function $faa2a3943cad7423$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $faa2a3943cad7423$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $faa2a3943cad7423$var$getEventTarget(event);
        if ($faa2a3943cad7423$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $c23193fe738c8aae$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $c23193fe738c8aae$export$e73679ffaf56810e)(target, "_sentryId", (0, $c0e4bdc3ef402b05$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$faa2a3943cad7423$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $faa2a3943cad7423$var$lastCapturedEventType = event.type;
            $faa2a3943cad7423$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($faa2a3943cad7423$var$debounceTimerID);
        $faa2a3943cad7423$var$debounceTimerID = (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).setTimeout(()=>{
            $faa2a3943cad7423$var$lastCapturedEventTargetId = void 0;
            $faa2a3943cad7423$var$lastCapturedEventType = void 0;
        }, $faa2a3943cad7423$var$DEBOUNCE_DURATION);
    };
}
function $faa2a3943cad7423$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        return null;
    }
}




const $34a6644daa1b55cb$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $34a6644daa1b55cb$var$INTEGRATION_NAME = "Breadcrumbs";
const $34a6644daa1b55cb$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $34a6644daa1b55cb$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $9409895355f874f2$exports.addConsoleInstrumentationHandler)($34a6644daa1b55cb$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $faa2a3943cad7423$export$5aeffd3db2cf9df7)($34a6644daa1b55cb$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $74592dea4a298c94$export$26ace48dd54c9aea)($34a6644daa1b55cb$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $9409895355f874f2$exports.addFetchInstrumentationHandler)($34a6644daa1b55cb$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $c1a8a7f184186a3b$export$3f18c56c58114e75)($34a6644daa1b55cb$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $34a6644daa1b55cb$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $34a6644daa1b55cb$export$c079d904b326663a = (0, $9409895355f874f2$exports.defineIntegration)($34a6644daa1b55cb$var$_breadcrumbsIntegration);
function $34a6644daa1b55cb$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $9409895355f874f2$exports.getClient)() !== client) return;
        (0, $9409895355f874f2$exports.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $9409895355f874f2$exports.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
function $34a6644daa1b55cb$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $9409895355f874f2$exports.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $34a6644daa1b55cb$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $35bf7e39ff9440e2$export$16a28057038b10ef) && (0, $9409895355f874f2$exports.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$34a6644daa1b55cb$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$34a6644daa1b55cb$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $34a6644daa1b55cb$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $34a6644daa1b55cb$var$_isEvent(event) ? event.target : event;
            target = (0, $5e6d95e419314f14$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $9409895355f874f2$exports.getComponentName)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $9409895355f874f2$exports.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $34a6644daa1b55cb$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $9409895355f874f2$exports.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $9409895355f874f2$exports.severityLevelFromString)(handlerData.level),
            message: (0, $9409895355f874f2$exports.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $9409895355f874f2$exports.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $9409895355f874f2$exports.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $34a6644daa1b55cb$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $9409895355f874f2$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $74592dea4a298c94$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $9409895355f874f2$exports.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $9409895355f874f2$exports.addBreadcrumb)(breadcrumb, hint);
    };
}
function $34a6644daa1b55cb$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $9409895355f874f2$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $9409895355f874f2$exports.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $9409895355f874f2$exports.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $9409895355f874f2$exports.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
function $34a6644daa1b55cb$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $9409895355f874f2$exports.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $9409895355f874f2$exports.parseUrl)((0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $9409895355f874f2$exports.parseUrl)(from) : void 0;
        const parsedTo = (0, $9409895355f874f2$exports.parseUrl)(to);
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $9409895355f874f2$exports.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $34a6644daa1b55cb$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $e510953c3bfea98f$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $e510953c3bfea98f$var$INTEGRATION_NAME = "BrowserApiErrors";
const $e510953c3bfea98f$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $e510953c3bfea98f$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $9409895355f874f2$exports.fill)((0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81), "setTimeout", $e510953c3bfea98f$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $9409895355f874f2$exports.fill)((0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81), "setInterval", $e510953c3bfea98f$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $9409895355f874f2$exports.fill)((0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81), "requestAnimationFrame", $e510953c3bfea98f$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81)) (0, $9409895355f874f2$exports.fill)(XMLHttpRequest.prototype, "send", $e510953c3bfea98f$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $e510953c3bfea98f$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$e510953c3bfea98f$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $e510953c3bfea98f$export$59bfe9f1c76150e = (0, $9409895355f874f2$exports.defineIntegration)($e510953c3bfea98f$var$_browserApiErrorsIntegration);
function $e510953c3bfea98f$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $53aee3b1e0ad0f44$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $9409895355f874f2$exports.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $e510953c3bfea98f$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $53aee3b1e0ad0f44$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $9409895355f874f2$exports.getFunctionName)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $e510953c3bfea98f$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $9409895355f874f2$exports.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $9409895355f874f2$exports.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $9409895355f874f2$exports.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $9409895355f874f2$exports.getFunctionName)(originalFunction);
                return (0, $53aee3b1e0ad0f44$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $e510953c3bfea98f$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $9409895355f874f2$exports.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($e510953c3bfea98f$var$isEventListenerObject(fn)) fn.handleEvent = (0, $53aee3b1e0ad0f44$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $9409895355f874f2$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {}
            if (integrationOptions.unregisterOriginalCallbacks) $e510953c3bfea98f$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $53aee3b1e0ad0f44$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $9409895355f874f2$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $9409895355f874f2$exports.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    const originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch  {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $e510953c3bfea98f$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $e510953c3bfea98f$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}






const $517ed7be5415fea0$export$1baa7880e357371c = (0, $9409895355f874f2$exports.defineIntegration)((options = {})=>{
    const lifecycle = options.lifecycle ?? "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $35bf7e39ff9440e2$export$16a28057038b10ef) && (0, $9409895355f874f2$exports.debug).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $9409895355f874f2$exports.startSession)({
                ignoreDuration: true
            });
            let initialSessionSent = false;
            (0, $f522d837479c7fe8$export$d3314d5863fc1fef)(()=>{
                if (!initialSessionSent) {
                    (0, $9409895355f874f2$exports.captureSession)();
                    initialSessionSent = true;
                }
            });
            const isolationScope = (0, $9409895355f874f2$exports.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    previousUser = maybeNewUser;
                    if (initialSessionSent) (0, $9409895355f874f2$exports.captureSession)();
                }
            });
            if (lifecycle === "route") (0, $c1a8a7f184186a3b$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $9409895355f874f2$exports.startSession)({
                        ignoreDuration: true
                    });
                    (0, $9409895355f874f2$exports.captureSession)();
                    initialSessionSent = true;
                }
            });
        }
    };
});




const $ba3433cc946c9981$var$INTEGRATION_NAME = "CultureContext";
const $ba3433cc946c9981$var$_cultureContextIntegration = ()=>{
    return {
        name: $ba3433cc946c9981$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $ba3433cc946c9981$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $ba3433cc946c9981$var$getCultureContext();
            if (culture) (0, $9409895355f874f2$exports.safeSetSpanJSONAttributes)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $ba3433cc946c9981$export$ec5976aacdc85985 = (0, $9409895355f874f2$exports.defineIntegration)($ba3433cc946c9981$var$_cultureContextIntegration);
function $ba3433cc946c9981$var$getCultureContext() {
    try {
        const intl = (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        return void 0;
    }
}






const $ffa2ee900ba5b2db$var$INTEGRATION_NAME = "GlobalHandlers";
const $ffa2ee900ba5b2db$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $ffa2ee900ba5b2db$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $ffa2ee900ba5b2db$var$_installGlobalOnErrorHandler(client);
                $ffa2ee900ba5b2db$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $ffa2ee900ba5b2db$var$_installGlobalOnUnhandledRejectionHandler(client);
                $ffa2ee900ba5b2db$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $ffa2ee900ba5b2db$export$66acc70e8cf2b71a = (0, $9409895355f874f2$exports.defineIntegration)($ffa2ee900ba5b2db$var$_globalHandlersIntegration);
function $ffa2ee900ba5b2db$var$_installGlobalOnErrorHandler(client) {
    (0, $9409895355f874f2$exports.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ffa2ee900ba5b2db$var$getOptions();
        if ((0, $9409895355f874f2$exports.getClient)() !== client || (0, $53aee3b1e0ad0f44$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $ffa2ee900ba5b2db$var$_enhanceEventWithInitialFrame((0, $31abd4af4ca88bbe$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $9409895355f874f2$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $ffa2ee900ba5b2db$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $9409895355f874f2$exports.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ffa2ee900ba5b2db$var$getOptions();
        if ((0, $9409895355f874f2$exports.getClient)() !== client || (0, $53aee3b1e0ad0f44$export$b79738ab10c590b2)()) return;
        const error = $ffa2ee900ba5b2db$export$b2cc40fa8241780(e);
        const event = (0, $9409895355f874f2$exports.isPrimitive)(error) ? $ffa2ee900ba5b2db$export$1353b5b36844a9ed(error) : (0, $31abd4af4ca88bbe$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $9409895355f874f2$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $ffa2ee900ba5b2db$export$b2cc40fa8241780(error) {
    if ((0, $9409895355f874f2$exports.isPrimitive)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {}
    return error;
}
function $ffa2ee900ba5b2db$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $ffa2ee900ba5b2db$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $ffa2ee900ba5b2db$var$getFilenameFromUrl(url) ?? (0, $9409895355f874f2$exports.getLocationHref)(),
        function: (0, $9409895355f874f2$exports.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $ffa2ee900ba5b2db$var$globalHandlerLog(type) {
    (0, $35bf7e39ff9440e2$export$16a28057038b10ef) && (0, $9409895355f874f2$exports.debug).log(`Global Handler attached: ${type}`);
}
function $ffa2ee900ba5b2db$var$getOptions() {
    const client = (0, $9409895355f874f2$exports.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $ffa2ee900ba5b2db$var$getFilenameFromUrl(url) {
    if (!(0, $9409895355f874f2$exports.isString)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $9409895355f874f2$exports.stripDataUrlContent)(url, false)}>`;
    return url;
}




const $1f3a5436feacfa9a$export$1378794447170364 = (0, $9409895355f874f2$exports.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            if (!(0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).navigator && !(0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).location && !(0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $53aee3b1e0ad0f44$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSegmentSpan (span) {
            const spanOp = span.attributes?.[0, $9409895355f874f2$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP];
            if (!(0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).navigator && !(0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).location && !(0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $53aee3b1e0ad0f44$export$a3c4a8453e8936f0)();
            (0, $9409895355f874f2$exports.safeSetSpanJSONAttributes)(span, {
                // Coerce empty string to undefined so the helper's nullish check drops it,
                // rather than writing an empty `url.full` attribute onto the span.
                "url.full": spanOp !== "http.client" ? reqData.url : void 0,
                "http.request.header.user_agent": reqData.headers["User-Agent"],
                "http.request.header.referer": reqData.headers["Referer"]
            });
        }
    };
});




const $1b6602b438dd846f$var$DEFAULT_KEY = "cause";
const $1b6602b438dd846f$var$DEFAULT_LIMIT = 5;
const $1b6602b438dd846f$var$INTEGRATION_NAME = "LinkedErrors";
const $1b6602b438dd846f$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $1b6602b438dd846f$var$DEFAULT_LIMIT;
    const key = options.key || $1b6602b438dd846f$var$DEFAULT_KEY;
    return {
        name: $1b6602b438dd846f$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $9409895355f874f2$exports.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $31abd4af4ca88bbe$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $1b6602b438dd846f$export$ebabb00eb7f3a395 = (0, $9409895355f874f2$exports.defineIntegration)($1b6602b438dd846f$var$_linkedErrorsIntegration);



const $4cda521fa88136cf$var$OPERA10_PRIORITY = 10;
const $4cda521fa88136cf$var$OPERA11_PRIORITY = 20;
const $4cda521fa88136cf$var$CHROME_PRIORITY = 30;
const $4cda521fa88136cf$var$WINJS_PRIORITY = 40;
const $4cda521fa88136cf$var$GECKO_PRIORITY = 50;
function $4cda521fa88136cf$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $9409895355f874f2$exports.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $4cda521fa88136cf$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $4cda521fa88136cf$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $4cda521fa88136cf$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $4cda521fa88136cf$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $4cda521fa88136cf$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($4cda521fa88136cf$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $4cda521fa88136cf$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $4cda521fa88136cf$var$createFrame(filename, (0, $9409895355f874f2$exports.UNKNOWN_FUNCTION), +line2, +col);
    }
    const parts = $4cda521fa88136cf$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0;
        if (isEval) {
            const subMatch = $4cda521fa88136cf$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $4cda521fa88136cf$var$extractSafariExtensionDetails(parts[1] || (0, $9409895355f874f2$exports.UNKNOWN_FUNCTION), parts[2]);
        return $4cda521fa88136cf$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $4cda521fa88136cf$export$263a749fff749872 = [
    $4cda521fa88136cf$var$CHROME_PRIORITY,
    $4cda521fa88136cf$var$chromeStackParserFn
];
const $4cda521fa88136cf$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $4cda521fa88136cf$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $4cda521fa88136cf$var$gecko = (line)=>{
    const parts = $4cda521fa88136cf$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $4cda521fa88136cf$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $9409895355f874f2$exports.UNKNOWN_FUNCTION);
        [func, filename] = $4cda521fa88136cf$var$extractSafariExtensionDetails(func, filename);
        return $4cda521fa88136cf$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $4cda521fa88136cf$export$cdba47a5dd2804d = [
    $4cda521fa88136cf$var$GECKO_PRIORITY,
    $4cda521fa88136cf$var$gecko
];
const $4cda521fa88136cf$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $4cda521fa88136cf$var$winjs = (line)=>{
    const parts = $4cda521fa88136cf$var$winjsRegex.exec(line);
    return parts ? $4cda521fa88136cf$var$createFrame(parts[2], parts[1] || (0, $9409895355f874f2$exports.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $4cda521fa88136cf$export$179460296da408e8 = [
    $4cda521fa88136cf$var$WINJS_PRIORITY,
    $4cda521fa88136cf$var$winjs
];
const $4cda521fa88136cf$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $4cda521fa88136cf$var$opera10 = (line)=>{
    const parts = $4cda521fa88136cf$var$opera10Regex.exec(line);
    return parts ? $4cda521fa88136cf$var$createFrame(parts[2], parts[3] || (0, $9409895355f874f2$exports.UNKNOWN_FUNCTION), +parts[1]) : void 0;
};
const $4cda521fa88136cf$export$f892b52c880ffc7a = [
    $4cda521fa88136cf$var$OPERA10_PRIORITY,
    $4cda521fa88136cf$var$opera10
];
const $4cda521fa88136cf$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $4cda521fa88136cf$var$opera11 = (line)=>{
    const parts = $4cda521fa88136cf$var$opera11Regex.exec(line);
    return parts ? $4cda521fa88136cf$var$createFrame(parts[5], parts[3] || parts[4] || (0, $9409895355f874f2$exports.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : void 0;
};
const $4cda521fa88136cf$export$af11af13f09fb0dc = [
    $4cda521fa88136cf$var$OPERA11_PRIORITY,
    $4cda521fa88136cf$var$opera11
];
const $4cda521fa88136cf$export$7197c0fe6554c079 = [
    $4cda521fa88136cf$export$263a749fff749872,
    $4cda521fa88136cf$export$cdba47a5dd2804d
];
const $4cda521fa88136cf$export$2b2b997d81bf3907 = (0, $9409895355f874f2$exports.createStackParser)(...$4cda521fa88136cf$export$7197c0fe6554c079);
const $4cda521fa88136cf$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $9409895355f874f2$exports.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};






const $e23394dcaf3c1d03$var$cachedImplementations = {};
function $e23394dcaf3c1d03$export$e464f4a514ac28a8(name) {
    const cached = $e23394dcaf3c1d03$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81)[name];
    if ((0, $5d3204b815cde265$export$d5f608b368e73f38)(impl)) return $e23394dcaf3c1d03$var$cachedImplementations[name] = impl.bind((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81));
    const document = (0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $d0c2be10ad9299aa$export$16a28057038b10ef) && (0, $9e6aad2ab33fde86$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $e23394dcaf3c1d03$var$cachedImplementations[name] = impl.bind((0, $f1ead4edfaa283d7$export$56d8a8a25bd48b81));
}
function $e23394dcaf3c1d03$export$8aa36702e8c8978(name) {
    $e23394dcaf3c1d03$var$cachedImplementations[name] = void 0;
}
function $e23394dcaf3c1d03$export$e7aa7bc5c1b3cfb3(...rest) {
    return $e23394dcaf3c1d03$export$e464f4a514ac28a8("fetch")(...rest);
}
function $e23394dcaf3c1d03$export$831dc9f2ab0a617b(...rest) {
    return $e23394dcaf3c1d03$export$e464f4a514ac28a8("setTimeout")(...rest);
}


const $eac3027072d627b1$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $eac3027072d627b1$export$b2311068c46d7cc8(options, nativeFetch = (0, $e23394dcaf3c1d03$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $e23394dcaf3c1d03$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $9409895355f874f2$exports.createTransport)(options, makeRequest, (0, $9409895355f874f2$exports.makePromiseBuffer)(options.bufferSize || $eac3027072d627b1$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $a7cc4e5cc8a01c47$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch  {
        return false;
    }
}


const $4364b47d89508b0b$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $4364b47d89508b0b$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $a7cc4e5cc8a01c47$export$45a5e7f76e0caa8d)(value)) {
        const objName = $4364b47d89508b0b$var$getConstructorName(value);
        if ($4364b47d89508b0b$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $5e6d95e419314f14$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $4364b47d89508b0b$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}





function $8e3aa3deb1d7bc9d$export$dc236a86065879fc() {
    if ($8e3aa3deb1d7bc9d$var$_isEmbeddedBrowserExtension()) {
        if (0, $35bf7e39ff9440e2$export$16a28057038b10ef) (0, $9409895355f874f2$exports.consoleSandbox)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $8e3aa3deb1d7bc9d$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $9409895355f874f2$exports.getLocationHref)();
    const isDedicatedExtensionPage = (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81) === (0, $53aee3b1e0ad0f44$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $f692584d7e6adcb2$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line typescript/no-deprecated
        (0, $9409895355f874f2$exports.inboundFiltersIntegration)(),
        (0, $9409895355f874f2$exports.functionToStringIntegration)(),
        (0, $9409895355f874f2$exports.conversationIdIntegration)(),
        (0, $e510953c3bfea98f$export$59bfe9f1c76150e)(),
        (0, $34a6644daa1b55cb$export$c079d904b326663a)(),
        (0, $ffa2ee900ba5b2db$export$66acc70e8cf2b71a)(),
        (0, $1b6602b438dd846f$export$ebabb00eb7f3a395)(),
        (0, $9409895355f874f2$exports.dedupeIntegration)(),
        (0, $1f3a5436feacfa9a$export$1378794447170364)(),
        (0, $ba3433cc946c9981$export$ec5976aacdc85985)(),
        (0, $517ed7be5415fea0$export$1baa7880e357371c)()
    ];
}
function $f692584d7e6adcb2$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $8e3aa3deb1d7bc9d$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $f692584d7e6adcb2$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $9409895355f874f2$exports.stackParserFromStackParserOptions)(options.stackParser || (0, $4cda521fa88136cf$export$2b2b997d81bf3907)),
        integrations: (0, $9409895355f874f2$exports.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $eac3027072d627b1$export$b2311068c46d7cc8)
    };
    (0, $9409895355f874f2$exports.setNormalizeStringifier)((0, $4364b47d89508b0b$export$4c88c355e6072df5));
    return (0, $9409895355f874f2$exports.initAndBind)((0, $2d9314519f9e35d8$export$1df9218a526d318d), clientOptions);
}
function $f692584d7e6adcb2$export$a3f323d81eede727() {}
function $f692584d7e6adcb2$export$4e4d8b287d028b6b(callback) {
    callback();
}


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $6e9d8fa85a388a89$export$dfd9b671c89acc8e = 7;
const $6e9d8fa85a388a89$export$3913210603d8e9ae = 365.2425;
const $6e9d8fa85a388a89$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $6e9d8fa85a388a89$export$4dec998e48f9c246 = -$6e9d8fa85a388a89$export$81caae6e1cc7a622;
const $6e9d8fa85a388a89$export$4fad13613e88edc8 = 604800000;
const $6e9d8fa85a388a89$export$b76b1809a2898f9a = 86400000;
const $6e9d8fa85a388a89$export$91246f0b9bd9beff = 60000;
const $6e9d8fa85a388a89$export$7f72910d6dfd237a = 3600000;
const $6e9d8fa85a388a89$export$397c2d5776aa9055 = 1000;
const $6e9d8fa85a388a89$export$3633035e63cee86a = 525600;
const $6e9d8fa85a388a89$export$ab7da2ccd1075c38 = 43200;
const $6e9d8fa85a388a89$export$2423174df8cd3cd2 = 1440;
const $6e9d8fa85a388a89$export$f2f5ae5a8e2d8f9f = 60;
const $6e9d8fa85a388a89$export$3c58128db900d44e = 3;
const $6e9d8fa85a388a89$export$80d7e435f744f319 = 12;
const $6e9d8fa85a388a89$export$4db7641526e3241f = 4;
const $6e9d8fa85a388a89$export$698aec755e92c695 = 3600;
const $6e9d8fa85a388a89$export$a77c1a7ebebe2a5a = 60;
const $6e9d8fa85a388a89$export$815a9362476d2fe3 = $6e9d8fa85a388a89$export$698aec755e92c695 * 24;
const $6e9d8fa85a388a89$export$34804a017b31e2fe = $6e9d8fa85a388a89$export$815a9362476d2fe3 * 7;
const $6e9d8fa85a388a89$export$7271e9e3478110d1 = $6e9d8fa85a388a89$export$815a9362476d2fe3 * $6e9d8fa85a388a89$export$3913210603d8e9ae;
const $6e9d8fa85a388a89$export$8e6600bbdee7dabb = $6e9d8fa85a388a89$export$7271e9e3478110d1 / 12;
const $6e9d8fa85a388a89$export$be1dccf2de902d31 = $6e9d8fa85a388a89$export$8e6600bbdee7dabb * 3;
const $6e9d8fa85a388a89$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $94e2600e6614cc67$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $6e9d8fa85a388a89$export$2a7b97929c48d47d) in date) return date[0, $6e9d8fa85a388a89$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$94e2600e6614cc67$export$2e2bcd8739ae039 = $94e2600e6614cc67$export$ead8a1812b171991;


function $5806bcec89744c32$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $94e2600e6614cc67$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$5806bcec89744c32$export$2e2bcd8739ae039 = $5806bcec89744c32$export$e67a095c620b86fe;


function $80c50a0a80ea8dc0$export$7be94d13716b4bf6(laterDate, earlierDate) {
    return +(0, $5806bcec89744c32$export$e67a095c620b86fe)(laterDate) - +(0, $5806bcec89744c32$export$e67a095c620b86fe)(earlierDate);
}
var // Fallback for modularized imports:
$80c50a0a80ea8dc0$export$2e2bcd8739ae039 = $80c50a0a80ea8dc0$export$7be94d13716b4bf6;

const $b25b0b5411c28ac7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $b25b0b5411c28ac7$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $b25b0b5411c28ac7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $937fcf7e723dd6d7$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $2febde47bb98bab0$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $2febde47bb98bab0$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $2febde47bb98bab0$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $2febde47bb98bab0$export$cbf60ecb96cbb82f = {
    date: (0, $937fcf7e723dd6d7$export$38e44e97ce4dbb7d)({
        formats: $2febde47bb98bab0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $937fcf7e723dd6d7$export$38e44e97ce4dbb7d)({
        formats: $2febde47bb98bab0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $937fcf7e723dd6d7$export$38e44e97ce4dbb7d)({
        formats: $2febde47bb98bab0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $8bc51fb51fb6cd5f$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $8bc51fb51fb6cd5f$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$8bc51fb51fb6cd5f$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $d1b31fbcf71c7062$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $bcec6c2f03a4d00e$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $bcec6c2f03a4d00e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $bcec6c2f03a4d00e$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $bcec6c2f03a4d00e$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $bcec6c2f03a4d00e$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $bcec6c2f03a4d00e$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $bcec6c2f03a4d00e$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $bcec6c2f03a4d00e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $bcec6c2f03a4d00e$var$ordinalNumber,
    era: (0, $d1b31fbcf71c7062$export$63596d6ee8878b25)({
        values: $bcec6c2f03a4d00e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $d1b31fbcf71c7062$export$63596d6ee8878b25)({
        values: $bcec6c2f03a4d00e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $d1b31fbcf71c7062$export$63596d6ee8878b25)({
        values: $bcec6c2f03a4d00e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $d1b31fbcf71c7062$export$63596d6ee8878b25)({
        values: $bcec6c2f03a4d00e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $d1b31fbcf71c7062$export$63596d6ee8878b25)({
        values: $bcec6c2f03a4d00e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $bcec6c2f03a4d00e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $397a5297d63bb64f$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $397a5297d63bb64f$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $397a5297d63bb64f$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $397a5297d63bb64f$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $397a5297d63bb64f$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $ea3e1a3193098a99$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $7fb87efbf3834a7c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $7fb87efbf3834a7c$var$parseOrdinalNumberPattern = /\d+/i;
const $7fb87efbf3834a7c$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $7fb87efbf3834a7c$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $7fb87efbf3834a7c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $7fb87efbf3834a7c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $7fb87efbf3834a7c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $7fb87efbf3834a7c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $7fb87efbf3834a7c$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $7fb87efbf3834a7c$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $7fb87efbf3834a7c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $7fb87efbf3834a7c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $7fb87efbf3834a7c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $ea3e1a3193098a99$export$fdaf2fd6d7edde95)({
        matchPattern: $7fb87efbf3834a7c$var$matchOrdinalNumberPattern,
        parsePattern: $7fb87efbf3834a7c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $397a5297d63bb64f$export$1430a0f35710914d)({
        matchPatterns: $7fb87efbf3834a7c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $397a5297d63bb64f$export$1430a0f35710914d)({
        matchPatterns: $7fb87efbf3834a7c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $397a5297d63bb64f$export$1430a0f35710914d)({
        matchPatterns: $7fb87efbf3834a7c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $397a5297d63bb64f$export$1430a0f35710914d)({
        matchPatterns: $7fb87efbf3834a7c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $397a5297d63bb64f$export$1430a0f35710914d)({
        matchPatterns: $7fb87efbf3834a7c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7fb87efbf3834a7c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $df2dd90e7c50f6a9$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $b25b0b5411c28ac7$export$2c14ff85d6318973),
    formatLong: (0, $2febde47bb98bab0$export$cbf60ecb96cbb82f),
    formatRelative: (0, $8bc51fb51fb6cd5f$export$8fbbfd65594f46a0),
    localize: (0, $bcec6c2f03a4d00e$export$b3bd0bc58e36cd63),
    match: (0, $7fb87efbf3834a7c$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$df2dd90e7c50f6a9$export$2e2bcd8739ae039 = $df2dd90e7c50f6a9$export$137380d9ce54f7f;


let $7d20c1ccd7dd6a35$var$defaultOptions = {};
function $7d20c1ccd7dd6a35$export$430a3269e24b912e() {
    return $7d20c1ccd7dd6a35$var$defaultOptions;
}
function $7d20c1ccd7dd6a35$export$95365be1b0704abc(newOptions) {
    $7d20c1ccd7dd6a35$var$defaultOptions = newOptions;
}


function $f120241e5fda9f45$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}



function $bf76c6c68c67552d$export$113002b5eff6e430(date) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $8ed334072e1c80b3$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $94e2600e6614cc67$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}



function $ad9b435b04f1cc72$export$fe114145ae75d197(dateLeft, dateRight) {
    const diff = +(0, $5806bcec89744c32$export$e67a095c620b86fe)(dateLeft) - +(0, $5806bcec89744c32$export$e67a095c620b86fe)(dateRight);
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$ad9b435b04f1cc72$export$2e2bcd8739ae039 = $ad9b435b04f1cc72$export$fe114145ae75d197;



function $4794d0aab3c34b75$export$e4be225b8ee0a759(laterDate, earlierDate, options) {
    const defaultOptions = (0, $7d20c1ccd7dd6a35$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $df2dd90e7c50f6a9$export$137380d9ce54f7f);
    const comparison = (0, $ad9b435b04f1cc72$export$fe114145ae75d197)(laterDate, earlierDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    const [laterDate_, earlierDate_] = (0, $8ed334072e1c80b3$export$9f53b88e82f64d8d)(options?.in, ...comparison > 0 ? [
        earlierDate,
        laterDate
    ] : [
        laterDate,
        earlierDate
    ]);
    const roundingMethod = (0, $f120241e5fda9f45$export$b6474a47258c1211)(options?.roundingMethod ?? "round");
    const milliseconds = earlierDate_.getTime() - laterDate_.getTime();
    const minutes = milliseconds / (0, $6e9d8fa85a388a89$export$91246f0b9bd9beff);
    const timezoneOffset = (0, $bf76c6c68c67552d$export$113002b5eff6e430)(earlierDate_) - (0, $bf76c6c68c67552d$export$113002b5eff6e430)(laterDate_);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / (0, $6e9d8fa85a388a89$export$91246f0b9bd9beff);
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < (0, $6e9d8fa85a388a89$export$2423174df8cd3cd2)) unit = "hour";
        else if (dstNormalizedMinutes < (0, $6e9d8fa85a388a89$export$ab7da2ccd1075c38)) unit = "day";
        else if (dstNormalizedMinutes < (0, $6e9d8fa85a388a89$export$3633035e63cee86a)) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / (0, $6e9d8fa85a388a89$export$2423174df8cd3cd2));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / (0, $6e9d8fa85a388a89$export$ab7da2ccd1075c38));
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / (0, $6e9d8fa85a388a89$export$3633035e63cee86a));
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}
var // Fallback for modularized imports:
$4794d0aab3c34b75$export$2e2bcd8739ae039 = $4794d0aab3c34b75$export$e4be225b8ee0a759;


function $829d18796c975ba8$export$fc5014aa3db48558(date) {
    return +(0, $5806bcec89744c32$export$e67a095c620b86fe)(date) < Date.now();
}
var // Fallback for modularized imports:
$829d18796c975ba8$export$2e2bcd8739ae039 = $829d18796c975ba8$export$fc5014aa3db48558;




function $7dcb966690c372e6$export$4393d2ccbbedb219(argument, options) {
    const invalidDate = ()=>(0, $94e2600e6614cc67$export$ead8a1812b171991)(options?.in, NaN);
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $7dcb966690c372e6$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $7dcb966690c372e6$var$parseYear(dateStrings.date, additionalDigits);
        date = $7dcb966690c372e6$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(+date)) return invalidDate();
    const timestamp = +date;
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $7dcb966690c372e6$var$parseTime(dateStrings.time);
        if (isNaN(time)) return invalidDate();
    }
    if (dateStrings.timezone) {
        offset = $7dcb966690c372e6$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return invalidDate();
    } else {
        const tmpDate = new Date(timestamp + time);
        const result = (0, $5806bcec89744c32$export$e67a095c620b86fe)(0, options?.in);
        result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
        result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
        return result;
    }
    return (0, $5806bcec89744c32$export$e67a095c620b86fe)(timestamp + time + offset, options?.in);
}
const $7dcb966690c372e6$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $7dcb966690c372e6$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $7dcb966690c372e6$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $7dcb966690c372e6$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $7dcb966690c372e6$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($7dcb966690c372e6$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($7dcb966690c372e6$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($7dcb966690c372e6$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $7dcb966690c372e6$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $7dcb966690c372e6$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $7dcb966690c372e6$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($7dcb966690c372e6$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $7dcb966690c372e6$var$parseDateUnit(captures[1]);
    const month = $7dcb966690c372e6$var$parseDateUnit(captures[2]) - 1;
    const day = $7dcb966690c372e6$var$parseDateUnit(captures[3]);
    const week = $7dcb966690c372e6$var$parseDateUnit(captures[4]);
    const dayOfWeek = $7dcb966690c372e6$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$7dcb966690c372e6$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $7dcb966690c372e6$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$7dcb966690c372e6$var$validateDate(year, month, day) || !$7dcb966690c372e6$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $7dcb966690c372e6$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $7dcb966690c372e6$var$parseTime(timeString) {
    const captures = timeString.match($7dcb966690c372e6$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $7dcb966690c372e6$var$parseTimeUnit(captures[1]);
    const minutes = $7dcb966690c372e6$var$parseTimeUnit(captures[2]);
    const seconds = $7dcb966690c372e6$var$parseTimeUnit(captures[3]);
    if (!$7dcb966690c372e6$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $6e9d8fa85a388a89$export$7f72910d6dfd237a) + minutes * (0, $6e9d8fa85a388a89$export$91246f0b9bd9beff) + seconds * 1000;
}
function $7dcb966690c372e6$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $7dcb966690c372e6$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($7dcb966690c372e6$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$7dcb966690c372e6$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $6e9d8fa85a388a89$export$7f72910d6dfd237a) + minutes * (0, $6e9d8fa85a388a89$export$91246f0b9bd9beff));
}
function $7dcb966690c372e6$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $7dcb966690c372e6$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $7dcb966690c372e6$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $7dcb966690c372e6$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($7dcb966690c372e6$var$daysInMonths[month] || ($7dcb966690c372e6$var$isLeapYearIndex(year) ? 29 : 28));
}
function $7dcb966690c372e6$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($7dcb966690c372e6$var$isLeapYearIndex(year) ? 366 : 365);
}
function $7dcb966690c372e6$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $7dcb966690c372e6$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $7dcb966690c372e6$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$7dcb966690c372e6$export$2e2bcd8739ae039 = $7dcb966690c372e6$export$4393d2ccbbedb219;


const $b721e510678a3c88$var$config = {
    checkUrl: `/user`,
    sendBeat: `/analytics`,
    sendVerify: `/verify`
};
var $b721e510678a3c88$export$2e2bcd8739ae039 = $b721e510678a3c88$var$config;


const $36980ba006f5b698$var$logLevels = [
    'info',
    'warn',
    'error',
    'debug'
];
const $36980ba006f5b698$var$writeLog = (logLevel, ...args)=>{
    const logIndex = $36980ba006f5b698$var$logLevels.indexOf(logLevel);
    const currentLogLevel = $36980ba006f5b698$var$logLevels.indexOf(window.LOG_LEVEL);
    if (logIndex > 0 && currentLogLevel >= logIndex) console[$36980ba006f5b698$var$logLevels[logIndex]](...args);
};
const $36980ba006f5b698$var$logger = (logLevel, ...args)=>{
    if (window.LOG_LEVEL) $36980ba006f5b698$var$writeLog(logLevel, ...args);
};
var $36980ba006f5b698$export$2e2bcd8739ae039 = $36980ba006f5b698$var$logger;




const $5926607b0b06e94b$var$getCookie = (name)=>{
    const cookie = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return cookie ? cookie[2] : null;
};
const $5926607b0b06e94b$var$setHeaders = ()=>{
    const cookie = $5926607b0b06e94b$var$getCookie('SoleAuth');
    const headers = {};
    if (cookie) headers.SoleAuth = `SoleAuth=${cookie}`;
    return headers;
};
const $5926607b0b06e94b$var$defaultOptions = {
    mode: 'cors',
    headers: $5926607b0b06e94b$var$setHeaders()
};
const $5926607b0b06e94b$var$makeCall = async (url, options = $5926607b0b06e94b$var$defaultOptions)=>{
    return fetch(url, options).then((response)=>response);
};
const $5926607b0b06e94b$var$getUserId = async ()=>{
    try {
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', 'checking if user is registered...');
        const response = await $5926607b0b06e94b$var$makeCall(`${"https://v20y5t9356.execute-api.eu-west-1.amazonaws.com/Prod"}${(0, $b721e510678a3c88$export$2e2bcd8739ae039).checkUrl}`);
        const payload = await response.json();
        switch(response.status){
            case 200:
                (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', `user accepted with uid: ${payload.uid}`);
                return payload.uid;
            case 404:
                // Caso utente non registrato
                $9409895355f874f2$exports.addBreadcrumb({
                    category: 'auth',
                    message: `user not registered.`,
                    level: 'warning'
                });
                throw new Error('UserNotRegistered');
            case 500:
                // Caso utente non registrato
                $9409895355f874f2$exports.addBreadcrumb({
                    category: 'auth',
                    message: `Invalid SoleAuth cookie or expired`,
                    level: 'error'
                });
                throw new Error('BadSoleAuthException');
            case 400:
                // Caso cooke non trovato
                $9409895355f874f2$exports.addBreadcrumb({
                    category: 'auth',
                    message: `Cookie sole not found`,
                    level: 'error'
                });
                throw new Error('CookieNotFound');
            default:
                $9409895355f874f2$exports.addBreadcrumb({
                    category: 'auth',
                    data: {
                        ...payload
                    },
                    level: 'error'
                });
                throw new Error('Errore generico getUserId');
        }
    } catch (err) {
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('error', 'errore chiamata isUserRegistered');
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('error', err);
        if (![
            'BadSoleAuthException',
            'UserNotRegistered',
            'CookieNotFound'
        ].includes(err.message)) $9409895355f874f2$exports.captureException(err);
        return false;
    }
};
const $5926607b0b06e94b$var$sendBeatToAnalytics = async (userId, endEvent)=>{
    try {
        if (document.visibilityState === 'hidden') {
            (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', 'the page is not visible, abort beat...');
            return;
        }
        // Ulteriore controllo sulla data di fine evento, se l'evento è terminato, non faccio nulla
        if ((0, $829d18796c975ba8$export$fc5014aa3db48558)(endEvent)) {
            (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', 'Event is not live, abort beat...');
            return;
        }
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', 'sending beat...');
        await $5926607b0b06e94b$var$makeCall(`${"https://v20y5t9356.execute-api.eu-west-1.amazonaws.com/Prod"}${(0, $b721e510678a3c88$export$2e2bcd8739ae039).sendBeat}`, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uid: userId,
                type: 'beat'
            })
        });
        const beatDate = new Date().toISOString();
        $9409895355f874f2$exports.addBreadcrumb({
            category: 'analytics',
            message: `Beat sent at ${beatDate}`,
            level: 'info'
        });
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', `beat sent at ${beatDate}`);
        return true;
    } catch (err) {
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('error', 'errore chiamata sendBeatToAnalytics');
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('error', err);
        return false;
    }
};
const $5926607b0b06e94b$var$confirmPresence = async (userId, vid)=>{
    try {
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', `waiting user ${userId} to confirm check ${vid}`);
        await $5926607b0b06e94b$var$makeCall(`${"https://v20y5t9356.execute-api.eu-west-1.amazonaws.com/Prod"}${(0, $b721e510678a3c88$export$2e2bcd8739ae039).sendVerify}`, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uid: userId,
                vid: vid
            })
        });
        $9409895355f874f2$exports.addBreadcrumb({
            category: 'analytics',
            message: `Confirmed presence at check ${vid}`,
            level: 'info'
        });
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', `check ${vid} confirmed`);
        return true;
    } catch (err) {
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('error', 'errore chiamata confirmPresence');
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('error', err);
        $9409895355f874f2$exports.captureException(err);
        return false;
    }
};
var $5926607b0b06e94b$export$2e2bcd8739ae039 = {
    getUserId: $5926607b0b06e94b$var$getUserId,
    sendBeatToAnalytics: $5926607b0b06e94b$var$sendBeatToAnalytics,
    confirmPresence: $5926607b0b06e94b$var$confirmPresence
};




/**
 * Questa funzione fa partire il tracciamento
 * mandando il beat ogni 2 minuti.
 */ const $705ced8733abd5af$var$init = (userId, endEvent)=>{
    (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', 'Start analytics...');
    // Mando il beat ogni 2 minuti.
    return setInterval(()=>(0, $5926607b0b06e94b$export$2e2bcd8739ae039).sendBeatToAnalytics(userId, endEvent), 120000);
};
const $705ced8733abd5af$var$stopAnalytics = ()=>{
    clearInterval(window.analyticsJob);
};
var $705ced8733abd5af$export$2e2bcd8739ae039 = {
    init: $705ced8733abd5af$var$init,
    stopAnalytics: $705ced8733abd5af$var$stopAnalytics
};





function $55000f1a72ca0916$export$c1889aec51783710(laterDate, earlierDate, options) {
    const diff = (0, $80c50a0a80ea8dc0$export$7be94d13716b4bf6)(laterDate, earlierDate) / 1000;
    return (0, $f120241e5fda9f45$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$55000f1a72ca0916$export$2e2bcd8739ae039 = $55000f1a72ca0916$export$c1889aec51783710;




/**
 * @license
 * Video.js 8.23.9 <http://videojs.com/>
 * Copyright 2010-present Video.js contributors
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */ 
var $hYfPi = parcelRequire("hYfPi");

var $01r8O = parcelRequire("01r8O");
var $f0ff6da7e6f661dc$exports = {};
"use strict";

var $hYfPi = parcelRequire("hYfPi");
var $fbb6a7bc8836e7ee$exports = {};
function $fbb6a7bc8836e7ee$var$_extends() {
    return $fbb6a7bc8836e7ee$exports = $fbb6a7bc8836e7ee$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fbb6a7bc8836e7ee$exports.__esModule = true, $fbb6a7bc8836e7ee$exports["default"] = $fbb6a7bc8836e7ee$exports, $fbb6a7bc8836e7ee$var$_extends.apply(null, arguments);
}
$fbb6a7bc8836e7ee$exports = $fbb6a7bc8836e7ee$var$_extends, $fbb6a7bc8836e7ee$exports.__esModule = true, $fbb6a7bc8836e7ee$exports["default"] = $fbb6a7bc8836e7ee$exports;


var $602d8da1e18fcdb2$exports = {};
$602d8da1e18fcdb2$exports = $602d8da1e18fcdb2$var$isFunction;
var $602d8da1e18fcdb2$var$toString = Object.prototype.toString;
function $602d8da1e18fcdb2$var$isFunction(fn) {
    if (!fn) return false;
    var string = $602d8da1e18fcdb2$var$toString.call(fn);
    return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && // IE8 and below
    (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
}


var $c3c49aacf397961d$exports = {};
"use strict";
function $c3c49aacf397961d$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c3c49aacf397961d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c3c49aacf397961d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c3c49aacf397961d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c3c49aacf397961d$var$_arrayLikeToArray(o, minLen);
}
function $c3c49aacf397961d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $c3c49aacf397961d$var$InterceptorsStorage = /*#__PURE__*/ function() {
    function InterceptorsStorage() {
        this.typeToInterceptorsMap_ = new Map();
        this.enabled_ = false;
    }
    var _proto = InterceptorsStorage.prototype;
    _proto.getIsEnabled = function getIsEnabled() {
        return this.enabled_;
    };
    _proto.enable = function enable() {
        this.enabled_ = true;
    };
    _proto.disable = function disable() {
        this.enabled_ = false;
    };
    _proto.reset = function reset() {
        this.typeToInterceptorsMap_ = new Map();
        this.enabled_ = false;
    };
    _proto.addInterceptor = function addInterceptor(type, interceptor) {
        if (!this.typeToInterceptorsMap_.has(type)) this.typeToInterceptorsMap_.set(type, new Set());
        var interceptorsSet = this.typeToInterceptorsMap_.get(type);
        if (interceptorsSet.has(interceptor)) // already have this interceptor
        return false;
        interceptorsSet.add(interceptor);
        return true;
    };
    _proto.removeInterceptor = function removeInterceptor(type, interceptor) {
        var interceptorsSet = this.typeToInterceptorsMap_.get(type);
        if (interceptorsSet && interceptorsSet.has(interceptor)) {
            interceptorsSet.delete(interceptor);
            return true;
        }
        return false;
    };
    _proto.clearInterceptorsByType = function clearInterceptorsByType(type) {
        var interceptorsSet = this.typeToInterceptorsMap_.get(type);
        if (!interceptorsSet) return false;
        this.typeToInterceptorsMap_.delete(type);
        this.typeToInterceptorsMap_.set(type, new Set());
        return true;
    };
    _proto.clear = function clear() {
        if (!this.typeToInterceptorsMap_.size) return false;
        this.typeToInterceptorsMap_ = new Map();
        return true;
    };
    _proto.getForType = function getForType(type) {
        return this.typeToInterceptorsMap_.get(type) || new Set();
    };
    _proto.execute = function execute(type, payload) {
        var interceptors = this.getForType(type);
        for(var _iterator = $c3c49aacf397961d$var$_createForOfIteratorHelperLoose(interceptors), _step; !(_step = _iterator()).done;){
            var interceptor = _step.value;
            try {
                payload = interceptor(payload);
            } catch (e) {}
        }
        return payload;
    };
    return InterceptorsStorage;
}();
$c3c49aacf397961d$exports = $c3c49aacf397961d$var$InterceptorsStorage;


var $44f7c438249f678c$exports = {};
"use strict";
var $44f7c438249f678c$var$RetryManager = /*#__PURE__*/ function() {
    function RetryManager() {
        this.maxAttempts_ = 1;
        this.delayFactor_ = 0.1;
        this.fuzzFactor_ = 0.1;
        this.initialDelay_ = 1000;
        this.enabled_ = false;
    }
    var _proto = RetryManager.prototype;
    _proto.getIsEnabled = function getIsEnabled() {
        return this.enabled_;
    };
    _proto.enable = function enable() {
        this.enabled_ = true;
    };
    _proto.disable = function disable() {
        this.enabled_ = false;
    };
    _proto.reset = function reset() {
        this.maxAttempts_ = 1;
        this.delayFactor_ = 0.1;
        this.fuzzFactor_ = 0.1;
        this.initialDelay_ = 1000;
        this.enabled_ = false;
    };
    _proto.getMaxAttempts = function getMaxAttempts() {
        return this.maxAttempts_;
    };
    _proto.setMaxAttempts = function setMaxAttempts(maxAttempts) {
        this.maxAttempts_ = maxAttempts;
    };
    _proto.getDelayFactor = function getDelayFactor() {
        return this.delayFactor_;
    };
    _proto.setDelayFactor = function setDelayFactor(delayFactor) {
        this.delayFactor_ = delayFactor;
    };
    _proto.getFuzzFactor = function getFuzzFactor() {
        return this.fuzzFactor_;
    };
    _proto.setFuzzFactor = function setFuzzFactor(fuzzFactor) {
        this.fuzzFactor_ = fuzzFactor;
    };
    _proto.getInitialDelay = function getInitialDelay() {
        return this.initialDelay_;
    };
    _proto.setInitialDelay = function setInitialDelay(initialDelay) {
        this.initialDelay_ = initialDelay;
    };
    _proto.createRetry = function createRetry(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, maxAttempts = _ref.maxAttempts, delayFactor = _ref.delayFactor, fuzzFactor = _ref.fuzzFactor, initialDelay = _ref.initialDelay;
        return new $44f7c438249f678c$var$Retry({
            maxAttempts: maxAttempts || this.maxAttempts_,
            delayFactor: delayFactor || this.delayFactor_,
            fuzzFactor: fuzzFactor || this.fuzzFactor_,
            initialDelay: initialDelay || this.initialDelay_
        });
    };
    return RetryManager;
}();
var $44f7c438249f678c$var$Retry = /*#__PURE__*/ function() {
    function Retry(options) {
        this.maxAttempts_ = options.maxAttempts;
        this.delayFactor_ = options.delayFactor;
        this.fuzzFactor_ = options.fuzzFactor;
        this.currentDelay_ = options.initialDelay;
        this.currentAttempt_ = 1;
    }
    var _proto2 = Retry.prototype;
    _proto2.moveToNextAttempt = function moveToNextAttempt() {
        this.currentAttempt_++;
        var delayDelta = this.currentDelay_ * this.delayFactor_;
        this.currentDelay_ = this.currentDelay_ + delayDelta;
    };
    _proto2.shouldRetry = function shouldRetry() {
        return this.currentAttempt_ < this.maxAttempts_;
    };
    _proto2.getCurrentDelay = function getCurrentDelay() {
        return this.currentDelay_;
    };
    _proto2.getCurrentMinPossibleDelay = function getCurrentMinPossibleDelay() {
        return (1 - this.fuzzFactor_) * this.currentDelay_;
    };
    _proto2.getCurrentMaxPossibleDelay = function getCurrentMaxPossibleDelay() {
        return (1 + this.fuzzFactor_) * this.currentDelay_;
    };
    _proto2.getCurrentFuzzedDelay = function getCurrentFuzzedDelay() {
        var lowValue = this.getCurrentMinPossibleDelay();
        var highValue = this.getCurrentMaxPossibleDelay();
        return lowValue + Math.random() * (highValue - lowValue);
    };
    return Retry;
}();
$44f7c438249f678c$exports = $44f7c438249f678c$var$RetryManager;



$f0ff6da7e6f661dc$var$createXHR.httpHandler = (parcelRequire("hg3q4"));
$f0ff6da7e6f661dc$var$createXHR.requestInterceptorsStorage = new $c3c49aacf397961d$exports();
$f0ff6da7e6f661dc$var$createXHR.responseInterceptorsStorage = new $c3c49aacf397961d$exports();
$f0ff6da7e6f661dc$var$createXHR.retryManager = new $44f7c438249f678c$exports();
/**
 * @license
 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
 * Copyright (c) 2014 David Björklund
 * Available under the MIT license
 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
 */ var $f0ff6da7e6f661dc$var$parseHeaders = function parseHeaders(headers) {
    var result = {};
    if (!headers) return result;
    headers.trim().split('\n').forEach(function(row) {
        var index = row.indexOf(':');
        var key = row.slice(0, index).trim().toLowerCase();
        var value = row.slice(index + 1).trim();
        if (typeof result[key] === 'undefined') result[key] = value;
        else if (Array.isArray(result[key])) result[key].push(value);
        else result[key] = [
            result[key],
            value
        ];
    });
    return result;
};
$f0ff6da7e6f661dc$exports = $f0ff6da7e6f661dc$var$createXHR; // Allow use of default import syntax in TypeScript
$f0ff6da7e6f661dc$exports.default = $f0ff6da7e6f661dc$var$createXHR;
$f0ff6da7e6f661dc$var$createXHR.XMLHttpRequest = $hYfPi.XMLHttpRequest || $f0ff6da7e6f661dc$var$noop;
$f0ff6da7e6f661dc$var$createXHR.XDomainRequest = "withCredentials" in new $f0ff6da7e6f661dc$var$createXHR.XMLHttpRequest() ? $f0ff6da7e6f661dc$var$createXHR.XMLHttpRequest : $hYfPi.XDomainRequest;
$f0ff6da7e6f661dc$var$forEachArray([
    "get",
    "put",
    "post",
    "patch",
    "head",
    "delete"
], function(method) {
    $f0ff6da7e6f661dc$var$createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
        options = $f0ff6da7e6f661dc$var$initParams(uri, options, callback);
        options.method = method.toUpperCase();
        return $f0ff6da7e6f661dc$var$_createXHR(options);
    };
});
function $f0ff6da7e6f661dc$var$forEachArray(array, iterator) {
    for(var i = 0; i < array.length; i++)iterator(array[i]);
}
function $f0ff6da7e6f661dc$var$isEmpty(obj) {
    for(var i in obj){
        if (obj.hasOwnProperty(i)) return false;
    }
    return true;
}
function $f0ff6da7e6f661dc$var$initParams(uri, options, callback) {
    var params = uri;
    if ($602d8da1e18fcdb2$exports(options)) {
        callback = options;
        if (typeof uri === "string") params = {
            uri: uri
        };
    } else params = $fbb6a7bc8836e7ee$exports({}, options, {
        uri: uri
    });
    params.callback = callback;
    return params;
}
function $f0ff6da7e6f661dc$var$createXHR(uri, options, callback) {
    options = $f0ff6da7e6f661dc$var$initParams(uri, options, callback);
    return $f0ff6da7e6f661dc$var$_createXHR(options);
}
function $f0ff6da7e6f661dc$var$_createXHR(options) {
    if (typeof options.callback === "undefined") throw new Error("callback argument missing");
     // call all registered request interceptors for a given request type:
    if (options.requestType && $f0ff6da7e6f661dc$var$createXHR.requestInterceptorsStorage.getIsEnabled()) {
        var requestInterceptorPayload = {
            uri: options.uri || options.url,
            headers: options.headers || {},
            body: options.body,
            metadata: options.metadata || {},
            retry: options.retry,
            timeout: options.timeout
        };
        var updatedPayload = $f0ff6da7e6f661dc$var$createXHR.requestInterceptorsStorage.execute(options.requestType, requestInterceptorPayload);
        options.uri = updatedPayload.uri;
        options.headers = updatedPayload.headers;
        options.body = updatedPayload.body;
        options.metadata = updatedPayload.metadata;
        options.retry = updatedPayload.retry;
        options.timeout = updatedPayload.timeout;
    }
    var called = false;
    var callback = function cbOnce(err, response, body) {
        if (!called) {
            called = true;
            options.callback(err, response, body);
        }
    };
    function readystatechange() {
        // do not call load 2 times when response interceptors are enabled
        // why do we even need this 2nd load?
        if (xhr.readyState === 4 && !$f0ff6da7e6f661dc$var$createXHR.responseInterceptorsStorage.getIsEnabled()) setTimeout(loadFunc, 0);
    }
    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined;
        if (xhr.response) body = xhr.response;
        else body = xhr.responseText || $f0ff6da7e6f661dc$var$getXml(xhr);
        if (isJson) try {
            body = JSON.parse(body);
        } catch (e) {}
        return body;
    }
    function errorFunc(evt) {
        clearTimeout(timeoutTimer);
        clearTimeout(options.retryTimeout);
        if (!(evt instanceof Error)) evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
        evt.statusCode = 0; // we would like to retry on error:
        if (!aborted && $f0ff6da7e6f661dc$var$createXHR.retryManager.getIsEnabled() && options.retry && options.retry.shouldRetry()) {
            options.retryTimeout = setTimeout(function() {
                options.retry.moveToNextAttempt(); // we want to re-use the same options and the same xhr object:
                options.xhr = xhr;
                $f0ff6da7e6f661dc$var$_createXHR(options);
            }, options.retry.getCurrentFuzzedDelay());
            return;
        } // call all registered response interceptors for a given request type:
        if (options.requestType && $f0ff6da7e6f661dc$var$createXHR.responseInterceptorsStorage.getIsEnabled()) {
            var responseInterceptorPayload = {
                headers: failureResponse.headers || {},
                body: failureResponse.body,
                responseUrl: xhr.responseURL,
                responseType: xhr.responseType
            };
            var _updatedPayload = $f0ff6da7e6f661dc$var$createXHR.responseInterceptorsStorage.execute(options.requestType, responseInterceptorPayload);
            failureResponse.body = _updatedPayload.body;
            failureResponse.headers = _updatedPayload.headers;
        }
        return callback(evt, failureResponse);
    } // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return;
        var status;
        clearTimeout(timeoutTimer);
        clearTimeout(options.retryTimeout);
        if (options.useXDR && xhr.status === undefined) //IE8 CORS GET successful response doesn't have a status field, but body is fine
        status = 200;
        else status = xhr.status === 1223 ? 204 : xhr.status;
        var response = failureResponse;
        var err = null;
        if (status !== 0) {
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            };
            if (xhr.getAllResponseHeaders) //remember xhr can in fact be XDR for CORS in IE
            response.headers = $f0ff6da7e6f661dc$var$parseHeaders(xhr.getAllResponseHeaders());
        } else err = new Error("Internal XMLHttpRequest Error");
         // call all registered response interceptors for a given request type:
        if (options.requestType && $f0ff6da7e6f661dc$var$createXHR.responseInterceptorsStorage.getIsEnabled()) {
            var responseInterceptorPayload = {
                headers: response.headers || {},
                body: response.body,
                responseUrl: xhr.responseURL,
                responseType: xhr.responseType
            };
            var _updatedPayload2 = $f0ff6da7e6f661dc$var$createXHR.responseInterceptorsStorage.execute(options.requestType, responseInterceptorPayload);
            response.body = _updatedPayload2.body;
            response.headers = _updatedPayload2.headers;
        }
        return callback(err, response, response.body);
    }
    var xhr = options.xhr || null;
    if (!xhr) {
        if (options.cors || options.useXDR) xhr = new $f0ff6da7e6f661dc$var$createXHR.XDomainRequest();
        else xhr = new $f0ff6da7e6f661dc$var$createXHR.XMLHttpRequest();
    }
    var key;
    var aborted;
    var uri = xhr.url = options.uri || options.url;
    var method = xhr.method = options.method || "GET";
    var body = options.body || options.data;
    var headers = xhr.headers = options.headers || {};
    var sync = !!options.sync;
    var isJson = false;
    var timeoutTimer;
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    };
    if ("json" in options && options.json !== false) {
        isJson = true;
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user
            body = JSON.stringify(options.json === true ? body : options.json);
        }
    }
    xhr.onreadystatechange = readystatechange;
    xhr.onload = loadFunc;
    xhr.onerror = errorFunc; // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function() {};
    xhr.onabort = function() {
        aborted = true;
        clearTimeout(options.retryTimeout);
    };
    xhr.ontimeout = errorFunc;
    xhr.open(method, uri, !sync, options.username, options.password); //has to be after open
    if (!sync) xhr.withCredentials = !!options.withCredentials;
     // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0) timeoutTimer = setTimeout(function() {
        if (aborted) return;
        aborted = true; //IE9 may still call readystatechange
        xhr.abort("timeout");
        var e = new Error("XMLHttpRequest timeout");
        e.code = "ETIMEDOUT";
        errorFunc(e);
    }, options.timeout);
    if (xhr.setRequestHeader) {
        for(key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    } else if (options.headers && !$f0ff6da7e6f661dc$var$isEmpty(options.headers)) throw new Error("Headers cannot be set on an XDomainRequest object");
    if ("responseType" in options) xhr.responseType = options.responseType;
    if ("beforeSend" in options && typeof options.beforeSend === "function") options.beforeSend(xhr);
     // Microsoft Edge browser sends "undefined" when send is called with undefined value.
    // XMLHttpRequest spec says to pass null as body to indicate no body
    // See https://github.com/naugtur/xhr/issues/100.
    xhr.send(body || null);
    return xhr;
}
function $f0ff6da7e6f661dc$var$getXml(xhr) {
    // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
    // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
    try {
        if (xhr.responseType === "document") return xhr.responseXML;
        var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
        if (xhr.responseType === "" && !firefoxBugTakenEffect) return xhr.responseXML;
    } catch (e) {}
    return null;
}
function $f0ff6da7e6f661dc$var$noop() {}


var $b8c3ace47d01a635$exports = {};
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Default exports for Node. Export the extended versions of VTTCue and
// VTTRegion in Node since we likely want the capability to convert back and
// forth between JSON. If we don't then it's not that big of a deal since we're
// off browser.

var $hYfPi = parcelRequire("hYfPi");



var $b8c3ace47d01a635$var$vttjs = $b8c3ace47d01a635$exports = {
    WebVTT: (parcelRequire("dDY2O")),
    VTTCue: (parcelRequire("49bT6")),
    VTTRegion: (parcelRequire("5KZYH"))
};
$hYfPi.vttjs = $b8c3ace47d01a635$var$vttjs;
$hYfPi.WebVTT = $b8c3ace47d01a635$var$vttjs.WebVTT;
var $b8c3ace47d01a635$var$cueShim = $b8c3ace47d01a635$var$vttjs.VTTCue;
var $b8c3ace47d01a635$var$regionShim = $b8c3ace47d01a635$var$vttjs.VTTRegion;
var $b8c3ace47d01a635$var$nativeVTTCue = $hYfPi.VTTCue;
var $b8c3ace47d01a635$var$nativeVTTRegion = $hYfPi.VTTRegion;
$b8c3ace47d01a635$var$vttjs.shim = function() {
    $hYfPi.VTTCue = $b8c3ace47d01a635$var$cueShim;
    $hYfPi.VTTRegion = $b8c3ace47d01a635$var$regionShim;
};
$b8c3ace47d01a635$var$vttjs.restore = function() {
    $hYfPi.VTTCue = $b8c3ace47d01a635$var$nativeVTTCue;
    $hYfPi.VTTRegion = $b8c3ace47d01a635$var$nativeVTTRegion;
};
if (!$hYfPi.VTTCue) $b8c3ace47d01a635$var$vttjs.shim();




var $hYfPi = parcelRequire("hYfPi");
var $3c711be251a9bb4f$var$DEFAULT_LOCATION = 'https://example.com';
var $3c711be251a9bb4f$var$resolveUrl = function resolveUrl(baseUrl, relativeUrl) {
    // return early if we don't need to resolve
    if (/^[a-z]+:/i.test(relativeUrl)) return relativeUrl;
     // if baseUrl is a data URI, ignore it and resolve everything relative to window.location
    if (/^data:/.test(baseUrl)) baseUrl = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).location && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).location.href || '';
    var protocolLess = /^\/\//.test(baseUrl); // remove location if window.location isn't available (i.e. we're in node)
    // and if baseUrl isn't an absolute url
    var removeLocation = !(0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).location && !/\/\//i.test(baseUrl); // if the base URL is relative then combine with the current location
    baseUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).URL(baseUrl, (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).location || $3c711be251a9bb4f$var$DEFAULT_LOCATION);
    var newUrl = new URL(relativeUrl, baseUrl); // if we're a protocol-less url, remove the protocol
    // and if we're location-less, remove the location
    // otherwise, return the url unmodified
    if (removeLocation) return newUrl.href.slice($3c711be251a9bb4f$var$DEFAULT_LOCATION.length);
    else if (protocolLess) return newUrl.href.slice(newUrl.protocol.length);
    return newUrl.href;
};
var $3c711be251a9bb4f$export$2e2bcd8739ae039 = $3c711be251a9bb4f$var$resolveUrl;


/*! @name m3u8-parser @version 7.2.0 @license Apache-2.0 */ /**
 * @file stream.js
 */ /**
 * A lightweight readable stream implemention that handles event dispatching.
 *
 * @class Stream
 */ var $240ec63f2cada8d3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Stream() {
        this.listeners = {};
    }
    /**
   * Add a listener for a specified event type.
   *
   * @param {string} type the event name
   * @param {Function} listener the callback to be invoked when an event of
   * the specified type occurs
   */ var _proto = Stream.prototype;
    _proto.on = function on(type, listener) {
        if (!this.listeners[type]) this.listeners[type] = [];
        this.listeners[type].push(listener);
    };
    _proto.off = function off(type, listener) {
        if (!this.listeners[type]) return false;
        var index = this.listeners[type].indexOf(listener); // TODO: which is better?
        // In Video.js we slice listener functions
        // on trigger so that it does not mess up the order
        // while we loop through.
        //
        // Here we slice on off so that the loop in trigger
        // can continue using it's old reference to loop without
        // messing up the order.
        this.listeners[type] = this.listeners[type].slice(0);
        this.listeners[type].splice(index, 1);
        return index > -1;
    };
    _proto.trigger = function trigger(type) {
        var callbacks = this.listeners[type];
        if (!callbacks) return;
         // Slicing the arguments on every invocation of this method
        // can add a significant amount of overhead. Avoid the
        // intermediate object creation for the common case of a
        // single callback argument
        if (arguments.length === 2) {
            var length = callbacks.length;
            for(var i = 0; i < length; ++i)callbacks[i].call(this, arguments[1]);
        } else {
            var args = Array.prototype.slice.call(arguments, 1);
            var _length = callbacks.length;
            for(var _i = 0; _i < _length; ++_i)callbacks[_i].apply(this, args);
        }
    };
    _proto.dispose = function dispose() {
        this.listeners = {};
    };
    _proto.pipe = function pipe(destination) {
        this.on('data', function(data) {
            destination.push(data);
        });
    };
    return Stream;
}();




var $hYfPi = parcelRequire("hYfPi");
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
'use strict';
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
'use strict';
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup['-'.charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup['_'.charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case 'base64':
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf);
    else return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0934e0939605d48c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $8a0a73e6b73fd0c4$export$d622b2ad8d90c771($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $39570e0c51fe4cb5$require$Buffer = $0934e0939605d48c$export$a143d493d941bafc;
var $39570e0c51fe4cb5$var$atob = function atob(s) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).atob ? (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).atob(s) : $39570e0c51fe4cb5$require$Buffer.from(s, 'base64').toString('binary');
};
function $39570e0c51fe4cb5$export$2e2bcd8739ae039(b64Text) {
    var decodedString = $39570e0c51fe4cb5$var$atob(b64Text);
    var array = new Uint8Array(decodedString.length);
    for(var i = 0; i < decodedString.length; i++)array[i] = decodedString.charCodeAt(i);
    return array;
}


/**
 * @file m3u8/line-stream.js
 */ /**
 * A stream that buffers string input and generates a `data` event for each
 * line.
 *
 * @class LineStream
 * @extends Stream
 */ class $d9ac9c5d7f472999$export$307ab5c52b11c33e extends (0, $240ec63f2cada8d3$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.buffer = '';
    }
    /**
   * Add new data to be parsed.
   *
   * @param {string} data the text to process
   */ push(data) {
        let nextNewline;
        this.buffer += data;
        nextNewline = this.buffer.indexOf('\n');
        for(; nextNewline > -1; nextNewline = this.buffer.indexOf('\n')){
            this.trigger('data', this.buffer.substring(0, nextNewline));
            this.buffer = this.buffer.substring(nextNewline + 1);
        }
    }
}
const $d9ac9c5d7f472999$var$TAB = String.fromCharCode(0x09);
const $d9ac9c5d7f472999$var$parseByterange = function(byterangeString) {
    // optionally match and capture 0+ digits before `@`
    // optionally match and capture 0+ digits after `@`
    const match = /([0-9.]*)?@?([0-9.]*)?/.exec(byterangeString || '');
    const result = {};
    if (match[1]) result.length = parseInt(match[1], 10);
    if (match[2]) result.offset = parseInt(match[2], 10);
    return result;
};
/**
 * "forgiving" attribute list psuedo-grammar:
 * attributes -> keyvalue (',' keyvalue)*
 * keyvalue   -> key '=' value
 * key        -> [^=]*
 * value      -> '"' [^"]* '"' | [^,]*
 */ const $d9ac9c5d7f472999$var$attributeSeparator = function() {
    const key = '[^=]*';
    const value = '"[^"]*"|[^,]*';
    const keyvalue = '(?:' + key + ')=(?:' + value + ')';
    return new RegExp('(?:^|,)(' + keyvalue + ')');
};
/**
 * Parse attributes from a line given the separator
 *
 * @param {string} attributes the attribute line to parse
 */ const $d9ac9c5d7f472999$var$parseAttributes = function(attributes) {
    const result = {};
    if (!attributes) return result;
     // split the string using attributes as the separator
    const attrs = attributes.split($d9ac9c5d7f472999$var$attributeSeparator());
    let i = attrs.length;
    let attr;
    while(i--){
        // filter out unmatched portions of the string
        if (attrs[i] === '') continue;
         // split the key and value
        attr = /([^=]*)=(.*)/.exec(attrs[i]).slice(1); // trim whitespace and remove optional quotes around the value
        attr[0] = attr[0].replace(/^\s+|\s+$/g, '');
        attr[1] = attr[1].replace(/^\s+|\s+$/g, '');
        attr[1] = attr[1].replace(/^['"](.*)['"]$/g, '$1');
        result[attr[0]] = attr[1];
    }
    return result;
};
/**
 * Converts a string into a resolution object
 *
 * @param {string} resolution a string such as 3840x2160
 *
 * @return {Object} An object representing the resolution
 *
 */ const $d9ac9c5d7f472999$var$parseResolution = (resolution)=>{
    const split = resolution.split('x');
    const result = {};
    if (split[0]) result.width = parseInt(split[0], 10);
    if (split[1]) result.height = parseInt(split[1], 10);
    return result;
};
/**
 * A line-level M3U8 parser event stream. It expects to receive input one
 * line at a time and performs a context-free parse of its contents. A stream
 * interpretation of a manifest can be useful if the manifest is expected to
 * be too large to fit comfortably into memory or the entirety of the input
 * is not immediately available. Otherwise, it's probably much easier to work
 * with a regular `Parser` object.
 *
 * Produces `data` events with an object that captures the parser's
 * interpretation of the input. That object has a property `tag` that is one
 * of `uri`, `comment`, or `tag`. URIs only have a single additional
 * property, `line`, which captures the entirety of the input without
 * interpretation. Comments similarly have a single additional property
 * `text` which is the input without the leading `#`.
 *
 * Tags always have a property `tagType` which is the lower-cased version of
 * the M3U8 directive without the `#EXT` or `#EXT-X-` prefix. For instance,
 * `#EXT-X-MEDIA-SEQUENCE` becomes `media-sequence` when parsed. Unrecognized
 * tags are given the tag type `unknown` and a single additional property
 * `data` with the remainder of the input.
 *
 * @class ParseStream
 * @extends Stream
 */ class $d9ac9c5d7f472999$export$bc65cb5a6d9da573 extends (0, $240ec63f2cada8d3$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.customParsers = [];
        this.tagMappers = [];
    }
    /**
   * Parses an additional line of input.
   *
   * @param {string} line a single line of an M3U8 file to parse
   */ push(line) {
        let match;
        let event; // strip whitespace
        line = line.trim();
        if (line.length === 0) // ignore empty lines
        return;
         // URIs
        if (line[0] !== '#') {
            this.trigger('data', {
                type: 'uri',
                uri: line
            });
            return;
        } // map tags
        const newLines = this.tagMappers.reduce((acc, mapper)=>{
            const mappedLine = mapper(line); // skip if unchanged
            if (mappedLine === line) return acc;
            return acc.concat([
                mappedLine
            ]);
        }, [
            line
        ]);
        newLines.forEach((newLine)=>{
            for(let i = 0; i < this.customParsers.length; i++){
                if (this.customParsers[i].call(this, newLine)) return;
            } // Comments
            if (newLine.indexOf('#EXT') !== 0) {
                this.trigger('data', {
                    type: 'comment',
                    text: newLine.slice(1)
                });
                return;
            } // strip off any carriage returns here so the regex matching
            // doesn't have to account for them.
            newLine = newLine.replace('\r', ''); // Tags
            match = /^#EXTM3U/.exec(newLine);
            if (match) {
                this.trigger('data', {
                    type: 'tag',
                    tagType: 'm3u'
                });
                return;
            }
            match = /^#EXTINF:([0-9\.]*)?,?(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'inf'
                };
                if (match[1]) event.duration = parseFloat(match[1]);
                if (match[2]) event.title = match[2];
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-TARGETDURATION:([0-9.]*)?/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'targetduration'
                };
                if (match[1]) event.duration = parseInt(match[1], 10);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-VERSION:([0-9.]*)?/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'version'
                };
                if (match[1]) event.version = parseInt(match[1], 10);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-MEDIA-SEQUENCE:(\-?[0-9.]*)?/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'media-sequence'
                };
                if (match[1]) event.number = parseInt(match[1], 10);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-DISCONTINUITY-SEQUENCE:(\-?[0-9.]*)?/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'discontinuity-sequence'
                };
                if (match[1]) event.number = parseInt(match[1], 10);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-PLAYLIST-TYPE:(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'playlist-type'
                };
                if (match[1]) event.playlistType = match[1];
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-BYTERANGE:(.*)?$/.exec(newLine);
            if (match) {
                event = (0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))($d9ac9c5d7f472999$var$parseByterange(match[1]), {
                    type: 'tag',
                    tagType: 'byterange'
                });
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-ALLOW-CACHE:(YES|NO)?/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'allow-cache'
                };
                if (match[1]) event.allowed = !/NO/.test(match[1]);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-MAP:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'map'
                };
                if (match[1]) {
                    const attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                    if (attributes.URI) event.uri = attributes.URI;
                    if (attributes.BYTERANGE) event.byterange = $d9ac9c5d7f472999$var$parseByterange(attributes.BYTERANGE);
                }
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-STREAM-INF:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'stream-inf'
                };
                if (match[1]) {
                    event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                    if (event.attributes.RESOLUTION) event.attributes.RESOLUTION = $d9ac9c5d7f472999$var$parseResolution(event.attributes.RESOLUTION);
                    if (event.attributes.BANDWIDTH) event.attributes.BANDWIDTH = parseInt(event.attributes.BANDWIDTH, 10);
                    if (event.attributes['FRAME-RATE']) event.attributes['FRAME-RATE'] = parseFloat(event.attributes['FRAME-RATE']);
                    if (event.attributes['PROGRAM-ID']) event.attributes['PROGRAM-ID'] = parseInt(event.attributes['PROGRAM-ID'], 10);
                }
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-MEDIA:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'media'
                };
                if (match[1]) event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-ENDLIST/.exec(newLine);
            if (match) {
                this.trigger('data', {
                    type: 'tag',
                    tagType: 'endlist'
                });
                return;
            }
            match = /^#EXT-X-DISCONTINUITY/.exec(newLine);
            if (match) {
                this.trigger('data', {
                    type: 'tag',
                    tagType: 'discontinuity'
                });
                return;
            }
            match = /^#EXT-X-PROGRAM-DATE-TIME:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'program-date-time'
                };
                if (match[1]) {
                    event.dateTimeString = match[1];
                    event.dateTimeObject = new Date(match[1]);
                }
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-KEY:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'key'
                };
                if (match[1]) {
                    event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]); // parse the IV string into a Uint32Array
                    if (event.attributes.IV) {
                        if (event.attributes.IV.substring(0, 2).toLowerCase() === '0x') event.attributes.IV = event.attributes.IV.substring(2);
                        event.attributes.IV = event.attributes.IV.match(/.{8}/g);
                        event.attributes.IV[0] = parseInt(event.attributes.IV[0], 16);
                        event.attributes.IV[1] = parseInt(event.attributes.IV[1], 16);
                        event.attributes.IV[2] = parseInt(event.attributes.IV[2], 16);
                        event.attributes.IV[3] = parseInt(event.attributes.IV[3], 16);
                        event.attributes.IV = new Uint32Array(event.attributes.IV);
                    }
                }
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-START:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'start'
                };
                if (match[1]) {
                    event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                    event.attributes['TIME-OFFSET'] = parseFloat(event.attributes['TIME-OFFSET']);
                    event.attributes.PRECISE = /YES/.test(event.attributes.PRECISE);
                }
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-CUE-OUT-CONT:(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'cue-out-cont'
                };
                if (match[1]) event.data = match[1];
                else event.data = '';
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-CUE-OUT:(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'cue-out'
                };
                if (match[1]) event.data = match[1];
                else event.data = '';
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-CUE-IN:?(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'cue-in'
                };
                if (match[1]) event.data = match[1];
                else event.data = '';
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-SKIP:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'skip'
                };
                event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                if (event.attributes.hasOwnProperty('SKIPPED-SEGMENTS')) event.attributes['SKIPPED-SEGMENTS'] = parseInt(event.attributes['SKIPPED-SEGMENTS'], 10);
                if (event.attributes.hasOwnProperty('RECENTLY-REMOVED-DATERANGES')) event.attributes['RECENTLY-REMOVED-DATERANGES'] = event.attributes['RECENTLY-REMOVED-DATERANGES'].split($d9ac9c5d7f472999$var$TAB);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-PART:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'part'
                };
                event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                [
                    'DURATION'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseFloat(event.attributes[key]);
                });
                [
                    'INDEPENDENT',
                    'GAP'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = /YES/.test(event.attributes[key]);
                });
                if (event.attributes.hasOwnProperty('BYTERANGE')) event.attributes.byterange = $d9ac9c5d7f472999$var$parseByterange(event.attributes.BYTERANGE);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'server-control'
                };
                event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                [
                    'CAN-SKIP-UNTIL',
                    'PART-HOLD-BACK',
                    'HOLD-BACK'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseFloat(event.attributes[key]);
                });
                [
                    'CAN-SKIP-DATERANGES',
                    'CAN-BLOCK-RELOAD'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = /YES/.test(event.attributes[key]);
                });
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-PART-INF:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'part-inf'
                };
                event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                [
                    'PART-TARGET'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseFloat(event.attributes[key]);
                });
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'preload-hint'
                };
                event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                [
                    'BYTERANGE-START',
                    'BYTERANGE-LENGTH'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) {
                        event.attributes[key] = parseInt(event.attributes[key], 10);
                        const subkey = key === 'BYTERANGE-LENGTH' ? 'length' : 'offset';
                        event.attributes.byterange = event.attributes.byterange || {};
                        event.attributes.byterange[subkey] = event.attributes[key]; // only keep the parsed byterange object.
                        delete event.attributes[key];
                    }
                });
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'rendition-report'
                };
                event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                [
                    'LAST-MSN',
                    'LAST-PART'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseInt(event.attributes[key], 10);
                });
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-DATERANGE:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'daterange'
                };
                event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                [
                    'ID',
                    'CLASS'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = String(event.attributes[key]);
                });
                [
                    'START-DATE',
                    'END-DATE'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = new Date(event.attributes[key]);
                });
                [
                    'DURATION',
                    'PLANNED-DURATION'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseFloat(event.attributes[key]);
                });
                [
                    'END-ON-NEXT'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = /YES/i.test(event.attributes[key]);
                });
                [
                    'SCTE35-CMD',
                    ' SCTE35-OUT',
                    'SCTE35-IN'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = event.attributes[key].toString(16);
                });
                const clientAttributePattern = /^X-([A-Z]+-)+[A-Z]+$/;
                for(const key in event.attributes){
                    if (!clientAttributePattern.test(key)) continue;
                    const isHexaDecimal = /[0-9A-Fa-f]{6}/g.test(event.attributes[key]);
                    const isDecimalFloating = /^\d+(\.\d+)?$/.test(event.attributes[key]);
                    event.attributes[key] = isHexaDecimal ? event.attributes[key].toString(16) : isDecimalFloating ? parseFloat(event.attributes[key]) : String(event.attributes[key]);
                }
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-INDEPENDENT-SEGMENTS/.exec(newLine);
            if (match) {
                this.trigger('data', {
                    type: 'tag',
                    tagType: 'independent-segments'
                });
                return;
            }
            match = /^#EXT-X-I-FRAMES-ONLY/.exec(newLine);
            if (match) {
                this.trigger('data', {
                    type: 'tag',
                    tagType: 'i-frames-only'
                });
                return;
            }
            match = /^#EXT-X-CONTENT-STEERING:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'content-steering'
                };
                event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-I-FRAME-STREAM-INF:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'i-frame-playlist'
                };
                event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                if (event.attributes.URI) event.uri = event.attributes.URI;
                if (event.attributes.BANDWIDTH) event.attributes.BANDWIDTH = parseInt(event.attributes.BANDWIDTH, 10);
                if (event.attributes.RESOLUTION) event.attributes.RESOLUTION = $d9ac9c5d7f472999$var$parseResolution(event.attributes.RESOLUTION);
                if (event.attributes['AVERAGE-BANDWIDTH']) event.attributes['AVERAGE-BANDWIDTH'] = parseInt(event.attributes['AVERAGE-BANDWIDTH'], 10);
                if (event.attributes['FRAME-RATE']) event.attributes['FRAME-RATE'] = parseFloat(event.attributes['FRAME-RATE']);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-DEFINE:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'define'
                };
                event.attributes = $d9ac9c5d7f472999$var$parseAttributes(match[1]);
                this.trigger('data', event);
                return;
            } // unknown tag type
            this.trigger('data', {
                type: 'tag',
                data: newLine.slice(4)
            });
        });
    }
    /**
   * Add a parser for custom headers
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */ addParser({ expression: expression, customType: customType, dataParser: dataParser, segment: segment }) {
        if (typeof dataParser !== 'function') dataParser = (line)=>line;
        this.customParsers.push((line)=>{
            const match = expression.exec(line);
            if (match) {
                this.trigger('data', {
                    type: 'custom',
                    data: dataParser(line),
                    customType: customType,
                    segment: segment
                });
                return true;
            }
        });
    }
    /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */ addTagMapper({ expression: expression, map: map }) {
        const mapFn = (line)=>{
            if (expression.test(line)) return map(line);
            return line;
        };
        this.tagMappers.push(mapFn);
    }
}
const $d9ac9c5d7f472999$var$camelCase = (str)=>str.toLowerCase().replace(/-(\w)/g, (a)=>a[1].toUpperCase());
const $d9ac9c5d7f472999$var$camelCaseKeys = function(attributes) {
    const result = {};
    Object.keys(attributes).forEach(function(key) {
        result[$d9ac9c5d7f472999$var$camelCase(key)] = attributes[key];
    });
    return result;
}; // set SERVER-CONTROL hold back based upon targetDuration and partTargetDuration
// we need this helper because defaults are based upon targetDuration and
// partTargetDuration being set, but they may not be if SERVER-CONTROL appears before
// target durations are set.
const $d9ac9c5d7f472999$var$setHoldBack = function(manifest) {
    const { serverControl: serverControl, targetDuration: targetDuration, partTargetDuration: partTargetDuration } = manifest;
    if (!serverControl) return;
    const tag = '#EXT-X-SERVER-CONTROL';
    const hb = 'holdBack';
    const phb = 'partHoldBack';
    const minTargetDuration = targetDuration && targetDuration * 3;
    const minPartDuration = partTargetDuration && partTargetDuration * 2;
    if (targetDuration && !serverControl.hasOwnProperty(hb)) {
        serverControl[hb] = minTargetDuration;
        this.trigger('info', {
            message: `${tag} defaulting HOLD-BACK to targetDuration * 3 (${minTargetDuration}).`
        });
    }
    if (minTargetDuration && serverControl[hb] < minTargetDuration) {
        this.trigger('warn', {
            message: `${tag} clamping HOLD-BACK (${serverControl[hb]}) to targetDuration * 3 (${minTargetDuration})`
        });
        serverControl[hb] = minTargetDuration;
    } // default no part hold back to part target duration * 3
    if (partTargetDuration && !serverControl.hasOwnProperty(phb)) {
        serverControl[phb] = partTargetDuration * 3;
        this.trigger('info', {
            message: `${tag} defaulting PART-HOLD-BACK to partTargetDuration * 3 (${serverControl[phb]}).`
        });
    } // if part hold back is too small default it to part target duration * 2
    if (partTargetDuration && serverControl[phb] < minPartDuration) {
        this.trigger('warn', {
            message: `${tag} clamping PART-HOLD-BACK (${serverControl[phb]}) to partTargetDuration * 2 (${minPartDuration}).`
        });
        serverControl[phb] = minPartDuration;
    }
};
/**
 * A parser for M3U8 files. The current interpretation of the input is
 * exposed as a property `manifest` on parser objects. It's just two lines to
 * create and parse a manifest once you have the contents available as a string:
 *
 * ```js
 * var parser = new m3u8.Parser();
 * parser.push(xhr.responseText);
 * ```
 *
 * New input can later be applied to update the manifest object by calling
 * `push` again.
 *
 * The parser attempts to create a usable manifest object even if the
 * underlying input is somewhat nonsensical. It emits `info` and `warning`
 * events during the parse if it encounters input that seems invalid or
 * requires some property of the manifest object to be defaulted.
 *
 * @class Parser
 * @param {Object} [opts] Options for the constructor, needed for substitutions
 * @param {string} [opts.uri] URL to check for query params
 * @param {Object} [opts.mainDefinitions] Definitions on main playlist that can be imported
 * @extends Stream
 */ class $d9ac9c5d7f472999$export$7acfa6ed01010e37 extends (0, $240ec63f2cada8d3$export$2e2bcd8739ae039) {
    constructor(opts = {}){
        super();
        this.lineStream = new $d9ac9c5d7f472999$export$307ab5c52b11c33e();
        this.parseStream = new $d9ac9c5d7f472999$export$bc65cb5a6d9da573();
        this.lineStream.pipe(this.parseStream);
        this.mainDefinitions = opts.mainDefinitions || {};
        this.params = new URL(opts.uri, 'https://a.com').searchParams;
        this.lastProgramDateTime = null;
        /* eslint-disable consistent-this */ const self = this;
        /* eslint-enable consistent-this */ const uris = [];
        let currentUri = {}; // if specified, the active EXT-X-MAP definition
        let currentMap; // if specified, the active decryption key
        let key;
        let hasParts = false;
        const noop = function() {};
        const defaultMediaGroups = {
            'AUDIO': {},
            'VIDEO': {},
            'CLOSED-CAPTIONS': {},
            'SUBTITLES': {}
        }; // This is the Widevine UUID from DASH IF IOP. The same exact string is
        // used in MPDs with Widevine encrypted streams.
        const widevineUuid = 'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed'; // group segments into numbered timelines delineated by discontinuities
        let currentTimeline = 0; // the manifest is empty until the parse stream begins delivering data
        this.manifest = {
            allowCache: true,
            discontinuityStarts: [],
            dateRanges: [],
            iFramePlaylists: [],
            segments: []
        }; // keep track of the last seen segment's byte range end, as segments are not required
        // to provide the offset, in which case it defaults to the next byte after the
        // previous segment
        let lastByterangeEnd = 0; // keep track of the last seen part's byte range end.
        let lastPartByterangeEnd = 0;
        const dateRangeTags = {};
        this.on('end', ()=>{
            // only add preloadSegment if we don't yet have a uri for it.
            // and we actually have parts/preloadHints
            if (currentUri.uri || !currentUri.parts && !currentUri.preloadHints) return;
            if (!currentUri.map && currentMap) currentUri.map = currentMap;
            if (!currentUri.key && key) currentUri.key = key;
            if (!currentUri.timeline && typeof currentTimeline === 'number') currentUri.timeline = currentTimeline;
            this.manifest.preloadSegment = currentUri;
        }); // update the manifest with the m3u8 entry from the parse stream
        this.parseStream.on('data', function(entry) {
            let mediaGroup;
            let rendition; // Replace variables in uris and attributes as defined in #EXT-X-DEFINE tags
            if (self.manifest.definitions) for(const def in self.manifest.definitions){
                if (entry.uri) entry.uri = entry.uri.replace(`{$${def}}`, self.manifest.definitions[def]);
                if (entry.attributes) {
                    for(const attr in entry.attributes)if (typeof entry.attributes[attr] === 'string') entry.attributes[attr] = entry.attributes[attr].replace(`{$${def}}`, self.manifest.definitions[def]);
                }
            }
            ({
                tag () {
                    // switch based on the tag type
                    (({
                        version () {
                            if (entry.version) this.manifest.version = entry.version;
                        },
                        'allow-cache' () {
                            this.manifest.allowCache = entry.allowed;
                            if (!('allowed' in entry)) {
                                this.trigger('info', {
                                    message: 'defaulting allowCache to YES'
                                });
                                this.manifest.allowCache = true;
                            }
                        },
                        byterange () {
                            const byterange = {};
                            if ('length' in entry) {
                                currentUri.byterange = byterange;
                                byterange.length = entry.length;
                                if (!('offset' in entry)) /*
                   * From the latest spec (as of this writing):
                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.2
                   *
                   * Same text since EXT-X-BYTERANGE's introduction in draft 7:
                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-07#section-3.3.1)
                   *
                   * "If o [offset] is not present, the sub-range begins at the next byte
                   * following the sub-range of the previous media segment."
                   */ entry.offset = lastByterangeEnd;
                            }
                            if ('offset' in entry) {
                                currentUri.byterange = byterange;
                                byterange.offset = entry.offset;
                            }
                            lastByterangeEnd = byterange.offset + byterange.length;
                        },
                        endlist () {
                            this.manifest.endList = true;
                        },
                        inf () {
                            if (!('mediaSequence' in this.manifest)) {
                                this.manifest.mediaSequence = 0;
                                this.trigger('info', {
                                    message: 'defaulting media sequence to zero'
                                });
                            }
                            if (!('discontinuitySequence' in this.manifest)) {
                                this.manifest.discontinuitySequence = 0;
                                this.trigger('info', {
                                    message: 'defaulting discontinuity sequence to zero'
                                });
                            }
                            if (entry.title) currentUri.title = entry.title;
                            if (entry.duration > 0) currentUri.duration = entry.duration;
                            if (entry.duration === 0) {
                                currentUri.duration = 0.01;
                                this.trigger('info', {
                                    message: 'updating zero segment duration to a small value'
                                });
                            }
                            this.manifest.segments = uris;
                        },
                        key () {
                            if (!entry.attributes) {
                                this.trigger('warn', {
                                    message: 'ignoring key declaration without attribute list'
                                });
                                return;
                            } // clear the active encryption key
                            if (entry.attributes.METHOD === 'NONE') {
                                key = null;
                                return;
                            }
                            if (!entry.attributes.URI) {
                                this.trigger('warn', {
                                    message: 'ignoring key declaration without URI'
                                });
                                return;
                            }
                            if (entry.attributes.KEYFORMAT === 'com.apple.streamingkeydelivery') {
                                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.
                                this.manifest.contentProtection['com.apple.fps.1_0'] = {
                                    attributes: entry.attributes
                                };
                                return;
                            }
                            if (entry.attributes.KEYFORMAT === 'com.microsoft.playready') {
                                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.
                                this.manifest.contentProtection['com.microsoft.playready'] = {
                                    uri: entry.attributes.URI
                                };
                                return;
                            } // check if the content is encrypted for Widevine
                            // Widevine/HLS spec: https://storage.googleapis.com/wvdocs/Widevine_DRM_HLS.pdf
                            if (entry.attributes.KEYFORMAT === widevineUuid) {
                                const VALID_METHODS = [
                                    'SAMPLE-AES',
                                    'SAMPLE-AES-CTR',
                                    'SAMPLE-AES-CENC'
                                ];
                                if (VALID_METHODS.indexOf(entry.attributes.METHOD) === -1) {
                                    this.trigger('warn', {
                                        message: 'invalid key method provided for Widevine'
                                    });
                                    return;
                                }
                                if (entry.attributes.METHOD === 'SAMPLE-AES-CENC') this.trigger('warn', {
                                    message: 'SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead'
                                });
                                if (entry.attributes.URI.substring(0, 23) !== 'data:text/plain;base64,') {
                                    this.trigger('warn', {
                                        message: 'invalid key URI provided for Widevine'
                                    });
                                    return;
                                }
                                if (!(entry.attributes.KEYID && entry.attributes.KEYID.substring(0, 2) === '0x')) {
                                    this.trigger('warn', {
                                        message: 'invalid key ID provided for Widevine'
                                    });
                                    return;
                                } // if Widevine key attributes are valid, store them as `contentProtection`
                                // on the manifest to emulate Widevine tag structure in a DASH mpd
                                this.manifest.contentProtection = this.manifest.contentProtection || {};
                                this.manifest.contentProtection['com.widevine.alpha'] = {
                                    attributes: {
                                        schemeIdUri: entry.attributes.KEYFORMAT,
                                        // remove '0x' from the key id string
                                        keyId: entry.attributes.KEYID.substring(2)
                                    },
                                    // decode the base64-encoded PSSH box
                                    pssh: (0, $39570e0c51fe4cb5$export$2e2bcd8739ae039)(entry.attributes.URI.split(',')[1])
                                };
                                return;
                            }
                            if (!entry.attributes.METHOD) this.trigger('warn', {
                                message: 'defaulting key method to AES-128'
                            });
                             // setup an encryption key for upcoming segments
                            key = {
                                method: entry.attributes.METHOD || 'AES-128',
                                uri: entry.attributes.URI
                            };
                            if (typeof entry.attributes.IV !== 'undefined') key.iv = entry.attributes.IV;
                        },
                        'media-sequence' () {
                            if (!isFinite(entry.number)) {
                                this.trigger('warn', {
                                    message: 'ignoring invalid media sequence: ' + entry.number
                                });
                                return;
                            }
                            this.manifest.mediaSequence = entry.number;
                        },
                        'discontinuity-sequence' () {
                            if (!isFinite(entry.number)) {
                                this.trigger('warn', {
                                    message: 'ignoring invalid discontinuity sequence: ' + entry.number
                                });
                                return;
                            }
                            this.manifest.discontinuitySequence = entry.number;
                            currentTimeline = entry.number;
                        },
                        'playlist-type' () {
                            if (!/VOD|EVENT/.test(entry.playlistType)) {
                                this.trigger('warn', {
                                    message: 'ignoring unknown playlist type: ' + entry.playlist
                                });
                                return;
                            }
                            this.manifest.playlistType = entry.playlistType;
                        },
                        map () {
                            currentMap = {};
                            if (entry.uri) currentMap.uri = entry.uri;
                            if (entry.byterange) currentMap.byterange = entry.byterange;
                            if (key) currentMap.key = key;
                        },
                        'stream-inf' () {
                            this.manifest.playlists = uris;
                            this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
                            if (!entry.attributes) {
                                this.trigger('warn', {
                                    message: 'ignoring empty stream-inf attributes'
                                });
                                return;
                            }
                            if (!currentUri.attributes) currentUri.attributes = {};
                            (0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))(currentUri.attributes, entry.attributes);
                        },
                        media () {
                            this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
                            if (!(entry.attributes && entry.attributes.TYPE && entry.attributes['GROUP-ID'] && entry.attributes.NAME)) {
                                this.trigger('warn', {
                                    message: 'ignoring incomplete or missing media group'
                                });
                                return;
                            } // find the media group, creating defaults as necessary
                            const mediaGroupType = this.manifest.mediaGroups[entry.attributes.TYPE];
                            mediaGroupType[entry.attributes['GROUP-ID']] = mediaGroupType[entry.attributes['GROUP-ID']] || {};
                            mediaGroup = mediaGroupType[entry.attributes['GROUP-ID']]; // collect the rendition metadata
                            rendition = {
                                default: /yes/i.test(entry.attributes.DEFAULT)
                            };
                            if (rendition.default) rendition.autoselect = true;
                            else rendition.autoselect = /yes/i.test(entry.attributes.AUTOSELECT);
                            if (entry.attributes.LANGUAGE) rendition.language = entry.attributes.LANGUAGE;
                            if (entry.attributes.URI) rendition.uri = entry.attributes.URI;
                            if (entry.attributes['INSTREAM-ID']) rendition.instreamId = entry.attributes['INSTREAM-ID'];
                            if (entry.attributes.CHARACTERISTICS) rendition.characteristics = entry.attributes.CHARACTERISTICS;
                            if (entry.attributes.FORCED) rendition.forced = /yes/i.test(entry.attributes.FORCED);
                             // insert the new rendition
                            mediaGroup[entry.attributes.NAME] = rendition;
                        },
                        discontinuity () {
                            currentTimeline += 1;
                            currentUri.discontinuity = true;
                            this.manifest.discontinuityStarts.push(uris.length);
                        },
                        'program-date-time' () {
                            if (typeof this.manifest.dateTimeString === 'undefined') {
                                // PROGRAM-DATE-TIME is a media-segment tag, but for backwards
                                // compatibility, we add the first occurence of the PROGRAM-DATE-TIME tag
                                // to the manifest object
                                // TODO: Consider removing this in future major version
                                this.manifest.dateTimeString = entry.dateTimeString;
                                this.manifest.dateTimeObject = entry.dateTimeObject;
                            }
                            currentUri.dateTimeString = entry.dateTimeString;
                            currentUri.dateTimeObject = entry.dateTimeObject;
                            const { lastProgramDateTime: lastProgramDateTime } = this;
                            this.lastProgramDateTime = new Date(entry.dateTimeString).getTime(); // We should extrapolate Program Date Time backward only during first program date time occurrence.
                            // Once we have at least one program date time point, we can always extrapolate it forward using lastProgramDateTime reference.
                            if (lastProgramDateTime === null) // Extrapolate Program Date Time backward
                            // Since it is first program date time occurrence we're assuming that
                            // all this.manifest.segments have no program date time info
                            this.manifest.segments.reduceRight((programDateTime, segment)=>{
                                segment.programDateTime = programDateTime - segment.duration * 1000;
                                return segment.programDateTime;
                            }, this.lastProgramDateTime);
                        },
                        targetduration () {
                            if (!isFinite(entry.duration) || entry.duration < 0) {
                                this.trigger('warn', {
                                    message: 'ignoring invalid target duration: ' + entry.duration
                                });
                                return;
                            }
                            this.manifest.targetDuration = entry.duration;
                            $d9ac9c5d7f472999$var$setHoldBack.call(this, this.manifest);
                        },
                        start () {
                            if (!entry.attributes || isNaN(entry.attributes['TIME-OFFSET'])) {
                                this.trigger('warn', {
                                    message: 'ignoring start declaration without appropriate attribute list'
                                });
                                return;
                            }
                            this.manifest.start = {
                                timeOffset: entry.attributes['TIME-OFFSET'],
                                precise: entry.attributes.PRECISE
                            };
                        },
                        'cue-out' () {
                            currentUri.cueOut = entry.data;
                        },
                        'cue-out-cont' () {
                            currentUri.cueOutCont = entry.data;
                        },
                        'cue-in' () {
                            currentUri.cueIn = entry.data;
                        },
                        'skip' () {
                            this.manifest.skip = $d9ac9c5d7f472999$var$camelCaseKeys(entry.attributes);
                            this.warnOnMissingAttributes_('#EXT-X-SKIP', entry.attributes, [
                                'SKIPPED-SEGMENTS'
                            ]);
                        },
                        'part' () {
                            hasParts = true; // parts are always specifed before a segment
                            const segmentIndex = this.manifest.segments.length;
                            const part = $d9ac9c5d7f472999$var$camelCaseKeys(entry.attributes);
                            currentUri.parts = currentUri.parts || [];
                            currentUri.parts.push(part);
                            if (part.byterange) {
                                if (!part.byterange.hasOwnProperty('offset')) part.byterange.offset = lastPartByterangeEnd;
                                lastPartByterangeEnd = part.byterange.offset + part.byterange.length;
                            }
                            const partIndex = currentUri.parts.length - 1;
                            this.warnOnMissingAttributes_(`#EXT-X-PART #${partIndex} for segment #${segmentIndex}`, entry.attributes, [
                                'URI',
                                'DURATION'
                            ]);
                            if (this.manifest.renditionReports) this.manifest.renditionReports.forEach((r, i)=>{
                                if (!r.hasOwnProperty('lastPart')) this.trigger('warn', {
                                    message: `#EXT-X-RENDITION-REPORT #${i} lacks required attribute(s): LAST-PART`
                                });
                            });
                        },
                        'server-control' () {
                            const attrs = this.manifest.serverControl = $d9ac9c5d7f472999$var$camelCaseKeys(entry.attributes);
                            if (!attrs.hasOwnProperty('canBlockReload')) {
                                attrs.canBlockReload = false;
                                this.trigger('info', {
                                    message: '#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false'
                                });
                            }
                            $d9ac9c5d7f472999$var$setHoldBack.call(this, this.manifest);
                            if (attrs.canSkipDateranges && !attrs.hasOwnProperty('canSkipUntil')) this.trigger('warn', {
                                message: '#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set'
                            });
                        },
                        'preload-hint' () {
                            // parts are always specifed before a segment
                            const segmentIndex = this.manifest.segments.length;
                            const hint = $d9ac9c5d7f472999$var$camelCaseKeys(entry.attributes);
                            const isPart = hint.type && hint.type === 'PART';
                            currentUri.preloadHints = currentUri.preloadHints || [];
                            currentUri.preloadHints.push(hint);
                            if (hint.byterange) {
                                if (!hint.byterange.hasOwnProperty('offset')) {
                                    // use last part byterange end or zero if not a part.
                                    hint.byterange.offset = isPart ? lastPartByterangeEnd : 0;
                                    if (isPart) lastPartByterangeEnd = hint.byterange.offset + hint.byterange.length;
                                }
                            }
                            const index = currentUri.preloadHints.length - 1;
                            this.warnOnMissingAttributes_(`#EXT-X-PRELOAD-HINT #${index} for segment #${segmentIndex}`, entry.attributes, [
                                'TYPE',
                                'URI'
                            ]);
                            if (!hint.type) return;
                             // search through all preload hints except for the current one for
                            // a duplicate type.
                            for(let i = 0; i < currentUri.preloadHints.length - 1; i++){
                                const otherHint = currentUri.preloadHints[i];
                                if (!otherHint.type) continue;
                                if (otherHint.type === hint.type) this.trigger('warn', {
                                    message: `#EXT-X-PRELOAD-HINT #${index} for segment #${segmentIndex} has the same TYPE ${hint.type} as preload hint #${i}`
                                });
                            }
                        },
                        'rendition-report' () {
                            const report = $d9ac9c5d7f472999$var$camelCaseKeys(entry.attributes);
                            this.manifest.renditionReports = this.manifest.renditionReports || [];
                            this.manifest.renditionReports.push(report);
                            const index = this.manifest.renditionReports.length - 1;
                            const required = [
                                'LAST-MSN',
                                'URI'
                            ];
                            if (hasParts) required.push('LAST-PART');
                            this.warnOnMissingAttributes_(`#EXT-X-RENDITION-REPORT #${index}`, entry.attributes, required);
                        },
                        'part-inf' () {
                            this.manifest.partInf = $d9ac9c5d7f472999$var$camelCaseKeys(entry.attributes);
                            this.warnOnMissingAttributes_('#EXT-X-PART-INF', entry.attributes, [
                                'PART-TARGET'
                            ]);
                            if (this.manifest.partInf.partTarget) this.manifest.partTargetDuration = this.manifest.partInf.partTarget;
                            $d9ac9c5d7f472999$var$setHoldBack.call(this, this.manifest);
                        },
                        'daterange' () {
                            this.manifest.dateRanges.push($d9ac9c5d7f472999$var$camelCaseKeys(entry.attributes));
                            const index = this.manifest.dateRanges.length - 1;
                            this.warnOnMissingAttributes_(`#EXT-X-DATERANGE #${index}`, entry.attributes, [
                                'ID',
                                'START-DATE'
                            ]);
                            const dateRange = this.manifest.dateRanges[index];
                            if (dateRange.endDate && dateRange.startDate && new Date(dateRange.endDate) < new Date(dateRange.startDate)) this.trigger('warn', {
                                message: 'EXT-X-DATERANGE END-DATE must be equal to or later than the value of the START-DATE'
                            });
                            if (dateRange.duration && dateRange.duration < 0) this.trigger('warn', {
                                message: 'EXT-X-DATERANGE DURATION must not be negative'
                            });
                            if (dateRange.plannedDuration && dateRange.plannedDuration < 0) this.trigger('warn', {
                                message: 'EXT-X-DATERANGE PLANNED-DURATION must not be negative'
                            });
                            const endOnNextYes = !!dateRange.endOnNext;
                            if (endOnNextYes && !dateRange.class) this.trigger('warn', {
                                message: 'EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must have a CLASS attribute'
                            });
                            if (endOnNextYes && (dateRange.duration || dateRange.endDate)) this.trigger('warn', {
                                message: 'EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must not contain DURATION or END-DATE attributes'
                            });
                            if (dateRange.duration && dateRange.endDate) {
                                const startDate = dateRange.startDate;
                                const newDateInSeconds = startDate.getTime() + dateRange.duration * 1000;
                                this.manifest.dateRanges[index].endDate = new Date(newDateInSeconds);
                            }
                            if (!dateRangeTags[dateRange.id]) dateRangeTags[dateRange.id] = dateRange;
                            else {
                                for(const attribute in dateRangeTags[dateRange.id])if (!!dateRange[attribute] && JSON.stringify(dateRangeTags[dateRange.id][attribute]) !== JSON.stringify(dateRange[attribute])) {
                                    this.trigger('warn', {
                                        message: 'EXT-X-DATERANGE tags with the same ID in a playlist must have the same attributes values'
                                    });
                                    break;
                                }
                                 // if tags with the same ID do not have conflicting attributes, merge them
                                const dateRangeWithSameId = this.manifest.dateRanges.findIndex((dateRangeToFind)=>dateRangeToFind.id === dateRange.id);
                                this.manifest.dateRanges[dateRangeWithSameId] = (0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))(this.manifest.dateRanges[dateRangeWithSameId], dateRange);
                                dateRangeTags[dateRange.id] = (0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))(dateRangeTags[dateRange.id], dateRange); // after merging, delete the duplicate dateRange that was added last
                                this.manifest.dateRanges.pop();
                            }
                        },
                        'independent-segments' () {
                            this.manifest.independentSegments = true;
                        },
                        'i-frames-only' () {
                            this.manifest.iFramesOnly = true;
                            this.requiredCompatibilityversion(this.manifest.version, 4);
                        },
                        'content-steering' () {
                            this.manifest.contentSteering = $d9ac9c5d7f472999$var$camelCaseKeys(entry.attributes);
                            this.warnOnMissingAttributes_('#EXT-X-CONTENT-STEERING', entry.attributes, [
                                'SERVER-URI'
                            ]);
                        },
                        /** @this {Parser} */ define () {
                            this.manifest.definitions = this.manifest.definitions || {};
                            const addDef = (n, v)=>{
                                if (n in this.manifest.definitions) {
                                    // An EXT-X-DEFINE tag MUST NOT specify the same Variable Name as any other
                                    // EXT-X-DEFINE tag in the same Playlist.  Parsers that encounter duplicate
                                    // Variable Name declarations MUST fail to parse the Playlist.
                                    this.trigger('error', {
                                        message: `EXT-X-DEFINE: Duplicate name ${n}`
                                    });
                                    return;
                                }
                                this.manifest.definitions[n] = v;
                            };
                            if ('QUERYPARAM' in entry.attributes) {
                                if ('NAME' in entry.attributes || 'IMPORT' in entry.attributes) {
                                    // An EXT-X-DEFINE tag MUST contain either a NAME, an IMPORT, or a
                                    // QUERYPARAM attribute, but only one of the three.  Otherwise, the
                                    // client MUST fail to parse the Playlist.
                                    this.trigger('error', {
                                        message: 'EXT-X-DEFINE: Invalid attributes'
                                    });
                                    return;
                                }
                                const val = this.params.get(entry.attributes.QUERYPARAM);
                                if (!val) {
                                    // If the QUERYPARAM attribute value does not match any query parameter in
                                    // the URI or the matching parameter has no associated value, the parser
                                    // MUST fail to parse the Playlist.  If more than one parameter matches,
                                    // any of the associated values MAY be used.
                                    this.trigger('error', {
                                        message: `EXT-X-DEFINE: No query param ${entry.attributes.QUERYPARAM}`
                                    });
                                    return;
                                }
                                addDef(entry.attributes.QUERYPARAM, decodeURIComponent(val));
                                return;
                            }
                            if ('NAME' in entry.attributes) {
                                if ('IMPORT' in entry.attributes) {
                                    // An EXT-X-DEFINE tag MUST contain either a NAME, an IMPORT, or a
                                    // QUERYPARAM attribute, but only one of the three.  Otherwise, the
                                    // client MUST fail to parse the Playlist.
                                    this.trigger('error', {
                                        message: 'EXT-X-DEFINE: Invalid attributes'
                                    });
                                    return;
                                }
                                if (!('VALUE' in entry.attributes) || typeof entry.attributes.VALUE !== 'string') {
                                    // This attribute is REQUIRED if the EXT-X-DEFINE tag has a NAME attribute.
                                    // The quoted-string MAY be empty.
                                    this.trigger('error', {
                                        message: `EXT-X-DEFINE: No value for ${entry.attributes.NAME}`
                                    });
                                    return;
                                }
                                addDef(entry.attributes.NAME, entry.attributes.VALUE);
                                return;
                            }
                            if ('IMPORT' in entry.attributes) {
                                if (!this.mainDefinitions[entry.attributes.IMPORT]) {
                                    // Covers two conditions, as mainDefinitions will always be empty on main
                                    //
                                    // EXT-X-DEFINE tags containing the IMPORT attribute MUST NOT occur in
                                    // Multivariant Playlists; they are only allowed in Media Playlists.
                                    //
                                    // If the IMPORT attribute value does not match any Variable Name in the
                                    // Multivariant Playlist, or if the Media Playlist loaded from a
                                    // Multivariant Playlist, the parser MUST fail the Playlist.
                                    this.trigger('error', {
                                        message: `EXT-X-DEFINE: No value ${entry.attributes.IMPORT} to import, or IMPORT used on main playlist`
                                    });
                                    return;
                                }
                                addDef(entry.attributes.IMPORT, this.mainDefinitions[entry.attributes.IMPORT]);
                                return;
                            } // An EXT-X-DEFINE tag MUST contain either a NAME, an IMPORT, or a QUERYPARAM
                            // attribute, but only one of the three.  Otherwise, the client MUST fail to
                            // parse the Playlist.
                            this.trigger('error', {
                                message: 'EXT-X-DEFINE: No attribute'
                            });
                        },
                        'i-frame-playlist' () {
                            this.manifest.iFramePlaylists.push({
                                attributes: entry.attributes,
                                uri: entry.uri,
                                timeline: currentTimeline
                            });
                            this.warnOnMissingAttributes_('#EXT-X-I-FRAME-STREAM-INF', entry.attributes, [
                                'BANDWIDTH',
                                'URI'
                            ]);
                        }
                    })[entry.tagType] || noop).call(self);
                },
                uri () {
                    currentUri.uri = entry.uri;
                    uris.push(currentUri); // if no explicit duration was declared, use the target duration
                    if (this.manifest.targetDuration && !('duration' in currentUri)) {
                        this.trigger('warn', {
                            message: 'defaulting segment duration to the target duration'
                        });
                        currentUri.duration = this.manifest.targetDuration;
                    } // annotate with encryption information, if necessary
                    if (key) currentUri.key = key;
                    currentUri.timeline = currentTimeline; // annotate with initialization segment information, if necessary
                    if (currentMap) currentUri.map = currentMap;
                     // reset the last byterange end as it needs to be 0 between parts
                    lastPartByterangeEnd = 0; // Once we have at least one program date time we can always extrapolate it forward
                    if (this.lastProgramDateTime !== null) {
                        currentUri.programDateTime = this.lastProgramDateTime;
                        this.lastProgramDateTime += currentUri.duration * 1000;
                    } // prepare for the next URI
                    currentUri = {};
                },
                comment () {},
                custom () {
                    // if this is segment-level data attach the output to the segment
                    if (entry.segment) {
                        currentUri.custom = currentUri.custom || {};
                        currentUri.custom[entry.customType] = entry.data; // if this is manifest-level data attach to the top level manifest object
                    } else {
                        this.manifest.custom = this.manifest.custom || {};
                        this.manifest.custom[entry.customType] = entry.data;
                    }
                }
            })[entry.type].call(self);
        });
    }
    requiredCompatibilityversion(currentVersion, targetVersion) {
        if (currentVersion < targetVersion || !currentVersion) this.trigger('warn', {
            message: `manifest must be at least version ${targetVersion}`
        });
    }
    warnOnMissingAttributes_(identifier, attributes, required) {
        const missing = [];
        required.forEach(function(key) {
            if (!attributes.hasOwnProperty(key)) missing.push(key);
        });
        if (missing.length) this.trigger('warn', {
            message: `${identifier} lacks required attribute(s): ${missing.join(', ')}`
        });
    }
    /**
   * Parse the input string and update the manifest object.
   *
   * @param {string} chunk a potentially incomplete portion of the manifest
   */ push(chunk) {
        this.lineStream.push(chunk);
    }
    /**
   * Flush any remaining input. This can be handy if the last line of an M3U8
   * manifest did not contain a trailing newline but the file has been
   * completely received.
   */ end() {
        // flush any buffered input
        this.lineStream.push('\n');
        if (this.manifest.dateRanges.length && this.lastProgramDateTime === null) this.trigger('warn', {
            message: 'A playlist with EXT-X-DATERANGE tag must contain atleast one EXT-X-PROGRAM-DATE-TIME tag'
        });
        this.lastProgramDateTime = null;
        this.trigger('end');
    }
    /**
   * Add an additional parser for non-standard tags
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */ addParser(options) {
        this.parseStream.addParser(options);
    }
    /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */ addTagMapper(options) {
        this.parseStream.addTagMapper(options);
    }
}



var $hYfPi = parcelRequire("hYfPi");
var $34bf5acfb37ee851$var$regexs = {
    // to determine mime types
    mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
    webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
    ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
    // to determine if a codec is audio or video
    video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
    audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
    text: /^(stpp.ttml.im1t)/,
    // mux.js support regex
    muxerVideo: /^(avc0?1)/,
    muxerAudio: /^(mp4a)/,
    // match nothing as muxer does not support text right now.
    // there cannot never be a character before the start of a string
    // so this matches nothing.
    muxerText: /a^/
};
var $34bf5acfb37ee851$var$mediaTypes = [
    'video',
    'audio',
    'text'
];
var $34bf5acfb37ee851$var$upperMediaTypes = [
    'Video',
    'Audio',
    'Text'
];
var $34bf5acfb37ee851$export$4e61c3c458a5b005 = function translateLegacyCodec(codec) {
    if (!codec) return codec;
    return codec.replace(/avc1\.(\d+)\.(\d+)/i, function(orig, profile, avcLevel) {
        var profileHex = ('00' + Number(profile).toString(16)).slice(-2);
        var avcLevelHex = ('00' + Number(avcLevel).toString(16)).slice(-2);
        return 'avc1.' + profileHex + '00' + avcLevelHex;
    });
};
var $34bf5acfb37ee851$export$2fa1fd5760053cdc = function translateLegacyCodecs(codecs) {
    return codecs.map($34bf5acfb37ee851$export$4e61c3c458a5b005);
};
var $34bf5acfb37ee851$export$ff37541a73872ef0 = function mapLegacyAvcCodecs(codecString) {
    return codecString.replace(/avc1\.(\d+)\.(\d+)/i, function(match) {
        return $34bf5acfb37ee851$export$2fa1fd5760053cdc([
            match
        ])[0];
    });
};
var $34bf5acfb37ee851$export$56679b562aa2891c = function parseCodecs(codecString) {
    if (codecString === void 0) codecString = '';
    var codecs = codecString.split(',');
    var result = [];
    codecs.forEach(function(codec) {
        codec = codec.trim();
        var codecType;
        $34bf5acfb37ee851$var$mediaTypes.forEach(function(name) {
            var match = $34bf5acfb37ee851$var$regexs[name].exec(codec.toLowerCase());
            if (!match || match.length <= 1) return;
            codecType = name; // maintain codec case
            var type = codec.substring(0, match[1].length);
            var details = codec.replace(type, '');
            result.push({
                type: type,
                details: details,
                mediaType: name
            });
        });
        if (!codecType) result.push({
            type: codec,
            details: '',
            mediaType: 'unknown'
        });
    });
    return result;
};
var $34bf5acfb37ee851$export$e192782a4d0b5c5c = function codecsFromDefault(master, audioGroupId) {
    if (!master.mediaGroups.AUDIO || !audioGroupId) return null;
    var audioGroup = master.mediaGroups.AUDIO[audioGroupId];
    if (!audioGroup) return null;
    for(var name in audioGroup){
        var audioType = audioGroup[name];
        if (audioType.default && audioType.playlists) // codec should be the same for all playlists within the audio type
        return $34bf5acfb37ee851$export$56679b562aa2891c(audioType.playlists[0].attributes.CODECS);
    }
    return null;
};
var $34bf5acfb37ee851$export$601d10c6a66cb34c = function isVideoCodec(codec) {
    if (codec === void 0) codec = '';
    return $34bf5acfb37ee851$var$regexs.video.test(codec.trim().toLowerCase());
};
var $34bf5acfb37ee851$export$c642d74e895e3217 = function isAudioCodec(codec) {
    if (codec === void 0) codec = '';
    return $34bf5acfb37ee851$var$regexs.audio.test(codec.trim().toLowerCase());
};
var $34bf5acfb37ee851$export$256d4a55aa322b7e = function isTextCodec(codec) {
    if (codec === void 0) codec = '';
    return $34bf5acfb37ee851$var$regexs.text.test(codec.trim().toLowerCase());
};
var $34bf5acfb37ee851$export$4b64fc0a026b9981 = function getMimeForCodec(codecString) {
    if (!codecString || typeof codecString !== 'string') return;
    var codecs = codecString.toLowerCase().split(',').map(function(c) {
        return $34bf5acfb37ee851$export$4e61c3c458a5b005(c.trim());
    }); // default to video type
    var type = 'video'; // only change to audio type if the only codec we have is
    // audio
    if (codecs.length === 1 && $34bf5acfb37ee851$export$c642d74e895e3217(codecs[0])) type = 'audio';
    else if (codecs.length === 1 && $34bf5acfb37ee851$export$256d4a55aa322b7e(codecs[0])) // text uses application/<container> for now
    type = 'application';
     // default the container to mp4
    var container = 'mp4'; // every codec must be able to go into the container
    // for that container to be the correct one
    if (codecs.every(function(c) {
        return $34bf5acfb37ee851$var$regexs.mp4.test(c);
    })) container = 'mp4';
    else if (codecs.every(function(c) {
        return $34bf5acfb37ee851$var$regexs.webm.test(c);
    })) container = 'webm';
    else if (codecs.every(function(c) {
        return $34bf5acfb37ee851$var$regexs.ogg.test(c);
    })) container = 'ogg';
    return type + "/" + container + ";codecs=\"" + codecString + "\"";
};
var $34bf5acfb37ee851$export$3ee949df8fbc592f = function browserSupportsCodec(codecString, withMMS) {
    if (codecString === void 0) codecString = '';
    if (withMMS === void 0) withMMS = false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).MediaSource && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).MediaSource.isTypeSupported && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).MediaSource.isTypeSupported($34bf5acfb37ee851$export$4b64fc0a026b9981(codecString)) || withMMS && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).ManagedMediaSource && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).ManagedMediaSource.isTypeSupported && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).ManagedMediaSource.isTypeSupported($34bf5acfb37ee851$export$4b64fc0a026b9981(codecString)) || false;
};
var $34bf5acfb37ee851$export$614fda2d02e4a9d7 = function muxerSupportsCodec(codecString) {
    if (codecString === void 0) codecString = '';
    return codecString.toLowerCase().split(',').every(function(codec) {
        codec = codec.trim(); // any match is supported.
        for(var i = 0; i < $34bf5acfb37ee851$var$upperMediaTypes.length; i++){
            var type = $34bf5acfb37ee851$var$upperMediaTypes[i];
            if ($34bf5acfb37ee851$var$regexs["muxer" + type].test(codec)) return true;
        }
        return false;
    });
};
var $34bf5acfb37ee851$export$615de1d7b49571dc = 'mp4a.40.2';
var $34bf5acfb37ee851$export$77d6196664053611 = 'avc1.4d400d';


var $fd4a1d4c2e8fc2b7$var$MPEGURL_REGEX = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i;
var $fd4a1d4c2e8fc2b7$var$DASH_REGEX = /^application\/dash\+xml/i;
var $fd4a1d4c2e8fc2b7$export$c4f0bf48244d4c05 = function simpleTypeFromSourceType(type) {
    if ($fd4a1d4c2e8fc2b7$var$MPEGURL_REGEX.test(type)) return 'hls';
    if ($fd4a1d4c2e8fc2b7$var$DASH_REGEX.test(type)) return 'dash';
     // Denotes the special case of a manifest object passed to http-streaming instead of a
    // source URL.
    //
    // See https://en.wikipedia.org/wiki/Media_type for details on specifying media types.
    //
    // In this case, vnd stands for vendor, video.js for the organization, VHS for this
    // project, and the +json suffix identifies the structure of the media type.
    if (type === 'application/vnd.videojs.vhs+json') return 'vhs-json';
    return null;
};



var $hYfPi = parcelRequire("hYfPi");
var $0cb67f3f52413d92$var$repeat = function repeat(str, len) {
    var acc = '';
    while(len--)acc += str;
    return acc;
}; // count the number of bits it would take to represent a number
var $0cb67f3f52413d92$export$33de6ea056a4cdbb = function countBits(x) {
    return x.toString(2).length;
}; // count the number of whole bytes it would take to represent a number
var $0cb67f3f52413d92$export$42cd407004f34122 = function countBytes(x) {
    return Math.ceil($0cb67f3f52413d92$export$33de6ea056a4cdbb(x) / 8);
};
var $0cb67f3f52413d92$export$36cf564d487b5178 = function padStart(b, len, str) {
    if (str === void 0) str = ' ';
    return ($0cb67f3f52413d92$var$repeat(str, len) + b.toString()).slice(-len);
};
var $0cb67f3f52413d92$export$ef047080f6507ccc = function isArrayBufferView(obj) {
    if (ArrayBuffer.isView === 'function') return ArrayBuffer.isView(obj);
    return obj && obj.buffer instanceof ArrayBuffer;
};
var $0cb67f3f52413d92$export$b119cc7e1840e59c = function isTypedArray(obj) {
    return $0cb67f3f52413d92$export$ef047080f6507ccc(obj);
};
var $0cb67f3f52413d92$export$63c3de442720649 = function toUint8(bytes) {
    if (bytes instanceof Uint8Array) return bytes;
    if (!Array.isArray(bytes) && !$0cb67f3f52413d92$export$b119cc7e1840e59c(bytes) && !(bytes instanceof ArrayBuffer)) {
        // any non-number or NaN leads to empty uint8array
        // eslint-disable-next-line
        if (typeof bytes !== 'number' || typeof bytes === 'number' && bytes !== bytes) bytes = 0;
        else bytes = [
            bytes
        ];
    }
    return new Uint8Array(bytes && bytes.buffer || bytes, bytes && bytes.byteOffset || 0, bytes && bytes.byteLength || 0);
};
var $0cb67f3f52413d92$export$f4915efbb94d4d01 = function toHexString(bytes) {
    bytes = $0cb67f3f52413d92$export$63c3de442720649(bytes);
    var str = '';
    for(var i = 0; i < bytes.length; i++)str += $0cb67f3f52413d92$export$36cf564d487b5178(bytes[i].toString(16), 2, '0');
    return str;
};
var $0cb67f3f52413d92$export$9a7d75f397723250 = function toBinaryString(bytes) {
    bytes = $0cb67f3f52413d92$export$63c3de442720649(bytes);
    var str = '';
    for(var i = 0; i < bytes.length; i++)str += $0cb67f3f52413d92$export$36cf564d487b5178(bytes[i].toString(2), 8, '0');
    return str;
};
var $0cb67f3f52413d92$var$BigInt = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt || Number;
var $0cb67f3f52413d92$var$BYTE_TABLE = [
    $0cb67f3f52413d92$var$BigInt('0x1'),
    $0cb67f3f52413d92$var$BigInt('0x100'),
    $0cb67f3f52413d92$var$BigInt('0x10000'),
    $0cb67f3f52413d92$var$BigInt('0x1000000'),
    $0cb67f3f52413d92$var$BigInt('0x100000000'),
    $0cb67f3f52413d92$var$BigInt('0x10000000000'),
    $0cb67f3f52413d92$var$BigInt('0x1000000000000'),
    $0cb67f3f52413d92$var$BigInt('0x100000000000000'),
    $0cb67f3f52413d92$var$BigInt('0x10000000000000000')
];
var $0cb67f3f52413d92$export$44623b3161268f13 = function() {
    var a = new Uint16Array([
        0xFFCC
    ]);
    var b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    if (b[0] === 0xFF) return 'big';
    if (b[0] === 0xCC) return 'little';
    return 'unknown';
}();
var $0cb67f3f52413d92$export$71d08edba63ee40 = $0cb67f3f52413d92$export$44623b3161268f13 === 'big';
var $0cb67f3f52413d92$export$c362788a4d6d6a65 = $0cb67f3f52413d92$export$44623b3161268f13 === 'little';
var $0cb67f3f52413d92$export$c0cca17bcf674749 = function bytesToNumber(bytes, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$signed = _ref.signed, signed = _ref$signed === void 0 ? false : _ref$signed, _ref$le = _ref.le, le = _ref$le === void 0 ? false : _ref$le;
    bytes = $0cb67f3f52413d92$export$63c3de442720649(bytes);
    var fn = le ? 'reduce' : 'reduceRight';
    var obj = bytes[fn] ? bytes[fn] : Array.prototype[fn];
    var number = obj.call(bytes, function(total, byte, i) {
        var exponent = le ? i : Math.abs(i + 1 - bytes.length);
        return total + $0cb67f3f52413d92$var$BigInt(byte) * $0cb67f3f52413d92$var$BYTE_TABLE[exponent];
    }, $0cb67f3f52413d92$var$BigInt(0));
    if (signed) {
        var max = $0cb67f3f52413d92$var$BYTE_TABLE[bytes.length] / $0cb67f3f52413d92$var$BigInt(2) - $0cb67f3f52413d92$var$BigInt(1);
        number = $0cb67f3f52413d92$var$BigInt(number);
        if (number > max) {
            number -= max;
            number -= max;
            number -= $0cb67f3f52413d92$var$BigInt(2);
        }
    }
    return Number(number);
};
var $0cb67f3f52413d92$export$49ad9be85c347998 = function numberToBytes(number, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$le = _ref2.le, le = _ref2$le === void 0 ? false : _ref2$le;
    // eslint-disable-next-line
    if (typeof number !== 'bigint' && typeof number !== 'number' || typeof number === 'number' && number !== number) number = 0;
    number = $0cb67f3f52413d92$var$BigInt(number);
    var byteCount = $0cb67f3f52413d92$export$42cd407004f34122(number);
    var bytes = new Uint8Array(new ArrayBuffer(byteCount));
    for(var i = 0; i < byteCount; i++){
        var byteIndex = le ? i : Math.abs(i + 1 - bytes.length);
        bytes[byteIndex] = Number(number / $0cb67f3f52413d92$var$BYTE_TABLE[i] & $0cb67f3f52413d92$var$BigInt(0xFF));
        if (number < 0) {
            bytes[byteIndex] = Math.abs(~bytes[byteIndex]);
            bytes[byteIndex] -= i === 0 ? 1 : 2;
        }
    }
    return bytes;
};
var $0cb67f3f52413d92$export$7c746b75f47c9c7d = function bytesToString(bytes) {
    if (!bytes) return '';
     // TODO: should toUint8 handle cases where we only have 8 bytes
    // but report more since this is a Uint16+ Array?
    bytes = Array.prototype.slice.call(bytes);
    var string = String.fromCharCode.apply(null, $0cb67f3f52413d92$export$63c3de442720649(bytes));
    try {
        return decodeURIComponent(escape(string));
    } catch (e) {
    // or full non string data. Just return the potentially garbled string.
    }
    return string;
};
var $0cb67f3f52413d92$export$c8dd6bc66a63753c = function stringToBytes(string, stringIsBytes) {
    if (typeof string !== 'string' && string && typeof string.toString === 'function') string = string.toString();
    if (typeof string !== 'string') return new Uint8Array();
     // If the string already is bytes, we don't have to do this
    // otherwise we do this so that we split multi length characters
    // into individual bytes
    if (!stringIsBytes) string = unescape(encodeURIComponent(string));
    var view = new Uint8Array(string.length);
    for(var i = 0; i < string.length; i++)view[i] = string.charCodeAt(i);
    return view;
};
var $0cb67f3f52413d92$export$229a3d5e59c9dd55 = function concatTypedArrays() {
    for(var _len = arguments.length, buffers = new Array(_len), _key = 0; _key < _len; _key++)buffers[_key] = arguments[_key];
    buffers = buffers.filter(function(b) {
        return b && (b.byteLength || b.length) && typeof b !== 'string';
    });
    if (buffers.length <= 1) // for 0 length we will return empty uint8
    // for 1 length we return the first uint8
    return $0cb67f3f52413d92$export$63c3de442720649(buffers[0]);
    var totalLen = buffers.reduce(function(total, buf, i) {
        return total + (buf.byteLength || buf.length);
    }, 0);
    var tempBuffer = new Uint8Array(totalLen);
    var offset = 0;
    buffers.forEach(function(buf) {
        buf = $0cb67f3f52413d92$export$63c3de442720649(buf);
        tempBuffer.set(buf, offset);
        offset += buf.byteLength;
    });
    return tempBuffer;
};
var $0cb67f3f52413d92$export$a20f7b76e5cfd223 = function bytesMatch(a, b, _temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$offset = _ref3.offset, offset = _ref3$offset === void 0 ? 0 : _ref3$offset, _ref3$mask = _ref3.mask, mask = _ref3$mask === void 0 ? [] : _ref3$mask;
    a = $0cb67f3f52413d92$export$63c3de442720649(a);
    b = $0cb67f3f52413d92$export$63c3de442720649(b); // ie 11 does not support uint8 every
    var fn = b.every ? b.every : Array.prototype.every;
    return b.length && a.length - offset >= b.length && // ie 11 doesn't support every on uin8
    fn.call(b, function(bByte, i) {
        var aByte = mask[i] ? mask[i] & a[offset + i] : a[offset + i];
        return bByte === aByte;
    });
};
var $0cb67f3f52413d92$export$8bac03c8c1da551 = function sliceBytes(src, start, end) {
    if (Uint8Array.prototype.slice) return Uint8Array.prototype.slice.call(src, start, end);
    return new Uint8Array(Array.prototype.slice.call(src, start, end));
};
var $0cb67f3f52413d92$export$8f563933fe97d489 = function reverseBytes(src) {
    if (src.reverse) return src.reverse();
    return Array.prototype.reverse.call(src);
};


/*! @name mpd-parser @version 1.4.0 @license Apache-2.0 */ 

var $hYfPi = parcelRequire("hYfPi");
/**
 * Loops through all supported media groups in master and calls the provided
 * callback for each group
 *
 * @param {Object} master
 *        The parsed master manifest object
 * @param {string[]} groups
 *        The media groups to call the callback for
 * @param {Function} callback
 *        Callback to call for each media group
 */ var $24dafe77b127de5f$export$308de5e7fb801aab = function forEachMediaGroup(master, groups, callback) {
    groups.forEach(function(mediaType) {
        for(var groupKey in master.mediaGroups[mediaType])for(var labelKey in master.mediaGroups[mediaType][groupKey]){
            var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
            callback(mediaProperties, mediaType, groupKey, labelKey);
        }
    });
};



var $a28fabd21ad88010$export$455426655eab1d48;
var $a28fabd21ad88010$export$64f0bed4ae6f0f24;
var $a28fabd21ad88010$export$1059c6e7d2ce5669;

var $cCG51 = parcelRequire("cCG51");
$a28fabd21ad88010$export$455426655eab1d48 = $cCG51.DOMImplementation;
$a28fabd21ad88010$export$64f0bed4ae6f0f24 = $cCG51.XMLSerializer;

$a28fabd21ad88010$export$1059c6e7d2ce5669 = (parcelRequire("bXM4z")).DOMParser;


var $fb56f0cd7d6a30bd$var$version = "1.4.0";
const $fb56f0cd7d6a30bd$var$isObject = (obj)=>{
    return !!obj && typeof obj === 'object';
};
const $fb56f0cd7d6a30bd$var$merge = (...objects)=>{
    return objects.reduce((result, source)=>{
        if (typeof source !== 'object') return result;
        Object.keys(source).forEach((key)=>{
            if (Array.isArray(result[key]) && Array.isArray(source[key])) result[key] = result[key].concat(source[key]);
            else if ($fb56f0cd7d6a30bd$var$isObject(result[key]) && $fb56f0cd7d6a30bd$var$isObject(source[key])) result[key] = $fb56f0cd7d6a30bd$var$merge(result[key], source[key]);
            else result[key] = source[key];
        });
        return result;
    }, {});
};
const $fb56f0cd7d6a30bd$var$values = (o)=>Object.keys(o).map((k)=>o[k]);
const $fb56f0cd7d6a30bd$var$range = (start, end)=>{
    const result = [];
    for(let i = start; i < end; i++)result.push(i);
    return result;
};
const $fb56f0cd7d6a30bd$var$flatten = (lists)=>lists.reduce((x, y)=>x.concat(y), []);
const $fb56f0cd7d6a30bd$var$from = (list)=>{
    if (!list.length) return [];
    const result = [];
    for(let i = 0; i < list.length; i++)result.push(list[i]);
    return result;
};
const $fb56f0cd7d6a30bd$var$findIndexes = (l, key)=>l.reduce((a, e, i)=>{
        if (e[key]) a.push(i);
        return a;
    }, []);
/**
 * Returns a union of the included lists provided each element can be identified by a key.
 *
 * @param {Array} list - list of lists to get the union of
 * @param {Function} keyFunction - the function to use as a key for each element
 *
 * @return {Array} the union of the arrays
 */ const $fb56f0cd7d6a30bd$var$union = (lists, keyFunction)=>{
    return $fb56f0cd7d6a30bd$var$values(lists.reduce((acc, list)=>{
        list.forEach((el)=>{
            acc[keyFunction(el)] = el;
        });
        return acc;
    }, {}));
};
var $fb56f0cd7d6a30bd$var$errors = {
    INVALID_NUMBER_OF_PERIOD: 'INVALID_NUMBER_OF_PERIOD',
    INVALID_NUMBER_OF_CONTENT_STEERING: 'INVALID_NUMBER_OF_CONTENT_STEERING',
    DASH_EMPTY_MANIFEST: 'DASH_EMPTY_MANIFEST',
    DASH_INVALID_XML: 'DASH_INVALID_XML',
    NO_BASE_URL: 'NO_BASE_URL',
    MISSING_SEGMENT_INFORMATION: 'MISSING_SEGMENT_INFORMATION',
    SEGMENT_TIME_UNSPECIFIED: 'SEGMENT_TIME_UNSPECIFIED',
    UNSUPPORTED_UTC_TIMING_SCHEME: 'UNSUPPORTED_UTC_TIMING_SCHEME'
};
/**
 * @typedef {Object} SingleUri
 * @property {string} uri - relative location of segment
 * @property {string} resolvedUri - resolved location of segment
 * @property {Object} byterange - Object containing information on how to make byte range
 *   requests following byte-range-spec per RFC2616.
 * @property {String} byterange.length - length of range request
 * @property {String} byterange.offset - byte offset of range request
 *
 * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.35.1
 */ /**
 * Converts a URLType node (5.3.9.2.3 Table 13) to a segment object
 * that conforms to how m3u8-parser is structured
 *
 * @see https://github.com/videojs/m3u8-parser
 *
 * @param {string} baseUrl - baseUrl provided by <BaseUrl> nodes
 * @param {string} source - source url for segment
 * @param {string} range - optional range used for range calls,
 *   follows  RFC 2616, Clause 14.35.1
 * @return {SingleUri} full segment information transformed into a format similar
 *   to m3u8-parser
 */ const $fb56f0cd7d6a30bd$var$urlTypeToSegment = ({ baseUrl: baseUrl = '', source: source = '', range: range = '', indexRange: indexRange = '' })=>{
    const segment = {
        uri: source,
        resolvedUri: (0, $3c711be251a9bb4f$export$2e2bcd8739ae039)(baseUrl || '', source)
    };
    if (range || indexRange) {
        const rangeStr = range ? range : indexRange;
        const ranges = rangeStr.split('-'); // default to parsing this as a BigInt if possible
        let startRange = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt ? (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(ranges[0]) : parseInt(ranges[0], 10);
        let endRange = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt ? (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(ranges[1]) : parseInt(ranges[1], 10); // convert back to a number if less than MAX_SAFE_INTEGER
        if (startRange < Number.MAX_SAFE_INTEGER && typeof startRange === 'bigint') startRange = Number(startRange);
        if (endRange < Number.MAX_SAFE_INTEGER && typeof endRange === 'bigint') endRange = Number(endRange);
        let length;
        if (typeof endRange === 'bigint' || typeof startRange === 'bigint') length = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(endRange) - (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(startRange) + (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(1);
        else length = endRange - startRange + 1;
        if (typeof length === 'bigint' && length < Number.MAX_SAFE_INTEGER) length = Number(length);
         // byterange should be inclusive according to
        // RFC 2616, Clause 14.35.1
        segment.byterange = {
            length: length,
            offset: startRange
        };
    }
    return segment;
};
const $fb56f0cd7d6a30bd$var$byteRangeToString = (byterange)=>{
    // `endRange` is one less than `offset + length` because the HTTP range
    // header uses inclusive ranges
    let endRange;
    if (typeof byterange.offset === 'bigint' || typeof byterange.length === 'bigint') endRange = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(byterange.offset) + (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(byterange.length) - (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(1);
    else endRange = byterange.offset + byterange.length - 1;
    return `${byterange.offset}-${endRange}`;
};
/**
 * parse the end number attribue that can be a string
 * number, or undefined.
 *
 * @param {string|number|undefined} endNumber
 *        The end number attribute.
 *
 * @return {number|null}
 *          The result of parsing the end number.
 */ const $fb56f0cd7d6a30bd$var$parseEndNumber = (endNumber)=>{
    if (endNumber && typeof endNumber !== 'number') endNumber = parseInt(endNumber, 10);
    if (isNaN(endNumber)) return null;
    return endNumber;
};
/**
 * Functions for calculating the range of available segments in static and dynamic
 * manifests.
 */ const $fb56f0cd7d6a30bd$var$segmentRange = {
    /**
   * Returns the entire range of available segments for a static MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */ static (attributes) {
        const { duration: duration, timescale: timescale = 1, sourceDuration: sourceDuration, periodDuration: periodDuration } = attributes;
        const endNumber = $fb56f0cd7d6a30bd$var$parseEndNumber(attributes.endNumber);
        const segmentDuration = duration / timescale;
        if (typeof endNumber === 'number') return {
            start: 0,
            end: endNumber
        };
        if (typeof periodDuration === 'number') return {
            start: 0,
            end: periodDuration / segmentDuration
        };
        return {
            start: 0,
            end: sourceDuration / segmentDuration
        };
    },
    /**
   * Returns the current live window range of available segments for a dynamic MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */ dynamic (attributes) {
        const { NOW: NOW, clientOffset: clientOffset, availabilityStartTime: availabilityStartTime, timescale: timescale = 1, duration: duration, periodStart: periodStart = 0, minimumUpdatePeriod: minimumUpdatePeriod = 0, timeShiftBufferDepth: timeShiftBufferDepth = Infinity } = attributes;
        const endNumber = $fb56f0cd7d6a30bd$var$parseEndNumber(attributes.endNumber); // clientOffset is passed in at the top level of mpd-parser and is an offset calculated
        // after retrieving UTC server time.
        const now = (NOW + clientOffset) / 1000; // WC stands for Wall Clock.
        // Convert the period start time to EPOCH.
        const periodStartWC = availabilityStartTime + periodStart; // Period end in EPOCH is manifest's retrieval time + time until next update.
        const periodEndWC = now + minimumUpdatePeriod;
        const periodDuration = periodEndWC - periodStartWC;
        const segmentCount = Math.ceil(periodDuration * timescale / duration);
        const availableStart = Math.floor((now - periodStartWC - timeShiftBufferDepth) * timescale / duration);
        const availableEnd = Math.floor((now - periodStartWC) * timescale / duration);
        return {
            start: Math.max(0, availableStart),
            end: typeof endNumber === 'number' ? endNumber : Math.min(segmentCount, availableEnd)
        };
    }
};
/**
 * Maps a range of numbers to objects with information needed to build the corresponding
 * segment list
 *
 * @name toSegmentsCallback
 * @function
 * @param {number} number
 *        Number of the segment
 * @param {number} index
 *        Index of the number in the range list
 * @return {{ number: Number, duration: Number, timeline: Number, time: Number }}
 *         Object with segment timing and duration info
 */ /**
 * Returns a callback for Array.prototype.map for mapping a range of numbers to
 * information needed to build the segment list.
 *
 * @param {Object} attributes
 *        Inherited MPD attributes
 * @return {toSegmentsCallback}
 *         Callback map function
 */ const $fb56f0cd7d6a30bd$var$toSegments = (attributes)=>(number)=>{
        const { duration: duration, timescale: timescale = 1, periodStart: periodStart, startNumber: startNumber = 1 } = attributes;
        return {
            number: startNumber + number,
            duration: duration / timescale,
            timeline: periodStart,
            time: number * duration
        };
    };
/**
 * Returns a list of objects containing segment timing and duration info used for
 * building the list of segments. This uses the @duration attribute specified
 * in the MPD manifest to derive the range of segments.
 *
 * @param {Object} attributes
 *        Inherited MPD attributes
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */ const $fb56f0cd7d6a30bd$var$parseByDuration = (attributes)=>{
    const { type: type, duration: duration, timescale: timescale = 1, periodDuration: periodDuration, sourceDuration: sourceDuration } = attributes;
    const { start: start, end: end } = $fb56f0cd7d6a30bd$var$segmentRange[type](attributes);
    const segments = $fb56f0cd7d6a30bd$var$range(start, end).map($fb56f0cd7d6a30bd$var$toSegments(attributes));
    if (type === 'static') {
        const index = segments.length - 1; // section is either a period or the full source
        const sectionDuration = typeof periodDuration === 'number' ? periodDuration : sourceDuration; // final segment may be less than full segment duration
        segments[index].duration = sectionDuration - duration / timescale * index;
    }
    return segments;
};
/**
 * Translates SegmentBase into a set of segments.
 * (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
 * node should be translated into segment.
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @return {Object.<Array>} list of segments
 */ const $fb56f0cd7d6a30bd$var$segmentsFromBase = (attributes)=>{
    const { baseUrl: baseUrl, initialization: initialization = {}, sourceDuration: sourceDuration, indexRange: indexRange = '', periodStart: periodStart, presentationTime: presentationTime, number: number = 0, duration: duration } = attributes; // base url is required for SegmentBase to work, per spec (Section 5.3.9.2.1)
    if (!baseUrl) throw new Error($fb56f0cd7d6a30bd$var$errors.NO_BASE_URL);
    const initSegment = $fb56f0cd7d6a30bd$var$urlTypeToSegment({
        baseUrl: baseUrl,
        source: initialization.sourceURL,
        range: initialization.range
    });
    const segment = $fb56f0cd7d6a30bd$var$urlTypeToSegment({
        baseUrl: baseUrl,
        source: baseUrl,
        indexRange: indexRange
    });
    segment.map = initSegment; // If there is a duration, use it, otherwise use the given duration of the source
    // (since SegmentBase is only for one total segment)
    if (duration) {
        const segmentTimeInfo = $fb56f0cd7d6a30bd$var$parseByDuration(attributes);
        if (segmentTimeInfo.length) {
            segment.duration = segmentTimeInfo[0].duration;
            segment.timeline = segmentTimeInfo[0].timeline;
        }
    } else if (sourceDuration) {
        segment.duration = sourceDuration;
        segment.timeline = periodStart;
    } // If presentation time is provided, these segments are being generated by SIDX
    // references, and should use the time provided. For the general case of SegmentBase,
    // there should only be one segment in the period, so its presentation time is the same
    // as its period start.
    segment.presentationTime = presentationTime || periodStart;
    segment.number = number;
    return [
        segment
    ];
};
/**
 * Given a playlist, a sidx box, and a baseUrl, update the segment list of the playlist
 * according to the sidx information given.
 *
 * playlist.sidx has metadadata about the sidx where-as the sidx param
 * is the parsed sidx box itself.
 *
 * @param {Object} playlist the playlist to update the sidx information for
 * @param {Object} sidx the parsed sidx box
 * @return {Object} the playlist object with the updated sidx information
 */ const $fb56f0cd7d6a30bd$export$2243d5aa7d4f4800 = (playlist, sidx, baseUrl)=>{
    // Retain init segment information
    const initSegment = playlist.sidx.map ? playlist.sidx.map : null; // Retain source duration from initial main manifest parsing
    const sourceDuration = playlist.sidx.duration; // Retain source timeline
    const timeline = playlist.timeline || 0;
    const sidxByteRange = playlist.sidx.byterange;
    const sidxEnd = sidxByteRange.offset + sidxByteRange.length; // Retain timescale of the parsed sidx
    const timescale = sidx.timescale; // referenceType 1 refers to other sidx boxes
    const mediaReferences = sidx.references.filter((r)=>r.referenceType !== 1);
    const segments = [];
    const type = playlist.endList ? 'static' : 'dynamic';
    const periodStart = playlist.sidx.timeline;
    let presentationTime = periodStart;
    let number = playlist.mediaSequence || 0; // firstOffset is the offset from the end of the sidx box
    let startIndex; // eslint-disable-next-line
    if (typeof sidx.firstOffset === 'bigint') startIndex = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(sidxEnd) + sidx.firstOffset;
    else startIndex = sidxEnd + sidx.firstOffset;
    for(let i = 0; i < mediaReferences.length; i++){
        const reference = sidx.references[i]; // size of the referenced (sub)segment
        const size = reference.referencedSize; // duration of the referenced (sub)segment, in  the  timescale
        // this will be converted to seconds when generating segments
        const duration = reference.subsegmentDuration; // should be an inclusive range
        let endIndex; // eslint-disable-next-line
        if (typeof startIndex === 'bigint') endIndex = startIndex + (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(size) - (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(1);
        else endIndex = startIndex + size - 1;
        const indexRange = `${startIndex}-${endIndex}`;
        const attributes = {
            baseUrl: baseUrl,
            timescale: timescale,
            timeline: timeline,
            periodStart: periodStart,
            presentationTime: presentationTime,
            number: number,
            duration: duration,
            sourceDuration: sourceDuration,
            indexRange: indexRange,
            type: type
        };
        const segment = $fb56f0cd7d6a30bd$var$segmentsFromBase(attributes)[0];
        if (initSegment) segment.map = initSegment;
        segments.push(segment);
        if (typeof startIndex === 'bigint') startIndex += (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(size);
        else startIndex += size;
        presentationTime += duration / timescale;
        number++;
    }
    playlist.segments = segments;
    return playlist;
};
const $fb56f0cd7d6a30bd$var$SUPPORTED_MEDIA_TYPES = [
    'AUDIO',
    'SUBTITLES'
]; // allow one 60fps frame as leniency (arbitrarily chosen)
const $fb56f0cd7d6a30bd$var$TIME_FUDGE = 1 / 60;
/**
 * Given a list of timelineStarts, combines, dedupes, and sorts them.
 *
 * @param {TimelineStart[]} timelineStarts - list of timeline starts
 *
 * @return {TimelineStart[]} the combined and deduped timeline starts
 */ const $fb56f0cd7d6a30bd$var$getUniqueTimelineStarts = (timelineStarts)=>{
    return $fb56f0cd7d6a30bd$var$union(timelineStarts, ({ timeline: timeline })=>timeline).sort((a, b)=>a.timeline > b.timeline ? 1 : -1);
};
/**
 * Finds the playlist with the matching NAME attribute.
 *
 * @param {Array} playlists - playlists to search through
 * @param {string} name - the NAME attribute to search for
 *
 * @return {Object|null} the matching playlist object, or null
 */ const $fb56f0cd7d6a30bd$var$findPlaylistWithName = (playlists, name)=>{
    for(let i = 0; i < playlists.length; i++){
        if (playlists[i].attributes.NAME === name) return playlists[i];
    }
    return null;
};
/**
 * Gets a flattened array of media group playlists.
 *
 * @param {Object} manifest - the main manifest object
 *
 * @return {Array} the media group playlists
 */ const $fb56f0cd7d6a30bd$var$getMediaGroupPlaylists = (manifest)=>{
    let mediaGroupPlaylists = [];
    (0, $24dafe77b127de5f$export$308de5e7fb801aab)(manifest, $fb56f0cd7d6a30bd$var$SUPPORTED_MEDIA_TYPES, (properties, type, group, label)=>{
        mediaGroupPlaylists = mediaGroupPlaylists.concat(properties.playlists || []);
    });
    return mediaGroupPlaylists;
};
/**
 * Updates the playlist's media sequence numbers.
 *
 * @param {Object} config - options object
 * @param {Object} config.playlist - the playlist to update
 * @param {number} config.mediaSequence - the mediaSequence number to start with
 */ const $fb56f0cd7d6a30bd$var$updateMediaSequenceForPlaylist = ({ playlist: playlist, mediaSequence: mediaSequence })=>{
    playlist.mediaSequence = mediaSequence;
    playlist.segments.forEach((segment, index)=>{
        segment.number = playlist.mediaSequence + index;
    });
};
/**
 * Updates the media and discontinuity sequence numbers of newPlaylists given oldPlaylists
 * and a complete list of timeline starts.
 *
 * If no matching playlist is found, only the discontinuity sequence number of the playlist
 * will be updated.
 *
 * Since early available timelines are not supported, at least one segment must be present.
 *
 * @param {Object} config - options object
 * @param {Object[]} oldPlaylists - the old playlists to use as a reference
 * @param {Object[]} newPlaylists - the new playlists to update
 * @param {Object} timelineStarts - all timelineStarts seen in the stream to this point
 */ const $fb56f0cd7d6a30bd$var$updateSequenceNumbers = ({ oldPlaylists: oldPlaylists, newPlaylists: newPlaylists, timelineStarts: timelineStarts })=>{
    newPlaylists.forEach((playlist)=>{
        playlist.discontinuitySequence = timelineStarts.findIndex(function({ timeline: timeline }) {
            return timeline === playlist.timeline;
        }); // Playlists NAMEs come from DASH Representation IDs, which are mandatory
        // (see ISO_23009-1-2012 5.3.5.2).
        //
        // If the same Representation existed in a prior Period, it will retain the same NAME.
        const oldPlaylist = $fb56f0cd7d6a30bd$var$findPlaylistWithName(oldPlaylists, playlist.attributes.NAME);
        if (!oldPlaylist) // Since this is a new playlist, the media sequence values can start from 0 without
        // consequence.
        return;
         // TODO better support for live SIDX
        //
        // As of this writing, mpd-parser does not support multiperiod SIDX (in live or VOD).
        // This is evident by a playlist only having a single SIDX reference. In a multiperiod
        // playlist there would need to be multiple SIDX references. In addition, live SIDX is
        // not supported when the SIDX properties change on refreshes.
        //
        // In the future, if support needs to be added, the merging logic here can be called
        // after SIDX references are resolved. For now, exit early to prevent exceptions being
        // thrown due to undefined references.
        if (playlist.sidx) return;
         // Since we don't yet support early available timelines, we don't need to support
        // playlists with no segments.
        const firstNewSegment = playlist.segments[0];
        const oldMatchingSegmentIndex = oldPlaylist.segments.findIndex(function(oldSegment) {
            return Math.abs(oldSegment.presentationTime - firstNewSegment.presentationTime) < $fb56f0cd7d6a30bd$var$TIME_FUDGE;
        }); // No matching segment from the old playlist means the entire playlist was refreshed.
        // In this case the media sequence should account for this update, and the new segments
        // should be marked as discontinuous from the prior content, since the last prior
        // timeline was removed.
        if (oldMatchingSegmentIndex === -1) {
            $fb56f0cd7d6a30bd$var$updateMediaSequenceForPlaylist({
                playlist: playlist,
                mediaSequence: oldPlaylist.mediaSequence + oldPlaylist.segments.length
            });
            playlist.segments[0].discontinuity = true;
            playlist.discontinuityStarts.unshift(0); // No matching segment does not necessarily mean there's missing content.
            //
            // If the new playlist's timeline is the same as the last seen segment's timeline,
            // then a discontinuity can be added to identify that there's potentially missing
            // content. If there's no missing content, the discontinuity should still be rather
            // harmless. It's possible that if segment durations are accurate enough, that the
            // existence of a gap can be determined using the presentation times and durations,
            // but if the segment timing info is off, it may introduce more problems than simply
            // adding the discontinuity.
            //
            // If the new playlist's timeline is different from the last seen segment's timeline,
            // then a discontinuity can be added to identify that this is the first seen segment
            // of a new timeline. However, the logic at the start of this function that
            // determined the disconinuity sequence by timeline index is now off by one (the
            // discontinuity of the newest timeline hasn't yet fallen off the manifest...since
            // we added it), so the disconinuity sequence must be decremented.
            //
            // A period may also have a duration of zero, so the case of no segments is handled
            // here even though we don't yet support early available periods.
            if (!oldPlaylist.segments.length && playlist.timeline > oldPlaylist.timeline || oldPlaylist.segments.length && playlist.timeline > oldPlaylist.segments[oldPlaylist.segments.length - 1].timeline) playlist.discontinuitySequence--;
            return;
        } // If the first segment matched with a prior segment on a discontinuity (it's matching
        // on the first segment of a period), then the discontinuitySequence shouldn't be the
        // timeline's matching one, but instead should be the one prior, and the first segment
        // of the new manifest should be marked with a discontinuity.
        //
        // The reason for this special case is that discontinuity sequence shows how many
        // discontinuities have fallen off of the playlist, and discontinuities are marked on
        // the first segment of a new "timeline." Because of this, while DASH will retain that
        // Period while the "timeline" exists, HLS keeps track of it via the discontinuity
        // sequence, and that first segment is an indicator, but can be removed before that
        // timeline is gone.
        const oldMatchingSegment = oldPlaylist.segments[oldMatchingSegmentIndex];
        if (oldMatchingSegment.discontinuity && !firstNewSegment.discontinuity) {
            firstNewSegment.discontinuity = true;
            playlist.discontinuityStarts.unshift(0);
            playlist.discontinuitySequence--;
        }
        $fb56f0cd7d6a30bd$var$updateMediaSequenceForPlaylist({
            playlist: playlist,
            mediaSequence: oldPlaylist.segments[oldMatchingSegmentIndex].number
        });
    });
};
/**
 * Given an old parsed manifest object and a new parsed manifest object, updates the
 * sequence and timing values within the new manifest to ensure that it lines up with the
 * old.
 *
 * @param {Array} oldManifest - the old main manifest object
 * @param {Array} newManifest - the new main manifest object
 *
 * @return {Object} the updated new manifest object
 */ const $fb56f0cd7d6a30bd$var$positionManifestOnTimeline = ({ oldManifest: oldManifest, newManifest: newManifest })=>{
    // Starting from v4.1.2 of the IOP, section 4.4.3.3 states:
    //
    // "MPD@availabilityStartTime and Period@start shall not be changed over MPD updates."
    //
    // This was added from https://github.com/Dash-Industry-Forum/DASH-IF-IOP/issues/160
    //
    // Because of this change, and the difficulty of supporting periods with changing start
    // times, periods with changing start times are not supported. This makes the logic much
    // simpler, since periods with the same start time can be considerred the same period
    // across refreshes.
    //
    // To give an example as to the difficulty of handling periods where the start time may
    // change, if a single period manifest is refreshed with another manifest with a single
    // period, and both the start and end times are increased, then the only way to determine
    // if it's a new period or an old one that has changed is to look through the segments of
    // each playlist and determine the presentation time bounds to find a match. In addition,
    // if the period start changed to exceed the old period end, then there would be no
    // match, and it would not be possible to determine whether the refreshed period is a new
    // one or the old one.
    const oldPlaylists = oldManifest.playlists.concat($fb56f0cd7d6a30bd$var$getMediaGroupPlaylists(oldManifest));
    const newPlaylists = newManifest.playlists.concat($fb56f0cd7d6a30bd$var$getMediaGroupPlaylists(newManifest)); // Save all seen timelineStarts to the new manifest. Although this potentially means that
    // there's a "memory leak" in that it will never stop growing, in reality, only a couple
    // of properties are saved for each seen Period. Even long running live streams won't
    // generate too many Periods, unless the stream is watched for decades. In the future,
    // this can be optimized by mapping to discontinuity sequence numbers for each timeline,
    // but it may not become an issue, and the additional info can be useful for debugging.
    newManifest.timelineStarts = $fb56f0cd7d6a30bd$var$getUniqueTimelineStarts([
        oldManifest.timelineStarts,
        newManifest.timelineStarts
    ]);
    $fb56f0cd7d6a30bd$var$updateSequenceNumbers({
        oldPlaylists: oldPlaylists,
        newPlaylists: newPlaylists,
        timelineStarts: newManifest.timelineStarts
    });
    return newManifest;
};
const $fb56f0cd7d6a30bd$export$2d92360466eb0b01 = (sidx)=>sidx && sidx.uri + '-' + $fb56f0cd7d6a30bd$var$byteRangeToString(sidx.byterange);
const $fb56f0cd7d6a30bd$var$mergeDiscontiguousPlaylists = (playlists)=>{
    // Break out playlists into groups based on their baseUrl
    const playlistsByBaseUrl = playlists.reduce(function(acc, cur) {
        if (!acc[cur.attributes.baseUrl]) acc[cur.attributes.baseUrl] = [];
        acc[cur.attributes.baseUrl].push(cur);
        return acc;
    }, {});
    let allPlaylists = [];
    Object.values(playlistsByBaseUrl).forEach((playlistGroup)=>{
        const mergedPlaylists = $fb56f0cd7d6a30bd$var$values(playlistGroup.reduce((acc, playlist)=>{
            // assuming playlist IDs are the same across periods
            // TODO: handle multiperiod where representation sets are not the same
            // across periods
            const name = playlist.attributes.id + (playlist.attributes.lang || '');
            if (!acc[name]) {
                // First Period
                acc[name] = playlist;
                acc[name].attributes.timelineStarts = [];
            } else {
                // Subsequent Periods
                if (playlist.segments) {
                    // first segment of subsequent periods signal a discontinuity
                    if (playlist.segments[0]) playlist.segments[0].discontinuity = true;
                    acc[name].segments.push(...playlist.segments);
                } // bubble up contentProtection, this assumes all DRM content
                // has the same contentProtection
                if (playlist.attributes.contentProtection) acc[name].attributes.contentProtection = playlist.attributes.contentProtection;
            }
            acc[name].attributes.timelineStarts.push({
                // Although they represent the same number, it's important to have both to make it
                // compatible with HLS potentially having a similar attribute.
                start: playlist.attributes.periodStart,
                timeline: playlist.attributes.periodStart
            });
            return acc;
        }, {}));
        allPlaylists = allPlaylists.concat(mergedPlaylists);
    });
    return allPlaylists.map((playlist)=>{
        playlist.discontinuityStarts = $fb56f0cd7d6a30bd$var$findIndexes(playlist.segments || [], 'discontinuity');
        return playlist;
    });
};
const $fb56f0cd7d6a30bd$var$addSidxSegmentsToPlaylist = (playlist, sidxMapping)=>{
    const sidxKey = $fb56f0cd7d6a30bd$export$2d92360466eb0b01(playlist.sidx);
    const sidxMatch = sidxKey && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx;
    if (sidxMatch) $fb56f0cd7d6a30bd$export$2243d5aa7d4f4800(playlist, sidxMatch, playlist.sidx.resolvedUri);
    return playlist;
};
const $fb56f0cd7d6a30bd$var$addSidxSegmentsToPlaylists = (playlists, sidxMapping = {})=>{
    if (!Object.keys(sidxMapping).length) return playlists;
    for(const i in playlists)playlists[i] = $fb56f0cd7d6a30bd$var$addSidxSegmentsToPlaylist(playlists[i], sidxMapping);
    return playlists;
};
const $fb56f0cd7d6a30bd$var$formatAudioPlaylist = ({ attributes: attributes, segments: segments, sidx: sidx, mediaSequence: mediaSequence, discontinuitySequence: discontinuitySequence, discontinuityStarts: discontinuityStarts }, isAudioOnly)=>{
    const playlist = {
        attributes: {
            NAME: attributes.id,
            BANDWIDTH: attributes.bandwidth,
            CODECS: attributes.codecs,
            ['PROGRAM-ID']: 1
        },
        uri: '',
        endList: attributes.type === 'static',
        timeline: attributes.periodStart,
        resolvedUri: attributes.baseUrl || '',
        targetDuration: attributes.duration,
        discontinuitySequence: discontinuitySequence,
        discontinuityStarts: discontinuityStarts,
        timelineStarts: attributes.timelineStarts,
        mediaSequence: mediaSequence,
        segments: segments
    };
    if (attributes.contentProtection) playlist.contentProtection = attributes.contentProtection;
    if (attributes.serviceLocation) playlist.attributes.serviceLocation = attributes.serviceLocation;
    if (sidx) playlist.sidx = sidx;
    if (isAudioOnly) {
        playlist.attributes.AUDIO = 'audio';
        playlist.attributes.SUBTITLES = 'subs';
    }
    return playlist;
};
const $fb56f0cd7d6a30bd$var$formatVttPlaylist = ({ attributes: attributes, segments: segments, mediaSequence: mediaSequence, discontinuityStarts: discontinuityStarts, discontinuitySequence: discontinuitySequence })=>{
    if (typeof segments === 'undefined') {
        // vtt tracks may use single file in BaseURL
        segments = [
            {
                uri: attributes.baseUrl,
                timeline: attributes.periodStart,
                resolvedUri: attributes.baseUrl || '',
                duration: attributes.sourceDuration,
                number: 0
            }
        ]; // targetDuration should be the same duration as the only segment
        attributes.duration = attributes.sourceDuration;
    }
    const m3u8Attributes = {
        NAME: attributes.id,
        BANDWIDTH: attributes.bandwidth,
        ['PROGRAM-ID']: 1
    };
    if (attributes.codecs) m3u8Attributes.CODECS = attributes.codecs;
    const vttPlaylist = {
        attributes: m3u8Attributes,
        uri: '',
        endList: attributes.type === 'static',
        timeline: attributes.periodStart,
        resolvedUri: attributes.baseUrl || '',
        targetDuration: attributes.duration,
        timelineStarts: attributes.timelineStarts,
        discontinuityStarts: discontinuityStarts,
        discontinuitySequence: discontinuitySequence,
        mediaSequence: mediaSequence,
        segments: segments
    };
    if (attributes.serviceLocation) vttPlaylist.attributes.serviceLocation = attributes.serviceLocation;
    return vttPlaylist;
};
const $fb56f0cd7d6a30bd$var$organizeAudioPlaylists = (playlists, sidxMapping = {}, isAudioOnly = false)=>{
    let mainPlaylist;
    const formattedPlaylists = playlists.reduce((a, playlist)=>{
        const role = playlist.attributes.role && playlist.attributes.role.value || '';
        const language = playlist.attributes.lang || '';
        let label = playlist.attributes.label || 'main';
        if (language && !playlist.attributes.label) {
            const roleLabel = role ? ` (${role})` : '';
            label = `${playlist.attributes.lang}${roleLabel}`;
        }
        if (!a[label]) a[label] = {
            language: language,
            autoselect: true,
            default: role === 'main',
            playlists: [],
            uri: ''
        };
        const formatted = $fb56f0cd7d6a30bd$var$addSidxSegmentsToPlaylist($fb56f0cd7d6a30bd$var$formatAudioPlaylist(playlist, isAudioOnly), sidxMapping);
        a[label].playlists.push(formatted);
        if (typeof mainPlaylist === 'undefined' && role === 'main') {
            mainPlaylist = playlist;
            mainPlaylist.default = true;
        }
        return a;
    }, {}); // if no playlists have role "main", mark the first as main
    if (!mainPlaylist) {
        const firstLabel = Object.keys(formattedPlaylists)[0];
        formattedPlaylists[firstLabel].default = true;
    }
    return formattedPlaylists;
};
const $fb56f0cd7d6a30bd$var$organizeVttPlaylists = (playlists, sidxMapping = {})=>{
    return playlists.reduce((a, playlist)=>{
        const label = playlist.attributes.label || playlist.attributes.lang || 'text';
        const language = playlist.attributes.lang || 'und';
        if (!a[label]) a[label] = {
            language: language,
            default: false,
            autoselect: false,
            playlists: [],
            uri: ''
        };
        a[label].playlists.push($fb56f0cd7d6a30bd$var$addSidxSegmentsToPlaylist($fb56f0cd7d6a30bd$var$formatVttPlaylist(playlist), sidxMapping));
        return a;
    }, {});
};
const $fb56f0cd7d6a30bd$var$organizeCaptionServices = (captionServices)=>captionServices.reduce((svcObj, svc)=>{
        if (!svc) return svcObj;
        svc.forEach((service)=>{
            const { channel: channel, language: language } = service;
            svcObj[language] = {
                autoselect: false,
                default: false,
                instreamId: channel,
                language: language
            };
            if (service.hasOwnProperty('aspectRatio')) svcObj[language].aspectRatio = service.aspectRatio;
            if (service.hasOwnProperty('easyReader')) svcObj[language].easyReader = service.easyReader;
            if (service.hasOwnProperty('3D')) svcObj[language]['3D'] = service['3D'];
        });
        return svcObj;
    }, {});
const $fb56f0cd7d6a30bd$var$formatVideoPlaylist = ({ attributes: attributes, segments: segments, sidx: sidx, discontinuityStarts: discontinuityStarts })=>{
    const playlist = {
        attributes: {
            NAME: attributes.id,
            AUDIO: 'audio',
            SUBTITLES: 'subs',
            RESOLUTION: {
                width: attributes.width,
                height: attributes.height
            },
            CODECS: attributes.codecs,
            BANDWIDTH: attributes.bandwidth,
            ['PROGRAM-ID']: 1
        },
        uri: '',
        endList: attributes.type === 'static',
        timeline: attributes.periodStart,
        resolvedUri: attributes.baseUrl || '',
        targetDuration: attributes.duration,
        discontinuityStarts: discontinuityStarts,
        timelineStarts: attributes.timelineStarts,
        segments: segments
    };
    if (attributes.frameRate) playlist.attributes['FRAME-RATE'] = attributes.frameRate;
     // qualityRanking is inversely related to quality (higher value = lower quality)
    // so SCORE is calculated as 1/(qualityRanking+1) (higher SCORE = higher quality)
    // The +1 ensures we avoid division by zero when qualityRanking is 0
    if (attributes.qualityRanking !== undefined) playlist.attributes.SCORE = 1 / (attributes.qualityRanking + 1);
    if (attributes.contentProtection) playlist.contentProtection = attributes.contentProtection;
    if (attributes.serviceLocation) playlist.attributes.serviceLocation = attributes.serviceLocation;
    if (sidx) playlist.sidx = sidx;
    return playlist;
};
const $fb56f0cd7d6a30bd$var$videoOnly = ({ attributes: attributes })=>attributes.mimeType === 'video/mp4' || attributes.mimeType === 'video/webm' || attributes.contentType === 'video';
const $fb56f0cd7d6a30bd$var$audioOnly = ({ attributes: attributes })=>attributes.mimeType === 'audio/mp4' || attributes.mimeType === 'audio/webm' || attributes.contentType === 'audio';
const $fb56f0cd7d6a30bd$var$vttOnly = ({ attributes: attributes })=>attributes.mimeType === 'text/vtt' || attributes.contentType === 'text';
/**
 * Contains start and timeline properties denoting a timeline start. For DASH, these will
 * be the same number.
 *
 * @typedef {Object} TimelineStart
 * @property {number} start - the start time of the timeline
 * @property {number} timeline - the timeline number
 */ /**
 * Adds appropriate media and discontinuity sequence values to the segments and playlists.
 *
 * Throughout mpd-parser, the `number` attribute is used in relation to `startNumber`, a
 * DASH specific attribute used in constructing segment URI's from templates. However, from
 * an HLS perspective, the `number` attribute on a segment would be its `mediaSequence`
 * value, which should start at the original media sequence value (or 0) and increment by 1
 * for each segment thereafter. Since DASH's `startNumber` values are independent per
 * period, it doesn't make sense to use it for `number`. Instead, assume everything starts
 * from a 0 mediaSequence value and increment from there.
 *
 * Note that VHS currently doesn't use the `number` property, but it can be helpful for
 * debugging and making sense of the manifest.
 *
 * For live playlists, to account for values increasing in manifests when periods are
 * removed on refreshes, merging logic should be used to update the numbers to their
 * appropriate values (to ensure they're sequential and increasing).
 *
 * @param {Object[]} playlists - the playlists to update
 * @param {TimelineStart[]} timelineStarts - the timeline starts for the manifest
 */ const $fb56f0cd7d6a30bd$var$addMediaSequenceValues = (playlists, timelineStarts)=>{
    // increment all segments sequentially
    playlists.forEach((playlist)=>{
        playlist.mediaSequence = 0;
        playlist.discontinuitySequence = timelineStarts.findIndex(function({ timeline: timeline }) {
            return timeline === playlist.timeline;
        });
        if (!playlist.segments) return;
        playlist.segments.forEach((segment, index)=>{
            segment.number = index;
        });
    });
};
/**
 * Given a media group object, flattens all playlists within the media group into a single
 * array.
 *
 * @param {Object} mediaGroupObject - the media group object
 *
 * @return {Object[]}
 *         The media group playlists
 */ const $fb56f0cd7d6a30bd$var$flattenMediaGroupPlaylists = (mediaGroupObject)=>{
    if (!mediaGroupObject) return [];
    return Object.keys(mediaGroupObject).reduce((acc, label)=>{
        const labelContents = mediaGroupObject[label];
        return acc.concat(labelContents.playlists);
    }, []);
};
const $fb56f0cd7d6a30bd$export$c90e7d9f067c8f2c = ({ dashPlaylists: dashPlaylists, locations: locations, contentSteering: contentSteering, sidxMapping: sidxMapping = {}, previousManifest: previousManifest, eventStream: eventStream })=>{
    if (!dashPlaylists.length) return {};
     // grab all main manifest attributes
    const { sourceDuration: duration, type: type, suggestedPresentationDelay: suggestedPresentationDelay, minimumUpdatePeriod: minimumUpdatePeriod } = dashPlaylists[0].attributes;
    const videoPlaylists = $fb56f0cd7d6a30bd$var$mergeDiscontiguousPlaylists(dashPlaylists.filter($fb56f0cd7d6a30bd$var$videoOnly)).map($fb56f0cd7d6a30bd$var$formatVideoPlaylist);
    const audioPlaylists = $fb56f0cd7d6a30bd$var$mergeDiscontiguousPlaylists(dashPlaylists.filter($fb56f0cd7d6a30bd$var$audioOnly));
    const vttPlaylists = $fb56f0cd7d6a30bd$var$mergeDiscontiguousPlaylists(dashPlaylists.filter($fb56f0cd7d6a30bd$var$vttOnly));
    const captions = dashPlaylists.map((playlist)=>playlist.attributes.captionServices).filter(Boolean);
    const manifest = {
        allowCache: true,
        discontinuityStarts: [],
        segments: [],
        endList: true,
        mediaGroups: {
            AUDIO: {},
            VIDEO: {},
            ['CLOSED-CAPTIONS']: {},
            SUBTITLES: {}
        },
        uri: '',
        duration: duration,
        playlists: $fb56f0cd7d6a30bd$var$addSidxSegmentsToPlaylists(videoPlaylists, sidxMapping)
    };
    if (minimumUpdatePeriod >= 0) manifest.minimumUpdatePeriod = minimumUpdatePeriod * 1000;
    if (locations) manifest.locations = locations;
    if (contentSteering) manifest.contentSteering = contentSteering;
    if (type === 'dynamic') manifest.suggestedPresentationDelay = suggestedPresentationDelay;
    if (eventStream && eventStream.length > 0) manifest.eventStream = eventStream;
    const isAudioOnly = manifest.playlists.length === 0;
    const organizedAudioGroup = audioPlaylists.length ? $fb56f0cd7d6a30bd$var$organizeAudioPlaylists(audioPlaylists, sidxMapping, isAudioOnly) : null;
    const organizedVttGroup = vttPlaylists.length ? $fb56f0cd7d6a30bd$var$organizeVttPlaylists(vttPlaylists, sidxMapping) : null;
    const formattedPlaylists = videoPlaylists.concat($fb56f0cd7d6a30bd$var$flattenMediaGroupPlaylists(organizedAudioGroup), $fb56f0cd7d6a30bd$var$flattenMediaGroupPlaylists(organizedVttGroup));
    const playlistTimelineStarts = formattedPlaylists.map(({ timelineStarts: timelineStarts })=>timelineStarts);
    manifest.timelineStarts = $fb56f0cd7d6a30bd$var$getUniqueTimelineStarts(playlistTimelineStarts);
    $fb56f0cd7d6a30bd$var$addMediaSequenceValues(formattedPlaylists, manifest.timelineStarts);
    if (organizedAudioGroup) manifest.mediaGroups.AUDIO.audio = organizedAudioGroup;
    if (organizedVttGroup) manifest.mediaGroups.SUBTITLES.subs = organizedVttGroup;
    if (captions.length) manifest.mediaGroups['CLOSED-CAPTIONS'].cc = $fb56f0cd7d6a30bd$var$organizeCaptionServices(captions);
    if (previousManifest) return $fb56f0cd7d6a30bd$var$positionManifestOnTimeline({
        oldManifest: previousManifest,
        newManifest: manifest
    });
    return manifest;
};
/**
 * Calculates the R (repetition) value for a live stream (for the final segment
 * in a manifest where the r value is negative 1)
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {number} time
 *        current time (typically the total time up until the final segment)
 * @param {number} duration
 *        duration property for the given <S />
 *
 * @return {number}
 *        R value to reach the end of the given period
 */ const $fb56f0cd7d6a30bd$var$getLiveRValue = (attributes, time, duration)=>{
    const { NOW: NOW, clientOffset: clientOffset, availabilityStartTime: availabilityStartTime, timescale: timescale = 1, periodStart: periodStart = 0, minimumUpdatePeriod: minimumUpdatePeriod = 0 } = attributes;
    const now = (NOW + clientOffset) / 1000;
    const periodStartWC = availabilityStartTime + periodStart;
    const periodEndWC = now + minimumUpdatePeriod;
    const periodDuration = periodEndWC - periodStartWC;
    return Math.ceil((periodDuration * timescale - time) / duration);
};
/**
 * Uses information provided by SegmentTemplate.SegmentTimeline to determine segment
 * timing and duration
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */ const $fb56f0cd7d6a30bd$var$parseByTimeline = (attributes, segmentTimeline)=>{
    const { type: type, minimumUpdatePeriod: minimumUpdatePeriod = 0, media: media = '', sourceDuration: sourceDuration, timescale: timescale = 1, startNumber: startNumber = 1, periodStart: timeline } = attributes;
    const segments = [];
    let time = -1;
    for(let sIndex = 0; sIndex < segmentTimeline.length; sIndex++){
        const S = segmentTimeline[sIndex];
        const duration = S.d;
        const repeat = S.r || 0;
        const segmentTime = S.t || 0;
        if (time < 0) // first segment
        time = segmentTime;
        if (segmentTime && segmentTime > time) // discontinuity
        // TODO: How to handle this type of discontinuity
        // timeline++ here would treat it like HLS discontuity and content would
        // get appended without gap
        // E.G.
        //  <S t="0" d="1" />
        //  <S d="1" />
        //  <S d="1" />
        //  <S t="5" d="1" />
        // would have $Time$ values of [0, 1, 2, 5]
        // should this be appened at time positions [0, 1, 2, 3],(#EXT-X-DISCONTINUITY)
        // or [0, 1, 2, gap, gap, 5]? (#EXT-X-GAP)
        // does the value of sourceDuration consider this when calculating arbitrary
        // negative @r repeat value?
        // E.G. Same elements as above with this added at the end
        //  <S d="1" r="-1" />
        //  with a sourceDuration of 10
        // Would the 2 gaps be included in the time duration calculations resulting in
        // 8 segments with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9] or 10 segments
        // with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9, 10, 11] ?
        time = segmentTime;
        let count;
        if (repeat < 0) {
            const nextS = sIndex + 1;
            if (nextS === segmentTimeline.length) {
                // last segment
                if (type === 'dynamic' && minimumUpdatePeriod > 0 && media.indexOf('$Number$') > 0) count = $fb56f0cd7d6a30bd$var$getLiveRValue(attributes, time, duration);
                else // TODO: This may be incorrect depending on conclusion of TODO above
                count = (sourceDuration * timescale - time) / duration;
            } else count = (segmentTimeline[nextS].t - time) / duration;
        } else count = repeat + 1;
        const end = startNumber + segments.length + count;
        let number = startNumber + segments.length;
        while(number < end){
            segments.push({
                number: number,
                duration: duration / timescale,
                time: time,
                timeline: timeline
            });
            time += duration;
            number++;
        }
    }
    return segments;
};
const $fb56f0cd7d6a30bd$var$identifierPattern = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g;
/**
 * Replaces template identifiers with corresponding values. To be used as the callback
 * for String.prototype.replace
 *
 * @name replaceCallback
 * @function
 * @param {string} match
 *        Entire match of identifier
 * @param {string} identifier
 *        Name of matched identifier
 * @param {string} format
 *        Format tag string. Its presence indicates that padding is expected
 * @param {string} width
 *        Desired length of the replaced value. Values less than this width shall be left
 *        zero padded
 * @return {string}
 *         Replacement for the matched identifier
 */ /**
 * Returns a function to be used as a callback for String.prototype.replace to replace
 * template identifiers
 *
 * @param {Obect} values
 *        Object containing values that shall be used to replace known identifiers
 * @param {number} values.RepresentationID
 *        Value of the Representation@id attribute
 * @param {number} values.Number
 *        Number of the corresponding segment
 * @param {number} values.Bandwidth
 *        Value of the Representation@bandwidth attribute.
 * @param {number} values.Time
 *        Timestamp value of the corresponding segment
 * @return {replaceCallback}
 *         Callback to be used with String.prototype.replace to replace identifiers
 */ const $fb56f0cd7d6a30bd$var$identifierReplacement = (values)=>(match, identifier, format, width)=>{
        if (match === '$$') // escape sequence
        return '$';
        if (typeof values[identifier] === 'undefined') return match;
        const value = '' + values[identifier];
        if (identifier === 'RepresentationID') // Format tag shall not be present with RepresentationID
        return value;
        if (!format) width = 1;
        else width = parseInt(width, 10);
        if (value.length >= width) return value;
        return `${new Array(width - value.length + 1).join('0')}${value}`;
    };
/**
 * Constructs a segment url from a template string
 *
 * @param {string} url
 *        Template string to construct url from
 * @param {Obect} values
 *        Object containing values that shall be used to replace known identifiers
 * @param {number} values.RepresentationID
 *        Value of the Representation@id attribute
 * @param {number} values.Number
 *        Number of the corresponding segment
 * @param {number} values.Bandwidth
 *        Value of the Representation@bandwidth attribute.
 * @param {number} values.Time
 *        Timestamp value of the corresponding segment
 * @return {string}
 *         Segment url with identifiers replaced
 */ const $fb56f0cd7d6a30bd$var$constructTemplateUrl = (url, values)=>url.replace($fb56f0cd7d6a30bd$var$identifierPattern, $fb56f0cd7d6a30bd$var$identifierReplacement(values));
/**
 * Generates a list of objects containing timing and duration information about each
 * segment needed to generate segment uris and the complete segment object
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */ const $fb56f0cd7d6a30bd$var$parseTemplateInfo = (attributes, segmentTimeline)=>{
    if (!attributes.duration && !segmentTimeline) // if neither @duration or SegmentTimeline are present, then there shall be exactly
    // one media segment
    return [
        {
            number: attributes.startNumber || 1,
            duration: attributes.sourceDuration,
            time: 0,
            timeline: attributes.periodStart
        }
    ];
    if (attributes.duration) return $fb56f0cd7d6a30bd$var$parseByDuration(attributes);
    return $fb56f0cd7d6a30bd$var$parseByTimeline(attributes, segmentTimeline);
};
/**
 * Generates a list of segments using information provided by the SegmentTemplate element
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {Object[]}
 *         List of segment objects
 */ const $fb56f0cd7d6a30bd$var$segmentsFromTemplate = (attributes, segmentTimeline)=>{
    const templateValues = {
        RepresentationID: attributes.id,
        Bandwidth: attributes.bandwidth || 0
    };
    const { initialization: initialization = {
        sourceURL: '',
        range: ''
    } } = attributes;
    const mapSegment = $fb56f0cd7d6a30bd$var$urlTypeToSegment({
        baseUrl: attributes.baseUrl,
        source: $fb56f0cd7d6a30bd$var$constructTemplateUrl(initialization.sourceURL, templateValues),
        range: initialization.range
    });
    const segments = $fb56f0cd7d6a30bd$var$parseTemplateInfo(attributes, segmentTimeline);
    return segments.map((segment)=>{
        templateValues.Number = segment.number;
        templateValues.Time = segment.time;
        const uri = $fb56f0cd7d6a30bd$var$constructTemplateUrl(attributes.media || '', templateValues); // See DASH spec section 5.3.9.2.2
        // - if timescale isn't present on any level, default to 1.
        const timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0
        const presentationTimeOffset = attributes.presentationTimeOffset || 0;
        const presentationTime = // calculated in mpd-parser prior to this, so it's assumed to be available.
        attributes.periodStart + (segment.time - presentationTimeOffset) / timescale;
        const map = {
            uri: uri,
            timeline: segment.timeline,
            duration: segment.duration,
            resolvedUri: (0, $3c711be251a9bb4f$export$2e2bcd8739ae039)(attributes.baseUrl || '', uri),
            map: mapSegment,
            number: segment.number,
            presentationTime: presentationTime
        };
        return map;
    });
};
/**
 * Converts a <SegmentUrl> (of type URLType from the DASH spec 5.3.9.2 Table 14)
 * to an object that matches the output of a segment in videojs/mpd-parser
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @param {Object} segmentUrl
 *   <SegmentURL> node to translate into a segment object
 * @return {Object} translated segment object
 */ const $fb56f0cd7d6a30bd$var$SegmentURLToSegmentObject = (attributes, segmentUrl)=>{
    const { baseUrl: baseUrl, initialization: initialization = {} } = attributes;
    const initSegment = $fb56f0cd7d6a30bd$var$urlTypeToSegment({
        baseUrl: baseUrl,
        source: initialization.sourceURL,
        range: initialization.range
    });
    const segment = $fb56f0cd7d6a30bd$var$urlTypeToSegment({
        baseUrl: baseUrl,
        source: segmentUrl.media,
        range: segmentUrl.mediaRange
    });
    segment.map = initSegment;
    return segment;
};
/**
 * Generates a list of segments using information provided by the SegmentList element
 * SegmentList (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
 * node should be translated into segment.
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {Object.<Array>} list of segments
 */ const $fb56f0cd7d6a30bd$var$segmentsFromList = (attributes, segmentTimeline)=>{
    const { duration: duration, segmentUrls: segmentUrls = [], periodStart: periodStart } = attributes; // Per spec (5.3.9.2.1) no way to determine segment duration OR
    // if both SegmentTimeline and @duration are defined, it is outside of spec.
    if (!duration && !segmentTimeline || duration && segmentTimeline) throw new Error($fb56f0cd7d6a30bd$var$errors.SEGMENT_TIME_UNSPECIFIED);
    const segmentUrlMap = segmentUrls.map((segmentUrlObject)=>$fb56f0cd7d6a30bd$var$SegmentURLToSegmentObject(attributes, segmentUrlObject));
    let segmentTimeInfo;
    if (duration) segmentTimeInfo = $fb56f0cd7d6a30bd$var$parseByDuration(attributes);
    if (segmentTimeline) segmentTimeInfo = $fb56f0cd7d6a30bd$var$parseByTimeline(attributes, segmentTimeline);
    const segments = segmentTimeInfo.map((segmentTime, index)=>{
        if (segmentUrlMap[index]) {
            const segment = segmentUrlMap[index]; // See DASH spec section 5.3.9.2.2
            // - if timescale isn't present on any level, default to 1.
            const timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0
            const presentationTimeOffset = attributes.presentationTimeOffset || 0;
            segment.timeline = segmentTime.timeline;
            segment.duration = segmentTime.duration;
            segment.number = segmentTime.number;
            segment.presentationTime = periodStart + (segmentTime.time - presentationTimeOffset) / timescale;
            return segment;
        } // Since we're mapping we should get rid of any blank segments (in case
    // the given SegmentTimeline is handling for more elements than we have
    // SegmentURLs for).
    }).filter((segment)=>segment);
    return segments;
};
const $fb56f0cd7d6a30bd$var$generateSegments = ({ attributes: attributes, segmentInfo: segmentInfo })=>{
    let segmentAttributes;
    let segmentsFn;
    if (segmentInfo.template) {
        segmentsFn = $fb56f0cd7d6a30bd$var$segmentsFromTemplate;
        segmentAttributes = $fb56f0cd7d6a30bd$var$merge(attributes, segmentInfo.template);
    } else if (segmentInfo.base) {
        segmentsFn = $fb56f0cd7d6a30bd$var$segmentsFromBase;
        segmentAttributes = $fb56f0cd7d6a30bd$var$merge(attributes, segmentInfo.base);
    } else if (segmentInfo.list) {
        segmentsFn = $fb56f0cd7d6a30bd$var$segmentsFromList;
        segmentAttributes = $fb56f0cd7d6a30bd$var$merge(attributes, segmentInfo.list);
    }
    const segmentsInfo = {
        attributes: attributes
    };
    if (!segmentsFn) return segmentsInfo;
    const segments = segmentsFn(segmentAttributes, segmentInfo.segmentTimeline); // The @duration attribute will be used to determin the playlist's targetDuration which
    // must be in seconds. Since we've generated the segment list, we no longer need
    // @duration to be in @timescale units, so we can convert it here.
    if (segmentAttributes.duration) {
        const { duration: duration, timescale: timescale = 1 } = segmentAttributes;
        segmentAttributes.duration = duration / timescale;
    } else if (segments.length) // if there is no @duration attribute, use the largest segment duration as
    // as target duration
    segmentAttributes.duration = segments.reduce((max, segment)=>{
        return Math.max(max, Math.ceil(segment.duration));
    }, 0);
    else segmentAttributes.duration = 0;
    segmentsInfo.attributes = segmentAttributes;
    segmentsInfo.segments = segments; // This is a sidx box without actual segment information
    if (segmentInfo.base && segmentAttributes.indexRange) {
        segmentsInfo.sidx = segments[0];
        segmentsInfo.segments = [];
    }
    return segmentsInfo;
};
const $fb56f0cd7d6a30bd$export$4362d710904f703f = (representations)=>representations.map($fb56f0cd7d6a30bd$var$generateSegments);
const $fb56f0cd7d6a30bd$var$findChildren = (element, name)=>$fb56f0cd7d6a30bd$var$from(element.childNodes).filter(({ tagName: tagName })=>tagName === name);
const $fb56f0cd7d6a30bd$var$getContent = (element)=>element.textContent.trim();
/**
 * Converts the provided string that may contain a division operation to a number.
 *
 * @param {string} value - the provided string value
 *
 * @return {number} the parsed string value
 */ const $fb56f0cd7d6a30bd$var$parseDivisionValue = (value)=>{
    return parseFloat(value.split('/').reduce((prev, current)=>prev / current));
};
const $fb56f0cd7d6a30bd$var$parseDuration = (str)=>{
    const SECONDS_IN_YEAR = 31536000;
    const SECONDS_IN_MONTH = 2592000;
    const SECONDS_IN_DAY = 86400;
    const SECONDS_IN_HOUR = 3600;
    const SECONDS_IN_MIN = 60; // P10Y10M10DT10H10M10.1S
    const durationRegex = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/;
    const match = durationRegex.exec(str);
    if (!match) return 0;
    const [year, month, day, hour, minute, second] = match.slice(1);
    return parseFloat(year || 0) * SECONDS_IN_YEAR + parseFloat(month || 0) * SECONDS_IN_MONTH + parseFloat(day || 0) * SECONDS_IN_DAY + parseFloat(hour || 0) * SECONDS_IN_HOUR + parseFloat(minute || 0) * SECONDS_IN_MIN + parseFloat(second || 0);
};
const $fb56f0cd7d6a30bd$var$parseDate = (str)=>{
    // Date format without timezone according to ISO 8601
    // YYY-MM-DDThh:mm:ss.ssssss
    const dateRegex = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/; // If the date string does not specifiy a timezone, we must specifiy UTC. This is
    // expressed by ending with 'Z'
    if (dateRegex.test(str)) str += 'Z';
    return Date.parse(str);
};
const $fb56f0cd7d6a30bd$var$parsers = {
    /**
   * Specifies the duration of the entire Media Presentation. Format is a duration string
   * as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ mediaPresentationDuration (value) {
        return $fb56f0cd7d6a30bd$var$parseDuration(value);
    },
    /**
   * Specifies the Segment availability start time for all Segments referred to in this
   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
   * time. Format is a date string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The date as seconds from unix epoch
   */ availabilityStartTime (value) {
        return $fb56f0cd7d6a30bd$var$parseDate(value) / 1000;
    },
    /**
   * Specifies the smallest period between potential changes to the MPD. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ minimumUpdatePeriod (value) {
        return $fb56f0cd7d6a30bd$var$parseDuration(value);
    },
    /**
   * Specifies the suggested presentation delay. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ suggestedPresentationDelay (value) {
        return $fb56f0cd7d6a30bd$var$parseDuration(value);
    },
    /**
   * specifices the type of mpd. Can be either "static" or "dynamic"
   *
   * @param {string} value
   *        value of attribute as a string
   *
   * @return {string}
   *         The type as a string
   */ type (value) {
        return value;
    },
    /**
   * Specifies the duration of the smallest time shifting buffer for any Representation
   * in the MPD. Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ timeShiftBufferDepth (value) {
        return $fb56f0cd7d6a30bd$var$parseDuration(value);
    },
    /**
   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
   * Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ start (value) {
        return $fb56f0cd7d6a30bd$var$parseDuration(value);
    },
    /**
   * Specifies the width of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed width
   */ width (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the height of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed height
   */ height (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the bitrate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed bandwidth
   */ bandwidth (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the frame rate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed frame rate
   */ frameRate (value) {
        return $fb56f0cd7d6a30bd$var$parseDivisionValue(value);
    },
    /**
   * Specifies the number of the first Media Segment in this Representation in the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */ startNumber (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the timescale in units per seconds
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed timescale
   */ timescale (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the presentationTimeOffset.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTimeOffset
   */ presentationTimeOffset (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the constant approximate Segment duration
   * NOTE: The <Period> element also contains an @duration attribute. This duration
   *       specifies the duration of the Period. This attribute is currently not
   *       supported by the rest of the parser, however we still check for it to prevent
   *       errors.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */ duration (value) {
        const parsedValue = parseInt(value, 10);
        if (isNaN(parsedValue)) return $fb56f0cd7d6a30bd$var$parseDuration(value);
        return parsedValue;
    },
    /**
   * Specifies the Segment duration, in units of the value of the @timescale.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */ d (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the MPD start time, in @timescale units, the first Segment in the series
   * starts relative to the beginning of the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed time
   */ t (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the repeat count of the number of following contiguous Segments with the
   * same duration expressed by the value of @d
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */ r (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the presentationTime.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTime
   */ presentationTime (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the quality ranking of the representation relative to others in the same
   * adaptation set. This is inversely related to quality - higher values represent
   * lower quality content (e.g., 1 = highest quality, 10 = lowest quality).
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed qualityRanking
   */ qualityRanking (value) {
        return parseInt(value, 10);
    },
    /**
   * Alias for qualityRanking to handle lowercase attribute names from HTML DOM.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed qualityRanking
   */ qualityranking (value) {
        return parseInt(value, 10);
    },
    /**
   * Default parser for all other attributes. Acts as a no-op and just returns the value
   * as a string
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {string}
   *         Unparsed value
   */ DEFAULT (value) {
        return value;
    }
};
/**
 * Maps lowercase attribute names to their camelCase equivalents for internal use.
 * HTML DOM converts attributes to lowercase, but we want to maintain camelCase
 * naming conventions in the parsed output. XML parsers like xmldom preserve
 * the original casing.
 */ const $fb56f0cd7d6a30bd$var$attributeNameMap = {
    qualityranking: 'qualityRanking'
};
/**
 * Gets all the attributes and values of the provided node, parses attributes with known
 * types, and returns an object with attribute names mapped to values.
 *
 * @param {Node} el
 *        The node to parse attributes from
 * @return {Object}
 *         Object with all attributes of el parsed
 */ const $fb56f0cd7d6a30bd$var$parseAttributes = (el)=>{
    if (!(el && el.attributes)) return {};
    return $fb56f0cd7d6a30bd$var$from(el.attributes).reduce((a, e)=>{
        const parseFn = $fb56f0cd7d6a30bd$var$parsers[e.name] || $fb56f0cd7d6a30bd$var$parsers.DEFAULT;
        const attributeName = $fb56f0cd7d6a30bd$var$attributeNameMap[e.name] || e.name;
        a[attributeName] = parseFn(e.value);
        return a;
    }, {});
};
const $fb56f0cd7d6a30bd$var$keySystemsMap = {
    'urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b': 'org.w3.clearkey',
    'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed': 'com.widevine.alpha',
    'urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95': 'com.microsoft.playready',
    'urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb': 'com.adobe.primetime',
    // ISO_IEC 23009-1_2022 5.8.5.2.2 The mp4 Protection Scheme
    'urn:mpeg:dash:mp4protection:2011': 'mp4protection'
};
/**
 * Builds a list of urls that is the product of the reference urls and BaseURL values
 *
 * @param {Object[]} references
 *        List of objects containing the reference URL as well as its attributes
 * @param {Node[]} baseUrlElements
 *        List of BaseURL nodes from the mpd
 * @return {Object[]}
 *         List of objects with resolved urls and attributes
 */ const $fb56f0cd7d6a30bd$var$buildBaseUrls = (references, baseUrlElements)=>{
    if (!baseUrlElements.length) return references;
    return $fb56f0cd7d6a30bd$var$flatten(references.map(function(reference) {
        return baseUrlElements.map(function(baseUrlElement) {
            const initialBaseUrl = $fb56f0cd7d6a30bd$var$getContent(baseUrlElement);
            const resolvedBaseUrl = (0, $3c711be251a9bb4f$export$2e2bcd8739ae039)(reference.baseUrl, initialBaseUrl);
            const finalBaseUrl = $fb56f0cd7d6a30bd$var$merge($fb56f0cd7d6a30bd$var$parseAttributes(baseUrlElement), {
                baseUrl: resolvedBaseUrl
            }); // If the URL is resolved, we want to get the serviceLocation from the reference
            // assuming there is no serviceLocation on the initialBaseUrl
            if (resolvedBaseUrl !== initialBaseUrl && !finalBaseUrl.serviceLocation && reference.serviceLocation) finalBaseUrl.serviceLocation = reference.serviceLocation;
            return finalBaseUrl;
        });
    }));
};
/**
 * Contains all Segment information for its containing AdaptationSet
 *
 * @typedef {Object} SegmentInformation
 * @property {Object|undefined} template
 *           Contains the attributes for the SegmentTemplate node
 * @property {Object[]|undefined} segmentTimeline
 *           Contains a list of atrributes for each S node within the SegmentTimeline node
 * @property {Object|undefined} list
 *           Contains the attributes for the SegmentList node
 * @property {Object|undefined} base
 *           Contains the attributes for the SegmentBase node
 */ /**
 * Returns all available Segment information contained within the AdaptationSet node
 *
 * @param {Node} adaptationSet
 *        The AdaptationSet node to get Segment information from
 * @return {SegmentInformation}
 *         The Segment information contained within the provided AdaptationSet
 */ const $fb56f0cd7d6a30bd$var$getSegmentInformation = (adaptationSet)=>{
    const segmentTemplate = $fb56f0cd7d6a30bd$var$findChildren(adaptationSet, 'SegmentTemplate')[0];
    const segmentList = $fb56f0cd7d6a30bd$var$findChildren(adaptationSet, 'SegmentList')[0];
    const segmentUrls = segmentList && $fb56f0cd7d6a30bd$var$findChildren(segmentList, 'SegmentURL').map((s)=>$fb56f0cd7d6a30bd$var$merge({
            tag: 'SegmentURL'
        }, $fb56f0cd7d6a30bd$var$parseAttributes(s)));
    const segmentBase = $fb56f0cd7d6a30bd$var$findChildren(adaptationSet, 'SegmentBase')[0];
    const segmentTimelineParentNode = segmentList || segmentTemplate;
    const segmentTimeline = segmentTimelineParentNode && $fb56f0cd7d6a30bd$var$findChildren(segmentTimelineParentNode, 'SegmentTimeline')[0];
    const segmentInitializationParentNode = segmentList || segmentBase || segmentTemplate;
    const segmentInitialization = segmentInitializationParentNode && $fb56f0cd7d6a30bd$var$findChildren(segmentInitializationParentNode, 'Initialization')[0]; // SegmentTemplate is handled slightly differently, since it can have both
    // @initialization and an <Initialization> node.  @initialization can be templated,
    // while the node can have a url and range specified.  If the <SegmentTemplate> has
    // both @initialization and an <Initialization> subelement we opt to override with
    // the node, as this interaction is not defined in the spec.
    const template = segmentTemplate && $fb56f0cd7d6a30bd$var$parseAttributes(segmentTemplate);
    if (template && segmentInitialization) template.initialization = segmentInitialization && $fb56f0cd7d6a30bd$var$parseAttributes(segmentInitialization);
    else if (template && template.initialization) // If it is @initialization we convert it to an object since this is the format that
    // later functions will rely on for the initialization segment.  This is only valid
    // for <SegmentTemplate>
    template.initialization = {
        sourceURL: template.initialization
    };
    const segmentInfo = {
        template: template,
        segmentTimeline: segmentTimeline && $fb56f0cd7d6a30bd$var$findChildren(segmentTimeline, 'S').map((s)=>$fb56f0cd7d6a30bd$var$parseAttributes(s)),
        list: segmentList && $fb56f0cd7d6a30bd$var$merge($fb56f0cd7d6a30bd$var$parseAttributes(segmentList), {
            segmentUrls: segmentUrls,
            initialization: $fb56f0cd7d6a30bd$var$parseAttributes(segmentInitialization)
        }),
        base: segmentBase && $fb56f0cd7d6a30bd$var$merge($fb56f0cd7d6a30bd$var$parseAttributes(segmentBase), {
            initialization: $fb56f0cd7d6a30bd$var$parseAttributes(segmentInitialization)
        })
    };
    Object.keys(segmentInfo).forEach((key)=>{
        if (!segmentInfo[key]) delete segmentInfo[key];
    });
    return segmentInfo;
};
/**
 * Contains Segment information and attributes needed to construct a Playlist object
 * from a Representation
 *
 * @typedef {Object} RepresentationInformation
 * @property {SegmentInformation} segmentInfo
 *           Segment information for this Representation
 * @property {Object} attributes
 *           Inherited attributes for this Representation
 */ /**
 * Maps a Representation node to an object containing Segment information and attributes
 *
 * @name inheritBaseUrlsCallback
 * @function
 * @param {Node} representation
 *        Representation node from the mpd
 * @return {RepresentationInformation}
 *         Representation information needed to construct a Playlist object
 */ /**
 * Returns a callback for Array.prototype.map for mapping Representation nodes to
 * Segment information and attributes using inherited BaseURL nodes.
 *
 * @param {Object} adaptationSetAttributes
 *        Contains attributes inherited by the AdaptationSet
 * @param {Object[]} adaptationSetBaseUrls
 *        List of objects containing resolved base URLs and attributes
 *        inherited by the AdaptationSet
 * @param {SegmentInformation} adaptationSetSegmentInfo
 *        Contains Segment information for the AdaptationSet
 * @return {inheritBaseUrlsCallback}
 *         Callback map function
 */ const $fb56f0cd7d6a30bd$var$inheritBaseUrls = (adaptationSetAttributes, adaptationSetBaseUrls, adaptationSetSegmentInfo)=>(representation)=>{
        const repBaseUrlElements = $fb56f0cd7d6a30bd$var$findChildren(representation, 'BaseURL');
        const repBaseUrls = $fb56f0cd7d6a30bd$var$buildBaseUrls(adaptationSetBaseUrls, repBaseUrlElements);
        const attributes = $fb56f0cd7d6a30bd$var$merge(adaptationSetAttributes, $fb56f0cd7d6a30bd$var$parseAttributes(representation));
        const representationSegmentInfo = $fb56f0cd7d6a30bd$var$getSegmentInformation(representation);
        return repBaseUrls.map((baseUrl)=>{
            return {
                segmentInfo: $fb56f0cd7d6a30bd$var$merge(adaptationSetSegmentInfo, representationSegmentInfo),
                attributes: $fb56f0cd7d6a30bd$var$merge(attributes, baseUrl)
            };
        });
    };
/**
 * Tranforms a series of content protection nodes to
 * an object containing pssh data by key system
 *
 * @param {Node[]} contentProtectionNodes
 *        Content protection nodes
 * @return {Object}
 *        Object containing pssh data by key system
 */ const $fb56f0cd7d6a30bd$var$generateKeySystemInformation = (contentProtectionNodes)=>{
    return contentProtectionNodes.reduce((acc, node)=>{
        const attributes = $fb56f0cd7d6a30bd$var$parseAttributes(node); // Although it could be argued that according to the UUID RFC spec the UUID string (a-f chars) should be generated
        // as a lowercase string it also mentions it should be treated as case-insensitive on input. Since the key system
        // UUIDs in the keySystemsMap are hardcoded as lowercase in the codebase there isn't any reason not to do
        // .toLowerCase() on the input UUID string from the manifest (at least I could not think of one).
        if (attributes.schemeIdUri) attributes.schemeIdUri = attributes.schemeIdUri.toLowerCase();
        const keySystem = $fb56f0cd7d6a30bd$var$keySystemsMap[attributes.schemeIdUri];
        if (keySystem) {
            acc[keySystem] = {
                attributes: attributes
            };
            const psshNode = $fb56f0cd7d6a30bd$var$findChildren(node, 'cenc:pssh')[0];
            if (psshNode) {
                const pssh = $fb56f0cd7d6a30bd$var$getContent(psshNode);
                acc[keySystem].pssh = pssh && (0, $39570e0c51fe4cb5$export$2e2bcd8739ae039)(pssh);
            }
        }
        return acc;
    }, {});
}; // defined in ANSI_SCTE 214-1 2016
const $fb56f0cd7d6a30bd$var$parseCaptionServiceMetadata = (service)=>{
    // 608 captions
    if (service.schemeIdUri === 'urn:scte:dash:cc:cea-608:2015') {
        const values = typeof service.value !== 'string' ? [] : service.value.split(';');
        return values.map((value)=>{
            let channel;
            let language; // default language to value
            language = value;
            if (/^CC\d=/.test(value)) [channel, language] = value.split('=');
            else if (/^CC\d$/.test(value)) channel = value;
            return {
                channel: channel,
                language: language
            };
        });
    } else if (service.schemeIdUri === 'urn:scte:dash:cc:cea-708:2015') {
        const values = typeof service.value !== 'string' ? [] : service.value.split(';');
        return values.map((value)=>{
            const flags = {
                // service or channel number 1-63
                'channel': undefined,
                // language is a 3ALPHA per ISO 639.2/B
                // field is required
                'language': undefined,
                // BIT 1/0 or ?
                // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
                'aspectRatio': 1,
                // BIT 1/0
                // easy reader flag indicated the text is tailed to the needs of beginning readers
                // default 0, or off
                'easyReader': 0,
                // BIT 1/0
                // If 3d metadata is present (CEA-708.1) then 1
                // default 0
                '3D': 0
            };
            if (/=/.test(value)) {
                const [channel, opts = ''] = value.split('=');
                flags.channel = channel;
                flags.language = value;
                opts.split(',').forEach((opt)=>{
                    const [name, val] = opt.split(':');
                    if (name === 'lang') flags.language = val; // er for easyReadery
                    else if (name === 'er') flags.easyReader = Number(val); // war for wide aspect ratio
                    else if (name === 'war') flags.aspectRatio = Number(val);
                    else if (name === '3D') flags['3D'] = Number(val);
                });
            } else flags.language = value;
            if (flags.channel) flags.channel = 'SERVICE' + flags.channel;
            return flags;
        });
    }
};
/**
 * A map callback that will parse all event stream data for a collection of periods
 * DASH ISO_IEC_23009 5.10.2.2
 * https://dashif-documents.azurewebsites.net/Events/master/event.html#mpd-event-timing
 *
 * @param {PeriodInformation} period object containing necessary period information
 * @return a collection of parsed eventstream event objects
 */ const $fb56f0cd7d6a30bd$var$toEventStream = (period)=>{
    // get and flatten all EventStreams tags and parse attributes and children
    return $fb56f0cd7d6a30bd$var$flatten($fb56f0cd7d6a30bd$var$findChildren(period.node, 'EventStream').map((eventStream)=>{
        const eventStreamAttributes = $fb56f0cd7d6a30bd$var$parseAttributes(eventStream);
        const schemeIdUri = eventStreamAttributes.schemeIdUri; // find all Events per EventStream tag and map to return objects
        return $fb56f0cd7d6a30bd$var$findChildren(eventStream, 'Event').map((event)=>{
            const eventAttributes = $fb56f0cd7d6a30bd$var$parseAttributes(event);
            const presentationTime = eventAttributes.presentationTime || 0;
            const timescale = eventStreamAttributes.timescale || 1;
            const duration = eventAttributes.duration || 0;
            const start = presentationTime / timescale + period.attributes.start;
            return {
                schemeIdUri: schemeIdUri,
                value: eventStreamAttributes.value,
                id: eventAttributes.id,
                start: start,
                end: start + duration / timescale,
                messageData: $fb56f0cd7d6a30bd$var$getContent(event) || eventAttributes.messageData,
                contentEncoding: eventStreamAttributes.contentEncoding,
                presentationTimeOffset: eventStreamAttributes.presentationTimeOffset || 0
            };
        });
    }));
};
/**
 * Maps an AdaptationSet node to a list of Representation information objects
 *
 * @name toRepresentationsCallback
 * @function
 * @param {Node} adaptationSet
 *        AdaptationSet node from the mpd
 * @return {RepresentationInformation[]}
 *         List of objects containing Representaion information
 */ /**
 * Returns a callback for Array.prototype.map for mapping AdaptationSet nodes to a list of
 * Representation information objects
 *
 * @param {Object} periodAttributes
 *        Contains attributes inherited by the Period
 * @param {Object[]} periodBaseUrls
 *        Contains list of objects with resolved base urls and attributes
 *        inherited by the Period
 * @param {string[]} periodSegmentInfo
 *        Contains Segment Information at the period level
 * @return {toRepresentationsCallback}
 *         Callback map function
 */ const $fb56f0cd7d6a30bd$var$toRepresentations = (periodAttributes, periodBaseUrls, periodSegmentInfo)=>(adaptationSet)=>{
        const adaptationSetAttributes = $fb56f0cd7d6a30bd$var$parseAttributes(adaptationSet);
        const adaptationSetBaseUrls = $fb56f0cd7d6a30bd$var$buildBaseUrls(periodBaseUrls, $fb56f0cd7d6a30bd$var$findChildren(adaptationSet, 'BaseURL'));
        const role = $fb56f0cd7d6a30bd$var$findChildren(adaptationSet, 'Role')[0];
        const roleAttributes = {
            role: $fb56f0cd7d6a30bd$var$parseAttributes(role)
        };
        let attrs = $fb56f0cd7d6a30bd$var$merge(periodAttributes, adaptationSetAttributes, roleAttributes);
        const accessibility = $fb56f0cd7d6a30bd$var$findChildren(adaptationSet, 'Accessibility')[0];
        const captionServices = $fb56f0cd7d6a30bd$var$parseCaptionServiceMetadata($fb56f0cd7d6a30bd$var$parseAttributes(accessibility));
        if (captionServices) attrs = $fb56f0cd7d6a30bd$var$merge(attrs, {
            captionServices: captionServices
        });
        const label = $fb56f0cd7d6a30bd$var$findChildren(adaptationSet, 'Label')[0];
        if (label && label.childNodes.length) {
            const labelVal = label.childNodes[0].nodeValue.trim();
            attrs = $fb56f0cd7d6a30bd$var$merge(attrs, {
                label: labelVal
            });
        }
        const contentProtection = $fb56f0cd7d6a30bd$var$generateKeySystemInformation($fb56f0cd7d6a30bd$var$findChildren(adaptationSet, 'ContentProtection'));
        if (Object.keys(contentProtection).length) attrs = $fb56f0cd7d6a30bd$var$merge(attrs, {
            contentProtection: contentProtection
        });
        const segmentInfo = $fb56f0cd7d6a30bd$var$getSegmentInformation(adaptationSet);
        const representations = $fb56f0cd7d6a30bd$var$findChildren(adaptationSet, 'Representation');
        const adaptationSetSegmentInfo = $fb56f0cd7d6a30bd$var$merge(periodSegmentInfo, segmentInfo);
        return $fb56f0cd7d6a30bd$var$flatten(representations.map($fb56f0cd7d6a30bd$var$inheritBaseUrls(attrs, adaptationSetBaseUrls, adaptationSetSegmentInfo)));
    };
/**
 * Contains all period information for mapping nodes onto adaptation sets.
 *
 * @typedef {Object} PeriodInformation
 * @property {Node} period.node
 *           Period node from the mpd
 * @property {Object} period.attributes
 *           Parsed period attributes from node plus any added
 */ /**
 * Maps a PeriodInformation object to a list of Representation information objects for all
 * AdaptationSet nodes contained within the Period.
 *
 * @name toAdaptationSetsCallback
 * @function
 * @param {PeriodInformation} period
 *        Period object containing necessary period information
 * @param {number} periodStart
 *        Start time of the Period within the mpd
 * @return {RepresentationInformation[]}
 *         List of objects containing Representaion information
 */ /**
 * Returns a callback for Array.prototype.map for mapping Period nodes to a list of
 * Representation information objects
 *
 * @param {Object} mpdAttributes
 *        Contains attributes inherited by the mpd
  * @param {Object[]} mpdBaseUrls
 *        Contains list of objects with resolved base urls and attributes
 *        inherited by the mpd
 * @return {toAdaptationSetsCallback}
 *         Callback map function
 */ const $fb56f0cd7d6a30bd$var$toAdaptationSets = (mpdAttributes, mpdBaseUrls)=>(period, index)=>{
        const periodBaseUrls = $fb56f0cd7d6a30bd$var$buildBaseUrls(mpdBaseUrls, $fb56f0cd7d6a30bd$var$findChildren(period.node, 'BaseURL'));
        const periodAttributes = $fb56f0cd7d6a30bd$var$merge(mpdAttributes, {
            periodStart: period.attributes.start
        });
        if (typeof period.attributes.duration === 'number') periodAttributes.periodDuration = period.attributes.duration;
        const adaptationSets = $fb56f0cd7d6a30bd$var$findChildren(period.node, 'AdaptationSet');
        const periodSegmentInfo = $fb56f0cd7d6a30bd$var$getSegmentInformation(period.node);
        return $fb56f0cd7d6a30bd$var$flatten(adaptationSets.map($fb56f0cd7d6a30bd$var$toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo)));
    };
/**
 * Tranforms an array of content steering nodes into an object
 * containing CDN content steering information from the MPD manifest.
 *
 * For more information on the DASH spec for Content Steering parsing, see:
 * https://dashif.org/docs/DASH-IF-CTS-00XX-Content-Steering-Community-Review.pdf
 *
 * @param {Node[]} contentSteeringNodes
 *        Content steering nodes
 * @param {Function} eventHandler
 *        The event handler passed into the parser options to handle warnings
 * @return {Object}
 *        Object containing content steering data
 */ const $fb56f0cd7d6a30bd$var$generateContentSteeringInformation = (contentSteeringNodes, eventHandler)=>{
    // If there are more than one ContentSteering tags, throw an error
    if (contentSteeringNodes.length > 1) eventHandler({
        type: 'warn',
        message: 'The MPD manifest should contain no more than one ContentSteering tag'
    });
     // Return a null value if there are no ContentSteering tags
    if (!contentSteeringNodes.length) return null;
    const infoFromContentSteeringTag = $fb56f0cd7d6a30bd$var$merge({
        serverURL: $fb56f0cd7d6a30bd$var$getContent(contentSteeringNodes[0])
    }, $fb56f0cd7d6a30bd$var$parseAttributes(contentSteeringNodes[0])); // Converts `queryBeforeStart` to a boolean, as well as setting the default value
    // to `false` if it doesn't exist
    infoFromContentSteeringTag.queryBeforeStart = infoFromContentSteeringTag.queryBeforeStart === 'true';
    return infoFromContentSteeringTag;
};
/**
 * Gets Period@start property for a given period.
 *
 * @param {Object} options
 *        Options object
 * @param {Object} options.attributes
 *        Period attributes
 * @param {Object} [options.priorPeriodAttributes]
 *        Prior period attributes (if prior period is available)
 * @param {string} options.mpdType
 *        The MPD@type these periods came from
 * @return {number|null}
 *         The period start, or null if it's an early available period or error
 */ const $fb56f0cd7d6a30bd$var$getPeriodStart = ({ attributes: attributes, priorPeriodAttributes: priorPeriodAttributes, mpdType: mpdType })=>{
    // Summary of period start time calculation from DASH spec section 5.3.2.1
    //
    // A period's start is the first period's start + time elapsed after playing all
    // prior periods to this one. Periods continue one after the other in time (without
    // gaps) until the end of the presentation.
    //
    // The value of Period@start should be:
    // 1. if Period@start is present: value of Period@start
    // 2. if previous period exists and it has @duration: previous Period@start +
    //    previous Period@duration
    // 3. if this is first period and MPD@type is 'static': 0
    // 4. in all other cases, consider the period an "early available period" (note: not
    //    currently supported)
    // (1)
    if (typeof attributes.start === 'number') return attributes.start;
     // (2)
    if (priorPeriodAttributes && typeof priorPeriodAttributes.start === 'number' && typeof priorPeriodAttributes.duration === 'number') return priorPeriodAttributes.start + priorPeriodAttributes.duration;
     // (3)
    if (!priorPeriodAttributes && mpdType === 'static') return 0;
     // (4)
    // There is currently no logic for calculating the Period@start value if there is
    // no Period@start or prior Period@start and Period@duration available. This is not made
    // explicit by the DASH interop guidelines or the DASH spec, however, since there's
    // nothing about any other resolution strategies, it's implied. Thus, this case should
    // be considered an early available period, or error, and null should suffice for both
    // of those cases.
    return null;
};
/**
 * Traverses the mpd xml tree to generate a list of Representation information objects
 * that have inherited attributes from parent nodes
 *
 * @param {Node} mpd
 *        The root node of the mpd
 * @param {Object} options
 *        Available options for inheritAttributes
 * @param {string} options.manifestUri
 *        The uri source of the mpd
 * @param {number} options.NOW
 *        Current time per DASH IOP.  Default is current time in ms since epoch
 * @param {number} options.clientOffset
 *        Client time difference from NOW (in milliseconds)
 * @return {RepresentationInformation[]}
 *         List of objects containing Representation information
 */ const $fb56f0cd7d6a30bd$export$1d58e194e30f14d4 = (mpd, options = {})=>{
    const { manifestUri: manifestUri = '', NOW: NOW = Date.now(), clientOffset: clientOffset = 0, eventHandler: // TODO: For now, we are expecting an eventHandler callback function
    // to be passed into the mpd parser as an option.
    // In the future, we should enable stream parsing by using the Stream class from vhs-utils.
    // This will support new features including a standardized event handler.
    // See the m3u8 parser for examples of how stream parsing is currently used for HLS parsing.
    // https://github.com/videojs/vhs-utils/blob/88d6e10c631e57a5af02c5a62bc7376cd456b4f5/src/stream.js#L9
    eventHandler = function() {} } = options;
    const periodNodes = $fb56f0cd7d6a30bd$var$findChildren(mpd, 'Period');
    if (!periodNodes.length) throw new Error($fb56f0cd7d6a30bd$var$errors.INVALID_NUMBER_OF_PERIOD);
    const locations = $fb56f0cd7d6a30bd$var$findChildren(mpd, 'Location');
    const mpdAttributes = $fb56f0cd7d6a30bd$var$parseAttributes(mpd);
    const mpdBaseUrls = $fb56f0cd7d6a30bd$var$buildBaseUrls([
        {
            baseUrl: manifestUri
        }
    ], $fb56f0cd7d6a30bd$var$findChildren(mpd, 'BaseURL'));
    const contentSteeringNodes = $fb56f0cd7d6a30bd$var$findChildren(mpd, 'ContentSteering'); // See DASH spec section 5.3.1.2, Semantics of MPD element. Default type to 'static'.
    mpdAttributes.type = mpdAttributes.type || 'static';
    mpdAttributes.sourceDuration = mpdAttributes.mediaPresentationDuration || 0;
    mpdAttributes.NOW = NOW;
    mpdAttributes.clientOffset = clientOffset;
    if (locations.length) mpdAttributes.locations = locations.map($fb56f0cd7d6a30bd$var$getContent);
    const periods = []; // Since toAdaptationSets acts on individual periods right now, the simplest approach to
    // adding properties that require looking at prior periods is to parse attributes and add
    // missing ones before toAdaptationSets is called. If more such properties are added, it
    // may be better to refactor toAdaptationSets.
    periodNodes.forEach((node, index)=>{
        const attributes = $fb56f0cd7d6a30bd$var$parseAttributes(node); // Use the last modified prior period, as it may contain added information necessary
        // for this period.
        const priorPeriod = periods[index - 1];
        attributes.start = $fb56f0cd7d6a30bd$var$getPeriodStart({
            attributes: attributes,
            priorPeriodAttributes: priorPeriod ? priorPeriod.attributes : null,
            mpdType: mpdAttributes.type
        });
        periods.push({
            node: node,
            attributes: attributes
        });
    });
    return {
        locations: mpdAttributes.locations,
        contentSteeringInfo: $fb56f0cd7d6a30bd$var$generateContentSteeringInformation(contentSteeringNodes, eventHandler),
        // TODO: There are occurences where this `representationInfo` array contains undesired
        // duplicates. This generally occurs when there are multiple BaseURL nodes that are
        // direct children of the MPD node. When we attempt to resolve URLs from a combination of the
        // parent BaseURL and a child BaseURL, and the value does not resolve,
        // we end up returning the child BaseURL multiple times.
        // We need to determine a way to remove these duplicates in a safe way.
        // See: https://github.com/videojs/mpd-parser/pull/17#discussion_r162750527
        representationInfo: $fb56f0cd7d6a30bd$var$flatten(periods.map($fb56f0cd7d6a30bd$var$toAdaptationSets(mpdAttributes, mpdBaseUrls))),
        eventStream: $fb56f0cd7d6a30bd$var$flatten(periods.map($fb56f0cd7d6a30bd$var$toEventStream))
    };
};
const $fb56f0cd7d6a30bd$export$d9d51d4eae920a2a = (manifestString)=>{
    if (manifestString === '') throw new Error($fb56f0cd7d6a30bd$var$errors.DASH_EMPTY_MANIFEST);
    const parser = new (0, $a28fabd21ad88010$export$1059c6e7d2ce5669)();
    let xml;
    let mpd;
    try {
        xml = parser.parseFromString(manifestString, 'application/xml');
        mpd = xml && xml.documentElement.tagName === 'MPD' ? xml.documentElement : null;
    } catch (e) {}
    if (!mpd || mpd && mpd.getElementsByTagName('parsererror').length > 0) throw new Error($fb56f0cd7d6a30bd$var$errors.DASH_INVALID_XML);
    return mpd;
};
/**
 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
 *
 * @param {string} mpd
 *        XML string of the MPD manifest
 * @return {Object|null}
 *         Attributes of UTCTiming node specified in the manifest. Null if none found
 */ const $fb56f0cd7d6a30bd$var$parseUTCTimingScheme = (mpd)=>{
    const UTCTimingNode = $fb56f0cd7d6a30bd$var$findChildren(mpd, 'UTCTiming')[0];
    if (!UTCTimingNode) return null;
    const attributes = $fb56f0cd7d6a30bd$var$parseAttributes(UTCTimingNode);
    switch(attributes.schemeIdUri){
        case 'urn:mpeg:dash:utc:http-head:2014':
        case 'urn:mpeg:dash:utc:http-head:2012':
            attributes.method = 'HEAD';
            break;
        case 'urn:mpeg:dash:utc:http-xsdate:2014':
        case 'urn:mpeg:dash:utc:http-iso:2014':
        case 'urn:mpeg:dash:utc:http-xsdate:2012':
        case 'urn:mpeg:dash:utc:http-iso:2012':
            attributes.method = 'GET';
            break;
        case 'urn:mpeg:dash:utc:direct:2014':
        case 'urn:mpeg:dash:utc:direct:2012':
            attributes.method = 'DIRECT';
            attributes.value = Date.parse(attributes.value);
            break;
        case 'urn:mpeg:dash:utc:http-ntp:2014':
        case 'urn:mpeg:dash:utc:ntp:2014':
        case 'urn:mpeg:dash:utc:sntp:2014':
        default:
            throw new Error($fb56f0cd7d6a30bd$var$errors.UNSUPPORTED_UTC_TIMING_SCHEME);
    }
    return attributes;
};
const $fb56f0cd7d6a30bd$export$a4ad2735b021c132 = $fb56f0cd7d6a30bd$var$version;
/*
 * Given a DASH manifest string and options, parses the DASH manifest into an object in the
 * form outputed by m3u8-parser and accepted by videojs/http-streaming.
 *
 * For live DASH manifests, if `previousManifest` is provided in options, then the newly
 * parsed DASH manifest will have its media sequence and discontinuity sequence values
 * updated to reflect its position relative to the prior manifest.
 *
 * @param {string} manifestString - the DASH manifest as a string
 * @param {options} [options] - any options
 *
 * @return {Object} the manifest object
 */ const $fb56f0cd7d6a30bd$export$98e6a39c04603d36 = (manifestString, options = {})=>{
    const parsedManifestInfo = $fb56f0cd7d6a30bd$export$1d58e194e30f14d4($fb56f0cd7d6a30bd$export$d9d51d4eae920a2a(manifestString), options);
    const playlists = $fb56f0cd7d6a30bd$export$4362d710904f703f(parsedManifestInfo.representationInfo);
    return $fb56f0cd7d6a30bd$export$c90e7d9f067c8f2c({
        dashPlaylists: playlists,
        locations: parsedManifestInfo.locations,
        contentSteering: parsedManifestInfo.contentSteeringInfo,
        sidxMapping: options.sidxMapping,
        previousManifest: options.previousManifest,
        eventStream: parsedManifestInfo.eventStream
    });
};
/**
 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
 *
 * @param {string} manifestString
 *        XML string of the MPD manifest
 * @return {Object|null}
 *         Attributes of UTCTiming node specified in the manifest. Null if none found
 */ const $fb56f0cd7d6a30bd$export$734c7278b5d0068c = (manifestString)=>$fb56f0cd7d6a30bd$var$parseUTCTimingScheme($fb56f0cd7d6a30bd$export$d9d51d4eae920a2a(manifestString));


var $5cbfc743861df2b8$exports = {};
var $a132f953d167c9dd$exports = {};
var $a132f953d167c9dd$var$MAX_UINT32 = Math.pow(2, 32);
var $a132f953d167c9dd$var$getUint64 = function(uint8) {
    var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
    var value;
    if (dv.getBigUint64) {
        value = dv.getBigUint64(0);
        if (value < Number.MAX_SAFE_INTEGER) return Number(value);
        return value;
    }
    return dv.getUint32(0) * $a132f953d167c9dd$var$MAX_UINT32 + dv.getUint32(4);
};
$a132f953d167c9dd$exports = {
    getUint64: $a132f953d167c9dd$var$getUint64,
    MAX_UINT32: $a132f953d167c9dd$var$MAX_UINT32
};


var $5cbfc743861df2b8$require$getUint64 = $a132f953d167c9dd$exports.getUint64;
var $5cbfc743861df2b8$var$parseSidx = function(data) {
    var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
        version: data[0],
        flags: new Uint8Array(data.subarray(1, 4)),
        references: [],
        referenceId: view.getUint32(4),
        timescale: view.getUint32(8)
    }, i = 12;
    if (result.version === 0) {
        result.earliestPresentationTime = view.getUint32(i);
        result.firstOffset = view.getUint32(i + 4);
        i += 8;
    } else {
        // read 64 bits
        result.earliestPresentationTime = $5cbfc743861df2b8$require$getUint64(data.subarray(i));
        result.firstOffset = $5cbfc743861df2b8$require$getUint64(data.subarray(i + 8));
        i += 16;
    }
    i += 2; // reserved
    var referenceCount = view.getUint16(i);
    i += 2; // start of references
    for(; referenceCount > 0; i += 12, referenceCount--)result.references.push({
        referenceType: (data[i] & 0x80) >>> 7,
        referencedSize: view.getUint32(i) & 0x7FFFFFFF,
        subsegmentDuration: view.getUint32(i + 4),
        startsWithSap: !!(data[i + 8] & 0x80),
        sapType: (data[i + 8] & 0x70) >>> 4,
        sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
    });
    return result;
};
$5cbfc743861df2b8$exports = $5cbfc743861df2b8$var$parseSidx;



var $beb668c0ff46ee9c$var$ID3 = (0, $0cb67f3f52413d92$export$63c3de442720649)([
    0x49,
    0x44,
    0x33
]);
var $beb668c0ff46ee9c$export$1d0ef9131773159b = function getId3Size(bytes, offset) {
    if (offset === void 0) offset = 0;
    bytes = (0, $0cb67f3f52413d92$export$63c3de442720649)(bytes);
    var flags = bytes[offset + 5];
    var returnSize = bytes[offset + 6] << 21 | bytes[offset + 7] << 14 | bytes[offset + 8] << 7 | bytes[offset + 9];
    var footerPresent = (flags & 16) >> 4;
    if (footerPresent) return returnSize + 20;
    return returnSize + 10;
};
var $beb668c0ff46ee9c$export$56b6cacf09ec1126 = function getId3Offset(bytes, offset) {
    if (offset === void 0) offset = 0;
    bytes = (0, $0cb67f3f52413d92$export$63c3de442720649)(bytes);
    if (bytes.length - offset < 10 || !(0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $beb668c0ff46ee9c$var$ID3, {
        offset: offset
    })) return offset;
    offset += $beb668c0ff46ee9c$export$1d0ef9131773159b(bytes, offset); // recursive check for id3 tags as some files
    // have multiple ID3 tag sections even though
    // they should not.
    return getId3Offset(bytes, offset);
};





var $83debb266c4a96bb$export$5ff37217be0e6718 = function getAv1Codec(bytes) {
    var codec = '';
    var profile = bytes[1] >>> 3;
    var level = bytes[1] & 0x1F;
    var tier = bytes[2] >>> 7;
    var highBitDepth = (bytes[2] & 0x40) >> 6;
    var twelveBit = (bytes[2] & 0x20) >> 5;
    var monochrome = (bytes[2] & 0x10) >> 4;
    var chromaSubsamplingX = (bytes[2] & 0x08) >> 3;
    var chromaSubsamplingY = (bytes[2] & 0x04) >> 2;
    var chromaSamplePosition = bytes[2] & 0x03;
    codec += profile + "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(level, 2, '0');
    if (tier === 0) codec += 'M';
    else if (tier === 1) codec += 'H';
    var bitDepth;
    if (profile === 2 && highBitDepth) bitDepth = twelveBit ? 12 : 10;
    else bitDepth = highBitDepth ? 10 : 8;
    codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(bitDepth, 2, '0'); // TODO: can we parse color range??
    codec += "." + monochrome;
    codec += "." + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition;
    return codec;
};
var $83debb266c4a96bb$export$f316fb16efba7de9 = function getAvcCodec(bytes) {
    var profileId = (0, $0cb67f3f52413d92$export$f4915efbb94d4d01)(bytes[1]);
    var constraintFlags = (0, $0cb67f3f52413d92$export$f4915efbb94d4d01)(bytes[2] & 0xFC);
    var levelId = (0, $0cb67f3f52413d92$export$f4915efbb94d4d01)(bytes[3]);
    return "" + profileId + constraintFlags + levelId;
};
var $83debb266c4a96bb$export$57f4fb41d46b44d9 = function getHvcCodec(bytes) {
    var codec = '';
    var profileSpace = bytes[1] >> 6;
    var profileId = bytes[1] & 0x1F;
    var tierFlag = (bytes[1] & 0x20) >> 5;
    var profileCompat = bytes.subarray(2, 6);
    var constraintIds = bytes.subarray(6, 12);
    var levelId = bytes[12];
    if (profileSpace === 1) codec += 'A';
    else if (profileSpace === 2) codec += 'B';
    else if (profileSpace === 3) codec += 'C';
    codec += profileId + "."; // ffmpeg does this in big endian
    var profileCompatVal = parseInt((0, $0cb67f3f52413d92$export$9a7d75f397723250)(profileCompat).split('').reverse().join(''), 2); // apple does this in little endian...
    if (profileCompatVal > 255) profileCompatVal = parseInt((0, $0cb67f3f52413d92$export$9a7d75f397723250)(profileCompat), 2);
    codec += profileCompatVal.toString(16) + ".";
    if (tierFlag === 0) codec += 'L';
    else codec += 'H';
    codec += levelId;
    var constraints = '';
    for(var i = 0; i < constraintIds.length; i++){
        var v = constraintIds[i];
        if (v) {
            if (constraints) constraints += '.';
            constraints += v.toString(16);
        }
    }
    if (constraints) codec += "." + constraints;
    return codec;
};


var $f2fca47ed8ab3dd3$export$bbdb118c36f58091 = new Uint8Array([
    0x4f,
    0x70,
    0x75,
    0x73,
    0x48,
    0x65,
    0x61,
    0x64
]); // https://wiki.xiph.org/OggOpus
var $f2fca47ed8ab3dd3$export$162487c51ffd8212 = function parseOpusHead(bytes) {
    var view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    var version = view.getUint8(0); // version 0, from mp4, does not use littleEndian.
    var littleEndian = version !== 0;
    var config = {
        version: version,
        channels: view.getUint8(1),
        preSkip: view.getUint16(2, littleEndian),
        sampleRate: view.getUint32(4, littleEndian),
        outputGain: view.getUint16(8, littleEndian),
        channelMappingFamily: view.getUint8(10)
    };
    if (config.channelMappingFamily > 0 && bytes.length > 10) {
        config.streamCount = view.getUint8(11);
        config.twoChannelStreamCount = view.getUint8(12);
        config.channelMapping = [];
        for(var c = 0; c < config.channels; c++)config.channelMapping.push(view.getUint8(13 + c));
    }
    return config;
};
var $f2fca47ed8ab3dd3$export$57dc6f8263af01df = function setOpusHead(config) {
    var size = config.channelMappingFamily <= 0 ? 11 : 12 + config.channels;
    var view = new DataView(new ArrayBuffer(size));
    var littleEndian = config.version !== 0;
    view.setUint8(0, config.version);
    view.setUint8(1, config.channels);
    view.setUint16(2, config.preSkip, littleEndian);
    view.setUint32(4, config.sampleRate, littleEndian);
    view.setUint16(8, config.outputGain, littleEndian);
    view.setUint8(10, config.channelMappingFamily);
    if (config.channelMappingFamily > 0) {
        view.setUint8(11, config.streamCount);
        config.channelMapping.foreach(function(cm, i) {
            view.setUint8(12 + i, cm);
        });
    }
    return new Uint8Array(view.buffer);
};


var $2bcab42a90c6ad9b$var$normalizePath = function normalizePath(path) {
    if (typeof path === 'string') return (0, $0cb67f3f52413d92$export$c8dd6bc66a63753c)(path);
    if (typeof path === 'number') return path;
    return path;
};
var $2bcab42a90c6ad9b$var$normalizePaths = function normalizePaths(paths) {
    if (!Array.isArray(paths)) return [
        $2bcab42a90c6ad9b$var$normalizePath(paths)
    ];
    return paths.map(function(p) {
        return $2bcab42a90c6ad9b$var$normalizePath(p);
    });
};
var $2bcab42a90c6ad9b$var$DESCRIPTORS;
var $2bcab42a90c6ad9b$export$fe4700066a34ac73 = function parseDescriptors(bytes) {
    bytes = (0, $0cb67f3f52413d92$export$63c3de442720649)(bytes);
    var results = [];
    var i = 0;
    while(bytes.length > i){
        var tag = bytes[i];
        var size = 0;
        var headerSize = 0; // tag
        headerSize++;
        var byte = bytes[headerSize]; // first byte
        headerSize++;
        while(byte & 0x80){
            size = (byte & 0x7F) << 7;
            byte = bytes[headerSize];
            headerSize++;
        }
        size += byte & 0x7F;
        for(var z = 0; z < $2bcab42a90c6ad9b$var$DESCRIPTORS.length; z++){
            var _DESCRIPTORS$z = $2bcab42a90c6ad9b$var$DESCRIPTORS[z], id = _DESCRIPTORS$z.id, parser = _DESCRIPTORS$z.parser;
            if (tag === id) {
                results.push(parser(bytes.subarray(headerSize, headerSize + size)));
                break;
            }
        }
        i += size + headerSize;
    }
    return results;
};
$2bcab42a90c6ad9b$var$DESCRIPTORS = [
    {
        id: 0x03,
        parser: function parser(bytes) {
            var desc = {
                tag: 0x03,
                id: bytes[0] << 8 | bytes[1],
                flags: bytes[2],
                size: 3,
                dependsOnEsId: 0,
                ocrEsId: 0,
                descriptors: [],
                url: ''
            }; // depends on es id
            if (desc.flags & 0x80) {
                desc.dependsOnEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
                desc.size += 2;
            } // url
            if (desc.flags & 0x40) {
                var len = bytes[desc.size];
                desc.url = (0, $0cb67f3f52413d92$export$7c746b75f47c9c7d)(bytes.subarray(desc.size + 1, desc.size + 1 + len));
                desc.size += len;
            } // ocr es id
            if (desc.flags & 0x20) {
                desc.ocrEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
                desc.size += 2;
            }
            desc.descriptors = $2bcab42a90c6ad9b$export$fe4700066a34ac73(bytes.subarray(desc.size)) || [];
            return desc;
        }
    },
    {
        id: 0x04,
        parser: function parser(bytes) {
            // DecoderConfigDescriptor
            var desc = {
                tag: 0x04,
                oti: bytes[0],
                streamType: bytes[1],
                bufferSize: bytes[2] << 16 | bytes[3] << 8 | bytes[4],
                maxBitrate: bytes[5] << 24 | bytes[6] << 16 | bytes[7] << 8 | bytes[8],
                avgBitrate: bytes[9] << 24 | bytes[10] << 16 | bytes[11] << 8 | bytes[12],
                descriptors: $2bcab42a90c6ad9b$export$fe4700066a34ac73(bytes.subarray(13))
            };
            return desc;
        }
    },
    {
        id: 0x05,
        parser: function parser(bytes) {
            // DecoderSpecificInfo
            return {
                tag: 0x05,
                bytes: bytes
            };
        }
    },
    {
        id: 0x06,
        parser: function parser(bytes) {
            // SLConfigDescriptor
            return {
                tag: 0x06,
                bytes: bytes
            };
        }
    }
];
var $2bcab42a90c6ad9b$export$d81d43b46e2012ef = function findBox(bytes, paths, complete) {
    if (complete === void 0) complete = false;
    paths = $2bcab42a90c6ad9b$var$normalizePaths(paths);
    bytes = (0, $0cb67f3f52413d92$export$63c3de442720649)(bytes);
    var results = [];
    if (!paths.length) // short-circuit the search for empty paths
    return results;
    var i = 0;
    while(i < bytes.length){
        var size = (bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]) >>> 0;
        var type = bytes.subarray(i + 4, i + 8); // invalid box format.
        if (size === 0) break;
        var end = i + size;
        if (end > bytes.length) {
            // this box is bigger than the number of bytes we have
            // and complete is set, we cannot find any more boxes.
            if (complete) break;
            end = bytes.length;
        }
        var data = bytes.subarray(i + 8, end);
        if ((0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(type, paths[0])) {
            if (paths.length === 1) // this is the end of the path and we've found the box we were
            // looking for
            results.push(data);
            else // recursively search for the next box along the path
            results.push.apply(results, findBox(data, paths.slice(1), complete));
        }
        i = end;
    } // we've finished searching all of bytes
    return results;
};
var $2bcab42a90c6ad9b$export$610b5b08fd0ffeb4 = function findNamedBox(bytes, name) {
    name = $2bcab42a90c6ad9b$var$normalizePath(name);
    if (!name.length) // short-circuit the search for empty paths
    return bytes.subarray(bytes.length);
    var i = 0;
    while(i < bytes.length){
        if ((0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes.subarray(i, i + name.length), name)) {
            var size = (bytes[i - 4] << 24 | bytes[i - 3] << 16 | bytes[i - 2] << 8 | bytes[i - 1]) >>> 0;
            var end = size > 1 ? i + size : bytes.byteLength;
            return bytes.subarray(i + 4, end);
        }
        i++;
    } // we've finished searching all of bytes
    return bytes.subarray(bytes.length);
};
var $2bcab42a90c6ad9b$var$parseSamples = function parseSamples(data, entrySize, parseEntry) {
    if (entrySize === void 0) entrySize = 4;
    if (parseEntry === void 0) parseEntry = function parseEntry(d) {
        return (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(d);
    };
    var entries = [];
    if (!data || !data.length) return entries;
    var entryCount = (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(data.subarray(4, 8));
    for(var i = 8; entryCount; i += entrySize, entryCount--)entries.push(parseEntry(data.subarray(i, i + entrySize)));
    return entries;
};
var $2bcab42a90c6ad9b$export$78870b2844ff6386 = function buildFrameTable(stbl, timescale) {
    var keySamples = $2bcab42a90c6ad9b$var$parseSamples($2bcab42a90c6ad9b$export$d81d43b46e2012ef(stbl, [
        'stss'
    ])[0]);
    var chunkOffsets = $2bcab42a90c6ad9b$var$parseSamples($2bcab42a90c6ad9b$export$d81d43b46e2012ef(stbl, [
        'stco'
    ])[0]);
    var timeToSamples = $2bcab42a90c6ad9b$var$parseSamples($2bcab42a90c6ad9b$export$d81d43b46e2012ef(stbl, [
        'stts'
    ])[0], 8, function(entry) {
        return {
            sampleCount: (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(entry.subarray(0, 4)),
            sampleDelta: (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(entry.subarray(4, 8))
        };
    });
    var samplesToChunks = $2bcab42a90c6ad9b$var$parseSamples($2bcab42a90c6ad9b$export$d81d43b46e2012ef(stbl, [
        'stsc'
    ])[0], 12, function(entry) {
        return {
            firstChunk: (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(entry.subarray(0, 4)),
            samplesPerChunk: (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(entry.subarray(4, 8)),
            sampleDescriptionIndex: (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(entry.subarray(8, 12))
        };
    });
    var stsz = $2bcab42a90c6ad9b$export$d81d43b46e2012ef(stbl, [
        'stsz'
    ])[0]; // stsz starts with a 4 byte sampleSize which we don't need
    var sampleSizes = $2bcab42a90c6ad9b$var$parseSamples(stsz && stsz.length && stsz.subarray(4) || null);
    var frames = [];
    for(var chunkIndex = 0; chunkIndex < chunkOffsets.length; chunkIndex++){
        var samplesInChunk = void 0;
        for(var i = 0; i < samplesToChunks.length; i++){
            var sampleToChunk = samplesToChunks[i];
            var isThisOne = chunkIndex + 1 >= sampleToChunk.firstChunk && (i + 1 >= samplesToChunks.length || chunkIndex + 1 < samplesToChunks[i + 1].firstChunk);
            if (isThisOne) {
                samplesInChunk = sampleToChunk.samplesPerChunk;
                break;
            }
        }
        var chunkOffset = chunkOffsets[chunkIndex];
        for(var _i = 0; _i < samplesInChunk; _i++){
            var frameEnd = sampleSizes[frames.length]; // if we don't have key samples every frame is a keyframe
            var keyframe = !keySamples.length;
            if (keySamples.length && keySamples.indexOf(frames.length + 1) !== -1) keyframe = true;
            var frame = {
                keyframe: keyframe,
                start: chunkOffset,
                end: chunkOffset + frameEnd
            };
            for(var k = 0; k < timeToSamples.length; k++){
                var _timeToSamples$k = timeToSamples[k], sampleCount = _timeToSamples$k.sampleCount, sampleDelta = _timeToSamples$k.sampleDelta;
                if (frames.length <= sampleCount) {
                    // ms to ns
                    var lastTimestamp = frames.length ? frames[frames.length - 1].timestamp : 0;
                    frame.timestamp = lastTimestamp + sampleDelta / timescale * 1000;
                    frame.duration = sampleDelta;
                    break;
                }
            }
            frames.push(frame);
            chunkOffset += frameEnd;
        }
    }
    return frames;
};
var $2bcab42a90c6ad9b$export$56fdd13a804135bf = function addSampleDescription(track, bytes) {
    var codec = (0, $0cb67f3f52413d92$export$7c746b75f47c9c7d)(bytes.subarray(0, 4));
    if (track.type === 'video') {
        track.info = track.info || {};
        track.info.width = bytes[28] << 8 | bytes[29];
        track.info.height = bytes[30] << 8 | bytes[31];
    } else if (track.type === 'audio') {
        track.info = track.info || {};
        track.info.channels = bytes[20] << 8 | bytes[21];
        track.info.bitDepth = bytes[22] << 8 | bytes[23];
        track.info.sampleRate = bytes[28] << 8 | bytes[29];
    }
    if (codec === 'avc1') {
        var avcC = $2bcab42a90c6ad9b$export$610b5b08fd0ffeb4(bytes, 'avcC'); // AVCDecoderConfigurationRecord
        codec += "." + (0, $83debb266c4a96bb$export$f316fb16efba7de9)(avcC);
        track.info.avcC = avcC; // TODO: do we need to parse all this?
    /* {
      configurationVersion: avcC[0],
      profile: avcC[1],
      profileCompatibility: avcC[2],
      level: avcC[3],
      lengthSizeMinusOne: avcC[4] & 0x3
    };
     let spsNalUnitCount = avcC[5] & 0x1F;
    const spsNalUnits = track.info.avc.spsNalUnits = [];
     // past spsNalUnitCount
    let offset = 6;
     while (spsNalUnitCount--) {
      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
       spsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
       offset += nalLen + 2;
    }
    let ppsNalUnitCount = avcC[offset];
    const ppsNalUnits = track.info.avc.ppsNalUnits = [];
     // past ppsNalUnitCount
    offset += 1;
     while (ppsNalUnitCount--) {
      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
       ppsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
       offset += nalLen + 2;
    }*/ // HEVCDecoderConfigurationRecord
    } else if (codec === 'hvc1' || codec === 'hev1') codec += "." + (0, $83debb266c4a96bb$export$57f4fb41d46b44d9)($2bcab42a90c6ad9b$export$610b5b08fd0ffeb4(bytes, 'hvcC'));
    else if (codec === 'mp4a' || codec === 'mp4v') {
        var esds = $2bcab42a90c6ad9b$export$610b5b08fd0ffeb4(bytes, 'esds');
        var esDescriptor = $2bcab42a90c6ad9b$export$fe4700066a34ac73(esds.subarray(4))[0];
        var decoderConfig = esDescriptor && esDescriptor.descriptors.filter(function(_ref) {
            var tag = _ref.tag;
            return tag === 0x04;
        })[0];
        if (decoderConfig) {
            // most codecs do not have a further '.'
            // such as 0xa5 for ac-3 and 0xa6 for e-ac-3
            codec += '.' + (0, $0cb67f3f52413d92$export$f4915efbb94d4d01)(decoderConfig.oti);
            if (decoderConfig.oti === 0x40) codec += '.' + (decoderConfig.descriptors[0].bytes[0] >> 3).toString();
            else if (decoderConfig.oti === 0x20) codec += '.' + decoderConfig.descriptors[0].bytes[4].toString();
            else if (decoderConfig.oti === 0xdd) codec = 'vorbis';
        } else if (track.type === 'audio') codec += '.40.2';
        else codec += '.20.9';
    } else if (codec === 'av01') // AV1DecoderConfigurationRecord
    codec += "." + (0, $83debb266c4a96bb$export$5ff37217be0e6718)($2bcab42a90c6ad9b$export$610b5b08fd0ffeb4(bytes, 'av1C'));
    else if (codec === 'vp09') {
        // VPCodecConfigurationRecord
        var vpcC = $2bcab42a90c6ad9b$export$610b5b08fd0ffeb4(bytes, 'vpcC'); // https://www.webmproject.org/vp9/mp4/
        var profile = vpcC[0];
        var level = vpcC[1];
        var bitDepth = vpcC[2] >> 4;
        var chromaSubsampling = (vpcC[2] & 0x0F) >> 1;
        var videoFullRangeFlag = (vpcC[2] & 0x0F) >> 3;
        var colourPrimaries = vpcC[3];
        var transferCharacteristics = vpcC[4];
        var matrixCoefficients = vpcC[5];
        codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(profile, 2, '0');
        codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(level, 2, '0');
        codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(bitDepth, 2, '0');
        codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(chromaSubsampling, 2, '0');
        codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(colourPrimaries, 2, '0');
        codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(transferCharacteristics, 2, '0');
        codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(matrixCoefficients, 2, '0');
        codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(videoFullRangeFlag, 2, '0');
    } else if (codec === 'theo') codec = 'theora';
    else if (codec === 'spex') codec = 'speex';
    else if (codec === '.mp3') codec = 'mp4a.40.34';
    else if (codec === 'msVo') codec = 'vorbis';
    else if (codec === 'Opus') {
        codec = 'opus';
        var dOps = $2bcab42a90c6ad9b$export$610b5b08fd0ffeb4(bytes, 'dOps');
        track.info.opus = (0, $f2fca47ed8ab3dd3$export$162487c51ffd8212)(dOps); // TODO: should this go into the webm code??
        // Firefox requires a codecDelay for opus playback
        // see https://bugzilla.mozilla.org/show_bug.cgi?id=1276238
        track.info.codecDelay = 6500000;
    } else codec = codec.toLowerCase();
    /* eslint-enable */ // flac, ac-3, ec-3, opus
    track.codec = codec;
};
var $2bcab42a90c6ad9b$export$b9400b1cdedffc2a = function parseTracks(bytes, frameTable) {
    if (frameTable === void 0) frameTable = true;
    bytes = (0, $0cb67f3f52413d92$export$63c3de442720649)(bytes);
    var traks = $2bcab42a90c6ad9b$export$d81d43b46e2012ef(bytes, [
        'moov',
        'trak'
    ], true);
    var tracks = [];
    traks.forEach(function(trak) {
        var track = {
            bytes: trak
        };
        var mdia = $2bcab42a90c6ad9b$export$d81d43b46e2012ef(trak, [
            'mdia'
        ])[0];
        var hdlr = $2bcab42a90c6ad9b$export$d81d43b46e2012ef(mdia, [
            'hdlr'
        ])[0];
        var trakType = (0, $0cb67f3f52413d92$export$7c746b75f47c9c7d)(hdlr.subarray(8, 12));
        if (trakType === 'soun') track.type = 'audio';
        else if (trakType === 'vide') track.type = 'video';
        else track.type = trakType;
        var tkhd = $2bcab42a90c6ad9b$export$d81d43b46e2012ef(trak, [
            'tkhd'
        ])[0];
        if (tkhd) {
            var view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
            var tkhdVersion = view.getUint8(0);
            track.number = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
        }
        var mdhd = $2bcab42a90c6ad9b$export$d81d43b46e2012ef(mdia, [
            'mdhd'
        ])[0];
        if (mdhd) {
            // mdhd is a FullBox, meaning it will have its own version as the first byte
            var version = mdhd[0];
            var index = version === 0 ? 12 : 20;
            track.timescale = (mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]) >>> 0;
        }
        var stbl = $2bcab42a90c6ad9b$export$d81d43b46e2012ef(mdia, [
            'minf',
            'stbl'
        ])[0];
        var stsd = $2bcab42a90c6ad9b$export$d81d43b46e2012ef(stbl, [
            'stsd'
        ])[0];
        var descriptionCount = (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(stsd.subarray(4, 8));
        var offset = 8; // add codec and codec info
        while(descriptionCount--){
            var len = (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(stsd.subarray(offset, offset + 4));
            var sampleDescriptor = stsd.subarray(offset + 4, offset + 4 + len);
            $2bcab42a90c6ad9b$export$56fdd13a804135bf(track, sampleDescriptor);
            offset += 4 + len;
        }
        if (frameTable) track.frameTable = $2bcab42a90c6ad9b$export$78870b2844ff6386(stbl, track.timescale);
         // codec has no sub parameters
        tracks.push(track);
    });
    return tracks;
};
var $2bcab42a90c6ad9b$export$bd2f7582ee199747 = function parseMediaInfo(bytes) {
    var mvhd = $2bcab42a90c6ad9b$export$d81d43b46e2012ef(bytes, [
        'moov',
        'mvhd'
    ], true)[0];
    if (!mvhd || !mvhd.length) return;
    var info = {}; // ms to ns
    // mvhd v1 has 8 byte duration and other fields too
    if (mvhd[0] === 1) {
        info.timestampScale = (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(mvhd.subarray(20, 24));
        info.duration = (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(mvhd.subarray(24, 32));
    } else {
        info.timestampScale = (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(mvhd.subarray(12, 16));
        info.duration = (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(mvhd.subarray(16, 20));
    }
    info.bytes = mvhd;
    return info;
};




var $fee1188618daff3c$export$3dc3c695a37e4653 = {
    EBML: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x1A,
        0x45,
        0xDF,
        0xA3
    ]),
    DocType: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x42,
        0x82
    ]),
    Segment: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x18,
        0x53,
        0x80,
        0x67
    ]),
    SegmentInfo: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x15,
        0x49,
        0xA9,
        0x66
    ]),
    Tracks: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x16,
        0x54,
        0xAE,
        0x6B
    ]),
    Track: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0xAE
    ]),
    TrackNumber: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0xd7
    ]),
    DefaultDuration: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x23,
        0xe3,
        0x83
    ]),
    TrackEntry: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0xAE
    ]),
    TrackType: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x83
    ]),
    FlagDefault: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x88
    ]),
    CodecID: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x86
    ]),
    CodecPrivate: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x63,
        0xA2
    ]),
    VideoTrack: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0xe0
    ]),
    AudioTrack: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0xe1
    ]),
    // Not used yet, but will be used for live webm/mkv
    // see https://www.matroska.org/technical/basics.html#block-structure
    // see https://www.matroska.org/technical/basics.html#simpleblock-structure
    Cluster: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x1F,
        0x43,
        0xB6,
        0x75
    ]),
    Timestamp: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0xE7
    ]),
    TimestampScale: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x2A,
        0xD7,
        0xB1
    ]),
    BlockGroup: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0xA0
    ]),
    BlockDuration: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x9B
    ]),
    Block: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0xA1
    ]),
    SimpleBlock: (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0xA3
    ])
};
/**
 * This is a simple table to determine the length
 * of things in ebml. The length is one based (starts at 1,
 * rather than zero) and for every zero bit before a one bit
 * we add one to length. We also need this table because in some
 * case we have to xor all the length bits from another value.
 */ var $fee1188618daff3c$var$LENGTH_TABLE = [
    128,
    64,
    32,
    16,
    8,
    4,
    2,
    1
];
var $fee1188618daff3c$var$getLength = function getLength(byte) {
    var len = 1;
    for(var i = 0; i < $fee1188618daff3c$var$LENGTH_TABLE.length; i++){
        if (byte & $fee1188618daff3c$var$LENGTH_TABLE[i]) break;
        len++;
    }
    return len;
}; // length in ebml is stored in the first 4 to 8 bits
// of the first byte. 4 for the id length and 8 for the
// data size length. Length is measured by converting the number to binary
// then 1 + the number of zeros before a 1 is encountered starting
// from the left.
var $fee1188618daff3c$var$getvint = function getvint(bytes, offset, removeLength, signed) {
    if (removeLength === void 0) removeLength = true;
    if (signed === void 0) signed = false;
    var length = $fee1188618daff3c$var$getLength(bytes[offset]);
    var valueBytes = bytes.subarray(offset, offset + length); // NOTE that we do **not** subarray here because we need to copy these bytes
    // as they will be modified below to remove the dataSizeLen bits and we do not
    // want to modify the original data. normally we could just call slice on
    // uint8array but ie 11 does not support that...
    if (removeLength) {
        valueBytes = Array.prototype.slice.call(bytes, offset, offset + length);
        valueBytes[0] ^= $fee1188618daff3c$var$LENGTH_TABLE[length - 1];
    }
    return {
        length: length,
        value: (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(valueBytes, {
            signed: signed
        }),
        bytes: valueBytes
    };
};
var $fee1188618daff3c$var$normalizePath = function normalizePath(path) {
    if (typeof path === 'string') return path.match(/.{1,2}/g).map(function(p) {
        return normalizePath(p);
    });
    if (typeof path === 'number') return (0, $0cb67f3f52413d92$export$49ad9be85c347998)(path);
    return path;
};
var $fee1188618daff3c$var$normalizePaths = function normalizePaths(paths) {
    if (!Array.isArray(paths)) return [
        $fee1188618daff3c$var$normalizePath(paths)
    ];
    return paths.map(function(p) {
        return $fee1188618daff3c$var$normalizePath(p);
    });
};
var $fee1188618daff3c$var$getInfinityDataSize = function getInfinityDataSize(id, bytes, offset) {
    if (offset >= bytes.length) return bytes.length;
    var innerid = $fee1188618daff3c$var$getvint(bytes, offset, false);
    if ((0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(id.bytes, innerid.bytes)) return offset;
    var dataHeader = $fee1188618daff3c$var$getvint(bytes, offset + innerid.length);
    return getInfinityDataSize(id, bytes, offset + dataHeader.length + dataHeader.value + innerid.length);
};
var $fee1188618daff3c$export$826a5b7de63531e6 = function findEbml(bytes, paths) {
    paths = $fee1188618daff3c$var$normalizePaths(paths);
    bytes = (0, $0cb67f3f52413d92$export$63c3de442720649)(bytes);
    var results = [];
    if (!paths.length) return results;
    var i = 0;
    while(i < bytes.length){
        var id = $fee1188618daff3c$var$getvint(bytes, i, false);
        var dataHeader = $fee1188618daff3c$var$getvint(bytes, i + id.length);
        var dataStart = i + id.length + dataHeader.length; // dataSize is unknown or this is a live stream
        if (dataHeader.value === 0x7f) {
            dataHeader.value = $fee1188618daff3c$var$getInfinityDataSize(id, bytes, dataStart);
            if (dataHeader.value !== bytes.length) dataHeader.value -= dataStart;
        }
        var dataEnd = dataStart + dataHeader.value > bytes.length ? bytes.length : dataStart + dataHeader.value;
        var data = bytes.subarray(dataStart, dataEnd);
        if ((0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(paths[0], id.bytes)) {
            if (paths.length === 1) // this is the end of the paths and we've found the tag we were
            // looking for
            results.push(data);
            else // recursively search for the next tag inside of the data
            // of this one
            results = results.concat(findEbml(data, paths.slice(1)));
        }
        var totalLength = id.length + dataHeader.length + data.length; // move past this tag entirely, we are not looking for it
        i += totalLength;
    }
    return results;
}; // see https://www.matroska.org/technical/basics.html#block-structure
var $fee1188618daff3c$export$cd5299e345c81b3 = function decodeBlock(block, type, timestampScale, clusterTimestamp) {
    var duration;
    if (type === 'group') {
        duration = $fee1188618daff3c$export$826a5b7de63531e6(block, [
            $fee1188618daff3c$export$3dc3c695a37e4653.BlockDuration
        ])[0];
        if (duration) {
            duration = (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(duration);
            duration = 1 / timestampScale * duration * timestampScale / 1000;
        }
        block = $fee1188618daff3c$export$826a5b7de63531e6(block, [
            $fee1188618daff3c$export$3dc3c695a37e4653.Block
        ])[0];
        type = 'block'; // treat data as a block after this point
    }
    var dv = new DataView(block.buffer, block.byteOffset, block.byteLength);
    var trackNumber = $fee1188618daff3c$var$getvint(block, 0);
    var timestamp = dv.getInt16(trackNumber.length, false);
    var flags = block[trackNumber.length + 2];
    var data = block.subarray(trackNumber.length + 3); // pts/dts in seconds
    var ptsdts = 1 / timestampScale * (clusterTimestamp + timestamp) * timestampScale / 1000; // return the frame
    var parsed = {
        duration: duration,
        trackNumber: trackNumber.value,
        keyframe: type === 'simple' && flags >> 7 === 1,
        invisible: (flags & 0x08) >> 3 === 1,
        lacing: (flags & 0x06) >> 1,
        discardable: type === 'simple' && (flags & 0x01) === 1,
        frames: [],
        pts: ptsdts,
        dts: ptsdts,
        timestamp: timestamp
    };
    if (!parsed.lacing) {
        parsed.frames.push(data);
        return parsed;
    }
    var numberOfFrames = data[0] + 1;
    var frameSizes = [];
    var offset = 1; // Fixed
    if (parsed.lacing === 2) {
        var sizeOfFrame = (data.length - offset) / numberOfFrames;
        for(var i = 0; i < numberOfFrames; i++)frameSizes.push(sizeOfFrame);
    } // xiph
    if (parsed.lacing === 1) for(var _i = 0; _i < numberOfFrames - 1; _i++){
        var size = 0;
        do {
            size += data[offset];
            offset++;
        }while (data[offset - 1] === 0xFF);
        frameSizes.push(size);
    }
     // ebml
    if (parsed.lacing === 3) {
        // first vint is unsinged
        // after that vints are singed and
        // based on a compounding size
        var _size = 0;
        for(var _i2 = 0; _i2 < numberOfFrames - 1; _i2++){
            var vint = _i2 === 0 ? $fee1188618daff3c$var$getvint(data, offset) : $fee1188618daff3c$var$getvint(data, offset, true, true);
            _size += vint.value;
            frameSizes.push(_size);
            offset += vint.length;
        }
    }
    frameSizes.forEach(function(size) {
        parsed.frames.push(data.subarray(offset, offset + size));
        offset += size;
    });
    return parsed;
}; // VP9 Codec Feature Metadata (CodecPrivate)
// https://www.webmproject.org/docs/container/
var $fee1188618daff3c$var$parseVp9Private = function parseVp9Private(bytes) {
    var i = 0;
    var params = {};
    while(i < bytes.length){
        var id = bytes[i] & 0x7f;
        var len = bytes[i + 1];
        var val = void 0;
        if (len === 1) val = bytes[i + 2];
        else val = bytes.subarray(i + 2, i + 2 + len);
        if (id === 1) params.profile = val;
        else if (id === 2) params.level = val;
        else if (id === 3) params.bitDepth = val;
        else if (id === 4) params.chromaSubsampling = val;
        else params[id] = val;
        i += 2 + len;
    }
    return params;
};
var $fee1188618daff3c$export$b9400b1cdedffc2a = function parseTracks(bytes) {
    bytes = (0, $0cb67f3f52413d92$export$63c3de442720649)(bytes);
    var decodedTracks = [];
    var tracks = $fee1188618daff3c$export$826a5b7de63531e6(bytes, [
        $fee1188618daff3c$export$3dc3c695a37e4653.Segment,
        $fee1188618daff3c$export$3dc3c695a37e4653.Tracks,
        $fee1188618daff3c$export$3dc3c695a37e4653.Track
    ]);
    if (!tracks.length) tracks = $fee1188618daff3c$export$826a5b7de63531e6(bytes, [
        $fee1188618daff3c$export$3dc3c695a37e4653.Tracks,
        $fee1188618daff3c$export$3dc3c695a37e4653.Track
    ]);
    if (!tracks.length) tracks = $fee1188618daff3c$export$826a5b7de63531e6(bytes, [
        $fee1188618daff3c$export$3dc3c695a37e4653.Track
    ]);
    if (!tracks.length) return decodedTracks;
    tracks.forEach(function(track) {
        var trackType = $fee1188618daff3c$export$826a5b7de63531e6(track, $fee1188618daff3c$export$3dc3c695a37e4653.TrackType)[0];
        if (!trackType || !trackType.length) return;
         // 1 is video, 2 is audio, 17 is subtitle
        // other values are unimportant in this context
        if (trackType[0] === 1) trackType = 'video';
        else if (trackType[0] === 2) trackType = 'audio';
        else if (trackType[0] === 17) trackType = 'subtitle';
        else return;
         // todo parse language
        var decodedTrack = {
            rawCodec: (0, $0cb67f3f52413d92$export$7c746b75f47c9c7d)($fee1188618daff3c$export$826a5b7de63531e6(track, [
                $fee1188618daff3c$export$3dc3c695a37e4653.CodecID
            ])[0]),
            type: trackType,
            codecPrivate: $fee1188618daff3c$export$826a5b7de63531e6(track, [
                $fee1188618daff3c$export$3dc3c695a37e4653.CodecPrivate
            ])[0],
            number: (0, $0cb67f3f52413d92$export$c0cca17bcf674749)($fee1188618daff3c$export$826a5b7de63531e6(track, [
                $fee1188618daff3c$export$3dc3c695a37e4653.TrackNumber
            ])[0]),
            defaultDuration: (0, $0cb67f3f52413d92$export$c0cca17bcf674749)($fee1188618daff3c$export$826a5b7de63531e6(track, [
                $fee1188618daff3c$export$3dc3c695a37e4653.DefaultDuration
            ])[0]),
            default: $fee1188618daff3c$export$826a5b7de63531e6(track, [
                $fee1188618daff3c$export$3dc3c695a37e4653.FlagDefault
            ])[0],
            rawData: track
        };
        var codec = '';
        if (/V_MPEG4\/ISO\/AVC/.test(decodedTrack.rawCodec)) codec = "avc1." + (0, $83debb266c4a96bb$export$f316fb16efba7de9)(decodedTrack.codecPrivate);
        else if (/V_MPEGH\/ISO\/HEVC/.test(decodedTrack.rawCodec)) codec = "hev1." + (0, $83debb266c4a96bb$export$57f4fb41d46b44d9)(decodedTrack.codecPrivate);
        else if (/V_MPEG4\/ISO\/ASP/.test(decodedTrack.rawCodec)) {
            if (decodedTrack.codecPrivate) codec = 'mp4v.20.' + decodedTrack.codecPrivate[4].toString();
            else codec = 'mp4v.20.9';
        } else if (/^V_THEORA/.test(decodedTrack.rawCodec)) codec = 'theora';
        else if (/^V_VP8/.test(decodedTrack.rawCodec)) codec = 'vp8';
        else if (/^V_VP9/.test(decodedTrack.rawCodec)) {
            if (decodedTrack.codecPrivate) {
                var _parseVp9Private = $fee1188618daff3c$var$parseVp9Private(decodedTrack.codecPrivate), profile = _parseVp9Private.profile, level = _parseVp9Private.level, bitDepth = _parseVp9Private.bitDepth, chromaSubsampling = _parseVp9Private.chromaSubsampling;
                codec = 'vp09.';
                codec += (0, $0cb67f3f52413d92$export$36cf564d487b5178)(profile, 2, '0') + ".";
                codec += (0, $0cb67f3f52413d92$export$36cf564d487b5178)(level, 2, '0') + ".";
                codec += (0, $0cb67f3f52413d92$export$36cf564d487b5178)(bitDepth, 2, '0') + ".";
                codec += "" + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(chromaSubsampling, 2, '0'); // Video -> Colour -> Ebml name
                var matrixCoefficients = $fee1188618daff3c$export$826a5b7de63531e6(track, [
                    0xE0,
                    [
                        0x55,
                        0xB0
                    ],
                    [
                        0x55,
                        0xB1
                    ]
                ])[0] || [];
                var videoFullRangeFlag = $fee1188618daff3c$export$826a5b7de63531e6(track, [
                    0xE0,
                    [
                        0x55,
                        0xB0
                    ],
                    [
                        0x55,
                        0xB9
                    ]
                ])[0] || [];
                var transferCharacteristics = $fee1188618daff3c$export$826a5b7de63531e6(track, [
                    0xE0,
                    [
                        0x55,
                        0xB0
                    ],
                    [
                        0x55,
                        0xBA
                    ]
                ])[0] || [];
                var colourPrimaries = $fee1188618daff3c$export$826a5b7de63531e6(track, [
                    0xE0,
                    [
                        0x55,
                        0xB0
                    ],
                    [
                        0x55,
                        0xBB
                    ]
                ])[0] || []; // if we find any optional codec parameter specify them all.
                if (matrixCoefficients.length || videoFullRangeFlag.length || transferCharacteristics.length || colourPrimaries.length) {
                    codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(colourPrimaries[0], 2, '0');
                    codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(transferCharacteristics[0], 2, '0');
                    codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(matrixCoefficients[0], 2, '0');
                    codec += "." + (0, $0cb67f3f52413d92$export$36cf564d487b5178)(videoFullRangeFlag[0], 2, '0');
                }
            } else codec = 'vp9';
        } else if (/^V_AV1/.test(decodedTrack.rawCodec)) codec = "av01." + (0, $83debb266c4a96bb$export$5ff37217be0e6718)(decodedTrack.codecPrivate);
        else if (/A_ALAC/.test(decodedTrack.rawCodec)) codec = 'alac';
        else if (/A_MPEG\/L2/.test(decodedTrack.rawCodec)) codec = 'mp2';
        else if (/A_MPEG\/L3/.test(decodedTrack.rawCodec)) codec = 'mp3';
        else if (/^A_AAC/.test(decodedTrack.rawCodec)) {
            if (decodedTrack.codecPrivate) codec = 'mp4a.40.' + (decodedTrack.codecPrivate[0] >>> 3).toString();
            else codec = 'mp4a.40.2';
        } else if (/^A_AC3/.test(decodedTrack.rawCodec)) codec = 'ac-3';
        else if (/^A_PCM/.test(decodedTrack.rawCodec)) codec = 'pcm';
        else if (/^A_MS\/ACM/.test(decodedTrack.rawCodec)) codec = 'speex';
        else if (/^A_EAC3/.test(decodedTrack.rawCodec)) codec = 'ec-3';
        else if (/^A_VORBIS/.test(decodedTrack.rawCodec)) codec = 'vorbis';
        else if (/^A_FLAC/.test(decodedTrack.rawCodec)) codec = 'flac';
        else if (/^A_OPUS/.test(decodedTrack.rawCodec)) codec = 'opus';
        decodedTrack.codec = codec;
        decodedTracks.push(decodedTrack);
    });
    return decodedTracks.sort(function(a, b) {
        return a.number - b.number;
    });
};
var $fee1188618daff3c$export$4c0e6fff2d4abe18 = function parseData(data, tracks) {
    var allBlocks = [];
    var segment = $fee1188618daff3c$export$826a5b7de63531e6(data, [
        $fee1188618daff3c$export$3dc3c695a37e4653.Segment
    ])[0];
    var timestampScale = $fee1188618daff3c$export$826a5b7de63531e6(segment, [
        $fee1188618daff3c$export$3dc3c695a37e4653.SegmentInfo,
        $fee1188618daff3c$export$3dc3c695a37e4653.TimestampScale
    ])[0]; // in nanoseconds, defaults to 1ms
    if (timestampScale && timestampScale.length) timestampScale = (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(timestampScale);
    else timestampScale = 1000000;
    var clusters = $fee1188618daff3c$export$826a5b7de63531e6(segment, [
        $fee1188618daff3c$export$3dc3c695a37e4653.Cluster
    ]);
    if (!tracks) tracks = $fee1188618daff3c$export$b9400b1cdedffc2a(segment);
    clusters.forEach(function(cluster, ci) {
        var simpleBlocks = $fee1188618daff3c$export$826a5b7de63531e6(cluster, [
            $fee1188618daff3c$export$3dc3c695a37e4653.SimpleBlock
        ]).map(function(b) {
            return {
                type: 'simple',
                data: b
            };
        });
        var blockGroups = $fee1188618daff3c$export$826a5b7de63531e6(cluster, [
            $fee1188618daff3c$export$3dc3c695a37e4653.BlockGroup
        ]).map(function(b) {
            return {
                type: 'group',
                data: b
            };
        });
        var timestamp = $fee1188618daff3c$export$826a5b7de63531e6(cluster, [
            $fee1188618daff3c$export$3dc3c695a37e4653.Timestamp
        ])[0] || 0;
        if (timestamp && timestamp.length) timestamp = (0, $0cb67f3f52413d92$export$c0cca17bcf674749)(timestamp);
         // get all blocks then sort them into the correct order
        var blocks = simpleBlocks.concat(blockGroups).sort(function(a, b) {
            return a.data.byteOffset - b.data.byteOffset;
        });
        blocks.forEach(function(block, bi) {
            var decoded = $fee1188618daff3c$export$cd5299e345c81b3(block.data, block.type, timestampScale, timestamp);
            allBlocks.push(decoded);
        });
    });
    return {
        tracks: tracks,
        blocks: allBlocks
    };
};




var $b80b81381ca99af3$export$c685721194c7e8f3 = (0, $0cb67f3f52413d92$export$63c3de442720649)([
    0x00,
    0x00,
    0x00,
    0x01
]);
var $b80b81381ca99af3$export$5e56cd062936486 = (0, $0cb67f3f52413d92$export$63c3de442720649)([
    0x00,
    0x00,
    0x01
]);
var $b80b81381ca99af3$export$c6449e11a0e55652 = (0, $0cb67f3f52413d92$export$63c3de442720649)([
    0x00,
    0x00,
    0x03
]);
var $b80b81381ca99af3$export$1a44f7c1c8cc8def = function discardEmulationPreventionBytes(bytes) {
    var positions = [];
    var i = 1; // Find all `Emulation Prevention Bytes`
    while(i < bytes.length - 2){
        if ((0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes.subarray(i, i + 3), $b80b81381ca99af3$export$c6449e11a0e55652)) {
            positions.push(i + 2);
            i++;
        }
        i++;
    } // If no Emulation Prevention Bytes were found just return the original
    // array
    if (positions.length === 0) return bytes;
     // Create a new array to hold the NAL unit data
    var newLength = bytes.length - positions.length;
    var newData = new Uint8Array(newLength);
    var sourceIndex = 0;
    for(i = 0; i < newLength; sourceIndex++, i++){
        if (sourceIndex === positions[0]) {
            // Skip this byte
            sourceIndex++; // Remove this position index
            positions.shift();
        }
        newData[i] = bytes[sourceIndex];
    }
    return newData;
};
var $b80b81381ca99af3$export$17fd5d00213a3829 = function findNal(bytes, dataType, types, nalLimit) {
    if (nalLimit === void 0) nalLimit = Infinity;
    bytes = (0, $0cb67f3f52413d92$export$63c3de442720649)(bytes);
    types = [].concat(types);
    var i = 0;
    var nalStart;
    var nalsFound = 0; // keep searching until:
    // we reach the end of bytes
    // we reach the maximum number of nals they want to seach
    // NOTE: that we disregard nalLimit when we have found the start
    // of the nal we want so that we can find the end of the nal we want.
    while(i < bytes.length && (nalsFound < nalLimit || nalStart)){
        var nalOffset = void 0;
        if ((0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes.subarray(i), $b80b81381ca99af3$export$c685721194c7e8f3)) nalOffset = 4;
        else if ((0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes.subarray(i), $b80b81381ca99af3$export$5e56cd062936486)) nalOffset = 3;
         // we are unsynced,
        // find the next nal unit
        if (!nalOffset) {
            i++;
            continue;
        }
        nalsFound++;
        if (nalStart) return $b80b81381ca99af3$export$1a44f7c1c8cc8def(bytes.subarray(nalStart, i));
        var nalType = void 0;
        if (dataType === 'h264') nalType = bytes[i + nalOffset] & 0x1f;
        else if (dataType === 'h265') nalType = bytes[i + nalOffset] >> 1 & 0x3f;
        if (types.indexOf(nalType) !== -1) nalStart = i + nalOffset;
         // nal header is 1 length for h264, and 2 for h265
        i += nalOffset + (dataType === 'h264' ? 1 : 2);
    }
    return bytes.subarray(0, 0);
};
var $b80b81381ca99af3$export$d9a366c79c59ccda = function findH264Nal(bytes, type, nalLimit) {
    return $b80b81381ca99af3$export$17fd5d00213a3829(bytes, 'h264', type, nalLimit);
};
var $b80b81381ca99af3$export$4b55988b6a40a3f0 = function findH265Nal(bytes, type, nalLimit) {
    return $b80b81381ca99af3$export$17fd5d00213a3829(bytes, 'h265', type, nalLimit);
};


var $7483119daf318a41$var$CONSTANTS = {
    // "webm" string literal in hex
    'webm': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x77,
        0x65,
        0x62,
        0x6d
    ]),
    // "matroska" string literal in hex
    'matroska': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x6d,
        0x61,
        0x74,
        0x72,
        0x6f,
        0x73,
        0x6b,
        0x61
    ]),
    // "fLaC" string literal in hex
    'flac': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x66,
        0x4c,
        0x61,
        0x43
    ]),
    // "OggS" string literal in hex
    'ogg': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x4f,
        0x67,
        0x67,
        0x53
    ]),
    // ac-3 sync byte, also works for ec-3 as that is simply a codec
    // of ac-3
    'ac3': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x0b,
        0x77
    ]),
    // "RIFF" string literal in hex used for wav and avi
    'riff': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x52,
        0x49,
        0x46,
        0x46
    ]),
    // "AVI" string literal in hex
    'avi': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x41,
        0x56,
        0x49
    ]),
    // "WAVE" string literal in hex
    'wav': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x57,
        0x41,
        0x56,
        0x45
    ]),
    // "ftyp3g" string literal in hex
    '3gp': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x66,
        0x74,
        0x79,
        0x70,
        0x33,
        0x67
    ]),
    // "ftyp" string literal in hex
    'mp4': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x66,
        0x74,
        0x79,
        0x70
    ]),
    // "styp" string literal in hex
    'fmp4': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x73,
        0x74,
        0x79,
        0x70
    ]),
    // "ftypqt" string literal in hex
    'mov': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x66,
        0x74,
        0x79,
        0x70,
        0x71,
        0x74
    ]),
    // moov string literal in hex
    'moov': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x6D,
        0x6F,
        0x6F,
        0x76
    ]),
    // moof string literal in hex
    'moof': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x6D,
        0x6F,
        0x6F,
        0x66
    ]),
    // "WEBVTT" string literal in hex
    'vtt': (0, $0cb67f3f52413d92$export$63c3de442720649)([
        0x57,
        0x45,
        0x42,
        0x56,
        0x54,
        0x54
    ])
};
var $7483119daf318a41$var$_isLikely = {
    aac: function aac(bytes) {
        var offset = (0, $beb668c0ff46ee9c$export$56b6cacf09ec1126)(bytes);
        return (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, [
            0xFF,
            0x10
        ], {
            offset: offset,
            mask: [
                0xFF,
                0x16
            ]
        });
    },
    mp3: function mp3(bytes) {
        var offset = (0, $beb668c0ff46ee9c$export$56b6cacf09ec1126)(bytes);
        return (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, [
            0xFF,
            0x02
        ], {
            offset: offset,
            mask: [
                0xFF,
                0x06
            ]
        });
    },
    webm: function webm(bytes) {
        var docType = (0, $fee1188618daff3c$export$826a5b7de63531e6)(bytes, [
            (0, $fee1188618daff3c$export$3dc3c695a37e4653).EBML,
            (0, $fee1188618daff3c$export$3dc3c695a37e4653).DocType
        ])[0]; // check if DocType EBML tag is webm
        return (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(docType, $7483119daf318a41$var$CONSTANTS.webm);
    },
    mkv: function mkv(bytes) {
        var docType = (0, $fee1188618daff3c$export$826a5b7de63531e6)(bytes, [
            (0, $fee1188618daff3c$export$3dc3c695a37e4653).EBML,
            (0, $fee1188618daff3c$export$3dc3c695a37e4653).DocType
        ])[0]; // check if DocType EBML tag is matroska
        return (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(docType, $7483119daf318a41$var$CONSTANTS.matroska);
    },
    mp4: function mp4(bytes) {
        // if this file is another base media file format, it is not mp4
        if ($7483119daf318a41$var$_isLikely['3gp'](bytes) || $7483119daf318a41$var$_isLikely.mov(bytes)) return false;
         // if this file starts with a ftyp or styp box its mp4
        if ((0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.mp4, {
            offset: 4
        }) || (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.fmp4, {
            offset: 4
        })) return true;
         // if this file starts with a moof/moov box its mp4
        if ((0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.moof, {
            offset: 4
        }) || (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.moov, {
            offset: 4
        })) return true;
    },
    mov: function mov(bytes) {
        return (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.mov, {
            offset: 4
        });
    },
    '3gp': function gp(bytes) {
        return (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS['3gp'], {
            offset: 4
        });
    },
    ac3: function ac3(bytes) {
        var offset = (0, $beb668c0ff46ee9c$export$56b6cacf09ec1126)(bytes);
        return (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.ac3, {
            offset: offset
        });
    },
    // Must be checked before ts. The sorting of isLikelyTypes ensures this.
    vtt: function vtt(bytes) {
        return (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.vtt);
    },
    ts: function ts(bytes) {
        if (bytes.length < 189 && bytes.length >= 1) return bytes[0] === 0x47;
        var i = 0; // check the first 376 bytes for two matching sync bytes
        while(i + 188 < bytes.length && i < 188){
            if (bytes[i] === 0x47 && bytes[i + 188] === 0x47) return true;
            i += 1;
        }
        return false;
    },
    flac: function flac(bytes) {
        var offset = (0, $beb668c0ff46ee9c$export$56b6cacf09ec1126)(bytes);
        return (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.flac, {
            offset: offset
        });
    },
    ogg: function ogg(bytes) {
        return (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.ogg);
    },
    avi: function avi(bytes) {
        return (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.riff) && (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.avi, {
            offset: 8
        });
    },
    wav: function wav(bytes) {
        return (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.riff) && (0, $0cb67f3f52413d92$export$a20f7b76e5cfd223)(bytes, $7483119daf318a41$var$CONSTANTS.wav, {
            offset: 8
        });
    },
    'h264': function h264(bytes) {
        // find seq_parameter_set_rbsp
        return (0, $b80b81381ca99af3$export$d9a366c79c59ccda)(bytes, 7, 3).length;
    },
    'h265': function h265(bytes) {
        // find video_parameter_set_rbsp or seq_parameter_set_rbsp
        return (0, $b80b81381ca99af3$export$4b55988b6a40a3f0)(bytes, [
            32,
            33
        ], 3).length;
    }
}; // get all the isLikely functions
// but make sure 'ts' is above h264 and h265
// but below everything else as it is the least specific
var $7483119daf318a41$var$isLikelyTypes = Object.keys($7483119daf318a41$var$_isLikely) // remove ts, h264, h265
.filter(function(t) {
    return t !== 'ts' && t !== 'h264' && t !== 'h265';
}) // add it back to the bottom
.concat([
    'ts',
    'h264',
    'h265'
]); // make sure we are dealing with uint8 data.
$7483119daf318a41$var$isLikelyTypes.forEach(function(type) {
    var isLikelyFn = $7483119daf318a41$var$_isLikely[type];
    $7483119daf318a41$var$_isLikely[type] = function(bytes) {
        return isLikelyFn((0, $0cb67f3f52413d92$export$63c3de442720649)(bytes));
    };
}); // export after wrapping
var $7483119daf318a41$export$4d8d080fd201ee1b = $7483119daf318a41$var$_isLikely; // A useful list of file signatures can be found here
var $7483119daf318a41$export$894319e75ed840c3 = function detectContainerForBytes(bytes) {
    bytes = (0, $0cb67f3f52413d92$export$63c3de442720649)(bytes);
    for(var i = 0; i < $7483119daf318a41$var$isLikelyTypes.length; i++){
        var type = $7483119daf318a41$var$isLikelyTypes[i];
        if ($7483119daf318a41$export$4d8d080fd201ee1b[type](bytes)) return type;
    }
    return '';
}; // fmp4 is not a container
var $7483119daf318a41$export$7d0b693bd7ec7827 = function isLikelyFmp4MediaSegment(bytes) {
    return (0, $2bcab42a90c6ad9b$export$d81d43b46e2012ef)(bytes, [
        'moof'
    ]).length > 0;
};


var $22231c6dfc449553$exports = {};
/**
 * mux.js
 *
 * Copyright (c) Brightcove
 * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
 */ var $22231c6dfc449553$var$ONE_SECOND_IN_TS = 90000, $22231c6dfc449553$var$secondsToVideoTs, $22231c6dfc449553$var$secondsToAudioTs, $22231c6dfc449553$var$videoTsToSeconds, $22231c6dfc449553$var$audioTsToSeconds, $22231c6dfc449553$var$audioTsToVideoTs, $22231c6dfc449553$var$videoTsToAudioTs, $22231c6dfc449553$var$metadataTsToSeconds;
$22231c6dfc449553$var$secondsToVideoTs = function(seconds) {
    return seconds * $22231c6dfc449553$var$ONE_SECOND_IN_TS;
};
$22231c6dfc449553$var$secondsToAudioTs = function(seconds, sampleRate) {
    return seconds * sampleRate;
};
$22231c6dfc449553$var$videoTsToSeconds = function(timestamp) {
    return timestamp / $22231c6dfc449553$var$ONE_SECOND_IN_TS;
};
$22231c6dfc449553$var$audioTsToSeconds = function(timestamp, sampleRate) {
    return timestamp / sampleRate;
};
$22231c6dfc449553$var$audioTsToVideoTs = function(timestamp, sampleRate) {
    return $22231c6dfc449553$var$secondsToVideoTs($22231c6dfc449553$var$audioTsToSeconds(timestamp, sampleRate));
};
$22231c6dfc449553$var$videoTsToAudioTs = function(timestamp, sampleRate) {
    return $22231c6dfc449553$var$secondsToAudioTs($22231c6dfc449553$var$videoTsToSeconds(timestamp), sampleRate);
};
/**
 * Adjust ID3 tag or caption timing information by the timeline pts values
 * (if keepOriginalTimestamps is false) and convert to seconds
 */ $22231c6dfc449553$var$metadataTsToSeconds = function(timestamp, timelineStartPts, keepOriginalTimestamps) {
    return $22231c6dfc449553$var$videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
};
$22231c6dfc449553$exports = {
    ONE_SECOND_IN_TS: $22231c6dfc449553$var$ONE_SECOND_IN_TS,
    secondsToVideoTs: $22231c6dfc449553$var$secondsToVideoTs,
    secondsToAudioTs: $22231c6dfc449553$var$secondsToAudioTs,
    videoTsToSeconds: $22231c6dfc449553$var$videoTsToSeconds,
    audioTsToSeconds: $22231c6dfc449553$var$audioTsToSeconds,
    audioTsToVideoTs: $22231c6dfc449553$var$audioTsToVideoTs,
    videoTsToAudioTs: $22231c6dfc449553$var$videoTsToAudioTs,
    metadataTsToSeconds: $22231c6dfc449553$var$metadataTsToSeconds
};


var $86defbb4e95ebb07$var$version$6 = "8.23.9";
/**
 * An Object that contains lifecycle hooks as keys which point to an array
 * of functions that are run when a lifecycle is triggered
 *
 * @private
 */ const $86defbb4e95ebb07$var$hooks_ = {};
/**
 * Get a list of hooks for a specific lifecycle
 *
 * @param  {string} type
 *         the lifecycle to get hooks from
 *
 * @param  {Function|Function[]} [fn]
 *         Optionally add a hook (or hooks) to the lifecycle that your are getting.
 *
 * @return {Array}
 *         an array of hooks, or an empty array if there are none.
 */ const $86defbb4e95ebb07$var$hooks = function(type, fn) {
    $86defbb4e95ebb07$var$hooks_[type] = $86defbb4e95ebb07$var$hooks_[type] || [];
    if (fn) $86defbb4e95ebb07$var$hooks_[type] = $86defbb4e95ebb07$var$hooks_[type].concat(fn);
    return $86defbb4e95ebb07$var$hooks_[type];
};
/**
 * Add a function hook to a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle to hook the function to.
 *
 * @param {Function|Function[]}
 *        The function or array of functions to attach.
 */ const $86defbb4e95ebb07$var$hook = function(type, fn) {
    $86defbb4e95ebb07$var$hooks(type, fn);
};
/**
 * Remove a hook from a specific videojs lifecycle.
 *
 * @param  {string} type
 *         the lifecycle that the function hooked to
 *
 * @param  {Function} fn
 *         The hooked function to remove
 *
 * @return {boolean}
 *         The function that was removed or undef
 */ const $86defbb4e95ebb07$var$removeHook = function(type, fn) {
    const index = $86defbb4e95ebb07$var$hooks(type).indexOf(fn);
    if (index <= -1) return false;
    $86defbb4e95ebb07$var$hooks_[type] = $86defbb4e95ebb07$var$hooks_[type].slice();
    $86defbb4e95ebb07$var$hooks_[type].splice(index, 1);
    return true;
};
/**
 * Add a function hook that will only run once to a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle to hook the function to.
 *
 * @param {Function|Function[]}
 *        The function or array of functions to attach.
 */ const $86defbb4e95ebb07$var$hookOnce = function(type, fn) {
    $86defbb4e95ebb07$var$hooks(type, [].concat(fn).map((original)=>{
        const wrapper = (...args)=>{
            $86defbb4e95ebb07$var$removeHook(type, wrapper);
            return original(...args);
        };
        return wrapper;
    }));
};
/**
 * @file fullscreen-api.js
 * @module fullscreen-api
 */ /**
 * Store the browser-specific methods for the fullscreen API.
 *
 * @type {Object}
 * @see [Specification]{@link https://fullscreen.spec.whatwg.org}
 * @see [Map Approach From Screenfull.js]{@link https://github.com/sindresorhus/screenfull.js}
 */ const $86defbb4e95ebb07$var$FullscreenApi = {
    prefixed: true
};
// browser API methods
const $86defbb4e95ebb07$var$apiMap = [
    [
        'requestFullscreen',
        'exitFullscreen',
        'fullscreenElement',
        'fullscreenEnabled',
        'fullscreenchange',
        'fullscreenerror',
        'fullscreen'
    ],
    // WebKit
    [
        'webkitRequestFullscreen',
        'webkitExitFullscreen',
        'webkitFullscreenElement',
        'webkitFullscreenEnabled',
        'webkitfullscreenchange',
        'webkitfullscreenerror',
        '-webkit-full-screen'
    ]
];
const $86defbb4e95ebb07$var$specApi = $86defbb4e95ebb07$var$apiMap[0];
let $86defbb4e95ebb07$var$browserApi;
// determine the supported set of functions
for(let i = 0; i < $86defbb4e95ebb07$var$apiMap.length; i++)// check for exitFullscreen function
if ($86defbb4e95ebb07$var$apiMap[i][1] in (0, (/*@__PURE__*/$parcel$interopDefault($01r8O)))) {
    $86defbb4e95ebb07$var$browserApi = $86defbb4e95ebb07$var$apiMap[i];
    break;
}
// map the browser API names to the spec API names
if ($86defbb4e95ebb07$var$browserApi) {
    for(let i = 0; i < $86defbb4e95ebb07$var$browserApi.length; i++)$86defbb4e95ebb07$var$FullscreenApi[$86defbb4e95ebb07$var$specApi[i]] = $86defbb4e95ebb07$var$browserApi[i];
    $86defbb4e95ebb07$var$FullscreenApi.prefixed = $86defbb4e95ebb07$var$browserApi[0] !== $86defbb4e95ebb07$var$specApi[0];
}
/**
 * @file create-logger.js
 * @module create-logger
 */ // This is the private tracking variable for the logging history.
let $86defbb4e95ebb07$var$history = [];
/**
 * Log messages to the console and history based on the type of message
 *
 * @private
 * @param  {string} name
 *         The name of the console method to use.
 *
 * @param  {Object} log
 *         The arguments to be passed to the matching console method.
 *
 * @param {string} [styles]
 *        styles for name
 */ const $86defbb4e95ebb07$var$LogByTypeFactory = (name, log, styles)=>(type, level, args)=>{
        const lvl = log.levels[level];
        const lvlRegExp = new RegExp(`^(${lvl})$`);
        let resultName = name;
        if (type !== 'log') // Add the type to the front of the message when it's not "log".
        args.unshift(type.toUpperCase() + ':');
        if (styles) {
            resultName = `%c${name}`;
            args.unshift(styles);
        }
        // Add console prefix after adding to history.
        args.unshift(resultName + ':');
        // Add a clone of the args at this point to history.
        if ($86defbb4e95ebb07$var$history) {
            $86defbb4e95ebb07$var$history.push([].concat(args));
            // only store 1000 history entries
            const splice = $86defbb4e95ebb07$var$history.length - 1000;
            $86defbb4e95ebb07$var$history.splice(0, splice > 0 ? splice : 0);
        }
        // If there's no console then don't try to output messages, but they will
        // still be stored in history.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).console) return;
        // Was setting these once outside of this function, but containing them
        // in the function makes it easier to test cases where console doesn't exist
        // when the module is executed.
        let fn = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).console[type];
        if (!fn && type === 'debug') // Certain browsers don't have support for console.debug. For those, we
        // should default to the closest comparable log.
        fn = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).console.info || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).console.log;
        // Bail out if there's no console or if this type is not allowed by the
        // current logging level.
        if (!fn || !lvl || !lvlRegExp.test(type)) return;
        fn[Array.isArray(args) ? 'apply' : 'call']((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).console, args);
    };
function $86defbb4e95ebb07$var$createLogger$1(name, delimiter = ':', styles = '') {
    // This is the private tracking variable for logging level.
    let level = 'info';
    // the curried logByType bound to the specific log and history
    let logByType;
    /**
   * Logs plain debug messages. Similar to `console.log`.
   *
   * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
   * of our JSDoc template, we cannot properly document this as both a function
   * and a namespace, so its function signature is documented here.
   *
   * #### Arguments
   * ##### *args
   * *[]
   *
   * Any combination of values that could be passed to `console.log()`.
   *
   * #### Return Value
   *
   * `undefined`
   *
   * @namespace
   * @param    {...*} args
   *           One or more messages or objects that should be logged.
   */ function log(...args) {
        logByType('log', level, args);
    }
    // This is the logByType helper that the logging methods below use
    logByType = $86defbb4e95ebb07$var$LogByTypeFactory(name, log, styles);
    /**
   * Create a new subLogger which chains the old name to the new name.
   *
   * For example, doing `mylogger = videojs.log.createLogger('player')` and then using that logger will log the following:
   * ```js
   *  mylogger('foo');
   *  // > VIDEOJS: player: foo
   * ```
   *
   * @param {string} subName
   *        The name to add call the new logger
   * @param {string} [subDelimiter]
   *        Optional delimiter
   * @param {string} [subStyles]
   *        Optional styles
   * @return {Object}
   */ log.createLogger = (subName, subDelimiter, subStyles)=>{
        const resultDelimiter = subDelimiter !== undefined ? subDelimiter : delimiter;
        const resultStyles = subStyles !== undefined ? subStyles : styles;
        const resultName = `${name} ${resultDelimiter} ${subName}`;
        return $86defbb4e95ebb07$var$createLogger$1(resultName, resultDelimiter, resultStyles);
    };
    /**
   * Create a new logger.
   *
   * @param {string} newName
   *        The name for the new logger
   * @param {string} [newDelimiter]
   *        Optional delimiter
   * @param {string} [newStyles]
   *        Optional styles
   * @return {Object}
   */ log.createNewLogger = (newName, newDelimiter, newStyles)=>{
        return $86defbb4e95ebb07$var$createLogger$1(newName, newDelimiter, newStyles);
    };
    /**
   * Enumeration of available logging levels, where the keys are the level names
   * and the values are `|`-separated strings containing logging methods allowed
   * in that logging level. These strings are used to create a regular expression
   * matching the function name being called.
   *
   * Levels provided by Video.js are:
   *
   * - `off`: Matches no calls. Any value that can be cast to `false` will have
   *   this effect. The most restrictive.
   * - `all`: Matches only Video.js-provided functions (`debug`, `log`,
   *   `log.warn`, and `log.error`).
   * - `debug`: Matches `log.debug`, `log`, `log.warn`, and `log.error` calls.
   * - `info` (default): Matches `log`, `log.warn`, and `log.error` calls.
   * - `warn`: Matches `log.warn` and `log.error` calls.
   * - `error`: Matches only `log.error` calls.
   *
   * @type {Object}
   */ log.levels = {
        all: 'debug|log|warn|error',
        off: '',
        debug: 'debug|log|warn|error',
        info: 'log|warn|error',
        warn: 'warn|error',
        error: 'error',
        DEFAULT: level
    };
    /**
   * Get or set the current logging level.
   *
   * If a string matching a key from {@link module:log.levels} is provided, acts
   * as a setter.
   *
   * @param  {'all'|'debug'|'info'|'warn'|'error'|'off'} [lvl]
   *         Pass a valid level to set a new logging level.
   *
   * @return {string}
   *         The current logging level.
   */ log.level = (lvl)=>{
        if (typeof lvl === 'string') {
            if (!log.levels.hasOwnProperty(lvl)) throw new Error(`"${lvl}" in not a valid log level`);
            level = lvl;
        }
        return level;
    };
    /**
   * Returns an array containing everything that has been logged to the history.
   *
   * This array is a shallow clone of the internal history record. However, its
   * contents are _not_ cloned; so, mutating objects inside this array will
   * mutate them in history.
   *
   * @return {Array}
   */ log.history = ()=>$86defbb4e95ebb07$var$history ? [].concat($86defbb4e95ebb07$var$history) : [];
    /**
   * Allows you to filter the history by the given logger name
   *
   * @param {string} fname
   *        The name to filter by
   *
   * @return {Array}
   *         The filtered list to return
   */ log.history.filter = (fname)=>{
        return ($86defbb4e95ebb07$var$history || []).filter((historyItem)=>{
            // if the first item in each historyItem includes `fname`, then it's a match
            return new RegExp(`.*${fname}.*`).test(historyItem[0]);
        });
    };
    /**
   * Clears the internal history tracking, but does not prevent further history
   * tracking.
   */ log.history.clear = ()=>{
        if ($86defbb4e95ebb07$var$history) $86defbb4e95ebb07$var$history.length = 0;
    };
    /**
   * Disable history tracking if it is currently enabled.
   */ log.history.disable = ()=>{
        if ($86defbb4e95ebb07$var$history !== null) {
            $86defbb4e95ebb07$var$history.length = 0;
            $86defbb4e95ebb07$var$history = null;
        }
    };
    /**
   * Enable history tracking if it is currently disabled.
   */ log.history.enable = ()=>{
        if ($86defbb4e95ebb07$var$history === null) $86defbb4e95ebb07$var$history = [];
    };
    /**
   * Logs error messages. Similar to `console.error`.
   *
   * @param {...*} args
   *        One or more messages or objects that should be logged as an error
   */ log.error = (...args)=>logByType('error', level, args);
    /**
   * Logs warning messages. Similar to `console.warn`.
   *
   * @param {...*} args
   *        One or more messages or objects that should be logged as a warning.
   */ log.warn = (...args)=>logByType('warn', level, args);
    /**
   * Logs debug messages. Similar to `console.debug`, but may also act as a comparable
   * log if `console.debug` is not available
   *
   * @param {...*} args
   *        One or more messages or objects that should be logged as debug.
   */ log.debug = (...args)=>logByType('debug', level, args);
    return log;
}
/**
 * @file log.js
 * @module log
 */ const $86defbb4e95ebb07$var$log$1 = $86defbb4e95ebb07$var$createLogger$1('VIDEOJS');
const $86defbb4e95ebb07$var$createLogger = $86defbb4e95ebb07$var$log$1.createLogger;
/**
 * @file obj.js
 * @module obj
 */ /**
 * @callback obj:EachCallback
 *
 * @param {*} value
 *        The current key for the object that is being iterated over.
 *
 * @param {string} key
 *        The current key-value for object that is being iterated over
 */ /**
 * @callback obj:ReduceCallback
 *
 * @param {*} accum
 *        The value that is accumulating over the reduce loop.
 *
 * @param {*} value
 *        The current key for the object that is being iterated over.
 *
 * @param {string} key
 *        The current key-value for object that is being iterated over
 *
 * @return {*}
 *         The new accumulated value.
 */ const $86defbb4e95ebb07$var$toString = Object.prototype.toString;
/**
 * Get the keys of an Object
 *
 * @param {Object}
 *        The Object to get the keys from
 *
 * @return {string[]}
 *         An array of the keys from the object. Returns an empty array if the
 *         object passed in was invalid or had no keys.
 *
 * @private
 */ const $86defbb4e95ebb07$var$keys = function(object) {
    return $86defbb4e95ebb07$var$isObject(object) ? Object.keys(object) : [];
};
/**
 * Array-like iteration for objects.
 *
 * @param {Object} object
 *        The object to iterate over
 *
 * @param {obj:EachCallback} fn
 *        The callback function which is called for each key in the object.
 */ function $86defbb4e95ebb07$var$each(object, fn) {
    $86defbb4e95ebb07$var$keys(object).forEach((key)=>fn(object[key], key));
}
/**
 * Array-like reduce for objects.
 *
 * @param {Object} object
 *        The Object that you want to reduce.
 *
 * @param {Function} fn
 *         A callback function which is called for each key in the object. It
 *         receives the accumulated value and the per-iteration value and key
 *         as arguments.
 *
 * @param {*} [initial = 0]
 *        Starting value
 *
 * @return {*}
 *         The final accumulated value.
 */ function $86defbb4e95ebb07$var$reduce(object, fn, initial = 0) {
    return $86defbb4e95ebb07$var$keys(object).reduce((accum, key)=>fn(accum, object[key], key), initial);
}
/**
 * Returns whether a value is an object of any kind - including DOM nodes,
 * arrays, regular expressions, etc. Not functions, though.
 *
 * This avoids the gotcha where using `typeof` on a `null` value
 * results in `'object'`.
 *
 * @param  {Object} value
 * @return {boolean}
 */ function $86defbb4e95ebb07$var$isObject(value) {
    return !!value && typeof value === 'object';
}
/**
 * Returns whether an object appears to be a "plain" object - that is, a
 * direct instance of `Object`.
 *
 * @param  {Object} value
 * @return {boolean}
 */ function $86defbb4e95ebb07$var$isPlain(value) {
    return $86defbb4e95ebb07$var$isObject(value) && $86defbb4e95ebb07$var$toString.call(value) === '[object Object]' && value.constructor === Object;
}
/**
 * Merge two objects recursively.
 *
 * Performs a deep merge like
 * {@link https://lodash.com/docs/4.17.10#merge|lodash.merge}, but only merges
 * plain objects (not arrays, elements, or anything else).
 *
 * Non-plain object values will be copied directly from the right-most
 * argument.
 *
 * @param   {Object[]} sources
 *          One or more objects to merge into a new object.
 *
 * @return {Object}
 *          A new object that is the merged result of all sources.
 */ function $86defbb4e95ebb07$var$merge$1(...sources) {
    const result = {};
    sources.forEach((source)=>{
        if (!source) return;
        $86defbb4e95ebb07$var$each(source, (value, key)=>{
            if (!$86defbb4e95ebb07$var$isPlain(value)) {
                result[key] = value;
                return;
            }
            if (!$86defbb4e95ebb07$var$isPlain(result[key])) result[key] = {};
            result[key] = $86defbb4e95ebb07$var$merge$1(result[key], value);
        });
    });
    return result;
}
/**
 * Returns an array of values for a given object
 *
 * @param  {Object} source - target object
 * @return {Array<unknown>} - object values
 */ function $86defbb4e95ebb07$var$values(source = {}) {
    const result = [];
    for(const key in source)if (source.hasOwnProperty(key)) {
        const value = source[key];
        result.push(value);
    }
    return result;
}
/**
 * Object.defineProperty but "lazy", which means that the value is only set after
 * it is retrieved the first time, rather than being set right away.
 *
 * @param {Object} obj the object to set the property on
 * @param {string} key the key for the property to set
 * @param {Function} getValue the function used to get the value when it is needed.
 * @param {boolean} setter whether a setter should be allowed or not
 */ function $86defbb4e95ebb07$var$defineLazyProperty(obj, key, getValue, setter = true) {
    const set = (value)=>Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            writable: true
        });
    const options = {
        configurable: true,
        enumerable: true,
        get () {
            const value = getValue();
            set(value);
            return value;
        }
    };
    if (setter) options.set = set;
    return Object.defineProperty(obj, key, options);
}
var $86defbb4e95ebb07$var$Obj = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    each: $86defbb4e95ebb07$var$each,
    reduce: $86defbb4e95ebb07$var$reduce,
    isObject: $86defbb4e95ebb07$var$isObject,
    isPlain: $86defbb4e95ebb07$var$isPlain,
    merge: $86defbb4e95ebb07$var$merge$1,
    values: $86defbb4e95ebb07$var$values,
    defineLazyProperty: $86defbb4e95ebb07$var$defineLazyProperty
});
/**
 * @file browser.js
 * @module browser
 */ /**
 * Whether or not this device is an iPod.
 *
 * @static
 * @type {Boolean}
 */ let $86defbb4e95ebb07$var$IS_IPOD = false;
/**
 * The detected iOS version - or `null`.
 *
 * @static
 * @type {string|null}
 */ let $86defbb4e95ebb07$var$IOS_VERSION = null;
/**
 * Whether or not this is an Android device.
 *
 * @static
 * @type {Boolean}
 */ let $86defbb4e95ebb07$var$IS_ANDROID = false;
/**
 * The detected Android version - or `null` if not Android or indeterminable.
 *
 * @static
 * @type {number|string|null}
 */ let $86defbb4e95ebb07$var$ANDROID_VERSION;
/**
 * Whether or not this is Mozilla Firefox.
 *
 * @static
 * @type {Boolean}
 */ let $86defbb4e95ebb07$var$IS_FIREFOX = false;
/**
 * Whether or not this is Microsoft Edge.
 *
 * @static
 * @type {Boolean}
 */ let $86defbb4e95ebb07$var$IS_EDGE = false;
/**
 * Whether or not this is any Chromium Browser
 *
 * @static
 * @type {Boolean}
 */ let $86defbb4e95ebb07$var$IS_CHROMIUM = false;
/**
 * Whether or not this is any Chromium browser that is not Edge.
 *
 * This will also be `true` for Chrome on iOS, which will have different support
 * as it is actually Safari under the hood.
 *
 * Deprecated, as the behaviour to not match Edge was to prevent Legacy Edge's UA matching.
 * IS_CHROMIUM should be used instead.
 * "Chromium but not Edge" could be explicitly tested with IS_CHROMIUM && !IS_EDGE
 *
 * @static
 * @deprecated
 * @type {Boolean}
 */ let $86defbb4e95ebb07$var$IS_CHROME = false;
/**
 * The detected Chromium version - or `null`.
 *
 * @static
 * @type {number|null}
 */ let $86defbb4e95ebb07$var$CHROMIUM_VERSION = null;
/**
 * The detected Google Chrome version - or `null`.
 * This has always been the _Chromium_ version, i.e. would return on Chromium Edge.
 * Deprecated, use CHROMIUM_VERSION instead.
 *
 * @static
 * @deprecated
 * @type {number|null}
 */ let $86defbb4e95ebb07$var$CHROME_VERSION = null;
/**
 * Whether or not this is a Chromecast receiver application.
 *
 * @static
 * @type {Boolean}
 */ const $86defbb4e95ebb07$var$IS_CHROMECAST_RECEIVER = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).cast && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).cast.framework && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).cast.framework.CastReceiverContext);
/**
 * The detected Internet Explorer version - or `null`.
 *
 * @static
 * @deprecated
 * @type {number|null}
 */ let $86defbb4e95ebb07$var$IE_VERSION = null;
/**
 * Whether or not this is desktop Safari.
 *
 * @static
 * @type {Boolean}
 */ let $86defbb4e95ebb07$var$IS_SAFARI = false;
/**
 * Whether or not this is a Windows machine.
 *
 * @static
 * @type {Boolean}
 */ let $86defbb4e95ebb07$var$IS_WINDOWS = false;
/**
 * Whether or not this device is an iPad.
 *
 * @static
 * @type {Boolean}
 */ let $86defbb4e95ebb07$var$IS_IPAD = false;
/**
 * Whether or not this device is an iPhone.
 *
 * @static
 * @type {Boolean}
 */ // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
// to identify iPhones, we need to exclude iPads.
// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
let $86defbb4e95ebb07$var$IS_IPHONE = false;
/**
 * Whether or not this is a Tizen device.
 *
 * @static
 * @type {Boolean}
 */ let $86defbb4e95ebb07$var$IS_TIZEN = false;
/**
 * Whether or not this is a WebOS device.
 *
 * @static
 * @type {Boolean}
 */ let $86defbb4e95ebb07$var$IS_WEBOS = false;
/**
 * Whether or not this is a Smart TV (Tizen or WebOS) device.
 *
 * @static
 * @type {Boolean}
 */ let $86defbb4e95ebb07$var$IS_SMART_TV = false;
/**
 * Whether or not this device is touch-enabled.
 *
 * @static
 * @const
 * @type {Boolean}
 */ const $86defbb4e95ebb07$var$TOUCH_ENABLED = Boolean($86defbb4e95ebb07$var$isReal() && ('ontouchstart' in (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))) || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).navigator.maxTouchPoints || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).DocumentTouch && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).document instanceof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).DocumentTouch));
const $86defbb4e95ebb07$var$UAD = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).navigator && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).navigator.userAgentData;
if ($86defbb4e95ebb07$var$UAD && $86defbb4e95ebb07$var$UAD.platform && $86defbb4e95ebb07$var$UAD.brands) {
    // If userAgentData is present, use it instead of userAgent to avoid warnings
    // Currently only implemented on Chromium
    // userAgentData does not expose Android version, so ANDROID_VERSION remains `null`
    $86defbb4e95ebb07$var$IS_ANDROID = $86defbb4e95ebb07$var$UAD.platform === 'Android';
    $86defbb4e95ebb07$var$IS_EDGE = Boolean($86defbb4e95ebb07$var$UAD.brands.find((b)=>b.brand === 'Microsoft Edge'));
    $86defbb4e95ebb07$var$IS_CHROMIUM = Boolean($86defbb4e95ebb07$var$UAD.brands.find((b)=>b.brand === 'Chromium'));
    $86defbb4e95ebb07$var$IS_CHROME = !$86defbb4e95ebb07$var$IS_EDGE && $86defbb4e95ebb07$var$IS_CHROMIUM;
    $86defbb4e95ebb07$var$CHROMIUM_VERSION = $86defbb4e95ebb07$var$CHROME_VERSION = ($86defbb4e95ebb07$var$UAD.brands.find((b)=>b.brand === 'Chromium') || {}).version || null;
    $86defbb4e95ebb07$var$IS_WINDOWS = $86defbb4e95ebb07$var$UAD.platform === 'Windows';
}
// If the browser is not Chromium, either userAgentData is not present which could be an old Chromium browser,
//  or it's a browser that has added userAgentData since that we don't have tests for yet. In either case,
// the checks need to be made agiainst the regular userAgent string.
if (!$86defbb4e95ebb07$var$IS_CHROMIUM) {
    const USER_AGENT = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).navigator && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).navigator.userAgent || '';
    $86defbb4e95ebb07$var$IS_IPOD = /iPod/i.test(USER_AGENT);
    $86defbb4e95ebb07$var$IOS_VERSION = function() {
        const match = USER_AGENT.match(/OS (\d+)_/i);
        if (match && match[1]) return match[1];
        return null;
    }();
    $86defbb4e95ebb07$var$IS_ANDROID = /Android/i.test(USER_AGENT);
    $86defbb4e95ebb07$var$ANDROID_VERSION = function() {
        // This matches Android Major.Minor.Patch versions
        // ANDROID_VERSION is Major.Minor as a Number, if Minor isn't available, then only Major is returned
        const match = USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
        if (!match) return null;
        const major = match[1] && parseFloat(match[1]);
        const minor = match[2] && parseFloat(match[2]);
        if (major && minor) return parseFloat(match[1] + '.' + match[2]);
        else if (major) return major;
        return null;
    }();
    $86defbb4e95ebb07$var$IS_FIREFOX = /Firefox/i.test(USER_AGENT);
    $86defbb4e95ebb07$var$IS_EDGE = /Edg/i.test(USER_AGENT);
    $86defbb4e95ebb07$var$IS_CHROMIUM = /Chrome/i.test(USER_AGENT) || /CriOS/i.test(USER_AGENT);
    $86defbb4e95ebb07$var$IS_CHROME = !$86defbb4e95ebb07$var$IS_EDGE && $86defbb4e95ebb07$var$IS_CHROMIUM;
    $86defbb4e95ebb07$var$CHROMIUM_VERSION = $86defbb4e95ebb07$var$CHROME_VERSION = function() {
        const match = USER_AGENT.match(/(Chrome|CriOS)\/(\d+)/);
        if (match && match[2]) return parseFloat(match[2]);
        return null;
    }();
    $86defbb4e95ebb07$var$IE_VERSION = function() {
        const result = /MSIE\s(\d+)\.\d/.exec(USER_AGENT);
        let version = result && parseFloat(result[1]);
        if (!version && /Trident\/7.0/i.test(USER_AGENT) && /rv:11.0/.test(USER_AGENT)) // IE 11 has a different user agent string than other IE versions
        version = 11.0;
        return version;
    }();
    $86defbb4e95ebb07$var$IS_TIZEN = /Tizen/i.test(USER_AGENT);
    $86defbb4e95ebb07$var$IS_WEBOS = /Web0S/i.test(USER_AGENT);
    $86defbb4e95ebb07$var$IS_SMART_TV = $86defbb4e95ebb07$var$IS_TIZEN || $86defbb4e95ebb07$var$IS_WEBOS;
    $86defbb4e95ebb07$var$IS_SAFARI = /Safari/i.test(USER_AGENT) && !$86defbb4e95ebb07$var$IS_CHROME && !$86defbb4e95ebb07$var$IS_ANDROID && !$86defbb4e95ebb07$var$IS_EDGE && !$86defbb4e95ebb07$var$IS_SMART_TV;
    $86defbb4e95ebb07$var$IS_WINDOWS = /Windows/i.test(USER_AGENT);
    $86defbb4e95ebb07$var$IS_IPAD = /iPad/i.test(USER_AGENT) || $86defbb4e95ebb07$var$IS_SAFARI && $86defbb4e95ebb07$var$TOUCH_ENABLED && !/iPhone/i.test(USER_AGENT);
    $86defbb4e95ebb07$var$IS_IPHONE = /iPhone/i.test(USER_AGENT) && !$86defbb4e95ebb07$var$IS_IPAD;
}
/**
 * Whether or not this is an iOS device.
 *
 * @static
 * @const
 * @type {Boolean}
 */ const $86defbb4e95ebb07$var$IS_IOS = $86defbb4e95ebb07$var$IS_IPHONE || $86defbb4e95ebb07$var$IS_IPAD || $86defbb4e95ebb07$var$IS_IPOD;
/**
 * Whether or not this is any flavor of Safari - including iOS.
 *
 * @static
 * @const
 * @type {Boolean}
 */ const $86defbb4e95ebb07$var$IS_ANY_SAFARI = ($86defbb4e95ebb07$var$IS_SAFARI || $86defbb4e95ebb07$var$IS_IOS) && !$86defbb4e95ebb07$var$IS_CHROME;
var $86defbb4e95ebb07$var$browser = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    get IS_IPOD () {
        return $86defbb4e95ebb07$var$IS_IPOD;
    },
    get IOS_VERSION () {
        return $86defbb4e95ebb07$var$IOS_VERSION;
    },
    get IS_ANDROID () {
        return $86defbb4e95ebb07$var$IS_ANDROID;
    },
    get ANDROID_VERSION () {
        return $86defbb4e95ebb07$var$ANDROID_VERSION;
    },
    get IS_FIREFOX () {
        return $86defbb4e95ebb07$var$IS_FIREFOX;
    },
    get IS_EDGE () {
        return $86defbb4e95ebb07$var$IS_EDGE;
    },
    get IS_CHROMIUM () {
        return $86defbb4e95ebb07$var$IS_CHROMIUM;
    },
    get IS_CHROME () {
        return $86defbb4e95ebb07$var$IS_CHROME;
    },
    get CHROMIUM_VERSION () {
        return $86defbb4e95ebb07$var$CHROMIUM_VERSION;
    },
    get CHROME_VERSION () {
        return $86defbb4e95ebb07$var$CHROME_VERSION;
    },
    IS_CHROMECAST_RECEIVER: $86defbb4e95ebb07$var$IS_CHROMECAST_RECEIVER,
    get IE_VERSION () {
        return $86defbb4e95ebb07$var$IE_VERSION;
    },
    get IS_SAFARI () {
        return $86defbb4e95ebb07$var$IS_SAFARI;
    },
    get IS_WINDOWS () {
        return $86defbb4e95ebb07$var$IS_WINDOWS;
    },
    get IS_IPAD () {
        return $86defbb4e95ebb07$var$IS_IPAD;
    },
    get IS_IPHONE () {
        return $86defbb4e95ebb07$var$IS_IPHONE;
    },
    get IS_TIZEN () {
        return $86defbb4e95ebb07$var$IS_TIZEN;
    },
    get IS_WEBOS () {
        return $86defbb4e95ebb07$var$IS_WEBOS;
    },
    get IS_SMART_TV () {
        return $86defbb4e95ebb07$var$IS_SMART_TV;
    },
    TOUCH_ENABLED: $86defbb4e95ebb07$var$TOUCH_ENABLED,
    IS_IOS: $86defbb4e95ebb07$var$IS_IOS,
    IS_ANY_SAFARI: $86defbb4e95ebb07$var$IS_ANY_SAFARI
});
/**
 * @file dom.js
 * @module dom
 */ /**
 * Detect if a value is a string with any non-whitespace characters.
 *
 * @private
 * @param  {string} str
 *         The string to check
 *
 * @return {boolean}
 *         Will be `true` if the string is non-blank, `false` otherwise.
 *
 */ function $86defbb4e95ebb07$var$isNonBlankString(str) {
    // we use str.trim as it will trim any whitespace characters
    // from the front or back of non-whitespace characters. aka
    // Any string that contains non-whitespace characters will
    // still contain them after `trim` but whitespace only strings
    // will have a length of 0, failing this check.
    return typeof str === 'string' && Boolean(str.trim());
}
/**
 * Throws an error if the passed string has whitespace. This is used by
 * class methods to be relatively consistent with the classList API.
 *
 * @private
 * @param  {string} str
 *         The string to check for whitespace.
 *
 * @throws {Error}
 *         Throws an error if there is whitespace in the string.
 */ function $86defbb4e95ebb07$var$throwIfWhitespace(str) {
    // str.indexOf instead of regex because str.indexOf is faster performance wise.
    if (str.indexOf(' ') >= 0) throw new Error('class has illegal whitespace characters');
}
/**
 * Whether the current DOM interface appears to be real (i.e. not simulated).
 *
 * @return {boolean}
 *         Will be `true` if the DOM appears to be real, `false` otherwise.
 */ function $86defbb4e95ebb07$var$isReal() {
    // Both document and window will never be undefined thanks to `global`.
    return (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))) === (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).document;
}
/**
 * Determines, via duck typing, whether or not a value is a DOM element.
 *
 * @param  {*} value
 *         The value to check.
 *
 * @return {boolean}
 *         Will be `true` if the value is a DOM element, `false` otherwise.
 */ function $86defbb4e95ebb07$var$isEl(value) {
    return $86defbb4e95ebb07$var$isObject(value) && value.nodeType === 1;
}
/**
 * Determines if the current DOM is embedded in an iframe.
 *
 * @return {boolean}
 *         Will be `true` if the DOM is embedded in an iframe, `false`
 *         otherwise.
 */ function $86defbb4e95ebb07$var$isInFrame() {
    // We need a try/catch here because Safari will throw errors when attempting
    // to get either `parent` or `self`
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).parent !== (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).self;
    } catch (x) {
        return true;
    }
}
/**
 * Creates functions to query the DOM using a given method.
 *
 * @private
 * @param   {string} method
 *          The method to create the query with.
 *
 * @return  {Function}
 *          The query method
 */ function $86defbb4e95ebb07$var$createQuerier(method) {
    return function(selector, context) {
        if (!$86defbb4e95ebb07$var$isNonBlankString(selector)) return (0, (/*@__PURE__*/$parcel$interopDefault($01r8O)))[method](null);
        if ($86defbb4e95ebb07$var$isNonBlankString(context)) context = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).querySelector(context);
        const ctx = $86defbb4e95ebb07$var$isEl(context) ? context : (0, (/*@__PURE__*/$parcel$interopDefault($01r8O)));
        return ctx[method] && ctx[method](selector);
    };
}
/**
 * Creates an element and applies properties, attributes, and inserts content.
 *
 * @param  {string} [tagName='div']
 *         Name of tag to be created.
 *
 * @param  {Object} [properties={}]
 *         Element properties to be applied.
 *
 * @param  {Object} [attributes={}]
 *         Element attributes to be applied.
 *
 * @param {ContentDescriptor} [content]
 *        A content descriptor object.
 *
 * @return {Element}
 *         The element that was created.
 */ function $86defbb4e95ebb07$var$createEl(tagName = 'div', properties = {}, attributes = {}, content) {
    const el = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement(tagName);
    Object.getOwnPropertyNames(properties).forEach(function(propName) {
        const val = properties[propName];
        // Handle textContent since it's not supported everywhere and we have a
        // method for it.
        if (propName === 'textContent') $86defbb4e95ebb07$var$textContent(el, val);
        else if (el[propName] !== val || propName === 'tabIndex') el[propName] = val;
    });
    Object.getOwnPropertyNames(attributes).forEach(function(attrName) {
        el.setAttribute(attrName, attributes[attrName]);
    });
    if (content) $86defbb4e95ebb07$var$appendContent(el, content);
    return el;
}
/**
 * Injects text into an element, replacing any existing contents entirely.
 *
 * @param  {HTMLElement} el
 *         The element to add text content into
 *
 * @param  {string} text
 *         The text content to add.
 *
 * @return {Element}
 *         The element with added text content.
 */ function $86defbb4e95ebb07$var$textContent(el, text) {
    if (typeof el.textContent === 'undefined') el.innerText = text;
    else el.textContent = text;
    return el;
}
/**
 * Insert an element as the first child node of another
 *
 * @param {Element} child
 *        Element to insert
 *
 * @param {Element} parent
 *        Element to insert child into
 */ function $86defbb4e95ebb07$var$prependTo(child, parent) {
    if (parent.firstChild) parent.insertBefore(child, parent.firstChild);
    else parent.appendChild(child);
}
/**
 * Check if an element has a class name.
 *
 * @param  {Element} element
 *         Element to check
 *
 * @param  {string} classToCheck
 *         Class name to check for
 *
 * @return {boolean}
 *         Will be `true` if the element has a class, `false` otherwise.
 *
 * @throws {Error}
 *         Throws an error if `classToCheck` has white space.
 */ function $86defbb4e95ebb07$var$hasClass(element, classToCheck) {
    $86defbb4e95ebb07$var$throwIfWhitespace(classToCheck);
    return element.classList.contains(classToCheck);
}
/**
 * Add a class name to an element.
 *
 * @param  {Element} element
 *         Element to add class name to.
 *
 * @param  {...string} classesToAdd
 *         One or more class name to add.
 *
 * @return {Element}
 *         The DOM element with the added class name.
 */ function $86defbb4e95ebb07$var$addClass(element, ...classesToAdd) {
    element.classList.add(...classesToAdd.reduce((prev, current)=>prev.concat(current.split(/\s+/)), []));
    return element;
}
/**
 * Remove a class name from an element.
 *
 * @param  {Element} element
 *         Element to remove a class name from.
 *
 * @param  {...string} classesToRemove
 *         One or more class name to remove.
 *
 * @return {Element}
 *         The DOM element with class name removed.
 */ function $86defbb4e95ebb07$var$removeClass(element, ...classesToRemove) {
    // Protect in case the player gets disposed
    if (!element) {
        $86defbb4e95ebb07$var$log$1.warn("removeClass was called with an element that doesn't exist");
        return null;
    }
    element.classList.remove(...classesToRemove.reduce((prev, current)=>prev.concat(current.split(/\s+/)), []));
    return element;
}
/**
 * The callback definition for toggleClass.
 *
 * @callback PredicateCallback
 * @param    {Element} element
 *           The DOM element of the Component.
 *
 * @param    {string} classToToggle
 *           The `className` that wants to be toggled
 *
 * @return   {boolean|undefined}
 *           If `true` is returned, the `classToToggle` will be added to the
 *           `element`, but not removed. If `false`, the `classToToggle` will be removed from
 *           the `element`, but not added. If `undefined`, the callback will be ignored.
 *
 */ /**
 * Adds or removes a class name to/from an element depending on an optional
 * condition or the presence/absence of the class name.
 *
 * @param  {Element} element
 *         The element to toggle a class name on.
 *
 * @param  {string} classToToggle
 *         The class that should be toggled.
 *
 * @param  {boolean|PredicateCallback} [predicate]
 *         See the return value for {@link module:dom~PredicateCallback}
 *
 * @return {Element}
 *         The element with a class that has been toggled.
 */ function $86defbb4e95ebb07$var$toggleClass(element, classToToggle, predicate) {
    if (typeof predicate === 'function') predicate = predicate(element, classToToggle);
    if (typeof predicate !== 'boolean') predicate = undefined;
    classToToggle.split(/\s+/).forEach((className)=>element.classList.toggle(className, predicate));
    return element;
}
/**
 * Apply attributes to an HTML element.
 *
 * @param {Element} el
 *        Element to add attributes to.
 *
 * @param {Object} [attributes]
 *        Attributes to be applied.
 */ function $86defbb4e95ebb07$var$setAttributes(el, attributes) {
    Object.getOwnPropertyNames(attributes).forEach(function(attrName) {
        const attrValue = attributes[attrName];
        if (attrValue === null || typeof attrValue === 'undefined' || attrValue === false) el.removeAttribute(attrName);
        else el.setAttribute(attrName, attrValue === true ? '' : attrValue);
    });
}
/**
 * Get an element's attribute values, as defined on the HTML tag.
 *
 * Attributes are not the same as properties. They're defined on the tag
 * or with setAttribute.
 *
 * @param  {Element} tag
 *         Element from which to get tag attributes.
 *
 * @return {Object}
 *         All attributes of the element. Boolean attributes will be `true` or
 *         `false`, others will be strings.
 */ function $86defbb4e95ebb07$var$getAttributes(tag) {
    const obj = {};
    // known boolean attributes
    // we can check for matching boolean properties, but not all browsers
    // and not all tags know about these attributes, so, we still want to check them manually
    const knownBooleans = [
        'autoplay',
        'controls',
        'playsinline',
        'loop',
        'muted',
        'default',
        'defaultMuted'
    ];
    if (tag && tag.attributes && tag.attributes.length > 0) {
        const attrs = tag.attributes;
        for(let i = attrs.length - 1; i >= 0; i--){
            const attrName = attrs[i].name;
            /** @type {boolean|string} */ let attrVal = attrs[i].value;
            // check for known booleans
            // the matching element property will return a value for typeof
            if (knownBooleans.includes(attrName)) // the value of an included boolean attribute is typically an empty
            // string ('') which would equal false if we just check for a false value.
            // we also don't want support bad code like autoplay='false'
            attrVal = attrVal !== null ? true : false;
            obj[attrName] = attrVal;
        }
    }
    return obj;
}
/**
 * Get the value of an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to get the value of.
 *
 * @return {string}
 *         The value of the attribute.
 */ function $86defbb4e95ebb07$var$getAttribute(el, attribute) {
    return el.getAttribute(attribute);
}
/**
 * Set the value of an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to set.
 *
 * @param {string} value
 *        Value to set the attribute to.
 */ function $86defbb4e95ebb07$var$setAttribute(el, attribute, value) {
    el.setAttribute(attribute, value);
}
/**
 * Remove an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to remove.
 */ function $86defbb4e95ebb07$var$removeAttribute(el, attribute) {
    el.removeAttribute(attribute);
}
/**
 * Attempt to block the ability to select text.
 */ function $86defbb4e95ebb07$var$blockTextSelection() {
    (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).body.focus();
    (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).onselectstart = function() {
        return false;
    };
}
/**
 * Turn off text selection blocking.
 */ function $86defbb4e95ebb07$var$unblockTextSelection() {
    (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).onselectstart = function() {
        return true;
    };
}
/**
 * Identical to the native `getBoundingClientRect` function, but ensures that
 * the method is supported at all (it is in all browsers we claim to support)
 * and that the element is in the DOM before continuing.
 *
 * This wrapper function also shims properties which are not provided by some
 * older browsers (namely, IE8).
 *
 * Additionally, some browsers do not support adding properties to a
 * `ClientRect`/`DOMRect` object; so, we shallow-copy it with the standard
 * properties (except `x` and `y` which are not widely supported). This helps
 * avoid implementations where keys are non-enumerable.
 *
 * @param  {Element} el
 *         Element whose `ClientRect` we want to calculate.
 *
 * @return {Object|undefined}
 *         Always returns a plain object - or `undefined` if it cannot.
 */ function $86defbb4e95ebb07$var$getBoundingClientRect(el) {
    if (el && el.getBoundingClientRect && el.parentNode) {
        const rect = el.getBoundingClientRect();
        const result = {};
        [
            'bottom',
            'height',
            'left',
            'right',
            'top',
            'width'
        ].forEach((k)=>{
            if (rect[k] !== undefined) result[k] = rect[k];
        });
        if (!result.height) result.height = parseFloat($86defbb4e95ebb07$var$computedStyle(el, 'height'));
        if (!result.width) result.width = parseFloat($86defbb4e95ebb07$var$computedStyle(el, 'width'));
        return result;
    }
}
/**
 * Represents the position of a DOM element on the page.
 *
 * @typedef  {Object} module:dom~Position
 *
 * @property {number} left
 *           Pixels to the left.
 *
 * @property {number} top
 *           Pixels from the top.
 */ /**
 * Get the position of an element in the DOM.
 *
 * Uses `getBoundingClientRect` technique from John Resig.
 *
 * @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @param  {Element} el
 *         Element from which to get offset.
 *
 * @return {module:dom~Position}
 *         The position of the element that was passed in.
 */ function $86defbb4e95ebb07$var$findPosition(el) {
    if (!el || el && !el.offsetParent) return {
        left: 0,
        top: 0,
        width: 0,
        height: 0
    };
    const width = el.offsetWidth;
    const height = el.offsetHeight;
    let left = 0;
    let top = 0;
    while(el.offsetParent && el !== (0, (/*@__PURE__*/$parcel$interopDefault($01r8O)))[$86defbb4e95ebb07$var$FullscreenApi.fullscreenElement]){
        left += el.offsetLeft;
        top += el.offsetTop;
        el = el.offsetParent;
    }
    return {
        left: left,
        top: top,
        width: width,
        height: height
    };
}
/**
 * Represents x and y coordinates for a DOM element or mouse pointer.
 *
 * @typedef  {Object} module:dom~Coordinates
 *
 * @property {number} x
 *           x coordinate in pixels
 *
 * @property {number} y
 *           y coordinate in pixels
 */ /**
 * Get the pointer position within an element.
 *
 * The base on the coordinates are the bottom left of the element.
 *
 * @param  {Element} el
 *         Element on which to get the pointer position on.
 *
 * @param  {Event} event
 *         Event object.
 *
 * @return {module:dom~Coordinates}
 *         A coordinates object corresponding to the mouse position.
 *
 */ function $86defbb4e95ebb07$var$getPointerPosition(el, event) {
    const translated = {
        x: 0,
        y: 0
    };
    if ($86defbb4e95ebb07$var$IS_IOS) {
        let item = el;
        while(item && item.nodeName.toLowerCase() !== 'html'){
            const transform = $86defbb4e95ebb07$var$computedStyle(item, 'transform');
            if (/^matrix/.test(transform)) {
                const values = transform.slice(7, -1).split(/,\s/).map(Number);
                translated.x += values[4];
                translated.y += values[5];
            } else if (/^matrix3d/.test(transform)) {
                const values = transform.slice(9, -1).split(/,\s/).map(Number);
                translated.x += values[12];
                translated.y += values[13];
            }
            if (item.assignedSlot && item.assignedSlot.parentElement && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebKitCSSMatrix) {
                const transformValue = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).getComputedStyle(item.assignedSlot.parentElement).transform;
                const matrix = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebKitCSSMatrix(transformValue);
                translated.x += matrix.m41;
                translated.y += matrix.m42;
            }
            item = item.parentNode || item.host;
        }
    }
    const position = {};
    const boxTarget = $86defbb4e95ebb07$var$findPosition(event.target);
    const box = $86defbb4e95ebb07$var$findPosition(el);
    const boxW = box.width;
    const boxH = box.height;
    let offsetY = event.offsetY - (box.top - boxTarget.top);
    let offsetX = event.offsetX - (box.left - boxTarget.left);
    if (event.changedTouches) {
        offsetX = event.changedTouches[0].pageX - box.left;
        offsetY = event.changedTouches[0].pageY + box.top;
        if ($86defbb4e95ebb07$var$IS_IOS) {
            offsetX -= translated.x;
            offsetY -= translated.y;
        }
    }
    position.y = 1 - Math.max(0, Math.min(1, offsetY / boxH));
    position.x = Math.max(0, Math.min(1, offsetX / boxW));
    return position;
}
/**
 * Determines, via duck typing, whether or not a value is a text node.
 *
 * @param  {*} value
 *         Check if this value is a text node.
 *
 * @return {boolean}
 *         Will be `true` if the value is a text node, `false` otherwise.
 */ function $86defbb4e95ebb07$var$isTextNode(value) {
    return $86defbb4e95ebb07$var$isObject(value) && value.nodeType === 3;
}
/**
 * Empties the contents of an element.
 *
 * @param  {Element} el
 *         The element to empty children from
 *
 * @return {Element}
 *         The element with no children
 */ function $86defbb4e95ebb07$var$emptyEl(el) {
    while(el.firstChild)el.removeChild(el.firstChild);
    return el;
}
/**
 * This is a mixed value that describes content to be injected into the DOM
 * via some method. It can be of the following types:
 *
 * Type       | Description
 * -----------|-------------
 * `string`   | The value will be normalized into a text node.
 * `Element`  | The value will be accepted as-is.
 * `Text`     | A TextNode. The value will be accepted as-is.
 * `Array`    | A one-dimensional array of strings, elements, text nodes, or functions. These functions should return a string, element, or text node (any other return value, like an array, will be ignored).
 * `Function` | A function, which is expected to return a string, element, text node, or array - any of the other possible values described above. This means that a content descriptor could be a function that returns an array of functions, but those second-level functions must return strings, elements, or text nodes.
 *
 * @typedef {string|Element|Text|Array|Function} ContentDescriptor
 */ /**
 * Normalizes content for eventual insertion into the DOM.
 *
 * This allows a wide range of content definition methods, but helps protect
 * from falling into the trap of simply writing to `innerHTML`, which could
 * be an XSS concern.
 *
 * The content for an element can be passed in multiple types and
 * combinations, whose behavior is as follows:
 *
 * @param {ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Array}
 *         All of the content that was passed in, normalized to an array of
 *         elements or text nodes.
 */ function $86defbb4e95ebb07$var$normalizeContent(content) {
    // First, invoke content if it is a function. If it produces an array,
    // that needs to happen before normalization.
    if (typeof content === 'function') content = content();
    // Next up, normalize to an array, so one or many items can be normalized,
    // filtered, and returned.
    return (Array.isArray(content) ? content : [
        content
    ]).map((value)=>{
        // First, invoke value if it is a function to produce a new value,
        // which will be subsequently normalized to a Node of some kind.
        if (typeof value === 'function') value = value();
        if ($86defbb4e95ebb07$var$isEl(value) || $86defbb4e95ebb07$var$isTextNode(value)) return value;
        if (typeof value === 'string' && /\S/.test(value)) return (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createTextNode(value);
    }).filter((value)=>value);
}
/**
 * Normalizes and appends content to an element.
 *
 * @param  {Element} el
 *         Element to append normalized content to.
 *
 * @param {ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Element}
 *         The element with appended normalized content.
 */ function $86defbb4e95ebb07$var$appendContent(el, content) {
    $86defbb4e95ebb07$var$normalizeContent(content).forEach((node)=>el.appendChild(node));
    return el;
}
/**
 * Normalizes and inserts content into an element; this is identical to
 * `appendContent()`, except it empties the element first.
 *
 * @param {Element} el
 *        Element to insert normalized content into.
 *
 * @param {ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Element}
 *         The element with inserted normalized content.
 */ function $86defbb4e95ebb07$var$insertContent(el, content) {
    return $86defbb4e95ebb07$var$appendContent($86defbb4e95ebb07$var$emptyEl(el), content);
}
/**
 * Check if an event was a single left click.
 *
 * @param  {MouseEvent} event
 *         Event object.
 *
 * @return {boolean}
 *         Will be `true` if a single left click, `false` otherwise.
 */ function $86defbb4e95ebb07$var$isSingleLeftClick(event) {
    // Note: if you create something draggable, be sure to
    // call it on both `mousedown` and `mousemove` event,
    // otherwise `mousedown` should be enough for a button
    if (event.button === undefined && event.buttons === undefined) // Why do we need `buttons` ?
    // Because, middle mouse sometimes have this:
    // e.button === 0 and e.buttons === 4
    // Furthermore, we want to prevent combination click, something like
    // HOLD middlemouse then left click, that would be
    // e.button === 0, e.buttons === 5
    // just `button` is not gonna work
    // Alright, then what this block does ?
    // this is for chrome `simulate mobile devices`
    // I want to support this as well
    return true;
    if (event.button === 0 && event.buttons === undefined) // Touch screen, sometimes on some specific device, `buttons`
    // doesn't have anything (safari on ios, blackberry...)
    return true;
    // `mouseup` event on a single left click has
    // `button` and `buttons` equal to 0
    if (event.type === 'mouseup' && event.button === 0 && event.buttons === 0) return true;
    // MacOS Sonoma trackpad when "tap to click enabled"
    if (event.type === 'mousedown' && event.button === 0 && event.buttons === 0) return true;
    if (event.button !== 0 || event.buttons !== 1) // This is the reason we have those if else block above
    // if any special case we can catch and let it slide
    // we do it above, when get to here, this definitely
    // is-not-left-click
    return false;
    return true;
}
/**
 * Finds a single DOM element matching `selector` within the optional
 * `context` of another DOM element (defaulting to `document`).
 *
 * @param  {string} selector
 *         A valid CSS selector, which will be passed to `querySelector`.
 *
 * @param  {Element|String} [context=document]
 *         A DOM element within which to query. Can also be a selector
 *         string in which case the first matching element will be used
 *         as context. If missing (or no element matches selector), falls
 *         back to `document`.
 *
 * @return {Element|null}
 *         The element that was found or null.
 */ const $86defbb4e95ebb07$var$$ = $86defbb4e95ebb07$var$createQuerier('querySelector');
/**
 * Finds a all DOM elements matching `selector` within the optional
 * `context` of another DOM element (defaulting to `document`).
 *
 * @param  {string} selector
 *         A valid CSS selector, which will be passed to `querySelectorAll`.
 *
 * @param  {Element|String} [context=document]
 *         A DOM element within which to query. Can also be a selector
 *         string in which case the first matching element will be used
 *         as context. If missing (or no element matches selector), falls
 *         back to `document`.
 *
 * @return {NodeList}
 *         A element list of elements that were found. Will be empty if none
 *         were found.
 *
 */ const $86defbb4e95ebb07$var$$$ = $86defbb4e95ebb07$var$createQuerier('querySelectorAll');
/**
 * A safe getComputedStyle.
 *
 * This is needed because in Firefox, if the player is loaded in an iframe with
 * `display:none`, then `getComputedStyle` returns `null`, so, we do a
 * null-check to make sure that the player doesn't break in these cases.
 *
 * @param    {Element} el
 *           The element you want the computed style of
 *
 * @param    {string} prop
 *           The property name you want
 *
 * @see      https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */ function $86defbb4e95ebb07$var$computedStyle(el, prop) {
    if (!el || !prop) return '';
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).getComputedStyle === 'function') {
        let computedStyleValue;
        try {
            computedStyleValue = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).getComputedStyle(el);
        } catch (e) {
            return '';
        }
        return computedStyleValue ? computedStyleValue.getPropertyValue(prop) || computedStyleValue[prop] : '';
    }
    return '';
}
/**
 * Copy document style sheets to another window.
 *
 * @param    {Window} win
 *           The window element you want to copy the document style sheets to.
 *
 */ function $86defbb4e95ebb07$var$copyStyleSheetsToWindow(win) {
    [
        ...(0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).styleSheets
    ].forEach((styleSheet)=>{
        try {
            const cssRules = [
                ...styleSheet.cssRules
            ].map((rule)=>rule.cssText).join('');
            const style = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('style');
            style.textContent = cssRules;
            win.document.head.appendChild(style);
        } catch (e) {
            const link = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('link');
            link.rel = 'stylesheet';
            link.type = styleSheet.type;
            // For older Safari this has to be the string; on other browsers setting the MediaList works
            link.media = styleSheet.media.mediaText;
            link.href = styleSheet.href;
            win.document.head.appendChild(link);
        }
    });
}
var $86defbb4e95ebb07$var$Dom = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    isReal: $86defbb4e95ebb07$var$isReal,
    isEl: $86defbb4e95ebb07$var$isEl,
    isInFrame: $86defbb4e95ebb07$var$isInFrame,
    createEl: $86defbb4e95ebb07$var$createEl,
    textContent: $86defbb4e95ebb07$var$textContent,
    prependTo: $86defbb4e95ebb07$var$prependTo,
    hasClass: $86defbb4e95ebb07$var$hasClass,
    addClass: $86defbb4e95ebb07$var$addClass,
    removeClass: $86defbb4e95ebb07$var$removeClass,
    toggleClass: $86defbb4e95ebb07$var$toggleClass,
    setAttributes: $86defbb4e95ebb07$var$setAttributes,
    getAttributes: $86defbb4e95ebb07$var$getAttributes,
    getAttribute: $86defbb4e95ebb07$var$getAttribute,
    setAttribute: $86defbb4e95ebb07$var$setAttribute,
    removeAttribute: $86defbb4e95ebb07$var$removeAttribute,
    blockTextSelection: $86defbb4e95ebb07$var$blockTextSelection,
    unblockTextSelection: $86defbb4e95ebb07$var$unblockTextSelection,
    getBoundingClientRect: $86defbb4e95ebb07$var$getBoundingClientRect,
    findPosition: $86defbb4e95ebb07$var$findPosition,
    getPointerPosition: $86defbb4e95ebb07$var$getPointerPosition,
    isTextNode: $86defbb4e95ebb07$var$isTextNode,
    emptyEl: $86defbb4e95ebb07$var$emptyEl,
    normalizeContent: $86defbb4e95ebb07$var$normalizeContent,
    appendContent: $86defbb4e95ebb07$var$appendContent,
    insertContent: $86defbb4e95ebb07$var$insertContent,
    isSingleLeftClick: $86defbb4e95ebb07$var$isSingleLeftClick,
    $: $86defbb4e95ebb07$var$$,
    $$: $86defbb4e95ebb07$var$$$,
    computedStyle: $86defbb4e95ebb07$var$computedStyle,
    copyStyleSheetsToWindow: $86defbb4e95ebb07$var$copyStyleSheetsToWindow
});
/**
 * @file setup.js - Functions for setting up a player without
 * user interaction based on the data-setup `attribute` of the video tag.
 *
 * @module setup
 */ let $86defbb4e95ebb07$var$_windowLoaded = false;
let $86defbb4e95ebb07$var$videojs$1;
/**
 * Set up any tags that have a data-setup `attribute` when the player is started.
 */ const $86defbb4e95ebb07$var$autoSetup = function() {
    if ($86defbb4e95ebb07$var$videojs$1.options.autoSetup === false) return;
    const vids = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).getElementsByTagName('video'));
    const audios = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).getElementsByTagName('audio'));
    const divs = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).getElementsByTagName('video-js'));
    const mediaEls = vids.concat(audios, divs);
    // Check if any media elements exist
    if (mediaEls && mediaEls.length > 0) for(let i = 0, e = mediaEls.length; i < e; i++){
        const mediaEl = mediaEls[i];
        // Check if element exists, has getAttribute func.
        if (mediaEl && mediaEl.getAttribute) // Make sure this player hasn't already been set up.
        {
            if (mediaEl.player === undefined) {
                const options = mediaEl.getAttribute('data-setup');
                // Check if data-setup attr exists.
                // We only auto-setup if they've added the data-setup attr.
                if (options !== null) // Create new video.js instance.
                $86defbb4e95ebb07$var$videojs$1(mediaEl);
            }
        } else {
            $86defbb4e95ebb07$var$autoSetupTimeout(1);
            break;
        }
    }
    else if (!$86defbb4e95ebb07$var$_windowLoaded) $86defbb4e95ebb07$var$autoSetupTimeout(1);
};
/**
 * Wait until the page is loaded before running autoSetup. This will be called in
 * autoSetup if `hasLoaded` returns false.
 *
 * @param {number} wait
 *        How long to wait in ms
 *
 * @param {module:videojs} [vjs]
 *        The videojs library function
 */ function $86defbb4e95ebb07$var$autoSetupTimeout(wait, vjs) {
    // Protect against breakage in non-browser environments
    if (!$86defbb4e95ebb07$var$isReal()) return;
    if (vjs) $86defbb4e95ebb07$var$videojs$1 = vjs;
    (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout($86defbb4e95ebb07$var$autoSetup, wait);
}
/**
 * Used to set the internal tracking of window loaded state to true.
 *
 * @private
 */ function $86defbb4e95ebb07$var$setWindowLoaded() {
    $86defbb4e95ebb07$var$_windowLoaded = true;
    (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).removeEventListener('load', $86defbb4e95ebb07$var$setWindowLoaded);
}
if ($86defbb4e95ebb07$var$isReal()) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).readyState === 'complete') $86defbb4e95ebb07$var$setWindowLoaded();
    else /**
     * Listen for the load event on window, and set _windowLoaded to true.
     *
     * We use a standard event listener here to avoid incrementing the GUID
     * before any players are created.
     *
     * @listens load
     */ (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).addEventListener('load', $86defbb4e95ebb07$var$setWindowLoaded);
}
/**
 * @file stylesheet.js
 * @module stylesheet
 */ /**
 * Create a DOM style element given a className for it.
 *
 * @param {string} className
 *        The className to add to the created style element.
 *
 * @return {Element}
 *         The element that was created.
 */ const $86defbb4e95ebb07$var$createStyleElement = function(className) {
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('style');
    style.className = className;
    return style;
};
/**
 * Add text to a DOM element.
 *
 * @param {Element} el
 *        The Element to add text content to.
 *
 * @param {string} content
 *        The text to add to the element.
 */ const $86defbb4e95ebb07$var$setTextContent = function(el, content) {
    if (el.styleSheet) el.styleSheet.cssText = content;
    else el.textContent = content;
};
/**
 * @file dom-data.js
 * @module dom-data
 */ /**
 * Element Data Store.
 *
 * Allows for binding data to an element without putting it directly on the
 * element. Ex. Event listeners are stored here.
 * (also from jsninja.com, slightly modified and updated for closure compiler)
 *
 * @type {Object}
 * @private
 */ var $86defbb4e95ebb07$var$DomData = new WeakMap();
/**
 * @file guid.js
 * @module guid
 */ // Default value for GUIDs. This allows us to reset the GUID counter in tests.
//
// The initial GUID is 3 because some users have come to rely on the first
// default player ID ending up as `vjs_video_3`.
//
// See: https://github.com/videojs/video.js/pull/6216
const $86defbb4e95ebb07$var$_initialGuid = 3;
/**
 * Unique ID for an element or function
 *
 * @type {Number}
 */ let $86defbb4e95ebb07$var$_guid = $86defbb4e95ebb07$var$_initialGuid;
/**
 * Get a unique auto-incrementing ID by number that has not been returned before.
 *
 * @return {number}
 *         A new unique ID.
 */ function $86defbb4e95ebb07$var$newGUID() {
    return $86defbb4e95ebb07$var$_guid++;
}
/**
 * @file events.js. An Event System (John Resig - Secrets of a JS Ninja http://jsninja.com/)
 * (Original book version wasn't completely usable, so fixed some things and made Closure Compiler compatible)
 * This should work very similarly to jQuery's events, however it's based off the book version which isn't as
 * robust as jquery's, so there's probably some differences.
 *
 * @file events.js
 * @module events
 */ /**
 * Clean up the listener cache and dispatchers
 *
 * @param {Element|Object} elem
 *        Element to clean up
 *
 * @param {string} type
 *        Type of event to clean up
 */ function $86defbb4e95ebb07$var$_cleanUpEvents(elem, type) {
    if (!$86defbb4e95ebb07$var$DomData.has(elem)) return;
    const data = $86defbb4e95ebb07$var$DomData.get(elem);
    // Remove the events of a particular type if there are none left
    if (data.handlers[type].length === 0) {
        delete data.handlers[type];
        // data.handlers[type] = null;
        // Setting to null was causing an error with data.handlers
        // Remove the meta-handler from the element
        if (elem.removeEventListener) elem.removeEventListener(type, data.dispatcher, false);
        else if (elem.detachEvent) elem.detachEvent('on' + type, data.dispatcher);
    }
    // Remove the events object if there are no types left
    if (Object.getOwnPropertyNames(data.handlers).length <= 0) {
        delete data.handlers;
        delete data.dispatcher;
        delete data.disabled;
    }
    // Finally remove the element data if there is no data left
    if (Object.getOwnPropertyNames(data).length === 0) $86defbb4e95ebb07$var$DomData.delete(elem);
}
/**
 * Loops through an array of event types and calls the requested method for each type.
 *
 * @param {Function} fn
 *        The event method we want to use.
 *
 * @param {Element|Object} elem
 *        Element or object to bind listeners to
 *
 * @param {string[]} types
 *        Type of event to bind to.
 *
 * @param {Function} callback
 *        Event listener.
 */ function $86defbb4e95ebb07$var$_handleMultipleEvents(fn, elem, types, callback) {
    types.forEach(function(type) {
        // Call the event method for each one of the types
        fn(elem, type, callback);
    });
}
/**
 * Fix a native event to have standard property values
 *
 * @param {Object} event
 *        Event object to fix.
 *
 * @return {Object}
 *         Fixed event object.
 */ function $86defbb4e95ebb07$var$fixEvent(event) {
    if (event.fixed_) return event;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Test if fixing up is needed
    // Used to check if !event.stopPropagation instead of isPropagationStopped
    // But native events return true for stopPropagation, but don't have
    // other expected methods like isPropagationStopped. Seems to be a problem
    // with the Javascript Ninja code. So we're just overriding all events now.
    if (!event || !event.isPropagationStopped || !event.isImmediatePropagationStopped) {
        const old = event || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).event;
        event = {};
        // Clone the old object so that we can modify the values event = {};
        // IE8 Doesn't like when you mess with native event properties
        // Firefox returns false for event.hasOwnProperty('type') and other props
        //  which makes copying more difficult.
        // TODO: Probably best to create an allowlist of event props
        const deprecatedProps = [
            'layerX',
            'layerY',
            'keyLocation',
            'path',
            'webkitMovementX',
            'webkitMovementY',
            'mozPressure',
            'mozInputSource'
        ];
        for(const key in old){
            // Safari 6.0.3 warns you if you try to copy deprecated layerX/Y
            // Chrome warns you if you try to copy deprecated keyboardEvent.keyLocation
            // and webkitMovementX/Y
            // Lighthouse complains if Event.path is copied
            if (!deprecatedProps.includes(key)) // Chrome 32+ warns if you try to copy deprecated returnValue, but
            // we still want to if preventDefault isn't supported (IE8).
            {
                if (!(key === 'returnValue' && old.preventDefault)) event[key] = old[key];
            }
        }
        // The event occurred on this element
        if (!event.target) event.target = event.srcElement || (0, (/*@__PURE__*/$parcel$interopDefault($01r8O)));
        // Handle which other element the event is related to
        if (!event.relatedTarget) event.relatedTarget = event.fromElement === event.target ? event.toElement : event.fromElement;
        // Stop the default browser action
        event.preventDefault = function() {
            if (old.preventDefault) old.preventDefault();
            event.returnValue = false;
            old.returnValue = false;
            event.defaultPrevented = true;
        };
        event.defaultPrevented = false;
        // Stop the event from bubbling
        event.stopPropagation = function() {
            if (old.stopPropagation) old.stopPropagation();
            event.cancelBubble = true;
            old.cancelBubble = true;
            event.isPropagationStopped = returnTrue;
        };
        event.isPropagationStopped = returnFalse;
        // Stop the event from bubbling and executing other handlers
        event.stopImmediatePropagation = function() {
            if (old.stopImmediatePropagation) old.stopImmediatePropagation();
            event.isImmediatePropagationStopped = returnTrue;
            event.stopPropagation();
        };
        event.isImmediatePropagationStopped = returnFalse;
        // Handle mouse position
        if (event.clientX !== null && event.clientX !== undefined) {
            const doc = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).documentElement;
            const body = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).body;
            event.pageX = event.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
            event.pageY = event.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
        }
        // Handle key presses
        event.which = event.charCode || event.keyCode;
        // Fix button for mouse clicks:
        // 0 == left; 1 == middle; 2 == right
        if (event.button !== null && event.button !== undefined) // The following is disabled because it does not pass videojs-standard
        // and... yikes.
        /* eslint-disable */ event.button = event.button & 1 ? 0 : event.button & 4 ? 1 : event.button & 2 ? 2 : 0;
    }
    event.fixed_ = true;
    // Returns fixed-up instance
    return event;
}
/**
 * Whether passive event listeners are supported
 */ let $86defbb4e95ebb07$var$_supportsPassive;
const $86defbb4e95ebb07$var$supportsPassive = function() {
    if (typeof $86defbb4e95ebb07$var$_supportsPassive !== 'boolean') {
        $86defbb4e95ebb07$var$_supportsPassive = false;
        try {
            const opts = Object.defineProperty({}, 'passive', {
                get () {
                    $86defbb4e95ebb07$var$_supportsPassive = true;
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).addEventListener('test', null, opts);
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).removeEventListener('test', null, opts);
        } catch (e) {
        // disregard
        }
    }
    return $86defbb4e95ebb07$var$_supportsPassive;
};
/**
 * Touch events Chrome expects to be passive
 */ const $86defbb4e95ebb07$var$passiveEvents = [
    'touchstart',
    'touchmove'
];
/**
 * Add an event listener to element
 * It stores the handler function in a separate cache object
 * and adds a generic handler to the element's event,
 * along with a unique id (guid) to the element.
 *
 * @param {Element|Object} elem
 *        Element or object to bind listeners to
 *
 * @param {string|string[]} type
 *        Type of event to bind to.
 *
 * @param {Function} fn
 *        Event listener.
 */ function $86defbb4e95ebb07$var$on(elem, type, fn) {
    if (Array.isArray(type)) return $86defbb4e95ebb07$var$_handleMultipleEvents($86defbb4e95ebb07$var$on, elem, type, fn);
    if (!$86defbb4e95ebb07$var$DomData.has(elem)) $86defbb4e95ebb07$var$DomData.set(elem, {});
    const data = $86defbb4e95ebb07$var$DomData.get(elem);
    // We need a place to store all our handler data
    if (!data.handlers) data.handlers = {};
    if (!data.handlers[type]) data.handlers[type] = [];
    if (!fn.guid) fn.guid = $86defbb4e95ebb07$var$newGUID();
    data.handlers[type].push(fn);
    if (!data.dispatcher) {
        data.disabled = false;
        data.dispatcher = function(event, hash) {
            if (data.disabled) return;
            event = $86defbb4e95ebb07$var$fixEvent(event);
            const handlers = data.handlers[event.type];
            if (handlers) {
                // Copy handlers so if handlers are added/removed during the process it doesn't throw everything off.
                const handlersCopy = handlers.slice(0);
                for(let m = 0, n = handlersCopy.length; m < n; m++){
                    if (event.isImmediatePropagationStopped()) break;
                    else try {
                        handlersCopy[m].call(elem, event, hash);
                    } catch (e) {
                        $86defbb4e95ebb07$var$log$1.error(e);
                    }
                }
            }
        };
    }
    if (data.handlers[type].length === 1) {
        if (elem.addEventListener) {
            let options = false;
            if ($86defbb4e95ebb07$var$supportsPassive() && $86defbb4e95ebb07$var$passiveEvents.indexOf(type) > -1) options = {
                passive: true
            };
            elem.addEventListener(type, data.dispatcher, options);
        } else if (elem.attachEvent) elem.attachEvent('on' + type, data.dispatcher);
    }
}
/**
 * Removes event listeners from an element
 *
 * @param {Element|Object} elem
 *        Object to remove listeners from.
 *
 * @param {string|string[]} [type]
 *        Type of listener to remove. Don't include to remove all events from element.
 *
 * @param {Function} [fn]
 *        Specific listener to remove. Don't include to remove listeners for an event
 *        type.
 */ function $86defbb4e95ebb07$var$off(elem, type, fn) {
    // Don't want to add a cache object through getElData if not needed
    if (!$86defbb4e95ebb07$var$DomData.has(elem)) return;
    const data = $86defbb4e95ebb07$var$DomData.get(elem);
    // If no events exist, nothing to unbind
    if (!data.handlers) return;
    if (Array.isArray(type)) return $86defbb4e95ebb07$var$_handleMultipleEvents($86defbb4e95ebb07$var$off, elem, type, fn);
    // Utility function
    const removeType = function(el, t) {
        data.handlers[t] = [];
        $86defbb4e95ebb07$var$_cleanUpEvents(el, t);
    };
    // Are we removing all bound events?
    if (type === undefined) {
        for(const t in data.handlers)if (Object.prototype.hasOwnProperty.call(data.handlers || {}, t)) removeType(elem, t);
        return;
    }
    const handlers = data.handlers[type];
    // If no handlers exist, nothing to unbind
    if (!handlers) return;
    // If no listener was provided, remove all listeners for type
    if (!fn) {
        removeType(elem, type);
        return;
    }
    // We're only removing a single handler
    if (fn.guid) {
        for(let n = 0; n < handlers.length; n++)if (handlers[n].guid === fn.guid) handlers.splice(n--, 1);
    }
    $86defbb4e95ebb07$var$_cleanUpEvents(elem, type);
}
/**
 * Trigger an event for an element
 *
 * @param {Element|Object} elem
 *        Element to trigger an event on
 *
 * @param {EventTarget~Event|string} event
 *        A string (the type) or an event object with a type attribute
 *
 * @param {Object} [hash]
 *        data hash to pass along with the event
 *
 * @return {boolean|undefined}
 *         Returns the opposite of `defaultPrevented` if default was
 *         prevented. Otherwise, returns `undefined`
 */ function $86defbb4e95ebb07$var$trigger(elem, event, hash) {
    // Fetches element data and a reference to the parent (for bubbling).
    // Don't want to add a data object to cache for every parent,
    // so checking hasElData first.
    const elemData = $86defbb4e95ebb07$var$DomData.has(elem) ? $86defbb4e95ebb07$var$DomData.get(elem) : {};
    const parent = elem.parentNode || elem.ownerDocument;
    // type = event.type || event,
    // handler;
    // If an event name was passed as a string, creates an event out of it
    if (typeof event === 'string') event = {
        type: event,
        target: elem
    };
    else if (!event.target) event.target = elem;
    // Normalizes the event properties.
    event = $86defbb4e95ebb07$var$fixEvent(event);
    // If the passed element has a dispatcher, executes the established handlers.
    if (elemData.dispatcher) elemData.dispatcher.call(elem, event, hash);
    // Unless explicitly stopped or the event does not bubble (e.g. media events)
    // recursively calls this function to bubble the event up the DOM.
    if (parent && !event.isPropagationStopped() && event.bubbles === true) $86defbb4e95ebb07$var$trigger.call(null, parent, event, hash);
    else if (!parent && !event.defaultPrevented && event.target && event.target[event.type]) {
        if (!$86defbb4e95ebb07$var$DomData.has(event.target)) $86defbb4e95ebb07$var$DomData.set(event.target, {});
        const targetData = $86defbb4e95ebb07$var$DomData.get(event.target);
        // Checks if the target has a default action for this event.
        if (event.target[event.type]) {
            // Temporarily disables event dispatching on the target as we have already executed the handler.
            targetData.disabled = true;
            // Executes the default action.
            if (typeof event.target[event.type] === 'function') event.target[event.type]();
            // Re-enables event dispatching.
            targetData.disabled = false;
        }
    }
    // Inform the triggerer if the default was prevented by returning false
    return !event.defaultPrevented;
}
/**
 * Trigger a listener only once for an event.
 *
 * @param {Element|Object} elem
 *        Element or object to bind to.
 *
 * @param {string|string[]} type
 *        Name/type of event
 *
 * @param {Event~EventListener} fn
 *        Event listener function
 */ function $86defbb4e95ebb07$var$one(elem, type, fn) {
    if (Array.isArray(type)) return $86defbb4e95ebb07$var$_handleMultipleEvents($86defbb4e95ebb07$var$one, elem, type, fn);
    const func = function() {
        $86defbb4e95ebb07$var$off(elem, type, func);
        fn.apply(this, arguments);
    };
    // copy the guid to the new function so it can removed using the original function's ID
    func.guid = fn.guid = fn.guid || $86defbb4e95ebb07$var$newGUID();
    $86defbb4e95ebb07$var$on(elem, type, func);
}
/**
 * Trigger a listener only once and then turn if off for all
 * configured events
 *
 * @param {Element|Object} elem
 *        Element or object to bind to.
 *
 * @param {string|string[]} type
 *        Name/type of event
 *
 * @param {Event~EventListener} fn
 *        Event listener function
 */ function $86defbb4e95ebb07$var$any(elem, type, fn) {
    const func = function() {
        $86defbb4e95ebb07$var$off(elem, type, func);
        fn.apply(this, arguments);
    };
    // copy the guid to the new function so it can removed using the original function's ID
    func.guid = fn.guid = fn.guid || $86defbb4e95ebb07$var$newGUID();
    // multiple ons, but one off for everything
    $86defbb4e95ebb07$var$on(elem, type, func);
}
var $86defbb4e95ebb07$var$Events = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    fixEvent: $86defbb4e95ebb07$var$fixEvent,
    on: $86defbb4e95ebb07$var$on,
    off: $86defbb4e95ebb07$var$off,
    trigger: $86defbb4e95ebb07$var$trigger,
    one: $86defbb4e95ebb07$var$one,
    any: $86defbb4e95ebb07$var$any
});
/**
 * @file fn.js
 * @module fn
 */ const $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL = 30;
/**
 * A private, internal-only function for changing the context of a function.
 *
 * It also stores a unique id on the function so it can be easily removed from
 * events.
 *
 * @private
 * @function
 * @param    {*} context
 *           The object to bind as scope.
 *
 * @param    {Function} fn
 *           The function to be bound to a scope.
 *
 * @param    {number} [uid]
 *           An optional unique ID for the function to be set
 *
 * @return   {Function}
 *           The new function that will be bound into the context given
 */ const $86defbb4e95ebb07$var$bind_ = function(context, fn, uid) {
    // Make sure the function has a unique ID
    if (!fn.guid) fn.guid = $86defbb4e95ebb07$var$newGUID();
    // Create the new function that changes the context
    const bound = fn.bind(context);
    // Allow for the ability to individualize this function
    // Needed in the case where multiple objects might share the same prototype
    // IF both items add an event listener with the same function, then you try to remove just one
    // it will remove both because they both have the same guid.
    // when using this, you need to use the bind method when you remove the listener as well.
    // currently used in text tracks
    bound.guid = uid ? uid + '_' + fn.guid : fn.guid;
    return bound;
};
/**
 * Wraps the given function, `fn`, with a new function that only invokes `fn`
 * at most once per every `wait` milliseconds.
 *
 * @function
 * @param    {Function} fn
 *           The function to be throttled.
 *
 * @param    {number}   wait
 *           The number of milliseconds by which to throttle.
 *
 * @return   {Function}
 */ const $86defbb4e95ebb07$var$throttle = function(fn, wait) {
    let last = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).performance.now();
    const throttled = function(...args) {
        const now = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).performance.now();
        if (now - last >= wait) {
            fn(...args);
            last = now;
        }
    };
    return throttled;
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked.
 *
 * Inspired by lodash and underscore implementations.
 *
 * @function
 * @param    {Function} func
 *           The function to wrap with debounce behavior.
 *
 * @param    {number} wait
 *           The number of milliseconds to wait after the last invocation.
 *
 * @param    {boolean} [immediate]
 *           Whether or not to invoke the function immediately upon creation.
 *
 * @param    {Object} [context=window]
 *           The "context" in which the debounced function should debounce. For
 *           example, if this function should be tied to a Video.js player,
 *           the player can be passed here. Alternatively, defaults to the
 *           global `window` object.
 *
 * @return   {Function}
 *           A debounced function.
 */ const $86defbb4e95ebb07$var$debounce$1 = function(func, wait, immediate, context = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi)))) {
    let timeout;
    const cancel = ()=>{
        context.clearTimeout(timeout);
        timeout = null;
    };
    /* eslint-disable consistent-this */ const debounced = function() {
        const self1 = this;
        const args = arguments;
        let later = function() {
            timeout = null;
            later = null;
            if (!immediate) func.apply(self1, args);
        };
        if (!timeout && immediate) func.apply(self1, args);
        context.clearTimeout(timeout);
        timeout = context.setTimeout(later, wait);
    };
    /* eslint-enable consistent-this */ debounced.cancel = cancel;
    return debounced;
};
var $86defbb4e95ebb07$var$Fn = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    UPDATE_REFRESH_INTERVAL: $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL,
    bind_: $86defbb4e95ebb07$var$bind_,
    throttle: $86defbb4e95ebb07$var$throttle,
    debounce: $86defbb4e95ebb07$var$debounce$1
});
/**
 * @file src/js/event-target.js
 */ let $86defbb4e95ebb07$var$EVENT_MAP;
/**
 * `EventTarget` is a class that can have the same API as the DOM `EventTarget`. It
 * adds shorthand functions that wrap around lengthy functions. For example:
 * the `on` function is a wrapper around `addEventListener`.
 *
 * @see [EventTarget Spec]{@link https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget}
 * @class EventTarget
 */ class $86defbb4e95ebb07$var$EventTarget$2 {
    /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */ on(type, fn) {
        // Remove the addEventListener alias before calling Events.on
        // so we don't get into an infinite type loop
        const ael = this.addEventListener;
        this.addEventListener = ()=>{};
        $86defbb4e95ebb07$var$on(this, type, fn);
        this.addEventListener = ael;
    }
    /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to remove.
   */ off(type, fn) {
        $86defbb4e95ebb07$var$off(this, type, fn);
    }
    /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */ one(type, fn) {
        // Remove the addEventListener aliasing Events.on
        // so we don't get into an infinite type loop
        const ael = this.addEventListener;
        this.addEventListener = ()=>{};
        $86defbb4e95ebb07$var$one(this, type, fn);
        this.addEventListener = ael;
    }
    /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */ any(type, fn) {
        // Remove the addEventListener aliasing Events.on
        // so we don't get into an infinite type loop
        const ael = this.addEventListener;
        this.addEventListener = ()=>{};
        $86defbb4e95ebb07$var$any(this, type, fn);
        this.addEventListener = ael;
    }
    /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|EventTarget~Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   */ trigger(event) {
        const type = event.type || event;
        // deprecation
        // In a future version we should default target to `this`
        // similar to how we default the target to `elem` in
        // `Events.trigger`. Right now the default `target` will be
        // `document` due to the `Event.fixEvent` call.
        if (typeof event === 'string') event = {
            type: type
        };
        event = $86defbb4e95ebb07$var$fixEvent(event);
        if (this.allowedEvents_[type] && this['on' + type]) this['on' + type](event);
        $86defbb4e95ebb07$var$trigger(this, event);
    }
    queueTrigger(event) {
        // only set up EVENT_MAP if it'll be used
        if (!$86defbb4e95ebb07$var$EVENT_MAP) $86defbb4e95ebb07$var$EVENT_MAP = new Map();
        const type = event.type || event;
        let map = $86defbb4e95ebb07$var$EVENT_MAP.get(this);
        if (!map) {
            map = new Map();
            $86defbb4e95ebb07$var$EVENT_MAP.set(this, map);
        }
        const oldTimeout = map.get(type);
        map.delete(type);
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(oldTimeout);
        const timeout = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>{
            map.delete(type);
            // if we cleared out all timeouts for the current target, delete its map
            if (map.size === 0) {
                map = null;
                $86defbb4e95ebb07$var$EVENT_MAP.delete(this);
            }
            this.trigger(event);
        }, 0);
        map.set(type, timeout);
    }
}
/**
 * A Custom DOM event.
 *
 * @typedef {CustomEvent} Event
 * @see [Properties]{@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
 */ /**
 * All event listeners should follow the following format.
 *
 * @callback EventListener
 * @this {EventTarget}
 *
 * @param {Event} event
 *        the event that triggered this function
 *
 * @param {Object} [hash]
 *        hash of data sent during the event
 */ /**
 * An object containing event names as keys and booleans as values.
 *
 * > NOTE: If an event name is set to a true value here {@link EventTarget#trigger}
 *         will have extra functionality. See that function for more information.
 *
 * @property EventTarget.prototype.allowedEvents_
 * @protected
 */ $86defbb4e95ebb07$var$EventTarget$2.prototype.allowedEvents_ = {};
/**
 * An alias of {@link EventTarget#on}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#on}
 */ $86defbb4e95ebb07$var$EventTarget$2.prototype.addEventListener = $86defbb4e95ebb07$var$EventTarget$2.prototype.on;
/**
 * An alias of {@link EventTarget#off}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#off}
 */ $86defbb4e95ebb07$var$EventTarget$2.prototype.removeEventListener = $86defbb4e95ebb07$var$EventTarget$2.prototype.off;
/**
 * An alias of {@link EventTarget#trigger}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#trigger}
 */ $86defbb4e95ebb07$var$EventTarget$2.prototype.dispatchEvent = $86defbb4e95ebb07$var$EventTarget$2.prototype.trigger;
/**
 * @file mixins/evented.js
 * @module evented
 */ const $86defbb4e95ebb07$var$objName = (obj)=>{
    if (typeof obj.name === 'function') return obj.name();
    if (typeof obj.name === 'string') return obj.name;
    if (obj.name_) return obj.name_;
    if (obj.constructor && obj.constructor.name) return obj.constructor.name;
    return typeof obj;
};
/**
 * Returns whether or not an object has had the evented mixin applied.
 *
 * @param  {Object} object
 *         An object to test.
 *
 * @return {boolean}
 *         Whether or not the object appears to be evented.
 */ const $86defbb4e95ebb07$var$isEvented = (object)=>object instanceof $86defbb4e95ebb07$var$EventTarget$2 || !!object.eventBusEl_ && [
        'on',
        'one',
        'off',
        'trigger'
    ].every((k)=>typeof object[k] === 'function');
/**
 * Adds a callback to run after the evented mixin applied.
 *
 * @param  {Object} target
 *         An object to Add
 * @param  {Function} callback
 *         The callback to run.
 */ const $86defbb4e95ebb07$var$addEventedCallback = (target, callback)=>{
    if ($86defbb4e95ebb07$var$isEvented(target)) callback();
    else {
        if (!target.eventedCallbacks) target.eventedCallbacks = [];
        target.eventedCallbacks.push(callback);
    }
};
/**
 * Whether a value is a valid event type - non-empty string or array.
 *
 * @private
 * @param  {string|Array} type
 *         The type value to test.
 *
 * @return {boolean}
 *         Whether or not the type is a valid event type.
 */ const $86defbb4e95ebb07$var$isValidEventType = (type)=>// The regex here verifies that the `type` contains at least one non-
    // whitespace character.
    typeof type === 'string' && /\S/.test(type) || Array.isArray(type) && !!type.length;
/**
 * Validates a value to determine if it is a valid event target. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the target does not appear to be a valid event target.
 *
 * @param  {Object} target
 *         The object to test.
 *
 * @param  {Object} obj
 *         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */ const $86defbb4e95ebb07$var$validateTarget = (target, obj, fnName)=>{
    if (!target || !target.nodeName && !$86defbb4e95ebb07$var$isEvented(target)) throw new Error(`Invalid target for ${$86defbb4e95ebb07$var$objName(obj)}#${fnName}; must be a DOM node or evented object.`);
};
/**
 * Validates a value to determine if it is a valid event target. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the type does not appear to be a valid event type.
 *
 * @param  {string|Array} type
 *         The type to test.
 *
 * @param  {Object} obj
*         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */ const $86defbb4e95ebb07$var$validateEventType = (type, obj, fnName)=>{
    if (!$86defbb4e95ebb07$var$isValidEventType(type)) throw new Error(`Invalid event type for ${$86defbb4e95ebb07$var$objName(obj)}#${fnName}; must be a non-empty string or array.`);
};
/**
 * Validates a value to determine if it is a valid listener. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the listener is not a function.
 *
 * @param  {Function} listener
 *         The listener to test.
 *
 * @param  {Object} obj
 *         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */ const $86defbb4e95ebb07$var$validateListener = (listener, obj, fnName)=>{
    if (typeof listener !== 'function') throw new Error(`Invalid listener for ${$86defbb4e95ebb07$var$objName(obj)}#${fnName}; must be a function.`);
};
/**
 * Takes an array of arguments given to `on()` or `one()`, validates them, and
 * normalizes them into an object.
 *
 * @private
 * @param  {Object} self
 *         The evented object on which `on()` or `one()` was called. This
 *         object will be bound as the `this` value for the listener.
 *
 * @param  {Array} args
 *         An array of arguments passed to `on()` or `one()`.
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 *
 * @return {Object}
 *         An object containing useful values for `on()` or `one()` calls.
 */ const $86defbb4e95ebb07$var$normalizeListenArgs = (self1, args, fnName)=>{
    // If the number of arguments is less than 3, the target is always the
    // evented object itself.
    const isTargetingSelf = args.length < 3 || args[0] === self1 || args[0] === self1.eventBusEl_;
    let target;
    let type;
    let listener;
    if (isTargetingSelf) {
        target = self1.eventBusEl_;
        // Deal with cases where we got 3 arguments, but we are still listening to
        // the evented object itself.
        if (args.length >= 3) args.shift();
        [type, listener] = args;
    } else {
        // This was `[target, type, listener] = args;` but this block needs more than
        // one statement to produce minified output compatible with Chrome 53.
        // See https://github.com/videojs/video.js/pull/8810
        target = args[0];
        type = args[1];
        listener = args[2];
    }
    $86defbb4e95ebb07$var$validateTarget(target, self1, fnName);
    $86defbb4e95ebb07$var$validateEventType(type, self1, fnName);
    $86defbb4e95ebb07$var$validateListener(listener, self1, fnName);
    listener = $86defbb4e95ebb07$var$bind_(self1, listener);
    return {
        isTargetingSelf: isTargetingSelf,
        target: target,
        type: type,
        listener: listener
    };
};
/**
 * Adds the listener to the event type(s) on the target, normalizing for
 * the type of target.
 *
 * @private
 * @param  {Element|Object} target
 *         A DOM node or evented object.
 *
 * @param  {string} method
 *         The event binding method to use ("on" or "one").
 *
 * @param  {string|Array} type
 *         One or more event type(s).
 *
 * @param  {Function} listener
 *         A listener function.
 */ const $86defbb4e95ebb07$var$listen = (target, method, type, listener)=>{
    $86defbb4e95ebb07$var$validateTarget(target, target, method);
    if (target.nodeName) $86defbb4e95ebb07$var$Events[method](target, type, listener);
    else target[method](type, listener);
};
/**
 * Contains methods that provide event capabilities to an object which is passed
 * to {@link module:evented|evented}.
 *
 * @mixin EventedMixin
 */ const $86defbb4e95ebb07$var$EventedMixin = {
    /**
   * Add a listener to an event (or events) on this object or another evented
   * object.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */ on (...args) {
        const { isTargetingSelf: isTargetingSelf, target: target, type: type, listener: listener } = $86defbb4e95ebb07$var$normalizeListenArgs(this, args, 'on');
        $86defbb4e95ebb07$var$listen(target, 'on', type, listener);
        // If this object is listening to another evented object.
        if (!isTargetingSelf) {
            // If this object is disposed, remove the listener.
            const removeListenerOnDispose = ()=>this.off(target, type, listener);
            // Use the same function ID as the listener so we can remove it later it
            // using the ID of the original listener.
            removeListenerOnDispose.guid = listener.guid;
            // Add a listener to the target's dispose event as well. This ensures
            // that if the target is disposed BEFORE this object, we remove the
            // removal listener that was just added. Otherwise, we create a memory leak.
            const removeRemoverOnTargetDispose = ()=>this.off('dispose', removeListenerOnDispose);
            // Use the same function ID as the listener so we can remove it later
            // it using the ID of the original listener.
            removeRemoverOnTargetDispose.guid = listener.guid;
            $86defbb4e95ebb07$var$listen(this, 'on', 'dispose', removeListenerOnDispose);
            $86defbb4e95ebb07$var$listen(target, 'on', 'dispose', removeRemoverOnTargetDispose);
        }
    },
    /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will be called once per event and then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */ one (...args) {
        const { isTargetingSelf: isTargetingSelf, target: target, type: type, listener: listener } = $86defbb4e95ebb07$var$normalizeListenArgs(this, args, 'one');
        // Targeting this evented object.
        if (isTargetingSelf) $86defbb4e95ebb07$var$listen(target, 'one', type, listener);
        else {
            // TODO: This wrapper is incorrect! It should only
            //       remove the wrapper for the event type that called it.
            //       Instead all listeners are removed on the first trigger!
            //       see https://github.com/videojs/video.js/issues/5962
            const wrapper = (...largs)=>{
                this.off(target, type, wrapper);
                listener.apply(null, largs);
            };
            // Use the same function ID as the listener so we can remove it later
            // it using the ID of the original listener.
            wrapper.guid = listener.guid;
            $86defbb4e95ebb07$var$listen(target, 'one', type, wrapper);
        }
    },
    /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will only be called once for the first event that is triggered
   * then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */ any (...args) {
        const { isTargetingSelf: isTargetingSelf, target: target, type: type, listener: listener } = $86defbb4e95ebb07$var$normalizeListenArgs(this, args, 'any');
        // Targeting this evented object.
        if (isTargetingSelf) $86defbb4e95ebb07$var$listen(target, 'any', type, listener);
        else {
            const wrapper = (...largs)=>{
                this.off(target, type, wrapper);
                listener.apply(null, largs);
            };
            // Use the same function ID as the listener so we can remove it later
            // it using the ID of the original listener.
            wrapper.guid = listener.guid;
            $86defbb4e95ebb07$var$listen(target, 'any', type, wrapper);
        }
    },
    /**
   * Removes listener(s) from event(s) on an evented object.
   *
   * @param  {string|Array|Element|Object} [targetOrType]
   *         If this is a string or array, it represents the event type(s).
   *
   *         Another evented object can be passed here instead, in which case
   *         ALL 3 arguments are _required_.
   *
   * @param  {string|Array|Function} [typeOrListener]
   *         If the first argument was a string or array, this may be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function; otherwise, _all_ listeners bound to the
   *         event type(s) will be removed.
   */ off (targetOrType, typeOrListener, listener) {
        // Targeting this evented object.
        if (!targetOrType || $86defbb4e95ebb07$var$isValidEventType(targetOrType)) $86defbb4e95ebb07$var$off(this.eventBusEl_, targetOrType, typeOrListener);
        else {
            const target = targetOrType;
            const type = typeOrListener;
            // Fail fast and in a meaningful way!
            $86defbb4e95ebb07$var$validateTarget(target, this, 'off');
            $86defbb4e95ebb07$var$validateEventType(type, this, 'off');
            $86defbb4e95ebb07$var$validateListener(listener, this, 'off');
            // Ensure there's at least a guid, even if the function hasn't been used
            listener = $86defbb4e95ebb07$var$bind_(this, listener);
            // Remove the dispose listener on this evented object, which was given
            // the same guid as the event listener in on().
            this.off('dispose', listener);
            if (target.nodeName) {
                $86defbb4e95ebb07$var$off(target, type, listener);
                $86defbb4e95ebb07$var$off(target, 'dispose', listener);
            } else if ($86defbb4e95ebb07$var$isEvented(target)) {
                target.off(type, listener);
                target.off('dispose', listener);
            }
        }
    },
    /**
   * Fire an event on this evented object, causing its listeners to be called.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash]
   *          An additional object to pass along to listeners.
   *
   * @return {boolean}
   *          Whether or not the default behavior was prevented.
   */ trigger (event, hash) {
        $86defbb4e95ebb07$var$validateTarget(this.eventBusEl_, this, 'trigger');
        const type = event && typeof event !== 'string' ? event.type : event;
        if (!$86defbb4e95ebb07$var$isValidEventType(type)) throw new Error(`Invalid event type for ${$86defbb4e95ebb07$var$objName(this)}#trigger; ` + 'must be a non-empty string or object with a type key that has a non-empty value.');
        return $86defbb4e95ebb07$var$trigger(this.eventBusEl_, event, hash);
    }
};
/**
 * Applies {@link module:evented~EventedMixin|EventedMixin} to a target object.
 *
 * @param  {Object} target
 *         The object to which to add event methods.
 *
 * @param  {Object} [options={}]
 *         Options for customizing the mixin behavior.
 *
 * @param  {string} [options.eventBusKey]
 *         By default, adds a `eventBusEl_` DOM element to the target object,
 *         which is used as an event bus. If the target object already has a
 *         DOM element that should be used, pass its key here.
 *
 * @return {Object}
 *         The target object.
 */ function $86defbb4e95ebb07$var$evented(target, options = {}) {
    const { eventBusKey: eventBusKey } = options;
    // Set or create the eventBusEl_.
    if (eventBusKey) {
        if (!target[eventBusKey].nodeName) throw new Error(`The eventBusKey "${eventBusKey}" does not refer to an element.`);
        target.eventBusEl_ = target[eventBusKey];
    } else target.eventBusEl_ = $86defbb4e95ebb07$var$createEl('span', {
        className: 'vjs-event-bus'
    });
    Object.assign(target, $86defbb4e95ebb07$var$EventedMixin);
    if (target.eventedCallbacks) target.eventedCallbacks.forEach((callback)=>{
        callback();
    });
    // When any evented object is disposed, it removes all its listeners.
    target.on('dispose', ()=>{
        target.off();
        [
            target,
            target.el_,
            target.eventBusEl_
        ].forEach(function(val) {
            if (val && $86defbb4e95ebb07$var$DomData.has(val)) $86defbb4e95ebb07$var$DomData.delete(val);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>{
            target.eventBusEl_ = null;
        }, 0);
    });
    return target;
}
/**
 * @file mixins/stateful.js
 * @module stateful
 */ /**
 * Contains methods that provide statefulness to an object which is passed
 * to {@link module:stateful}.
 *
 * @mixin StatefulMixin
 */ const $86defbb4e95ebb07$var$StatefulMixin = {
    /**
   * A hash containing arbitrary keys and values representing the state of
   * the object.
   *
   * @type {Object}
   */ state: {},
    /**
   * Set the state of an object by mutating its
   * {@link module:stateful~StatefulMixin.state|state} object in place.
   *
   * @fires   module:stateful~StatefulMixin#statechanged
   * @param   {Object|Function} stateUpdates
   *          A new set of properties to shallow-merge into the plugin state.
   *          Can be a plain object or a function returning a plain object.
   *
   * @return {Object|undefined}
   *          An object containing changes that occurred. If no changes
   *          occurred, returns `undefined`.
   */ setState (stateUpdates) {
        // Support providing the `stateUpdates` state as a function.
        if (typeof stateUpdates === 'function') stateUpdates = stateUpdates();
        let changes;
        $86defbb4e95ebb07$var$each(stateUpdates, (value, key)=>{
            // Record the change if the value is different from what's in the
            // current state.
            if (this.state[key] !== value) {
                changes = changes || {};
                changes[key] = {
                    from: this.state[key],
                    to: value
                };
            }
            this.state[key] = value;
        });
        // Only trigger "statechange" if there were changes AND we have a trigger
        // function. This allows us to not require that the target object be an
        // evented object.
        if (changes && $86defbb4e95ebb07$var$isEvented(this)) /**
       * An event triggered on an object that is both
       * {@link module:stateful|stateful} and {@link module:evented|evented}
       * indicating that its state has changed.
       *
       * @event    module:stateful~StatefulMixin#statechanged
       * @type     {Object}
       * @property {Object} changes
       *           A hash containing the properties that were changed and
       *           the values they were changed `from` and `to`.
       */ this.trigger({
            changes: changes,
            type: 'statechanged'
        });
        return changes;
    }
};
/**
 * Applies {@link module:stateful~StatefulMixin|StatefulMixin} to a target
 * object.
 *
 * If the target object is {@link module:evented|evented} and has a
 * `handleStateChanged` method, that method will be automatically bound to the
 * `statechanged` event on itself.
 *
 * @param   {Object} target
 *          The object to be made stateful.
 *
 * @param   {Object} [defaultState]
 *          A default set of properties to populate the newly-stateful object's
 *          `state` property.
 *
 * @return {Object}
 *          Returns the `target`.
 */ function $86defbb4e95ebb07$var$stateful(target, defaultState) {
    Object.assign(target, $86defbb4e95ebb07$var$StatefulMixin);
    // This happens after the mixing-in because we need to replace the `state`
    // added in that step.
    target.state = Object.assign({}, target.state, defaultState);
    // Auto-bind the `handleStateChanged` method of the target object if it exists.
    if (typeof target.handleStateChanged === 'function' && $86defbb4e95ebb07$var$isEvented(target)) target.on('statechanged', target.handleStateChanged);
    return target;
}
/**
 * @file str.js
 * @module to-lower-case
 */ /**
 * Lowercase the first letter of a string.
 *
 * @param {string} string
 *        String to be lowercased
 *
 * @return {string}
 *         The string with a lowercased first letter
 */ const $86defbb4e95ebb07$var$toLowerCase = function(string) {
    if (typeof string !== 'string') return string;
    return string.replace(/./, (w)=>w.toLowerCase());
};
/**
 * Uppercase the first letter of a string.
 *
 * @param {string} string
 *        String to be uppercased
 *
 * @return {string}
 *         The string with an uppercased first letter
 */ const $86defbb4e95ebb07$var$toTitleCase$1 = function(string) {
    if (typeof string !== 'string') return string;
    return string.replace(/./, (w)=>w.toUpperCase());
};
/**
 * Compares the TitleCase versions of the two strings for equality.
 *
 * @param {string} str1
 *        The first string to compare
 *
 * @param {string} str2
 *        The second string to compare
 *
 * @return {boolean}
 *         Whether the TitleCase versions of the strings are equal
 */ const $86defbb4e95ebb07$var$titleCaseEquals = function(str1, str2) {
    return $86defbb4e95ebb07$var$toTitleCase$1(str1) === $86defbb4e95ebb07$var$toTitleCase$1(str2);
};
var $86defbb4e95ebb07$var$Str = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    toLowerCase: $86defbb4e95ebb07$var$toLowerCase,
    toTitleCase: $86defbb4e95ebb07$var$toTitleCase$1,
    titleCaseEquals: $86defbb4e95ebb07$var$titleCaseEquals
});
/**
 * Player Component - Base class for all UI objects
 *
 * @file component.js
 */ /** @import Player from './player' */ /**
 * A callback to be called if and when the component is ready.
 * `this` will be the Component instance.
 *
 * @callback ReadyCallback
 * @returns  {void}
 */ /**
 * Base class for all UI Components.
 * Components are UI objects which represent both a javascript object and an element
 * in the DOM. They can be children of other components, and can have
 * children themselves.
 *
 * Components can also use methods from {@link EventTarget}
 */ class $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of component options.
   *
   * @param {Object[]} [options.children]
   *        An array of children objects to initialize this component with. Children objects have
   *        a name property that will be used if more than one component of the same type needs to be
   *        added.
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   * @param {ReadyCallback} [ready]
   *        Function that gets called when the `Component` is ready.
   */ constructor(player, options, ready){
        // The component might be the player itself and we can't pass `this` to super
        if (!player && this.play) this.player_ = player = this; // eslint-disable-line
        else this.player_ = player;
        this.isDisposed_ = false;
        // Hold the reference to the parent component via `addChild` method
        this.parentComponent_ = null;
        // Make a copy of prototype.options_ to protect against overriding defaults
        this.options_ = $86defbb4e95ebb07$var$merge$1({}, this.options_);
        // Updated options with supplied options
        options = this.options_ = $86defbb4e95ebb07$var$merge$1(this.options_, options);
        // Get ID from options or options element if one is supplied
        this.id_ = options.id || options.el && options.el.id;
        // If there was no ID from the options, generate one
        if (!this.id_) {
            // Don't require the player ID function in the case of mock players
            const id = player && player.id && player.id() || 'no_player';
            this.id_ = `${id}_component_${$86defbb4e95ebb07$var$newGUID()}`;
        }
        this.name_ = options.name || null;
        // Create element if one wasn't provided in options
        if (options.el) this.el_ = options.el;
        else if (options.createEl !== false) this.el_ = this.createEl();
        if (options.className && this.el_) options.className.split(' ').forEach((c)=>this.addClass(c));
        // Remove the placeholder event methods. If the component is evented, the
        // real methods are added next
        [
            'on',
            'off',
            'one',
            'any',
            'trigger'
        ].forEach((fn)=>{
            this[fn] = undefined;
        });
        // if evented is anything except false, we want to mixin in evented
        if (options.evented !== false) {
            // Make this an evented object and use `el_`, if available, as its event bus
            $86defbb4e95ebb07$var$evented(this, {
                eventBusKey: this.el_ ? 'el_' : null
            });
            this.handleLanguagechange = this.handleLanguagechange.bind(this);
            this.on(this.player_, 'languagechange', this.handleLanguagechange);
        }
        $86defbb4e95ebb07$var$stateful(this, this.constructor.defaultState);
        this.children_ = [];
        this.childIndex_ = {};
        this.childNameIndex_ = {};
        this.setTimeoutIds_ = new Set();
        this.setIntervalIds_ = new Set();
        this.rafIds_ = new Set();
        this.namedRafs_ = new Map();
        this.clearingTimersOnDispose_ = false;
        // Add any child components in options
        if (options.initChildren !== false) this.initChildren();
        // Don't want to trigger ready here or it will go before init is actually
        // finished for all children that run this constructor
        this.ready(ready);
        if (options.reportTouchActivity !== false) this.enableTouchActivity();
    }
    // `on`, `off`, `one`, `any` and `trigger` are here so tsc includes them in definitions.
    // They are replaced or removed in the constructor
    /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */ /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} [fn]
   *        The function to remove. If not specified, all listeners managed by Video.js will be removed.
   */ /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */ /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */ /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * @param {Object} [hash]
   *        Optionally extra argument to pass through to an event listener
   */ /**
   * Dispose of the `Component` and all child components.
   *
   * @fires Component#dispose
   *
   * @param {Object} options
   * @param {Element} options.originalEl element with which to replace player element
   */ dispose(options = {}) {
        // Bail out if the component has already been disposed.
        if (this.isDisposed_) return;
        if (this.readyQueue_) this.readyQueue_.length = 0;
        /**
     * Triggered when a `Component` is disposed.
     *
     * @event Component#dispose
     * @type {Event}
     *
     * @property {boolean} [bubbles=false]
     *           set to false so that the dispose event does not
     *           bubble up
     */ this.trigger({
            type: 'dispose',
            bubbles: false
        });
        this.isDisposed_ = true;
        // Dispose all children.
        if (this.children_) {
            for(let i = this.children_.length - 1; i >= 0; i--)if (this.children_[i].dispose) this.children_[i].dispose();
        }
        // Delete child references
        this.children_ = null;
        this.childIndex_ = null;
        this.childNameIndex_ = null;
        this.parentComponent_ = null;
        if (this.el_) {
            // Remove element from DOM
            if (this.el_.parentNode) {
                if (options.restoreEl) this.el_.parentNode.replaceChild(options.restoreEl, this.el_);
                else this.el_.parentNode.removeChild(this.el_);
            }
            this.el_ = null;
        }
        // remove reference to the player after disposing of the element
        this.player_ = null;
    }
    /**
   * Determine whether or not this component has been disposed.
   *
   * @return {boolean}
   *         If the component has been disposed, will be `true`. Otherwise, `false`.
   */ isDisposed() {
        return Boolean(this.isDisposed_);
    }
    /**
   * Return the {@link Player} that the `Component` has attached to.
   *
   * @return {Player}
   *         The player that this `Component` has attached to.
   */ player() {
        return this.player_;
    }
    /**
   * Deep merge of options objects with new options.
   * > Note: When both `obj` and `options` contain properties whose values are objects.
   *         The two properties get merged using {@link module:obj.merge}
   *
   * @param {Object} obj
   *        The object that contains new options.
   *
   * @return {Object}
   *         A new object of `this.options_` and `obj` merged together.
   */ options(obj) {
        if (!obj) return this.options_;
        this.options_ = $86defbb4e95ebb07$var$merge$1(this.options_, obj);
        return this.options_;
    }
    /**
   * Get the `Component`s DOM element
   *
   * @return {Element}
   *         The DOM element for this `Component`.
   */ el() {
        return this.el_;
    }
    /**
   * Create the `Component`s DOM element.
   *
   * @param {string} [tagName]
   *        Element's DOM node type. e.g. 'div'
   *
   * @param {Object} [properties]
   *        An object of properties that should be set.
   *
   * @param {Object} [attributes]
   *        An object of attributes that should be set.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(tagName, properties, attributes) {
        return $86defbb4e95ebb07$var$createEl(tagName, properties, attributes);
    }
    /**
   * Localize a string given the string in english.
   *
   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
   *
   * If a `defaultValue` is provided, it'll use that over `string`,
   * if a value isn't found in provided language files.
   * This is useful if you want to have a descriptive key for token replacement
   * but have a succinct localized string and not require `en.json` to be included.
   *
   * Currently, it is used for the progress bar timing.
   * ```js
   * {
   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
   * }
   * ```
   * It is then used like so:
   * ```js
   * this.localize('progress bar timing: currentTime={1} duration{2}',
   *               [this.player_.currentTime(), this.player_.duration()],
   *               '{1} of {2}');
   * ```
   *
   * Which outputs something like: `01:23 of 24:56`.
   *
   *
   * @param {string} string
   *        The string to localize and the key to lookup in the language files.
   * @param {string[]} [tokens]
   *        If the current item has token replacements, provide the tokens here.
   * @param {string} [defaultValue]
   *        Defaults to `string`. Can be a default value to use for token replacement
   *        if the lookup key is needed to be separate.
   *
   * @return {string}
   *         The localized string or if no localization exists the english string.
   */ localize(string, tokens, defaultValue = string) {
        const code = this.player_.language && this.player_.language();
        const languages = this.player_.languages && this.player_.languages();
        const language = languages && languages[code];
        const primaryCode = code && code.split('-')[0];
        const primaryLang = languages && languages[primaryCode];
        let localizedString = defaultValue;
        if (language && language[string]) localizedString = language[string];
        else if (primaryLang && primaryLang[string]) localizedString = primaryLang[string];
        if (tokens) localizedString = localizedString.replace(/\{(\d+)\}/g, function(match, index) {
            const value = tokens[index - 1];
            let ret = value;
            if (typeof value === 'undefined') ret = match;
            return ret;
        });
        return localizedString;
    }
    /**
   * Handles language change for the player in components. Should be overridden by sub-components.
   *
   * @abstract
   */ handleLanguagechange() {}
    /**
   * Return the `Component`s DOM element. This is where children get inserted.
   * This will usually be the the same as the element returned in {@link Component#el}.
   *
   * @return {Element}
   *         The content element for this `Component`.
   */ contentEl() {
        return this.contentEl_ || this.el_;
    }
    /**
   * Get this `Component`s ID
   *
   * @return {string}
   *         The id of this `Component`
   */ id() {
        return this.id_;
    }
    /**
   * Get the `Component`s name. The name gets used to reference the `Component`
   * and is set during registration.
   *
   * @return {string}
   *         The name of this `Component`.
   */ name() {
        return this.name_;
    }
    /**
   * Get an array of all child components
   *
   * @return {Array}
   *         The children
   */ children() {
        return this.children_;
    }
    /**
   * Returns the child `Component` with the given `id`.
   *
   * @param {string} id
   *        The id of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `id` or undefined.
   */ getChildById(id) {
        return this.childIndex_[id];
    }
    /**
   * Returns the child `Component` with the given `name`.
   *
   * @param {string} name
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `name` or undefined.
   */ getChild(name) {
        if (!name) return;
        return this.childNameIndex_[name];
    }
    /**
   * Returns the descendant `Component` following the givent
   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
   * try to get 'foo' on the current component, 'bar' on the 'foo'
   * component and 'baz' on the 'bar' component and return undefined
   * if any of those don't exist.
   *
   * @param {...string[]|...string} names
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The descendant `Component` following the given descendant
   *         `names` or undefined.
   */ getDescendant(...names) {
        // flatten array argument into the main array
        names = names.reduce((acc, n)=>acc.concat(n), []);
        let currentChild = this;
        for(let i = 0; i < names.length; i++){
            currentChild = currentChild.getChild(names[i]);
            if (!currentChild || !currentChild.getChild) return;
        }
        return currentChild;
    }
    /**
   * Adds an SVG icon element to another element or component.
   *
   * @param {string} iconName
   *        The name of icon. A list of all the icon names can be found at 'sandbox/svg-icons.html'
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on. Defaults to the current Component's element.
   *
   * @return {Element}
   *        The newly created icon element.
   */ setIcon(iconName, el = this.el()) {
        // TODO: In v9 of video.js, we will want to remove font icons entirely.
        // This means this check, as well as the others throughout the code, and
        // the unecessary CSS for font icons, will need to be removed.
        // See https://github.com/videojs/video.js/pull/8260 as to which components
        // need updating.
        if (!this.player_.options_.experimentalSvgIcons) return;
        const xmlnsURL = 'http://www.w3.org/2000/svg';
        // The below creates an element in the format of:
        // <span><svg><use>....</use></svg></span>
        const iconContainer = $86defbb4e95ebb07$var$createEl('span', {
            className: 'vjs-icon-placeholder vjs-svg-icon'
        }, {
            'aria-hidden': 'true'
        });
        const svgEl = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElementNS(xmlnsURL, 'svg');
        svgEl.setAttributeNS(null, 'viewBox', '0 0 512 512');
        const useEl = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElementNS(xmlnsURL, 'use');
        svgEl.appendChild(useEl);
        useEl.setAttributeNS(null, 'href', `#vjs-icon-${iconName}`);
        iconContainer.appendChild(svgEl);
        // Replace a pre-existing icon if one exists.
        if (this.iconIsSet_) el.replaceChild(iconContainer, el.querySelector('.vjs-icon-placeholder'));
        else el.appendChild(iconContainer);
        this.iconIsSet_ = true;
        return iconContainer;
    }
    /**
   * Add a child `Component` inside the current `Component`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @param {number} [index=this.children_.length]
   *        The index to attempt to add a child into.
   *
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   */ addChild(child, options = {}, index = this.children_.length) {
        let component;
        let componentName;
        // If child is a string, create component with options
        if (typeof child === 'string') {
            componentName = $86defbb4e95ebb07$var$toTitleCase$1(child);
            const componentClassName = options.componentClass || componentName;
            // Set name through options
            options.name = componentName;
            // Create a new object & element for this controls set
            // If there's no .player_, this is a player
            const ComponentClass = $86defbb4e95ebb07$var$Component$1.getComponent(componentClassName);
            if (!ComponentClass) throw new Error(`Component ${componentClassName} does not exist`);
            // data stored directly on the videojs object may be
            // misidentified as a component to retain
            // backwards-compatibility with 4.x. check to make sure the
            // component class can be instantiated.
            if (typeof ComponentClass !== 'function') return null;
            component = new ComponentClass(this.player_ || this, options);
        // child is a component instance
        } else component = child;
        if (component.parentComponent_) component.parentComponent_.removeChild(component);
        this.children_.splice(index, 0, component);
        component.parentComponent_ = this;
        if (typeof component.id === 'function') this.childIndex_[component.id()] = component;
        // If a name wasn't used to create the component, check if we can use the
        // name function of the component
        componentName = componentName || component.name && $86defbb4e95ebb07$var$toTitleCase$1(component.name());
        if (componentName) {
            this.childNameIndex_[componentName] = component;
            this.childNameIndex_[$86defbb4e95ebb07$var$toLowerCase(componentName)] = component;
        }
        // Add the UI object's element to the container div (box)
        // Having an element is not required
        if (typeof component.el === 'function' && component.el()) {
            // If inserting before a component, insert before that component's element
            let refNode = null;
            if (this.children_[index + 1]) {
                // Most children are components, but the video tech is an HTML element
                if (this.children_[index + 1].el_) refNode = this.children_[index + 1].el_;
                else if ($86defbb4e95ebb07$var$isEl(this.children_[index + 1])) refNode = this.children_[index + 1];
            }
            this.contentEl().insertBefore(component.el(), refNode);
        }
        // Return so it can stored on parent object if desired.
        return component;
    }
    /**
   * Remove a child `Component` from this `Component`s list of children. Also removes
   * the child `Component`s element from this `Component`s element.
   *
   * @param {string|Component} component
   *       The name or instance of a child to remove.
   */ removeChild(component) {
        if (typeof component === 'string') component = this.getChild(component);
        if (!component || !this.children_) return;
        let childFound = false;
        for(let i = this.children_.length - 1; i >= 0; i--)if (this.children_[i] === component) {
            childFound = true;
            this.children_.splice(i, 1);
            break;
        }
        if (!childFound) return;
        component.parentComponent_ = null;
        this.childIndex_[component.id()] = null;
        this.childNameIndex_[$86defbb4e95ebb07$var$toTitleCase$1(component.name())] = null;
        this.childNameIndex_[$86defbb4e95ebb07$var$toLowerCase(component.name())] = null;
        const compEl = component.el();
        if (compEl && compEl.parentNode === this.contentEl()) this.contentEl().removeChild(component.el());
    }
    /**
   * Add and initialize default child `Component`s based upon options.
   */ initChildren() {
        const children = this.options_.children;
        if (children) {
            // `this` is `parent`
            const parentOptions = this.options_;
            const handleAdd = (child)=>{
                const name = child.name;
                let opts = child.opts;
                // Allow options for children to be set at the parent options
                // e.g. videojs(id, { controlBar: false });
                // instead of videojs(id, { children: { controlBar: false });
                if (parentOptions[name] !== undefined) opts = parentOptions[name];
                // Allow for disabling default components
                // e.g. options['children']['posterImage'] = false
                if (opts === false) return;
                // Allow options to be passed as a simple boolean if no configuration
                // is necessary.
                if (opts === true) opts = {};
                // We also want to pass the original player options
                // to each component as well so they don't need to
                // reach back into the player for options later.
                opts.playerOptions = this.options_.playerOptions;
                // Create and add the child component.
                // Add a direct reference to the child by name on the parent instance.
                // If two of the same component are used, different names should be supplied
                // for each
                const newChild = this.addChild(name, opts);
                if (newChild) this[name] = newChild;
            };
            // Allow for an array of children details to passed in the options
            let workingChildren;
            const Tech = $86defbb4e95ebb07$var$Component$1.getComponent('Tech');
            if (Array.isArray(children)) workingChildren = children;
            else workingChildren = Object.keys(children);
            workingChildren// children that are in this.options_ but also in workingChildren  would
            // give us extra children we do not want. So, we want to filter them out.
            .concat(Object.keys(this.options_).filter(function(child) {
                return !workingChildren.some(function(wchild) {
                    if (typeof wchild === 'string') return child === wchild;
                    return child === wchild.name;
                });
            })).map((child)=>{
                let name;
                let opts;
                if (typeof child === 'string') {
                    name = child;
                    opts = children[name] || this.options_[name] || {};
                } else {
                    name = child.name;
                    opts = child;
                }
                return {
                    name: name,
                    opts: opts
                };
            }).filter((child)=>{
                // we have to make sure that child.name isn't in the techOrder since
                // techs are registered as Components but can't aren't compatible
                // See https://github.com/videojs/video.js/issues/2772
                const c = $86defbb4e95ebb07$var$Component$1.getComponent(child.opts.componentClass || $86defbb4e95ebb07$var$toTitleCase$1(child.name));
                return c && !Tech.isTech(c);
            }).forEach(handleAdd);
        }
    }
    /**
   * Builds the default DOM class name. Should be overridden by sub-components.
   *
   * @return {string}
   *         The DOM class name for this object.
   *
   * @abstract
   */ buildCSSClass() {
        // Child classes can include a function that does:
        // return 'CLASS NAME' + this._super();
        return '';
    }
    /**
   * Bind a listener to the component's ready state.
   * Different from event listeners in that if the ready event has already happened
   * it will trigger the function immediately.
   *
   * @param {ReadyCallback} fn
   *        Function that gets called when the `Component` is ready.
   */ ready(fn, sync = false) {
        if (!fn) return;
        if (!this.isReady_) {
            this.readyQueue_ = this.readyQueue_ || [];
            this.readyQueue_.push(fn);
            return;
        }
        if (sync) fn.call(this);
        else // Call the function asynchronously by default for consistency
        this.setTimeout(fn, 1);
    }
    /**
   * Trigger all the ready listeners for this `Component`.
   *
   * @fires Component#ready
   */ triggerReady() {
        this.isReady_ = true;
        // Ensure ready is triggered asynchronously
        this.setTimeout(function() {
            const readyQueue = this.readyQueue_;
            // Reset Ready Queue
            this.readyQueue_ = [];
            if (readyQueue && readyQueue.length > 0) readyQueue.forEach(function(fn) {
                fn.call(this);
            }, this);
            // Allow for using event listeners also
            /**
       * Triggered when a `Component` is ready.
       *
       * @event Component#ready
       * @type {Event}
       */ this.trigger('ready');
        }, 1);
    }
    /**
   * Find a single DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelector`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {Element|null}
   *         the dom element that was found, or null
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */ $(selector, context) {
        return $86defbb4e95ebb07$var$$(selector, context || this.contentEl());
    }
    /**
   * Finds all DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelectorAll`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {NodeList}
   *         a list of dom elements that were found
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */ $$(selector, context) {
        return $86defbb4e95ebb07$var$$$(selector, context || this.contentEl());
    }
    /**
   * Check if a component's element has a CSS class name.
   *
   * @param {string} classToCheck
   *        CSS class name to check.
   *
   * @return {boolean}
   *         - True if the `Component` has the class.
   *         - False if the `Component` does not have the class`
   */ hasClass(classToCheck) {
        return $86defbb4e95ebb07$var$hasClass(this.el_, classToCheck);
    }
    /**
   * Add a CSS class name to the `Component`s element.
   *
   * @param {...string} classesToAdd
   *        One or more CSS class name to add.
   */ addClass(...classesToAdd) {
        $86defbb4e95ebb07$var$addClass(this.el_, ...classesToAdd);
    }
    /**
   * Remove a CSS class name from the `Component`s element.
   *
   * @param {...string} classesToRemove
   *        One or more CSS class name to remove.
   */ removeClass(...classesToRemove) {
        $86defbb4e95ebb07$var$removeClass(this.el_, ...classesToRemove);
    }
    /**
   * Add or remove a CSS class name from the component's element.
   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
   *
   * @param  {string} classToToggle
   *         The class to add or remove. Passed to DOMTokenList's toggle()
   *
   * @param  {boolean|Dom.PredicateCallback} [predicate]
   *         A boolean or function that returns a boolean. Passed to DOMTokenList's toggle().
   */ toggleClass(classToToggle, predicate) {
        $86defbb4e95ebb07$var$toggleClass(this.el_, classToToggle, predicate);
    }
    /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it.
   */ show() {
        this.removeClass('vjs-hidden');
    }
    /**
   * Hide the `Component`s element if it is currently showing by adding the
   * 'vjs-hidden` class name to it.
   */ hide() {
        this.addClass('vjs-hidden');
    }
    /**
   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
   * class name to it. Used during fadeIn/fadeOut.
   *
   * @private
   */ lockShowing() {
        this.addClass('vjs-lock-showing');
    }
    /**
   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
   * class name from it. Used during fadeIn/fadeOut.
   *
   * @private
   */ unlockShowing() {
        this.removeClass('vjs-lock-showing');
    }
    /**
   * Get the value of an attribute on the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to get the value from.
   *
   * @return {string|null}
   *         - The value of the attribute that was asked for.
   *         - Can be an empty string on some browsers if the attribute does not exist
   *           or has no value
   *         - Most browsers will return null if the attribute does not exist or has
   *           no value.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
   */ getAttribute(attribute) {
        return $86defbb4e95ebb07$var$getAttribute(this.el_, attribute);
    }
    /**
   * Set the value of an attribute on the `Component`'s element
   *
   * @param {string} attribute
   *        Name of the attribute to set.
   *
   * @param {string} value
   *        Value to set the attribute to.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
   */ setAttribute(attribute, value) {
        $86defbb4e95ebb07$var$setAttribute(this.el_, attribute, value);
    }
    /**
   * Remove an attribute from the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to remove.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
   */ removeAttribute(attribute) {
        $86defbb4e95ebb07$var$removeAttribute(this.el_, attribute);
    }
    /**
   * Get or set the width of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The width that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The width when getting, zero if there is no width
   */ width(num, skipListeners) {
        return this.dimension('width', num, skipListeners);
    }
    /**
   * Get or set the height of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The height that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The height when getting, zero if there is no height
   */ height(num, skipListeners) {
        return this.dimension('height', num, skipListeners);
    }
    /**
   * Set both the width and height of the `Component` element at the same time.
   *
   * @param  {number|string} width
   *         Width to set the `Component`s element to.
   *
   * @param  {number|string} height
   *         Height to set the `Component`s element to.
   */ dimensions(width, height) {
        // Skip componentresize listeners on width for optimization
        this.width(width, true);
        this.height(height);
    }
    /**
   * Get or set width or height of the `Component` element. This is the shared code
   * for the {@link Component#width} and {@link Component#height}.
   *
   * Things to know:
   * - If the width or height in an number this will return the number postfixed with 'px'.
   * - If the width/height is a percent this will return the percent postfixed with '%'
   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
   *   for more information
   * - If you want the computed style of the component, use {@link Component#currentWidth}
   *   and {@link {Component#currentHeight}
   *
   * @fires Component#componentresize
   *
   * @param {string} widthOrHeight
   8        'width' or 'height'
   *
   * @param  {number|string} [num]
   8         New dimension
   *
   * @param  {boolean} [skipListeners]
   *         Skip componentresize event trigger
   *
   * @return {number|undefined}
   *         The dimension when getting or 0 if unset
   */ dimension(widthOrHeight, num, skipListeners) {
        if (num !== undefined) {
            // Set to zero if null or literally NaN (NaN !== NaN)
            if (num === null || num !== num) num = 0;
            // Check if using css width/height (% or px) and adjust
            if (('' + num).indexOf('%') !== -1 || ('' + num).indexOf('px') !== -1) this.el_.style[widthOrHeight] = num;
            else if (num === 'auto') this.el_.style[widthOrHeight] = '';
            else this.el_.style[widthOrHeight] = num + 'px';
            // skipListeners allows us to avoid triggering the resize event when setting both width and height
            if (!skipListeners) /**
         * Triggered when a component is resized.
         *
         * @event Component#componentresize
         * @type {Event}
         */ this.trigger('componentresize');
            return;
        }
        // Not setting a value, so getting it
        // Make sure element exists
        if (!this.el_) return 0;
        // Get dimension value from style
        const val = this.el_.style[widthOrHeight];
        const pxIndex = val.indexOf('px');
        if (pxIndex !== -1) // Return the pixel value with no 'px'
        return parseInt(val.slice(0, pxIndex), 10);
        // No px so using % or no style was set, so falling back to offsetWidth/height
        // If component has display:none, offset will return 0
        // TODO: handle display:none and no dimension style using px
        return parseInt(this.el_['offset' + $86defbb4e95ebb07$var$toTitleCase$1(widthOrHeight)], 10);
    }
    /**
   * Get the computed width or the height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @param {string} widthOrHeight
   *        A string containing 'width' or 'height'. Whichever one you want to get.
   *
   * @return {number}
   *         The dimension that gets asked for or 0 if nothing was set
   *         for that dimension.
   */ currentDimension(widthOrHeight) {
        let computedWidthOrHeight = 0;
        if (widthOrHeight !== 'width' && widthOrHeight !== 'height') throw new Error('currentDimension only accepts width or height value');
        computedWidthOrHeight = $86defbb4e95ebb07$var$computedStyle(this.el_, widthOrHeight);
        // remove 'px' from variable and parse as integer
        computedWidthOrHeight = parseFloat(computedWidthOrHeight);
        // if the computed value is still 0, it's possible that the browser is lying
        // and we want to check the offset values.
        // This code also runs wherever getComputedStyle doesn't exist.
        if (computedWidthOrHeight === 0 || isNaN(computedWidthOrHeight)) {
            const rule = `offset${$86defbb4e95ebb07$var$toTitleCase$1(widthOrHeight)}`;
            computedWidthOrHeight = this.el_[rule];
        }
        return computedWidthOrHeight;
    }
    /**
   * An object that contains width and height values of the `Component`s
   * computed style. Uses `window.getComputedStyle`.
   *
   * @typedef {Object} Component~DimensionObject
   *
   * @property {number} width
   *           The width of the `Component`s computed style.
   *
   * @property {number} height
   *           The height of the `Component`s computed style.
   */ /**
   * Get an object that contains computed width and height values of the
   * component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {Component~DimensionObject}
   *         The computed dimensions of the component's element.
   */ currentDimensions() {
        return {
            width: this.currentDimension('width'),
            height: this.currentDimension('height')
        };
    }
    /**
   * Get the computed width of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed width of the component's element.
   */ currentWidth() {
        return this.currentDimension('width');
    }
    /**
   * Get the computed height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed height of the component's element.
   */ currentHeight() {
        return this.currentDimension('height');
    }
    /**
   * Retrieves the position and size information of the component's element.
   *
   * @return {Object} An object with `boundingClientRect` and `center` properties.
   *         - `boundingClientRect`: An object with properties `x`, `y`, `width`,
   *           `height`, `top`, `right`, `bottom`, and `left`, representing
   *           the bounding rectangle of the element.
   *         - `center`: An object with properties `x` and `y`, representing
   *           the center point of the element. `width` and `height` are set to 0.
   */ getPositions() {
        const rect = this.el_.getBoundingClientRect();
        // Creating objects that mirror DOMRectReadOnly for boundingClientRect and center
        const boundingClientRect = {
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left
        };
        // Calculating the center position
        const center = {
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2,
            width: 0,
            height: 0,
            top: rect.top + rect.height / 2,
            right: rect.left + rect.width / 2,
            bottom: rect.top + rect.height / 2,
            left: rect.left + rect.width / 2
        };
        return {
            boundingClientRect: boundingClientRect,
            center: center
        };
    }
    /**
   * Set the focus to this component
   */ focus() {
        this.el_.focus();
    }
    /**
   * Remove the focus from this component
   */ blur() {
        this.el_.blur();
    }
    /**
   * When this Component receives a `keydown` event which it does not process,
   *  it passes the event to the Player for handling.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   */ handleKeyDown(event) {
        if (this.player_) {
            // We only stop propagation here because we want unhandled events to fall
            // back to the browser. Exclude Tab for focus trapping, exclude also when spatialNavigation is enabled.
            if (event.key !== 'Tab' && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) event.stopPropagation();
            this.player_.handleKeyDown(event);
        }
    }
    /**
   * Many components used to have a `handleKeyPress` method, which was poorly
   * named because it listened to a `keydown` event. This method name now
   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
   * will not see their method calls stop working.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to be called.
   */ handleKeyPress(event) {
        this.handleKeyDown(event);
    }
    /**
   * Emit a 'tap' events when touch event support gets detected. This gets used to
   * support toggling the controls through a tap on the video. They get enabled
   * because every sub-component would have extra overhead otherwise.
   *
   * @protected
   * @fires Component#tap
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchleave
   * @listens Component#touchcancel
   * @listens Component#touchend
    */ emitTapEvents() {
        // Track the start time so we can determine how long the touch lasted
        let touchStart = 0;
        let firstTouch = null;
        // Maximum movement allowed during a touch event to still be considered a tap
        // Other popular libs use anywhere from 2 (hammer.js) to 15,
        // so 10 seems like a nice, round number.
        const tapMovementThreshold = 10;
        // The maximum length a touch can be while still being considered a tap
        const touchTimeThreshold = 200;
        let couldBeTap;
        this.on('touchstart', function(event) {
            // If more than one finger, don't consider treating this as a click
            if (event.touches.length === 1) {
                // Copy pageX/pageY from the object
                firstTouch = {
                    pageX: event.touches[0].pageX,
                    pageY: event.touches[0].pageY
                };
                // Record start time so we can detect a tap vs. "touch and hold"
                touchStart = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).performance.now();
                // Reset couldBeTap tracking
                couldBeTap = true;
            }
        });
        this.on('touchmove', function(event) {
            // If more than one finger, don't consider treating this as a click
            if (event.touches.length > 1) couldBeTap = false;
            else if (firstTouch) {
                // Some devices will throw touchmoves for all but the slightest of taps.
                // So, if we moved only a small distance, this could still be a tap
                const xdiff = event.touches[0].pageX - firstTouch.pageX;
                const ydiff = event.touches[0].pageY - firstTouch.pageY;
                const touchDistance = Math.sqrt(xdiff * xdiff + ydiff * ydiff);
                if (touchDistance > tapMovementThreshold) couldBeTap = false;
            }
        });
        const noTap = function() {
            couldBeTap = false;
        };
        // TODO: Listen to the original target. http://youtu.be/DujfpXOKUp8?t=13m8s
        this.on('touchleave', noTap);
        this.on('touchcancel', noTap);
        // When the touch ends, measure how long it took and trigger the appropriate
        // event
        this.on('touchend', function(event) {
            firstTouch = null;
            // Proceed only if the touchmove/leave/cancel event didn't happen
            if (couldBeTap === true) {
                // Measure how long the touch lasted
                const touchTime = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).performance.now() - touchStart;
                // Make sure the touch was less than the threshold to be considered a tap
                if (touchTime < touchTimeThreshold) {
                    // Don't let browser turn this into a click
                    event.preventDefault();
                    /**
           * Triggered when a `Component` is tapped.
           *
           * @event Component#tap
           * @type {MouseEvent}
           */ this.trigger('tap');
                // It may be good to copy the touchend event object and change the
                // type to tap, if the other event properties aren't exact after
                // Events.fixEvent runs (e.g. event.target)
                }
            }
        });
    }
    /**
   * This function reports user activity whenever touch events happen. This can get
   * turned off by any sub-components that wants touch events to act another way.
   *
   * Report user touch activity when touch events occur. User activity gets used to
   * determine when controls should show/hide. It is simple when it comes to mouse
   * events, because any mouse event should show the controls. So we capture mouse
   * events that bubble up to the player and report activity when that happens.
   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
   * controls. So touch events can't help us at the player level either.
   *
   * User activity gets checked asynchronously. So what could happen is a tap event
   * on the video turns the controls off. Then the `touchend` event bubbles up to
   * the player. Which, if it reported user activity, would turn the controls right
   * back on. We also don't want to completely block touch events from bubbling up.
   * Furthermore a `touchmove` event and anything other than a tap, should not turn
   * controls back on.
   *
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchend
   * @listens Component#touchcancel
   */ enableTouchActivity() {
        // Don't continue if the root player doesn't support reporting user activity
        if (!this.player() || !this.player().reportUserActivity) return;
        // listener for reporting that the user is active
        const report = $86defbb4e95ebb07$var$bind_(this.player(), this.player().reportUserActivity);
        let touchHolding;
        this.on('touchstart', function() {
            report();
            // For as long as the they are touching the device or have their mouse down,
            // we consider them active even if they're not moving their finger or mouse.
            // So we want to continue to update that they are active
            this.clearInterval(touchHolding);
            // report at the same interval as activityCheck
            touchHolding = this.setInterval(report, 250);
        });
        const touchEnd = function(event) {
            report();
            // stop the interval that maintains activity if the touch is holding
            this.clearInterval(touchHolding);
        };
        this.on('touchmove', report);
        this.on('touchend', touchEnd);
        this.on('touchcancel', touchEnd);
    }
    /**
   * A callback that has no parameters and is bound into `Component`s context.
   *
   * @callback Component~GenericCallback
   * @this Component
   */ /**
   * Creates a function that runs after an `x` millisecond timeout. This function is a
   * wrapper around `window.setTimeout`. There are a few reasons to use this one
   * instead though:
   * 1. It gets cleared via  {@link Component#clearTimeout} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
   *
   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
   *         will cause its dispose listener not to get cleaned up! Please use
   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
   *
   * @param {Component~GenericCallback} fn
   *        The function that will be run after `timeout`.
   *
   * @param {number} timeout
   *        Timeout in milliseconds to delay before executing the specified function.
   *
   * @return {number}
   *         Returns a timeout ID that gets used to identify the timeout. It can also
   *         get used in {@link Component#clearTimeout} to clear the timeout that
   *         was set.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
   */ setTimeout(fn, timeout) {
        // declare as variables so they are properly available in timeout function
        // eslint-disable-next-line
        var timeoutId;
        fn = $86defbb4e95ebb07$var$bind_(this, fn);
        this.clearTimersOnDispose_();
        timeoutId = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>{
            if (this.setTimeoutIds_.has(timeoutId)) this.setTimeoutIds_.delete(timeoutId);
            fn();
        }, timeout);
        this.setTimeoutIds_.add(timeoutId);
        return timeoutId;
    }
    /**
   * Clears a timeout that gets created via `window.setTimeout` or
   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
   * use this function instead of `window.clearTimout`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} timeoutId
   *        The id of the timeout to clear. The return value of
   *        {@link Component#setTimeout} or `window.setTimeout`.
   *
   * @return {number}
   *         Returns the timeout id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
   */ clearTimeout(timeoutId) {
        if (this.setTimeoutIds_.has(timeoutId)) {
            this.setTimeoutIds_.delete(timeoutId);
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(timeoutId);
        }
        return timeoutId;
    }
    /**
   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
   * around `window.setInterval`. There are a few reasons to use this one instead though.
   * 1. It gets cleared via  {@link Component#clearInterval} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will be a {@link Component~GenericCallback}
   *
   * @param {Component~GenericCallback} fn
   *        The function to run every `x` seconds.
   *
   * @param {number} interval
   *        Execute the specified function every `x` milliseconds.
   *
   * @return {number}
   *         Returns an id that can be used to identify the interval. It can also be be used in
   *         {@link Component#clearInterval} to clear the interval.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
   */ setInterval(fn, interval) {
        fn = $86defbb4e95ebb07$var$bind_(this, fn);
        this.clearTimersOnDispose_();
        const intervalId = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setInterval(fn, interval);
        this.setIntervalIds_.add(intervalId);
        return intervalId;
    }
    /**
   * Clears an interval that gets created via `window.setInterval` or
   * {@link Component#setInterval}. If you set an interval via {@link Component#setInterval}
   * use this function instead of `window.clearInterval`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} intervalId
   *        The id of the interval to clear. The return value of
   *        {@link Component#setInterval} or `window.setInterval`.
   *
   * @return {number}
   *         Returns the interval id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
   */ clearInterval(intervalId) {
        if (this.setIntervalIds_.has(intervalId)) {
            this.setIntervalIds_.delete(intervalId);
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearInterval(intervalId);
        }
        return intervalId;
    }
    /**
   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
   * with a few extra bonuses:
   *
   * - Supports browsers that do not support rAF by falling back to
   *   {@link Component#setTimeout}.
   *
   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
   *   bound to the component).
   *
   * - Automatic cancellation of the rAF callback is handled if the component
   *   is disposed before it is called.
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   *
   * @return {number}
   *         Returns an rAF ID that gets used to identify the timeout. It can
   *         also be used in {@link Component#cancelAnimationFrame} to cancel
   *         the animation frame callback.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
   */ requestAnimationFrame(fn) {
        this.clearTimersOnDispose_();
        // declare as variables so they are properly available in rAF function
        // eslint-disable-next-line
        var id;
        fn = $86defbb4e95ebb07$var$bind_(this, fn);
        id = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).requestAnimationFrame(()=>{
            if (this.rafIds_.has(id)) this.rafIds_.delete(id);
            fn();
        });
        this.rafIds_.add(id);
        return id;
    }
    /**
   * Request an animation frame, but only one named animation
   * frame will be queued. Another will never be added until
   * the previous one finishes.
   *
   * @param {string} name
   *        The name to give this requestAnimationFrame
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   */ requestNamedAnimationFrame(name, fn) {
        if (this.namedRafs_.has(name)) this.cancelNamedAnimationFrame(name);
        this.clearTimersOnDispose_();
        fn = $86defbb4e95ebb07$var$bind_(this, fn);
        const id = this.requestAnimationFrame(()=>{
            fn();
            if (this.namedRafs_.has(name)) this.namedRafs_.delete(name);
        });
        this.namedRafs_.set(name, id);
        return name;
    }
    /**
   * Cancels a current named animation frame if it exists.
   *
   * @param {string} name
   *        The name of the requestAnimationFrame to cancel.
   */ cancelNamedAnimationFrame(name) {
        if (!this.namedRafs_.has(name)) return;
        this.cancelAnimationFrame(this.namedRafs_.get(name));
        this.namedRafs_.delete(name);
    }
    /**
   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
   * (rAF).
   *
   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
   * use this function instead of `window.cancelAnimationFrame`. If you don't,
   * your dispose listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} id
   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
   *
   * @return {number}
   *         Returns the rAF ID that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
   */ cancelAnimationFrame(id) {
        if (this.rafIds_.has(id)) {
            this.rafIds_.delete(id);
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).cancelAnimationFrame(id);
        }
        return id;
    }
    /**
   * A function to setup `requestAnimationFrame`, `setTimeout`,
   * and `setInterval`, clearing on dispose.
   *
   * > Previously each timer added and removed dispose listeners on it's own.
   * For better performance it was decided to batch them all, and use `Set`s
   * to track outstanding timer ids.
   *
   * @private
   */ clearTimersOnDispose_() {
        if (this.clearingTimersOnDispose_) return;
        this.clearingTimersOnDispose_ = true;
        this.one('dispose', ()=>{
            [
                [
                    'namedRafs_',
                    'cancelNamedAnimationFrame'
                ],
                [
                    'rafIds_',
                    'cancelAnimationFrame'
                ],
                [
                    'setTimeoutIds_',
                    'clearTimeout'
                ],
                [
                    'setIntervalIds_',
                    'clearInterval'
                ]
            ].forEach(([idName, cancelName])=>{
                // for a `Set` key will actually be the value again
                // so forEach((val, val) =>` but for maps we want to use
                // the key.
                this[idName].forEach((val, key)=>this[cancelName](key));
            });
            this.clearingTimersOnDispose_ = false;
        });
    }
    /**
    * Decide whether an element is actually disabled or not.
    *
    * @function isActuallyDisabled
    * @param element {Node}
    * @return {boolean}
    *
    * @see {@link https://html.spec.whatwg.org/multipage/semantics-other.html#concept-element-disabled}
    */ getIsDisabled() {
        return Boolean(this.el_.disabled);
    }
    /**
    * Decide whether the element is expressly inert or not.
    *
    * @see {@link https://html.spec.whatwg.org/multipage/interaction.html#expressly-inert}
    * @function isExpresslyInert
    * @param element {Node}
    * @return {boolean}
    */ getIsExpresslyInert() {
        return this.el_.inert && !this.el_.ownerDocument.documentElement.inert;
    }
    /**
   * Determine whether or not this component can be considered as focusable component.
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can be focused, will be `true`. Otherwise, `false`.
   */ getIsFocusable(el) {
        const element = el || this.el_;
        return element.tabIndex >= 0 && !(this.getIsDisabled() || this.getIsExpresslyInert());
    }
    /**
   * Determine whether or not this component is currently visible/enabled/etc...
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can is currently visible & enabled, will be `true`. Otherwise, `false`.
   */ getIsAvailableToBeFocused(el) {
        /**
     * Decide the style property of this element is specified whether it's visible or not.
     *
     * @function isVisibleStyleProperty
     * @param element {CSSStyleDeclaration}
     * @return {boolean}
     */ function isVisibleStyleProperty(element) {
            const elementStyle = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).getComputedStyle(element, null);
            const thisVisibility = elementStyle.getPropertyValue('visibility');
            const thisDisplay = elementStyle.getPropertyValue('display');
            const invisibleStyle = [
                'hidden',
                'collapse'
            ];
            return thisDisplay !== 'none' && !invisibleStyle.includes(thisVisibility);
        }
        /**
     * Decide whether the element is being rendered or not.
     * 1. If an element has the style as "visibility: hidden | collapse" or "display: none", it is not being rendered.
     * 2. If an element has the style as "opacity: 0", it is not being rendered.(that is, invisible).
     * 3. If width and height of an element are explicitly set to 0, it is not being rendered.
     * 4. If a parent element is hidden, an element itself is not being rendered.
     * (CSS visibility property and display property are inherited.)
     *
     * @see {@link https://html.spec.whatwg.org/multipage/rendering.html#being-rendered}
     * @function isBeingRendered
     * @param element {Node}
     * @return {boolean}
     */ function isBeingRendered(element) {
            if (!isVisibleStyleProperty(element.parentElement)) return false;
            if (!isVisibleStyleProperty(element) || element.style.opacity === '0' || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).getComputedStyle(element).height === '0px' || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).getComputedStyle(element).width === '0px') return false;
            return true;
        }
        /**
     * Determine if the element is visible for the user or not.
     * 1. If an element sum of its offsetWidth, offsetHeight, height and width is less than 1 is not visible.
     * 2. If elementCenter.x is less than is not visible.
     * 3. If elementCenter.x is more than the document's width is not visible.
     * 4. If elementCenter.y is less than 0 is not visible.
     * 5. If elementCenter.y is the document's height is not visible.
     *
     * @function isVisible
     * @param element {Node}
     * @return {boolean}
     */ function isVisible(element) {
            if (element.offsetWidth + element.offsetHeight + element.getBoundingClientRect().height + element.getBoundingClientRect().width === 0) return false;
            // Define elementCenter object with props of x and y
            // x: Left position relative to the viewport plus element's width (no margin) divided between 2.
            // y: Top position relative to the viewport plus element's height (no margin) divided between 2.
            const elementCenter = {
                x: element.getBoundingClientRect().left + element.offsetWidth / 2,
                y: element.getBoundingClientRect().top + element.offsetHeight / 2
            };
            if (elementCenter.x < 0) return false;
            if (elementCenter.x > ((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).documentElement.clientWidth || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).innerWidth)) return false;
            if (elementCenter.y < 0) return false;
            if (elementCenter.y > ((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).documentElement.clientHeight || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).innerHeight)) return false;
            let pointContainer = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).elementFromPoint(elementCenter.x, elementCenter.y);
            while(pointContainer){
                if (pointContainer === element) return true;
                if (pointContainer.parentNode) pointContainer = pointContainer.parentNode;
                else return false;
            }
        }
        // If no DOM element was passed as argument use this component's element.
        if (!el) el = this.el();
        // If element is visible, is being rendered & either does not have a parent element or its tabIndex is not negative.
        if (isVisible(el) && isBeingRendered(el) && (!el.parentElement || el.tabIndex >= 0)) return true;
        return false;
    }
    /**
   * Register a `Component` with `videojs` given the name and the component.
   *
   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
   *         should be registered using {@link Tech.registerTech} or
   *         {@link videojs:videojs.registerTech}.
   *
   * > NOTE: This function can also be seen on videojs as
   *         {@link videojs:videojs.registerComponent}.
   *
   * @param {string} name
   *        The name of the `Component` to register.
   *
   * @param {Component} ComponentToRegister
   *        The `Component` class to register.
   *
   * @return {Component}
   *         The `Component` that was registered.
   */ static registerComponent(name, ComponentToRegister) {
        if (typeof name !== 'string' || !name) throw new Error(`Illegal component name, "${name}"; must be a non-empty string.`);
        const Tech = $86defbb4e95ebb07$var$Component$1.getComponent('Tech');
        // We need to make sure this check is only done if Tech has been registered.
        const isTech = Tech && Tech.isTech(ComponentToRegister);
        const isComp = $86defbb4e95ebb07$var$Component$1 === ComponentToRegister || $86defbb4e95ebb07$var$Component$1.prototype.isPrototypeOf(ComponentToRegister.prototype);
        if (isTech || !isComp) {
            let reason;
            if (isTech) reason = 'techs must be registered using Tech.registerTech()';
            else reason = 'must be a Component subclass';
            throw new Error(`Illegal component, "${name}"; ${reason}.`);
        }
        name = $86defbb4e95ebb07$var$toTitleCase$1(name);
        if (!$86defbb4e95ebb07$var$Component$1.components_) $86defbb4e95ebb07$var$Component$1.components_ = {};
        const Player = $86defbb4e95ebb07$var$Component$1.getComponent('Player');
        if (name === 'Player' && Player && Player.players) {
            const players = Player.players;
            const playerNames = Object.keys(players);
            // If we have players that were disposed, then their name will still be
            // in Players.players. So, we must loop through and verify that the value
            // for each item is null. This allows registration of the Player component
            // after all players have been disposed or before any were created.
            if (players && playerNames.length > 0) for(let i = 0; i < playerNames.length; i++){
                if (players[playerNames[i]] !== null) throw new Error('Can not register Player component after player has been created.');
            }
        }
        $86defbb4e95ebb07$var$Component$1.components_[name] = ComponentToRegister;
        $86defbb4e95ebb07$var$Component$1.components_[$86defbb4e95ebb07$var$toLowerCase(name)] = ComponentToRegister;
        return ComponentToRegister;
    }
    /**
   * Get a `Component` based on the name it was registered with.
   *
   * @param {string} name
   *        The Name of the component to get.
   *
   * @return {typeof Component}
   *         The `Component` that got registered under the given name.
   */ static getComponent(name) {
        if (!name || !$86defbb4e95ebb07$var$Component$1.components_) return;
        return $86defbb4e95ebb07$var$Component$1.components_[name];
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('Component', $86defbb4e95ebb07$var$Component$1);
/**
 * @file time.js
 * @module time
 */ /**
 * Returns the time for the specified index at the start or end
 * of a TimeRange object.
 *
 * @typedef    {Function} TimeRangeIndex
 *
 * @param      {number} [index=0]
 *             The range number to return the time for.
 *
 * @return     {number}
 *             The time offset at the specified index.
 *
 * @deprecated The index argument must be provided.
 *             In the future, leaving it out will throw an error.
 */ /**
 * An object that contains ranges of time, which mimics {@link TimeRanges}.
 *
 * @typedef  {Object} TimeRange
 *
 * @property {number} length
 *           The number of time ranges represented by this object.
 *
 * @property {module:time~TimeRangeIndex} start
 *           Returns the time offset at which a specified time range begins.
 *
 * @property {module:time~TimeRangeIndex} end
 *           Returns the time offset at which a specified time range ends.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges
 */ /**
 * Check if any of the time ranges are over the maximum index.
 *
 * @private
 * @param   {string} fnName
 *          The function name to use for logging
 *
 * @param   {number} index
 *          The index to check
 *
 * @param   {number} maxIndex
 *          The maximum possible index
 *
 * @throws  {Error} if the timeRanges provided are over the maxIndex
 */ function $86defbb4e95ebb07$var$rangeCheck(fnName, index, maxIndex) {
    if (typeof index !== 'number' || index < 0 || index > maxIndex) throw new Error(`Failed to execute '${fnName}' on 'TimeRanges': The index provided (${index}) is non-numeric or out of bounds (0-${maxIndex}).`);
}
/**
 * Get the time for the specified index at the start or end
 * of a TimeRange object.
 *
 * @private
 * @param      {string} fnName
 *             The function name to use for logging
 *
 * @param      {string} valueIndex
 *             The property that should be used to get the time. should be
 *             'start' or 'end'
 *
 * @param      {Array} ranges
 *             An array of time ranges
 *
 * @param      {Array} [rangeIndex=0]
 *             The index to start the search at
 *
 * @return     {number}
 *             The time that offset at the specified index.
 *
 * @deprecated rangeIndex must be set to a value, in the future this will throw an error.
 * @throws     {Error} if rangeIndex is more than the length of ranges
 */ function $86defbb4e95ebb07$var$getRange(fnName, valueIndex, ranges, rangeIndex) {
    $86defbb4e95ebb07$var$rangeCheck(fnName, rangeIndex, ranges.length - 1);
    return ranges[rangeIndex][valueIndex];
}
/**
 * Create a time range object given ranges of time.
 *
 * @private
 * @param   {Array} [ranges]
 *          An array of time ranges.
 *
 * @return  {TimeRange}
 */ function $86defbb4e95ebb07$var$createTimeRangesObj(ranges) {
    let timeRangesObj;
    if (ranges === undefined || ranges.length === 0) timeRangesObj = {
        length: 0,
        start () {
            throw new Error('This TimeRanges object is empty');
        },
        end () {
            throw new Error('This TimeRanges object is empty');
        }
    };
    else timeRangesObj = {
        length: ranges.length,
        start: $86defbb4e95ebb07$var$getRange.bind(null, 'start', 0, ranges),
        end: $86defbb4e95ebb07$var$getRange.bind(null, 'end', 1, ranges)
    };
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Symbol && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Symbol.iterator) timeRangesObj[(0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Symbol.iterator] = ()=>(ranges || []).values();
    return timeRangesObj;
}
/**
 * Create a `TimeRange` object which mimics an
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges|HTML5 TimeRanges instance}.
 *
 * @param {number|Array[]} start
 *        The start of a single range (a number) or an array of ranges (an
 *        array of arrays of two numbers each).
 *
 * @param {number} end
 *        The end of a single range. Cannot be used with the array form of
 *        the `start` argument.
 *
 * @return {TimeRange}
 */ function $86defbb4e95ebb07$var$createTimeRanges$1(start, end) {
    if (Array.isArray(start)) return $86defbb4e95ebb07$var$createTimeRangesObj(start);
    else if (start === undefined || end === undefined) return $86defbb4e95ebb07$var$createTimeRangesObj();
    return $86defbb4e95ebb07$var$createTimeRangesObj([
        [
            start,
            end
        ]
    ]);
}
/**
 * Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in
 * seconds) will force a number of leading zeros to cover the length of the
 * guide.
 *
 * @private
 * @param  {number} seconds
 *         Number of seconds to be turned into a string
 *
 * @param  {number} guide
 *         Number (in seconds) to model the string after
 *
 * @return {string}
 *         Time formatted as H:MM:SS or M:SS
 */ const $86defbb4e95ebb07$var$defaultImplementation = function(seconds, guide) {
    seconds = seconds < 0 ? 0 : seconds;
    let s = Math.floor(seconds % 60);
    let m = Math.floor(seconds / 60 % 60);
    let h = Math.floor(seconds / 3600);
    const gm = Math.floor(guide / 60 % 60);
    const gh = Math.floor(guide / 3600);
    // handle invalid times
    if (isNaN(seconds) || seconds === Infinity) // '-' is false for all relational operators (e.g. <, >=) so this setting
    // will add the minimum number of fields specified by the guide
    h = m = s = '-';
    // Check if we need to show hours
    h = h > 0 || gh > 0 ? h + ':' : '';
    // If hours are showing, we may need to add a leading zero.
    // Always show at least one digit of minutes.
    m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':';
    // Check if leading zero is need for seconds
    s = s < 10 ? '0' + s : s;
    return h + m + s;
};
// Internal pointer to the current implementation.
let $86defbb4e95ebb07$var$implementation = $86defbb4e95ebb07$var$defaultImplementation;
/**
 * Replaces the default formatTime implementation with a custom implementation.
 *
 * @param {Function} customImplementation
 *        A function which will be used in place of the default formatTime
 *        implementation. Will receive the current time in seconds and the
 *        guide (in seconds) as arguments.
 */ function $86defbb4e95ebb07$var$setFormatTime(customImplementation) {
    $86defbb4e95ebb07$var$implementation = customImplementation;
}
/**
 * Resets formatTime to the default implementation.
 */ function $86defbb4e95ebb07$var$resetFormatTime() {
    $86defbb4e95ebb07$var$implementation = $86defbb4e95ebb07$var$defaultImplementation;
}
/**
 * Delegates to either the default time formatting function or a custom
 * function supplied via `setFormatTime`.
 *
 * Formats seconds as a time string (H:MM:SS or M:SS). Supplying a
 * guide (in seconds) will force a number of leading zeros to cover the
 * length of the guide.
 *
 * @example  formatTime(125, 600) === "02:05"
 * @param    {number} seconds
 *           Number of seconds to be turned into a string
 *
 * @param    {number} guide
 *           Number (in seconds) to model the string after
 *
 * @return   {string}
 *           Time formatted as H:MM:SS or M:SS
 */ function $86defbb4e95ebb07$var$formatTime(seconds, guide = seconds) {
    return $86defbb4e95ebb07$var$implementation(seconds, guide);
}
var $86defbb4e95ebb07$var$Time = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createTimeRanges: $86defbb4e95ebb07$var$createTimeRanges$1,
    createTimeRange: $86defbb4e95ebb07$var$createTimeRanges$1,
    setFormatTime: $86defbb4e95ebb07$var$setFormatTime,
    resetFormatTime: $86defbb4e95ebb07$var$resetFormatTime,
    formatTime: $86defbb4e95ebb07$var$formatTime
});
/**
 * @file buffer.js
 * @module buffer
 */ /** @import { TimeRange } from './time' */ /**
 * Compute the percentage of the media that has been buffered.
 *
 * @param {TimeRange} buffered
 *        The current `TimeRanges` object representing buffered time ranges
 *
 * @param {number} duration
 *        Total duration of the media
 *
 * @return {number}
 *         Percent buffered of the total duration in decimal form.
 */ function $86defbb4e95ebb07$var$bufferedPercent(buffered, duration) {
    let bufferedDuration = 0;
    let start;
    let end;
    if (!duration) return 0;
    if (!buffered || !buffered.length) buffered = $86defbb4e95ebb07$var$createTimeRanges$1(0, 0);
    for(let i = 0; i < buffered.length; i++){
        start = buffered.start(i);
        end = buffered.end(i);
        // buffered end can be bigger than duration by a very small fraction
        if (end > duration) end = duration;
        bufferedDuration += end - start;
    }
    return bufferedDuration / duration;
}
/**
 * @file media-error.js
 */ /**
 * A Custom `MediaError` class which mimics the standard HTML5 `MediaError` class.
 *
 * @param {number|string|Object|MediaError} value
 *        This can be of multiple types:
 *        - number: should be a standard error code
 *        - string: an error message (the code will be 0)
 *        - Object: arbitrary properties
 *        - `MediaError` (native): used to populate a video.js `MediaError` object
 *        - `MediaError` (video.js): will return itself if it's already a
 *          video.js `MediaError` object.
 *
 * @see [MediaError Spec]{@link https://dev.w3.org/html5/spec-author-view/video.html#mediaerror}
 * @see [Encrypted MediaError Spec]{@link https://www.w3.org/TR/2013/WD-encrypted-media-20130510/#error-codes}
 *
 * @class MediaError
 */ function $86defbb4e95ebb07$var$MediaError(value) {
    // Allow redundant calls to this constructor to avoid having `instanceof`
    // checks peppered around the code.
    if (value instanceof $86defbb4e95ebb07$var$MediaError) return value;
    if (typeof value === 'number') this.code = value;
    else if (typeof value === 'string') // default code is zero, so this is a custom error
    this.message = value;
    else if ($86defbb4e95ebb07$var$isObject(value)) {
        // We assign the `code` property manually because native `MediaError` objects
        // do not expose it as an own/enumerable property of the object.
        if (typeof value.code === 'number') this.code = value.code;
        Object.assign(this, value);
    }
    if (!this.message) this.message = $86defbb4e95ebb07$var$MediaError.defaultMessages[this.code] || '';
}
/**
 * The error code that refers two one of the defined `MediaError` types
 *
 * @type {Number}
 */ $86defbb4e95ebb07$var$MediaError.prototype.code = 0;
/**
 * An optional message that to show with the error. Message is not part of the HTML5
 * video spec but allows for more informative custom errors.
 *
 * @type {String}
 */ $86defbb4e95ebb07$var$MediaError.prototype.message = '';
/**
 * An optional status code that can be set by plugins to allow even more detail about
 * the error. For example a plugin might provide a specific HTTP status code and an
 * error message for that code. Then when the plugin gets that error this class will
 * know how to display an error message for it. This allows a custom message to show
 * up on the `Player` error overlay.
 *
 * @type {Array}
 */ $86defbb4e95ebb07$var$MediaError.prototype.status = null;
/**
 * An object containing an error type, as well as other information regarding the error.
 *
 * @typedef {{errorType: string, [key: string]: any}} ErrorMetadata
 */ /**
 * An optional object to give more detail about the error. This can be used to give
 * a higher level of specificity to an error versus the more generic MediaError codes.
 * `metadata` expects an `errorType` string that should align with the values from videojs.Error.
 *
 * @type {ErrorMetadata}
 */ $86defbb4e95ebb07$var$MediaError.prototype.metadata = null;
/**
 * Errors indexed by the W3C standard. The order **CANNOT CHANGE**! See the
 * specification listed under {@link MediaError} for more information.
 *
 * @enum {array}
 * @readonly
 * @property {string} 0 - MEDIA_ERR_CUSTOM
 * @property {string} 1 - MEDIA_ERR_ABORTED
 * @property {string} 2 - MEDIA_ERR_NETWORK
 * @property {string} 3 - MEDIA_ERR_DECODE
 * @property {string} 4 - MEDIA_ERR_SRC_NOT_SUPPORTED
 * @property {string} 5 - MEDIA_ERR_ENCRYPTED
 */ $86defbb4e95ebb07$var$MediaError.errorTypes = [
    'MEDIA_ERR_CUSTOM',
    'MEDIA_ERR_ABORTED',
    'MEDIA_ERR_NETWORK',
    'MEDIA_ERR_DECODE',
    'MEDIA_ERR_SRC_NOT_SUPPORTED',
    'MEDIA_ERR_ENCRYPTED'
];
/**
 * The default `MediaError` messages based on the {@link MediaError.errorTypes}.
 *
 * @type {Array}
 * @constant
 */ $86defbb4e95ebb07$var$MediaError.defaultMessages = {
    1: 'You aborted the media playback',
    2: 'A network error caused the media download to fail part-way.',
    3: 'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.',
    4: 'The media could not be loaded, either because the server or network failed or because the format is not supported.',
    5: 'The media is encrypted and we do not have the keys to decrypt it.'
};
/**
 * W3C error code for any custom error.
 *
 * @member MediaError#MEDIA_ERR_CUSTOM
 * @constant {number}
 * @default 0
 */ $86defbb4e95ebb07$var$MediaError.MEDIA_ERR_CUSTOM = 0;
/**
 * W3C error code for any custom error.
 *
 * @member MediaError.MEDIA_ERR_CUSTOM
 * @constant {number}
 * @default 0
 */ $86defbb4e95ebb07$var$MediaError.prototype.MEDIA_ERR_CUSTOM = 0;
/**
 * W3C error code for media error aborted.
 *
 * @member MediaError#MEDIA_ERR_ABORTED
 * @constant {number}
 * @default 1
 */ $86defbb4e95ebb07$var$MediaError.MEDIA_ERR_ABORTED = 1;
/**
 * W3C error code for media error aborted.
 *
 * @member MediaError.MEDIA_ERR_ABORTED
 * @constant {number}
 * @default 1
 */ $86defbb4e95ebb07$var$MediaError.prototype.MEDIA_ERR_ABORTED = 1;
/**
 * W3C error code for any network error.
 *
 * @member MediaError#MEDIA_ERR_NETWORK
 * @constant {number}
 * @default 2
 */ $86defbb4e95ebb07$var$MediaError.MEDIA_ERR_NETWORK = 2;
/**
 * W3C error code for any network error.
 *
 * @member MediaError.MEDIA_ERR_NETWORK
 * @constant {number}
 * @default 2
 */ $86defbb4e95ebb07$var$MediaError.prototype.MEDIA_ERR_NETWORK = 2;
/**
 * W3C error code for any decoding error.
 *
 * @member MediaError#MEDIA_ERR_DECODE
 * @constant {number}
 * @default 3
 */ $86defbb4e95ebb07$var$MediaError.MEDIA_ERR_DECODE = 3;
/**
 * W3C error code for any decoding error.
 *
 * @member MediaError.MEDIA_ERR_DECODE
 * @constant {number}
 * @default 3
 */ $86defbb4e95ebb07$var$MediaError.prototype.MEDIA_ERR_DECODE = 3;
/**
 * W3C error code for any time that a source is not supported.
 *
 * @member MediaError#MEDIA_ERR_SRC_NOT_SUPPORTED
 * @constant {number}
 * @default 4
 */ $86defbb4e95ebb07$var$MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
/**
 * W3C error code for any time that a source is not supported.
 *
 * @member MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED
 * @constant {number}
 * @default 4
 */ $86defbb4e95ebb07$var$MediaError.prototype.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
/**
 * W3C error code for any time that a source is encrypted.
 *
 * @member MediaError#MEDIA_ERR_ENCRYPTED
 * @constant {number}
 * @default 5
 */ $86defbb4e95ebb07$var$MediaError.MEDIA_ERR_ENCRYPTED = 5;
/**
 * W3C error code for any time that a source is encrypted.
 *
 * @member MediaError.MEDIA_ERR_ENCRYPTED
 * @constant {number}
 * @default 5
 */ $86defbb4e95ebb07$var$MediaError.prototype.MEDIA_ERR_ENCRYPTED = 5;
/**
 * Returns whether an object is `Promise`-like (i.e. has a `then` method).
 *
 * @param  {Object}  value
 *         An object that may or may not be `Promise`-like.
 *
 * @return {boolean}
 *         Whether or not the object is `Promise`-like.
 */ function $86defbb4e95ebb07$var$isPromise(value) {
    return value !== undefined && value !== null && typeof value.then === 'function';
}
/**
 * Silence a Promise-like object.
 *
 * This is useful for avoiding non-harmful, but potentially confusing "uncaught
 * play promise" rejection error messages.
 *
 * @param  {Object} value
 *         An object that may or may not be `Promise`-like.
 */ function $86defbb4e95ebb07$var$silencePromise(value) {
    if ($86defbb4e95ebb07$var$isPromise(value)) value.then(null, (e)=>{});
}
/**
 * @file text-track-list-converter.js Utilities for capturing text track state and
 * re-creating tracks based on a capture.
 *
 * @module text-track-list-converter
 */ /** @import Tech from '../tech/tech' */ /**
 * Examine a single {@link TextTrack} and return a JSON-compatible javascript object that
 * represents the {@link TextTrack}'s state.
 *
 * @param {TextTrack} track
 *        The text track to query.
 *
 * @return {Object}
 *         A serializable javascript representation of the TextTrack.
 * @private
 */ const $86defbb4e95ebb07$var$trackToJson = function(track) {
    const ret = [
        'kind',
        'label',
        'language',
        'id',
        'inBandMetadataTrackDispatchType',
        'mode',
        'src'
    ].reduce((acc, prop, i)=>{
        if (track[prop]) acc[prop] = track[prop];
        return acc;
    }, {
        cues: track.cues && Array.prototype.map.call(track.cues, function(cue) {
            return {
                startTime: cue.startTime,
                endTime: cue.endTime,
                text: cue.text,
                id: cue.id
            };
        })
    });
    return ret;
};
/**
 * Examine a {@link Tech} and return a JSON-compatible javascript array that represents the
 * state of all {@link TextTrack}s currently configured. The return array is compatible with
 * {@link text-track-list-converter:jsonToTextTracks}.
 *
 * @param {Tech} tech
 *        The tech object to query
 *
 * @return {Array}
 *         A serializable javascript representation of the {@link Tech}s
 *         {@link TextTrackList}.
 */ const $86defbb4e95ebb07$var$textTracksToJson = function(tech) {
    const trackEls = tech.$$('track');
    const trackObjs = Array.prototype.map.call(trackEls, (t)=>t.track);
    const tracks = Array.prototype.map.call(trackEls, function(trackEl) {
        const json = $86defbb4e95ebb07$var$trackToJson(trackEl.track);
        if (trackEl.src) json.src = trackEl.src;
        return json;
    });
    return tracks.concat(Array.prototype.filter.call(tech.textTracks(), function(track) {
        return trackObjs.indexOf(track) === -1;
    }).map($86defbb4e95ebb07$var$trackToJson));
};
/**
 * Create a set of remote {@link TextTrack}s on a {@link Tech} based on an array of javascript
 * object {@link TextTrack} representations.
 *
 * @param {Array} json
 *        An array of `TextTrack` representation objects, like those that would be
 *        produced by `textTracksToJson`.
 *
 * @param {Tech} tech
 *        The `Tech` to create the `TextTrack`s on.
 */ const $86defbb4e95ebb07$var$jsonToTextTracks = function(json, tech) {
    json.forEach(function(track) {
        const addedTrack = tech.addRemoteTextTrack(track).track;
        if (!track.src && track.cues) track.cues.forEach((cue)=>addedTrack.addCue(cue));
    });
    return tech.textTracks();
};
var $86defbb4e95ebb07$var$textTrackConverter = {
    textTracksToJson: $86defbb4e95ebb07$var$textTracksToJson,
    jsonToTextTracks: $86defbb4e95ebb07$var$jsonToTextTracks,
    trackToJson: $86defbb4e95ebb07$var$trackToJson
};
/**
 * @file modal-dialog.js
 */ /** @import Player from './player' */ /** @import { ContentDescriptor } from './utils/dom' */ const $86defbb4e95ebb07$var$MODAL_CLASS_NAME = 'vjs-modal-dialog';
/**
 * The `ModalDialog` displays over the video and its controls, which blocks
 * interaction with the player until it is closed.
 *
 * Modal dialogs include a "Close" button and will close when that button
 * is activated - or when ESC is pressed anywhere.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$ModalDialog extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.description]
   *        A text description for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.fillAlways=false]
   *        Normally, modals are automatically filled only the first time
   *        they open. This tells the modal to refresh its content
   *        every time it opens.
   *
   * @param {string} [options.label]
   *        A text label for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.pauseOnOpen=true]
   *        If `true`, playback will will be paused if playing when
   *        the modal opens, and resumed when it closes.
   *
   * @param {boolean} [options.temporary=true]
   *        If `true`, the modal can only be opened once; it will be
   *        disposed as soon as it's closed.
   *
   * @param {boolean} [options.uncloseable=false]
   *        If `true`, the user will not be able to close the modal
   *        through the UI in the normal ways. Programmatic closing is
   *        still possible.
   */ constructor(player, options){
        super(player, options);
        this.handleKeyDown_ = (e)=>this.handleKeyDown(e);
        this.close_ = (e)=>this.close(e);
        this.opened_ = this.hasBeenOpened_ = this.hasBeenFilled_ = false;
        this.closeable(!this.options_.uncloseable);
        this.content(this.options_.content);
        // Make sure the contentEl is defined AFTER any children are initialized
        // because we only want the contents of the modal in the contentEl
        // (not the UI elements like the close button).
        this.contentEl_ = $86defbb4e95ebb07$var$createEl('div', {
            className: `${$86defbb4e95ebb07$var$MODAL_CLASS_NAME}-content`
        }, {
            role: 'document'
        });
        this.descEl_ = $86defbb4e95ebb07$var$createEl('p', {
            className: `${$86defbb4e95ebb07$var$MODAL_CLASS_NAME}-description vjs-control-text`,
            id: this.el().getAttribute('aria-describedby')
        });
        $86defbb4e95ebb07$var$textContent(this.descEl_, this.description());
        this.el_.appendChild(this.descEl_);
        this.el_.appendChild(this.contentEl_);
    }
    /**
   * Create the `ModalDialog`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        return super.createEl('div', {
            className: this.buildCSSClass(),
            tabIndex: -1
        }, {
            'aria-describedby': `${this.id()}_description`,
            'aria-hidden': 'true',
            'aria-label': this.label(),
            'role': 'dialog',
            'aria-live': 'polite'
        });
    }
    dispose() {
        this.contentEl_ = null;
        this.descEl_ = null;
        this.previouslyActiveEl_ = null;
        super.dispose();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `${$86defbb4e95ebb07$var$MODAL_CLASS_NAME} vjs-hidden ${super.buildCSSClass()}`;
    }
    /**
   * Returns the label string for this modal. Primarily used for accessibility.
   *
   * @return {string}
   *         the localized or raw label of this modal.
   */ label() {
        return this.localize(this.options_.label || 'Modal Window');
    }
    /**
   * Returns the description string for this modal. Primarily used for
   * accessibility.
   *
   * @return {string}
   *         The localized or raw description of this modal.
   */ description() {
        let desc = this.options_.description || this.localize('This is a modal window.');
        // Append a universal closeability message if the modal is closeable.
        if (this.closeable()) desc += ' ' + this.localize('This modal can be closed by pressing the Escape key or activating the close button.');
        return desc;
    }
    /**
   * Opens the modal.
   *
   * @fires ModalDialog#beforemodalopen
   * @fires ModalDialog#modalopen
   */ open() {
        if (this.opened_) {
            if (this.options_.fillAlways) this.fill();
            return;
        }
        const player = this.player();
        /**
      * Fired just before a `ModalDialog` is opened.
      *
      * @event ModalDialog#beforemodalopen
      * @type {Event}
      */ this.trigger('beforemodalopen');
        this.opened_ = true;
        // Fill content if the modal has never opened before and
        // never been filled.
        if (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) this.fill();
        // If the player was playing, pause it and take note of its previously
        // playing state.
        this.wasPlaying_ = !player.paused();
        if (this.options_.pauseOnOpen && this.wasPlaying_) player.pause();
        this.on('keydown', this.handleKeyDown_);
        // Hide controls and note if they were enabled.
        this.hadControls_ = player.controls();
        player.controls(false);
        this.show();
        this.conditionalFocus_();
        this.el().setAttribute('aria-hidden', 'false');
        /**
      * Fired just after a `ModalDialog` is opened.
      *
      * @event ModalDialog#modalopen
      * @type {Event}
      */ this.trigger('modalopen');
        this.hasBeenOpened_ = true;
    }
    /**
   * If the `ModalDialog` is currently open or closed.
   *
   * @param  {boolean} [value]
   *         If given, it will open (`true`) or close (`false`) the modal.
   *
   * @return {boolean}
   *         the current open state of the modaldialog
   */ opened(value) {
        if (typeof value === 'boolean') this[value ? 'open' : 'close']();
        return this.opened_;
    }
    /**
   * Closes the modal, does nothing if the `ModalDialog` is
   * not open.
   *
   * @fires ModalDialog#beforemodalclose
   * @fires ModalDialog#modalclose
   */ close() {
        if (!this.opened_) return;
        const player = this.player();
        /**
      * Fired just before a `ModalDialog` is closed.
      *
      * @event ModalDialog#beforemodalclose
      * @type {Event}
      */ this.trigger('beforemodalclose');
        this.opened_ = false;
        if (this.wasPlaying_ && this.options_.pauseOnOpen) player.play();
        this.off('keydown', this.handleKeyDown_);
        if (this.hadControls_) player.controls(true);
        this.hide();
        this.el().setAttribute('aria-hidden', 'true');
        /**
      * Fired just after a `ModalDialog` is closed.
      *
      * @event ModalDialog#modalclose
      * @type {Event}
      *
      * @property {boolean} [bubbles=true]
      */ this.trigger({
            type: 'modalclose',
            bubbles: true
        });
        this.conditionalBlur_();
        if (this.options_.temporary) this.dispose();
    }
    /**
   * Check to see if the `ModalDialog` is closeable via the UI.
   *
   * @param  {boolean} [value]
   *         If given as a boolean, it will set the `closeable` option.
   *
   * @return {boolean}
   *         Returns the final value of the closable option.
   */ closeable(value) {
        if (typeof value === 'boolean') {
            const closeable = this.closeable_ = !!value;
            let close = this.getChild('closeButton');
            // If this is being made closeable and has no close button, add one.
            if (closeable && !close) {
                // The close button should be a child of the modal - not its
                // content element, so temporarily change the content element.
                const temp = this.contentEl_;
                this.contentEl_ = this.el_;
                close = this.addChild('closeButton', {
                    controlText: 'Close Modal Dialog'
                });
                this.contentEl_ = temp;
                this.on(close, 'close', this.close_);
            }
            // If this is being made uncloseable and has a close button, remove it.
            if (!closeable && close) {
                this.off(close, 'close', this.close_);
                this.removeChild(close);
                close.dispose();
            }
        }
        return this.closeable_;
    }
    /**
   * Fill the modal's content element with the modal's "content" option.
   * The content element will be emptied before this change takes place.
   */ fill() {
        this.fillWith(this.content());
    }
    /**
   * Fill the modal's content element with arbitrary content.
   * The content element will be emptied before this change takes place.
   *
   * @fires ModalDialog#beforemodalfill
   * @fires ModalDialog#modalfill
   *
   * @param {ContentDescriptor} [content]
   *        The same rules apply to this as apply to the `content` option.
   */ fillWith(content) {
        const contentEl = this.contentEl();
        const parentEl = contentEl.parentNode;
        const nextSiblingEl = contentEl.nextSibling;
        /**
      * Fired just before a `ModalDialog` is filled with content.
      *
      * @event ModalDialog#beforemodalfill
      * @type {Event}
      */ this.trigger('beforemodalfill');
        this.hasBeenFilled_ = true;
        // Detach the content element from the DOM before performing
        // manipulation to avoid modifying the live DOM multiple times.
        parentEl.removeChild(contentEl);
        this.empty();
        $86defbb4e95ebb07$var$insertContent(contentEl, content);
        /**
     * Fired just after a `ModalDialog` is filled with content.
     *
     * @event ModalDialog#modalfill
     * @type {Event}
     */ this.trigger('modalfill');
        // Re-inject the re-filled content element.
        if (nextSiblingEl) parentEl.insertBefore(contentEl, nextSiblingEl);
        else parentEl.appendChild(contentEl);
        // make sure that the close button is last in the dialog DOM
        const closeButton = this.getChild('closeButton');
        if (closeButton) parentEl.appendChild(closeButton.el_);
        /**
     * Fired after `ModalDialog` is re-filled with content & close button is appended.
     *
     * @event ModalDialog#aftermodalfill
     * @type {Event}
     */ this.trigger('aftermodalfill');
    }
    /**
   * Empties the content element. This happens anytime the modal is filled.
   *
   * @fires ModalDialog#beforemodalempty
   * @fires ModalDialog#modalempty
   */ empty() {
        /**
    * Fired just before a `ModalDialog` is emptied.
    *
    * @event ModalDialog#beforemodalempty
    * @type {Event}
    */ this.trigger('beforemodalempty');
        $86defbb4e95ebb07$var$emptyEl(this.contentEl());
        /**
    * Fired just after a `ModalDialog` is emptied.
    *
    * @event ModalDialog#modalempty
    * @type {Event}
    */ this.trigger('modalempty');
    }
    /**
   * Gets or sets the modal content, which gets normalized before being
   * rendered into the DOM.
   *
   * This does not update the DOM or fill the modal, but it is called during
   * that process.
   *
   * @param  {ContentDescriptor} [value]
   *         If defined, sets the internal content value to be used on the
   *         next call(s) to `fill`. This value is normalized before being
   *         inserted. To "clear" the internal content value, pass `null`.
   *
   * @return {ContentDescriptor}
   *         The current content of the modal dialog
   */ content(value) {
        if (typeof value !== 'undefined') this.content_ = value;
        return this.content_;
    }
    /**
   * conditionally focus the modal dialog if focus was previously on the player.
   *
   * @private
   */ conditionalFocus_() {
        const activeEl = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).activeElement;
        const playerEl = this.player_.el_;
        this.previouslyActiveEl_ = null;
        if (playerEl.contains(activeEl) || playerEl === activeEl) {
            this.previouslyActiveEl_ = activeEl;
            this.focus();
        }
    }
    /**
   * conditionally blur the element and refocus the last focused element
   *
   * @private
   */ conditionalBlur_() {
        if (this.previouslyActiveEl_) {
            this.previouslyActiveEl_.focus();
            this.previouslyActiveEl_ = null;
        }
    }
    /**
   * Keydown handler. Attached when modal is focused.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        /**
     * Fired a custom keyDown event that bubbles.
     *
     * @event ModalDialog#modalKeydown
     * @type {Event}
     */ this.trigger({
            type: 'modalKeydown',
            originalEvent: event,
            target: this,
            bubbles: true
        });
        // Do not allow keydowns to reach out of the modal dialog.
        event.stopPropagation();
        if (event.key === 'Escape' && this.closeable()) {
            event.preventDefault();
            this.close();
            return;
        }
        // exit early if it isn't a tab key
        if (event.key !== 'Tab') return;
        const focusableEls = this.focusableEls_();
        const activeEl = this.el_.querySelector(':focus');
        let focusIndex;
        for(let i = 0; i < focusableEls.length; i++)if (activeEl === focusableEls[i]) {
            focusIndex = i;
            break;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).activeElement === this.el_) focusIndex = 0;
        if (event.shiftKey && focusIndex === 0) {
            focusableEls[focusableEls.length - 1].focus();
            event.preventDefault();
        } else if (!event.shiftKey && focusIndex === focusableEls.length - 1) {
            focusableEls[0].focus();
            event.preventDefault();
        }
    }
    /**
   * get all focusable elements
   *
   * @private
   */ focusableEls_() {
        const allChildren = this.el_.querySelectorAll('*');
        return Array.prototype.filter.call(allChildren, (child)=>{
            return (child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).HTMLAnchorElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).HTMLAreaElement) && child.hasAttribute('href') || (child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).HTMLInputElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).HTMLSelectElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).HTMLTextAreaElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).HTMLButtonElement) && !child.hasAttribute('disabled') || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).HTMLIFrameElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).HTMLObjectElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).HTMLEmbedElement || child.hasAttribute('tabindex') && child.getAttribute('tabindex') !== -1 || child.hasAttribute('contenteditable');
        });
    }
}
/**
 * Default options for `ModalDialog` default options.
 *
 * @type {Object}
 * @private
 */ $86defbb4e95ebb07$var$ModalDialog.prototype.options_ = {
    pauseOnOpen: true,
    temporary: true
};
$86defbb4e95ebb07$var$Component$1.registerComponent('ModalDialog', $86defbb4e95ebb07$var$ModalDialog);
/**
 * @file track-list.js
 */ /** @import Track from './track' */ /**
 * Common functionaliy between {@link TextTrackList}, {@link AudioTrackList}, and
 * {@link VideoTrackList}
 *
 * @extends EventTarget
 */ class $86defbb4e95ebb07$var$TrackList extends $86defbb4e95ebb07$var$EventTarget$2 {
    /**
   * Create an instance of this class
   *
   * @param { Track[] } tracks
   *        A list of tracks to initialize the list with.
   *
   * @abstract
   */ constructor(tracks = []){
        super();
        this.tracks_ = [];
        for(let i = 0; i < tracks.length; i++)this.addTrack(tracks[i]);
    }
    /**
   * The current number of `Track`s in this TrackList.
   *
   * @type {number}
   */ get length() {
        return this.tracks_.length;
    }
    /**
   * Add a {@link Track} to the `TrackList`
   *
   * @param {Track} track
   *        The audio, video, or text track to add to the list.
   *
   * @fires TrackList#addtrack
   */ addTrack(track) {
        const index = this.tracks_.length;
        if (!('' + index in this)) Object.defineProperty(this, index, {
            get () {
                return this.tracks_[index];
            }
        });
        // Do not add duplicate tracks
        if (this.tracks_.indexOf(track) === -1) {
            this.tracks_.push(track);
            /**
       * Triggered when a track is added to a track list.
       *
       * @event TrackList#addtrack
       * @type {Event}
       * @property {Track} track
       *           A reference to track that was added.
       */ this.trigger({
                track: track,
                type: 'addtrack',
                target: this
            });
        }
        /**
     * Triggered when a track label is changed.
     *
     * @event TrackList#labelchange
     * @type {Event}
     * @property {Track} track
     *           A reference to track whose label was changed.
     */ track.labelchange_ = ()=>{
            this.trigger({
                track: track,
                type: 'labelchange',
                target: this
            });
        };
        if ($86defbb4e95ebb07$var$isEvented(track)) track.addEventListener('labelchange', track.labelchange_);
    }
    /**
   * Remove a {@link Track} from the `TrackList`
   *
   * @param {Track} rtrack
   *        The audio, video, or text track to remove from the list.
   *
   * @fires TrackList#removetrack
   */ removeTrack(rtrack) {
        let track;
        for(let i = 0, l = this.length; i < l; i++)if (this[i] === rtrack) {
            track = this[i];
            if (track.off) track.off();
            this.tracks_.splice(i, 1);
            break;
        }
        if (!track) return;
        /**
     * Triggered when a track is removed from track list.
     *
     * @event TrackList#removetrack
     * @type {Event}
     * @property {Track} track
     *           A reference to track that was removed.
     */ this.trigger({
            track: track,
            type: 'removetrack',
            target: this
        });
    }
    /**
   * Get a Track from the TrackList by a tracks id
   *
   * @param {string} id - the id of the track to get
   * @method getTrackById
   * @return {Track}
   * @private
   */ getTrackById(id) {
        let result = null;
        for(let i = 0, l = this.length; i < l; i++){
            const track = this[i];
            if (track.id === id) {
                result = track;
                break;
            }
        }
        return result;
    }
}
/**
 * Triggered when a different track is selected/enabled.
 *
 * @event TrackList#change
 * @type {Event}
 */ /**
 * Events that can be called with on + eventName. See {@link EventHandler}.
 *
 * @property {Object} TrackList#allowedEvents_
 * @protected
 */ $86defbb4e95ebb07$var$TrackList.prototype.allowedEvents_ = {
    change: 'change',
    addtrack: 'addtrack',
    removetrack: 'removetrack',
    labelchange: 'labelchange'
};
// emulate attribute EventHandler support to allow for feature detection
for(const event in $86defbb4e95ebb07$var$TrackList.prototype.allowedEvents_)$86defbb4e95ebb07$var$TrackList.prototype['on' + event] = null;
/**
 * @file audio-track-list.js
 */ /** @import AudioTrack from './audio-track' */ /**
 * Anywhere we call this function we diverge from the spec
 * as we only support one enabled audiotrack at a time
 *
 * @param {AudioTrackList} list
 *        list to work on
 *
 * @param {AudioTrack} track
 *        The track to skip
 *
 * @private
 */ const $86defbb4e95ebb07$var$disableOthers$1 = function(list, track) {
    for(let i = 0; i < list.length; i++){
        if (!Object.keys(list[i]).length || track.id === list[i].id) continue;
        // another audio track is enabled, disable it
        list[i].enabled = false;
    }
};
/**
 * The current list of {@link AudioTrack} for a media file.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist}
 * @extends TrackList
 */ class $86defbb4e95ebb07$var$AudioTrackList extends $86defbb4e95ebb07$var$TrackList {
    /**
   * Create an instance of this class.
   *
   * @param {AudioTrack[]} [tracks=[]]
   *        A list of `AudioTrack` to instantiate the list with.
   */ constructor(tracks = []){
        // make sure only 1 track is enabled
        // sorted from last index to first index
        for(let i = tracks.length - 1; i >= 0; i--)if (tracks[i].enabled) {
            $86defbb4e95ebb07$var$disableOthers$1(tracks, tracks[i]);
            break;
        }
        super(tracks);
        this.changing_ = false;
    }
    /**
   * Add an {@link AudioTrack} to the `AudioTrackList`.
   *
   * @param {AudioTrack} track
   *        The AudioTrack to add to the list
   *
   * @fires TrackList#addtrack
   */ addTrack(track) {
        if (track.enabled) $86defbb4e95ebb07$var$disableOthers$1(this, track);
        super.addTrack(track);
        // native tracks don't have this
        if (!track.addEventListener) return;
        track.enabledChange_ = ()=>{
            // when we are disabling other tracks (since we don't support
            // more than one track at a time) we will set changing_
            // to true so that we don't trigger additional change events
            if (this.changing_) return;
            this.changing_ = true;
            $86defbb4e95ebb07$var$disableOthers$1(this, track);
            this.changing_ = false;
            this.trigger('change');
        };
        /**
     * @listens AudioTrack#enabledchange
     * @fires TrackList#change
     */ track.addEventListener('enabledchange', track.enabledChange_);
    }
    removeTrack(rtrack) {
        super.removeTrack(rtrack);
        if (rtrack.removeEventListener && rtrack.enabledChange_) {
            rtrack.removeEventListener('enabledchange', rtrack.enabledChange_);
            rtrack.enabledChange_ = null;
        }
    }
}
/**
 * @file video-track-list.js
 */ /** @import VideoTrack from './video-track' */ /**
 * Un-select all other {@link VideoTrack}s that are selected.
 *
 * @param {VideoTrackList} list
 *        list to work on
 *
 * @param {VideoTrack} track
 *        The track to skip
 *
 * @private
 */ const $86defbb4e95ebb07$var$disableOthers = function(list, track) {
    for(let i = 0; i < list.length; i++){
        if (!Object.keys(list[i]).length || track.id === list[i].id) continue;
        // another video track is enabled, disable it
        list[i].selected = false;
    }
};
/**
 * The current list of {@link VideoTrack} for a video.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist}
 * @extends TrackList
 */ class $86defbb4e95ebb07$var$VideoTrackList extends $86defbb4e95ebb07$var$TrackList {
    /**
   * Create an instance of this class.
   *
   * @param {VideoTrack[]} [tracks=[]]
   *        A list of `VideoTrack` to instantiate the list with.
   */ constructor(tracks = []){
        // make sure only 1 track is enabled
        // sorted from last index to first index
        for(let i = tracks.length - 1; i >= 0; i--)if (tracks[i].selected) {
            $86defbb4e95ebb07$var$disableOthers(tracks, tracks[i]);
            break;
        }
        super(tracks);
        this.changing_ = false;
        /**
     * @member {number} VideoTrackList#selectedIndex
     *         The current index of the selected {@link VideoTrack`}.
     */ Object.defineProperty(this, 'selectedIndex', {
            get () {
                for(let i = 0; i < this.length; i++){
                    if (this[i].selected) return i;
                }
                return -1;
            },
            set () {}
        });
    }
    /**
   * Add a {@link VideoTrack} to the `VideoTrackList`.
   *
   * @param {VideoTrack} track
   *        The VideoTrack to add to the list
   *
   * @fires TrackList#addtrack
   */ addTrack(track) {
        if (track.selected) $86defbb4e95ebb07$var$disableOthers(this, track);
        super.addTrack(track);
        // native tracks don't have this
        if (!track.addEventListener) return;
        track.selectedChange_ = ()=>{
            if (this.changing_) return;
            this.changing_ = true;
            $86defbb4e95ebb07$var$disableOthers(this, track);
            this.changing_ = false;
            this.trigger('change');
        };
        /**
     * @listens VideoTrack#selectedchange
     * @fires TrackList#change
     */ track.addEventListener('selectedchange', track.selectedChange_);
    }
    removeTrack(rtrack) {
        super.removeTrack(rtrack);
        if (rtrack.removeEventListener && rtrack.selectedChange_) {
            rtrack.removeEventListener('selectedchange', rtrack.selectedChange_);
            rtrack.selectedChange_ = null;
        }
    }
}
/**
 * @file text-track-list.js
 */ /** @import TextTrack from './text-track' */ /**
 * The current list of {@link TextTrack} for a media file.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist}
 * @extends TrackList
 */ class $86defbb4e95ebb07$var$TextTrackList extends $86defbb4e95ebb07$var$TrackList {
    /**
   * Add a {@link TextTrack} to the `TextTrackList`
   *
   * @param {TextTrack} track
   *        The text track to add to the list.
   *
   * @fires TrackList#addtrack
   */ addTrack(track) {
        super.addTrack(track);
        if (!this.queueChange_) this.queueChange_ = ()=>this.queueTrigger('change');
        if (!this.triggerSelectedlanguagechange) this.triggerSelectedlanguagechange_ = ()=>this.trigger('selectedlanguagechange');
        /**
     * @listens TextTrack#modechange
     * @fires TrackList#change
     */ track.addEventListener('modechange', this.queueChange_);
        const nonLanguageTextTrackKind = [
            'metadata',
            'chapters'
        ];
        if (nonLanguageTextTrackKind.indexOf(track.kind) === -1) track.addEventListener('modechange', this.triggerSelectedlanguagechange_);
    }
    removeTrack(rtrack) {
        super.removeTrack(rtrack);
        // manually remove the event handlers we added
        if (rtrack.removeEventListener) {
            if (this.queueChange_) rtrack.removeEventListener('modechange', this.queueChange_);
            if (this.selectedlanguagechange_) rtrack.removeEventListener('modechange', this.triggerSelectedlanguagechange_);
        }
    }
    /**
   * Creates a serializable array of objects that contains serialized copies
   * of each text track.
   *
   * @return {Object[]} A serializable list of objects for the text track list
   */ toJSON() {
        return this.tracks_.map((track)=>track.toJSON());
    }
}
/**
 * @file html-track-element-list.js
 */ /**
 * The current list of {@link HtmlTrackElement}s.
 */ class $86defbb4e95ebb07$var$HtmlTrackElementList {
    /**
   * Create an instance of this class.
   *
   * @param {HtmlTrackElement[]} [tracks=[]]
   *        A list of `HtmlTrackElement` to instantiate the list with.
   */ constructor(trackElements = []){
        this.trackElements_ = [];
        /**
     * @memberof HtmlTrackElementList
     * @member {number} length
     *         The current number of `Track`s in the this Trackist.
     * @instance
     */ Object.defineProperty(this, 'length', {
            get () {
                return this.trackElements_.length;
            }
        });
        for(let i = 0, length = trackElements.length; i < length; i++)this.addTrackElement_(trackElements[i]);
    }
    /**
   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to add to the list.
   *
   * @private
   */ addTrackElement_(trackElement) {
        const index = this.trackElements_.length;
        if (!('' + index in this)) Object.defineProperty(this, index, {
            get () {
                return this.trackElements_[index];
            }
        });
        // Do not add duplicate elements
        if (this.trackElements_.indexOf(trackElement) === -1) this.trackElements_.push(trackElement);
    }
    /**
   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
   * {@link TextTrack}.
   *
   * @param {TextTrack} track
   *        The track associated with a track element.
   *
   * @return {HtmlTrackElement|undefined}
   *         The track element that was found or undefined.
   *
   * @private
   */ getTrackElementByTrack_(track) {
        let trackElement_;
        for(let i = 0, length = this.trackElements_.length; i < length; i++)if (track === this.trackElements_[i].track) {
            trackElement_ = this.trackElements_[i];
            break;
        }
        return trackElement_;
    }
    /**
   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to remove from the list.
   *
   * @private
   */ removeTrackElement_(trackElement) {
        for(let i = 0, length = this.trackElements_.length; i < length; i++)if (trackElement === this.trackElements_[i]) {
            if (this.trackElements_[i].track && typeof this.trackElements_[i].track.off === 'function') this.trackElements_[i].track.off();
            if (typeof this.trackElements_[i].off === 'function') this.trackElements_[i].off();
            this.trackElements_.splice(i, 1);
            break;
        }
    }
}
/**
 * @file text-track-cue-list.js
 */ /**
 * @typedef {Object} TextTrackCueList~TextTrackCue
 *
 * @property {string} id
 *           The unique id for this text track cue
 *
 * @property {number} startTime
 *           The start time for this text track cue
 *
 * @property {number} endTime
 *           The end time for this text track cue
 *
 * @property {boolean} pauseOnExit
 *           Pause when the end time is reached if true.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcue}
 */ /**
 * A List of TextTrackCues.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcuelist}
 */ class $86defbb4e95ebb07$var$TextTrackCueList {
    /**
   * Create an instance of this class..
   *
   * @param {Array} cues
   *        A list of cues to be initialized with
   */ constructor(cues){
        $86defbb4e95ebb07$var$TextTrackCueList.prototype.setCues_.call(this, cues);
        /**
     * @memberof TextTrackCueList
     * @member {number} length
     *         The current number of `TextTrackCue`s in the TextTrackCueList.
     * @instance
     */ Object.defineProperty(this, 'length', {
            get () {
                return this.length_;
            }
        });
    }
    /**
   * A setter for cues in this list. Creates getters
   * an an index for the cues.
   *
   * @param {Array} cues
   *        An array of cues to set
   *
   * @private
   */ setCues_(cues) {
        const oldLength = this.length || 0;
        let i = 0;
        const l = cues.length;
        this.cues_ = cues;
        this.length_ = cues.length;
        const defineProp = function(index) {
            if (!('' + index in this)) Object.defineProperty(this, '' + index, {
                get () {
                    return this.cues_[index];
                }
            });
        };
        if (oldLength < l) {
            i = oldLength;
            for(; i < l; i++)defineProp.call(this, i);
        }
    }
    /**
   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
   *
   * @param {string} id
   *        The id of the cue that should be searched for.
   *
   * @return {TextTrackCueList~TextTrackCue|null}
   *         A single cue or null if none was found.
   */ getCueById(id) {
        let result = null;
        for(let i = 0, l = this.length; i < l; i++){
            const cue = this[i];
            if (cue.id === id) {
                result = cue;
                break;
            }
        }
        return result;
    }
}
/**
 * @file track-kinds.js
 */ /**
 * All possible `VideoTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
 * @typedef VideoTrack~Kind
 * @enum
 */ const $86defbb4e95ebb07$var$VideoTrackKind = {
    alternative: 'alternative',
    captions: 'captions',
    main: 'main',
    sign: 'sign',
    subtitles: 'subtitles',
    commentary: 'commentary'
};
/**
 * All possible `AudioTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
 * @typedef AudioTrack~Kind
 * @enum
 */ const $86defbb4e95ebb07$var$AudioTrackKind = {
    'alternative': 'alternative',
    'descriptions': 'descriptions',
    'main': 'main',
    'main-desc': 'main-desc',
    'translation': 'translation',
    'commentary': 'commentary'
};
/**
 * All possible `TextTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-texttrack-kind
 * @typedef TextTrack~Kind
 * @enum
 */ const $86defbb4e95ebb07$var$TextTrackKind = {
    subtitles: 'subtitles',
    captions: 'captions',
    descriptions: 'descriptions',
    chapters: 'chapters',
    metadata: 'metadata'
};
/**
 * All possible `TextTrackMode`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
 * @typedef TextTrack~Mode
 * @enum
 */ const $86defbb4e95ebb07$var$TextTrackMode = {
    disabled: 'disabled',
    hidden: 'hidden',
    showing: 'showing'
};
/**
 * @file track.js
 */ /**
 * A Track class that contains all of the common functionality for {@link AudioTrack},
 * {@link VideoTrack}, and {@link TextTrack}.
 *
 * > Note: This class should not be used directly
 *
 * @see {@link https://html.spec.whatwg.org/multipage/embedded-content.html}
 * @extends EventTarget
 * @abstract
 */ class $86defbb4e95ebb07$var$Track extends $86defbb4e95ebb07$var$EventTarget$2 {
    /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid kind for the track type you are creating.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @abstract
   */ constructor(options = {}){
        super();
        const trackProps = {
            id: options.id || 'vjs_track_' + $86defbb4e95ebb07$var$newGUID(),
            kind: options.kind || '',
            language: options.language || ''
        };
        let label = options.label || '';
        /**
     * @memberof Track
     * @member {string} id
     *         The id of this track. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */ /**
     * @memberof Track
     * @member {string} kind
     *         The kind of track that this is. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */ /**
     * @memberof Track
     * @member {string} language
     *         The two letter language code for this track. Cannot be changed after
     *         creation.
     * @instance
     *
     * @readonly
     */ for(const key in trackProps)Object.defineProperty(this, key, {
            get () {
                return trackProps[key];
            },
            set () {}
        });
        /**
     * @memberof Track
     * @member {string} label
     *         The label of this track. Cannot be changed after creation.
     * @instance
     *
     * @fires Track#labelchange
     */ Object.defineProperty(this, 'label', {
            get () {
                return label;
            },
            set (newLabel) {
                if (newLabel !== label) {
                    label = newLabel;
                    /**
           * An event that fires when label changes on this track.
           *
           * > Note: This is not part of the spec!
           *
           * @event Track#labelchange
           * @type {Event}
           */ this.trigger('labelchange');
                }
            }
        });
    }
}
/**
 * @file url.js
 * @module url
 */ /**
 * Resolve and parse the elements of a URL.
 *
 * @function
 * @param    {string} url
 *           The url to parse
 *
 * @return   {URL}
 *           An object of url details
 */ const $86defbb4e95ebb07$var$parseUrl = function(url) {
    return new URL(url, (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).baseURI);
};
/**
 * Get absolute version of relative URL.
 *
 * @function
 * @param    {string} url
 *           URL to make absolute
 *
 * @return   {string}
 *           Absolute URL
 */ const $86defbb4e95ebb07$var$getAbsoluteURL = function(url) {
    return new URL(url, (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).baseURI).href;
};
/**
 * Returns the extension of the passed file name. It will return an empty string
 * if passed an invalid path.
 *
 * @function
 * @param    {string} path
 *           The fileName path like '/path/to/file.mp4'
 *
 * @return  {string}
 *           The extension in lower case or an empty string if no
 *           extension could be found.
 */ const $86defbb4e95ebb07$var$getFileExtension = function(path) {
    if (typeof path === 'string') {
        const cleanPath = path.split('?')[0].replace(/\/+$/, '');
        const match = cleanPath.match(/\.([^.\/]+)$/);
        return match ? match[1].toLowerCase() : '';
    }
    return '';
};
/**
 * Returns whether the url passed is a cross domain request or not.
 *
 * @function
 * @param    {string} url
 *           The url to check.
 *
 * @param    {URL} [winLoc]
 *           the domain to check the url against, defaults to window.location
 *
 * @return   {boolean}
 *           Whether it is a cross domain request or not.
 */ const $86defbb4e95ebb07$var$isCrossOrigin = function(url, winLoc = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).location) {
    return $86defbb4e95ebb07$var$parseUrl(url).origin !== winLoc.origin;
};
var $86defbb4e95ebb07$var$Url = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    parseUrl: $86defbb4e95ebb07$var$parseUrl,
    getAbsoluteURL: $86defbb4e95ebb07$var$getAbsoluteURL,
    getFileExtension: $86defbb4e95ebb07$var$getFileExtension,
    isCrossOrigin: $86defbb4e95ebb07$var$isCrossOrigin
});
/**
 * @file text-track.js
 */ /** @import Tech from '../tech/tech' */ /**
 * Takes a webvtt file contents and parses it into cues
 *
 * @param {string} srcContent
 *        webVTT file contents
 *
 * @param {TextTrack} track
 *        TextTrack to add cues to. Cues come from the srcContent.
 *
 * @private
 */ const $86defbb4e95ebb07$var$parseCues = function(srcContent, track) {
    const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT.Parser((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))), (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).vttjs, (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT.StringDecoder());
    const errors = [];
    parser.oncue = function(cue) {
        track.addCue(cue);
    };
    parser.onparsingerror = function(error) {
        errors.push(error);
    };
    parser.onflush = function() {
        track.trigger({
            type: 'loadeddata',
            target: track
        });
    };
    parser.parse(srcContent);
    if (errors.length > 0) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).console && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).console.groupCollapsed) (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).console.groupCollapsed(`Text Track parsing errors for ${track.src}`);
        errors.forEach((error)=>$86defbb4e95ebb07$var$log$1.error(error));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).console && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).console.groupEnd) (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).console.groupEnd();
    }
    parser.flush();
};
/**
 * Load a `TextTrack` from a specified url.
 *
 * @param {string} src
 *        Url to load track from.
 *
 * @param {TextTrack} track
 *        Track to add cues to. Comes from the content at the end of `url`.
 *
 * @private
 */ const $86defbb4e95ebb07$var$loadTrack = function(src, track) {
    const opts = {
        uri: src
    };
    const crossOrigin = $86defbb4e95ebb07$var$isCrossOrigin(src);
    if (crossOrigin) opts.cors = crossOrigin;
    const withCredentials = track.tech_.crossOrigin() === 'use-credentials';
    if (withCredentials) opts.withCredentials = withCredentials;
    (0, (/*@__PURE__*/$parcel$interopDefault($f0ff6da7e6f661dc$exports)))(opts, $86defbb4e95ebb07$var$bind_(this, function(err, response, responseBody) {
        if (err) return $86defbb4e95ebb07$var$log$1.error(err, response);
        track.loaded_ = true;
        // Make sure that vttjs has loaded, otherwise, wait till it finished loading
        // NOTE: this is only used for the alt/video.novtt.js build
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT !== 'function') {
            if (track.tech_) // to prevent use before define eslint error, we define loadHandler
            // as a let here
            track.tech_.any([
                'vttjsloaded',
                'vttjserror'
            ], (event)=>{
                if (event.type === 'vttjserror') {
                    $86defbb4e95ebb07$var$log$1.error(`vttjs failed to load, stopping trying to process ${track.src}`);
                    return;
                }
                return $86defbb4e95ebb07$var$parseCues(responseBody, track);
            });
        } else $86defbb4e95ebb07$var$parseCues(responseBody, track);
    }));
};
/**
 * A representation of a single `TextTrack`.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrack}
 * @extends Track
 */ class $86defbb4e95ebb07$var$TextTrack extends $86defbb4e95ebb07$var$Track {
    /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this TextTrack.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */ constructor(options = {}){
        if (!options.tech) throw new Error('A tech was not provided.');
        const settings = $86defbb4e95ebb07$var$merge$1(options, {
            kind: $86defbb4e95ebb07$var$TextTrackKind[options.kind] || 'subtitles',
            language: options.language || options.srclang || ''
        });
        let mode = $86defbb4e95ebb07$var$TextTrackMode[settings.mode] || 'disabled';
        const default_ = settings.default;
        if (settings.kind === 'metadata' || settings.kind === 'chapters') mode = 'hidden';
        super(settings);
        this.tech_ = settings.tech;
        this.cues_ = [];
        this.activeCues_ = [];
        this.preload_ = this.tech_.preloadTextTracks !== false;
        const cues = new $86defbb4e95ebb07$var$TextTrackCueList(this.cues_);
        const activeCues = new $86defbb4e95ebb07$var$TextTrackCueList(this.activeCues_);
        let changed = false;
        this.timeupdateHandler = $86defbb4e95ebb07$var$bind_(this, function(event = {}) {
            if (this.tech_.isDisposed()) return;
            if (!this.tech_.isReady_) {
                if (event.type !== 'timeupdate') this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
                return;
            }
            // Accessing this.activeCues for the side-effects of updating itself
            // due to its nature as a getter function. Do not remove or cues will
            // stop updating!
            // Use the setter to prevent deletion from uglify (pure_getters rule)
            this.activeCues = this.activeCues;
            if (changed) {
                this.trigger('cuechange');
                changed = false;
            }
            if (event.type !== 'timeupdate') this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
        });
        const disposeHandler = ()=>{
            this.stopTracking();
        };
        this.tech_.one('dispose', disposeHandler);
        if (mode !== 'disabled') this.startTracking();
        Object.defineProperties(this, {
            /**
       * @memberof TextTrack
       * @member {boolean} default
       *         If this track was set to be on or off by default. Cannot be changed after
       *         creation.
       * @instance
       *
       * @readonly
       */ default: {
                get () {
                    return default_;
                },
                set () {}
            },
            /**
       * @memberof TextTrack
       * @member {string} mode
       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
       *         not be set if setting to an invalid mode.
       * @instance
       *
       * @fires TextTrack#modechange
       */ mode: {
                get () {
                    return mode;
                },
                set (newMode) {
                    if (!$86defbb4e95ebb07$var$TextTrackMode[newMode]) return;
                    if (mode === newMode) return;
                    mode = newMode;
                    if (!this.preload_ && mode !== 'disabled' && this.cues.length === 0) // On-demand load.
                    $86defbb4e95ebb07$var$loadTrack(this.src, this);
                    this.stopTracking();
                    if (mode !== 'disabled') this.startTracking();
                    /**
           * An event that fires when mode changes on this track. This allows
           * the TextTrackList that holds this track to act accordingly.
           *
           * > Note: This is not part of the spec!
           *
           * @event TextTrack#modechange
           * @type {Event}
           */ this.trigger('modechange');
                }
            },
            /**
       * @memberof TextTrack
       * @member {TextTrackCueList} cues
       *         The text track cue list for this TextTrack.
       * @instance
       */ cues: {
                get () {
                    if (!this.loaded_) return null;
                    return cues;
                },
                set () {}
            },
            /**
       * @memberof TextTrack
       * @member {TextTrackCueList} activeCues
       *         The list text track cues that are currently active for this TextTrack.
       * @instance
       */ activeCues: {
                get () {
                    if (!this.loaded_) return null;
                    // nothing to do
                    if (this.cues.length === 0) return activeCues;
                    const ct = this.tech_.currentTime();
                    const active = [];
                    for(let i = 0, l = this.cues.length; i < l; i++){
                        const cue = this.cues[i];
                        if (cue.startTime <= ct && cue.endTime >= ct) active.push(cue);
                    }
                    changed = false;
                    if (active.length !== this.activeCues_.length) changed = true;
                    else {
                        for(let i = 0; i < active.length; i++)if (this.activeCues_.indexOf(active[i]) === -1) changed = true;
                    }
                    this.activeCues_ = active;
                    activeCues.setCues_(this.activeCues_);
                    return activeCues;
                },
                // /!\ Keep this setter empty (see the timeupdate handler above)
                set () {}
            }
        });
        if (settings.src) {
            this.src = settings.src;
            if (!this.preload_) // Tracks will load on-demand.
            // Act like we're loaded for other purposes.
            this.loaded_ = true;
            if (this.preload_ || settings.kind !== 'subtitles' && settings.kind !== 'captions') $86defbb4e95ebb07$var$loadTrack(this.src, this);
        } else this.loaded_ = true;
    }
    startTracking() {
        // More precise cues based on requestVideoFrameCallback with a requestAnimationFram fallback
        this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
        // Also listen to timeupdate in case rVFC/rAF stops (window in background, audio in video el)
        this.tech_.on('timeupdate', this.timeupdateHandler);
    }
    stopTracking() {
        if (this.rvf_) {
            this.tech_.cancelVideoFrameCallback(this.rvf_);
            this.rvf_ = undefined;
        }
        this.tech_.off('timeupdate', this.timeupdateHandler);
    }
    /**
   * Add a cue to the internal list of cues.
   *
   * @param {TextTrack~Cue} cue
   *        The cue to add to our internal list
   */ addCue(originalCue) {
        let cue = originalCue;
        // Testing if the cue is a VTTCue in a way that survives minification
        if (!('getCueAsHTML' in cue)) {
            cue = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).vttjs.VTTCue(originalCue.startTime, originalCue.endTime, originalCue.text);
            for(const prop in originalCue)if (!(prop in cue)) cue[prop] = originalCue[prop];
            // make sure that `id` is copied over
            cue.id = originalCue.id;
            cue.originalCue_ = originalCue;
        }
        const tracks = this.tech_.textTracks();
        for(let i = 0; i < tracks.length; i++)if (tracks[i] !== this) tracks[i].removeCue(cue);
        this.cues_.push(cue);
        this.cues.setCues_(this.cues_);
    }
    /**
   * Creates a copy of the text track and makes it serializable
   * by removing circular dependencies.
   *
   * @return {Object} The track information as a serializable object
   */ toJSON() {
        return $86defbb4e95ebb07$var$textTrackConverter.trackToJson(this);
    }
    /**
   * Remove a cue from our internal list
   *
   * @param {TextTrack~Cue} removeCue
   *        The cue to remove from our internal list
   */ removeCue(removeCue) {
        let i = this.cues_.length;
        while(i--){
            const cue = this.cues_[i];
            if (cue === removeCue || cue.originalCue_ && cue.originalCue_ === removeCue) {
                this.cues_.splice(i, 1);
                this.cues.setCues_(this.cues_);
                break;
            }
        }
    }
}
/**
 * cuechange - One or more cues in the track have become active or stopped being active.
 *
 * @protected
 */ $86defbb4e95ebb07$var$TextTrack.prototype.allowedEvents_ = {
    cuechange: 'cuechange'
};
/**
 * A representation of a single `AudioTrack`. If it is part of an {@link AudioTrackList}
 * only one `AudioTrack` in the list will be enabled at a time.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack}
 * @extends Track
 */ class $86defbb4e95ebb07$var$AudioTrack extends $86defbb4e95ebb07$var$Track {
    /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {AudioTrack~Kind} [options.kind='']
   *        A valid audio track kind
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.enabled]
   *        If this track is the one that is currently playing. If this track is part of
   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
   */ constructor(options = {}){
        const settings = $86defbb4e95ebb07$var$merge$1(options, {
            kind: $86defbb4e95ebb07$var$AudioTrackKind[options.kind] || ''
        });
        super(settings);
        let enabled = false;
        /**
     * @memberof AudioTrack
     * @member {boolean} enabled
     *         If this `AudioTrack` is enabled or not. When setting this will
     *         fire {@link AudioTrack#enabledchange} if the state of enabled is changed.
     * @instance
     *
     * @fires VideoTrack#selectedchange
     */ Object.defineProperty(this, 'enabled', {
            get () {
                return enabled;
            },
            set (newEnabled) {
                // an invalid or unchanged value
                if (typeof newEnabled !== 'boolean' || newEnabled === enabled) return;
                enabled = newEnabled;
                /**
         * An event that fires when enabled changes on this track. This allows
         * the AudioTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec! Native tracks will do
         *         this internally without an event.
         *
         * @event AudioTrack#enabledchange
         * @type {Event}
         */ this.trigger('enabledchange');
            }
        });
        // if the user sets this track to selected then
        // set selected to that true value otherwise
        // we keep it false
        if (settings.enabled) this.enabled = settings.enabled;
        this.loaded_ = true;
    }
}
/**
 * A representation of a single `VideoTrack`.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack}
 * @extends Track
 */ class $86defbb4e95ebb07$var$VideoTrack extends $86defbb4e95ebb07$var$Track {
    /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid {@link VideoTrack~Kind}
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.selected]
   *        If this track is the one that is currently playing.
   */ constructor(options = {}){
        const settings = $86defbb4e95ebb07$var$merge$1(options, {
            kind: $86defbb4e95ebb07$var$VideoTrackKind[options.kind] || ''
        });
        super(settings);
        let selected = false;
        /**
     * @memberof VideoTrack
     * @member {boolean} selected
     *         If this `VideoTrack` is selected or not. When setting this will
     *         fire {@link VideoTrack#selectedchange} if the state of selected changed.
     * @instance
     *
     * @fires VideoTrack#selectedchange
     */ Object.defineProperty(this, 'selected', {
            get () {
                return selected;
            },
            set (newSelected) {
                // an invalid or unchanged value
                if (typeof newSelected !== 'boolean' || newSelected === selected) return;
                selected = newSelected;
                /**
         * An event that fires when selected changes on this track. This allows
         * the VideoTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec! Native tracks will do
         *         this internally without an event.
         *
         * @event VideoTrack#selectedchange
         * @type {Event}
         */ this.trigger('selectedchange');
            }
        });
        // if the user sets this track to selected then
        // set selected to that true value otherwise
        // we keep it false
        if (settings.selected) this.selected = settings.selected;
    }
}
/**
 * @file html-track-element.js
 */ /** @import Tech from '../tech/tech' */ /**
 * A single track represented in the DOM.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement}
 * @extends EventTarget
 */ class $86defbb4e95ebb07$var$HTMLTrackElement extends $86defbb4e95ebb07$var$EventTarget$2 {
    /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this HTMLTrackElement.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */ constructor(options = {}){
        super();
        let readyState;
        const track = new $86defbb4e95ebb07$var$TextTrack(options);
        this.kind = track.kind;
        this.src = track.src;
        this.srclang = track.language;
        this.label = track.label;
        this.default = track.default;
        Object.defineProperties(this, {
            /**
       * @memberof HTMLTrackElement
       * @member {HTMLTrackElement~ReadyState} readyState
       *         The current ready state of the track element.
       * @instance
       */ readyState: {
                get () {
                    return readyState;
                }
            },
            /**
       * @memberof HTMLTrackElement
       * @member {TextTrack} track
       *         The underlying TextTrack object.
       * @instance
       *
       */ track: {
                get () {
                    return track;
                }
            }
        });
        readyState = $86defbb4e95ebb07$var$HTMLTrackElement.NONE;
        /**
     * @listens TextTrack#loadeddata
     * @fires HTMLTrackElement#load
     */ track.addEventListener('loadeddata', ()=>{
            readyState = $86defbb4e95ebb07$var$HTMLTrackElement.LOADED;
            this.trigger({
                type: 'load',
                target: this
            });
        });
    }
}
/**
 * @protected
 */ $86defbb4e95ebb07$var$HTMLTrackElement.prototype.allowedEvents_ = {
    load: 'load'
};
/**
 * The text track not loaded state.
 *
 * @type {number}
 * @static
 */ $86defbb4e95ebb07$var$HTMLTrackElement.NONE = 0;
/**
 * The text track loading state.
 *
 * @type {number}
 * @static
 */ $86defbb4e95ebb07$var$HTMLTrackElement.LOADING = 1;
/**
 * The text track loaded state.
 *
 * @type {number}
 * @static
 */ $86defbb4e95ebb07$var$HTMLTrackElement.LOADED = 2;
/**
 * The text track failed to load state.
 *
 * @type {number}
 * @static
 */ $86defbb4e95ebb07$var$HTMLTrackElement.ERROR = 3;
/*
 * This file contains all track properties that are used in
 * player.js, tech.js, html5.js and possibly other techs in the future.
 */ const $86defbb4e95ebb07$var$NORMAL = {
    audio: {
        ListClass: $86defbb4e95ebb07$var$AudioTrackList,
        TrackClass: $86defbb4e95ebb07$var$AudioTrack,
        capitalName: 'Audio'
    },
    video: {
        ListClass: $86defbb4e95ebb07$var$VideoTrackList,
        TrackClass: $86defbb4e95ebb07$var$VideoTrack,
        capitalName: 'Video'
    },
    text: {
        ListClass: $86defbb4e95ebb07$var$TextTrackList,
        TrackClass: $86defbb4e95ebb07$var$TextTrack,
        capitalName: 'Text'
    }
};
Object.keys($86defbb4e95ebb07$var$NORMAL).forEach(function(type) {
    $86defbb4e95ebb07$var$NORMAL[type].getterName = `${type}Tracks`;
    $86defbb4e95ebb07$var$NORMAL[type].privateName = `${type}Tracks_`;
});
const $86defbb4e95ebb07$var$REMOTE = {
    remoteText: {
        ListClass: $86defbb4e95ebb07$var$TextTrackList,
        TrackClass: $86defbb4e95ebb07$var$TextTrack,
        capitalName: 'RemoteText',
        getterName: 'remoteTextTracks',
        privateName: 'remoteTextTracks_'
    },
    remoteTextEl: {
        ListClass: $86defbb4e95ebb07$var$HtmlTrackElementList,
        TrackClass: $86defbb4e95ebb07$var$HTMLTrackElement,
        capitalName: 'RemoteTextTrackEls',
        getterName: 'remoteTextTrackEls',
        privateName: 'remoteTextTrackEls_'
    }
};
const $86defbb4e95ebb07$var$ALL = Object.assign({}, $86defbb4e95ebb07$var$NORMAL, $86defbb4e95ebb07$var$REMOTE);
$86defbb4e95ebb07$var$REMOTE.names = Object.keys($86defbb4e95ebb07$var$REMOTE);
$86defbb4e95ebb07$var$NORMAL.names = Object.keys($86defbb4e95ebb07$var$NORMAL);
$86defbb4e95ebb07$var$ALL.names = [].concat($86defbb4e95ebb07$var$REMOTE.names).concat($86defbb4e95ebb07$var$NORMAL.names);
/**
 * @file tech.js
 */ /** @import { TimeRange } from '../utils/time' */ /**
 * An Object containing a structure like: `{src: 'url', type: 'mimetype'}` or string
 * that just contains the src url alone.
 * * `var SourceObject = {src: 'http://ex.com/video.mp4', type: 'video/mp4'};`
   * `var SourceString = 'http://example.com/some-video.mp4';`
 *
 * @typedef {Object|string} SourceObject
 *
 * @property {string} src
 *           The url to the source
 *
 * @property {string} type
 *           The mime type of the source
 */ /**
 * A function used by {@link Tech} to create a new {@link TextTrack}.
 *
 * @private
 *
 * @param {Tech} self
 *        An instance of the Tech class.
 *
 * @param {string} kind
 *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
 *
 * @param {string} [label]
 *        Label to identify the text track
 *
 * @param {string} [language]
 *        Two letter language abbreviation
 *
 * @param {Object} [options={}]
 *        An object with additional text track options
 *
 * @return {TextTrack}
 *          The text track that was created.
 */ function $86defbb4e95ebb07$var$createTrackHelper(self1, kind, label, language, options = {}) {
    const tracks = self1.textTracks();
    options.kind = kind;
    if (label) options.label = label;
    if (language) options.language = language;
    options.tech = self1;
    const track = new $86defbb4e95ebb07$var$ALL.text.TrackClass(options);
    tracks.addTrack(track);
    return track;
}
/**
 * This is the base class for media playback technology controllers, such as
 * {@link HTML5}
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$Tech extends $86defbb4e95ebb07$var$Component$1 {
    /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */ constructor(options = {}, ready = function() {}){
        // we don't want the tech to report user activity automatically.
        // This is done manually in addControlsListeners
        options.reportTouchActivity = false;
        super(null, options, ready);
        this.onDurationChange_ = (e)=>this.onDurationChange(e);
        this.trackProgress_ = (e)=>this.trackProgress(e);
        this.trackCurrentTime_ = (e)=>this.trackCurrentTime(e);
        this.stopTrackingCurrentTime_ = (e)=>this.stopTrackingCurrentTime(e);
        this.disposeSourceHandler_ = (e)=>this.disposeSourceHandler(e);
        this.queuedHanders_ = new Set();
        // keep track of whether the current source has played at all to
        // implement a very limited played()
        this.hasStarted_ = false;
        this.on('playing', function() {
            this.hasStarted_ = true;
        });
        this.on('loadstart', function() {
            this.hasStarted_ = false;
        });
        $86defbb4e95ebb07$var$ALL.names.forEach((name)=>{
            const props = $86defbb4e95ebb07$var$ALL[name];
            if (options && options[props.getterName]) this[props.privateName] = options[props.getterName];
        });
        // Manually track progress in cases where the browser/tech doesn't report it.
        if (!this.featuresProgressEvents) this.manualProgressOn();
        // Manually track timeupdates in cases where the browser/tech doesn't report it.
        if (!this.featuresTimeupdateEvents) this.manualTimeUpdatesOn();
        [
            'Text',
            'Audio',
            'Video'
        ].forEach((track)=>{
            if (options[`native${track}Tracks`] === false) this[`featuresNative${track}Tracks`] = false;
        });
        if (options.nativeCaptions === false || options.nativeTextTracks === false) this.featuresNativeTextTracks = false;
        else if (options.nativeCaptions === true || options.nativeTextTracks === true) this.featuresNativeTextTracks = true;
        if (!this.featuresNativeTextTracks) this.emulateTextTracks();
        this.preloadTextTracks = options.preloadTextTracks !== false;
        this.autoRemoteTextTracks_ = new $86defbb4e95ebb07$var$ALL.text.ListClass();
        this.initTrackListeners();
        // Turn on component tap events only if not using native controls
        if (!options.nativeControlsForTouch) this.emitTapEvents();
        if (this.constructor) this.name_ = this.constructor.name || 'Unknown Tech';
    }
    /**
   * A special function to trigger source set in a way that will allow player
   * to re-trigger if the player or tech are not ready yet.
   *
   * @fires Tech#sourceset
   * @param {string} src The source string at the time of the source changing.
   */ triggerSourceset(src) {
        if (!this.isReady_) // on initial ready we have to trigger source set
        // 1ms after ready so that player can watch for it.
        this.one('ready', ()=>this.setTimeout(()=>this.triggerSourceset(src), 1));
        /**
     * Fired when the source is set on the tech causing the media element
     * to reload.
     *
     * @see {@link Player#event:sourceset}
     * @event Tech#sourceset
     * @type {Event}
     */ this.trigger({
            src: src,
            type: 'sourceset'
        });
    }
    /* Fallbacks for unsupported event types
  ================================================================================ */ /**
   * Polyfill the `progress` event for browsers that don't support it natively.
   *
   * @see {@link Tech#trackProgress}
   */ manualProgressOn() {
        this.on('durationchange', this.onDurationChange_);
        this.manualProgress = true;
        // Trigger progress watching when a source begins loading
        this.one('ready', this.trackProgress_);
    }
    /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   */ manualProgressOff() {
        this.manualProgress = false;
        this.stopTrackingProgress();
        this.off('durationchange', this.onDurationChange_);
    }
    /**
   * This is used to trigger a `progress` event when the buffered percent changes. It
   * sets an interval function that will be called every 500 milliseconds to check if the
   * buffer end percent has changed.
   *
   * > This function is called by {@link Tech#manualProgressOn}
   *
   * @param {Event} event
   *        The `ready` event that caused this to run.
   *
   * @listens Tech#ready
   * @fires Tech#progress
   */ trackProgress(event) {
        this.stopTrackingProgress();
        this.progressInterval = this.setInterval($86defbb4e95ebb07$var$bind_(this, function() {
            // Don't trigger unless buffered amount is greater than last time
            const numBufferedPercent = this.bufferedPercent();
            if (this.bufferedPercent_ !== numBufferedPercent) /**
         * See {@link Player#progress}
         *
         * @event Tech#progress
         * @type {Event}
         */ this.trigger('progress');
            this.bufferedPercent_ = numBufferedPercent;
            if (numBufferedPercent === 1) this.stopTrackingProgress();
        }), 500);
    }
    /**
   * Update our internal duration on a `durationchange` event by calling
   * {@link Tech#duration}.
   *
   * @param {Event} event
   *        The `durationchange` event that caused this to run.
   *
   * @listens Tech#durationchange
   */ onDurationChange(event) {
        this.duration_ = this.duration();
    }
    /**
   * Get and create a `TimeRange` object for buffering.
   *
   * @return {TimeRange}
   *         The time range object that was created.
   */ buffered() {
        return $86defbb4e95ebb07$var$createTimeRanges$1(0, 0);
    }
    /**
   * Get the percentage of the current video that is currently buffered.
   *
   * @return {number}
   *         A number from 0 to 1 that represents the decimal percentage of the
   *         video that is buffered.
   *
   */ bufferedPercent() {
        return $86defbb4e95ebb07$var$bufferedPercent(this.buffered(), this.duration_);
    }
    /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   * Stop manually tracking progress events by clearing the interval that was set in
   * {@link Tech#trackProgress}.
   */ stopTrackingProgress() {
        this.clearInterval(this.progressInterval);
    }
    /**
   * Polyfill the `timeupdate` event for browsers that don't support it.
   *
   * @see {@link Tech#trackCurrentTime}
   */ manualTimeUpdatesOn() {
        this.manualTimeUpdates = true;
        this.on('play', this.trackCurrentTime_);
        this.on('pause', this.stopTrackingCurrentTime_);
    }
    /**
   * Turn off the polyfill for `timeupdate` events that was created in
   * {@link Tech#manualTimeUpdatesOn}
   */ manualTimeUpdatesOff() {
        this.manualTimeUpdates = false;
        this.stopTrackingCurrentTime();
        this.off('play', this.trackCurrentTime_);
        this.off('pause', this.stopTrackingCurrentTime_);
    }
    /**
   * Sets up an interval function to track current time and trigger `timeupdate` every
   * 250 milliseconds.
   *
   * @listens Tech#play
   * @triggers Tech#timeupdate
   */ trackCurrentTime() {
        if (this.currentTimeInterval) this.stopTrackingCurrentTime();
        this.currentTimeInterval = this.setInterval(function() {
            /**
       * Triggered at an interval of 250ms to indicated that time is passing in the video.
       *
       * @event Tech#timeupdate
       * @type {Event}
       */ this.trigger({
                type: 'timeupdate',
                target: this,
                manuallyTriggered: true
            });
        // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
        }, 250);
    }
    /**
   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
   * `timeupdate` event is no longer triggered.
   *
   * @listens {Tech#pause}
   */ stopTrackingCurrentTime() {
        this.clearInterval(this.currentTimeInterval);
        // #1002 - if the video ends right before the next timeupdate would happen,
        // the progress bar won't make it all the way to the end
        this.trigger({
            type: 'timeupdate',
            target: this,
            manuallyTriggered: true
        });
    }
    /**
   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
   *
   * @fires Component#dispose
   */ dispose() {
        // clear out all tracks because we can't reuse them between techs
        this.clearTracks($86defbb4e95ebb07$var$NORMAL.names);
        // Turn off any manual progress or timeupdate tracking
        if (this.manualProgress) this.manualProgressOff();
        if (this.manualTimeUpdates) this.manualTimeUpdatesOff();
        super.dispose();
    }
    /**
   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
   *
   * > Note: Techs without source handlers should call this between sources for `video`
   *         & `audio` tracks. You don't want to use them between tracks!
   *
   * @param {string[]|string} types
   *        TrackList names to clear, valid names are `video`, `audio`, and
   *        `text`.
   */ clearTracks(types) {
        types = [].concat(types);
        // clear out all tracks because we can't reuse them between techs
        types.forEach((type)=>{
            const list = this[`${type}Tracks`]() || [];
            let i = list.length;
            while(i--){
                const track = list[i];
                if (type === 'text') this.removeRemoteTextTrack(track);
                list.removeTrack(track);
            }
        });
    }
    /**
   * Remove any TextTracks added via addRemoteTextTrack that are
   * flagged for automatic garbage collection
   */ cleanupAutoTextTracks() {
        const list = this.autoRemoteTextTracks_ || [];
        let i = list.length;
        while(i--){
            const track = list[i];
            this.removeRemoteTextTrack(track);
        }
    }
    /**
   * Reset the tech, which will removes all sources and reset the internal readyState.
   *
   * @abstract
   */ reset() {}
    /**
   * Get the value of `crossOrigin` from the tech.
   *
   * @abstract
   *
   * @see {Html5#crossOrigin}
   */ crossOrigin() {}
    /**
   * Set the value of `crossOrigin` on the tech.
   *
   * @abstract
   *
   * @param {string} crossOrigin the crossOrigin value
   * @see {Html5#setCrossOrigin}
   */ setCrossOrigin() {}
    /**
   * Get or set an error on the Tech.
   *
   * @param {MediaError} [err]
   *        Error to set on the Tech
   *
   * @return {MediaError|null}
   *         The current error object on the tech, or null if there isn't one.
   */ error(err) {
        if (err !== undefined) {
            this.error_ = new $86defbb4e95ebb07$var$MediaError(err);
            this.trigger('error');
        }
        return this.error_;
    }
    /**
   * Returns the `TimeRange`s that have been played through for the current source.
   *
   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
   *         It only checks whether the source has played at all or not.
   *
   * @return {TimeRange}
   *         - A single time range if this video has played
   *         - An empty set of ranges if not.
   */ played() {
        if (this.hasStarted_) return $86defbb4e95ebb07$var$createTimeRanges$1(0, 0);
        return $86defbb4e95ebb07$var$createTimeRanges$1();
    }
    /**
   * Start playback
   *
   * @abstract
   *
   * @see {Html5#play}
   */ play() {}
    /**
   * Set whether we are scrubbing or not
   *
   * @abstract
   * @param {boolean} _isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   *
   * @see {Html5#setScrubbing}
   */ setScrubbing(_isScrubbing) {}
    /**
   * Get whether we are scrubbing or not
   *
   * @abstract
   *
   * @see {Html5#scrubbing}
   */ scrubbing() {}
    /**
   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
   * previously called.
   *
   * @param {number} _seconds
   *        Set the current time of the media to this.
   * @fires Tech#timeupdate
   */ setCurrentTime(_seconds) {
        // improve the accuracy of manual timeupdates
        if (this.manualTimeUpdates) /**
       * A manual `timeupdate` event.
       *
       * @event Tech#timeupdate
       * @type {Event}
       */ this.trigger({
            type: 'timeupdate',
            target: this,
            manuallyTriggered: true
        });
    }
    /**
   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
   * {@link TextTrackList} events.
   *
   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
   *
   * @fires Tech#audiotrackchange
   * @fires Tech#videotrackchange
   * @fires Tech#texttrackchange
   */ initTrackListeners() {
        /**
      * Triggered when tracks are added or removed on the Tech {@link AudioTrackList}
      *
      * @event Tech#audiotrackchange
      * @type {Event}
      */ /**
      * Triggered when tracks are added or removed on the Tech {@link VideoTrackList}
      *
      * @event Tech#videotrackchange
      * @type {Event}
      */ /**
      * Triggered when tracks are added or removed on the Tech {@link TextTrackList}
      *
      * @event Tech#texttrackchange
      * @type {Event}
      */ $86defbb4e95ebb07$var$NORMAL.names.forEach((name)=>{
            const props = $86defbb4e95ebb07$var$NORMAL[name];
            const trackListChanges = ()=>{
                this.trigger(`${name}trackchange`);
            };
            const tracks = this[props.getterName]();
            tracks.addEventListener('removetrack', trackListChanges);
            tracks.addEventListener('addtrack', trackListChanges);
            this.on('dispose', ()=>{
                tracks.removeEventListener('removetrack', trackListChanges);
                tracks.removeEventListener('addtrack', trackListChanges);
            });
        });
    }
    /**
   * Emulate TextTracks using vtt.js if necessary
   *
   * @fires Tech#vttjsloaded
   * @fires Tech#vttjserror
   */ addWebVttScript_() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT) return;
        // Initially, Tech.el_ is a child of a dummy-div wait until the Component system
        // signals that the Tech is ready at which point Tech.el_ is part of the DOM
        // before inserting the WebVTT script
        if ((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).body.contains(this.el())) {
            // load via require if available and vtt.js script location was not passed in
            // as an option. novtt builds will turn the above require call into an empty object
            // which will cause this if check to always fail.
            if (!this.options_['vtt.js'] && $86defbb4e95ebb07$var$isPlain((0, (/*@__PURE__*/$parcel$interopDefault($b8c3ace47d01a635$exports)))) && Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($b8c3ace47d01a635$exports)))).length > 0) {
                this.trigger('vttjsloaded');
                return;
            }
            // load vtt.js via the script location option or the cdn of no location was
            // passed in
            const script = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('script');
            script.src = this.options_['vtt.js'] || 'https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js';
            script.onload = ()=>{
                /**
         * Fired when vtt.js is loaded.
         *
         * @event Tech#vttjsloaded
         * @type {Event}
         */ this.trigger('vttjsloaded');
            };
            script.onerror = ()=>{
                /**
         * Fired when vtt.js was not loaded due to an error
         *
         * @event Tech#vttjsloaded
         * @type {Event}
         */ this.trigger('vttjserror');
            };
            this.on('dispose', ()=>{
                script.onload = null;
                script.onerror = null;
            });
            // but have not loaded yet and we set it to true before the inject so that
            // we don't overwrite the injected window.WebVTT if it loads right away
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT = true;
            this.el().parentNode.appendChild(script);
        } else this.ready(this.addWebVttScript_);
    }
    /**
   * Emulate texttracks
   *
   */ emulateTextTracks() {
        const tracks = this.textTracks();
        const remoteTracks = this.remoteTextTracks();
        const handleAddTrack = (e)=>tracks.addTrack(e.track);
        const handleRemoveTrack = (e)=>tracks.removeTrack(e.track);
        remoteTracks.on('addtrack', handleAddTrack);
        remoteTracks.on('removetrack', handleRemoveTrack);
        this.addWebVttScript_();
        const updateDisplay = ()=>this.trigger('texttrackchange');
        const textTracksChanges = ()=>{
            updateDisplay();
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                track.removeEventListener('cuechange', updateDisplay);
                if (track.mode === 'showing') track.addEventListener('cuechange', updateDisplay);
            }
        };
        textTracksChanges();
        tracks.addEventListener('change', textTracksChanges);
        tracks.addEventListener('addtrack', textTracksChanges);
        tracks.addEventListener('removetrack', textTracksChanges);
        this.on('dispose', function() {
            remoteTracks.off('addtrack', handleAddTrack);
            remoteTracks.off('removetrack', handleRemoveTrack);
            tracks.removeEventListener('change', textTracksChanges);
            tracks.removeEventListener('addtrack', textTracksChanges);
            tracks.removeEventListener('removetrack', textTracksChanges);
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                track.removeEventListener('cuechange', updateDisplay);
            }
        });
    }
    /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */ addTextTrack(kind, label, language) {
        if (!kind) throw new Error('TextTrack kind is required but was not provided');
        return $86defbb4e95ebb07$var$createTrackHelper(this, kind, label, language);
    }
    /**
   * Create an emulated TextTrack for use by addRemoteTextTrack
   *
   * This is intended to be overridden by classes that inherit from
   * Tech in order to create native or custom TextTracks.
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label].
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */ createRemoteTextTrack(options) {
        const track = $86defbb4e95ebb07$var$merge$1(options, {
            tech: this
        });
        return new $86defbb4e95ebb07$var$REMOTE.remoteTextEl.TrackClass(track);
    }
    /**
   * Creates a remote text track object and returns an html track element.
   *
   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   * @param {Object} options
   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
   *
   * @param {boolean} [manualCleanup=false]
   *        - When false: the TextTrack will be automatically removed from the video
   *          element whenever the source changes
   *        - When True: The TextTrack will have to be cleaned up manually
   *
   * @return {HTMLTrackElement}
   *         An Html Track Element.
   *
   */ addRemoteTextTrack(options = {}, manualCleanup) {
        const htmlTrackElement = this.createRemoteTextTrack(options);
        if (typeof manualCleanup !== 'boolean') manualCleanup = false;
        // store HTMLTrackElement and TextTrack to remote list
        this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
        this.remoteTextTracks().addTrack(htmlTrackElement.track);
        if (manualCleanup === false) // create the TextTrackList if it doesn't exist
        this.ready(()=>this.autoRemoteTextTracks_.addTrack(htmlTrackElement.track));
        return htmlTrackElement;
    }
    /**
   * Remove a remote text track from the remote `TextTrackList`.
   *
   * @param {TextTrack} track
   *        `TextTrack` to remove from the `TextTrackList`
   */ removeRemoteTextTrack(track) {
        const trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track);
        // remove HTMLTrackElement and TextTrack from remote list
        this.remoteTextTrackEls().removeTrackElement_(trackElement);
        this.remoteTextTracks().removeTrack(track);
        this.autoRemoteTextTracks_.removeTrack(track);
    }
    /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   *
   * @abstract
   */ getVideoPlaybackQuality() {
        return {};
    }
    /**
   * Attempt to create a floating video window always on top of other windows
   * so that users may continue consuming media while they interact with other
   * content sites, or applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise|undefined}
   *         A promise with a Picture-in-Picture window if the browser supports
   *         Promises (or one was passed in as an option). It returns undefined
   *         otherwise.
   *
   * @abstract
   */ requestPictureInPicture() {
        return Promise.reject();
    }
    /**
   * A method to check for the value of the 'disablePictureInPicture' <video> property.
   * Defaults to true, as it should be considered disabled if the tech does not support pip
   *
   * @abstract
   */ disablePictureInPicture() {
        return true;
    }
    /**
   * A method to set or unset the 'disablePictureInPicture' <video> property.
   *
   * @abstract
   */ setDisablePictureInPicture() {}
    /**
   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
   *
   * @param {function} cb
   * @return {number} request id
   */ requestVideoFrameCallback(cb) {
        const id = $86defbb4e95ebb07$var$newGUID();
        if (!this.isReady_ || this.paused()) {
            this.queuedHanders_.add(id);
            this.one('playing', ()=>{
                if (this.queuedHanders_.has(id)) {
                    this.queuedHanders_.delete(id);
                    cb();
                }
            });
        } else this.requestNamedAnimationFrame(id, cb);
        return id;
    }
    /**
   * A fallback implementation of cancelVideoFrameCallback
   *
   * @param {number} id id of callback to be cancelled
   */ cancelVideoFrameCallback(id) {
        if (this.queuedHanders_.has(id)) this.queuedHanders_.delete(id);
        else this.cancelNamedAnimationFrame(id);
    }
    /**
   * A method to set a poster from a `Tech`.
   *
   * @abstract
   */ setPoster() {}
    /**
   * A method to check for the presence of the 'playsinline' <video> attribute.
   *
   * @abstract
   */ playsinline() {}
    /**
   * A method to set or unset the 'playsinline' <video> attribute.
   *
   * @abstract
   */ setPlaysinline() {}
    /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   *
   * @abstract
   */ overrideNativeAudioTracks(override) {}
    /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   *
   * @abstract
   */ overrideNativeVideoTracks(override) {}
    /**
   * Check if the tech can support the given mime-type.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param  {string} _type
   *         The mimetype to check for support
   *
   * @return {string}
   *         'probably', 'maybe', or empty string
   *
   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
   *
   * @abstract
   */ canPlayType(_type) {
        return '';
    }
    /**
   * Check if the type is supported by this tech.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param {string} _type
   *        The media type to check
   * @return {string} Returns the native video element's response
   */ static canPlayType(_type) {
        return '';
    }
    /**
   * Check if the tech can support the given source
   *
   * @param {Object} srcObj
   *        The source object
   * @param {Object} options
   *        The options passed to the tech
   * @return {string} 'probably', 'maybe', or '' (empty string)
   */ static canPlaySource(srcObj, options) {
        return $86defbb4e95ebb07$var$Tech.canPlayType(srcObj.type);
    }
    /*
   * Return whether the argument is a Tech or not.
   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
   *
   * @param {Object} component
   *        The item to check
   *
   * @return {boolean}
   *         Whether it is a tech or not
   *         - True if it is a tech
   *         - False if it is not
   */ static isTech(component) {
        return component.prototype instanceof $86defbb4e95ebb07$var$Tech || component instanceof $86defbb4e95ebb07$var$Tech || component === $86defbb4e95ebb07$var$Tech;
    }
    /**
   * Registers a `Tech` into a shared list for videojs.
   *
   * @param {string} name
   *        Name of the `Tech` to register.
   *
   * @param {Object} tech
   *        The `Tech` class to register.
   */ static registerTech(name, tech) {
        if (!$86defbb4e95ebb07$var$Tech.techs_) $86defbb4e95ebb07$var$Tech.techs_ = {};
        if (!$86defbb4e95ebb07$var$Tech.isTech(tech)) throw new Error(`Tech ${name} must be a Tech`);
        if (!$86defbb4e95ebb07$var$Tech.canPlayType) throw new Error('Techs must have a static canPlayType method on them');
        if (!$86defbb4e95ebb07$var$Tech.canPlaySource) throw new Error('Techs must have a static canPlaySource method on them');
        name = $86defbb4e95ebb07$var$toTitleCase$1(name);
        $86defbb4e95ebb07$var$Tech.techs_[name] = tech;
        $86defbb4e95ebb07$var$Tech.techs_[$86defbb4e95ebb07$var$toLowerCase(name)] = tech;
        if (name !== 'Tech') // camel case the techName for use in techOrder
        $86defbb4e95ebb07$var$Tech.defaultTechOrder_.push(name);
        return tech;
    }
    /**
   * Get a `Tech` from the shared list by name.
   *
   * @param {string} name
   *        `camelCase` or `TitleCase` name of the Tech to get
   *
   * @return {Tech|undefined}
   *         The `Tech` or undefined if there was no tech with the name requested.
   */ static getTech(name) {
        if (!name) return;
        if ($86defbb4e95ebb07$var$Tech.techs_ && $86defbb4e95ebb07$var$Tech.techs_[name]) return $86defbb4e95ebb07$var$Tech.techs_[name];
        name = $86defbb4e95ebb07$var$toTitleCase$1(name);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))) && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).videojs && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).videojs[name]) {
            $86defbb4e95ebb07$var$log$1.warn(`The ${name} tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)`);
            return (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).videojs[name];
        }
    }
}
/**
 * Get the {@link VideoTrackList}
 *
 * @returns {VideoTrackList}
 * @method Tech.prototype.videoTracks
 */ /**
 * Get the {@link AudioTrackList}
 *
 * @returns {AudioTrackList}
 * @method Tech.prototype.audioTracks
 */ /**
 * Get the {@link TextTrackList}
 *
 * @returns {TextTrackList}
 * @method Tech.prototype.textTracks
 */ /**
 * Get the remote element {@link TextTrackList}
 *
 * @returns {TextTrackList}
 * @method Tech.prototype.remoteTextTracks
 */ /**
 * Get the remote element {@link HtmlTrackElementList}
 *
 * @returns {HtmlTrackElementList}
 * @method Tech.prototype.remoteTextTrackEls
 */ $86defbb4e95ebb07$var$ALL.names.forEach(function(name) {
    const props = $86defbb4e95ebb07$var$ALL[name];
    $86defbb4e95ebb07$var$Tech.prototype[props.getterName] = function() {
        this[props.privateName] = this[props.privateName] || new props.ListClass();
        return this[props.privateName];
    };
});
/**
 * List of associated text tracks
 *
 * @type {TextTrackList}
 * @private
 * @property Tech#textTracks_
 */ /**
 * List of associated audio tracks.
 *
 * @type {AudioTrackList}
 * @private
 * @property Tech#audioTracks_
 */ /**
 * List of associated video tracks.
 *
 * @type {VideoTrackList}
 * @private
 * @property Tech#videoTracks_
 */ /**
 * Boolean indicating whether the `Tech` supports volume control.
 *
 * @type {boolean}
 * @default
 */ $86defbb4e95ebb07$var$Tech.prototype.featuresVolumeControl = true;
/**
 * Boolean indicating whether the `Tech` supports muting volume.
 *
 * @type {boolean}
 * @default
 */ $86defbb4e95ebb07$var$Tech.prototype.featuresMuteControl = true;
/**
 * Boolean indicating whether the `Tech` supports fullscreen resize control.
 * Resizing plugins using request fullscreen reloads the plugin
 *
 * @type {boolean}
 * @default
 */ $86defbb4e95ebb07$var$Tech.prototype.featuresFullscreenResize = false;
/**
 * Boolean indicating whether the `Tech` supports changing the speed at which the video
 * plays. Examples:
 *   - Set player to play 2x (twice) as fast
 *   - Set player to play 0.5x (half) as fast
 *
 * @type {boolean}
 * @default
 */ $86defbb4e95ebb07$var$Tech.prototype.featuresPlaybackRate = false;
/**
 * Boolean indicating whether the `Tech` supports the `progress` event.
 * This will be used to determine if {@link Tech#manualProgressOn} should be called.
 *
 * @type {boolean}
 * @default
 */ $86defbb4e95ebb07$var$Tech.prototype.featuresProgressEvents = false;
/**
 * Boolean indicating whether the `Tech` supports the `sourceset` event.
 *
 * A tech should set this to `true` and then use {@link Tech#triggerSourceset}
 * to trigger a {@link Tech#event:sourceset} at the earliest time after getting
 * a new source.
 *
 * @type {boolean}
 * @default
 */ $86defbb4e95ebb07$var$Tech.prototype.featuresSourceset = false;
/**
 * Boolean indicating whether the `Tech` supports the `timeupdate` event.
 * This will be used to determine if {@link Tech#manualTimeUpdates} should be called.
 *
 * @type {boolean}
 * @default
 */ $86defbb4e95ebb07$var$Tech.prototype.featuresTimeupdateEvents = false;
/**
 * Boolean indicating whether the `Tech` supports the native `TextTrack`s.
 * This will help us integrate with native `TextTrack`s if the browser supports them.
 *
 * @type {boolean}
 * @default
 */ $86defbb4e95ebb07$var$Tech.prototype.featuresNativeTextTracks = false;
/**
 * Boolean indicating whether the `Tech` supports `requestVideoFrameCallback`.
 *
 * @type {boolean}
 * @default
 */ $86defbb4e95ebb07$var$Tech.prototype.featuresVideoFrameCallback = false;
/**
 * A functional mixin for techs that want to use the Source Handler pattern.
 * Source handlers are scripts for handling specific formats.
 * The source handler pattern is used for adaptive formats (HLS, DASH) that
 * manually load video data and feed it into a Source Buffer (Media Source Extensions)
 * Example: `Tech.withSourceHandlers.call(MyTech);`
 *
 * @param {Tech} _Tech
 *        The tech to add source handler functions to.
 *
 * @mixes Tech~SourceHandlerAdditions
 */ $86defbb4e95ebb07$var$Tech.withSourceHandlers = function(_Tech) {
    /**
   * Register a source handler
   *
   * @param {Function} handler
   *        The source handler class
   *
   * @param {number} [index]
   *        Register it at the following index
   */ _Tech.registerSourceHandler = function(handler, index) {
        let handlers = _Tech.sourceHandlers;
        if (!handlers) handlers = _Tech.sourceHandlers = [];
        if (index === undefined) // add to the end of the list
        index = handlers.length;
        handlers.splice(index, 0, handler);
    };
    /**
   * Check if the tech can support the given type. Also checks the
   * Techs sourceHandlers.
   *
   * @param {string} type
   *         The mimetype to check.
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */ _Tech.canPlayType = function(type) {
        const handlers = _Tech.sourceHandlers || [];
        let can;
        for(let i = 0; i < handlers.length; i++){
            can = handlers[i].canPlayType(type);
            if (can) return can;
        }
        return '';
    };
    /**
   * Returns the first source handler that supports the source.
   *
   * TODO: Answer question: should 'probably' be prioritized over 'maybe'
   *
   * @param {SourceObject} source
   *        The source object
   *
   * @param {Object} options
   *        The options passed to the tech
   *
   * @return {SourceHandler|null}
   *          The first source handler that supports the source or null if
   *          no SourceHandler supports the source
   */ _Tech.selectSourceHandler = function(source, options) {
        const handlers = _Tech.sourceHandlers || [];
        let can;
        for(let i = 0; i < handlers.length; i++){
            can = handlers[i].canHandleSource(source, options);
            if (can) return handlers[i];
        }
        return null;
    };
    /**
   * Check if the tech can support the given source.
   *
   * @param {SourceObject} srcObj
   *        The source object
   *
   * @param {Object} options
   *        The options passed to the tech
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */ _Tech.canPlaySource = function(srcObj, options) {
        const sh = _Tech.selectSourceHandler(srcObj, options);
        if (sh) return sh.canHandleSource(srcObj, options);
        return '';
    };
    /**
   * When using a source handler, prefer its implementation of
   * any function normally provided by the tech.
   */ const deferrable = [
        'seekable',
        'seeking',
        'duration'
    ];
    /**
   * A wrapper around {@link Tech#seekable} that will call a `SourceHandler`s seekable
   * function if it exists, with a fallback to the Techs seekable function.
   *
   * @method _Tech.seekable
   */ /**
   * A wrapper around {@link Tech#duration} that will call a `SourceHandler`s duration
   * function if it exists, otherwise it will fallback to the techs duration function.
   *
   * @method _Tech.duration
   */ deferrable.forEach(function(fnName) {
        const originalFn = this[fnName];
        if (typeof originalFn !== 'function') return;
        this[fnName] = function() {
            if (this.sourceHandler_ && this.sourceHandler_[fnName]) return this.sourceHandler_[fnName].apply(this.sourceHandler_, arguments);
            return originalFn.apply(this, arguments);
        };
    }, _Tech.prototype);
    /**
   * Create a function for setting the source using a source object
   * and source handlers.
   * Should never be called unless a source handler was found.
   *
   * @param {SourceObject} source
   *        A source object with src and type keys
   */ _Tech.prototype.setSource = function(source) {
        let sh = _Tech.selectSourceHandler(source, this.options_);
        if (!sh) {
            // Fall back to a native source handler when unsupported sources are
            // deliberately set
            if (_Tech.nativeSourceHandler) sh = _Tech.nativeSourceHandler;
            else $86defbb4e95ebb07$var$log$1.error('No source handler found for the current source.');
        }
        // Dispose any existing source handler
        this.disposeSourceHandler();
        this.off('dispose', this.disposeSourceHandler_);
        if (sh !== _Tech.nativeSourceHandler) this.currentSource_ = source;
        this.sourceHandler_ = sh.handleSource(source, this, this.options_);
        this.one('dispose', this.disposeSourceHandler_);
    };
    /**
   * Clean up any existing SourceHandlers and listeners when the Tech is disposed.
   *
   * @listens Tech#dispose
   */ _Tech.prototype.disposeSourceHandler = function() {
        // if we have a source and get another one
        // then we are loading something new
        // than clear all of our current tracks
        if (this.currentSource_) {
            this.clearTracks([
                'audio',
                'video'
            ]);
            this.currentSource_ = null;
        }
        // always clean up auto-text tracks
        this.cleanupAutoTextTracks();
        if (this.sourceHandler_) {
            if (this.sourceHandler_.dispose) this.sourceHandler_.dispose();
            this.sourceHandler_ = null;
        }
    };
};
// The base Tech class needs to be registered as a Component. It is the only
// Tech that can be registered as a Component.
$86defbb4e95ebb07$var$Component$1.registerComponent('Tech', $86defbb4e95ebb07$var$Tech);
$86defbb4e95ebb07$var$Tech.registerTech('Tech', $86defbb4e95ebb07$var$Tech);
/**
 * A list of techs that should be added to techOrder on Players
 *
 * @private
 */ $86defbb4e95ebb07$var$Tech.defaultTechOrder_ = [];
/**
 * @file middleware.js
 * @module middleware
 */ /** @import Player from '../player' */ /** @import Tech from '../tech/tech' */ const $86defbb4e95ebb07$var$middlewares = {};
const $86defbb4e95ebb07$var$middlewareInstances = {};
const $86defbb4e95ebb07$var$TERMINATOR = {};
/**
 * A middleware object is a plain JavaScript object that has methods that
 * match the {@link Tech} methods found in the lists of allowed
 * {@link module:middleware.allowedGetters|getters},
 * {@link module:middleware.allowedSetters|setters}, and
 * {@link module:middleware.allowedMediators|mediators}.
 *
 * @typedef {Object} MiddlewareObject
 */ /**
 * A middleware factory function that should return a
 * {@link module:middleware~MiddlewareObject|MiddlewareObject}.
 *
 * This factory will be called for each player when needed, with the player
 * passed in as an argument.
 *
 * @callback MiddlewareFactory
 * @param {Player} player
 *        A Video.js player.
 */ /**
 * Define a middleware that the player should use by way of a factory function
 * that returns a middleware object.
 *
 * @param  {string} type
 *         The MIME type to match or `"*"` for all MIME types.
 *
 * @param  {MiddlewareFactory} middleware
 *         A middleware factory function that will be executed for
 *         matching types.
 */ function $86defbb4e95ebb07$var$use(type, middleware) {
    $86defbb4e95ebb07$var$middlewares[type] = $86defbb4e95ebb07$var$middlewares[type] || [];
    $86defbb4e95ebb07$var$middlewares[type].push(middleware);
}
/**
 * Asynchronously sets a source using middleware by recursing through any
 * matching middlewares and calling `setSource` on each, passing along the
 * previous returned value each time.
 *
 * @param  {Player} player
 *         A {@link Player} instance.
 *
 * @param  {Tech~SourceObject} src
 *         A source object.
 *
 * @param  {Function}
 *         The next middleware to run.
 */ function $86defbb4e95ebb07$var$setSource(player, src, next) {
    player.setTimeout(()=>$86defbb4e95ebb07$var$setSourceHelper(src, $86defbb4e95ebb07$var$middlewares[src.type], next, player), 1);
}
/**
 * When the tech is set, passes the tech to each middleware's `setTech` method.
 *
 * @param {Object[]} middleware
 *        An array of middleware instances.
 *
 * @param {Tech} tech
 *        A Video.js tech.
 */ function $86defbb4e95ebb07$var$setTech(middleware, tech) {
    middleware.forEach((mw)=>mw.setTech && mw.setTech(tech));
}
/**
 * Calls a getter on the tech first, through each middleware
 * from right to left to the player.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  {Tech} tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @return {*}
 *         The final value from the tech after middleware has intercepted it.
 */ function $86defbb4e95ebb07$var$get(middleware, tech, method) {
    return middleware.reduceRight($86defbb4e95ebb07$var$middlewareIterator(method), tech[method]());
}
/**
 * Takes the argument given to the player and calls the setter method on each
 * middleware from left to right to the tech.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  {Tech} tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @param  {*} arg
 *         The value to set on the tech.
 *
 * @return {*}
 *         The return value of the `method` of the `tech`.
 */ function $86defbb4e95ebb07$var$set(middleware, tech, method, arg) {
    return tech[method](middleware.reduce($86defbb4e95ebb07$var$middlewareIterator(method), arg));
}
/**
 * Takes the argument given to the player and calls the `call` version of the
 * method on each middleware from left to right.
 *
 * Then, call the passed in method on the tech and return the result unchanged
 * back to the player, through middleware, this time from right to left.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  {Tech} tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @param  {*} arg
 *         The value to set on the tech.
 *
 * @return {*}
 *         The return value of the `method` of the `tech`, regardless of the
 *         return values of middlewares.
 */ function $86defbb4e95ebb07$var$mediate(middleware, tech, method, arg = null) {
    const callMethod = 'call' + $86defbb4e95ebb07$var$toTitleCase$1(method);
    const middlewareValue = middleware.reduce($86defbb4e95ebb07$var$middlewareIterator(callMethod), arg);
    const terminated = middlewareValue === $86defbb4e95ebb07$var$TERMINATOR;
    // deprecated. The `null` return value should instead return TERMINATOR to
    // prevent confusion if a techs method actually returns null.
    const returnValue = terminated ? null : tech[method](middlewareValue);
    $86defbb4e95ebb07$var$executeRight(middleware, method, returnValue, terminated);
    return returnValue;
}
/**
 * Enumeration of allowed getters where the keys are method names.
 *
 * @type {Object}
 */ const $86defbb4e95ebb07$var$allowedGetters = {
    buffered: 1,
    currentTime: 1,
    duration: 1,
    muted: 1,
    played: 1,
    paused: 1,
    seekable: 1,
    volume: 1,
    ended: 1
};
/**
 * Enumeration of allowed setters where the keys are method names.
 *
 * @type {Object}
 */ const $86defbb4e95ebb07$var$allowedSetters = {
    setCurrentTime: 1,
    setMuted: 1,
    setVolume: 1
};
/**
 * Enumeration of allowed mediators where the keys are method names.
 *
 * @type {Object}
 */ const $86defbb4e95ebb07$var$allowedMediators = {
    play: 1,
    pause: 1
};
function $86defbb4e95ebb07$var$middlewareIterator(method) {
    return (value, mw)=>{
        // if the previous middleware terminated, pass along the termination
        if (value === $86defbb4e95ebb07$var$TERMINATOR) return $86defbb4e95ebb07$var$TERMINATOR;
        if (mw[method]) return mw[method](value);
        return value;
    };
}
function $86defbb4e95ebb07$var$executeRight(mws, method, value, terminated) {
    for(let i = mws.length - 1; i >= 0; i--){
        const mw = mws[i];
        if (mw[method]) mw[method](terminated, value);
    }
}
/**
 * Clear the middleware cache for a player.
 *
 * @param  {Player} player
 *         A {@link Player} instance.
 */ function $86defbb4e95ebb07$var$clearCacheForPlayer(player) {
    if ($86defbb4e95ebb07$var$middlewareInstances.hasOwnProperty(player.id())) delete $86defbb4e95ebb07$var$middlewareInstances[player.id()];
}
/**
 * {
 *  [playerId]: [[mwFactory, mwInstance], ...]
 * }
 *
 * @private
 */ function $86defbb4e95ebb07$var$getOrCreateFactory(player, mwFactory) {
    const mws = $86defbb4e95ebb07$var$middlewareInstances[player.id()];
    let mw = null;
    if (mws === undefined || mws === null) {
        mw = mwFactory(player);
        $86defbb4e95ebb07$var$middlewareInstances[player.id()] = [
            [
                mwFactory,
                mw
            ]
        ];
        return mw;
    }
    for(let i = 0; i < mws.length; i++){
        const [mwf, mwi] = mws[i];
        if (mwf !== mwFactory) continue;
        mw = mwi;
    }
    if (mw === null) {
        mw = mwFactory(player);
        mws.push([
            mwFactory,
            mw
        ]);
    }
    return mw;
}
function $86defbb4e95ebb07$var$setSourceHelper(src = {}, middleware = [], next, player, acc = [], lastRun = false) {
    const [mwFactory, ...mwrest] = middleware;
    // if mwFactory is a string, then we're at a fork in the road
    if (typeof mwFactory === 'string') $86defbb4e95ebb07$var$setSourceHelper(src, $86defbb4e95ebb07$var$middlewares[mwFactory], next, player, acc, lastRun);
    else if (mwFactory) {
        const mw = $86defbb4e95ebb07$var$getOrCreateFactory(player, mwFactory);
        // if setSource isn't present, implicitly select this middleware
        if (!mw.setSource) {
            acc.push(mw);
            return $86defbb4e95ebb07$var$setSourceHelper(src, mwrest, next, player, acc, lastRun);
        }
        mw.setSource(Object.assign({}, src), function(err, _src) {
            // something happened, try the next middleware on the current level
            // make sure to use the old src
            if (err) return $86defbb4e95ebb07$var$setSourceHelper(src, mwrest, next, player, acc, lastRun);
            // we've succeeded, now we need to go deeper
            acc.push(mw);
            // if it's the same type, continue down the current chain
            // otherwise, we want to go down the new chain
            $86defbb4e95ebb07$var$setSourceHelper(_src, src.type === _src.type ? mwrest : $86defbb4e95ebb07$var$middlewares[_src.type], next, player, acc, lastRun);
        });
    } else if (mwrest.length) $86defbb4e95ebb07$var$setSourceHelper(src, mwrest, next, player, acc, lastRun);
    else if (lastRun) next(src, acc);
    else $86defbb4e95ebb07$var$setSourceHelper(src, $86defbb4e95ebb07$var$middlewares['*'], next, player, acc, true);
}
/** @import Player from '../player' */ /**
 * Mimetypes
 *
 * @see https://www.iana.org/assignments/media-types/media-types.xhtml
 * @typedef Mimetypes~Kind
 * @enum
 */ const $86defbb4e95ebb07$var$MimetypesKind = {
    opus: 'video/ogg',
    ogv: 'video/ogg',
    mp4: 'video/mp4',
    mov: 'video/mp4',
    m4v: 'video/mp4',
    mkv: 'video/x-matroska',
    m4a: 'audio/mp4',
    mp3: 'audio/mpeg',
    aac: 'audio/aac',
    caf: 'audio/x-caf',
    flac: 'audio/flac',
    oga: 'audio/ogg',
    wav: 'audio/wav',
    m3u8: 'application/x-mpegURL',
    mpd: 'application/dash+xml',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    png: 'image/png',
    svg: 'image/svg+xml',
    webp: 'image/webp'
};
/**
 * Get the mimetype of a given src url if possible
 *
 * @param {string} src
 *        The url to the src
 *
 * @return {string}
 *         return the mimetype if it was known or empty string otherwise
 */ const $86defbb4e95ebb07$var$getMimetype = function(src = '') {
    const ext = $86defbb4e95ebb07$var$getFileExtension(src);
    const mimetype = $86defbb4e95ebb07$var$MimetypesKind[ext.toLowerCase()];
    return mimetype || '';
};
/**
 * Find the mime type of a given source string if possible. Uses the player
 * source cache.
 *
 * @param {Player} player
 *        The player object
 *
 * @param {string} src
 *        The source string
 *
 * @return {string}
 *         The type that was found
 */ const $86defbb4e95ebb07$var$findMimetype = (player, src)=>{
    if (!src) return '';
    // 1. check for the type in the `source` cache
    if (player.cache_.source.src === src && player.cache_.source.type) return player.cache_.source.type;
    // 2. see if we have this source in our `currentSources` cache
    const matchingSources = player.cache_.sources.filter((s)=>s.src === src);
    if (matchingSources.length) return matchingSources[0].type;
    // 3. look for the src url in source elements and use the type there
    const sources = player.$$('source');
    for(let i = 0; i < sources.length; i++){
        const s = sources[i];
        if (s.type && s.src && s.src === src) return s.type;
    }
    // 4. finally fallback to our list of mime types based on src url extension
    return $86defbb4e95ebb07$var$getMimetype(src);
};
/**
 * @module filter-source
 */ /**
 * Filter out single bad source objects or multiple source objects in an
 * array. Also flattens nested source object arrays into a 1 dimensional
 * array of source objects.
 *
 * @param {Tech~SourceObject|Tech~SourceObject[]} src
 *        The src object to filter
 *
 * @return {Tech~SourceObject[]}
 *         An array of sourceobjects containing only valid sources
 *
 * @private
 */ const $86defbb4e95ebb07$var$filterSource = function(src) {
    // traverse array
    if (Array.isArray(src)) {
        let newsrc = [];
        src.forEach(function(srcobj) {
            srcobj = $86defbb4e95ebb07$var$filterSource(srcobj);
            if (Array.isArray(srcobj)) newsrc = newsrc.concat(srcobj);
            else if ($86defbb4e95ebb07$var$isObject(srcobj)) newsrc.push(srcobj);
        });
        src = newsrc;
    } else if (typeof src === 'string' && src.trim()) // convert string into object
    src = [
        $86defbb4e95ebb07$var$fixSource({
            src: src
        })
    ];
    else if ($86defbb4e95ebb07$var$isObject(src) && typeof src.src === 'string' && src.src && src.src.trim()) // src is already valid
    src = [
        $86defbb4e95ebb07$var$fixSource(src)
    ];
    else // invalid source, turn it into an empty array
    src = [];
    return src;
};
/**
 * Checks src mimetype, adding it when possible
 *
 * @param {Tech~SourceObject} src
 *        The src object to check
 * @return {Tech~SourceObject}
 *        src Object with known type
 */ function $86defbb4e95ebb07$var$fixSource(src) {
    if (!src.type) {
        const mimetype = $86defbb4e95ebb07$var$getMimetype(src.src);
        if (mimetype) src.type = mimetype;
    }
    return src;
}
var $86defbb4e95ebb07$var$icons = "<svg xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-play\">\n      <path d=\"M16 10v28l22-14z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-pause\">\n      <path d=\"M12 38h8V10h-8v28zm16-28v28h8V10h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-audio\">\n      <path d=\"M24 2C14.06 2 6 10.06 6 20v14c0 3.31 2.69 6 6 6h6V24h-8v-4c0-7.73 6.27-14 14-14s14 6.27 14 14v4h-8v16h6c3.31 0 6-2.69 6-6V20c0-9.94-8.06-18-18-18z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-captions\">\n      <path d=\"M38 8H10c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM22 22h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2zm14 0h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-subtitles\">\n      <path d=\"M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM8 24h8v4H8v-4zm20 12H8v-4h20v4zm12 0h-8v-4h8v4zm0-8H20v-4h20v4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-fullscreen-enter\">\n      <path d=\"M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-fullscreen-exit\">\n      <path d=\"M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-play-circle\">\n      <path d=\"M20 33l12-9-12-9v18zm4-29C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-mute\">\n      <path d=\"M33 24c0-3.53-2.04-6.58-5-8.05v4.42l4.91 4.91c.06-.42.09-.85.09-1.28zm5 0c0 1.88-.41 3.65-1.08 5.28l3.03 3.03C41.25 29.82 42 27 42 24c0-8.56-5.99-15.72-14-17.54v4.13c5.78 1.72 10 7.07 10 13.41zM8.55 6L6 8.55 15.45 18H6v12h8l10 10V26.55l8.51 8.51c-1.34 1.03-2.85 1.86-4.51 2.36v4.13a17.94 17.94 0 0 0 7.37-3.62L39.45 42 42 39.45l-18-18L8.55 6zM24 8l-4.18 4.18L24 16.36V8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-low\">\n      <path d=\"M14 18v12h8l10 10V8L22 18h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-medium\">\n      <path d=\"M37 24c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zm-27-6v12h8l10 10V8L18 18h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-high\">\n      <path d=\"M6 18v12h8l10 10V8L14 18H6zm27 6c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zM28 6.46v4.13c5.78 1.72 10 7.07 10 13.41s-4.22 11.69-10 13.41v4.13c8.01-1.82 14-8.97 14-17.54S36.01 8.28 28 6.46z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-spinner\">\n      <path d=\"M18.8 21l9.53-16.51C26.94 4.18 25.49 4 24 4c-4.8 0-9.19 1.69-12.64 4.51l7.33 12.69.11-.2zm24.28-3c-1.84-5.85-6.3-10.52-11.99-12.68L23.77 18h19.31zm.52 2H28.62l.58 1 9.53 16.5C41.99 33.94 44 29.21 44 24c0-1.37-.14-2.71-.4-4zm-26.53 4l-7.8-13.5C6.01 14.06 4 18.79 4 24c0 1.37.14 2.71.4 4h14.98l-2.31-4zM4.92 30c1.84 5.85 6.3 10.52 11.99 12.68L24.23 30H4.92zm22.54 0l-7.8 13.51c1.4.31 2.85.49 4.34.49 4.8 0 9.19-1.69 12.64-4.51L29.31 26.8 27.46 30z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 24 24\" id=\"vjs-icon-hd\">\n      <path d=\"M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-chapters\">\n      <path d=\"M6 26h4v-4H6v4zm0 8h4v-4H6v4zm0-16h4v-4H6v4zm8 8h28v-4H14v4zm0 8h28v-4H14v4zm0-20v4h28v-4H14z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 40 40\" id=\"vjs-icon-downloading\">\n      <path d=\"M18.208 36.875q-3.208-.292-5.979-1.729-2.771-1.438-4.812-3.729-2.042-2.292-3.188-5.229-1.146-2.938-1.146-6.23 0-6.583 4.334-11.416 4.333-4.834 10.833-5.5v3.166q-5.167.75-8.583 4.646Q6.25 14.75 6.25 19.958q0 5.209 3.396 9.104 3.396 3.896 8.562 4.646zM20 28.417L11.542 20l2.083-2.083 4.917 4.916v-11.25h2.916v11.25l4.875-4.916L28.417 20zm1.792 8.458v-3.167q1.833-.25 3.541-.958 1.709-.708 3.167-1.875l2.333 2.292q-1.958 1.583-4.25 2.541-2.291.959-4.791 1.167zm6.791-27.792q-1.541-1.125-3.25-1.854-1.708-.729-3.541-1.021V3.042q2.5.25 4.77 1.208 2.271.958 4.271 2.5zm4.584 21.584l-2.25-2.25q1.166-1.5 1.854-3.209.687-1.708.937-3.541h3.209q-.292 2.5-1.229 4.791-.938 2.292-2.521 4.209zm.541-12.417q-.291-1.833-.958-3.562-.667-1.73-1.833-3.188l2.375-2.208q1.541 1.916 2.458 4.208.917 2.292 1.167 4.75z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download\">\n      <path d=\"M10.8 40.55q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h26.35v-7.7h3.4v7.7q0 1.4-1 2.4t-2.4 1zM24 32.1L13.9 22.05l2.45-2.45 5.95 5.95V7.15h3.4v18.4l5.95-5.95 2.45 2.45z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download-done\">\n      <path d=\"M9.8 40.5v-3.45h28.4v3.45zm9.2-9.05L7.4 19.85l2.45-2.35L19 26.65l19.2-19.2 2.4 2.4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download-off\">\n      <path d=\"M4.9 4.75L43.25 43.1 41 45.3l-4.75-4.75q-.05.05-.075.025-.025-.025-.075-.025H10.8q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h22.05l-7-7-1.85 1.8L13.9 21.9l1.85-1.85L2.7 7zm26.75 14.7l2.45 2.45-3.75 3.8-2.45-2.5zM25.7 7.15V21.1l-3.4-3.45V7.15z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-share\">\n      <path d=\"M36 32.17c-1.52 0-2.89.59-3.93 1.54L17.82 25.4c.11-.45.18-.92.18-1.4s-.07-.95-.18-1.4l14.1-8.23c1.07 1 2.5 1.62 4.08 1.62 3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6c0 .48.07.95.18 1.4l-14.1 8.23c-1.07-1-2.5-1.62-4.08-1.62-3.31 0-6 2.69-6 6s2.69 6 6 6c1.58 0 3.01-.62 4.08-1.62l14.25 8.31c-.1.42-.16.86-.16 1.31A5.83 5.83 0 1 0 36 32.17z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cog\">\n      <path d=\"M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97L29 4.84c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3a14.8 14.8 0 0 0-3.38 1.97L9.9 10.1a1 1 0 0 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31C9.06 22.69 9 23.34 9 24s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3a14.8 14.8 0 0 0 3.38-1.97l4.98 2.01a1 1 0 0 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zM24 31c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-square\">\n      <path d=\"M36 8H12c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H12V12h24v24z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle\">\n      <circle cx=\"24\" cy=\"24\" r=\"20\"></circle>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle-outline\">\n      <path d=\"M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle-inner-circle\">\n      <path d=\"M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm6-16c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cancel\">\n      <path d=\"M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-replay\">\n      <path d=\"M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-repeat\">\n      <path d=\"M14 14h20v6l8-8-8-8v6H10v12h4v-8zm20 20H14v-6l-8 8 8 8v-6h24V26h-4v8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-5\">\n      <path d=\"M17.689 98l-8.697 8.696 8.697 8.697 2.486-2.485-4.32-4.319h1.302c4.93 0 9.071 1.722 12.424 5.165 3.352 3.443 5.029 7.638 5.029 12.584h3.55c0-2.958-.553-5.73-1.658-8.313-1.104-2.583-2.622-4.841-4.555-6.774-1.932-1.932-4.19-3.45-6.773-4.555-2.584-1.104-5.355-1.657-8.313-1.657H15.5l4.615-4.615zm-8.08 21.659v13.861h11.357v5.008H9.609V143h12.7c.834 0 1.55-.298 2.146-.894.596-.597.895-1.31.895-2.145v-7.781c0-.835-.299-1.55-.895-2.147a2.929 2.929 0 0 0-2.147-.894h-8.227v-5.096H25.35v-4.384z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-10\">\n      <path d=\"M42.315 125.63c0-4.997-1.694-9.235-5.08-12.713-3.388-3.479-7.571-5.218-12.552-5.218h-1.315l4.363 4.363-2.51 2.51-8.787-8.786L25.221 97l2.45 2.45-4.662 4.663h1.375c2.988 0 5.788.557 8.397 1.673 2.61 1.116 4.892 2.65 6.844 4.602 1.953 1.953 3.487 4.234 4.602 6.844 1.116 2.61 1.674 5.41 1.674 8.398zM8.183 142v-19.657H3.176V117.8h9.643V142zm13.63 0c-1.156 0-2.127-.393-2.912-1.178-.778-.778-1.168-1.746-1.168-2.902v-16.04c0-1.156.393-2.127 1.178-2.912.779-.779 1.746-1.168 2.902-1.168h7.696c1.156 0 2.126.392 2.911 1.177.779.78 1.168 1.747 1.168 2.903v16.04c0 1.156-.392 2.127-1.177 2.912-.779.779-1.746 1.168-2.902 1.168zm.556-4.636h6.583v-15.02H22.37z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-30\">\n      <path d=\"M26.047 97l-8.733 8.732 8.733 8.733 2.496-2.494-4.336-4.338h1.307c4.95 0 9.108 1.73 12.474 5.187 3.367 3.458 5.051 7.668 5.051 12.635h3.565c0-2.97-.556-5.751-1.665-8.346-1.109-2.594-2.633-4.862-4.574-6.802-1.94-1.941-4.208-3.466-6.803-4.575-2.594-1.109-5.375-1.664-8.345-1.664H23.85l4.634-4.634zM2.555 117.531v4.688h10.297v5.25H5.873v4.687h6.979v5.156H2.555V142H13.36c1.061 0 1.95-.395 2.668-1.186.718-.79 1.076-1.772 1.076-2.94v-16.218c0-1.168-.358-2.149-1.076-2.94-.717-.79-1.607-1.185-2.668-1.185zm22.482.14c-1.149 0-2.11.39-2.885 1.165-.78.78-1.172 1.744-1.172 2.893v15.943c0 1.149.388 2.11 1.163 2.885.78.78 1.745 1.172 2.894 1.172h7.649c1.148 0 2.11-.388 2.884-1.163.78-.78 1.17-1.745 1.17-2.894v-15.943c0-1.15-.386-2.111-1.16-2.885-.78-.78-1.746-1.172-2.894-1.172zm.553 4.518h6.545v14.93H25.59z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-5\">\n      <path d=\"M29.508 97l-2.431 2.43 4.625 4.625h-1.364c-2.965 0-5.742.554-8.332 1.66-2.589 1.107-4.851 2.629-6.788 4.566-1.937 1.937-3.458 4.2-4.565 6.788-1.107 2.59-1.66 5.367-1.66 8.331h3.557c0-4.957 1.68-9.16 5.04-12.611 3.36-3.45 7.51-5.177 12.451-5.177h1.304l-4.326 4.33 2.49 2.49 8.715-8.716zm-9.783 21.61v13.89h11.382v5.018H19.725V142h12.727a2.93 2.93 0 0 0 2.15-.896 2.93 2.93 0 0 0 .896-2.15v-7.798c0-.837-.299-1.554-.896-2.152a2.93 2.93 0 0 0-2.15-.896h-8.245V123h11.29v-4.392z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-10\">\n      <path d=\"M23.119 97l-2.386 2.383 4.538 4.538h-1.339c-2.908 0-5.633.543-8.173 1.63-2.54 1.085-4.76 2.577-6.66 4.478-1.9 1.9-3.392 4.12-4.478 6.66-1.085 2.54-1.629 5.264-1.629 8.172h3.49c0-4.863 1.648-8.986 4.944-12.372 3.297-3.385 7.368-5.078 12.216-5.078h1.279l-4.245 4.247 2.443 2.442 8.55-8.55zm-9.52 21.45v4.42h4.871V142h4.513v-23.55zm18.136 0c-1.125 0-2.066.377-2.824 1.135-.764.764-1.148 1.709-1.148 2.834v15.612c0 1.124.38 2.066 1.139 2.824.764.764 1.708 1.145 2.833 1.145h7.489c1.125 0 2.066-.378 2.824-1.136.764-.764 1.145-1.709 1.145-2.833v-15.612c0-1.125-.378-2.067-1.136-2.825-.764-.764-1.708-1.145-2.833-1.145zm.54 4.42h6.408v14.617h-6.407z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-30\">\n      <path d=\"M25.549 97l-2.437 2.434 4.634 4.635H26.38c-2.97 0-5.753.555-8.347 1.664-2.594 1.109-4.861 2.633-6.802 4.574-1.94 1.94-3.465 4.207-4.574 6.802-1.109 2.594-1.664 5.377-1.664 8.347h3.565c0-4.967 1.683-9.178 5.05-12.636 3.366-3.458 7.525-5.187 12.475-5.187h1.307l-4.335 4.338 2.495 2.494 8.732-8.732zm-11.553 20.53v4.689h10.297v5.249h-6.978v4.688h6.978v5.156H13.996V142h10.808c1.06 0 1.948-.395 2.666-1.186.718-.79 1.077-1.771 1.077-2.94v-16.217c0-1.169-.36-2.15-1.077-2.94-.718-.79-1.605-1.186-2.666-1.186zm21.174.168c-1.149 0-2.11.389-2.884 1.163-.78.78-1.172 1.745-1.172 2.894v15.942c0 1.15.388 2.11 1.162 2.885.78.78 1.745 1.17 2.894 1.17h7.649c1.149 0 2.11-.386 2.885-1.16.78-.78 1.17-1.746 1.17-2.895v-15.942c0-1.15-.387-2.11-1.161-2.885-.78-.78-1.745-1.172-2.894-1.172zm.552 4.516h6.542v14.931h-6.542z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 512 512\" id=\"vjs-icon-audio-description\">\n      <g fill-rule=\"evenodd\"><path d=\"M227.29 381.351V162.993c50.38-1.017 89.108-3.028 117.631 17.126 27.374 19.342 48.734 56.965 44.89 105.325-4.067 51.155-41.335 94.139-89.776 98.475-24.085 2.155-71.972 0-71.972 0s-.84-1.352-.773-2.568m48.755-54.804c31.43 1.26 53.208-16.633 56.495-45.386 4.403-38.51-21.188-63.552-58.041-60.796v103.612c-.036 1.466.575 2.22 1.546 2.57\"></path><path d=\"M383.78 381.328c13.336 3.71 17.387-11.06 23.215-21.408 12.722-22.571 22.294-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.226 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894\"></path><path d=\"M425.154 381.328c13.336 3.71 17.384-11.061 23.215-21.408 12.721-22.571 22.291-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.511c-.586 3.874 2.226 7.315 3.866 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894\"></path><path d=\"M466.26 381.328c13.337 3.71 17.385-11.061 23.216-21.408 12.722-22.571 22.292-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.225 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894M4.477 383.005H72.58l18.573-28.484 64.169-.135s.065 19.413.065 28.62h48.756V160.307h-58.816c-5.653 9.537-140.85 222.697-140.85 222.697zm152.667-145.282v71.158l-40.453-.27 40.453-70.888z\"></path></g>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-next-item\">\n      <path d=\"M12 36l17-12-17-12v24zm20-24v24h4V12h-4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-previous-item\">\n      <path d=\"M12 12h4v24h-4zm7 12l17 12V12z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-shuffle\">\n      <path d=\"M21.17 18.34L10.83 8 8 10.83l10.34 10.34 2.83-2.83zM29 8l4.09 4.09L8 37.17 10.83 40l25.09-25.09L40 19V8H29zm.66 18.83l-2.83 2.83 6.26 6.26L29 40h11V29l-4.09 4.09-6.25-6.26z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cast\">\n      <path d=\"M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-picture-in-picture-enter\">\n      <path d=\"M38 22H22v11.99h16V22zm8 16V9.96C46 7.76 44.2 6 42 6H6C3.8 6 2 7.76 2 9.96V38c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4zm-4 .04H6V9.94h36v28.1z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 22 18\" id=\"vjs-icon-picture-in-picture-exit\">\n      <path d=\"M18 4H4v10h14V4zm4 12V1.98C22 .88 21.1 0 20 0H2C.9 0 0 .88 0 1.98V16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H2V1.97h18v14.05z\"></path>\n      <path fill=\"none\" d=\"M-1-3h24v24H-1z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-facebook\">\n      <path d=\"M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759H734V905H479V609h255V391q0-186 104-288.5T1115 0q147 0 228 12z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-linkedin\">\n      <path d=\"M477 625v991H147V625h330zm21-306q1 73-50.5 122T312 490h-2q-82 0-132-49t-50-122q0-74 51.5-122.5T314 148t133 48.5T498 319zm1166 729v568h-329v-530q0-105-40.5-164.5T1168 862q-63 0-105.5 34.5T999 982q-11 30-11 81v553H659q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5T1285 602q171 0 275 113.5t104 332.5z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1200 1227\" id=\"vjs-icon-twitter\">\n      <path d=\"M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z\"/>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-tumblr\">\n      <path d=\"M1328 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26T787 1564t-95-106-55.5-120-16.5-118V676H452V461q72-26 129-69.5t91-90 58-102 34-99T779 12q1-5 4.5-8.5T791 0h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-pinterest\">\n      <path d=\"M1664 896q0 209-103 385.5T1281.5 1561 896 1664q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214T1180 449t-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5T377 866q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5T904 517q151 0 235.5 82t84.5 213q0 170-68.5 289T980 1220q-61 0-98-43.5T859 1072q8-35 26.5-93.5t30-103T927 800q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281T128 896q0-209 103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z\"></path>\n    </symbol>\n  </defs>\n</svg>";
// /**
// Determine the keycode for the 'back' key based on the platform
const $86defbb4e95ebb07$var$backKeyCode = $86defbb4e95ebb07$var$IS_TIZEN ? 10009 : $86defbb4e95ebb07$var$IS_WEBOS ? 461 : 8;
const $86defbb4e95ebb07$var$SpatialNavKeyCodes = {
    codes: {
        play: 415,
        pause: 19,
        ff: 417,
        rw: 412,
        back: $86defbb4e95ebb07$var$backKeyCode
    },
    names: {
        415: 'play',
        19: 'pause',
        417: 'ff',
        412: 'rw',
        [$86defbb4e95ebb07$var$backKeyCode]: 'back'
    },
    isEventKey (event, keyName) {
        keyName = keyName.toLowerCase();
        if (this.names[event.keyCode] && this.names[event.keyCode] === keyName) return true;
        return false;
    },
    getEventName (event) {
        if (this.names[event.keyCode]) return this.names[event.keyCode];
        else if (this.codes[event.code]) {
            const code = this.codes[event.code];
            return this.names[code];
        }
        return null;
    }
};
/**
 * @file spatial-navigation.js
 */ /** @import Component from './component' */ /** @import Player from './player' */ // The number of seconds the `step*` functions move the timeline.
const $86defbb4e95ebb07$var$STEP_SECONDS = 5;
/**
 * Spatial Navigation in Video.js enhances user experience and accessibility on smartTV devices,
 * enabling seamless navigation through interactive elements within the player using remote control arrow keys.
 * This functionality allows users to effortlessly navigate through focusable components.
 *
 * @extends EventTarget
 */ class $86defbb4e95ebb07$var$SpatialNavigation extends $86defbb4e95ebb07$var$EventTarget$2 {
    /**
   * Constructs a SpatialNavigation instance with initial settings.
   * Sets up the player instance, and prepares the spatial navigation system.
   *
   * @class
   * @param {Player} player - The Video.js player instance to which the spatial navigation is attached.
   */ constructor(player){
        super();
        this.player_ = player;
        this.focusableComponents = [];
        this.isListening_ = false;
        this.isPaused_ = false;
        this.onKeyDown_ = this.onKeyDown_.bind(this);
        this.lastFocusedComponent_ = null;
    }
    /**
   * Starts the spatial navigation by adding a keydown event listener to the video container.
   * This method ensures that the event listener is added only once.
   */ start() {
        // If the listener is already active, exit early.
        if (this.isListening_) return;
        // Add the event listener since the listener is not yet active.
        this.player_.on('keydown', this.onKeyDown_);
        this.player_.on('modalKeydown', this.onKeyDown_);
        // Listen for source change events
        this.player_.on('loadedmetadata', ()=>{
            this.focus(this.updateFocusableComponents()[0]);
        });
        this.player_.on('modalclose', ()=>{
            this.refocusComponent();
        });
        this.player_.on('focusin', this.handlePlayerFocus_.bind(this));
        this.player_.on('focusout', this.handlePlayerBlur_.bind(this));
        this.isListening_ = true;
        if (this.player_.errorDisplay) this.player_.errorDisplay.on('aftermodalfill', ()=>{
            this.updateFocusableComponents();
            if (this.focusableComponents.length) {
                // The modal has focusable components:
                if (this.focusableComponents.length > 1) // The modal has close button + some additional buttons.
                // Focusing first additional button:
                this.focusableComponents[1].focus();
                else // The modal has only close button,
                // Focusing it:
                this.focusableComponents[0].focus();
            }
        });
    }
    /**
   * Stops the spatial navigation by removing the keydown event listener from the video container.
   * Also sets the `isListening_` flag to false.
   */ stop() {
        this.player_.off('keydown', this.onKeyDown_);
        this.isListening_ = false;
    }
    /**
   * Responds to keydown events for spatial navigation and media control.
   *
   * Determines if spatial navigation or media control is active and handles key inputs accordingly.
   *
   * @param {KeyboardEvent} event - The keydown event to be handled.
   */ onKeyDown_(event) {
        // Determine if the event is a custom modalKeydown event
        const actualEvent = event.originalEvent ? event.originalEvent : event;
        if ([
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'ArrowDown'
        ].includes(actualEvent.key)) {
            // Handle directional navigation
            if (this.isPaused_) return;
            actualEvent.preventDefault();
            // "ArrowLeft" => "left" etc
            const direction = actualEvent.key.substring(5).toLowerCase();
            this.move(direction);
        } else if ($86defbb4e95ebb07$var$SpatialNavKeyCodes.isEventKey(actualEvent, 'play') || $86defbb4e95ebb07$var$SpatialNavKeyCodes.isEventKey(actualEvent, 'pause') || $86defbb4e95ebb07$var$SpatialNavKeyCodes.isEventKey(actualEvent, 'ff') || $86defbb4e95ebb07$var$SpatialNavKeyCodes.isEventKey(actualEvent, 'rw')) {
            // Handle media actions
            actualEvent.preventDefault();
            const action = $86defbb4e95ebb07$var$SpatialNavKeyCodes.getEventName(actualEvent);
            this.performMediaAction_(action);
        } else if ($86defbb4e95ebb07$var$SpatialNavKeyCodes.isEventKey(actualEvent, 'Back') && event.target && typeof event.target.closeable === 'function' && event.target.closeable()) {
            actualEvent.preventDefault();
            event.target.close();
        }
    }
    /**
   * Performs media control actions based on the given key input.
   *
   * Controls the playback and seeking functionalities of the media player.
   *
   * @param {string} key - The key representing the media action to be performed.
   *   Accepted keys: 'play', 'pause', 'ff' (fast-forward), 'rw' (rewind).
   */ performMediaAction_(key) {
        if (this.player_) switch(key){
            case 'play':
                if (this.player_.paused()) this.player_.play();
                break;
            case 'pause':
                if (!this.player_.paused()) this.player_.pause();
                break;
            case 'ff':
                this.userSeek_(this.player_.currentTime() + $86defbb4e95ebb07$var$STEP_SECONDS);
                break;
            case 'rw':
                this.userSeek_(this.player_.currentTime() - $86defbb4e95ebb07$var$STEP_SECONDS);
                break;
        }
    }
    /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */ userSeek_(ct) {
        if (this.player_.liveTracker && this.player_.liveTracker.isLive()) this.player_.liveTracker.nextSeekedFromUser();
        this.player_.currentTime(ct);
    }
    /**
   * Pauses the spatial navigation functionality.
   * This method sets a flag that can be used to temporarily disable the navigation logic.
   */ pause() {
        this.isPaused_ = true;
    }
    /**
   * Resumes the spatial navigation functionality if it has been paused.
   * This method resets the pause flag, re-enabling the navigation logic.
   */ resume() {
        this.isPaused_ = false;
    }
    /**
   * Handles Player Blur.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * Calls for handling of the Player Blur if:
   * *The next focused element is not a child of current focused element &
   * The next focused element is not a child of the Player.
   * *There is no next focused element
   */ handlePlayerBlur_(event) {
        const nextFocusedElement = event.relatedTarget;
        let isChildrenOfPlayer = null;
        const currentComponent = this.getCurrentComponent(event.target);
        if (nextFocusedElement) {
            isChildrenOfPlayer = Boolean(nextFocusedElement.closest('.video-js'));
            // If nextFocusedElement is the 'TextTrackSettings' component
            if (nextFocusedElement.classList.contains('vjs-text-track-settings') && !this.isPaused_) this.searchForTrackSelect_();
        }
        if (!event.currentTarget.contains(event.relatedTarget) && !isChildrenOfPlayer || !nextFocusedElement) {
            if (currentComponent && currentComponent.name() === 'CloseButton') this.refocusComponent();
            else {
                this.pause();
                if (currentComponent && currentComponent.el()) // Store last focused component
                this.lastFocusedComponent_ = currentComponent;
            }
        }
    }
    /**
   * Handles the Player focus event.
   *
   * Calls for handling of the Player Focus if current element is focusable.
   */ handlePlayerFocus_() {
        if (this.getCurrentComponent() && this.getCurrentComponent().getIsFocusable()) this.resume();
    }
    /**
   * Gets a set of focusable components.
   *
   * @return {Array}
   *         Returns an array of focusable components.
   */ updateFocusableComponents() {
        const player = this.player_;
        const focusableComponents = [];
        /**
     * Searches for children candidates.
     *
     * Pushes Components to array of 'focusableComponents'.
     * Calls itself if there is children elements inside iterated component.
     *
     * @param {Array} componentsArray - The array of components to search for focusable children.
     */ function searchForChildrenCandidates(componentsArray) {
            for (const i of componentsArray){
                if (i.hasOwnProperty('el_') && i.getIsFocusable() && i.getIsAvailableToBeFocused(i.el())) focusableComponents.push(i);
                if (i.hasOwnProperty('children_') && i.children_.length > 0) searchForChildrenCandidates(i.children_);
            }
        }
        // Iterate inside all children components of the player.
        player.children_.forEach((value)=>{
            if (value.hasOwnProperty('el_')) {
                // If component has required functions 'getIsFocusable' & 'getIsAvailableToBeFocused', is focusable & available to be focused.
                if (value.getIsFocusable && value.getIsAvailableToBeFocused && value.getIsFocusable() && value.getIsAvailableToBeFocused(value.el())) {
                    focusableComponents.push(value);
                    return;
                // If component has posible children components as candidates.
                } else if (value.hasOwnProperty('children_') && value.children_.length > 0) searchForChildrenCandidates(value.children_);
                else if (value.hasOwnProperty('items') && value.items.length > 0) searchForChildrenCandidates(value.items);
                else if (this.findSuitableDOMChild(value)) focusableComponents.push(value);
            }
            // TODO - Refactor the following logic after refactor of videojs-errors elements to be components is done.
            if (value.name_ === 'ErrorDisplay' && value.opened_) {
                const buttonContainer = value.el_.querySelector('.vjs-errors-ok-button-container');
                if (buttonContainer) {
                    const modalButtons = buttonContainer.querySelectorAll('button');
                    modalButtons.forEach((element, index)=>{
                        // Add elements as objects to be handled by the spatial navigation
                        focusableComponents.push({
                            name: ()=>{
                                return 'ModalButton' + (index + 1);
                            },
                            el: ()=>element,
                            getPositions: ()=>{
                                const rect = element.getBoundingClientRect();
                                // Creating objects that mirror DOMRectReadOnly for boundingClientRect and center
                                const boundingClientRect = {
                                    x: rect.x,
                                    y: rect.y,
                                    width: rect.width,
                                    height: rect.height,
                                    top: rect.top,
                                    right: rect.right,
                                    bottom: rect.bottom,
                                    left: rect.left
                                };
                                // Calculating the center position
                                const center = {
                                    x: rect.left + rect.width / 2,
                                    y: rect.top + rect.height / 2,
                                    width: 0,
                                    height: 0,
                                    top: rect.top + rect.height / 2,
                                    right: rect.left + rect.width / 2,
                                    bottom: rect.top + rect.height / 2,
                                    left: rect.left + rect.width / 2
                                };
                                return {
                                    boundingClientRect: boundingClientRect,
                                    center: center
                                };
                            },
                            // Asume that the following are always focusable
                            getIsAvailableToBeFocused: ()=>true,
                            getIsFocusable: (el)=>true,
                            focus: ()=>element.focus()
                        });
                    });
                }
            }
        });
        this.focusableComponents = focusableComponents;
        return this.focusableComponents;
    }
    /**
   * Finds a suitable child element within the provided component's DOM element.
   *
   * @param {Object} component - The component containing the DOM element to search within.
   * @return {HTMLElement|null} Returns the suitable child element if found, or null if not found.
   */ findSuitableDOMChild(component) {
        /**
     * Recursively searches for a suitable child node that can be focused within a given component.
     * It first checks if the provided node itself can be focused according to the component's
     * `getIsFocusable` and `getIsAvailableToBeFocused` methods. If not, it recursively searches
     * through the node's children to find a suitable child node that meets the focusability criteria.
     *
     * @param {HTMLElement} node - The DOM node to start the search from.
     * @return {HTMLElement|null} The first child node that is focusable and available to be focused,
     * or `null` if no suitable child is found.
     */ function searchForSuitableChild(node) {
            if (component.getIsFocusable(node) && component.getIsAvailableToBeFocused(node)) return node;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                const suitableChild = searchForSuitableChild(child);
                if (suitableChild) return suitableChild;
            }
            return null;
        }
        if (component.el()) return searchForSuitableChild(component.el());
        return null;
    }
    /**
   * Gets the currently focused component from the list of focusable components.
   * If a target element is provided, it uses that element to find the corresponding
   * component. If no target is provided, it defaults to using the document's currently
   * active element.
   *
   * @param {HTMLElement} [target] - The DOM element to check against the focusable components.
   *                                 If not provided, `document.activeElement` is used.
   * @return {Component|null} - Returns the focused component if found among the focusable components,
   *                            otherwise returns null if no matching component is found.
   */ getCurrentComponent(target) {
        this.updateFocusableComponents();
        // eslint-disable-next-line
        const curComp = target || document.activeElement;
        if (this.focusableComponents.length) for (const i of this.focusableComponents){
            // If component Node is equal to the current active element.
            if (i.el() === curComp) return i;
        }
    }
    /**
   * Adds a component to the array of focusable components.
   *
   * @param {Component} component
   *        The `Component` to be added.
   */ add(component) {
        const focusableComponents = [
            ...this.focusableComponents
        ];
        if (component.hasOwnProperty('el_') && component.getIsFocusable() && component.getIsAvailableToBeFocused(component.el())) focusableComponents.push(component);
        this.focusableComponents = focusableComponents;
        // Trigger the notification manually
        this.trigger({
            type: 'focusableComponentsChanged',
            focusableComponents: this.focusableComponents
        });
    }
    /**
   * Removes component from the array of focusable components.
   *
   * @param {Component} component - The component to be removed from the focusable components array.
   */ remove(component) {
        for(let i = 0; i < this.focusableComponents.length; i++)if (this.focusableComponents[i].name() === component.name()) {
            this.focusableComponents.splice(i, 1);
            // Trigger the notification manually
            this.trigger({
                type: 'focusableComponentsChanged',
                focusableComponents: this.focusableComponents
            });
            return;
        }
    }
    /**
   * Clears array of focusable components.
   */ clear() {
        // Check if the array is already empty to avoid unnecessary event triggering
        if (this.focusableComponents.length > 0) {
            // Clear the array
            this.focusableComponents = [];
            // Trigger the notification manually
            this.trigger({
                type: 'focusableComponentsChanged',
                focusableComponents: this.focusableComponents
            });
        }
    }
    /**
   * Navigates to the next focusable component based on the specified direction.
   *
   * @param {string} direction 'up', 'down', 'left', 'right'
   */ move(direction) {
        const currentFocusedComponent = this.getCurrentComponent();
        if (!currentFocusedComponent) return;
        const currentPositions = currentFocusedComponent.getPositions();
        const candidates = this.focusableComponents.filter((component)=>component !== currentFocusedComponent && this.isInDirection_(currentPositions.boundingClientRect, component.getPositions().boundingClientRect, direction));
        const bestCandidate = this.findBestCandidate_(currentPositions.center, candidates, direction);
        if (bestCandidate) this.focus(bestCandidate);
        else this.trigger({
            type: 'endOfFocusableComponents',
            direction: direction,
            focusedComponent: currentFocusedComponent
        });
    }
    /**
   * Finds the best candidate on the current center position,
   * the list of candidates, and the specified navigation direction.
   *
   * @param {Object} currentCenter The center position of the current focused component element.
   * @param {Array} candidates An array of candidate components to receive focus.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {Object|null} The component that is the best candidate for receiving focus.
   */ findBestCandidate_(currentCenter, candidates, direction) {
        let minDistance = Infinity;
        let bestCandidate = null;
        for (const candidate of candidates){
            const candidateCenter = candidate.getPositions().center;
            const distance = this.calculateDistance_(currentCenter, candidateCenter, direction);
            if (distance < minDistance) {
                minDistance = distance;
                bestCandidate = candidate;
            }
        }
        return bestCandidate;
    }
    /**
   * Determines if a target rectangle is in the specified navigation direction
   * relative to a source rectangle.
   *
   * @param {Object} srcRect The bounding rectangle of the source element.
   * @param {Object} targetRect The bounding rectangle of the target element.
   * @param {string} direction The navigation direction ('up', 'down', 'left', 'right').
   * @return {boolean} True if the target is in the specified direction relative to the source.
   */ isInDirection_(srcRect, targetRect, direction) {
        switch(direction){
            case 'right':
                return targetRect.left >= srcRect.right;
            case 'left':
                return targetRect.right <= srcRect.left;
            case 'down':
                return targetRect.top >= srcRect.bottom;
            case 'up':
                return targetRect.bottom <= srcRect.top;
            default:
                return false;
        }
    }
    /**
   * Focus the last focused component saved before blur on player.
   */ refocusComponent() {
        if (this.lastFocusedComponent_) {
            // If user is not active, set it to active.
            if (!this.player_.userActive()) this.player_.userActive(true);
            this.updateFocusableComponents();
            // Search inside array of 'focusableComponents' for a match of name of
            // the last focused component.
            for(let i = 0; i < this.focusableComponents.length; i++)if (this.focusableComponents[i].name() === this.lastFocusedComponent_.name()) {
                this.focus(this.focusableComponents[i]);
                return;
            }
        } else this.focus(this.updateFocusableComponents()[0]);
    }
    /**
   * Focuses on a given component.
   * If the component is available to be focused, it focuses on the component.
   * If not, it attempts to find a suitable DOM child within the component and focuses on it.
   *
   * @param {Component} component - The component to be focused.
   */ focus(component) {
        if (typeof component !== 'object') return;
        if (component.getIsAvailableToBeFocused(component.el())) component.focus();
        else if (this.findSuitableDOMChild(component)) this.findSuitableDOMChild(component).focus();
    }
    /**
   * Calculates the distance between two points, adjusting the calculation based on
   * the specified navigation direction.
   *
   * @param {Object} center1 The center point of the first element.
   * @param {Object} center2 The center point of the second element.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {number} The calculated distance between the two centers.
   */ calculateDistance_(center1, center2, direction) {
        const dx = Math.abs(center1.x - center2.x);
        const dy = Math.abs(center1.y - center2.y);
        let distance;
        switch(direction){
            case 'right':
            case 'left':
                // Higher weight for vertical distance in horizontal navigation.
                distance = dx + dy * 100;
                break;
            case 'up':
                // Strongly prioritize vertical proximity for UP navigation.
                // Adjust the weight to ensure that elements directly above are favored.
                distance = dy * 2 + dx * 0.5;
                break;
            case 'down':
                // More balanced weight for vertical and horizontal distances.
                // Adjust the weights here to find the best balance.
                distance = dy * 5 + dx;
                break;
            default:
                distance = dx + dy;
        }
        return distance;
    }
    /**
   * This gets called by 'handlePlayerBlur_' if 'spatialNavigation' is enabled.
   * Searches for the first 'TextTrackSelect' inside of modal to focus.
   *
   * @private
   */ searchForTrackSelect_() {
        const spatialNavigation = this;
        for (const component of spatialNavigation.updateFocusableComponents())if (component.constructor.name === 'TextTrackSelect') {
            spatialNavigation.focus(component);
            break;
        }
    }
}
/**
 * @file loader.js
 */ /** @import Player from '../player' */ /**
 * The `MediaLoader` is the `Component` that decides which playback technology to load
 * when a player is initialized.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$MediaLoader extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function that is run when this component is ready.
   */ constructor(player, options, ready){
        // MediaLoader has no element
        const options_ = $86defbb4e95ebb07$var$merge$1({
            createEl: false
        }, options);
        super(player, options_, ready);
        // If there are no sources when the player is initialized,
        // load the first supported playback technology.
        if (!options.playerOptions.sources || options.playerOptions.sources.length === 0) for(let i = 0, j = options.playerOptions.techOrder; i < j.length; i++){
            const techName = $86defbb4e95ebb07$var$toTitleCase$1(j[i]);
            let tech = $86defbb4e95ebb07$var$Tech.getTech(techName);
            // Support old behavior of techs being registered as components.
            // Remove once that deprecated behavior is removed.
            if (!techName) tech = $86defbb4e95ebb07$var$Component$1.getComponent(techName);
            // Check if the browser supports this technology
            if (tech && tech.isSupported()) {
                player.loadTech_(techName);
                break;
            }
        }
        else // Loop through playback technologies (e.g. HTML5) and check for support.
        // Then load the best source.
        // A few assumptions here:
        //   All playback technologies respect preload false.
        player.src(options.playerOptions.sources);
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('MediaLoader', $86defbb4e95ebb07$var$MediaLoader);
/**
 * @file clickable-component.js
 */ /** @import Player from './player' */ /**
 * Component which is clickable or keyboard actionable, but is not a
 * native HTML button.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$ClickableComponent extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of component options.
   *
   * @param  {function} [options.clickHandler]
   *         The function to call when the button is clicked / activated
   *
   * @param  {string} [options.controlText]
   *         The text to set on the button
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   */ constructor(player, options){
        super(player, options);
        if (this.options_.controlText) this.controlText(this.options_.controlText);
        this.handleMouseOver_ = (e)=>this.handleMouseOver(e);
        this.handleMouseOut_ = (e)=>this.handleMouseOut(e);
        this.handleClick_ = (e)=>this.handleClick(e);
        this.handleKeyDown_ = (e)=>this.handleKeyDown(e);
        this.emitTapEvents();
        this.enable();
    }
    /**
   * Create the `ClickableComponent`s DOM element.
   *
   * @param {string} [tag=div]
   *        The element's node type.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(tag = 'div', props = {}, attributes = {}) {
        props = Object.assign({
            className: this.buildCSSClass(),
            tabIndex: 0
        }, props);
        if (tag === 'button') $86defbb4e95ebb07$var$log$1.error(`Creating a ClickableComponent with an HTML element of ${tag} is not supported; use a Button instead.`);
        // Add ARIA attributes for clickable element which is not a native HTML button
        attributes = Object.assign({
            role: 'button'
        }, attributes);
        this.tabIndex_ = props.tabIndex;
        const el = $86defbb4e95ebb07$var$createEl(tag, props, attributes);
        if (!this.player_.options_.experimentalSvgIcons) el.appendChild($86defbb4e95ebb07$var$createEl('span', {
            className: 'vjs-icon-placeholder'
        }, {
            'aria-hidden': true
        }));
        this.createControlTextEl(el);
        return el;
    }
    dispose() {
        // remove controlTextEl_ on dispose
        this.controlTextEl_ = null;
        super.dispose();
    }
    /**
   * Create a control text element on this `ClickableComponent`
   *
   * @param {Element} [el]
   *        Parent element for the control text.
   *
   * @return {Element}
   *         The control text element that gets created.
   */ createControlTextEl(el) {
        this.controlTextEl_ = $86defbb4e95ebb07$var$createEl('span', {
            className: 'vjs-control-text'
        }, {
            // let the screen reader user know that the text of the element may change
            'aria-live': 'polite'
        });
        if (el) el.appendChild(this.controlTextEl_);
        this.controlText(this.controlText_, el);
        return this.controlTextEl_;
    }
    /**
   * Get or set the localize text to use for the controls on the `ClickableComponent`.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */ controlText(text, el = this.el()) {
        if (text === undefined) return this.controlText_ || 'Need Text';
        const localizedText = this.localize(text);
        /** @protected */ this.controlText_ = text;
        $86defbb4e95ebb07$var$textContent(this.controlTextEl_, localizedText);
        if (!this.nonIconControl && !this.player_.options_.noUITitleAttributes) // Set title attribute if only an icon is shown
        el.setAttribute('title', localizedText);
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-control vjs-button ${super.buildCSSClass()}`;
    }
    /**
   * Enable this `ClickableComponent`
   */ enable() {
        if (!this.enabled_) {
            this.enabled_ = true;
            this.removeClass('vjs-disabled');
            this.el_.setAttribute('aria-disabled', 'false');
            if (typeof this.tabIndex_ !== 'undefined') this.el_.setAttribute('tabIndex', this.tabIndex_);
            this.on([
                'tap',
                'click'
            ], this.handleClick_);
            this.on('keydown', this.handleKeyDown_);
        }
    }
    /**
   * Disable this `ClickableComponent`
   */ disable() {
        this.enabled_ = false;
        this.addClass('vjs-disabled');
        this.el_.setAttribute('aria-disabled', 'true');
        if (typeof this.tabIndex_ !== 'undefined') this.el_.removeAttribute('tabIndex');
        this.off('mouseover', this.handleMouseOver_);
        this.off('mouseout', this.handleMouseOut_);
        this.off([
            'tap',
            'click'
        ], this.handleClick_);
        this.off('keydown', this.handleKeyDown_);
    }
    /**
   * Handles language change in ClickableComponent for the player in components
   *
   *
   */ handleLanguagechange() {
        this.controlText(this.controlText_);
    }
    /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `click` or `tap` event.
   *
   * @param {Event} event
   *        The `tap` or `click` event that caused this function to be called.
   *
   * @listens tap
   * @listens click
   * @abstract
   */ handleClick(event) {
        if (this.options_.clickHandler) this.options_.clickHandler.call(this, arguments);
    }
    /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `keydown` event.
   *
   * By default, if the key is Space or Enter, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Support Space or Enter key operation to fire a click event. Also,
        // prevent the event from propagating through the DOM and triggering
        // Player hotkeys.
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.trigger('click');
        } else // Pass keypress handling up for unsupported keys
        super.handleKeyDown(event);
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('ClickableComponent', $86defbb4e95ebb07$var$ClickableComponent);
/**
 * @file poster-image.js
 */ /** @import Player from './player' */ /**
 * A `ClickableComponent` that handles showing the poster image for the player.
 *
 * @extends ClickableComponent
 */ class $86defbb4e95ebb07$var$PosterImage extends $86defbb4e95ebb07$var$ClickableComponent {
    /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update();
        this.update_ = (e)=>this.update(e);
        player.on('posterchange', this.update_);
    }
    /**
   * Clean up and dispose of the `PosterImage`.
   */ dispose() {
        this.player().off('posterchange', this.update_);
        super.dispose();
    }
    /**
   * Create the `PosterImage`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl() {
        // The el is an empty div to keep position in the DOM
        // A picture and img el will be inserted when a source is set
        return $86defbb4e95ebb07$var$createEl('div', {
            className: 'vjs-poster'
        });
    }
    /**
   * Get or set the `PosterImage`'s crossOrigin option.
   *
   * @param {string|null} [value]
   *        The value to set the crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */ crossOrigin(value) {
        // `null` can be set to unset a value
        if (typeof value === 'undefined') {
            if (this.$('img')) // If the poster's element exists, give its value
            return this.$('img').crossOrigin;
            else if (this.player_.tech_ && this.player_.tech_.isReady_) // If not but the tech is ready, query the tech
            return this.player_.crossOrigin();
            // Otherwise check options as the  poster is usually set before the state of crossorigin
            // can be retrieved by the getter
            return this.player_.options_.crossOrigin || this.player_.options_.crossorigin || null;
        }
        if (value !== null && value !== 'anonymous' && value !== 'use-credentials') {
            this.player_.log.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${value}"`);
            return;
        }
        if (this.$('img')) this.$('img').crossOrigin = value;
        return;
    }
    /**
   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
   *
   * @listens Player#posterchange
   *
   * @param {Event} [event]
   *        The `Player#posterchange` event that triggered this function.
   */ update(event) {
        const url = this.player().poster();
        this.setSrc(url);
        // If there's no poster source we should display:none on this component
        // so it's not still clickable or right-clickable
        if (url) this.show();
        else this.hide();
    }
    /**
   * Set the source of the `PosterImage` depending on the display method. (Re)creates
   * the inner picture and img elementss when needed.
   *
   * @param {string} [url]
   *        The URL to the source for the `PosterImage`. If not specified or falsy,
   *        any source and ant inner picture/img are removed.
   */ setSrc(url) {
        if (!url) {
            this.el_.textContent = '';
            return;
        }
        if (!this.$('img')) this.el_.appendChild($86defbb4e95ebb07$var$createEl('picture', {
            className: 'vjs-poster',
            // Don't want poster to be tabbable.
            tabIndex: -1
        }, {}, $86defbb4e95ebb07$var$createEl('img', {
            loading: 'lazy',
            crossOrigin: this.crossOrigin()
        }, {
            alt: ''
        })));
        this.$('img').src = url;
    }
    /**
   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
   *
   * @listens tap
   * @listens click
   * @listens keydown
   *
   * @param {Event} event
   +        The `click`, `tap` or `keydown` event that caused this function to be called.
   */ handleClick(event) {
        // We don't want a click to trigger playback when controls are disabled
        if (!this.player_.controls()) return;
        if (this.player_.tech(true)) this.player_.tech(true).focus();
        if (this.player_.paused()) $86defbb4e95ebb07$var$silencePromise(this.player_.play());
        else this.player_.pause();
    }
}
/**
 * Get or set the `PosterImage`'s crossorigin option. For the HTML5 player, this
 * sets the `crossOrigin` property on the `<img>` tag to control the CORS
 * behavior.
 *
 * @param {string|null} [value]
 *        The value to set the `PosterImages`'s crossorigin to. If an argument is
 *        given, must be one of `anonymous` or `use-credentials`.
 *
 * @return {string|null|undefined}
 *         - The current crossorigin value of the `Player` when getting.
 *         - undefined when setting
 */ $86defbb4e95ebb07$var$PosterImage.prototype.crossorigin = $86defbb4e95ebb07$var$PosterImage.prototype.crossOrigin;
$86defbb4e95ebb07$var$Component$1.registerComponent('PosterImage', $86defbb4e95ebb07$var$PosterImage);
/**
 * @file text-track-display.js
 */ /** @import Player from '../player' */ const $86defbb4e95ebb07$var$darkGray = '#222';
const $86defbb4e95ebb07$var$lightGray = '#ccc';
const $86defbb4e95ebb07$var$fontMap = {
    monospace: 'monospace',
    sansSerif: 'sans-serif',
    serif: 'serif',
    monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
    monospaceSerif: '"Courier New", monospace',
    proportionalSansSerif: 'sans-serif',
    proportionalSerif: 'serif',
    casual: '"Comic Sans MS", Impact, fantasy',
    script: '"Monotype Corsiva", cursive',
    smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};
/**
 * Construct an rgba color from a given hex color code.
 *
 * @param {number} color
 *        Hex number for color, like #f0e or #f604e2.
 *
 * @param {number} opacity
 *        Value for opacity, 0.0 - 1.0.
 *
 * @return {string}
 *         The rgba color that was created, like 'rgba(255, 0, 0, 0.3)'.
 */ function $86defbb4e95ebb07$var$constructColor(color, opacity) {
    let hex;
    if (color.length === 4) // color looks like "#f0e"
    hex = color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
    else if (color.length === 7) // color looks like "#f604e2"
    hex = color.slice(1);
    else throw new Error('Invalid color code provided, ' + color + '; must be formatted as e.g. #f0e or #f604e2.');
    return 'rgba(' + parseInt(hex.slice(0, 2), 16) + ',' + parseInt(hex.slice(2, 4), 16) + ',' + parseInt(hex.slice(4, 6), 16) + ',' + opacity + ')';
}
/**
 * Try to update the style of a DOM element. Some style changes will throw an error,
 * particularly in IE8. Those should be noops.
 *
 * @param {Element} el
 *        The DOM element to be styled.
 *
 * @param {string} style
 *        The CSS property on the element that should be styled.
 *
 * @param {string} rule
 *        The style rule that should be applied to the property.
 *
 * @private
 */ function $86defbb4e95ebb07$var$tryUpdateStyle(el, style, rule) {
    try {
        el.style[style] = rule;
    } catch (e) {
        // Satisfies linter.
        return;
    }
}
/**
 * Converts the CSS top/right/bottom/left property numeric value to string in pixels.
 *
 * @param {number} position
 *        The CSS top/right/bottom/left property value.
 *
 * @return {string}
 *          The CSS property value that was created, like '10px'.
 *
 * @private
 */ function $86defbb4e95ebb07$var$getCSSPositionValue(position) {
    return position ? `${position}px` : '';
}
/**
 * The component for displaying text track cues.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$TextTrackDisplay extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when `TextTrackDisplay` is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        const updateDisplayTextHandler = (e)=>this.updateDisplay(e);
        const updateDisplayHandler = (e)=>{
            this.updateDisplayOverlay();
            this.updateDisplay(e);
        };
        player.on('loadstart', (e)=>this.toggleDisplay(e));
        player.on('useractive', updateDisplayTextHandler);
        player.on('userinactive', updateDisplayTextHandler);
        player.on('texttrackchange', updateDisplayTextHandler);
        player.on('loadedmetadata', (e)=>{
            this.updateDisplayOverlay();
            this.preselectTrack(e);
        });
        // This used to be called during player init, but was causing an error
        // if a track should show by default and the display hadn't loaded yet.
        // Should probably be moved to an external track loader when we support
        // tracks that don't need a display.
        player.ready($86defbb4e95ebb07$var$bind_(this, function() {
            if (player.tech_ && player.tech_.featuresNativeTextTracks) {
                this.hide();
                return;
            }
            player.on('fullscreenchange', updateDisplayHandler);
            player.on('playerresize', updateDisplayHandler);
            const screenOrientation = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).screen.orientation || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi)));
            const changeOrientationEvent = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).screen.orientation ? 'change' : 'orientationchange';
            screenOrientation.addEventListener(changeOrientationEvent, updateDisplayHandler);
            player.on('dispose', ()=>screenOrientation.removeEventListener(changeOrientationEvent, updateDisplayHandler));
            const tracks = this.options_.playerOptions.tracks || [];
            for(let i = 0; i < tracks.length; i++)this.player_.addRemoteTextTrack(tracks[i], true);
            this.preselectTrack();
        }));
    }
    /**
  * Preselect a track following this precedence:
  * - matches the previously selected {@link TextTrack}'s language and kind
  * - matches the previously selected {@link TextTrack}'s language only
  * - is the first default captions track
  * - is the first default descriptions track
  *
  * @listens Player#loadstart
  */ preselectTrack() {
        const modes = {
            captions: 1,
            subtitles: 1
        };
        const trackList = this.player_.textTracks();
        const userPref = this.player_.cache_.selectedLanguage;
        let firstDesc;
        let firstCaptions;
        let preferredTrack;
        for(let i = 0; i < trackList.length; i++){
            const track = trackList[i];
            if (userPref && userPref.enabled && userPref.language && userPref.language === track.language && track.kind in modes) {
                // Always choose the track that matches both language and kind
                if (track.kind === userPref.kind) preferredTrack = track;
                else if (!preferredTrack) preferredTrack = track;
            // clear everything if offTextTrackMenuItem was clicked
            } else if (userPref && !userPref.enabled) {
                preferredTrack = null;
                firstDesc = null;
                firstCaptions = null;
            } else if (track.default) {
                if (track.kind === 'descriptions' && !firstDesc) firstDesc = track;
                else if (track.kind in modes && !firstCaptions) firstCaptions = track;
            }
        }
        // The preferredTrack matches the user preference and takes
        // precedence over all the other tracks.
        // So, display the preferredTrack before the first default track
        // and the subtitles/captions track before the descriptions track
        if (preferredTrack) preferredTrack.mode = 'showing';
        else if (firstCaptions) firstCaptions.mode = 'showing';
        else if (firstDesc) firstDesc.mode = 'showing';
    }
    /**
   * Turn display of {@link TextTrack}'s from the current state into the other state.
   * There are only two states:
   * - 'shown'
   * - 'hidden'
   *
   * @listens Player#loadstart
   */ toggleDisplay() {
        if (this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks) this.hide();
        else this.show();
    }
    /**
   * Create the {@link Component}'s DOM element.
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-text-track-display'
        }, {
            'translate': 'yes',
            'aria-live': 'off',
            'aria-atomic': 'true'
        });
    }
    /**
   * Clear all displayed {@link TextTrack}s.
   */ clearDisplay() {
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT === 'function') (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT.processCues((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))), [], this.el_);
    }
    /**
   * Update the displayed {@link TextTrack} when either a {@link Player#texttrackchange},
   * a {@link Player#fullscreenchange}, a {@link Player#useractive}, or a
   * {@link Player#userinactive} is fired.
   *
   * @listens Player#texttrackchange
   * @listens Player#fullscreenchange
   * @listens Player#useractive
   * @listens Player#userinactive
   */ updateDisplay() {
        const tracks = this.player_.textTracks();
        const allowMultipleShowingTracks = this.options_.allowMultipleShowingTracks;
        this.clearDisplay();
        if (allowMultipleShowingTracks) {
            const showingTracks = [];
            for(let i = 0; i < tracks.length; ++i){
                const track = tracks[i];
                if (track.mode !== 'showing') continue;
                showingTracks.push(track);
            }
            this.updateForTrack(showingTracks);
            return;
        }
        //  Track display prioritization model: if multiple tracks are 'showing',
        //  display the first 'subtitles' or 'captions' track which is 'showing',
        //  otherwise display the first 'descriptions' track which is 'showing'
        let descriptionsTrack = null;
        let captionsSubtitlesTrack = null;
        let i = tracks.length;
        while(i--){
            const track = tracks[i];
            if (track.mode === 'showing') {
                if (track.kind === 'descriptions') descriptionsTrack = track;
                else captionsSubtitlesTrack = track;
            }
        }
        if (captionsSubtitlesTrack) {
            if (this.getAttribute('aria-live') !== 'off') this.setAttribute('aria-live', 'off');
            this.updateForTrack(captionsSubtitlesTrack);
        } else if (descriptionsTrack) {
            if (this.getAttribute('aria-live') !== 'assertive') this.setAttribute('aria-live', 'assertive');
            this.updateForTrack(descriptionsTrack);
        }
        if (!((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).CSS !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).CSS.supports('inset', '10px'))) {
            const textTrackDisplay = this.el_;
            const vjsTextTrackCues = textTrackDisplay.querySelectorAll('.vjs-text-track-cue');
            const controlBarHeight = this.player_.controlBar.el_.getBoundingClientRect().height;
            const playerHeight = this.player_.el_.getBoundingClientRect().height;
            // Clear inline style before getting actual height of textTrackDisplay
            textTrackDisplay.style = '';
            // textrack style updates, this styles are required to be inline
            $86defbb4e95ebb07$var$tryUpdateStyle(textTrackDisplay, 'position', 'relative');
            $86defbb4e95ebb07$var$tryUpdateStyle(textTrackDisplay, 'height', playerHeight - controlBarHeight + 'px');
            $86defbb4e95ebb07$var$tryUpdateStyle(textTrackDisplay, 'top', 'unset');
            if ($86defbb4e95ebb07$var$IS_SMART_TV) $86defbb4e95ebb07$var$tryUpdateStyle(textTrackDisplay, 'bottom', playerHeight + 'px');
            else $86defbb4e95ebb07$var$tryUpdateStyle(textTrackDisplay, 'bottom', '0px');
            // vjsTextTrackCue style updates
            if (vjsTextTrackCues.length > 0) vjsTextTrackCues.forEach((vjsTextTrackCue)=>{
                // verify if inset styles are inline
                if (vjsTextTrackCue.style.inset) {
                    const insetStyles = vjsTextTrackCue.style.inset.split(' ');
                    // expected value is always 3
                    if (insetStyles.length === 3) Object.assign(vjsTextTrackCue.style, {
                        top: insetStyles[0],
                        right: insetStyles[1],
                        bottom: insetStyles[2],
                        left: 'unset'
                    });
                }
            });
        }
    }
    /**
   * Updates the displayed TextTrack to be sure it overlays the video when a either
   * a {@link Player#texttrackchange} or a {@link Player#fullscreenchange} is fired.
   */ updateDisplayOverlay() {
        // inset-inline and inset-block are not supprted on old chrome, but these are
        // only likely to be used on TV devices
        if (!this.player_.videoHeight() || !((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).CSS !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).CSS.supports('inset-inline: 10px'))) return;
        const playerWidth = this.player_.currentWidth();
        const playerHeight = this.player_.currentHeight();
        const playerAspectRatio = playerWidth / playerHeight;
        const videoAspectRatio = this.player_.videoWidth() / this.player_.videoHeight();
        let insetInlineMatch = 0;
        let insetBlockMatch = 0;
        if (Math.abs(playerAspectRatio - videoAspectRatio) > 0.1) {
            if (playerAspectRatio > videoAspectRatio) insetInlineMatch = Math.round((playerWidth - playerHeight * videoAspectRatio) / 2);
            else insetBlockMatch = Math.round((playerHeight - playerWidth / videoAspectRatio) / 2);
        }
        $86defbb4e95ebb07$var$tryUpdateStyle(this.el_, 'insetInline', $86defbb4e95ebb07$var$getCSSPositionValue(insetInlineMatch));
        $86defbb4e95ebb07$var$tryUpdateStyle(this.el_, 'insetBlock', $86defbb4e95ebb07$var$getCSSPositionValue(insetBlockMatch));
    }
    /**
   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
   *
   * @param {TextTrack} track
   *        Text track object containing active cues to style.
   */ updateDisplayState(track) {
        const overrides = this.player_.textTrackSettings.getValues();
        const cues = track.activeCues;
        let i = cues.length;
        while(i--){
            const cue = cues[i];
            if (!cue) continue;
            const cueDiv = cue.displayState;
            if (overrides.color) cueDiv.firstChild.style.color = overrides.color;
            if (overrides.textOpacity) $86defbb4e95ebb07$var$tryUpdateStyle(cueDiv.firstChild, 'color', $86defbb4e95ebb07$var$constructColor(overrides.color || '#fff', overrides.textOpacity));
            if (overrides.backgroundColor) cueDiv.firstChild.style.backgroundColor = overrides.backgroundColor;
            if (overrides.backgroundOpacity) $86defbb4e95ebb07$var$tryUpdateStyle(cueDiv.firstChild, 'backgroundColor', $86defbb4e95ebb07$var$constructColor(overrides.backgroundColor || '#000', overrides.backgroundOpacity));
            if (overrides.windowColor) {
                if (overrides.windowOpacity) $86defbb4e95ebb07$var$tryUpdateStyle(cueDiv, 'backgroundColor', $86defbb4e95ebb07$var$constructColor(overrides.windowColor, overrides.windowOpacity));
                else cueDiv.style.backgroundColor = overrides.windowColor;
            }
            if (overrides.edgeStyle) {
                if (overrides.edgeStyle === 'dropshadow') cueDiv.firstChild.style.textShadow = `2px 2px 3px ${$86defbb4e95ebb07$var$darkGray}, 2px 2px 4px ${$86defbb4e95ebb07$var$darkGray}, 2px 2px 5px ${$86defbb4e95ebb07$var$darkGray}`;
                else if (overrides.edgeStyle === 'raised') cueDiv.firstChild.style.textShadow = `1px 1px ${$86defbb4e95ebb07$var$darkGray}, 2px 2px ${$86defbb4e95ebb07$var$darkGray}, 3px 3px ${$86defbb4e95ebb07$var$darkGray}`;
                else if (overrides.edgeStyle === 'depressed') cueDiv.firstChild.style.textShadow = `1px 1px ${$86defbb4e95ebb07$var$lightGray}, 0 1px ${$86defbb4e95ebb07$var$lightGray}, -1px -1px ${$86defbb4e95ebb07$var$darkGray}, 0 -1px ${$86defbb4e95ebb07$var$darkGray}`;
                else if (overrides.edgeStyle === 'uniform') cueDiv.firstChild.style.textShadow = `0 0 4px ${$86defbb4e95ebb07$var$darkGray}, 0 0 4px ${$86defbb4e95ebb07$var$darkGray}, 0 0 4px ${$86defbb4e95ebb07$var$darkGray}, 0 0 4px ${$86defbb4e95ebb07$var$darkGray}`;
            }
            if (overrides.fontPercent && overrides.fontPercent !== 1) {
                const fontSize = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).parseFloat(cueDiv.style.fontSize);
                cueDiv.style.fontSize = fontSize * overrides.fontPercent + 'px';
                cueDiv.style.height = 'auto';
                cueDiv.style.top = 'auto';
            }
            if (overrides.fontFamily && overrides.fontFamily !== 'default') {
                if (overrides.fontFamily === 'small-caps') cueDiv.firstChild.style.fontVariant = 'small-caps';
                else cueDiv.firstChild.style.fontFamily = $86defbb4e95ebb07$var$fontMap[overrides.fontFamily];
            }
        }
    }
    /**
   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
   *
   * @param {TextTrack|TextTrack[]} tracks
   *        Text track object or text track array to be added to the list.
   */ updateForTrack(tracks) {
        if (!Array.isArray(tracks)) tracks = [
            tracks
        ];
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT !== 'function' || tracks.every((track)=>{
            return !track.activeCues;
        })) return;
        const cues = [];
        // push all active track cues
        for(let i = 0; i < tracks.length; ++i){
            const track = tracks[i];
            for(let j = 0; j < track.activeCues.length; ++j)cues.push(track.activeCues[j]);
        }
        // removes all cues before it processes new ones
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT.processCues((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))), cues, this.el_);
        // add unique class to each language text track & add settings styling if necessary
        for(let i = 0; i < tracks.length; ++i){
            const track = tracks[i];
            for(let j = 0; j < track.activeCues.length; ++j){
                const cueEl = track.activeCues[j].displayState;
                $86defbb4e95ebb07$var$addClass(cueEl, 'vjs-text-track-cue', 'vjs-text-track-cue-' + (track.language ? track.language : i));
                if (track.language) $86defbb4e95ebb07$var$setAttribute(cueEl, 'lang', track.language);
            }
            if (this.player_.textTrackSettings) this.updateDisplayState(track);
        }
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TextTrackDisplay', $86defbb4e95ebb07$var$TextTrackDisplay);
/**
 * @file loading-spinner.js
 */ /**
 * A loading spinner for use during waiting/loading events.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$LoadingSpinner extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Create the `LoadingSpinner`s DOM element.
   *
   * @return {Element}
   *         The dom element that gets created.
   */ createEl() {
        const isAudio = this.player_.isAudio();
        const playerType = this.localize(isAudio ? 'Audio Player' : 'Video Player');
        const controlText = $86defbb4e95ebb07$var$createEl('span', {
            className: 'vjs-control-text',
            textContent: this.localize('{1} is loading.', [
                playerType
            ])
        });
        const el = super.createEl('div', {
            className: 'vjs-loading-spinner',
            dir: 'ltr'
        });
        el.appendChild(controlText);
        return el;
    }
    /**
   * Update control text on languagechange
   */ handleLanguagechange() {
        this.$('.vjs-control-text').textContent = this.localize('{1} is loading.', [
            this.player_.isAudio() ? 'Audio Player' : 'Video Player'
        ]);
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('LoadingSpinner', $86defbb4e95ebb07$var$LoadingSpinner);
/**
 * @file button.js
 */ /**
 * Base class for all buttons.
 *
 * @extends ClickableComponent
 */ class $86defbb4e95ebb07$var$Button extends $86defbb4e95ebb07$var$ClickableComponent {
    /**
   * Create the `Button`s DOM element.
   *
   * @param {string} [tag="button"]
   *        The element's node type. This argument is IGNORED: no matter what
   *        is passed, it will always create a `button` element.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(tag, props = {}, attributes = {}) {
        tag = 'button';
        props = Object.assign({
            className: this.buildCSSClass()
        }, props);
        // Add attributes for button element
        attributes = Object.assign({
            // Necessary since the default button type is "submit"
            type: 'button'
        }, attributes);
        const el = $86defbb4e95ebb07$var$createEl(tag, props, attributes);
        if (!this.player_.options_.experimentalSvgIcons) el.appendChild($86defbb4e95ebb07$var$createEl('span', {
            className: 'vjs-icon-placeholder'
        }, {
            'aria-hidden': true
        }));
        this.createControlTextEl(el);
        return el;
    }
    /**
   * Add a child `Component` inside of this `Button`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   *
   * @deprecated since version 5
   */ addChild(child, options = {}) {
        const className = this.constructor.name;
        $86defbb4e95ebb07$var$log$1.warn(`Adding an actionable (user controllable) child to a Button (${className}) is not supported; use a ClickableComponent instead.`);
        // Avoid the error message generated by ClickableComponent's addChild method
        return $86defbb4e95ebb07$var$Component$1.prototype.addChild.call(this, child, options);
    }
    /**
   * Enable the `Button` element so that it can be activated or clicked. Use this with
   * {@link Button#disable}.
   */ enable() {
        super.enable();
        this.el_.removeAttribute('disabled');
    }
    /**
   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
   * {@link Button#enable}.
   */ disable() {
        super.disable();
        this.el_.setAttribute('disabled', 'disabled');
    }
    /**
   * This gets called when a `Button` has focus and `keydown` is triggered via a key
   * press.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to get called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Ignore Space or Enter key operation, which is handled by the browser for
        // a button - though not for its super class, ClickableComponent. Also,
        // prevent the event from propagating through the DOM and triggering Player
        // hotkeys. We do not preventDefault here because we _want_ the browser to
        // handle it.
        if (event.key === ' ' || event.key === 'Enter') {
            event.stopPropagation();
            return;
        }
        // Pass keypress handling up for unsupported keys
        super.handleKeyDown(event);
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('Button', $86defbb4e95ebb07$var$Button);
/**
 * @file big-play-button.js
 */ /**
 * The initial play button that shows before the video has played. The hiding of the
 * `BigPlayButton` get done via CSS and `Player` states.
 *
 * @extends Button
 */ class $86defbb4e95ebb07$var$BigPlayButton extends $86defbb4e95ebb07$var$Button {
    constructor(player, options){
        super(player, options);
        this.mouseused_ = false;
        this.setIcon('play');
        this.on('mousedown', (e)=>this.handleMouseDown(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
   */ buildCSSClass() {
        return 'vjs-big-play-button';
    }
    /**
   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {KeyboardEvent|MouseEvent|TouchEvent} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        const playPromise = this.player_.play();
        // exit early if tapped or clicked via the mouse
        if (event.type === 'tap' || this.mouseused_ && 'clientX' in event && 'clientY' in event) {
            $86defbb4e95ebb07$var$silencePromise(playPromise);
            if (this.player_.tech(true)) this.player_.tech(true).focus();
            return;
        }
        const cb = this.player_.getChild('controlBar');
        const playToggle = cb && cb.getChild('playToggle');
        if (!playToggle) {
            this.player_.tech(true).focus();
            return;
        }
        const playFocus = ()=>playToggle.focus();
        if ($86defbb4e95ebb07$var$isPromise(playPromise)) playPromise.then(playFocus, ()=>{});
        else this.setTimeout(playFocus, 1);
    }
    /**
   * Event handler that is called when a `BigPlayButton` receives a
   * `keydown` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        this.mouseused_ = false;
        super.handleKeyDown(event);
    }
    /**
   * Handle `mousedown` events on the `BigPlayButton`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   */ handleMouseDown(event) {
        this.mouseused_ = true;
    }
}
/**
 * The text that should display over the `BigPlayButton`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$BigPlayButton.prototype.controlText_ = 'Play Video';
$86defbb4e95ebb07$var$Component$1.registerComponent('BigPlayButton', $86defbb4e95ebb07$var$BigPlayButton);
/**
 * @file close-button.js
 */ /** @import Player from './player' */ /**
 * The `CloseButton` is a `{@link Button}` that fires a `close` event when
 * it gets clicked.
 *
 * @extends Button
 */ class $86defbb4e95ebb07$var$CloseButton extends $86defbb4e95ebb07$var$Button {
    /**
  * Creates an instance of the this class.
  *
  * @param  {Player} player
  *         The `Player` that this class should be attached to.
  *
  * @param  {Object} [options]
  *         The key/value store of player options.
  */ constructor(player, options){
        super(player, options);
        this.setIcon('cancel');
        this.controlText(options && options.controlText || this.localize('Close'));
    }
    /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */ buildCSSClass() {
        return `vjs-close-button ${super.buildCSSClass()}`;
    }
    /**
   * This gets called when a `CloseButton` gets clicked. See
   * {@link ClickableComponent#handleClick} for more information on when
   * this will be triggered
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   * @fires CloseButton#close
   */ handleClick(event) {
        /**
     * Triggered when the a `CloseButton` is clicked.
     *
     * @event CloseButton#close
     * @type {Event}
     *
     * @property {boolean} [bubbles=false]
     *           set to false so that the close event does not
     *           bubble up to parents if there is no listener
     */ this.trigger({
            type: 'close',
            bubbles: false
        });
    }
    /**
   * Event handler that is called when a `CloseButton` receives a
   * `keydown` event.
   *
   * By default, if the key is Esc, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Esc button will trigger `click` event
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.trigger('click');
        } else // Pass keypress handling up for unsupported keys
        super.handleKeyDown(event);
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('CloseButton', $86defbb4e95ebb07$var$CloseButton);
/**
 * @file play-toggle.js
 */ /** @import Player from '../player' */ /**
 * Button to toggle between play and pause.
 *
 * @extends Button
 */ class $86defbb4e95ebb07$var$PlayToggle extends $86defbb4e95ebb07$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        super(player, options);
        // show or hide replay icon
        options.replay = options.replay === undefined || options.replay;
        this.setIcon('play');
        this.on(player, 'play', (e)=>this.handlePlay(e));
        this.on(player, 'pause', (e)=>this.handlePause(e));
        if (options.replay) this.on(player, 'ended', (e)=>this.handleEnded(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-play-control ${super.buildCSSClass()}`;
    }
    /**
   * This gets called when an `PlayToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        if (this.player_.paused()) $86defbb4e95ebb07$var$silencePromise(this.player_.play());
        else this.player_.pause();
    }
    /**
   * This gets called once after the video has ended and the user seeks so that
   * we can change the replay button back to a play button.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#seeked
   */ handleSeeked(event) {
        this.removeClass('vjs-ended');
        if (this.player_.paused()) this.handlePause(event);
        else this.handlePlay(event);
    }
    /**
   * Add the vjs-playing class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#play
   */ handlePlay(event) {
        this.removeClass('vjs-ended', 'vjs-paused');
        this.addClass('vjs-playing');
        // change the button text to "Pause"
        this.setIcon('pause');
        this.controlText('Pause');
    }
    /**
   * Add the vjs-paused class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#pause
   */ handlePause(event) {
        this.removeClass('vjs-playing');
        this.addClass('vjs-paused');
        // change the button text to "Play"
        this.setIcon('play');
        this.controlText('Play');
    }
    /**
   * Add the vjs-ended class to the element so it can change appearance
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ended
   */ handleEnded(event) {
        this.removeClass('vjs-playing');
        this.addClass('vjs-ended');
        // change the button text to "Replay"
        this.setIcon('replay');
        this.controlText('Replay');
        // on the next seek remove the replay button
        this.one(this.player_, 'seeked', (e)=>this.handleSeeked(e));
    }
}
/**
 * The text that should display over the `PlayToggle`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$PlayToggle.prototype.controlText_ = 'Play';
$86defbb4e95ebb07$var$Component$1.registerComponent('PlayToggle', $86defbb4e95ebb07$var$PlayToggle);
/**
 * @file time-display.js
 */ /** @import Player from '../../player' */ /**
 * Displays time information about the video
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$TimeDisplay extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.on(player, [
            'timeupdate',
            'ended',
            'seeking'
        ], (e)=>this.update(e));
        this.updateTextNode_();
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const className = this.buildCSSClass();
        const el = super.createEl('div', {
            className: `${className} vjs-time-control vjs-control`
        });
        const span = $86defbb4e95ebb07$var$createEl('span', {
            className: 'vjs-control-text',
            textContent: `${this.localize(this.labelText_)}\u00a0`
        }, {
            role: 'presentation'
        });
        el.appendChild(span);
        this.contentEl_ = $86defbb4e95ebb07$var$createEl('span', {
            className: `${className}-display`
        }, {
            // span elements have no implicit role, but some screen readers (notably VoiceOver)
            // treat them as a break between items in the DOM when using arrow keys
            // (or left-to-right swipes on iOS) to read contents of a page. Using
            // role='presentation' causes VoiceOver to NOT treat this span as a break.
            role: 'presentation'
        });
        el.appendChild(this.contentEl_);
        return el;
    }
    dispose() {
        this.contentEl_ = null;
        this.textNode_ = null;
        super.dispose();
    }
    /**
   * Updates the displayed time according to the `updateContent` function which is defined in the child class.
   *
   * @param {Event} [event]
   *          The `timeupdate`, `ended` or `seeking` (if enableSmoothSeeking is true) event that caused this function to be called.
   */ update(event) {
        if (!this.player_.options_.enableSmoothSeeking && event.type === 'seeking') return;
        this.updateContent(event);
    }
    /**
   * Updates the time display text node with a new time
   *
   * @param {number} [time=0] the time to update to
   *
   * @private
   */ updateTextNode_(time = 0) {
        time = $86defbb4e95ebb07$var$formatTime(time);
        if (this.formattedTime_ === time) return;
        this.formattedTime_ = time;
        this.requestNamedAnimationFrame('TimeDisplay#updateTextNode_', ()=>{
            if (!this.contentEl_) return;
            let oldNode = this.textNode_;
            if (oldNode && this.contentEl_.firstChild !== oldNode) {
                oldNode = null;
                $86defbb4e95ebb07$var$log$1.warn('TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.');
            }
            this.textNode_ = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createTextNode(this.formattedTime_);
            if (!this.textNode_) return;
            if (oldNode) this.contentEl_.replaceChild(this.textNode_, oldNode);
            else this.contentEl_.appendChild(this.textNode_);
        });
    }
    /**
   * To be filled out in the child class, should update the displayed time
   * in accordance with the fact that the current time has changed.
   *
   * @param {Event} [event]
   *        The `timeupdate`  event that caused this to run.
   *
   * @listens Player#timeupdate
   */ updateContent(event) {}
}
/**
 * The text that is added to the `TimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */ $86defbb4e95ebb07$var$TimeDisplay.prototype.labelText_ = 'Time';
/**
 * The text that should display over the `TimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */ $86defbb4e95ebb07$var$TimeDisplay.prototype.controlText_ = 'Time';
$86defbb4e95ebb07$var$Component$1.registerComponent('TimeDisplay', $86defbb4e95ebb07$var$TimeDisplay);
/**
 * @file current-time-display.js
 */ /**
 * Displays the current time
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$CurrentTimeDisplay extends $86defbb4e95ebb07$var$TimeDisplay {
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return 'vjs-current-time';
    }
    /**
   * Update current time display
   *
   * @param {Event} [event]
   *        The `timeupdate` event that caused this function to run.
   *
   * @listens Player#timeupdate
   */ updateContent(event) {
        // Allows for smooth scrubbing, when player can't keep up.
        let time;
        if (this.player_.ended()) time = this.player_.duration();
        else if (event && event.target && typeof event.target.pendingSeekTime === 'function' && event.target.pendingSeekTime() !== null) time = event.target.pendingSeekTime();
        else time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
        this.updateTextNode_(time);
    }
}
/**
 * The text that is added to the `CurrentTimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */ $86defbb4e95ebb07$var$CurrentTimeDisplay.prototype.labelText_ = 'Current Time';
/**
 * The text that should display over the `CurrentTimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */ $86defbb4e95ebb07$var$CurrentTimeDisplay.prototype.controlText_ = 'Current Time';
$86defbb4e95ebb07$var$Component$1.registerComponent('CurrentTimeDisplay', $86defbb4e95ebb07$var$CurrentTimeDisplay);
/**
 * @file duration-display.js
 */ /** @import Player from '../../player' */ /**
 * Displays the duration
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$DurationDisplay extends $86defbb4e95ebb07$var$TimeDisplay {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        const updateContent = (e)=>this.updateContent(e);
        // we do not want to/need to throttle duration changes,
        // as they should always display the changed duration as
        // it has changed
        this.on(player, 'durationchange', updateContent);
        // Listen to loadstart because the player duration is reset when a new media element is loaded,
        // but the durationchange on the user agent will not fire.
        // @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
        this.on(player, 'loadstart', updateContent);
        // Also listen for timeupdate (in the parent) and loadedmetadata because removing those
        // listeners could have broken dependent applications/libraries. These
        // can likely be removed for 7.0.
        this.on(player, 'loadedmetadata', updateContent);
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return 'vjs-duration';
    }
    /**
   * Update duration time display.
   *
   * @param {Event} [event]
   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
   *        this function to be called.
   *
   * @listens Player#durationchange
   * @listens Player#timeupdate
   * @listens Player#loadedmetadata
   */ updateContent(event) {
        const duration = this.player_.duration();
        this.updateTextNode_(duration);
    }
}
/**
 * The text that is added to the `DurationDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */ $86defbb4e95ebb07$var$DurationDisplay.prototype.labelText_ = 'Duration';
/**
 * The text that should display over the `DurationDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */ $86defbb4e95ebb07$var$DurationDisplay.prototype.controlText_ = 'Duration';
$86defbb4e95ebb07$var$Component$1.registerComponent('DurationDisplay', $86defbb4e95ebb07$var$DurationDisplay);
/**
 * @file time-divider.js
 */ /**
 * The separator between the current time and duration.
 * Can be hidden if it's not needed in the design.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$TimeDivider extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Create the component's DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl('div', {
            className: 'vjs-time-control vjs-time-divider'
        }, {
            // this element and its contents can be hidden from assistive techs since
            // it is made extraneous by the announcement of the control text
            // for the current time and duration displays
            'aria-hidden': true
        });
        const div = super.createEl('div');
        const span = super.createEl('span', {
            textContent: '/'
        });
        div.appendChild(span);
        el.appendChild(div);
        return el;
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TimeDivider', $86defbb4e95ebb07$var$TimeDivider);
/**
 * @file remaining-time-display.js
 */ /** @import Player from '../../player' */ /**
 * Displays the time left in the video
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$RemainingTimeDisplay extends $86defbb4e95ebb07$var$TimeDisplay {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.on(player, 'durationchange', (e)=>this.updateContent(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return 'vjs-remaining-time';
    }
    /**
   * Create the `Component`'s DOM element with the "minus" character prepend to the time
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl();
        if (this.options_.displayNegative !== false) el.insertBefore($86defbb4e95ebb07$var$createEl('span', {}, {
            'aria-hidden': true
        }, '-'), this.contentEl_);
        return el;
    }
    /**
   * Update remaining time display.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `durationchange` event that caused this to run.
   *
   * @listens Player#timeupdate
   * @listens Player#durationchange
   */ updateContent(event) {
        if (typeof this.player_.duration() !== 'number') return;
        let time;
        // @deprecated We should only use remainingTimeDisplay
        // as of video.js 7
        if (this.player_.ended()) time = 0;
        else if (this.player_.remainingTimeDisplay) time = this.player_.remainingTimeDisplay();
        else time = this.player_.remainingTime();
        this.updateTextNode_(time);
    }
}
/**
 * The text that is added to the `RemainingTimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */ $86defbb4e95ebb07$var$RemainingTimeDisplay.prototype.labelText_ = 'Remaining Time';
/**
 * The text that should display over the `RemainingTimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */ $86defbb4e95ebb07$var$RemainingTimeDisplay.prototype.controlText_ = 'Remaining Time';
$86defbb4e95ebb07$var$Component$1.registerComponent('RemainingTimeDisplay', $86defbb4e95ebb07$var$RemainingTimeDisplay);
/**
 * @file live-display.js
 */ /** @import Player from '../player' */ // TODO - Future make it click to snap to live
/**
 * Displays the live indicator when duration is Infinity.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$LiveDisplay extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.updateShowing();
        this.on(this.player(), 'durationchange', (e)=>this.updateShowing(e));
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl('div', {
            className: 'vjs-live-control vjs-control'
        });
        this.contentEl_ = $86defbb4e95ebb07$var$createEl('div', {
            className: 'vjs-live-display'
        }, {
            'aria-live': 'off'
        });
        this.contentEl_.appendChild($86defbb4e95ebb07$var$createEl('span', {
            className: 'vjs-control-text',
            textContent: `${this.localize('Stream Type')}\u00a0`
        }));
        this.contentEl_.appendChild((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createTextNode(this.localize('LIVE')));
        el.appendChild(this.contentEl_);
        return el;
    }
    dispose() {
        this.contentEl_ = null;
        super.dispose();
    }
    /**
   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
   * it accordingly
   *
   * @param {Event} [event]
   *        The {@link Player#durationchange} event that caused this function to run.
   *
   * @listens Player#durationchange
   */ updateShowing(event) {
        if (this.player().duration() === Infinity) this.show();
        else this.hide();
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('LiveDisplay', $86defbb4e95ebb07$var$LiveDisplay);
/**
 * @file seek-to-live.js
 */ /** @import Player from '../player' */ /**
 * Displays the live indicator when duration is Infinity.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$SeekToLive extends $86defbb4e95ebb07$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.updateLiveEdgeStatus();
        if (this.player_.liveTracker) {
            this.updateLiveEdgeStatusHandler_ = (e)=>this.updateLiveEdgeStatus(e);
            this.on(this.player_.liveTracker, 'liveedgechange', this.updateLiveEdgeStatusHandler_);
        }
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl('button', {
            className: 'vjs-seek-to-live-control vjs-control'
        });
        this.setIcon('circle', el);
        this.textEl_ = $86defbb4e95ebb07$var$createEl('span', {
            className: 'vjs-seek-to-live-text',
            textContent: this.localize('LIVE')
        }, {
            'aria-hidden': 'true'
        });
        el.appendChild(this.textEl_);
        return el;
    }
    /**
   * Update the state of this button if we are at the live edge
   * or not
   */ updateLiveEdgeStatus() {
        // default to live edge
        if (!this.player_.liveTracker || this.player_.liveTracker.atLiveEdge()) {
            this.setAttribute('aria-disabled', true);
            this.addClass('vjs-at-live-edge');
            this.controlText('Seek to live, currently playing live');
        } else {
            this.setAttribute('aria-disabled', false);
            this.removeClass('vjs-at-live-edge');
            this.controlText('Seek to live, currently behind live');
        }
    }
    /**
   * On click bring us as near to the live point as possible.
   * This requires that we wait for the next `live-seekable-change`
   * event which will happen every segment length seconds.
   */ handleClick() {
        this.player_.liveTracker.seekToLiveEdge();
    }
    /**
   * Dispose of the element and stop tracking
   */ dispose() {
        if (this.player_.liveTracker) this.off(this.player_.liveTracker, 'liveedgechange', this.updateLiveEdgeStatusHandler_);
        this.textEl_ = null;
        super.dispose();
    }
}
/**
 * The text that should display over the `SeekToLive`s control. Added for localization.
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$SeekToLive.prototype.controlText_ = 'Seek to live, currently playing live';
$86defbb4e95ebb07$var$Component$1.registerComponent('SeekToLive', $86defbb4e95ebb07$var$SeekToLive);
/**
 * @file num.js
 * @module num
 */ /**
 * Keep a number between a min and a max value
 *
 * @param {number} number
 *        The number to clamp
 *
 * @param {number} min
 *        The minimum value
 * @param {number} max
 *        The maximum value
 *
 * @return {number}
 *         the clamped number
 */ function $86defbb4e95ebb07$var$clamp(number, min, max) {
    number = Number(number);
    return Math.min(max, Math.max(min, isNaN(number) ? min : number));
}
var $86defbb4e95ebb07$var$Num = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    clamp: $86defbb4e95ebb07$var$clamp
});
/**
 * @file slider.js
 */ /** @import Player from '../player' */ /**
 * The base functionality for a slider. Can be vertical or horizontal.
 * For instance the volume bar or the seek bar on a video is a slider.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$Slider extends $86defbb4e95ebb07$var$Component$1 {
    /**
  * Create an instance of this class
  *
  * @param {Player} player
  *        The `Player` that this class should be attached to.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  */ constructor(player, options){
        super(player, options);
        this.handleMouseDown_ = (e)=>this.handleMouseDown(e);
        this.handleMouseUp_ = (e)=>this.handleMouseUp(e);
        this.handleKeyDown_ = (e)=>this.handleKeyDown(e);
        this.handleClick_ = (e)=>this.handleClick(e);
        this.handleMouseMove_ = (e)=>this.handleMouseMove(e);
        this.update_ = (e)=>this.update(e);
        // Set property names to bar to match with the child Slider class is looking for
        this.bar = this.getChild(this.options_.barName);
        // Set a horizontal or vertical class on the slider depending on the slider type
        this.vertical(!!this.options_.vertical);
        this.enable();
    }
    /**
   * Are controls are currently enabled for this slider or not.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */ enabled() {
        return this.enabled_;
    }
    /**
   * Enable controls for this slider if they are disabled
   */ enable() {
        if (this.enabled()) return;
        this.on('mousedown', this.handleMouseDown_);
        this.on('touchstart', this.handleMouseDown_);
        this.on('keydown', this.handleKeyDown_);
        this.on('click', this.handleClick_);
        // TODO: deprecated, controlsvisible does not seem to be fired
        this.on(this.player_, 'controlsvisible', this.update);
        if (this.playerEvent) this.on(this.player_, this.playerEvent, this.update);
        this.removeClass('disabled');
        this.setAttribute('tabindex', 0);
        this.enabled_ = true;
    }
    /**
   * Disable controls for this slider if they are enabled
   */ disable() {
        if (!this.enabled()) return;
        const doc = this.bar.el_.ownerDocument;
        this.off('mousedown', this.handleMouseDown_);
        this.off('touchstart', this.handleMouseDown_);
        this.off('keydown', this.handleKeyDown_);
        this.off('click', this.handleClick_);
        this.off(this.player_, 'controlsvisible', this.update_);
        this.off(doc, 'mousemove', this.handleMouseMove_);
        this.off(doc, 'mouseup', this.handleMouseUp_);
        this.off(doc, 'touchmove', this.handleMouseMove_);
        this.off(doc, 'touchend', this.handleMouseUp_);
        this.removeAttribute('tabindex');
        this.addClass('disabled');
        if (this.playerEvent) this.off(this.player_, this.playerEvent, this.update);
        this.enabled_ = false;
    }
    /**
   * Create the `Slider`s DOM element.
   *
   * @param {string} type
   *        Type of element to create.
   *
   * @param {Object} [props={}]
   *        List of properties in Object form.
   *
   * @param {Object} [attributes={}]
   *        list of attributes in Object form.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(type, props = {}, attributes = {}) {
        // Add the slider element class to all sub classes
        props.className = props.className + ' vjs-slider';
        props = Object.assign({
            tabIndex: 0
        }, props);
        attributes = Object.assign({
            'role': 'slider',
            'aria-valuenow': 0,
            'aria-valuemin': 0,
            'aria-valuemax': 100
        }, attributes);
        return super.createEl(type, props, attributes);
    }
    /**
   * Handle `mousedown` or `touchstart` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   * @fires Slider#slideractive
   */ handleMouseDown(event) {
        const doc = this.bar.el_.ownerDocument;
        if (event.type === 'mousedown') event.preventDefault();
        // Do not call preventDefault() on touchstart in Chrome
        // to avoid console warnings. Use a 'touch-action: none' style
        // instead to prevent unintended scrolling.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        if (event.type === 'touchstart' && !$86defbb4e95ebb07$var$IS_CHROME) event.preventDefault();
        $86defbb4e95ebb07$var$blockTextSelection();
        this.addClass('vjs-sliding');
        /**
     * Triggered when the slider is in an active state
     *
     * @event Slider#slideractive
     * @type {MouseEvent}
     */ this.trigger('slideractive');
        this.on(doc, 'mousemove', this.handleMouseMove_);
        this.on(doc, 'mouseup', this.handleMouseUp_);
        this.on(doc, 'touchmove', this.handleMouseMove_);
        this.on(doc, 'touchend', this.handleMouseUp_);
        this.handleMouseMove(event, true);
    }
    /**
   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
   * The `mousemove` and `touchmove` events will only only trigger this function during
   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
   * {@link Slider#handleMouseUp}.
   *
   * @param {MouseEvent} event
   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
   *        this function
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
   *
   * @listens mousemove
   * @listens touchmove
   */ handleMouseMove(event) {}
    /**
   * Handle `mouseup` or `touchend` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   * @fires Slider#sliderinactive
   */ handleMouseUp(event) {
        const doc = this.bar.el_.ownerDocument;
        $86defbb4e95ebb07$var$unblockTextSelection();
        this.removeClass('vjs-sliding');
        /**
     * Triggered when the slider is no longer in an active state.
     *
     * @event Slider#sliderinactive
     * @type {Event}
     */ this.trigger('sliderinactive');
        this.off(doc, 'mousemove', this.handleMouseMove_);
        this.off(doc, 'mouseup', this.handleMouseUp_);
        this.off(doc, 'touchmove', this.handleMouseMove_);
        this.off(doc, 'touchend', this.handleMouseUp_);
        this.update();
    }
    /**
   * Update the progress bar of the `Slider`.
   *
   * @return {number}
   *          The percentage of progress the progress bar represents as a
   *          number from 0 to 1.
   */ update() {
        // In VolumeBar init we have a setTimeout for update that pops and update
        // to the end of the execution stack. The player is destroyed before then
        // update will cause an error
        // If there's no bar...
        if (!this.el_ || !this.bar) return;
        // clamp progress between 0 and 1
        // and only round to four decimal places, as we round to two below
        const progress = this.getProgress();
        if (progress === this.progress_) return progress;
        this.progress_ = progress;
        this.requestNamedAnimationFrame('Slider#update', ()=>{
            // Set the new bar width or height
            const sizeKey = this.vertical() ? 'height' : 'width';
            // Convert to a percentage for css value
            this.bar.el().style[sizeKey] = (progress * 100).toFixed(2) + '%';
        });
        return progress;
    }
    /**
   * Get the percentage of the bar that should be filled
   * but clamped and rounded.
   *
   * @return {number}
   *         percentage filled that the slider is
   */ getProgress() {
        return Number($86defbb4e95ebb07$var$clamp(this.getPercent(), 0, 1).toFixed(4));
    }
    /**
   * Calculate distance for slider
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @return {number}
   *         The current position of the Slider.
   *         - position.x for vertical `Slider`s
   *         - position.y for horizontal `Slider`s
   */ calculateDistance(event) {
        const position = $86defbb4e95ebb07$var$getPointerPosition(this.el_, event);
        if (this.vertical()) return position.y;
        return position.x;
    }
    /**
   * Handle a `keydown` event on the `Slider`. Watches for left, right, up, and down
   * arrow keys. This function will only be called when the slider has focus. See
   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
   *
   * @param {KeyboardEvent} event
   *        the `keydown` event that caused this function to run.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        const spatialNavOptions = this.options_.playerOptions.spatialNavigation;
        const spatialNavEnabled = spatialNavOptions && spatialNavOptions.enabled;
        const horizontalSeek = spatialNavOptions && spatialNavOptions.horizontalSeek;
        if (spatialNavEnabled) {
            if (horizontalSeek && event.key === 'ArrowLeft' || !horizontalSeek && event.key === 'ArrowDown') {
                event.preventDefault();
                event.stopPropagation();
                this.stepBack();
            } else if (horizontalSeek && event.key === 'ArrowRight' || !horizontalSeek && event.key === 'ArrowUp') {
                event.preventDefault();
                event.stopPropagation();
                this.stepForward();
            } else {
                if (this.pendingSeekTime()) {
                    this.pendingSeekTime(null);
                    this.userSeek_(this.player_.currentTime());
                }
                super.handleKeyDown(event);
            }
        // Left and Down Arrows
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
            event.preventDefault();
            event.stopPropagation();
            this.stepBack();
        // Up and Right Arrows
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowRight') {
            event.preventDefault();
            event.stopPropagation();
            this.stepForward();
        } else // Pass keydown handling up for unsupported keys
        super.handleKeyDown(event);
    }
    /**
   * Listener for click events on slider, used to prevent clicks
   *   from bubbling up to parent elements like button menus.
   *
   * @param {Object} event
   *        Event that caused this object to run
   */ handleClick(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    /**
   * Get/set if slider is horizontal for vertical
   *
   * @param {boolean} [bool]
   *        - true if slider is vertical,
   *        - false is horizontal
   *
   * @return {boolean}
   *         - true if slider is vertical, and getting
   *         - false if the slider is horizontal, and getting
   */ vertical(bool) {
        if (bool === undefined) return this.vertical_ || false;
        this.vertical_ = !!bool;
        if (this.vertical_) this.addClass('vjs-slider-vertical');
        else this.addClass('vjs-slider-horizontal');
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('Slider', $86defbb4e95ebb07$var$Slider);
/**
 * @file load-progress-bar.js
 */ /** @import Player from '../../player' */ // get the percent width of a time compared to the total end
const $86defbb4e95ebb07$var$percentify = (time, end)=>$86defbb4e95ebb07$var$clamp(time / end * 100, 0, 100).toFixed(2) + '%';
/**
 * Shows loading progress
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$LoadProgressBar extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.partEls_ = [];
        this.on(player, 'progress', (e)=>this.update(e));
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl('div', {
            className: 'vjs-load-progress'
        });
        const wrapper = $86defbb4e95ebb07$var$createEl('span', {
            className: 'vjs-control-text'
        });
        const loadedText = $86defbb4e95ebb07$var$createEl('span', {
            textContent: this.localize('Loaded')
        });
        const separator = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createTextNode(': ');
        this.percentageEl_ = $86defbb4e95ebb07$var$createEl('span', {
            className: 'vjs-control-text-loaded-percentage',
            textContent: '0%'
        });
        el.appendChild(wrapper);
        wrapper.appendChild(loadedText);
        wrapper.appendChild(separator);
        wrapper.appendChild(this.percentageEl_);
        return el;
    }
    dispose() {
        this.partEls_ = null;
        this.percentageEl_ = null;
        super.dispose();
    }
    /**
   * Update progress bar
   *
   * @param {Event} [event]
   *        The `progress` event that caused this function to run.
   *
   * @listens Player#progress
   */ update(event) {
        this.requestNamedAnimationFrame('LoadProgressBar#update', ()=>{
            const liveTracker = this.player_.liveTracker;
            const buffered = this.player_.buffered();
            const duration = liveTracker && liveTracker.isLive() ? liveTracker.seekableEnd() : this.player_.duration();
            const bufferedEnd = this.player_.bufferedEnd();
            const children = this.partEls_;
            const percent = $86defbb4e95ebb07$var$percentify(bufferedEnd, duration);
            if (this.percent_ !== percent) {
                // update the width of the progress bar
                this.el_.style.width = percent;
                // update the control-text
                $86defbb4e95ebb07$var$textContent(this.percentageEl_, percent);
                this.percent_ = percent;
            }
            // add child elements to represent the individual buffered time ranges
            for(let i = 0; i < buffered.length; i++){
                const start = buffered.start(i);
                const end = buffered.end(i);
                let part = children[i];
                if (!part) {
                    part = this.el_.appendChild($86defbb4e95ebb07$var$createEl());
                    children[i] = part;
                }
                //  only update if changed
                if (part.dataset.start === start && part.dataset.end === end) continue;
                part.dataset.start = start;
                part.dataset.end = end;
                // set the percent based on the width of the progress bar (bufferedEnd)
                part.style.left = $86defbb4e95ebb07$var$percentify(start, bufferedEnd);
                part.style.width = $86defbb4e95ebb07$var$percentify(end - start, bufferedEnd);
            }
            // remove unused buffered range elements
            for(let i = children.length; i > buffered.length; i--)this.el_.removeChild(children[i - 1]);
            children.length = buffered.length;
        });
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('LoadProgressBar', $86defbb4e95ebb07$var$LoadProgressBar);
/**
 * @file time-tooltip.js
 */ /** @import Player from '../../player' */ /**
 * Time tooltips display a time above the progress bar.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$TimeTooltip extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update = $86defbb4e95ebb07$var$throttle($86defbb4e95ebb07$var$bind_(this, this.update), $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the time tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-time-tooltip'
        }, {
            'aria-hidden': 'true'
        });
    }
    /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */ update(seekBarRect, seekBarPoint, content) {
        const tooltipRect = $86defbb4e95ebb07$var$findPosition(this.el_);
        const playerRect = $86defbb4e95ebb07$var$getBoundingClientRect(this.player_.el());
        const seekBarPointPx = seekBarRect.width * seekBarPoint;
        // do nothing if either rect isn't available
        // for example, if the player isn't in the DOM for testing
        if (!playerRect || !tooltipRect) return;
        // This is the space left of the `seekBarPoint` available within the bounds
        // of the player. We calculate any gap between the left edge of the player
        // and the left edge of the `SeekBar` and add the number of pixels in the
        // `SeekBar` before hitting the `seekBarPoint`
        let spaceLeftOfPoint = seekBarRect.left - playerRect.left + seekBarPointPx;
        // This is the space right of the `seekBarPoint` available within the bounds
        // of the player. We calculate the number of pixels from the `seekBarPoint`
        // to the right edge of the `SeekBar` and add to that any gap between the
        // right edge of the `SeekBar` and the player.
        let spaceRightOfPoint = seekBarRect.width - seekBarPointPx + (playerRect.right - seekBarRect.right);
        // spaceRightOfPoint is always NaN for mouse time display
        // because the seekbarRect does not have a right property. This causes
        // the mouse tool tip to be truncated when it's close to the right edge of the player.
        // In such cases, we ignore the `playerRect.right - seekBarRect.right` value when calculating.
        // For the sake of consistency, we ignore seekBarRect.left - playerRect.left for the left edge.
        if (!spaceRightOfPoint) {
            spaceRightOfPoint = seekBarRect.width - seekBarPointPx;
            spaceLeftOfPoint = seekBarPointPx;
        }
        // This is the number of pixels by which the tooltip will need to be pulled
        // further to the right to center it over the `seekBarPoint`.
        let pullTooltipBy = tooltipRect.width / 2;
        // Adjust the `pullTooltipBy` distance to the left or right depending on
        // the results of the space calculations above.
        if (spaceLeftOfPoint < pullTooltipBy) pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
        else if (spaceRightOfPoint < pullTooltipBy) pullTooltipBy = spaceRightOfPoint;
        // Due to the imprecision of decimal/ratio based calculations and varying
        // rounding behaviors, there are cases where the spacing adjustment is off
        // by a pixel or two. This adds insurance to these calculations.
        if (pullTooltipBy < 0) pullTooltipBy = 0;
        else if (pullTooltipBy > tooltipRect.width) pullTooltipBy = tooltipRect.width;
        // prevent small width fluctuations within 0.4px from
        // changing the value below.
        // This really helps for live to prevent the play
        // progress time tooltip from jittering
        pullTooltipBy = Math.round(pullTooltipBy);
        this.el_.style.right = `-${pullTooltipBy}px`;
        this.write(content);
    }
    /**
   * Write the time to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted time for the tooltip.
   */ write(content) {
        $86defbb4e95ebb07$var$textContent(this.el_, content);
    }
    /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {number} time
   *        The time to update the tooltip to, not used during live playback
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */ updateTime(seekBarRect, seekBarPoint, time, cb) {
        this.requestNamedAnimationFrame('TimeTooltip#updateTime', ()=>{
            let content;
            const duration = this.player_.duration();
            if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
                const liveWindow = this.player_.liveTracker.liveWindow();
                const secondsBehind = liveWindow - seekBarPoint * liveWindow;
                content = (secondsBehind < 1 ? '' : '-') + $86defbb4e95ebb07$var$formatTime(secondsBehind, liveWindow);
            } else content = $86defbb4e95ebb07$var$formatTime(time, duration);
            this.update(seekBarRect, seekBarPoint, content);
            if (cb) cb();
        });
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TimeTooltip', $86defbb4e95ebb07$var$TimeTooltip);
/**
 * @file play-progress-bar.js
 */ /**
 * Used by {@link SeekBar} to display media playback progress as part of the
 * {@link ProgressControl}.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$PlayProgressBar extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.setIcon('circle');
        this.update = $86defbb4e95ebb07$var$throttle($86defbb4e95ebb07$var$bind_(this, this.update), $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-play-progress vjs-slider-bar'
        }, {
            'aria-hidden': 'true'
        });
    }
    /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {Event} [event]
   *        The `timeupdate` event that caused this function to run.
   */ update(seekBarRect, seekBarPoint, event) {
        const timeTooltip = this.getChild('timeTooltip');
        if (!timeTooltip) return;
        // Combined logic: if an event with a valid pendingSeekTime getter exists, use it.
        const time = event && event.target && typeof event.target.pendingSeekTime === 'function' ? event.target.pendingSeekTime() : this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
        timeTooltip.updateTime(seekBarRect, seekBarPoint, time);
    }
}
/**
 * Default options for {@link PlayProgressBar}.
 *
 * @type {Object}
 * @private
 */ $86defbb4e95ebb07$var$PlayProgressBar.prototype.options_ = {
    children: []
};
// Time tooltips should not be added to a player on mobile devices
if (!$86defbb4e95ebb07$var$IS_IOS && !$86defbb4e95ebb07$var$IS_ANDROID) $86defbb4e95ebb07$var$PlayProgressBar.prototype.options_.children.push('timeTooltip');
$86defbb4e95ebb07$var$Component$1.registerComponent('PlayProgressBar', $86defbb4e95ebb07$var$PlayProgressBar);
/**
 * @file mouse-time-display.js
 */ /**
 * The {@link MouseTimeDisplay} component tracks mouse movement over the
 * {@link ProgressControl}. It displays an indicator and a {@link TimeTooltip}
 * indicating the time which is represented by a given point in the
 * {@link ProgressControl}.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$MouseTimeDisplay extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update = $86defbb4e95ebb07$var$throttle($86defbb4e95ebb07$var$bind_(this, this.update), $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-mouse-display'
        });
    }
    /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */ update(seekBarRect, seekBarPoint) {
        const time = seekBarPoint * this.player_.duration();
        this.getChild('timeTooltip').updateTime(seekBarRect, seekBarPoint, time, ()=>{
            this.el_.style.left = `${seekBarRect.width * seekBarPoint}px`;
        });
    }
}
/**
 * Default options for `MouseTimeDisplay`
 *
 * @type {Object}
 * @private
 */ $86defbb4e95ebb07$var$MouseTimeDisplay.prototype.options_ = {
    children: [
        'timeTooltip'
    ]
};
$86defbb4e95ebb07$var$Component$1.registerComponent('MouseTimeDisplay', $86defbb4e95ebb07$var$MouseTimeDisplay);
/**
 * @file seek-bar.js
 */ /**
 * Seek bar and container for the progress bars. Uses {@link PlayProgressBar}
 * as its `bar`.
 *
 * @extends Slider
 */ class $86defbb4e95ebb07$var$SeekBar extends $86defbb4e95ebb07$var$Slider {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   * @param {number} [options.stepSeconds=5]
   *        The number of seconds to increment on keyboard control
   * @param {number} [options.pageMultiplier=12]
   *        The multiplier of stepSeconds that PgUp/PgDown move the timeline.
   */ constructor(player, options){
        options = $86defbb4e95ebb07$var$merge$1($86defbb4e95ebb07$var$SeekBar.prototype.options_, options);
        // Avoid mutating the prototype's `children` array by creating a copy
        options.children = [
            ...options.children
        ];
        const shouldDisableSeekWhileScrubbing = player.options_.disableSeekWhileScrubbingOnMobile && ($86defbb4e95ebb07$var$IS_IOS || $86defbb4e95ebb07$var$IS_ANDROID) || player.options_.disableSeekWhileScrubbingOnSTV;
        // Add the TimeTooltip as a child if we are on desktop, or on mobile with `disableSeekWhileScrubbingOnMobile: true`
        if (!$86defbb4e95ebb07$var$IS_IOS && !$86defbb4e95ebb07$var$IS_ANDROID || shouldDisableSeekWhileScrubbing) options.children.splice(1, 0, 'mouseTimeDisplay');
        super(player, options);
        this.shouldDisableSeekWhileScrubbing_ = shouldDisableSeekWhileScrubbing;
        this.pendingSeekTime_ = null;
        this.setEventHandlers_();
    }
    /**
   * Sets the event handlers
   *
   * @private
   */ setEventHandlers_() {
        this.update_ = $86defbb4e95ebb07$var$bind_(this, this.update);
        this.update = $86defbb4e95ebb07$var$throttle(this.update_, $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL);
        this.on(this.player_, [
            'durationchange',
            'timeupdate'
        ], this.update);
        this.on(this.player_, [
            'ended'
        ], this.update_);
        if (this.player_.liveTracker) this.on(this.player_.liveTracker, 'liveedgechange', this.update);
        // when playing, let's ensure we smoothly update the play progress bar
        // via an interval
        this.updateInterval = null;
        this.enableIntervalHandler_ = (e)=>this.enableInterval_(e);
        this.disableIntervalHandler_ = (e)=>this.disableInterval_(e);
        this.on(this.player_, [
            'playing'
        ], this.enableIntervalHandler_);
        this.on(this.player_, [
            'ended',
            'pause',
            'waiting'
        ], this.disableIntervalHandler_);
        // we don't need to update the play progress if the document is hidden,
        // also, this causes the CPU to spike and eventually crash the page on IE11.
        if ('hidden' in (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))) && 'visibilityState' in (0, (/*@__PURE__*/$parcel$interopDefault($01r8O)))) this.on((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))), 'visibilitychange', this.toggleVisibility_);
    }
    toggleVisibility_(e) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).visibilityState === 'hidden') {
            this.cancelNamedAnimationFrame('SeekBar#update');
            this.cancelNamedAnimationFrame('Slider#update');
            this.disableInterval_(e);
        } else {
            if (!this.player_.ended() && !this.player_.paused()) this.enableInterval_();
            // we just switched back to the page and someone may be looking, so, update ASAP
            this.update();
        }
    }
    enableInterval_() {
        if (this.updateInterval) return;
        this.updateInterval = this.setInterval(this.update, $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL);
    }
    disableInterval_(e) {
        if (this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== 'ended') return;
        if (!this.updateInterval) return;
        this.clearInterval(this.updateInterval);
        this.updateInterval = null;
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-progress-holder'
        }, {
            'aria-label': this.localize('Progress Bar')
        });
    }
    /**
   * This function updates the play progress bar and accessibility
   * attributes to whatever is passed in.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `ended` event that caused this to run.
   *
   * @listens Player#timeupdate
   *
   * @return {number}
   *          The current percent at a number from 0-1
   */ update(event) {
        // ignore updates while the tab is hidden
        if ((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).visibilityState === 'hidden') return;
        const percent = super.update();
        this.requestNamedAnimationFrame('SeekBar#update', ()=>{
            const currentTime = this.player_.ended() ? this.player_.duration() : this.getCurrentTime_();
            const liveTracker = this.player_.liveTracker;
            let duration = this.player_.duration();
            if (liveTracker && liveTracker.isLive()) duration = this.player_.liveTracker.liveCurrentTime();
            if (this.percent_ !== percent) {
                // machine readable value of progress bar (percentage complete)
                this.el_.setAttribute('aria-valuenow', (percent * 100).toFixed(2));
                this.percent_ = percent;
            }
            if (this.currentTime_ !== currentTime || this.duration_ !== duration) {
                // human readable value of progress bar (time complete)
                this.el_.setAttribute('aria-valuetext', this.localize('progress bar timing: currentTime={1} duration={2}', [
                    $86defbb4e95ebb07$var$formatTime(currentTime, duration),
                    $86defbb4e95ebb07$var$formatTime(duration, duration)
                ], '{1} of {2}'));
                this.currentTime_ = currentTime;
                this.duration_ = duration;
            }
            // update the progress bar time tooltip with the current time
            if (this.bar) this.bar.update($86defbb4e95ebb07$var$getBoundingClientRect(this.el()), this.getProgress(), event);
        });
        return percent;
    }
    /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */ userSeek_(ct) {
        if (this.player_.liveTracker && this.player_.liveTracker.isLive()) this.player_.liveTracker.nextSeekedFromUser();
        this.player_.currentTime(ct);
    }
    /**
   * Get the value of current time but allows for smooth scrubbing,
   * when player can't keep up.
   *
   * @return {number}
   *         The current time value to display
   *
   * @private
   */ getCurrentTime_() {
        return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
    }
    /**
   * Getter and setter for pendingSeekTime.
   * Ensures the value is clamped between 0 and duration.
   *
   * @param {number|null} [time] - Optional. The new pending seek time, can be a number or null.
   * @return {number|null} - The current pending seek time.
   */ pendingSeekTime(time) {
        if (time !== undefined) {
            if (time !== null) {
                const duration = this.player_.duration();
                this.pendingSeekTime_ = Math.max(0, Math.min(time, duration));
            } else this.pendingSeekTime_ = null;
        }
        return this.pendingSeekTime_;
    }
    /**
   * Get the percentage of media played so far.
   *
   * @return {number}
   *         The percentage of media played so far (0 to 1).
   */ getPercent() {
        // If we have a pending seek time, we are scrubbing on mobile and should set the slider percent
        // to reflect the current scrub location.
        if (this.pendingSeekTime() !== null) return this.pendingSeekTime() / this.player_.duration();
        const currentTime = this.getCurrentTime_();
        let percent;
        const liveTracker = this.player_.liveTracker;
        if (liveTracker && liveTracker.isLive()) {
            percent = (currentTime - liveTracker.seekableStart()) / liveTracker.liveWindow();
            // prevent the percent from changing at the live edge
            if (liveTracker.atLiveEdge()) percent = 1;
        } else percent = currentTime / this.player_.duration();
        return percent;
    }
    /**
   * Handle mouse down on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */ handleMouseDown(event) {
        if (!$86defbb4e95ebb07$var$isSingleLeftClick(event)) return;
        // Stop event propagation to prevent double fire in progress-control.js
        event.stopPropagation();
        this.videoWasPlaying = !this.player_.paused();
        // Don't pause if we are on mobile and `disableSeekWhileScrubbingOnMobile: true`.
        // In that case, playback should continue while the player scrubs to a new location.
        if (!this.shouldDisableSeekWhileScrubbing_) this.player_.pause();
        super.handleMouseDown(event);
    }
    /**
   * Handle mouse move on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousemove` event that caused this to run.
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
   *
   * @listens mousemove
   */ handleMouseMove(event, mouseDown = false) {
        if (!$86defbb4e95ebb07$var$isSingleLeftClick(event) || isNaN(this.player_.duration())) return;
        if (!mouseDown && !this.player_.scrubbing()) this.player_.scrubbing(true);
        let newTime;
        const distance = this.calculateDistance(event);
        const liveTracker = this.player_.liveTracker;
        if (!liveTracker || !liveTracker.isLive()) {
            newTime = distance * this.player_.duration();
            // Don't let video end while scrubbing.
            if (newTime === this.player_.duration()) newTime = newTime - 0.1;
        } else {
            if (distance >= 0.99) {
                liveTracker.seekToLiveEdge();
                return;
            }
            const seekableStart = liveTracker.seekableStart();
            const seekableEnd = liveTracker.liveCurrentTime();
            newTime = seekableStart + distance * liveTracker.liveWindow();
            // Don't let video end while scrubbing.
            if (newTime >= seekableEnd) newTime = seekableEnd;
            // Compensate for precision differences so that currentTime is not less
            // than seekable start
            if (newTime <= seekableStart) newTime = seekableStart + 0.1;
            // On android seekableEnd can be Infinity sometimes,
            // this will cause newTime to be Infinity, which is
            // not a valid currentTime.
            if (newTime === Infinity) return;
        }
        // if on mobile and `disableSeekWhileScrubbingOnMobile: true`, keep track of the desired seek point but we won't initiate the seek until 'touchend'
        if (this.shouldDisableSeekWhileScrubbing_) this.pendingSeekTime(newTime);
        else this.userSeek_(newTime);
        if (this.player_.options_.enableSmoothSeeking) this.update();
    }
    enable() {
        super.enable();
        const mouseTimeDisplay = this.getChild('mouseTimeDisplay');
        if (!mouseTimeDisplay) return;
        mouseTimeDisplay.show();
    }
    disable() {
        super.disable();
        const mouseTimeDisplay = this.getChild('mouseTimeDisplay');
        if (!mouseTimeDisplay) return;
        mouseTimeDisplay.hide();
    }
    /**
   * Handle mouse up on seek bar
   *
   * @param {MouseEvent} event
   *        The `mouseup` event that caused this to run.
   *
   * @listens mouseup
   */ handleMouseUp(event) {
        super.handleMouseUp(event);
        // Stop event propagation to prevent double fire in progress-control.js
        if (event) event.stopPropagation();
        this.player_.scrubbing(false);
        // If we have a pending seek time, then we have finished scrubbing on mobile and should initiate a seek.
        if (this.pendingSeekTime() !== null) {
            this.userSeek_(this.pendingSeekTime());
            this.pendingSeekTime(null);
        }
        /**
     * Trigger timeupdate because we're done seeking and the time has changed.
     * This is particularly useful for if the player is paused to time the time displays.
     *
     * @event Tech#timeupdate
     * @type {Event}
     */ this.player_.trigger({
            type: 'timeupdate',
            target: this,
            manuallyTriggered: true
        });
        if (this.videoWasPlaying) $86defbb4e95ebb07$var$silencePromise(this.player_.play());
        else // We're done seeking and the time has changed.
        // If the player is paused, make sure we display the correct time on the seek bar.
        this.update_();
    }
    /**
   * Handles pending seek time when `disableSeekWhileScrubbingOnSTV` is enabled.
   *
   * @param {number} stepAmount - The number of seconds to step (positive for forward, negative for backward).
   */ handlePendingSeek_(stepAmount) {
        if (!this.player_.paused()) this.player_.pause();
        const currentPos = this.pendingSeekTime() !== null ? this.pendingSeekTime() : this.player_.currentTime();
        this.pendingSeekTime(currentPos + stepAmount);
        this.player_.trigger({
            type: 'timeupdate',
            target: this,
            manuallyTriggered: true
        });
    }
    /**
   * Move more quickly fast forward for keyboard-only users
   */ stepForward() {
        // if `disableSeekWhileScrubbingOnSTV: true`, keep track of the desired seek point but we won't initiate the seek
        if (this.shouldDisableSeekWhileScrubbing_) this.handlePendingSeek_(this.options().stepSeconds);
        else this.userSeek_(this.player_.currentTime() + this.options().stepSeconds);
    }
    /**
   * Move more quickly rewind for keyboard-only users
   */ stepBack() {
        // if `disableSeekWhileScrubbingOnSTV: true`, keep track of the desired seek point but we won't initiate the seek
        if (this.shouldDisableSeekWhileScrubbing_) this.handlePendingSeek_(-this.options().stepSeconds);
        else this.userSeek_(this.player_.currentTime() - this.options().stepSeconds);
    }
    /**
   * Toggles the playback state of the player
   * This gets called when enter or space is used on the seekbar
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called
   *
   */ handleAction(event) {
        if (this.pendingSeekTime() !== null) {
            this.userSeek_(this.pendingSeekTime());
            this.pendingSeekTime(null);
        }
        if (this.player_.paused()) this.player_.play();
        else this.player_.pause();
    }
    /**
   * Called when this SeekBar has focus and a key gets pressed down.
   * Supports the following keys:
   *
   *   Space or Enter key fire a click event
   *   Home key moves to start of the timeline
   *   End key moves to end of the timeline
   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
   *   PageDown key moves back a larger step than ArrowDown
   *   PageUp key moves forward a large step
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        const liveTracker = this.player_.liveTracker;
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.handleAction(event);
        } else if (event.key === 'Home') {
            event.preventDefault();
            event.stopPropagation();
            this.userSeek_(0);
        } else if (event.key === 'End') {
            event.preventDefault();
            event.stopPropagation();
            if (liveTracker && liveTracker.isLive()) this.userSeek_(liveTracker.liveCurrentTime());
            else this.userSeek_(this.player_.duration());
        } else if (/^[0-9]$/.test(event.key)) {
            event.preventDefault();
            event.stopPropagation();
            const gotoFraction = parseInt(event.key, 10) * 0.1;
            if (liveTracker && liveTracker.isLive()) this.userSeek_(liveTracker.seekableStart() + liveTracker.liveWindow() * gotoFraction);
            else this.userSeek_(this.player_.duration() * gotoFraction);
        } else if (event.key === 'PageDown') {
            event.preventDefault();
            event.stopPropagation();
            this.userSeek_(this.player_.currentTime() - this.options().stepSeconds * this.options().pageMultiplier);
        } else if (event.key === 'PageUp') {
            event.preventDefault();
            event.stopPropagation();
            this.userSeek_(this.player_.currentTime() + this.options().stepSeconds * this.options().pageMultiplier);
        } else // Pass keydown handling up for unsupported keys
        super.handleKeyDown(event);
    }
    dispose() {
        this.disableInterval_();
        this.off(this.player_, [
            'durationchange',
            'timeupdate'
        ], this.update);
        this.off(this.player_, [
            'ended'
        ], this.update_);
        if (this.player_.liveTracker) this.off(this.player_.liveTracker, 'liveedgechange', this.update);
        this.off(this.player_, [
            'playing'
        ], this.enableIntervalHandler_);
        this.off(this.player_, [
            'ended',
            'pause',
            'waiting'
        ], this.disableIntervalHandler_);
        // we don't need to update the play progress if the document is hidden,
        // also, this causes the CPU to spike and eventually crash the page on IE11.
        if ('hidden' in (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))) && 'visibilityState' in (0, (/*@__PURE__*/$parcel$interopDefault($01r8O)))) this.off((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))), 'visibilitychange', this.toggleVisibility_);
        super.dispose();
    }
}
/**
 * Default options for the `SeekBar`
 *
 * @type {Object}
 * @private
 */ $86defbb4e95ebb07$var$SeekBar.prototype.options_ = {
    children: [
        'loadProgressBar',
        'playProgressBar'
    ],
    barName: 'playProgressBar',
    stepSeconds: 5,
    pageMultiplier: 12
};
$86defbb4e95ebb07$var$Component$1.registerComponent('SeekBar', $86defbb4e95ebb07$var$SeekBar);
/**
 * @file progress-control.js
 */ /**
 * The Progress Control component contains the seek bar, load progress,
 * and play progress.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$ProgressControl extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.handleMouseMove = $86defbb4e95ebb07$var$throttle($86defbb4e95ebb07$var$bind_(this, this.handleMouseMove), $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL);
        this.throttledHandleMouseSeek = $86defbb4e95ebb07$var$throttle($86defbb4e95ebb07$var$bind_(this, this.handleMouseSeek), $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL);
        this.handleMouseUpHandler_ = (e)=>this.handleMouseUp(e);
        this.handleMouseDownHandler_ = (e)=>this.handleMouseDown(e);
        this.enable();
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-progress-control vjs-control'
        });
    }
    /**
   * When the mouse moves over the `ProgressControl`, the pointer position
   * gets passed down to the `MouseTimeDisplay` component.
   *
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   */ handleMouseMove(event) {
        const seekBar = this.getChild('seekBar');
        if (!seekBar) return;
        const playProgressBar = seekBar.getChild('playProgressBar');
        const mouseTimeDisplay = seekBar.getChild('mouseTimeDisplay');
        if (!playProgressBar && !mouseTimeDisplay) return;
        const seekBarEl = seekBar.el();
        const seekBarRect = $86defbb4e95ebb07$var$findPosition(seekBarEl);
        let seekBarPoint = $86defbb4e95ebb07$var$getPointerPosition(seekBarEl, event).x;
        // The default skin has a gap on either side of the `SeekBar`. This means
        // that it's possible to trigger this behavior outside the boundaries of
        // the `SeekBar`. This ensures we stay within it at all times.
        seekBarPoint = $86defbb4e95ebb07$var$clamp(seekBarPoint, 0, 1);
        if (mouseTimeDisplay) mouseTimeDisplay.update(seekBarRect, seekBarPoint);
        if (playProgressBar) playProgressBar.update(seekBarRect, seekBar.getProgress());
    }
    /**
   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
   *
   * @method ProgressControl#throttledHandleMouseSeek
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   * @listen touchmove
   */ /**
   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousemove
   * @listens touchmove
   */ handleMouseSeek(event) {
        const seekBar = this.getChild('seekBar');
        if (seekBar) seekBar.handleMouseMove(event);
    }
    /**
   * Are controls are currently enabled for this progress control.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */ enabled() {
        return this.enabled_;
    }
    /**
   * Disable all controls on the progress control and its children
   */ disable() {
        this.children().forEach((child)=>child.disable && child.disable());
        if (!this.enabled()) return;
        this.off([
            'mousedown',
            'touchstart'
        ], this.handleMouseDownHandler_);
        this.off(this.el_, [
            'mousemove',
            'touchmove'
        ], this.handleMouseMove);
        this.removeListenersAddedOnMousedownAndTouchstart();
        this.addClass('disabled');
        this.enabled_ = false;
        // Restore normal playback state if controls are disabled while scrubbing
        if (this.player_.scrubbing()) {
            const seekBar = this.getChild('seekBar');
            this.player_.scrubbing(false);
            if (seekBar.videoWasPlaying) $86defbb4e95ebb07$var$silencePromise(this.player_.play());
        }
    }
    /**
   * Enable all controls on the progress control and its children
   */ enable() {
        this.children().forEach((child)=>child.enable && child.enable());
        if (this.enabled()) return;
        this.on([
            'mousedown',
            'touchstart'
        ], this.handleMouseDownHandler_);
        this.on(this.el_, [
            'mousemove',
            'touchmove'
        ], this.handleMouseMove);
        this.removeClass('disabled');
        this.enabled_ = true;
    }
    /**
   * Cleanup listeners after the user finishes interacting with the progress controls
   */ removeListenersAddedOnMousedownAndTouchstart() {
        const doc = this.el_.ownerDocument;
        this.off(doc, 'mousemove', this.throttledHandleMouseSeek);
        this.off(doc, 'touchmove', this.throttledHandleMouseSeek);
        this.off(doc, 'mouseup', this.handleMouseUpHandler_);
        this.off(doc, 'touchend', this.handleMouseUpHandler_);
    }
    /**
   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */ handleMouseDown(event) {
        const doc = this.el_.ownerDocument;
        const seekBar = this.getChild('seekBar');
        if (seekBar) seekBar.handleMouseDown(event);
        this.on(doc, 'mousemove', this.throttledHandleMouseSeek);
        this.on(doc, 'touchmove', this.throttledHandleMouseSeek);
        this.on(doc, 'mouseup', this.handleMouseUpHandler_);
        this.on(doc, 'touchend', this.handleMouseUpHandler_);
    }
    /**
   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */ handleMouseUp(event) {
        const seekBar = this.getChild('seekBar');
        if (seekBar) seekBar.handleMouseUp(event);
        this.removeListenersAddedOnMousedownAndTouchstart();
    }
}
/**
 * Default options for `ProgressControl`
 *
 * @type {Object}
 * @private
 */ $86defbb4e95ebb07$var$ProgressControl.prototype.options_ = {
    children: [
        'seekBar'
    ]
};
$86defbb4e95ebb07$var$Component$1.registerComponent('ProgressControl', $86defbb4e95ebb07$var$ProgressControl);
/**
 * @file picture-in-picture-toggle.js
 */ /** @import Player from '../player' */ /**
 * Toggle Picture-in-Picture mode
 *
 * @extends Button
 */ class $86defbb4e95ebb07$var$PictureInPictureToggle extends $86defbb4e95ebb07$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */ constructor(player, options){
        super(player, options);
        this.setIcon('picture-in-picture-enter');
        this.on(player, [
            'enterpictureinpicture',
            'leavepictureinpicture'
        ], (e)=>this.handlePictureInPictureChange(e));
        this.on(player, [
            'disablepictureinpicturechanged',
            'loadedmetadata'
        ], (e)=>this.handlePictureInPictureEnabledChange(e));
        this.on(player, [
            'loadedmetadata',
            'audioonlymodechange',
            'audiopostermodechange'
        ], ()=>this.handlePictureInPictureAudioModeChange());
        // TODO: Deactivate button on player emptied event.
        this.disable();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-picture-in-picture-control vjs-hidden ${super.buildCSSClass()}`;
    }
    /**
   * Displays or hides the button depending on the audio mode detection.
   * Exits picture-in-picture if it is enabled when switching to audio mode.
   */ handlePictureInPictureAudioModeChange() {
        // This audio detection will not detect HLS or DASH audio-only streams because there was no reliable way to detect them at the time
        const isSourceAudio = this.player_.currentType().substring(0, 5) === 'audio';
        const isAudioMode = isSourceAudio || this.player_.audioPosterMode() || this.player_.audioOnlyMode();
        if (!isAudioMode) {
            this.show();
            return;
        }
        if (this.player_.isInPictureInPicture()) this.player_.exitPictureInPicture();
        this.hide();
    }
    /**
   * Enables or disables button based on availability of a Picture-In-Picture mode.
   *
   * Enabled if
   * - `player.options().enableDocumentPictureInPicture` is true and
   *   window.documentPictureInPicture is available; or
   * - `player.disablePictureInPicture()` is false and
   *   element.requestPictureInPicture is available
   */ handlePictureInPictureEnabledChange() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).pictureInPictureEnabled && this.player_.disablePictureInPicture() === false || this.player_.options_.enableDocumentPictureInPicture && 'documentPictureInPicture' in (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi)))) this.enable();
        else this.disable();
    }
    /**
   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
   *        called.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */ handlePictureInPictureChange(event) {
        if (this.player_.isInPictureInPicture()) {
            this.setIcon('picture-in-picture-exit');
            this.controlText('Exit Picture-in-Picture');
        } else {
            this.setIcon('picture-in-picture-enter');
            this.controlText('Picture-in-Picture');
        }
        this.handlePictureInPictureEnabledChange();
    }
    /**
   * This gets called when an `PictureInPictureToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        if (!this.player_.isInPictureInPicture()) this.player_.requestPictureInPicture();
        else this.player_.exitPictureInPicture();
    }
    /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it only in browsers that support the Picture-in-Picture API.
   */ show() {
        // Does not allow to display the pictureInPictureToggle in browsers that do not support the Picture-in-Picture API, e.g. Firefox.
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).exitPictureInPicture !== 'function') return;
        super.show();
    }
}
/**
 * The text that should display over the `PictureInPictureToggle`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$PictureInPictureToggle.prototype.controlText_ = 'Picture-in-Picture';
$86defbb4e95ebb07$var$Component$1.registerComponent('PictureInPictureToggle', $86defbb4e95ebb07$var$PictureInPictureToggle);
/**
 * @file fullscreen-toggle.js
 */ /** @import Player from '../player' */ /**
 * Toggle fullscreen video
 *
 * @extends Button
 */ class $86defbb4e95ebb07$var$FullscreenToggle extends $86defbb4e95ebb07$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.setIcon('fullscreen-enter');
        this.on(player, 'fullscreenchange', (e)=>this.handleFullscreenChange(e));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($01r8O)))[player.fsApi_.fullscreenEnabled] === false) this.disable();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-fullscreen-control ${super.buildCSSClass()}`;
    }
    /**
   * Handles fullscreenchange on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#fullscreenchange} event that caused this function to be
   *        called.
   *
   * @listens Player#fullscreenchange
   */ handleFullscreenChange(event) {
        if (this.player_.isFullscreen()) {
            this.controlText('Exit Fullscreen');
            this.setIcon('fullscreen-exit');
        } else {
            this.controlText('Fullscreen');
            this.setIcon('fullscreen-enter');
        }
    }
    /**
   * This gets called when an `FullscreenToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        if (!this.player_.isFullscreen()) this.player_.requestFullscreen();
        else this.player_.exitFullscreen();
    }
}
/**
 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$FullscreenToggle.prototype.controlText_ = 'Fullscreen';
$86defbb4e95ebb07$var$Component$1.registerComponent('FullscreenToggle', $86defbb4e95ebb07$var$FullscreenToggle);
/** @import Component from '../../component' */ /** @import Player from '../../player' */ /**
 * Check if volume control is supported and if it isn't hide the
 * `Component` that was passed  using the `vjs-hidden` class.
 *
 * @param {Component} self
 *        The component that should be hidden if volume is unsupported
 *
 * @param {Player} player
 *        A reference to the player
 *
 * @private
 */ const $86defbb4e95ebb07$var$checkVolumeSupport = function(self1, player) {
    // hide volume controls when they're not supported by the current tech
    if (player.tech_ && !player.tech_.featuresVolumeControl) self1.addClass('vjs-hidden');
    self1.on(player, 'loadstart', function() {
        if (!player.tech_.featuresVolumeControl) self1.addClass('vjs-hidden');
        else self1.removeClass('vjs-hidden');
    });
};
/**
 * @file volume-level.js
 */ /**
 * Shows volume level
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$VolumeLevel extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl('div', {
            className: 'vjs-volume-level'
        });
        this.setIcon('circle', el);
        el.appendChild(super.createEl('span', {
            className: 'vjs-control-text'
        }));
        return el;
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('VolumeLevel', $86defbb4e95ebb07$var$VolumeLevel);
/**
 * @file volume-level-tooltip.js
 */ /** @import Player from '../../player' */ /**
 * Volume level tooltips display a volume above or side by side the volume bar.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$VolumeLevelTooltip extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update = $86defbb4e95ebb07$var$throttle($86defbb4e95ebb07$var$bind_(this, this.update), $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the volume tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-volume-tooltip'
        }, {
            'aria-hidden': 'true'
        });
    }
    /**
   * Updates the position of the tooltip relative to the `VolumeBar` and
   * its content text.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */ update(rangeBarRect, rangeBarPoint, vertical, content) {
        if (!vertical) {
            const tooltipRect = $86defbb4e95ebb07$var$getBoundingClientRect(this.el_);
            const playerRect = $86defbb4e95ebb07$var$getBoundingClientRect(this.player_.el());
            const volumeBarPointPx = rangeBarRect.width * rangeBarPoint;
            if (!playerRect || !tooltipRect) return;
            const spaceLeftOfPoint = rangeBarRect.left - playerRect.left + volumeBarPointPx;
            const spaceRightOfPoint = rangeBarRect.width - volumeBarPointPx + (playerRect.right - rangeBarRect.right);
            let pullTooltipBy = tooltipRect.width / 2;
            if (spaceLeftOfPoint < pullTooltipBy) pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
            else if (spaceRightOfPoint < pullTooltipBy) pullTooltipBy = spaceRightOfPoint;
            if (pullTooltipBy < 0) pullTooltipBy = 0;
            else if (pullTooltipBy > tooltipRect.width) pullTooltipBy = tooltipRect.width;
            this.el_.style.right = `-${pullTooltipBy}px`;
        }
        this.write(`${content}%`);
    }
    /**
   * Write the volume to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted volume for the tooltip.
   */ write(content) {
        $86defbb4e95ebb07$var$textContent(this.el_, content);
    }
    /**
   * Updates the position of the volume tooltip relative to the `VolumeBar`.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   * @param {number} volume
   *        The volume level to update the tooltip to
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */ updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, cb) {
        this.requestNamedAnimationFrame('VolumeLevelTooltip#updateVolume', ()=>{
            this.update(rangeBarRect, rangeBarPoint, vertical, volume.toFixed(0));
            if (cb) cb();
        });
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('VolumeLevelTooltip', $86defbb4e95ebb07$var$VolumeLevelTooltip);
/**
 * @file mouse-volume-level-display.js
 */ /**
 * The {@link MouseVolumeLevelDisplay} component tracks mouse movement over the
 * {@link VolumeControl}. It displays an indicator and a {@link VolumeLevelTooltip}
 * indicating the volume level which is represented by a given point in the
 * {@link VolumeBar}.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$MouseVolumeLevelDisplay extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update = $86defbb4e95ebb07$var$throttle($86defbb4e95ebb07$var$bind_(this, this.update), $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-mouse-display'
        });
    }
    /**
   * Enquires updates to its own DOM as well as the DOM of its
   * {@link VolumeLevelTooltip} child.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */ update(rangeBarRect, rangeBarPoint, vertical) {
        const volume = 100 * rangeBarPoint;
        this.getChild('volumeLevelTooltip').updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, ()=>{
            if (vertical) this.el_.style.bottom = `${rangeBarRect.height * rangeBarPoint}px`;
            else this.el_.style.left = `${rangeBarRect.width * rangeBarPoint}px`;
        });
    }
}
/**
 * Default options for `MouseVolumeLevelDisplay`
 *
 * @type {Object}
 * @private
 */ $86defbb4e95ebb07$var$MouseVolumeLevelDisplay.prototype.options_ = {
    children: [
        'volumeLevelTooltip'
    ]
};
$86defbb4e95ebb07$var$Component$1.registerComponent('MouseVolumeLevelDisplay', $86defbb4e95ebb07$var$MouseVolumeLevelDisplay);
/**
 * @file volume-bar.js
 */ /**
 * The bar that contains the volume level and can be clicked on to adjust the level
 *
 * @extends Slider
 */ class $86defbb4e95ebb07$var$VolumeBar extends $86defbb4e95ebb07$var$Slider {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.on('slideractive', (e)=>this.updateLastVolume_(e));
        this.on(player, 'volumechange', (e)=>this.updateARIAAttributes(e));
        player.ready(()=>this.updateARIAAttributes());
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-volume-bar vjs-slider-bar'
        }, {
            'aria-label': this.localize('Volume Level'),
            'aria-live': 'polite'
        });
    }
    /**
   * Handle mouse down on volume bar
   *
   * @param {Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */ handleMouseDown(event) {
        if (!$86defbb4e95ebb07$var$isSingleLeftClick(event)) return;
        super.handleMouseDown(event);
    }
    /**
   * Handle movement events on the {@link VolumeMenuButton}.
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @listens mousemove
   */ handleMouseMove(event) {
        const mouseVolumeLevelDisplay = this.getChild('mouseVolumeLevelDisplay');
        if (mouseVolumeLevelDisplay) {
            const volumeBarEl = this.el();
            const volumeBarRect = $86defbb4e95ebb07$var$getBoundingClientRect(volumeBarEl);
            const vertical = this.vertical();
            let volumeBarPoint = $86defbb4e95ebb07$var$getPointerPosition(volumeBarEl, event);
            volumeBarPoint = vertical ? volumeBarPoint.y : volumeBarPoint.x;
            // The default skin has a gap on either side of the `VolumeBar`. This means
            // that it's possible to trigger this behavior outside the boundaries of
            // the `VolumeBar`. This ensures we stay within it at all times.
            volumeBarPoint = $86defbb4e95ebb07$var$clamp(volumeBarPoint, 0, 1);
            mouseVolumeLevelDisplay.update(volumeBarRect, volumeBarPoint, vertical);
        }
        if (!$86defbb4e95ebb07$var$isSingleLeftClick(event)) return;
        this.checkMuted();
        this.player_.volume(this.calculateDistance(event));
    }
    /**
   * If the player is muted unmute it.
   */ checkMuted() {
        if (this.player_.muted()) this.player_.muted(false);
    }
    /**
   * Get percent of volume level
   *
   * @return {number}
   *         Volume level percent as a decimal number.
   */ getPercent() {
        if (this.player_.muted()) return 0;
        return this.player_.volume();
    }
    /**
   * Increase volume level for keyboard users
   */ stepForward() {
        this.checkMuted();
        this.player_.volume(this.player_.volume() + 0.1);
    }
    /**
   * Decrease volume level for keyboard users
   */ stepBack() {
        this.checkMuted();
        this.player_.volume(this.player_.volume() - 0.1);
    }
    /**
   * Update ARIA accessibility attributes
   *
   * @param {Event} [event]
   *        The `volumechange` event that caused this function to run.
   *
   * @listens Player#volumechange
   */ updateARIAAttributes(event) {
        const ariaValue = this.player_.muted() ? 0 : this.volumeAsPercentage_();
        this.el_.setAttribute('aria-valuenow', ariaValue);
        this.el_.setAttribute('aria-valuetext', ariaValue + '%');
    }
    /**
   * Returns the current value of the player volume as a percentage
   *
   * @private
   */ volumeAsPercentage_() {
        return Math.round(this.player_.volume() * 100);
    }
    /**
   * When user starts dragging the VolumeBar, store the volume and listen for
   * the end of the drag. When the drag ends, if the volume was set to zero,
   * set lastVolume to the stored volume.
   *
   * @listens slideractive
   * @private
   */ updateLastVolume_() {
        const volumeBeforeDrag = this.player_.volume();
        this.one('sliderinactive', ()=>{
            if (this.player_.volume() === 0) this.player_.lastVolume_(volumeBeforeDrag);
        });
    }
}
/**
 * Default options for the `VolumeBar`
 *
 * @type {Object}
 * @private
 */ $86defbb4e95ebb07$var$VolumeBar.prototype.options_ = {
    children: [
        'volumeLevel'
    ],
    barName: 'volumeLevel'
};
// MouseVolumeLevelDisplay tooltip should not be added to a player on mobile devices
if (!$86defbb4e95ebb07$var$IS_IOS && !$86defbb4e95ebb07$var$IS_ANDROID) $86defbb4e95ebb07$var$VolumeBar.prototype.options_.children.splice(0, 0, 'mouseVolumeLevelDisplay');
/**
 * Call the update event for this Slider when this event happens on the player.
 *
 * @type {string}
 */ $86defbb4e95ebb07$var$VolumeBar.prototype.playerEvent = 'volumechange';
$86defbb4e95ebb07$var$Component$1.registerComponent('VolumeBar', $86defbb4e95ebb07$var$VolumeBar);
/**
 * @file volume-control.js
 */ /**
 * The component for controlling the volume level
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$VolumeControl extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        options.vertical = options.vertical || false;
        // Pass the vertical option down to the VolumeBar if
        // the VolumeBar is turned on.
        if (typeof options.volumeBar === 'undefined' || $86defbb4e95ebb07$var$isPlain(options.volumeBar)) {
            options.volumeBar = options.volumeBar || {};
            options.volumeBar.vertical = options.vertical;
        }
        super(player, options);
        // hide this control if volume support is missing
        $86defbb4e95ebb07$var$checkVolumeSupport(this, player);
        this.throttledHandleMouseMove = $86defbb4e95ebb07$var$throttle($86defbb4e95ebb07$var$bind_(this, this.handleMouseMove), $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL);
        this.handleMouseUpHandler_ = (e)=>this.handleMouseUp(e);
        this.on('mousedown', (e)=>this.handleMouseDown(e));
        this.on('touchstart', (e)=>this.handleMouseDown(e));
        this.on('mousemove', (e)=>this.handleMouseMove(e));
        // while the slider is active (the mouse has been pressed down and
        // is dragging) or in focus we do not want to hide the VolumeBar
        this.on(this.volumeBar, [
            'focus',
            'slideractive'
        ], ()=>{
            this.volumeBar.addClass('vjs-slider-active');
            this.addClass('vjs-slider-active');
            this.trigger('slideractive');
        });
        this.on(this.volumeBar, [
            'blur',
            'sliderinactive'
        ], ()=>{
            this.volumeBar.removeClass('vjs-slider-active');
            this.removeClass('vjs-slider-active');
            this.trigger('sliderinactive');
        });
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        let orientationClass = 'vjs-volume-horizontal';
        if (this.options_.vertical) orientationClass = 'vjs-volume-vertical';
        return super.createEl('div', {
            className: `vjs-volume-control vjs-control ${orientationClass}`
        });
    }
    /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */ handleMouseDown(event) {
        const doc = this.el_.ownerDocument;
        this.on(doc, 'mousemove', this.throttledHandleMouseMove);
        this.on(doc, 'touchmove', this.throttledHandleMouseMove);
        this.on(doc, 'mouseup', this.handleMouseUpHandler_);
        this.on(doc, 'touchend', this.handleMouseUpHandler_);
    }
    /**
   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */ handleMouseUp(event) {
        const doc = this.el_.ownerDocument;
        this.off(doc, 'mousemove', this.throttledHandleMouseMove);
        this.off(doc, 'touchmove', this.throttledHandleMouseMove);
        this.off(doc, 'mouseup', this.handleMouseUpHandler_);
        this.off(doc, 'touchend', this.handleMouseUpHandler_);
    }
    /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */ handleMouseMove(event) {
        this.volumeBar.handleMouseMove(event);
    }
}
/**
 * Default options for the `VolumeControl`
 *
 * @type {Object}
 * @private
 */ $86defbb4e95ebb07$var$VolumeControl.prototype.options_ = {
    children: [
        'volumeBar'
    ]
};
$86defbb4e95ebb07$var$Component$1.registerComponent('VolumeControl', $86defbb4e95ebb07$var$VolumeControl);
/** @import Component from '../../component' */ /** @import Player from '../../player' */ /**
 * Check if muting volume is supported and if it isn't hide the mute toggle
 * button.
 *
 * @param {Component} self
 *        A reference to the mute toggle button
 *
 * @param {Player} player
 *        A reference to the player
 *
 * @private
 */ const $86defbb4e95ebb07$var$checkMuteSupport = function(self1, player) {
    // hide mute toggle button if it's not supported by the current tech
    if (player.tech_ && !player.tech_.featuresMuteControl) self1.addClass('vjs-hidden');
    self1.on(player, 'loadstart', function() {
        if (!player.tech_.featuresMuteControl) self1.addClass('vjs-hidden');
        else self1.removeClass('vjs-hidden');
    });
};
/**
 * @file mute-toggle.js
 */ /** @import Player from '../player' */ /**
 * A button component for muting the audio.
 *
 * @extends Button
 */ class $86defbb4e95ebb07$var$MuteToggle extends $86defbb4e95ebb07$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        // hide this control if volume support is missing
        $86defbb4e95ebb07$var$checkMuteSupport(this, player);
        this.on(player, [
            'loadstart',
            'volumechange'
        ], (e)=>this.update(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-mute-control ${super.buildCSSClass()}`;
    }
    /**
   * This gets called when an `MuteToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        const vol = this.player_.volume();
        const lastVolume = this.player_.lastVolume_();
        if (vol === 0) {
            const volumeToSet = lastVolume < 0.1 ? 0.1 : lastVolume;
            this.player_.volume(volumeToSet);
            this.player_.muted(false);
        } else this.player_.muted(this.player_.muted() ? false : true);
    }
    /**
   * Update the `MuteToggle` button based on the state of `volume` and `muted`
   * on the player.
   *
   * @param {Event} [event]
   *        The {@link Player#loadstart} event if this function was called
   *        through an event.
   *
   * @listens Player#loadstart
   * @listens Player#volumechange
   */ update(event) {
        this.updateIcon_();
        this.updateControlText_();
    }
    /**
   * Update the appearance of the `MuteToggle` icon.
   *
   * Possible states (given `level` variable below):
   * - 0: crossed out
   * - 1: zero bars of volume
   * - 2: one bar of volume
   * - 3: two bars of volume
   *
   * @private
   */ updateIcon_() {
        const vol = this.player_.volume();
        let level = 3;
        this.setIcon('volume-high');
        // in iOS when a player is loaded with muted attribute
        // and volume is changed with a native mute button
        // we want to make sure muted state is updated
        if ($86defbb4e95ebb07$var$IS_IOS && this.player_.tech_ && this.player_.tech_.el_) this.player_.muted(this.player_.tech_.el_.muted);
        if (vol === 0 || this.player_.muted()) {
            this.setIcon('volume-mute');
            level = 0;
        } else if (vol < 0.33) {
            this.setIcon('volume-low');
            level = 1;
        } else if (vol < 0.67) {
            this.setIcon('volume-medium');
            level = 2;
        }
        $86defbb4e95ebb07$var$removeClass(this.el_, [
            0,
            1,
            2,
            3
        ].reduce((str, i)=>str + `${i ? ' ' : ''}vjs-vol-${i}`, ''));
        $86defbb4e95ebb07$var$addClass(this.el_, `vjs-vol-${level}`);
    }
    /**
   * If `muted` has changed on the player, update the control text
   * (`title` attribute on `vjs-mute-control` element and content of
   * `vjs-control-text` element).
   *
   * @private
   */ updateControlText_() {
        const soundOff = this.player_.muted() || this.player_.volume() === 0;
        const text = soundOff ? 'Unmute' : 'Mute';
        if (this.controlText() !== text) this.controlText(text);
    }
}
/**
 * The text that should display over the `MuteToggle`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$MuteToggle.prototype.controlText_ = 'Mute';
$86defbb4e95ebb07$var$Component$1.registerComponent('MuteToggle', $86defbb4e95ebb07$var$MuteToggle);
/**
 * @file volume-control.js
 */ /**
 * A Component to contain the MuteToggle and VolumeControl so that
 * they can work together.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$VolumePanel extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        if (typeof options.inline !== 'undefined') options.inline = options.inline;
        else options.inline = true;
        // pass the inline option down to the VolumeControl as vertical if
        // the VolumeControl is on.
        if (typeof options.volumeControl === 'undefined' || $86defbb4e95ebb07$var$isPlain(options.volumeControl)) {
            options.volumeControl = options.volumeControl || {};
            options.volumeControl.vertical = !options.inline;
        }
        super(player, options);
        // this handler is used by mouse handler methods below
        this.handleKeyPressHandler_ = (e)=>this.handleKeyPress(e);
        this.on(player, [
            'loadstart'
        ], (e)=>this.volumePanelState_(e));
        this.on(this.muteToggle, 'keyup', (e)=>this.handleKeyPress(e));
        this.on(this.volumeControl, 'keyup', (e)=>this.handleVolumeControlKeyUp(e));
        this.on('keydown', (e)=>this.handleKeyPress(e));
        this.on('mouseover', (e)=>this.handleMouseOver(e));
        this.on('mouseout', (e)=>this.handleMouseOut(e));
        // while the slider is active (the mouse has been pressed down and
        // is dragging) we do not want to hide the VolumeBar
        this.on(this.volumeControl, [
            'slideractive'
        ], this.sliderActive_);
        this.on(this.volumeControl, [
            'sliderinactive'
        ], this.sliderInactive_);
    }
    /**
   * Add vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#slideractive
   * @private
   */ sliderActive_() {
        this.addClass('vjs-slider-active');
    }
    /**
   * Removes vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#sliderinactive
   * @private
   */ sliderInactive_() {
        this.removeClass('vjs-slider-active');
    }
    /**
   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
   * depending on MuteToggle and VolumeControl state
   *
   * @listens Player#loadstart
   * @private
   */ volumePanelState_() {
        // hide volume panel if neither volume control or mute toggle
        // are displayed
        if (this.volumeControl.hasClass('vjs-hidden') && this.muteToggle.hasClass('vjs-hidden')) this.addClass('vjs-hidden');
        // if only mute toggle is visible we don't want
        // volume panel expanding when hovered or active
        if (this.volumeControl.hasClass('vjs-hidden') && !this.muteToggle.hasClass('vjs-hidden')) this.addClass('vjs-mute-toggle-only');
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        let orientationClass = 'vjs-volume-panel-horizontal';
        if (!this.options_.inline) orientationClass = 'vjs-volume-panel-vertical';
        return super.createEl('div', {
            className: `vjs-volume-panel vjs-control ${orientationClass}`
        });
    }
    /**
   * Dispose of the `volume-panel` and all child components.
   */ dispose() {
        this.handleMouseOut();
        super.dispose();
    }
    /**
   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
   * the volume panel and sets focus on `MuteToggle`.
   *
   * @param {Event} event
   *        The `keyup` event that caused this function to be called.
   *
   * @listens keyup
   */ handleVolumeControlKeyUp(event) {
        if (event.key === 'Escape') this.muteToggle.focus();
    }
    /**
   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
   * Turns on listening for `mouseover` event. When they happen it
   * calls `this.handleMouseOver`.
   *
   * @param {Event} event
   *        The `mouseover` event that caused this function to be called.
   *
   * @listens mouseover
   */ handleMouseOver(event) {
        this.addClass('vjs-hover');
        $86defbb4e95ebb07$var$on((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))), 'keyup', this.handleKeyPressHandler_);
    }
    /**
   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
   * Turns on listening for `mouseout` event. When they happen it
   * calls `this.handleMouseOut`.
   *
   * @param {Event} event
   *        The `mouseout` event that caused this function to be called.
   *
   * @listens mouseout
   */ handleMouseOut(event) {
        this.removeClass('vjs-hover');
        $86defbb4e95ebb07$var$off((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))), 'keyup', this.handleKeyPressHandler_);
    }
    /**
   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
   * looking for ESC, which hides the `VolumeControl`.
   *
   * @param {Event} event
   *        The keypress that triggered this event.
   *
   * @listens keydown | keyup
   */ handleKeyPress(event) {
        if (event.key === 'Escape') this.handleMouseOut();
    }
}
/**
 * Default options for the `VolumeControl`
 *
 * @type {Object}
 * @private
 */ $86defbb4e95ebb07$var$VolumePanel.prototype.options_ = {
    children: [
        'muteToggle',
        'volumeControl'
    ]
};
$86defbb4e95ebb07$var$Component$1.registerComponent('VolumePanel', $86defbb4e95ebb07$var$VolumePanel);
/**
 * Button to skip forward a configurable amount of time
 * through a video. Renders in the control bar.
 *
 * e.g. options: {controlBar: {skipButtons: forward: 5}}
 *
 * @extends Button
 */ class $86defbb4e95ebb07$var$SkipForward extends $86defbb4e95ebb07$var$Button {
    constructor(player, options){
        super(player, options);
        this.validOptions = [
            5,
            10,
            30
        ];
        this.skipTime = this.getSkipForwardTime();
        if (this.skipTime && this.validOptions.includes(this.skipTime)) {
            this.setIcon(`forward-${this.skipTime}`);
            this.controlText(this.localize('Skip forward {1} seconds', [
                this.skipTime.toLocaleString(player.language())
            ]));
            this.show();
        } else this.hide();
    }
    getSkipForwardTime() {
        const playerOptions = this.options_.playerOptions;
        return playerOptions.controlBar && playerOptions.controlBar.skipButtons && playerOptions.controlBar.skipButtons.forward;
    }
    buildCSSClass() {
        return `vjs-skip-forward-${this.getSkipForwardTime()} ${super.buildCSSClass()}`;
    }
    /**
   * On click, skips forward in the duration/seekable range by a configurable amount of seconds.
   * If the time left in the duration/seekable range is less than the configured 'skip forward' time,
   * skips to end of duration/seekable range.
   *
   * Handle a click on a `SkipForward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */ handleClick(event) {
        if (isNaN(this.player_.duration())) return;
        const currentVideoTime = this.player_.currentTime();
        const liveTracker = this.player_.liveTracker;
        const duration = liveTracker && liveTracker.isLive() ? liveTracker.seekableEnd() : this.player_.duration();
        let newTime;
        if (currentVideoTime + this.skipTime <= duration) newTime = currentVideoTime + this.skipTime;
        else newTime = duration;
        this.player_.currentTime(newTime);
    }
    /**
   * Update control text on languagechange
   */ handleLanguagechange() {
        this.controlText(this.localize('Skip forward {1} seconds', [
            this.skipTime
        ]));
    }
}
$86defbb4e95ebb07$var$SkipForward.prototype.controlText_ = 'Skip Forward';
$86defbb4e95ebb07$var$Component$1.registerComponent('SkipForward', $86defbb4e95ebb07$var$SkipForward);
/**
 * Button to skip backward a configurable amount of time
 * through a video. Renders in the control bar.
 *
 *  * e.g. options: {controlBar: {skipButtons: backward: 5}}
 *
 * @extends Button
 */ class $86defbb4e95ebb07$var$SkipBackward extends $86defbb4e95ebb07$var$Button {
    constructor(player, options){
        super(player, options);
        this.validOptions = [
            5,
            10,
            30
        ];
        this.skipTime = this.getSkipBackwardTime();
        if (this.skipTime && this.validOptions.includes(this.skipTime)) {
            this.setIcon(`replay-${this.skipTime}`);
            this.controlText(this.localize('Skip backward {1} seconds', [
                this.skipTime.toLocaleString(player.language())
            ]));
            this.show();
        } else this.hide();
    }
    getSkipBackwardTime() {
        const playerOptions = this.options_.playerOptions;
        return playerOptions.controlBar && playerOptions.controlBar.skipButtons && playerOptions.controlBar.skipButtons.backward;
    }
    buildCSSClass() {
        return `vjs-skip-backward-${this.getSkipBackwardTime()} ${super.buildCSSClass()}`;
    }
    /**
   * On click, skips backward in the video by a configurable amount of seconds.
   * If the current time in the video is less than the configured 'skip backward' time,
   * skips to beginning of video or seekable range.
   *
   * Handle a click on a `SkipBackward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */ handleClick(event) {
        const currentVideoTime = this.player_.currentTime();
        const liveTracker = this.player_.liveTracker;
        const seekableStart = liveTracker && liveTracker.isLive() && liveTracker.seekableStart();
        let newTime;
        if (seekableStart && currentVideoTime - this.skipTime <= seekableStart) newTime = seekableStart;
        else if (currentVideoTime >= this.skipTime) newTime = currentVideoTime - this.skipTime;
        else newTime = 0;
        this.player_.currentTime(newTime);
    }
    /**
   * Update control text on languagechange
   */ handleLanguagechange() {
        this.controlText(this.localize('Skip backward {1} seconds', [
            this.skipTime
        ]));
    }
}
$86defbb4e95ebb07$var$SkipBackward.prototype.controlText_ = 'Skip Backward';
$86defbb4e95ebb07$var$Component$1.registerComponent('SkipBackward', $86defbb4e95ebb07$var$SkipBackward);
/**
 * @file menu.js
 */ /** @import Player from '../player' */ /**
 * The Menu component is used to build popup menus, including subtitle and
 * captions selection menus.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$Menu extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        the player that this component should attach to
   *
   * @param {Object} [options]
   *        Object of option names and values
   *
   */ constructor(player, options){
        super(player, options);
        if (options) this.menuButton_ = options.menuButton;
        this.focusedChild_ = -1;
        this.on('keydown', (e)=>this.handleKeyDown(e));
        // All the menu item instances share the same blur handler provided by the menu container.
        this.boundHandleBlur_ = (e)=>this.handleBlur(e);
        this.boundHandleTapClick_ = (e)=>this.handleTapClick(e);
    }
    /**
   * Add event listeners to the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to add listeners to.
   *
   */ addEventListenerForItem(component) {
        if (!(component instanceof $86defbb4e95ebb07$var$Component$1)) return;
        this.on(component, 'blur', this.boundHandleBlur_);
        this.on(component, [
            'tap',
            'click'
        ], this.boundHandleTapClick_);
    }
    /**
   * Remove event listeners from the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to remove listeners.
   *
   */ removeEventListenerForItem(component) {
        if (!(component instanceof $86defbb4e95ebb07$var$Component$1)) return;
        this.off(component, 'blur', this.boundHandleBlur_);
        this.off(component, [
            'tap',
            'click'
        ], this.boundHandleTapClick_);
    }
    /**
   * This method will be called indirectly when the component has been added
   * before the component adds to the new menu instance by `addItem`.
   * In this case, the original menu instance will remove the component
   * by calling `removeChild`.
   *
   * @param {Object} component
   *        The instance of the `MenuItem`
   */ removeChild(component) {
        if (typeof component === 'string') component = this.getChild(component);
        this.removeEventListenerForItem(component);
        super.removeChild(component);
    }
    /**
   * Add a {@link MenuItem} to the menu.
   *
   * @param {Object|string} component
   *        The name or instance of the `MenuItem` to add.
   *
   */ addItem(component) {
        const childComponent = this.addChild(component);
        if (childComponent) this.addEventListenerForItem(childComponent);
    }
    /**
   * Create the `Menu`s DOM element.
   *
   * @return {Element}
   *         the element that was created
   */ createEl() {
        const contentElType = this.options_.contentElType || 'ul';
        this.contentEl_ = $86defbb4e95ebb07$var$createEl(contentElType, {
            className: 'vjs-menu-content'
        });
        this.contentEl_.setAttribute('role', 'menu');
        const el = super.createEl('div', {
            append: this.contentEl_,
            className: 'vjs-menu'
        });
        el.appendChild(this.contentEl_);
        // Prevent clicks from bubbling up. Needed for Menu Buttons,
        // where a click on the parent is significant
        $86defbb4e95ebb07$var$on(el, 'click', function(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        });
        return el;
    }
    dispose() {
        this.contentEl_ = null;
        this.boundHandleBlur_ = null;
        this.boundHandleTapClick_ = null;
        super.dispose();
    }
    /**
   * Called when a `MenuItem` loses focus.
   *
   * @param {Event} event
   *        The `blur` event that caused this function to be called.
   *
   * @listens blur
   */ handleBlur(event) {
        const relatedTarget = event.relatedTarget || (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).activeElement;
        // Close menu popup when a user clicks outside the menu
        if (!this.children().some((element)=>{
            return element.el() === relatedTarget;
        })) {
            const btn = this.menuButton_;
            if (btn && btn.buttonPressed_ && relatedTarget !== btn.el().firstChild) btn.unpressButton();
        }
    }
    /**
   * Called when a `MenuItem` gets clicked or tapped.
   *
   * @param {Event} event
   *        The `click` or `tap` event that caused this function to be called.
   *
   * @listens click,tap
   */ handleTapClick(event) {
        // Unpress the associated MenuButton, and move focus back to it
        if (this.menuButton_) {
            this.menuButton_.unpressButton();
            const childComponents = this.children();
            if (!Array.isArray(childComponents)) return;
            const foundComponent = childComponents.filter((component)=>component.el() === event.target)[0];
            if (!foundComponent) return;
            // don't focus menu button if item is a caption settings item
            // because focus will move elsewhere
            if (foundComponent.name() !== 'CaptionSettingsMenuItem') this.menuButton_.focus();
        }
    }
    /**
   * Handle a `keydown` event on this menu. This listener is added in the constructor.
   *
   * @param {KeyboardEvent} event
   *        A `keydown` event that happened on the menu.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Left and Down Arrows
        if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
            event.preventDefault();
            event.stopPropagation();
            this.stepForward();
        // Up and Right Arrows
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
            event.preventDefault();
            event.stopPropagation();
            this.stepBack();
        }
    }
    /**
   * Move to next (lower) menu item for keyboard users.
   */ stepForward() {
        let stepChild = 0;
        if (this.focusedChild_ !== undefined) stepChild = this.focusedChild_ + 1;
        this.focus(stepChild);
    }
    /**
   * Move to previous (higher) menu item for keyboard users.
   */ stepBack() {
        let stepChild = 0;
        if (this.focusedChild_ !== undefined) stepChild = this.focusedChild_ - 1;
        this.focus(stepChild);
    }
    /**
   * Set focus on a {@link MenuItem} in the `Menu`.
   *
   * @param {Object|string} [item=0]
   *        Index of child item set focus on.
   */ focus(item = 0) {
        const children = this.children().slice();
        const haveTitle = children.length && children[0].hasClass('vjs-menu-title');
        if (haveTitle) children.shift();
        if (children.length > 0) {
            if (item < 0) item = 0;
            else if (item >= children.length) item = children.length - 1;
            this.focusedChild_ = item;
            children[item].el_.focus();
        }
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('Menu', $86defbb4e95ebb07$var$Menu);
/**
 * @file menu-button.js
 */ /** @import Player from '../player' */ /**
 * A `MenuButton` class for any popup {@link Menu}.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$MenuButton extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        super(player, options);
        this.menuButton_ = new $86defbb4e95ebb07$var$Button(player, options);
        this.menuButton_.controlText(this.controlText_);
        this.menuButton_.el_.setAttribute('aria-haspopup', 'true');
        // Add buildCSSClass values to the button, not the wrapper
        const buttonClass = $86defbb4e95ebb07$var$Button.prototype.buildCSSClass();
        this.menuButton_.el_.className = this.buildCSSClass() + ' ' + buttonClass;
        this.menuButton_.removeClass('vjs-control');
        this.addChild(this.menuButton_);
        this.update();
        this.enabled_ = true;
        const handleClick = (e)=>this.handleClick(e);
        this.handleMenuKeyUp_ = (e)=>this.handleMenuKeyUp(e);
        this.on(this.menuButton_, 'tap', handleClick);
        this.on(this.menuButton_, 'click', handleClick);
        this.on(this.menuButton_, 'keydown', (e)=>this.handleKeyDown(e));
        this.on(this.menuButton_, 'mouseenter', ()=>{
            this.addClass('vjs-hover');
            this.menu.show();
            $86defbb4e95ebb07$var$on((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))), 'keyup', this.handleMenuKeyUp_);
        });
        this.on('mouseleave', (e)=>this.handleMouseLeave(e));
        this.on('keydown', (e)=>this.handleSubmenuKeyDown(e));
    }
    /**
   * Update the menu based on the current state of its items.
   */ update() {
        const menu = this.createMenu();
        if (this.menu) {
            this.menu.dispose();
            this.removeChild(this.menu);
        }
        this.menu = menu;
        this.addChild(menu);
        /**
     * Track the state of the menu button
     *
     * @type {Boolean}
     * @private
     */ this.buttonPressed_ = false;
        this.menuButton_.el_.setAttribute('aria-expanded', 'false');
        if (this.items && this.items.length <= this.hideThreshold_) {
            this.hide();
            this.menu.contentEl_.removeAttribute('role');
        } else {
            this.show();
            this.menu.contentEl_.setAttribute('role', 'menu');
        }
    }
    /**
   * Create the menu and add all items to it.
   *
   * @return {Menu}
   *         The constructed menu
   */ createMenu() {
        const menu = new $86defbb4e95ebb07$var$Menu(this.player_, {
            menuButton: this
        });
        /**
     * Hide the menu if the number of items is less than or equal to this threshold. This defaults
     * to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
     * it here because every time we run `createMenu` we need to reset the value.
     *
     * @protected
     * @type {Number}
     */ this.hideThreshold_ = 0;
        // Add a title list item to the top
        if (this.options_.title) {
            const titleEl = $86defbb4e95ebb07$var$createEl('li', {
                className: 'vjs-menu-title',
                textContent: $86defbb4e95ebb07$var$toTitleCase$1(this.options_.title),
                tabIndex: -1
            });
            const titleComponent = new $86defbb4e95ebb07$var$Component$1(this.player_, {
                el: titleEl
            });
            menu.addItem(titleComponent);
        }
        this.items = this.createItems();
        if (this.items) // Add menu items to the menu
        for(let i = 0; i < this.items.length; i++)menu.addItem(this.items[i]);
        return menu;
    }
    /**
   * Create the list of menu items. Specific to each subclass.
   *
   * @abstract
   */ createItems() {}
    /**
   * Create the `MenuButtons`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl() {
        return super.createEl('div', {
            className: this.buildWrapperCSSClass()
        }, {});
    }
    /**
   * Overwrites the `setIcon` method from `Component`.
   * In this case, we want the icon to be appended to the menuButton.
   *
   * @param {string} name
   *         The icon name to be added.
   *
   * @return {Element}
   *         The element that gets created.
   */ setIcon(name) {
        return super.setIcon(name, this.menuButton_.el_);
    }
    /**
   * Allow sub components to stack CSS class names for the wrapper element
   *
   * @return {string}
   *         The constructed wrapper DOM `className`
   */ buildWrapperCSSClass() {
        let menuButtonClass = 'vjs-menu-button';
        // If the inline option is passed, we want to use different styles altogether.
        if (this.options_.inline === true) menuButtonClass += '-inline';
        else menuButtonClass += '-popup';
        // TODO: Fix the CSS so that this isn't necessary
        const buttonClass = $86defbb4e95ebb07$var$Button.prototype.buildCSSClass();
        return `vjs-menu-button ${menuButtonClass} ${buttonClass} ${super.buildCSSClass()}`;
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        let menuButtonClass = 'vjs-menu-button';
        // If the inline option is passed, we want to use different styles altogether.
        if (this.options_.inline === true) menuButtonClass += '-inline';
        else menuButtonClass += '-popup';
        return `vjs-menu-button ${menuButtonClass} ${super.buildCSSClass()}`;
    }
    /**
   * Get or set the localized control text that will be used for accessibility.
   *
   * > NOTE: This will come from the internal `menuButton_` element.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.menuButton_.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */ controlText(text, el = this.menuButton_.el()) {
        return this.menuButton_.controlText(text, el);
    }
    /**
   * Dispose of the `menu-button` and all child components.
   */ dispose() {
        this.handleMouseLeave();
        super.dispose();
    }
    /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        if (this.buttonPressed_) this.unpressButton();
        else this.pressButton();
    }
    /**
   * Handle `mouseleave` for `MenuButton`.
   *
   * @param {Event} event
   *        The `mouseleave` event that caused this function to be called.
   *
   * @listens mouseleave
   */ handleMouseLeave(event) {
        this.removeClass('vjs-hover');
        $86defbb4e95ebb07$var$off((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))), 'keyup', this.handleMenuKeyUp_);
    }
    /**
   * Set the focus to the actual button, not to this element
   */ focus() {
        this.menuButton_.focus();
    }
    /**
   * Remove the focus from the actual button, not this element
   */ blur() {
        this.menuButton_.blur();
    }
    /**
   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Escape or Tab unpress the 'button'
        if (event.key === 'Escape' || event.key === 'Tab') {
            if (this.buttonPressed_) this.unpressButton();
            // Don't preventDefault for Tab key - we still want to lose focus
            event.key;
        // Up Arrow or Down Arrow also 'press' the button to open the menu
        } else if (event.key === 'Up' || event.key === 'Down' && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) {
            if (!this.buttonPressed_) {
                event.preventDefault();
                this.pressButton();
            }
        }
    }
    /**
   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keyup
   */ handleMenuKeyUp(event) {
        // Escape hides popup menu
        if (event.key === 'Escape' || event.key === 'Tab') this.removeClass('vjs-hover');
    }
    /**
   * This method name now delegates to `handleSubmenuKeyDown`. This means
   * anyone calling `handleSubmenuKeyPress` will not see their method calls
   * stop working.
   *
   * @param {Event} event
   *        The event that caused this function to be called.
   */ handleSubmenuKeyPress(event) {
        this.handleSubmenuKeyDown(event);
    }
    /**
   * Handle a `keydown` event on a sub-menu. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keydown
   */ handleSubmenuKeyDown(event) {
        // Escape or Tab unpress the 'button'
        if (event.key === 'Escape' || event.key === 'Tab') {
            if (this.buttonPressed_) this.unpressButton();
            // Don't preventDefault for Tab key - we still want to lose focus
            event.key;
        }
    }
    /**
   * Put the current `MenuButton` into a pressed state.
   */ pressButton() {
        if (this.enabled_) {
            this.buttonPressed_ = true;
            this.menu.show();
            this.menu.lockShowing();
            this.menuButton_.el_.setAttribute('aria-expanded', 'true');
            // set the focus into the submenu, except on iOS where it is resulting in
            // undesired scrolling behavior when the player is in an iframe
            if ($86defbb4e95ebb07$var$IS_IOS && $86defbb4e95ebb07$var$isInFrame()) // Return early so that the menu isn't focused
            return;
            this.menu.focus();
        }
    }
    /**
   * Take the current `MenuButton` out of a pressed state.
   */ unpressButton() {
        if (this.enabled_) {
            this.buttonPressed_ = false;
            this.menu.unlockShowing();
            this.menu.hide();
            this.menuButton_.el_.setAttribute('aria-expanded', 'false');
        }
    }
    /**
   * Disable the `MenuButton`. Don't allow it to be clicked.
   */ disable() {
        this.unpressButton();
        this.enabled_ = false;
        this.addClass('vjs-disabled');
        this.menuButton_.disable();
    }
    /**
   * Enable the `MenuButton`. Allow it to be clicked.
   */ enable() {
        this.enabled_ = true;
        this.removeClass('vjs-disabled');
        this.menuButton_.enable();
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('MenuButton', $86defbb4e95ebb07$var$MenuButton);
/**
 * @file track-button.js
 */ /** @import Player from '../player' */ /**
 * The base class for buttons that toggle specific  track types (e.g. subtitles).
 *
 * @extends MenuButton
 */ class $86defbb4e95ebb07$var$TrackButton extends $86defbb4e95ebb07$var$MenuButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const tracks = options.tracks;
        super(player, options);
        if (this.items.length <= 1) this.hide();
        if (!tracks) return;
        this.updateHandler_ = $86defbb4e95ebb07$var$bind_(this, this.update);
        this.cleanupHandler_ = $86defbb4e95ebb07$var$bind_(this, this.cleanupTrackListeners_);
        tracks.addEventListener('removetrack', this.updateHandler_);
        tracks.addEventListener('addtrack', this.updateHandler_);
        tracks.addEventListener('labelchange', this.updateHandler_);
        this.player_.on('ready', this.updateHandler_);
        this.player_.on('dispose', this.cleanupHandler_);
    }
    /**
   * Remove all track list event listeners without triggering a full dispose.
   * Used as the player 'dispose' handler and called by dispose() before super.
   *
   * @private
   */ cleanupTrackListeners_() {
        if (!this.updateHandler_) return;
        const tracks = this.options_.tracks;
        if (tracks) {
            tracks.removeEventListener('removetrack', this.updateHandler_);
            tracks.removeEventListener('addtrack', this.updateHandler_);
            tracks.removeEventListener('labelchange', this.updateHandler_);
        }
        if (this.player_) {
            this.player_.off('ready', this.updateHandler_);
            this.player_.off('dispose', this.cleanupHandler_);
        }
        this.updateHandler_ = null;
        this.cleanupHandler_ = null;
    }
    /**
   * Dispose of the Component and remove all event listeners.
   *
   * @override
   */ dispose() {
        this.cleanupTrackListeners_();
        super.dispose();
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TrackButton', $86defbb4e95ebb07$var$TrackButton);
/**
 * @file menu-item.js
 */ /** @import Player from '../player' */ /**
 * The component for a menu item. `<li>`
 *
 * @extends ClickableComponent
 */ class $86defbb4e95ebb07$var$MenuItem extends $86defbb4e95ebb07$var$ClickableComponent {
    /**
   * Creates an instance of the this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   *
   */ constructor(player, options){
        super(player, options);
        this.selectable = options.selectable;
        this.isSelected_ = options.selected || false;
        this.multiSelectable = options.multiSelectable;
        this.selected(this.isSelected_);
        if (this.selectable) {
            if (this.multiSelectable) this.el_.setAttribute('role', 'menuitemcheckbox');
            else this.el_.setAttribute('role', 'menuitemradio');
        } else this.el_.setAttribute('role', 'menuitem');
    }
    /**
   * Create the `MenuItem's DOM element
   *
   * @param {string} [type=li]
   *        Element's node type, not actually used, always set to `li`.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element
   *
   * @param {Object} [attrs={}]
   *        An object of attributes that should be set on the element
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(type, props, attrs) {
        // The control is textual, not just an icon
        this.nonIconControl = true;
        const el = super.createEl('li', Object.assign({
            className: 'vjs-menu-item',
            tabIndex: -1
        }, props), attrs);
        // swap icon with menu item text.
        const menuItemEl = $86defbb4e95ebb07$var$createEl('span', {
            className: 'vjs-menu-item-text',
            textContent: this.localize(this.options_.label)
        });
        // If using SVG icons, the element with vjs-icon-placeholder will be added separately.
        if (this.player_.options_.experimentalSvgIcons) el.appendChild(menuItemEl);
        else el.replaceChild(menuItemEl, el.querySelector('.vjs-icon-placeholder'));
        return el;
    }
    /**
   * Ignore keys which are used by the menu, but pass any other ones up. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        if (![
            'Tab',
            'Escape',
            'ArrowUp',
            'ArrowLeft',
            'ArrowRight',
            'ArrowDown'
        ].includes(event.key)) // Pass keydown handling up for unused keys
        super.handleKeyDown(event);
    }
    /**
   * Any click on a `MenuItem` puts it into the selected state.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        this.selected(true);
    }
    /**
   * Set the state for this menu item as selected or not.
   *
   * @param {boolean} selected
   *        if the menu item is selected or not
   */ selected(selected) {
        if (this.selectable) {
            if (selected) {
                this.addClass('vjs-selected');
                this.el_.setAttribute('aria-checked', 'true');
                // aria-checked isn't fully supported by browsers/screen readers,
                // so indicate selected state to screen reader in the control text.
                this.controlText(', selected');
                this.isSelected_ = true;
            } else {
                this.removeClass('vjs-selected');
                this.el_.setAttribute('aria-checked', 'false');
                // Indicate un-selected state to screen reader
                this.controlText('');
                this.isSelected_ = false;
            }
        }
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('MenuItem', $86defbb4e95ebb07$var$MenuItem);
/**
 * @file text-track-menu-item.js
 */ /** @import Player from '../../player' */ /**
 * The specific menu item type for selecting a language within a text track kind
 *
 * @extends MenuItem
 */ class $86defbb4e95ebb07$var$TextTrackMenuItem extends $86defbb4e95ebb07$var$MenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const track = options.track;
        const tracks = player.textTracks();
        // Modify options for parent MenuItem class's init.
        options.label = track.label || track.language || 'Unknown';
        options.selected = track.mode === 'showing';
        super(player, options);
        this.track = track;
        // Determine the relevant kind(s) of tracks for this component and filter
        // out empty kinds.
        this.kinds = (options.kinds || [
            options.kind || this.track.kind
        ]).filter(Boolean);
        const changeHandler = (...args)=>{
            this.handleTracksChange.apply(this, args);
        };
        const selectedLanguageChangeHandler = (...args)=>{
            this.handleSelectedLanguageChange.apply(this, args);
        };
        player.on([
            'loadstart',
            'texttrackchange'
        ], changeHandler);
        tracks.addEventListener('change', changeHandler);
        tracks.addEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
        this.on('dispose', function() {
            player.off([
                'loadstart',
                'texttrackchange'
            ], changeHandler);
            tracks.removeEventListener('change', changeHandler);
            tracks.removeEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
        });
        // iOS7 doesn't dispatch change events to TextTrackLists when an
        // associated track's mode changes. Without something like
        // Object.observe() (also not present on iOS7), it's not
        // possible to detect changes to the mode attribute and polyfill
        // the change event. As a poor substitute, we manually dispatch
        // change events whenever the controls modify the mode.
        if (tracks.onchange === undefined) {
            let event;
            this.on([
                'tap',
                'click'
            ], function() {
                if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Event !== 'object') // Android 2.3 throws an Illegal Constructor error for window.Event
                try {
                    event = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Event('change');
                } catch (err) {
                // continue regardless of error
                }
                if (!event) {
                    event = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createEvent('Event');
                    event.initEvent('change', true, true);
                }
                tracks.dispatchEvent(event);
            });
        }
        // set the default state based on current tracks
        this.handleTracksChange();
    }
    /**
   * This gets called when an `TextTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        const referenceTrack = this.track;
        const tracks = this.player_.textTracks();
        super.handleClick(event);
        if (!tracks) return;
        for(let i = 0; i < tracks.length; i++){
            const track = tracks[i];
            // If the track from the text tracks list is not of the right kind,
            // skip it. We do not want to affect tracks of incompatible kind(s).
            if (this.kinds.indexOf(track.kind) === -1) continue;
            // If this text track is the component's track and it is not showing,
            // set it to showing.
            if (track === referenceTrack) {
                if (track.mode !== 'showing') track.mode = 'showing';
            } else if (track.mode !== 'disabled') track.mode = 'disabled';
        }
    }
    /**
   * Handle text track list change
   *
   * @param {Event} event
   *        The `change` event that caused this function to be called.
   *
   * @listens TextTrackList#change
   */ handleTracksChange(event) {
        const shouldBeSelected = this.track.mode === 'showing';
        // Prevent redundant selected() calls because they may cause
        // screen readers to read the appended control text unnecessarily
        if (shouldBeSelected !== this.isSelected_) this.selected(shouldBeSelected);
    }
    handleSelectedLanguageChange(event) {
        if (this.track.mode === 'showing') {
            const selectedLanguage = this.player_.cache_.selectedLanguage;
            // Don't replace the kind of track across the same language
            if (selectedLanguage && selectedLanguage.enabled && selectedLanguage.language === this.track.language && selectedLanguage.kind !== this.track.kind) return;
            this.player_.cache_.selectedLanguage = {
                enabled: true,
                language: this.track.language,
                kind: this.track.kind
            };
        }
    }
    dispose() {
        // remove reference to track object on dispose
        this.track = null;
        super.dispose();
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TextTrackMenuItem', $86defbb4e95ebb07$var$TextTrackMenuItem);
/**
 * @file off-text-track-menu-item.js
 */ /** @import Player from '../../player' */ /**
 * A special menu item for turning off a specific type of text track
 *
 * @extends TextTrackMenuItem
 */ class $86defbb4e95ebb07$var$OffTextTrackMenuItem extends $86defbb4e95ebb07$var$TextTrackMenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        // Create pseudo track info
        // Requires options['kind']
        options.track = {
            player: player,
            // it is no longer necessary to store `kind` or `kinds` on the track itself
            // since they are now stored in the `kinds` property of all instances of
            // TextTrackMenuItem, but this will remain for backwards compatibility
            kind: options.kind,
            kinds: options.kinds,
            default: false,
            mode: 'disabled'
        };
        if (!options.kinds) options.kinds = [
            options.kind
        ];
        if (options.label) options.track.label = options.label;
        else options.track.label = options.kinds.join(' and ') + ' off';
        // MenuItem is selectable
        options.selectable = true;
        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
        options.multiSelectable = false;
        super(player, options);
    }
    /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   */ handleTracksChange(event) {
        const tracks = this.player().textTracks();
        let shouldBeSelected = true;
        for(let i = 0, l = tracks.length; i < l; i++){
            const track = tracks[i];
            if (this.options_.kinds.indexOf(track.kind) > -1 && track.mode === 'showing') {
                shouldBeSelected = false;
                break;
            }
        }
        // Prevent redundant selected() calls because they may cause
        // screen readers to read the appended control text unnecessarily
        if (shouldBeSelected !== this.isSelected_) this.selected(shouldBeSelected);
    }
    handleSelectedLanguageChange(event) {
        const tracks = this.player().textTracks();
        let allHidden = true;
        for(let i = 0, l = tracks.length; i < l; i++){
            const track = tracks[i];
            if ([
                'captions',
                'descriptions',
                'subtitles'
            ].indexOf(track.kind) > -1 && track.mode === 'showing') {
                allHidden = false;
                break;
            }
        }
        if (allHidden) this.player_.cache_.selectedLanguage = {
            enabled: false
        };
    }
    /**
   * Update control text and label on languagechange
   */ handleLanguagechange() {
        this.$('.vjs-menu-item-text').textContent = this.player_.localize(this.options_.label);
        super.handleLanguagechange();
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('OffTextTrackMenuItem', $86defbb4e95ebb07$var$OffTextTrackMenuItem);
/**
 * @file text-track-button.js
 */ /** @import Player from '../../player' */ /**
 * The base class for buttons that toggle specific text track types (e.g. subtitles)
 *
 * @extends MenuButton
 */ class $86defbb4e95ebb07$var$TextTrackButton extends $86defbb4e95ebb07$var$TrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        options.tracks = player.textTracks();
        super(player, options);
    }
    /**
   * Create a menu item for each text track
   *
   * @param {TextTrackMenuItem[]} [items=[]]
   *        Existing array of items to use during creation
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items that were created
   */ createItems(items = [], TrackMenuItem = $86defbb4e95ebb07$var$TextTrackMenuItem) {
        // Label is an override for the [track] off label
        // USed to localise captions/subtitles
        let label;
        if (this.label_) label = `${this.label_} off`;
        // Add an OFF menu item to turn all tracks off
        items.push(new $86defbb4e95ebb07$var$OffTextTrackMenuItem(this.player_, {
            kinds: this.kinds_,
            kind: this.kind_,
            label: label
        }));
        this.hideThreshold_ += 1;
        const tracks = this.player_.textTracks();
        if (!Array.isArray(this.kinds_)) this.kinds_ = [
            this.kind_
        ];
        for(let i = 0; i < tracks.length; i++){
            const track = tracks[i];
            // only add tracks that are of an appropriate kind and have a label
            if (this.kinds_.indexOf(track.kind) > -1) {
                const item = new TrackMenuItem(this.player_, {
                    track: track,
                    kinds: this.kinds_,
                    kind: this.kind_,
                    // MenuItem is selectable
                    selectable: true,
                    // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
                    multiSelectable: false
                });
                item.addClass(`vjs-${track.kind}-menu-item`);
                items.push(item);
            }
        }
        return items;
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TextTrackButton', $86defbb4e95ebb07$var$TextTrackButton);
/**
 * @file chapters-track-menu-item.js
 */ /** @import Player from '../../player' */ /**
 * The chapter track menu item
 *
 * @extends MenuItem
 */ class $86defbb4e95ebb07$var$ChaptersTrackMenuItem extends $86defbb4e95ebb07$var$MenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const track = options.track;
        const cue = options.cue;
        const currentTime = player.currentTime();
        // Modify options for parent MenuItem class's init.
        options.selectable = true;
        options.multiSelectable = false;
        options.label = cue.text;
        options.selected = cue.startTime <= currentTime && currentTime < cue.endTime;
        super(player, options);
        this.track = track;
        this.cue = cue;
    }
    /**
   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        super.handleClick();
        this.player_.currentTime(this.cue.startTime);
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('ChaptersTrackMenuItem', $86defbb4e95ebb07$var$ChaptersTrackMenuItem);
/**
 * @file chapters-button.js
 */ /** @import Player from '../../player' */ /** @import Menu from '../../menu/menu' */ /** @import TextTrack from '../../tracks/text-track' */ /** @import TextTrackMenuItem from '../text-track-controls/text-track-menu-item' */ /**
 * The button component for toggling and selecting chapters
 * Chapters act much differently than other text tracks
 * Cues are navigation vs. other tracks of alternative languages
 *
 * @extends TextTrackButton
 */ class $86defbb4e95ebb07$var$ChaptersButton extends $86defbb4e95ebb07$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this function is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        this.setIcon('chapters');
        this.selectCurrentItem_ = ()=>{
            this.items.forEach((item)=>{
                item.selected(this.track_.activeCues[0] === item.cue);
            });
        };
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-chapters-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-chapters-button ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Update the menu based on the current state of its items.
   *
   * @param {Event} [event]
   *        An event that triggered this function to run.
   *
   * @listens TextTrackList#addtrack
   * @listens TextTrackList#removetrack
   * @listens TextTrackList#change
   */ update(event) {
        if (event && event.track && event.track.kind !== 'chapters') return;
        const track = this.findChaptersTrack();
        if (track !== this.track_) {
            this.setTrack(track);
            super.update();
        } else if (!this.items || track && track.cues && track.cues.length !== this.items.length) // Update the menu initially or if the number of cues has changed since set
        super.update();
    }
    /**
   * Set the currently selected track for the chapters button.
   *
   * @param {TextTrack} track
   *        The new track to select. Nothing will change if this is the currently selected
   *        track.
   */ setTrack(track) {
        if (this.track_ === track) return;
        if (!this.updateHandler_) this.updateHandler_ = this.update.bind(this);
        // here this.track_ refers to the old track instance
        if (this.track_) {
            const remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
            if (remoteTextTrackEl) remoteTextTrackEl.removeEventListener('load', this.updateHandler_);
            this.track_.removeEventListener('cuechange', this.selectCurrentItem_);
            this.track_ = null;
        }
        this.track_ = track;
        // here this.track_ refers to the new track instance
        if (this.track_) {
            this.track_.mode = 'hidden';
            const remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
            if (remoteTextTrackEl) remoteTextTrackEl.addEventListener('load', this.updateHandler_);
            this.track_.addEventListener('cuechange', this.selectCurrentItem_);
        }
    }
    /**
   * Find the track object that is currently in use by this ChaptersButton
   *
   * @return {TextTrack|undefined}
   *         The current track or undefined if none was found.
   */ findChaptersTrack() {
        const tracks = this.player_.textTracks() || [];
        for(let i = tracks.length - 1; i >= 0; i--){
            // We will always choose the last track as our chaptersTrack
            const track = tracks[i];
            if (track.kind === this.kind_) return track;
        }
    }
    /**
   * Get the caption for the ChaptersButton based on the track label. This will also
   * use the current tracks localized kind as a fallback if a label does not exist.
   *
   * @return {string}
   *         The tracks current label or the localized track kind.
   */ getMenuCaption() {
        if (this.track_ && this.track_.label) return this.track_.label;
        return this.localize($86defbb4e95ebb07$var$toTitleCase$1(this.kind_));
    }
    /**
   * Create menu from chapter track
   *
   * @return {Menu}
   *         New menu for the chapter buttons
   */ createMenu() {
        this.options_.title = this.getMenuCaption();
        return super.createMenu();
    }
    /**
   * Create a menu item for each text track
   *
   * @return  {TextTrackMenuItem[]}
   *         Array of menu items
   */ createItems() {
        const items = [];
        if (!this.track_) return items;
        const cues = this.track_.cues;
        if (!cues) return items;
        for(let i = 0, l = cues.length; i < l; i++){
            const cue = cues[i];
            const mi = new $86defbb4e95ebb07$var$ChaptersTrackMenuItem(this.player_, {
                track: this.track_,
                cue: cue
            });
            items.push(mi);
        }
        return items;
    }
}
/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ $86defbb4e95ebb07$var$ChaptersButton.prototype.kind_ = 'chapters';
/**
 * The text that should display over the `ChaptersButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$ChaptersButton.prototype.controlText_ = 'Chapters';
$86defbb4e95ebb07$var$Component$1.registerComponent('ChaptersButton', $86defbb4e95ebb07$var$ChaptersButton);
/**
 * @file descriptions-button.js
 */ /** @import Player from '../../player' */ /**
 * The button component for toggling and selecting descriptions
 *
 * @extends TextTrackButton
 */ class $86defbb4e95ebb07$var$DescriptionsButton extends $86defbb4e95ebb07$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        this.setIcon('audio-description');
        const tracks = player.textTracks();
        const changeHandler = $86defbb4e95ebb07$var$bind_(this, this.handleTracksChange);
        tracks.addEventListener('change', changeHandler);
        this.on('dispose', function() {
            tracks.removeEventListener('change', changeHandler);
        });
    }
    /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   *
   * @listens TextTrackList#change
   */ handleTracksChange(event) {
        const tracks = this.player().textTracks();
        let disabled = false;
        // Check whether a track of a different kind is showing
        for(let i = 0, l = tracks.length; i < l; i++){
            const track = tracks[i];
            if (track.kind !== this.kind_ && track.mode === 'showing') {
                disabled = true;
                break;
            }
        }
        // If another track is showing, disable this menu button
        if (disabled) this.disable();
        else this.enable();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-descriptions-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-descriptions-button ${super.buildWrapperCSSClass()}`;
    }
}
/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ $86defbb4e95ebb07$var$DescriptionsButton.prototype.kind_ = 'descriptions';
/**
 * The text that should display over the `DescriptionsButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$DescriptionsButton.prototype.controlText_ = 'Descriptions';
$86defbb4e95ebb07$var$Component$1.registerComponent('DescriptionsButton', $86defbb4e95ebb07$var$DescriptionsButton);
/**
 * @file subtitles-button.js
 */ /** @import Player from '../../player' */ /**
 * The button component for toggling and selecting subtitles
 *
 * @extends TextTrackButton
 */ class $86defbb4e95ebb07$var$SubtitlesButton extends $86defbb4e95ebb07$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        this.setIcon('subtitles');
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-subtitles-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-subtitles-button ${super.buildWrapperCSSClass()}`;
    }
}
/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ $86defbb4e95ebb07$var$SubtitlesButton.prototype.kind_ = 'subtitles';
/**
 * The text that should display over the `SubtitlesButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$SubtitlesButton.prototype.controlText_ = 'Subtitles';
$86defbb4e95ebb07$var$Component$1.registerComponent('SubtitlesButton', $86defbb4e95ebb07$var$SubtitlesButton);
/**
 * @file caption-settings-menu-item.js
 */ /** @import Player from '../../player' */ /**
 * The menu item for caption track settings menu
 *
 * @extends TextTrackMenuItem
 */ class $86defbb4e95ebb07$var$CaptionSettingsMenuItem extends $86defbb4e95ebb07$var$TextTrackMenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        options.track = {
            player: player,
            kind: options.kind,
            label: options.kind + ' settings',
            selectable: false,
            default: false,
            mode: 'disabled'
        };
        // CaptionSettingsMenuItem has no concept of 'selected'
        options.selectable = false;
        options.name = 'CaptionSettingsMenuItem';
        super(player, options);
        this.addClass('vjs-texttrack-settings');
        this.controlText(', opens ' + options.kind + ' settings dialog');
    }
    /**
   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        this.player().getChild('textTrackSettings').open();
    }
    /**
   * Update control text and label on languagechange
   */ handleLanguagechange() {
        this.$('.vjs-menu-item-text').textContent = this.player_.localize(this.options_.kind + ' settings');
        super.handleLanguagechange();
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('CaptionSettingsMenuItem', $86defbb4e95ebb07$var$CaptionSettingsMenuItem);
/**
 * @file captions-button.js
 */ /** @import Player from '../../player' */ /**
 * The button component for toggling and selecting captions
 *
 * @extends TextTrackButton
 */ class $86defbb4e95ebb07$var$CaptionsButton extends $86defbb4e95ebb07$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        this.setIcon('captions');
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-captions-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-captions-button ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Create caption menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */ createItems() {
        const items = [];
        if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
            items.push(new $86defbb4e95ebb07$var$CaptionSettingsMenuItem(this.player_, {
                kind: this.kind_
            }));
            this.hideThreshold_ += 1;
        }
        return super.createItems(items);
    }
}
/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ $86defbb4e95ebb07$var$CaptionsButton.prototype.kind_ = 'captions';
/**
 * The text that should display over the `CaptionsButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$CaptionsButton.prototype.controlText_ = 'Captions';
$86defbb4e95ebb07$var$Component$1.registerComponent('CaptionsButton', $86defbb4e95ebb07$var$CaptionsButton);
/**
 * @file subs-caps-menu-item.js
 */ /**
 * SubsCapsMenuItem has an [cc] icon to distinguish captions from subtitles
 * in the SubsCapsMenu.
 *
 * @extends TextTrackMenuItem
 */ class $86defbb4e95ebb07$var$SubsCapsMenuItem extends $86defbb4e95ebb07$var$TextTrackMenuItem {
    createEl(type, props, attrs) {
        const el = super.createEl(type, props, attrs);
        const parentSpan = el.querySelector('.vjs-menu-item-text');
        if (this.options_.track.kind === 'captions') {
            if (this.player_.options_.experimentalSvgIcons) this.setIcon('captions', el);
            else parentSpan.appendChild($86defbb4e95ebb07$var$createEl('span', {
                className: 'vjs-icon-placeholder'
            }, {
                'aria-hidden': true
            }));
            parentSpan.appendChild($86defbb4e95ebb07$var$createEl('span', {
                className: 'vjs-control-text',
                // space added as the text will visually flow with the
                // label
                textContent: ` ${this.localize('Captions')}`
            }));
        }
        return el;
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('SubsCapsMenuItem', $86defbb4e95ebb07$var$SubsCapsMenuItem);
/**
 * @file sub-caps-button.js
 */ /** @import Player from '../../player' */ /**
 * The button component for toggling and selecting captions and/or subtitles
 *
 * @extends TextTrackButton
 */ class $86defbb4e95ebb07$var$SubsCapsButton extends $86defbb4e95ebb07$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */ constructor(player, options = {}){
        super(player, options);
        // Although North America uses "captions" in most cases for
        // "captions and subtitles" other locales use "subtitles"
        this.label_ = 'subtitles';
        this.setIcon('subtitles');
        if ([
            'en',
            'en-us',
            'en-ca',
            'fr-ca'
        ].indexOf(this.player_.language_) > -1) {
            this.label_ = 'captions';
            this.setIcon('captions');
        }
        this.menuButton_.controlText($86defbb4e95ebb07$var$toTitleCase$1(this.label_));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-subs-caps-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-subs-caps-button ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Create caption/subtitles menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */ createItems() {
        let items = [];
        if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
            items.push(new $86defbb4e95ebb07$var$CaptionSettingsMenuItem(this.player_, {
                kind: this.label_
            }));
            this.hideThreshold_ += 1;
        }
        items = super.createItems(items, $86defbb4e95ebb07$var$SubsCapsMenuItem);
        return items;
    }
}
/**
 * `kind`s of TextTrack to look for to associate it with this menu.
 *
 * @type {array}
 * @private
 */ $86defbb4e95ebb07$var$SubsCapsButton.prototype.kinds_ = [
    'captions',
    'subtitles'
];
/**
 * The text that should display over the `SubsCapsButton`s controls.
 *
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$SubsCapsButton.prototype.controlText_ = 'Subtitles';
$86defbb4e95ebb07$var$Component$1.registerComponent('SubsCapsButton', $86defbb4e95ebb07$var$SubsCapsButton);
/**
 * @file audio-track-menu-item.js
 */ /** @import Player from '../../player' */ /**
 * An {@link AudioTrack} {@link MenuItem}
 *
 * @extends MenuItem
 */ class $86defbb4e95ebb07$var$AudioTrackMenuItem extends $86defbb4e95ebb07$var$MenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const track = options.track;
        const tracks = player.audioTracks();
        // Modify options for parent MenuItem class's init.
        options.label = track.label || track.language || 'Unknown';
        options.selected = track.enabled;
        super(player, options);
        this.track = track;
        this.addClass(`vjs-${track.kind}-menu-item`);
        const changeHandler = (...args)=>{
            this.handleTracksChange.apply(this, args);
        };
        tracks.addEventListener('change', changeHandler);
        this.on('dispose', ()=>{
            tracks.removeEventListener('change', changeHandler);
        });
    }
    createEl(type, props, attrs) {
        const el = super.createEl(type, props, attrs);
        const parentSpan = el.querySelector('.vjs-menu-item-text');
        if ([
            'main-desc',
            'descriptions',
            'description'
        ].indexOf(this.options_.track.kind) >= 0) {
            parentSpan.appendChild($86defbb4e95ebb07$var$createEl('span', {
                className: 'vjs-icon-placeholder'
            }, {
                'aria-hidden': true
            }));
            parentSpan.appendChild($86defbb4e95ebb07$var$createEl('span', {
                className: 'vjs-control-text',
                textContent: ' ' + this.localize('Descriptions')
            }));
        }
        return el;
    }
    /**
   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        super.handleClick(event);
        // the audio track list will automatically toggle other tracks
        // off for us.
        this.track.enabled = true;
        // when native audio tracks are used, we want to make sure that other tracks are turned off
        if (this.player_.tech_.featuresNativeAudioTracks) {
            const tracks = this.player_.audioTracks();
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                // skip the current track since we enabled it above
                if (track === this.track) continue;
                track.enabled = track === this.track;
            }
        }
    }
    /**
   * Handle any {@link AudioTrack} change.
   *
   * @param {Event} [event]
   *        The {@link AudioTrackList#change} event that caused this to run.
   *
   * @listens AudioTrackList#change
   */ handleTracksChange(event) {
        this.selected(this.track.enabled);
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('AudioTrackMenuItem', $86defbb4e95ebb07$var$AudioTrackMenuItem);
/**
 * @file audio-track-button.js
 */ /**
 * The base class for buttons that toggle specific {@link AudioTrack} types.
 *
 * @extends TrackButton
 */ class $86defbb4e95ebb07$var$AudioTrackButton extends $86defbb4e95ebb07$var$TrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        options.tracks = player.audioTracks();
        super(player, options);
        this.setIcon('audio');
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-audio-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-audio-button ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Create a menu item for each audio track
   *
   * @param {AudioTrackMenuItem[]} [items=[]]
   *        An array of existing menu items to use.
   *
   * @return {AudioTrackMenuItem[]}
   *         An array of menu items
   */ createItems(items = []) {
        // if there's only one audio track, there no point in showing it
        this.hideThreshold_ = 1;
        const tracks = this.player_.audioTracks();
        for(let i = 0; i < tracks.length; i++){
            const track = tracks[i];
            items.push(new $86defbb4e95ebb07$var$AudioTrackMenuItem(this.player_, {
                track: track,
                // MenuItem is selectable
                selectable: true,
                // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
                multiSelectable: false
            }));
        }
        return items;
    }
}
/**
 * The text that should display over the `AudioTrackButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$AudioTrackButton.prototype.controlText_ = 'Audio Track';
$86defbb4e95ebb07$var$Component$1.registerComponent('AudioTrackButton', $86defbb4e95ebb07$var$AudioTrackButton);
/**
 * @file playback-rate-menu-item.js
 */ /** @import Player from '../../player' */ /**
 * The specific menu item type for selecting a playback rate.
 *
 * @extends MenuItem
 */ class $86defbb4e95ebb07$var$PlaybackRateMenuItem extends $86defbb4e95ebb07$var$MenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const label = options.rate;
        const rate = parseFloat(label, 10);
        // Modify options for parent MenuItem class's init.
        options.label = label;
        options.selected = rate === player.playbackRate();
        options.selectable = true;
        options.multiSelectable = false;
        super(player, options);
        this.label = label;
        this.rate = rate;
        this.on(player, 'ratechange', (e)=>this.update(e));
    }
    /**
   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        super.handleClick();
        this.player().playbackRate(this.rate);
    }
    /**
   * Update the PlaybackRateMenuItem when the playbackrate changes.
   *
   * @param {Event} [event]
   *        The `ratechange` event that caused this function to run.
   *
   * @listens Player#ratechange
   */ update(event) {
        this.selected(this.player().playbackRate() === this.rate);
    }
}
/**
 * The text that should display over the `PlaybackRateMenuItem`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */ $86defbb4e95ebb07$var$PlaybackRateMenuItem.prototype.contentElType = 'button';
$86defbb4e95ebb07$var$Component$1.registerComponent('PlaybackRateMenuItem', $86defbb4e95ebb07$var$PlaybackRateMenuItem);
/**
 * @file playback-rate-menu-button.js
 */ /** @import Player from '../../player' */ /**
 * The component for controlling the playback rate.
 *
 * @extends MenuButton
 */ class $86defbb4e95ebb07$var$PlaybackRateMenuButton extends $86defbb4e95ebb07$var$MenuButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.menuButton_.el_.setAttribute('aria-describedby', this.labelElId_);
        this.updateVisibility();
        this.updateLabel();
        this.on(player, 'loadstart', (e)=>this.updateVisibility(e));
        this.on(player, 'ratechange', (e)=>this.updateLabel(e));
        this.on(player, 'playbackrateschange', (e)=>this.handlePlaybackRateschange(e));
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl();
        this.labelElId_ = 'vjs-playback-rate-value-label-' + this.id_;
        this.labelEl_ = $86defbb4e95ebb07$var$createEl('div', {
            className: 'vjs-playback-rate-value',
            id: this.labelElId_,
            textContent: '1x'
        });
        el.appendChild(this.labelEl_);
        return el;
    }
    dispose() {
        this.labelEl_ = null;
        super.dispose();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-playback-rate ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-playback-rate ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Create the list of menu items. Specific to each subclass.
   *
   */ createItems() {
        const rates = this.playbackRates();
        const items = [];
        for(let i = rates.length - 1; i >= 0; i--)items.push(new $86defbb4e95ebb07$var$PlaybackRateMenuItem(this.player(), {
            rate: rates[i] + 'x'
        }));
        return items;
    }
    /**
   * On playbackrateschange, update the menu to account for the new items.
   *
   * @listens Player#playbackrateschange
   */ handlePlaybackRateschange(event) {
        this.update();
    }
    /**
   * Get possible playback rates
   *
   * @return {Array}
   *         All possible playback rates
   */ playbackRates() {
        const player = this.player();
        return player.playbackRates && player.playbackRates() || [];
    }
    /**
   * Get whether playback rates is supported by the tech
   * and an array of playback rates exists
   *
   * @return {boolean}
   *         Whether changing playback rate is supported
   */ playbackRateSupported() {
        return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
    }
    /**
   * Hide playback rate controls when they're no playback rate options to select
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#loadstart
   */ updateVisibility(event) {
        if (this.playbackRateSupported()) this.removeClass('vjs-hidden');
        else this.addClass('vjs-hidden');
    }
    /**
   * Update button label when rate changed
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ratechange
   */ updateLabel(event) {
        if (this.playbackRateSupported()) this.labelEl_.textContent = this.player().playbackRate() + 'x';
    }
}
/**
 * The text that should display over the `PlaybackRateMenuButton`s controls.
 *
 * Added for localization.
 *
 * @type {string}
 * @protected
 */ $86defbb4e95ebb07$var$PlaybackRateMenuButton.prototype.controlText_ = 'Playback Rate';
$86defbb4e95ebb07$var$Component$1.registerComponent('PlaybackRateMenuButton', $86defbb4e95ebb07$var$PlaybackRateMenuButton);
/**
 * @file spacer.js
 */ /**
 * Just an empty spacer element that can be used as an append point for plugins, etc.
 * Also can be used to create space between elements when necessary.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$Spacer extends $86defbb4e95ebb07$var$Component$1 {
    /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */ buildCSSClass() {
        return `vjs-spacer ${super.buildCSSClass()}`;
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl(tag = 'div', props = {}, attributes = {}) {
        if (!props.className) props.className = this.buildCSSClass();
        return super.createEl(tag, props, attributes);
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('Spacer', $86defbb4e95ebb07$var$Spacer);
/**
 * @file custom-control-spacer.js
 */ /**
 * Spacer specifically meant to be used as an insertion point for new plugins, etc.
 *
 * @extends Spacer
 */ class $86defbb4e95ebb07$var$CustomControlSpacer extends $86defbb4e95ebb07$var$Spacer {
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-custom-control-spacer ${super.buildCSSClass()}`;
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: this.buildCSSClass(),
            // No-flex/table-cell mode requires there be some content
            // in the cell to fill the remaining space of the table.
            textContent: '\u00a0'
        });
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('CustomControlSpacer', $86defbb4e95ebb07$var$CustomControlSpacer);
/**
 * @file control-bar.js
 */ /**
 * Container of main controls.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$ControlBar extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-control-bar',
            dir: 'ltr'
        });
    }
}
/**
 * Default options for `ControlBar`
 *
 * @type {Object}
 * @private
 */ $86defbb4e95ebb07$var$ControlBar.prototype.options_ = {
    children: [
        'playToggle',
        'skipBackward',
        'skipForward',
        'volumePanel',
        'currentTimeDisplay',
        'timeDivider',
        'durationDisplay',
        'progressControl',
        'liveDisplay',
        'seekToLive',
        'remainingTimeDisplay',
        'customControlSpacer',
        'playbackRateMenuButton',
        'chaptersButton',
        'descriptionsButton',
        'subsCapsButton',
        'audioTrackButton',
        'pictureInPictureToggle',
        'fullscreenToggle'
    ]
};
$86defbb4e95ebb07$var$Component$1.registerComponent('ControlBar', $86defbb4e95ebb07$var$ControlBar);
/**
 * @file error-display.js
 */ /** @import Player from './player' */ /**
 * A display that indicates an error has occurred. This means that the video
 * is unplayable.
 *
 * @extends ModalDialog
 */ class $86defbb4e95ebb07$var$ErrorDisplay extends $86defbb4e95ebb07$var$ModalDialog {
    /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.on(player, 'error', (e)=>{
            this.open(e);
        });
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   *
   * @deprecated Since version 5.
   */ buildCSSClass() {
        return `vjs-error-display ${super.buildCSSClass()}`;
    }
    /**
   * Gets the localized error message based on the `Player`s error.
   *
   * @return {string}
   *         The `Player`s error message localized or an empty string.
   */ content() {
        const error = this.player().error();
        return error ? this.localize(error.message) : '';
    }
}
/**
 * The default options for an `ErrorDisplay`.
 *
 * @private
 */ $86defbb4e95ebb07$var$ErrorDisplay.prototype.options_ = Object.assign({}, $86defbb4e95ebb07$var$ModalDialog.prototype.options_, {
    pauseOnOpen: false,
    fillAlways: true,
    temporary: false,
    uncloseable: true
});
$86defbb4e95ebb07$var$Component$1.registerComponent('ErrorDisplay', $86defbb4e95ebb07$var$ErrorDisplay);
/** @import Player from '../player' */ /** @import { ContentDescriptor } from  '../utils/dom' */ /**
 * Creates DOM element of 'select' & its options.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$TextTrackSelect extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements.
   */ constructor(player, options = {}){
        super(player, options);
        this.el_.setAttribute('aria-labelledby', this.selectLabelledbyIds);
    }
    /**
   * Create the `TextTrackSelect`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        this.selectLabelledbyIds = [
            this.options_.legendId,
            this.options_.labelId
        ].join(' ').trim();
        // Create select & inner options
        const selectoptions = $86defbb4e95ebb07$var$createEl('select', {
            id: this.options_.id
        }, {}, this.options_.SelectOptions.map((optionText)=>{
            // Constructs an id for the <option>.
            // For the colour settings that have two <selects> with a <label> each, generates an id based off the label value
            // For font size/family and edge style with one <select> and no <label>, generates an id with a guid
            const optionId = (this.options_.labelId ? this.options_.labelId : `vjs-track-option-${$86defbb4e95ebb07$var$newGUID()}`) + '-' + optionText[1].replace(/\W+/g, '');
            const option = $86defbb4e95ebb07$var$createEl('option', {
                id: optionId,
                value: this.localize(optionText[0]),
                textContent: this.localize(optionText[1])
            });
            option.setAttribute('aria-labelledby', `${this.selectLabelledbyIds} ${optionId}`);
            return option;
        }));
        return selectoptions;
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TextTrackSelect', $86defbb4e95ebb07$var$TextTrackSelect);
/** @import Player from '../player' */ /** @import { ContentDescriptor } from '../utils/dom' */ /**
 * Creates fieldset section of 'TextTrackSettings'.
 * Manganes two versions of fieldsets, one for type of 'colors'
 * & the other for 'font', Component adds diferent DOM elements
 * to that fieldset  depending on the type.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$TextTrackFieldset extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.legendText]
   *        A text to use as the text content of the legend element.
   *
   * @param {Array} [options.selects]
   *        Array that contains the selects that are use to create 'selects'
   *        components.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements, it passes to 'TextTrackSelect'.
   *
   * @param {string} [options.type]
   *        Conditions if some DOM elements will be added to the fieldset
   *        component.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the selects configurations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        These properties are use to configure the 'TextTrackSelect' Component.
   */ constructor(player, options = {}){
        super(player, options);
        // Add Components & DOM Elements
        const legendElement = $86defbb4e95ebb07$var$createEl('legend', {
            textContent: this.localize(this.options_.legendText),
            id: this.options_.legendId
        });
        this.el().appendChild(legendElement);
        const selects = this.options_.selects;
        // Iterate array of selects to create 'selects' components
        for (const i of selects){
            const selectConfig = this.options_.selectConfigs[i];
            const selectClassName = selectConfig.className;
            const id = selectConfig.id.replace('%s', this.options_.id_);
            let span = null;
            const guid = `vjs_select_${$86defbb4e95ebb07$var$newGUID()}`;
            // Conditionally create span to add on the component
            if (this.options_.type === 'colors') {
                span = $86defbb4e95ebb07$var$createEl('span', {
                    className: selectClassName
                });
                const label = $86defbb4e95ebb07$var$createEl('label', {
                    id: id,
                    className: 'vjs-label',
                    textContent: this.localize(selectConfig.label)
                });
                label.setAttribute('for', guid);
                span.appendChild(label);
            }
            const textTrackSelect = new $86defbb4e95ebb07$var$TextTrackSelect(player, {
                SelectOptions: selectConfig.options,
                legendId: this.options_.legendId,
                id: guid,
                labelId: id
            });
            this.addChild(textTrackSelect);
            // Conditionally append to 'select' component to conditionally created span
            if (this.options_.type === 'colors') {
                span.appendChild(textTrackSelect.el());
                this.el().appendChild(span);
            }
        }
    }
    /**
   * Create the `TextTrackFieldset`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        const el = $86defbb4e95ebb07$var$createEl('fieldset', {
            // Prefixing classes of elements within a player with "vjs-"
            // is a convention used in Video.js.
            className: this.options_.className
        });
        return el;
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TextTrackFieldset', $86defbb4e95ebb07$var$TextTrackFieldset);
/** @import Player from '../player' */ /** @import { ContentDescriptor } from  '../utils/dom' */ /**
 * The component 'TextTrackSettingsColors' displays a set of 'fieldsets'
 * using the component 'TextTrackFieldset'.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$TextTrackSettingsColors extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */ constructor(player, options = {}){
        super(player, options);
        const id_ = this.options_.textTrackComponentid;
        // createElFgColor_
        const ElFgColorFieldset = new $86defbb4e95ebb07$var$TextTrackFieldset(player, {
            id_: id_,
            legendId: `captions-text-legend-${id_}`,
            legendText: this.localize('Text'),
            className: 'vjs-fg vjs-track-setting',
            selects: this.options_.fieldSets[0],
            selectConfigs: this.options_.selectConfigs,
            type: 'colors'
        });
        this.addChild(ElFgColorFieldset);
        // createElBgColor_
        const ElBgColorFieldset = new $86defbb4e95ebb07$var$TextTrackFieldset(player, {
            id_: id_,
            legendId: `captions-background-${id_}`,
            legendText: this.localize('Text Background'),
            className: 'vjs-bg vjs-track-setting',
            selects: this.options_.fieldSets[1],
            selectConfigs: this.options_.selectConfigs,
            type: 'colors'
        });
        this.addChild(ElBgColorFieldset);
        // createElWinColor_
        const ElWinColorFieldset = new $86defbb4e95ebb07$var$TextTrackFieldset(player, {
            id_: id_,
            legendId: `captions-window-${id_}`,
            legendText: this.localize('Caption Area Background'),
            className: 'vjs-window vjs-track-setting',
            selects: this.options_.fieldSets[2],
            selectConfigs: this.options_.selectConfigs,
            type: 'colors'
        });
        this.addChild(ElWinColorFieldset);
    }
    /**
   * Create the `TextTrackSettingsColors`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        const el = $86defbb4e95ebb07$var$createEl('div', {
            className: 'vjs-track-settings-colors'
        });
        return el;
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TextTrackSettingsColors', $86defbb4e95ebb07$var$TextTrackSettingsColors);
/** @import Player from '../player' */ /** @import { ContentDescriptor } from  '../utils/dom' */ /**
 * The component 'TextTrackSettingsFont' displays a set of 'fieldsets'
 * using the component 'TextTrackFieldset'.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$TextTrackSettingsFont extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */ constructor(player, options = {}){
        super(player, options);
        const id_ = this.options_.textTrackComponentid;
        const ElFgColorFieldset = new $86defbb4e95ebb07$var$TextTrackFieldset(player, {
            id_: id_,
            legendId: `captions-font-size-${id_}`,
            legendText: 'Font Size',
            className: 'vjs-font-percent vjs-track-setting',
            selects: this.options_.fieldSets[0],
            selectConfigs: this.options_.selectConfigs,
            type: 'font'
        });
        this.addChild(ElFgColorFieldset);
        const ElBgColorFieldset = new $86defbb4e95ebb07$var$TextTrackFieldset(player, {
            id_: id_,
            legendId: `captions-edge-style-${id_}`,
            legendText: this.localize('Text Edge Style'),
            className: 'vjs-edge-style vjs-track-setting',
            selects: this.options_.fieldSets[1],
            selectConfigs: this.options_.selectConfigs,
            type: 'font'
        });
        this.addChild(ElBgColorFieldset);
        const ElWinColorFieldset = new $86defbb4e95ebb07$var$TextTrackFieldset(player, {
            id_: id_,
            legendId: `captions-font-family-${id_}`,
            legendText: this.localize('Font Family'),
            className: 'vjs-font-family vjs-track-setting',
            selects: this.options_.fieldSets[2],
            selectConfigs: this.options_.selectConfigs,
            type: 'font'
        });
        this.addChild(ElWinColorFieldset);
    }
    /**
   * Create the `TextTrackSettingsFont`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        const el = $86defbb4e95ebb07$var$createEl('div', {
            className: 'vjs-track-settings-font'
        });
        return el;
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TextTrackSettingsFont', $86defbb4e95ebb07$var$TextTrackSettingsFont);
/**
 * Buttons of reset & done that modal 'TextTrackSettings'
 * uses as part of its content.
 *
 * 'Reset': Resets all settings on 'TextTrackSettings'.
 * 'Done': Closes 'TextTrackSettings' modal.
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$TrackSettingsControls extends $86defbb4e95ebb07$var$Component$1 {
    constructor(player, options = {}){
        super(player, options);
        // Create DOM elements
        const resetButton = new $86defbb4e95ebb07$var$Button(player, {
            controlText: this.localize('restore all settings to the default values'),
            className: 'vjs-default-button'
        });
        resetButton.el().classList.remove('vjs-control', 'vjs-button');
        resetButton.el().textContent = this.localize('Reset');
        this.addChild(resetButton);
        const doneText = this.localize('Done');
        const doneButton = new $86defbb4e95ebb07$var$Button(player, {
            controlText: doneText,
            className: 'vjs-done-button'
        });
        // Remove unrequired style classes
        doneButton.el().classList.remove('vjs-control', 'vjs-button');
        doneButton.el().textContent = doneText;
        this.addChild(doneButton);
    }
    /**
   * Create the `TrackSettingsControls`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        const el = $86defbb4e95ebb07$var$createEl('div', {
            className: 'vjs-track-settings-controls'
        });
        return el;
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TrackSettingsControls', $86defbb4e95ebb07$var$TrackSettingsControls);
/**
 * @file text-track-settings.js
 */ /** @import Player from '../player' */ const $86defbb4e95ebb07$var$LOCAL_STORAGE_KEY$1 = 'vjs-text-track-settings';
const $86defbb4e95ebb07$var$COLOR_BLACK = [
    '#000',
    'Black'
];
const $86defbb4e95ebb07$var$COLOR_BLUE = [
    '#00F',
    'Blue'
];
const $86defbb4e95ebb07$var$COLOR_CYAN = [
    '#0FF',
    'Cyan'
];
const $86defbb4e95ebb07$var$COLOR_GREEN = [
    '#0F0',
    'Green'
];
const $86defbb4e95ebb07$var$COLOR_MAGENTA = [
    '#F0F',
    'Magenta'
];
const $86defbb4e95ebb07$var$COLOR_RED = [
    '#F00',
    'Red'
];
const $86defbb4e95ebb07$var$COLOR_WHITE = [
    '#FFF',
    'White'
];
const $86defbb4e95ebb07$var$COLOR_YELLOW = [
    '#FF0',
    'Yellow'
];
const $86defbb4e95ebb07$var$OPACITY_OPAQUE = [
    '1',
    'Opaque'
];
const $86defbb4e95ebb07$var$OPACITY_SEMI = [
    '0.5',
    'Semi-Transparent'
];
const $86defbb4e95ebb07$var$OPACITY_TRANS = [
    '0',
    'Transparent'
];
// Configuration for the various <select> elements in the DOM of this component.
//
// Possible keys include:
//
// `default`:
//   The default option index. Only needs to be provided if not zero.
// `parser`:
//   A function which is used to parse the value from the selected option in
//   a customized way.
// `selector`:
//   The selector used to find the associated <select> element.
const $86defbb4e95ebb07$var$selectConfigs = {
    backgroundColor: {
        selector: '.vjs-bg-color > select',
        id: 'captions-background-color-%s',
        label: 'Color',
        options: [
            $86defbb4e95ebb07$var$COLOR_BLACK,
            $86defbb4e95ebb07$var$COLOR_WHITE,
            $86defbb4e95ebb07$var$COLOR_RED,
            $86defbb4e95ebb07$var$COLOR_GREEN,
            $86defbb4e95ebb07$var$COLOR_BLUE,
            $86defbb4e95ebb07$var$COLOR_YELLOW,
            $86defbb4e95ebb07$var$COLOR_MAGENTA,
            $86defbb4e95ebb07$var$COLOR_CYAN
        ],
        className: 'vjs-bg-color'
    },
    backgroundOpacity: {
        selector: '.vjs-bg-opacity > select',
        id: 'captions-background-opacity-%s',
        label: 'Opacity',
        options: [
            $86defbb4e95ebb07$var$OPACITY_OPAQUE,
            $86defbb4e95ebb07$var$OPACITY_SEMI,
            $86defbb4e95ebb07$var$OPACITY_TRANS
        ],
        className: 'vjs-bg-opacity vjs-opacity'
    },
    color: {
        selector: '.vjs-text-color > select',
        id: 'captions-foreground-color-%s',
        label: 'Color',
        options: [
            $86defbb4e95ebb07$var$COLOR_WHITE,
            $86defbb4e95ebb07$var$COLOR_BLACK,
            $86defbb4e95ebb07$var$COLOR_RED,
            $86defbb4e95ebb07$var$COLOR_GREEN,
            $86defbb4e95ebb07$var$COLOR_BLUE,
            $86defbb4e95ebb07$var$COLOR_YELLOW,
            $86defbb4e95ebb07$var$COLOR_MAGENTA,
            $86defbb4e95ebb07$var$COLOR_CYAN
        ],
        className: 'vjs-text-color'
    },
    edgeStyle: {
        selector: '.vjs-edge-style > select',
        id: '',
        label: 'Text Edge Style',
        options: [
            [
                'none',
                'None'
            ],
            [
                'raised',
                'Raised'
            ],
            [
                'depressed',
                'Depressed'
            ],
            [
                'uniform',
                'Uniform'
            ],
            [
                'dropshadow',
                'Drop shadow'
            ]
        ]
    },
    fontFamily: {
        selector: '.vjs-font-family > select',
        id: '',
        label: 'Font Family',
        options: [
            [
                'proportionalSansSerif',
                'Proportional Sans-Serif'
            ],
            [
                'monospaceSansSerif',
                'Monospace Sans-Serif'
            ],
            [
                'proportionalSerif',
                'Proportional Serif'
            ],
            [
                'monospaceSerif',
                'Monospace Serif'
            ],
            [
                'casual',
                'Casual'
            ],
            [
                'script',
                'Script'
            ],
            [
                'small-caps',
                'Small Caps'
            ]
        ]
    },
    fontPercent: {
        selector: '.vjs-font-percent > select',
        id: '',
        label: 'Font Size',
        options: [
            [
                '0.50',
                '50%'
            ],
            [
                '0.75',
                '75%'
            ],
            [
                '1.00',
                '100%'
            ],
            [
                '1.25',
                '125%'
            ],
            [
                '1.50',
                '150%'
            ],
            [
                '1.75',
                '175%'
            ],
            [
                '2.00',
                '200%'
            ],
            [
                '3.00',
                '300%'
            ],
            [
                '4.00',
                '400%'
            ]
        ],
        default: 2,
        parser: (v)=>v === '1.00' ? null : Number(v)
    },
    textOpacity: {
        selector: '.vjs-text-opacity > select',
        id: 'captions-foreground-opacity-%s',
        label: 'Opacity',
        options: [
            $86defbb4e95ebb07$var$OPACITY_OPAQUE,
            $86defbb4e95ebb07$var$OPACITY_SEMI
        ],
        className: 'vjs-text-opacity vjs-opacity'
    },
    // Options for this object are defined below.
    windowColor: {
        selector: '.vjs-window-color > select',
        id: 'captions-window-color-%s',
        label: 'Color',
        className: 'vjs-window-color'
    },
    // Options for this object are defined below.
    windowOpacity: {
        selector: '.vjs-window-opacity > select',
        id: 'captions-window-opacity-%s',
        label: 'Opacity',
        options: [
            $86defbb4e95ebb07$var$OPACITY_TRANS,
            $86defbb4e95ebb07$var$OPACITY_SEMI,
            $86defbb4e95ebb07$var$OPACITY_OPAQUE
        ],
        className: 'vjs-window-opacity vjs-opacity'
    }
};
$86defbb4e95ebb07$var$selectConfigs.windowColor.options = $86defbb4e95ebb07$var$selectConfigs.backgroundColor.options;
/**
 * Get the actual value of an option.
 *
 * @param  {string} value
 *         The value to get
 *
 * @param  {Function} [parser]
 *         Optional function to adjust the value.
 *
 * @return {*}
 *         - Will be `undefined` if no value exists
 *         - Will be `undefined` if the given value is "none".
 *         - Will be the actual value otherwise.
 *
 * @private
 */ function $86defbb4e95ebb07$var$parseOptionValue(value, parser) {
    if (parser) value = parser(value);
    if (value && value !== 'none') return value;
}
/**
 * Gets the value of the selected <option> element within a <select> element.
 *
 * @param  {Element} el
 *         the element to look in
 *
 * @param  {Function} [parser]
 *         Optional function to adjust the value.
 *
 * @return {*}
 *         - Will be `undefined` if no value exists
 *         - Will be `undefined` if the given value is "none".
 *         - Will be the actual value otherwise.
 *
 * @private
 */ function $86defbb4e95ebb07$var$getSelectedOptionValue(el, parser) {
    const value = el.options[el.options.selectedIndex].value;
    return $86defbb4e95ebb07$var$parseOptionValue(value, parser);
}
/**
 * Sets the selected <option> element within a <select> element based on a
 * given value.
 *
 * @param {Element} el
 *        The element to look in.
 *
 * @param {string} value
 *        the property to look on.
 *
 * @param {Function} [parser]
 *        Optional function to adjust the value before comparing.
 *
 * @private
 */ function $86defbb4e95ebb07$var$setSelectedOption(el, value, parser) {
    if (!value) return;
    for(let i = 0; i < el.options.length; i++)if ($86defbb4e95ebb07$var$parseOptionValue(el.options[i].value, parser) === value) {
        el.selectedIndex = i;
        break;
    }
}
/**
 * Manipulate Text Tracks settings.
 *
 * @extends ModalDialog
 */ class $86defbb4e95ebb07$var$TextTrackSettings extends $86defbb4e95ebb07$var$ModalDialog {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *         The key/value store of player options.
   */ constructor(player, options){
        options.temporary = false;
        super(player, options);
        this.updateDisplay = this.updateDisplay.bind(this);
        // fill the modal and pretend we have opened it
        this.fill();
        this.hasBeenOpened_ = this.hasBeenFilled_ = true;
        this.renderModalComponents(player);
        this.endDialog = $86defbb4e95ebb07$var$createEl('p', {
            className: 'vjs-control-text',
            textContent: this.localize('End of dialog window.')
        });
        this.el().appendChild(this.endDialog);
        this.setDefaults();
        // Grab `persistTextTrackSettings` from the player options if not passed in child options
        if (options.persistTextTrackSettings === undefined) this.options_.persistTextTrackSettings = this.options_.playerOptions.persistTextTrackSettings;
        this.bindFunctionsToSelectsAndButtons();
        if (this.options_.persistTextTrackSettings) this.restoreSettings();
    }
    renderModalComponents(player) {
        const textTrackSettingsColors = new $86defbb4e95ebb07$var$TextTrackSettingsColors(player, {
            textTrackComponentid: this.id_,
            selectConfigs: $86defbb4e95ebb07$var$selectConfigs,
            fieldSets: [
                [
                    'color',
                    'textOpacity'
                ],
                [
                    'backgroundColor',
                    'backgroundOpacity'
                ],
                [
                    'windowColor',
                    'windowOpacity'
                ]
            ]
        });
        this.addChild(textTrackSettingsColors);
        const textTrackSettingsFont = new $86defbb4e95ebb07$var$TextTrackSettingsFont(player, {
            textTrackComponentid: this.id_,
            selectConfigs: $86defbb4e95ebb07$var$selectConfigs,
            fieldSets: [
                [
                    'fontPercent'
                ],
                [
                    'edgeStyle'
                ],
                [
                    'fontFamily'
                ]
            ]
        });
        this.addChild(textTrackSettingsFont);
        const trackSettingsControls = new $86defbb4e95ebb07$var$TrackSettingsControls(player);
        this.addChild(trackSettingsControls);
    }
    bindFunctionsToSelectsAndButtons() {
        this.on(this.$('.vjs-done-button'), [
            'click',
            'tap'
        ], ()=>{
            this.saveSettings();
            this.close();
        });
        this.on(this.$('.vjs-default-button'), [
            'click',
            'tap'
        ], ()=>{
            this.setDefaults();
            this.updateDisplay();
        });
        $86defbb4e95ebb07$var$each($86defbb4e95ebb07$var$selectConfigs, (config)=>{
            this.on(this.$(config.selector), 'change', this.updateDisplay);
        });
    }
    dispose() {
        this.endDialog = null;
        super.dispose();
    }
    label() {
        return this.localize('Caption Settings Dialog');
    }
    description() {
        return this.localize('Beginning of dialog window. Escape will cancel and close the window.');
    }
    buildCSSClass() {
        return super.buildCSSClass() + ' vjs-text-track-settings';
    }
    /**
   * Gets an object of text track settings (or null).
   *
   * @return {Object}
   *         An object with config values parsed from the DOM or localStorage.
   */ getValues() {
        return $86defbb4e95ebb07$var$reduce($86defbb4e95ebb07$var$selectConfigs, (accum, config, key)=>{
            const value = $86defbb4e95ebb07$var$getSelectedOptionValue(this.$(config.selector), config.parser);
            if (value !== undefined) accum[key] = value;
            return accum;
        }, {});
    }
    /**
   * Sets text track settings from an object of values.
   *
   * @param {Object} values
   *        An object with config values parsed from the DOM or localStorage.
   */ setValues(values) {
        $86defbb4e95ebb07$var$each($86defbb4e95ebb07$var$selectConfigs, (config, key)=>{
            $86defbb4e95ebb07$var$setSelectedOption(this.$(config.selector), values[key], config.parser);
        });
    }
    /**
   * Sets all `<select>` elements to their default values.
   */ setDefaults() {
        $86defbb4e95ebb07$var$each($86defbb4e95ebb07$var$selectConfigs, (config)=>{
            const index = config.hasOwnProperty('default') ? config.default : 0;
            this.$(config.selector).selectedIndex = index;
        });
    }
    /**
   * Restore texttrack settings from localStorage
   */ restoreSettings() {
        let values;
        try {
            values = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).localStorage.getItem($86defbb4e95ebb07$var$LOCAL_STORAGE_KEY$1));
        } catch (err) {
            $86defbb4e95ebb07$var$log$1.warn(err);
        }
        if (values) this.setValues(values);
    }
    /**
   * Save text track settings to localStorage
   */ saveSettings() {
        if (!this.options_.persistTextTrackSettings) return;
        const values = this.getValues();
        try {
            if (Object.keys(values).length) (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).localStorage.setItem($86defbb4e95ebb07$var$LOCAL_STORAGE_KEY$1, JSON.stringify(values));
            else (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).localStorage.removeItem($86defbb4e95ebb07$var$LOCAL_STORAGE_KEY$1);
        } catch (err) {
            $86defbb4e95ebb07$var$log$1.warn(err);
        }
    }
    /**
   * Update display of text track settings
   */ updateDisplay() {
        const ttDisplay = this.player_.getChild('textTrackDisplay');
        if (ttDisplay) ttDisplay.updateDisplay();
    }
    /**
   * Repopulate dialog with new localizations on languagechange
   */ handleLanguagechange() {
        this.fill();
        this.renderModalComponents(this.player_);
        this.bindFunctionsToSelectsAndButtons();
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TextTrackSettings', $86defbb4e95ebb07$var$TextTrackSettings);
/**
 * @file resize-manager.js
 */ /**
 * A Resize Manager. It is in charge of triggering `playerresize` on the player in the right conditions.
 *
 * It'll either create an iframe and use a debounced resize handler on it or use the new {@link https://wicg.github.io/ResizeObserver/|ResizeObserver}.
 *
 * If the ResizeObserver is available natively, it will be used. A polyfill can be passed in as an option.
 * If a `playerresize` event is not needed, the ResizeManager component can be removed from the player, see the example below.
 *
 * @example <caption>How to disable the resize manager</caption>
 * const player = videojs('#vid', {
 *   resizeManager: false
 * });
 *
 * @see {@link https://wicg.github.io/ResizeObserver/|ResizeObserver specification}
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$ResizeManager extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Create the ResizeManager.
   *
   * @param {Object} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of ResizeManager options.
   *
   * @param {Object} [options.ResizeObserver]
   *        A polyfill for ResizeObserver can be passed in here.
   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
   */ constructor(player, options){
        let RESIZE_OBSERVER_AVAILABLE = options.ResizeObserver || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).ResizeObserver;
        // if `null` was passed, we want to disable the ResizeObserver
        if (options.ResizeObserver === null) RESIZE_OBSERVER_AVAILABLE = false;
        // Only create an element when ResizeObserver isn't available
        const options_ = $86defbb4e95ebb07$var$merge$1({
            createEl: !RESIZE_OBSERVER_AVAILABLE,
            reportTouchActivity: false
        }, options);
        super(player, options_);
        this.ResizeObserver = options.ResizeObserver || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).ResizeObserver;
        this.loadListener_ = null;
        this.resizeObserver_ = null;
        this.debouncedHandler_ = $86defbb4e95ebb07$var$debounce$1(()=>{
            this.resizeHandler();
        }, 100, false, this);
        if (RESIZE_OBSERVER_AVAILABLE) {
            this.resizeObserver_ = new this.ResizeObserver(this.debouncedHandler_);
            this.resizeObserver_.observe(player.el());
        } else {
            this.loadListener_ = ()=>{
                if (!this.el_ || !this.el_.contentWindow) return;
                const debouncedHandler_ = this.debouncedHandler_;
                let unloadListener_ = this.unloadListener_ = function() {
                    $86defbb4e95ebb07$var$off(this, 'resize', debouncedHandler_);
                    $86defbb4e95ebb07$var$off(this, 'unload', unloadListener_);
                    unloadListener_ = null;
                };
                // safari and edge can unload the iframe before resizemanager dispose
                // we have to dispose of event handlers correctly before that happens
                $86defbb4e95ebb07$var$on(this.el_.contentWindow, 'unload', unloadListener_);
                $86defbb4e95ebb07$var$on(this.el_.contentWindow, 'resize', debouncedHandler_);
            };
            this.one('load', this.loadListener_);
        }
    }
    createEl() {
        return super.createEl('iframe', {
            className: 'vjs-resize-manager',
            tabIndex: -1,
            title: this.localize('No content')
        }, {
            'aria-hidden': 'true'
        });
    }
    /**
   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
   *
   * @fires Player#playerresize
   */ resizeHandler() {
        /**
     * Called when the player size has changed
     *
     * @event Player#playerresize
     * @type {Event}
     */ // make sure player is still around to trigger
        // prevents this from causing an error after dispose
        if (!this.player_ || !this.player_.trigger) return;
        this.player_.trigger('playerresize');
    }
    dispose() {
        if (this.debouncedHandler_) this.debouncedHandler_.cancel();
        if (this.resizeObserver_) {
            if (this.player_.el()) this.resizeObserver_.unobserve(this.player_.el());
            this.resizeObserver_.disconnect();
        }
        if (this.loadListener_) this.off('load', this.loadListener_);
        if (this.el_ && this.el_.contentWindow && this.unloadListener_) this.unloadListener_.call(this.el_.contentWindow);
        this.ResizeObserver = null;
        this.resizeObserver = null;
        this.debouncedHandler_ = null;
        this.loadListener_ = null;
        super.dispose();
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('ResizeManager', $86defbb4e95ebb07$var$ResizeManager);
/** @import Player from './player' */ const $86defbb4e95ebb07$var$defaults$1 = {
    trackingThreshold: 20,
    liveTolerance: 15
};
/*
  track when we are at the live edge, and other helpers for live playback */ /**
 * A class for checking live current time and determining when the player
 * is at or behind the live edge.
 */ class $86defbb4e95ebb07$var$LiveTracker extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {number} [options.trackingThreshold=20]
   *        Number of seconds of live window (seekableEnd - seekableStart) that
   *        media needs to have before the liveui will be shown.
   *
   * @param {number} [options.liveTolerance=15]
   *        Number of seconds behind live that we have to be
   *        before we will be considered non-live. Note that this will only
   *        be used when playing at the live edge. This allows large seekable end
   *        changes to not effect whether we are live or not.
   */ constructor(player, options){
        // LiveTracker does not need an element
        const options_ = $86defbb4e95ebb07$var$merge$1($86defbb4e95ebb07$var$defaults$1, options, {
            createEl: false
        });
        super(player, options_);
        this.trackLiveHandler_ = ()=>this.trackLive_();
        this.handlePlay_ = (e)=>this.handlePlay(e);
        this.handleFirstTimeupdate_ = (e)=>this.handleFirstTimeupdate(e);
        this.handleSeeked_ = (e)=>this.handleSeeked(e);
        this.seekToLiveEdge_ = (e)=>this.seekToLiveEdge(e);
        this.reset_();
        this.on(this.player_, 'durationchange', (e)=>this.handleDurationchange(e));
        // we should try to toggle tracking on canplay as native playback engines, like Safari
        // may not have the proper values for things like seekableEnd until then
        this.on(this.player_, 'canplay', ()=>this.toggleTracking());
    }
    /**
   * all the functionality for tracking when seek end changes
   * and for tracking how far past seek end we should be
   */ trackLive_() {
        const seekable = this.player_.seekable();
        // skip undefined seekable
        if (!seekable || !seekable.length) return;
        const newTime = Number((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).performance.now().toFixed(4));
        const deltaTime = this.lastTime_ === -1 ? 0 : (newTime - this.lastTime_) / 1000;
        this.lastTime_ = newTime;
        this.pastSeekEnd_ = this.pastSeekEnd() + deltaTime;
        const liveCurrentTime = this.liveCurrentTime();
        const currentTime = this.player_.currentTime();
        // we are behind live if any are true
        // 1. the player is paused
        // 2. the user seeked to a location 2 seconds away from live
        // 3. the difference between live and current time is greater
        //    liveTolerance which defaults to 15s
        let isBehind = this.player_.paused() || this.seekedBehindLive_ || Math.abs(liveCurrentTime - currentTime) > this.options_.liveTolerance;
        // we cannot be behind if
        // 1. until we have not seen a timeupdate yet
        // 2. liveCurrentTime is Infinity, which happens on Android and Native Safari
        if (!this.timeupdateSeen_ || liveCurrentTime === Infinity) isBehind = false;
        if (isBehind !== this.behindLiveEdge_) {
            this.behindLiveEdge_ = isBehind;
            this.trigger('liveedgechange');
        }
    }
    /**
   * handle a durationchange event on the player
   * and start/stop tracking accordingly.
   */ handleDurationchange() {
        this.toggleTracking();
    }
    /**
   * start/stop tracking
   */ toggleTracking() {
        if (this.player_.duration() === Infinity && this.liveWindow() >= this.options_.trackingThreshold) {
            if (this.player_.options_.liveui) this.player_.addClass('vjs-liveui');
            this.startTracking();
        } else {
            this.player_.removeClass('vjs-liveui');
            this.stopTracking();
        }
    }
    /**
   * start tracking live playback
   */ startTracking() {
        if (this.isTracking()) return;
        // If we haven't seen a timeupdate, we need to check whether playback
        // began before this component started tracking. This can happen commonly
        // when using autoplay.
        if (!this.timeupdateSeen_) this.timeupdateSeen_ = this.player_.hasStarted();
        this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, $86defbb4e95ebb07$var$UPDATE_REFRESH_INTERVAL);
        this.trackLive_();
        this.on(this.player_, [
            'play',
            'pause'
        ], this.trackLiveHandler_);
        if (!this.timeupdateSeen_) {
            this.one(this.player_, 'play', this.handlePlay_);
            this.one(this.player_, 'timeupdate', this.handleFirstTimeupdate_);
        } else this.on(this.player_, 'seeked', this.handleSeeked_);
    }
    /**
   * handle the first timeupdate on the player if it wasn't already playing
   * when live tracker started tracking.
   */ handleFirstTimeupdate() {
        this.timeupdateSeen_ = true;
        this.on(this.player_, 'seeked', this.handleSeeked_);
    }
    /**
   * Keep track of what time a seek starts, and listen for seeked
   * to find where a seek ends.
   */ handleSeeked() {
        const timeDiff = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
        this.seekedBehindLive_ = this.nextSeekedFromUser_ && timeDiff > 2;
        this.nextSeekedFromUser_ = false;
        this.trackLive_();
    }
    /**
   * handle the first play on the player, and make sure that we seek
   * right to the live edge.
   */ handlePlay() {
        this.one(this.player_, 'timeupdate', this.seekToLiveEdge_);
    }
    /**
   * Stop tracking, and set all internal variables to
   * their initial value.
   */ reset_() {
        this.lastTime_ = -1;
        this.pastSeekEnd_ = 0;
        this.lastSeekEnd_ = -1;
        this.behindLiveEdge_ = true;
        this.timeupdateSeen_ = false;
        this.seekedBehindLive_ = false;
        this.nextSeekedFromUser_ = false;
        this.clearInterval(this.trackingInterval_);
        this.trackingInterval_ = null;
        this.off(this.player_, [
            'play',
            'pause'
        ], this.trackLiveHandler_);
        this.off(this.player_, 'seeked', this.handleSeeked_);
        this.off(this.player_, 'play', this.handlePlay_);
        this.off(this.player_, 'timeupdate', this.handleFirstTimeupdate_);
        this.off(this.player_, 'timeupdate', this.seekToLiveEdge_);
    }
    /**
   * The next seeked event is from the user. Meaning that any seek
   * > 2s behind live will be considered behind live for real and
   * liveTolerance will be ignored.
   */ nextSeekedFromUser() {
        this.nextSeekedFromUser_ = true;
    }
    /**
   * stop tracking live playback
   */ stopTracking() {
        if (!this.isTracking()) return;
        this.reset_();
        this.trigger('liveedgechange');
    }
    /**
   * A helper to get the player seekable end
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The furthest seekable end or Infinity.
   */ seekableEnd() {
        const seekable = this.player_.seekable();
        const seekableEnds = [];
        let i = seekable ? seekable.length : 0;
        while(i--)seekableEnds.push(seekable.end(i));
        // grab the furthest seekable end after sorting, or if there are none
        // default to Infinity
        return seekableEnds.length ? seekableEnds.sort()[seekableEnds.length - 1] : Infinity;
    }
    /**
   * A helper to get the player seekable start
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The earliest seekable start or 0.
   */ seekableStart() {
        const seekable = this.player_.seekable();
        const seekableStarts = [];
        let i = seekable ? seekable.length : 0;
        while(i--)seekableStarts.push(seekable.start(i));
        // grab the first seekable start after sorting, or if there are none
        // default to 0
        return seekableStarts.length ? seekableStarts.sort()[0] : 0;
    }
    /**
   * Get the live time window aka
   * the amount of time between seekable start and
   * live current time.
   *
   * @return {number}
   *         The amount of seconds that are seekable in
   *         the live video.
   */ liveWindow() {
        const liveCurrentTime = this.liveCurrentTime();
        // if liveCurrenTime is Infinity then we don't have a liveWindow at all
        if (liveCurrentTime === Infinity) return 0;
        return liveCurrentTime - this.seekableStart();
    }
    /**
   * Determines if the player is live, only checks if this component
   * is tracking live playback or not
   *
   * @return {boolean}
   *         Whether liveTracker is tracking
   */ isLive() {
        return this.isTracking();
    }
    /**
   * Determines if currentTime is at the live edge and won't fall behind
   * on each seekableendchange
   *
   * @return {boolean}
   *         Whether playback is at the live edge
   */ atLiveEdge() {
        return !this.behindLiveEdge();
    }
    /**
   * get what we expect the live current time to be
   *
   * @return {number}
   *         The expected live current time
   */ liveCurrentTime() {
        return this.pastSeekEnd() + this.seekableEnd();
    }
    /**
   * The number of seconds that have occurred after seekable end
   * changed. This will be reset to 0 once seekable end changes.
   *
   * @return {number}
   *         Seconds past the current seekable end
   */ pastSeekEnd() {
        const seekableEnd = this.seekableEnd();
        if (this.lastSeekEnd_ !== -1 && seekableEnd !== this.lastSeekEnd_) this.pastSeekEnd_ = 0;
        this.lastSeekEnd_ = seekableEnd;
        return this.pastSeekEnd_;
    }
    /**
   * If we are currently behind the live edge, aka currentTime will be
   * behind on a seekableendchange
   *
   * @return {boolean}
   *         If we are behind the live edge
   */ behindLiveEdge() {
        return this.behindLiveEdge_;
    }
    /**
   * Whether live tracker is currently tracking or not.
   */ isTracking() {
        return typeof this.trackingInterval_ === 'number';
    }
    /**
   * Seek to the live edge if we are behind the live edge
   */ seekToLiveEdge() {
        this.seekedBehindLive_ = false;
        if (this.atLiveEdge()) return;
        this.nextSeekedFromUser_ = false;
        this.player_.currentTime(this.liveCurrentTime());
    }
    /**
   * Dispose of liveTracker
   */ dispose() {
        this.stopTracking();
        super.dispose();
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('LiveTracker', $86defbb4e95ebb07$var$LiveTracker);
/**
 * Displays an element over the player which contains an optional title and
 * description for the current content.
 *
 * Much of the code for this component originated in the now obsolete
 * videojs-dock plugin: https://github.com/brightcove/videojs-dock/
 *
 * @extends Component
 */ class $86defbb4e95ebb07$var$TitleBar extends $86defbb4e95ebb07$var$Component$1 {
    constructor(player, options){
        super(player, options);
        this.on('statechanged', (e)=>this.updateDom_());
        this.updateDom_();
    }
    /**
   * Create the `TitleBar`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        this.els = {
            title: $86defbb4e95ebb07$var$createEl('div', {
                className: 'vjs-title-bar-title',
                id: `vjs-title-bar-title-${$86defbb4e95ebb07$var$newGUID()}`
            }),
            description: $86defbb4e95ebb07$var$createEl('div', {
                className: 'vjs-title-bar-description',
                id: `vjs-title-bar-description-${$86defbb4e95ebb07$var$newGUID()}`
            })
        };
        return $86defbb4e95ebb07$var$createEl('div', {
            className: 'vjs-title-bar'
        }, {}, $86defbb4e95ebb07$var$values(this.els));
    }
    /**
   * Updates the DOM based on the component's state object.
   */ updateDom_() {
        const tech = this.player_.tech_;
        const techEl = tech && tech.el_;
        const techAriaAttrs = {
            title: 'aria-labelledby',
            description: 'aria-describedby'
        };
        [
            'title',
            'description'
        ].forEach((k)=>{
            const value = this.state[k];
            const el = this.els[k];
            const techAriaAttr = techAriaAttrs[k];
            $86defbb4e95ebb07$var$emptyEl(el);
            if (value) $86defbb4e95ebb07$var$textContent(el, value);
            // If there is a tech element available, update its ARIA attributes
            // according to whether a title and/or description have been provided.
            if (techEl) {
                techEl.removeAttribute(techAriaAttr);
                if (value) techEl.setAttribute(techAriaAttr, el.id);
            }
        });
        if (this.state.title || this.state.description) this.show();
        else this.hide();
    }
    /**
   * Update the contents of the title bar component with new title and
   * description text.
   *
   * If both title and description are missing, the title bar will be hidden.
   *
   * If either title or description are present, the title bar will be visible.
   *
   * NOTE: Any previously set value will be preserved. To unset a previously
   * set value, you must pass an empty string or null.
   *
   * For example:
   *
   * ```
   * update({title: 'foo', description: 'bar'}) // title: 'foo', description: 'bar'
   * update({description: 'bar2'}) // title: 'foo', description: 'bar2'
   * update({title: ''}) // title: '', description: 'bar2'
   * update({title: 'foo', description: null}) // title: 'foo', description: null
   * ```
   *
   * @param  {Object} [options={}]
   *         An options object. When empty, the title bar will be hidden.
   *
   * @param  {string} [options.title]
   *         A title to display in the title bar.
   *
   * @param  {string} [options.description]
   *         A description to display in the title bar.
   */ update(options) {
        this.setState(options);
    }
    /**
   * Dispose the component.
   */ dispose() {
        const tech = this.player_.tech_;
        const techEl = tech && tech.el_;
        if (techEl) {
            techEl.removeAttribute('aria-labelledby');
            techEl.removeAttribute('aria-describedby');
        }
        super.dispose();
        this.els = null;
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TitleBar', $86defbb4e95ebb07$var$TitleBar);
/** @import Player from './player' */ /**
 * @typedef {object} TransientButtonOptions
 * @property {string} [controlText] Control text, usually visible for these buttons
 * @property {number} [initialDisplay=4000] Time in ms that button should initially remain visible
 * @property {Array<'top'|'neartop'|'bottom'|'left'|'right'>} [position] Array of position strings to add basic styles for positioning
 * @property {string} [className] Class(es) to add
 * @property {boolean} [takeFocus=false] Whether element sohuld take focus when shown
 * @property {Function} [clickHandler] Function called on button activation
 */ /** @type {TransientButtonOptions} */ const $86defbb4e95ebb07$var$defaults = {
    initialDisplay: 4000,
    position: [],
    takeFocus: false
};
/**
 * A floating transient button.
 * It's recommended to insert these buttons _before_ the control bar with the this argument to `addChild`
 * for a logical tab order.
 *
 * @example
 * ```
 * player.addChild(
 *   'TransientButton',
 *   options,
 *   player.children().indexOf(player.getChild("ControlBar"))
 * )
 * ```
 *
 * @extends Button
 */ class $86defbb4e95ebb07$var$TransientButton extends $86defbb4e95ebb07$var$Button {
    /**
   * TransientButton constructor
   *
   * @param {Player} player The button's player
   * @param {TransientButtonOptions} options Options for the transient button
   */ constructor(player, options){
        options = $86defbb4e95ebb07$var$merge$1($86defbb4e95ebb07$var$defaults, options);
        super(player, options);
        this.controlText(options.controlText);
        this.hide();
        // When shown, the float button will be visible even if the user is inactive.
        // Clear this if there is any interaction.
        this.on(this.player_, [
            'useractive',
            'userinactive'
        ], (e)=>{
            this.removeClass('force-display');
        });
    }
    /**
   * Return CSS class including position classes
   *
   * @return {string} CSS class list
   */ buildCSSClass() {
        return `vjs-transient-button focus-visible ${this.options_.position.map((c)=>`vjs-${c}`).join(' ')}`;
    }
    /**
   * Create the button element
   *
   * @return {HTMLButtonElement} The button element
   */ createEl() {
        /** @type HTMLButtonElement */ const el = $86defbb4e95ebb07$var$createEl('button', {}, {
            type: 'button',
            class: this.buildCSSClass()
        }, $86defbb4e95ebb07$var$createEl('span'));
        this.controlTextEl_ = el.querySelector('span');
        return el;
    }
    /**
   * Show the button. The button will remain visible for the `initialDisplay` time, default 4s,
   * and when there is user activity.
   */ show() {
        super.show();
        this.addClass('force-display');
        if (this.options_.takeFocus) this.el().focus({
            preventScroll: true
        });
        this.forceDisplayTimeout = this.player_.setTimeout(()=>{
            this.removeClass('force-display');
        }, this.options_.initialDisplay);
    }
    /**
   * Hide the display, even if during the `initialDisplay` time.
   */ hide() {
        this.removeClass('force-display');
        super.hide();
    }
    /**
   * Dispose the component
   */ dispose() {
        this.player_.clearTimeout(this.forceDisplayTimeout);
        super.dispose();
    }
}
$86defbb4e95ebb07$var$Component$1.registerComponent('TransientButton', $86defbb4e95ebb07$var$TransientButton);
/** @import Html5 from './html5' */ /**
 * This function is used to fire a sourceset when there is something
 * similar to `mediaEl.load()` being called. It will try to find the source via
 * the `src` attribute and then the `<source>` elements. It will then fire `sourceset`
 * with the source that was found or empty string if we cannot know. If it cannot
 * find a source then `sourceset` will not be fired.
 *
 * @param {Html5} tech
 *        The tech object that sourceset was setup on
 *
 * @return {boolean}
 *         returns false if the sourceset was not fired and true otherwise.
 */ const $86defbb4e95ebb07$var$sourcesetLoad = (tech)=>{
    const el = tech.el();
    // if `el.src` is set, that source will be loaded.
    if (el.hasAttribute('src')) {
        tech.triggerSourceset(el.src);
        return true;
    }
    /**
   * Since there isn't a src property on the media element, source elements will be used for
   * implementing the source selection algorithm. This happens asynchronously and
   * for most cases were there is more than one source we cannot tell what source will
   * be loaded, without re-implementing the source selection algorithm. At this time we are not
   * going to do that. There are three special cases that we do handle here though:
   *
   * 1. If there are no sources, do not fire `sourceset`.
   * 2. If there is only one `<source>` with a `src` property/attribute that is our `src`
   * 3. If there is more than one `<source>` but all of them have the same `src` url.
   *    That will be our src.
   */ const sources = tech.$$('source');
    const srcUrls = [];
    let src = '';
    // if there are no sources, do not fire sourceset
    if (!sources.length) return false;
    // only count valid/non-duplicate source elements
    for(let i = 0; i < sources.length; i++){
        const url = sources[i].src;
        if (url && srcUrls.indexOf(url) === -1) srcUrls.push(url);
    }
    // there were no valid sources
    if (!srcUrls.length) return false;
    // there is only one valid source element url
    // use that
    if (srcUrls.length === 1) src = srcUrls[0];
    tech.triggerSourceset(src);
    return true;
};
/**
 * our implementation of an `innerHTML` descriptor for browsers
 * that do not have one.
 */ const $86defbb4e95ebb07$var$innerHTMLDescriptorPolyfill = Object.defineProperty({}, 'innerHTML', {
    get () {
        return this.cloneNode(true).innerHTML;
    },
    set (v) {
        // make a dummy node to use innerHTML on
        const dummy = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement(this.nodeName.toLowerCase());
        // set innerHTML to the value provided
        dummy.innerHTML = v;
        // make a document fragment to hold the nodes from dummy
        const docFrag = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createDocumentFragment();
        // copy all of the nodes created by the innerHTML on dummy
        // to the document fragment
        while(dummy.childNodes.length)docFrag.appendChild(dummy.childNodes[0]);
        // remove content
        this.innerText = '';
        // now we add all of that html in one by appending the
        // document fragment. This is how innerHTML does it.
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Element.prototype.appendChild.call(this, docFrag);
        // then return the result that innerHTML's setter would
        return this.innerHTML;
    }
});
/**
 * Get a property descriptor given a list of priorities and the
 * property to get.
 */ const $86defbb4e95ebb07$var$getDescriptor = (priority, prop)=>{
    let descriptor = {};
    for(let i = 0; i < priority.length; i++){
        descriptor = Object.getOwnPropertyDescriptor(priority[i], prop);
        if (descriptor && descriptor.set && descriptor.get) break;
    }
    descriptor.enumerable = true;
    descriptor.configurable = true;
    return descriptor;
};
const $86defbb4e95ebb07$var$getInnerHTMLDescriptor = (tech)=>$86defbb4e95ebb07$var$getDescriptor([
        tech.el(),
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).HTMLMediaElement.prototype,
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Element.prototype,
        $86defbb4e95ebb07$var$innerHTMLDescriptorPolyfill
    ], 'innerHTML');
/**
 * Patches browser internal functions so that we can tell synchronously
 * if a `<source>` was appended to the media element. For some reason this
 * causes a `sourceset` if the the media element is ready and has no source.
 * This happens when:
 * - The page has just loaded and the media element does not have a source.
 * - The media element was emptied of all sources, then `load()` was called.
 *
 * It does this by patching the following functions/properties when they are supported:
 *
 * - `append()` - can be used to add a `<source>` element to the media element
 * - `appendChild()` - can be used to add a `<source>` element to the media element
 * - `insertAdjacentHTML()` -  can be used to add a `<source>` element to the media element
 * - `innerHTML` -  can be used to add a `<source>` element to the media element
 *
 * @param {Html5} tech
 *        The tech object that sourceset is being setup on.
 */ const $86defbb4e95ebb07$var$firstSourceWatch = function(tech) {
    const el = tech.el();
    // make sure firstSourceWatch isn't setup twice.
    if (el.resetSourceWatch_) return;
    const old = {};
    const innerDescriptor = $86defbb4e95ebb07$var$getInnerHTMLDescriptor(tech);
    const appendWrapper = (appendFn)=>(...args)=>{
            const retval = appendFn.apply(el, args);
            $86defbb4e95ebb07$var$sourcesetLoad(tech);
            return retval;
        };
    [
        'append',
        'appendChild',
        'insertAdjacentHTML'
    ].forEach((k)=>{
        if (!el[k]) return;
        // store the old function
        old[k] = el[k];
        // call the old function with a sourceset if a source
        // was loaded
        el[k] = appendWrapper(old[k]);
    });
    Object.defineProperty(el, 'innerHTML', $86defbb4e95ebb07$var$merge$1(innerDescriptor, {
        set: appendWrapper(innerDescriptor.set)
    }));
    el.resetSourceWatch_ = ()=>{
        el.resetSourceWatch_ = null;
        Object.keys(old).forEach((k)=>{
            el[k] = old[k];
        });
        Object.defineProperty(el, 'innerHTML', innerDescriptor);
    };
    // on the first sourceset, we need to revert our changes
    tech.one('sourceset', el.resetSourceWatch_);
};
/**
 * our implementation of a `src` descriptor for browsers
 * that do not have one
 */ const $86defbb4e95ebb07$var$srcDescriptorPolyfill = Object.defineProperty({}, 'src', {
    get () {
        if (this.hasAttribute('src')) return $86defbb4e95ebb07$var$getAbsoluteURL((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Element.prototype.getAttribute.call(this, 'src'));
        return '';
    },
    set (v) {
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Element.prototype.setAttribute.call(this, 'src', v);
        return v;
    }
});
const $86defbb4e95ebb07$var$getSrcDescriptor = (tech)=>$86defbb4e95ebb07$var$getDescriptor([
        tech.el(),
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).HTMLMediaElement.prototype,
        $86defbb4e95ebb07$var$srcDescriptorPolyfill
    ], 'src');
/**
 * setup `sourceset` handling on the `Html5` tech. This function
 * patches the following element properties/functions:
 *
 * - `src` - to determine when `src` is set
 * - `setAttribute()` - to determine when `src` is set
 * - `load()` - this re-triggers the source selection algorithm, and can
 *              cause a sourceset.
 *
 * If there is no source when we are adding `sourceset` support or during a `load()`
 * we also patch the functions listed in `firstSourceWatch`.
 *
 * @param {Html5} tech
 *        The tech to patch
 */ const $86defbb4e95ebb07$var$setupSourceset = function(tech) {
    if (!tech.featuresSourceset) return;
    const el = tech.el();
    // make sure sourceset isn't setup twice.
    if (el.resetSourceset_) return;
    const srcDescriptor = $86defbb4e95ebb07$var$getSrcDescriptor(tech);
    const oldSetAttribute = el.setAttribute;
    const oldLoad = el.load;
    Object.defineProperty(el, 'src', $86defbb4e95ebb07$var$merge$1(srcDescriptor, {
        set: (v)=>{
            const retval = srcDescriptor.set.call(el, v);
            // we use the getter here to get the actual value set on src
            tech.triggerSourceset(el.src);
            return retval;
        }
    }));
    el.setAttribute = (n, v)=>{
        const retval = oldSetAttribute.call(el, n, v);
        if (/src/i.test(n)) tech.triggerSourceset(el.src);
        return retval;
    };
    el.load = ()=>{
        const retval = oldLoad.call(el);
        // if load was called, but there was no source to fire
        // sourceset on. We have to watch for a source append
        // as that can trigger a `sourceset` when the media element
        // has no source
        if (!$86defbb4e95ebb07$var$sourcesetLoad(tech)) {
            tech.triggerSourceset('');
            $86defbb4e95ebb07$var$firstSourceWatch(tech);
        }
        return retval;
    };
    if (el.currentSrc) tech.triggerSourceset(el.currentSrc);
    else if (!$86defbb4e95ebb07$var$sourcesetLoad(tech)) $86defbb4e95ebb07$var$firstSourceWatch(tech);
    el.resetSourceset_ = ()=>{
        el.resetSourceset_ = null;
        el.load = oldLoad;
        el.setAttribute = oldSetAttribute;
        Object.defineProperty(el, 'src', srcDescriptor);
        if (el.resetSourceWatch_) el.resetSourceWatch_();
    };
};
/**
 * @file html5.js
 */ /**
 * HTML5 Media Controller - Wrapper for HTML5 Media API
 *
 * @mixes Tech~SourceHandlerAdditions
 * @extends Tech
 */ class $86defbb4e95ebb07$var$Html5 extends $86defbb4e95ebb07$var$Tech {
    /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */ constructor(options, ready){
        super(options, ready);
        const source = options.source;
        let crossoriginTracks = false;
        this.featuresVideoFrameCallback = this.featuresVideoFrameCallback && this.el_.tagName === 'VIDEO';
        // Set the source if one is provided
        // 1) Check if the source is new (if not, we want to keep the original so playback isn't interrupted)
        // 2) Check to see if the network state of the tag was failed at init, and if so, reset the source
        // anyway so the error gets fired.
        if (source && (this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) this.setSource(source);
        else this.handleLateInit_(this.el_);
        // setup sourceset after late sourceset/init
        if (options.enableSourceset) this.setupSourcesetHandling_();
        this.isScrubbing_ = false;
        if (this.el_.hasChildNodes()) {
            const nodes = this.el_.childNodes;
            let nodesLength = nodes.length;
            const removeNodes = [];
            while(nodesLength--){
                const node = nodes[nodesLength];
                const nodeName = node.nodeName.toLowerCase();
                if (nodeName === 'track') {
                    if (!this.featuresNativeTextTracks) // Empty video tag tracks so the built-in player doesn't use them also.
                    // This may not be fast enough to stop HTML5 browsers from reading the tags
                    // so we'll need to turn off any default tracks if we're manually doing
                    // captions and subtitles. videoElement.textTracks
                    removeNodes.push(node);
                    else {
                        // store HTMLTrackElement and TextTrack to remote list
                        this.remoteTextTrackEls().addTrackElement_(node);
                        this.remoteTextTracks().addTrack(node.track);
                        this.textTracks().addTrack(node.track);
                        if (!crossoriginTracks && !this.el_.hasAttribute('crossorigin') && $86defbb4e95ebb07$var$isCrossOrigin(node.src)) crossoriginTracks = true;
                    }
                }
            }
            for(let i = 0; i < removeNodes.length; i++)this.el_.removeChild(removeNodes[i]);
        }
        this.proxyNativeTracks_();
        if (this.featuresNativeTextTracks && crossoriginTracks) $86defbb4e95ebb07$var$log$1.warn("Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.\nThis may prevent text tracks from loading.");
        // prevent iOS Safari from disabling metadata text tracks during native playback
        this.restoreMetadataTracksInIOSNativePlayer_();
        // Determine if native controls should be used
        // Our goal should be to get the custom controls on mobile solid everywhere
        // so we can remove this all together. Right now this will block custom
        // controls on touch enabled laptops like the Chrome Pixel
        if (($86defbb4e95ebb07$var$TOUCH_ENABLED || $86defbb4e95ebb07$var$IS_IPHONE) && options.nativeControlsForTouch === true) this.setControls(true);
        // on iOS, we want to proxy `webkitbeginfullscreen` and `webkitendfullscreen`
        // into a `fullscreenchange` event
        this.proxyWebkitFullscreen_();
        this.triggerReady();
    }
    /**
   * Dispose of `HTML5` media element and remove all tracks.
   */ dispose() {
        if (this.el_ && this.el_.resetSourceset_) this.el_.resetSourceset_();
        $86defbb4e95ebb07$var$Html5.disposeMediaElement(this.el_);
        this.options_ = null;
        // tech will handle clearing of the emulated track list
        super.dispose();
    }
    /**
   * Modify the media element so that we can detect when
   * the source is changed. Fires `sourceset` just after the source has changed
   */ setupSourcesetHandling_() {
        $86defbb4e95ebb07$var$setupSourceset(this);
    }
    /**
   * When a captions track is enabled in the iOS Safari native player, all other
   * tracks are disabled (including metadata tracks), which nulls all of their
   * associated cue points. This will restore metadata tracks to their pre-fullscreen
   * state in those cases so that cue points are not needlessly lost.
   *
   * @private
   */ restoreMetadataTracksInIOSNativePlayer_() {
        const textTracks = this.textTracks();
        let metadataTracksPreFullscreenState;
        // captures a snapshot of every metadata track's current state
        const takeMetadataTrackSnapshot = ()=>{
            metadataTracksPreFullscreenState = [];
            for(let i = 0; i < textTracks.length; i++){
                const track = textTracks[i];
                if (track.kind === 'metadata') metadataTracksPreFullscreenState.push({
                    track: track,
                    storedMode: track.mode
                });
            }
        };
        // snapshot each metadata track's initial state, and update the snapshot
        // each time there is a track 'change' event
        takeMetadataTrackSnapshot();
        textTracks.addEventListener('change', takeMetadataTrackSnapshot);
        this.on('dispose', ()=>textTracks.removeEventListener('change', takeMetadataTrackSnapshot));
        const restoreTrackMode = ()=>{
            for(let i = 0; i < metadataTracksPreFullscreenState.length; i++){
                const storedTrack = metadataTracksPreFullscreenState[i];
                if (storedTrack.track.mode === 'disabled' && storedTrack.track.mode !== storedTrack.storedMode) storedTrack.track.mode = storedTrack.storedMode;
            }
            // we only want this handler to be executed on the first 'change' event
            textTracks.removeEventListener('change', restoreTrackMode);
        };
        // when we enter fullscreen playback, stop updating the snapshot and
        // restore all track modes to their pre-fullscreen state
        this.on('webkitbeginfullscreen', ()=>{
            textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
            // remove the listener before adding it just in case it wasn't previously removed
            textTracks.removeEventListener('change', restoreTrackMode);
            textTracks.addEventListener('change', restoreTrackMode);
        });
        // start updating the snapshot again after leaving fullscreen
        this.on('webkitendfullscreen', ()=>{
            // remove the listener before adding it just in case it wasn't previously removed
            textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
            textTracks.addEventListener('change', takeMetadataTrackSnapshot);
            // remove the restoreTrackMode handler in case it wasn't triggered during fullscreen playback
            textTracks.removeEventListener('change', restoreTrackMode);
        });
    }
    /**
   * Attempt to force override of tracks for the given type
   *
   * @param {string} type - Track type to override, possible values include 'Audio',
   * 'Video', and 'Text'.
   * @param {boolean} override - If set to true native audio/video will be overridden,
   * otherwise native audio/video will potentially be used.
   * @private
   */ overrideNative_(type, override) {
        // If there is no behavioral change don't add/remove listeners
        if (override !== this[`featuresNative${type}Tracks`]) return;
        const lowerCaseType = type.toLowerCase();
        if (this[`${lowerCaseType}TracksListeners_`]) Object.keys(this[`${lowerCaseType}TracksListeners_`]).forEach((eventName)=>{
            const elTracks = this.el()[`${lowerCaseType}Tracks`];
            elTracks.removeEventListener(eventName, this[`${lowerCaseType}TracksListeners_`][eventName]);
        });
        this[`featuresNative${type}Tracks`] = !override;
        this[`${lowerCaseType}TracksListeners_`] = null;
        this.proxyNativeTracksForType_(lowerCaseType);
    }
    /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   */ overrideNativeAudioTracks(override) {
        this.overrideNative_('Audio', override);
    }
    /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   */ overrideNativeVideoTracks(override) {
        this.overrideNative_('Video', override);
    }
    /**
   * Proxy native track list events for the given type to our track
   * lists if the browser we are playing in supports that type of track list.
   *
   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
   * @private
   */ proxyNativeTracksForType_(name) {
        const props = $86defbb4e95ebb07$var$NORMAL[name];
        const elTracks = this.el()[props.getterName];
        const techTracks = this[props.getterName]();
        if (!this[`featuresNative${props.capitalName}Tracks`] || !elTracks || !elTracks.addEventListener) return;
        const listeners = {
            change: (e)=>{
                const event = {
                    type: 'change',
                    target: techTracks,
                    currentTarget: techTracks,
                    srcElement: techTracks
                };
                techTracks.trigger(event);
                // if we are a text track change event, we should also notify the
                // remote text track list. This can potentially cause a false positive
                // if we were to get a change event on a non-remote track and
                // we triggered the event on the remote text track list which doesn't
                // contain that track. However, best practices mean looping through the
                // list of tracks and searching for the appropriate mode value, so,
                // this shouldn't pose an issue
                if (name === 'text') this[$86defbb4e95ebb07$var$REMOTE.remoteText.getterName]().trigger(event);
            },
            addtrack (e) {
                techTracks.addTrack(e.track);
            },
            removetrack (e) {
                techTracks.removeTrack(e.track);
            }
        };
        const removeOldTracks = function() {
            const removeTracks = [];
            for(let i = 0; i < techTracks.length; i++){
                let found = false;
                for(let j = 0; j < elTracks.length; j++)if (elTracks[j] === techTracks[i]) {
                    found = true;
                    break;
                }
                if (!found) removeTracks.push(techTracks[i]);
            }
            while(removeTracks.length)techTracks.removeTrack(removeTracks.shift());
        };
        this[props.getterName + 'Listeners_'] = listeners;
        Object.keys(listeners).forEach((eventName)=>{
            const listener = listeners[eventName];
            elTracks.addEventListener(eventName, listener);
            this.on('dispose', (e)=>elTracks.removeEventListener(eventName, listener));
        });
        // Remove (native) tracks that are not used anymore
        this.on('loadstart', removeOldTracks);
        this.on('dispose', (e)=>this.off('loadstart', removeOldTracks));
    }
    /**
   * Proxy all native track list events to our track lists if the browser we are playing
   * in supports that type of track list.
   *
   * @private
   */ proxyNativeTracks_() {
        $86defbb4e95ebb07$var$NORMAL.names.forEach((name)=>{
            this.proxyNativeTracksForType_(name);
        });
    }
    /**
   * Create the `Html5` Tech's DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl() {
        let el = this.options_.tag;
        // Check if this browser supports moving the element into the box.
        // On the iPhone video will break if you move the element,
        // So we have to create a brand new element.
        // If we ingested the player div, we do not need to move the media element.
        if (!el || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
            // If the original tag is still there, clone and remove it.
            if (el) {
                const clone = el.cloneNode(true);
                if (el.parentNode) el.parentNode.insertBefore(clone, el);
                $86defbb4e95ebb07$var$Html5.disposeMediaElement(el);
                el = clone;
            } else {
                el = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('video');
                // determine if native controls should be used
                const tagAttributes = this.options_.tag && $86defbb4e95ebb07$var$getAttributes(this.options_.tag);
                const attributes = $86defbb4e95ebb07$var$merge$1({}, tagAttributes);
                if (!$86defbb4e95ebb07$var$TOUCH_ENABLED || this.options_.nativeControlsForTouch !== true) delete attributes.controls;
                $86defbb4e95ebb07$var$setAttributes(el, Object.assign(attributes, {
                    id: this.options_.techId,
                    class: 'vjs-tech'
                }));
            }
            el.playerId = this.options_.playerId;
        }
        if (typeof this.options_.preload !== 'undefined') $86defbb4e95ebb07$var$setAttribute(el, 'preload', this.options_.preload);
        if (this.options_.disablePictureInPicture !== undefined) el.disablePictureInPicture = this.options_.disablePictureInPicture;
        // Update specific tag settings, in case they were overridden
        // `autoplay` has to be *last* so that `muted` and `playsinline` are present
        // when iOS/Safari or other browsers attempt to autoplay.
        const settingsAttrs = [
            'loop',
            'muted',
            'playsinline',
            'autoplay'
        ];
        for(let i = 0; i < settingsAttrs.length; i++){
            const attr = settingsAttrs[i];
            const value = this.options_[attr];
            if (typeof value !== 'undefined') {
                if (value) $86defbb4e95ebb07$var$setAttribute(el, attr, attr);
                else $86defbb4e95ebb07$var$removeAttribute(el, attr);
                el[attr] = value;
            }
        }
        return el;
    }
    /**
   * This will be triggered if the loadstart event has already fired, before videojs was
   * ready. Two known examples of when this can happen are:
   * 1. If we're loading the playback object after it has started loading
   * 2. The media is already playing the (often with autoplay on) then
   *
   * This function will fire another loadstart so that videojs can catchup.
   *
   * @fires Tech#loadstart
   *
   * @return {undefined}
   *         returns nothing.
   */ handleLateInit_(el) {
        if (el.networkState === 0 || el.networkState === 3) // The video element hasn't started loading the source yet
        // or didn't find a source
        return;
        if (el.readyState === 0) {
            // NetworkState is set synchronously BUT loadstart is fired at the
            // end of the current stack, usually before setInterval(fn, 0).
            // So at this point we know loadstart may have already fired or is
            // about to fire, and either way the player hasn't seen it yet.
            // We don't want to fire loadstart prematurely here and cause a
            // double loadstart so we'll wait and see if it happens between now
            // and the next loop, and fire it if not.
            // HOWEVER, we also want to make sure it fires before loadedmetadata
            // which could also happen between now and the next loop, so we'll
            // watch for that also.
            let loadstartFired = false;
            const setLoadstartFired = function() {
                loadstartFired = true;
            };
            this.on('loadstart', setLoadstartFired);
            const triggerLoadstart = function() {
                // We did miss the original loadstart. Make sure the player
                // sees loadstart before loadedmetadata
                if (!loadstartFired) this.trigger('loadstart');
            };
            this.on('loadedmetadata', triggerLoadstart);
            this.ready(function() {
                this.off('loadstart', setLoadstartFired);
                this.off('loadedmetadata', triggerLoadstart);
                if (!loadstartFired) // We did miss the original native loadstart. Fire it now.
                this.trigger('loadstart');
            });
            return;
        }
        // From here on we know that loadstart already fired and we missed it.
        // The other readyState events aren't as much of a problem if we double
        // them, so not going to go to as much trouble as loadstart to prevent
        // that unless we find reason to.
        const eventsToTrigger = [
            'loadstart'
        ];
        // loadedmetadata: newly equal to HAVE_METADATA (1) or greater
        eventsToTrigger.push('loadedmetadata');
        // loadeddata: newly increased to HAVE_CURRENT_DATA (2) or greater
        if (el.readyState >= 2) eventsToTrigger.push('loadeddata');
        // canplay: newly increased to HAVE_FUTURE_DATA (3) or greater
        if (el.readyState >= 3) eventsToTrigger.push('canplay');
        // canplaythrough: newly equal to HAVE_ENOUGH_DATA (4)
        if (el.readyState >= 4) eventsToTrigger.push('canplaythrough');
        // We still need to give the player time to add event listeners
        this.ready(function() {
            eventsToTrigger.forEach(function(type) {
                this.trigger(type);
            }, this);
        });
    }
    /**
   * Set whether we are scrubbing or not.
   * This is used to decide whether we should use `fastSeek` or not.
   * `fastSeek` is used to provide trick play on Safari browsers.
   *
   * @param {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */ setScrubbing(isScrubbing) {
        this.isScrubbing_ = isScrubbing;
    }
    /**
   * Get whether we are scrubbing or not.
   *
   * @return {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */ scrubbing() {
        return this.isScrubbing_;
    }
    /**
   * Set current time for the `HTML5` tech.
   *
   * @param {number} seconds
   *        Set the current time of the media to this.
   */ setCurrentTime(seconds) {
        try {
            if (this.isScrubbing_ && this.el_.fastSeek && $86defbb4e95ebb07$var$IS_ANY_SAFARI) this.el_.fastSeek(seconds);
            else this.el_.currentTime = seconds;
        } catch (e) {
            $86defbb4e95ebb07$var$log$1(e, 'Video is not ready. (Video.js)');
        // this.warning(VideoJS.warnings.videoNotReady);
        }
    }
    /**
   * Get the current duration of the HTML5 media element.
   *
   * @return {number}
   *         The duration of the media or 0 if there is no duration.
   */ duration() {
        // Android Chrome will report duration as Infinity for VOD HLS until after
        // playback has started, which triggers the live display erroneously.
        // Return NaN if playback has not started and trigger a durationupdate once
        // the duration can be reliably known.
        if (this.el_.duration === Infinity && $86defbb4e95ebb07$var$IS_ANDROID && $86defbb4e95ebb07$var$IS_CHROME && this.el_.currentTime === 0) {
            // Wait for the first `timeupdate` with currentTime > 0 - there may be
            // several with 0
            const checkProgress = ()=>{
                if (this.el_.currentTime > 0) {
                    // Trigger durationchange for genuinely live video
                    if (this.el_.duration === Infinity) this.trigger('durationchange');
                    this.off('timeupdate', checkProgress);
                }
            };
            this.on('timeupdate', checkProgress);
            return NaN;
        }
        return this.el_.duration || NaN;
    }
    /**
   * Get the current width of the HTML5 media element.
   *
   * @return {number}
   *         The width of the HTML5 media element.
   */ width() {
        return this.el_.offsetWidth;
    }
    /**
   * Get the current height of the HTML5 media element.
   *
   * @return {number}
   *         The height of the HTML5 media element.
   */ height() {
        return this.el_.offsetHeight;
    }
    /**
   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
   * `fullscreenchange` event.
   *
   * @private
   * @fires fullscreenchange
   * @listens webkitendfullscreen
   * @listens webkitbeginfullscreen
   * @listens webkitbeginfullscreen
   */ proxyWebkitFullscreen_() {
        if (!('webkitDisplayingFullscreen' in this.el_)) return;
        const endFn = function() {
            this.trigger('fullscreenchange', {
                isFullscreen: false
            });
            // Safari will sometimes set controls on the videoelement when existing fullscreen.
            if (this.el_.controls && !this.options_.nativeControlsForTouch && this.controls()) this.el_.controls = false;
        };
        const beginFn = function() {
            if ('webkitPresentationMode' in this.el_ && this.el_.webkitPresentationMode !== 'picture-in-picture') {
                this.one('webkitendfullscreen', endFn);
                this.trigger('fullscreenchange', {
                    isFullscreen: true,
                    // set a flag in case another tech triggers fullscreenchange
                    nativeIOSFullscreen: true
                });
            }
        };
        this.on('webkitbeginfullscreen', beginFn);
        this.on('dispose', ()=>{
            this.off('webkitbeginfullscreen', beginFn);
            this.off('webkitendfullscreen', endFn);
        });
    }
    /**
   * Check if fullscreen is supported on the video el.
   *
   * @return {boolean}
   *         - True if fullscreen is supported.
   *         - False if fullscreen is not supported.
   */ supportsFullScreen() {
        return typeof this.el_.webkitEnterFullScreen === 'function';
    }
    /**
   * Request that the `HTML5` Tech enter fullscreen.
   */ enterFullScreen() {
        const video = this.el_;
        if (video.paused && video.networkState <= video.HAVE_METADATA) {
            // attempt to prime the video element for programmatic access
            // this isn't necessary on the desktop but shouldn't hurt
            $86defbb4e95ebb07$var$silencePromise(this.el_.play());
            // playing and pausing synchronously during the transition to fullscreen
            // can get iOS ~6.1 devices into a play/pause loop
            this.setTimeout(function() {
                video.pause();
                try {
                    video.webkitEnterFullScreen();
                } catch (e) {
                    this.trigger('fullscreenerror', e);
                }
            }, 0);
        } else try {
            video.webkitEnterFullScreen();
        } catch (e) {
            this.trigger('fullscreenerror', e);
        }
    }
    /**
   * Request that the `HTML5` Tech exit fullscreen.
   */ exitFullScreen() {
        if (!this.el_.webkitDisplayingFullscreen) {
            this.trigger('fullscreenerror', new Error('The video is not fullscreen'));
            return;
        }
        this.el_.webkitExitFullScreen();
    }
    /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */ requestPictureInPicture() {
        return this.el_.requestPictureInPicture();
    }
    /**
   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
   * Needs to be checked later than the constructor
   * This will be a false positive for clear sources loaded after a Fairplay source
   *
   * @param {function} cb function to call
   * @return {number} id of request
   */ requestVideoFrameCallback(cb) {
        if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) return this.el_.requestVideoFrameCallback(cb);
        return super.requestVideoFrameCallback(cb);
    }
    /**
   * Native or fallback requestVideoFrameCallback
   *
   * @param {number} id request id to cancel
   */ cancelVideoFrameCallback(id) {
        if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) this.el_.cancelVideoFrameCallback(id);
        else super.cancelVideoFrameCallback(id);
    }
    /**
   * A getter/setter for the `Html5` Tech's source object.
   * > Note: Please use {@link Html5#setSource}
   *
   * @param {Tech~SourceObject} [src]
   *        The source object you want to set on the `HTML5` techs element.
   *
   * @return {Tech~SourceObject|undefined}
   *         - The current source object when a source is not passed in.
   *         - undefined when setting
   *
   * @deprecated Since version 5.
   */ src(src) {
        if (src === undefined) return this.el_.src;
        // Setting src through `src` instead of `setSrc` will be deprecated
        this.setSrc(src);
    }
    /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */ addSourceElement(srcUrl, mimeType) {
        if (!srcUrl) {
            $86defbb4e95ebb07$var$log$1.error('Invalid source URL.');
            return false;
        }
        const sourceAttributes = {
            src: srcUrl
        };
        if (mimeType) sourceAttributes.type = mimeType;
        const sourceElement = $86defbb4e95ebb07$var$createEl('source', {}, sourceAttributes);
        this.el_.appendChild(sourceElement);
        return true;
    }
    /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */ removeSourceElement(srcUrl) {
        if (!srcUrl) {
            $86defbb4e95ebb07$var$log$1.error('Source URL is required to remove the source element.');
            return false;
        }
        const sourceElements = this.el_.querySelectorAll('source');
        for (const sourceElement of sourceElements)if (sourceElement.src === srcUrl) {
            this.el_.removeChild(sourceElement);
            return true;
        }
        $86defbb4e95ebb07$var$log$1.warn(`No matching source element found with src: ${srcUrl}`);
        return false;
    }
    /**
   * Reset the tech by removing all sources and then calling
   * {@link Html5.resetMediaElement}.
   */ reset() {
        $86defbb4e95ebb07$var$Html5.resetMediaElement(this.el_);
    }
    /**
   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
   * the HTML5 media element.
   *
   * @return {Tech~SourceObject}
   *         The current source object from the HTML5 tech. With a fallback to the
   *         elements source.
   */ currentSrc() {
        if (this.currentSource_) return this.currentSource_.src;
        return this.el_.currentSrc;
    }
    /**
   * Set controls attribute for the HTML5 media Element.
   *
   * @param {string} val
   *        Value to set the controls attribute to
   */ setControls(val) {
        this.el_.controls = !!val;
    }
    /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */ addTextTrack(kind, label, language) {
        if (!this.featuresNativeTextTracks) return super.addTextTrack(kind, label, language);
        return this.el_.addTextTrack(kind, label, language);
    }
    /**
   * Creates either native TextTrack or an emulated TextTrack depending
   * on the value of `featuresNativeTextTracks`
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label]
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @param {boolean} [options.default]
   *        Default this track to on.
   *
   * @param {string} [options.id]
   *        The internal id to assign this track.
   *
   * @param {string} [options.src]
   *        A source url for the track.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */ createRemoteTextTrack(options) {
        if (!this.featuresNativeTextTracks) return super.createRemoteTextTrack(options);
        const htmlTrackElement = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('track');
        if (options.kind) htmlTrackElement.kind = options.kind;
        if (options.label) htmlTrackElement.label = options.label;
        if (options.language || options.srclang) htmlTrackElement.srclang = options.language || options.srclang;
        if (options.default) htmlTrackElement.default = options.default;
        if (options.id) htmlTrackElement.id = options.id;
        if (options.src) htmlTrackElement.src = options.src;
        return htmlTrackElement;
    }
    /**
   * Creates a remote text track object and returns an html track element.
   *
   * @param {Object} options The object should contain values for
   * kind, language, label, and src (location of the WebVTT file)
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack
   * will not be removed from the TextTrackList and HtmlTrackElementList
   * after a source change
   * @return {HTMLTrackElement} An Html Track Element.
   * This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   */ addRemoteTextTrack(options, manualCleanup) {
        const htmlTrackElement = super.addRemoteTextTrack(options, manualCleanup);
        if (this.featuresNativeTextTracks) this.el().appendChild(htmlTrackElement);
        return htmlTrackElement;
    }
    /**
   * Remove remote `TextTrack` from `TextTrackList` object
   *
   * @param {TextTrack} track
   *        `TextTrack` object to remove
   */ removeRemoteTextTrack(track) {
        super.removeRemoteTextTrack(track);
        if (this.featuresNativeTextTracks) {
            const tracks = this.$$('track');
            let i = tracks.length;
            while(i--)if (track === tracks[i] || track === tracks[i].track) this.el().removeChild(tracks[i]);
        }
    }
    /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   */ getVideoPlaybackQuality() {
        if (typeof this.el().getVideoPlaybackQuality === 'function') return this.el().getVideoPlaybackQuality();
        const videoPlaybackQuality = {};
        if (typeof this.el().webkitDroppedFrameCount !== 'undefined' && typeof this.el().webkitDecodedFrameCount !== 'undefined') {
            videoPlaybackQuality.droppedVideoFrames = this.el().webkitDroppedFrameCount;
            videoPlaybackQuality.totalVideoFrames = this.el().webkitDecodedFrameCount;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).performance) videoPlaybackQuality.creationTime = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).performance.now();
        return videoPlaybackQuality;
    }
}
/* HTML5 Support Testing ---------------------------------------------------- */ /**
 * Element for testing browser HTML5 media capabilities
 *
 * @type {Element}
 * @constant
 * @private
 */ $86defbb4e95ebb07$var$defineLazyProperty($86defbb4e95ebb07$var$Html5, 'TEST_VID', function() {
    if (!$86defbb4e95ebb07$var$isReal()) return;
    const video = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('video');
    const track = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('track');
    track.kind = 'captions';
    track.srclang = 'en';
    track.label = 'English';
    video.appendChild(track);
    return video;
});
/**
 * Check if HTML5 media is supported by this browser/device.
 *
 * @return {boolean}
 *         - True if HTML5 media is supported.
 *         - False if HTML5 media is not supported.
 */ $86defbb4e95ebb07$var$Html5.isSupported = function() {
    // IE with no Media Player is a LIAR! (#984)
    try {
        $86defbb4e95ebb07$var$Html5.TEST_VID.volume = 0.5;
    } catch (e) {
        return false;
    }
    return !!($86defbb4e95ebb07$var$Html5.TEST_VID && $86defbb4e95ebb07$var$Html5.TEST_VID.canPlayType);
};
/**
 * Check if the tech can support the given type
 *
 * @param {string} type
 *        The mimetype to check
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */ $86defbb4e95ebb07$var$Html5.canPlayType = function(type) {
    return $86defbb4e95ebb07$var$Html5.TEST_VID.canPlayType(type);
};
/**
 * Check if the tech can support the given source
 *
 * @param {Object} srcObj
 *        The source object
 * @param {Object} options
 *        The options passed to the tech
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */ $86defbb4e95ebb07$var$Html5.canPlaySource = function(srcObj, options) {
    return $86defbb4e95ebb07$var$Html5.canPlayType(srcObj.type);
};
/**
 * Check if the volume can be changed in this browser/device.
 * Volume cannot be changed in a lot of mobile devices.
 * Specifically, it can't be changed from 1 on iOS.
 *
 * @return {boolean}
 *         - True if volume can be controlled
 *         - False otherwise
 */ $86defbb4e95ebb07$var$Html5.canControlVolume = function() {
    // IE will error if Windows Media Player not installed #3315
    try {
        const volume = $86defbb4e95ebb07$var$Html5.TEST_VID.volume;
        $86defbb4e95ebb07$var$Html5.TEST_VID.volume = volume / 2 + 0.1;
        const canControl = volume !== $86defbb4e95ebb07$var$Html5.TEST_VID.volume;
        // With the introduction of iOS 15, there are cases where the volume is read as
        // changed but reverts back to its original state at the start of the next tick.
        // To determine whether volume can be controlled on iOS,
        // a timeout is set and the volume is checked asynchronously.
        // Since `features` doesn't currently work asynchronously, the value is manually set.
        if (canControl && $86defbb4e95ebb07$var$IS_IOS) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>{
                if ($86defbb4e95ebb07$var$Html5 && $86defbb4e95ebb07$var$Html5.prototype) $86defbb4e95ebb07$var$Html5.prototype.featuresVolumeControl = volume !== $86defbb4e95ebb07$var$Html5.TEST_VID.volume;
            });
            // default iOS to false, which will be updated in the timeout above.
            return false;
        }
        return canControl;
    } catch (e) {
        return false;
    }
};
/**
 * Check if the volume can be muted in this browser/device.
 * Some devices, e.g. iOS, don't allow changing volume
 * but permits muting/unmuting.
 *
 * @return {boolean}
 *      - True if volume can be muted
 *      - False otherwise
 */ $86defbb4e95ebb07$var$Html5.canMuteVolume = function() {
    try {
        const muted = $86defbb4e95ebb07$var$Html5.TEST_VID.muted;
        // in some versions of iOS muted property doesn't always
        // work, so we want to set both property and attribute
        $86defbb4e95ebb07$var$Html5.TEST_VID.muted = !muted;
        if ($86defbb4e95ebb07$var$Html5.TEST_VID.muted) $86defbb4e95ebb07$var$setAttribute($86defbb4e95ebb07$var$Html5.TEST_VID, 'muted', 'muted');
        else $86defbb4e95ebb07$var$removeAttribute($86defbb4e95ebb07$var$Html5.TEST_VID, 'muted', 'muted');
        return muted !== $86defbb4e95ebb07$var$Html5.TEST_VID.muted;
    } catch (e) {
        return false;
    }
};
/**
 * Check if the playback rate can be changed in this browser/device.
 *
 * @return {boolean}
 *         - True if playback rate can be controlled
 *         - False otherwise
 */ $86defbb4e95ebb07$var$Html5.canControlPlaybackRate = function() {
    // Playback rate API is implemented in Android Chrome, but doesn't do anything
    // https://github.com/videojs/video.js/issues/3180
    if ($86defbb4e95ebb07$var$IS_ANDROID && $86defbb4e95ebb07$var$IS_CHROME && $86defbb4e95ebb07$var$CHROME_VERSION < 58) return false;
    // IE will error if Windows Media Player not installed #3315
    try {
        const playbackRate = $86defbb4e95ebb07$var$Html5.TEST_VID.playbackRate;
        $86defbb4e95ebb07$var$Html5.TEST_VID.playbackRate = playbackRate / 2 + 0.1;
        return playbackRate !== $86defbb4e95ebb07$var$Html5.TEST_VID.playbackRate;
    } catch (e) {
        return false;
    }
};
/**
 * Check if we can override a video/audio elements attributes, with
 * Object.defineProperty.
 *
 * @return {boolean}
 *         - True if builtin attributes can be overridden
 *         - False otherwise
 */ $86defbb4e95ebb07$var$Html5.canOverrideAttributes = function() {
    // if we cannot overwrite the src/innerHTML property, there is no support
    // iOS 7 safari for instance cannot do this.
    try {
        const noop = ()=>{};
        Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('video'), 'src', {
            get: noop,
            set: noop
        });
        Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('audio'), 'src', {
            get: noop,
            set: noop
        });
        Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('video'), 'innerHTML', {
            get: noop,
            set: noop
        });
        Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('audio'), 'innerHTML', {
            get: noop,
            set: noop
        });
    } catch (e) {
        return false;
    }
    return true;
};
/**
 * Check to see if native `TextTrack`s are supported by this browser/device.
 *
 * @return {boolean}
 *         - True if native `TextTrack`s are supported.
 *         - False otherwise
 */ $86defbb4e95ebb07$var$Html5.supportsNativeTextTracks = function() {
    return $86defbb4e95ebb07$var$IS_ANY_SAFARI || $86defbb4e95ebb07$var$IS_IOS && $86defbb4e95ebb07$var$IS_CHROME;
};
/**
 * Check to see if native `VideoTrack`s are supported by this browser/device
 *
 * @return {boolean}
 *        - True if native `VideoTrack`s are supported.
 *        - False otherwise
 */ $86defbb4e95ebb07$var$Html5.supportsNativeVideoTracks = function() {
    return !!($86defbb4e95ebb07$var$Html5.TEST_VID && $86defbb4e95ebb07$var$Html5.TEST_VID.videoTracks);
};
/**
 * Check to see if native `AudioTrack`s are supported by this browser/device
 *
 * @return {boolean}
 *        - True if native `AudioTrack`s are supported.
 *        - False otherwise
 */ $86defbb4e95ebb07$var$Html5.supportsNativeAudioTracks = function() {
    return !!($86defbb4e95ebb07$var$Html5.TEST_VID && $86defbb4e95ebb07$var$Html5.TEST_VID.audioTracks);
};
/**
 * An array of events available on the Html5 tech.
 *
 * @private
 * @type {Array}
 */ $86defbb4e95ebb07$var$Html5.Events = [
    'loadstart',
    'suspend',
    'abort',
    'error',
    'emptied',
    'stalled',
    'loadedmetadata',
    'loadeddata',
    'canplay',
    'canplaythrough',
    'playing',
    'waiting',
    'seeking',
    'seeked',
    'ended',
    'durationchange',
    'timeupdate',
    'progress',
    'play',
    'pause',
    'ratechange',
    'resize',
    'volumechange'
];
/**
 * Boolean indicating whether the `Tech` supports volume control.
 *
 * @type {boolean}
 * @default {@link Html5.canControlVolume}
 */ /**
 * Boolean indicating whether the `Tech` supports muting volume.
 *
 * @type {boolean}
 * @default {@link Html5.canMuteVolume}
 */ /**
 * Boolean indicating whether the `Tech` supports changing the speed at which the media
 * plays. Examples:
 *   - Set player to play 2x (twice) as fast
 *   - Set player to play 0.5x (half) as fast
 *
 * @type {boolean}
 * @default {@link Html5.canControlPlaybackRate}
 */ /**
 * Boolean indicating whether the `Tech` supports the `sourceset` event.
 *
 * @type {boolean}
 * @default
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `TextTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeTextTracks}
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `VideoTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeVideoTracks}
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `AudioTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeAudioTracks}
 */ [
    [
        'featuresMuteControl',
        'canMuteVolume'
    ],
    [
        'featuresPlaybackRate',
        'canControlPlaybackRate'
    ],
    [
        'featuresSourceset',
        'canOverrideAttributes'
    ],
    [
        'featuresNativeTextTracks',
        'supportsNativeTextTracks'
    ],
    [
        'featuresNativeVideoTracks',
        'supportsNativeVideoTracks'
    ],
    [
        'featuresNativeAudioTracks',
        'supportsNativeAudioTracks'
    ]
].forEach(function([key, fn]) {
    $86defbb4e95ebb07$var$defineLazyProperty($86defbb4e95ebb07$var$Html5.prototype, key, ()=>$86defbb4e95ebb07$var$Html5[fn](), true);
});
$86defbb4e95ebb07$var$Html5.prototype.featuresVolumeControl = $86defbb4e95ebb07$var$Html5.canControlVolume();
/**
 * Boolean indicating whether the `HTML5` tech currently supports the media element
 * moving in the DOM. iOS breaks if you move the media element, so this is set this to
 * false there. Everywhere else this should be true.
 *
 * @type {boolean}
 * @default
 */ $86defbb4e95ebb07$var$Html5.prototype.movingMediaElementInDOM = !$86defbb4e95ebb07$var$IS_IOS;
// TODO: Previous comment: No longer appears to be used. Can probably be removed.
//       Is this true?
/**
 * Boolean indicating whether the `HTML5` tech currently supports automatic media resize
 * when going into fullscreen.
 *
 * @type {boolean}
 * @default
 */ $86defbb4e95ebb07$var$Html5.prototype.featuresFullscreenResize = true;
/**
 * Boolean indicating whether the `HTML5` tech currently supports the progress event.
 * If this is false, manual `progress` events will be triggered instead.
 *
 * @type {boolean}
 * @default
 */ $86defbb4e95ebb07$var$Html5.prototype.featuresProgressEvents = true;
/**
 * Boolean indicating whether the `HTML5` tech currently supports the timeupdate event.
 * If this is false, manual `timeupdate` events will be triggered instead.
 *
 * @default
 */ $86defbb4e95ebb07$var$Html5.prototype.featuresTimeupdateEvents = true;
/**
 * Whether the HTML5 el supports `requestVideoFrameCallback`
 *
 * @type {boolean}
 */ $86defbb4e95ebb07$var$Html5.prototype.featuresVideoFrameCallback = !!($86defbb4e95ebb07$var$Html5.TEST_VID && $86defbb4e95ebb07$var$Html5.TEST_VID.requestVideoFrameCallback);
$86defbb4e95ebb07$var$Html5.disposeMediaElement = function(el) {
    if (!el) return;
    if (el.parentNode) el.parentNode.removeChild(el);
    // remove any child track or source nodes to prevent their loading
    while(el.hasChildNodes())el.removeChild(el.firstChild);
    // remove any src reference. not setting `src=''` because that causes a warning
    // in firefox
    el.removeAttribute('src');
    // force the media element to update its loading state by calling load()
    // however IE on Windows 7N has a bug that throws an error so need a try/catch (#793)
    if (typeof el.load === 'function') // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
    (function() {
        try {
            el.load();
        } catch (e) {
        // not supported
        }
    })();
};
$86defbb4e95ebb07$var$Html5.resetMediaElement = function(el) {
    if (!el) return;
    const sources = el.querySelectorAll('source');
    let i = sources.length;
    while(i--)el.removeChild(sources[i]);
    // remove any src reference.
    // not setting `src=''` because that throws an error
    el.removeAttribute('src');
    if (typeof el.load === 'function') // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
    (function() {
        try {
            el.load();
        } catch (e) {
        // satisfy linter
        }
    })();
};
/* Native HTML5 element property wrapping ----------------------------------- */ // Wrap native boolean attributes with getters that check both property and attribute
// The list is as followed:
// muted, defaultMuted, autoplay, controls, loop, playsinline
[
    /**
 * Get the value of `muted` from the media element. `muted` indicates
 * that the volume for the media should be set to silent. This does not actually change
 * the `volume` attribute.
 *
 * @method Html5#muted
 * @return {boolean}
 *         - True if the value of `volume` should be ignored and the audio set to silent.
 *         - False if the value of `volume` should be used.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
 */ 'muted',
    /**
 * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
 * whether the media should start muted or not. Only changes the default state of the
 * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
 * current state.
 *
 * @method Html5#defaultMuted
 * @return {boolean}
 *         - The value of `defaultMuted` from the media element.
 *         - True indicates that the media should start muted.
 *         - False indicates that the media should not start muted
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
 */ 'defaultMuted',
    /**
 * Get the value of `autoplay` from the media element. `autoplay` indicates
 * that the media should start to play as soon as the page is ready.
 *
 * @method Html5#autoplay
 * @return {boolean}
 *         - The value of `autoplay` from the media element.
 *         - True indicates that the media should start as soon as the page loads.
 *         - False indicates that the media should not start as soon as the page loads.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
 */ 'autoplay',
    /**
 * Get the value of `controls` from the media element. `controls` indicates
 * whether the native media controls should be shown or hidden.
 *
 * @method Html5#controls
 * @return {boolean}
 *         - The value of `controls` from the media element.
 *         - True indicates that native controls should be showing.
 *         - False indicates that native controls should be hidden.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
 */ 'controls',
    /**
 * Get the value of `loop` from the media element. `loop` indicates
 * that the media should return to the start of the media and continue playing once
 * it reaches the end.
 *
 * @method Html5#loop
 * @return {boolean}
 *         - The value of `loop` from the media element.
 *         - True indicates that playback should seek back to start once
 *           the end of a media is reached.
 *         - False indicates that playback should not loop back to the start when the
 *           end of the media is reached.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
 */ 'loop',
    /**
 * Get the value of `playsinline` from the media element. `playsinline` indicates
 * to the browser that non-fullscreen playback is preferred when fullscreen
 * playback is the native default, such as in iOS Safari.
 *
 * @method Html5#playsinline
 * @return {boolean}
 *         - The value of `playsinline` from the media element.
 *         - True indicates that the media should play inline.
 *         - False indicates that the media should not play inline.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
 */ 'playsinline'
].forEach(function(prop) {
    $86defbb4e95ebb07$var$Html5.prototype[prop] = function() {
        return this.el_[prop] || this.el_.hasAttribute(prop);
    };
});
// Wrap native boolean attributes with setters that set both property and attribute
// The list is as followed:
// setMuted, setDefaultMuted, setAutoplay, setLoop, setPlaysinline
// setControls is special-cased above
[
    /**
 * Set the value of `muted` on the media element. `muted` indicates that the current
 * audio level should be silent.
 *
 * @method Html5#setMuted
 * @param {boolean} muted
 *        - True if the audio should be set to silent
 *        - False otherwise
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
 */ 'muted',
    /**
 * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
 * audio level should be silent, but will only effect the muted level on initial playback..
 *
 * @method Html5.prototype.setDefaultMuted
 * @param {boolean} defaultMuted
 *        - True if the audio should be set to silent
 *        - False otherwise
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
 */ 'defaultMuted',
    /**
 * Set the value of `autoplay` on the media element. `autoplay` indicates
 * that the media should start to play as soon as the page is ready.
 *
 * @method Html5#setAutoplay
 * @param {boolean} autoplay
 *         - True indicates that the media should start as soon as the page loads.
 *         - False indicates that the media should not start as soon as the page loads.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
 */ 'autoplay',
    /**
 * Set the value of `loop` on the media element. `loop` indicates
 * that the media should return to the start of the media and continue playing once
 * it reaches the end.
 *
 * @method Html5#setLoop
 * @param {boolean} loop
 *         - True indicates that playback should seek back to start once
 *           the end of a media is reached.
 *         - False indicates that playback should not loop back to the start when the
 *           end of the media is reached.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
 */ 'loop',
    /**
 * Set the value of `playsinline` from the media element. `playsinline` indicates
 * to the browser that non-fullscreen playback is preferred when fullscreen
 * playback is the native default, such as in iOS Safari.
 *
 * @method Html5#setPlaysinline
 * @param {boolean} playsinline
 *         - True indicates that the media should play inline.
 *         - False indicates that the media should not play inline.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
 */ 'playsinline'
].forEach(function(prop) {
    $86defbb4e95ebb07$var$Html5.prototype['set' + $86defbb4e95ebb07$var$toTitleCase$1(prop)] = function(v) {
        this.el_[prop] = v;
        if (v) this.el_.setAttribute(prop, prop);
        else this.el_.removeAttribute(prop);
    };
});
// Wrap native properties with a getter
// The list is as followed
// paused, currentTime, buffered, volume, poster, preload, error, seeking
// seekable, ended, playbackRate, defaultPlaybackRate, disablePictureInPicture
// played, networkState, readyState, videoWidth, videoHeight, crossOrigin
[
    /**
 * Get the value of `paused` from the media element. `paused` indicates whether the media element
 * is currently paused or not.
 *
 * @method Html5#paused
 * @return {boolean}
 *         The value of `paused` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
 */ 'paused',
    /**
 * Get the value of `currentTime` from the media element. `currentTime` indicates
 * the current second that the media is at in playback.
 *
 * @method Html5#currentTime
 * @return {number}
 *         The value of `currentTime` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
 */ 'currentTime',
    /**
 * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
 * object that represents the parts of the media that are already downloaded and
 * available for playback.
 *
 * @method Html5#buffered
 * @return {TimeRange}
 *         The value of `buffered` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
 */ 'buffered',
    /**
 * Get the value of `volume` from the media element. `volume` indicates
 * the current playback volume of audio for a media. `volume` will be a value from 0
 * (silent) to 1 (loudest and default).
 *
 * @method Html5#volume
 * @return {number}
 *         The value of `volume` from the media element. Value will be between 0-1.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
 */ 'volume',
    /**
 * Get the value of `poster` from the media element. `poster` indicates
 * that the url of an image file that can/will be shown when no media data is available.
 *
 * @method Html5#poster
 * @return {string}
 *         The value of `poster` from the media element. Value will be a url to an
 *         image.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
 */ 'poster',
    /**
 * Get the value of `preload` from the media element. `preload` indicates
 * what should download before the media is interacted with. It can have the following
 * values:
 * - none: nothing should be downloaded
 * - metadata: poster and the first few frames of the media may be downloaded to get
 *   media dimensions and other metadata
 * - auto: allow the media and metadata for the media to be downloaded before
 *    interaction
 *
 * @method Html5#preload
 * @return {string}
 *         The value of `preload` from the media element. Will be 'none', 'metadata',
 *         or 'auto'.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
 */ 'preload',
    /**
 * Get the value of the `error` from the media element. `error` indicates any
 * MediaError that may have occurred during playback. If error returns null there is no
 * current error.
 *
 * @method Html5#error
 * @return {MediaError|null}
 *         The value of `error` from the media element. Will be `MediaError` if there
 *         is a current error and null otherwise.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
 */ 'error',
    /**
 * Get the value of `seeking` from the media element. `seeking` indicates whether the
 * media is currently seeking to a new position or not.
 *
 * @method Html5#seeking
 * @return {boolean}
 *         - The value of `seeking` from the media element.
 *         - True indicates that the media is currently seeking to a new position.
 *         - False indicates that the media is not seeking to a new position at this time.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
 */ 'seeking',
    /**
 * Get the value of `seekable` from the media element. `seekable` returns a
 * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
 *
 * @method Html5#seekable
 * @return {TimeRange}
 *         The value of `seekable` from the media element. A `TimeRange` object
 *         indicating the current ranges of time that can be seeked to.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
 */ 'seekable',
    /**
 * Get the value of `ended` from the media element. `ended` indicates whether
 * the media has reached the end or not.
 *
 * @method Html5#ended
 * @return {boolean}
 *         - The value of `ended` from the media element.
 *         - True indicates that the media has ended.
 *         - False indicates that the media has not ended.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
 */ 'ended',
    /**
 * Get the value of `playbackRate` from the media element. `playbackRate` indicates
 * the rate at which the media is currently playing back. Examples:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5#playbackRate
 * @return {number}
 *         The value of `playbackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */ 'playbackRate',
    /**
 * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
 * the rate at which the media is currently playing back. This value will not indicate the current
 * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
 *
 * Examples:
 *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
 *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5.prototype.defaultPlaybackRate
 * @return {number}
 *         The value of `defaultPlaybackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */ 'defaultPlaybackRate',
    /**
 * Get the value of 'disablePictureInPicture' from the video element.
 *
 * @method Html5#disablePictureInPicture
 * @return {boolean} value
 *         - The value of `disablePictureInPicture` from the video element.
 *         - True indicates that the video can't be played in Picture-In-Picture mode
 *         - False indicates that the video can be played in Picture-In-Picture mode
 *
 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
 */ 'disablePictureInPicture',
    /**
 * Get the value of `played` from the media element. `played` returns a `TimeRange`
 * object representing points in the media timeline that have been played.
 *
 * @method Html5#played
 * @return {TimeRange}
 *         The value of `played` from the media element. A `TimeRange` object indicating
 *         the ranges of time that have been played.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
 */ 'played',
    /**
 * Get the value of `networkState` from the media element. `networkState` indicates
 * the current network state. It returns an enumeration from the following list:
 * - 0: NETWORK_EMPTY
 * - 1: NETWORK_IDLE
 * - 2: NETWORK_LOADING
 * - 3: NETWORK_NO_SOURCE
 *
 * @method Html5#networkState
 * @return {number}
 *         The value of `networkState` from the media element. This will be a number
 *         from the list in the description.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
 */ 'networkState',
    /**
 * Get the value of `readyState` from the media element. `readyState` indicates
 * the current state of the media element. It returns an enumeration from the
 * following list:
 * - 0: HAVE_NOTHING
 * - 1: HAVE_METADATA
 * - 2: HAVE_CURRENT_DATA
 * - 3: HAVE_FUTURE_DATA
 * - 4: HAVE_ENOUGH_DATA
 *
 * @method Html5#readyState
 * @return {number}
 *         The value of `readyState` from the media element. This will be a number
 *         from the list in the description.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
 */ 'readyState',
    /**
 * Get the value of `videoWidth` from the video element. `videoWidth` indicates
 * the current width of the video in css pixels.
 *
 * @method Html5#videoWidth
 * @return {number}
 *         The value of `videoWidth` from the video element. This will be a number
 *         in css pixels.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
 */ 'videoWidth',
    /**
 * Get the value of `videoHeight` from the video element. `videoHeight` indicates
 * the current height of the video in css pixels.
 *
 * @method Html5#videoHeight
 * @return {number}
 *         The value of `videoHeight` from the video element. This will be a number
 *         in css pixels.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
 */ 'videoHeight',
    /**
 * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
 * to the browser that should sent the cookies along with the requests for the
 * different assets/playlists
 *
 * @method Html5#crossOrigin
 * @return {string}
 *         - anonymous indicates that the media should not sent cookies.
 *         - use-credentials indicates that the media should sent cookies along the requests.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
 */ 'crossOrigin'
].forEach(function(prop) {
    $86defbb4e95ebb07$var$Html5.prototype[prop] = function() {
        return this.el_[prop];
    };
});
// Wrap native properties with a setter in this format:
// set + toTitleCase(name)
// The list is as follows:
// setVolume, setSrc, setPoster, setPreload, setPlaybackRate, setDefaultPlaybackRate,
// setDisablePictureInPicture, setCrossOrigin
[
    /**
 * Set the value of `volume` on the media element. `volume` indicates the current
 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
 * so on.
 *
 * @method Html5#setVolume
 * @param {number} percentAsDecimal
 *        The volume percent as a decimal. Valid range is from 0-1.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
 */ 'volume',
    /**
 * Set the value of `src` on the media element. `src` indicates the current
 * {@link Tech~SourceObject} for the media.
 *
 * @method Html5#setSrc
 * @param {Tech~SourceObject} src
 *        The source object to set as the current source.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
 */ 'src',
    /**
 * Set the value of `poster` on the media element. `poster` is the url to
 * an image file that can/will be shown when no media data is available.
 *
 * @method Html5#setPoster
 * @param {string} poster
 *        The url to an image that should be used as the `poster` for the media
 *        element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
 */ 'poster',
    /**
 * Set the value of `preload` on the media element. `preload` indicates
 * what should download before the media is interacted with. It can have the following
 * values:
 * - none: nothing should be downloaded
 * - metadata: poster and the first few frames of the media may be downloaded to get
 *   media dimensions and other metadata
 * - auto: allow the media and metadata for the media to be downloaded before
 *    interaction
 *
 * @method Html5#setPreload
 * @param {string} preload
 *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
 *         or 'auto'.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
 */ 'preload',
    /**
 * Set the value of `playbackRate` on the media element. `playbackRate` indicates
 * the rate at which the media should play back. Examples:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5#setPlaybackRate
 * @return {number}
 *         The value of `playbackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */ 'playbackRate',
    /**
 * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
 * the rate at which the media should play back upon initial startup. Changing this value
 * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
 *
 * Example Values:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5.prototype.setDefaultPlaybackRate
 * @return {number}
 *         The value of `defaultPlaybackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
 */ 'defaultPlaybackRate',
    /**
 * Prevents the browser from suggesting a Picture-in-Picture context menu
 * or to request Picture-in-Picture automatically in some cases.
 *
 * @method Html5#setDisablePictureInPicture
 * @param {boolean} value
 *         The true value will disable Picture-in-Picture mode.
 *
 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
 */ 'disablePictureInPicture',
    /**
 * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
 * to the browser that should sent the cookies along with the requests for the
 * different assets/playlists
 *
 * @method Html5#setCrossOrigin
 * @param {string} crossOrigin
 *         - anonymous indicates that the media should not sent cookies.
 *         - use-credentials indicates that the media should sent cookies along the requests.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
 */ 'crossOrigin'
].forEach(function(prop) {
    $86defbb4e95ebb07$var$Html5.prototype['set' + $86defbb4e95ebb07$var$toTitleCase$1(prop)] = function(v) {
        this.el_[prop] = v;
    };
});
// wrap native functions with a function
// The list is as follows:
// pause, load, play
[
    /**
 * A wrapper around the media elements `pause` function. This will call the `HTML5`
 * media elements `pause` function.
 *
 * @method Html5#pause
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
 */ 'pause',
    /**
 * A wrapper around the media elements `load` function. This will call the `HTML5`s
 * media element `load` function.
 *
 * @method Html5#load
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
 */ 'load',
    /**
 * A wrapper around the media elements `play` function. This will call the `HTML5`s
 * media element `play` function.
 *
 * @method Html5#play
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
 */ 'play'
].forEach(function(prop) {
    $86defbb4e95ebb07$var$Html5.prototype[prop] = function() {
        return this.el_[prop]();
    };
});
$86defbb4e95ebb07$var$Tech.withSourceHandlers($86defbb4e95ebb07$var$Html5);
/**
 * Native source handler for Html5, simply passes the source to the media element.
 *
 * @property {Tech~SourceObject} source
 *        The source object
 *
 * @property {Html5} tech
 *        The instance of the HTML5 tech.
 */ $86defbb4e95ebb07$var$Html5.nativeSourceHandler = {};
/**
 * Check if the media element can play the given mime type.
 *
 * @param {string} type
 *        The mimetype to check
 *
 * @return {string}
 *         'probably', 'maybe', or '' (empty string)
 */ $86defbb4e95ebb07$var$Html5.nativeSourceHandler.canPlayType = function(type) {
    // IE without MediaPlayer throws an error (#519)
    try {
        return $86defbb4e95ebb07$var$Html5.TEST_VID.canPlayType(type);
    } catch (e) {
        return '';
    }
};
/**
 * Check if the media element can handle a source natively.
 *
 * @param {Tech~SourceObject} source
 *         The source object
 *
 * @param {Object} [options]
 *         Options to be passed to the tech.
 *
 * @return {string}
 *         'probably', 'maybe', or '' (empty string).
 */ $86defbb4e95ebb07$var$Html5.nativeSourceHandler.canHandleSource = function(source, options) {
    // If a type was provided we should rely on that
    if (source.type) return $86defbb4e95ebb07$var$Html5.nativeSourceHandler.canPlayType(source.type);
    else if (source.src) {
        const ext = $86defbb4e95ebb07$var$getFileExtension(source.src);
        return $86defbb4e95ebb07$var$Html5.nativeSourceHandler.canPlayType(`video/${ext}`);
    }
    return '';
};
/**
 * Pass the source to the native media element.
 *
 * @param {Tech~SourceObject} source
 *        The source object
 *
 * @param {Html5} tech
 *        The instance of the Html5 tech
 *
 * @param {Object} [options]
 *        The options to pass to the source
 */ $86defbb4e95ebb07$var$Html5.nativeSourceHandler.handleSource = function(source, tech, options) {
    tech.setSrc(source.src);
};
/**
 * A noop for the native dispose function, as cleanup is not needed.
 */ $86defbb4e95ebb07$var$Html5.nativeSourceHandler.dispose = function() {};
// Register the native source handler
$86defbb4e95ebb07$var$Html5.registerSourceHandler($86defbb4e95ebb07$var$Html5.nativeSourceHandler);
$86defbb4e95ebb07$var$Tech.registerTech('Html5', $86defbb4e95ebb07$var$Html5);
/**
 * @file player.js
 */ /** @import AudioTrackList from './tracks/audio-track-list' */ /** @import HtmlTrackElement from './tracks/html-track-element' */ /** @import HtmlTrackElementList from './tracks/html-track-element-list' */ /** @import TextTrackList from './tracks/text-track-list' */ /** @import { TimeRange } from './utils/time' */ /** @import VideoTrackList from './tracks/video-track-list' */ /**
 * @callback PlayerReadyCallback
 * @this     {Player}
 * @returns  {void}
 */ // The following tech events are simply re-triggered
// on the player when they happen
const $86defbb4e95ebb07$var$TECH_EVENTS_RETRIGGER = [
    /**
 * Fired while the user agent is downloading media data.
 *
 * @event Player#progress
 * @type {Event}
 */ /**
 * Retrigger the `progress` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechProgress_
 * @fires Player#progress
 * @listens Tech#progress
 */ 'progress',
    /**
 * Fires when the loading of an audio/video is aborted.
 *
 * @event Player#abort
 * @type {Event}
 */ /**
 * Retrigger the `abort` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechAbort_
 * @fires Player#abort
 * @listens Tech#abort
 */ 'abort',
    /**
 * Fires when the browser is intentionally not getting media data.
 *
 * @event Player#suspend
 * @type {Event}
 */ /**
 * Retrigger the `suspend` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechSuspend_
 * @fires Player#suspend
 * @listens Tech#suspend
 */ 'suspend',
    /**
 * Fires when the current playlist is empty.
 *
 * @event Player#emptied
 * @type {Event}
 */ /**
 * Retrigger the `emptied` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechEmptied_
 * @fires Player#emptied
 * @listens Tech#emptied
 */ 'emptied',
    /**
 * Fires when the browser is trying to get media data, but data is not available.
 *
 * @event Player#stalled
 * @type {Event}
 */ /**
 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechStalled_
 * @fires Player#stalled
 * @listens Tech#stalled
 */ 'stalled',
    /**
 * Fires when the browser has loaded meta data for the audio/video.
 *
 * @event Player#loadedmetadata
 * @type {Event}
 */ /**
 * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechLoadedmetadata_
 * @fires Player#loadedmetadata
 * @listens Tech#loadedmetadata
 */ 'loadedmetadata',
    /**
 * Fires when the browser has loaded the current frame of the audio/video.
 *
 * @event Player#loadeddata
 * @type {event}
 */ /**
 * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechLoaddeddata_
 * @fires Player#loadeddata
 * @listens Tech#loadeddata
 */ 'loadeddata',
    /**
 * Fires when the current playback position has changed.
 *
 * @event Player#timeupdate
 * @type {event}
 */ /**
 * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechTimeUpdate_
 * @fires Player#timeupdate
 * @listens Tech#timeupdate
 */ 'timeupdate',
    /**
 * Fires when the video's intrinsic dimensions change
 *
 * @event Player#resize
 * @type {event}
 */ /**
 * Retrigger the `resize` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechResize_
 * @fires Player#resize
 * @listens Tech#resize
 */ 'resize',
    /**
 * Fires when the volume has been changed
 *
 * @event Player#volumechange
 * @type {event}
 */ /**
 * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechVolumechange_
 * @fires Player#volumechange
 * @listens Tech#volumechange
 */ 'volumechange',
    /**
 * Fires when the text track has been changed
 *
 * @event Player#texttrackchange
 * @type {event}
 */ /**
 * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechTexttrackchange_
 * @fires Player#texttrackchange
 * @listens Tech#texttrackchange
 */ 'texttrackchange'
];
// events to queue when playback rate is zero
// this is a hash for the sole purpose of mapping non-camel-cased event names
// to camel-cased function names
const $86defbb4e95ebb07$var$TECH_EVENTS_QUEUE = {
    canplay: 'CanPlay',
    canplaythrough: 'CanPlayThrough',
    playing: 'Playing',
    seeked: 'Seeked'
};
const $86defbb4e95ebb07$var$BREAKPOINT_ORDER = [
    'tiny',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'huge'
];
const $86defbb4e95ebb07$var$BREAKPOINT_CLASSES = {};
// grep: vjs-layout-tiny
// grep: vjs-layout-x-small
// grep: vjs-layout-small
// grep: vjs-layout-medium
// grep: vjs-layout-large
// grep: vjs-layout-x-large
// grep: vjs-layout-huge
$86defbb4e95ebb07$var$BREAKPOINT_ORDER.forEach((k)=>{
    const v = k.charAt(0) === 'x' ? `x-${k.substring(1)}` : k;
    $86defbb4e95ebb07$var$BREAKPOINT_CLASSES[k] = `vjs-layout-${v}`;
});
const $86defbb4e95ebb07$var$DEFAULT_BREAKPOINTS = {
    tiny: 210,
    xsmall: 320,
    small: 425,
    medium: 768,
    large: 1440,
    xlarge: 2560,
    huge: Infinity
};
/**
 * An instance of the `Player` class is created when any of the Video.js setup methods
 * are used to initialize a video.
 *
 * After an instance has been created it can be accessed globally in three ways:
 * 1. By calling `videojs.getPlayer('example_video_1');`
 * 2. By calling `videojs('example_video_1');` (not recommended)
 * 2. By using it directly via `videojs.players.example_video_1;`
 *
 * @extends Component
 * @global
 */ class $86defbb4e95ebb07$var$Player extends $86defbb4e95ebb07$var$Component$1 {
    /**
   * Create an instance of this class.
   *
   * @param {Element} tag
   *        The original video DOM element used for configuring options.
   *
   * @param {Object} [options]
   *        Object of option names and values.
   *
   * @param {PlayerReadyCallback} [ready]
   *        Ready callback function.
   */ constructor(tag, options, ready){
        // Make sure tag ID exists
        // also here.. probably better
        tag.id = tag.id || options.id || `vjs_video_${$86defbb4e95ebb07$var$newGUID()}`;
        // Set Options
        // The options argument overrides options set in the video tag
        // which overrides globally set options.
        // This latter part coincides with the load order
        // (tag must exist before Player)
        options = Object.assign($86defbb4e95ebb07$var$Player.getTagSettings(tag), options);
        // Delay the initialization of children because we need to set up
        // player properties first, and can't use `this` before `super()`
        options.initChildren = false;
        // Same with creating the element
        options.createEl = false;
        // don't auto mixin the evented mixin
        options.evented = false;
        // we don't want the player to report touch activity on itself
        // see enableTouchActivity in Component
        options.reportTouchActivity = false;
        // If language is not set, get the closest lang attribute
        if (!options.language) {
            const closest = tag.closest('[lang]');
            if (closest) options.language = closest.getAttribute('lang');
        }
        // Run base component initializing with new options
        super(null, options, ready);
        // Create bound methods for document listeners.
        this.boundDocumentFullscreenChange_ = (e)=>this.documentFullscreenChange_(e);
        this.boundFullWindowOnEscKey_ = (e)=>this.fullWindowOnEscKey(e);
        this.boundUpdateStyleEl_ = (e)=>this.updateStyleEl_(e);
        this.boundApplyInitTime_ = (e)=>this.applyInitTime_(e);
        this.boundUpdateCurrentBreakpoint_ = (e)=>this.updateCurrentBreakpoint_(e);
        this.boundHandleTechClick_ = (e)=>this.handleTechClick_(e);
        this.boundHandleTechDoubleClick_ = (e)=>this.handleTechDoubleClick_(e);
        this.boundHandleTechTouchStart_ = (e)=>this.handleTechTouchStart_(e);
        this.boundHandleTechTouchMove_ = (e)=>this.handleTechTouchMove_(e);
        this.boundHandleTechTouchEnd_ = (e)=>this.handleTechTouchEnd_(e);
        this.boundHandleTechTap_ = (e)=>this.handleTechTap_(e);
        this.boundUpdatePlayerHeightOnAudioOnlyMode_ = (e)=>this.updatePlayerHeightOnAudioOnlyMode_(e);
        // default isFullscreen_ to false
        this.isFullscreen_ = false;
        // create logger
        this.log = $86defbb4e95ebb07$var$createLogger(this.id_);
        // Hold our own reference to fullscreen api so it can be mocked in tests
        this.fsApi_ = $86defbb4e95ebb07$var$FullscreenApi;
        // Tracks when a tech changes the poster
        this.isPosterFromTech_ = false;
        // Holds callback info that gets queued when playback rate is zero
        // and a seek is happening
        this.queuedCallbacks_ = [];
        // Turn off API access because we're loading a new tech that might load asynchronously
        this.isReady_ = false;
        // Init state hasStarted_
        this.hasStarted_ = false;
        // Init state userActive_
        this.userActive_ = false;
        // Init debugEnabled_
        this.debugEnabled_ = false;
        // Init state audioOnlyMode_
        this.audioOnlyMode_ = false;
        // Init state audioPosterMode_
        this.audioPosterMode_ = false;
        // Init state audioOnlyCache_
        this.audioOnlyCache_ = {
            controlBarHeight: null,
            playerHeight: null,
            hiddenChildren: []
        };
        // if the global option object was accidentally blown away by
        // someone, bail early with an informative error
        if (!this.options_ || !this.options_.techOrder || !this.options_.techOrder.length) throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
        // Store the original tag used to set options
        this.tag = tag;
        // Store the tag attributes used to restore html5 element
        this.tagAttributes = tag && $86defbb4e95ebb07$var$getAttributes(tag);
        // Update current language
        this.language(this.options_.language);
        // Update Supported Languages
        if (options.languages) {
            // Normalise player option languages to lowercase
            const languagesToLower = {};
            Object.getOwnPropertyNames(options.languages).forEach(function(name) {
                languagesToLower[name.toLowerCase()] = options.languages[name];
            });
            this.languages_ = languagesToLower;
        } else this.languages_ = $86defbb4e95ebb07$var$Player.prototype.options_.languages;
        this.resetCache_();
        // Set poster
        /** @type string */ this.poster_ = options.poster || '';
        // Set controls
        /** @type {boolean} */ this.controls_ = !!options.controls;
        // Original tag settings stored in options
        // now remove immediately so native controls don't flash.
        // May be turned back on by HTML5 tech if nativeControlsForTouch is true
        tag.controls = false;
        tag.removeAttribute('controls');
        this.changingSrc_ = false;
        this.playCallbacks_ = [];
        this.playTerminatedQueue_ = [];
        // the attribute overrides the option
        if (tag.hasAttribute('autoplay')) this.autoplay(true);
        else // otherwise use the setter to validate and
        // set the correct value.
        this.autoplay(this.options_.autoplay);
        // check plugins
        if (options.plugins) Object.keys(options.plugins).forEach((name)=>{
            if (typeof this[name] !== 'function') throw new Error(`plugin "${name}" does not exist`);
        });
        /*
     * Store the internal state of scrubbing
     *
     * @private
     * @return {Boolean} True if the user is scrubbing
     */ this.scrubbing_ = false;
        this.el_ = this.createEl();
        // Make this an evented object and use `el_` as its event bus.
        $86defbb4e95ebb07$var$evented(this, {
            eventBusKey: 'el_'
        });
        // listen to document and player fullscreenchange handlers so we receive those events
        // before a user can receive them so we can update isFullscreen appropriately.
        // make sure that we listen to fullscreenchange events before everything else to make sure that
        // our isFullscreen method is updated properly for internal components as well as external.
        if (this.fsApi_.requestFullscreen) {
            $86defbb4e95ebb07$var$on((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))), this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
            this.on(this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
        }
        if (this.fluid_) this.on([
            'playerreset',
            'resize'
        ], this.boundUpdateStyleEl_);
        // We also want to pass the original player options to each component and plugin
        // as well so they don't need to reach back into the player for options later.
        // We also need to do another copy of this.options_ so we don't end up with
        // an infinite loop.
        const playerOptionsCopy = $86defbb4e95ebb07$var$merge$1(this.options_);
        // Load plugins
        if (options.plugins) Object.keys(options.plugins).forEach((name)=>{
            this[name](options.plugins[name]);
        });
        // Enable debug mode to fire debugon event for all plugins.
        if (options.debug) this.debug(true);
        this.options_.playerOptions = playerOptionsCopy;
        this.middleware_ = [];
        this.playbackRates(options.playbackRates);
        if (options.experimentalSvgIcons) {
            // Add SVG Sprite to the DOM
            const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).DOMParser();
            const parsedSVG = parser.parseFromString($86defbb4e95ebb07$var$icons, 'image/svg+xml');
            const errorNode = parsedSVG.querySelector('parsererror');
            if (errorNode) {
                $86defbb4e95ebb07$var$log$1.warn('Failed to load SVG Icons. Falling back to Font Icons.');
                this.options_.experimentalSvgIcons = null;
            } else {
                const sprite = parsedSVG.documentElement;
                sprite.style.display = 'none';
                this.el_.appendChild(sprite);
                this.addClass('vjs-svg-icons-enabled');
            }
        }
        this.initChildren();
        // Set isAudio based on whether or not an audio tag was used
        this.isAudio(tag.nodeName.toLowerCase() === 'audio');
        // Update controls className. Can't do this when the controls are initially
        // set because the element doesn't exist yet.
        if (this.controls()) this.addClass('vjs-controls-enabled');
        else this.addClass('vjs-controls-disabled');
        // Set ARIA label and region role depending on player type
        this.el_.setAttribute('role', 'region');
        if (this.isAudio()) this.el_.setAttribute('aria-label', this.localize('Audio Player'));
        else this.el_.setAttribute('aria-label', this.localize('Video Player'));
        if (this.isAudio()) this.addClass('vjs-audio');
        // Check if spatial navigation is enabled in the options.
        // If enabled, instantiate the SpatialNavigation class.
        if (options.spatialNavigation && options.spatialNavigation.enabled) {
            this.spatialNavigation = new $86defbb4e95ebb07$var$SpatialNavigation(this);
            this.addClass('vjs-spatial-navigation-enabled');
        }
        // TODO: Make this smarter. Toggle user state between touching/mousing
        // using events, since devices can have both touch and mouse events.
        // TODO: Make this check be performed again when the window switches between monitors
        // (See https://github.com/videojs/video.js/issues/5683)
        if ($86defbb4e95ebb07$var$TOUCH_ENABLED) this.addClass('vjs-touch-enabled');
        // iOS Safari has broken hover handling
        if (!$86defbb4e95ebb07$var$IS_IOS) this.addClass('vjs-workinghover');
        // Make player easily findable by ID
        $86defbb4e95ebb07$var$Player.players[this.id_] = this;
        // Add a major version class to aid css in plugins
        const majorVersion = $86defbb4e95ebb07$var$version$6.split('.')[0];
        this.addClass(`vjs-v${majorVersion}`);
        // When the player is first initialized, trigger activity so components
        // like the control bar show themselves if needed
        this.userActive(true);
        this.reportUserActivity();
        this.one('play', (e)=>this.listenForUserActivity_(e));
        this.on('keydown', (e)=>this.handleKeyDown(e));
        this.on('languagechange', (e)=>this.handleLanguagechange(e));
        this.breakpoints(this.options_.breakpoints);
        this.responsive(this.options_.responsive);
        // Calling both the audio mode methods after the player is fully
        // setup to be able to listen to the events triggered by them
        this.on('ready', ()=>{
            // Calling the audioPosterMode method first so that
            // the audioOnlyMode can take precedence when both options are set to true
            this.audioPosterMode(this.options_.audioPosterMode);
            this.audioOnlyMode(this.options_.audioOnlyMode);
        });
    }
    /**
   * Destroys the video player and does any necessary cleanup.
   *
   * This is especially helpful if you are dynamically adding and removing videos
   * to/from the DOM.
   *
   * @fires Player#dispose
   */ dispose() {
        /**
     * Called when the player is being disposed of.
     *
     * @event Player#dispose
     * @type {Event}
     */ this.trigger('dispose');
        // prevent dispose from being called twice
        this.off('dispose');
        // Make sure all player-specific document listeners are unbound. This is
        $86defbb4e95ebb07$var$off((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))), this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
        $86defbb4e95ebb07$var$off((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))), 'keydown', this.boundFullWindowOnEscKey_);
        if (this.styleEl_ && this.styleEl_.parentNode) {
            this.styleEl_.parentNode.removeChild(this.styleEl_);
            this.styleEl_ = null;
        }
        // Kill reference to this player
        $86defbb4e95ebb07$var$Player.players[this.id_] = null;
        if (this.tag && this.tag.player) this.tag.player = null;
        if (this.el_ && this.el_.player) this.el_.player = null;
        if (this.tech_) {
            this.tech_.dispose();
            this.isPosterFromTech_ = false;
            this.poster_ = '';
        }
        if (this.playerElIngest_) this.playerElIngest_ = null;
        if (this.tag) this.tag = null;
        $86defbb4e95ebb07$var$clearCacheForPlayer(this);
        // remove all event handlers for track lists
        // all tracks and track listeners are removed on
        // tech dispose
        $86defbb4e95ebb07$var$ALL.names.forEach((name)=>{
            const props = $86defbb4e95ebb07$var$ALL[name];
            const list = this[props.getterName]();
            // if it is not a native list
            // we have to manually remove event listeners
            if (list && list.off) list.off();
        });
        // the actual .el_ is removed here, or replaced if
        super.dispose({
            restoreEl: this.options_.restoreEl
        });
    }
    /**
   * Create the `Player`'s DOM element.
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        let tag = this.tag;
        let el;
        let playerElIngest = this.playerElIngest_ = tag.parentNode && tag.parentNode.hasAttribute && tag.parentNode.hasAttribute('data-vjs-player');
        const divEmbed = this.tag.tagName.toLowerCase() === 'video-js';
        if (playerElIngest) el = this.el_ = tag.parentNode;
        else if (!divEmbed) el = this.el_ = super.createEl('div');
        // Copy over all the attributes from the tag, including ID and class
        // ID will now reference player box, not the video tag
        const attrs = $86defbb4e95ebb07$var$getAttributes(tag);
        if (divEmbed) {
            el = this.el_ = tag;
            tag = this.tag = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('video');
            while(el.children.length)tag.appendChild(el.firstChild);
            if (!$86defbb4e95ebb07$var$hasClass(el, 'video-js')) $86defbb4e95ebb07$var$addClass(el, 'video-js');
            el.appendChild(tag);
            playerElIngest = this.playerElIngest_ = el;
            // move properties over from our custom `video-js` element
            // to our new `video` element. This will move things like
            // `src` or `controls` that were set via js before the player
            // was initialized.
            Object.keys(el).forEach((k)=>{
                try {
                    tag[k] = el[k];
                } catch (e) {
                // we got a a property like outerHTML which we can't actually copy, ignore it
                }
            });
        }
        // set tabindex to -1 to remove the video element from the focus order
        tag.setAttribute('tabindex', '-1');
        attrs.tabindex = '-1';
        // Workaround for #4583 on Chrome (on Windows) with JAWS.
        // See https://github.com/FreedomScientific/VFO-standards-support/issues/78
        // Note that we can't detect if JAWS is being used, but this ARIA attribute
        // doesn't change behavior of Chrome if JAWS is not being used
        if ($86defbb4e95ebb07$var$IS_CHROME && $86defbb4e95ebb07$var$IS_WINDOWS) {
            tag.setAttribute('role', 'application');
            attrs.role = 'application';
        }
        // Remove width/height attrs from tag so CSS can make it 100% width/height
        tag.removeAttribute('width');
        tag.removeAttribute('height');
        if ('width' in attrs) delete attrs.width;
        if ('height' in attrs) delete attrs.height;
        Object.getOwnPropertyNames(attrs).forEach(function(attr) {
            // don't copy over the class attribute to the player element when we're in a div embed
            // the class is already set up properly in the divEmbed case
            // and we want to make sure that the `video-js` class doesn't get lost
            if (!(divEmbed && attr === 'class')) el.setAttribute(attr, attrs[attr]);
            if (divEmbed) tag.setAttribute(attr, attrs[attr]);
        });
        // Update tag id/class for use as HTML5 playback tech
        // Might think we should do this after embedding in container so .vjs-tech class
        // doesn't flash 100% width/height, but class only applies with .video-js parent
        tag.playerId = tag.id;
        tag.id += '_html5_api';
        tag.className = 'vjs-tech';
        // Make player findable on elements
        tag.player = el.player = this;
        // Default state of video is paused
        this.addClass('vjs-paused');
        const deviceClassNames = [
            'IS_SMART_TV',
            'IS_TIZEN',
            'IS_WEBOS',
            'IS_ANDROID',
            'IS_IPAD',
            'IS_IPHONE',
            'IS_CHROMECAST_RECEIVER'
        ].filter((key)=>$86defbb4e95ebb07$var$browser[key]).map((key)=>{
            return 'vjs-device-' + key.substring(3).toLowerCase().replace(/\_/g, '-');
        });
        this.addClass(...deviceClassNames);
        // Add a style element in the player that we'll use to set the width/height
        // of the player in a way that's still overridable by CSS, just like the
        // video element
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).VIDEOJS_NO_DYNAMIC_STYLE !== true) {
            this.styleEl_ = $86defbb4e95ebb07$var$createStyleElement('vjs-styles-dimensions');
            const defaultsStyleEl = $86defbb4e95ebb07$var$$('.vjs-styles-defaults');
            const head = $86defbb4e95ebb07$var$$('head');
            head.insertBefore(this.styleEl_, defaultsStyleEl ? defaultsStyleEl.nextSibling : head.firstChild);
        }
        this.fill_ = false;
        this.fluid_ = false;
        // Pass in the width/height/aspectRatio options which will update the style el
        this.width(this.options_.width);
        this.height(this.options_.height);
        this.fill(this.options_.fill);
        this.fluid(this.options_.fluid);
        this.aspectRatio(this.options_.aspectRatio);
        // support both crossOrigin and crossorigin to reduce confusion and issues around the name
        this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
        // Hide any links within the video/audio tag,
        // because IE doesn't hide them completely from screen readers.
        const links = tag.getElementsByTagName('a');
        for(let i = 0; i < links.length; i++){
            const linkEl = links.item(i);
            $86defbb4e95ebb07$var$addClass(linkEl, 'vjs-hidden');
            linkEl.setAttribute('hidden', 'hidden');
        }
        // insertElFirst seems to cause the networkState to flicker from 3 to 2, so
        // keep track of the original for later so we can know if the source originally failed
        tag.initNetworkState_ = tag.networkState;
        // Wrap video tag in div (el/box) container
        if (tag.parentNode && !playerElIngest) tag.parentNode.insertBefore(el, tag);
        // insert the tag as the first child of the player element
        // then manually add it to the children array so that this.addChild
        // will work properly for other components
        //
        // Breaks iPhone, fixed in HTML5 setup.
        $86defbb4e95ebb07$var$prependTo(tag, el);
        this.children_.unshift(tag);
        // Set lang attr on player to ensure CSS :lang() in consistent with player
        // if it's been set to something different to the doc
        this.el_.setAttribute('lang', this.language_);
        this.el_.setAttribute('translate', 'no');
        this.el_ = el;
        return el;
    }
    /**
   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
   * behavior.
   *
   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
   *
   * @param {string|null} [value]
   *        The value to set the `Player`'s crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null|undefined}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */ crossOrigin(value) {
        // `null` can be set to unset a value
        if (typeof value === 'undefined') return this.techGet_('crossOrigin');
        if (value !== null && value !== 'anonymous' && value !== 'use-credentials') {
            $86defbb4e95ebb07$var$log$1.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${value}"`);
            return;
        }
        this.techCall_('setCrossOrigin', value);
        if (this.posterImage) this.posterImage.crossOrigin(value);
        return;
    }
    /**
   * A getter/setter for the `Player`'s width. Returns the player's configured value.
   * To get the current width use `currentWidth()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s width to.
   *
   * @return {number|undefined}
   *         - The current width of the `Player` when getting.
   *         - Nothing when setting
   */ width(value) {
        return this.dimension('width', value);
    }
    /**
   * A getter/setter for the `Player`'s height. Returns the player's configured value.
   * To get the current height use `currentheight()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s height to.
   *
   * @return {number|undefined}
   *         - The current height of the `Player` when getting.
   *         - Nothing when setting
   */ height(value) {
        return this.dimension('height', value);
    }
    /**
   * A getter/setter for the `Player`'s width & height.
   *
   * @param {string} dimension
   *        This string can be:
   *        - 'width'
   *        - 'height'
   *
   * @param {number|string} [value]
   *        Value for dimension specified in the first argument.
   *
   * @return {number}
   *         The dimension arguments value when getting (width/height).
   */ dimension(dimension, value) {
        const privDimension = dimension + '_';
        if (value === undefined) return this[privDimension] || 0;
        if (value === '' || value === 'auto') {
            // If an empty string is given, reset the dimension to be automatic
            this[privDimension] = undefined;
            this.updateStyleEl_();
            return;
        }
        const parsedVal = parseFloat(value);
        if (isNaN(parsedVal)) {
            $86defbb4e95ebb07$var$log$1.error(`Improper value "${value}" supplied for for ${dimension}`);
            return;
        }
        this[privDimension] = parsedVal;
        this.updateStyleEl_();
    }
    /**
   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
   *
   * Turning this on will turn off fill mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */ fluid(bool) {
        if (bool === undefined) return !!this.fluid_;
        this.fluid_ = !!bool;
        if ($86defbb4e95ebb07$var$isEvented(this)) this.off([
            'playerreset',
            'resize'
        ], this.boundUpdateStyleEl_);
        if (bool) {
            this.addClass('vjs-fluid');
            this.fill(false);
            $86defbb4e95ebb07$var$addEventedCallback(this, ()=>{
                this.on([
                    'playerreset',
                    'resize'
                ], this.boundUpdateStyleEl_);
            });
        } else this.removeClass('vjs-fluid');
        this.updateStyleEl_();
    }
    /**
   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
   *
   * Turning this on will turn off fluid mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */ fill(bool) {
        if (bool === undefined) return !!this.fill_;
        this.fill_ = !!bool;
        if (bool) {
            this.addClass('vjs-fill');
            this.fluid(false);
        } else this.removeClass('vjs-fill');
    }
    /**
   * Get/Set the aspect ratio
   *
   * @param {string} [ratio]
   *        Aspect ratio for player
   *
   * @return {string|undefined}
   *         returns the current aspect ratio when getting
   */ /**
   * A getter/setter for the `Player`'s aspect ratio.
   *
   * @param {string} [ratio]
   *        The value to set the `Player`'s aspect ratio to.
   *
   * @return {string|undefined}
   *         - The current aspect ratio of the `Player` when getting.
   *         - undefined when setting
   */ aspectRatio(ratio) {
        if (ratio === undefined) return this.aspectRatio_;
        // Check for width:height format
        if (!/^\d+\:\d+$/.test(ratio)) throw new Error('Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.');
        this.aspectRatio_ = ratio;
        // We're assuming if you set an aspect ratio you want fluid mode,
        // because in fixed mode you could calculate width and height yourself.
        this.fluid(true);
        this.updateStyleEl_();
    }
    /**
   * Update styles of the `Player` element (height, width and aspect ratio).
   *
   * @private
   * @listens Tech#loadedmetadata
   */ updateStyleEl_() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).VIDEOJS_NO_DYNAMIC_STYLE === true) {
            const width = typeof this.width_ === 'number' ? this.width_ : this.options_.width;
            const height = typeof this.height_ === 'number' ? this.height_ : this.options_.height;
            const techEl = this.tech_ && this.tech_.el();
            if (techEl) {
                if (width >= 0) techEl.width = width;
                if (height >= 0) techEl.height = height;
            }
            return;
        }
        let width;
        let height;
        let aspectRatio;
        let idClass;
        // The aspect ratio is either used directly or to calculate width and height.
        if (this.aspectRatio_ !== undefined && this.aspectRatio_ !== 'auto') // Use any aspectRatio that's been specifically set
        aspectRatio = this.aspectRatio_;
        else if (this.videoWidth() > 0) // Otherwise try to get the aspect ratio from the video metadata
        aspectRatio = this.videoWidth() + ':' + this.videoHeight();
        else // Or use a default. The video element's is 2:1, but 16:9 is more common.
        aspectRatio = '16:9';
        // Get the ratio as a decimal we can use to calculate dimensions
        const ratioParts = aspectRatio.split(':');
        const ratioMultiplier = ratioParts[1] / ratioParts[0];
        if (this.width_ !== undefined) // Use any width that's been specifically set
        width = this.width_;
        else if (this.height_ !== undefined) // Or calculate the width from the aspect ratio if a height has been set
        width = this.height_ / ratioMultiplier;
        else // Or use the video's metadata, or use the video el's default of 300
        width = this.videoWidth() || 300;
        if (this.height_ !== undefined) // Use any height that's been specifically set
        height = this.height_;
        else // Otherwise calculate the height from the ratio and the width
        height = width * ratioMultiplier;
        // Ensure the CSS class is valid by starting with an alpha character
        if (/^[^a-zA-Z]/.test(this.id())) idClass = 'dimensions-' + this.id();
        else idClass = this.id() + '-dimensions';
        // Ensure the right class is still on the player for the style element
        this.addClass(idClass);
        $86defbb4e95ebb07$var$setTextContent(this.styleEl_, `
      .${idClass} {
        width: ${width}px;
        height: ${height}px;
      }

      .${idClass}.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ${ratioMultiplier * 100}%;
      }
    `);
    }
    /**
   * Load/Create an instance of playback {@link Tech} including element
   * and API methods. Then append the `Tech` element in `Player` as a child.
   *
   * @param {string} techName
   *        name of the playback technology
   *
   * @param {string} source
   *        video source
   *
   * @private
   */ loadTech_(techName, source) {
        // Pause and remove current playback technology
        if (this.tech_) this.unloadTech_();
        const titleTechName = $86defbb4e95ebb07$var$toTitleCase$1(techName);
        const camelTechName = techName.charAt(0).toLowerCase() + techName.slice(1);
        // get rid of the HTML5 video tag as soon as we are using another tech
        if (titleTechName !== 'Html5' && this.tag) {
            $86defbb4e95ebb07$var$Tech.getTech('Html5').disposeMediaElement(this.tag);
            this.tag.player = null;
            this.tag = null;
        }
        this.techName_ = titleTechName;
        // Turn off API access because we're loading a new tech that might load asynchronously
        this.isReady_ = false;
        let autoplay = this.autoplay();
        // if autoplay is a string (or `true` with normalizeAutoplay: true) we pass false to the tech
        // because the player is going to handle autoplay on `loadstart`
        if (typeof this.autoplay() === 'string' || this.autoplay() === true && this.options_.normalizeAutoplay) autoplay = false;
        // Grab tech-specific options from player options and add source and parent element to use.
        const techOptions = {
            source: source,
            autoplay: autoplay,
            'nativeControlsForTouch': this.options_.nativeControlsForTouch,
            'playerId': this.id(),
            'techId': `${this.id()}_${camelTechName}_api`,
            'playsinline': this.options_.playsinline,
            'preload': this.options_.preload,
            'loop': this.options_.loop,
            'disablePictureInPicture': this.options_.disablePictureInPicture,
            'muted': this.options_.muted,
            'poster': this.poster(),
            'language': this.language(),
            'playerElIngest': this.playerElIngest_ || false,
            'vtt.js': this.options_['vtt.js'],
            'canOverridePoster': !!this.options_.techCanOverridePoster,
            'enableSourceset': this.options_.enableSourceset
        };
        $86defbb4e95ebb07$var$ALL.names.forEach((name)=>{
            const props = $86defbb4e95ebb07$var$ALL[name];
            techOptions[props.getterName] = this[props.privateName];
        });
        Object.assign(techOptions, this.options_[titleTechName]);
        Object.assign(techOptions, this.options_[camelTechName]);
        Object.assign(techOptions, this.options_[techName.toLowerCase()]);
        if (this.tag) techOptions.tag = this.tag;
        if (source && source.src === this.cache_.src && this.cache_.currentTime > 0) techOptions.startTime = this.cache_.currentTime;
        // Initialize tech instance
        const TechClass = $86defbb4e95ebb07$var$Tech.getTech(techName);
        if (!TechClass) throw new Error(`No Tech named '${titleTechName}' exists! '${titleTechName}' should be registered using videojs.registerTech()'`);
        this.tech_ = new TechClass(techOptions);
        // player.triggerReady is always async, so don't need this to be async
        this.tech_.ready($86defbb4e95ebb07$var$bind_(this, this.handleTechReady_), true);
        $86defbb4e95ebb07$var$textTrackConverter.jsonToTextTracks(this.textTracksJson_ || [], this.tech_);
        // Listen to all HTML5-defined events and trigger them on the player
        $86defbb4e95ebb07$var$TECH_EVENTS_RETRIGGER.forEach((event)=>{
            this.on(this.tech_, event, (e)=>this[`handleTech${$86defbb4e95ebb07$var$toTitleCase$1(event)}_`](e));
        });
        Object.keys($86defbb4e95ebb07$var$TECH_EVENTS_QUEUE).forEach((event)=>{
            this.on(this.tech_, event, (eventObj)=>{
                if (this.tech_.playbackRate() === 0 && this.tech_.seeking()) {
                    this.queuedCallbacks_.push({
                        callback: this[`handleTech${$86defbb4e95ebb07$var$TECH_EVENTS_QUEUE[event]}_`].bind(this),
                        event: eventObj
                    });
                    return;
                }
                this[`handleTech${$86defbb4e95ebb07$var$TECH_EVENTS_QUEUE[event]}_`](eventObj);
            });
        });
        this.on(this.tech_, 'loadstart', (e)=>this.handleTechLoadStart_(e));
        this.on(this.tech_, 'sourceset', (e)=>this.handleTechSourceset_(e));
        this.on(this.tech_, 'waiting', (e)=>this.handleTechWaiting_(e));
        this.on(this.tech_, 'ended', (e)=>this.handleTechEnded_(e));
        this.on(this.tech_, 'seeking', (e)=>this.handleTechSeeking_(e));
        this.on(this.tech_, 'play', (e)=>this.handleTechPlay_(e));
        this.on(this.tech_, 'pause', (e)=>this.handleTechPause_(e));
        this.on(this.tech_, 'durationchange', (e)=>this.handleTechDurationChange_(e));
        this.on(this.tech_, 'fullscreenchange', (e, data)=>this.handleTechFullscreenChange_(e, data));
        this.on(this.tech_, 'fullscreenerror', (e, err)=>this.handleTechFullscreenError_(e, err));
        this.on(this.tech_, 'enterpictureinpicture', (e)=>this.handleTechEnterPictureInPicture_(e));
        this.on(this.tech_, 'leavepictureinpicture', (e)=>this.handleTechLeavePictureInPicture_(e));
        this.on(this.tech_, 'error', (e)=>this.handleTechError_(e));
        this.on(this.tech_, 'posterchange', (e)=>this.handleTechPosterChange_(e));
        this.on(this.tech_, 'textdata', (e)=>this.handleTechTextData_(e));
        this.on(this.tech_, 'ratechange', (e)=>this.handleTechRateChange_(e));
        this.on(this.tech_, 'loadedmetadata', this.boundUpdateStyleEl_);
        this.usingNativeControls(this.techGet_('controls'));
        if (this.controls() && !this.usingNativeControls()) this.addTechControlsListeners_();
        // Add the tech element in the DOM if it was not already there
        // Make sure to not insert the original video element if using Html5
        if (this.tech_.el().parentNode !== this.el() && (titleTechName !== 'Html5' || !this.tag)) $86defbb4e95ebb07$var$prependTo(this.tech_.el(), this.el());
        // Get rid of the original video tag reference after the first tech is loaded
        if (this.tag) {
            this.tag.player = null;
            this.tag = null;
        }
    }
    /**
   * Unload and dispose of the current playback {@link Tech}.
   *
   * @private
   */ unloadTech_() {
        // Save the current text tracks so that we can reuse the same text tracks with the next tech
        $86defbb4e95ebb07$var$ALL.names.forEach((name)=>{
            const props = $86defbb4e95ebb07$var$ALL[name];
            this[props.privateName] = this[props.getterName]();
        });
        this.textTracksJson_ = $86defbb4e95ebb07$var$textTrackConverter.textTracksToJson(this.tech_);
        this.isReady_ = false;
        this.tech_.dispose();
        this.tech_ = false;
        if (this.isPosterFromTech_) {
            this.poster_ = '';
            this.trigger('posterchange');
        }
        this.isPosterFromTech_ = false;
    }
    /**
   * Return a reference to the current {@link Tech}.
   * It will print a warning by default about the danger of using the tech directly
   * but any argument that is passed in will silence the warning.
   *
   * @param {*} [safety]
   *        Anything passed in to silence the warning
   *
   * @return {Tech}
   *         The Tech
   */ tech(safety) {
        if (safety === undefined) $86defbb4e95ebb07$var$log$1.warn("Using the tech directly can be dangerous. I hope you know what you're doing.\nSee https://github.com/videojs/video.js/issues/2617 for more info.\n");
        return this.tech_;
    }
    /**
   * An object that contains Video.js version.
   *
   * @typedef {Object} PlayerVersion
   *
   * @property {string} 'video.js' - Video.js version
   */ /**
   * Returns an object with Video.js version.
   *
   * @return {PlayerVersion}
   *          An object with Video.js version.
   */ version() {
        return {
            'video.js': $86defbb4e95ebb07$var$version$6
        };
    }
    /**
   * Set up click and touch listeners for the playback element
   *
   * - On desktops: a click on the video itself will toggle playback
   * - On mobile devices: a click on the video toggles controls
   *   which is done by toggling the user state between active and
   *   inactive
   * - A tap can signal that a user has become active or has become inactive
   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
   *   quick tap should hide them again (signaling the user is in an inactive
   *   viewing state)
   * - In addition to this, we still want the user to be considered inactive after
   *   a few seconds of inactivity.
   *
   * > Note: the only part of iOS interaction we can't mimic with this setup
   * is a touch and hold on the video element counting as activity in order to
   * keep the controls showing, but that shouldn't be an issue. A touch and hold
   * on any controls will still keep the user active
   *
   * @private
   */ addTechControlsListeners_() {
        // Make sure to remove all the previous listeners in case we are called multiple times.
        this.removeTechControlsListeners_();
        this.on(this.tech_, 'click', this.boundHandleTechClick_);
        this.on(this.tech_, 'dblclick', this.boundHandleTechDoubleClick_);
        // If the controls were hidden we don't want that to change without a tap event
        // so we'll check if the controls were already showing before reporting user
        // activity
        this.on(this.tech_, 'touchstart', this.boundHandleTechTouchStart_);
        this.on(this.tech_, 'touchmove', this.boundHandleTechTouchMove_);
        this.on(this.tech_, 'touchend', this.boundHandleTechTouchEnd_);
        // The tap listener needs to come after the touchend listener because the tap
        // listener cancels out any reportedUserActivity when setting userActive(false)
        this.on(this.tech_, 'tap', this.boundHandleTechTap_);
    }
    /**
   * Remove the listeners used for click and tap controls. This is needed for
   * toggling to controls disabled, where a tap/touch should do nothing.
   *
   * @private
   */ removeTechControlsListeners_() {
        // We don't want to just use `this.off()` because there might be other needed
        // listeners added by techs that extend this.
        this.off(this.tech_, 'tap', this.boundHandleTechTap_);
        this.off(this.tech_, 'touchstart', this.boundHandleTechTouchStart_);
        this.off(this.tech_, 'touchmove', this.boundHandleTechTouchMove_);
        this.off(this.tech_, 'touchend', this.boundHandleTechTouchEnd_);
        this.off(this.tech_, 'click', this.boundHandleTechClick_);
        this.off(this.tech_, 'dblclick', this.boundHandleTechDoubleClick_);
    }
    /**
   * Player waits for the tech to be ready
   *
   * @private
   */ handleTechReady_() {
        this.triggerReady();
        // Keep the same volume as before
        if (this.cache_.volume) this.techCall_('setVolume', this.cache_.volume);
        // Look if the tech found a higher resolution poster while loading
        this.handleTechPosterChange_();
        // Update the duration if available
        this.handleTechDurationChange_();
    }
    /**
   * Retrigger the `loadstart` event that was triggered by the {@link Tech}.
   *
   * @fires Player#loadstart
   * @listens Tech#loadstart
   * @private
   */ handleTechLoadStart_() {
        // TODO: Update to use `emptied` event instead. See #1277.
        this.removeClass('vjs-ended', 'vjs-seeking');
        // reset the error state
        this.error(null);
        // Update the duration
        this.handleTechDurationChange_();
        if (!this.paused()) /**
       * Fired when the user agent begins looking for media data
       *
       * @event Player#loadstart
       * @type {Event}
       */ this.trigger('loadstart');
        else {
            // reset the hasStarted state
            this.hasStarted(false);
            this.trigger('loadstart');
        }
        // autoplay happens after loadstart for the browser,
        // so we mimic that behavior
        this.manualAutoplay_(this.autoplay() === true && this.options_.normalizeAutoplay ? 'play' : this.autoplay());
    }
    /**
   * Handle autoplay string values, rather than the typical boolean
   * values that should be handled by the tech. Note that this is not
   * part of any specification. Valid values and what they do can be
   * found on the autoplay getter at Player#autoplay()
   */ manualAutoplay_(type) {
        if (!this.tech_ || typeof type !== 'string') return;
        // Save original muted() value, set muted to true, and attempt to play().
        // On promise rejection, restore muted from saved value
        const resolveMuted = ()=>{
            const previouslyMuted = this.muted();
            this.muted(true);
            const restoreMuted = ()=>{
                this.muted(previouslyMuted);
            };
            // restore muted on play terminatation
            this.playTerminatedQueue_.push(restoreMuted);
            const mutedPromise = this.play();
            if (!$86defbb4e95ebb07$var$isPromise(mutedPromise)) return;
            return mutedPromise.catch((err)=>{
                restoreMuted();
                throw new Error(`Rejection at manualAutoplay. Restoring muted value. ${err ? err : ''}`);
            });
        };
        let promise;
        // if muted defaults to true
        // the only thing we can do is call play
        if (type === 'any' && !this.muted()) {
            promise = this.play();
            if ($86defbb4e95ebb07$var$isPromise(promise)) promise = promise.catch(resolveMuted);
        } else if (type === 'muted' && !this.muted()) promise = resolveMuted();
        else promise = this.play();
        if (!$86defbb4e95ebb07$var$isPromise(promise)) return;
        return promise.then(()=>{
            this.trigger({
                type: 'autoplay-success',
                autoplay: type
            });
        }).catch(()=>{
            this.trigger({
                type: 'autoplay-failure',
                autoplay: type
            });
        });
    }
    /**
   * Update the internal source caches so that we return the correct source from
   * `src()`, `currentSource()`, and `currentSources()`.
   *
   * > Note: `currentSources` will not be updated if the source that is passed in exists
   *         in the current `currentSources` cache.
   *
   *
   * @param {Tech~SourceObject} srcObj
   *        A string or object source to update our caches to.
   */ updateSourceCaches_(srcObj = '') {
        let src = srcObj;
        let type = '';
        if (typeof src !== 'string') {
            src = srcObj.src;
            type = srcObj.type;
        }
        // make sure all the caches are set to default values
        // to prevent null checking
        this.cache_.source = this.cache_.source || {};
        this.cache_.sources = this.cache_.sources || [];
        // try to get the type of the src that was passed in
        if (src && !type) type = $86defbb4e95ebb07$var$findMimetype(this, src);
        // update `currentSource` cache always
        this.cache_.source = $86defbb4e95ebb07$var$merge$1({}, srcObj, {
            src: src,
            type: type
        });
        const matchingSources = this.cache_.sources.filter((s)=>s.src && s.src === src);
        const sourceElSources = [];
        const sourceEls = this.$$('source');
        const matchingSourceEls = [];
        for(let i = 0; i < sourceEls.length; i++){
            const sourceObj = $86defbb4e95ebb07$var$getAttributes(sourceEls[i]);
            sourceElSources.push(sourceObj);
            if (sourceObj.src && sourceObj.src === src) matchingSourceEls.push(sourceObj.src);
        }
        // if we have matching source els but not matching sources
        // the current source cache is not up to date
        if (matchingSourceEls.length && !matchingSources.length) this.cache_.sources = sourceElSources;
        else if (!matchingSources.length) this.cache_.sources = [
            this.cache_.source
        ];
        // update the tech `src` cache
        this.cache_.src = src;
    }
    /**
   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
   * causing the media element to reload.
   *
   * It will fire for the initial source and each subsequent source.
   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
   *
   * The event object for this event contains a `src` property that will contain the source
   * that was available when the event was triggered. This is generally only necessary if Video.js
   * is switching techs while the source was being changed.
   *
   * It is also fired when `load` is called on the player (or media element)
   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
   * says that the resource selection algorithm needs to be aborted and restarted.
   * In this case, it is very likely that the `src` property will be set to the
   * empty string `""` to indicate we do not know what the source will be but
   * that it is changing.
   *
   * *This event is currently still experimental and may change in minor releases.*
   * __To use this, pass `enableSourceset` option to the player.__
   *
   * @event Player#sourceset
   * @type {Event}
   * @prop {string} src
   *                The source url available when the `sourceset` was triggered.
   *                It will be an empty string if we cannot know what the source is
   *                but know that the source will change.
   */ /**
   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
   *
   * @fires Player#sourceset
   * @listens Tech#sourceset
   * @private
   */ handleTechSourceset_(event) {
        // only update the source cache when the source
        // was not updated using the player api
        if (!this.changingSrc_) {
            let updateSourceCaches = (src)=>this.updateSourceCaches_(src);
            const playerSrc = this.currentSource().src;
            const eventSrc = event.src;
            // if we have a playerSrc that is not a blob, and a tech src that is a blob
            if (playerSrc && !/^blob:/.test(playerSrc) && /^blob:/.test(eventSrc)) // if both the tech source and the player source were updated we assume
            // something like @videojs/http-streaming did the sourceset and skip updating the source cache.
            {
                if (!this.lastSource_ || this.lastSource_.tech !== eventSrc && this.lastSource_.player !== playerSrc) updateSourceCaches = ()=>{};
            }
            // update the source to the initial source right away
            // in some cases this will be empty string
            updateSourceCaches(eventSrc);
            // if the `sourceset` `src` was an empty string
            // wait for a `loadstart` to update the cache to `currentSrc`.
            // If a sourceset happens before a `loadstart`, we reset the state
            if (!event.src) this.tech_.any([
                'sourceset',
                'loadstart'
            ], (e)=>{
                // if a sourceset happens before a `loadstart` there
                // is nothing to do as this `handleTechSourceset_`
                // will be called again and this will be handled there.
                if (e.type === 'sourceset') return;
                const techSrc = this.techGet_('currentSrc');
                this.lastSource_.tech = techSrc;
                this.updateSourceCaches_(techSrc);
            });
        }
        this.lastSource_ = {
            player: this.currentSource().src,
            tech: event.src
        };
        this.trigger({
            src: event.src,
            type: 'sourceset'
        });
    }
    /**
   * Add/remove the vjs-has-started class
   *
   *
   * @param {boolean} request
   *        - true: adds the class
   *        - false: remove the class
   *
   * @return {boolean}
   *         the boolean value of hasStarted_
   */ hasStarted(request) {
        if (request === undefined) // act as getter, if we have no request to change
        return this.hasStarted_;
        if (request === this.hasStarted_) return;
        this.hasStarted_ = request;
        if (this.hasStarted_) this.addClass('vjs-has-started');
        else this.removeClass('vjs-has-started');
    }
    /**
   * Fired whenever the media begins or resumes playback
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
   * @fires Player#play
   * @listens Tech#play
   * @private
   */ handleTechPlay_() {
        this.removeClass('vjs-ended', 'vjs-paused');
        this.addClass('vjs-playing');
        // hide the poster when the user hits play
        this.hasStarted(true);
        /**
     * Triggered whenever an {@link Tech#play} event happens. Indicates that
     * playback has started or resumed.
     *
     * @event Player#play
     * @type {Event}
     */ this.trigger('play');
    }
    /**
   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
   *
   * If there were any events queued while the playback rate was zero, fire
   * those events now.
   *
   * @private
   * @method Player#handleTechRateChange_
   * @fires Player#ratechange
   * @listens Tech#ratechange
   */ handleTechRateChange_() {
        if (this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0) {
            this.queuedCallbacks_.forEach((queued)=>queued.callback(queued.event));
            this.queuedCallbacks_ = [];
        }
        this.cache_.lastPlaybackRate = this.tech_.playbackRate();
        /**
     * Fires when the playing speed of the audio/video is changed
     *
     * @event Player#ratechange
     * @type {event}
     */ this.trigger('ratechange');
    }
    /**
   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
   *
   * @fires Player#waiting
   * @listens Tech#waiting
   * @private
   */ handleTechWaiting_() {
        this.addClass('vjs-waiting');
        /**
     * A readyState change on the DOM element has caused playback to stop.
     *
     * @event Player#waiting
     * @type {Event}
     */ this.trigger('waiting');
        // Browsers may emit a timeupdate event after a waiting event. In order to prevent
        // premature removal of the waiting class, wait for the time to change.
        const timeWhenWaiting = this.currentTime();
        const timeUpdateListener = ()=>{
            if (timeWhenWaiting !== this.currentTime()) {
                this.removeClass('vjs-waiting');
                this.off('timeupdate', timeUpdateListener);
            }
        };
        this.on('timeupdate', timeUpdateListener);
    }
    /**
   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
   * > Note: This is not consistent between browsers. See #1351
   *
   * @fires Player#canplay
   * @listens Tech#canplay
   * @private
   */ handleTechCanPlay_() {
        this.removeClass('vjs-waiting');
        /**
     * The media has a readyState of HAVE_FUTURE_DATA or greater.
     *
     * @event Player#canplay
     * @type {Event}
     */ this.trigger('canplay');
    }
    /**
   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
   *
   * @fires Player#canplaythrough
   * @listens Tech#canplaythrough
   * @private
   */ handleTechCanPlayThrough_() {
        this.removeClass('vjs-waiting');
        /**
     * The media has a readyState of HAVE_ENOUGH_DATA or greater. This means that the
     * entire media file can be played without buffering.
     *
     * @event Player#canplaythrough
     * @type {Event}
     */ this.trigger('canplaythrough');
    }
    /**
   * Retrigger the `playing` event that was triggered by the {@link Tech}.
   *
   * @fires Player#playing
   * @listens Tech#playing
   * @private
   */ handleTechPlaying_() {
        this.removeClass('vjs-waiting');
        /**
     * The media is no longer blocked from playback, and has started playing.
     *
     * @event Player#playing
     * @type {Event}
     */ this.trigger('playing');
    }
    /**
   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeking
   * @listens Tech#seeking
   * @private
   */ handleTechSeeking_() {
        this.addClass('vjs-seeking');
        /**
     * Fired whenever the player is jumping to a new time
     *
     * @event Player#seeking
     * @type {Event}
     */ this.trigger('seeking');
    }
    /**
   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeked
   * @listens Tech#seeked
   * @private
   */ handleTechSeeked_() {
        this.removeClass('vjs-seeking', 'vjs-ended');
        /**
     * Fired when the player has finished jumping to a new time
     *
     * @event Player#seeked
     * @type {Event}
     */ this.trigger('seeked');
    }
    /**
   * Retrigger the `pause` event that was triggered by the {@link Tech}.
   *
   * @fires Player#pause
   * @listens Tech#pause
   * @private
   */ handleTechPause_() {
        this.removeClass('vjs-playing');
        this.addClass('vjs-paused');
        /**
     * Fired whenever the media has been paused
     *
     * @event Player#pause
     * @type {Event}
     */ this.trigger('pause');
    }
    /**
   * Retrigger the `ended` event that was triggered by the {@link Tech}.
   *
   * @fires Player#ended
   * @listens Tech#ended
   * @private
   */ handleTechEnded_() {
        this.addClass('vjs-ended');
        this.removeClass('vjs-waiting');
        if (this.options_.loop) {
            this.currentTime(0);
            this.play();
        } else if (!this.paused()) this.pause();
        /**
     * Fired when the end of the media resource is reached (currentTime == duration)
     *
     * @event Player#ended
     * @type {Event}
     */ this.trigger('ended');
    }
    /**
   * Fired when the duration of the media resource is first known or changed
   *
   * @listens Tech#durationchange
   * @private
   */ handleTechDurationChange_() {
        this.duration(this.techGet_('duration'));
    }
    /**
   * Handle a click on the media element to play/pause
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#click
   * @private
   */ handleTechClick_(event) {
        // When controls are disabled a click should not toggle playback because
        // the click is considered a control
        if (!this.controls_) return;
        if (this.options_ === undefined || this.options_.userActions === undefined || this.options_.userActions.click === undefined || this.options_.userActions.click !== false) {
            if (this.options_ !== undefined && this.options_.userActions !== undefined && typeof this.options_.userActions.click === 'function') this.options_.userActions.click.call(this, event);
            else if (this.paused()) $86defbb4e95ebb07$var$silencePromise(this.play());
            else this.pause();
        }
    }
    /**
   * Handle a double-click on the media element to enter/exit fullscreen,
   * or exit documentPictureInPicture mode
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#dblclick
   * @private
   */ handleTechDoubleClick_(event) {
        if (!this.controls_) return;
        // we do not want to toggle fullscreen state
        // when double-clicking inside a control bar or a modal
        const inAllowedEls = Array.prototype.some.call(this.$$('.vjs-control-bar, .vjs-modal-dialog'), (el)=>el.contains(event.target));
        if (!inAllowedEls) /*
       * options.userActions.doubleClick
       *
       * If `undefined` or `true`, double-click toggles fullscreen if controls are present
       * Set to `false` to disable double-click handling
       * Set to a function to substitute an external double-click handler
       */ {
            if (this.options_ === undefined || this.options_.userActions === undefined || this.options_.userActions.doubleClick === undefined || this.options_.userActions.doubleClick !== false) {
                if (this.options_ !== undefined && this.options_.userActions !== undefined && typeof this.options_.userActions.doubleClick === 'function') this.options_.userActions.doubleClick.call(this, event);
                else if (this.isInPictureInPicture() && !(0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).pictureInPictureElement) // Checking the presence of `window.documentPictureInPicture.window` complicates
                // tests, checking `document.pictureInPictureElement` also works. It wouldn't
                // be null in regular picture in picture.
                // Exit picture in picture mode. This gesture can't trigger pip on the main window.
                this.exitPictureInPicture();
                else if (this.isFullscreen()) this.exitFullscreen();
                else this.requestFullscreen();
            }
        }
    }
    /**
   * Handle a tap on the media element. It will toggle the user
   * activity state, which hides and shows the controls.
   *
   * @listens Tech#tap
   * @private
   */ handleTechTap_() {
        this.userActive(!this.userActive());
    }
    /**
   * Handle touch to start
   *
   * @listens Tech#touchstart
   * @private
   */ handleTechTouchStart_() {
        this.userWasActive = this.userActive();
    }
    /**
   * Handle touch to move
   *
   * @listens Tech#touchmove
   * @private
   */ handleTechTouchMove_() {
        if (this.userWasActive) this.reportUserActivity();
    }
    /**
   * Handle touch to end
   *
   * @param {Event} event
   *        the touchend event that triggered
   *        this function
   *
   * @listens Tech#touchend
   * @private
   */ handleTechTouchEnd_(event) {
        // Stop the mouse events from also happening
        if (event.cancelable) event.preventDefault();
    }
    /**
   * @private
   */ toggleFullscreenClass_() {
        if (this.isFullscreen()) this.addClass('vjs-fullscreen');
        else this.removeClass('vjs-fullscreen');
    }
    /**
   * when the document fschange event triggers it calls this
   */ documentFullscreenChange_(e) {
        const targetPlayer = e.target.player;
        // if another player was fullscreen
        // do a null check for targetPlayer because older firefox's would put document as e.target
        if (targetPlayer && targetPlayer !== this) return;
        const el = this.el();
        let isFs = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O)))[this.fsApi_.fullscreenElement] === el;
        if (!isFs && el.matches) isFs = el.matches(':' + this.fsApi_.fullscreen);
        this.isFullscreen(isFs);
    }
    /**
   * Handle Tech Fullscreen Change
   *
   * @param {Event} event
   *        the fullscreenchange event that triggered this function
   *
   * @param {Object} data
   *        the data that was sent with the event
   *
   * @private
   * @listens Tech#fullscreenchange
   * @fires Player#fullscreenchange
   */ handleTechFullscreenChange_(event, data) {
        if (data) {
            if (data.nativeIOSFullscreen) {
                this.addClass('vjs-ios-native-fs');
                this.tech_.one('webkitendfullscreen', ()=>{
                    this.removeClass('vjs-ios-native-fs');
                });
            }
            this.isFullscreen(data.isFullscreen);
        }
    }
    handleTechFullscreenError_(event, err) {
        this.trigger('fullscreenerror', err);
    }
    /**
   * @private
   */ togglePictureInPictureClass_() {
        if (this.isInPictureInPicture()) this.addClass('vjs-picture-in-picture');
        else this.removeClass('vjs-picture-in-picture');
    }
    /**
   * Handle Tech Enter Picture-in-Picture.
   *
   * @param {Event} event
   *        the enterpictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#enterpictureinpicture
   */ handleTechEnterPictureInPicture_(event) {
        this.isInPictureInPicture(true);
    }
    /**
   * Handle Tech Leave Picture-in-Picture.
   *
   * @param {Event} event
   *        the leavepictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#leavepictureinpicture
   */ handleTechLeavePictureInPicture_(event) {
        this.isInPictureInPicture(false);
    }
    /**
   * Fires when an error occurred during the loading of an audio/video.
   *
   * @private
   * @listens Tech#error
   */ handleTechError_() {
        const error = this.tech_.error();
        if (error) this.error(error);
    }
    /**
   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
   *
   * @fires Player#textdata
   * @listens Tech#textdata
   * @private
   */ handleTechTextData_() {
        let data = null;
        if (arguments.length > 1) data = arguments[1];
        /**
     * Fires when we get a textdata event from tech
     *
     * @event Player#textdata
     * @type {Event}
     */ this.trigger('textdata', data);
    }
    /**
   * Get object for cached values.
   *
   * @return {Object}
   *         get the current object cache
   */ getCache() {
        return this.cache_;
    }
    /**
   * Resets the internal cache object.
   *
   * Using this function outside the player constructor or reset method may
   * have unintended side-effects.
   *
   * @private
   */ resetCache_() {
        this.cache_ = {
            // Right now, the currentTime is not _really_ cached because it is always
            // retrieved from the tech (see: currentTime). However, for completeness,
            // we set it to zero here to ensure that if we do start actually caching
            // it, we reset it along with everything else.
            currentTime: 0,
            initTime: 0,
            inactivityTimeout: this.options_.inactivityTimeout,
            duration: NaN,
            lastVolume: 1,
            lastPlaybackRate: this.defaultPlaybackRate(),
            media: null,
            src: '',
            source: {},
            sources: [],
            playbackRates: [],
            volume: 1
        };
    }
    /**
   * Pass values to the playback tech
   *
   * @param {string} [method]
   *        the method to call
   *
   * @param {Object} [arg]
   *        the argument to pass
   *
   * @private
   */ techCall_(method, arg) {
        // If it's not ready yet, call method when it is
        this.ready(function() {
            if (method in $86defbb4e95ebb07$var$allowedSetters) return $86defbb4e95ebb07$var$set(this.middleware_, this.tech_, method, arg);
            else if (method in $86defbb4e95ebb07$var$allowedMediators) return $86defbb4e95ebb07$var$mediate(this.middleware_, this.tech_, method, arg);
            try {
                if (this.tech_) this.tech_[method](arg);
            } catch (e) {
                $86defbb4e95ebb07$var$log$1(e);
                throw e;
            }
        }, true);
    }
    /**
   * Mediate attempt to call playback tech method
   * and return the value of the method called.
   *
   * @param {string} method
   *        Tech method
   *
   * @return {*}
   *         Value returned by the tech method called, undefined if tech
   *         is not ready or tech method is not present
   *
   * @private
   */ techGet_(method) {
        if (!this.tech_ || !this.tech_.isReady_) return;
        if (method in $86defbb4e95ebb07$var$allowedGetters) return $86defbb4e95ebb07$var$get(this.middleware_, this.tech_, method);
        else if (method in $86defbb4e95ebb07$var$allowedMediators) return $86defbb4e95ebb07$var$mediate(this.middleware_, this.tech_, method);
        // Log error when playback tech object is present but method
        // is undefined or unavailable
        try {
            return this.tech_[method]();
        } catch (e) {
            // When building additional tech libs, an expected method may not be defined yet
            if (this.tech_[method] === undefined) {
                $86defbb4e95ebb07$var$log$1(`Video.js: ${method} method not defined for ${this.techName_} playback technology.`, e);
                throw e;
            }
            // When a method isn't available on the object it throws a TypeError
            if (e.name === 'TypeError') {
                $86defbb4e95ebb07$var$log$1(`Video.js: ${method} unavailable on ${this.techName_} playback technology element.`, e);
                this.tech_.isReady_ = false;
                throw e;
            }
            // If error unknown, just log and throw
            $86defbb4e95ebb07$var$log$1(e);
            throw e;
        }
    }
    /**
   * Attempt to begin playback at the first opportunity.
   *
   * @return {Promise|undefined}
   *         Returns a promise if the browser supports Promises (or one
   *         was passed in as an option). This promise will be resolved on
   *         the return value of play. If this is undefined it will fulfill the
   *         promise chain otherwise the promise chain will be fulfilled when
   *         the promise from play is fulfilled.
   */ play() {
        return new Promise((resolve)=>{
            this.play_(resolve);
        });
    }
    /**
   * The actual logic for play, takes a callback that will be resolved on the
   * return value of play. This allows us to resolve to the play promise if there
   * is one on modern browsers.
   *
   * @private
   * @param {Function} [callback]
   *        The callback that should be called when the techs play is actually called
   */ play_(callback = $86defbb4e95ebb07$var$silencePromise) {
        this.playCallbacks_.push(callback);
        const isSrcReady = Boolean(!this.changingSrc_ && (this.src() || this.currentSrc()));
        const isSafariOrIOS = Boolean($86defbb4e95ebb07$var$IS_ANY_SAFARI || $86defbb4e95ebb07$var$IS_IOS);
        // treat calls to play_ somewhat like the `one` event function
        if (this.waitToPlay_) {
            this.off([
                'ready',
                'loadstart'
            ], this.waitToPlay_);
            this.waitToPlay_ = null;
        }
        // if the player/tech is not ready or the src itself is not ready
        // queue up a call to play on `ready` or `loadstart`
        if (!this.isReady_ || !isSrcReady) {
            this.waitToPlay_ = (e)=>{
                this.play_();
            };
            this.one([
                'ready',
                'loadstart'
            ], this.waitToPlay_);
            // if we are in Safari, there is a high chance that loadstart will trigger after the gesture timeperiod
            // in that case, we need to prime the video element by calling load so it'll be ready in time
            if (!isSrcReady && isSafariOrIOS) this.load();
            return;
        }
        // If the player/tech is ready and we have a source, we can attempt playback.
        const val = this.techGet_('play');
        // For native playback, reset the progress bar if we get a play call from a replay.
        const isNativeReplay = isSafariOrIOS && this.hasClass('vjs-ended');
        if (isNativeReplay) this.resetProgressBar_();
        // play was terminated if the returned value is null
        if (val === null) this.runPlayTerminatedQueue_();
        else this.runPlayCallbacks_(val);
    }
    /**
   * These functions will be run when if play is terminated. If play
   * runPlayCallbacks_ is run these function will not be run. This allows us
   * to differentiate between a terminated play and an actual call to play.
   */ runPlayTerminatedQueue_() {
        const queue = this.playTerminatedQueue_.slice(0);
        this.playTerminatedQueue_ = [];
        queue.forEach(function(q) {
            q();
        });
    }
    /**
   * When a callback to play is delayed we have to run these
   * callbacks when play is actually called on the tech. This function
   * runs the callbacks that were delayed and accepts the return value
   * from the tech.
   *
   * @param {undefined|Promise} val
   *        The return value from the tech.
   */ runPlayCallbacks_(val) {
        const callbacks = this.playCallbacks_.slice(0);
        this.playCallbacks_ = [];
        // clear play terminatedQueue since we finished a real play
        this.playTerminatedQueue_ = [];
        callbacks.forEach(function(cb) {
            cb(val);
        });
    }
    /**
   * Pause the video playback
   */ pause() {
        this.techCall_('pause');
    }
    /**
   * Check if the player is paused or has yet to play
   *
   * @return {boolean}
   *         - false: if the media is currently playing
   *         - true: if media is not currently playing
   */ paused() {
        // The initial state of paused should be true (in Safari it's actually false)
        return this.techGet_('paused') === false ? false : true;
    }
    /**
   * Get a TimeRange object representing the current ranges of time that the user
   * has played.
   *
   * @return {TimeRange}
   *         A time range object that represents all the increments of time that have
   *         been played.
   */ played() {
        return this.techGet_('played') || $86defbb4e95ebb07$var$createTimeRanges$1(0, 0);
    }
    /**
   * Sets or returns whether or not the user is "scrubbing". Scrubbing is
   * when the user has clicked the progress bar handle and is
   * dragging it along the progress bar.
   *
   * @param {boolean} [isScrubbing]
   *        whether the user is or is not scrubbing
   *
   * @return {boolean|undefined}
   *         - The value of scrubbing when getting
   *         - Nothing when setting
   */ scrubbing(isScrubbing) {
        if (typeof isScrubbing === 'undefined') return this.scrubbing_;
        this.scrubbing_ = !!isScrubbing;
        this.techCall_('setScrubbing', this.scrubbing_);
        if (isScrubbing) this.addClass('vjs-scrubbing');
        else this.removeClass('vjs-scrubbing');
    }
    /**
   * Get or set the current time (in seconds)
   *
   * @param {number|string} [seconds]
   *        The time to seek to in seconds
   *
   * @return {number|undefined}
   *         - the current time in seconds when getting
   *         - Nothing when setting
   */ currentTime(seconds) {
        if (seconds === undefined) {
            // cache last currentTime and return. default to 0 seconds
            //
            // Caching the currentTime is meant to prevent a massive amount of reads on the tech's
            // currentTime when scrubbing, but may not provide much performance benefit after all.
            // Should be tested. Also something has to read the actual current time or the cache will
            // never get updated.
            this.cache_.currentTime = this.techGet_('currentTime') || 0;
            return this.cache_.currentTime;
        }
        if (seconds < 0) seconds = 0;
        if (!this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
            this.cache_.initTime = seconds;
            this.off('canplay', this.boundApplyInitTime_);
            this.one('canplay', this.boundApplyInitTime_);
            return;
        }
        this.techCall_('setCurrentTime', seconds);
        this.cache_.initTime = 0;
        if (isFinite(seconds)) this.cache_.currentTime = Number(seconds);
    }
    /**
   * Apply the value of initTime stored in cache as currentTime.
   *
   * @private
   */ applyInitTime_() {
        this.currentTime(this.cache_.initTime);
    }
    /**
   * Normally gets the length in time of the video in seconds;
   * in all but the rarest use cases an argument will NOT be passed to the method
   *
   * > **NOTE**: The video must have started loading before the duration can be
   * known, and depending on preload behaviour may not be known until the video starts
   * playing.
   *
   * @fires Player#durationchange
   *
   * @param {number} [seconds]
   *        The duration of the video to set in seconds
   *
   * @return {number|undefined}
   *         - The duration of the video in seconds when getting
   *         - Nothing when setting
   */ duration(seconds) {
        if (seconds === undefined) // return NaN if the duration is not known
        return this.cache_.duration !== undefined ? this.cache_.duration : NaN;
        seconds = parseFloat(seconds);
        // Standardize on Infinity for signaling video is live
        if (seconds < 0) seconds = Infinity;
        if (seconds !== this.cache_.duration) {
            // Cache the last set value for optimized scrubbing
            this.cache_.duration = seconds;
            if (seconds === Infinity) this.addClass('vjs-live');
            else this.removeClass('vjs-live');
            if (!isNaN(seconds)) // Do not fire durationchange unless the duration value is known.
            // @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
            /**
         * @event Player#durationchange
         * @type {Event}
         */ this.trigger('durationchange');
        }
    }
    /**
   * Calculates how much time is left in the video. Not part
   * of the native video API.
   *
   * @return {number}
   *         The time remaining in seconds
   */ remainingTime() {
        return this.duration() - this.currentTime();
    }
    /**
   * A remaining time function that is intended to be used when
   * the time is to be displayed directly to the user.
   *
   * @return {number}
   *         The rounded time remaining in seconds
   */ remainingTimeDisplay() {
        return Math.floor(this.duration()) - Math.floor(this.currentTime());
    }
    //
    // Kind of like an array of portions of the video that have been downloaded.
    /**
   * Get a TimeRange object with an array of the times of the video
   * that have been downloaded. If you just want the percent of the
   * video that's been downloaded, use bufferedPercent.
   *
   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */ buffered() {
        let buffered = this.techGet_('buffered');
        if (!buffered || !buffered.length) buffered = $86defbb4e95ebb07$var$createTimeRanges$1(0, 0);
        return buffered;
    }
    /**
   * Get the TimeRanges of the media that are currently available
   * for seeking to.
   *
   * @see [Seekable Spec]{@link https://html.spec.whatwg.org/multipage/media.html#dom-media-seekable}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */ seekable() {
        let seekable = this.techGet_('seekable');
        if (!seekable || !seekable.length) seekable = $86defbb4e95ebb07$var$createTimeRanges$1(0, 0);
        return seekable;
    }
    /**
   * Returns whether the player is in the "seeking" state.
   *
   * @return {boolean} True if the player is in the seeking state, false if not.
   */ seeking() {
        return this.techGet_('seeking');
    }
    /**
   * Returns whether the player is in the "ended" state.
   *
   * @return {boolean} True if the player is in the ended state, false if not.
   */ ended() {
        return this.techGet_('ended');
    }
    /**
   * Returns the current state of network activity for the element, from
   * the codes in the list below.
   * - NETWORK_EMPTY (numeric value 0)
   *   The element has not yet been initialised. All attributes are in
   *   their initial states.
   * - NETWORK_IDLE (numeric value 1)
   *   The element's resource selection algorithm is active and has
   *   selected a resource, but it is not actually using the network at
   *   this time.
   * - NETWORK_LOADING (numeric value 2)
   *   The user agent is actively trying to download data.
   * - NETWORK_NO_SOURCE (numeric value 3)
   *   The element's resource selection algorithm is active, but it has
   *   not yet found a resource to use.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
   * @return {number} the current network activity state
   */ networkState() {
        return this.techGet_('networkState');
    }
    /**
   * Returns a value that expresses the current state of the element
   * with respect to rendering the current playback position, from the
   * codes in the list below.
   * - HAVE_NOTHING (numeric value 0)
   *   No information regarding the media resource is available.
   * - HAVE_METADATA (numeric value 1)
   *   Enough of the resource has been obtained that the duration of the
   *   resource is available.
   * - HAVE_CURRENT_DATA (numeric value 2)
   *   Data for the immediate current playback position is available.
   * - HAVE_FUTURE_DATA (numeric value 3)
   *   Data for the immediate current playback position is available, as
   *   well as enough data for the user agent to advance the current
   *   playback position in the direction of playback.
   * - HAVE_ENOUGH_DATA (numeric value 4)
   *   The user agent estimates that enough data is available for
   *   playback to proceed uninterrupted.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
   * @return {number} the current playback rendering state
   */ readyState() {
        return this.techGet_('readyState');
    }
    /**
   * Get the percent (as a decimal) of the video that's been downloaded.
   * This method is not a part of the native HTML video API.
   *
   * @return {number}
   *         A decimal between 0 and 1 representing the percent
   *         that is buffered 0 being 0% and 1 being 100%
   */ bufferedPercent() {
        return $86defbb4e95ebb07$var$bufferedPercent(this.buffered(), this.duration());
    }
    /**
   * Get the ending time of the last buffered time range
   * This is used in the progress bar to encapsulate all time ranges.
   *
   * @return {number}
   *         The end of the last buffered time range
   */ bufferedEnd() {
        const buffered = this.buffered();
        const duration = this.duration();
        let end = buffered.end(buffered.length - 1);
        if (end > duration) end = duration;
        return end;
    }
    /**
   * Get or set the current volume of the media
   *
   * @param  {number} [percentAsDecimal]
   *         The new volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         The current volume as a percent when getting
   */ volume(percentAsDecimal) {
        let vol;
        if (percentAsDecimal !== undefined) {
            // Force value to between 0 and 1
            vol = Math.max(0, Math.min(1, percentAsDecimal));
            this.cache_.volume = vol;
            this.techCall_('setVolume', vol);
            if (vol > 0) this.lastVolume_(vol);
            return;
        }
        // Default to 1 when returning current volume.
        vol = parseFloat(this.techGet_('volume'));
        return isNaN(vol) ? 1 : vol;
    }
    /**
   * Get the current muted state, or turn mute on or off
   *
   * @param {boolean} [muted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if mute is on and getting
   *         - false if mute is off and getting
   *         - nothing if setting
   */ muted(muted) {
        if (muted !== undefined) {
            this.techCall_('setMuted', muted);
            return;
        }
        return this.techGet_('muted') || false;
    }
    /**
   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
   * indicates the state of muted on initial playback.
   *
   * ```js
   *   var myPlayer = videojs('some-player-id');
   *
   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
   *
   *   // get, should be false
   *   console.log(myPlayer.defaultMuted());
   *   // set to true
   *   myPlayer.defaultMuted(true);
   *   // get should be true
   *   console.log(myPlayer.defaultMuted());
   * ```
   *
   * @param {boolean} [defaultMuted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if defaultMuted is on and getting
   *         - false if defaultMuted is off and getting
   *         - Nothing when setting
   */ defaultMuted(defaultMuted) {
        if (defaultMuted !== undefined) this.techCall_('setDefaultMuted', defaultMuted);
        return this.techGet_('defaultMuted') || false;
    }
    /**
   * Get the last volume, or set it
   *
   * @param  {number} [percentAsDecimal]
   *         The new last volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         - The current value of lastVolume as a percent when getting
   *         - Nothing when setting
   *
   * @private
   */ lastVolume_(percentAsDecimal) {
        if (percentAsDecimal !== undefined && percentAsDecimal !== 0) {
            this.cache_.lastVolume = percentAsDecimal;
            return;
        }
        return this.cache_.lastVolume;
    }
    /**
   * Check if current tech can support native fullscreen
   * (e.g. with built in controls like iOS)
   *
   * @return {boolean}
   *         if native fullscreen is supported
   */ supportsFullScreen() {
        return this.techGet_('supportsFullScreen') || false;
    }
    /**
   * Check if the player is in fullscreen mode or tell the player that it
   * is or is not in fullscreen mode.
   *
   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
   * property and instead document.fullscreenElement is used. But isFullscreen is
   * still a valuable property for internal player workings.
   *
   * @param  {boolean} [isFS]
   *         Set the players current fullscreen state
   *
   * @return {boolean|undefined}
   *         - true if fullscreen is on and getting
   *         - false if fullscreen is off and getting
   *         - Nothing when setting
   */ isFullscreen(isFS) {
        if (isFS !== undefined) {
            const oldValue = this.isFullscreen_;
            this.isFullscreen_ = Boolean(isFS);
            // if we changed fullscreen state and we're in prefixed mode, trigger fullscreenchange
            // this is the only place where we trigger fullscreenchange events for older browsers
            // fullWindow mode is treated as a prefixed event and will get a fullscreenchange event as well
            if (this.isFullscreen_ !== oldValue && this.fsApi_.prefixed) /**
           * @event Player#fullscreenchange
           * @type {Event}
           */ this.trigger('fullscreenchange');
            this.toggleFullscreenClass_();
            return;
        }
        return this.isFullscreen_;
    }
    /**
   * Increase the size of the video to full screen
   * In some browsers, full screen is not supported natively, so it enters
   * "full window mode", where the video fills the browser window.
   * In browsers and devices that support native full screen, sometimes the
   * browser's default controls will be shown, and not the Video.js custom skin.
   * This includes most mobile devices (iOS, Android) and older versions of
   * Safari.
   *
   * @param  {Object} [fullscreenOptions]
   *         Override the player fullscreen options
   *
   * @fires Player#fullscreenchange
   */ requestFullscreen(fullscreenOptions) {
        if (this.isInPictureInPicture()) this.exitPictureInPicture();
        const self1 = this;
        return new Promise((resolve, reject)=>{
            function offHandler() {
                self1.off('fullscreenerror', errorHandler);
                self1.off('fullscreenchange', changeHandler);
            }
            function changeHandler() {
                offHandler();
                resolve();
            }
            function errorHandler(e, err) {
                offHandler();
                reject(err);
            }
            self1.one('fullscreenchange', changeHandler);
            self1.one('fullscreenerror', errorHandler);
            const promise = self1.requestFullscreenHelper_(fullscreenOptions);
            if (promise) {
                promise.then(offHandler, offHandler);
                promise.then(resolve, reject);
            }
        });
    }
    requestFullscreenHelper_(fullscreenOptions) {
        let fsOptions;
        // Only pass fullscreen options to requestFullscreen in spec-compliant browsers.
        // Use defaults or player configured option unless passed directly to this method.
        if (!this.fsApi_.prefixed) {
            fsOptions = this.options_.fullscreen && this.options_.fullscreen.options || {};
            if (fullscreenOptions !== undefined) fsOptions = fullscreenOptions;
        }
        // This method works as follows:
        // 1. if a fullscreen api is available, use it
        //   1. call requestFullscreen with potential options
        //   2. if we got a promise from above, use it to update isFullscreen()
        // 2. otherwise, if the tech supports fullscreen, call `enterFullScreen` on it.
        //   This is particularly used for iPhone, older iPads, and non-safari browser on iOS.
        // 3. otherwise, use "fullWindow" mode
        if (this.fsApi_.requestFullscreen) {
            const promise = this.el_[this.fsApi_.requestFullscreen](fsOptions);
            // Even on browsers with promise support this may not return a promise
            if (promise) promise.then(()=>this.isFullscreen(true), ()=>this.isFullscreen(false));
            return promise;
        } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) // we can't take the video.js controls fullscreen but we can go fullscreen
        // with native controls
        this.techCall_('enterFullScreen');
        else // fullscreen isn't supported so we'll just stretch the video element to
        // fill the viewport
        this.enterFullWindow();
    }
    /**
   * Return the video to its normal size after having been in full screen mode
   *
   * @fires Player#fullscreenchange
   */ exitFullscreen() {
        const self1 = this;
        return new Promise((resolve, reject)=>{
            function offHandler() {
                self1.off('fullscreenerror', errorHandler);
                self1.off('fullscreenchange', changeHandler);
            }
            function changeHandler() {
                offHandler();
                resolve();
            }
            function errorHandler(e, err) {
                offHandler();
                reject(err);
            }
            self1.one('fullscreenchange', changeHandler);
            self1.one('fullscreenerror', errorHandler);
            const promise = self1.exitFullscreenHelper_();
            if (promise) {
                promise.then(offHandler, offHandler);
                // map the promise to our resolve/reject methods
                promise.then(resolve, reject);
            }
        });
    }
    exitFullscreenHelper_() {
        if (this.fsApi_.requestFullscreen) {
            const promise = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O)))[this.fsApi_.exitFullscreen]();
            // Even on browsers with promise support this may not return a promise
            if (promise) // we're splitting the promise here, so, we want to catch the
            // potential error so that this chain doesn't have unhandled errors
            $86defbb4e95ebb07$var$silencePromise(promise.then(()=>this.isFullscreen(false)));
            return promise;
        } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) this.techCall_('exitFullScreen');
        else this.exitFullWindow();
    }
    /**
   * When fullscreen isn't supported we can stretch the
   * video container to as wide as the browser will let us.
   *
   * @fires Player#enterFullWindow
   */ enterFullWindow() {
        this.isFullscreen(true);
        this.isFullWindow = true;
        // Storing original doc overflow value to return to when fullscreen is off
        this.docOrigOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).documentElement.style.overflow;
        // Add listener for esc key to exit fullscreen
        $86defbb4e95ebb07$var$on((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))), 'keydown', this.boundFullWindowOnEscKey_);
        // Hide any scroll bars
        (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).documentElement.style.overflow = 'hidden';
        // Apply fullscreen styles
        $86defbb4e95ebb07$var$addClass((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).body, 'vjs-full-window');
        /**
     * @event Player#enterFullWindow
     * @type {Event}
     */ this.trigger('enterFullWindow');
    }
    /**
   * Check for call to either exit full window or
   * full screen on ESC key
   *
   * @param {string} event
   *        Event to check for key press
   */ fullWindowOnEscKey(event) {
        if (event.key === 'Escape') {
            if (this.isFullscreen() === true) {
                if (!this.isFullWindow) this.exitFullscreen();
                else this.exitFullWindow();
            }
        }
    }
    /**
   * Exit full window
   *
   * @fires Player#exitFullWindow
   */ exitFullWindow() {
        this.isFullscreen(false);
        this.isFullWindow = false;
        $86defbb4e95ebb07$var$off((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))), 'keydown', this.boundFullWindowOnEscKey_);
        // Unhide scroll bars.
        (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).documentElement.style.overflow = this.docOrigOverflow;
        // Remove fullscreen styles
        $86defbb4e95ebb07$var$removeClass((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).body, 'vjs-full-window');
        // Resize the box, controller, and poster to original sizes
        // this.positionAll();
        /**
     * @event Player#exitFullWindow
     * @type {Event}
     */ this.trigger('exitFullWindow');
    }
    /**
   * Get or set disable Picture-in-Picture mode.
   *
   * @param {boolean} [value]
   *                  - true will disable Picture-in-Picture mode
   *                  - false will enable Picture-in-Picture mode
   */ disablePictureInPicture(value) {
        if (value === undefined) return this.techGet_('disablePictureInPicture');
        this.techCall_('setDisablePictureInPicture', value);
        this.options_.disablePictureInPicture = value;
        this.trigger('disablepictureinpicturechanged');
    }
    /**
   * Check if the player is in Picture-in-Picture mode or tell the player that it
   * is or is not in Picture-in-Picture mode.
   *
   * @param  {boolean} [isPiP]
   *         Set the players current Picture-in-Picture state
   *
   * @return {boolean|undefined}
   *         - true if Picture-in-Picture is on and getting
   *         - false if Picture-in-Picture is off and getting
   *         - nothing if setting
   */ isInPictureInPicture(isPiP) {
        if (isPiP !== undefined) {
            this.isInPictureInPicture_ = !!isPiP;
            this.togglePictureInPictureClass_();
            return;
        }
        return !!this.isInPictureInPicture_;
    }
    /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * This can use document picture-in-picture or element picture in picture
   *
   * Set `enableDocumentPictureInPicture` to `true` to use docPiP on a supported browser
   * Else set `disablePictureInPicture` to `false` to disable elPiP on a supported browser
   *
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/}
   * @see [Spec]{@link https://wicg.github.io/document-picture-in-picture/}
   *
   * @fires Player#enterpictureinpicture
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */ requestPictureInPicture() {
        if (this.options_.enableDocumentPictureInPicture && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).documentPictureInPicture) {
            const pipContainer = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement(this.el().tagName);
            pipContainer.classList = this.el().classList;
            pipContainer.classList.add('vjs-pip-container');
            if (this.posterImage) pipContainer.appendChild(this.posterImage.el().cloneNode(true));
            if (this.titleBar) pipContainer.appendChild(this.titleBar.el().cloneNode(true));
            pipContainer.appendChild($86defbb4e95ebb07$var$createEl('p', {
                className: 'vjs-pip-text'
            }, {}, this.localize('Playing in picture-in-picture')));
            return (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).documentPictureInPicture.requestWindow({
                // The aspect ratio won't be correct, Chrome bug https://crbug.com/1407629
                width: this.videoWidth(),
                height: this.videoHeight()
            }).then((pipWindow)=>{
                $86defbb4e95ebb07$var$copyStyleSheetsToWindow(pipWindow);
                this.el_.parentNode.insertBefore(pipContainer, this.el_);
                pipWindow.document.body.appendChild(this.el_);
                pipWindow.document.body.classList.add('vjs-pip-window');
                this.player_.isInPictureInPicture(true);
                this.player_.trigger({
                    type: 'enterpictureinpicture',
                    pipWindow: pipWindow
                });
                // Listen for the PiP closing event to move the video back.
                pipWindow.addEventListener('pagehide', (event)=>{
                    const pipVideo = event.target.querySelector('.video-js');
                    pipContainer.parentNode.replaceChild(pipVideo, pipContainer);
                    this.player_.isInPictureInPicture(false);
                    this.player_.trigger('leavepictureinpicture');
                });
                return pipWindow;
            });
        }
        if ('pictureInPictureEnabled' in (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))) && this.disablePictureInPicture() === false) /**
       * This event fires when the player enters picture in picture mode
       *
       * @event Player#enterpictureinpicture
       * @type {Event}
       */ return this.techGet_('requestPictureInPicture');
        return Promise.reject('No PiP mode is available');
    }
    /**
   * Exit Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @fires Player#leavepictureinpicture
   *
   * @return {Promise}
   *         A promise.
   */ exitPictureInPicture() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).documentPictureInPicture && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).documentPictureInPicture.window) {
            // With documentPictureInPicture, Player#leavepictureinpicture is fired in the pagehide handler
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).documentPictureInPicture.window.close();
            return Promise.resolve();
        }
        if ('pictureInPictureEnabled' in (0, (/*@__PURE__*/$parcel$interopDefault($01r8O)))) /**
       * This event fires when the player leaves picture in picture mode
       *
       * @event Player#leavepictureinpicture
       * @type {Event}
       */ return (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).exitPictureInPicture();
    }
    /**
   * Called when this Player has focus and a key gets pressed down, or when
   * any Component of this player receives a key press that it doesn't handle.
   * This allows player-wide hotkeys (either as defined below, or optionally
   * by an external function).
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        const { userActions: userActions } = this.options_;
        // Bail out if hotkeys are not configured.
        if (!userActions || !userActions.hotkeys) return;
        // Function that determines whether or not to exclude an element from
        // hotkeys handling.
        const excludeElement = (el)=>{
            const tagName = el.tagName.toLowerCase();
            // The first and easiest test is for `contenteditable` elements.
            if (el.isContentEditable) return true;
            // Inputs matching these types will still trigger hotkey handling as
            // they are not text inputs.
            const allowedInputTypes = [
                'button',
                'checkbox',
                'hidden',
                'radio',
                'reset',
                'submit'
            ];
            if (tagName === 'input') return allowedInputTypes.indexOf(el.type) === -1;
            // The final test is by tag name. These tags will be excluded entirely.
            const excludedTags = [
                'textarea'
            ];
            return excludedTags.indexOf(tagName) !== -1;
        };
        // Bail out if the user is focused on an interactive form element.
        if (excludeElement(this.el_.ownerDocument.activeElement)) return;
        if (typeof userActions.hotkeys === 'function') userActions.hotkeys.call(this, event);
        else this.handleHotkeys(event);
    }
    /**
   * Called when this Player receives a hotkey keydown event.
   * Supported player-wide hotkeys are:
   *
   *   f          - toggle fullscreen
   *   m          - toggle mute
   *   k or Space - toggle play/pause
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   */ handleHotkeys(event) {
        const hotkeys = this.options_.userActions ? this.options_.userActions.hotkeys : {};
        // set fullscreenKey, muteKey, playPauseKey from `hotkeys`, use defaults if not set
        const { fullscreenKey: fullscreenKey = (keydownEvent)=>event.key.toLowerCase() === 'f', muteKey: muteKey = (keydownEvent)=>event.key.toLowerCase() === 'm', playPauseKey: playPauseKey = (keydownEvent)=>event.key.toLowerCase() === 'k' || event.key.toLowerCase() === ' ' } = hotkeys;
        if (fullscreenKey.call(this, event)) {
            event.preventDefault();
            event.stopPropagation();
            const FSToggle = $86defbb4e95ebb07$var$Component$1.getComponent('FullscreenToggle');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($01r8O)))[this.fsApi_.fullscreenEnabled] !== false) FSToggle.prototype.handleClick.call(this, event);
        } else if (muteKey.call(this, event)) {
            event.preventDefault();
            event.stopPropagation();
            const MuteToggle = $86defbb4e95ebb07$var$Component$1.getComponent('MuteToggle');
            MuteToggle.prototype.handleClick.call(this, event);
        } else if (playPauseKey.call(this, event)) {
            event.preventDefault();
            event.stopPropagation();
            const PlayToggle = $86defbb4e95ebb07$var$Component$1.getComponent('PlayToggle');
            PlayToggle.prototype.handleClick.call(this, event);
        }
    }
    /**
   * Check whether the player can play a given mimetype
   *
   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
   *
   * @param {string} type
   *        The mimetype to check
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */ canPlayType(type) {
        let can;
        // Loop through each playback technology in the options order
        for(let i = 0, j = this.options_.techOrder; i < j.length; i++){
            const techName = j[i];
            let tech = $86defbb4e95ebb07$var$Tech.getTech(techName);
            // Support old behavior of techs being registered as components.
            // Remove once that deprecated behavior is removed.
            if (!tech) tech = $86defbb4e95ebb07$var$Component$1.getComponent(techName);
            // Check if the current tech is defined before continuing
            if (!tech) {
                $86defbb4e95ebb07$var$log$1.error(`The "${techName}" tech is undefined. Skipped browser support check for that tech.`);
                continue;
            }
            // Check if the browser supports this technology
            if (tech.isSupported()) {
                can = tech.canPlayType(type);
                if (can) return can;
            }
        }
        return '';
    }
    /**
   * Select source based on tech-order or source-order
   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
   * defaults to tech-order selection
   *
   * @param {Array} sources
   *        The sources for a media asset
   *
   * @return {Object|boolean}
   *         Object of source and tech order or false
   */ selectSource(sources) {
        // Get only the techs specified in `techOrder` that exist and are supported by the
        // current platform
        const techs = this.options_.techOrder.map((techName)=>{
            return [
                techName,
                $86defbb4e95ebb07$var$Tech.getTech(techName)
            ];
        }).filter(([techName, tech])=>{
            // Check if the current tech is defined before continuing
            if (tech) // Check if the browser supports this technology
            return tech.isSupported();
            $86defbb4e95ebb07$var$log$1.error(`The "${techName}" tech is undefined. Skipped browser support check for that tech.`);
            return false;
        });
        // Iterate over each `innerArray` element once per `outerArray` element and execute
        // `tester` with both. If `tester` returns a non-falsy value, exit early and return
        // that value.
        const findFirstPassingTechSourcePair = function(outerArray, innerArray, tester) {
            let found;
            outerArray.some((outerChoice)=>{
                return innerArray.some((innerChoice)=>{
                    found = tester(outerChoice, innerChoice);
                    if (found) return true;
                });
            });
            return found;
        };
        let foundSourceAndTech;
        const flip = (fn)=>(a, b)=>fn(b, a);
        const finder = ([techName, tech], source)=>{
            if (tech.canPlaySource(source, this.options_[techName.toLowerCase()])) return {
                source: source,
                tech: techName
            };
        };
        // Depending on the truthiness of `options.sourceOrder`, we swap the order of techs and sources
        // to select from them based on their priority.
        if (this.options_.sourceOrder) // Source-first ordering
        foundSourceAndTech = findFirstPassingTechSourcePair(sources, techs, flip(finder));
        else // Tech-first ordering
        foundSourceAndTech = findFirstPassingTechSourcePair(techs, sources, finder);
        return foundSourceAndTech || false;
    }
    /**
   * Executes source setting and getting logic
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   * @param {boolean} [isRetry]
   *        Indicates whether this is being called internally as a result of a retry
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */ handleSrc_(source, isRetry) {
        // getter usage
        if (typeof source === 'undefined') return this.cache_.src || '';
        // Reset retry behavior for new source
        if (this.resetRetryOnError_) this.resetRetryOnError_();
        // filter out invalid sources and turn our source into
        // an array of source objects
        const sources = $86defbb4e95ebb07$var$filterSource(source);
        // if a source was passed in then it is invalid because
        // it was filtered to a zero length Array. So we have to
        // show an error
        if (!sources.length) {
            this.setTimeout(function() {
                this.error({
                    code: 4,
                    message: this.options_.notSupportedMessage
                });
            }, 0);
            return;
        }
        // initial sources
        this.changingSrc_ = true;
        // Only update the cached source list if we are not retrying a new source after error,
        // since in that case we want to include the failed source(s) in the cache
        if (!isRetry) this.cache_.sources = sources;
        this.updateSourceCaches_(sources[0]);
        // middlewareSource is the source after it has been changed by middleware
        $86defbb4e95ebb07$var$setSource(this, sources[0], (middlewareSource, mws)=>{
            this.middleware_ = mws;
            // since sourceSet is async we have to update the cache again after we select a source since
            // the source that is selected could be out of order from the cache update above this callback.
            if (!isRetry) this.cache_.sources = sources;
            this.updateSourceCaches_(middlewareSource);
            const err = this.src_(middlewareSource);
            if (err) {
                if (sources.length > 1) return this.handleSrc_(sources.slice(1));
                this.changingSrc_ = false;
                // We need to wrap this in a timeout to give folks a chance to add error event handlers
                this.setTimeout(function() {
                    this.error({
                        code: 4,
                        message: this.options_.notSupportedMessage
                    });
                }, 0);
                // we could not find an appropriate tech, but let's still notify the delegate that this is it
                // this needs a better comment about why this is needed
                this.triggerReady();
                return;
            }
            $86defbb4e95ebb07$var$setTech(mws, this.tech_);
        });
        // Try another available source if this one fails before playback.
        if (sources.length > 1) {
            const retry = ()=>{
                // Remove the error modal
                this.error(null);
                this.handleSrc_(sources.slice(1), true);
            };
            const stopListeningForErrors = ()=>{
                this.off('error', retry);
            };
            this.one('error', retry);
            this.one('playing', stopListeningForErrors);
            this.resetRetryOnError_ = ()=>{
                this.off('error', retry);
                this.off('playing', stopListeningForErrors);
            };
        }
    }
    /**
   * Get or set the video source.
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */ src(source) {
        return this.handleSrc_(source, false);
    }
    /**
   * Set the source object on the tech, returns a boolean that indicates whether
   * there is a tech that can play the source or not
   *
   * @param {Tech~SourceObject} source
   *        The source object to set on the Tech
   *
   * @return {boolean}
   *         - True if there is no Tech to playback this source
   *         - False otherwise
   *
   * @private
   */ src_(source) {
        const sourceTech = this.selectSource([
            source
        ]);
        if (!sourceTech) return true;
        if (!$86defbb4e95ebb07$var$titleCaseEquals(sourceTech.tech, this.techName_)) {
            this.changingSrc_ = true;
            // load this technology with the chosen source
            this.loadTech_(sourceTech.tech, sourceTech.source);
            this.tech_.ready(()=>{
                this.changingSrc_ = false;
            });
            return false;
        }
        // wait until the tech is ready to set the source
        // and set it synchronously if possible (#2326)
        this.ready(function() {
            // The setSource tech method was added with source handlers
            // so older techs won't support it
            // We need to check the direct prototype for the case where subclasses
            // of the tech do not support source handlers
            if (this.tech_.constructor.prototype.hasOwnProperty('setSource')) this.techCall_('setSource', source);
            else this.techCall_('src', source.src);
            this.changingSrc_ = false;
        }, true);
        return false;
    }
    /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */ addSourceElement(srcUrl, mimeType) {
        if (!this.tech_) return false;
        return this.tech_.addSourceElement(srcUrl, mimeType);
    }
    /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */ removeSourceElement(srcUrl) {
        if (!this.tech_) return false;
        return this.tech_.removeSourceElement(srcUrl);
    }
    /**
   * Begin loading the src data.
   */ load() {
        // Workaround to use the load method with the VHS.
        // Does not cover the case when the load method is called directly from the mediaElement.
        if (this.tech_ && this.tech_.vhs) {
            this.src(this.currentSource());
            return;
        }
        this.techCall_('load');
    }
    /**
   * Reset the player. Loads the first tech in the techOrder,
   * removes all the text tracks in the existing `tech`,
   * and calls `reset` on the `tech`.
   */ reset() {
        if (this.paused()) this.doReset_();
        else {
            const playPromise = this.play();
            $86defbb4e95ebb07$var$silencePromise(playPromise.then(()=>this.doReset_()));
        }
    }
    doReset_() {
        if (this.tech_) this.tech_.clearTracks('text');
        this.removeClass('vjs-playing');
        this.addClass('vjs-paused');
        this.resetCache_();
        this.poster('');
        this.loadTech_(this.options_.techOrder[0], null);
        this.techCall_('reset');
        this.resetControlBarUI_();
        this.error(null);
        if (this.titleBar) this.titleBar.update({
            title: undefined,
            description: undefined
        });
        if ($86defbb4e95ebb07$var$isEvented(this)) this.trigger('playerreset');
    }
    /**
   * Reset Control Bar's UI by calling sub-methods that reset
   * all of Control Bar's components
   */ resetControlBarUI_() {
        this.resetProgressBar_();
        this.resetPlaybackRate_();
        this.resetVolumeBar_();
    }
    /**
   * Reset tech's progress so progress bar is reset in the UI
   */ resetProgressBar_() {
        this.currentTime(0);
        const { currentTimeDisplay: currentTimeDisplay, durationDisplay: durationDisplay, progressControl: progressControl, remainingTimeDisplay: remainingTimeDisplay } = this.controlBar || {};
        const { seekBar: seekBar } = progressControl || {};
        if (currentTimeDisplay) currentTimeDisplay.updateContent();
        if (durationDisplay) durationDisplay.updateContent();
        if (remainingTimeDisplay) remainingTimeDisplay.updateContent();
        if (seekBar) {
            seekBar.update();
            if (seekBar.loadProgressBar) seekBar.loadProgressBar.update();
        }
    }
    /**
   * Reset Playback ratio
   */ resetPlaybackRate_() {
        this.playbackRate(this.defaultPlaybackRate());
        this.handleTechRateChange_();
    }
    /**
   * Reset Volume bar
   */ resetVolumeBar_() {
        this.volume(1.0);
        this.trigger('volumechange');
    }
    /**
   * Returns all of the current source objects.
   *
   * @return {Tech~SourceObject[]}
   *         The current source objects
   */ currentSources() {
        const source = this.currentSource();
        const sources = [];
        // assume `{}` or `{ src }`
        if (Object.keys(source).length !== 0) sources.push(source);
        return this.cache_.sources || sources;
    }
    /**
   * Returns the current source object.
   *
   * @return {Tech~SourceObject}
   *         The current source object
   */ currentSource() {
        return this.cache_.source || {};
    }
    /**
   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
   *
   * @return {string}
   *         The current source
   */ currentSrc() {
        return this.currentSource() && this.currentSource().src || '';
    }
    /**
   * Get the current source type e.g. video/mp4
   * This can allow you rebuild the current source object so that you could load the same
   * source and tech later
   *
   * @return {string}
   *         The source MIME type
   */ currentType() {
        return this.currentSource() && this.currentSource().type || '';
    }
    /**
   * Get or set the preload attribute
   *
   * @param {'none'|'auto'|'metadata'} [value]
   *        Preload mode to pass to tech
   *
   * @return {string|undefined}
   *         - The preload attribute value when getting
   *         - Nothing when setting
   */ preload(value) {
        if (value !== undefined) {
            this.techCall_('setPreload', value);
            this.options_.preload = value;
            return;
        }
        return this.techGet_('preload');
    }
    /**
   * Get or set the autoplay option. When this is a boolean it will
   * modify the attribute on the tech. When this is a string the attribute on
   * the tech will be removed and `Player` will handle autoplay on loadstarts.
   *
   * @param {boolean|'play'|'muted'|'any'} [value]
   *        - true: autoplay using the browser behavior
   *        - false: do not autoplay
   *        - 'play': call play() on every loadstart
   *        - 'muted': call muted() then play() on every loadstart
   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
   *        - *: values other than those listed here will be set `autoplay` to true
   *
   * @return {boolean|string|undefined}
   *         - The current value of autoplay when getting
   *         - Nothing when setting
   */ autoplay(value) {
        // getter usage
        if (value === undefined) return this.options_.autoplay || false;
        let techAutoplay;
        // if the value is a valid string set it to that, or normalize `true` to 'play', if need be
        if (typeof value === 'string' && /(any|play|muted)/.test(value) || value === true && this.options_.normalizeAutoplay) {
            this.options_.autoplay = value;
            this.manualAutoplay_(typeof value === 'string' ? value : 'play');
            techAutoplay = false;
        // any falsy value sets autoplay to false in the browser,
        // lets do the same
        } else if (!value) this.options_.autoplay = false;
        else this.options_.autoplay = true;
        techAutoplay = typeof techAutoplay === 'undefined' ? this.options_.autoplay : techAutoplay;
        // if we don't have a tech then we do not queue up
        // a setAutoplay call on tech ready. We do this because the
        // autoplay option will be passed in the constructor and we
        // do not need to set it twice
        if (this.tech_) this.techCall_('setAutoplay', techAutoplay);
    }
    /**
   * Set or unset the playsinline attribute.
   * Playsinline tells the browser that non-fullscreen playback is preferred.
   *
   * @param {boolean} [value]
   *        - true means that we should try to play inline by default
   *        - false means that we should use the browser's default playback mode,
   *          which in most cases is inline. iOS Safari is a notable exception
   *          and plays fullscreen by default.
   *
   * @return {string|undefined}
   *         - the current value of playsinline
   *         - Nothing when setting
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */ playsinline(value) {
        if (value !== undefined) {
            this.techCall_('setPlaysinline', value);
            this.options_.playsinline = value;
        }
        return this.techGet_('playsinline');
    }
    /**
   * Get or set the loop attribute on the video element.
   *
   * @param {boolean} [value]
   *        - true means that we should loop the video
   *        - false means that we should not loop the video
   *
   * @return {boolean|undefined}
   *         - The current value of loop when getting
   *         - Nothing when setting
   */ loop(value) {
        if (value !== undefined) {
            this.techCall_('setLoop', value);
            this.options_.loop = value;
            return;
        }
        return this.techGet_('loop');
    }
    /**
   * Get or set the poster image source url
   *
   * @fires Player#posterchange
   *
   * @param {string} [src]
   *        Poster image source URL
   *
   * @return {string|undefined}
   *         - The current value of poster when getting
   *         - Nothing when setting
   */ poster(src) {
        if (src === undefined) return this.poster_;
        // The correct way to remove a poster is to set as an empty string
        // other falsey values will throw errors
        if (!src) src = '';
        if (src === this.poster_) return;
        // update the internal poster variable
        this.poster_ = src;
        // update the tech's poster
        this.techCall_('setPoster', src);
        this.isPosterFromTech_ = false;
        // alert components that the poster has been set
        /**
     * This event fires when the poster image is changed on the player.
     *
     * @event Player#posterchange
     * @type {Event}
     */ this.trigger('posterchange');
    }
    /**
   * Some techs (e.g. YouTube) can provide a poster source in an
   * asynchronous way. We want the poster component to use this
   * poster source so that it covers up the tech's controls.
   * (YouTube's play button). However we only want to use this
   * source if the player user hasn't set a poster through
   * the normal APIs.
   *
   * @fires Player#posterchange
   * @listens Tech#posterchange
   * @private
   */ handleTechPosterChange_() {
        if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
            const newPoster = this.tech_.poster() || '';
            if (newPoster !== this.poster_) {
                this.poster_ = newPoster;
                this.isPosterFromTech_ = true;
                // Let components know the poster has changed
                this.trigger('posterchange');
            }
        }
    }
    /**
   * Get or set whether or not the controls are showing.
   *
   * @fires Player#controlsenabled
   *
   * @param {boolean} [bool]
   *        - true to turn controls on
   *        - false to turn controls off
   *
   * @return {boolean|undefined}
   *         - The current value of controls when getting
   *         - Nothing when setting
   */ controls(bool) {
        if (bool === undefined) return !!this.controls_;
        bool = !!bool;
        // Don't trigger a change event unless it actually changed
        if (this.controls_ === bool) return;
        this.controls_ = bool;
        if (this.usingNativeControls()) this.techCall_('setControls', bool);
        if (this.controls_) {
            this.removeClass('vjs-controls-disabled');
            this.addClass('vjs-controls-enabled');
            /**
       * @event Player#controlsenabled
       * @type {Event}
       */ this.trigger('controlsenabled');
            if (!this.usingNativeControls()) this.addTechControlsListeners_();
        } else {
            this.removeClass('vjs-controls-enabled');
            this.addClass('vjs-controls-disabled');
            /**
       * @event Player#controlsdisabled
       * @type {Event}
       */ this.trigger('controlsdisabled');
            if (!this.usingNativeControls()) this.removeTechControlsListeners_();
        }
    }
    /**
   * Toggle native controls on/off. Native controls are the controls built into
   * devices (e.g. default iPhone controls) or other techs
   * (e.g. Vimeo Controls)
   * **This should only be set by the current tech, because only the tech knows
   * if it can support native controls**
   *
   * @fires Player#usingnativecontrols
   * @fires Player#usingcustomcontrols
   *
   * @param {boolean} [bool]
   *        - true to turn native controls on
   *        - false to turn native controls off
   *
   * @return {boolean|undefined}
   *         - The current value of native controls when getting
   *         - Nothing when setting
   */ usingNativeControls(bool) {
        if (bool === undefined) return !!this.usingNativeControls_;
        bool = !!bool;
        // Don't trigger a change event unless it actually changed
        if (this.usingNativeControls_ === bool) return;
        this.usingNativeControls_ = bool;
        if (this.usingNativeControls_) {
            this.addClass('vjs-using-native-controls');
            /**
       * player is using the native device controls
       *
       * @event Player#usingnativecontrols
       * @type {Event}
       */ this.trigger('usingnativecontrols');
        } else {
            this.removeClass('vjs-using-native-controls');
            /**
       * player is using the custom HTML controls
       *
       * @event Player#usingcustomcontrols
       * @type {Event}
       */ this.trigger('usingcustomcontrols');
        }
    }
    /**
   * Set or get the current MediaError
   *
   * @fires Player#error
   *
   * @param  {MediaError|string|number} [err]
   *         A MediaError or a string/number to be turned
   *         into a MediaError
   *
   * @return {MediaError|null|undefined}
   *         - The current MediaError when getting (or null)
   *         - Nothing when setting
   */ error(err) {
        if (err === undefined) return this.error_ || null;
        // allow hooks to modify error object
        $86defbb4e95ebb07$var$hooks('beforeerror').forEach((hookFunction)=>{
            const newErr = hookFunction(this, err);
            if (!($86defbb4e95ebb07$var$isObject(newErr) && !Array.isArray(newErr) || typeof newErr === 'string' || typeof newErr === 'number' || newErr === null)) {
                this.log.error('please return a value that MediaError expects in beforeerror hooks');
                return;
            }
            err = newErr;
        });
        // Suppress the first error message for no compatible source until
        // user interaction
        if (this.options_.suppressNotSupportedError && err && err.code === 4) {
            const triggerSuppressedError = function() {
                this.error(err);
            };
            this.options_.suppressNotSupportedError = false;
            this.any([
                'click',
                'touchstart'
            ], triggerSuppressedError);
            this.one('loadstart', function() {
                this.off([
                    'click',
                    'touchstart'
                ], triggerSuppressedError);
            });
            return;
        }
        // restoring to default
        if (err === null) {
            this.error_ = null;
            this.removeClass('vjs-error');
            if (this.errorDisplay) this.errorDisplay.close();
            return;
        }
        this.error_ = new $86defbb4e95ebb07$var$MediaError(err);
        // add the vjs-error classname to the player
        this.addClass('vjs-error');
        // log the name of the error type and any message
        // IE11 logs "[object object]" and required you to expand message to see error object
        $86defbb4e95ebb07$var$log$1.error(`(CODE:${this.error_.code} ${$86defbb4e95ebb07$var$MediaError.errorTypes[this.error_.code]})`, this.error_.message, this.error_);
        /**
     * @event Player#error
     * @type {Event}
     */ this.trigger('error');
        // notify hooks of the per player error
        $86defbb4e95ebb07$var$hooks('error').forEach((hookFunction)=>hookFunction(this, this.error_));
        return;
    }
    /**
   * Report user activity
   *
   * @param {Object} event
   *        Event object
   */ reportUserActivity(event) {
        this.userActivity_ = true;
    }
    /**
   * Get/set if user is active
   *
   * @fires Player#useractive
   * @fires Player#userinactive
   *
   * @param {boolean} [bool]
   *        - true if the user is active
   *        - false if the user is inactive
   *
   * @return {boolean|undefined}
   *         - The current value of userActive when getting
   *         - Nothing when setting
   */ userActive(bool) {
        if (bool === undefined) return this.userActive_;
        bool = !!bool;
        if (bool === this.userActive_) return;
        this.userActive_ = bool;
        if (this.userActive_) {
            this.userActivity_ = true;
            this.removeClass('vjs-user-inactive');
            this.addClass('vjs-user-active');
            /**
       * @event Player#useractive
       * @type {Event}
       */ this.trigger('useractive');
            return;
        }
        // Chrome/Safari/IE have bugs where when you change the cursor it can
        // trigger a mousemove event. This causes an issue when you're hiding
        // the cursor when the user is inactive, and a mousemove signals user
        // activity. Making it impossible to go into inactive mode. Specifically
        // this happens in fullscreen when we really need to hide the cursor.
        //
        // When this gets resolved in ALL browsers it can be removed
        // https://code.google.com/p/chromium/issues/detail?id=103041
        if (this.tech_) this.tech_.one('mousemove', function(e) {
            e.stopPropagation();
            e.preventDefault();
        });
        this.userActivity_ = false;
        this.removeClass('vjs-user-active');
        this.addClass('vjs-user-inactive');
        /**
     * @event Player#userinactive
     * @type {Event}
     */ this.trigger('userinactive');
    }
    /**
   * Listen for user activity based on timeout value
   *
   * @private
   */ listenForUserActivity_() {
        let mouseInProgress;
        let lastMoveX;
        let lastMoveY;
        const handleActivity = $86defbb4e95ebb07$var$bind_(this, this.reportUserActivity);
        const handleMouseMove = function(e) {
            // #1068 - Prevent mousemove spamming
            // Chrome Bug: https://code.google.com/p/chromium/issues/detail?id=366970
            if (e.screenX !== lastMoveX || e.screenY !== lastMoveY) {
                lastMoveX = e.screenX;
                lastMoveY = e.screenY;
                handleActivity();
            }
        };
        const handleMouseDown = function() {
            handleActivity();
            // For as long as the they are touching the device or have their mouse down,
            // we consider them active even if they're not moving their finger or mouse.
            // So we want to continue to update that they are active
            this.clearInterval(mouseInProgress);
            // Setting userActivity=true now and setting the interval to the same time
            // as the activityCheck interval (250) should ensure we never miss the
            // next activityCheck
            mouseInProgress = this.setInterval(handleActivity, 250);
        };
        const handleMouseUpAndMouseLeave = function(event) {
            handleActivity();
            // Stop the interval that maintains activity if the mouse/touch is down
            this.clearInterval(mouseInProgress);
        };
        // Any mouse movement will be considered user activity
        this.on('mousedown', handleMouseDown);
        this.on('mousemove', handleMouseMove);
        this.on('mouseup', handleMouseUpAndMouseLeave);
        this.on('mouseleave', handleMouseUpAndMouseLeave);
        const controlBar = this.getChild('controlBar');
        // Fixes bug on Android & iOS where when tapping progressBar (when control bar is displayed)
        // controlBar would no longer be hidden by default timeout.
        if (controlBar && !$86defbb4e95ebb07$var$IS_IOS && !$86defbb4e95ebb07$var$IS_ANDROID) {
            controlBar.on('mouseenter', function(event) {
                if (this.player().options_.inactivityTimeout !== 0) this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout;
                this.player().options_.inactivityTimeout = 0;
            });
            controlBar.on('mouseleave', function(event) {
                this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
            });
        }
        // Listen for keyboard navigation
        // Shouldn't need to use inProgress interval because of key repeat
        this.on('keydown', handleActivity);
        this.on('keyup', handleActivity);
        // Run an interval every 250 milliseconds instead of stuffing everything into
        // the mousemove/touchmove function itself, to prevent performance degradation.
        // `this.reportUserActivity` simply sets this.userActivity_ to true, which
        // then gets picked up by this loop
        // http://ejohn.org/blog/learning-from-twitter/
        let inactivityTimeout;
        /** @this Player */ const activityCheck = function() {
            // Check to see if mouse/touch activity has happened
            if (!this.userActivity_) return;
            // Reset the activity tracker
            this.userActivity_ = false;
            // If the user state was inactive, set the state to active
            this.userActive(true);
            // Clear any existing inactivity timeout to start the timer over
            this.clearTimeout(inactivityTimeout);
            const timeout = this.options_.inactivityTimeout;
            if (timeout <= 0) return;
            // In <timeout> milliseconds, if no more activity has occurred the
            // user will be considered inactive
            inactivityTimeout = this.setTimeout(function() {
                // Protect against the case where the inactivityTimeout can trigger just
                // before the next user activity is picked up by the activity check loop
                // causing a flicker
                if (!this.userActivity_) this.userActive(false);
            }, timeout);
        };
        this.setInterval(activityCheck, 250);
    }
    /**
   * Gets or sets the current playback rate. A playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed
   * playback, for instance.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
   *
   * @param {number} [rate]
   *       New playback rate to set.
   *
   * @return {number|undefined}
   *         - The current playback rate when getting or 1.0
   *         - Nothing when setting
   */ playbackRate(rate) {
        if (rate !== undefined) {
            // NOTE: this.cache_.lastPlaybackRate is set from the tech handler
            // that is registered above
            this.techCall_('setPlaybackRate', rate);
            return;
        }
        if (this.tech_ && this.tech_.featuresPlaybackRate) return this.cache_.lastPlaybackRate || this.techGet_('playbackRate');
        return 1.0;
    }
    /**
   * Gets or sets the current default playback rate. A default playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
   * not the current playbackRate.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
   *
   * @param {number} [rate]
   *       New default playback rate to set.
   *
   * @return {number|undefined}
   *         - The default playback rate when getting or 1.0
   *         - Nothing when setting
   */ defaultPlaybackRate(rate) {
        if (rate !== undefined) return this.techCall_('setDefaultPlaybackRate', rate);
        if (this.tech_ && this.tech_.featuresPlaybackRate) return this.techGet_('defaultPlaybackRate');
        return 1.0;
    }
    /**
   * Gets or sets the audio flag
   *
   * @param {boolean} [bool]
   *        - true signals that this is an audio player
   *        - false signals that this is not an audio player
   *
   * @return {boolean|undefined}
   *         - The current value of isAudio when getting
   *         - Nothing when setting
   */ isAudio(bool) {
        if (bool !== undefined) {
            this.isAudio_ = !!bool;
            return;
        }
        return !!this.isAudio_;
    }
    updatePlayerHeightOnAudioOnlyMode_() {
        const controlBar = this.getChild('ControlBar');
        if (!controlBar || this.audioOnlyCache_.controlBarHeight === controlBar.currentHeight()) return;
        this.audioOnlyCache_.controlBarHeight = controlBar.currentHeight();
        this.height(this.audioOnlyCache_.controlBarHeight);
    }
    enableAudioOnlyUI_() {
        // Update styling immediately to show the control bar so we can get its height
        this.addClass('vjs-audio-only-mode');
        const playerChildren = this.children();
        const controlBar = this.getChild('ControlBar');
        const controlBarHeight = controlBar && controlBar.currentHeight();
        // Hide all player components except the control bar. Control bar components
        // needed only for video are hidden with CSS
        playerChildren.forEach((child)=>{
            if (child === controlBar) return;
            if (child.el_ && !child.hasClass('vjs-hidden')) {
                child.hide();
                this.audioOnlyCache_.hiddenChildren.push(child);
            }
        });
        this.audioOnlyCache_.playerHeight = this.currentHeight();
        this.audioOnlyCache_.controlBarHeight = controlBarHeight;
        this.on('playerresize', this.boundUpdatePlayerHeightOnAudioOnlyMode_);
        // Set the player height the same as the control bar
        this.height(controlBarHeight);
        this.trigger('audioonlymodechange');
    }
    disableAudioOnlyUI_() {
        this.removeClass('vjs-audio-only-mode');
        this.off('playerresize', this.boundUpdatePlayerHeightOnAudioOnlyMode_);
        // Show player components that were previously hidden
        this.audioOnlyCache_.hiddenChildren.forEach((child)=>child.show());
        // Reset player height
        this.height(this.audioOnlyCache_.playerHeight);
        this.trigger('audioonlymodechange');
    }
    /**
   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
   *
   * Setting this to `true` will hide all player components except the control bar,
   * as well as control bar components needed only for video.
   *
   * @param {boolean} [value]
   *         The value to set audioOnlyMode to.
   *
   * @return {Promise|boolean}
   *        A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */ audioOnlyMode(value) {
        if (typeof value !== 'boolean' || value === this.audioOnlyMode_) return this.audioOnlyMode_;
        this.audioOnlyMode_ = value;
        // Enable Audio Only Mode
        if (value) {
            const exitPromises = [];
            // Fullscreen and PiP are not supported in audioOnlyMode, so exit if we need to.
            if (this.isInPictureInPicture()) exitPromises.push(this.exitPictureInPicture());
            if (this.isFullscreen()) exitPromises.push(this.exitFullscreen());
            if (this.audioPosterMode()) exitPromises.push(this.audioPosterMode(false));
            return Promise.all(exitPromises).then(()=>this.enableAudioOnlyUI_());
        }
        // Disable Audio Only Mode
        return Promise.resolve().then(()=>this.disableAudioOnlyUI_());
    }
    enablePosterModeUI_() {
        // Hide the video element and show the poster image to enable posterModeUI
        const tech = this.tech_ && this.tech_;
        tech.hide();
        this.addClass('vjs-audio-poster-mode');
        this.trigger('audiopostermodechange');
    }
    disablePosterModeUI_() {
        // Show the video element and hide the poster image to disable posterModeUI
        const tech = this.tech_ && this.tech_;
        tech.show();
        this.removeClass('vjs-audio-poster-mode');
        this.trigger('audiopostermodechange');
    }
    /**
   * Get the current audioPosterMode state or set audioPosterMode to true or false
   *
   * @param {boolean} [value]
   *         The value to set audioPosterMode to.
   *
   * @return {Promise|boolean}
   *         A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */ audioPosterMode(value) {
        if (typeof value !== 'boolean' || value === this.audioPosterMode_) return this.audioPosterMode_;
        this.audioPosterMode_ = value;
        if (value) {
            if (this.audioOnlyMode()) {
                const audioOnlyModePromise = this.audioOnlyMode(false);
                return audioOnlyModePromise.then(()=>{
                    // enable audio poster mode after audio only mode is disabled
                    this.enablePosterModeUI_();
                });
            }
            return Promise.resolve().then(()=>{
                // enable audio poster mode
                this.enablePosterModeUI_();
            });
        }
        return Promise.resolve().then(()=>{
            // disable audio poster mode
            this.disablePosterModeUI_();
        });
    }
    /**
   * A helper method for adding a {@link TextTrack} to our
   * {@link TextTrackList}.
   *
   * In addition to the W3C settings we allow adding additional info through options.
   *
   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
   *
   * @param {string} [kind]
   *        the kind of TextTrack you are adding
   *
   * @param {string} [label]
   *        the label to give the TextTrack label
   *
   * @param {string} [language]
   *        the language to set on the TextTrack
   *
   * @return {TextTrack|undefined}
   *         the TextTrack that was added or undefined
   *         if there is no tech
   */ addTextTrack(kind, label, language) {
        if (this.tech_) return this.tech_.addTextTrack(kind, label, language);
    }
    /**
   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
   *
   * @param {Object} options
   *        Options to pass to {@link HTMLTrackElement} during creation. See
   *        {@link HTMLTrackElement} for object properties that you should use.
   *
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack will not be removed
   *                                        from the TextTrackList and HtmlTrackElementList
   *                                        after a source change
   *
   * @return {HtmlTrackElement}
   *         the HTMLTrackElement that was created and added
   *         to the HtmlTrackElementList and the remote
   *         TextTrackList
   *
   */ addRemoteTextTrack(options, manualCleanup) {
        if (this.tech_) return this.tech_.addRemoteTextTrack(options, manualCleanup);
    }
    /**
   * Remove a remote {@link TextTrack} from the respective
   * {@link TextTrackList} and {@link HtmlTrackElementList}.
   *
   * @param {Object} track
   *        Remote {@link TextTrack} to remove
   *
   * @return {undefined}
   *         does not return anything
   */ removeRemoteTextTrack(obj = {}) {
        let { track: track } = obj;
        if (!track) track = obj;
        // destructure the input into an object with a track argument, defaulting to arguments[0]
        // default the whole argument to an empty object if nothing was passed in
        if (this.tech_) return this.tech_.removeRemoteTextTrack(track);
    }
    /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object|undefined}
   *         An object with supported media playback quality metrics or undefined if there
   *         is no tech or the tech does not support it.
   */ getVideoPlaybackQuality() {
        return this.techGet_('getVideoPlaybackQuality');
    }
    /**
   * Get video width
   *
   * @return {number}
   *         current video width
   */ videoWidth() {
        return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
    }
    /**
   * Get video height
   *
   * @return {number}
   *         current video height
   */ videoHeight() {
        return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
    }
    /**
   * Set or get the player's language code.
   *
   * Changing the language will trigger
   * [languagechange]{@link Player#event:languagechange}
   * which Components can use to update control text.
   * ClickableComponent will update its control text by default on
   * [languagechange]{@link Player#event:languagechange}.
   *
   * @fires Player#languagechange
   *
   * @param {string} [code]
   *        the language code to set the player to
   *
   * @return {string|undefined}
   *         - The current language code when getting
   *         - Nothing when setting
   */ language(code) {
        if (code === undefined) return this.language_;
        if (this.language_ !== String(code).toLowerCase()) {
            this.language_ = String(code).toLowerCase();
            // during first init, it's possible some things won't be evented
            if ($86defbb4e95ebb07$var$isEvented(this)) /**
        * fires when the player language change
        *
        * @event Player#languagechange
        * @type {Event}
        */ this.trigger('languagechange');
        }
    }
    /**
   * Get the player's language dictionary
   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
   * Languages specified directly in the player options have precedence
   *
   * @return {Array}
   *         An array of of supported languages
   */ languages() {
        return $86defbb4e95ebb07$var$merge$1($86defbb4e95ebb07$var$Player.prototype.options_.languages, this.languages_);
    }
    /**
   * returns a JavaScript object representing the current track
   * information. **DOES not return it as JSON**
   *
   * @return {Object}
   *         Object representing the current of track info
   */ toJSON() {
        const options = $86defbb4e95ebb07$var$merge$1(this.options_);
        const tracks = options.tracks;
        options.tracks = [];
        for(let i = 0; i < tracks.length; i++){
            let track = tracks[i];
            // deep merge tracks and null out player so no circular references
            track = $86defbb4e95ebb07$var$merge$1(track);
            track.player = undefined;
            options.tracks[i] = track;
        }
        return options;
    }
    /**
   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
   * component) that immediately overlays the player with arbitrary
   * content and removes itself when closed.
   *
   * @param {string|Function|Element|Array|null} content
   *        Same as {@link ModalDialog#content}'s param of the same name.
   *        The most straight-forward usage is to provide a string or DOM
   *        element.
   *
   * @param {Object} [options]
   *        Extra options which will be passed on to the {@link ModalDialog}.
   *
   * @return {ModalDialog}
   *         the {@link ModalDialog} that was created
   */ createModal(content, options) {
        options = options || {};
        options.content = content || '';
        const modal = new $86defbb4e95ebb07$var$ModalDialog(this, options);
        this.addChild(modal);
        modal.on('dispose', ()=>{
            this.removeChild(modal);
        });
        modal.open();
        return modal;
    }
    /**
   * Change breakpoint classes when the player resizes.
   *
   * @private
   */ updateCurrentBreakpoint_() {
        if (!this.responsive()) return;
        const currentBreakpoint = this.currentBreakpoint();
        const currentWidth = this.currentWidth();
        for(let i = 0; i < $86defbb4e95ebb07$var$BREAKPOINT_ORDER.length; i++){
            const candidateBreakpoint = $86defbb4e95ebb07$var$BREAKPOINT_ORDER[i];
            const maxWidth = this.breakpoints_[candidateBreakpoint];
            if (currentWidth <= maxWidth) {
                // The current breakpoint did not change, nothing to do.
                if (currentBreakpoint === candidateBreakpoint) return;
                // Only remove a class if there is a current breakpoint.
                if (currentBreakpoint) this.removeClass($86defbb4e95ebb07$var$BREAKPOINT_CLASSES[currentBreakpoint]);
                this.addClass($86defbb4e95ebb07$var$BREAKPOINT_CLASSES[candidateBreakpoint]);
                this.breakpoint_ = candidateBreakpoint;
                break;
            }
        }
    }
    /**
   * Removes the current breakpoint.
   *
   * @private
   */ removeCurrentBreakpoint_() {
        const className = this.currentBreakpointClass();
        this.breakpoint_ = '';
        if (className) this.removeClass(className);
    }
    /**
   * Get or set breakpoints on the player.
   *
   * Calling this method with an object or `true` will remove any previous
   * custom breakpoints and start from the defaults again.
   *
   * @param  {Object|boolean} [breakpoints]
   *         If an object is given, it can be used to provide custom
   *         breakpoints. If `true` is given, will set default breakpoints.
   *         If this argument is not given, will simply return the current
   *         breakpoints.
   *
   * @param  {number} [breakpoints.tiny]
   *         The maximum width for the "vjs-layout-tiny" class.
   *
   * @param  {number} [breakpoints.xsmall]
   *         The maximum width for the "vjs-layout-x-small" class.
   *
   * @param  {number} [breakpoints.small]
   *         The maximum width for the "vjs-layout-small" class.
   *
   * @param  {number} [breakpoints.medium]
   *         The maximum width for the "vjs-layout-medium" class.
   *
   * @param  {number} [breakpoints.large]
   *         The maximum width for the "vjs-layout-large" class.
   *
   * @param  {number} [breakpoints.xlarge]
   *         The maximum width for the "vjs-layout-x-large" class.
   *
   * @param  {number} [breakpoints.huge]
   *         The maximum width for the "vjs-layout-huge" class.
   *
   * @return {Object}
   *         An object mapping breakpoint names to maximum width values.
   */ breakpoints(breakpoints) {
        // Used as a getter.
        if (breakpoints === undefined) return Object.assign(this.breakpoints_);
        this.removeCurrentBreakpoint_();
        this.breakpoints_ = Object.assign({}, $86defbb4e95ebb07$var$DEFAULT_BREAKPOINTS, breakpoints);
        // When breakpoint definitions change, we need to update the currently
        // selected breakpoint.
        this.updateCurrentBreakpoint_();
        // Clone the breakpoints before returning.
        return Object.assign(this.breakpoints_);
    }
    /**
   * Get or set a flag indicating whether or not this player should adjust
   * its UI based on its dimensions.
   *
   * @param  {boolean} [value]
   *         Should be `true` if the player should adjust its UI based on its
   *         dimensions; otherwise, should be `false`.
   *
   * @return {boolean|undefined}
   *         Will be `true` if this player should adjust its UI based on its
   *         dimensions; otherwise, will be `false`.
   *         Nothing if setting
   */ responsive(value) {
        // Used as a getter.
        if (value === undefined) return this.responsive_;
        value = Boolean(value);
        const current = this.responsive_;
        // Nothing changed.
        if (value === current) return;
        // The value actually changed, set it.
        this.responsive_ = value;
        // Start listening for breakpoints and set the initial breakpoint if the
        // player is now responsive.
        if (value) {
            this.on('playerresize', this.boundUpdateCurrentBreakpoint_);
            this.updateCurrentBreakpoint_();
        // Stop listening for breakpoints if the player is no longer responsive.
        } else {
            this.off('playerresize', this.boundUpdateCurrentBreakpoint_);
            this.removeCurrentBreakpoint_();
        }
        return value;
    }
    /**
   * Get current breakpoint name, if any.
   *
   * @return {string}
   *         If there is currently a breakpoint set, returns a the key from the
   *         breakpoints object matching it. Otherwise, returns an empty string.
   */ currentBreakpoint() {
        return this.breakpoint_;
    }
    /**
   * Get the current breakpoint class name.
   *
   * @return {string}
   *         The matching class name (e.g. `"vjs-layout-tiny"` or
   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
   *         there is no current breakpoint.
   */ currentBreakpointClass() {
        return $86defbb4e95ebb07$var$BREAKPOINT_CLASSES[this.breakpoint_] || '';
    }
    /**
   * An object that describes a single piece of media.
   *
   * Properties that are not part of this type description will be retained; so,
   * this can be viewed as a generic metadata storage mechanism as well.
   *
   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
   * @typedef  {Object} Player~MediaObject
   *
   * @property {string} [album]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {string} [artist]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [artwork]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API. If not specified, will be populated via the `poster`, if
   *           available.
   *
   * @property {string} [poster]
   *           URL to an image that will display before playback.
   *
   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
   *           A single source object, an array of source objects, or a string
   *           referencing a URL to a media source. It is _highly recommended_
   *           that an object or array of objects is used here, so that source
   *           selection algorithms can take the `type` into account.
   *
   * @property {string} [title]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [textTracks]
   *           An array of objects to be used to create text tracks, following
   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
   *           For ease of removal, these will be created as "remote" text
   *           tracks and set to automatically clean up on source changes.
   *
   *           These objects may have properties like `src`, `kind`, `label`,
   *           and `language`, see {@link Tech#createRemoteTextTrack}.
   */ /**
   * Populate the player using a {@link Player~MediaObject|MediaObject}.
   *
   * @param  {Player~MediaObject} media
   *         A media object.
   *
   * @param  {Function} ready
   *         A callback to be called when the player is ready.
   */ loadMedia(media, ready) {
        if (!media || typeof media !== 'object') return;
        const crossOrigin = this.crossOrigin();
        this.reset();
        // Clone the media object so it cannot be mutated from outside.
        this.cache_.media = $86defbb4e95ebb07$var$merge$1(media);
        const { artist: artist, artwork: artwork, description: description, poster: poster, src: src, textTracks: textTracks, title: title } = this.cache_.media;
        // If `artwork` is not given, create it using `poster`.
        if (!artwork && poster) this.cache_.media.artwork = [
            {
                src: poster,
                type: $86defbb4e95ebb07$var$getMimetype(poster)
            }
        ];
        if (crossOrigin) this.crossOrigin(crossOrigin);
        if (src) this.src(src);
        if (poster) this.poster(poster);
        if (Array.isArray(textTracks)) textTracks.forEach((tt)=>this.addRemoteTextTrack(tt, false));
        if (this.titleBar) this.titleBar.update({
            title: title,
            description: description || artist || ''
        });
        this.ready(ready);
    }
    /**
   * Get a clone of the current {@link Player~MediaObject} for this player.
   *
   * If the `loadMedia` method has not been used, will attempt to return a
   * {@link Player~MediaObject} based on the current state of the player.
   *
   * @return {Player~MediaObject}
   */ getMedia() {
        if (!this.cache_.media) {
            const poster = this.poster();
            const src = this.currentSources();
            const textTracks = Array.prototype.map.call(this.remoteTextTracks(), (tt)=>({
                    kind: tt.kind,
                    label: tt.label,
                    language: tt.language,
                    src: tt.src
                }));
            const media = {
                src: src,
                textTracks: textTracks
            };
            if (poster) {
                media.poster = poster;
                media.artwork = [
                    {
                        src: media.poster,
                        type: $86defbb4e95ebb07$var$getMimetype(media.poster)
                    }
                ];
            }
            return media;
        }
        return $86defbb4e95ebb07$var$merge$1(this.cache_.media);
    }
    /**
   * Gets tag settings
   *
   * @param {Element} tag
   *        The player tag
   *
   * @return {Object}
   *         An object containing all of the settings
   *         for a player tag
   */ static getTagSettings(tag) {
        const baseOptions = {
            sources: [],
            tracks: []
        };
        const tagOptions = $86defbb4e95ebb07$var$getAttributes(tag);
        const dataSetup = tagOptions['data-setup'];
        if ($86defbb4e95ebb07$var$hasClass(tag, 'vjs-fill')) tagOptions.fill = true;
        if ($86defbb4e95ebb07$var$hasClass(tag, 'vjs-fluid')) tagOptions.fluid = true;
        // Check if data-setup attr exists.
        if (dataSetup !== null) // Parse options JSON
        try {
            // If empty string, make it a parsable json object.
            Object.assign(tagOptions, JSON.parse(dataSetup || '{}'));
        } catch (e) {
            $86defbb4e95ebb07$var$log$1.error('data-setup', e);
        }
        Object.assign(baseOptions, tagOptions);
        // Get tag children settings
        if (tag.hasChildNodes()) {
            const children = tag.childNodes;
            for(let i = 0, j = children.length; i < j; i++){
                const child = children[i];
                // Change case needed: http://ejohn.org/blog/nodename-case-sensitivity/
                const childName = child.nodeName.toLowerCase();
                if (childName === 'source') baseOptions.sources.push($86defbb4e95ebb07$var$getAttributes(child));
                else if (childName === 'track') baseOptions.tracks.push($86defbb4e95ebb07$var$getAttributes(child));
            }
        }
        return baseOptions;
    }
    /**
   * Set debug mode to enable/disable logs at info level.
   *
   * @param {boolean} enabled
   * @fires Player#debugon
   * @fires Player#debugoff
   * @return {boolean|undefined}
   */ debug(enabled) {
        if (enabled === undefined) return this.debugEnabled_;
        if (enabled) {
            this.trigger('debugon');
            this.previousLogLevel_ = this.log.level;
            this.log.level('debug');
            this.debugEnabled_ = true;
        } else {
            this.trigger('debugoff');
            this.log.level(this.previousLogLevel_);
            this.previousLogLevel_ = undefined;
            this.debugEnabled_ = false;
        }
    }
    /**
   * Set or get current playback rates.
   * Takes an array and updates the playback rates menu with the new items.
   * Pass in an empty array to hide the menu.
   * Values other than arrays are ignored.
   *
   * @fires Player#playbackrateschange
   * @param {number[]} [newRates]
   *                   The new rates that the playback rates menu should update to.
   *                   An empty array will hide the menu
   * @return {number[]} When used as a getter will return the current playback rates
   */ playbackRates(newRates) {
        if (newRates === undefined) return this.cache_.playbackRates;
        // ignore any value that isn't an array
        if (!Array.isArray(newRates)) return;
        // ignore any arrays that don't only contain numbers
        if (!newRates.every((rate)=>typeof rate === 'number')) return;
        this.cache_.playbackRates = newRates;
        /**
    * fires when the playback rates in a player are changed
    *
    * @event Player#playbackrateschange
    * @type {Event}
    */ this.trigger('playbackrateschange');
    }
}
/**
 * Get the {@link VideoTrackList}
 *
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
 *
 * @return {VideoTrackList}
 *         the current video track list
 *
 * @method Player.prototype.videoTracks
 */ $86defbb4e95ebb07$var$Player.prototype.videoTracks = ()=>{};
/**
 * Get the {@link AudioTrackList}
 *
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist
 *
 * @return {AudioTrackList}
 *         the current audio track list
 *
 * @method Player.prototype.audioTracks
 */ $86defbb4e95ebb07$var$Player.prototype.audioTracks = ()=>{};
/**
 * Get the {@link TextTrackList}
 *
 * @link http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-texttracks
 *
 * @return {TextTrackList}
 *         the current text track list
 *
 * @method Player.prototype.textTracks
 */ $86defbb4e95ebb07$var$Player.prototype.textTracks = ()=>{};
/**
 * Get the remote {@link TextTrackList}
 *
 * @return {TextTrackList}
 *         The current remote text track list
 *
 * @method Player.prototype.remoteTextTracks
 */ $86defbb4e95ebb07$var$Player.prototype.remoteTextTracks = ()=>{};
/**
 * Get the remote {@link HtmlTrackElementList} tracks.
 *
 * @return {HtmlTrackElementList}
 *         The current remote text track element list
 *
 * @method Player.prototype.remoteTextTrackEls
 */ $86defbb4e95ebb07$var$Player.prototype.remoteTextTrackEls = ()=>{};
$86defbb4e95ebb07$var$ALL.names.forEach(function(name) {
    const props = $86defbb4e95ebb07$var$ALL[name];
    $86defbb4e95ebb07$var$Player.prototype[props.getterName] = function() {
        if (this.tech_) return this.tech_[props.getterName]();
        // if we have not yet loadTech_, we create {video,audio,text}Tracks_
        // these will be passed to the tech during loading
        this[props.privateName] = this[props.privateName] || new props.ListClass();
        return this[props.privateName];
    };
});
/**
 * Get or set the `Player`'s crossorigin option. For the HTML5 player, this
 * sets the `crossOrigin` property on the `<video>` tag to control the CORS
 * behavior.
 *
 * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
 *
 * @param {string} [value]
 *        The value to set the `Player`'s crossorigin to. If an argument is
 *        given, must be one of `anonymous` or `use-credentials`.
 *
 * @return {string|undefined}
 *         - The current crossorigin value of the `Player` when getting.
 *         - undefined when setting
 */ $86defbb4e95ebb07$var$Player.prototype.crossorigin = $86defbb4e95ebb07$var$Player.prototype.crossOrigin;
/**
 * Global enumeration of players.
 *
 * The keys are the player IDs and the values are either the {@link Player}
 * instance or `null` for disposed players.
 *
 * @type {Object}
 */ $86defbb4e95ebb07$var$Player.players = {};
const $86defbb4e95ebb07$var$navigator = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).navigator;
/*
 * Player instance options, surfaced using options
 * options = Player.prototype.options_
 * Make changes in options, not here.
 *
 * @type {Object}
 * @private
 */ $86defbb4e95ebb07$var$Player.prototype.options_ = {
    // Default order of fallback technology
    techOrder: $86defbb4e95ebb07$var$Tech.defaultTechOrder_,
    html5: {},
    // enable sourceset by default
    enableSourceset: true,
    // default inactivity timeout
    inactivityTimeout: 2000,
    // default playback rates
    playbackRates: [],
    // Add playback rate selection by adding rates
    // 'playbackRates': [0.5, 1, 1.5, 2],
    liveui: false,
    // Included control sets
    children: [
        'mediaLoader',
        'posterImage',
        'titleBar',
        'textTrackDisplay',
        'loadingSpinner',
        'bigPlayButton',
        'liveTracker',
        'controlBar',
        'errorDisplay',
        'textTrackSettings',
        'resizeManager'
    ],
    language: $86defbb4e95ebb07$var$navigator && ($86defbb4e95ebb07$var$navigator.languages && $86defbb4e95ebb07$var$navigator.languages[0] || $86defbb4e95ebb07$var$navigator.userLanguage || $86defbb4e95ebb07$var$navigator.language) || 'en',
    // locales and their language translations
    languages: {},
    // Default message to show when a video cannot be played.
    notSupportedMessage: 'No compatible source was found for this media.',
    normalizeAutoplay: false,
    fullscreen: {
        options: {
            navigationUI: 'hide'
        }
    },
    breakpoints: {},
    responsive: false,
    audioOnlyMode: false,
    audioPosterMode: false,
    spatialNavigation: {
        enabled: false,
        horizontalSeek: false
    },
    // Default smooth seeking to false
    enableSmoothSeeking: false,
    disableSeekWhileScrubbingOnMobile: false,
    disableSeekWhileScrubbingOnSTV: false
};
$86defbb4e95ebb07$var$TECH_EVENTS_RETRIGGER.forEach(function(event) {
    $86defbb4e95ebb07$var$Player.prototype[`handleTech${$86defbb4e95ebb07$var$toTitleCase$1(event)}_`] = function() {
        return this.trigger(event);
    };
});
/**
 * Fired when the player has initial duration and dimension information
 *
 * @event Player#loadedmetadata
 * @type {Event}
 */ /**
 * Fired when the player has downloaded data at the current playback position
 *
 * @event Player#loadeddata
 * @type {Event}
 */ /**
 * Fired when the current playback position has changed *
 * During playback this is fired every 15-250 milliseconds, depending on the
 * playback technology in use.
 *
 * @event Player#timeupdate
 * @type {Event}
 */ /**
 * Fired when the volume changes
 *
 * @event Player#volumechange
 * @type {Event}
 */ $86defbb4e95ebb07$var$Component$1.registerComponent('Player', $86defbb4e95ebb07$var$Player);
/**
 * @file plugin.js
 */ /**
 * The base plugin name.
 *
 * @private
 * @constant
 * @type {string}
 */ const $86defbb4e95ebb07$var$BASE_PLUGIN_NAME = 'plugin';
/**
 * The key on which a player's active plugins cache is stored.
 *
 * @private
 * @constant
 * @type     {string}
 */ const $86defbb4e95ebb07$var$PLUGIN_CACHE_KEY = 'activePlugins_';
/**
 * Stores registered plugins in a private space.
 *
 * @private
 * @type    {Object}
 */ const $86defbb4e95ebb07$var$pluginStorage = {};
/**
 * Reports whether or not a plugin has been registered.
 *
 * @private
 * @param   {string} name
 *          The name of a plugin.
 *
 * @return {boolean}
 *          Whether or not the plugin has been registered.
 */ const $86defbb4e95ebb07$var$pluginExists = (name)=>$86defbb4e95ebb07$var$pluginStorage.hasOwnProperty(name);
/**
 * Get a single registered plugin by name.
 *
 * @private
 * @param   {string} name
 *          The name of a plugin.
 *
 * @return {typeof Plugin|Function|undefined}
 *          The plugin (or undefined).
 */ const $86defbb4e95ebb07$var$getPlugin = (name)=>$86defbb4e95ebb07$var$pluginExists(name) ? $86defbb4e95ebb07$var$pluginStorage[name] : undefined;
/**
 * Marks a plugin as "active" on a player.
 *
 * Also, ensures that the player has an object for tracking active plugins.
 *
 * @private
 * @param   {Player} player
 *          A Video.js player instance.
 *
 * @param   {string} name
 *          The name of a plugin.
 */ const $86defbb4e95ebb07$var$markPluginAsActive = (player, name)=>{
    player[$86defbb4e95ebb07$var$PLUGIN_CACHE_KEY] = player[$86defbb4e95ebb07$var$PLUGIN_CACHE_KEY] || {};
    player[$86defbb4e95ebb07$var$PLUGIN_CACHE_KEY][name] = true;
};
/**
 * Triggers a pair of plugin setup events.
 *
 * @private
 * @param  {Player} player
 *         A Video.js player instance.
 *
 * @param  {PluginEventHash} hash
 *         A plugin event hash.
 *
 * @param  {boolean} [before]
 *         If true, prefixes the event name with "before". In other words,
 *         use this to trigger "beforepluginsetup" instead of "pluginsetup".
 */ const $86defbb4e95ebb07$var$triggerSetupEvent = (player, hash, before)=>{
    const eventName = (before ? 'before' : '') + 'pluginsetup';
    player.trigger(eventName, hash);
    player.trigger(eventName + ':' + hash.name, hash);
};
/**
 * Takes a basic plugin function and returns a wrapper function which marks
 * on the player that the plugin has been activated.
 *
 * @private
 * @param   {string} name
 *          The name of the plugin.
 *
 * @param   {Function} plugin
 *          The basic plugin.
 *
 * @return {Function}
 *          A wrapper function for the given plugin.
 */ const $86defbb4e95ebb07$var$createBasicPlugin = function(name, plugin) {
    const basicPluginWrapper = function() {
        // We trigger the "beforepluginsetup" and "pluginsetup" events on the player
        // regardless, but we want the hash to be consistent with the hash provided
        // for advanced plugins.
        //
        // The only potentially counter-intuitive thing here is the `instance` in
        // the "pluginsetup" event is the value returned by the `plugin` function.
        $86defbb4e95ebb07$var$triggerSetupEvent(this, {
            name: name,
            plugin: plugin,
            instance: null
        }, true);
        const instance = plugin.apply(this, arguments);
        $86defbb4e95ebb07$var$markPluginAsActive(this, name);
        $86defbb4e95ebb07$var$triggerSetupEvent(this, {
            name: name,
            plugin: plugin,
            instance: instance
        });
        return instance;
    };
    Object.keys(plugin).forEach(function(prop) {
        basicPluginWrapper[prop] = plugin[prop];
    });
    return basicPluginWrapper;
};
/**
 * Takes a plugin sub-class and returns a factory function for generating
 * instances of it.
 *
 * This factory function will replace itself with an instance of the requested
 * sub-class of Plugin.
 *
 * @private
 * @param   {string} name
 *          The name of the plugin.
 *
 * @param   {Plugin} PluginSubClass
 *          The advanced plugin.
 *
 * @return {Function}
 */ const $86defbb4e95ebb07$var$createPluginFactory = (name, PluginSubClass)=>{
    // Add a `name` property to the plugin prototype so that each plugin can
    // refer to itself by name.
    PluginSubClass.prototype.name = name;
    return function(...args) {
        $86defbb4e95ebb07$var$triggerSetupEvent(this, {
            name: name,
            plugin: PluginSubClass,
            instance: null
        }, true);
        const instance = new PluginSubClass(...[
            this,
            ...args
        ]);
        // The plugin is replaced by a function that returns the current instance.
        this[name] = ()=>instance;
        $86defbb4e95ebb07$var$triggerSetupEvent(this, instance.getEventHash());
        return instance;
    };
};
/**
 * Parent class for all advanced plugins.
 *
 * @mixes   module:evented~EventedMixin
 * @mixes   module:stateful~StatefulMixin
 * @fires   Player#beforepluginsetup
 * @fires   Player#beforepluginsetup:$name
 * @fires   Player#pluginsetup
 * @fires   Player#pluginsetup:$name
 * @listens Player#dispose
 * @throws  {Error}
 *          If attempting to instantiate the base {@link Plugin} class
 *          directly instead of via a sub-class.
 */ class $86defbb4e95ebb07$var$Plugin {
    /**
   * Creates an instance of this class.
   *
   * Sub-classes should call `super` to ensure plugins are properly initialized.
   *
   * @param {Player} player
   *        A Video.js player instance.
   */ constructor(player){
        if (this.constructor === $86defbb4e95ebb07$var$Plugin) throw new Error('Plugin must be sub-classed; not directly instantiated.');
        this.player = player;
        if (!this.log) this.log = this.player.log.createLogger(this.name);
        // Make this object evented, but remove the added `trigger` method so we
        // use the prototype version instead.
        $86defbb4e95ebb07$var$evented(this);
        delete this.trigger;
        $86defbb4e95ebb07$var$stateful(this, this.constructor.defaultState);
        $86defbb4e95ebb07$var$markPluginAsActive(player, this.name);
        // Auto-bind the dispose method so we can use it as a listener and unbind
        // it later easily.
        this.dispose = this.dispose.bind(this);
        // If the player is disposed, dispose the plugin.
        player.on('dispose', this.dispose);
    }
    /**
   * Get the version of the plugin that was set on <pluginName>.VERSION
   */ version() {
        return this.constructor.VERSION;
    }
    /**
   * Each event triggered by plugins includes a hash of additional data with
   * conventional properties.
   *
   * This returns that object or mutates an existing hash.
   *
   * @param   {Object} [hash={}]
   *          An object to be used as event an event hash.
   *
   * @return {PluginEventHash}
   *          An event hash object with provided properties mixed-in.
   */ getEventHash(hash = {}) {
        hash.name = this.name;
        hash.plugin = this.constructor;
        hash.instance = this;
        return hash;
    }
    /**
   * Triggers an event on the plugin object and overrides
   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash={}]
   *          Additional data hash to merge with a
   *          {@link PluginEventHash|PluginEventHash}.
   *
   * @return {boolean}
   *          Whether or not default was prevented.
   */ trigger(event, hash = {}) {
        return $86defbb4e95ebb07$var$trigger(this.eventBusEl_, event, this.getEventHash(hash));
    }
    /**
   * Handles "statechanged" events on the plugin. No-op by default, override by
   * subclassing.
   *
   * @abstract
   * @param    {Event} e
   *           An event object provided by a "statechanged" event.
   *
   * @param    {Object} e.changes
   *           An object describing changes that occurred with the "statechanged"
   *           event.
   */ handleStateChanged(e) {}
    /**
   * Disposes a plugin.
   *
   * Subclasses can override this if they want, but for the sake of safety,
   * it's probably best to subscribe the "dispose" event.
   *
   * @fires Plugin#dispose
   */ dispose() {
        const { name: name, player: player } = this;
        /**
     * Signals that a advanced plugin is about to be disposed.
     *
     * @event Plugin#dispose
     * @type  {Event}
     */ this.trigger('dispose');
        this.off();
        player.off('dispose', this.dispose);
        // Eliminate any possible sources of leaking memory by clearing up
        // references between the player and the plugin instance and nulling out
        // the plugin's state and replacing methods with a function that throws.
        player[$86defbb4e95ebb07$var$PLUGIN_CACHE_KEY][name] = false;
        this.player = this.state = null;
        // Finally, replace the plugin name on the player with a new factory
        // function, so that the plugin is ready to be set up again.
        player[name] = $86defbb4e95ebb07$var$createPluginFactory(name, $86defbb4e95ebb07$var$pluginStorage[name]);
    }
    /**
   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
   *
   * @param   {string|Function} plugin
   *          If a string, matches the name of a plugin. If a function, will be
   *          tested directly.
   *
   * @return {boolean}
   *          Whether or not a plugin is a basic plugin.
   */ static isBasic(plugin) {
        const p = typeof plugin === 'string' ? $86defbb4e95ebb07$var$getPlugin(plugin) : plugin;
        return typeof p === 'function' && !$86defbb4e95ebb07$var$Plugin.prototype.isPrototypeOf(p.prototype);
    }
    /**
   * Register a Video.js plugin.
   *
   * @param   {string} name
   *          The name of the plugin to be registered. Must be a string and
   *          must not match an existing plugin or a method on the `Player`
   *          prototype.
   *
   * @param   {typeof Plugin|Function} plugin
   *          A sub-class of `Plugin` or a function for basic plugins.
   *
   * @return {typeof Plugin|Function}
   *          For advanced plugins, a factory function for that plugin. For
   *          basic plugins, a wrapper function that initializes the plugin.
   */ static registerPlugin(name, plugin) {
        if (typeof name !== 'string') throw new Error(`Illegal plugin name, "${name}", must be a string, was ${typeof name}.`);
        if ($86defbb4e95ebb07$var$pluginExists(name)) $86defbb4e95ebb07$var$log$1.warn(`A plugin named "${name}" already exists. You may want to avoid re-registering plugins!`);
        else if ($86defbb4e95ebb07$var$Player.prototype.hasOwnProperty(name)) throw new Error(`Illegal plugin name, "${name}", cannot share a name with an existing player method!`);
        if (typeof plugin !== 'function') throw new Error(`Illegal plugin for "${name}", must be a function, was ${typeof plugin}.`);
        $86defbb4e95ebb07$var$pluginStorage[name] = plugin;
        // Add a player prototype method for all sub-classed plugins (but not for
        // the base Plugin class).
        if (name !== $86defbb4e95ebb07$var$BASE_PLUGIN_NAME) {
            if ($86defbb4e95ebb07$var$Plugin.isBasic(plugin)) $86defbb4e95ebb07$var$Player.prototype[name] = $86defbb4e95ebb07$var$createBasicPlugin(name, plugin);
            else $86defbb4e95ebb07$var$Player.prototype[name] = $86defbb4e95ebb07$var$createPluginFactory(name, plugin);
        }
        return plugin;
    }
    /**
   * De-register a Video.js plugin.
   *
   * @param  {string} name
   *         The name of the plugin to be de-registered. Must be a string that
   *         matches an existing plugin.
   *
   * @throws {Error}
   *         If an attempt is made to de-register the base plugin.
   */ static deregisterPlugin(name) {
        if (name === $86defbb4e95ebb07$var$BASE_PLUGIN_NAME) throw new Error('Cannot de-register base plugin.');
        if ($86defbb4e95ebb07$var$pluginExists(name)) {
            delete $86defbb4e95ebb07$var$pluginStorage[name];
            delete $86defbb4e95ebb07$var$Player.prototype[name];
        }
    }
    /**
   * Gets an object containing multiple Video.js plugins.
   *
   * @param   {Array} [names]
   *          If provided, should be an array of plugin names. Defaults to _all_
   *          plugin names.
   *
   * @return {Object|undefined}
   *          An object containing plugin(s) associated with their name(s) or
   *          `undefined` if no matching plugins exist).
   */ static getPlugins(names = Object.keys($86defbb4e95ebb07$var$pluginStorage)) {
        let result;
        names.forEach((name)=>{
            const plugin = $86defbb4e95ebb07$var$getPlugin(name);
            if (plugin) {
                result = result || {};
                result[name] = plugin;
            }
        });
        return result;
    }
    /**
   * Gets a plugin's version, if available
   *
   * @param   {string} name
   *          The name of a plugin.
   *
   * @return {string}
   *          The plugin's version or an empty string.
   */ static getPluginVersion(name) {
        const plugin = $86defbb4e95ebb07$var$getPlugin(name);
        return plugin && plugin.VERSION || '';
    }
}
/**
 * Gets a plugin by name if it exists.
 *
 * @static
 * @method   getPlugin
 * @memberOf Plugin
 * @param    {string} name
 *           The name of a plugin.
 *
 * @returns  {typeof Plugin|Function|undefined}
 *           The plugin (or `undefined`).
 */ $86defbb4e95ebb07$var$Plugin.getPlugin = $86defbb4e95ebb07$var$getPlugin;
/**
 * The name of the base plugin class as it is registered.
 *
 * @type {string}
 */ $86defbb4e95ebb07$var$Plugin.BASE_PLUGIN_NAME = $86defbb4e95ebb07$var$BASE_PLUGIN_NAME;
$86defbb4e95ebb07$var$Plugin.registerPlugin($86defbb4e95ebb07$var$BASE_PLUGIN_NAME, $86defbb4e95ebb07$var$Plugin);
/**
 * Documented in player.js
 *
 * @ignore
 */ $86defbb4e95ebb07$var$Player.prototype.usingPlugin = function(name) {
    return !!this[$86defbb4e95ebb07$var$PLUGIN_CACHE_KEY] && this[$86defbb4e95ebb07$var$PLUGIN_CACHE_KEY][name] === true;
};
/**
 * Documented in player.js
 *
 * @ignore
 */ $86defbb4e95ebb07$var$Player.prototype.hasPlugin = function(name) {
    return !!$86defbb4e95ebb07$var$pluginExists(name);
};
/**
 * Signals that a plugin is about to be set up on a player.
 *
 * @event    Player#beforepluginsetup
 * @type     {PluginEventHash}
 */ /**
 * Signals that a plugin is about to be set up on a player - by name. The name
 * is the name of the plugin.
 *
 * @event    Player#beforepluginsetup:$name
 * @type     {PluginEventHash}
 */ /**
 * Signals that a plugin has just been set up on a player.
 *
 * @event    Player#pluginsetup
 * @type     {PluginEventHash}
 */ /**
 * Signals that a plugin has just been set up on a player - by name. The name
 * is the name of the plugin.
 *
 * @event    Player#pluginsetup:$name
 * @type     {PluginEventHash}
 */ /**
 * @typedef  {Object} PluginEventHash
 *
 * @property {string} instance
 *           For basic plugins, the return value of the plugin function. For
 *           advanced plugins, the plugin instance on which the event is fired.
 *
 * @property {string} name
 *           The name of the plugin.
 *
 * @property {string} plugin
 *           For basic plugins, the plugin function. For advanced plugins, the
 *           plugin class/constructor.
 */ /**
 * @file deprecate.js
 * @module deprecate
 */ /**
 * Decorate a function with a deprecation message the first time it is called.
 *
 * @param  {string}   message
 *         A deprecation message to log the first time the returned function
 *         is called.
 *
 * @param  {Function} fn
 *         The function to be deprecated.
 *
 * @return {Function}
 *         A wrapper function that will log a deprecation warning the first
 *         time it is called. The return value will be the return value of
 *         the wrapped function.
 */ function $86defbb4e95ebb07$var$deprecate(message, fn) {
    let warned = false;
    return function(...args) {
        if (!warned) $86defbb4e95ebb07$var$log$1.warn(message);
        warned = true;
        return fn.apply(this, args);
    };
}
/**
 * Internal function used to mark a function as deprecated in the next major
 * version with consistent messaging.
 *
 * @param  {number}   major   The major version where it will be removed
 * @param  {string}   oldName The old function name
 * @param  {string}   newName The new function name
 * @param  {Function} fn      The function to deprecate
 * @return {Function}         The decorated function
 */ function $86defbb4e95ebb07$var$deprecateForMajor(major, oldName, newName, fn) {
    return $86defbb4e95ebb07$var$deprecate(`${oldName} is deprecated and will be removed in ${major}.0; please use ${newName} instead.`, fn);
}
var $86defbb4e95ebb07$var$VjsErrors = {
    NetworkBadStatus: 'networkbadstatus',
    NetworkRequestFailed: 'networkrequestfailed',
    NetworkRequestAborted: 'networkrequestaborted',
    NetworkRequestTimeout: 'networkrequesttimeout',
    NetworkBodyParserFailed: 'networkbodyparserfailed',
    StreamingHlsPlaylistParserError: 'streaminghlsplaylistparsererror',
    StreamingDashManifestParserError: 'streamingdashmanifestparsererror',
    StreamingContentSteeringParserError: 'streamingcontentsteeringparsererror',
    StreamingVttParserError: 'streamingvttparsererror',
    StreamingFailedToSelectNextSegment: 'streamingfailedtoselectnextsegment',
    StreamingFailedToDecryptSegment: 'streamingfailedtodecryptsegment',
    StreamingFailedToTransmuxSegment: 'streamingfailedtotransmuxsegment',
    StreamingFailedToAppendSegment: 'streamingfailedtoappendsegment',
    StreamingCodecsChangeError: 'streamingcodecschangeerror'
};
/**
 * @file video.js
 * @module videojs
 */ /** @import { PlayerReadyCallback } from './player' */ /**
 * Normalize an `id` value by trimming off a leading `#`
 *
 * @private
 * @param   {string} id
 *          A string, maybe with a leading `#`.
 *
 * @return {string}
 *          The string, without any leading `#`.
 */ const $86defbb4e95ebb07$var$normalizeId = (id)=>id.indexOf('#') === 0 ? id.slice(1) : id;
/**
 * The `videojs()` function doubles as the main function for users to create a
 * {@link Player} instance as well as the main library namespace.
 *
 * It can also be used as a getter for a pre-existing {@link Player} instance.
 * However, we _strongly_ recommend using `videojs.getPlayer()` for this
 * purpose because it avoids any potential for unintended initialization.
 *
 * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
 * of our JSDoc template, we cannot properly document this as both a function
 * and a namespace, so its function signature is documented here.
 *
 * #### Arguments
 * ##### id
 * string|Element, **required**
 *
 * Video element or video element ID.
 *
 * ##### options
 * Object, optional
 *
 * Options object for providing settings.
 * See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
 *
 * ##### ready
 * {@link Component~ReadyCallback}, optional
 *
 * A function to be called when the {@link Player} and {@link Tech} are ready.
 *
 * #### Return Value
 *
 * The `videojs()` function returns a {@link Player} instance.
 *
 * @namespace
 *
 * @borrows AudioTrack as AudioTrack
 * @borrows Component.getComponent as getComponent
 * @borrows module:events.on as on
 * @borrows module:events.one as one
 * @borrows module:events.off as off
 * @borrows module:events.trigger as trigger
 * @borrows EventTarget as EventTarget
 * @borrows module:middleware.use as use
 * @borrows Player.players as players
 * @borrows Plugin.registerPlugin as registerPlugin
 * @borrows Plugin.deregisterPlugin as deregisterPlugin
 * @borrows Plugin.getPlugins as getPlugins
 * @borrows Plugin.getPlugin as getPlugin
 * @borrows Plugin.getPluginVersion as getPluginVersion
 * @borrows Tech.getTech as getTech
 * @borrows Tech.registerTech as registerTech
 * @borrows TextTrack as TextTrack
 * @borrows VideoTrack as VideoTrack
 *
 * @param  {string|Element} id
 *         Video element or video element ID.
 *
 * @param  {Object} [options]
 *         Options object for providing settings.
 *         See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
 *
 * @param  {PlayerReadyCallback} [ready]
 *         A function to be called when the {@link Player} and {@link Tech} are
 *         ready.
 *
 * @return {Player}
 *         The `videojs()` function returns a {@link Player|Player} instance.
 */ function $86defbb4e95ebb07$export$2e2bcd8739ae039(id, options, ready) {
    let player = $86defbb4e95ebb07$export$2e2bcd8739ae039.getPlayer(id);
    if (player) {
        if (options) $86defbb4e95ebb07$var$log$1.warn(`Player "${id}" is already initialised. Options will not be applied.`);
        if (ready) player.ready(ready);
        return player;
    }
    const el = typeof id === 'string' ? $86defbb4e95ebb07$var$$('#' + $86defbb4e95ebb07$var$normalizeId(id)) : id;
    if (!$86defbb4e95ebb07$var$isEl(el)) throw new TypeError('The element or ID supplied is not valid. (videojs)');
    // document.body.contains(el) will only check if el is contained within that one document.
    // This causes problems for elements in iframes.
    // Instead, use the element's ownerDocument instead of the global document.
    // This will make sure that the element is indeed in the dom of that document.
    // Additionally, check that the document in question has a default view.
    // If the document is no longer attached to the dom, the defaultView of the document will be null.
    // If element is inside Shadow DOM (e.g. is part of a Custom element), ownerDocument.body
    // always returns false. Instead, use the Shadow DOM root.
    const inShadowDom = 'getRootNode' in el ? el.getRootNode() instanceof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).ShadowRoot : false;
    const rootNode = inShadowDom ? el.getRootNode() : el.ownerDocument.body;
    if (!el.ownerDocument.defaultView || !rootNode.contains(el)) $86defbb4e95ebb07$var$log$1.warn('The element supplied is not included in the DOM');
    options = options || {};
    // Store a copy of the el before modification, if it is to be restored in destroy()
    // If div ingest, store the parent div
    if (options.restoreEl === true) options.restoreEl = (el.parentNode && el.parentNode.hasAttribute && el.parentNode.hasAttribute('data-vjs-player') ? el.parentNode : el).cloneNode(true);
    $86defbb4e95ebb07$var$hooks('beforesetup').forEach((hookFunction)=>{
        const opts = hookFunction(el, $86defbb4e95ebb07$var$merge$1(options));
        if (!$86defbb4e95ebb07$var$isObject(opts) || Array.isArray(opts)) {
            $86defbb4e95ebb07$var$log$1.error('please return an object in beforesetup hooks');
            return;
        }
        options = $86defbb4e95ebb07$var$merge$1(options, opts);
    });
    // We get the current "Player" component here in case an integration has
    // replaced it with a custom player.
    const PlayerComponent = $86defbb4e95ebb07$var$Component$1.getComponent('Player');
    player = new PlayerComponent(el, options, ready);
    $86defbb4e95ebb07$var$hooks('setup').forEach((hookFunction)=>hookFunction(player));
    return player;
}
$86defbb4e95ebb07$export$2e2bcd8739ae039.hooks_ = $86defbb4e95ebb07$var$hooks_;
$86defbb4e95ebb07$export$2e2bcd8739ae039.hooks = $86defbb4e95ebb07$var$hooks;
$86defbb4e95ebb07$export$2e2bcd8739ae039.hook = $86defbb4e95ebb07$var$hook;
$86defbb4e95ebb07$export$2e2bcd8739ae039.hookOnce = $86defbb4e95ebb07$var$hookOnce;
$86defbb4e95ebb07$export$2e2bcd8739ae039.removeHook = $86defbb4e95ebb07$var$removeHook;
// Add default styles
if ((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).VIDEOJS_NO_DYNAMIC_STYLE !== true && $86defbb4e95ebb07$var$isReal()) {
    let style = $86defbb4e95ebb07$var$$('.vjs-styles-defaults');
    if (!style) {
        style = $86defbb4e95ebb07$var$createStyleElement('vjs-styles-defaults');
        const head = $86defbb4e95ebb07$var$$('head');
        if (head) head.insertBefore(style, head.firstChild);
        $86defbb4e95ebb07$var$setTextContent(style, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: 56.25%
      }
    `);
    }
}
// Run Auto-load players
// You have to wait at least once in case this script is loaded after your
// video in the DOM (weird behavior only with minified version)
$86defbb4e95ebb07$var$autoSetupTimeout(1, $86defbb4e95ebb07$export$2e2bcd8739ae039);
/**
 * Current Video.js version. Follows [semantic versioning](https://semver.org/).
 *
 * @type {string}
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.VERSION = $86defbb4e95ebb07$var$version$6;
/**
 * The global options object. These are the settings that take effect
 * if no overrides are specified when the player is created.
 *
 * @type {Object}
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.options = $86defbb4e95ebb07$var$Player.prototype.options_;
/**
 * Get an object with the currently created players, keyed by player ID
 *
 * @return {Object}
 *         The created players
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.getPlayers = ()=>$86defbb4e95ebb07$var$Player.players;
/**
 * Get a single player based on an ID or DOM element.
 *
 * This is useful if you want to check if an element or ID has an associated
 * Video.js player, but not create one if it doesn't.
 *
 * @param   {string|Element} id
 *          An HTML element - `<video>`, `<audio>`, or `<video-js>` -
 *          or a string matching the `id` of such an element.
 *
 * @return {Player|undefined}
 *          A player instance or `undefined` if there is no player instance
 *          matching the argument.
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.getPlayer = (id)=>{
    const players = $86defbb4e95ebb07$var$Player.players;
    let tag;
    if (typeof id === 'string') {
        const nId = $86defbb4e95ebb07$var$normalizeId(id);
        const player = players[nId];
        if (player) return player;
        tag = $86defbb4e95ebb07$var$$('#' + nId);
    } else tag = id;
    if ($86defbb4e95ebb07$var$isEl(tag)) {
        const { player: player, playerId: playerId } = tag;
        // Element may have a `player` property referring to an already created
        // player instance. If so, return that.
        if (player || players[playerId]) return player || players[playerId];
    }
};
/**
 * Returns an array of all current players.
 *
 * @return {Array}
 *         An array of all players. The array will be in the order that
 *         `Object.keys` provides, which could potentially vary between
 *         JavaScript engines.
 *
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.getAllPlayers = ()=>// Disposed players leave a key with a `null` value, so we need to make sure
    // we filter those out.
    Object.keys($86defbb4e95ebb07$var$Player.players).map((k)=>$86defbb4e95ebb07$var$Player.players[k]).filter(Boolean);
$86defbb4e95ebb07$export$2e2bcd8739ae039.players = $86defbb4e95ebb07$var$Player.players;
$86defbb4e95ebb07$export$2e2bcd8739ae039.getComponent = $86defbb4e95ebb07$var$Component$1.getComponent;
/**
 * Register a component so it can referred to by name. Used when adding to other
 * components, either through addChild `component.addChild('myComponent')` or through
 * default children options  `{ children: ['myComponent'] }`.
 *
 * > NOTE: You could also just initialize the component before adding.
 * `component.addChild(new MyComponent());`
 *
 * @param {string} name
 *        The class name of the component
 *
 * @param {typeof Component} comp
 *        The component class
 *
 * @return {typeof Component}
 *         The newly registered component
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.registerComponent = (name, comp)=>{
    if ($86defbb4e95ebb07$var$Tech.isTech(comp)) $86defbb4e95ebb07$var$log$1.warn(`The ${name} tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)`);
    return $86defbb4e95ebb07$var$Component$1.registerComponent.call($86defbb4e95ebb07$var$Component$1, name, comp);
};
$86defbb4e95ebb07$export$2e2bcd8739ae039.getTech = $86defbb4e95ebb07$var$Tech.getTech;
$86defbb4e95ebb07$export$2e2bcd8739ae039.registerTech = $86defbb4e95ebb07$var$Tech.registerTech;
$86defbb4e95ebb07$export$2e2bcd8739ae039.use = $86defbb4e95ebb07$var$use;
/**
 * An object that can be returned by a middleware to signify
 * that the middleware is being terminated.
 *
 * @type {object}
 * @property {object} middleware.TERMINATOR
 */ Object.defineProperty($86defbb4e95ebb07$export$2e2bcd8739ae039, 'middleware', {
    value: {},
    writeable: false,
    enumerable: true
});
Object.defineProperty($86defbb4e95ebb07$export$2e2bcd8739ae039.middleware, 'TERMINATOR', {
    value: $86defbb4e95ebb07$var$TERMINATOR,
    writeable: false,
    enumerable: true
});
/**
 * A reference to the {@link module:browser|browser utility module} as an object.
 *
 * @type {Object}
 * @see  {@link module:browser|browser}
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.browser = $86defbb4e95ebb07$var$browser;
/**
 * A reference to the {@link module:obj|obj utility module} as an object.
 *
 * @type {Object}
 * @see  {@link module:obj|obj}
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.obj = $86defbb4e95ebb07$var$Obj;
/**
 * Deprecated reference to the {@link module:obj.merge|merge function}
 *
 * @type {Function}
 * @see {@link module:obj.merge|merge}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.obj.merge instead.
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.mergeOptions = $86defbb4e95ebb07$var$deprecateForMajor(9, 'videojs.mergeOptions', 'videojs.obj.merge', $86defbb4e95ebb07$var$merge$1);
/**
 * Deprecated reference to the {@link module:obj.defineLazyProperty|defineLazyProperty function}
 *
 * @type {Function}
 * @see {@link module:obj.defineLazyProperty|defineLazyProperty}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.obj.defineLazyProperty instead.
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.defineLazyProperty = $86defbb4e95ebb07$var$deprecateForMajor(9, 'videojs.defineLazyProperty', 'videojs.obj.defineLazyProperty', $86defbb4e95ebb07$var$defineLazyProperty);
/**
 * Deprecated reference to the {@link module:fn.bind_|fn.bind_ function}
 *
 * @type {Function}
 * @see {@link module:fn.bind_|fn.bind_}
 * @deprecated Deprecated and will be removed in 9.0. Please use native Function.prototype.bind instead.
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.bind = $86defbb4e95ebb07$var$deprecateForMajor(9, 'videojs.bind', 'native Function.prototype.bind', $86defbb4e95ebb07$var$bind_);
$86defbb4e95ebb07$export$2e2bcd8739ae039.registerPlugin = $86defbb4e95ebb07$var$Plugin.registerPlugin;
$86defbb4e95ebb07$export$2e2bcd8739ae039.deregisterPlugin = $86defbb4e95ebb07$var$Plugin.deregisterPlugin;
/**
 * Deprecated method to register a plugin with Video.js
 *
 * @deprecated Deprecated and will be removed in 9.0. Use videojs.registerPlugin() instead.
 *
 * @param {string} name
 *        The plugin name
*
 * @param {typeof Plugin|Function} plugin
 *         The plugin sub-class or function
 *
 * @return {typeof Plugin|Function}
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.plugin = (name, plugin)=>{
    $86defbb4e95ebb07$var$log$1.warn('videojs.plugin() is deprecated; use videojs.registerPlugin() instead');
    return $86defbb4e95ebb07$var$Plugin.registerPlugin(name, plugin);
};
$86defbb4e95ebb07$export$2e2bcd8739ae039.getPlugins = $86defbb4e95ebb07$var$Plugin.getPlugins;
$86defbb4e95ebb07$export$2e2bcd8739ae039.getPlugin = $86defbb4e95ebb07$var$Plugin.getPlugin;
$86defbb4e95ebb07$export$2e2bcd8739ae039.getPluginVersion = $86defbb4e95ebb07$var$Plugin.getPluginVersion;
/**
 * Adding languages so that they're available to all players.
 * Example: `videojs.addLanguage('es', { 'Hello': 'Hola' });`
 *
 * @param {string} code
 *        The language code or dictionary property
 *
 * @param {Object} data
 *        The data values to be translated
 *
 * @return {Object}
 *         The resulting language dictionary object
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.addLanguage = function(code, data) {
    code = ('' + code).toLowerCase();
    $86defbb4e95ebb07$export$2e2bcd8739ae039.options.languages = $86defbb4e95ebb07$var$merge$1($86defbb4e95ebb07$export$2e2bcd8739ae039.options.languages, {
        [code]: data
    });
    return $86defbb4e95ebb07$export$2e2bcd8739ae039.options.languages[code];
};
/**
 * A reference to the {@link module:log|log utility module} as an object.
 *
 * @type {Function}
 * @see  {@link module:log|log}
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.log = $86defbb4e95ebb07$var$log$1;
$86defbb4e95ebb07$export$2e2bcd8739ae039.createLogger = $86defbb4e95ebb07$var$createLogger;
/**
 * A reference to the {@link module:time|time utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:time|time}
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.time = $86defbb4e95ebb07$var$Time;
/**
 * Deprecated reference to the {@link module:time.createTimeRanges|createTimeRanges function}
 *
 * @type {Function}
 * @see {@link module:time.createTimeRanges|createTimeRanges}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.createTimeRanges instead.
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.createTimeRange = $86defbb4e95ebb07$var$deprecateForMajor(9, 'videojs.createTimeRange', 'videojs.time.createTimeRanges', $86defbb4e95ebb07$var$createTimeRanges$1);
/**
 * Deprecated reference to the {@link module:time.createTimeRanges|createTimeRanges function}
 *
 * @type {Function}
 * @see {@link module:time.createTimeRanges|createTimeRanges}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.createTimeRanges instead.
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.createTimeRanges = $86defbb4e95ebb07$var$deprecateForMajor(9, 'videojs.createTimeRanges', 'videojs.time.createTimeRanges', $86defbb4e95ebb07$var$createTimeRanges$1);
/**
 * Deprecated reference to the {@link module:time.formatTime|formatTime function}
 *
 * @type {Function}
 * @see {@link module:time.formatTime|formatTime}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.format instead.
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.formatTime = $86defbb4e95ebb07$var$deprecateForMajor(9, 'videojs.formatTime', 'videojs.time.formatTime', $86defbb4e95ebb07$var$formatTime);
/**
 * Deprecated reference to the {@link module:time.setFormatTime|setFormatTime function}
 *
 * @type {Function}
 * @see {@link module:time.setFormatTime|setFormatTime}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.setFormat instead.
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.setFormatTime = $86defbb4e95ebb07$var$deprecateForMajor(9, 'videojs.setFormatTime', 'videojs.time.setFormatTime', $86defbb4e95ebb07$var$setFormatTime);
/**
 * Deprecated reference to the {@link module:time.resetFormatTime|resetFormatTime function}
 *
 * @type {Function}
 * @see {@link module:time.resetFormatTime|resetFormatTime}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.resetFormat instead.
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.resetFormatTime = $86defbb4e95ebb07$var$deprecateForMajor(9, 'videojs.resetFormatTime', 'videojs.time.resetFormatTime', $86defbb4e95ebb07$var$resetFormatTime);
/**
 * Deprecated reference to the {@link module:url.parseUrl|Url.parseUrl function}
 *
 * @type {Function}
 * @see {@link module:url.parseUrl|parseUrl}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.url.parseUrl instead.
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.parseUrl = $86defbb4e95ebb07$var$deprecateForMajor(9, 'videojs.parseUrl', 'videojs.url.parseUrl', $86defbb4e95ebb07$var$parseUrl);
/**
 * Deprecated reference to the {@link module:url.isCrossOrigin|Url.isCrossOrigin function}
 *
 * @type {Function}
 * @see {@link module:url.isCrossOrigin|isCrossOrigin}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.url.isCrossOrigin instead.
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.isCrossOrigin = $86defbb4e95ebb07$var$deprecateForMajor(9, 'videojs.isCrossOrigin', 'videojs.url.isCrossOrigin', $86defbb4e95ebb07$var$isCrossOrigin);
$86defbb4e95ebb07$export$2e2bcd8739ae039.EventTarget = $86defbb4e95ebb07$var$EventTarget$2;
$86defbb4e95ebb07$export$2e2bcd8739ae039.any = $86defbb4e95ebb07$var$any;
$86defbb4e95ebb07$export$2e2bcd8739ae039.on = $86defbb4e95ebb07$var$on;
$86defbb4e95ebb07$export$2e2bcd8739ae039.one = $86defbb4e95ebb07$var$one;
$86defbb4e95ebb07$export$2e2bcd8739ae039.off = $86defbb4e95ebb07$var$off;
$86defbb4e95ebb07$export$2e2bcd8739ae039.trigger = $86defbb4e95ebb07$var$trigger;
/**
 * A cross-browser XMLHttpRequest wrapper.
 *
 * @function
 * @param    {Object} options
 *           Settings for the request.
 *
 * @return   {XMLHttpRequest|XDomainRequest}
 *           The request object.
 *
 * @see      https://github.com/Raynos/xhr
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.xhr = (0, (/*@__PURE__*/$parcel$interopDefault($f0ff6da7e6f661dc$exports)));
$86defbb4e95ebb07$export$2e2bcd8739ae039.TrackList = $86defbb4e95ebb07$var$TrackList;
$86defbb4e95ebb07$export$2e2bcd8739ae039.TextTrack = $86defbb4e95ebb07$var$TextTrack;
$86defbb4e95ebb07$export$2e2bcd8739ae039.TextTrackList = $86defbb4e95ebb07$var$TextTrackList;
$86defbb4e95ebb07$export$2e2bcd8739ae039.AudioTrack = $86defbb4e95ebb07$var$AudioTrack;
$86defbb4e95ebb07$export$2e2bcd8739ae039.AudioTrackList = $86defbb4e95ebb07$var$AudioTrackList;
$86defbb4e95ebb07$export$2e2bcd8739ae039.VideoTrack = $86defbb4e95ebb07$var$VideoTrack;
$86defbb4e95ebb07$export$2e2bcd8739ae039.VideoTrackList = $86defbb4e95ebb07$var$VideoTrackList;
[
    'isEl',
    'isTextNode',
    'createEl',
    'hasClass',
    'addClass',
    'removeClass',
    'toggleClass',
    'setAttributes',
    'getAttributes',
    'emptyEl',
    'appendContent',
    'insertContent'
].forEach((k)=>{
    $86defbb4e95ebb07$export$2e2bcd8739ae039[k] = function() {
        $86defbb4e95ebb07$var$log$1.warn(`videojs.${k}() is deprecated; use videojs.dom.${k}() instead`);
        return $86defbb4e95ebb07$var$Dom[k].apply(null, arguments);
    };
});
$86defbb4e95ebb07$export$2e2bcd8739ae039.computedStyle = $86defbb4e95ebb07$var$deprecateForMajor(9, 'videojs.computedStyle', 'videojs.dom.computedStyle', $86defbb4e95ebb07$var$computedStyle);
/**
 * A reference to the {@link module:dom|DOM utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:dom|dom}
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.dom = $86defbb4e95ebb07$var$Dom;
/**
 * A reference to the {@link module:fn|fn utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:fn|fn}
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.fn = $86defbb4e95ebb07$var$Fn;
/**
 * A reference to the {@link module:num|num utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:num|num}
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.num = $86defbb4e95ebb07$var$Num;
/**
 * A reference to the {@link module:str|str utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:str|str}
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.str = $86defbb4e95ebb07$var$Str;
/**
 * A reference to the {@link module:url|URL utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:url|url}
 */ $86defbb4e95ebb07$export$2e2bcd8739ae039.url = $86defbb4e95ebb07$var$Url;
// The list of possible error types to occur in video.js
$86defbb4e95ebb07$export$2e2bcd8739ae039.Error = $86defbb4e95ebb07$var$VjsErrors;
/*! @name videojs-contrib-quality-levels @version 4.1.0 @license Apache-2.0 */ /**
 * A single QualityLevel.
 *
 * interface QualityLevel {
 *   readonly attribute DOMString id;
 *            attribute DOMString label;
 *   readonly attribute long width;
 *   readonly attribute long height;
 *   readonly attribute long bitrate;
 *            attribute boolean enabled;
 * };
 *
 * @class QualityLevel
 */ class $86defbb4e95ebb07$var$QualityLevel {
    /**
   * Creates a QualityLevel
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   */ constructor(representation){
        let level = this; // eslint-disable-line
        level.id = representation.id;
        level.label = level.id;
        level.width = representation.width;
        level.height = representation.height;
        level.bitrate = representation.bandwidth;
        level.frameRate = representation.frameRate;
        level.enabled_ = representation.enabled;
        Object.defineProperty(level, 'enabled', {
            /**
       * Get whether the QualityLevel is enabled.
       *
       * @return {boolean} True if the QualityLevel is enabled.
       */ get () {
                return level.enabled_();
            },
            /**
       * Enable or disable the QualityLevel.
       *
       * @param {boolean} enable true to enable QualityLevel, false to disable.
       */ set (enable) {
                level.enabled_(enable);
            }
        });
        return level;
    }
}
/**
 * A list of QualityLevels.
 *
 * interface QualityLevelList : EventTarget {
 *   getter QualityLevel (unsigned long index);
 *   readonly attribute unsigned long length;
 *   readonly attribute long selectedIndex;
 *
 *   void addQualityLevel(QualityLevel qualityLevel)
 *   void removeQualityLevel(QualityLevel remove)
 *   QualityLevel? getQualityLevelById(DOMString id);
 *
 *   attribute EventHandler onchange;
 *   attribute EventHandler onaddqualitylevel;
 *   attribute EventHandler onremovequalitylevel;
 * };
 *
 * @extends videojs.EventTarget
 * @class QualityLevelList
 */ class $86defbb4e95ebb07$var$QualityLevelList extends $86defbb4e95ebb07$export$2e2bcd8739ae039.EventTarget {
    /**
   * Creates a QualityLevelList.
   */ constructor(){
        super();
        let list = this; // eslint-disable-line
        list.levels_ = [];
        list.selectedIndex_ = -1;
        /**
     * Get the index of the currently selected QualityLevel.
     *
     * @returns {number} The index of the selected QualityLevel. -1 if none selected.
     * @readonly
     */ Object.defineProperty(list, 'selectedIndex', {
            get () {
                return list.selectedIndex_;
            }
        });
        /**
     * Get the length of the list of QualityLevels.
     *
     * @returns {number} The length of the list.
     * @readonly
     */ Object.defineProperty(list, 'length', {
            get () {
                return list.levels_.length;
            }
        });
        list[Symbol.iterator] = ()=>list.levels_.values();
        return list;
    }
    /**
   * Adds a quality level to the list.
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   * @return {QualityLevel} the QualityLevel added to the list
   * @method addQualityLevel
   */ addQualityLevel(representation) {
        let qualityLevel = this.getQualityLevelById(representation.id);
        // Do not add duplicate quality levels
        if (qualityLevel) return qualityLevel;
        const index = this.levels_.length;
        qualityLevel = new $86defbb4e95ebb07$var$QualityLevel(representation);
        if (!('' + index in this)) Object.defineProperty(this, index, {
            get () {
                return this.levels_[index];
            }
        });
        this.levels_.push(qualityLevel);
        this.trigger({
            qualityLevel: qualityLevel,
            type: 'addqualitylevel'
        });
        return qualityLevel;
    }
    /**
   * Removes a quality level from the list.
   *
   * @param {QualityLevel} qualityLevel The QualityLevel to remove from the list.
   * @return {QualityLevel|null} the QualityLevel removed or null if nothing removed
   * @method removeQualityLevel
   */ removeQualityLevel(qualityLevel) {
        let removed = null;
        for(let i = 0, l = this.length; i < l; i++)if (this[i] === qualityLevel) {
            removed = this.levels_.splice(i, 1)[0];
            if (this.selectedIndex_ === i) this.selectedIndex_ = -1;
            else if (this.selectedIndex_ > i) this.selectedIndex_--;
            break;
        }
        if (removed) this.trigger({
            qualityLevel: qualityLevel,
            type: 'removequalitylevel'
        });
        return removed;
    }
    /**
   * Searches for a QualityLevel with the given id.
   *
   * @param {string} id The id of the QualityLevel to find.
   * @return {QualityLevel|null} The QualityLevel with id, or null if not found.
   * @method getQualityLevelById
   */ getQualityLevelById(id) {
        for(let i = 0, l = this.length; i < l; i++){
            const level = this[i];
            if (level.id === id) return level;
        }
        return null;
    }
    /**
   * Resets the list of QualityLevels to empty
   *
   * @method dispose
   */ dispose() {
        this.selectedIndex_ = -1;
        this.levels_.length = 0;
    }
}
/**
 * change - The selected QualityLevel has changed.
 * addqualitylevel - A QualityLevel has been added to the QualityLevelList.
 * removequalitylevel - A QualityLevel has been removed from the QualityLevelList.
 */ $86defbb4e95ebb07$var$QualityLevelList.prototype.allowedEvents_ = {
    change: 'change',
    addqualitylevel: 'addqualitylevel',
    removequalitylevel: 'removequalitylevel'
};
// emulate attribute EventHandler support to allow for feature detection
for(const event in $86defbb4e95ebb07$var$QualityLevelList.prototype.allowedEvents_)$86defbb4e95ebb07$var$QualityLevelList.prototype['on' + event] = null;
var $86defbb4e95ebb07$var$version$5 = "4.1.0";
/**
 * Initialization function for the qualityLevels plugin. Sets up the QualityLevelList and
 * event handlers.
 *
 * @param {Player} player Player object.
 * @param {Object} options Plugin options object.
 * @return {QualityLevelList} a list of QualityLevels
 */ const $86defbb4e95ebb07$var$initPlugin$1 = function(player, options) {
    const originalPluginFn = player.qualityLevels;
    const qualityLevelList = new $86defbb4e95ebb07$var$QualityLevelList();
    const disposeHandler = function() {
        qualityLevelList.dispose();
        player.qualityLevels = originalPluginFn;
        player.off('dispose', disposeHandler);
    };
    player.on('dispose', disposeHandler);
    player.qualityLevels = ()=>qualityLevelList;
    player.qualityLevels.VERSION = $86defbb4e95ebb07$var$version$5;
    return qualityLevelList;
};
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @param {Object} options Plugin options object
 * @return {QualityLevelList} a list of QualityLevels
 */ const $86defbb4e95ebb07$var$qualityLevels = function(options) {
    return $86defbb4e95ebb07$var$initPlugin$1(this, $86defbb4e95ebb07$export$2e2bcd8739ae039.obj.merge({}, options));
};
// Register the plugin with video.js.
$86defbb4e95ebb07$export$2e2bcd8739ae039.registerPlugin('qualityLevels', $86defbb4e95ebb07$var$qualityLevels);
// Include the version number.
$86defbb4e95ebb07$var$qualityLevels.VERSION = $86defbb4e95ebb07$var$version$5;
/*! @name @videojs/http-streaming @version 3.17.5 @license Apache-2.0 */ /**
 * @file resolve-url.js - Handling how URLs are resolved and manipulated
 */ const $86defbb4e95ebb07$var$resolveUrl = (0, $3c711be251a9bb4f$export$2e2bcd8739ae039);
/**
 * If the xhr request was redirected, return the responseURL, otherwise,
 * return the original url.
 *
 * @api private
 *
 * @param  {string} url - an url being requested
 * @param  {XMLHttpRequest} req - xhr request result
 *
 * @return {string}
 */ const $86defbb4e95ebb07$var$resolveManifestRedirect = (url, req)=>{
    // To understand how the responseURL below is set and generated:
    // - https://fetch.spec.whatwg.org/#concept-response-url
    // - https://fetch.spec.whatwg.org/#atomic-http-redirect-handling
    if (req && req.responseURL && url !== req.responseURL) return req.responseURL;
    return url;
};
const $86defbb4e95ebb07$var$logger = (source)=>{
    if ($86defbb4e95ebb07$export$2e2bcd8739ae039.log.debug) return $86defbb4e95ebb07$export$2e2bcd8739ae039.log.debug.bind($86defbb4e95ebb07$export$2e2bcd8739ae039, 'VHS:', `${source} >`);
    return function() {};
};
/**
 * Provides a compatibility layer between Video.js 7 and 8 API changes for VHS.
 */ /**
 * Delegates to videojs.obj.merge (Video.js 8) or
 * videojs.mergeOptions (Video.js 7).
 */ function $86defbb4e95ebb07$var$merge(...args) {
    const context = $86defbb4e95ebb07$export$2e2bcd8739ae039.obj || $86defbb4e95ebb07$export$2e2bcd8739ae039;
    const fn = context.merge || context.mergeOptions;
    return fn.apply(context, args);
}
/**
 * Delegates to videojs.time.createTimeRanges (Video.js 8) or
 * videojs.createTimeRanges (Video.js 7).
 */ function $86defbb4e95ebb07$var$createTimeRanges(...args) {
    const context = $86defbb4e95ebb07$export$2e2bcd8739ae039.time || $86defbb4e95ebb07$export$2e2bcd8739ae039;
    const fn = context.createTimeRanges || context.createTimeRanges;
    return fn.apply(context, args);
}
/**
 * Converts provided buffered ranges to a descriptive string
 *
 * @param {TimeRanges} buffered - received buffered time ranges
 *
 * @return {string} - descriptive string
 */ function $86defbb4e95ebb07$var$bufferedRangesToString(buffered) {
    if (buffered.length === 0) return 'Buffered Ranges are empty';
    let bufferedRangesStr = 'Buffered Ranges: \n';
    for(let i = 0; i < buffered.length; i++){
        const start = buffered.start(i);
        const end = buffered.end(i);
        bufferedRangesStr += `${start} --> ${end}. Duration (${end - start})\n`;
    }
    return bufferedRangesStr;
}
/**
 * ranges
 *
 * Utilities for working with TimeRanges.
 *
 */ const $86defbb4e95ebb07$var$TIME_FUDGE_FACTOR = 1 / 30; // Comparisons between time values such as current time and the end of the buffered range
// can be misleading because of precision differences or when the current media has poorly
// aligned audio and video, which can cause values to be slightly off from what you would
// expect. This value is what we consider to be safe to use in such comparisons to account
// for these scenarios.
const $86defbb4e95ebb07$var$SAFE_TIME_DELTA = $86defbb4e95ebb07$var$TIME_FUDGE_FACTOR * 3;
const $86defbb4e95ebb07$var$filterRanges = function(timeRanges, predicate) {
    const results = [];
    let i;
    if (timeRanges && timeRanges.length) {
        // Search for ranges that match the predicate
        for(i = 0; i < timeRanges.length; i++)if (predicate(timeRanges.start(i), timeRanges.end(i))) results.push([
            timeRanges.start(i),
            timeRanges.end(i)
        ]);
    }
    return $86defbb4e95ebb07$var$createTimeRanges(results);
};
/**
 * Attempts to find the buffered TimeRange that contains the specified
 * time.
 *
 * @param {TimeRanges} buffered - the TimeRanges object to query
 * @param {number} time  - the time to filter on.
 * @return {TimeRanges} a new TimeRanges object
 */ const $86defbb4e95ebb07$var$findRange = function(buffered, time) {
    return $86defbb4e95ebb07$var$filterRanges(buffered, function(start, end) {
        return start - $86defbb4e95ebb07$var$SAFE_TIME_DELTA <= time && end + $86defbb4e95ebb07$var$SAFE_TIME_DELTA >= time;
    });
};
/**
 * Returns the TimeRanges that begin later than the specified time.
 *
 * @param {TimeRanges} timeRanges - the TimeRanges object to query
 * @param {number} time - the time to filter on.
 * @return {TimeRanges} a new TimeRanges object.
 */ const $86defbb4e95ebb07$var$findNextRange = function(timeRanges, time) {
    return $86defbb4e95ebb07$var$filterRanges(timeRanges, function(start) {
        return start - $86defbb4e95ebb07$var$TIME_FUDGE_FACTOR >= time;
    });
};
/**
 * Returns gaps within a list of TimeRanges
 *
 * @param {TimeRanges} buffered - the TimeRanges object
 * @return {TimeRanges} a TimeRanges object of gaps
 */ const $86defbb4e95ebb07$var$findGaps = function(buffered) {
    if (buffered.length < 2) return $86defbb4e95ebb07$var$createTimeRanges();
    const ranges = [];
    for(let i = 1; i < buffered.length; i++){
        const start = buffered.end(i - 1);
        const end = buffered.start(i);
        ranges.push([
            start,
            end
        ]);
    }
    return $86defbb4e95ebb07$var$createTimeRanges(ranges);
};
/**
 * Calculate the intersection of two TimeRanges
 *
 * @param {TimeRanges} bufferA
 * @param {TimeRanges} bufferB
 * @return {TimeRanges} The interesection of `bufferA` with `bufferB`
 */ const $86defbb4e95ebb07$var$bufferIntersection = function(bufferA, bufferB) {
    let start = null;
    let end = null;
    let arity = 0;
    const extents = [];
    const ranges = [];
    if (!bufferA || !bufferA.length || !bufferB || !bufferB.length) return $86defbb4e95ebb07$var$createTimeRanges();
     // Handle the case where we have both buffers and create an
    // intersection of the two
    let count = bufferA.length; // A) Gather up all start and end times
    while(count--){
        extents.push({
            time: bufferA.start(count),
            type: 'start'
        });
        extents.push({
            time: bufferA.end(count),
            type: 'end'
        });
    }
    count = bufferB.length;
    while(count--){
        extents.push({
            time: bufferB.start(count),
            type: 'start'
        });
        extents.push({
            time: bufferB.end(count),
            type: 'end'
        });
    } // B) Sort them by time
    extents.sort(function(a, b) {
        return a.time - b.time;
    }); // C) Go along one by one incrementing arity for start and decrementing
    //    arity for ends
    for(count = 0; count < extents.length; count++){
        if (extents[count].type === 'start') {
            arity++; // D) If arity is ever incremented to 2 we are entering an
            //    overlapping range
            if (arity === 2) start = extents[count].time;
        } else if (extents[count].type === 'end') {
            arity--; // E) If arity is ever decremented to 1 we leaving an
            //    overlapping range
            if (arity === 1) end = extents[count].time;
        } // F) Record overlapping ranges
        if (start !== null && end !== null) {
            ranges.push([
                start,
                end
            ]);
            start = null;
            end = null;
        }
    }
    return $86defbb4e95ebb07$var$createTimeRanges(ranges);
};
/**
 * Gets a human readable string for a TimeRange
 *
 * @param {TimeRange} range
 * @return {string} a human readable string
 */ const $86defbb4e95ebb07$var$printableRange = (range)=>{
    const strArr = [];
    if (!range || !range.length) return '';
    for(let i = 0; i < range.length; i++)strArr.push(range.start(i) + ' => ' + range.end(i));
    return strArr.join(', ');
};
/**
 * Calculates the amount of time left in seconds until the player hits the end of the
 * buffer and causes a rebuffer
 *
 * @param {TimeRange} buffered
 *        The state of the buffer
 * @param {Numnber} currentTime
 *        The current time of the player
 * @param {number} playbackRate
 *        The current playback rate of the player. Defaults to 1.
 * @return {number}
 *         Time until the player has to start rebuffering in seconds.
 * @function timeUntilRebuffer
 */ const $86defbb4e95ebb07$var$timeUntilRebuffer = function(buffered, currentTime, playbackRate = 1) {
    const bufferedEnd = buffered.length ? buffered.end(buffered.length - 1) : 0;
    return (bufferedEnd - currentTime) / playbackRate;
};
/**
 * Converts a TimeRanges object into an array representation
 *
 * @param {TimeRanges} timeRanges
 * @return {Array}
 */ const $86defbb4e95ebb07$var$timeRangesToArray = (timeRanges)=>{
    const timeRangesList = [];
    for(let i = 0; i < timeRanges.length; i++)timeRangesList.push({
        start: timeRanges.start(i),
        end: timeRanges.end(i)
    });
    return timeRangesList;
};
/**
 * Determines if two time range objects are different.
 *
 * @param {TimeRange} a
 *        the first time range object to check
 *
 * @param {TimeRange} b
 *        the second time range object to check
 *
 * @return {Boolean}
 *         Whether the time range objects differ
 */ const $86defbb4e95ebb07$var$isRangeDifferent = function(a, b) {
    // same object
    if (a === b) return false;
     // one or the other is undefined
    if (!a && b || !b && a) return true;
     // length is different
    if (a.length !== b.length) return true;
     // see if any start/end pair is different
    for(let i = 0; i < a.length; i++){
        if (a.start(i) !== b.start(i) || a.end(i) !== b.end(i)) return true;
    } // if the length and every pair is the same
    // this is the same time range
    return false;
};
const $86defbb4e95ebb07$var$lastBufferedEnd = function(a) {
    if (!a || !a.length || !a.end) return;
    return a.end(a.length - 1);
};
/**
 * A utility function to add up the amount of time in a timeRange
 * after a specified startTime.
 * ie:[[0, 10], [20, 40], [50, 60]] with a startTime 0
 *     would return 40 as there are 40s seconds after 0 in the timeRange
 *
 * @param {TimeRange} range
 *        The range to check against
 * @param {number} startTime
 *        The time in the time range that you should start counting from
 *
 * @return {number}
 *          The number of seconds in the buffer passed the specified time.
 */ const $86defbb4e95ebb07$var$timeAheadOf = function(range, startTime) {
    let time = 0;
    if (!range || !range.length) return time;
    for(let i = 0; i < range.length; i++){
        const start = range.start(i);
        const end = range.end(i); // startTime is after this range entirely
        if (startTime > end) continue;
         // startTime is within this range
        if (startTime > start && startTime <= end) {
            time += end - startTime;
            continue;
        } // startTime is before this range.
        time += end - start;
    }
    return time;
};
/**
 * @file playlist.js
 *
 * Playlist related utilities.
 */ /**
 * Get the duration of a segment, with special cases for
 * llhls segments that do not have a duration yet.
 *
 * @param {Object} playlist
 *        the playlist that the segment belongs to.
 * @param {Object} segment
 *        the segment to get a duration for.
 *
 * @return {number}
 *          the segment duration
 */ const $86defbb4e95ebb07$var$segmentDurationWithParts = (playlist, segment)=>{
    // if this isn't a preload segment
    // then we will have a segment duration that is accurate.
    if (!segment.preload) return segment.duration;
     // otherwise we have to add up parts and preload hints
    // to get an up to date duration.
    let result = 0;
    (segment.parts || []).forEach(function(p) {
        result += p.duration;
    }); // for preload hints we have to use partTargetDuration
    // as they won't even have a duration yet.
    (segment.preloadHints || []).forEach(function(p) {
        if (p.type === 'PART') result += playlist.partTargetDuration;
    });
    return result;
};
/**
 * A function to get a combined list of parts and segments with durations
 * and indexes.
 *
 * @param {Playlist} playlist the playlist to get the list for.
 *
 * @return {Array} The part/segment list.
 */ const $86defbb4e95ebb07$var$getPartsAndSegments = (playlist)=>(playlist.segments || []).reduce((acc, segment, si)=>{
        if (segment.parts) segment.parts.forEach(function(part, pi) {
            acc.push({
                duration: part.duration,
                segmentIndex: si,
                partIndex: pi,
                part: part,
                segment: segment
            });
        });
        else acc.push({
            duration: segment.duration,
            segmentIndex: si,
            partIndex: null,
            segment: segment,
            part: null
        });
        return acc;
    }, []);
const $86defbb4e95ebb07$var$getLastParts = (media)=>{
    const lastSegment = media.segments && media.segments.length && media.segments[media.segments.length - 1];
    return lastSegment && lastSegment.parts || [];
};
const $86defbb4e95ebb07$var$getKnownPartCount = ({ preloadSegment: preloadSegment })=>{
    if (!preloadSegment) return;
    const { parts: parts, preloadHints: preloadHints } = preloadSegment;
    let partCount = (preloadHints || []).reduce((count, hint)=>count + (hint.type === 'PART' ? 1 : 0), 0);
    partCount += parts && parts.length ? parts.length : 0;
    return partCount;
};
/**
 * Get the number of seconds to delay from the end of a
 * live playlist.
 *
 * @param {Playlist} main the main playlist
 * @param {Playlist} media the media playlist
 * @return {number} the hold back in seconds.
 */ const $86defbb4e95ebb07$var$liveEdgeDelay = (main, media)=>{
    if (media.endList) return 0;
     // dash suggestedPresentationDelay trumps everything
    if (main && main.suggestedPresentationDelay) return main.suggestedPresentationDelay;
    const hasParts = $86defbb4e95ebb07$var$getLastParts(media).length > 0; // look for "part" delays from ll-hls first
    if (hasParts && media.serverControl && media.serverControl.partHoldBack) return media.serverControl.partHoldBack;
    else if (hasParts && media.partTargetDuration) return media.partTargetDuration * 3; // finally look for full segment delays
    else if (media.serverControl && media.serverControl.holdBack) return media.serverControl.holdBack;
    else if (media.targetDuration) return media.targetDuration * 3;
    return 0;
};
/**
 * walk backward until we find a duration we can use
 * or return a failure
 *
 * @param {Playlist} playlist the playlist to walk through
 * @param {Number} endSequence the mediaSequence to stop walking on
 */ const $86defbb4e95ebb07$var$backwardDuration = function(playlist, endSequence) {
    let result = 0;
    let i = endSequence - playlist.mediaSequence; // if a start time is available for segment immediately following
    // the interval, use it
    let segment = playlist.segments[i]; // Walk backward until we find the latest segment with timeline
    // information that is earlier than endSequence
    if (segment) {
        if (typeof segment.start !== 'undefined') return {
            result: segment.start,
            precise: true
        };
        if (typeof segment.end !== 'undefined') return {
            result: segment.end - segment.duration,
            precise: true
        };
    }
    while(i--){
        segment = playlist.segments[i];
        if (typeof segment.end !== 'undefined') return {
            result: result + segment.end,
            precise: true
        };
        result += $86defbb4e95ebb07$var$segmentDurationWithParts(playlist, segment);
        if (typeof segment.start !== 'undefined') return {
            result: result + segment.start,
            precise: true
        };
    }
    return {
        result: result,
        precise: false
    };
};
/**
 * walk forward until we find a duration we can use
 * or return a failure
 *
 * @param {Playlist} playlist the playlist to walk through
 * @param {number} endSequence the mediaSequence to stop walking on
 */ const $86defbb4e95ebb07$var$forwardDuration = function(playlist, endSequence) {
    let result = 0;
    let segment;
    let i = endSequence - playlist.mediaSequence; // Walk forward until we find the earliest segment with timeline
    // information
    for(; i < playlist.segments.length; i++){
        segment = playlist.segments[i];
        if (typeof segment.start !== 'undefined') return {
            result: segment.start - result,
            precise: true
        };
        result += $86defbb4e95ebb07$var$segmentDurationWithParts(playlist, segment);
        if (typeof segment.end !== 'undefined') return {
            result: segment.end - result,
            precise: true
        };
    } // indicate we didn't find a useful duration estimate
    return {
        result: -1,
        precise: false
    };
};
/**
  * Calculate the media duration from the segments associated with a
  * playlist. The duration of a subinterval of the available segments
  * may be calculated by specifying an end index.
  *
  * @param {Object} playlist a media playlist object
  * @param {number=} endSequence an exclusive upper boundary
  * for the playlist.  Defaults to playlist length.
  * @param {number} expired the amount of time that has dropped
  * off the front of the playlist in a live scenario
  * @return {number} the duration between the first available segment
  * and end index.
  */ const $86defbb4e95ebb07$var$intervalDuration = function(playlist, endSequence, expired) {
    if (typeof endSequence === 'undefined') endSequence = playlist.mediaSequence + playlist.segments.length;
    if (endSequence < playlist.mediaSequence) return 0;
     // do a backward walk to estimate the duration
    const backward = $86defbb4e95ebb07$var$backwardDuration(playlist, endSequence);
    if (backward.precise) // if we were able to base our duration estimate on timing
    // information provided directly from the Media Source, return
    // it
    return backward.result;
     // walk forward to see if a precise duration estimate can be made
    // that way
    const forward = $86defbb4e95ebb07$var$forwardDuration(playlist, endSequence);
    if (forward.precise) // we found a segment that has been buffered and so it's
    // position is known precisely
    return forward.result;
     // return the less-precise, playlist-based duration estimate
    return backward.result + expired;
};
/**
  * Calculates the duration of a playlist. If a start and end index
  * are specified, the duration will be for the subset of the media
  * timeline between those two indices. The total duration for live
  * playlists is always Infinity.
  *
  * @param {Object} playlist a media playlist object
  * @param {number=} endSequence an exclusive upper
  * boundary for the playlist. Defaults to the playlist media
  * sequence number plus its length.
  * @param {number=} expired the amount of time that has
  * dropped off the front of the playlist in a live scenario
  * @return {number} the duration between the start index and end
  * index.
  */ const $86defbb4e95ebb07$var$duration = function(playlist, endSequence, expired) {
    if (!playlist) return 0;
    if (typeof expired !== 'number') expired = 0;
     // if a slice of the total duration is not requested, use
    // playlist-level duration indicators when they're present
    if (typeof endSequence === 'undefined') {
        // if present, use the duration specified in the playlist
        if (playlist.totalDuration) return playlist.totalDuration;
         // duration should be Infinity for live playlists
        if (!playlist.endList) return (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Infinity;
    } // calculate the total duration based on the segment durations
    return $86defbb4e95ebb07$var$intervalDuration(playlist, endSequence, expired);
};
/**
  * Calculate the time between two indexes in the current playlist
  * neight the start- nor the end-index need to be within the current
  * playlist in which case, the targetDuration of the playlist is used
  * to approximate the durations of the segments
  *
  * @param {Array} options.durationList list to iterate over for durations.
  * @param {number} options.defaultDuration duration to use for elements before or after the durationList
  * @param {number} options.startIndex partsAndSegments index to start
  * @param {number} options.endIndex partsAndSegments index to end.
  * @return {number} the number of seconds between startIndex and endIndex
  */ const $86defbb4e95ebb07$var$sumDurations = function({ defaultDuration: defaultDuration, durationList: durationList, startIndex: startIndex, endIndex: endIndex }) {
    let durations = 0;
    if (startIndex > endIndex) [startIndex, endIndex] = [
        endIndex,
        startIndex
    ];
    if (startIndex < 0) {
        for(let i = startIndex; i < Math.min(0, endIndex); i++)durations += defaultDuration;
        startIndex = 0;
    }
    for(let i = startIndex; i < endIndex; i++)durations += durationList[i].duration;
    return durations;
};
/**
 * Calculates the playlist end time
 *
 * @param {Object} playlist a media playlist object
 * @param {number=} expired the amount of time that has
 *                  dropped off the front of the playlist in a live scenario
 * @param {boolean|false} useSafeLiveEnd a boolean value indicating whether or not the
 *                        playlist end calculation should consider the safe live end
 *                        (truncate the playlist end by three segments). This is normally
 *                        used for calculating the end of the playlist's seekable range.
 *                        This takes into account the value of liveEdgePadding.
 *                        Setting liveEdgePadding to 0 is equivalent to setting this to false.
 * @param {number} liveEdgePadding a number indicating how far from the end of the playlist we should be in seconds.
 *                 If this is provided, it is used in the safe live end calculation.
 *                 Setting useSafeLiveEnd=false or liveEdgePadding=0 are equivalent.
 *                 Corresponds to suggestedPresentationDelay in DASH manifests.
 * @return {number} the end time of playlist
 * @function playlistEnd
 */ const $86defbb4e95ebb07$var$playlistEnd = function(playlist, expired, useSafeLiveEnd, liveEdgePadding) {
    if (!playlist || !playlist.segments) return null;
    if (playlist.endList) return $86defbb4e95ebb07$var$duration(playlist);
    if (expired === null) return null;
    expired = expired || 0;
    let lastSegmentEndTime = $86defbb4e95ebb07$var$intervalDuration(playlist, playlist.mediaSequence + playlist.segments.length, expired);
    if (useSafeLiveEnd) {
        liveEdgePadding = typeof liveEdgePadding === 'number' ? liveEdgePadding : $86defbb4e95ebb07$var$liveEdgeDelay(null, playlist);
        lastSegmentEndTime -= liveEdgePadding;
    } // don't return a time less than zero
    return Math.max(0, lastSegmentEndTime);
};
/**
  * Calculates the interval of time that is currently seekable in a
  * playlist. The returned time ranges are relative to the earliest
  * moment in the specified playlist that is still available. A full
  * seekable implementation for live streams would need to offset
  * these values by the duration of content that has expired from the
  * stream.
  *
  * @param {Object} playlist a media playlist object
  * dropped off the front of the playlist in a live scenario
  * @param {number=} expired the amount of time that has
  * dropped off the front of the playlist in a live scenario
  * @param {number} liveEdgePadding how far from the end of the playlist we should be in seconds.
  *        Corresponds to suggestedPresentationDelay in DASH manifests.
  * @return {TimeRanges} the periods of time that are valid targets
  * for seeking
  */ const $86defbb4e95ebb07$var$seekable = function(playlist, expired, liveEdgePadding) {
    const useSafeLiveEnd = true;
    const seekableStart = expired || 0;
    let seekableEnd = $86defbb4e95ebb07$var$playlistEnd(playlist, expired, useSafeLiveEnd, liveEdgePadding);
    if (seekableEnd === null) return $86defbb4e95ebb07$var$createTimeRanges();
     // Clamp seekable end since it can not be less than the seekable start
    if (seekableEnd < seekableStart) seekableEnd = seekableStart;
    return $86defbb4e95ebb07$var$createTimeRanges(seekableStart, seekableEnd);
};
/**
 * Determine the index and estimated starting time of the segment that
 * contains a specified playback position in a media playlist.
 *
 * @param {Object} options.playlist the media playlist to query
 * @param {number} options.currentTime The number of seconds since the earliest
 * possible position to determine the containing segment for
 * @param {number} options.startTime the time when the segment/part starts
 * @param {number} options.startingSegmentIndex the segment index to start looking at.
 * @param {number?} [options.startingPartIndex] the part index to look at within the segment.
 *
 * @return {Object} an object with partIndex, segmentIndex, and startTime.
 */ const $86defbb4e95ebb07$var$getMediaInfoForTime = function({ playlist: playlist, currentTime: currentTime, startingSegmentIndex: startingSegmentIndex, startingPartIndex: startingPartIndex, startTime: startTime, exactManifestTimings: exactManifestTimings }) {
    let time = currentTime - startTime;
    const partsAndSegments = $86defbb4e95ebb07$var$getPartsAndSegments(playlist);
    let startIndex = 0;
    for(let i = 0; i < partsAndSegments.length; i++){
        const partAndSegment = partsAndSegments[i];
        if (startingSegmentIndex !== partAndSegment.segmentIndex) continue;
         // skip this if part index does not match.
        if (typeof startingPartIndex === 'number' && typeof partAndSegment.partIndex === 'number' && startingPartIndex !== partAndSegment.partIndex) continue;
        startIndex = i;
        break;
    }
    if (time < 0) {
        // Walk backward from startIndex in the playlist, adding durations
        // until we find a segment that contains `time` and return it
        if (startIndex > 0) for(let i = startIndex - 1; i >= 0; i--){
            const partAndSegment = partsAndSegments[i];
            time += partAndSegment.duration;
            if (exactManifestTimings) {
                if (time < 0) continue;
            } else if (time + $86defbb4e95ebb07$var$TIME_FUDGE_FACTOR <= 0) continue;
            return {
                partIndex: partAndSegment.partIndex,
                segmentIndex: partAndSegment.segmentIndex,
                startTime: startTime - $86defbb4e95ebb07$var$sumDurations({
                    defaultDuration: playlist.targetDuration,
                    durationList: partsAndSegments,
                    startIndex: startIndex,
                    endIndex: i
                })
            };
        }
         // We were unable to find a good segment within the playlist
        // so select the first segment
        return {
            partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
            segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
            startTime: currentTime
        };
    } // When startIndex is negative, we first walk forward to first segment
    // adding target durations. If we "run out of time" before getting to
    // the first segment, return the first segment
    if (startIndex < 0) {
        for(let i = startIndex; i < 0; i++){
            time -= playlist.targetDuration;
            if (time < 0) return {
                partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
                segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
                startTime: currentTime
            };
        }
        startIndex = 0;
    } // Walk forward from startIndex in the playlist, subtracting durations
    // until we find a segment that contains `time` and return it
    for(let i = startIndex; i < partsAndSegments.length; i++){
        const partAndSegment = partsAndSegments[i];
        time -= partAndSegment.duration;
        const canUseFudgeFactor = partAndSegment.duration > $86defbb4e95ebb07$var$TIME_FUDGE_FACTOR;
        const isExactlyAtTheEnd = time === 0;
        const isExtremelyCloseToTheEnd = canUseFudgeFactor && time + $86defbb4e95ebb07$var$TIME_FUDGE_FACTOR >= 0;
        if (isExactlyAtTheEnd || isExtremelyCloseToTheEnd) {
            // 1) We are exactly at the end of the current segment.
            // 2) We are extremely close to the end of the current segment (The difference is less than  1 / 30).
            //    We may encounter this situation when
            //    we don't have exact match between segment duration info in the manifest and the actual duration of the segment
            //    For example:
            //    We appended 3 segments 10 seconds each, meaning we should have 30 sec buffered,
            //    but we the actual buffered is 29.99999
            //
            // In both cases:
            // if we passed current time -> it means that we already played current segment
            // if we passed buffered.end -> it means that this segment is already loaded and buffered
            // we should select the next segment if we have one:
            if (i !== partsAndSegments.length - 1) continue;
        }
        if (exactManifestTimings) {
            if (time > 0) continue;
        } else if (time - $86defbb4e95ebb07$var$TIME_FUDGE_FACTOR >= 0) continue;
        return {
            partIndex: partAndSegment.partIndex,
            segmentIndex: partAndSegment.segmentIndex,
            startTime: startTime + $86defbb4e95ebb07$var$sumDurations({
                defaultDuration: playlist.targetDuration,
                durationList: partsAndSegments,
                startIndex: startIndex,
                endIndex: i
            })
        };
    } // We are out of possible candidates so load the last one...
    return {
        segmentIndex: partsAndSegments[partsAndSegments.length - 1].segmentIndex,
        partIndex: partsAndSegments[partsAndSegments.length - 1].partIndex,
        startTime: currentTime
    };
};
/**
 * Check whether the playlist is excluded or not.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is excluded or not
 * @function isExcluded
 */ const $86defbb4e95ebb07$var$isExcluded = function(playlist) {
    return playlist.excludeUntil && playlist.excludeUntil > Date.now();
};
/**
 * Check whether the playlist is compatible with current playback configuration or has
 * been excluded permanently for being incompatible.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is incompatible or not
 * @function isIncompatible
 */ const $86defbb4e95ebb07$var$isIncompatible = function(playlist) {
    return playlist.excludeUntil && playlist.excludeUntil === Infinity;
};
/**
 * Check whether the playlist is enabled or not.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is enabled or not
 * @function isEnabled
 */ const $86defbb4e95ebb07$var$isEnabled = function(playlist) {
    const excluded = $86defbb4e95ebb07$var$isExcluded(playlist);
    return !playlist.disabled && !excluded;
};
/**
 * Check whether the playlist has been manually disabled through the representations api.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is disabled manually or not
 * @function isDisabled
 */ const $86defbb4e95ebb07$var$isDisabled = function(playlist) {
    return playlist.disabled;
};
/**
 * Returns whether the current playlist is an AES encrypted HLS stream
 *
 * @return {boolean} true if it's an AES encrypted HLS stream
 */ const $86defbb4e95ebb07$var$isAes = function(media) {
    for(let i = 0; i < media.segments.length; i++){
        if (media.segments[i].key) return true;
    }
    return false;
};
/**
 * Checks if the playlist has a value for the specified attribute
 *
 * @param {string} attr
 *        Attribute to check for
 * @param {Object} playlist
 *        The media playlist object
 * @return {boolean}
 *         Whether the playlist contains a value for the attribute or not
 * @function hasAttribute
 */ const $86defbb4e95ebb07$var$hasAttribute = function(attr, playlist) {
    return playlist.attributes && playlist.attributes[attr];
};
/**
 * Estimates the time required to complete a segment download from the specified playlist
 *
 * @param {number} segmentDuration
 *        Duration of requested segment
 * @param {number} bandwidth
 *        Current measured bandwidth of the player
 * @param {Object} playlist
 *        The media playlist object
 * @param {number=} bytesReceived
 *        Number of bytes already received for the request. Defaults to 0
 * @return {number|NaN}
 *         The estimated time to request the segment. NaN if bandwidth information for
 *         the given playlist is unavailable
 * @function estimateSegmentRequestTime
 */ const $86defbb4e95ebb07$var$estimateSegmentRequestTime = function(segmentDuration, bandwidth, playlist, bytesReceived = 0) {
    if (!$86defbb4e95ebb07$var$hasAttribute('BANDWIDTH', playlist)) return NaN;
    const size = segmentDuration * playlist.attributes.BANDWIDTH;
    return (size - bytesReceived * 8) / bandwidth;
};
/*
 * Returns whether the current playlist is the lowest rendition
 *
 * @return {Boolean} true if on lowest rendition
 */ const $86defbb4e95ebb07$var$isLowestEnabledRendition = (main, media)=>{
    if (main.playlists.length === 1) return true;
    const currentBandwidth = media.attributes.BANDWIDTH || Number.MAX_VALUE;
    return main.playlists.filter((playlist)=>{
        if (!$86defbb4e95ebb07$var$isEnabled(playlist)) return false;
        return (playlist.attributes.BANDWIDTH || 0) < currentBandwidth;
    }).length === 0;
};
const $86defbb4e95ebb07$var$playlistMatch = (a, b)=>{
    // both playlits are null
    // or only one playlist is non-null
    // no match
    if (!a && !b || !a && b || a && !b) return false;
     // playlist objects are the same, match
    if (a === b) return true;
     // first try to use id as it should be the most
    // accurate
    if (a.id && b.id && a.id === b.id) return true;
     // next try to use reslovedUri as it should be the
    // second most accurate.
    if (a.resolvedUri && b.resolvedUri && a.resolvedUri === b.resolvedUri) return true;
     // finally try to use uri as it should be accurate
    // but might miss a few cases for relative uris
    if (a.uri && b.uri && a.uri === b.uri) return true;
    return false;
};
const $86defbb4e95ebb07$var$someAudioVariant = function(main, callback) {
    const AUDIO = main && main.mediaGroups && main.mediaGroups.AUDIO || {};
    let found = false;
    for(const groupName in AUDIO){
        for(const label in AUDIO[groupName]){
            found = callback(AUDIO[groupName][label]);
            if (found) break;
        }
        if (found) break;
    }
    return !!found;
};
const $86defbb4e95ebb07$var$isAudioOnly = (main)=>{
    // we are audio only if we have no main playlists but do
    // have media group playlists.
    if (!main || !main.playlists || !main.playlists.length) {
        // without audio variants or playlists this
        // is not an audio only main.
        const found = $86defbb4e95ebb07$var$someAudioVariant(main, (variant)=>variant.playlists && variant.playlists.length || variant.uri);
        return found;
    } // if every playlist has only an audio codec it is audio only
    for(let i = 0; i < main.playlists.length; i++){
        const playlist = main.playlists[i];
        const CODECS = playlist.attributes && playlist.attributes.CODECS; // all codecs are audio, this is an audio playlist.
        if (CODECS && CODECS.split(',').every((c)=>(0, $34bf5acfb37ee851$export$c642d74e895e3217)(c))) continue;
         // playlist is in an audio group it is audio only
        const found = $86defbb4e95ebb07$var$someAudioVariant(main, (variant)=>$86defbb4e95ebb07$var$playlistMatch(playlist, variant));
        if (found) continue;
         // if we make it here this playlist isn't audio and we
        // are not audio only
        return false;
    } // if we make it past every playlist without returning, then
    // this is an audio only playlist.
    return true;
}; // exports
var $86defbb4e95ebb07$var$Playlist = {
    liveEdgeDelay: $86defbb4e95ebb07$var$liveEdgeDelay,
    duration: $86defbb4e95ebb07$var$duration,
    seekable: $86defbb4e95ebb07$var$seekable,
    getMediaInfoForTime: $86defbb4e95ebb07$var$getMediaInfoForTime,
    isEnabled: $86defbb4e95ebb07$var$isEnabled,
    isDisabled: $86defbb4e95ebb07$var$isDisabled,
    isExcluded: $86defbb4e95ebb07$var$isExcluded,
    isIncompatible: $86defbb4e95ebb07$var$isIncompatible,
    playlistEnd: $86defbb4e95ebb07$var$playlistEnd,
    isAes: $86defbb4e95ebb07$var$isAes,
    hasAttribute: $86defbb4e95ebb07$var$hasAttribute,
    estimateSegmentRequestTime: $86defbb4e95ebb07$var$estimateSegmentRequestTime,
    isLowestEnabledRendition: $86defbb4e95ebb07$var$isLowestEnabledRendition,
    isAudioOnly: $86defbb4e95ebb07$var$isAudioOnly,
    playlistMatch: $86defbb4e95ebb07$var$playlistMatch,
    segmentDurationWithParts: $86defbb4e95ebb07$var$segmentDurationWithParts
};
const { log: $86defbb4e95ebb07$var$log } = $86defbb4e95ebb07$export$2e2bcd8739ae039;
const $86defbb4e95ebb07$var$createPlaylistID = (index, uri)=>{
    return `${index}-${uri}`;
}; // default function for creating a group id
const $86defbb4e95ebb07$var$groupID = (type, group, label)=>{
    return `placeholder-uri-${type}-${group}-${label}`;
};
/**
 * Parses a given m3u8 playlist
 *
 * @param {Function} [onwarn]
 *        a function to call when the parser triggers a warning event.
 * @param {Function} [oninfo]
 *        a function to call when the parser triggers an info event.
 * @param {string} manifestString
 *        The downloaded manifest string
 * @param {Object[]} [customTagParsers]
 *        An array of custom tag parsers for the m3u8-parser instance
 * @param {Object[]} [customTagMappers]
 *        An array of custom tag mappers for the m3u8-parser instance
 * @param {boolean} [llhls]
 *        Whether to keep ll-hls features in the manifest after parsing.
 * @return {Object}
 *         The manifest object
 */ const $86defbb4e95ebb07$var$parseManifest = ({ onwarn: onwarn, oninfo: oninfo, manifestString: manifestString, customTagParsers: customTagParsers = [], customTagMappers: customTagMappers = [], llhls: llhls })=>{
    const parser = new (0, $d9ac9c5d7f472999$export$7acfa6ed01010e37)();
    if (onwarn) parser.on('warn', onwarn);
    if (oninfo) parser.on('info', oninfo);
    customTagParsers.forEach((customParser)=>parser.addParser(customParser));
    customTagMappers.forEach((mapper)=>parser.addTagMapper(mapper));
    parser.push(manifestString);
    parser.end();
    const manifest = parser.manifest; // remove llhls features from the parsed manifest
    // if we don't want llhls support.
    if (!llhls) {
        [
            'preloadSegment',
            'skip',
            'serverControl',
            'renditionReports',
            'partInf',
            'partTargetDuration'
        ].forEach(function(k) {
            if (manifest.hasOwnProperty(k)) delete manifest[k];
        });
        if (manifest.segments) manifest.segments.forEach(function(segment) {
            [
                'parts',
                'preloadHints'
            ].forEach(function(k) {
                if (segment.hasOwnProperty(k)) delete segment[k];
            });
        });
    }
    if (!manifest.targetDuration) {
        let targetDuration = 10;
        if (manifest.segments && manifest.segments.length) targetDuration = manifest.segments.reduce((acc, s)=>Math.max(acc, s.duration), 0);
        if (onwarn) onwarn({
            message: `manifest has no targetDuration defaulting to ${targetDuration}`
        });
        manifest.targetDuration = targetDuration;
    }
    const parts = $86defbb4e95ebb07$var$getLastParts(manifest);
    if (parts.length && !manifest.partTargetDuration) {
        const partTargetDuration = parts.reduce((acc, p)=>Math.max(acc, p.duration), 0);
        if (onwarn) {
            onwarn({
                message: `manifest has no partTargetDuration defaulting to ${partTargetDuration}`
            });
            $86defbb4e95ebb07$var$log.error('LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.');
        }
        manifest.partTargetDuration = partTargetDuration;
    }
    return manifest;
};
/**
 * Loops through all supported media groups in main and calls the provided
 * callback for each group
 *
 * @param {Object} main
 *        The parsed main manifest object
 * @param {Function} callback
 *        Callback to call for each media group
 */ const $86defbb4e95ebb07$var$forEachMediaGroup = (main, callback)=>{
    if (!main.mediaGroups) return;
    [
        'AUDIO',
        'SUBTITLES'
    ].forEach((mediaType)=>{
        if (!main.mediaGroups[mediaType]) return;
        for(const groupKey in main.mediaGroups[mediaType])for(const labelKey in main.mediaGroups[mediaType][groupKey]){
            const mediaProperties = main.mediaGroups[mediaType][groupKey][labelKey];
            callback(mediaProperties, mediaType, groupKey, labelKey);
        }
    });
};
/**
 * Adds properties and attributes to the playlist to keep consistent functionality for
 * playlists throughout VHS.
 *
 * @param {Object} config
 *        Arguments object
 * @param {Object} config.playlist
 *        The media playlist
 * @param {string} [config.uri]
 *        The uri to the media playlist (if media playlist is not from within a main
 *        playlist)
 * @param {string} id
 *        ID to use for the playlist
 */ const $86defbb4e95ebb07$var$setupMediaPlaylist = ({ playlist: playlist, uri: uri, id: id })=>{
    playlist.id = id;
    playlist.playlistErrors_ = 0;
    if (uri) // For media playlists, m3u8-parser does not have access to a URI, as HLS media
    // playlists do not contain their own source URI, but one is needed for consistency in
    // VHS.
    playlist.uri = uri;
     // For HLS main playlists, even though certain attributes MUST be defined, the
    // stream may still be played without them.
    // For HLS media playlists, m3u8-parser does not attach an attributes object to the
    // manifest.
    //
    // To avoid undefined reference errors through the project, and make the code easier
    // to write/read, add an empty attributes object for these cases.
    playlist.attributes = playlist.attributes || {};
};
/**
 * Adds ID, resolvedUri, and attributes properties to each playlist of the main, where
 * necessary. In addition, creates playlist IDs for each playlist and adds playlist ID to
 * playlist references to the playlists array.
 *
 * @param {Object} main
 *        The main playlist
 */ const $86defbb4e95ebb07$var$setupMediaPlaylists = (main)=>{
    let i = main.playlists.length;
    while(i--){
        const playlist = main.playlists[i];
        $86defbb4e95ebb07$var$setupMediaPlaylist({
            playlist: playlist,
            id: $86defbb4e95ebb07$var$createPlaylistID(i, playlist.uri)
        });
        playlist.resolvedUri = $86defbb4e95ebb07$var$resolveUrl(main.uri, playlist.uri);
        main.playlists[playlist.id] = playlist; // URI reference added for backwards compatibility
        main.playlists[playlist.uri] = playlist; // Although the spec states an #EXT-X-STREAM-INF tag MUST have a BANDWIDTH attribute,
        // the stream can be played without it. Although an attributes property may have been
        // added to the playlist to prevent undefined references, issue a warning to fix the
        // manifest.
        if (!playlist.attributes.BANDWIDTH) $86defbb4e95ebb07$var$log.warn('Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.');
    }
};
/**
 * Adds resolvedUri properties to each media group.
 *
 * @param {Object} main
 *        The main playlist
 */ const $86defbb4e95ebb07$var$resolveMediaGroupUris = (main)=>{
    $86defbb4e95ebb07$var$forEachMediaGroup(main, (properties)=>{
        if (properties.uri) properties.resolvedUri = $86defbb4e95ebb07$var$resolveUrl(main.uri, properties.uri);
    });
};
/**
 * Creates a main playlist wrapper to insert a sole media playlist into.
 *
 * @param {Object} media
 *        Media playlist
 * @param {string} uri
 *        The media URI
 *
 * @return {Object}
 *         main playlist
 */ const $86defbb4e95ebb07$var$mainForMedia = (media, uri)=>{
    const id = $86defbb4e95ebb07$var$createPlaylistID(0, uri);
    const main = {
        mediaGroups: {
            'AUDIO': {},
            'VIDEO': {},
            'CLOSED-CAPTIONS': {},
            'SUBTITLES': {}
        },
        uri: (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).location.href,
        resolvedUri: (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).location.href,
        playlists: [
            {
                uri: uri,
                id: id,
                resolvedUri: uri,
                // m3u8-parser does not attach an attributes property to media playlists so make
                // sure that the property is attached to avoid undefined reference errors
                attributes: {}
            }
        ]
    }; // set up ID reference
    main.playlists[id] = main.playlists[0]; // URI reference added for backwards compatibility
    main.playlists[uri] = main.playlists[0];
    return main;
};
/**
 * Does an in-place update of the main manifest to add updated playlist URI references
 * as well as other properties needed by VHS that aren't included by the parser.
 *
 * @param {Object} main
 *        main manifest object
 * @param {string} uri
 *        The source URI
 * @param {function} createGroupID
 *        A function to determine how to create the groupID for mediaGroups
 */ const $86defbb4e95ebb07$var$addPropertiesToMain = (main, uri, createGroupID = $86defbb4e95ebb07$var$groupID)=>{
    main.uri = uri;
    for(let i = 0; i < main.playlists.length; i++)if (!main.playlists[i].uri) {
        // Set up phony URIs for the playlists since playlists are referenced by their URIs
        // throughout VHS, but some formats (e.g., DASH) don't have external URIs
        // TODO: consider adding dummy URIs in mpd-parser
        const phonyUri = `placeholder-uri-${i}`;
        main.playlists[i].uri = phonyUri;
    }
    const audioOnlyMain = $86defbb4e95ebb07$var$isAudioOnly(main);
    $86defbb4e95ebb07$var$forEachMediaGroup(main, (properties, mediaType, groupKey, labelKey)=>{
        // add a playlist array under properties
        if (!properties.playlists || !properties.playlists.length) {
            // If the manifest is audio only and this media group does not have a uri, check
            // if the media group is located in the main list of playlists. If it is, don't add
            // placeholder properties as it shouldn't be considered an alternate audio track.
            if (audioOnlyMain && mediaType === 'AUDIO' && !properties.uri) for(let i = 0; i < main.playlists.length; i++){
                const p = main.playlists[i];
                if (p.attributes && p.attributes.AUDIO && p.attributes.AUDIO === groupKey) return;
            }
            properties.playlists = [
                (0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, properties)
            ];
        }
        properties.playlists.forEach(function(p, i) {
            const groupId = createGroupID(mediaType, groupKey, labelKey, p);
            const id = $86defbb4e95ebb07$var$createPlaylistID(i, groupId);
            if (p.uri) p.resolvedUri = p.resolvedUri || $86defbb4e95ebb07$var$resolveUrl(main.uri, p.uri);
            else {
                // DEPRECATED, this has been added to prevent a breaking change.
                // previously we only ever had a single media group playlist, so
                // we mark the first playlist uri without prepending the index as we used to
                // ideally we would do all of the playlists the same way.
                p.uri = i === 0 ? groupId : id; // don't resolve a placeholder uri to an absolute url, just use
                // the placeholder again
                p.resolvedUri = p.uri;
            }
            p.id = p.id || id; // add an empty attributes object, all playlists are
            // expected to have this.
            p.attributes = p.attributes || {}; // setup ID and URI references (URI for backwards compatibility)
            main.playlists[p.id] = p;
            main.playlists[p.uri] = p;
        });
    });
    $86defbb4e95ebb07$var$setupMediaPlaylists(main);
    $86defbb4e95ebb07$var$resolveMediaGroupUris(main);
};
class $86defbb4e95ebb07$var$DateRangesStorage {
    constructor(){
        this.offset_ = null;
        this.pendingDateRanges_ = new Map();
        this.processedDateRanges_ = new Map();
    }
    setOffset(segments = []) {
        // already set
        if (this.offset_ !== null) return;
         // no segment to process
        if (!segments.length) return;
        const [firstSegment] = segments; // no program date time
        if (firstSegment.programDateTime === undefined) return;
         // Set offset as ProgramDateTime for the very first segment of the very first playlist load:
        this.offset_ = firstSegment.programDateTime / 1000;
    }
    setPendingDateRanges(dateRanges = []) {
        if (!dateRanges.length) return;
        const [dateRange] = dateRanges;
        const startTime = dateRange.startDate.getTime();
        this.trimProcessedDateRanges_(startTime);
        this.pendingDateRanges_ = dateRanges.reduce((map, pendingDateRange)=>{
            map.set(pendingDateRange.id, pendingDateRange);
            return map;
        }, new Map());
    }
    processDateRange(dateRange) {
        this.pendingDateRanges_.delete(dateRange.id);
        this.processedDateRanges_.set(dateRange.id, dateRange);
    }
    getDateRangesToProcess() {
        if (this.offset_ === null) return [];
        const dateRangeClasses = {};
        const dateRangesToProcess = [];
        this.pendingDateRanges_.forEach((dateRange, id)=>{
            if (this.processedDateRanges_.has(id)) return;
            dateRange.startTime = dateRange.startDate.getTime() / 1000 - this.offset_;
            dateRange.processDateRange = ()=>this.processDateRange(dateRange);
            dateRangesToProcess.push(dateRange);
            if (!dateRange.class) return;
            if (dateRangeClasses[dateRange.class]) {
                const length = dateRangeClasses[dateRange.class].push(dateRange);
                dateRange.classListIndex = length - 1;
            } else {
                dateRangeClasses[dateRange.class] = [
                    dateRange
                ];
                dateRange.classListIndex = 0;
            }
        });
        for (const dateRange of dateRangesToProcess){
            const classList = dateRangeClasses[dateRange.class] || [];
            if (dateRange.endDate) dateRange.endTime = dateRange.endDate.getTime() / 1000 - this.offset_;
            else if (dateRange.endOnNext && classList[dateRange.classListIndex + 1]) dateRange.endTime = classList[dateRange.classListIndex + 1].startTime;
            else if (dateRange.duration) dateRange.endTime = dateRange.startTime + dateRange.duration;
            else if (dateRange.plannedDuration) dateRange.endTime = dateRange.startTime + dateRange.plannedDuration;
            else dateRange.endTime = dateRange.startTime;
        }
        return dateRangesToProcess;
    }
    trimProcessedDateRanges_(startTime) {
        const copy = new Map(this.processedDateRanges_);
        copy.forEach((dateRange, id)=>{
            if (dateRange.startDate.getTime() < startTime) this.processedDateRanges_.delete(id);
        });
    }
}
const $86defbb4e95ebb07$var$QUOTA_EXCEEDED_ERR = 22;
const $86defbb4e95ebb07$var$getStreamingNetworkErrorMetadata = ({ requestType: requestType, request: request, error: error, parseFailure: parseFailure })=>{
    const isBadStatus = request.status < 200 || request.status > 299;
    const isFailure = request.status >= 400 && request.status <= 499;
    const errorMetadata = {
        uri: request.uri,
        requestType: requestType
    };
    const isBadStatusOrParseFailure = isBadStatus && !isFailure || parseFailure;
    if (error && isFailure) {
        // copy original error and add to the metadata.
        errorMetadata.error = (0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, error);
        errorMetadata.errorType = $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.NetworkRequestFailed;
    } else if (request.aborted) errorMetadata.errorType = $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.NetworkRequestAborted;
    else if (request.timedout) errorMetadata.errorType = $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.NetworkRequestTimeout;
    else if (isBadStatusOrParseFailure) {
        const errorType = parseFailure ? $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.NetworkBodyParserFailed : $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.NetworkBadStatus;
        errorMetadata.errorType = errorType;
        errorMetadata.status = request.status;
        errorMetadata.headers = request.headers;
    }
    return errorMetadata;
};
/**
 * @file - codecs.js - Handles tasks regarding codec strings such as translating them to
 * codec strings, or translating codec strings into objects that can be examined.
 */ const $86defbb4e95ebb07$var$logFn$1 = $86defbb4e95ebb07$var$logger('CodecUtils');
/**
 * Returns a set of codec strings parsed from the playlist or the default
 * codec strings if no codecs were specified in the playlist
 *
 * @param {Playlist} media the current media playlist
 * @return {Object} an object with the video and audio codecs
 */ const $86defbb4e95ebb07$var$getCodecs = function(media) {
    // if the codecs were explicitly specified, use them instead of the
    // defaults
    const mediaAttributes = media.attributes || {};
    if (mediaAttributes.CODECS) return (0, $34bf5acfb37ee851$export$56679b562aa2891c)(mediaAttributes.CODECS);
};
const $86defbb4e95ebb07$var$isMaat = (main, media)=>{
    const mediaAttributes = media.attributes || {};
    return main && main.mediaGroups && main.mediaGroups.AUDIO && mediaAttributes.AUDIO && main.mediaGroups.AUDIO[mediaAttributes.AUDIO];
};
const $86defbb4e95ebb07$var$isMuxed = (main, media)=>{
    if (!$86defbb4e95ebb07$var$isMaat(main, media)) return true;
    const mediaAttributes = media.attributes || {};
    const audioGroup = main.mediaGroups.AUDIO[mediaAttributes.AUDIO];
    for(const groupId in audioGroup){
        // If an audio group has a URI (the case for HLS, as HLS will use external playlists),
        // or there are listed playlists (the case for DASH, as the manifest will have already
        // provided all of the details necessary to generate the audio playlist, as opposed to
        // HLS' externally requested playlists), then the content is demuxed.
        if (!audioGroup[groupId].uri && !audioGroup[groupId].playlists) return true;
    }
    return false;
};
const $86defbb4e95ebb07$var$unwrapCodecList = function(codecList) {
    const codecs = {};
    codecList.forEach(({ mediaType: mediaType, type: type, details: details })=>{
        codecs[mediaType] = codecs[mediaType] || [];
        codecs[mediaType].push((0, $34bf5acfb37ee851$export$4e61c3c458a5b005)(`${type}${details}`));
    });
    Object.keys(codecs).forEach(function(mediaType) {
        if (codecs[mediaType].length > 1) {
            $86defbb4e95ebb07$var$logFn$1(`multiple ${mediaType} codecs found as attributes: ${codecs[mediaType].join(', ')}. Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.`);
            codecs[mediaType] = null;
            return;
        }
        codecs[mediaType] = codecs[mediaType][0];
    });
    return codecs;
};
const $86defbb4e95ebb07$var$codecCount = function(codecObj) {
    let count = 0;
    if (codecObj.audio) count++;
    if (codecObj.video) count++;
    return count;
};
/**
 * Calculates the codec strings for a working configuration of
 * SourceBuffers to play variant streams in a main playlist. If
 * there is no possible working configuration, an empty object will be
 * returned.
 *
 * @param main {Object} the m3u8 object for the main playlist
 * @param media {Object} the m3u8 object for the variant playlist
 * @return {Object} the codec strings.
 *
 * @private
 */ const $86defbb4e95ebb07$var$codecsForPlaylist = function(main, media) {
    const mediaAttributes = media.attributes || {};
    const codecInfo = $86defbb4e95ebb07$var$unwrapCodecList($86defbb4e95ebb07$var$getCodecs(media) || []); // HLS with multiple-audio tracks must always get an audio codec.
    // Put another way, there is no way to have a video-only multiple-audio HLS!
    if ($86defbb4e95ebb07$var$isMaat(main, media) && !codecInfo.audio) {
        if (!$86defbb4e95ebb07$var$isMuxed(main, media)) {
            // It is possible for codecs to be specified on the audio media group playlist but
            // not on the rendition playlist. This is mostly the case for DASH, where audio and
            // video are always separate (and separately specified).
            const defaultCodecs = $86defbb4e95ebb07$var$unwrapCodecList((0, $34bf5acfb37ee851$export$e192782a4d0b5c5c)(main, mediaAttributes.AUDIO) || []);
            if (defaultCodecs.audio) codecInfo.audio = defaultCodecs.audio;
        }
    }
    return codecInfo;
};
const { EventTarget: $86defbb4e95ebb07$var$EventTarget$1 } = $86defbb4e95ebb07$export$2e2bcd8739ae039;
const $86defbb4e95ebb07$var$addLLHLSQueryDirectives = (uri, media)=>{
    if (media.endList || !media.serverControl) return uri;
    const parameters = {};
    if (media.serverControl.canBlockReload) {
        const { preloadSegment: preloadSegment } = media; // next msn is a zero based value, length is not.
        let nextMSN = media.mediaSequence + media.segments.length; // If preload segment has parts then it is likely
        // that we are going to request a part of that preload segment.
        // the logic below is used to determine that.
        if (preloadSegment) {
            const parts = preloadSegment.parts || []; // _HLS_part is a zero based index
            const nextPart = $86defbb4e95ebb07$var$getKnownPartCount(media) - 1; // if nextPart is > -1 and not equal to just the
            // length of parts, then we know we had part preload hints
            // and we need to add the _HLS_part= query
            if (nextPart > -1 && nextPart !== parts.length - 1) // add existing parts to our preload hints
            // eslint-disable-next-line
            parameters._HLS_part = nextPart;
             // this if statement makes sure that we request the msn
            // of the preload segment if:
            // 1. the preload segment had parts (and was not yet a full segment)
            //    but was added to our segments array
            // 2. the preload segment had preload hints for parts that are not in
            //    the manifest yet.
            // in all other cases we want the segment after the preload segment
            // which will be given by using media.segments.length because it is 1 based
            // rather than 0 based.
            if (nextPart > -1 || parts.length) nextMSN--;
        } // add _HLS_msn= in front of any _HLS_part query
        // eslint-disable-next-line
        parameters._HLS_msn = nextMSN;
    }
    if (media.serverControl && media.serverControl.canSkipUntil) // add _HLS_skip= infront of all other queries.
    // eslint-disable-next-line
    parameters._HLS_skip = media.serverControl.canSkipDateranges ? 'v2' : 'YES';
    if (Object.keys(parameters).length) {
        const parsedUri = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).URL(uri);
        [
            '_HLS_skip',
            '_HLS_msn',
            '_HLS_part'
        ].forEach(function(name) {
            if (!parameters.hasOwnProperty(name)) return;
            parsedUri.searchParams.set(name, parameters[name]);
        });
        uri = parsedUri.toString();
    }
    return uri;
};
/**
 * Returns a new segment object with properties and
 * the parts array merged.
 *
 * @param {Object} a the old segment
 * @param {Object} b the new segment
 *
 * @return {Object} the merged segment
 */ const $86defbb4e95ebb07$var$updateSegment = (a, b)=>{
    if (!a) return b;
    const result = $86defbb4e95ebb07$var$merge(a, b); // if only the old segment has preload hints
    // and the new one does not, remove preload hints.
    if (a.preloadHints && !b.preloadHints) delete result.preloadHints;
     // if only the old segment has parts
    // then the parts are no longer valid
    if (a.parts && !b.parts) delete result.parts; // if both segments have parts
    else if (a.parts && b.parts) {
        for(let i = 0; i < b.parts.length; i++)if (a.parts && a.parts[i]) result.parts[i] = $86defbb4e95ebb07$var$merge(a.parts[i], b.parts[i]);
    } // set skipped to false for segments that have
    // have had information merged from the old segment.
    if (!a.skipped && b.skipped) result.skipped = false;
     // set preload to false for segments that have
    // had information added in the new segment.
    if (a.preload && !b.preload) result.preload = false;
    return result;
};
/**
 * Returns a new array of segments that is the result of merging
 * properties from an older list of segments onto an updated
 * list. No properties on the updated playlist will be ovewritten.
 *
 * @param {Array} original the outdated list of segments
 * @param {Array} update the updated list of segments
 * @param {number=} offset the index of the first update
 * segment in the original segment list. For non-live playlists,
 * this should always be zero and does not need to be
 * specified. For live playlists, it should be the difference
 * between the media sequence numbers in the original and updated
 * playlists.
 * @return {Array} a list of merged segment objects
 */ const $86defbb4e95ebb07$var$updateSegments = (original, update, offset)=>{
    const oldSegments = original.slice();
    const newSegments = update.slice();
    offset = offset || 0;
    const result = [];
    let currentMap;
    for(let newIndex = 0; newIndex < newSegments.length; newIndex++){
        const oldSegment = oldSegments[newIndex + offset];
        const newSegment = newSegments[newIndex];
        if (oldSegment) {
            currentMap = oldSegment.map || currentMap;
            result.push($86defbb4e95ebb07$var$updateSegment(oldSegment, newSegment));
        } else {
            // carry over map to new segment if it is missing
            if (currentMap && !newSegment.map) newSegment.map = currentMap;
            result.push(newSegment);
        }
    }
    return result;
};
const $86defbb4e95ebb07$var$resolveSegmentUris = (segment, baseUri)=>{
    // preloadSegment will not have a uri at all
    // as the segment isn't actually in the manifest yet, only parts
    if (!segment.resolvedUri && segment.uri) segment.resolvedUri = $86defbb4e95ebb07$var$resolveUrl(baseUri, segment.uri);
    if (segment.key && !segment.key.resolvedUri) segment.key.resolvedUri = $86defbb4e95ebb07$var$resolveUrl(baseUri, segment.key.uri);
    if (segment.map && !segment.map.resolvedUri) segment.map.resolvedUri = $86defbb4e95ebb07$var$resolveUrl(baseUri, segment.map.uri);
    if (segment.map && segment.map.key && !segment.map.key.resolvedUri) segment.map.key.resolvedUri = $86defbb4e95ebb07$var$resolveUrl(baseUri, segment.map.key.uri);
    if (segment.parts && segment.parts.length) segment.parts.forEach((p)=>{
        if (p.resolvedUri) return;
        p.resolvedUri = $86defbb4e95ebb07$var$resolveUrl(baseUri, p.uri);
    });
    if (segment.preloadHints && segment.preloadHints.length) segment.preloadHints.forEach((p)=>{
        if (p.resolvedUri) return;
        p.resolvedUri = $86defbb4e95ebb07$var$resolveUrl(baseUri, p.uri);
    });
};
const $86defbb4e95ebb07$var$getAllSegments = function(media) {
    const segments = media.segments || [];
    const preloadSegment = media.preloadSegment; // a preloadSegment with only preloadHints is not currently
    // a usable segment, only include a preloadSegment that has
    // parts.
    if (preloadSegment && preloadSegment.parts && preloadSegment.parts.length) {
        // if preloadHints has a MAP that means that the
        // init segment is going to change. We cannot use any of the parts
        // from this preload segment.
        if (preloadSegment.preloadHints) for(let i = 0; i < preloadSegment.preloadHints.length; i++){
            if (preloadSegment.preloadHints[i].type === 'MAP') return segments;
        }
         // set the duration for our preload segment to target duration.
        preloadSegment.duration = media.targetDuration;
        preloadSegment.preload = true;
        segments.push(preloadSegment);
    }
    return segments;
}; // consider the playlist unchanged if the playlist object is the same or
// the number of segments is equal, the media sequence number is unchanged,
// and this playlist hasn't become the end of the playlist
const $86defbb4e95ebb07$var$isPlaylistUnchanged = (a, b)=>a === b || a.segments && b.segments && a.segments.length === b.segments.length && a.endList === b.endList && a.mediaSequence === b.mediaSequence && a.preloadSegment === b.preloadSegment;
/**
  * Returns a new main playlist that is the result of merging an
  * updated media playlist into the original version. If the
  * updated media playlist does not match any of the playlist
  * entries in the original main playlist, null is returned.
  *
  * @param {Object} main a parsed main M3U8 object
  * @param {Object} media a parsed media M3U8 object
  * @return {Object} a new object that represents the original
  * main playlist with the updated media playlist merged in, or
  * null if the merge produced no change.
  */ const $86defbb4e95ebb07$var$updateMain$1 = (main, newMedia, unchangedCheck = $86defbb4e95ebb07$var$isPlaylistUnchanged)=>{
    const result = $86defbb4e95ebb07$var$merge(main, {});
    const oldMedia = result.playlists[newMedia.id];
    if (!oldMedia) return null;
    if (unchangedCheck(oldMedia, newMedia)) return null;
    newMedia.segments = $86defbb4e95ebb07$var$getAllSegments(newMedia);
    const mergedPlaylist = $86defbb4e95ebb07$var$merge(oldMedia, newMedia); // always use the new media's preload segment
    if (mergedPlaylist.preloadSegment && !newMedia.preloadSegment) delete mergedPlaylist.preloadSegment;
     // if the update could overlap existing segment information, merge the two segment lists
    if (oldMedia.segments) {
        if (newMedia.skip) {
            newMedia.segments = newMedia.segments || []; // add back in objects for skipped segments, so that we merge
            // old properties into the new segments
            for(let i = 0; i < newMedia.skip.skippedSegments; i++)newMedia.segments.unshift({
                skipped: true
            });
        }
        mergedPlaylist.segments = $86defbb4e95ebb07$var$updateSegments(oldMedia.segments, newMedia.segments, newMedia.mediaSequence - oldMedia.mediaSequence);
    } // resolve any segment URIs to prevent us from having to do it later
    mergedPlaylist.segments.forEach((segment)=>{
        $86defbb4e95ebb07$var$resolveSegmentUris(segment, mergedPlaylist.resolvedUri);
    }); // TODO Right now in the playlists array there are two references to each playlist, one
    // that is referenced by index, and one by URI. The index reference may no longer be
    // necessary.
    for(let i = 0; i < result.playlists.length; i++)if (result.playlists[i].id === newMedia.id) result.playlists[i] = mergedPlaylist;
    result.playlists[newMedia.id] = mergedPlaylist; // URI reference added for backwards compatibility
    result.playlists[newMedia.uri] = mergedPlaylist; // update media group playlist references.
    $86defbb4e95ebb07$var$forEachMediaGroup(main, (properties, mediaType, groupKey, labelKey)=>{
        if (!properties.playlists) return;
        for(let i = 0; i < properties.playlists.length; i++)if (newMedia.id === properties.playlists[i].id) properties.playlists[i] = mergedPlaylist;
    });
    return result;
};
/**
 * Calculates the time to wait before refreshing a live playlist
 *
 * @param {Object} media
 *        The current media
 * @param {boolean} update
 *        True if there were any updates from the last refresh, false otherwise
 * @return {number}
 *         The time in ms to wait before refreshing the live playlist
 */ const $86defbb4e95ebb07$var$refreshDelay = (media, update)=>{
    const segments = media.segments || [];
    const lastSegment = segments[segments.length - 1];
    const lastPart = lastSegment && lastSegment.parts && lastSegment.parts[lastSegment.parts.length - 1];
    const lastDuration = lastPart && lastPart.duration || lastSegment && lastSegment.duration;
    if (update && lastDuration) return lastDuration * 1000;
     // if the playlist is unchanged since the last reload or last segment duration
    // cannot be determined, try again after half the target duration
    return (media.partTargetDuration || media.targetDuration || 10) * 500;
};
const $86defbb4e95ebb07$var$playlistMetadataPayload = (playlists, type, isLive)=>{
    if (!playlists) return;
    const renditions = [];
    playlists.forEach((playlist)=>{
        // we need attributes to populate rendition data.
        if (!playlist.attributes) return;
        const { BANDWIDTH: BANDWIDTH, RESOLUTION: RESOLUTION, CODECS: CODECS } = playlist.attributes;
        renditions.push({
            id: playlist.id,
            bandwidth: BANDWIDTH,
            resolution: RESOLUTION,
            codecs: CODECS
        });
    });
    return {
        type: type,
        isLive: isLive,
        renditions: renditions
    };
};
/**
 * Load a playlist from a remote location
 *
 * @class PlaylistLoader
 * @extends Stream
 * @param {string|Object} src url or object of manifest
 * @param {boolean} withCredentials the withCredentials xhr option
 * @class
 */ class $86defbb4e95ebb07$var$PlaylistLoader extends $86defbb4e95ebb07$var$EventTarget$1 {
    constructor(src, vhs, options = {}){
        super();
        if (!src) throw new Error('A non-empty playlist URL or object is required');
        this.logger_ = $86defbb4e95ebb07$var$logger('PlaylistLoader');
        const { withCredentials: withCredentials = false } = options;
        this.src = src;
        this.vhs_ = vhs;
        this.withCredentials = withCredentials;
        this.addDateRangesToTextTrack_ = options.addDateRangesToTextTrack;
        const vhsOptions = vhs.options_;
        this.customTagParsers = vhsOptions && vhsOptions.customTagParsers || [];
        this.customTagMappers = vhsOptions && vhsOptions.customTagMappers || [];
        this.llhls = vhsOptions && vhsOptions.llhls;
        this.dateRangesStorage_ = new $86defbb4e95ebb07$var$DateRangesStorage(); // initialize the loader state
        this.state = 'HAVE_NOTHING'; // live playlist staleness timeout
        this.handleMediaupdatetimeout_ = this.handleMediaupdatetimeout_.bind(this);
        this.on('mediaupdatetimeout', this.handleMediaupdatetimeout_);
        this.on('loadedplaylist', this.handleLoadedPlaylist_.bind(this));
    }
    handleLoadedPlaylist_() {
        const mediaPlaylist = this.media();
        if (!mediaPlaylist) return;
        this.dateRangesStorage_.setOffset(mediaPlaylist.segments);
        this.dateRangesStorage_.setPendingDateRanges(mediaPlaylist.dateRanges);
        const availableDateRanges = this.dateRangesStorage_.getDateRangesToProcess();
        if (!availableDateRanges.length || !this.addDateRangesToTextTrack_) return;
        this.addDateRangesToTextTrack_(availableDateRanges);
    }
    handleMediaupdatetimeout_() {
        if (this.state !== 'HAVE_METADATA') // only refresh the media playlist if no other activity is going on
        return;
        const media = this.media();
        let uri = $86defbb4e95ebb07$var$resolveUrl(this.main.uri, media.uri);
        if (this.llhls) uri = $86defbb4e95ebb07$var$addLLHLSQueryDirectives(uri, media);
        this.state = 'HAVE_CURRENT_METADATA';
        this.request = this.vhs_.xhr({
            uri: uri,
            withCredentials: this.withCredentials,
            requestType: 'hls-playlist'
        }, (error, req)=>{
            // disposed
            if (!this.request) return;
            if (error) return this.playlistRequestError(this.request, this.media(), 'HAVE_METADATA');
            this.haveMetadata({
                playlistString: this.request.responseText,
                url: this.media().uri,
                id: this.media().id
            });
        });
    }
    playlistRequestError(xhr, playlist, startingState) {
        const { uri: uri, id: id } = playlist; // any in-flight request is now finished
        this.request = null;
        if (startingState) this.state = startingState;
        this.error = {
            playlist: this.main.playlists[id],
            status: xhr.status,
            message: `HLS playlist request error at URL: ${uri}.`,
            responseText: xhr.responseText,
            code: xhr.status >= 500 ? 4 : 2,
            metadata: $86defbb4e95ebb07$var$getStreamingNetworkErrorMetadata({
                requestType: xhr.requestType,
                request: xhr,
                error: xhr.error
            })
        };
        this.trigger('error');
    }
    parseManifest_({ url: url, manifestString: manifestString }) {
        try {
            const parsed = $86defbb4e95ebb07$var$parseManifest({
                onwarn: ({ message: message })=>this.logger_(`m3u8-parser warn for ${url}: ${message}`),
                oninfo: ({ message: message })=>this.logger_(`m3u8-parser info for ${url}: ${message}`),
                manifestString: manifestString,
                customTagParsers: this.customTagParsers,
                customTagMappers: this.customTagMappers,
                llhls: this.llhls
            });
            /**
       * VHS does not support switching between variants with and without audio and video
       * so we want to filter out audio-only variants when variants with video and(or) audio are also detected.
       */ if (!parsed.playlists || !parsed.playlists.length) return parsed;
            this.excludeAudioOnlyVariants(parsed.playlists);
            return parsed;
        } catch (error) {
            this.error = error;
            this.error.metadata = {
                errorType: $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.StreamingHlsPlaylistParserError,
                error: error
            };
        }
    }
    excludeAudioOnlyVariants(playlists) {
        // helper function
        const hasVideo = (playlist)=>{
            const attributes = playlist.attributes || {};
            const { width: width, height: height } = attributes.RESOLUTION || {};
            if (width && height) return true;
             // parse codecs string from playlist attributes
            const codecsList = $86defbb4e95ebb07$var$getCodecs(playlist) || []; // unwrap list
            const codecsInfo = $86defbb4e95ebb07$var$unwrapCodecList(codecsList);
            return Boolean(codecsInfo.video);
        };
        if (playlists.some(hasVideo)) playlists.forEach((playlist)=>{
            if (!hasVideo(playlist)) playlist.excludeUntil = Infinity;
        });
    }
    /**
   * Update the playlist loader's state in response to a new or updated playlist.
   *
   * @param {string} [playlistString]
   *        Playlist string (if playlistObject is not provided)
   * @param {Object} [playlistObject]
   *        Playlist object (if playlistString is not provided)
   * @param {string} url
   *        URL of playlist
   * @param {string} id
   *        ID to use for playlist
   */ haveMetadata({ playlistString: playlistString, playlistObject: playlistObject, url: url, id: id }) {
        // any in-flight request is now finished
        this.request = null;
        this.state = 'HAVE_METADATA';
        const metadata = {
            playlistInfo: {
                type: 'media',
                uri: url
            }
        };
        this.trigger({
            type: 'playlistparsestart',
            metadata: metadata
        });
        const playlist = playlistObject || this.parseManifest_({
            url: url,
            manifestString: playlistString
        });
        playlist.lastRequest = Date.now();
        $86defbb4e95ebb07$var$setupMediaPlaylist({
            playlist: playlist,
            uri: url,
            id: id
        }); // merge this playlist into the main manifest
        const update = $86defbb4e95ebb07$var$updateMain$1(this.main, playlist);
        this.targetDuration = playlist.partTargetDuration || playlist.targetDuration;
        this.pendingMedia_ = null;
        if (update) {
            this.main = update;
            this.media_ = this.main.playlists[id];
        } else this.trigger('playlistunchanged');
        this.updateMediaUpdateTimeout_($86defbb4e95ebb07$var$refreshDelay(this.media(), !!update));
        metadata.parsedPlaylist = $86defbb4e95ebb07$var$playlistMetadataPayload(this.main.playlists, metadata.playlistInfo.type, !this.media_.endList);
        this.trigger({
            type: 'playlistparsecomplete',
            metadata: metadata
        });
        this.trigger('loadedplaylist');
    }
    /**
    * Abort any outstanding work and clean up.
    */ dispose() {
        this.trigger('dispose');
        this.stopRequest();
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mediaUpdateTimeout);
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.finalRenditionTimeout);
        this.dateRangesStorage_ = new $86defbb4e95ebb07$var$DateRangesStorage();
        this.off();
    }
    stopRequest() {
        if (this.request) {
            const oldRequest = this.request;
            this.request = null;
            oldRequest.onreadystatechange = null;
            oldRequest.abort();
        }
    }
    /**
    * When called without any arguments, returns the currently
    * active media playlist. When called with a single argument,
    * triggers the playlist loader to asynchronously switch to the
    * specified media playlist. Calling this method while the
    * loader is in the HAVE_NOTHING causes an error to be emitted
    * but otherwise has no effect.
    *
    * @param {Object=} playlist the parsed media playlist
    * object to switch to
    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
    *
    * @return {Playlist} the current loaded media
    */ media(playlist, shouldDelay) {
        // getter
        if (!playlist) return this.media_;
         // setter
        if (this.state === 'HAVE_NOTHING') throw new Error('Cannot switch media playlist from ' + this.state);
         // find the playlist object if the target playlist has been
        // specified by URI
        if (typeof playlist === 'string') {
            if (!this.main.playlists[playlist]) throw new Error('Unknown playlist URI: ' + playlist);
            playlist = this.main.playlists[playlist];
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.finalRenditionTimeout);
        if (shouldDelay) {
            const delay = (playlist.partTargetDuration || playlist.targetDuration) / 2 * 1000 || 5000;
            this.finalRenditionTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(this.media.bind(this, playlist, false), delay);
            return;
        }
        const startingState = this.state;
        const mediaChange = !this.media_ || playlist.id !== this.media_.id;
        const mainPlaylistRef = this.main.playlists[playlist.id]; // switch to fully loaded playlists immediately
        if (mainPlaylistRef && mainPlaylistRef.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
        // media playlist or, for the case of demuxed audio, a resolved audio media group)
        playlist.endList && playlist.segments.length) {
            // abort outstanding playlist requests
            if (this.request) {
                this.request.onreadystatechange = null;
                this.request.abort();
                this.request = null;
            }
            this.state = 'HAVE_METADATA';
            this.media_ = playlist; // trigger media change if the active media has been updated
            if (mediaChange) {
                this.trigger('mediachanging');
                if (startingState === 'HAVE_MAIN_MANIFEST') // The initial playlist was a main manifest, and the first media selected was
                // also provided (in the form of a resolved playlist object) as part of the
                // source object (rather than just a URL). Therefore, since the media playlist
                // doesn't need to be requested, loadedmetadata won't trigger as part of the
                // normal flow, and needs an explicit trigger here.
                this.trigger('loadedmetadata');
                else this.trigger('mediachange');
            }
            return;
        } // We update/set the timeout here so that live playlists
        // that are not a media change will "start" the loader as expected.
        // We expect that this function will start the media update timeout
        // cycle again. This also prevents a playlist switch failure from
        // causing us to stall during live.
        this.updateMediaUpdateTimeout_($86defbb4e95ebb07$var$refreshDelay(playlist, true)); // switching to the active playlist is a no-op
        if (!mediaChange) return;
        this.state = 'SWITCHING_MEDIA'; // there is already an outstanding playlist request
        if (this.request) {
            if (playlist.resolvedUri === this.request.url) // requesting to switch to the same playlist multiple times
            // has no effect after the first
            return;
            this.request.onreadystatechange = null;
            this.request.abort();
            this.request = null;
        } // request the new playlist
        if (this.media_) this.trigger('mediachanging');
        this.pendingMedia_ = playlist;
        const metadata = {
            playlistInfo: {
                type: 'media',
                uri: playlist.uri
            }
        };
        this.trigger({
            type: 'playlistrequeststart',
            metadata: metadata
        });
        this.request = this.vhs_.xhr({
            uri: playlist.resolvedUri,
            withCredentials: this.withCredentials,
            requestType: 'hls-playlist'
        }, (error, req)=>{
            // disposed
            if (!this.request) return;
            playlist.lastRequest = Date.now();
            playlist.resolvedUri = $86defbb4e95ebb07$var$resolveManifestRedirect(playlist.resolvedUri, req);
            if (error) return this.playlistRequestError(this.request, playlist, startingState);
            this.trigger({
                type: 'playlistrequestcomplete',
                metadata: metadata
            });
            this.haveMetadata({
                playlistString: req.responseText,
                url: playlist.uri,
                id: playlist.id
            }); // fire loadedmetadata the first time a media playlist is loaded
            if (startingState === 'HAVE_MAIN_MANIFEST') this.trigger('loadedmetadata');
            else this.trigger('mediachange');
        });
    }
    /**
   * pause loading of the playlist
   */ pause() {
        if (this.mediaUpdateTimeout) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mediaUpdateTimeout);
            this.mediaUpdateTimeout = null;
        }
        this.stopRequest();
        if (this.state === 'HAVE_NOTHING') // If we pause the loader before any data has been retrieved, its as if we never
        // started, so reset to an unstarted state.
        this.started = false;
         // Need to restore state now that no activity is happening
        if (this.state === 'SWITCHING_MEDIA') {
            // if the loader was in the process of switching media, it should either return to
            // HAVE_MAIN_MANIFEST or HAVE_METADATA depending on if the loader has loaded a media
            // playlist yet. This is determined by the existence of loader.media_
            if (this.media_) this.state = 'HAVE_METADATA';
            else this.state = 'HAVE_MAIN_MANIFEST';
        } else if (this.state === 'HAVE_CURRENT_METADATA') this.state = 'HAVE_METADATA';
    }
    /**
   * start loading of the playlist
   */ load(shouldDelay) {
        if (this.mediaUpdateTimeout) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mediaUpdateTimeout);
            this.mediaUpdateTimeout = null;
        }
        const media = this.media();
        if (shouldDelay) {
            const delay = media ? (media.partTargetDuration || media.targetDuration) / 2 * 1000 : 5000;
            this.mediaUpdateTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>{
                this.mediaUpdateTimeout = null;
                this.load();
            }, delay);
            return;
        }
        if (!this.started) {
            this.start();
            return;
        }
        if (media && !media.endList) this.trigger('mediaupdatetimeout');
        else this.trigger('loadedplaylist');
    }
    updateMediaUpdateTimeout_(delay) {
        if (this.mediaUpdateTimeout) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mediaUpdateTimeout);
            this.mediaUpdateTimeout = null;
        } // we only have use mediaupdatetimeout for live playlists.
        if (!this.media() || this.media().endList) return;
        this.mediaUpdateTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>{
            this.mediaUpdateTimeout = null;
            this.trigger('mediaupdatetimeout');
            this.updateMediaUpdateTimeout_(delay);
        }, delay);
    }
    /**
   * start loading of the playlist
   */ start() {
        this.started = true;
        if (typeof this.src === 'object') {
            // in the case of an entirely constructed manifest object (meaning there's no actual
            // manifest on a server), default the uri to the page's href
            if (!this.src.uri) this.src.uri = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).location.href;
             // resolvedUri is added on internally after the initial request. Since there's no
            // request for pre-resolved manifests, add on resolvedUri here.
            this.src.resolvedUri = this.src.uri; // Since a manifest object was passed in as the source (instead of a URL), the first
            // request can be skipped (since the top level of the manifest, at a minimum, is
            // already available as a parsed manifest object). However, if the manifest object
            // represents a main playlist, some media playlists may need to be resolved before
            // the starting segment list is available. Therefore, go directly to setup of the
            // initial playlist, and let the normal flow continue from there.
            //
            // Note that the call to setup is asynchronous, as other sections of VHS may assume
            // that the first request is asynchronous.
            setTimeout(()=>{
                this.setupInitialPlaylist(this.src);
            }, 0);
            return;
        }
        const metadata = {
            playlistInfo: {
                type: 'multivariant',
                uri: this.src
            }
        };
        this.trigger({
            type: 'playlistrequeststart',
            metadata: metadata
        }); // request the specified URL
        this.request = this.vhs_.xhr({
            uri: this.src,
            withCredentials: this.withCredentials,
            requestType: 'hls-playlist'
        }, (error, req)=>{
            // disposed
            if (!this.request) return;
             // clear the loader's request reference
            this.request = null;
            if (error) {
                this.error = {
                    status: req.status,
                    message: `HLS playlist request error at URL: ${this.src}.`,
                    responseText: req.responseText,
                    // MEDIA_ERR_NETWORK
                    code: 2,
                    metadata: $86defbb4e95ebb07$var$getStreamingNetworkErrorMetadata({
                        requestType: req.requestType,
                        request: req,
                        error: error
                    })
                };
                if (this.state === 'HAVE_NOTHING') this.started = false;
                return this.trigger('error');
            }
            this.trigger({
                type: 'playlistrequestcomplete',
                metadata: metadata
            });
            this.src = $86defbb4e95ebb07$var$resolveManifestRedirect(this.src, req);
            this.trigger({
                type: 'playlistparsestart',
                metadata: metadata
            });
            const manifest = this.parseManifest_({
                manifestString: req.responseText,
                url: this.src
            }); // we haven't loaded any variant playlists here so we default to false for isLive.
            metadata.parsedPlaylist = $86defbb4e95ebb07$var$playlistMetadataPayload(manifest.playlists, metadata.playlistInfo.type, false);
            this.trigger({
                type: 'playlistparsecomplete',
                metadata: metadata
            });
            this.setupInitialPlaylist(manifest);
        });
    }
    srcUri() {
        return typeof this.src === 'string' ? this.src : this.src.uri;
    }
    /**
   * Given a manifest object that's either a main or media playlist, trigger the proper
   * events and set the state of the playlist loader.
   *
   * If the manifest object represents a main playlist, `loadedplaylist` will be
   * triggered to allow listeners to select a playlist. If none is selected, the loader
   * will default to the first one in the playlists array.
   *
   * If the manifest object represents a media playlist, `loadedplaylist` will be
   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
   *
   * In the case of a media playlist, a main playlist object wrapper with one playlist
   * will be created so that all logic can handle playlists in the same fashion (as an
   * assumed manifest object schema).
   *
   * @param {Object} manifest
   *        The parsed manifest object
   */ setupInitialPlaylist(manifest) {
        this.state = 'HAVE_MAIN_MANIFEST';
        if (manifest.playlists) {
            this.main = manifest;
            $86defbb4e95ebb07$var$addPropertiesToMain(this.main, this.srcUri()); // If the initial main playlist has playlists wtih segments already resolved,
            // then resolve URIs in advance, as they are usually done after a playlist request,
            // which may not happen if the playlist is resolved.
            manifest.playlists.forEach((playlist)=>{
                playlist.segments = $86defbb4e95ebb07$var$getAllSegments(playlist);
                playlist.segments.forEach((segment)=>{
                    $86defbb4e95ebb07$var$resolveSegmentUris(segment, playlist.resolvedUri);
                });
            });
            this.trigger('loadedplaylist');
            if (!this.request) // no media playlist was specifically selected so start
            // from the first listed one
            this.media(this.main.playlists[0]);
            return;
        } // In order to support media playlists passed in as vhs-json, the case where the uri
        // is not provided as part of the manifest should be considered, and an appropriate
        // default used.
        const uri = this.srcUri() || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).location.href;
        this.main = $86defbb4e95ebb07$var$mainForMedia(manifest, uri);
        this.haveMetadata({
            playlistObject: manifest,
            url: uri,
            id: this.main.playlists[0].id
        });
        this.trigger('loadedmetadata');
    }
    /**
   * Updates or deletes a preexisting pathway clone.
   * Ensures that all playlists related to the old pathway clone are
   * either updated or deleted.
   *
   * @param {Object} clone On update, the pathway clone object for the newly updated pathway clone.
   *        On delete, the old pathway clone object to be deleted.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */ updateOrDeleteClone(clone, isUpdate) {
        const main = this.main;
        const pathway = clone.ID;
        let i = main.playlists.length; // Iterate backwards through the playlist so we can remove playlists if necessary.
        while(i--){
            const p = main.playlists[i];
            if (p.attributes['PATHWAY-ID'] === pathway) {
                const oldPlaylistUri = p.resolvedUri;
                const oldPlaylistId = p.id; // update the indexed playlist and add new playlists by ID and URI
                if (isUpdate) {
                    const newPlaylistUri = this.createCloneURI_(p.resolvedUri, clone);
                    const newPlaylistId = $86defbb4e95ebb07$var$createPlaylistID(pathway, newPlaylistUri);
                    const attributes = this.createCloneAttributes_(pathway, p.attributes);
                    const updatedPlaylist = this.createClonePlaylist_(p, newPlaylistId, clone, attributes);
                    main.playlists[i] = updatedPlaylist;
                    main.playlists[newPlaylistId] = updatedPlaylist;
                    main.playlists[newPlaylistUri] = updatedPlaylist;
                } else // Remove the indexed playlist.
                main.playlists.splice(i, 1);
                 // Remove playlists by the old ID and URI.
                delete main.playlists[oldPlaylistId];
                delete main.playlists[oldPlaylistUri];
            }
        }
        this.updateOrDeleteCloneMedia(clone, isUpdate);
    }
    /**
   * Updates or deletes media data based on the pathway clone object.
   * Due to the complexity of the media groups and playlists, in all cases
   * we remove all of the old media groups and playlists.
   * On updates, we then create new media groups and playlists based on the
   * new pathway clone object.
   *
   * @param {Object} clone The pathway clone object for the newly updated pathway clone.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */ updateOrDeleteCloneMedia(clone, isUpdate) {
        const main = this.main;
        const id = clone.ID;
        [
            'AUDIO',
            'SUBTITLES',
            'CLOSED-CAPTIONS'
        ].forEach((mediaType)=>{
            if (!main.mediaGroups[mediaType] || !main.mediaGroups[mediaType][id]) return;
            for(const groupKey in main.mediaGroups[mediaType])// Remove all media playlists for the media group for this pathway clone.
            if (groupKey === id) {
                for(const labelKey in main.mediaGroups[mediaType][groupKey]){
                    const oldMedia = main.mediaGroups[mediaType][groupKey][labelKey];
                    oldMedia.playlists.forEach((p, i)=>{
                        const oldMediaPlaylist = main.playlists[p.id];
                        const oldPlaylistId = oldMediaPlaylist.id;
                        const oldPlaylistUri = oldMediaPlaylist.resolvedUri;
                        delete main.playlists[oldPlaylistId];
                        delete main.playlists[oldPlaylistUri];
                    });
                } // Delete the old media group.
                delete main.mediaGroups[mediaType][groupKey];
            }
        }); // Create the new media groups and playlists if there is an update.
        if (isUpdate) this.createClonedMediaGroups_(clone);
    }
    /**
   * Given a pathway clone object, clones all necessary playlists.
   *
   * @param {Object} clone The pathway clone object.
   * @param {Object} basePlaylist The original playlist to clone from.
   */ addClonePathway(clone, basePlaylist = {}) {
        const main = this.main;
        const index = main.playlists.length;
        const uri = this.createCloneURI_(basePlaylist.resolvedUri, clone);
        const playlistId = $86defbb4e95ebb07$var$createPlaylistID(clone.ID, uri);
        const attributes = this.createCloneAttributes_(clone.ID, basePlaylist.attributes);
        const playlist = this.createClonePlaylist_(basePlaylist, playlistId, clone, attributes);
        main.playlists[index] = playlist; // add playlist by ID and URI
        main.playlists[playlistId] = playlist;
        main.playlists[uri] = playlist;
        this.createClonedMediaGroups_(clone);
    }
    /**
   * Given a pathway clone object we create clones of all media.
   * In this function, all necessary information and updated playlists
   * are added to the `mediaGroup` object.
   * Playlists are also added to the `playlists` array so the media groups
   * will be properly linked.
   *
   * @param {Object} clone The pathway clone object.
   */ createClonedMediaGroups_(clone) {
        const id = clone.ID;
        const baseID = clone['BASE-ID'];
        const main = this.main;
        [
            'AUDIO',
            'SUBTITLES',
            'CLOSED-CAPTIONS'
        ].forEach((mediaType)=>{
            // If the media type doesn't exist, or there is already a clone, skip
            // to the next media type.
            if (!main.mediaGroups[mediaType] || main.mediaGroups[mediaType][id]) return;
            for(const groupKey in main.mediaGroups[mediaType]){
                if (groupKey === baseID) // Create the group.
                main.mediaGroups[mediaType][id] = {};
                else continue;
                for(const labelKey in main.mediaGroups[mediaType][groupKey]){
                    const oldMedia = main.mediaGroups[mediaType][groupKey][labelKey];
                    main.mediaGroups[mediaType][id][labelKey] = (0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, oldMedia);
                    const newMedia = main.mediaGroups[mediaType][id][labelKey]; // update URIs on the media
                    const newUri = this.createCloneURI_(oldMedia.resolvedUri, clone);
                    newMedia.resolvedUri = newUri;
                    newMedia.uri = newUri; // Reset playlists in the new media group.
                    newMedia.playlists = []; // Create new playlists in the newly cloned media group.
                    oldMedia.playlists.forEach((p, i)=>{
                        const oldMediaPlaylist = main.playlists[p.id];
                        const group = $86defbb4e95ebb07$var$groupID(mediaType, id, labelKey);
                        const newPlaylistID = $86defbb4e95ebb07$var$createPlaylistID(id, group); // Check to see if it already exists
                        if (oldMediaPlaylist && !main.playlists[newPlaylistID]) {
                            const newMediaPlaylist = this.createClonePlaylist_(oldMediaPlaylist, newPlaylistID, clone);
                            const newPlaylistUri = newMediaPlaylist.resolvedUri;
                            main.playlists[newPlaylistID] = newMediaPlaylist;
                            main.playlists[newPlaylistUri] = newMediaPlaylist;
                        }
                        newMedia.playlists[i] = this.createClonePlaylist_(p, newPlaylistID, clone);
                    });
                }
            }
        });
    }
    /**
   * Using the original playlist to be cloned, and the pathway clone object
   * information, we create a new playlist.
   *
   * @param {Object} basePlaylist  The original playlist to be cloned from.
   * @param {string} id The desired id of the newly cloned playlist.
   * @param {Object} clone The pathway clone object.
   * @param {Object} attributes An optional object to populate the `attributes` property in the playlist.
   *
   * @return {Object} The combined cloned playlist.
   */ createClonePlaylist_(basePlaylist, id, clone, attributes) {
        const uri = this.createCloneURI_(basePlaylist.resolvedUri, clone);
        const newProps = {
            resolvedUri: uri,
            uri: uri,
            id: id
        }; // Remove all segments from previous playlist in the clone.
        if (basePlaylist.segments) newProps.segments = [];
        if (attributes) newProps.attributes = attributes;
        return $86defbb4e95ebb07$var$merge(basePlaylist, newProps);
    }
    /**
   * Generates an updated URI for a cloned pathway based on the original
   * pathway's URI and the paramaters from the pathway clone object in the
   * content steering server response.
   *
   * @param {string} baseUri URI to be updated in the cloned pathway.
   * @param {Object} clone The pathway clone object.
   *
   * @return {string} The updated URI for the cloned pathway.
   */ createCloneURI_(baseURI, clone) {
        const uri = new URL(baseURI);
        uri.hostname = clone['URI-REPLACEMENT'].HOST;
        const params = clone['URI-REPLACEMENT'].PARAMS; // Add params to the cloned URL.
        for (const key of Object.keys(params))uri.searchParams.set(key, params[key]);
        return uri.href;
    }
    /**
   * Helper function to create the attributes needed for the new clone.
   * This mainly adds the necessary media attributes.
   *
   * @param {string} id The pathway clone object ID.
   * @param {Object} oldAttributes The old attributes to compare to.
   * @return {Object} The new attributes to add to the playlist.
   */ createCloneAttributes_(id, oldAttributes) {
        const attributes = {
            ['PATHWAY-ID']: id
        };
        [
            'AUDIO',
            'SUBTITLES',
            'CLOSED-CAPTIONS'
        ].forEach((mediaType)=>{
            if (oldAttributes[mediaType]) attributes[mediaType] = id;
        });
        return attributes;
    }
    /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */ getKeyIdSet(playlist) {
        const keyIds = new Set();
        if (!playlist || !playlist.contentProtection) return keyIds;
        for(const keysystem in playlist.contentProtection)if (playlist.contentProtection[keysystem] && playlist.contentProtection[keysystem].attributes && playlist.contentProtection[keysystem].attributes.keyId) {
            const keyId = playlist.contentProtection[keysystem].attributes.keyId;
            keyIds.add(keyId.toLowerCase());
        }
        return keyIds;
    }
}
/**
 * @file xhr.js
 */ const $86defbb4e95ebb07$var$callbackWrapper = function(request, error, response, callback) {
    const reqResponse = request.responseType === 'arraybuffer' ? request.response : request.responseText;
    if (!error && reqResponse) {
        request.responseTime = Date.now();
        request.roundTripTime = request.responseTime - request.requestTime;
        request.bytesReceived = reqResponse.byteLength || reqResponse.length;
        if (!request.bandwidth) request.bandwidth = Math.floor(request.bytesReceived / request.roundTripTime * 8000);
    }
    if (response.headers) request.responseHeaders = response.headers;
     // videojs.xhr now uses a specific code on the error
    // object to signal that a request has timed out instead
    // of setting a boolean on the request object
    if (error && error.code === 'ETIMEDOUT') request.timedout = true;
     // videojs.xhr no longer considers status codes outside of 200 and 0
    // (for file uris) to be errors, but the old XHR did, so emulate that
    // behavior. Status 206 may be used in response to byterange requests.
    if (!error && !request.aborted && response.statusCode !== 200 && response.statusCode !== 206 && response.statusCode !== 0) error = new Error('XHR Failed with a response of: ' + (request && (reqResponse || request.responseText)));
    callback(error, request);
};
/**
 * Iterates over the request hooks Set and calls them in order
 *
 * @param {Set} hooks the hook Set to iterate over
 * @param {Object} options the request options to pass to the xhr wrapper
 * @return the callback hook function return value, the modified or new options Object.
 */ const $86defbb4e95ebb07$var$callAllRequestHooks = (requestSet, options)=>{
    if (!requestSet || !requestSet.size) return;
    let newOptions = options;
    requestSet.forEach((requestCallback)=>{
        newOptions = requestCallback(newOptions);
    });
    return newOptions;
};
/**
 * Iterates over the response hooks Set and calls them in order.
 *
 * @param {Set} hooks the hook Set to iterate over
 * @param {Object} request the xhr request object
 * @param {Object} error the xhr error object
 * @param {Object} response the xhr response object
 */ const $86defbb4e95ebb07$var$callAllResponseHooks = (responseSet, request, error, response)=>{
    if (!responseSet || !responseSet.size) return;
    responseSet.forEach((responseCallback)=>{
        responseCallback(request, error, response);
    });
};
const $86defbb4e95ebb07$var$xhrFactory = function() {
    const xhr = function XhrFunction(options, callback) {
        // Add a default timeout
        options = $86defbb4e95ebb07$var$merge({
            timeout: 45e3
        }, options); // Allow an optional user-specified function to modify the option
        // object before we construct the xhr request
        // TODO: Remove beforeRequest in the next major release.
        const beforeRequest = XhrFunction.beforeRequest || $86defbb4e95ebb07$export$2e2bcd8739ae039.Vhs.xhr.beforeRequest; // onRequest and onResponse hooks as a Set, at either the player or global level.
        // TODO: new Set added here for beforeRequest alias. Remove this when beforeRequest is removed.
        const _requestCallbackSet = XhrFunction._requestCallbackSet || $86defbb4e95ebb07$export$2e2bcd8739ae039.Vhs.xhr._requestCallbackSet || new Set();
        const _responseCallbackSet = XhrFunction._responseCallbackSet || $86defbb4e95ebb07$export$2e2bcd8739ae039.Vhs.xhr._responseCallbackSet;
        if (beforeRequest && typeof beforeRequest === 'function') {
            $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn('beforeRequest is deprecated, use onRequest instead.');
            _requestCallbackSet.add(beforeRequest);
        } // Use the standard videojs.xhr() method unless `videojs.Vhs.xhr` has been overriden
        // TODO: switch back to videojs.Vhs.xhr.name === 'XhrFunction' when we drop IE11
        const xhrMethod = $86defbb4e95ebb07$export$2e2bcd8739ae039.Vhs.xhr.original === true ? $86defbb4e95ebb07$export$2e2bcd8739ae039.xhr : $86defbb4e95ebb07$export$2e2bcd8739ae039.Vhs.xhr; // call all registered onRequest hooks, assign new options.
        const beforeRequestOptions = $86defbb4e95ebb07$var$callAllRequestHooks(_requestCallbackSet, options); // Remove the beforeRequest function from the hooks set so stale beforeRequest functions are not called.
        _requestCallbackSet.delete(beforeRequest); // xhrMethod will call XMLHttpRequest.open and XMLHttpRequest.send
        const request = xhrMethod(beforeRequestOptions || options, function(error, response) {
            // call all registered onResponse hooks
            $86defbb4e95ebb07$var$callAllResponseHooks(_responseCallbackSet, request, error, response);
            return $86defbb4e95ebb07$var$callbackWrapper(request, error, response, callback);
        });
        const originalAbort = request.abort;
        request.abort = function() {
            request.aborted = true;
            return originalAbort.apply(request, arguments);
        };
        request.uri = options.uri;
        request.requestType = options.requestType;
        request.requestTime = Date.now();
        return request;
    };
    xhr.original = true;
    return xhr;
};
/**
 * Turns segment byterange into a string suitable for use in
 * HTTP Range requests
 *
 * @param {Object} byterange - an object with two values defining the start and end
 *                             of a byte-range
 */ const $86defbb4e95ebb07$var$byterangeStr = function(byterange) {
    // `byterangeEnd` is one less than `offset + length` because the HTTP range
    // header uses inclusive ranges
    let byterangeEnd;
    const byterangeStart = byterange.offset;
    if (typeof byterange.offset === 'bigint' || typeof byterange.length === 'bigint') byterangeEnd = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(byterange.offset) + (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(byterange.length) - (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(1);
    else byterangeEnd = byterange.offset + byterange.length - 1;
    return 'bytes=' + byterangeStart + '-' + byterangeEnd;
};
/**
 * Defines headers for use in the xhr request for a particular segment.
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 */ const $86defbb4e95ebb07$var$segmentXhrHeaders = function(segment) {
    const headers = {};
    if (segment.byterange) headers.Range = $86defbb4e95ebb07$var$byterangeStr(segment.byterange);
    return headers;
};
/**
 * @file bin-utils.js
 */ /**
 * convert a TimeRange to text
 *
 * @param {TimeRange} range the timerange to use for conversion
 * @param {number} i the iterator on the range to convert
 * @return {string} the range in string format
 */ const $86defbb4e95ebb07$var$textRange = function(range, i) {
    return range.start(i) + '-' + range.end(i);
};
/**
 * format a number as hex string
 *
 * @param {number} e The number
 * @param {number} i the iterator
 * @return {string} the hex formatted number as a string
 */ const $86defbb4e95ebb07$var$formatHexString = function(e, i) {
    const value = e.toString(16);
    return '00'.substring(0, 2 - value.length) + value + (i % 2 ? ' ' : '');
};
const $86defbb4e95ebb07$var$formatAsciiString = function(e) {
    if (e >= 0x20 && e < 0x7e) return String.fromCharCode(e);
    return '.';
};
/**
 * Creates an object for sending to a web worker modifying properties that are TypedArrays
 * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
 *
 * @param {Object} message
 *        Object of properties and values to send to the web worker
 * @return {Object}
 *         Modified message with TypedArray values expanded
 * @function createTransferableMessage
 */ const $86defbb4e95ebb07$var$createTransferableMessage = function(message) {
    const transferable = {};
    Object.keys(message).forEach((key)=>{
        const value = message[key];
        if ((0, $0cb67f3f52413d92$export$ef047080f6507ccc)(value)) transferable[key] = {
            bytes: value.buffer,
            byteOffset: value.byteOffset,
            byteLength: value.byteLength
        };
        else transferable[key] = value;
    });
    return transferable;
};
/**
 * Returns a unique string identifier for a media initialization
 * segment.
 *
 * @param {Object} initSegment
 *        the init segment object.
 *
 * @return {string} the generated init segment id
 */ const $86defbb4e95ebb07$var$initSegmentId = function(initSegment) {
    const byterange = initSegment.byterange || {
        length: Infinity,
        offset: 0
    };
    return [
        byterange.length,
        byterange.offset,
        initSegment.resolvedUri
    ].join(',');
};
/**
 * Returns a unique string identifier for a media segment key.
 *
 * @param {Object} key the encryption key
 * @return {string} the unique id for the media segment key.
 */ const $86defbb4e95ebb07$var$segmentKeyId = function(key) {
    return key.resolvedUri;
};
/**
 * utils to help dump binary data to the console
 *
 * @param {Array|TypedArray} data
 *        data to dump to a string
 *
 * @return {string} the data as a hex string.
 */ const $86defbb4e95ebb07$var$hexDump = (data)=>{
    const bytes = Array.prototype.slice.call(data);
    const step = 16;
    let result = '';
    let hex;
    let ascii;
    for(let j = 0; j < bytes.length / step; j++){
        hex = bytes.slice(j * step, j * step + step).map($86defbb4e95ebb07$var$formatHexString).join('');
        ascii = bytes.slice(j * step, j * step + step).map($86defbb4e95ebb07$var$formatAsciiString).join('');
        result += hex + ' ' + ascii + '\n';
    }
    return result;
};
const $86defbb4e95ebb07$var$tagDump = ({ bytes: bytes })=>$86defbb4e95ebb07$var$hexDump(bytes);
const $86defbb4e95ebb07$var$textRanges = (ranges)=>{
    let result = '';
    let i;
    for(i = 0; i < ranges.length; i++)result += $86defbb4e95ebb07$var$textRange(ranges, i) + ' ';
    return result;
};
var $86defbb4e95ebb07$var$utils = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createTransferableMessage: $86defbb4e95ebb07$var$createTransferableMessage,
    initSegmentId: $86defbb4e95ebb07$var$initSegmentId,
    segmentKeyId: $86defbb4e95ebb07$var$segmentKeyId,
    hexDump: $86defbb4e95ebb07$var$hexDump,
    tagDump: $86defbb4e95ebb07$var$tagDump,
    textRanges: $86defbb4e95ebb07$var$textRanges
});
// TODO handle fmp4 case where the timing info is accurate and doesn't involve transmux
// 25% was arbitrarily chosen, and may need to be refined over time.
const $86defbb4e95ebb07$var$SEGMENT_END_FUDGE_PERCENT = 0.25;
/**
 * Converts a player time (any time that can be gotten/set from player.currentTime(),
 * e.g., any time within player.seekable().start(0) to player.seekable().end(0)) to a
 * program time (any time referencing the real world (e.g., EXT-X-PROGRAM-DATE-TIME)).
 *
 * The containing segment is required as the EXT-X-PROGRAM-DATE-TIME serves as an "anchor
 * point" (a point where we have a mapping from program time to player time, with player
 * time being the post transmux start of the segment).
 *
 * For more details, see [this doc](../../docs/program-time-from-player-time.md).
 *
 * @param {number} playerTime the player time
 * @param {Object} segment the segment which contains the player time
 * @return {Date} program time
 */ const $86defbb4e95ebb07$var$playerTimeToProgramTime = (playerTime, segment)=>{
    if (!segment.dateTimeObject) // Can't convert without an "anchor point" for the program time (i.e., a time that can
    // be used to map the start of a segment with a real world time).
    return null;
    const transmuxerPrependedSeconds = segment.videoTimingInfo.transmuxerPrependedSeconds;
    const transmuxedStart = segment.videoTimingInfo.transmuxedPresentationStart; // get the start of the content from before old content is prepended
    const startOfSegment = transmuxedStart + transmuxerPrependedSeconds;
    const offsetFromSegmentStart = playerTime - startOfSegment;
    return new Date(segment.dateTimeObject.getTime() + offsetFromSegmentStart * 1000);
};
const $86defbb4e95ebb07$var$originalSegmentVideoDuration = (videoTimingInfo)=>{
    return videoTimingInfo.transmuxedPresentationEnd - videoTimingInfo.transmuxedPresentationStart - videoTimingInfo.transmuxerPrependedSeconds;
};
/**
 * Finds a segment that contains the time requested given as an ISO-8601 string. The
 * returned segment might be an estimate or an accurate match.
 *
 * @param {string} programTime The ISO-8601 programTime to find a match for
 * @param {Object} playlist A playlist object to search within
 */ const $86defbb4e95ebb07$var$findSegmentForProgramTime = (programTime, playlist)=>{
    // Assumptions:
    //  - verifyProgramDateTimeTags has already been run
    //  - live streams have been started
    let dateTimeObject;
    try {
        dateTimeObject = new Date(programTime);
    } catch (e) {
        return null;
    }
    if (!playlist || !playlist.segments || playlist.segments.length === 0) return null;
    let segment = playlist.segments[0];
    if (dateTimeObject < new Date(segment.dateTimeObject)) // Requested time is before stream start.
    return null;
    for(let i = 0; i < playlist.segments.length - 1; i++){
        segment = playlist.segments[i];
        const nextSegmentStart = new Date(playlist.segments[i + 1].dateTimeObject);
        if (dateTimeObject < nextSegmentStart) break;
    }
    const lastSegment = playlist.segments[playlist.segments.length - 1];
    const lastSegmentStart = lastSegment.dateTimeObject;
    const lastSegmentDuration = lastSegment.videoTimingInfo ? $86defbb4e95ebb07$var$originalSegmentVideoDuration(lastSegment.videoTimingInfo) : lastSegment.duration + lastSegment.duration * $86defbb4e95ebb07$var$SEGMENT_END_FUDGE_PERCENT;
    const lastSegmentEnd = new Date(lastSegmentStart.getTime() + lastSegmentDuration * 1000);
    if (dateTimeObject > lastSegmentEnd) // Beyond the end of the stream, or our best guess of the end of the stream.
    return null;
    if (dateTimeObject > new Date(lastSegmentStart)) segment = lastSegment;
    return {
        segment: segment,
        estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : $86defbb4e95ebb07$var$Playlist.duration(playlist, playlist.mediaSequence + playlist.segments.indexOf(segment)),
        // Although, given that all segments have accurate date time objects, the segment
        // selected should be accurate, unless the video has been transmuxed at some point
        // (determined by the presence of the videoTimingInfo object), the segment's "player
        // time" (the start time in the player) can't be considered accurate.
        type: segment.videoTimingInfo ? 'accurate' : 'estimate'
    };
};
/**
 * Finds a segment that contains the given player time(in seconds).
 *
 * @param {number} time The player time to find a match for
 * @param {Object} playlist A playlist object to search within
 */ const $86defbb4e95ebb07$var$findSegmentForPlayerTime = (time, playlist)=>{
    // Assumptions:
    // - there will always be a segment.duration
    // - we can start from zero
    // - segments are in time order
    if (!playlist || !playlist.segments || playlist.segments.length === 0) return null;
    let segmentEnd = 0;
    let segment;
    for(let i = 0; i < playlist.segments.length; i++){
        segment = playlist.segments[i]; // videoTimingInfo is set after the segment is downloaded and transmuxed, and
        // should contain the most accurate values we have for the segment's player times.
        //
        // Use the accurate transmuxedPresentationEnd value if it is available, otherwise fall
        // back to an estimate based on the manifest derived (inaccurate) segment.duration, to
        // calculate an end value.
        segmentEnd = segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationEnd : segmentEnd + segment.duration;
        if (time <= segmentEnd) break;
    }
    const lastSegment = playlist.segments[playlist.segments.length - 1];
    if (lastSegment.videoTimingInfo && lastSegment.videoTimingInfo.transmuxedPresentationEnd < time) // The time requested is beyond the stream end.
    return null;
    if (time > segmentEnd) {
        // The time is within or beyond the last segment.
        //
        // Check to see if the time is beyond a reasonable guess of the end of the stream.
        if (time > segmentEnd + lastSegment.duration * $86defbb4e95ebb07$var$SEGMENT_END_FUDGE_PERCENT) // Technically, because the duration value is only an estimate, the time may still
        // exist in the last segment, however, there isn't enough information to make even
        // a reasonable estimate.
        return null;
        segment = lastSegment;
    }
    return {
        segment: segment,
        estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : segmentEnd - segment.duration,
        // Because videoTimingInfo is only set after transmux, it is the only way to get
        // accurate timing values.
        type: segment.videoTimingInfo ? 'accurate' : 'estimate'
    };
};
/**
 * Gives the offset of the comparisonTimestamp from the programTime timestamp in seconds.
 * If the offset returned is positive, the programTime occurs after the
 * comparisonTimestamp.
 * If the offset is negative, the programTime occurs before the comparisonTimestamp.
 *
 * @param {string} comparisonTimeStamp An ISO-8601 timestamp to compare against
 * @param {string} programTime The programTime as an ISO-8601 string
 * @return {number} offset
 */ const $86defbb4e95ebb07$var$getOffsetFromTimestamp = (comparisonTimeStamp, programTime)=>{
    let segmentDateTime;
    let programDateTime;
    try {
        segmentDateTime = new Date(comparisonTimeStamp);
        programDateTime = new Date(programTime);
    } catch (e) {}
    const segmentTimeEpoch = segmentDateTime.getTime();
    const programTimeEpoch = programDateTime.getTime();
    return (programTimeEpoch - segmentTimeEpoch) / 1000;
};
/**
 * Checks that all segments in this playlist have programDateTime tags.
 *
 * @param {Object} playlist A playlist object
 */ const $86defbb4e95ebb07$var$verifyProgramDateTimeTags = (playlist)=>{
    if (!playlist.segments || playlist.segments.length === 0) return false;
    for(let i = 0; i < playlist.segments.length; i++){
        const segment = playlist.segments[i];
        if (!segment.dateTimeObject) return false;
    }
    return true;
};
/**
 * Returns the programTime of the media given a playlist and a playerTime.
 * The playlist must have programDateTime tags for a programDateTime tag to be returned.
 * If the segments containing the time requested have not been buffered yet, an estimate
 * may be returned to the callback.
 *
 * @param {Object} args
 * @param {Object} args.playlist A playlist object to search within
 * @param {number} time A playerTime in seconds
 * @param {Function} callback(err, programTime)
 * @return {string} err.message A detailed error message
 * @return {Object} programTime
 * @return {number} programTime.mediaSeconds The streamTime in seconds
 * @return {string} programTime.programDateTime The programTime as an ISO-8601 String
 */ const $86defbb4e95ebb07$var$getProgramTime = ({ playlist: playlist, time: time, callback: callback })=>{
    if (!callback) throw new Error('getProgramTime: callback must be provided');
    if (!playlist || time === undefined) return callback({
        message: 'getProgramTime: playlist and time must be provided'
    });
    const matchedSegment = $86defbb4e95ebb07$var$findSegmentForPlayerTime(time, playlist);
    if (!matchedSegment) return callback({
        message: 'valid programTime was not found'
    });
    if (matchedSegment.type === 'estimate') return callback({
        message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
        seekTime: matchedSegment.estimatedStart
    });
    const programTimeObject = {
        mediaSeconds: time
    };
    const programTime = $86defbb4e95ebb07$var$playerTimeToProgramTime(time, matchedSegment.segment);
    if (programTime) programTimeObject.programDateTime = programTime.toISOString();
    return callback(null, programTimeObject);
};
/**
 * Seeks in the player to a time that matches the given programTime ISO-8601 string.
 *
 * @param {Object} args
 * @param {string} args.programTime A programTime to seek to as an ISO-8601 String
 * @param {Object} args.playlist A playlist to look within
 * @param {number} args.retryCount The number of times to try for an accurate seek. Default is 2.
 * @param {Function} args.seekTo A method to perform a seek
 * @param {boolean} args.pauseAfterSeek Whether to end in a paused state after seeking. Default is true.
 * @param {Object} args.tech The tech to seek on
 * @param {Function} args.callback(err, newTime) A callback to return the new time to
 * @return {string} err.message A detailed error message
 * @return {number} newTime The exact time that was seeked to in seconds
 */ const $86defbb4e95ebb07$var$seekToProgramTime = ({ programTime: programTime, playlist: playlist, retryCount: retryCount = 2, seekTo: seekTo, pauseAfterSeek: pauseAfterSeek = true, tech: tech, callback: callback })=>{
    if (!callback) throw new Error('seekToProgramTime: callback must be provided');
    if (typeof programTime === 'undefined' || !playlist || !seekTo) return callback({
        message: 'seekToProgramTime: programTime, seekTo and playlist must be provided'
    });
    if (!playlist.endList && !tech.hasStarted_) return callback({
        message: 'player must be playing a live stream to start buffering'
    });
    if (!$86defbb4e95ebb07$var$verifyProgramDateTimeTags(playlist)) return callback({
        message: 'programDateTime tags must be provided in the manifest ' + playlist.resolvedUri
    });
    const matchedSegment = $86defbb4e95ebb07$var$findSegmentForProgramTime(programTime, playlist); // no match
    if (!matchedSegment) return callback({
        message: `${programTime} was not found in the stream`
    });
    const segment = matchedSegment.segment;
    const mediaOffset = $86defbb4e95ebb07$var$getOffsetFromTimestamp(segment.dateTimeObject, programTime);
    if (matchedSegment.type === 'estimate') {
        // we've run out of retries
        if (retryCount === 0) return callback({
            message: `${programTime} is not buffered yet. Try again`
        });
        seekTo(matchedSegment.estimatedStart + mediaOffset);
        tech.one('seeked', ()=>{
            $86defbb4e95ebb07$var$seekToProgramTime({
                programTime: programTime,
                playlist: playlist,
                retryCount: retryCount - 1,
                seekTo: seekTo,
                pauseAfterSeek: pauseAfterSeek,
                tech: tech,
                callback: callback
            });
        });
        return;
    } // Since the segment.start value is determined from the buffered end or ending time
    // of the prior segment, the seekToTime doesn't need to account for any transmuxer
    // modifications.
    const seekToTime = segment.start + mediaOffset;
    const seekedCallback = ()=>{
        return callback(null, tech.currentTime());
    }; // listen for seeked event
    tech.one('seeked', seekedCallback); // pause before seeking as video.js will restore this state
    if (pauseAfterSeek) tech.pause();
    seekTo(seekToTime);
};
// which will only happen if the request is complete.
const $86defbb4e95ebb07$var$callbackOnCompleted = (request, cb)=>{
    if (request.readyState === 4) return cb();
    return;
};
const $86defbb4e95ebb07$var$containerRequest = (uri, xhr, cb, requestType)=>{
    let bytes = [];
    let id3Offset;
    let finished = false;
    const endRequestAndCallback = function(err, req, type, _bytes) {
        req.abort();
        finished = true;
        return cb(err, req, type, _bytes);
    };
    const progressListener = function(error, request) {
        if (finished) return;
        if (error) {
            error.metadata = $86defbb4e95ebb07$var$getStreamingNetworkErrorMetadata({
                requestType: requestType,
                request: request,
                error: error
            });
            return endRequestAndCallback(error, request, '', bytes);
        } // grap the new part of content that was just downloaded
        const newPart = request.responseText.substring(bytes && bytes.byteLength || 0, request.responseText.length); // add that onto bytes
        bytes = (0, $0cb67f3f52413d92$export$229a3d5e59c9dd55)(bytes, (0, $0cb67f3f52413d92$export$c8dd6bc66a63753c)(newPart, true));
        id3Offset = id3Offset || (0, $beb668c0ff46ee9c$export$56b6cacf09ec1126)(bytes); // we need at least 10 bytes to determine a type
        // or we need at least two bytes after an id3Offset
        if (bytes.length < 10 || id3Offset && bytes.length < id3Offset + 2) return $86defbb4e95ebb07$var$callbackOnCompleted(request, ()=>endRequestAndCallback(error, request, '', bytes));
        const type = (0, $7483119daf318a41$export$894319e75ed840c3)(bytes); // if this looks like a ts segment but we don't have enough data
        // to see the second sync byte, wait until we have enough data
        // before declaring it ts
        if (type === 'ts' && bytes.length < 188) return $86defbb4e95ebb07$var$callbackOnCompleted(request, ()=>endRequestAndCallback(error, request, '', bytes));
         // this may be an unsynced ts segment
        // wait for 376 bytes before detecting no container
        if (!type && bytes.length < 376) return $86defbb4e95ebb07$var$callbackOnCompleted(request, ()=>endRequestAndCallback(error, request, '', bytes));
        return endRequestAndCallback(null, request, type, bytes);
    };
    const options = {
        uri: uri,
        beforeSend (request) {
            // this forces the browser to pass the bytes to us unprocessed
            request.overrideMimeType('text/plain; charset=x-user-defined');
            request.addEventListener('progress', function({ total: total, loaded: loaded }) {
                return $86defbb4e95ebb07$var$callbackWrapper(request, null, {
                    statusCode: request.status
                }, progressListener);
            });
        }
    };
    const request = xhr(options, function(error, response) {
        return $86defbb4e95ebb07$var$callbackWrapper(request, error, response, progressListener);
    });
    return request;
};
const { EventTarget: $86defbb4e95ebb07$var$EventTarget } = $86defbb4e95ebb07$export$2e2bcd8739ae039;
const $86defbb4e95ebb07$var$dashPlaylistUnchanged = function(a, b) {
    if (!$86defbb4e95ebb07$var$isPlaylistUnchanged(a, b)) return false;
     // for dash the above check will often return true in scenarios where
    // the playlist actually has changed because mediaSequence isn't a
    // dash thing, and we often set it to 1. So if the playlists have the same amount
    // of segments we return true.
    // So for dash we need to make sure that the underlying segments are different.
    // if sidx changed then the playlists are different.
    if (a.sidx && b.sidx && (a.sidx.offset !== b.sidx.offset || a.sidx.length !== b.sidx.length)) return false;
    else if (!a.sidx && b.sidx || a.sidx && !b.sidx) return false;
     // one or the other does not have segments
    // there was a change.
    if (a.segments && !b.segments || !a.segments && b.segments) return false;
     // neither has segments nothing changed
    if (!a.segments && !b.segments) return true;
     // check segments themselves
    for(let i = 0; i < a.segments.length; i++){
        const aSegment = a.segments[i];
        const bSegment = b.segments[i]; // if uris are different between segments there was a change
        if (aSegment.uri !== bSegment.uri) return false;
         // neither segment has a byterange, there will be no byterange change.
        if (!aSegment.byterange && !bSegment.byterange) continue;
        const aByterange = aSegment.byterange;
        const bByterange = bSegment.byterange; // if byterange only exists on one of the segments, there was a change.
        if (aByterange && !bByterange || !aByterange && bByterange) return false;
         // if both segments have byterange with different offsets, there was a change.
        if (aByterange.offset !== bByterange.offset || aByterange.length !== bByterange.length) return false;
    } // if everything was the same with segments, this is the same playlist.
    return true;
};
/**
 * Use the representation IDs from the mpd object to create groupIDs, the NAME is set to mandatory representation
 * ID in the parser. This allows for continuous playout across periods with the same representation IDs
 * (continuous periods as defined in DASH-IF 3.2.12). This is assumed in the mpd-parser as well. If we want to support
 * periods without continuous playback this function may need modification as well as the parser.
 */ const $86defbb4e95ebb07$var$dashGroupId = (type, group, label, playlist)=>{
    // If the manifest somehow does not have an ID (non-dash compliant), use the label.
    const playlistId = playlist.attributes.NAME || label;
    return `placeholder-uri-${type}-${group}-${playlistId}`;
};
/**
 * Parses the main XML string and updates playlist URI references.
 *
 * @param {Object} config
 *        Object of arguments
 * @param {string} config.mainXml
 *        The mpd XML
 * @param {string} config.srcUrl
 *        The mpd URL
 * @param {Date} config.clientOffset
 *         A time difference between server and client
 * @param {Object} config.sidxMapping
 *        SIDX mappings for moof/mdat URIs and byte ranges
 * @return {Object}
 *         The parsed mpd manifest object
 */ const $86defbb4e95ebb07$var$parseMainXml = ({ mainXml: mainXml, srcUrl: srcUrl, clientOffset: clientOffset, sidxMapping: sidxMapping, previousManifest: previousManifest })=>{
    const manifest = (0, $fb56f0cd7d6a30bd$export$98e6a39c04603d36)(mainXml, {
        manifestUri: srcUrl,
        clientOffset: clientOffset,
        sidxMapping: sidxMapping,
        previousManifest: previousManifest
    });
    $86defbb4e95ebb07$var$addPropertiesToMain(manifest, srcUrl, $86defbb4e95ebb07$var$dashGroupId);
    return manifest;
};
/**
 * Removes any mediaGroup labels that no longer exist in the newMain
 *
 * @param {Object} update
 *         The previous mpd object being updated
 * @param {Object} newMain
 *         The new mpd object
 */ const $86defbb4e95ebb07$var$removeOldMediaGroupLabels = (update, newMain)=>{
    $86defbb4e95ebb07$var$forEachMediaGroup(update, (properties, type, group, label)=>{
        if (!newMain.mediaGroups[type][group] || !(label in newMain.mediaGroups[type][group])) delete update.mediaGroups[type][group][label];
    });
};
/**
 * Returns a new main manifest that is the result of merging an updated main manifest
 * into the original version.
 *
 * @param {Object} oldMain
 *        The old parsed mpd object
 * @param {Object} newMain
 *        The updated parsed mpd object
 * @return {Object}
 *         A new object representing the original main manifest with the updated media
 *         playlists merged in
 */ const $86defbb4e95ebb07$var$updateMain = (oldMain, newMain, sidxMapping)=>{
    let noChanges = true;
    let update = $86defbb4e95ebb07$var$merge(oldMain, {
        // These are top level properties that can be updated
        duration: newMain.duration,
        minimumUpdatePeriod: newMain.minimumUpdatePeriod,
        timelineStarts: newMain.timelineStarts
    }); // First update the playlists in playlist list
    for(let i = 0; i < newMain.playlists.length; i++){
        const playlist = newMain.playlists[i];
        if (playlist.sidx) {
            const sidxKey = (0, $fb56f0cd7d6a30bd$export$2d92360466eb0b01)(playlist.sidx); // add sidx segments to the playlist if we have all the sidx info already
            if (sidxMapping && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx) (0, $fb56f0cd7d6a30bd$export$2243d5aa7d4f4800)(playlist, sidxMapping[sidxKey].sidx, playlist.sidx.resolvedUri);
        }
        const playlistUpdate = $86defbb4e95ebb07$var$updateMain$1(update, playlist, $86defbb4e95ebb07$var$dashPlaylistUnchanged);
        if (playlistUpdate) {
            update = playlistUpdate;
            noChanges = false;
        }
    } // Then update media group playlists
    $86defbb4e95ebb07$var$forEachMediaGroup(newMain, (properties, type, group, label)=>{
        if (properties.playlists && properties.playlists.length) {
            const id = properties.playlists[0].id;
            const playlistUpdate = $86defbb4e95ebb07$var$updateMain$1(update, properties.playlists[0], $86defbb4e95ebb07$var$dashPlaylistUnchanged);
            if (playlistUpdate) {
                update = playlistUpdate; // add new mediaGroup label if it doesn't exist and assign the new mediaGroup.
                if (!(label in update.mediaGroups[type][group])) update.mediaGroups[type][group][label] = properties;
                 // update the playlist reference within media groups
                update.mediaGroups[type][group][label].playlists[0] = update.playlists[id];
                noChanges = false;
            }
        }
    }); // remove mediaGroup labels and references that no longer exist in the newMain
    $86defbb4e95ebb07$var$removeOldMediaGroupLabels(update, newMain);
    if (newMain.minimumUpdatePeriod !== oldMain.minimumUpdatePeriod) noChanges = false;
    if (noChanges) return null;
    return update;
}; // SIDX should be equivalent if the URI and byteranges of the SIDX match.
// If the SIDXs have maps, the two maps should match,
// both `a` and `b` missing SIDXs is considered matching.
// If `a` or `b` but not both have a map, they aren't matching.
const $86defbb4e95ebb07$var$equivalentSidx = (a, b)=>{
    const neitherMap = Boolean(!a.map && !b.map);
    const equivalentMap = neitherMap || Boolean(a.map && b.map && a.map.byterange.offset === b.map.byterange.offset && a.map.byterange.length === b.map.byterange.length);
    return equivalentMap && a.uri === b.uri && a.byterange.offset === b.byterange.offset && a.byterange.length === b.byterange.length;
}; // exported for testing
const $86defbb4e95ebb07$var$compareSidxEntry = (playlists, oldSidxMapping)=>{
    const newSidxMapping = {};
    for(const id in playlists){
        const playlist = playlists[id];
        const currentSidxInfo = playlist.sidx;
        if (currentSidxInfo) {
            const key = (0, $fb56f0cd7d6a30bd$export$2d92360466eb0b01)(currentSidxInfo);
            if (!oldSidxMapping[key]) break;
            const savedSidxInfo = oldSidxMapping[key].sidxInfo;
            if ($86defbb4e95ebb07$var$equivalentSidx(savedSidxInfo, currentSidxInfo)) newSidxMapping[key] = oldSidxMapping[key];
        }
    }
    return newSidxMapping;
};
/**
 *  A function that filters out changed items as they need to be requested separately.
 *
 *  The method is exported for testing
 *
 *  @param {Object} main the parsed mpd XML returned via mpd-parser
 *  @param {Object} oldSidxMapping the SIDX to compare against
 */ const $86defbb4e95ebb07$var$filterChangedSidxMappings = (main, oldSidxMapping)=>{
    const videoSidx = $86defbb4e95ebb07$var$compareSidxEntry(main.playlists, oldSidxMapping);
    let mediaGroupSidx = videoSidx;
    $86defbb4e95ebb07$var$forEachMediaGroup(main, (properties, mediaType, groupKey, labelKey)=>{
        if (properties.playlists && properties.playlists.length) {
            const playlists = properties.playlists;
            mediaGroupSidx = $86defbb4e95ebb07$var$merge(mediaGroupSidx, $86defbb4e95ebb07$var$compareSidxEntry(playlists, oldSidxMapping));
        }
    });
    return mediaGroupSidx;
};
class $86defbb4e95ebb07$var$DashPlaylistLoader extends $86defbb4e95ebb07$var$EventTarget {
    // DashPlaylistLoader must accept either a src url or a playlist because subsequent
    // playlist loader setups from media groups will expect to be able to pass a playlist
    // (since there aren't external URLs to media playlists with DASH)
    constructor(srcUrlOrPlaylist, vhs, options = {}, mainPlaylistLoader){
        super();
        this.isPaused_ = true;
        this.mainPlaylistLoader_ = mainPlaylistLoader || this;
        if (!mainPlaylistLoader) this.isMain_ = true;
        const { withCredentials: withCredentials = false } = options;
        this.vhs_ = vhs;
        this.withCredentials = withCredentials;
        this.addMetadataToTextTrack = options.addMetadataToTextTrack;
        if (!srcUrlOrPlaylist) throw new Error('A non-empty playlist URL or object is required');
         // event naming?
        this.on('minimumUpdatePeriod', ()=>{
            this.refreshXml_();
        }); // live playlist staleness timeout
        this.on('mediaupdatetimeout', ()=>{
            this.refreshMedia_(this.media().id);
        });
        this.state = 'HAVE_NOTHING';
        this.loadedPlaylists_ = {};
        this.logger_ = $86defbb4e95ebb07$var$logger('DashPlaylistLoader'); // initialize the loader state
        // The mainPlaylistLoader will be created with a string
        if (this.isMain_) {
            this.mainPlaylistLoader_.srcUrl = srcUrlOrPlaylist; // TODO: reset sidxMapping between period changes
            // once multi-period is refactored
            this.mainPlaylistLoader_.sidxMapping_ = {};
        } else this.childPlaylist_ = srcUrlOrPlaylist;
    }
    get isPaused() {
        return this.isPaused_;
    }
    requestErrored_(err, request, startingState) {
        // disposed
        if (!this.request) return true;
         // pending request is cleared
        this.request = null;
        if (err) {
            // use the provided error object or create one
            // based on the request/response
            this.error = typeof err === 'object' && !(err instanceof Error) ? err : {
                status: request.status,
                message: 'DASH request error at URL: ' + request.uri,
                response: request.response,
                // MEDIA_ERR_NETWORK
                code: 2,
                metadata: err.metadata
            };
            if (startingState) this.state = startingState;
            this.trigger('error');
            return true;
        }
    }
    /**
   * Verify that the container of the sidx segment can be parsed
   * and if it can, get and parse that segment.
   */ addSidxSegments_(playlist, startingState, cb) {
        const sidxKey = playlist.sidx && (0, $fb56f0cd7d6a30bd$export$2d92360466eb0b01)(playlist.sidx); // playlist lacks sidx or sidx segments were added to this playlist already.
        if (!playlist.sidx || !sidxKey || this.mainPlaylistLoader_.sidxMapping_[sidxKey]) {
            // keep this function async
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mediaRequest_);
            this.mediaRequest_ = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>cb(false), 0);
            return;
        } // resolve the segment URL relative to the playlist
        const uri = $86defbb4e95ebb07$var$resolveManifestRedirect(playlist.sidx.resolvedUri);
        const fin = (err, request)=>{
            if (this.requestErrored_(err, request, startingState)) return;
            const sidxMapping = this.mainPlaylistLoader_.sidxMapping_;
            const { requestType: requestType } = request;
            let sidx;
            try {
                sidx = (0, (/*@__PURE__*/$parcel$interopDefault($5cbfc743861df2b8$exports)))((0, $0cb67f3f52413d92$export$63c3de442720649)(request.response).subarray(8));
            } catch (e) {
                e.metadata = $86defbb4e95ebb07$var$getStreamingNetworkErrorMetadata({
                    requestType: requestType,
                    request: request,
                    parseFailure: true
                }); // sidx parsing failed.
                this.requestErrored_(e, request, startingState);
                return;
            }
            sidxMapping[sidxKey] = {
                sidxInfo: playlist.sidx,
                sidx: sidx
            };
            (0, $fb56f0cd7d6a30bd$export$2243d5aa7d4f4800)(playlist, sidx, playlist.sidx.resolvedUri);
            return cb(true);
        };
        const REQUEST_TYPE = 'dash-sidx';
        this.request = $86defbb4e95ebb07$var$containerRequest(uri, this.vhs_.xhr, (err, request, container, bytes)=>{
            if (err) return fin(err, request);
            if (!container || container !== 'mp4') {
                const sidxContainer = container || 'unknown';
                return fin({
                    status: request.status,
                    message: `Unsupported ${sidxContainer} container type for sidx segment at URL: ${uri}`,
                    // response is just bytes in this case
                    // but we really don't want to return that.
                    response: '',
                    playlist: playlist,
                    internal: true,
                    playlistExclusionDuration: Infinity,
                    // MEDIA_ERR_NETWORK
                    code: 2
                }, request);
            } // if we already downloaded the sidx bytes in the container request, use them
            const { offset: offset, length: length } = playlist.sidx.byterange;
            if (bytes.length >= length + offset) return fin(err, {
                response: bytes.subarray(offset, offset + length),
                status: request.status,
                uri: request.uri
            });
             // otherwise request sidx bytes
            this.request = this.vhs_.xhr({
                uri: uri,
                responseType: 'arraybuffer',
                requestType: 'dash-sidx',
                headers: $86defbb4e95ebb07$var$segmentXhrHeaders({
                    byterange: playlist.sidx.byterange
                })
            }, fin);
        }, REQUEST_TYPE);
    }
    dispose() {
        this.isPaused_ = true;
        this.trigger('dispose');
        this.stopRequest();
        this.loadedPlaylists_ = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.minimumUpdatePeriodTimeout_);
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mediaRequest_);
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mediaUpdateTimeout);
        this.mediaUpdateTimeout = null;
        this.mediaRequest_ = null;
        this.minimumUpdatePeriodTimeout_ = null;
        if (this.mainPlaylistLoader_.createMupOnMedia_) {
            this.off('loadedmetadata', this.mainPlaylistLoader_.createMupOnMedia_);
            this.mainPlaylistLoader_.createMupOnMedia_ = null;
        }
        this.off();
    }
    hasPendingRequest() {
        return this.request || this.mediaRequest_;
    }
    stopRequest() {
        if (this.request) {
            const oldRequest = this.request;
            this.request = null;
            oldRequest.onreadystatechange = null;
            oldRequest.abort();
        }
    }
    media(playlist) {
        // getter
        if (!playlist) return this.media_;
         // setter
        if (this.state === 'HAVE_NOTHING') throw new Error('Cannot switch media playlist from ' + this.state);
        const startingState = this.state; // find the playlist object if the target playlist has been specified by URI
        if (typeof playlist === 'string') {
            if (!this.mainPlaylistLoader_.main.playlists[playlist]) throw new Error('Unknown playlist URI: ' + playlist);
            playlist = this.mainPlaylistLoader_.main.playlists[playlist];
        }
        const mediaChange = !this.media_ || playlist.id !== this.media_.id; // switch to previously loaded playlists immediately
        if (mediaChange && this.loadedPlaylists_[playlist.id] && this.loadedPlaylists_[playlist.id].endList) {
            this.state = 'HAVE_METADATA';
            this.media_ = playlist; // trigger media change if the active media has been updated
            if (mediaChange) {
                this.trigger('mediachanging');
                this.trigger('mediachange');
            }
            return;
        } // switching to the active playlist is a no-op
        if (!mediaChange) return;
         // switching from an already loaded playlist
        if (this.media_) this.trigger('mediachanging');
        this.addSidxSegments_(playlist, startingState, (sidxChanged)=>{
            // everything is ready just continue to haveMetadata
            this.haveMetadata({
                startingState: startingState,
                playlist: playlist
            });
        });
    }
    haveMetadata({ startingState: startingState, playlist: playlist }) {
        this.state = 'HAVE_METADATA';
        this.loadedPlaylists_[playlist.id] = playlist;
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mediaRequest_);
        this.mediaRequest_ = null; // This will trigger loadedplaylist
        this.refreshMedia_(playlist.id); // fire loadedmetadata the first time a media playlist is loaded
        // to resolve setup of media groups
        if (startingState === 'HAVE_MAIN_MANIFEST') this.trigger('loadedmetadata');
        else // trigger media change if the active media has been updated
        this.trigger('mediachange');
    }
    pause() {
        this.isPaused_ = true;
        if (this.mainPlaylistLoader_.createMupOnMedia_) {
            this.off('loadedmetadata', this.mainPlaylistLoader_.createMupOnMedia_);
            this.mainPlaylistLoader_.createMupOnMedia_ = null;
        }
        this.stopRequest();
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mediaUpdateTimeout);
        this.mediaUpdateTimeout = null;
        if (this.isMain_) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_);
            this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_ = null;
        }
        if (this.state === 'HAVE_NOTHING') // If we pause the loader before any data has been retrieved, its as if we never
        // started, so reset to an unstarted state.
        this.started = false;
    }
    load(isFinalRendition) {
        this.isPaused_ = false;
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mediaUpdateTimeout);
        this.mediaUpdateTimeout = null;
        const media = this.media();
        if (isFinalRendition) {
            const delay = media ? media.targetDuration / 2 * 1000 : 5000;
            this.mediaUpdateTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>this.load(), delay);
            return;
        } // because the playlists are internal to the manifest, load should either load the
        // main manifest, or do nothing but trigger an event
        if (!this.started) {
            this.start();
            return;
        }
        if (media && !media.endList) {
            // Check to see if this is the main loader and the MUP was cleared (this happens
            // when the loader was paused). `media` should be set at this point since one is always
            // set during `start()`.
            if (this.isMain_ && !this.minimumUpdatePeriodTimeout_) {
                // Trigger minimumUpdatePeriod to refresh the main manifest
                this.trigger('minimumUpdatePeriod'); // Since there was no prior minimumUpdatePeriodTimeout it should be recreated
                this.updateMinimumUpdatePeriodTimeout_();
            }
            this.trigger('mediaupdatetimeout');
        } else this.trigger('loadedplaylist');
    }
    start() {
        this.started = true; // We don't need to request the main manifest again
        // Call this asynchronously to match the xhr request behavior below
        if (!this.isMain_) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mediaRequest_);
            this.mediaRequest_ = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>this.haveMain_(), 0);
            return;
        }
        this.requestMain_((req, mainChanged)=>{
            this.haveMain_();
            if (!this.hasPendingRequest() && !this.media_) this.media(this.mainPlaylistLoader_.main.playlists[0]);
        });
    }
    requestMain_(cb) {
        const metadata = {
            manifestInfo: {
                uri: this.mainPlaylistLoader_.srcUrl
            }
        };
        this.trigger({
            type: 'manifestrequeststart',
            metadata: metadata
        });
        this.request = this.vhs_.xhr({
            uri: this.mainPlaylistLoader_.srcUrl,
            withCredentials: this.withCredentials,
            requestType: 'dash-manifest'
        }, (error, req)=>{
            if (error) {
                const { requestType: requestType } = req;
                error.metadata = $86defbb4e95ebb07$var$getStreamingNetworkErrorMetadata({
                    requestType: requestType,
                    request: req,
                    error: error
                });
            }
            if (this.requestErrored_(error, req)) {
                if (this.state === 'HAVE_NOTHING') this.started = false;
                return;
            }
            this.trigger({
                type: 'manifestrequestcomplete',
                metadata: metadata
            });
            const mainChanged = req.responseText !== this.mainPlaylistLoader_.mainXml_;
            this.mainPlaylistLoader_.mainXml_ = req.responseText;
            if (req.responseHeaders && req.responseHeaders.date) this.mainLoaded_ = Date.parse(req.responseHeaders.date);
            else this.mainLoaded_ = Date.now();
            this.mainPlaylistLoader_.srcUrl = $86defbb4e95ebb07$var$resolveManifestRedirect(this.mainPlaylistLoader_.srcUrl, req);
            if (mainChanged) {
                this.handleMain_();
                this.syncClientServerClock_(()=>{
                    return cb(req, mainChanged);
                });
                return;
            }
            return cb(req, mainChanged);
        });
    }
    /**
   * Parses the main xml for UTCTiming node to sync the client clock to the server
   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
   *
   * @param {Function} done
   *        Function to call when clock sync has completed
   */ syncClientServerClock_(done) {
        const utcTiming = (0, $fb56f0cd7d6a30bd$export$734c7278b5d0068c)(this.mainPlaylistLoader_.mainXml_); // No UTCTiming element found in the mpd. Use Date header from mpd request as the
        // server clock
        if (utcTiming === null) {
            this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now();
            return done();
        }
        if (utcTiming.method === 'DIRECT') {
            this.mainPlaylistLoader_.clientOffset_ = utcTiming.value - Date.now();
            return done();
        }
        this.request = this.vhs_.xhr({
            uri: $86defbb4e95ebb07$var$resolveUrl(this.mainPlaylistLoader_.srcUrl, utcTiming.value),
            method: utcTiming.method,
            withCredentials: this.withCredentials,
            requestType: 'dash-clock-sync'
        }, (error, req)=>{
            // disposed
            if (!this.request) return;
            if (error) {
                const { requestType: requestType } = req;
                this.error.metadata = $86defbb4e95ebb07$var$getStreamingNetworkErrorMetadata({
                    requestType: requestType,
                    request: req,
                    error: error
                }); // sync request failed, fall back to using date header from mpd
                // TODO: log warning
                this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now();
                return done();
            }
            let serverTime;
            if (utcTiming.method === 'HEAD') {
                if (!req.responseHeaders || !req.responseHeaders.date) // expected date header not preset, fall back to using date header from mpd
                // TODO: log warning
                serverTime = this.mainLoaded_;
                else serverTime = Date.parse(req.responseHeaders.date);
            } else serverTime = Date.parse(req.responseText);
            this.mainPlaylistLoader_.clientOffset_ = serverTime - Date.now();
            done();
        });
    }
    haveMain_() {
        this.state = 'HAVE_MAIN_MANIFEST';
        if (this.isMain_) // We have the main playlist at this point, so
        // trigger this to allow PlaylistController
        // to make an initial playlist selection
        this.trigger('loadedplaylist');
        else if (!this.media_) // no media playlist was specifically selected so select
        // the one the child playlist loader was created with
        this.media(this.childPlaylist_);
    }
    handleMain_() {
        // clear media request
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.mediaRequest_);
        this.mediaRequest_ = null;
        const oldMain = this.mainPlaylistLoader_.main;
        const metadata = {
            manifestInfo: {
                uri: this.mainPlaylistLoader_.srcUrl
            }
        };
        this.trigger({
            type: 'manifestparsestart',
            metadata: metadata
        });
        let newMain;
        try {
            newMain = $86defbb4e95ebb07$var$parseMainXml({
                mainXml: this.mainPlaylistLoader_.mainXml_,
                srcUrl: this.mainPlaylistLoader_.srcUrl,
                clientOffset: this.mainPlaylistLoader_.clientOffset_,
                sidxMapping: this.mainPlaylistLoader_.sidxMapping_,
                previousManifest: oldMain
            });
        } catch (error) {
            this.error = error;
            this.error.metadata = {
                errorType: $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.StreamingDashManifestParserError,
                error: error
            };
            this.trigger('error');
        } // if we have an old main to compare the new main against
        if (oldMain) newMain = $86defbb4e95ebb07$var$updateMain(oldMain, newMain, this.mainPlaylistLoader_.sidxMapping_);
         // only update main if we have a new main
        this.mainPlaylistLoader_.main = newMain ? newMain : oldMain;
        const location = this.mainPlaylistLoader_.main.locations && this.mainPlaylistLoader_.main.locations[0];
        if (location && location !== this.mainPlaylistLoader_.srcUrl) this.mainPlaylistLoader_.srcUrl = location;
        if (!oldMain || newMain && newMain.minimumUpdatePeriod !== oldMain.minimumUpdatePeriod) this.updateMinimumUpdatePeriodTimeout_();
        this.addEventStreamToMetadataTrack_(newMain);
        if (newMain) {
            const { duration: duration, endList: endList } = newMain;
            const renditions = [];
            newMain.playlists.forEach((playlist)=>{
                renditions.push({
                    id: playlist.id,
                    bandwidth: playlist.attributes.BANDWIDTH,
                    resolution: playlist.attributes.RESOLUTION,
                    codecs: playlist.attributes.CODECS
                });
            });
            const parsedManifest = {
                duration: duration,
                isLive: !endList,
                renditions: renditions
            };
            metadata.parsedManifest = parsedManifest;
            this.trigger({
                type: 'manifestparsecomplete',
                metadata: metadata
            });
        }
        return Boolean(newMain);
    }
    updateMinimumUpdatePeriodTimeout_() {
        const mpl = this.mainPlaylistLoader_; // cancel any pending creation of mup on media
        // a new one will be added if needed.
        if (mpl.createMupOnMedia_) {
            mpl.off('loadedmetadata', mpl.createMupOnMedia_);
            mpl.createMupOnMedia_ = null;
        } // clear any pending timeouts
        if (mpl.minimumUpdatePeriodTimeout_) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(mpl.minimumUpdatePeriodTimeout_);
            mpl.minimumUpdatePeriodTimeout_ = null;
        }
        let mup = mpl.main && mpl.main.minimumUpdatePeriod; // If the minimumUpdatePeriod has a value of 0, that indicates that the current
        // MPD has no future validity, so a new one will need to be acquired when new
        // media segments are to be made available. Thus, we use the target duration
        // in this case
        if (mup === 0) {
            if (mpl.media()) mup = mpl.media().targetDuration * 1000;
            else {
                mpl.createMupOnMedia_ = mpl.updateMinimumUpdatePeriodTimeout_;
                mpl.one('loadedmetadata', mpl.createMupOnMedia_);
            }
        } // if minimumUpdatePeriod is invalid or <= zero, which
        // can happen when a live video becomes VOD. skip timeout
        // creation.
        if (typeof mup !== 'number' || mup <= 0) {
            if (mup < 0) this.logger_(`found invalid minimumUpdatePeriod of ${mup}, not setting a timeout`);
            return;
        }
        this.createMUPTimeout_(mup);
    }
    createMUPTimeout_(mup) {
        const mpl = this.mainPlaylistLoader_;
        mpl.minimumUpdatePeriodTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>{
            mpl.minimumUpdatePeriodTimeout_ = null;
            mpl.trigger('minimumUpdatePeriod');
            mpl.createMUPTimeout_(mup);
        }, mup);
    }
    /**
   * Sends request to refresh the main xml and updates the parsed main manifest
   */ refreshXml_() {
        this.requestMain_((req, mainChanged)=>{
            if (!mainChanged) return;
            if (this.media_) this.media_ = this.mainPlaylistLoader_.main.playlists[this.media_.id];
             // This will filter out updated sidx info from the mapping
            this.mainPlaylistLoader_.sidxMapping_ = $86defbb4e95ebb07$var$filterChangedSidxMappings(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.sidxMapping_);
            this.addSidxSegments_(this.media(), this.state, (sidxChanged)=>{
                // TODO: do we need to reload the current playlist?
                this.refreshMedia_(this.media().id);
            });
        });
    }
    /**
   * Refreshes the media playlist by re-parsing the main xml and updating playlist
   * references. If this is an alternate loader, the updated parsed manifest is retrieved
   * from the main loader.
   */ refreshMedia_(mediaID) {
        if (!mediaID) throw new Error('refreshMedia_ must take a media id');
         // for main we have to reparse the main xml
        // to re-create segments based on current timing values
        // which may change media. We only skip updating the main manifest
        // if this is the first time this.media_ is being set.
        // as main was just parsed in that case.
        if (this.media_ && this.isMain_) this.handleMain_();
        const playlists = this.mainPlaylistLoader_.main.playlists;
        const mediaChanged = !this.media_ || this.media_ !== playlists[mediaID];
        if (mediaChanged) this.media_ = playlists[mediaID];
        else this.trigger('playlistunchanged');
        if (!this.mediaUpdateTimeout) {
            const createMediaUpdateTimeout = ()=>{
                if (this.media().endList) return;
                this.mediaUpdateTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>{
                    this.trigger('mediaupdatetimeout');
                    createMediaUpdateTimeout();
                }, $86defbb4e95ebb07$var$refreshDelay(this.media(), Boolean(mediaChanged)));
            };
            createMediaUpdateTimeout();
        }
        this.trigger('loadedplaylist');
    }
    /**
   * Takes eventstream data from a parsed DASH manifest and adds it to the metadata text track.
   *
   * @param {manifest} newMain the newly parsed manifest
   */ addEventStreamToMetadataTrack_(newMain) {
        // Only add new event stream metadata if we have a new manifest.
        if (newMain && this.mainPlaylistLoader_.main.eventStream) {
            // convert EventStream to ID3-like data.
            const metadataArray = this.mainPlaylistLoader_.main.eventStream.map((eventStreamNode)=>{
                return {
                    cueTime: eventStreamNode.start,
                    frames: [
                        {
                            data: eventStreamNode.messageData
                        }
                    ]
                };
            });
            this.addMetadataToTextTrack('EventStream', metadataArray, this.mainPlaylistLoader_.main.duration);
        }
    }
    /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */ getKeyIdSet(playlist) {
        if (playlist.contentProtection) {
            const keyIds = new Set();
            for(const keysystem in playlist.contentProtection){
                const defaultKID = playlist.contentProtection[keysystem].attributes['cenc:default_KID'];
                if (defaultKID) // DASH keyIds are separated by dashes.
                keyIds.add(defaultKID.replace(/-/g, '').toLowerCase());
            }
            return keyIds;
        }
    }
}
var $86defbb4e95ebb07$var$Config = {
    GOAL_BUFFER_LENGTH: 30,
    MAX_GOAL_BUFFER_LENGTH: 60,
    BACK_BUFFER_LENGTH: 30,
    GOAL_BUFFER_LENGTH_RATE: 1,
    // 0.5 MB/s
    INITIAL_BANDWIDTH: 4194304,
    // A fudge factor to apply to advertised playlist bitrates to account for
    // temporary flucations in client bandwidth
    BANDWIDTH_VARIANCE: 1.2,
    // How much of the buffer must be filled before we consider upswitching
    BUFFER_LOW_WATER_LINE: 0,
    MAX_BUFFER_LOW_WATER_LINE: 30,
    // TODO: Remove this when experimentalBufferBasedABR is removed
    EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
    BUFFER_LOW_WATER_LINE_RATE: 1,
    // If the buffer is greater than the high water line, we won't switch down
    BUFFER_HIGH_WATER_LINE: 30
};
const $86defbb4e95ebb07$var$stringToArrayBuffer = (string)=>{
    const view = new Uint8Array(new ArrayBuffer(string.length));
    for(let i = 0; i < string.length; i++)view[i] = string.charCodeAt(i);
    return view.buffer;
};
/* global Blob, BlobBuilder, Worker */ // unify worker interface
const $86defbb4e95ebb07$var$browserWorkerPolyFill = function(workerObj) {
    // node only supports on/off
    workerObj.on = workerObj.addEventListener;
    workerObj.off = workerObj.removeEventListener;
    return workerObj;
};
const $86defbb4e95ebb07$var$createObjectURL = function(str) {
    try {
        return URL.createObjectURL(new Blob([
            str
        ], {
            type: 'application/javascript'
        }));
    } catch (e) {
        const blob = new BlobBuilder();
        blob.append(str);
        return URL.createObjectURL(blob.getBlob());
    }
};
const $86defbb4e95ebb07$var$factory = function(code) {
    return function() {
        const objectUrl = $86defbb4e95ebb07$var$createObjectURL(code);
        const worker = $86defbb4e95ebb07$var$browserWorkerPolyFill(new Worker(objectUrl));
        worker.objURL = objectUrl;
        const terminate = worker.terminate;
        worker.on = worker.addEventListener;
        worker.off = worker.removeEventListener;
        worker.terminate = function() {
            URL.revokeObjectURL(objectUrl);
            return terminate.call(this);
        };
        return worker;
    };
};
const $86defbb4e95ebb07$var$transform = function(code) {
    return `var browserWorkerPolyFill = ${$86defbb4e95ebb07$var$browserWorkerPolyFill.toString()};\n` + 'browserWorkerPolyFill(self);\n' + code;
};
const $86defbb4e95ebb07$var$getWorkerString = function(fn) {
    return fn.toString().replace(/^function.+?{/, '').slice(0, -1);
};
/* rollup-plugin-worker-factory start for worker!/Users/srimron-soutter/repos/github/vjs/http-streaming/src/transmuxer-worker.js */ const $86defbb4e95ebb07$var$workerCode$1 = $86defbb4e95ebb07$var$transform($86defbb4e95ebb07$var$getWorkerString(function() {
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A lightweight readable stream implemention that handles event dispatching.
   * Objects that inherit from streams should call init in their constructors.
   */ var Stream$8 = function() {
        this.init = function() {
            var listeners = {};
            /**
       * Add a listener for a specified event type.
       * @param type {string} the event name
       * @param listener {function} the callback to be invoked when an event of
       * the specified type occurs
       */ this.on = function(type, listener) {
                if (!listeners[type]) listeners[type] = [];
                listeners[type] = listeners[type].concat(listener);
            };
            /**
       * Remove a listener for a specified event type.
       * @param type {string} the event name
       * @param listener {function} a function previously registered for this
       * type of event through `on`
       */ this.off = function(type, listener) {
                var index;
                if (!listeners[type]) return false;
                index = listeners[type].indexOf(listener);
                listeners[type] = listeners[type].slice();
                listeners[type].splice(index, 1);
                return index > -1;
            };
            /**
       * Trigger an event of the specified type on this stream. Any additional
       * arguments to this function are passed as parameters to event listeners.
       * @param type {string} the event name
       */ this.trigger = function(type) {
                var callbacks, i, length, args;
                callbacks = listeners[type];
                if (!callbacks) return;
                 // Slicing the arguments on every invocation of this method
                // can add a significant amount of overhead. Avoid the
                // intermediate object creation for the common case of a
                // single callback argument
                if (arguments.length === 2) {
                    length = callbacks.length;
                    for(i = 0; i < length; ++i)callbacks[i].call(this, arguments[1]);
                } else {
                    args = [];
                    i = arguments.length;
                    for(i = 1; i < arguments.length; ++i)args.push(arguments[i]);
                    length = callbacks.length;
                    for(i = 0; i < length; ++i)callbacks[i].apply(this, args);
                }
            };
            /**
       * Destroys the stream and cleans up.
       */ this.dispose = function() {
                listeners = {};
            };
        };
    };
    /**
   * Forwards all `data` events on this stream to the destination stream. The
   * destination stream should provide a method `push` to receive the data
   * events as they arrive.
   * @param destination {stream} the stream that will receive all `data` events
   * @param autoFlush {boolean} if false, we will not call `flush` on the destination
   *                            when the current stream emits a 'done' event
   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
   */ Stream$8.prototype.pipe = function(destination) {
        this.on('data', function(data) {
            destination.push(data);
        });
        this.on('done', function(flushSource) {
            destination.flush(flushSource);
        });
        this.on('partialdone', function(flushSource) {
            destination.partialFlush(flushSource);
        });
        this.on('endedtimeline', function(flushSource) {
            destination.endTimeline(flushSource);
        });
        this.on('reset', function(flushSource) {
            destination.reset(flushSource);
        });
        return destination;
    }; // Default stream functions that are expected to be overridden to perform
    // actual work. These are provided by the prototype as a sort of no-op
    // implementation so that we don't have to check for their existence in the
    // `pipe` function above.
    Stream$8.prototype.push = function(data) {
        this.trigger('data', data);
    };
    Stream$8.prototype.flush = function(flushSource) {
        this.trigger('done', flushSource);
    };
    Stream$8.prototype.partialFlush = function(flushSource) {
        this.trigger('partialdone', flushSource);
    };
    Stream$8.prototype.endTimeline = function(flushSource) {
        this.trigger('endedtimeline', flushSource);
    };
    Stream$8.prototype.reset = function(flushSource) {
        this.trigger('reset', flushSource);
    };
    var stream = Stream$8;
    var MAX_UINT32$1 = Math.pow(2, 32);
    var getUint64$5 = function(uint8) {
        var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
        var value;
        if (dv.getBigUint64) {
            value = dv.getBigUint64(0);
            if (value < Number.MAX_SAFE_INTEGER) return Number(value);
            return value;
        }
        return dv.getUint32(0) * MAX_UINT32$1 + dv.getUint32(4);
    };
    var numbers = {
        getUint64: getUint64$5,
        MAX_UINT32: MAX_UINT32$1
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Functions that generate fragmented MP4s suitable for use with Media
   * Source Extensions.
   */ var MAX_UINT32 = numbers.MAX_UINT32;
    var box, dinf, esds, ftyp, mdat, mfhd, minf, moof, moov, mvex, mvhd, trak, tkhd, mdia, mdhd, hdlr, sdtp, stbl, stsd, traf, trex, trun$1, types, MAJOR_BRAND, MINOR_VERSION, AVC1_BRAND, VIDEO_HDLR, AUDIO_HDLR, HDLR_TYPES, VMHD, SMHD, DREF, STCO, STSC, STSZ, STTS; // pre-calculate constants
    (function() {
        var i;
        types = {
            avc1: [],
            // codingname
            avcC: [],
            btrt: [],
            dinf: [],
            dref: [],
            esds: [],
            ftyp: [],
            hdlr: [],
            mdat: [],
            mdhd: [],
            mdia: [],
            mfhd: [],
            minf: [],
            moof: [],
            moov: [],
            mp4a: [],
            // codingname
            mvex: [],
            mvhd: [],
            pasp: [],
            sdtp: [],
            smhd: [],
            stbl: [],
            stco: [],
            stsc: [],
            stsd: [],
            stsz: [],
            stts: [],
            styp: [],
            tfdt: [],
            tfhd: [],
            traf: [],
            trak: [],
            trun: [],
            trex: [],
            tkhd: [],
            vmhd: []
        }; // In environments where Uint8Array is undefined (e.g., IE8), skip set up so that we
        // don't throw an error
        if (typeof Uint8Array === 'undefined') return;
        for(i in types)if (types.hasOwnProperty(i)) types[i] = [
            i.charCodeAt(0),
            i.charCodeAt(1),
            i.charCodeAt(2),
            i.charCodeAt(3)
        ];
        MAJOR_BRAND = new Uint8Array([
            'i'.charCodeAt(0),
            's'.charCodeAt(0),
            'o'.charCodeAt(0),
            'm'.charCodeAt(0)
        ]);
        AVC1_BRAND = new Uint8Array([
            'a'.charCodeAt(0),
            'v'.charCodeAt(0),
            'c'.charCodeAt(0),
            '1'.charCodeAt(0)
        ]);
        MINOR_VERSION = new Uint8Array([
            0,
            0,
            0,
            1
        ]);
        VIDEO_HDLR = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x76,
            0x69,
            0x64,
            0x65,
            // handler_type: 'vide'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x56,
            0x69,
            0x64,
            0x65,
            0x6f,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'VideoHandler'
        ]);
        AUDIO_HDLR = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x73,
            0x6f,
            0x75,
            0x6e,
            // handler_type: 'soun'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x53,
            0x6f,
            0x75,
            0x6e,
            0x64,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'SoundHandler'
        ]);
        HDLR_TYPES = {
            video: VIDEO_HDLR,
            audio: AUDIO_HDLR
        };
        DREF = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01,
            // entry_count
            0x00,
            0x00,
            0x00,
            0x0c,
            // entry_size
            0x75,
            0x72,
            0x6c,
            0x20,
            // 'url' type
            0x00,
            // version 0
            0x00,
            0x00,
            0x01 // entry_flags
        ]);
        SMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            // balance, 0 means centered
            0x00,
            0x00 // reserved
        ]);
        STCO = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00 // entry_count
        ]);
        STSC = STCO;
        STSZ = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // sample_size
            0x00,
            0x00,
            0x00,
            0x00 // sample_count
        ]);
        STTS = STCO;
        VMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x01,
            // flags
            0x00,
            0x00,
            // graphicsmode
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00 // opcolor
        ]);
    })();
    box = function(type) {
        var payload = [], size = 0, i, result, view;
        for(i = 1; i < arguments.length; i++)payload.push(arguments[i]);
        i = payload.length; // calculate the total size we need to allocate
        while(i--)size += payload[i].byteLength;
        result = new Uint8Array(size + 8);
        view = new DataView(result.buffer, result.byteOffset, result.byteLength);
        view.setUint32(0, result.byteLength);
        result.set(type, 4); // copy the payload into the result
        for(i = 0, size = 8; i < payload.length; i++){
            result.set(payload[i], size);
            size += payload[i].byteLength;
        }
        return result;
    };
    dinf = function() {
        return box(types.dinf, box(types.dref, DREF));
    };
    esds = function(track) {
        return box(types.esds, new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            // ES_Descriptor
            0x03,
            // tag, ES_DescrTag
            0x19,
            // length
            0x00,
            0x00,
            // ES_ID
            0x00,
            // streamDependenceFlag, URL_flag, reserved, streamPriority
            // DecoderConfigDescriptor
            0x04,
            // tag, DecoderConfigDescrTag
            0x11,
            // length
            0x40,
            // object type
            0x15,
            // streamType
            0x00,
            0x06,
            0x00,
            // bufferSizeDB
            0x00,
            0x00,
            0xda,
            0xc0,
            // maxBitrate
            0x00,
            0x00,
            0xda,
            0xc0,
            // avgBitrate
            // DecoderSpecificInfo
            0x05,
            // tag, DecoderSpecificInfoTag
            0x02,
            // length
            // ISO/IEC 14496-3, AudioSpecificConfig
            // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
            track.audioobjecttype << 3 | track.samplingfrequencyindex >>> 1,
            track.samplingfrequencyindex << 7 | track.channelcount << 3,
            0x06,
            0x01,
            0x02 // GASpecificConfig
        ]));
    };
    ftyp = function() {
        return box(types.ftyp, MAJOR_BRAND, MINOR_VERSION, MAJOR_BRAND, AVC1_BRAND);
    };
    hdlr = function(type) {
        return box(types.hdlr, HDLR_TYPES[type]);
    };
    mdat = function(data) {
        return box(types.mdat, data);
    };
    mdhd = function(track) {
        var result = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            0x00,
            0x01,
            0x5f,
            0x90,
            // timescale, 90,000 "ticks" per second
            track.duration >>> 24 & 0xFF,
            track.duration >>> 16 & 0xFF,
            track.duration >>> 8 & 0xFF,
            track.duration & 0xFF,
            // duration
            0x55,
            0xc4,
            // 'und' language (undetermined)
            0x00,
            0x00
        ]); // Use the sample rate from the track metadata, when it is
        // defined. The sample rate can be parsed out of an ADTS header, for
        // instance.
        if (track.samplerate) {
            result[12] = track.samplerate >>> 24 & 0xFF;
            result[13] = track.samplerate >>> 16 & 0xFF;
            result[14] = track.samplerate >>> 8 & 0xFF;
            result[15] = track.samplerate & 0xFF;
        }
        return box(types.mdhd, result);
    };
    mdia = function(track) {
        return box(types.mdia, mdhd(track), hdlr(track.type), minf(track));
    };
    mfhd = function(sequenceNumber) {
        return box(types.mfhd, new Uint8Array([
            0x00,
            0x00,
            0x00,
            0x00,
            // flags
            (sequenceNumber & 0xFF000000) >> 24,
            (sequenceNumber & 0xFF0000) >> 16,
            (sequenceNumber & 0xFF00) >> 8,
            sequenceNumber & 0xFF // sequence_number
        ]));
    };
    minf = function(track) {
        return box(types.minf, track.type === 'video' ? box(types.vmhd, VMHD) : box(types.smhd, SMHD), dinf(), stbl(track));
    };
    moof = function(sequenceNumber, tracks) {
        var trackFragments = [], i = tracks.length; // build traf boxes for each track fragment
        while(i--)trackFragments[i] = traf(tracks[i]);
        return box.apply(null, [
            types.moof,
            mfhd(sequenceNumber)
        ].concat(trackFragments));
    };
    /**
   * Returns a movie box.
   * @param tracks {array} the tracks associated with this movie
   * @see ISO/IEC 14496-12:2012(E), section 8.2.1
   */ moov = function(tracks) {
        var i = tracks.length, boxes = [];
        while(i--)boxes[i] = trak(tracks[i]);
        return box.apply(null, [
            types.moov,
            mvhd(0xffffffff)
        ].concat(boxes).concat(mvex(tracks)));
    };
    mvex = function(tracks) {
        var i = tracks.length, boxes = [];
        while(i--)boxes[i] = trex(tracks[i]);
        return box.apply(null, [
            types.mvex
        ].concat(boxes));
    };
    mvhd = function(duration) {
        var bytes = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x02,
            // modification_time
            0x00,
            0x01,
            0x5f,
            0x90,
            // timescale, 90,000 "ticks" per second
            (duration & 0xFF000000) >> 24,
            (duration & 0xFF0000) >> 16,
            (duration & 0xFF00) >> 8,
            duration & 0xFF,
            // duration
            0x00,
            0x01,
            0x00,
            0x00,
            // 1.0 rate
            0x01,
            0x00,
            // 1.0 volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0xff,
            0xff,
            0xff,
            0xff // next_track_ID
        ]);
        return box(types.mvhd, bytes);
    };
    sdtp = function(track) {
        var samples = track.samples || [], bytes = new Uint8Array(4 + samples.length), flags, i; // leave the full box header (4 bytes) all zero
        // write the sample table
        for(i = 0; i < samples.length; i++){
            flags = samples[i].flags;
            bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
        }
        return box(types.sdtp, bytes);
    };
    stbl = function(track) {
        return box(types.stbl, stsd(track), box(types.stts, STTS), box(types.stsc, STSC), box(types.stsz, STSZ), box(types.stco, STCO));
    };
    (function() {
        var videoSample, audioSample;
        stsd = function(track) {
            return box(types.stsd, new Uint8Array([
                0x00,
                // version 0
                0x00,
                0x00,
                0x00,
                // flags
                0x00,
                0x00,
                0x00,
                0x01
            ]), track.type === 'video' ? videoSample(track) : audioSample(track));
        };
        videoSample = function(track) {
            var sps = track.sps || [], pps = track.pps || [], sequenceParameterSets = [], pictureParameterSets = [], i, avc1Box; // assemble the SPSs
            for(i = 0; i < sps.length; i++){
                sequenceParameterSets.push((sps[i].byteLength & 0xFF00) >>> 8);
                sequenceParameterSets.push(sps[i].byteLength & 0xFF); // sequenceParameterSetLength
                sequenceParameterSets = sequenceParameterSets.concat(Array.prototype.slice.call(sps[i])); // SPS
            } // assemble the PPSs
            for(i = 0; i < pps.length; i++){
                pictureParameterSets.push((pps[i].byteLength & 0xFF00) >>> 8);
                pictureParameterSets.push(pps[i].byteLength & 0xFF);
                pictureParameterSets = pictureParameterSets.concat(Array.prototype.slice.call(pps[i]));
            }
            avc1Box = [
                types.avc1,
                new Uint8Array([
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    // reserved
                    0x00,
                    0x01,
                    // data_reference_index
                    0x00,
                    0x00,
                    // pre_defined
                    0x00,
                    0x00,
                    // reserved
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    // pre_defined
                    (track.width & 0xff00) >> 8,
                    track.width & 0xff,
                    // width
                    (track.height & 0xff00) >> 8,
                    track.height & 0xff,
                    // height
                    0x00,
                    0x48,
                    0x00,
                    0x00,
                    // horizresolution
                    0x00,
                    0x48,
                    0x00,
                    0x00,
                    // vertresolution
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    // reserved
                    0x00,
                    0x01,
                    // frame_count
                    0x13,
                    0x76,
                    0x69,
                    0x64,
                    0x65,
                    0x6f,
                    0x6a,
                    0x73,
                    0x2d,
                    0x63,
                    0x6f,
                    0x6e,
                    0x74,
                    0x72,
                    0x69,
                    0x62,
                    0x2d,
                    0x68,
                    0x6c,
                    0x73,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    // compressorname
                    0x00,
                    0x18,
                    // depth = 24
                    0x11,
                    0x11 // pre_defined = -1
                ]),
                box(types.avcC, new Uint8Array([
                    0x01,
                    // configurationVersion
                    track.profileIdc,
                    // AVCProfileIndication
                    track.profileCompatibility,
                    // profile_compatibility
                    track.levelIdc,
                    // AVCLevelIndication
                    0xff // lengthSizeMinusOne, hard-coded to 4 bytes
                ].concat([
                    sps.length
                ], // numOfSequenceParameterSets
                sequenceParameterSets, // "SPS"
                [
                    pps.length
                ], // numOfPictureParameterSets
                pictureParameterSets // "PPS"
                ))),
                box(types.btrt, new Uint8Array([
                    0x00,
                    0x1c,
                    0x9c,
                    0x80,
                    // bufferSizeDB
                    0x00,
                    0x2d,
                    0xc6,
                    0xc0,
                    // maxBitrate
                    0x00,
                    0x2d,
                    0xc6,
                    0xc0 // avgBitrate
                ]))
            ];
            if (track.sarRatio) {
                var hSpacing = track.sarRatio[0], vSpacing = track.sarRatio[1];
                avc1Box.push(box(types.pasp, new Uint8Array([
                    (hSpacing & 0xFF000000) >> 24,
                    (hSpacing & 0xFF0000) >> 16,
                    (hSpacing & 0xFF00) >> 8,
                    hSpacing & 0xFF,
                    (vSpacing & 0xFF000000) >> 24,
                    (vSpacing & 0xFF0000) >> 16,
                    (vSpacing & 0xFF00) >> 8,
                    vSpacing & 0xFF
                ])));
            }
            return box.apply(null, avc1Box);
        };
        audioSample = function(track) {
            return box(types.mp4a, new Uint8Array([
                // SampleEntry, ISO/IEC 14496-12
                0x00,
                0x00,
                0x00,
                0x00,
                0x00,
                0x00,
                // reserved
                0x00,
                0x01,
                // data_reference_index
                // AudioSampleEntry, ISO/IEC 14496-12
                0x00,
                0x00,
                0x00,
                0x00,
                // reserved
                0x00,
                0x00,
                0x00,
                0x00,
                // reserved
                (track.channelcount & 0xff00) >> 8,
                track.channelcount & 0xff,
                // channelcount
                (track.samplesize & 0xff00) >> 8,
                track.samplesize & 0xff,
                // samplesize
                0x00,
                0x00,
                // pre_defined
                0x00,
                0x00,
                // reserved
                (track.samplerate & 0xff00) >> 8,
                track.samplerate & 0xff,
                0x00,
                0x00 // samplerate, 16.16
            ]), esds(track));
        };
    })();
    tkhd = function(track) {
        var result = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x07,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            // modification_time
            (track.id & 0xFF000000) >> 24,
            (track.id & 0xFF0000) >> 16,
            (track.id & 0xFF00) >> 8,
            track.id & 0xFF,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            (track.duration & 0xFF000000) >> 24,
            (track.duration & 0xFF0000) >> 16,
            (track.duration & 0xFF00) >> 8,
            track.duration & 0xFF,
            // duration
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            // layer
            0x00,
            0x00,
            // alternate_group
            0x01,
            0x00,
            // non-audio track volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            (track.width & 0xFF00) >> 8,
            track.width & 0xFF,
            0x00,
            0x00,
            // width
            (track.height & 0xFF00) >> 8,
            track.height & 0xFF,
            0x00,
            0x00 // height
        ]);
        return box(types.tkhd, result);
    };
    /**
   * Generate a track fragment (traf) box. A traf box collects metadata
   * about tracks in a movie fragment (moof) box.
   */ traf = function(track) {
        var trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable, dataOffset, upperWordBaseMediaDecodeTime, lowerWordBaseMediaDecodeTime;
        trackFragmentHeader = box(types.tfhd, new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x3a,
            // flags
            (track.id & 0xFF000000) >> 24,
            (track.id & 0xFF0000) >> 16,
            (track.id & 0xFF00) >> 8,
            track.id & 0xFF,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x01,
            // sample_description_index
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_duration
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_size
            0x00,
            0x00,
            0x00,
            0x00 // default_sample_flags
        ]));
        upperWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime / MAX_UINT32);
        lowerWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime % MAX_UINT32);
        trackFragmentDecodeTime = box(types.tfdt, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            // baseMediaDecodeTime
            upperWordBaseMediaDecodeTime >>> 24 & 0xFF,
            upperWordBaseMediaDecodeTime >>> 16 & 0xFF,
            upperWordBaseMediaDecodeTime >>> 8 & 0xFF,
            upperWordBaseMediaDecodeTime & 0xFF,
            lowerWordBaseMediaDecodeTime >>> 24 & 0xFF,
            lowerWordBaseMediaDecodeTime >>> 16 & 0xFF,
            lowerWordBaseMediaDecodeTime >>> 8 & 0xFF,
            lowerWordBaseMediaDecodeTime & 0xFF
        ])); // the data offset specifies the number of bytes from the start of
        // the containing moof to the first payload byte of the associated
        // mdat
        dataOffset = 92; // mdat header
        // audio tracks require less metadata
        if (track.type === 'audio') {
            trackFragmentRun = trun$1(track, dataOffset);
            return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun);
        } // video tracks should contain an independent and disposable samples
        // box (sdtp)
        // generate one and adjust offsets to match
        sampleDependencyTable = sdtp(track);
        trackFragmentRun = trun$1(track, sampleDependencyTable.length + dataOffset);
        return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable);
    };
    /**
   * Generate a track box.
   * @param track {object} a track definition
   * @return {Uint8Array} the track box
   */ trak = function(track) {
        track.duration = track.duration || 0xffffffff;
        return box(types.trak, tkhd(track), mdia(track));
    };
    trex = function(track) {
        var result = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            (track.id & 0xFF000000) >> 24,
            (track.id & 0xFF0000) >> 16,
            (track.id & 0xFF00) >> 8,
            track.id & 0xFF,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x01,
            // default_sample_description_index
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_duration
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_size
            0x00,
            0x01,
            0x00,
            0x01 // default_sample_flags
        ]); // the last two bytes of default_sample_flags is the sample
        // degradation priority, a hint about the importance of this sample
        // relative to others. Lower the degradation priority for all sample
        // types other than video.
        if (track.type !== 'video') result[result.length - 1] = 0x00;
        return box(types.trex, result);
    };
    (function() {
        var audioTrun, videoTrun, trunHeader; // This method assumes all samples are uniform. That is, if a
        // duration is present for the first sample, it will be present for
        // all subsequent samples.
        // see ISO/IEC 14496-12:2012, Section 8.8.8.1
        trunHeader = function(samples, offset) {
            var durationPresent = 0, sizePresent = 0, flagsPresent = 0, compositionTimeOffset = 0; // trun flag constants
            if (samples.length) {
                if (samples[0].duration !== undefined) durationPresent = 0x1;
                if (samples[0].size !== undefined) sizePresent = 0x2;
                if (samples[0].flags !== undefined) flagsPresent = 0x4;
                if (samples[0].compositionTimeOffset !== undefined) compositionTimeOffset = 0x8;
            }
            return [
                0x00,
                // version 0
                0x00,
                durationPresent | sizePresent | flagsPresent | compositionTimeOffset,
                0x01,
                // flags
                (samples.length & 0xFF000000) >>> 24,
                (samples.length & 0xFF0000) >>> 16,
                (samples.length & 0xFF00) >>> 8,
                samples.length & 0xFF,
                // sample_count
                (offset & 0xFF000000) >>> 24,
                (offset & 0xFF0000) >>> 16,
                (offset & 0xFF00) >>> 8,
                offset & 0xFF // data_offset
            ];
        };
        videoTrun = function(track, offset) {
            var bytesOffest, bytes, header, samples, sample, i;
            samples = track.samples || [];
            offset += 20 + 16 * samples.length;
            header = trunHeader(samples, offset);
            bytes = new Uint8Array(header.length + samples.length * 16);
            bytes.set(header);
            bytesOffest = header.length;
            for(i = 0; i < samples.length; i++){
                sample = samples[i];
                bytes[bytesOffest++] = (sample.duration & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.duration & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.duration & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.duration & 0xFF; // sample_duration
                bytes[bytesOffest++] = (sample.size & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.size & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.size & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.size & 0xFF; // sample_size
                bytes[bytesOffest++] = sample.flags.isLeading << 2 | sample.flags.dependsOn;
                bytes[bytesOffest++] = sample.flags.isDependedOn << 6 | sample.flags.hasRedundancy << 4 | sample.flags.paddingValue << 1 | sample.flags.isNonSyncSample;
                bytes[bytesOffest++] = sample.flags.degradationPriority & 61440;
                bytes[bytesOffest++] = sample.flags.degradationPriority & 0x0F; // sample_flags
                bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.compositionTimeOffset & 0xFF; // sample_composition_time_offset
            }
            return box(types.trun, bytes);
        };
        audioTrun = function(track, offset) {
            var bytes, bytesOffest, header, samples, sample, i;
            samples = track.samples || [];
            offset += 20 + 8 * samples.length;
            header = trunHeader(samples, offset);
            bytes = new Uint8Array(header.length + samples.length * 8);
            bytes.set(header);
            bytesOffest = header.length;
            for(i = 0; i < samples.length; i++){
                sample = samples[i];
                bytes[bytesOffest++] = (sample.duration & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.duration & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.duration & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.duration & 0xFF; // sample_duration
                bytes[bytesOffest++] = (sample.size & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.size & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.size & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.size & 0xFF; // sample_size
            }
            return box(types.trun, bytes);
        };
        trun$1 = function(track, offset) {
            if (track.type === 'audio') return audioTrun(track, offset);
            return videoTrun(track, offset);
        };
    })();
    var mp4Generator = {
        ftyp: ftyp,
        mdat: mdat,
        moof: moof,
        moov: moov,
        initSegment: function(tracks) {
            var fileType = ftyp(), movie = moov(tracks), result;
            result = new Uint8Array(fileType.byteLength + movie.byteLength);
            result.set(fileType);
            result.set(movie, fileType.byteLength);
            return result;
        }
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ // composed of the nal units that make up that frame
    // Also keep track of cummulative data about the frame from the nal units such
    // as the frame duration, starting pts, etc.
    var groupNalsIntoFrames = function(nalUnits) {
        var i, currentNal, currentFrame = [], frames = []; // TODO added for LHLS, make sure this is OK
        frames.byteLength = 0;
        frames.nalCount = 0;
        frames.duration = 0;
        currentFrame.byteLength = 0;
        for(i = 0; i < nalUnits.length; i++){
            currentNal = nalUnits[i]; // Split on 'aud'-type nal units
            if (currentNal.nalUnitType === 'access_unit_delimiter_rbsp') {
                // Since the very first nal unit is expected to be an AUD
                // only push to the frames array when currentFrame is not empty
                if (currentFrame.length) {
                    currentFrame.duration = currentNal.dts - currentFrame.dts; // TODO added for LHLS, make sure this is OK
                    frames.byteLength += currentFrame.byteLength;
                    frames.nalCount += currentFrame.length;
                    frames.duration += currentFrame.duration;
                    frames.push(currentFrame);
                }
                currentFrame = [
                    currentNal
                ];
                currentFrame.byteLength = currentNal.data.byteLength;
                currentFrame.pts = currentNal.pts;
                currentFrame.dts = currentNal.dts;
            } else {
                // Specifically flag key frames for ease of use later
                if (currentNal.nalUnitType === 'slice_layer_without_partitioning_rbsp_idr') currentFrame.keyFrame = true;
                currentFrame.duration = currentNal.dts - currentFrame.dts;
                currentFrame.byteLength += currentNal.data.byteLength;
                currentFrame.push(currentNal);
            }
        } // For the last frame, use the duration of the previous frame if we
        // have nothing better to go on
        if (frames.length && (!currentFrame.duration || currentFrame.duration <= 0)) currentFrame.duration = frames[frames.length - 1].duration;
         // Push the final frame
        // TODO added for LHLS, make sure this is OK
        frames.byteLength += currentFrame.byteLength;
        frames.nalCount += currentFrame.length;
        frames.duration += currentFrame.duration;
        frames.push(currentFrame);
        return frames;
    }; // Convert an array of frames into an array of Gop with each Gop being composed
    // of the frames that make up that Gop
    // Also keep track of cummulative data about the Gop from the frames such as the
    // Gop duration, starting pts, etc.
    var groupFramesIntoGops = function(frames) {
        var i, currentFrame, currentGop = [], gops = []; // We must pre-set some of the values on the Gop since we
        // keep running totals of these values
        currentGop.byteLength = 0;
        currentGop.nalCount = 0;
        currentGop.duration = 0;
        currentGop.pts = frames[0].pts;
        currentGop.dts = frames[0].dts; // store some metadata about all the Gops
        gops.byteLength = 0;
        gops.nalCount = 0;
        gops.duration = 0;
        gops.pts = frames[0].pts;
        gops.dts = frames[0].dts;
        for(i = 0; i < frames.length; i++){
            currentFrame = frames[i];
            if (currentFrame.keyFrame) {
                // Since the very first frame is expected to be an keyframe
                // only push to the gops array when currentGop is not empty
                if (currentGop.length) {
                    gops.push(currentGop);
                    gops.byteLength += currentGop.byteLength;
                    gops.nalCount += currentGop.nalCount;
                    gops.duration += currentGop.duration;
                }
                currentGop = [
                    currentFrame
                ];
                currentGop.nalCount = currentFrame.length;
                currentGop.byteLength = currentFrame.byteLength;
                currentGop.pts = currentFrame.pts;
                currentGop.dts = currentFrame.dts;
                currentGop.duration = currentFrame.duration;
            } else {
                currentGop.duration += currentFrame.duration;
                currentGop.nalCount += currentFrame.length;
                currentGop.byteLength += currentFrame.byteLength;
                currentGop.push(currentFrame);
            }
        }
        if (gops.length && currentGop.duration <= 0) currentGop.duration = gops[gops.length - 1].duration;
        gops.byteLength += currentGop.byteLength;
        gops.nalCount += currentGop.nalCount;
        gops.duration += currentGop.duration; // push the final Gop
        gops.push(currentGop);
        return gops;
    };
    /*
   * Search for the first keyframe in the GOPs and throw away all frames
   * until that keyframe. Then extend the duration of the pulled keyframe
   * and pull the PTS and DTS of the keyframe so that it covers the time
   * range of the frames that were disposed.
   *
   * @param {Array} gops video GOPs
   * @returns {Array} modified video GOPs
   */ var extendFirstKeyFrame = function(gops) {
        var currentGop;
        if (!gops[0][0].keyFrame && gops.length > 1) {
            // Remove the first GOP
            currentGop = gops.shift();
            gops.byteLength -= currentGop.byteLength;
            gops.nalCount -= currentGop.nalCount; // Extend the first frame of what is now the
            // first gop to cover the time period of the
            // frames we just removed
            gops[0][0].dts = currentGop.dts;
            gops[0][0].pts = currentGop.pts;
            gops[0][0].duration += currentGop.duration;
        }
        return gops;
    };
    /**
   * Default sample object
   * see ISO/IEC 14496-12:2012, section 8.6.4.3
   */ var createDefaultSample = function() {
        return {
            size: 0,
            flags: {
                isLeading: 0,
                dependsOn: 1,
                isDependedOn: 0,
                hasRedundancy: 0,
                degradationPriority: 0,
                isNonSyncSample: 1
            }
        };
    };
    /*
   * Collates information from a video frame into an object for eventual
   * entry into an MP4 sample table.
   *
   * @param {Object} frame the video frame
   * @param {Number} dataOffset the byte offset to position the sample
   * @return {Object} object containing sample table info for a frame
   */ var sampleForFrame = function(frame, dataOffset) {
        var sample = createDefaultSample();
        sample.dataOffset = dataOffset;
        sample.compositionTimeOffset = frame.pts - frame.dts;
        sample.duration = frame.duration;
        sample.size = 4 * frame.length; // Space for nal unit size
        sample.size += frame.byteLength;
        if (frame.keyFrame) {
            sample.flags.dependsOn = 2;
            sample.flags.isNonSyncSample = 0;
        }
        return sample;
    }; // generate the track's sample table from an array of gops
    var generateSampleTable$1 = function(gops, baseDataOffset) {
        var h, i, sample, currentGop, currentFrame, dataOffset = baseDataOffset || 0, samples = [];
        for(h = 0; h < gops.length; h++){
            currentGop = gops[h];
            for(i = 0; i < currentGop.length; i++){
                currentFrame = currentGop[i];
                sample = sampleForFrame(currentFrame, dataOffset);
                dataOffset += sample.size;
                samples.push(sample);
            }
        }
        return samples;
    }; // generate the track's raw mdat data from an array of gops
    var concatenateNalData = function(gops) {
        var h, i, j, currentGop, currentFrame, currentNal, dataOffset = 0, nalsByteLength = gops.byteLength, numberOfNals = gops.nalCount, totalByteLength = nalsByteLength + 4 * numberOfNals, data = new Uint8Array(totalByteLength), view = new DataView(data.buffer); // For each Gop..
        for(h = 0; h < gops.length; h++){
            currentGop = gops[h]; // For each Frame..
            for(i = 0; i < currentGop.length; i++){
                currentFrame = currentGop[i]; // For each NAL..
                for(j = 0; j < currentFrame.length; j++){
                    currentNal = currentFrame[j];
                    view.setUint32(dataOffset, currentNal.data.byteLength);
                    dataOffset += 4;
                    data.set(currentNal.data, dataOffset);
                    dataOffset += currentNal.data.byteLength;
                }
            }
        }
        return data;
    }; // generate the track's sample table from a frame
    var generateSampleTableForFrame = function(frame, baseDataOffset) {
        var sample, dataOffset = baseDataOffset || 0, samples = [];
        sample = sampleForFrame(frame, dataOffset);
        samples.push(sample);
        return samples;
    }; // generate the track's raw mdat data from a frame
    var concatenateNalDataForFrame = function(frame) {
        var i, currentNal, dataOffset = 0, nalsByteLength = frame.byteLength, numberOfNals = frame.length, totalByteLength = nalsByteLength + 4 * numberOfNals, data = new Uint8Array(totalByteLength), view = new DataView(data.buffer); // For each NAL..
        for(i = 0; i < frame.length; i++){
            currentNal = frame[i];
            view.setUint32(dataOffset, currentNal.data.byteLength);
            dataOffset += 4;
            data.set(currentNal.data, dataOffset);
            dataOffset += currentNal.data.byteLength;
        }
        return data;
    };
    var frameUtils$1 = {
        groupNalsIntoFrames: groupNalsIntoFrames,
        groupFramesIntoGops: groupFramesIntoGops,
        extendFirstKeyFrame: extendFirstKeyFrame,
        generateSampleTable: generateSampleTable$1,
        concatenateNalData: concatenateNalData,
        generateSampleTableForFrame: generateSampleTableForFrame,
        concatenateNalDataForFrame: concatenateNalDataForFrame
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var highPrefix = [
        33,
        16,
        5,
        32,
        164,
        27
    ];
    var lowPrefix = [
        33,
        65,
        108,
        84,
        1,
        2,
        4,
        8,
        168,
        2,
        4,
        8,
        17,
        191,
        252
    ];
    var zeroFill = function(count) {
        var a = [];
        while(count--)a.push(0);
        return a;
    };
    var makeTable = function(metaTable) {
        return Object.keys(metaTable).reduce(function(obj, key) {
            obj[key] = new Uint8Array(metaTable[key].reduce(function(arr, part) {
                return arr.concat(part);
            }, []));
            return obj;
        }, {});
    };
    var silence;
    var silence_1 = function() {
        if (!silence) {
            // Frames-of-silence to use for filling in missing AAC frames
            var coneOfSilence = {
                96000: [
                    highPrefix,
                    [
                        227,
                        64
                    ],
                    zeroFill(154),
                    [
                        56
                    ]
                ],
                88200: [
                    highPrefix,
                    [
                        231
                    ],
                    zeroFill(170),
                    [
                        56
                    ]
                ],
                64000: [
                    highPrefix,
                    [
                        248,
                        192
                    ],
                    zeroFill(240),
                    [
                        56
                    ]
                ],
                48000: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        148,
                        128
                    ],
                    zeroFill(54),
                    [
                        112
                    ]
                ],
                44100: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        163,
                        128
                    ],
                    zeroFill(84),
                    [
                        112
                    ]
                ],
                32000: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        234
                    ],
                    zeroFill(226),
                    [
                        112
                    ]
                ],
                24000: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        255,
                        128
                    ],
                    zeroFill(268),
                    [
                        111,
                        112
                    ],
                    zeroFill(126),
                    [
                        224
                    ]
                ],
                16000: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        255,
                        128
                    ],
                    zeroFill(268),
                    [
                        111,
                        255
                    ],
                    zeroFill(269),
                    [
                        223,
                        108
                    ],
                    zeroFill(195),
                    [
                        1,
                        192
                    ]
                ],
                12000: [
                    lowPrefix,
                    zeroFill(268),
                    [
                        3,
                        127,
                        248
                    ],
                    zeroFill(268),
                    [
                        6,
                        255,
                        240
                    ],
                    zeroFill(268),
                    [
                        13,
                        255,
                        224
                    ],
                    zeroFill(268),
                    [
                        27,
                        253,
                        128
                    ],
                    zeroFill(259),
                    [
                        56
                    ]
                ],
                11025: [
                    lowPrefix,
                    zeroFill(268),
                    [
                        3,
                        127,
                        248
                    ],
                    zeroFill(268),
                    [
                        6,
                        255,
                        240
                    ],
                    zeroFill(268),
                    [
                        13,
                        255,
                        224
                    ],
                    zeroFill(268),
                    [
                        27,
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        175,
                        128
                    ],
                    zeroFill(108),
                    [
                        112
                    ]
                ],
                8000: [
                    lowPrefix,
                    zeroFill(268),
                    [
                        3,
                        121,
                        16
                    ],
                    zeroFill(47),
                    [
                        7
                    ]
                ]
            };
            silence = makeTable(coneOfSilence);
        }
        return silence;
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var ONE_SECOND_IN_TS$4 = 90000, // 90kHz clock
    secondsToVideoTs, secondsToAudioTs, videoTsToSeconds, audioTsToSeconds, audioTsToVideoTs, videoTsToAudioTs, metadataTsToSeconds;
    secondsToVideoTs = function(seconds) {
        return seconds * ONE_SECOND_IN_TS$4;
    };
    secondsToAudioTs = function(seconds, sampleRate) {
        return seconds * sampleRate;
    };
    videoTsToSeconds = function(timestamp) {
        return timestamp / ONE_SECOND_IN_TS$4;
    };
    audioTsToSeconds = function(timestamp, sampleRate) {
        return timestamp / sampleRate;
    };
    audioTsToVideoTs = function(timestamp, sampleRate) {
        return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
    };
    videoTsToAudioTs = function(timestamp, sampleRate) {
        return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
    };
    /**
   * Adjust ID3 tag or caption timing information by the timeline pts values
   * (if keepOriginalTimestamps is false) and convert to seconds
   */ metadataTsToSeconds = function(timestamp, timelineStartPts, keepOriginalTimestamps) {
        return videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
    };
    var clock$2 = {
        ONE_SECOND_IN_TS: ONE_SECOND_IN_TS$4,
        secondsToVideoTs: secondsToVideoTs,
        secondsToAudioTs: secondsToAudioTs,
        videoTsToSeconds: videoTsToSeconds,
        audioTsToSeconds: audioTsToSeconds,
        audioTsToVideoTs: audioTsToVideoTs,
        videoTsToAudioTs: videoTsToAudioTs,
        metadataTsToSeconds: metadataTsToSeconds
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var coneOfSilence = silence_1;
    var clock$1 = clock$2;
    /**
   * Sum the `byteLength` properties of the data in each AAC frame
   */ var sumFrameByteLengths = function(array) {
        var i, currentObj, sum = 0; // sum the byteLength's all each nal unit in the frame
        for(i = 0; i < array.length; i++){
            currentObj = array[i];
            sum += currentObj.data.byteLength;
        }
        return sum;
    }; // Possibly pad (prefix) the audio track with silence if appending this track
    // would lead to the introduction of a gap in the audio buffer
    var prefixWithSilence = function(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime) {
        var baseMediaDecodeTimeTs, frameDuration = 0, audioGapDuration = 0, audioFillFrameCount = 0, audioFillDuration = 0, silentFrame, i, firstFrame;
        if (!frames.length) return;
        baseMediaDecodeTimeTs = clock$1.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate); // determine frame clock duration based on sample rate, round up to avoid overfills
        frameDuration = Math.ceil(clock$1.ONE_SECOND_IN_TS / (track.samplerate / 1024));
        if (audioAppendStartTs && videoBaseMediaDecodeTime) {
            // insert the shortest possible amount (audio gap or audio to video gap)
            audioGapDuration = baseMediaDecodeTimeTs - Math.max(audioAppendStartTs, videoBaseMediaDecodeTime); // number of full frames in the audio gap
            audioFillFrameCount = Math.floor(audioGapDuration / frameDuration);
            audioFillDuration = audioFillFrameCount * frameDuration;
        } // don't attempt to fill gaps smaller than a single frame or larger
        // than a half second
        if (audioFillFrameCount < 1 || audioFillDuration > clock$1.ONE_SECOND_IN_TS / 2) return;
        silentFrame = coneOfSilence()[track.samplerate];
        if (!silentFrame) // we don't have a silent frame pregenerated for the sample rate, so use a frame
        // from the content instead
        silentFrame = frames[0].data;
        for(i = 0; i < audioFillFrameCount; i++){
            firstFrame = frames[0];
            frames.splice(0, 0, {
                data: silentFrame,
                dts: firstFrame.dts - frameDuration,
                pts: firstFrame.pts - frameDuration
            });
        }
        track.baseMediaDecodeTime -= Math.floor(clock$1.videoTsToAudioTs(audioFillDuration, track.samplerate));
        return audioFillDuration;
    }; // If the audio segment extends before the earliest allowed dts
    // value, remove AAC frames until starts at or after the earliest
    // allowed DTS so that we don't end up with a negative baseMedia-
    // DecodeTime for the audio track
    var trimAdtsFramesByEarliestDts = function(adtsFrames, track, earliestAllowedDts) {
        if (track.minSegmentDts >= earliestAllowedDts) return adtsFrames;
         // We will need to recalculate the earliest segment Dts
        track.minSegmentDts = Infinity;
        return adtsFrames.filter(function(currentFrame) {
            // If this is an allowed frame, keep it and record it's Dts
            if (currentFrame.dts >= earliestAllowedDts) {
                track.minSegmentDts = Math.min(track.minSegmentDts, currentFrame.dts);
                track.minSegmentPts = track.minSegmentDts;
                return true;
            } // Otherwise, discard it
            return false;
        });
    }; // generate the track's raw mdat data from an array of frames
    var generateSampleTable = function(frames) {
        var i, currentFrame, samples = [];
        for(i = 0; i < frames.length; i++){
            currentFrame = frames[i];
            samples.push({
                size: currentFrame.data.byteLength,
                duration: 1024 // For AAC audio, all samples contain 1024 samples
            });
        }
        return samples;
    }; // generate the track's sample table from an array of frames
    var concatenateFrameData = function(frames) {
        var i, currentFrame, dataOffset = 0, data = new Uint8Array(sumFrameByteLengths(frames));
        for(i = 0; i < frames.length; i++){
            currentFrame = frames[i];
            data.set(currentFrame.data, dataOffset);
            dataOffset += currentFrame.data.byteLength;
        }
        return data;
    };
    var audioFrameUtils$1 = {
        prefixWithSilence: prefixWithSilence,
        trimAdtsFramesByEarliestDts: trimAdtsFramesByEarliestDts,
        generateSampleTable: generateSampleTable,
        concatenateFrameData: concatenateFrameData
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var ONE_SECOND_IN_TS$3 = clock$2.ONE_SECOND_IN_TS;
    /**
   * Store information about the start and end of the track and the
   * duration for each frame/sample we process in order to calculate
   * the baseMediaDecodeTime
   */ var collectDtsInfo = function(track, data) {
        if (typeof data.pts === 'number') {
            if (track.timelineStartInfo.pts === undefined) track.timelineStartInfo.pts = data.pts;
            if (track.minSegmentPts === undefined) track.minSegmentPts = data.pts;
            else track.minSegmentPts = Math.min(track.minSegmentPts, data.pts);
            if (track.maxSegmentPts === undefined) track.maxSegmentPts = data.pts;
            else track.maxSegmentPts = Math.max(track.maxSegmentPts, data.pts);
        }
        if (typeof data.dts === 'number') {
            if (track.timelineStartInfo.dts === undefined) track.timelineStartInfo.dts = data.dts;
            if (track.minSegmentDts === undefined) track.minSegmentDts = data.dts;
            else track.minSegmentDts = Math.min(track.minSegmentDts, data.dts);
            if (track.maxSegmentDts === undefined) track.maxSegmentDts = data.dts;
            else track.maxSegmentDts = Math.max(track.maxSegmentDts, data.dts);
        }
    };
    /**
   * Clear values used to calculate the baseMediaDecodeTime between
   * tracks
   */ var clearDtsInfo = function(track) {
        delete track.minSegmentDts;
        delete track.maxSegmentDts;
        delete track.minSegmentPts;
        delete track.maxSegmentPts;
    };
    /**
   * Calculate the track's baseMediaDecodeTime based on the earliest
   * DTS the transmuxer has ever seen and the minimum DTS for the
   * current track
   * @param track {object} track metadata configuration
   * @param keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */ var calculateTrackBaseMediaDecodeTime = function(track, keepOriginalTimestamps) {
        var baseMediaDecodeTime, scale, minSegmentDts = track.minSegmentDts; // Optionally adjust the time so the first segment starts at zero.
        if (!keepOriginalTimestamps) minSegmentDts -= track.timelineStartInfo.dts;
         // track.timelineStartInfo.baseMediaDecodeTime is the location, in time, where
        // we want the start of the first segment to be placed
        baseMediaDecodeTime = track.timelineStartInfo.baseMediaDecodeTime; // Add to that the distance this segment is from the very first
        baseMediaDecodeTime += minSegmentDts; // baseMediaDecodeTime must not become negative
        baseMediaDecodeTime = Math.max(0, baseMediaDecodeTime);
        if (track.type === 'audio') {
            // Audio has a different clock equal to the sampling_rate so we need to
            // scale the PTS values into the clock rate of the track
            scale = track.samplerate / ONE_SECOND_IN_TS$3;
            baseMediaDecodeTime *= scale;
            baseMediaDecodeTime = Math.floor(baseMediaDecodeTime);
        }
        return baseMediaDecodeTime;
    };
    var trackDecodeInfo$1 = {
        clearDtsInfo: clearDtsInfo,
        calculateTrackBaseMediaDecodeTime: calculateTrackBaseMediaDecodeTime,
        collectDtsInfo: collectDtsInfo
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Reads in-band caption information from a video elementary
   * stream. Captions must follow the CEA-708 standard for injection
   * into an MPEG-2 transport streams.
   * @see https://en.wikipedia.org/wiki/CEA-708
   * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
   */ // payload type field to indicate how they are to be
    // interpreted. CEAS-708 caption content is always transmitted with
    // payload type 0x04.
    var USER_DATA_REGISTERED_ITU_T_T35 = 4, RBSP_TRAILING_BITS = 128;
    /**
    * Parse a supplemental enhancement information (SEI) NAL unit.
    * Stops parsing once a message of type ITU T T35 has been found.
    *
    * @param bytes {Uint8Array} the bytes of a SEI NAL unit
    * @return {object} the parsed SEI payload
    * @see Rec. ITU-T H.264, 7.3.2.3.1
    */ var parseSei = function(bytes) {
        var i = 0, result = {
            payloadType: -1,
            payloadSize: 0
        }, payloadType = 0, payloadSize = 0; // go through the sei_rbsp parsing each each individual sei_message
        while(i < bytes.byteLength){
            // stop once we have hit the end of the sei_rbsp
            if (bytes[i] === RBSP_TRAILING_BITS) break;
             // Parse payload type
            while(bytes[i] === 0xFF){
                payloadType += 255;
                i++;
            }
            payloadType += bytes[i++]; // Parse payload size
            while(bytes[i] === 0xFF){
                payloadSize += 255;
                i++;
            }
            payloadSize += bytes[i++]; // this sei_message is a 608/708 caption so save it and break
            // there can only ever be one caption message in a frame's sei
            if (!result.payload && payloadType === USER_DATA_REGISTERED_ITU_T_T35) {
                var userIdentifier = String.fromCharCode(bytes[i + 3], bytes[i + 4], bytes[i + 5], bytes[i + 6]);
                if (userIdentifier === 'GA94') {
                    result.payloadType = payloadType;
                    result.payloadSize = payloadSize;
                    result.payload = bytes.subarray(i, i + payloadSize);
                    break;
                } else result.payload = void 0;
            } // skip the payload and parse the next message
            i += payloadSize;
            payloadType = 0;
            payloadSize = 0;
        }
        return result;
    }; // see ANSI/SCTE 128-1 (2013), section 8.1
    var parseUserData = function(sei) {
        // itu_t_t35_contry_code must be 181 (United States) for
        // captions
        if (sei.payload[0] !== 181) return null;
         // itu_t_t35_provider_code should be 49 (ATSC) for captions
        if ((sei.payload[1] << 8 | sei.payload[2]) !== 49) return null;
         // the user_identifier should be "GA94" to indicate ATSC1 data
        if (String.fromCharCode(sei.payload[3], sei.payload[4], sei.payload[5], sei.payload[6]) !== 'GA94') return null;
         // finally, user_data_type_code should be 0x03 for caption data
        if (sei.payload[7] !== 0x03) return null;
         // return the user_data_type_structure and strip the trailing
        // marker bits
        return sei.payload.subarray(8, sei.payload.length - 1);
    }; // see CEA-708-D, section 4.4
    var parseCaptionPackets = function(pts, userData) {
        var results = [], i, count, offset, data; // if this is just filler, return immediately
        if (!(userData[0] & 0x40)) return results;
         // parse out the cc_data_1 and cc_data_2 fields
        count = userData[0] & 0x1f;
        for(i = 0; i < count; i++){
            offset = i * 3;
            data = {
                type: userData[offset + 2] & 0x03,
                pts: pts
            }; // capture cc data when cc_valid is 1
            if (userData[offset + 2] & 0x04) {
                data.ccData = userData[offset + 3] << 8 | userData[offset + 4];
                results.push(data);
            }
        }
        return results;
    };
    var discardEmulationPreventionBytes$1 = function(data) {
        var length = data.byteLength, emulationPreventionBytesPositions = [], i = 1, newLength, newData; // Find all `Emulation Prevention Bytes`
        while(i < length - 2)if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
            emulationPreventionBytesPositions.push(i + 2);
            i += 2;
        } else i++;
         // If no Emulation Prevention Bytes were found just return the original
        // array
        if (emulationPreventionBytesPositions.length === 0) return data;
         // Create a new array to hold the NAL unit data
        newLength = length - emulationPreventionBytesPositions.length;
        newData = new Uint8Array(newLength);
        var sourceIndex = 0;
        for(i = 0; i < newLength; sourceIndex++, i++){
            if (sourceIndex === emulationPreventionBytesPositions[0]) {
                // Skip this byte
                sourceIndex++; // Remove this position index
                emulationPreventionBytesPositions.shift();
            }
            newData[i] = data[sourceIndex];
        }
        return newData;
    }; // exports
    var captionPacketParser = {
        parseSei: parseSei,
        parseUserData: parseUserData,
        parseCaptionPackets: parseCaptionPackets,
        discardEmulationPreventionBytes: discardEmulationPreventionBytes$1,
        USER_DATA_REGISTERED_ITU_T_T35: USER_DATA_REGISTERED_ITU_T_T35
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Reads in-band caption information from a video elementary
   * stream. Captions must follow the CEA-708 standard for injection
   * into an MPEG-2 transport streams.
   * @see https://en.wikipedia.org/wiki/CEA-708
   * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
   */ // Link To Transport
    // -----------------
    var Stream$7 = stream;
    var cea708Parser = captionPacketParser;
    var CaptionStream$2 = function(options) {
        options = options || {};
        CaptionStream$2.prototype.init.call(this); // parse708captions flag, default to true
        this.parse708captions_ = typeof options.parse708captions === 'boolean' ? options.parse708captions : true;
        this.captionPackets_ = [];
        this.ccStreams_ = [
            new Cea608Stream(0, 0),
            // eslint-disable-line no-use-before-define
            new Cea608Stream(0, 1),
            // eslint-disable-line no-use-before-define
            new Cea608Stream(1, 0),
            // eslint-disable-line no-use-before-define
            new Cea608Stream(1, 1) // eslint-disable-line no-use-before-define
        ];
        if (this.parse708captions_) this.cc708Stream_ = new Cea708Stream({
            captionServices: options.captionServices
        }); // eslint-disable-line no-use-before-define
        this.reset(); // forward data and done events from CCs to this CaptionStream
        this.ccStreams_.forEach(function(cc) {
            cc.on('data', this.trigger.bind(this, 'data'));
            cc.on('partialdone', this.trigger.bind(this, 'partialdone'));
            cc.on('done', this.trigger.bind(this, 'done'));
        }, this);
        if (this.parse708captions_) {
            this.cc708Stream_.on('data', this.trigger.bind(this, 'data'));
            this.cc708Stream_.on('partialdone', this.trigger.bind(this, 'partialdone'));
            this.cc708Stream_.on('done', this.trigger.bind(this, 'done'));
        }
    };
    CaptionStream$2.prototype = new Stream$7();
    CaptionStream$2.prototype.push = function(event) {
        var sei, userData, newCaptionPackets; // only examine SEI NALs
        if (event.nalUnitType !== 'sei_rbsp') return;
         // parse the sei
        sei = cea708Parser.parseSei(event.escapedRBSP); // no payload data, skip
        if (!sei.payload) return;
         // ignore everything but user_data_registered_itu_t_t35
        if (sei.payloadType !== cea708Parser.USER_DATA_REGISTERED_ITU_T_T35) return;
         // parse out the user data payload
        userData = cea708Parser.parseUserData(sei); // ignore unrecognized userData
        if (!userData) return;
         // Sometimes, the same segment # will be downloaded twice. To stop the
        // caption data from being processed twice, we track the latest dts we've
        // received and ignore everything with a dts before that. However, since
        // data for a specific dts can be split across packets on either side of
        // a segment boundary, we need to make sure we *don't* ignore the packets
        // from the *next* segment that have dts === this.latestDts_. By constantly
        // tracking the number of packets received with dts === this.latestDts_, we
        // know how many should be ignored once we start receiving duplicates.
        if (event.dts < this.latestDts_) {
            // We've started getting older data, so set the flag.
            this.ignoreNextEqualDts_ = true;
            return;
        } else if (event.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
            this.numSameDts_--;
            if (!this.numSameDts_) // We've received the last duplicate packet, time to start processing again
            this.ignoreNextEqualDts_ = false;
            return;
        } // parse out CC data packets and save them for later
        newCaptionPackets = cea708Parser.parseCaptionPackets(event.pts, userData);
        this.captionPackets_ = this.captionPackets_.concat(newCaptionPackets);
        if (this.latestDts_ !== event.dts) this.numSameDts_ = 0;
        this.numSameDts_++;
        this.latestDts_ = event.dts;
    };
    CaptionStream$2.prototype.flushCCStreams = function(flushType) {
        this.ccStreams_.forEach(function(cc) {
            return flushType === 'flush' ? cc.flush() : cc.partialFlush();
        }, this);
    };
    CaptionStream$2.prototype.flushStream = function(flushType) {
        // make sure we actually parsed captions before proceeding
        if (!this.captionPackets_.length) {
            this.flushCCStreams(flushType);
            return;
        } // In Chrome, the Array#sort function is not stable so add a
        // presortIndex that we can use to ensure we get a stable-sort
        this.captionPackets_.forEach(function(elem, idx) {
            elem.presortIndex = idx;
        }); // sort caption byte-pairs based on their PTS values
        this.captionPackets_.sort(function(a, b) {
            if (a.pts === b.pts) return a.presortIndex - b.presortIndex;
            return a.pts - b.pts;
        });
        this.captionPackets_.forEach(function(packet) {
            if (packet.type < 2) // Dispatch packet to the right Cea608Stream
            this.dispatchCea608Packet(packet);
            else // Dispatch packet to the Cea708Stream
            this.dispatchCea708Packet(packet);
        }, this);
        this.captionPackets_.length = 0;
        this.flushCCStreams(flushType);
    };
    CaptionStream$2.prototype.flush = function() {
        return this.flushStream('flush');
    }; // Only called if handling partial data
    CaptionStream$2.prototype.partialFlush = function() {
        return this.flushStream('partialFlush');
    };
    CaptionStream$2.prototype.reset = function() {
        this.latestDts_ = null;
        this.ignoreNextEqualDts_ = false;
        this.numSameDts_ = 0;
        this.activeCea608Channel_ = [
            null,
            null
        ];
        this.ccStreams_.forEach(function(ccStream) {
            ccStream.reset();
        });
    }; // From the CEA-608 spec:
    /*
   * When XDS sub-packets are interleaved with other services, the end of each sub-packet shall be followed
   * by a control pair to change to a different service. When any of the control codes from 0x10 to 0x1F is
   * used to begin a control code pair, it indicates the return to captioning or Text data. The control code pair
   * and subsequent data should then be processed according to the FCC rules. It may be necessary for the
   * line 21 data encoder to automatically insert a control code pair (i.e. RCL, RU2, RU3, RU4, RDC, or RTD)
   * to switch to captioning or Text.
  */ // With that in mind, we ignore any data between an XDS control code and a
    // subsequent closed-captioning control code.
    CaptionStream$2.prototype.dispatchCea608Packet = function(packet) {
        // NOTE: packet.type is the CEA608 field
        if (this.setsTextOrXDSActive(packet)) this.activeCea608Channel_[packet.type] = null;
        else if (this.setsChannel1Active(packet)) this.activeCea608Channel_[packet.type] = 0;
        else if (this.setsChannel2Active(packet)) this.activeCea608Channel_[packet.type] = 1;
        if (this.activeCea608Channel_[packet.type] === null) // If we haven't received anything to set the active channel, or the
        // packets are Text/XDS data, discard the data; we don't want jumbled
        // captions
        return;
        this.ccStreams_[(packet.type << 1) + this.activeCea608Channel_[packet.type]].push(packet);
    };
    CaptionStream$2.prototype.setsChannel1Active = function(packet) {
        return (packet.ccData & 0x7800) === 0x1000;
    };
    CaptionStream$2.prototype.setsChannel2Active = function(packet) {
        return (packet.ccData & 0x7800) === 0x1800;
    };
    CaptionStream$2.prototype.setsTextOrXDSActive = function(packet) {
        return (packet.ccData & 0x7100) === 0x0100 || (packet.ccData & 0x78fe) === 0x102a || (packet.ccData & 0x78fe) === 0x182a;
    };
    CaptionStream$2.prototype.dispatchCea708Packet = function(packet) {
        if (this.parse708captions_) this.cc708Stream_.push(packet);
    }; // ----------------------
    // Session to Application
    // ----------------------
    // This hash maps special and extended character codes to their
    // proper Unicode equivalent. The first one-byte key is just a
    // non-standard character code. The two-byte keys that follow are
    // the extended CEA708 character codes, along with the preceding
    // 0x10 extended character byte to distinguish these codes from
    // non-extended character codes. Every CEA708 character code that
    // is not in this object maps directly to a standard unicode
    // character code.
    // The transparent space and non-breaking transparent space are
    // technically not fully supported since there is no code to
    // make them transparent, so they have normal non-transparent
    // stand-ins.
    // The special closed caption (CC) character isn't a standard
    // unicode character, so a fairly similar unicode character was
    // chosen in it's place.
    var CHARACTER_TRANSLATION_708 = {
        0x7f: 0x266a,
        // ♪
        0x1020: 0x20,
        // Transparent Space
        0x1021: 0xa0,
        // Nob-breaking Transparent Space
        0x1025: 0x2026,
        // …
        0x102a: 0x0160,
        // Š
        0x102c: 0x0152,
        // Œ
        0x1030: 0x2588,
        // █
        0x1031: 0x2018,
        // ‘
        0x1032: 0x2019,
        // ’
        0x1033: 0x201c,
        // “
        0x1034: 0x201d,
        // ”
        0x1035: 0x2022,
        // •
        0x1039: 0x2122,
        // ™
        0x103a: 0x0161,
        // š
        0x103c: 0x0153,
        // œ
        0x103d: 0x2120,
        // ℠
        0x103f: 0x0178,
        // Ÿ
        0x1076: 0x215b,
        // ⅛
        0x1077: 0x215c,
        // ⅜
        0x1078: 0x215d,
        // ⅝
        0x1079: 0x215e,
        // ⅞
        0x107a: 0x23d0,
        // ⏐
        0x107b: 0x23a4,
        // ⎤
        0x107c: 0x23a3,
        // ⎣
        0x107d: 0x23af,
        // ⎯
        0x107e: 0x23a6,
        // ⎦
        0x107f: 0x23a1,
        // ⎡
        0x10a0: 0x3138 // ㄸ (CC char)
    };
    var get708CharFromCode = function(code) {
        var newCode = CHARACTER_TRANSLATION_708[code] || code;
        if (code & 0x1000 && code === newCode) // Invalid extended code
        return '';
        return String.fromCharCode(newCode);
    };
    var within708TextBlock = function(b) {
        return 0x20 <= b && b <= 0x7f || 0xa0 <= b && b <= 0xff;
    };
    var Cea708Window = function(windowNum) {
        this.windowNum = windowNum;
        this.reset();
    };
    Cea708Window.prototype.reset = function() {
        this.clearText();
        this.pendingNewLine = false;
        this.winAttr = {};
        this.penAttr = {};
        this.penLoc = {};
        this.penColor = {}; // These default values are arbitrary,
        // defineWindow will usually override them
        this.visible = 0;
        this.rowLock = 0;
        this.columnLock = 0;
        this.priority = 0;
        this.relativePositioning = 0;
        this.anchorVertical = 0;
        this.anchorHorizontal = 0;
        this.anchorPoint = 0;
        this.rowCount = 1;
        this.virtualRowCount = this.rowCount + 1;
        this.columnCount = 41;
        this.windowStyle = 0;
        this.penStyle = 0;
    };
    Cea708Window.prototype.getText = function() {
        return this.rows.join('\n');
    };
    Cea708Window.prototype.clearText = function() {
        this.rows = [
            ''
        ];
        this.rowIdx = 0;
    };
    Cea708Window.prototype.newLine = function(pts) {
        if (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow === 'function') this.beforeRowOverflow(pts);
        if (this.rows.length > 0) {
            this.rows.push('');
            this.rowIdx++;
        } // Show all virtual rows since there's no visible scrolling
        while(this.rows.length > this.virtualRowCount){
            this.rows.shift();
            this.rowIdx--;
        }
    };
    Cea708Window.prototype.isEmpty = function() {
        if (this.rows.length === 0) return true;
        else if (this.rows.length === 1) return this.rows[0] === '';
        return false;
    };
    Cea708Window.prototype.addText = function(text) {
        this.rows[this.rowIdx] += text;
    };
    Cea708Window.prototype.backspace = function() {
        if (!this.isEmpty()) {
            var row = this.rows[this.rowIdx];
            this.rows[this.rowIdx] = row.substr(0, row.length - 1);
        }
    };
    var Cea708Service = function(serviceNum, encoding, stream) {
        this.serviceNum = serviceNum;
        this.text = '';
        this.currentWindow = new Cea708Window(-1);
        this.windows = [];
        this.stream = stream; // Try to setup a TextDecoder if an `encoding` value was provided
        if (typeof encoding === 'string') this.createTextDecoder(encoding);
    };
    /**
   * Initialize service windows
   * Must be run before service use
   *
   * @param  {Integer}  pts               PTS value
   * @param  {Function} beforeRowOverflow Function to execute before row overflow of a window
   */ Cea708Service.prototype.init = function(pts, beforeRowOverflow) {
        this.startPts = pts;
        for(var win = 0; win < 8; win++){
            this.windows[win] = new Cea708Window(win);
            if (typeof beforeRowOverflow === 'function') this.windows[win].beforeRowOverflow = beforeRowOverflow;
        }
    };
    /**
   * Set current window of service to be affected by commands
   *
   * @param  {Integer} windowNum Window number
   */ Cea708Service.prototype.setCurrentWindow = function(windowNum) {
        this.currentWindow = this.windows[windowNum];
    };
    /**
   * Try to create a TextDecoder if it is natively supported
   */ Cea708Service.prototype.createTextDecoder = function(encoding) {
        if (typeof TextDecoder === 'undefined') this.stream.trigger('log', {
            level: 'warn',
            message: 'The `encoding` option is unsupported without TextDecoder support'
        });
        else try {
            this.textDecoder_ = new TextDecoder(encoding);
        } catch (error) {
            this.stream.trigger('log', {
                level: 'warn',
                message: 'TextDecoder could not be created with ' + encoding + ' encoding. ' + error
            });
        }
    };
    var Cea708Stream = function(options) {
        options = options || {};
        Cea708Stream.prototype.init.call(this);
        var self1 = this;
        var captionServices = options.captionServices || {};
        var captionServiceEncodings = {};
        var serviceProps; // Get service encodings from captionServices option block
        Object.keys(captionServices).forEach((serviceName)=>{
            serviceProps = captionServices[serviceName];
            if (/^SERVICE/.test(serviceName)) captionServiceEncodings[serviceName] = serviceProps.encoding;
        });
        this.serviceEncodings = captionServiceEncodings;
        this.current708Packet = null;
        this.services = {};
        this.push = function(packet) {
            if (packet.type === 3) {
                // 708 packet start
                self1.new708Packet();
                self1.add708Bytes(packet);
            } else {
                if (self1.current708Packet === null) // This should only happen at the start of a file if there's no packet start.
                self1.new708Packet();
                self1.add708Bytes(packet);
            }
        };
    };
    Cea708Stream.prototype = new Stream$7();
    /**
   * Push current 708 packet, create new 708 packet.
   */ Cea708Stream.prototype.new708Packet = function() {
        if (this.current708Packet !== null) this.push708Packet();
        this.current708Packet = {
            data: [],
            ptsVals: []
        };
    };
    /**
   * Add pts and both bytes from packet into current 708 packet.
   */ Cea708Stream.prototype.add708Bytes = function(packet) {
        var data = packet.ccData;
        var byte0 = data >>> 8;
        var byte1 = data & 0xff; // I would just keep a list of packets instead of bytes, but it isn't clear in the spec
        // that service blocks will always line up with byte pairs.
        this.current708Packet.ptsVals.push(packet.pts);
        this.current708Packet.data.push(byte0);
        this.current708Packet.data.push(byte1);
    };
    /**
   * Parse completed 708 packet into service blocks and push each service block.
   */ Cea708Stream.prototype.push708Packet = function() {
        var packet708 = this.current708Packet;
        var packetData = packet708.data;
        var serviceNum = null;
        var blockSize = null;
        var i = 0;
        var b = packetData[i++];
        packet708.seq = b >> 6;
        packet708.sizeCode = b & 0x3f; // 0b00111111;
        for(; i < packetData.length; i++){
            b = packetData[i++];
            serviceNum = b >> 5;
            blockSize = b & 0x1f; // 0b00011111
            if (serviceNum === 7 && blockSize > 0) {
                // Extended service num
                b = packetData[i++];
                serviceNum = b;
            }
            this.pushServiceBlock(serviceNum, i, blockSize);
            if (blockSize > 0) i += blockSize - 1;
        }
    };
    /**
   * Parse service block, execute commands, read text.
   *
   * Note: While many of these commands serve important purposes,
   * many others just parse out the parameters or attributes, but
   * nothing is done with them because this is not a full and complete
   * implementation of the entire 708 spec.
   *
   * @param  {Integer} serviceNum Service number
   * @param  {Integer} start      Start index of the 708 packet data
   * @param  {Integer} size       Block size
   */ Cea708Stream.prototype.pushServiceBlock = function(serviceNum, start, size) {
        var b;
        var i = start;
        var packetData = this.current708Packet.data;
        var service = this.services[serviceNum];
        if (!service) service = this.initService(serviceNum, i);
        for(; i < start + size && i < packetData.length; i++){
            b = packetData[i];
            if (within708TextBlock(b)) i = this.handleText(i, service);
            else if (b === 0x18) i = this.multiByteCharacter(i, service);
            else if (b === 0x10) i = this.extendedCommands(i, service);
            else if (0x80 <= b && b <= 0x87) i = this.setCurrentWindow(i, service);
            else if (0x98 <= b && b <= 0x9f) i = this.defineWindow(i, service);
            else if (b === 0x88) i = this.clearWindows(i, service);
            else if (b === 0x8c) i = this.deleteWindows(i, service);
            else if (b === 0x89) i = this.displayWindows(i, service);
            else if (b === 0x8a) i = this.hideWindows(i, service);
            else if (b === 0x8b) i = this.toggleWindows(i, service);
            else if (b === 0x97) i = this.setWindowAttributes(i, service);
            else if (b === 0x90) i = this.setPenAttributes(i, service);
            else if (b === 0x91) i = this.setPenColor(i, service);
            else if (b === 0x92) i = this.setPenLocation(i, service);
            else if (b === 0x8f) service = this.reset(i, service);
            else if (b === 0x08) // BS: Backspace
            service.currentWindow.backspace();
            else if (b === 0x0c) // FF: Form feed
            service.currentWindow.clearText();
            else if (b === 0x0d) // CR: Carriage return
            service.currentWindow.pendingNewLine = true;
            else if (b === 0x0e) // HCR: Horizontal carriage return
            service.currentWindow.clearText();
            else if (b === 0x8d) // DLY: Delay, nothing to do
            i++;
        }
    };
    /**
   * Execute an extended command
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.extendedCommands = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        if (within708TextBlock(b)) i = this.handleText(i, service, {
            isExtended: true
        });
        return i;
    };
    /**
   * Get PTS value of a given byte index
   *
   * @param  {Integer} byteIndex  Index of the byte
   * @return {Integer}            PTS
   */ Cea708Stream.prototype.getPts = function(byteIndex) {
        // There's 1 pts value per 2 bytes
        return this.current708Packet.ptsVals[Math.floor(byteIndex / 2)];
    };
    /**
   * Initializes a service
   *
   * @param  {Integer} serviceNum Service number
   * @return {Service}            Initialized service object
   */ Cea708Stream.prototype.initService = function(serviceNum, i) {
        var serviceName = 'SERVICE' + serviceNum;
        var self1 = this;
        var serviceName;
        var encoding;
        if (serviceName in this.serviceEncodings) encoding = this.serviceEncodings[serviceName];
        this.services[serviceNum] = new Cea708Service(serviceNum, encoding, self1);
        this.services[serviceNum].init(this.getPts(i), function(pts) {
            self1.flushDisplayed(pts, self1.services[serviceNum]);
        });
        return this.services[serviceNum];
    };
    /**
   * Execute text writing to current window
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.handleText = function(i, service, options) {
        var isExtended = options && options.isExtended;
        var isMultiByte = options && options.isMultiByte;
        var packetData = this.current708Packet.data;
        var extended = isExtended ? 0x1000 : 0x0000;
        var currentByte = packetData[i];
        var nextByte = packetData[i + 1];
        var win = service.currentWindow;
        var char;
        var charCodeArray; // Converts an array of bytes to a unicode hex string.
        function toHexString(byteArray) {
            return byteArray.map((byte)=>{
                return ('0' + (byte & 0xFF).toString(16)).slice(-2);
            }).join('');
        }
        if (isMultiByte) {
            charCodeArray = [
                currentByte,
                nextByte
            ];
            i++;
        } else charCodeArray = [
            currentByte
        ];
         // Use the TextDecoder if one was created for this service
        if (service.textDecoder_ && !isExtended) char = service.textDecoder_.decode(new Uint8Array(charCodeArray));
        else // We assume any multi-byte char without a decoder is unicode.
        if (isMultiByte) {
            const unicode = toHexString(charCodeArray); // Takes a unicode hex string and creates a single character.
            char = String.fromCharCode(parseInt(unicode, 16));
        } else char = get708CharFromCode(extended | currentByte);
        if (win.pendingNewLine && !win.isEmpty()) win.newLine(this.getPts(i));
        win.pendingNewLine = false;
        win.addText(char);
        return i;
    };
    /**
   * Handle decoding of multibyte character
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.multiByteCharacter = function(i, service) {
        var packetData = this.current708Packet.data;
        var firstByte = packetData[i + 1];
        var secondByte = packetData[i + 2];
        if (within708TextBlock(firstByte) && within708TextBlock(secondByte)) i = this.handleText(++i, service, {
            isMultiByte: true
        });
        return i;
    };
    /**
   * Parse and execute the CW# command.
   *
   * Set the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setCurrentWindow = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var windowNum = b & 0x07;
        service.setCurrentWindow(windowNum);
        return i;
    };
    /**
   * Parse and execute the DF# command.
   *
   * Define a window and set it as the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.defineWindow = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var windowNum = b & 0x07;
        service.setCurrentWindow(windowNum);
        var win = service.currentWindow;
        b = packetData[++i];
        win.visible = (b & 0x20) >> 5; // v
        win.rowLock = (b & 0x10) >> 4; // rl
        win.columnLock = (b & 0x08) >> 3; // cl
        win.priority = b & 0x07; // p
        b = packetData[++i];
        win.relativePositioning = (b & 0x80) >> 7; // rp
        win.anchorVertical = b & 0x7f; // av
        b = packetData[++i];
        win.anchorHorizontal = b; // ah
        b = packetData[++i];
        win.anchorPoint = (b & 0xf0) >> 4; // ap
        win.rowCount = b & 0x0f; // rc
        b = packetData[++i];
        win.columnCount = b & 0x3f; // cc
        b = packetData[++i];
        win.windowStyle = (b & 0x38) >> 3; // ws
        win.penStyle = b & 0x07; // ps
        // The spec says there are (rowCount+1) "virtual rows"
        win.virtualRowCount = win.rowCount + 1;
        return i;
    };
    /**
   * Parse and execute the SWA command.
   *
   * Set attributes of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setWindowAttributes = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var winAttr = service.currentWindow.winAttr;
        b = packetData[++i];
        winAttr.fillOpacity = (b & 0xc0) >> 6; // fo
        winAttr.fillRed = (b & 0x30) >> 4; // fr
        winAttr.fillGreen = (b & 0x0c) >> 2; // fg
        winAttr.fillBlue = b & 0x03; // fb
        b = packetData[++i];
        winAttr.borderType = (b & 0xc0) >> 6; // bt
        winAttr.borderRed = (b & 0x30) >> 4; // br
        winAttr.borderGreen = (b & 0x0c) >> 2; // bg
        winAttr.borderBlue = b & 0x03; // bb
        b = packetData[++i];
        winAttr.borderType += (b & 0x80) >> 5; // bt
        winAttr.wordWrap = (b & 0x40) >> 6; // ww
        winAttr.printDirection = (b & 0x30) >> 4; // pd
        winAttr.scrollDirection = (b & 0x0c) >> 2; // sd
        winAttr.justify = b & 0x03; // j
        b = packetData[++i];
        winAttr.effectSpeed = (b & 0xf0) >> 4; // es
        winAttr.effectDirection = (b & 0x0c) >> 2; // ed
        winAttr.displayEffect = b & 0x03; // de
        return i;
    };
    /**
   * Gather text from all displayed windows and push a caption to output.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   */ Cea708Stream.prototype.flushDisplayed = function(pts, service) {
        var displayedText = []; // TODO: Positioning not supported, displaying multiple windows will not necessarily
        // display text in the correct order, but sample files so far have not shown any issue.
        for(var winId = 0; winId < 8; winId++)if (service.windows[winId].visible && !service.windows[winId].isEmpty()) displayedText.push(service.windows[winId].getText());
        service.endPts = pts;
        service.text = displayedText.join('\n\n');
        this.pushCaption(service);
        service.startPts = pts;
    };
    /**
   * Push a caption to output if the caption contains text.
   *
   * @param  {Service} service  The service object to be affected
   */ Cea708Stream.prototype.pushCaption = function(service) {
        if (service.text !== '') {
            this.trigger('data', {
                startPts: service.startPts,
                endPts: service.endPts,
                text: service.text,
                stream: 'cc708_' + service.serviceNum
            });
            service.text = '';
            service.startPts = service.endPts;
        }
    };
    /**
   * Parse and execute the DSW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.displayWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].visible = 1;
        return i;
    };
    /**
   * Parse and execute the HDW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.hideWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].visible = 0;
        return i;
    };
    /**
   * Parse and execute the TGW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.toggleWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].visible ^= 1;
        return i;
    };
    /**
   * Parse and execute the CLW command.
   *
   * Clear text of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.clearWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].clearText();
        return i;
    };
    /**
   * Parse and execute the DLW command.
   *
   * Re-initialize windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.deleteWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].reset();
        return i;
    };
    /**
   * Parse and execute the SPA command.
   *
   * Set pen attributes of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setPenAttributes = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var penAttr = service.currentWindow.penAttr;
        b = packetData[++i];
        penAttr.textTag = (b & 0xf0) >> 4; // tt
        penAttr.offset = (b & 0x0c) >> 2; // o
        penAttr.penSize = b & 0x03; // s
        b = packetData[++i];
        penAttr.italics = (b & 0x80) >> 7; // i
        penAttr.underline = (b & 0x40) >> 6; // u
        penAttr.edgeType = (b & 0x38) >> 3; // et
        penAttr.fontStyle = b & 0x07; // fs
        return i;
    };
    /**
   * Parse and execute the SPC command.
   *
   * Set pen color of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setPenColor = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var penColor = service.currentWindow.penColor;
        b = packetData[++i];
        penColor.fgOpacity = (b & 0xc0) >> 6; // fo
        penColor.fgRed = (b & 0x30) >> 4; // fr
        penColor.fgGreen = (b & 0x0c) >> 2; // fg
        penColor.fgBlue = b & 0x03; // fb
        b = packetData[++i];
        penColor.bgOpacity = (b & 0xc0) >> 6; // bo
        penColor.bgRed = (b & 0x30) >> 4; // br
        penColor.bgGreen = (b & 0x0c) >> 2; // bg
        penColor.bgBlue = b & 0x03; // bb
        b = packetData[++i];
        penColor.edgeRed = (b & 0x30) >> 4; // er
        penColor.edgeGreen = (b & 0x0c) >> 2; // eg
        penColor.edgeBlue = b & 0x03; // eb
        return i;
    };
    /**
   * Parse and execute the SPL command.
   *
   * Set pen location of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setPenLocation = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var penLoc = service.currentWindow.penLoc; // Positioning isn't really supported at the moment, so this essentially just inserts a linebreak
        service.currentWindow.pendingNewLine = true;
        b = packetData[++i];
        penLoc.row = b & 0x0f; // r
        b = packetData[++i];
        penLoc.column = b & 0x3f; // c
        return i;
    };
    /**
   * Execute the RST command.
   *
   * Reset service to a clean slate. Re-initialize.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Service}          Re-initialized service
   */ Cea708Stream.prototype.reset = function(i, service) {
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        return this.initService(service.serviceNum, i);
    }; // This hash maps non-ASCII, special, and extended character codes to their
    // proper Unicode equivalent. The first keys that are only a single byte
    // are the non-standard ASCII characters, which simply map the CEA608 byte
    // to the standard ASCII/Unicode. The two-byte keys that follow are the CEA608
    // character codes, but have their MSB bitmasked with 0x03 so that a lookup
    // can be performed regardless of the field and data channel on which the
    // character code was received.
    var CHARACTER_TRANSLATION = {
        0x2a: 0xe1,
        // á
        0x5c: 0xe9,
        // é
        0x5e: 0xed,
        // í
        0x5f: 0xf3,
        // ó
        0x60: 0xfa,
        // ú
        0x7b: 0xe7,
        // ç
        0x7c: 0xf7,
        // ÷
        0x7d: 0xd1,
        // Ñ
        0x7e: 0xf1,
        // ñ
        0x7f: 0x2588,
        // █
        0x0130: 0xae,
        // ®
        0x0131: 0xb0,
        // °
        0x0132: 0xbd,
        // ½
        0x0133: 0xbf,
        // ¿
        0x0134: 0x2122,
        // ™
        0x0135: 0xa2,
        // ¢
        0x0136: 0xa3,
        // £
        0x0137: 0x266a,
        // ♪
        0x0138: 0xe0,
        // à
        0x0139: 0xa0,
        //
        0x013a: 0xe8,
        // è
        0x013b: 0xe2,
        // â
        0x013c: 0xea,
        // ê
        0x013d: 0xee,
        // î
        0x013e: 0xf4,
        // ô
        0x013f: 0xfb,
        // û
        0x0220: 0xc1,
        // Á
        0x0221: 0xc9,
        // É
        0x0222: 0xd3,
        // Ó
        0x0223: 0xda,
        // Ú
        0x0224: 0xdc,
        // Ü
        0x0225: 0xfc,
        // ü
        0x0226: 0x2018,
        // ‘
        0x0227: 0xa1,
        // ¡
        0x0228: 0x2a,
        // *
        0x0229: 0x27,
        // '
        0x022a: 0x2014,
        // —
        0x022b: 0xa9,
        // ©
        0x022c: 0x2120,
        // ℠
        0x022d: 0x2022,
        // •
        0x022e: 0x201c,
        // “
        0x022f: 0x201d,
        // ”
        0x0230: 0xc0,
        // À
        0x0231: 0xc2,
        // Â
        0x0232: 0xc7,
        // Ç
        0x0233: 0xc8,
        // È
        0x0234: 0xca,
        // Ê
        0x0235: 0xcb,
        // Ë
        0x0236: 0xeb,
        // ë
        0x0237: 0xce,
        // Î
        0x0238: 0xcf,
        // Ï
        0x0239: 0xef,
        // ï
        0x023a: 0xd4,
        // Ô
        0x023b: 0xd9,
        // Ù
        0x023c: 0xf9,
        // ù
        0x023d: 0xdb,
        // Û
        0x023e: 0xab,
        // «
        0x023f: 0xbb,
        // »
        0x0320: 0xc3,
        // Ã
        0x0321: 0xe3,
        // ã
        0x0322: 0xcd,
        // Í
        0x0323: 0xcc,
        // Ì
        0x0324: 0xec,
        // ì
        0x0325: 0xd2,
        // Ò
        0x0326: 0xf2,
        // ò
        0x0327: 0xd5,
        // Õ
        0x0328: 0xf5,
        // õ
        0x0329: 0x7b,
        // {
        0x032a: 0x7d,
        // }
        0x032b: 0x5c,
        // \
        0x032c: 0x5e,
        // ^
        0x032d: 0x5f,
        // _
        0x032e: 0x7c,
        // |
        0x032f: 0x7e,
        // ~
        0x0330: 0xc4,
        // Ä
        0x0331: 0xe4,
        // ä
        0x0332: 0xd6,
        // Ö
        0x0333: 0xf6,
        // ö
        0x0334: 0xdf,
        // ß
        0x0335: 0xa5,
        // ¥
        0x0336: 0xa4,
        // ¤
        0x0337: 0x2502,
        // │
        0x0338: 0xc5,
        // Å
        0x0339: 0xe5,
        // å
        0x033a: 0xd8,
        // Ø
        0x033b: 0xf8,
        // ø
        0x033c: 0x250c,
        // ┌
        0x033d: 0x2510,
        // ┐
        0x033e: 0x2514,
        // └
        0x033f: 0x2518 // ┘
    };
    var getCharFromCode = function(code) {
        if (code === null) return '';
        code = CHARACTER_TRANSLATION[code] || code;
        return String.fromCharCode(code);
    }; // the index of the last row in a CEA-608 display buffer
    var BOTTOM_ROW = 14; // This array is used for mapping PACs -> row #, since there's no way of
    // getting it through bit logic.
    var ROWS = [
        0x1100,
        0x1120,
        0x1200,
        0x1220,
        0x1500,
        0x1520,
        0x1600,
        0x1620,
        0x1700,
        0x1720,
        0x1000,
        0x1300,
        0x1320,
        0x1400,
        0x1420
    ]; // CEA-608 captions are rendered onto a 34x15 matrix of character
    // cells. The "bottom" row is the last element in the outer array.
    // We keep track of positioning information as we go by storing the
    // number of indentations and the tab offset in this buffer.
    var createDisplayBuffer = function() {
        var result = [], i = BOTTOM_ROW + 1;
        while(i--)result.push({
            text: '',
            indent: 0,
            offset: 0
        });
        return result;
    };
    var Cea608Stream = function(field, dataChannel) {
        Cea608Stream.prototype.init.call(this);
        this.field_ = field || 0;
        this.dataChannel_ = dataChannel || 0;
        this.name_ = 'CC' + ((this.field_ << 1 | this.dataChannel_) + 1);
        this.setConstants();
        this.reset();
        this.push = function(packet) {
            var data, swap, char0, char1, text; // remove the parity bits
            data = packet.ccData & 0x7f7f; // ignore duplicate control codes; the spec demands they're sent twice
            if (data === this.lastControlCode_) {
                this.lastControlCode_ = null;
                return;
            } // Store control codes
            if ((data & 0xf000) === 0x1000) this.lastControlCode_ = data;
            else if (data !== this.PADDING_) this.lastControlCode_ = null;
            char0 = data >>> 8;
            char1 = data & 0xff;
            if (data === this.PADDING_) return;
            else if (data === this.RESUME_CAPTION_LOADING_) this.mode_ = 'popOn';
            else if (data === this.END_OF_CAPTION_) {
                // If an EOC is received while in paint-on mode, the displayed caption
                // text should be swapped to non-displayed memory as if it was a pop-on
                // caption. Because of that, we should explicitly switch back to pop-on
                // mode
                this.mode_ = 'popOn';
                this.clearFormatting(packet.pts); // if a caption was being displayed, it's gone now
                this.flushDisplayed(packet.pts); // flip memory
                swap = this.displayed_;
                this.displayed_ = this.nonDisplayed_;
                this.nonDisplayed_ = swap; // start measuring the time to display the caption
                this.startPts_ = packet.pts;
            } else if (data === this.ROLL_UP_2_ROWS_) {
                this.rollUpRows_ = 2;
                this.setRollUp(packet.pts);
            } else if (data === this.ROLL_UP_3_ROWS_) {
                this.rollUpRows_ = 3;
                this.setRollUp(packet.pts);
            } else if (data === this.ROLL_UP_4_ROWS_) {
                this.rollUpRows_ = 4;
                this.setRollUp(packet.pts);
            } else if (data === this.CARRIAGE_RETURN_) {
                this.clearFormatting(packet.pts);
                this.flushDisplayed(packet.pts);
                this.shiftRowsUp_();
                this.startPts_ = packet.pts;
            } else if (data === this.BACKSPACE_) {
                if (this.mode_ === 'popOn') this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1);
                else this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
            } else if (data === this.ERASE_DISPLAYED_MEMORY_) {
                this.flushDisplayed(packet.pts);
                this.displayed_ = createDisplayBuffer();
            } else if (data === this.ERASE_NON_DISPLAYED_MEMORY_) this.nonDisplayed_ = createDisplayBuffer();
            else if (data === this.RESUME_DIRECT_CAPTIONING_) {
                if (this.mode_ !== 'paintOn') {
                    // NOTE: This should be removed when proper caption positioning is
                    // implemented
                    this.flushDisplayed(packet.pts);
                    this.displayed_ = createDisplayBuffer();
                }
                this.mode_ = 'paintOn';
                this.startPts_ = packet.pts; // Append special characters to caption text
            } else if (this.isSpecialCharacter(char0, char1)) {
                // Bitmask char0 so that we can apply character transformations
                // regardless of field and data channel.
                // Then byte-shift to the left and OR with char1 so we can pass the
                // entire character code to `getCharFromCode`.
                char0 = (char0 & 0x03) << 8;
                text = getCharFromCode(char0 | char1);
                this[this.mode_](packet.pts, text);
                this.column_++; // Append extended characters to caption text
            } else if (this.isExtCharacter(char0, char1)) {
                // Extended characters always follow their "non-extended" equivalents.
                // IE if a "è" is desired, you'll always receive "eè"; non-compliant
                // decoders are supposed to drop the "è", while compliant decoders
                // backspace the "e" and insert "è".
                // Delete the previous character
                if (this.mode_ === 'popOn') this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1);
                else this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
                 // Bitmask char0 so that we can apply character transformations
                // regardless of field and data channel.
                // Then byte-shift to the left and OR with char1 so we can pass the
                // entire character code to `getCharFromCode`.
                char0 = (char0 & 0x03) << 8;
                text = getCharFromCode(char0 | char1);
                this[this.mode_](packet.pts, text);
                this.column_++; // Process mid-row codes
            } else if (this.isMidRowCode(char0, char1)) {
                // Attributes are not additive, so clear all formatting
                this.clearFormatting(packet.pts); // According to the standard, mid-row codes
                // should be replaced with spaces, so add one now
                this[this.mode_](packet.pts, ' ');
                this.column_++;
                if ((char1 & 0xe) === 0xe) this.addFormatting(packet.pts, [
                    'i'
                ]);
                if ((char1 & 0x1) === 0x1) this.addFormatting(packet.pts, [
                    'u'
                ]);
                 // Detect offset control codes and adjust cursor
            } else if (this.isOffsetControlCode(char0, char1)) {
                // Cursor position is set by indent PAC (see below) in 4-column
                // increments, with an additional offset code of 1-3 to reach any
                // of the 32 columns specified by CEA-608. So all we need to do
                // here is increment the column cursor by the given offset.
                const offset = char1 & 0x03; // For an offest value 1-3, set the offset for that caption
                // in the non-displayed array.
                this.nonDisplayed_[this.row_].offset = offset;
                this.column_ += offset; // Detect PACs (Preamble Address Codes)
            } else if (this.isPAC(char0, char1)) {
                // There's no logic for PAC -> row mapping, so we have to just
                // find the row code in an array and use its index :(
                var row = ROWS.indexOf(data & 0x1f20); // Configure the caption window if we're in roll-up mode
                if (this.mode_ === 'rollUp') {
                    // This implies that the base row is incorrectly set.
                    // As per the recommendation in CEA-608(Base Row Implementation), defer to the number
                    // of roll-up rows set.
                    if (row - this.rollUpRows_ + 1 < 0) row = this.rollUpRows_ - 1;
                    this.setRollUp(packet.pts, row);
                } // Ensure the row is between 0 and 14, otherwise use the most
                // recent or default row.
                if (row !== this.row_ && row >= 0 && row <= 14) {
                    // formatting is only persistent for current row
                    this.clearFormatting(packet.pts);
                    this.row_ = row;
                } // All PACs can apply underline, so detect and apply
                // (All odd-numbered second bytes set underline)
                if (char1 & 0x1 && this.formatting_.indexOf('u') === -1) this.addFormatting(packet.pts, [
                    'u'
                ]);
                if ((data & 0x10) === 0x10) {
                    // We've got an indent level code. Each successive even number
                    // increments the column cursor by 4, so we can get the desired
                    // column position by bit-shifting to the right (to get n/2)
                    // and multiplying by 4.
                    const indentations = (data & 0xe) >> 1;
                    this.column_ = indentations * 4; // add to the number of indentations for positioning
                    this.nonDisplayed_[this.row_].indent += indentations;
                }
                if (this.isColorPAC(char1)) // it's a color code, though we only support white, which
                // can be either normal or italicized. white italics can be
                // either 0x4e or 0x6e depending on the row, so we just
                // bitwise-and with 0xe to see if italics should be turned on
                {
                    if ((char1 & 0xe) === 0xe) this.addFormatting(packet.pts, [
                        'i'
                    ]);
                } // We have a normal character in char0, and possibly one in char1
            } else if (this.isNormalChar(char0)) {
                if (char1 === 0x00) char1 = null;
                text = getCharFromCode(char0);
                text += getCharFromCode(char1);
                this[this.mode_](packet.pts, text);
                this.column_ += text.length;
            } // finish data processing
        };
    };
    Cea608Stream.prototype = new Stream$7(); // Trigger a cue point that captures the current state of the
    // display buffer
    Cea608Stream.prototype.flushDisplayed = function(pts) {
        const logWarning = (index)=>{
            this.trigger('log', {
                level: 'warn',
                message: 'Skipping a malformed 608 caption at index ' + index + '.'
            });
        };
        const content = [];
        this.displayed_.forEach((row, i)=>{
            if (row && row.text && row.text.length) {
                try {
                    // remove spaces from the start and end of the string
                    row.text = row.text.trim();
                } catch (e) {
                    // Ordinarily, this shouldn't happen. However, caption
                    // parsing errors should not throw exceptions and
                    // break playback.
                    logWarning(i);
                } // See the below link for more details on the following fields:
                // https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
                if (row.text.length) content.push({
                    // The text to be displayed in the caption from this specific row, with whitespace removed.
                    text: row.text,
                    // Value between 1 and 15 representing the PAC row used to calculate line height.
                    line: i + 1,
                    // A number representing the indent position by percentage (CEA-608 PAC indent code).
                    // The value will be a number between 10 and 80. Offset is used to add an aditional
                    // value to the position if necessary.
                    position: 10 + Math.min(70, row.indent * 10) + row.offset * 2.5
                });
            } else if (row === undefined || row === null) logWarning(i);
        });
        if (content.length) this.trigger('data', {
            startPts: this.startPts_,
            endPts: pts,
            content: content,
            stream: this.name_
        });
    };
    /**
   * Zero out the data, used for startup and on seek
   */ Cea608Stream.prototype.reset = function() {
        this.mode_ = 'popOn'; // When in roll-up mode, the index of the last row that will
        // actually display captions. If a caption is shifted to a row
        // with a lower index than this, it is cleared from the display
        // buffer
        this.topRow_ = 0;
        this.startPts_ = 0;
        this.displayed_ = createDisplayBuffer();
        this.nonDisplayed_ = createDisplayBuffer();
        this.lastControlCode_ = null; // Track row and column for proper line-breaking and spacing
        this.column_ = 0;
        this.row_ = BOTTOM_ROW;
        this.rollUpRows_ = 2; // This variable holds currently-applied formatting
        this.formatting_ = [];
    };
    /**
   * Sets up control code and related constants for this instance
   */ Cea608Stream.prototype.setConstants = function() {
        // The following attributes have these uses:
        // ext_ :    char0 for mid-row codes, and the base for extended
        //           chars (ext_+0, ext_+1, and ext_+2 are char0s for
        //           extended codes)
        // control_: char0 for control codes, except byte-shifted to the
        //           left so that we can do this.control_ | CONTROL_CODE
        // offset_:  char0 for tab offset codes
        //
        // It's also worth noting that control codes, and _only_ control codes,
        // differ between field 1 and field2. Field 2 control codes are always
        // their field 1 value plus 1. That's why there's the "| field" on the
        // control value.
        if (this.dataChannel_ === 0) {
            this.BASE_ = 0x10;
            this.EXT_ = 0x11;
            this.CONTROL_ = (0x14 | this.field_) << 8;
            this.OFFSET_ = 0x17;
        } else if (this.dataChannel_ === 1) {
            this.BASE_ = 0x18;
            this.EXT_ = 0x19;
            this.CONTROL_ = (0x1c | this.field_) << 8;
            this.OFFSET_ = 0x1f;
        } // Constants for the LSByte command codes recognized by Cea608Stream. This
        // list is not exhaustive. For a more comprehensive listing and semantics see
        // http://www.gpo.gov/fdsys/pkg/CFR-2010-title47-vol1/pdf/CFR-2010-title47-vol1-sec15-119.pdf
        // Padding
        this.PADDING_ = 0x0000; // Pop-on Mode
        this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 0x20;
        this.END_OF_CAPTION_ = this.CONTROL_ | 0x2f; // Roll-up Mode
        this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 0x25;
        this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 0x26;
        this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 0x27;
        this.CARRIAGE_RETURN_ = this.CONTROL_ | 0x2d; // paint-on mode
        this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 0x29; // Erasure
        this.BACKSPACE_ = this.CONTROL_ | 0x21;
        this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2c;
        this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2e;
    };
    /**
   * Detects if the 2-byte packet data is a special character
   *
   * Special characters have a second byte in the range 0x30 to 0x3f,
   * with the first byte being 0x11 (for data channel 1) or 0x19 (for
   * data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an special character
   */ Cea608Stream.prototype.isSpecialCharacter = function(char0, char1) {
        return char0 === this.EXT_ && char1 >= 0x30 && char1 <= 0x3f;
    };
    /**
   * Detects if the 2-byte packet data is an extended character
   *
   * Extended characters have a second byte in the range 0x20 to 0x3f,
   * with the first byte being 0x12 or 0x13 (for data channel 1) or
   * 0x1a or 0x1b (for data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an extended character
   */ Cea608Stream.prototype.isExtCharacter = function(char0, char1) {
        return (char0 === this.EXT_ + 1 || char0 === this.EXT_ + 2) && char1 >= 0x20 && char1 <= 0x3f;
    };
    /**
   * Detects if the 2-byte packet is a mid-row code
   *
   * Mid-row codes have a second byte in the range 0x20 to 0x2f, with
   * the first byte being 0x11 (for data channel 1) or 0x19 (for data
   * channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are a mid-row code
   */ Cea608Stream.prototype.isMidRowCode = function(char0, char1) {
        return char0 === this.EXT_ && char1 >= 0x20 && char1 <= 0x2f;
    };
    /**
   * Detects if the 2-byte packet is an offset control code
   *
   * Offset control codes have a second byte in the range 0x21 to 0x23,
   * with the first byte being 0x17 (for data channel 1) or 0x1f (for
   * data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an offset control code
   */ Cea608Stream.prototype.isOffsetControlCode = function(char0, char1) {
        return char0 === this.OFFSET_ && char1 >= 0x21 && char1 <= 0x23;
    };
    /**
   * Detects if the 2-byte packet is a Preamble Address Code
   *
   * PACs have a first byte in the range 0x10 to 0x17 (for data channel 1)
   * or 0x18 to 0x1f (for data channel 2), with the second byte in the
   * range 0x40 to 0x7f.
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are a PAC
   */ Cea608Stream.prototype.isPAC = function(char0, char1) {
        return char0 >= this.BASE_ && char0 < this.BASE_ + 8 && char1 >= 0x40 && char1 <= 0x7f;
    };
    /**
   * Detects if a packet's second byte is in the range of a PAC color code
   *
   * PAC color codes have the second byte be in the range 0x40 to 0x4f, or
   * 0x60 to 0x6f.
   *
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the byte is a color PAC
   */ Cea608Stream.prototype.isColorPAC = function(char1) {
        return char1 >= 0x40 && char1 <= 0x4f || char1 >= 0x60 && char1 <= 0x7f;
    };
    /**
   * Detects if a single byte is in the range of a normal character
   *
   * Normal text bytes are in the range 0x20 to 0x7f.
   *
   * @param  {Integer} char  The byte
   * @return {Boolean}       Whether the byte is a normal character
   */ Cea608Stream.prototype.isNormalChar = function(char) {
        return char >= 0x20 && char <= 0x7f;
    };
    /**
   * Configures roll-up
   *
   * @param  {Integer} pts         Current PTS
   * @param  {Integer} newBaseRow  Used by PACs to slide the current window to
   *                               a new position
   */ Cea608Stream.prototype.setRollUp = function(pts, newBaseRow) {
        // Reset the base row to the bottom row when switching modes
        if (this.mode_ !== 'rollUp') {
            this.row_ = BOTTOM_ROW;
            this.mode_ = 'rollUp'; // Spec says to wipe memories when switching to roll-up
            this.flushDisplayed(pts);
            this.nonDisplayed_ = createDisplayBuffer();
            this.displayed_ = createDisplayBuffer();
        }
        if (newBaseRow !== undefined && newBaseRow !== this.row_) // move currently displayed captions (up or down) to the new base row
        for(var i = 0; i < this.rollUpRows_; i++){
            this.displayed_[newBaseRow - i] = this.displayed_[this.row_ - i];
            this.displayed_[this.row_ - i] = {
                text: '',
                indent: 0,
                offset: 0
            };
        }
        if (newBaseRow === undefined) newBaseRow = this.row_;
        this.topRow_ = newBaseRow - this.rollUpRows_ + 1;
    }; // Adds the opening HTML tag for the passed character to the caption text,
    // and keeps track of it for later closing
    Cea608Stream.prototype.addFormatting = function(pts, format) {
        this.formatting_ = this.formatting_.concat(format);
        var text = format.reduce(function(text, format) {
            return text + '<' + format + '>';
        }, '');
        this[this.mode_](pts, text);
    }; // Adds HTML closing tags for current formatting to caption text and
    // clears remembered formatting
    Cea608Stream.prototype.clearFormatting = function(pts) {
        if (!this.formatting_.length) return;
        var text = this.formatting_.reverse().reduce(function(text, format) {
            return text + '</' + format + '>';
        }, '');
        this.formatting_ = [];
        this[this.mode_](pts, text);
    }; // Mode Implementations
    Cea608Stream.prototype.popOn = function(pts, text) {
        var baseRow = this.nonDisplayed_[this.row_].text; // buffer characters
        baseRow += text;
        this.nonDisplayed_[this.row_].text = baseRow;
    };
    Cea608Stream.prototype.rollUp = function(pts, text) {
        var baseRow = this.displayed_[this.row_].text;
        baseRow += text;
        this.displayed_[this.row_].text = baseRow;
    };
    Cea608Stream.prototype.shiftRowsUp_ = function() {
        var i; // clear out inactive rows
        for(i = 0; i < this.topRow_; i++)this.displayed_[i] = {
            text: '',
            indent: 0,
            offset: 0
        };
        for(i = this.row_ + 1; i < BOTTOM_ROW + 1; i++)this.displayed_[i] = {
            text: '',
            indent: 0,
            offset: 0
        };
         // shift displayed rows up
        for(i = this.topRow_; i < this.row_; i++)this.displayed_[i] = this.displayed_[i + 1];
         // clear out the bottom row
        this.displayed_[this.row_] = {
            text: '',
            indent: 0,
            offset: 0
        };
    };
    Cea608Stream.prototype.paintOn = function(pts, text) {
        var baseRow = this.displayed_[this.row_].text;
        baseRow += text;
        this.displayed_[this.row_].text = baseRow;
    }; // exports
    var captionStream = {
        CaptionStream: CaptionStream$2,
        Cea608Stream: Cea608Stream,
        Cea708Stream: Cea708Stream
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var streamTypes = {
        H264_STREAM_TYPE: 0x1B,
        ADTS_STREAM_TYPE: 0x0F,
        METADATA_STREAM_TYPE: 0x15
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Accepts program elementary stream (PES) data events and corrects
   * decode and presentation time stamps to account for a rollover
   * of the 33 bit value.
   */ var Stream$6 = stream;
    var MAX_TS = 8589934592;
    var RO_THRESH = 4294967296;
    var TYPE_SHARED = 'shared';
    var handleRollover$1 = function(value, reference) {
        var direction = 1;
        if (value > reference) // If the current timestamp value is greater than our reference timestamp and we detect a
        // timestamp rollover, this means the roll over is happening in the opposite direction.
        // Example scenario: Enter a long stream/video just after a rollover occurred. The reference
        // point will be set to a small number, e.g. 1. The user then seeks backwards over the
        // rollover point. In loading this segment, the timestamp values will be very large,
        // e.g. 2^33 - 1. Since this comes before the data we loaded previously, we want to adjust
        // the time stamp to be `value - 2^33`.
        direction = -1;
         // Note: A seek forwards or back that is greater than the RO_THRESH (2^32, ~13 hours) will
        // cause an incorrect adjustment.
        while(Math.abs(reference - value) > RO_THRESH)value += direction * MAX_TS;
        return value;
    };
    var TimestampRolloverStream$1 = function(type) {
        var lastDTS, referenceDTS;
        TimestampRolloverStream$1.prototype.init.call(this); // The "shared" type is used in cases where a stream will contain muxed
        // video and audio. We could use `undefined` here, but having a string
        // makes debugging a little clearer.
        this.type_ = type || TYPE_SHARED;
        this.push = function(data) {
            /**
       * Rollover stream expects data from elementary stream.
       * Elementary stream can push forward 2 types of data
       * - Parsed Video/Audio/Timed-metadata PES (packetized elementary stream) packets
       * - Tracks metadata from PMT (Program Map Table)
       * Rollover stream expects pts/dts info to be available, since it stores lastDTS
       * We should ignore non-PES packets since they may override lastDTS to undefined.
       * lastDTS is important to signal the next segments
       * about rollover from the previous segments.
       */ if (data.type === 'metadata') {
                this.trigger('data', data);
                return;
            } // Any "shared" rollover streams will accept _all_ data. Otherwise,
            // streams will only accept data that matches their type.
            if (this.type_ !== TYPE_SHARED && data.type !== this.type_) return;
            if (referenceDTS === undefined) referenceDTS = data.dts;
            data.dts = handleRollover$1(data.dts, referenceDTS);
            data.pts = handleRollover$1(data.pts, referenceDTS);
            lastDTS = data.dts;
            this.trigger('data', data);
        };
        this.flush = function() {
            referenceDTS = lastDTS;
            this.trigger('done');
        };
        this.endTimeline = function() {
            this.flush();
            this.trigger('endedtimeline');
        };
        this.discontinuity = function() {
            referenceDTS = void 0;
            lastDTS = void 0;
        };
        this.reset = function() {
            this.discontinuity();
            this.trigger('reset');
        };
    };
    TimestampRolloverStream$1.prototype = new Stream$6();
    var timestampRolloverStream = {
        TimestampRolloverStream: TimestampRolloverStream$1,
        handleRollover: handleRollover$1
    }; // Once IE11 support is dropped, this function should be removed.
    var typedArrayIndexOf$1 = (typedArray, element, fromIndex)=>{
        if (!typedArray) return -1;
        var currentIndex = fromIndex;
        for(; currentIndex < typedArray.length; currentIndex++){
            if (typedArray[currentIndex] === element) return currentIndex;
        }
        return -1;
    };
    var typedArray = {
        typedArrayIndexOf: typedArrayIndexOf$1
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Tools for parsing ID3 frame data
   * @see http://id3.org/id3v2.3.0
   */ var typedArrayIndexOf = typedArray.typedArrayIndexOf, // Frames that allow different types of text encoding contain a text
    // encoding description byte [ID3v2.4.0 section 4.]
    textEncodingDescriptionByte = {
        Iso88591: 0x00,
        // ISO-8859-1, terminated with \0.
        Utf16: 0x01,
        // UTF-16 encoded Unicode BOM, terminated with \0\0
        Utf16be: 0x02,
        // UTF-16BE encoded Unicode, without BOM, terminated with \0\0
        Utf8: 0x03 // UTF-8 encoded Unicode, terminated with \0
    }, // return a percent-encoded representation of the specified byte range
    // @see http://en.wikipedia.org/wiki/Percent-encoding 
    percentEncode$1 = function(bytes, start, end) {
        var i, result = '';
        for(i = start; i < end; i++)result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
        return result;
    }, // return the string representation of the specified byte range,
    // interpreted as UTf-8.
    parseUtf8 = function(bytes, start, end) {
        return decodeURIComponent(percentEncode$1(bytes, start, end));
    }, // return the string representation of the specified byte range,
    // interpreted as ISO-8859-1.
    parseIso88591$1 = function(bytes, start, end) {
        return unescape(percentEncode$1(bytes, start, end)); // jshint ignore:line
    }, parseSyncSafeInteger$1 = function(data) {
        return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
    }, frameParsers = {
        'APIC': function(frame) {
            var i = 1, mimeTypeEndIndex, descriptionEndIndex, LINK_MIME_TYPE = '-->';
            if (frame.data[0] !== textEncodingDescriptionByte.Utf8) // ignore frames with unrecognized character encodings
            return;
             // parsing fields [ID3v2.4.0 section 4.14.]
            mimeTypeEndIndex = typedArrayIndexOf(frame.data, 0, i);
            if (mimeTypeEndIndex < 0) // malformed frame
            return;
             // parsing Mime type field (terminated with \0)
            frame.mimeType = parseIso88591$1(frame.data, i, mimeTypeEndIndex);
            i = mimeTypeEndIndex + 1; // parsing 1-byte Picture Type field
            frame.pictureType = frame.data[i];
            i++;
            descriptionEndIndex = typedArrayIndexOf(frame.data, 0, i);
            if (descriptionEndIndex < 0) // malformed frame
            return;
             // parsing Description field (terminated with \0)
            frame.description = parseUtf8(frame.data, i, descriptionEndIndex);
            i = descriptionEndIndex + 1;
            if (frame.mimeType === LINK_MIME_TYPE) // parsing Picture Data field as URL (always represented as ISO-8859-1 [ID3v2.4.0 section 4.])
            frame.url = parseIso88591$1(frame.data, i, frame.data.length);
            else // parsing Picture Data field as binary data
            frame.pictureData = frame.data.subarray(i, frame.data.length);
        },
        'T*': function(frame) {
            if (frame.data[0] !== textEncodingDescriptionByte.Utf8) // ignore frames with unrecognized character encodings
            return;
             // parse text field, do not include null terminator in the frame value
            // frames that allow different types of encoding contain terminated text [ID3v2.4.0 section 4.]
            frame.value = parseUtf8(frame.data, 1, frame.data.length).replace(/\0*$/, ''); // text information frames supports multiple strings, stored as a terminator separated list [ID3v2.4.0 section 4.2.]
            frame.values = frame.value.split('\0');
        },
        'TXXX': function(frame) {
            var descriptionEndIndex;
            if (frame.data[0] !== textEncodingDescriptionByte.Utf8) // ignore frames with unrecognized character encodings
            return;
            descriptionEndIndex = typedArrayIndexOf(frame.data, 0, 1);
            if (descriptionEndIndex === -1) return;
             // parse the text fields
            frame.description = parseUtf8(frame.data, 1, descriptionEndIndex); // do not include the null terminator in the tag value
            // frames that allow different types of encoding contain terminated text
            // [ID3v2.4.0 section 4.]
            frame.value = parseUtf8(frame.data, descriptionEndIndex + 1, frame.data.length).replace(/\0*$/, '');
            frame.data = frame.value;
        },
        'W*': function(frame) {
            // parse URL field; URL fields are always represented as ISO-8859-1 [ID3v2.4.0 section 4.]
            // if the value is followed by a string termination all the following information should be ignored [ID3v2.4.0 section 4.3]
            frame.url = parseIso88591$1(frame.data, 0, frame.data.length).replace(/\0.*$/, '');
        },
        'WXXX': function(frame) {
            var descriptionEndIndex;
            if (frame.data[0] !== textEncodingDescriptionByte.Utf8) // ignore frames with unrecognized character encodings
            return;
            descriptionEndIndex = typedArrayIndexOf(frame.data, 0, 1);
            if (descriptionEndIndex === -1) return;
             // parse the description and URL fields
            frame.description = parseUtf8(frame.data, 1, descriptionEndIndex); // URL fields are always represented as ISO-8859-1 [ID3v2.4.0 section 4.]
            // if the value is followed by a string termination all the following information
            // should be ignored [ID3v2.4.0 section 4.3]
            frame.url = parseIso88591$1(frame.data, descriptionEndIndex + 1, frame.data.length).replace(/\0.*$/, '');
        },
        'PRIV': function(frame) {
            var i;
            for(i = 0; i < frame.data.length; i++)if (frame.data[i] === 0) {
                // parse the description and URL fields
                frame.owner = parseIso88591$1(frame.data, 0, i);
                break;
            }
            frame.privateData = frame.data.subarray(i + 1);
            frame.data = frame.privateData;
        }
    };
    var parseId3Frames$1 = function(data) {
        var frameSize, frameHeader, frameStart = 10, tagSize = 0, frames = []; // If we don't have enough data for a header, 10 bytes, 
        // or 'ID3' in the first 3 bytes this is not a valid ID3 tag.
        if (data.length < 10 || data[0] !== 'I'.charCodeAt(0) || data[1] !== 'D'.charCodeAt(0) || data[2] !== '3'.charCodeAt(0)) return;
         // the frame size is transmitted as a 28-bit integer in the
        // last four bytes of the ID3 header.
        // The most significant bit of each byte is dropped and the
        // results concatenated to recover the actual value.
        tagSize = parseSyncSafeInteger$1(data.subarray(6, 10)); // ID3 reports the tag size excluding the header but it's more
        // convenient for our comparisons to include it
        tagSize += 10; // check bit 6 of byte 5 for the extended header flag.
        var hasExtendedHeader = data[5] & 0x40;
        if (hasExtendedHeader) {
            // advance the frame start past the extended header
            frameStart += 4; // header size field
            frameStart += parseSyncSafeInteger$1(data.subarray(10, 14));
            tagSize -= parseSyncSafeInteger$1(data.subarray(16, 20)); // clip any padding off the end
        } // parse one or more ID3 frames
        // http://id3.org/id3v2.3.0#ID3v2_frame_overview
        do {
            // determine the number of bytes in this frame
            frameSize = parseSyncSafeInteger$1(data.subarray(frameStart + 4, frameStart + 8));
            if (frameSize < 1) break;
            frameHeader = String.fromCharCode(data[frameStart], data[frameStart + 1], data[frameStart + 2], data[frameStart + 3]);
            var frame = {
                id: frameHeader,
                data: data.subarray(frameStart + 10, frameStart + frameSize + 10)
            };
            frame.key = frame.id; // parse frame values
            if (frameParsers[frame.id]) // use frame specific parser
            frameParsers[frame.id](frame);
            else if (frame.id[0] === 'T') // use text frame generic parser
            frameParsers['T*'](frame);
            else if (frame.id[0] === 'W') // use URL link frame generic parser
            frameParsers['W*'](frame);
            frames.push(frame);
            frameStart += 10; // advance past the frame header
            frameStart += frameSize; // advance past the frame body
        }while (frameStart < tagSize);
        return frames;
    };
    var parseId3 = {
        parseId3Frames: parseId3Frames$1,
        parseSyncSafeInteger: parseSyncSafeInteger$1,
        frameParsers: frameParsers
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Accepts program elementary stream (PES) data events and parses out
   * ID3 metadata from them, if present.
   * @see http://id3.org/id3v2.3.0
   */ var Stream$5 = stream, StreamTypes$3 = streamTypes, id3 = parseId3, MetadataStream;
    MetadataStream = function(options) {
        var settings = {
            // the bytes of the program-level descriptor field in MP2T
            // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
            // program element descriptors"
            descriptor: options && options.descriptor
        }, // the total size in bytes of the ID3 tag being parsed
        tagSize = 0, // tag data that is not complete enough to be parsed
        buffer = [], // the total number of bytes currently in the buffer
        bufferSize = 0, i;
        MetadataStream.prototype.init.call(this); // calculate the text track in-band metadata track dispatch type
        // https://html.spec.whatwg.org/multipage/embedded-content.html#steps-to-expose-a-media-resource-specific-text-track
        this.dispatchType = StreamTypes$3.METADATA_STREAM_TYPE.toString(16);
        if (settings.descriptor) for(i = 0; i < settings.descriptor.length; i++)this.dispatchType += ('00' + settings.descriptor[i].toString(16)).slice(-2);
        this.push = function(chunk) {
            var tag, frameStart, frameSize, frame, i, frameHeader;
            if (chunk.type !== 'timed-metadata') return;
             // if data_alignment_indicator is set in the PES header,
            // we must have the start of a new ID3 tag. Assume anything
            // remaining in the buffer was malformed and throw it out
            if (chunk.dataAlignmentIndicator) {
                bufferSize = 0;
                buffer.length = 0;
            } // ignore events that don't look like ID3 data
            if (buffer.length === 0 && (chunk.data.length < 10 || chunk.data[0] !== 'I'.charCodeAt(0) || chunk.data[1] !== 'D'.charCodeAt(0) || chunk.data[2] !== '3'.charCodeAt(0))) {
                this.trigger('log', {
                    level: 'warn',
                    message: 'Skipping unrecognized metadata packet'
                });
                return;
            } // add this chunk to the data we've collected so far
            buffer.push(chunk);
            bufferSize += chunk.data.byteLength; // grab the size of the entire frame from the ID3 header
            if (buffer.length === 1) {
                // the frame size is transmitted as a 28-bit integer in the
                // last four bytes of the ID3 header.
                // The most significant bit of each byte is dropped and the
                // results concatenated to recover the actual value.
                tagSize = id3.parseSyncSafeInteger(chunk.data.subarray(6, 10)); // ID3 reports the tag size excluding the header but it's more
                // convenient for our comparisons to include it
                tagSize += 10;
            } // if the entire frame has not arrived, wait for more data
            if (bufferSize < tagSize) return;
             // collect the entire frame so it can be parsed
            tag = {
                data: new Uint8Array(tagSize),
                frames: [],
                pts: buffer[0].pts,
                dts: buffer[0].dts
            };
            for(i = 0; i < tagSize;){
                tag.data.set(buffer[0].data.subarray(0, tagSize - i), i);
                i += buffer[0].data.byteLength;
                bufferSize -= buffer[0].data.byteLength;
                buffer.shift();
            } // find the start of the first frame and the end of the tag
            frameStart = 10;
            if (tag.data[5] & 0x40) {
                // advance the frame start past the extended header
                frameStart += 4; // header size field
                frameStart += id3.parseSyncSafeInteger(tag.data.subarray(10, 14)); // clip any padding off the end
                tagSize -= id3.parseSyncSafeInteger(tag.data.subarray(16, 20));
            } // parse one or more ID3 frames
            // http://id3.org/id3v2.3.0#ID3v2_frame_overview
            do {
                // determine the number of bytes in this frame
                frameSize = id3.parseSyncSafeInteger(tag.data.subarray(frameStart + 4, frameStart + 8));
                if (frameSize < 1) {
                    this.trigger('log', {
                        level: 'warn',
                        message: 'Malformed ID3 frame encountered. Skipping remaining metadata parsing.'
                    }); // If the frame is malformed, don't parse any further frames but allow previous valid parsed frames
                    break;
                }
                frameHeader = String.fromCharCode(tag.data[frameStart], tag.data[frameStart + 1], tag.data[frameStart + 2], tag.data[frameStart + 3]);
                frame = {
                    id: frameHeader,
                    data: tag.data.subarray(frameStart + 10, frameStart + frameSize + 10)
                };
                frame.key = frame.id; // parse frame values
                if (id3.frameParsers[frame.id]) // use frame specific parser
                id3.frameParsers[frame.id](frame);
                else if (frame.id[0] === 'T') // use text frame generic parser
                id3.frameParsers['T*'](frame);
                else if (frame.id[0] === 'W') // use URL link frame generic parser
                id3.frameParsers['W*'](frame);
                 // handle the special PRIV frame used to indicate the start
                // time for raw AAC data
                if (frame.owner === 'com.apple.streaming.transportStreamTimestamp') {
                    var d = frame.data, size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
                    size *= 4;
                    size += d[7] & 0x03;
                    frame.timeStamp = size; // in raw AAC, all subsequent data will be timestamped based
                    // on the value of this frame
                    // we couldn't have known the appropriate pts and dts before
                    // parsing this ID3 tag so set those values now
                    if (tag.pts === undefined && tag.dts === undefined) {
                        tag.pts = frame.timeStamp;
                        tag.dts = frame.timeStamp;
                    }
                    this.trigger('timestamp', frame);
                }
                tag.frames.push(frame);
                frameStart += 10; // advance past the frame header
                frameStart += frameSize; // advance past the frame body
            }while (frameStart < tagSize);
            this.trigger('data', tag);
        };
    };
    MetadataStream.prototype = new Stream$5();
    var metadataStream = MetadataStream;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A stream-based mp2t to mp4 converter. This utility can be used to
   * deliver mp4s to a SourceBuffer on platforms that support native
   * Media Source Extensions.
   */ var Stream$4 = stream, CaptionStream$1 = captionStream, StreamTypes$2 = streamTypes, TimestampRolloverStream = timestampRolloverStream.TimestampRolloverStream; // object types
    var TransportPacketStream, TransportParseStream, ElementaryStream; // constants
    var MP2T_PACKET_LENGTH$1 = 188, // bytes
    SYNC_BYTE$1 = 0x47;
    /**
   * Splits an incoming stream of binary data into MPEG-2 Transport
   * Stream packets.
   */ TransportPacketStream = function() {
        var buffer = new Uint8Array(MP2T_PACKET_LENGTH$1), bytesInBuffer = 0;
        TransportPacketStream.prototype.init.call(this); // Deliver new bytes to the stream.
        /**
     * Split a stream of data into M2TS packets
    **/ this.push = function(bytes) {
            var startIndex = 0, endIndex = MP2T_PACKET_LENGTH$1, everything; // If there are bytes remaining from the last segment, prepend them to the
            // bytes that were pushed in
            if (bytesInBuffer) {
                everything = new Uint8Array(bytes.byteLength + bytesInBuffer);
                everything.set(buffer.subarray(0, bytesInBuffer));
                everything.set(bytes, bytesInBuffer);
                bytesInBuffer = 0;
            } else everything = bytes;
             // While we have enough data for a packet
            while(endIndex < everything.byteLength){
                // Look for a pair of start and end sync bytes in the data..
                if (everything[startIndex] === SYNC_BYTE$1 && everything[endIndex] === SYNC_BYTE$1) {
                    // We found a packet so emit it and jump one whole packet forward in
                    // the stream
                    this.trigger('data', everything.subarray(startIndex, endIndex));
                    startIndex += MP2T_PACKET_LENGTH$1;
                    endIndex += MP2T_PACKET_LENGTH$1;
                    continue;
                } // If we get here, we have somehow become de-synchronized and we need to step
                // forward one byte at a time until we find a pair of sync bytes that denote
                // a packet
                startIndex++;
                endIndex++;
            } // If there was some data left over at the end of the segment that couldn't
            // possibly be a whole packet, keep it because it might be the start of a packet
            // that continues in the next segment
            if (startIndex < everything.byteLength) {
                buffer.set(everything.subarray(startIndex), 0);
                bytesInBuffer = everything.byteLength - startIndex;
            }
        };
        /**
     * Passes identified M2TS packets to the TransportParseStream to be parsed
    **/ this.flush = function() {
            // If the buffer contains a whole packet when we are being flushed, emit it
            // and empty the buffer. Otherwise hold onto the data because it may be
            // important for decoding the next segment
            if (bytesInBuffer === MP2T_PACKET_LENGTH$1 && buffer[0] === SYNC_BYTE$1) {
                this.trigger('data', buffer);
                bytesInBuffer = 0;
            }
            this.trigger('done');
        };
        this.endTimeline = function() {
            this.flush();
            this.trigger('endedtimeline');
        };
        this.reset = function() {
            bytesInBuffer = 0;
            this.trigger('reset');
        };
    };
    TransportPacketStream.prototype = new Stream$4();
    /**
   * Accepts an MP2T TransportPacketStream and emits data events with parsed
   * forms of the individual transport stream packets.
   */ TransportParseStream = function() {
        var parsePsi, parsePat, parsePmt, self1;
        TransportParseStream.prototype.init.call(this);
        self1 = this;
        this.packetsWaitingForPmt = [];
        this.programMapTable = undefined;
        parsePsi = function(payload, psi) {
            var offset = 0; // PSI packets may be split into multiple sections and those
            // sections may be split into multiple packets. If a PSI
            // section starts in this packet, the payload_unit_start_indicator
            // will be true and the first byte of the payload will indicate
            // the offset from the current position to the start of the
            // section.
            if (psi.payloadUnitStartIndicator) offset += payload[offset] + 1;
            if (psi.type === 'pat') parsePat(payload.subarray(offset), psi);
            else parsePmt(payload.subarray(offset), psi);
        };
        parsePat = function(payload, pat) {
            pat.section_number = payload[7]; // eslint-disable-line camelcase
            pat.last_section_number = payload[8]; // eslint-disable-line camelcase
            // skip the PSI header and parse the first PMT entry
            self1.pmtPid = (payload[10] & 0x1F) << 8 | payload[11];
            pat.pmtPid = self1.pmtPid;
        };
        /**
     * Parse out the relevant fields of a Program Map Table (PMT).
     * @param payload {Uint8Array} the PMT-specific portion of an MP2T
     * packet. The first byte in this array should be the table_id
     * field.
     * @param pmt {object} the object that should be decorated with
     * fields parsed from the PMT.
     */ parsePmt = function(payload, pmt) {
            var sectionLength, tableEnd, programInfoLength, offset; // PMTs can be sent ahead of the time when they should actually
            // take effect. We don't believe this should ever be the case
            // for HLS but we'll ignore "forward" PMT declarations if we see
            // them. Future PMT declarations have the current_next_indicator
            // set to zero.
            if (!(payload[5] & 0x01)) return;
             // overwrite any existing program map table
            self1.programMapTable = {
                video: null,
                audio: null,
                'timed-metadata': {}
            }; // the mapping table ends at the end of the current section
            sectionLength = (payload[1] & 0x0f) << 8 | payload[2];
            tableEnd = 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
            // long the program info descriptors are
            programInfoLength = (payload[10] & 0x0f) << 8 | payload[11]; // advance the offset to the first entry in the mapping table
            offset = 12 + programInfoLength;
            while(offset < tableEnd){
                var streamType = payload[offset];
                var pid = (payload[offset + 1] & 0x1F) << 8 | payload[offset + 2]; // only map a single elementary_pid for audio and video stream types
                // TODO: should this be done for metadata too? for now maintain behavior of
                //       multiple metadata streams
                if (streamType === StreamTypes$2.H264_STREAM_TYPE && self1.programMapTable.video === null) self1.programMapTable.video = pid;
                else if (streamType === StreamTypes$2.ADTS_STREAM_TYPE && self1.programMapTable.audio === null) self1.programMapTable.audio = pid;
                else if (streamType === StreamTypes$2.METADATA_STREAM_TYPE) // map pid to stream type for metadata streams
                self1.programMapTable['timed-metadata'][pid] = streamType;
                 // move to the next table entry
                // skip past the elementary stream descriptors, if present
                offset += ((payload[offset + 3] & 0x0F) << 8 | payload[offset + 4]) + 5;
            } // record the map on the packet as well
            pmt.programMapTable = self1.programMapTable;
        };
        /**
     * Deliver a new MP2T packet to the next stream in the pipeline.
     */ this.push = function(packet) {
            var result = {}, offset = 4;
            result.payloadUnitStartIndicator = !!(packet[1] & 0x40); // pid is a 13-bit field starting at the last bit of packet[1]
            result.pid = packet[1] & 0x1f;
            result.pid <<= 8;
            result.pid |= packet[2]; // if an adaption field is present, its length is specified by the
            // fifth byte of the TS packet header. The adaptation field is
            // used to add stuffing to PES packets that don't fill a complete
            // TS packet, and to specify some forms of timing and control data
            // that we do not currently use.
            if ((packet[3] & 0x30) >>> 4 > 0x01) offset += packet[offset] + 1;
             // parse the rest of the packet based on the type
            if (result.pid === 0) {
                result.type = 'pat';
                parsePsi(packet.subarray(offset), result);
                this.trigger('data', result);
            } else if (result.pid === this.pmtPid) {
                result.type = 'pmt';
                parsePsi(packet.subarray(offset), result);
                this.trigger('data', result); // if there are any packets waiting for a PMT to be found, process them now
                while(this.packetsWaitingForPmt.length)this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
            } else if (this.programMapTable === undefined) // When we have not seen a PMT yet, defer further processing of
            // PES packets until one has been parsed
            this.packetsWaitingForPmt.push([
                packet,
                offset,
                result
            ]);
            else this.processPes_(packet, offset, result);
        };
        this.processPes_ = function(packet, offset, result) {
            // set the appropriate stream type
            if (result.pid === this.programMapTable.video) result.streamType = StreamTypes$2.H264_STREAM_TYPE;
            else if (result.pid === this.programMapTable.audio) result.streamType = StreamTypes$2.ADTS_STREAM_TYPE;
            else // if not video or audio, it is timed-metadata or unknown
            // if unknown, streamType will be undefined
            result.streamType = this.programMapTable['timed-metadata'][result.pid];
            result.type = 'pes';
            result.data = packet.subarray(offset);
            this.trigger('data', result);
        };
    };
    TransportParseStream.prototype = new Stream$4();
    TransportParseStream.STREAM_TYPES = {
        h264: 0x1b,
        adts: 0x0f
    };
    /**
   * Reconsistutes program elementary stream (PES) packets from parsed
   * transport stream packets. That is, if you pipe an
   * mp2t.TransportParseStream into a mp2t.ElementaryStream, the output
   * events will be events which capture the bytes for individual PES
   * packets plus relevant metadata that has been extracted from the
   * container.
   */ ElementaryStream = function() {
        var self1 = this, segmentHadPmt = false, // PES packet fragments
        video = {
            data: [],
            size: 0
        }, audio = {
            data: [],
            size: 0
        }, timedMetadata = {
            data: [],
            size: 0
        }, programMapTable, parsePes = function(payload, pes) {
            var ptsDtsFlags;
            const startPrefix = payload[0] << 16 | payload[1] << 8 | payload[2]; // default to an empty array
            pes.data = new Uint8Array(); // In certain live streams, the start of a TS fragment has ts packets
            // that are frame data that is continuing from the previous fragment. This
            // is to check that the pes data is the start of a new pes payload
            if (startPrefix !== 1) return;
             // get the packet length, this will be 0 for video
            pes.packetLength = 6 + (payload[4] << 8 | payload[5]); // find out if this packets starts a new keyframe
            pes.dataAlignmentIndicator = (payload[6] & 0x04) !== 0; // PES packets may be annotated with a PTS value, or a PTS value
            // and a DTS value. Determine what combination of values is
            // available to work with.
            ptsDtsFlags = payload[7]; // PTS and DTS are normally stored as a 33-bit number.  Javascript
            // performs all bitwise operations on 32-bit integers but javascript
            // supports a much greater range (52-bits) of integer using standard
            // mathematical operations.
            // We construct a 31-bit value using bitwise operators over the 31
            // most significant bits and then multiply by 4 (equal to a left-shift
            // of 2) before we add the final 2 least significant bits of the
            // timestamp (equal to an OR.)
            if (ptsDtsFlags & 0xC0) {
                // the PTS and DTS are not written out directly. For information
                // on how they are encoded, see
                // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
                pes.pts = (payload[9] & 0x0E) << 27 | (payload[10] & 0xFF) << 20 | (payload[11] & 0xFE) << 12 | (payload[12] & 0xFF) << 5 | (payload[13] & 0xFE) >>> 3;
                pes.pts *= 4; // Left shift by 2
                pes.pts += (payload[13] & 0x06) >>> 1; // OR by the two LSBs
                pes.dts = pes.pts;
                if (ptsDtsFlags & 0x40) {
                    pes.dts = (payload[14] & 0x0E) << 27 | (payload[15] & 0xFF) << 20 | (payload[16] & 0xFE) << 12 | (payload[17] & 0xFF) << 5 | (payload[18] & 0xFE) >>> 3;
                    pes.dts *= 4; // Left shift by 2
                    pes.dts += (payload[18] & 0x06) >>> 1; // OR by the two LSBs
                }
            } // the data section starts immediately after the PES header.
            // pes_header_data_length specifies the number of header bytes
            // that follow the last byte of the field.
            pes.data = payload.subarray(9 + payload[8]);
        }, /**
        * Pass completely parsed PES packets to the next stream in the pipeline
       **/ flushStream = function(stream, type, forceFlush) {
            var packetData = new Uint8Array(stream.size), event = {
                type: type
            }, i = 0, offset = 0, packetFlushable = false, fragment; // do nothing if there is not enough buffered data for a complete
            // PES header
            if (!stream.data.length || stream.size < 9) return;
            event.trackId = stream.data[0].pid; // reassemble the packet
            for(i = 0; i < stream.data.length; i++){
                fragment = stream.data[i];
                packetData.set(fragment.data, offset);
                offset += fragment.data.byteLength;
            } // parse assembled packet's PES header
            parsePes(packetData, event); // non-video PES packets MUST have a non-zero PES_packet_length
            // check that there is enough stream data to fill the packet
            packetFlushable = type === 'video' || event.packetLength <= stream.size; // flush pending packets if the conditions are right
            if (forceFlush || packetFlushable) {
                stream.size = 0;
                stream.data.length = 0;
            } // only emit packets that are complete. this is to avoid assembling
            // incomplete PES packets due to poor segmentation
            if (packetFlushable) self1.trigger('data', event);
        };
        ElementaryStream.prototype.init.call(this);
        /**
     * Identifies M2TS packet types and parses PES packets using metadata
     * parsed from the PMT
     **/ this.push = function(data) {
            ({
                pat: function() {
                // have any meaningful metadata
                },
                pes: function() {
                    var stream, streamType;
                    switch(data.streamType){
                        case StreamTypes$2.H264_STREAM_TYPE:
                            stream = video;
                            streamType = 'video';
                            break;
                        case StreamTypes$2.ADTS_STREAM_TYPE:
                            stream = audio;
                            streamType = 'audio';
                            break;
                        case StreamTypes$2.METADATA_STREAM_TYPE:
                            stream = timedMetadata;
                            streamType = 'timed-metadata';
                            break;
                        default:
                            // ignore unknown stream types
                            return;
                    } // if a new packet is starting, we can flush the completed
                    // packet
                    if (data.payloadUnitStartIndicator) flushStream(stream, streamType, true);
                     // buffer this fragment until we are sure we've received the
                    // complete payload
                    stream.data.push(data);
                    stream.size += data.data.byteLength;
                },
                pmt: function() {
                    var event = {
                        type: 'metadata',
                        tracks: []
                    };
                    programMapTable = data.programMapTable; // translate audio and video streams to tracks
                    if (programMapTable.video !== null) event.tracks.push({
                        timelineStartInfo: {
                            baseMediaDecodeTime: 0
                        },
                        id: +programMapTable.video,
                        codec: 'avc',
                        type: 'video'
                    });
                    if (programMapTable.audio !== null) event.tracks.push({
                        timelineStartInfo: {
                            baseMediaDecodeTime: 0
                        },
                        id: +programMapTable.audio,
                        codec: 'adts',
                        type: 'audio'
                    });
                    segmentHadPmt = true;
                    self1.trigger('data', event);
                }
            })[data.type]();
        };
        this.reset = function() {
            video.size = 0;
            video.data.length = 0;
            audio.size = 0;
            audio.data.length = 0;
            this.trigger('reset');
        };
        /**
     * Flush any remaining input. Video PES packets may be of variable
     * length. Normally, the start of a new video packet can trigger the
     * finalization of the previous packet. That is not possible if no
     * more video is forthcoming, however. In that case, some other
     * mechanism (like the end of the file) has to be employed. When it is
     * clear that no additional data is forthcoming, calling this method
     * will flush the buffered packets.
     */ this.flushStreams_ = function() {
            // !!THIS ORDER IS IMPORTANT!!
            // video first then audio
            flushStream(video, 'video');
            flushStream(audio, 'audio');
            flushStream(timedMetadata, 'timed-metadata');
        };
        this.flush = function() {
            // if on flush we haven't had a pmt emitted
            // and we have a pmt to emit. emit the pmt
            // so that we trigger a trackinfo downstream.
            if (!segmentHadPmt && programMapTable) {
                var pmt = {
                    type: 'metadata',
                    tracks: []
                }; // translate audio and video streams to tracks
                if (programMapTable.video !== null) pmt.tracks.push({
                    timelineStartInfo: {
                        baseMediaDecodeTime: 0
                    },
                    id: +programMapTable.video,
                    codec: 'avc',
                    type: 'video'
                });
                if (programMapTable.audio !== null) pmt.tracks.push({
                    timelineStartInfo: {
                        baseMediaDecodeTime: 0
                    },
                    id: +programMapTable.audio,
                    codec: 'adts',
                    type: 'audio'
                });
                self1.trigger('data', pmt);
            }
            segmentHadPmt = false;
            this.flushStreams_();
            this.trigger('done');
        };
    };
    ElementaryStream.prototype = new Stream$4();
    var m2ts$1 = {
        PAT_PID: 0x0000,
        MP2T_PACKET_LENGTH: MP2T_PACKET_LENGTH$1,
        TransportPacketStream: TransportPacketStream,
        TransportParseStream: TransportParseStream,
        ElementaryStream: ElementaryStream,
        TimestampRolloverStream: TimestampRolloverStream,
        CaptionStream: CaptionStream$1.CaptionStream,
        Cea608Stream: CaptionStream$1.Cea608Stream,
        Cea708Stream: CaptionStream$1.Cea708Stream,
        MetadataStream: metadataStream
    };
    for(var type in StreamTypes$2)if (StreamTypes$2.hasOwnProperty(type)) m2ts$1[type] = StreamTypes$2[type];
    var m2ts_1 = m2ts$1;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var Stream$3 = stream;
    var ONE_SECOND_IN_TS$2 = clock$2.ONE_SECOND_IN_TS;
    var AdtsStream$1;
    var ADTS_SAMPLING_FREQUENCIES$1 = [
        96000,
        88200,
        64000,
        48000,
        44100,
        32000,
        24000,
        22050,
        16000,
        12000,
        11025,
        8000,
        7350
    ];
    /*
   * Accepts a ElementaryStream and emits data events with parsed
   * AAC Audio Frames of the individual packets. Input audio in ADTS
   * format is unpacked and re-emitted as AAC frames.
   *
   * @see http://wiki.multimedia.cx/index.php?title=ADTS
   * @see http://wiki.multimedia.cx/?title=Understanding_AAC
   */ AdtsStream$1 = function(handlePartialSegments) {
        var buffer, frameNum = 0;
        AdtsStream$1.prototype.init.call(this);
        this.skipWarn_ = function(start, end) {
            this.trigger('log', {
                level: 'warn',
                message: `adts skiping bytes ${start} to ${end} in frame ${frameNum} outside syncword`
            });
        };
        this.push = function(packet) {
            var i = 0, frameLength, protectionSkipBytes, oldBuffer, sampleCount, adtsFrameDuration;
            if (!handlePartialSegments) frameNum = 0;
            if (packet.type !== 'audio') // ignore non-audio data
            return;
             // Prepend any data in the buffer to the input data so that we can parse
            // aac frames the cross a PES packet boundary
            if (buffer && buffer.length) {
                oldBuffer = buffer;
                buffer = new Uint8Array(oldBuffer.byteLength + packet.data.byteLength);
                buffer.set(oldBuffer);
                buffer.set(packet.data, oldBuffer.byteLength);
            } else buffer = packet.data;
             // unpack any ADTS frames which have been fully received
            // for details on the ADTS header, see http://wiki.multimedia.cx/index.php?title=ADTS
            var skip; // We use i + 7 here because we want to be able to parse the entire header.
            // If we don't have enough bytes to do that, then we definitely won't have a full frame.
            while(i + 7 < buffer.length){
                // Look for the start of an ADTS header..
                if (buffer[i] !== 0xFF || (buffer[i + 1] & 0xF6) !== 0xF0) {
                    if (typeof skip !== 'number') skip = i;
                     // If a valid header was not found,  jump one forward and attempt to
                    // find a valid ADTS header starting at the next byte
                    i++;
                    continue;
                }
                if (typeof skip === 'number') {
                    this.skipWarn_(skip, i);
                    skip = null;
                } // The protection skip bit tells us if we have 2 bytes of CRC data at the
                // end of the ADTS header
                protectionSkipBytes = (~buffer[i + 1] & 0x01) * 2; // Frame length is a 13 bit integer starting 16 bits from the
                // end of the sync sequence
                // NOTE: frame length includes the size of the header
                frameLength = (buffer[i + 3] & 0x03) << 11 | buffer[i + 4] << 3 | (buffer[i + 5] & 0xe0) >> 5;
                sampleCount = ((buffer[i + 6] & 0x03) + 1) * 1024;
                adtsFrameDuration = sampleCount * ONE_SECOND_IN_TS$2 / ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 0x3c) >>> 2]; // If we don't have enough data to actually finish this ADTS frame,
                // then we have to wait for more data
                if (buffer.byteLength - i < frameLength) break;
                 // Otherwise, deliver the complete AAC frame
                this.trigger('data', {
                    pts: packet.pts + frameNum * adtsFrameDuration,
                    dts: packet.dts + frameNum * adtsFrameDuration,
                    sampleCount: sampleCount,
                    audioobjecttype: (buffer[i + 2] >>> 6 & 0x03) + 1,
                    channelcount: (buffer[i + 2] & 1) << 2 | (buffer[i + 3] & 0xc0) >>> 6,
                    samplerate: ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 0x3c) >>> 2],
                    samplingfrequencyindex: (buffer[i + 2] & 0x3c) >>> 2,
                    // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
                    samplesize: 16,
                    // data is the frame without it's header
                    data: buffer.subarray(i + 7 + protectionSkipBytes, i + frameLength)
                });
                frameNum++;
                i += frameLength;
            }
            if (typeof skip === 'number') {
                this.skipWarn_(skip, i);
                skip = null;
            } // remove processed bytes from the buffer.
            buffer = buffer.subarray(i);
        };
        this.flush = function() {
            frameNum = 0;
            this.trigger('done');
        };
        this.reset = function() {
            buffer = void 0;
            this.trigger('reset');
        };
        this.endTimeline = function() {
            buffer = void 0;
            this.trigger('endedtimeline');
        };
    };
    AdtsStream$1.prototype = new Stream$3();
    var adts = AdtsStream$1;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var ExpGolomb$1;
    /**
   * Parser for exponential Golomb codes, a variable-bitwidth number encoding
   * scheme used by h264.
   */ ExpGolomb$1 = function(workingData) {
        var // the number of bytes left to examine in workingData
        workingBytesAvailable = workingData.byteLength, // the current word being examined
        workingWord = 0, // :uint
        // the number of bits left to examine in the current word
        workingBitsAvailable = 0; // :uint;
        // ():uint
        this.length = function() {
            return 8 * workingBytesAvailable;
        }; // ():uint
        this.bitsAvailable = function() {
            return 8 * workingBytesAvailable + workingBitsAvailable;
        }; // ():void
        this.loadWord = function() {
            var position = workingData.byteLength - workingBytesAvailable, workingBytes = new Uint8Array(4), availableBytes = Math.min(4, workingBytesAvailable);
            if (availableBytes === 0) throw new Error('no bytes available');
            workingBytes.set(workingData.subarray(position, position + availableBytes));
            workingWord = new DataView(workingBytes.buffer).getUint32(0); // track the amount of workingData that has been processed
            workingBitsAvailable = availableBytes * 8;
            workingBytesAvailable -= availableBytes;
        }; // (count:int):void
        this.skipBits = function(count) {
            var skipBytes; // :int
            if (workingBitsAvailable > count) {
                workingWord <<= count;
                workingBitsAvailable -= count;
            } else {
                count -= workingBitsAvailable;
                skipBytes = Math.floor(count / 8);
                count -= skipBytes * 8;
                workingBytesAvailable -= skipBytes;
                this.loadWord();
                workingWord <<= count;
                workingBitsAvailable -= count;
            }
        }; // (size:int):uint
        this.readBits = function(size) {
            var bits = Math.min(workingBitsAvailable, size), // :uint
            valu = workingWord >>> 32 - bits; // :uint
            // if size > 31, handle error
            workingBitsAvailable -= bits;
            if (workingBitsAvailable > 0) workingWord <<= bits;
            else if (workingBytesAvailable > 0) this.loadWord();
            bits = size - bits;
            if (bits > 0) return valu << bits | this.readBits(bits);
            return valu;
        }; // ():uint
        this.skipLeadingZeros = function() {
            var leadingZeroCount; // :uint
            for(leadingZeroCount = 0; leadingZeroCount < workingBitsAvailable; ++leadingZeroCount)if ((workingWord & 0x80000000 >>> leadingZeroCount) !== 0) {
                // the first bit of working word is 1
                workingWord <<= leadingZeroCount;
                workingBitsAvailable -= leadingZeroCount;
                return leadingZeroCount;
            }
             // we exhausted workingWord and still have not found a 1
            this.loadWord();
            return leadingZeroCount + this.skipLeadingZeros();
        }; // ():void
        this.skipUnsignedExpGolomb = function() {
            this.skipBits(1 + this.skipLeadingZeros());
        }; // ():void
        this.skipExpGolomb = function() {
            this.skipBits(1 + this.skipLeadingZeros());
        }; // ():uint
        this.readUnsignedExpGolomb = function() {
            var clz = this.skipLeadingZeros(); // :uint
            return this.readBits(clz + 1) - 1;
        }; // ():int
        this.readExpGolomb = function() {
            var valu = this.readUnsignedExpGolomb(); // :int
            if (0x01 & valu) // the number is odd if the low order bit is set
            return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
            return -1 * (valu >>> 1); // divide by two then make it negative
        }; // Some convenience functions
        // :Boolean
        this.readBoolean = function() {
            return this.readBits(1) === 1;
        }; // ():int
        this.readUnsignedByte = function() {
            return this.readBits(8);
        };
        this.loadWord();
    };
    var expGolomb = ExpGolomb$1;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var Stream$2 = stream;
    var ExpGolomb = expGolomb;
    var H264Stream$1, NalByteStream;
    var PROFILES_WITH_OPTIONAL_SPS_DATA;
    /**
   * Accepts a NAL unit byte stream and unpacks the embedded NAL units.
   */ NalByteStream = function() {
        var syncPoint = 0, i, buffer;
        NalByteStream.prototype.init.call(this);
        /*
     * Scans a byte stream and triggers a data event with the NAL units found.
     * @param {Object} data Event received from H264Stream
     * @param {Uint8Array} data.data The h264 byte stream to be scanned
     *
     * @see H264Stream.push
     */ this.push = function(data) {
            var swapBuffer;
            if (!buffer) buffer = data.data;
            else {
                swapBuffer = new Uint8Array(buffer.byteLength + data.data.byteLength);
                swapBuffer.set(buffer);
                swapBuffer.set(data.data, buffer.byteLength);
                buffer = swapBuffer;
            }
            var len = buffer.byteLength; // Rec. ITU-T H.264, Annex B
            // scan for NAL unit boundaries
            // a match looks like this:
            // 0 0 1 .. NAL .. 0 0 1
            // ^ sync point        ^ i
            // or this:
            // 0 0 1 .. NAL .. 0 0 0
            // ^ sync point        ^ i
            // advance the sync point to a NAL start, if necessary
            for(; syncPoint < len - 3; syncPoint++)if (buffer[syncPoint + 2] === 1) {
                // the sync point is properly aligned
                i = syncPoint + 5;
                break;
            }
            while(i < len)// look at the current byte to determine if we've hit the end of
            // a NAL unit boundary
            switch(buffer[i]){
                case 0:
                    // skip past non-sync sequences
                    if (buffer[i - 1] !== 0) {
                        i += 2;
                        break;
                    } else if (buffer[i - 2] !== 0) {
                        i++;
                        break;
                    } // deliver the NAL unit if it isn't empty
                    if (syncPoint + 3 !== i - 2) this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
                     // drop trailing zeroes
                    do i++;
                    while (buffer[i] !== 1 && i < len);
                    syncPoint = i - 2;
                    i += 3;
                    break;
                case 1:
                    // skip past non-sync sequences
                    if (buffer[i - 1] !== 0 || buffer[i - 2] !== 0) {
                        i += 3;
                        break;
                    } // deliver the NAL unit
                    this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
                    syncPoint = i - 2;
                    i += 3;
                    break;
                default:
                    // the current byte isn't a one or zero, so it cannot be part
                    // of a sync sequence
                    i += 3;
                    break;
            }
             // filter out the NAL units that were delivered
            buffer = buffer.subarray(syncPoint);
            i -= syncPoint;
            syncPoint = 0;
        };
        this.reset = function() {
            buffer = null;
            syncPoint = 0;
            this.trigger('reset');
        };
        this.flush = function() {
            // deliver the last buffered NAL unit
            if (buffer && buffer.byteLength > 3) this.trigger('data', buffer.subarray(syncPoint + 3));
             // reset the stream state
            buffer = null;
            syncPoint = 0;
            this.trigger('done');
        };
        this.endTimeline = function() {
            this.flush();
            this.trigger('endedtimeline');
        };
    };
    NalByteStream.prototype = new Stream$2(); // values of profile_idc that indicate additional fields are included in the SPS
    // see Recommendation ITU-T H.264 (4/2013),
    // 7.3.2.1.1 Sequence parameter set data syntax
    PROFILES_WITH_OPTIONAL_SPS_DATA = {
        100: true,
        110: true,
        122: true,
        244: true,
        44: true,
        83: true,
        86: true,
        118: true,
        128: true,
        // TODO: the three profiles below don't
        // appear to have sps data in the specificiation anymore?
        138: true,
        139: true,
        134: true
    };
    /**
   * Accepts input from a ElementaryStream and produces H.264 NAL unit data
   * events.
   */ H264Stream$1 = function() {
        var nalByteStream = new NalByteStream(), self1, trackId, currentPts, currentDts, discardEmulationPreventionBytes, readSequenceParameterSet, skipScalingList;
        H264Stream$1.prototype.init.call(this);
        self1 = this;
        /*
     * Pushes a packet from a stream onto the NalByteStream
     *
     * @param {Object} packet - A packet received from a stream
     * @param {Uint8Array} packet.data - The raw bytes of the packet
     * @param {Number} packet.dts - Decode timestamp of the packet
     * @param {Number} packet.pts - Presentation timestamp of the packet
     * @param {Number} packet.trackId - The id of the h264 track this packet came from
     * @param {('video'|'audio')} packet.type - The type of packet
     *
     */ this.push = function(packet) {
            if (packet.type !== 'video') return;
            trackId = packet.trackId;
            currentPts = packet.pts;
            currentDts = packet.dts;
            nalByteStream.push(packet);
        };
        /*
     * Identify NAL unit types and pass on the NALU, trackId, presentation and decode timestamps
     * for the NALUs to the next stream component.
     * Also, preprocess caption and sequence parameter NALUs.
     *
     * @param {Uint8Array} data - A NAL unit identified by `NalByteStream.push`
     * @see NalByteStream.push
     */ nalByteStream.on('data', function(data) {
            var event = {
                trackId: trackId,
                pts: currentPts,
                dts: currentDts,
                data: data,
                nalUnitTypeCode: data[0] & 0x1f
            };
            switch(event.nalUnitTypeCode){
                case 0x05:
                    event.nalUnitType = 'slice_layer_without_partitioning_rbsp_idr';
                    break;
                case 0x06:
                    event.nalUnitType = 'sei_rbsp';
                    event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
                    break;
                case 0x07:
                    event.nalUnitType = 'seq_parameter_set_rbsp';
                    event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
                    event.config = readSequenceParameterSet(event.escapedRBSP);
                    break;
                case 0x08:
                    event.nalUnitType = 'pic_parameter_set_rbsp';
                    break;
                case 0x09:
                    event.nalUnitType = 'access_unit_delimiter_rbsp';
                    break;
            } // This triggers data on the H264Stream
            self1.trigger('data', event);
        });
        nalByteStream.on('done', function() {
            self1.trigger('done');
        });
        nalByteStream.on('partialdone', function() {
            self1.trigger('partialdone');
        });
        nalByteStream.on('reset', function() {
            self1.trigger('reset');
        });
        nalByteStream.on('endedtimeline', function() {
            self1.trigger('endedtimeline');
        });
        this.flush = function() {
            nalByteStream.flush();
        };
        this.partialFlush = function() {
            nalByteStream.partialFlush();
        };
        this.reset = function() {
            nalByteStream.reset();
        };
        this.endTimeline = function() {
            nalByteStream.endTimeline();
        };
        /**
     * Advance the ExpGolomb decoder past a scaling list. The scaling
     * list is optionally transmitted as part of a sequence parameter
     * set and is not relevant to transmuxing.
     * @param count {number} the number of entries in this scaling list
     * @param expGolombDecoder {object} an ExpGolomb pointed to the
     * start of a scaling list
     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
     */ skipScalingList = function(count, expGolombDecoder) {
            var lastScale = 8, nextScale = 8, j, deltaScale;
            for(j = 0; j < count; j++){
                if (nextScale !== 0) {
                    deltaScale = expGolombDecoder.readExpGolomb();
                    nextScale = (lastScale + deltaScale + 256) % 256;
                }
                lastScale = nextScale === 0 ? lastScale : nextScale;
            }
        };
        /**
     * Expunge any "Emulation Prevention" bytes from a "Raw Byte
     * Sequence Payload"
     * @param data {Uint8Array} the bytes of a RBSP from a NAL
     * unit
     * @return {Uint8Array} the RBSP without any Emulation
     * Prevention Bytes
     */ discardEmulationPreventionBytes = function(data) {
            var length = data.byteLength, emulationPreventionBytesPositions = [], i = 1, newLength, newData; // Find all `Emulation Prevention Bytes`
            while(i < length - 2)if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
                emulationPreventionBytesPositions.push(i + 2);
                i += 2;
            } else i++;
             // If no Emulation Prevention Bytes were found just return the original
            // array
            if (emulationPreventionBytesPositions.length === 0) return data;
             // Create a new array to hold the NAL unit data
            newLength = length - emulationPreventionBytesPositions.length;
            newData = new Uint8Array(newLength);
            var sourceIndex = 0;
            for(i = 0; i < newLength; sourceIndex++, i++){
                if (sourceIndex === emulationPreventionBytesPositions[0]) {
                    // Skip this byte
                    sourceIndex++; // Remove this position index
                    emulationPreventionBytesPositions.shift();
                }
                newData[i] = data[sourceIndex];
            }
            return newData;
        };
        /**
     * Read a sequence parameter set and return some interesting video
     * properties. A sequence parameter set is the H264 metadata that
     * describes the properties of upcoming video frames.
     * @param data {Uint8Array} the bytes of a sequence parameter set
     * @return {object} an object with configuration parsed from the
     * sequence parameter set, including the dimensions of the
     * associated video frames.
     */ readSequenceParameterSet = function(data) {
            var frameCropLeftOffset = 0, frameCropRightOffset = 0, frameCropTopOffset = 0, frameCropBottomOffset = 0, expGolombDecoder, profileIdc, levelIdc, profileCompatibility, chromaFormatIdc, picOrderCntType, numRefFramesInPicOrderCntCycle, picWidthInMbsMinus1, picHeightInMapUnitsMinus1, frameMbsOnlyFlag, scalingListCount, sarRatio = [
                1,
                1
            ], aspectRatioIdc, i;
            expGolombDecoder = new ExpGolomb(data);
            profileIdc = expGolombDecoder.readUnsignedByte(); // profile_idc
            profileCompatibility = expGolombDecoder.readUnsignedByte(); // constraint_set[0-5]_flag
            levelIdc = expGolombDecoder.readUnsignedByte(); // level_idc u(8)
            expGolombDecoder.skipUnsignedExpGolomb(); // seq_parameter_set_id
            // some profiles have more optional data we don't need
            if (PROFILES_WITH_OPTIONAL_SPS_DATA[profileIdc]) {
                chromaFormatIdc = expGolombDecoder.readUnsignedExpGolomb();
                if (chromaFormatIdc === 3) expGolombDecoder.skipBits(1); // separate_colour_plane_flag
                expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_luma_minus8
                expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_chroma_minus8
                expGolombDecoder.skipBits(1); // qpprime_y_zero_transform_bypass_flag
                if (expGolombDecoder.readBoolean()) {
                    // seq_scaling_matrix_present_flag
                    scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
                    for(i = 0; i < scalingListCount; i++)if (expGolombDecoder.readBoolean()) {
                        // seq_scaling_list_present_flag[ i ]
                        if (i < 6) skipScalingList(16, expGolombDecoder);
                        else skipScalingList(64, expGolombDecoder);
                    }
                }
            }
            expGolombDecoder.skipUnsignedExpGolomb(); // log2_max_frame_num_minus4
            picOrderCntType = expGolombDecoder.readUnsignedExpGolomb();
            if (picOrderCntType === 0) expGolombDecoder.readUnsignedExpGolomb(); // log2_max_pic_order_cnt_lsb_minus4
            else if (picOrderCntType === 1) {
                expGolombDecoder.skipBits(1); // delta_pic_order_always_zero_flag
                expGolombDecoder.skipExpGolomb(); // offset_for_non_ref_pic
                expGolombDecoder.skipExpGolomb(); // offset_for_top_to_bottom_field
                numRefFramesInPicOrderCntCycle = expGolombDecoder.readUnsignedExpGolomb();
                for(i = 0; i < numRefFramesInPicOrderCntCycle; i++)expGolombDecoder.skipExpGolomb(); // offset_for_ref_frame[ i ]
            }
            expGolombDecoder.skipUnsignedExpGolomb(); // max_num_ref_frames
            expGolombDecoder.skipBits(1); // gaps_in_frame_num_value_allowed_flag
            picWidthInMbsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
            picHeightInMapUnitsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
            frameMbsOnlyFlag = expGolombDecoder.readBits(1);
            if (frameMbsOnlyFlag === 0) expGolombDecoder.skipBits(1); // mb_adaptive_frame_field_flag
            expGolombDecoder.skipBits(1); // direct_8x8_inference_flag
            if (expGolombDecoder.readBoolean()) {
                // frame_cropping_flag
                frameCropLeftOffset = expGolombDecoder.readUnsignedExpGolomb();
                frameCropRightOffset = expGolombDecoder.readUnsignedExpGolomb();
                frameCropTopOffset = expGolombDecoder.readUnsignedExpGolomb();
                frameCropBottomOffset = expGolombDecoder.readUnsignedExpGolomb();
            }
            if (expGolombDecoder.readBoolean()) // vui_parameters_present_flag
            {
                if (expGolombDecoder.readBoolean()) {
                    // aspect_ratio_info_present_flag
                    aspectRatioIdc = expGolombDecoder.readUnsignedByte();
                    switch(aspectRatioIdc){
                        case 1:
                            sarRatio = [
                                1,
                                1
                            ];
                            break;
                        case 2:
                            sarRatio = [
                                12,
                                11
                            ];
                            break;
                        case 3:
                            sarRatio = [
                                10,
                                11
                            ];
                            break;
                        case 4:
                            sarRatio = [
                                16,
                                11
                            ];
                            break;
                        case 5:
                            sarRatio = [
                                40,
                                33
                            ];
                            break;
                        case 6:
                            sarRatio = [
                                24,
                                11
                            ];
                            break;
                        case 7:
                            sarRatio = [
                                20,
                                11
                            ];
                            break;
                        case 8:
                            sarRatio = [
                                32,
                                11
                            ];
                            break;
                        case 9:
                            sarRatio = [
                                80,
                                33
                            ];
                            break;
                        case 10:
                            sarRatio = [
                                18,
                                11
                            ];
                            break;
                        case 11:
                            sarRatio = [
                                15,
                                11
                            ];
                            break;
                        case 12:
                            sarRatio = [
                                64,
                                33
                            ];
                            break;
                        case 13:
                            sarRatio = [
                                160,
                                99
                            ];
                            break;
                        case 14:
                            sarRatio = [
                                4,
                                3
                            ];
                            break;
                        case 15:
                            sarRatio = [
                                3,
                                2
                            ];
                            break;
                        case 16:
                            sarRatio = [
                                2,
                                1
                            ];
                            break;
                        case 255:
                            sarRatio = [
                                expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte(),
                                expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte()
                            ];
                            break;
                    }
                    if (sarRatio) sarRatio[0], sarRatio[1];
                }
            }
            return {
                profileIdc: profileIdc,
                levelIdc: levelIdc,
                profileCompatibility: profileCompatibility,
                width: (picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2,
                height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - frameCropTopOffset * 2 - frameCropBottomOffset * 2,
                // sar is sample aspect ratio
                sarRatio: sarRatio
            };
        };
    };
    H264Stream$1.prototype = new Stream$2();
    var h264 = {
        H264Stream: H264Stream$1,
        NalByteStream: NalByteStream
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Utilities to detect basic properties and metadata about Aac data.
   */ var ADTS_SAMPLING_FREQUENCIES = [
        96000,
        88200,
        64000,
        48000,
        44100,
        32000,
        24000,
        22050,
        16000,
        12000,
        11025,
        8000,
        7350
    ];
    var parseId3TagSize = function(header, byteIndex) {
        var returnSize = header[byteIndex + 6] << 21 | header[byteIndex + 7] << 14 | header[byteIndex + 8] << 7 | header[byteIndex + 9], flags = header[byteIndex + 5], footerPresent = (flags & 16) >> 4; // if we get a negative returnSize clamp it to 0
        returnSize = returnSize >= 0 ? returnSize : 0;
        if (footerPresent) return returnSize + 20;
        return returnSize + 10;
    };
    var getId3Offset = function(data, offset) {
        if (data.length - offset < 10 || data[offset] !== 'I'.charCodeAt(0) || data[offset + 1] !== 'D'.charCodeAt(0) || data[offset + 2] !== '3'.charCodeAt(0)) return offset;
        offset += parseId3TagSize(data, offset);
        return getId3Offset(data, offset);
    }; // TODO: use vhs-utils
    var isLikelyAacData$1 = function(data) {
        var offset = getId3Offset(data, 0);
        return data.length >= offset + 2 && (data[offset] & 0xFF) === 0xFF && (data[offset + 1] & 0xF0) === 0xF0 && // verify that the 2 layer bits are 0, aka this
        // is not mp3 data but aac data.
        (data[offset + 1] & 0x16) === 0x10;
    };
    var parseSyncSafeInteger = function(data) {
        return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
    }; // return a percent-encoded representation of the specified byte range
    // @see http://en.wikipedia.org/wiki/Percent-encoding
    var percentEncode = function(bytes, start, end) {
        var i, result = '';
        for(i = start; i < end; i++)result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
        return result;
    }; // return the string representation of the specified byte range,
    // interpreted as ISO-8859-1.
    var parseIso88591 = function(bytes, start, end) {
        return unescape(percentEncode(bytes, start, end)); // jshint ignore:line
    };
    var parseAdtsSize = function(header, byteIndex) {
        var lowThree = (header[byteIndex + 5] & 0xE0) >> 5, middle = header[byteIndex + 4] << 3, highTwo = header[byteIndex + 3] & 6144;
        return highTwo | middle | lowThree;
    };
    var parseType$5 = function(header, byteIndex) {
        if (header[byteIndex] === 'I'.charCodeAt(0) && header[byteIndex + 1] === 'D'.charCodeAt(0) && header[byteIndex + 2] === '3'.charCodeAt(0)) return 'timed-metadata';
        else if (header[byteIndex] & true && (header[byteIndex + 1] & 0xf0) === 0xf0) return 'audio';
        return null;
    };
    var parseSampleRate = function(packet) {
        var i = 0;
        while(i + 5 < packet.length){
            if (packet[i] !== 0xFF || (packet[i + 1] & 0xF6) !== 0xF0) {
                // If a valid header was not found,  jump one forward and attempt to
                // find a valid ADTS header starting at the next byte
                i++;
                continue;
            }
            return ADTS_SAMPLING_FREQUENCIES[(packet[i + 2] & 0x3c) >>> 2];
        }
        return null;
    };
    var parseAacTimestamp = function(packet) {
        var frameStart, frameSize, frame, frameHeader; // find the start of the first frame and the end of the tag
        frameStart = 10;
        if (packet[5] & 0x40) {
            // advance the frame start past the extended header
            frameStart += 4; // header size field
            frameStart += parseSyncSafeInteger(packet.subarray(10, 14));
        } // parse one or more ID3 frames
        // http://id3.org/id3v2.3.0#ID3v2_frame_overview
        do {
            // determine the number of bytes in this frame
            frameSize = parseSyncSafeInteger(packet.subarray(frameStart + 4, frameStart + 8));
            if (frameSize < 1) return null;
            frameHeader = String.fromCharCode(packet[frameStart], packet[frameStart + 1], packet[frameStart + 2], packet[frameStart + 3]);
            if (frameHeader === 'PRIV') {
                frame = packet.subarray(frameStart + 10, frameStart + frameSize + 10);
                for(var i = 0; i < frame.byteLength; i++)if (frame[i] === 0) {
                    var owner = parseIso88591(frame, 0, i);
                    if (owner === 'com.apple.streaming.transportStreamTimestamp') {
                        var d = frame.subarray(i + 1);
                        var size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
                        size *= 4;
                        size += d[7] & 0x03;
                        return size;
                    }
                    break;
                }
            }
            frameStart += 10; // advance past the frame header
            frameStart += frameSize; // advance past the frame body
        }while (frameStart < packet.byteLength);
        return null;
    };
    var utils = {
        isLikelyAacData: isLikelyAacData$1,
        parseId3TagSize: parseId3TagSize,
        parseAdtsSize: parseAdtsSize,
        parseType: parseType$5,
        parseSampleRate: parseSampleRate,
        parseAacTimestamp: parseAacTimestamp
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A stream-based aac to mp4 converter. This utility can be used to
   * deliver mp4s to a SourceBuffer on platforms that support native
   * Media Source Extensions.
   */ var Stream$1 = stream;
    var aacUtils = utils; // Constants
    var AacStream$1;
    /**
   * Splits an incoming stream of binary data into ADTS and ID3 Frames.
   */ AacStream$1 = function() {
        var everything = new Uint8Array(), timeStamp = 0;
        AacStream$1.prototype.init.call(this);
        this.setTimestamp = function(timestamp) {
            timeStamp = timestamp;
        };
        this.push = function(bytes) {
            var frameSize = 0, byteIndex = 0, bytesLeft, chunk, packet, tempLength; // If there are bytes remaining from the last segment, prepend them to the
            // bytes that were pushed in
            if (everything.length) {
                tempLength = everything.length;
                everything = new Uint8Array(bytes.byteLength + tempLength);
                everything.set(everything.subarray(0, tempLength));
                everything.set(bytes, tempLength);
            } else everything = bytes;
            while(everything.length - byteIndex >= 3){
                if (everything[byteIndex] === 'I'.charCodeAt(0) && everything[byteIndex + 1] === 'D'.charCodeAt(0) && everything[byteIndex + 2] === '3'.charCodeAt(0)) {
                    // Exit early because we don't have enough to parse
                    // the ID3 tag header
                    if (everything.length - byteIndex < 10) break;
                     // check framesize
                    frameSize = aacUtils.parseId3TagSize(everything, byteIndex); // Exit early if we don't have enough in the buffer
                    // to emit a full packet
                    // Add to byteIndex to support multiple ID3 tags in sequence
                    if (byteIndex + frameSize > everything.length) break;
                    chunk = {
                        type: 'timed-metadata',
                        data: everything.subarray(byteIndex, byteIndex + frameSize)
                    };
                    this.trigger('data', chunk);
                    byteIndex += frameSize;
                    continue;
                } else if ((everything[byteIndex] & 0xff) === 0xff && (everything[byteIndex + 1] & 0xf0) === 0xf0) {
                    // Exit early because we don't have enough to parse
                    // the ADTS frame header
                    if (everything.length - byteIndex < 7) break;
                    frameSize = aacUtils.parseAdtsSize(everything, byteIndex); // Exit early if we don't have enough in the buffer
                    // to emit a full packet
                    if (byteIndex + frameSize > everything.length) break;
                    packet = {
                        type: 'audio',
                        data: everything.subarray(byteIndex, byteIndex + frameSize),
                        pts: timeStamp,
                        dts: timeStamp
                    };
                    this.trigger('data', packet);
                    byteIndex += frameSize;
                    continue;
                }
                byteIndex++;
            }
            bytesLeft = everything.length - byteIndex;
            if (bytesLeft > 0) everything = everything.subarray(byteIndex);
            else everything = new Uint8Array();
        };
        this.reset = function() {
            everything = new Uint8Array();
            this.trigger('reset');
        };
        this.endTimeline = function() {
            everything = new Uint8Array();
            this.trigger('endedtimeline');
        };
    };
    AacStream$1.prototype = new Stream$1();
    var aac = AacStream$1;
    var AUDIO_PROPERTIES$1 = [
        'audioobjecttype',
        'channelcount',
        'samplerate',
        'samplingfrequencyindex',
        'samplesize'
    ];
    var audioProperties = AUDIO_PROPERTIES$1;
    var VIDEO_PROPERTIES$1 = [
        'width',
        'height',
        'profileIdc',
        'levelIdc',
        'profileCompatibility',
        'sarRatio'
    ];
    var videoProperties = VIDEO_PROPERTIES$1;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A stream-based mp2t to mp4 converter. This utility can be used to
   * deliver mp4s to a SourceBuffer on platforms that support native
   * Media Source Extensions.
   */ var Stream = stream;
    var mp4 = mp4Generator;
    var frameUtils = frameUtils$1;
    var audioFrameUtils = audioFrameUtils$1;
    var trackDecodeInfo = trackDecodeInfo$1;
    var m2ts = m2ts_1;
    var clock = clock$2;
    var AdtsStream = adts;
    var H264Stream = h264.H264Stream;
    var AacStream = aac;
    var isLikelyAacData = utils.isLikelyAacData;
    var ONE_SECOND_IN_TS$1 = clock$2.ONE_SECOND_IN_TS;
    var AUDIO_PROPERTIES = audioProperties;
    var VIDEO_PROPERTIES = videoProperties; // object types
    var VideoSegmentStream, AudioSegmentStream, Transmuxer, CoalesceStream;
    var retriggerForStream = function(key, event) {
        event.stream = key;
        this.trigger('log', event);
    };
    var addPipelineLogRetriggers = function(transmuxer, pipeline) {
        var keys = Object.keys(pipeline);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i]; // skip non-stream keys and headOfPipeline
            // which is just a duplicate
            if (key === 'headOfPipeline' || !pipeline[key].on) continue;
            pipeline[key].on('log', retriggerForStream.bind(transmuxer, key));
        }
    };
    /**
   * Compare two arrays (even typed) for same-ness
   */ var arrayEquals = function(a, b) {
        var i;
        if (a.length !== b.length) return false;
         // compare the value of each element in the array
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    };
    var generateSegmentTimingInfo = function(baseMediaDecodeTime, startDts, startPts, endDts, endPts, prependedContentDuration) {
        var ptsOffsetFromDts = startPts - startDts, decodeDuration = endDts - startDts, presentationDuration = endPts - startPts; // The PTS and DTS values are based on the actual stream times from the segment,
        // however, the player time values will reflect a start from the baseMediaDecodeTime.
        // In order to provide relevant values for the player times, base timing info on the
        // baseMediaDecodeTime and the DTS and PTS durations of the segment.
        return {
            start: {
                dts: baseMediaDecodeTime,
                pts: baseMediaDecodeTime + ptsOffsetFromDts
            },
            end: {
                dts: baseMediaDecodeTime + decodeDuration,
                pts: baseMediaDecodeTime + presentationDuration
            },
            prependedContentDuration: prependedContentDuration,
            baseMediaDecodeTime: baseMediaDecodeTime
        };
    };
    /**
   * Constructs a single-track, ISO BMFF media segment from AAC data
   * events. The output of this stream can be fed to a SourceBuffer
   * configured with a suitable initialization segment.
   * @param track {object} track metadata configuration
   * @param options {object} transmuxer options object
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */ AudioSegmentStream = function(track, options) {
        var adtsFrames = [], sequenceNumber, earliestAllowedDts = 0, audioAppendStartTs = 0, videoBaseMediaDecodeTime = Infinity;
        options = options || {};
        sequenceNumber = options.firstSequenceNumber || 0;
        AudioSegmentStream.prototype.init.call(this);
        this.push = function(data) {
            trackDecodeInfo.collectDtsInfo(track, data);
            if (track) AUDIO_PROPERTIES.forEach(function(prop) {
                track[prop] = data[prop];
            });
             // buffer audio data until end() is called
            adtsFrames.push(data);
        };
        this.setEarliestDts = function(earliestDts) {
            earliestAllowedDts = earliestDts;
        };
        this.setVideoBaseMediaDecodeTime = function(baseMediaDecodeTime) {
            videoBaseMediaDecodeTime = baseMediaDecodeTime;
        };
        this.setAudioAppendStart = function(timestamp) {
            audioAppendStartTs = timestamp;
        };
        this.flush = function() {
            var frames, moof, mdat, boxes, frameDuration, segmentDuration, videoClockCyclesOfSilencePrefixed; // return early if no audio data has been observed
            if (adtsFrames.length === 0) {
                this.trigger('done', 'AudioSegmentStream');
                return;
            }
            frames = audioFrameUtils.trimAdtsFramesByEarliestDts(adtsFrames, track, earliestAllowedDts);
            track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps); // amount of audio filled but the value is in video clock rather than audio clock
            videoClockCyclesOfSilencePrefixed = audioFrameUtils.prefixWithSilence(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime); // we have to build the index from byte locations to
            // samples (that is, adts frames) in the audio data
            track.samples = audioFrameUtils.generateSampleTable(frames); // concatenate the audio data to constuct the mdat
            mdat = mp4.mdat(audioFrameUtils.concatenateFrameData(frames));
            adtsFrames = [];
            moof = mp4.moof(sequenceNumber, [
                track
            ]);
            boxes = new Uint8Array(moof.byteLength + mdat.byteLength); // bump the sequence number for next time
            sequenceNumber++;
            boxes.set(moof);
            boxes.set(mdat, moof.byteLength);
            trackDecodeInfo.clearDtsInfo(track);
            frameDuration = Math.ceil(ONE_SECOND_IN_TS$1 * 1024 / track.samplerate); // TODO this check was added to maintain backwards compatibility (particularly with
            // tests) on adding the timingInfo event. However, it seems unlikely that there's a
            // valid use-case where an init segment/data should be triggered without associated
            // frames. Leaving for now, but should be looked into.
            if (frames.length) {
                segmentDuration = frames.length * frameDuration;
                this.trigger('segmentTimingInfo', generateSegmentTimingInfo(// The audio track's baseMediaDecodeTime is in audio clock cycles, but the
                // frame info is in video clock cycles. Convert to match expectation of
                // listeners (that all timestamps will be based on video clock cycles).
                clock.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate), // frame times are already in video clock, as is segment duration
                frames[0].dts, frames[0].pts, frames[0].dts + segmentDuration, frames[0].pts + segmentDuration, videoClockCyclesOfSilencePrefixed || 0));
                this.trigger('timingInfo', {
                    start: frames[0].pts,
                    end: frames[0].pts + segmentDuration
                });
            }
            this.trigger('data', {
                track: track,
                boxes: boxes
            });
            this.trigger('done', 'AudioSegmentStream');
        };
        this.reset = function() {
            trackDecodeInfo.clearDtsInfo(track);
            adtsFrames = [];
            this.trigger('reset');
        };
    };
    AudioSegmentStream.prototype = new Stream();
    /**
   * Constructs a single-track, ISO BMFF media segment from H264 data
   * events. The output of this stream can be fed to a SourceBuffer
   * configured with a suitable initialization segment.
   * @param track {object} track metadata configuration
   * @param options {object} transmuxer options object
   * @param options.alignGopsAtEnd {boolean} If true, start from the end of the
   *        gopsToAlignWith list when attempting to align gop pts
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */ VideoSegmentStream = function(track, options) {
        var sequenceNumber, nalUnits = [], gopsToAlignWith = [], config, pps;
        options = options || {};
        sequenceNumber = options.firstSequenceNumber || 0;
        VideoSegmentStream.prototype.init.call(this);
        delete track.minPTS;
        this.gopCache_ = [];
        /**
      * Constructs a ISO BMFF segment given H264 nalUnits
      * @param {Object} nalUnit A data event representing a nalUnit
      * @param {String} nalUnit.nalUnitType
      * @param {Object} nalUnit.config Properties for a mp4 track
      * @param {Uint8Array} nalUnit.data The nalUnit bytes
      * @see lib/codecs/h264.js
     **/ this.push = function(nalUnit) {
            trackDecodeInfo.collectDtsInfo(track, nalUnit); // record the track config
            if (nalUnit.nalUnitType === 'seq_parameter_set_rbsp' && !config) {
                config = nalUnit.config;
                track.sps = [
                    nalUnit.data
                ];
                VIDEO_PROPERTIES.forEach(function(prop) {
                    track[prop] = config[prop];
                }, this);
            }
            if (nalUnit.nalUnitType === 'pic_parameter_set_rbsp' && !pps) {
                pps = nalUnit.data;
                track.pps = [
                    nalUnit.data
                ];
            } // buffer video until flush() is called
            nalUnits.push(nalUnit);
        };
        /**
      * Pass constructed ISO BMFF track and boxes on to the
      * next stream in the pipeline
     **/ this.flush = function() {
            var frames, gopForFusion, gops, moof, mdat, boxes, prependedContentDuration = 0, firstGop, lastGop; // Throw away nalUnits at the start of the byte stream until
            // we find the first AUD
            while(nalUnits.length){
                if (nalUnits[0].nalUnitType === 'access_unit_delimiter_rbsp') break;
                nalUnits.shift();
            } // Return early if no video data has been observed
            if (nalUnits.length === 0) {
                this.resetStream_();
                this.trigger('done', 'VideoSegmentStream');
                return;
            } // Organize the raw nal-units into arrays that represent
            // higher-level constructs such as frames and gops
            // (group-of-pictures)
            frames = frameUtils.groupNalsIntoFrames(nalUnits);
            gops = frameUtils.groupFramesIntoGops(frames); // If the first frame of this fragment is not a keyframe we have
            // a problem since MSE (on Chrome) requires a leading keyframe.
            //
            // We have two approaches to repairing this situation:
            // 1) GOP-FUSION:
            //    This is where we keep track of the GOPS (group-of-pictures)
            //    from previous fragments and attempt to find one that we can
            //    prepend to the current fragment in order to create a valid
            //    fragment.
            // 2) KEYFRAME-PULLING:
            //    Here we search for the first keyframe in the fragment and
            //    throw away all the frames between the start of the fragment
            //    and that keyframe. We then extend the duration and pull the
            //    PTS of the keyframe forward so that it covers the time range
            //    of the frames that were disposed of.
            //
            // #1 is far prefereable over #2 which can cause "stuttering" but
            // requires more things to be just right.
            if (!gops[0][0].keyFrame) {
                // Search for a gop for fusion from our gopCache
                gopForFusion = this.getGopForFusion_(nalUnits[0], track);
                if (gopForFusion) {
                    // in order to provide more accurate timing information about the segment, save
                    // the number of seconds prepended to the original segment due to GOP fusion
                    prependedContentDuration = gopForFusion.duration;
                    gops.unshift(gopForFusion); // Adjust Gops' metadata to account for the inclusion of the
                    // new gop at the beginning
                    gops.byteLength += gopForFusion.byteLength;
                    gops.nalCount += gopForFusion.nalCount;
                    gops.pts = gopForFusion.pts;
                    gops.dts = gopForFusion.dts;
                    gops.duration += gopForFusion.duration;
                } else // If we didn't find a candidate gop fall back to keyframe-pulling
                gops = frameUtils.extendFirstKeyFrame(gops);
            } // Trim gops to align with gopsToAlignWith
            if (gopsToAlignWith.length) {
                var alignedGops;
                if (options.alignGopsAtEnd) alignedGops = this.alignGopsAtEnd_(gops);
                else alignedGops = this.alignGopsAtStart_(gops);
                if (!alignedGops) {
                    // save all the nals in the last GOP into the gop cache
                    this.gopCache_.unshift({
                        gop: gops.pop(),
                        pps: track.pps,
                        sps: track.sps
                    }); // Keep a maximum of 6 GOPs in the cache
                    this.gopCache_.length = Math.min(6, this.gopCache_.length); // Clear nalUnits
                    nalUnits = []; // return early no gops can be aligned with desired gopsToAlignWith
                    this.resetStream_();
                    this.trigger('done', 'VideoSegmentStream');
                    return;
                } // Some gops were trimmed. clear dts info so minSegmentDts and pts are correct
                // when recalculated before sending off to CoalesceStream
                trackDecodeInfo.clearDtsInfo(track);
                gops = alignedGops;
            }
            trackDecodeInfo.collectDtsInfo(track, gops); // First, we have to build the index from byte locations to
            // samples (that is, frames) in the video data
            track.samples = frameUtils.generateSampleTable(gops); // Concatenate the video data and construct the mdat
            mdat = mp4.mdat(frameUtils.concatenateNalData(gops));
            track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps);
            this.trigger('processedGopsInfo', gops.map(function(gop) {
                return {
                    pts: gop.pts,
                    dts: gop.dts,
                    byteLength: gop.byteLength
                };
            }));
            firstGop = gops[0];
            lastGop = gops[gops.length - 1];
            this.trigger('segmentTimingInfo', generateSegmentTimingInfo(track.baseMediaDecodeTime, firstGop.dts, firstGop.pts, lastGop.dts + lastGop.duration, lastGop.pts + lastGop.duration, prependedContentDuration));
            this.trigger('timingInfo', {
                start: gops[0].pts,
                end: gops[gops.length - 1].pts + gops[gops.length - 1].duration
            }); // save all the nals in the last GOP into the gop cache
            this.gopCache_.unshift({
                gop: gops.pop(),
                pps: track.pps,
                sps: track.sps
            }); // Keep a maximum of 6 GOPs in the cache
            this.gopCache_.length = Math.min(6, this.gopCache_.length); // Clear nalUnits
            nalUnits = [];
            this.trigger('baseMediaDecodeTime', track.baseMediaDecodeTime);
            this.trigger('timelineStartInfo', track.timelineStartInfo);
            moof = mp4.moof(sequenceNumber, [
                track
            ]); // it would be great to allocate this array up front instead of
            // throwing away hundreds of media segment fragments
            boxes = new Uint8Array(moof.byteLength + mdat.byteLength); // Bump the sequence number for next time
            sequenceNumber++;
            boxes.set(moof);
            boxes.set(mdat, moof.byteLength);
            this.trigger('data', {
                track: track,
                boxes: boxes
            });
            this.resetStream_(); // Continue with the flush process now
            this.trigger('done', 'VideoSegmentStream');
        };
        this.reset = function() {
            this.resetStream_();
            nalUnits = [];
            this.gopCache_.length = 0;
            gopsToAlignWith.length = 0;
            this.trigger('reset');
        };
        this.resetStream_ = function() {
            trackDecodeInfo.clearDtsInfo(track); // reset config and pps because they may differ across segments
            // for instance, when we are rendition switching
            config = undefined;
            pps = undefined;
        }; // Search for a candidate Gop for gop-fusion from the gop cache and
        // return it or return null if no good candidate was found
        this.getGopForFusion_ = function(nalUnit) {
            var halfSecond = 45000, // Half-a-second in a 90khz clock
            allowableOverlap = 10000, // About 3 frames @ 30fps
            nearestDistance = Infinity, dtsDistance, nearestGopObj, currentGop, currentGopObj, i; // Search for the GOP nearest to the beginning of this nal unit
            for(i = 0; i < this.gopCache_.length; i++){
                currentGopObj = this.gopCache_[i];
                currentGop = currentGopObj.gop; // Reject Gops with different SPS or PPS
                if (!(track.pps && arrayEquals(track.pps[0], currentGopObj.pps[0])) || !(track.sps && arrayEquals(track.sps[0], currentGopObj.sps[0]))) continue;
                 // Reject Gops that would require a negative baseMediaDecodeTime
                if (currentGop.dts < track.timelineStartInfo.dts) continue;
                 // The distance between the end of the gop and the start of the nalUnit
                dtsDistance = nalUnit.dts - currentGop.dts - currentGop.duration; // Only consider GOPS that start before the nal unit and end within
                // a half-second of the nal unit
                if (dtsDistance >= -allowableOverlap && dtsDistance <= halfSecond) // Always use the closest GOP we found if there is more than
                // one candidate
                {
                    if (!nearestGopObj || nearestDistance > dtsDistance) {
                        nearestGopObj = currentGopObj;
                        nearestDistance = dtsDistance;
                    }
                }
            }
            if (nearestGopObj) return nearestGopObj.gop;
            return null;
        }; // trim gop list to the first gop found that has a matching pts with a gop in the list
        // of gopsToAlignWith starting from the START of the list
        this.alignGopsAtStart_ = function(gops) {
            var alignIndex, gopIndex, align, gop, byteLength, nalCount, duration, alignedGops;
            byteLength = gops.byteLength;
            nalCount = gops.nalCount;
            duration = gops.duration;
            alignIndex = gopIndex = 0;
            while(alignIndex < gopsToAlignWith.length && gopIndex < gops.length){
                align = gopsToAlignWith[alignIndex];
                gop = gops[gopIndex];
                if (align.pts === gop.pts) break;
                if (gop.pts > align.pts) {
                    // this current gop starts after the current gop we want to align on, so increment
                    // align index
                    alignIndex++;
                    continue;
                } // current gop starts before the current gop we want to align on. so increment gop
                // index
                gopIndex++;
                byteLength -= gop.byteLength;
                nalCount -= gop.nalCount;
                duration -= gop.duration;
            }
            if (gopIndex === 0) // no gops to trim
            return gops;
            if (gopIndex === gops.length) // all gops trimmed, skip appending all gops
            return null;
            alignedGops = gops.slice(gopIndex);
            alignedGops.byteLength = byteLength;
            alignedGops.duration = duration;
            alignedGops.nalCount = nalCount;
            alignedGops.pts = alignedGops[0].pts;
            alignedGops.dts = alignedGops[0].dts;
            return alignedGops;
        }; // trim gop list to the first gop found that has a matching pts with a gop in the list
        // of gopsToAlignWith starting from the END of the list
        this.alignGopsAtEnd_ = function(gops) {
            var alignIndex, gopIndex, align, gop, alignEndIndex, matchFound;
            alignIndex = gopsToAlignWith.length - 1;
            gopIndex = gops.length - 1;
            alignEndIndex = null;
            matchFound = false;
            while(alignIndex >= 0 && gopIndex >= 0){
                align = gopsToAlignWith[alignIndex];
                gop = gops[gopIndex];
                if (align.pts === gop.pts) {
                    matchFound = true;
                    break;
                }
                if (align.pts > gop.pts) {
                    alignIndex--;
                    continue;
                }
                if (alignIndex === gopsToAlignWith.length - 1) // gop.pts is greater than the last alignment candidate. If no match is found
                // by the end of this loop, we still want to append gops that come after this
                // point
                alignEndIndex = gopIndex;
                gopIndex--;
            }
            if (!matchFound && alignEndIndex === null) return null;
            var trimIndex;
            if (matchFound) trimIndex = gopIndex;
            else trimIndex = alignEndIndex;
            if (trimIndex === 0) return gops;
            var alignedGops = gops.slice(trimIndex);
            var metadata = alignedGops.reduce(function(total, gop) {
                total.byteLength += gop.byteLength;
                total.duration += gop.duration;
                total.nalCount += gop.nalCount;
                return total;
            }, {
                byteLength: 0,
                duration: 0,
                nalCount: 0
            });
            alignedGops.byteLength = metadata.byteLength;
            alignedGops.duration = metadata.duration;
            alignedGops.nalCount = metadata.nalCount;
            alignedGops.pts = alignedGops[0].pts;
            alignedGops.dts = alignedGops[0].dts;
            return alignedGops;
        };
        this.alignGopsWith = function(newGopsToAlignWith) {
            gopsToAlignWith = newGopsToAlignWith;
        };
    };
    VideoSegmentStream.prototype = new Stream();
    /**
   * A Stream that can combine multiple streams (ie. audio & video)
   * into a single output segment for MSE. Also supports audio-only
   * and video-only streams.
   * @param options {object} transmuxer options object
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at media timeline start.
   */ CoalesceStream = function(options, metadataStream) {
        // Number of Tracks per output segment
        // If greater than 1, we combine multiple
        // tracks into a single segment
        this.numberOfTracks = 0;
        this.metadataStream = metadataStream;
        options = options || {};
        if (typeof options.remux !== 'undefined') this.remuxTracks = !!options.remux;
        else this.remuxTracks = true;
        if (typeof options.keepOriginalTimestamps === 'boolean') this.keepOriginalTimestamps = options.keepOriginalTimestamps;
        else this.keepOriginalTimestamps = false;
        this.pendingTracks = [];
        this.videoTrack = null;
        this.pendingBoxes = [];
        this.pendingCaptions = [];
        this.pendingMetadata = [];
        this.pendingBytes = 0;
        this.emittedTracks = 0;
        CoalesceStream.prototype.init.call(this); // Take output from multiple
        this.push = function(output) {
            // buffer incoming captions until the associated video segment
            // finishes
            if (output.content || output.text) return this.pendingCaptions.push(output);
             // buffer incoming id3 tags until the final flush
            if (output.frames) return this.pendingMetadata.push(output);
             // Add this track to the list of pending tracks and store
            // important information required for the construction of
            // the final segment
            this.pendingTracks.push(output.track);
            this.pendingBytes += output.boxes.byteLength; // TODO: is there an issue for this against chrome?
            // We unshift audio and push video because
            // as of Chrome 75 when switching from
            // one init segment to another if the video
            // mdat does not appear after the audio mdat
            // only audio will play for the duration of our transmux.
            if (output.track.type === 'video') {
                this.videoTrack = output.track;
                this.pendingBoxes.push(output.boxes);
            }
            if (output.track.type === 'audio') {
                this.audioTrack = output.track;
                this.pendingBoxes.unshift(output.boxes);
            }
        };
    };
    CoalesceStream.prototype = new Stream();
    CoalesceStream.prototype.flush = function(flushSource) {
        var offset = 0, event = {
            captions: [],
            captionStreams: {},
            metadata: [],
            info: {}
        }, caption, id3, initSegment, timelineStartPts = 0, i;
        if (this.pendingTracks.length < this.numberOfTracks) {
            if (flushSource !== 'VideoSegmentStream' && flushSource !== 'AudioSegmentStream') // Return because we haven't received a flush from a data-generating
            // portion of the segment (meaning that we have only recieved meta-data
            // or captions.)
            return;
            else if (this.remuxTracks) // Return until we have enough tracks from the pipeline to remux (if we
            // are remuxing audio and video into a single MP4)
            return;
            else if (this.pendingTracks.length === 0) {
                // In the case where we receive a flush without any data having been
                // received we consider it an emitted track for the purposes of coalescing
                // `done` events.
                // We do this for the case where there is an audio and video track in the
                // segment but no audio data. (seen in several playlists with alternate
                // audio tracks and no audio present in the main TS segments.)
                this.emittedTracks++;
                if (this.emittedTracks >= this.numberOfTracks) {
                    this.trigger('done');
                    this.emittedTracks = 0;
                }
                return;
            }
        }
        if (this.videoTrack) {
            timelineStartPts = this.videoTrack.timelineStartInfo.pts;
            VIDEO_PROPERTIES.forEach(function(prop) {
                event.info[prop] = this.videoTrack[prop];
            }, this);
        } else if (this.audioTrack) {
            timelineStartPts = this.audioTrack.timelineStartInfo.pts;
            AUDIO_PROPERTIES.forEach(function(prop) {
                event.info[prop] = this.audioTrack[prop];
            }, this);
        }
        if (this.videoTrack || this.audioTrack) {
            if (this.pendingTracks.length === 1) event.type = this.pendingTracks[0].type;
            else event.type = 'combined';
            this.emittedTracks += this.pendingTracks.length;
            initSegment = mp4.initSegment(this.pendingTracks); // Create a new typed array to hold the init segment
            event.initSegment = new Uint8Array(initSegment.byteLength); // Create an init segment containing a moov
            // and track definitions
            event.initSegment.set(initSegment); // Create a new typed array to hold the moof+mdats
            event.data = new Uint8Array(this.pendingBytes); // Append each moof+mdat (one per track) together
            for(i = 0; i < this.pendingBoxes.length; i++){
                event.data.set(this.pendingBoxes[i], offset);
                offset += this.pendingBoxes[i].byteLength;
            } // Translate caption PTS times into second offsets to match the
            // video timeline for the segment, and add track info
            for(i = 0; i < this.pendingCaptions.length; i++){
                caption = this.pendingCaptions[i];
                caption.startTime = clock.metadataTsToSeconds(caption.startPts, timelineStartPts, this.keepOriginalTimestamps);
                caption.endTime = clock.metadataTsToSeconds(caption.endPts, timelineStartPts, this.keepOriginalTimestamps);
                event.captionStreams[caption.stream] = true;
                event.captions.push(caption);
            } // Translate ID3 frame PTS times into second offsets to match the
            // video timeline for the segment
            for(i = 0; i < this.pendingMetadata.length; i++){
                id3 = this.pendingMetadata[i];
                id3.cueTime = clock.metadataTsToSeconds(id3.pts, timelineStartPts, this.keepOriginalTimestamps);
                event.metadata.push(id3);
            } // We add this to every single emitted segment even though we only need
            // it for the first
            event.metadata.dispatchType = this.metadataStream.dispatchType; // Reset stream state
            this.pendingTracks.length = 0;
            this.videoTrack = null;
            this.pendingBoxes.length = 0;
            this.pendingCaptions.length = 0;
            this.pendingBytes = 0;
            this.pendingMetadata.length = 0; // Emit the built segment
            // We include captions and ID3 tags for backwards compatibility,
            // ideally we should send only video and audio in the data event
            this.trigger('data', event); // Emit each caption to the outside world
            // Ideally, this would happen immediately on parsing captions,
            // but we need to ensure that video data is sent back first
            // so that caption timing can be adjusted to match video timing
            for(i = 0; i < event.captions.length; i++){
                caption = event.captions[i];
                this.trigger('caption', caption);
            } // Emit each id3 tag to the outside world
            // Ideally, this would happen immediately on parsing the tag,
            // but we need to ensure that video data is sent back first
            // so that ID3 frame timing can be adjusted to match video timing
            for(i = 0; i < event.metadata.length; i++){
                id3 = event.metadata[i];
                this.trigger('id3Frame', id3);
            }
        } // Only emit `done` if all tracks have been flushed and emitted
        if (this.emittedTracks >= this.numberOfTracks) {
            this.trigger('done');
            this.emittedTracks = 0;
        }
    };
    CoalesceStream.prototype.setRemux = function(val) {
        this.remuxTracks = val;
    };
    /**
   * A Stream that expects MP2T binary data as input and produces
   * corresponding media segments, suitable for use with Media Source
   * Extension (MSE) implementations that support the ISO BMFF byte
   * stream format, like Chrome.
   */ Transmuxer = function(options) {
        var self1 = this, hasFlushed = true, videoTrack, audioTrack;
        Transmuxer.prototype.init.call(this);
        options = options || {};
        this.baseMediaDecodeTime = options.baseMediaDecodeTime || 0;
        this.transmuxPipeline_ = {};
        this.setupAacPipeline = function() {
            var pipeline = {};
            this.transmuxPipeline_ = pipeline;
            pipeline.type = 'aac';
            pipeline.metadataStream = new m2ts.MetadataStream(); // set up the parsing pipeline
            pipeline.aacStream = new AacStream();
            pipeline.audioTimestampRolloverStream = new m2ts.TimestampRolloverStream('audio');
            pipeline.timedMetadataTimestampRolloverStream = new m2ts.TimestampRolloverStream('timed-metadata');
            pipeline.adtsStream = new AdtsStream();
            pipeline.coalesceStream = new CoalesceStream(options, pipeline.metadataStream);
            pipeline.headOfPipeline = pipeline.aacStream;
            pipeline.aacStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);
            pipeline.aacStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);
            pipeline.metadataStream.on('timestamp', function(frame) {
                pipeline.aacStream.setTimestamp(frame.timeStamp);
            });
            pipeline.aacStream.on('data', function(data) {
                if (data.type !== 'timed-metadata' && data.type !== 'audio' || pipeline.audioSegmentStream) return;
                audioTrack = audioTrack || {
                    timelineStartInfo: {
                        baseMediaDecodeTime: self1.baseMediaDecodeTime
                    },
                    codec: 'adts',
                    type: 'audio'
                }; // hook up the audio segment stream to the first track with aac data
                pipeline.coalesceStream.numberOfTracks++;
                pipeline.audioSegmentStream = new AudioSegmentStream(audioTrack, options);
                pipeline.audioSegmentStream.on('log', self1.getLogTrigger_('audioSegmentStream'));
                pipeline.audioSegmentStream.on('timingInfo', self1.trigger.bind(self1, 'audioTimingInfo')); // Set up the final part of the audio pipeline
                pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream); // emit pmt info
                self1.trigger('trackinfo', {
                    hasAudio: !!audioTrack,
                    hasVideo: !!videoTrack
                });
            }); // Re-emit any data coming from the coalesce stream to the outside world
            pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data')); // Let the consumer know we have finished flushing the entire pipeline
            pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
            addPipelineLogRetriggers(this, pipeline);
        };
        this.setupTsPipeline = function() {
            var pipeline = {};
            this.transmuxPipeline_ = pipeline;
            pipeline.type = 'ts';
            pipeline.metadataStream = new m2ts.MetadataStream(); // set up the parsing pipeline
            pipeline.packetStream = new m2ts.TransportPacketStream();
            pipeline.parseStream = new m2ts.TransportParseStream();
            pipeline.elementaryStream = new m2ts.ElementaryStream();
            pipeline.timestampRolloverStream = new m2ts.TimestampRolloverStream();
            pipeline.adtsStream = new AdtsStream();
            pipeline.h264Stream = new H264Stream();
            pipeline.captionStream = new m2ts.CaptionStream(options);
            pipeline.coalesceStream = new CoalesceStream(options, pipeline.metadataStream);
            pipeline.headOfPipeline = pipeline.packetStream; // disassemble MPEG2-TS packets into elementary streams
            pipeline.packetStream.pipe(pipeline.parseStream).pipe(pipeline.elementaryStream).pipe(pipeline.timestampRolloverStream); // !!THIS ORDER IS IMPORTANT!!
            // demux the streams
            pipeline.timestampRolloverStream.pipe(pipeline.h264Stream);
            pipeline.timestampRolloverStream.pipe(pipeline.adtsStream);
            pipeline.timestampRolloverStream.pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream); // Hook up CEA-608/708 caption stream
            pipeline.h264Stream.pipe(pipeline.captionStream).pipe(pipeline.coalesceStream);
            pipeline.elementaryStream.on('data', function(data) {
                var i;
                if (data.type === 'metadata') {
                    i = data.tracks.length; // scan the tracks listed in the metadata
                    while(i--){
                        if (!videoTrack && data.tracks[i].type === 'video') {
                            videoTrack = data.tracks[i];
                            videoTrack.timelineStartInfo.baseMediaDecodeTime = self1.baseMediaDecodeTime;
                        } else if (!audioTrack && data.tracks[i].type === 'audio') {
                            audioTrack = data.tracks[i];
                            audioTrack.timelineStartInfo.baseMediaDecodeTime = self1.baseMediaDecodeTime;
                        }
                    } // hook up the video segment stream to the first track with h264 data
                    if (videoTrack && !pipeline.videoSegmentStream) {
                        pipeline.coalesceStream.numberOfTracks++;
                        pipeline.videoSegmentStream = new VideoSegmentStream(videoTrack, options);
                        pipeline.videoSegmentStream.on('log', self1.getLogTrigger_('videoSegmentStream'));
                        pipeline.videoSegmentStream.on('timelineStartInfo', function(timelineStartInfo) {
                            // When video emits timelineStartInfo data after a flush, we forward that
                            // info to the AudioSegmentStream, if it exists, because video timeline
                            // data takes precedence.  Do not do this if keepOriginalTimestamps is set,
                            // because this is a particularly subtle form of timestamp alteration.
                            if (audioTrack && !options.keepOriginalTimestamps) {
                                audioTrack.timelineStartInfo = timelineStartInfo; // On the first segment we trim AAC frames that exist before the
                                // very earliest DTS we have seen in video because Chrome will
                                // interpret any video track with a baseMediaDecodeTime that is
                                // non-zero as a gap.
                                pipeline.audioSegmentStream.setEarliestDts(timelineStartInfo.dts - self1.baseMediaDecodeTime);
                            }
                        });
                        pipeline.videoSegmentStream.on('processedGopsInfo', self1.trigger.bind(self1, 'gopInfo'));
                        pipeline.videoSegmentStream.on('segmentTimingInfo', self1.trigger.bind(self1, 'videoSegmentTimingInfo'));
                        pipeline.videoSegmentStream.on('baseMediaDecodeTime', function(baseMediaDecodeTime) {
                            if (audioTrack) pipeline.audioSegmentStream.setVideoBaseMediaDecodeTime(baseMediaDecodeTime);
                        });
                        pipeline.videoSegmentStream.on('timingInfo', self1.trigger.bind(self1, 'videoTimingInfo')); // Set up the final part of the video pipeline
                        pipeline.h264Stream.pipe(pipeline.videoSegmentStream).pipe(pipeline.coalesceStream);
                    }
                    if (audioTrack && !pipeline.audioSegmentStream) {
                        // hook up the audio segment stream to the first track with aac data
                        pipeline.coalesceStream.numberOfTracks++;
                        pipeline.audioSegmentStream = new AudioSegmentStream(audioTrack, options);
                        pipeline.audioSegmentStream.on('log', self1.getLogTrigger_('audioSegmentStream'));
                        pipeline.audioSegmentStream.on('timingInfo', self1.trigger.bind(self1, 'audioTimingInfo'));
                        pipeline.audioSegmentStream.on('segmentTimingInfo', self1.trigger.bind(self1, 'audioSegmentTimingInfo')); // Set up the final part of the audio pipeline
                        pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);
                    } // emit pmt info
                    self1.trigger('trackinfo', {
                        hasAudio: !!audioTrack,
                        hasVideo: !!videoTrack
                    });
                }
            }); // Re-emit any data coming from the coalesce stream to the outside world
            pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data'));
            pipeline.coalesceStream.on('id3Frame', function(id3Frame) {
                id3Frame.dispatchType = pipeline.metadataStream.dispatchType;
                self1.trigger('id3Frame', id3Frame);
            });
            pipeline.coalesceStream.on('caption', this.trigger.bind(this, 'caption')); // Let the consumer know we have finished flushing the entire pipeline
            pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
            addPipelineLogRetriggers(this, pipeline);
        }; // hook up the segment streams once track metadata is delivered
        this.setBaseMediaDecodeTime = function(baseMediaDecodeTime) {
            var pipeline = this.transmuxPipeline_;
            if (!options.keepOriginalTimestamps) this.baseMediaDecodeTime = baseMediaDecodeTime;
            if (audioTrack) {
                audioTrack.timelineStartInfo.dts = undefined;
                audioTrack.timelineStartInfo.pts = undefined;
                trackDecodeInfo.clearDtsInfo(audioTrack);
                if (pipeline.audioTimestampRolloverStream) pipeline.audioTimestampRolloverStream.discontinuity();
            }
            if (videoTrack) {
                if (pipeline.videoSegmentStream) pipeline.videoSegmentStream.gopCache_ = [];
                videoTrack.timelineStartInfo.dts = undefined;
                videoTrack.timelineStartInfo.pts = undefined;
                trackDecodeInfo.clearDtsInfo(videoTrack);
                pipeline.captionStream.reset();
            }
            if (pipeline.timestampRolloverStream) pipeline.timestampRolloverStream.discontinuity();
        };
        this.setAudioAppendStart = function(timestamp) {
            if (audioTrack) this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(timestamp);
        };
        this.setRemux = function(val) {
            var pipeline = this.transmuxPipeline_;
            options.remux = val;
            if (pipeline && pipeline.coalesceStream) pipeline.coalesceStream.setRemux(val);
        };
        this.alignGopsWith = function(gopsToAlignWith) {
            if (videoTrack && this.transmuxPipeline_.videoSegmentStream) this.transmuxPipeline_.videoSegmentStream.alignGopsWith(gopsToAlignWith);
        };
        this.getLogTrigger_ = function(key) {
            var self1 = this;
            return function(event) {
                event.stream = key;
                self1.trigger('log', event);
            };
        }; // feed incoming data to the front of the parsing pipeline
        this.push = function(data) {
            if (hasFlushed) {
                var isAac = isLikelyAacData(data);
                if (isAac && this.transmuxPipeline_.type !== 'aac') this.setupAacPipeline();
                else if (!isAac && this.transmuxPipeline_.type !== 'ts') this.setupTsPipeline();
                hasFlushed = false;
            }
            this.transmuxPipeline_.headOfPipeline.push(data);
        }; // flush any buffered data
        this.flush = function() {
            hasFlushed = true; // Start at the top of the pipeline and flush all pending work
            this.transmuxPipeline_.headOfPipeline.flush();
        };
        this.endTimeline = function() {
            this.transmuxPipeline_.headOfPipeline.endTimeline();
        };
        this.reset = function() {
            if (this.transmuxPipeline_.headOfPipeline) this.transmuxPipeline_.headOfPipeline.reset();
        }; // Caption data has to be reset when seeking outside buffered range
        this.resetCaptions = function() {
            if (this.transmuxPipeline_.captionStream) this.transmuxPipeline_.captionStream.reset();
        };
    };
    Transmuxer.prototype = new Stream();
    var transmuxer = {
        Transmuxer: Transmuxer,
        VideoSegmentStream: VideoSegmentStream,
        AudioSegmentStream: AudioSegmentStream,
        AUDIO_PROPERTIES: AUDIO_PROPERTIES,
        VIDEO_PROPERTIES: VIDEO_PROPERTIES,
        // exported for testing
        generateSegmentTimingInfo: generateSegmentTimingInfo
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var toUnsigned$3 = function(value) {
        return value >>> 0;
    };
    var toHexString$1 = function(value) {
        return ('00' + value.toString(16)).slice(-2);
    };
    var bin = {
        toUnsigned: toUnsigned$3,
        toHexString: toHexString$1
    };
    var parseType$4 = function(buffer) {
        var result = '';
        result += String.fromCharCode(buffer[0]);
        result += String.fromCharCode(buffer[1]);
        result += String.fromCharCode(buffer[2]);
        result += String.fromCharCode(buffer[3]);
        return result;
    };
    var parseType_1 = parseType$4;
    var toUnsigned$2 = bin.toUnsigned;
    var parseType$3 = parseType_1;
    var findBox$5 = function(data, path) {
        var results = [], i, size, type, end, subresults;
        if (!path.length) // short-circuit the search for empty paths
        return null;
        for(i = 0; i < data.byteLength;){
            size = toUnsigned$2(data[i] << 24 | data[i + 1] << 16 | data[i + 2] << 8 | data[i + 3]);
            type = parseType$3(data.subarray(i + 4, i + 8));
            end = size > 1 ? i + size : data.byteLength;
            if (type === path[0]) {
                if (path.length === 1) // this is the end of the path and we've found the box we were
                // looking for
                results.push(data.subarray(i + 8, end));
                else {
                    // recursively search for the next box along the path
                    subresults = findBox$5(data.subarray(i + 8, end), path.slice(1));
                    if (subresults.length) results = results.concat(subresults);
                }
            }
            i = end;
        } // we've finished searching all of data
        return results;
    };
    var findBox_1 = findBox$5;
    var toUnsigned$1 = bin.toUnsigned;
    var getUint64$4 = numbers.getUint64;
    var tfdt = function(data) {
        var result = {
            version: data[0],
            flags: new Uint8Array(data.subarray(1, 4))
        };
        if (result.version === 1) result.baseMediaDecodeTime = getUint64$4(data.subarray(4));
        else result.baseMediaDecodeTime = toUnsigned$1(data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]);
        return result;
    };
    var parseTfdt$3 = tfdt;
    var tfhd = function(data) {
        var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
            version: data[0],
            flags: new Uint8Array(data.subarray(1, 4)),
            trackId: view.getUint32(4)
        }, baseDataOffsetPresent = result.flags[2] & 0x01, sampleDescriptionIndexPresent = result.flags[2] & 0x02, defaultSampleDurationPresent = result.flags[2] & 0x08, defaultSampleSizePresent = result.flags[2] & 0x10, defaultSampleFlagsPresent = result.flags[2] & 0x20, durationIsEmpty = result.flags[0] & 0x010000, defaultBaseIsMoof = result.flags[0] & 0x020000, i;
        i = 8;
        if (baseDataOffsetPresent) {
            i += 4; // truncate top 4 bytes
            // FIXME: should we read the full 64 bits?
            result.baseDataOffset = view.getUint32(12);
            i += 4;
        }
        if (sampleDescriptionIndexPresent) {
            result.sampleDescriptionIndex = view.getUint32(i);
            i += 4;
        }
        if (defaultSampleDurationPresent) {
            result.defaultSampleDuration = view.getUint32(i);
            i += 4;
        }
        if (defaultSampleSizePresent) {
            result.defaultSampleSize = view.getUint32(i);
            i += 4;
        }
        if (defaultSampleFlagsPresent) result.defaultSampleFlags = view.getUint32(i);
        if (durationIsEmpty) result.durationIsEmpty = true;
        if (!baseDataOffsetPresent && defaultBaseIsMoof) result.baseDataOffsetIsMoof = true;
        return result;
    };
    var parseTfhd$2 = tfhd;
    var getUint64$3 = numbers.getUint64;
    var parseSidx = function(data) {
        var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
            version: data[0],
            flags: new Uint8Array(data.subarray(1, 4)),
            references: [],
            referenceId: view.getUint32(4),
            timescale: view.getUint32(8)
        }, i = 12;
        if (result.version === 0) {
            result.earliestPresentationTime = view.getUint32(i);
            result.firstOffset = view.getUint32(i + 4);
            i += 8;
        } else {
            // read 64 bits
            result.earliestPresentationTime = getUint64$3(data.subarray(i));
            result.firstOffset = getUint64$3(data.subarray(i + 8));
            i += 16;
        }
        i += 2; // reserved
        var referenceCount = view.getUint16(i);
        i += 2; // start of references
        for(; referenceCount > 0; i += 12, referenceCount--)result.references.push({
            referenceType: (data[i] & 0x80) >>> 7,
            referencedSize: view.getUint32(i) & 0x7FFFFFFF,
            subsegmentDuration: view.getUint32(i + 4),
            startsWithSap: !!(data[i + 8] & 0x80),
            sapType: (data[i + 8] & 0x70) >>> 4,
            sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
        });
        return result;
    };
    var parseSidx_1 = parseSidx;
    var parseSampleFlags$1 = function(flags) {
        return {
            isLeading: (flags[0] & 0x0c) >>> 2,
            dependsOn: flags[0] & 0x03,
            isDependedOn: (flags[1] & 0xc0) >>> 6,
            hasRedundancy: (flags[1] & 0x30) >>> 4,
            paddingValue: (flags[1] & 0x0e) >>> 1,
            isNonSyncSample: flags[1] & 0x01,
            degradationPriority: flags[2] << 8 | flags[3]
        };
    };
    var parseSampleFlags_1 = parseSampleFlags$1;
    var parseSampleFlags = parseSampleFlags_1;
    var trun = function(data) {
        var result = {
            version: data[0],
            flags: new Uint8Array(data.subarray(1, 4)),
            samples: []
        }, view = new DataView(data.buffer, data.byteOffset, data.byteLength), // Flag interpretation
        dataOffsetPresent = result.flags[2] & 0x01, // compare with 2nd byte of 0x1
        firstSampleFlagsPresent = result.flags[2] & 0x04, // compare with 2nd byte of 0x4
        sampleDurationPresent = result.flags[1] & 0x01, // compare with 2nd byte of 0x100
        sampleSizePresent = result.flags[1] & 0x02, // compare with 2nd byte of 0x200
        sampleFlagsPresent = result.flags[1] & 0x04, // compare with 2nd byte of 0x400
        sampleCompositionTimeOffsetPresent = result.flags[1] & 0x08, // compare with 2nd byte of 0x800
        sampleCount = view.getUint32(4), offset = 8, sample;
        if (dataOffsetPresent) {
            // 32 bit signed integer
            result.dataOffset = view.getInt32(offset);
            offset += 4;
        } // Overrides the flags for the first sample only. The order of
        // optional values will be: duration, size, compositionTimeOffset
        if (firstSampleFlagsPresent && sampleCount) {
            sample = {
                flags: parseSampleFlags(data.subarray(offset, offset + 4))
            };
            offset += 4;
            if (sampleDurationPresent) {
                sample.duration = view.getUint32(offset);
                offset += 4;
            }
            if (sampleSizePresent) {
                sample.size = view.getUint32(offset);
                offset += 4;
            }
            if (sampleCompositionTimeOffsetPresent) {
                if (result.version === 1) sample.compositionTimeOffset = view.getInt32(offset);
                else sample.compositionTimeOffset = view.getUint32(offset);
                offset += 4;
            }
            result.samples.push(sample);
            sampleCount--;
        }
        while(sampleCount--){
            sample = {};
            if (sampleDurationPresent) {
                sample.duration = view.getUint32(offset);
                offset += 4;
            }
            if (sampleSizePresent) {
                sample.size = view.getUint32(offset);
                offset += 4;
            }
            if (sampleFlagsPresent) {
                sample.flags = parseSampleFlags(data.subarray(offset, offset + 4));
                offset += 4;
            }
            if (sampleCompositionTimeOffsetPresent) {
                if (result.version === 1) sample.compositionTimeOffset = view.getInt32(offset);
                else sample.compositionTimeOffset = view.getUint32(offset);
                offset += 4;
            }
            result.samples.push(sample);
        }
        return result;
    };
    var parseTrun$2 = trun;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Parse the internal MP4 structure into an equivalent javascript
   * object.
   */ var numberHelpers = numbers;
    var getUint64$2 = numberHelpers.getUint64;
    var inspectMp4, textifyMp4, parseMp4Date = function(seconds) {
        return new Date(seconds * 1000 - 2082844800000);
    }, parseType$2 = parseType_1, findBox$4 = findBox_1, nalParse = function(avcStream) {
        var avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength), result = [], i, length;
        for(i = 0; i + 4 < avcStream.length; i += length){
            length = avcView.getUint32(i);
            i += 4; // bail if this doesn't appear to be an H264 stream
            if (length <= 0) {
                result.push('<span style=\'color:red;\'>MALFORMED DATA</span>');
                continue;
            }
            switch(avcStream[i] & 0x1F){
                case 0x01:
                    result.push('slice_layer_without_partitioning_rbsp');
                    break;
                case 0x05:
                    result.push('slice_layer_without_partitioning_rbsp_idr');
                    break;
                case 0x06:
                    result.push('sei_rbsp');
                    break;
                case 0x07:
                    result.push('seq_parameter_set_rbsp');
                    break;
                case 0x08:
                    result.push('pic_parameter_set_rbsp');
                    break;
                case 0x09:
                    result.push('access_unit_delimiter_rbsp');
                    break;
                default:
                    result.push('UNKNOWN NAL - ' + avcStream[i] & 0x1F);
                    break;
            }
        }
        return result;
    }, // registry of handlers for individual mp4 box types
    parse = {
        // codingname, not a first-class box type. stsd entries share the
        // same format as real boxes so the parsing infrastructure can be
        // shared
        avc1: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
            return {
                dataReferenceIndex: view.getUint16(6),
                width: view.getUint16(24),
                height: view.getUint16(26),
                horizresolution: view.getUint16(28) + view.getUint16(30) / 16,
                vertresolution: view.getUint16(32) + view.getUint16(34) / 16,
                frameCount: view.getUint16(40),
                depth: view.getUint16(74),
                config: inspectMp4(data.subarray(78, data.byteLength))
            };
        },
        avcC: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                configurationVersion: data[0],
                avcProfileIndication: data[1],
                profileCompatibility: data[2],
                avcLevelIndication: data[3],
                lengthSizeMinusOne: data[4] & 0x03,
                sps: [],
                pps: []
            }, numOfSequenceParameterSets = data[5] & 0x1f, numOfPictureParameterSets, nalSize, offset, i; // iterate past any SPSs
            offset = 6;
            for(i = 0; i < numOfSequenceParameterSets; i++){
                nalSize = view.getUint16(offset);
                offset += 2;
                result.sps.push(new Uint8Array(data.subarray(offset, offset + nalSize)));
                offset += nalSize;
            } // iterate past any PPSs
            numOfPictureParameterSets = data[offset];
            offset++;
            for(i = 0; i < numOfPictureParameterSets; i++){
                nalSize = view.getUint16(offset);
                offset += 2;
                result.pps.push(new Uint8Array(data.subarray(offset, offset + nalSize)));
                offset += nalSize;
            }
            return result;
        },
        btrt: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
            return {
                bufferSizeDB: view.getUint32(0),
                maxBitrate: view.getUint32(4),
                avgBitrate: view.getUint32(8)
            };
        },
        edts: function edts(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        elst: function elst(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4)),
                edits: []
            }, entryCount = view.getUint32(4), i;
            for(i = 8; entryCount; entryCount--)if (result.version === 0) {
                result.edits.push({
                    segmentDuration: view.getUint32(i),
                    mediaTime: view.getInt32(i + 4),
                    mediaRate: view.getUint16(i + 8) + view.getUint16(i + 10) / 65536
                });
                i += 12;
            } else {
                result.edits.push({
                    segmentDuration: getUint64$2(data.subarray(i)),
                    mediaTime: getUint64$2(data.subarray(i + 8)),
                    mediaRate: view.getUint16(i + 16) + view.getUint16(i + 18) / 65536
                });
                i += 20;
            }
            return result;
        },
        esds: function(data) {
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                esId: data[6] << 8 | data[7],
                streamPriority: data[8] & 0x1f,
                decoderConfig: {
                    objectProfileIndication: data[11],
                    streamType: data[12] >>> 2 & 0x3f,
                    bufferSize: data[13] << 16 | data[14] << 8 | data[15],
                    maxBitrate: data[16] << 24 | data[17] << 16 | data[18] << 8 | data[19],
                    avgBitrate: data[20] << 24 | data[21] << 16 | data[22] << 8 | data[23],
                    decoderConfigDescriptor: {
                        tag: data[24],
                        length: data[25],
                        audioObjectType: data[26] >>> 3 & 0x1f,
                        samplingFrequencyIndex: (data[26] & 0x07) << 1 | data[27] >>> 7 & 0x01,
                        channelConfiguration: data[27] >>> 3 & 0x0f
                    }
                }
            };
        },
        ftyp: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                majorBrand: parseType$2(data.subarray(0, 4)),
                minorVersion: view.getUint32(4),
                compatibleBrands: []
            }, i = 8;
            while(i < data.byteLength){
                result.compatibleBrands.push(parseType$2(data.subarray(i, i + 4)));
                i += 4;
            }
            return result;
        },
        dinf: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        dref: function(data) {
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                dataReferences: inspectMp4(data.subarray(8))
            };
        },
        hdlr: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4)),
                handlerType: parseType$2(data.subarray(8, 12)),
                name: ''
            }, i = 8; // parse out the name field
            for(i = 24; i < data.byteLength; i++){
                if (data[i] === 0x00) {
                    // the name field is null-terminated
                    i++;
                    break;
                }
                result.name += String.fromCharCode(data[i]);
            } // decode UTF-8 to javascript's internal representation
            // see http://ecmanaut.blogspot.com/2006/07/encoding-decoding-utf8-in-javascript.html
            result.name = decodeURIComponent(escape(result.name));
            return result;
        },
        mdat: function(data) {
            return {
                byteLength: data.byteLength,
                nals: nalParse(data)
            };
        },
        mdhd: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), i = 4, language, result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4)),
                language: ''
            };
            if (result.version === 1) {
                i += 4;
                result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
                i += 8;
                result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
                i += 4;
                result.timescale = view.getUint32(i);
                i += 8;
                result.duration = view.getUint32(i); // truncating top 4 bytes
            } else {
                result.creationTime = parseMp4Date(view.getUint32(i));
                i += 4;
                result.modificationTime = parseMp4Date(view.getUint32(i));
                i += 4;
                result.timescale = view.getUint32(i);
                i += 4;
                result.duration = view.getUint32(i);
            }
            i += 4; // language is stored as an ISO-639-2/T code in an array of three 5-bit fields
            // each field is the packed difference between its ASCII value and 0x60
            language = view.getUint16(i);
            result.language += String.fromCharCode((language >> 10) + 0x60);
            result.language += String.fromCharCode(((language & 0x03e0) >> 5) + 0x60);
            result.language += String.fromCharCode((language & 0x1f) + 0x60);
            return result;
        },
        mdia: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        mfhd: function(data) {
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                sequenceNumber: data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]
            };
        },
        minf: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        // codingname, not a first-class box type. stsd entries share the
        // same format as real boxes so the parsing infrastructure can be
        // shared
        mp4a: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                // 6 bytes reserved
                dataReferenceIndex: view.getUint16(6),
                // 4 + 4 bytes reserved
                channelcount: view.getUint16(16),
                samplesize: view.getUint16(18),
                // 2 bytes pre_defined
                // 2 bytes reserved
                samplerate: view.getUint16(24) + view.getUint16(26) / 65536
            }; // if there are more bytes to process, assume this is an ISO/IEC
            // 14496-14 MP4AudioSampleEntry and parse the ESDBox
            if (data.byteLength > 28) result.streamDescriptor = inspectMp4(data.subarray(28))[0];
            return result;
        },
        moof: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        moov: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        mvex: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        mvhd: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), i = 4, result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4))
            };
            if (result.version === 1) {
                i += 4;
                result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
                i += 8;
                result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
                i += 4;
                result.timescale = view.getUint32(i);
                i += 8;
                result.duration = view.getUint32(i); // truncating top 4 bytes
            } else {
                result.creationTime = parseMp4Date(view.getUint32(i));
                i += 4;
                result.modificationTime = parseMp4Date(view.getUint32(i));
                i += 4;
                result.timescale = view.getUint32(i);
                i += 4;
                result.duration = view.getUint32(i);
            }
            i += 4; // convert fixed-point, base 16 back to a number
            result.rate = view.getUint16(i) + view.getUint16(i + 2) / 16;
            i += 4;
            result.volume = view.getUint8(i) + view.getUint8(i + 1) / 8;
            i += 2;
            i += 2;
            i += 8;
            result.matrix = new Uint32Array(data.subarray(i, i + 36));
            i += 36;
            i += 24;
            result.nextTrackId = view.getUint32(i);
            return result;
        },
        pdin: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
            return {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4)),
                rate: view.getUint32(4),
                initialDelay: view.getUint32(8)
            };
        },
        sdtp: function(data) {
            var result = {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                samples: []
            }, i;
            for(i = 4; i < data.byteLength; i++)result.samples.push({
                dependsOn: (data[i] & 0x30) >> 4,
                isDependedOn: (data[i] & 0x0c) >> 2,
                hasRedundancy: data[i] & 0x03
            });
            return result;
        },
        sidx: parseSidx_1,
        smhd: function(data) {
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                balance: data[4] + data[5] / 256
            };
        },
        stbl: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        ctts: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4)),
                compositionOffsets: []
            }, entryCount = view.getUint32(4), i;
            for(i = 8; entryCount; i += 8, entryCount--)result.compositionOffsets.push({
                sampleCount: view.getUint32(i),
                sampleOffset: view[result.version === 0 ? 'getUint32' : 'getInt32'](i + 4)
            });
            return result;
        },
        stss: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4)),
                syncSamples: []
            }, entryCount = view.getUint32(4), i;
            for(i = 8; entryCount; i += 4, entryCount--)result.syncSamples.push(view.getUint32(i));
            return result;
        },
        stco: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                chunkOffsets: []
            }, entryCount = view.getUint32(4), i;
            for(i = 8; entryCount; i += 4, entryCount--)result.chunkOffsets.push(view.getUint32(i));
            return result;
        },
        stsc: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), entryCount = view.getUint32(4), result = {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                sampleToChunks: []
            }, i;
            for(i = 8; entryCount; i += 12, entryCount--)result.sampleToChunks.push({
                firstChunk: view.getUint32(i),
                samplesPerChunk: view.getUint32(i + 4),
                sampleDescriptionIndex: view.getUint32(i + 8)
            });
            return result;
        },
        stsd: function(data) {
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                sampleDescriptions: inspectMp4(data.subarray(8))
            };
        },
        stsz: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                sampleSize: view.getUint32(4),
                entries: []
            }, i;
            for(i = 12; i < data.byteLength; i += 4)result.entries.push(view.getUint32(i));
            return result;
        },
        stts: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                timeToSamples: []
            }, entryCount = view.getUint32(4), i;
            for(i = 8; entryCount; i += 8, entryCount--)result.timeToSamples.push({
                sampleCount: view.getUint32(i),
                sampleDelta: view.getUint32(i + 4)
            });
            return result;
        },
        styp: function(data) {
            return parse.ftyp(data);
        },
        tfdt: parseTfdt$3,
        tfhd: parseTfhd$2,
        tkhd: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), i = 4, result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4))
            };
            if (result.version === 1) {
                i += 4;
                result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
                i += 8;
                result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
                i += 4;
                result.trackId = view.getUint32(i);
                i += 4;
                i += 8;
                result.duration = view.getUint32(i); // truncating top 4 bytes
            } else {
                result.creationTime = parseMp4Date(view.getUint32(i));
                i += 4;
                result.modificationTime = parseMp4Date(view.getUint32(i));
                i += 4;
                result.trackId = view.getUint32(i);
                i += 4;
                i += 4;
                result.duration = view.getUint32(i);
            }
            i += 4;
            i += 8;
            result.layer = view.getUint16(i);
            i += 2;
            result.alternateGroup = view.getUint16(i);
            i += 2; // convert fixed-point, base 16 back to a number
            result.volume = view.getUint8(i) + view.getUint8(i + 1) / 8;
            i += 2;
            i += 2;
            result.matrix = new Uint32Array(data.subarray(i, i + 36));
            i += 36;
            result.width = view.getUint16(i) + view.getUint16(i + 2) / 65536;
            i += 4;
            result.height = view.getUint16(i) + view.getUint16(i + 2) / 65536;
            return result;
        },
        traf: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        trak: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        trex: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                trackId: view.getUint32(4),
                defaultSampleDescriptionIndex: view.getUint32(8),
                defaultSampleDuration: view.getUint32(12),
                defaultSampleSize: view.getUint32(16),
                sampleDependsOn: data[20] & 0x03,
                sampleIsDependedOn: (data[21] & 0xc0) >> 6,
                sampleHasRedundancy: (data[21] & 0x30) >> 4,
                samplePaddingValue: (data[21] & 0x0e) >> 1,
                sampleIsDifferenceSample: !!(data[21] & 0x01),
                sampleDegradationPriority: view.getUint16(22)
            };
        },
        trun: parseTrun$2,
        'url ': function(data) {
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4))
            };
        },
        vmhd: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                graphicsmode: view.getUint16(4),
                opcolor: new Uint16Array([
                    view.getUint16(6),
                    view.getUint16(8),
                    view.getUint16(10)
                ])
            };
        }
    };
    /**
   * Return a javascript array of box objects parsed from an ISO base
   * media file.
   * @param data {Uint8Array} the binary data of the media to be inspected
   * @return {array} a javascript array of potentially nested box objects
   */ inspectMp4 = function(data) {
        var i = 0, result = [], view, size, type, end, box; // Convert data from Uint8Array to ArrayBuffer, to follow Dataview API
        var ab = new ArrayBuffer(data.length);
        var v = new Uint8Array(ab);
        for(var z = 0; z < data.length; ++z)v[z] = data[z];
        view = new DataView(ab);
        while(i < data.byteLength){
            // parse box data
            size = view.getUint32(i);
            type = parseType$2(data.subarray(i + 4, i + 8));
            end = size > 1 ? i + size : data.byteLength; // parse type-specific data
            box = (parse[type] || function(data) {
                return {
                    data: data
                };
            })(data.subarray(i + 8, end));
            box.size = size;
            box.type = type; // store this box and move to the next
            result.push(box);
            i = end;
        }
        return result;
    };
    /**
   * Returns a textual representation of the javascript represtentation
   * of an MP4 file. You can use it as an alternative to
   * JSON.stringify() to compare inspected MP4s.
   * @param inspectedMp4 {array} the parsed array of boxes in an MP4
   * file
   * @param depth {number} (optional) the number of ancestor boxes of
   * the elements of inspectedMp4. Assumed to be zero if unspecified.
   * @return {string} a text representation of the parsed MP4
   */ textifyMp4 = function(inspectedMp4, depth) {
        var indent;
        depth = depth || 0;
        indent = new Array(depth * 2 + 1).join(' '); // iterate over all the boxes
        return inspectedMp4.map(function(box, index) {
            // list the box type first at the current indentation level
            return indent + box.type + '\n' + // the type is already included and handle child boxes separately
            Object.keys(box).filter(function(key) {
                return key !== 'type' && key !== 'boxes'; // output all the box properties
            }).map(function(key) {
                var prefix = indent + '  ' + key + ': ', value = box[key]; // print out raw bytes as hexademical
                if (value instanceof Uint8Array || value instanceof Uint32Array) {
                    var bytes = Array.prototype.slice.call(new Uint8Array(value.buffer, value.byteOffset, value.byteLength)).map(function(byte) {
                        return ' ' + ('00' + byte.toString(16)).slice(-2);
                    }).join('').match(/.{1,24}/g);
                    if (!bytes) return prefix + '<>';
                    if (bytes.length === 1) return prefix + '<' + bytes.join('').slice(1) + '>';
                    return prefix + '<\n' + bytes.map(function(line) {
                        return indent + '  ' + line;
                    }).join('\n') + '\n' + indent + '  >';
                } // stringify generic objects
                return prefix + JSON.stringify(value, null, 2).split('\n').map(function(line, index) {
                    if (index === 0) return line;
                    return indent + '  ' + line;
                }).join('\n');
            }).join('\n') + // recursively textify the child boxes
            (box.boxes ? '\n' + textifyMp4(box.boxes, depth + 1) : '');
        }).join('\n');
    };
    var mp4Inspector = {
        inspect: inspectMp4,
        textify: textifyMp4,
        parseType: parseType$2,
        findBox: findBox$4,
        parseTraf: parse.traf,
        parseTfdt: parse.tfdt,
        parseHdlr: parse.hdlr,
        parseTfhd: parse.tfhd,
        parseTrun: parse.trun,
        parseSidx: parse.sidx
    };
    /**
   * Returns the first string in the data array ending with a null char '\0'
   * @param {UInt8} data 
   * @returns the string with the null char
   */ var uint8ToCString$1 = function(data) {
        var index = 0;
        var curChar = String.fromCharCode(data[index]);
        var retString = '';
        while(curChar !== '\0'){
            retString += curChar;
            index++;
            curChar = String.fromCharCode(data[index]);
        } // Add nullChar
        retString += curChar;
        return retString;
    };
    var string = {
        uint8ToCString: uint8ToCString$1
    };
    var uint8ToCString = string.uint8ToCString;
    var getUint64$1 = numbers.getUint64;
    /**
   * Based on: ISO/IEC 23009 Section: 5.10.3.3
   * References:
   * https://dashif-documents.azurewebsites.net/Events/master/event.html#emsg-format
   * https://aomediacodec.github.io/id3-emsg/
   * 
   * Takes emsg box data as a uint8 array and returns a emsg box object
   * @param {UInt8Array} boxData data from emsg box
   * @returns A parsed emsg box object
   */ var parseEmsgBox = function(boxData) {
        // version + flags
        var offset = 4;
        var version = boxData[0];
        var scheme_id_uri, value, timescale, presentation_time, presentation_time_delta, event_duration, id, message_data;
        if (version === 0) {
            scheme_id_uri = uint8ToCString(boxData.subarray(offset));
            offset += scheme_id_uri.length;
            value = uint8ToCString(boxData.subarray(offset));
            offset += value.length;
            var dv = new DataView(boxData.buffer);
            timescale = dv.getUint32(offset);
            offset += 4;
            presentation_time_delta = dv.getUint32(offset);
            offset += 4;
            event_duration = dv.getUint32(offset);
            offset += 4;
            id = dv.getUint32(offset);
            offset += 4;
        } else if (version === 1) {
            var dv = new DataView(boxData.buffer);
            timescale = dv.getUint32(offset);
            offset += 4;
            presentation_time = getUint64$1(boxData.subarray(offset));
            offset += 8;
            event_duration = dv.getUint32(offset);
            offset += 4;
            id = dv.getUint32(offset);
            offset += 4;
            scheme_id_uri = uint8ToCString(boxData.subarray(offset));
            offset += scheme_id_uri.length;
            value = uint8ToCString(boxData.subarray(offset));
            offset += value.length;
        }
        message_data = new Uint8Array(boxData.subarray(offset, boxData.byteLength));
        var emsgBox = {
            scheme_id_uri: scheme_id_uri,
            value: value,
            // if timescale is undefined or 0 set to 1 
            timescale: timescale ? timescale : 1,
            presentation_time: presentation_time,
            presentation_time_delta: presentation_time_delta,
            event_duration: event_duration,
            id: id,
            message_data: message_data
        };
        return isValidEmsgBox(version, emsgBox) ? emsgBox : undefined;
    };
    /**
   * Scales a presentation time or time delta with an offset with a provided timescale
   * @param {number} presentationTime 
   * @param {number} timescale 
   * @param {number} timeDelta 
   * @param {number} offset 
   * @returns the scaled time as a number
   */ var scaleTime = function(presentationTime, timescale, timeDelta, offset) {
        return presentationTime || presentationTime === 0 ? presentationTime / timescale : offset + timeDelta / timescale;
    };
    /**
   * Checks the emsg box data for validity based on the version
   * @param {number} version of the emsg box to validate
   * @param {Object} emsg the emsg data to validate
   * @returns if the box is valid as a boolean
   */ var isValidEmsgBox = function(version, emsg) {
        var hasScheme = emsg.scheme_id_uri !== '\0';
        var isValidV0Box = version === 0 && isDefined(emsg.presentation_time_delta) && hasScheme;
        var isValidV1Box = version === 1 && isDefined(emsg.presentation_time) && hasScheme; // Only valid versions of emsg are 0 and 1
        return !(version > 1) && isValidV0Box || isValidV1Box;
    }; // Utility function to check if an object is defined
    var isDefined = function(data) {
        return data !== undefined || data !== null;
    };
    var emsg$1 = {
        parseEmsgBox: parseEmsgBox,
        scaleTime: scaleTime
    };
    var win;
    if (typeof window !== "undefined") win = window;
    else if (typeof commonjsGlobal !== "undefined") win = commonjsGlobal;
    else if (typeof self !== "undefined") win = self;
    else win = {};
    var window_1 = win;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Utilities to detect basic properties and metadata about MP4s.
   */ var toUnsigned = bin.toUnsigned;
    var toHexString = bin.toHexString;
    var findBox$3 = findBox_1;
    var parseType$1 = parseType_1;
    var emsg = emsg$1;
    var parseTfhd$1 = parseTfhd$2;
    var parseTrun$1 = parseTrun$2;
    var parseTfdt$2 = parseTfdt$3;
    var getUint64 = numbers.getUint64;
    var timescale, startTime, compositionStartTime, getVideoTrackIds, getTracks, getTimescaleFromMediaHeader$1, getEmsgID3;
    var window$2 = window_1;
    var parseId3Frames = parseId3.parseId3Frames;
    /**
   * Parses an MP4 initialization segment and extracts the timescale
   * values for any declared tracks. Timescale values indicate the
   * number of clock ticks per second to assume for time-based values
   * elsewhere in the MP4.
   *
   * To determine the start time of an MP4, you need two pieces of
   * information: the timescale unit and the earliest base media decode
   * time. Multiple timescales can be specified within an MP4 but the
   * base media decode time is always expressed in the timescale from
   * the media header box for the track:
   * ```
   * moov > trak > mdia > mdhd.timescale
   * ```
   * @param init {Uint8Array} the bytes of the init segment
   * @return {object} a hash of track ids to timescale values or null if
   * the init segment is malformed.
   */ timescale = function(init) {
        var result = {}, traks = findBox$3(init, [
            'moov',
            'trak'
        ]); // mdhd timescale
        return traks.reduce(function(result, trak) {
            var tkhd, version, index, id, mdhd;
            tkhd = findBox$3(trak, [
                'tkhd'
            ])[0];
            if (!tkhd) return null;
            version = tkhd[0];
            index = version === 0 ? 12 : 20;
            id = toUnsigned(tkhd[index] << 24 | tkhd[index + 1] << 16 | tkhd[index + 2] << 8 | tkhd[index + 3]);
            mdhd = findBox$3(trak, [
                'mdia',
                'mdhd'
            ])[0];
            if (!mdhd) return null;
            version = mdhd[0];
            index = version === 0 ? 12 : 20;
            result[id] = toUnsigned(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
            return result;
        }, result);
    };
    /**
   * Determine the base media decode start time, in seconds, for an MP4
   * fragment. If multiple fragments are specified, the earliest time is
   * returned.
   *
   * The base media decode time can be parsed from track fragment
   * metadata:
   * ```
   * moof > traf > tfdt.baseMediaDecodeTime
   * ```
   * It requires the timescale value from the mdhd to interpret.
   *
   * @param timescale {object} a hash of track ids to timescale values.
   * @return {number} the earliest base media decode start time for the
   * fragment, in seconds
   */ startTime = function(timescale, fragment) {
        var trafs; // we need info from two childrend of each track fragment box
        trafs = findBox$3(fragment, [
            'moof',
            'traf'
        ]); // determine the start times for each track
        var lowestTime = trafs.reduce(function(acc, traf) {
            var tfhd = findBox$3(traf, [
                'tfhd'
            ])[0]; // get the track id from the tfhd
            var id = toUnsigned(tfhd[4] << 24 | tfhd[5] << 16 | tfhd[6] << 8 | tfhd[7]); // assume a 90kHz clock if no timescale was specified
            var scale = timescale[id] || 90e3; // get the base media decode time from the tfdt
            var tfdt = findBox$3(traf, [
                'tfdt'
            ])[0];
            var dv = new DataView(tfdt.buffer, tfdt.byteOffset, tfdt.byteLength);
            var baseTime; // version 1 is 64 bit
            if (tfdt[0] === 1) baseTime = getUint64(tfdt.subarray(4, 12));
            else baseTime = dv.getUint32(4);
             // convert base time to seconds if it is a valid number.
            let seconds;
            if (typeof baseTime === 'bigint') seconds = baseTime / window$2.BigInt(scale);
            else if (typeof baseTime === 'number' && !isNaN(baseTime)) seconds = baseTime / scale;
            if (seconds < Number.MAX_SAFE_INTEGER) seconds = Number(seconds);
            if (seconds < acc) acc = seconds;
            return acc;
        }, Infinity);
        return typeof lowestTime === 'bigint' || isFinite(lowestTime) ? lowestTime : 0;
    };
    /**
   * Determine the composition start, in seconds, for an MP4
   * fragment.
   *
   * The composition start time of a fragment can be calculated using the base
   * media decode time, composition time offset, and timescale, as follows:
   *
   * compositionStartTime = (baseMediaDecodeTime + compositionTimeOffset) / timescale
   *
   * All of the aforementioned information is contained within a media fragment's
   * `traf` box, except for timescale info, which comes from the initialization
   * segment, so a track id (also contained within a `traf`) is also necessary to
   * associate it with a timescale
   *
   *
   * @param timescales {object} - a hash of track ids to timescale values.
   * @param fragment {Unit8Array} - the bytes of a media segment
   * @return {number} the composition start time for the fragment, in seconds
   **/ compositionStartTime = function(timescales, fragment) {
        var trafBoxes = findBox$3(fragment, [
            'moof',
            'traf'
        ]);
        var baseMediaDecodeTime = 0;
        var compositionTimeOffset = 0;
        var trackId;
        if (trafBoxes && trafBoxes.length) {
            // The spec states that track run samples contained within a `traf` box are contiguous, but
            // it does not explicitly state whether the `traf` boxes themselves are contiguous.
            // We will assume that they are, so we only need the first to calculate start time.
            var tfhd = findBox$3(trafBoxes[0], [
                'tfhd'
            ])[0];
            var trun = findBox$3(trafBoxes[0], [
                'trun'
            ])[0];
            var tfdt = findBox$3(trafBoxes[0], [
                'tfdt'
            ])[0];
            if (tfhd) {
                var parsedTfhd = parseTfhd$1(tfhd);
                trackId = parsedTfhd.trackId;
            }
            if (tfdt) {
                var parsedTfdt = parseTfdt$2(tfdt);
                baseMediaDecodeTime = parsedTfdt.baseMediaDecodeTime;
            }
            if (trun) {
                var parsedTrun = parseTrun$1(trun);
                if (parsedTrun.samples && parsedTrun.samples.length) compositionTimeOffset = parsedTrun.samples[0].compositionTimeOffset || 0;
            }
        } // Get timescale for this specific track. Assume a 90kHz clock if no timescale was
        // specified.
        var timescale = timescales[trackId] || 90e3; // return the composition start time, in seconds
        if (typeof baseMediaDecodeTime === 'bigint') {
            compositionTimeOffset = window$2.BigInt(compositionTimeOffset);
            timescale = window$2.BigInt(timescale);
        }
        var result = (baseMediaDecodeTime + compositionTimeOffset) / timescale;
        if (typeof result === 'bigint' && result < Number.MAX_SAFE_INTEGER) result = Number(result);
        return result;
    };
    /**
    * Find the trackIds of the video tracks in this source.
    * Found by parsing the Handler Reference and Track Header Boxes:
    *   moov > trak > mdia > hdlr
    *   moov > trak > tkhd
    *
    * @param {Uint8Array} init - The bytes of the init segment for this source
    * @return {Number[]} A list of trackIds
    *
    * @see ISO-BMFF-12/2015, Section 8.4.3
   **/ getVideoTrackIds = function(init) {
        var traks = findBox$3(init, [
            'moov',
            'trak'
        ]);
        var videoTrackIds = [];
        traks.forEach(function(trak) {
            var hdlrs = findBox$3(trak, [
                'mdia',
                'hdlr'
            ]);
            var tkhds = findBox$3(trak, [
                'tkhd'
            ]);
            hdlrs.forEach(function(hdlr, index) {
                var handlerType = parseType$1(hdlr.subarray(8, 12));
                var tkhd = tkhds[index];
                var view;
                var version;
                var trackId;
                if (handlerType === 'vide') {
                    view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
                    version = view.getUint8(0);
                    trackId = version === 0 ? view.getUint32(12) : view.getUint32(20);
                    videoTrackIds.push(trackId);
                }
            });
        });
        return videoTrackIds;
    };
    getTimescaleFromMediaHeader$1 = function(mdhd) {
        // mdhd is a FullBox, meaning it will have its own version as the first byte
        var version = mdhd[0];
        var index = version === 0 ? 12 : 20;
        return toUnsigned(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
    };
    /**
   * Get all the video, audio, and hint tracks from a non fragmented
   * mp4 segment
   */ getTracks = function(init) {
        var traks = findBox$3(init, [
            'moov',
            'trak'
        ]);
        var tracks = [];
        traks.forEach(function(trak) {
            var track = {};
            var tkhd = findBox$3(trak, [
                'tkhd'
            ])[0];
            var view, tkhdVersion; // id
            if (tkhd) {
                view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
                tkhdVersion = view.getUint8(0);
                track.id = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
            }
            var hdlr = findBox$3(trak, [
                'mdia',
                'hdlr'
            ])[0]; // type
            if (hdlr) {
                var type = parseType$1(hdlr.subarray(8, 12));
                if (type === 'vide') track.type = 'video';
                else if (type === 'soun') track.type = 'audio';
                else track.type = type;
            } // codec
            var stsd = findBox$3(trak, [
                'mdia',
                'minf',
                'stbl',
                'stsd'
            ])[0];
            if (stsd) {
                var sampleDescriptions = stsd.subarray(8); // gives the codec type string
                track.codec = parseType$1(sampleDescriptions.subarray(4, 8));
                var codecBox = findBox$3(sampleDescriptions, [
                    track.codec
                ])[0];
                var codecConfig, codecConfigType;
                if (codecBox) {
                    // https://tools.ietf.org/html/rfc6381#section-3.3
                    if (/^[asm]vc[1-9]$/i.test(track.codec)) {
                        // we don't need anything but the "config" parameter of the
                        // avc1 codecBox
                        codecConfig = codecBox.subarray(78);
                        codecConfigType = parseType$1(codecConfig.subarray(4, 8));
                        if (codecConfigType === 'avcC' && codecConfig.length > 11) {
                            track.codec += '.'; // left padded with zeroes for single digit hex
                            // profile idc
                            track.codec += toHexString(codecConfig[9]); // the byte containing the constraint_set flags
                            track.codec += toHexString(codecConfig[10]); // level idc
                            track.codec += toHexString(codecConfig[11]);
                        } else // TODO: show a warning that we couldn't parse the codec
                        // and are using the default
                        track.codec = 'avc1.4d400d';
                    } else if (/^mp4[a,v]$/i.test(track.codec)) {
                        // we do not need anything but the streamDescriptor of the mp4a codecBox
                        codecConfig = codecBox.subarray(28);
                        codecConfigType = parseType$1(codecConfig.subarray(4, 8));
                        if (codecConfigType === 'esds' && codecConfig.length > 20 && codecConfig[19] !== 0) {
                            track.codec += '.' + toHexString(codecConfig[19]); // this value is only a single digit
                            track.codec += '.' + toHexString(codecConfig[20] >>> 2 & 0x3f).replace(/^0/, '');
                        } else // TODO: show a warning that we couldn't parse the codec
                        // and are using the default
                        track.codec = 'mp4a.40.2';
                    } else // flac, opus, etc
                    track.codec = track.codec.toLowerCase();
                }
            }
            var mdhd = findBox$3(trak, [
                'mdia',
                'mdhd'
            ])[0];
            if (mdhd) track.timescale = getTimescaleFromMediaHeader$1(mdhd);
            tracks.push(track);
        });
        return tracks;
    };
    /**
   * Returns an array of emsg ID3 data from the provided segmentData.
   * An offset can also be provided as the Latest Arrival Time to calculate 
   * the Event Start Time of v0 EMSG boxes. 
   * See: https://dashif-documents.azurewebsites.net/Events/master/event.html#Inband-event-timing
   * 
   * @param {Uint8Array} segmentData the segment byte array.
   * @param {number} offset the segment start time or Latest Arrival Time, 
   * @return {Object[]} an array of ID3 parsed from EMSG boxes
   */ getEmsgID3 = function(segmentData, offset = 0) {
        var emsgBoxes = findBox$3(segmentData, [
            'emsg'
        ]);
        return emsgBoxes.map((data)=>{
            var parsedBox = emsg.parseEmsgBox(new Uint8Array(data));
            var parsedId3Frames = parseId3Frames(parsedBox.message_data);
            return {
                cueTime: emsg.scaleTime(parsedBox.presentation_time, parsedBox.timescale, parsedBox.presentation_time_delta, offset),
                duration: emsg.scaleTime(parsedBox.event_duration, parsedBox.timescale),
                frames: parsedId3Frames
            };
        });
    };
    var probe$2 = {
        // export mp4 inspector's findBox and parseType for backwards compatibility
        findBox: findBox$3,
        parseType: parseType$1,
        timescale: timescale,
        startTime: startTime,
        compositionStartTime: compositionStartTime,
        videoTrackIds: getVideoTrackIds,
        tracks: getTracks,
        getTimescaleFromMediaHeader: getTimescaleFromMediaHeader$1,
        getEmsgID3: getEmsgID3
    };
    const { parseTrun: parseTrun } = mp4Inspector;
    const { findBox: findBox$2 } = probe$2;
    var window$1 = window_1;
    /**
   * Utility function for parsing data from mdat boxes.
   * @param {Array<Uint8Array>} segment the segment data to create mdat/traf pairs from.
   * @returns mdat and traf boxes paired up for easier parsing.
   */ var getMdatTrafPairs$2 = function(segment) {
        var trafs = findBox$2(segment, [
            'moof',
            'traf'
        ]);
        var mdats = findBox$2(segment, [
            'mdat'
        ]);
        var mdatTrafPairs = []; // Pair up each traf with a mdat as moofs and mdats are in pairs
        mdats.forEach(function(mdat, index) {
            var matchingTraf = trafs[index];
            mdatTrafPairs.push({
                mdat: mdat,
                traf: matchingTraf
            });
        });
        return mdatTrafPairs;
    };
    /**
    * Parses sample information out of Track Run Boxes and calculates
    * the absolute presentation and decode timestamps of each sample.
    *
    * @param {Array<Uint8Array>} truns - The Trun Run boxes to be parsed
    * @param {Number|BigInt} baseMediaDecodeTime - base media decode time from tfdt
        @see ISO-BMFF-12/2015, Section 8.8.12
    * @param {Object} tfhd - The parsed Track Fragment Header
    *   @see inspect.parseTfhd
    * @return {Object[]} the parsed samples
    *
    * @see ISO-BMFF-12/2015, Section 8.8.8
   **/ var parseSamples$2 = function(truns, baseMediaDecodeTime, tfhd) {
        var currentDts = baseMediaDecodeTime;
        var defaultSampleDuration = tfhd.defaultSampleDuration || 0;
        var defaultSampleSize = tfhd.defaultSampleSize || 0;
        var trackId = tfhd.trackId;
        var allSamples = [];
        truns.forEach(function(trun) {
            // Note: We currently do not parse the sample table as well
            // as the trun. It's possible some sources will require this.
            // moov > trak > mdia > minf > stbl
            var trackRun = parseTrun(trun);
            var samples = trackRun.samples;
            samples.forEach(function(sample) {
                if (sample.duration === undefined) sample.duration = defaultSampleDuration;
                if (sample.size === undefined) sample.size = defaultSampleSize;
                sample.trackId = trackId;
                sample.dts = currentDts;
                if (sample.compositionTimeOffset === undefined) sample.compositionTimeOffset = 0;
                if (typeof currentDts === 'bigint') {
                    sample.pts = currentDts + window$1.BigInt(sample.compositionTimeOffset);
                    currentDts += window$1.BigInt(sample.duration);
                } else {
                    sample.pts = currentDts + sample.compositionTimeOffset;
                    currentDts += sample.duration;
                }
            });
            allSamples = allSamples.concat(samples);
        });
        return allSamples;
    };
    var samples = {
        getMdatTrafPairs: getMdatTrafPairs$2,
        parseSamples: parseSamples$2
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Reads in-band CEA-708 captions out of FMP4 segments.
   * @see https://en.wikipedia.org/wiki/CEA-708
   */ var discardEmulationPreventionBytes = captionPacketParser.discardEmulationPreventionBytes;
    var CaptionStream = captionStream.CaptionStream;
    var findBox$1 = findBox_1;
    var parseTfdt$1 = parseTfdt$3;
    var parseTfhd = parseTfhd$2;
    var { getMdatTrafPairs: getMdatTrafPairs$1, parseSamples: parseSamples$1 } = samples;
    /**
    * Maps an offset in the mdat to a sample based on the the size of the samples.
    * Assumes that `parseSamples` has been called first.
    *
    * @param {Number} offset - The offset into the mdat
    * @param {Object[]} samples - An array of samples, parsed using `parseSamples`
    * @return {?Object} The matching sample, or null if no match was found.
    *
    * @see ISO-BMFF-12/2015, Section 8.8.8
   **/ var mapToSample = function(offset, samples) {
        var approximateOffset = offset;
        for(var i = 0; i < samples.length; i++){
            var sample = samples[i];
            if (approximateOffset < sample.size) return sample;
            approximateOffset -= sample.size;
        }
        return null;
    };
    /**
    * Finds SEI nal units contained in a Media Data Box.
    * Assumes that `parseSamples` has been called first.
    *
    * @param {Uint8Array} avcStream - The bytes of the mdat
    * @param {Object[]} samples - The samples parsed out by `parseSamples`
    * @param {Number} trackId - The trackId of this video track
    * @return {Object[]} seiNals - the parsed SEI NALUs found.
    *   The contents of the seiNal should match what is expected by
    *   CaptionStream.push (nalUnitType, size, data, escapedRBSP, pts, dts)
    *
    * @see ISO-BMFF-12/2015, Section 8.1.1
    * @see Rec. ITU-T H.264, 7.3.2.3.1
   **/ var findSeiNals = function(avcStream, samples, trackId) {
        var avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength), result = {
            logs: [],
            seiNals: []
        }, seiNal, i, length, lastMatchedSample;
        for(i = 0; i + 4 < avcStream.length; i += length){
            length = avcView.getUint32(i);
            i += 4; // Bail if this doesn't appear to be an H264 stream
            if (length <= 0) continue;
            switch(avcStream[i] & 0x1F){
                case 0x06:
                    var data = avcStream.subarray(i + 1, i + 1 + length);
                    var matchingSample = mapToSample(i, samples);
                    seiNal = {
                        nalUnitType: 'sei_rbsp',
                        size: length,
                        data: data,
                        escapedRBSP: discardEmulationPreventionBytes(data),
                        trackId: trackId
                    };
                    if (matchingSample) {
                        seiNal.pts = matchingSample.pts;
                        seiNal.dts = matchingSample.dts;
                        lastMatchedSample = matchingSample;
                    } else if (lastMatchedSample) {
                        // If a matching sample cannot be found, use the last
                        // sample's values as they should be as close as possible
                        seiNal.pts = lastMatchedSample.pts;
                        seiNal.dts = lastMatchedSample.dts;
                    } else {
                        result.logs.push({
                            level: 'warn',
                            message: 'We\'ve encountered a nal unit without data at ' + i + ' for trackId ' + trackId + '. See mux.js#223.'
                        });
                        break;
                    }
                    result.seiNals.push(seiNal);
                    break;
            }
        }
        return result;
    };
    /**
    * Parses out caption nals from an FMP4 segment's video tracks.
    *
    * @param {Uint8Array} segment - The bytes of a single segment
    * @param {Number} videoTrackId - The trackId of a video track in the segment
    * @return {Object.<Number, Object[]>} A mapping of video trackId to
    *   a list of seiNals found in that track
   **/ var parseCaptionNals = function(segment, videoTrackId) {
        var captionNals = {};
        var mdatTrafPairs = getMdatTrafPairs$1(segment);
        mdatTrafPairs.forEach(function(pair) {
            var mdat = pair.mdat;
            var traf = pair.traf;
            var tfhd = findBox$1(traf, [
                'tfhd'
            ]); // Exactly 1 tfhd per traf
            var headerInfo = parseTfhd(tfhd[0]);
            var trackId = headerInfo.trackId;
            var tfdt = findBox$1(traf, [
                'tfdt'
            ]); // Either 0 or 1 tfdt per traf
            var baseMediaDecodeTime = tfdt.length > 0 ? parseTfdt$1(tfdt[0]).baseMediaDecodeTime : 0;
            var truns = findBox$1(traf, [
                'trun'
            ]);
            var samples;
            var result; // Only parse video data for the chosen video track
            if (videoTrackId === trackId && truns.length > 0) {
                samples = parseSamples$1(truns, baseMediaDecodeTime, headerInfo);
                result = findSeiNals(mdat, samples, trackId);
                if (!captionNals[trackId]) captionNals[trackId] = {
                    seiNals: [],
                    logs: []
                };
                captionNals[trackId].seiNals = captionNals[trackId].seiNals.concat(result.seiNals);
                captionNals[trackId].logs = captionNals[trackId].logs.concat(result.logs);
            }
        });
        return captionNals;
    };
    /**
    * Parses out inband captions from an MP4 container and returns
    * caption objects that can be used by WebVTT and the TextTrack API.
    * @see https://developer.mozilla.org/en-US/docs/Web/API/VTTCue
    * @see https://developer.mozilla.org/en-US/docs/Web/API/TextTrack
    * Assumes that `probe.getVideoTrackIds` and `probe.timescale` have been called first
    *
    * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
    * @param {Number} trackId - The id of the video track to parse
    * @param {Number} timescale - The timescale for the video track from the init segment
    *
    * @return {?Object[]} parsedCaptions - A list of captions or null if no video tracks
    * @return {Number} parsedCaptions[].startTime - The time to show the caption in seconds
    * @return {Number} parsedCaptions[].endTime - The time to stop showing the caption in seconds
    * @return {Object[]} parsedCaptions[].content - A list of individual caption segments
    * @return {String} parsedCaptions[].content.text - The visible content of the caption segment
    * @return {Number} parsedCaptions[].content.line - The line height from 1-15 for positioning of the caption segment
    * @return {Number} parsedCaptions[].content.position - The column indent percentage for cue positioning from 10-80
   **/ var parseEmbeddedCaptions = function(segment, trackId, timescale) {
        var captionNals; // the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
        if (trackId === null) return null;
        captionNals = parseCaptionNals(segment, trackId);
        var trackNals = captionNals[trackId] || {};
        return {
            seiNals: trackNals.seiNals,
            logs: trackNals.logs,
            timescale: timescale
        };
    };
    /**
    * Converts SEI NALUs into captions that can be used by video.js
   **/ var CaptionParser = function() {
        var isInitialized = false;
        var captionStream; // Stores segments seen before trackId and timescale are set
        var segmentCache; // Stores video track ID of the track being parsed
        var trackId; // Stores the timescale of the track being parsed
        var timescale; // Stores captions parsed so far
        var parsedCaptions; // Stores whether we are receiving partial data or not
        var parsingPartial;
        /**
      * A method to indicate whether a CaptionParser has been initalized
      * @returns {Boolean}
     **/ this.isInitialized = function() {
            return isInitialized;
        };
        /**
      * Initializes the underlying CaptionStream, SEI NAL parsing
      * and management, and caption collection
     **/ this.init = function(options) {
            captionStream = new CaptionStream();
            isInitialized = true;
            parsingPartial = options ? options.isPartial : false; // Collect dispatched captions
            captionStream.on('data', function(event) {
                // Convert to seconds in the source's timescale
                event.startTime = event.startPts / timescale;
                event.endTime = event.endPts / timescale;
                parsedCaptions.captions.push(event);
                parsedCaptions.captionStreams[event.stream] = true;
            });
            captionStream.on('log', function(log) {
                parsedCaptions.logs.push(log);
            });
        };
        /**
      * Determines if a new video track will be selected
      * or if the timescale changed
      * @return {Boolean}
     **/ this.isNewInit = function(videoTrackIds, timescales) {
            if (videoTrackIds && videoTrackIds.length === 0 || timescales && typeof timescales === 'object' && Object.keys(timescales).length === 0) return false;
            return trackId !== videoTrackIds[0] || timescale !== timescales[trackId];
        };
        /**
      * Parses out SEI captions and interacts with underlying
      * CaptionStream to return dispatched captions
      *
      * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
      * @param {Number[]} videoTrackIds - A list of video tracks found in the init segment
      * @param {Object.<Number, Number>} timescales - The timescales found in the init segment
      * @see parseEmbeddedCaptions
      * @see m2ts/caption-stream.js
     **/ this.parse = function(segment, videoTrackIds, timescales) {
            var parsedData;
            if (!this.isInitialized()) return null; // This is not likely to be a video segment
            else if (!videoTrackIds || !timescales) return null;
            else if (this.isNewInit(videoTrackIds, timescales)) {
                // Use the first video track only as there is no
                // mechanism to switch to other video tracks
                trackId = videoTrackIds[0];
                timescale = timescales[trackId]; // If an init segment has not been seen yet, hold onto segment
            // data until we have one.
            // the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
            } else if (trackId === null || !timescale) {
                segmentCache.push(segment);
                return null;
            } // Now that a timescale and trackId is set, parse cached segments
            while(segmentCache.length > 0){
                var cachedSegment = segmentCache.shift();
                this.parse(cachedSegment, videoTrackIds, timescales);
            }
            parsedData = parseEmbeddedCaptions(segment, trackId, timescale);
            if (parsedData && parsedData.logs) parsedCaptions.logs = parsedCaptions.logs.concat(parsedData.logs);
            if (parsedData === null || !parsedData.seiNals) {
                if (parsedCaptions.logs.length) return {
                    logs: parsedCaptions.logs,
                    captions: [],
                    captionStreams: []
                };
                return null;
            }
            this.pushNals(parsedData.seiNals); // Force the parsed captions to be dispatched
            this.flushStream();
            return parsedCaptions;
        };
        /**
      * Pushes SEI NALUs onto CaptionStream
      * @param {Object[]} nals - A list of SEI nals parsed using `parseCaptionNals`
      * Assumes that `parseCaptionNals` has been called first
      * @see m2ts/caption-stream.js
      **/ this.pushNals = function(nals) {
            if (!this.isInitialized() || !nals || nals.length === 0) return null;
            nals.forEach(function(nal) {
                captionStream.push(nal);
            });
        };
        /**
      * Flushes underlying CaptionStream to dispatch processed, displayable captions
      * @see m2ts/caption-stream.js
     **/ this.flushStream = function() {
            if (!this.isInitialized()) return null;
            if (!parsingPartial) captionStream.flush();
            else captionStream.partialFlush();
        };
        /**
      * Reset caption buckets for new data
     **/ this.clearParsedCaptions = function() {
            parsedCaptions.captions = [];
            parsedCaptions.captionStreams = {};
            parsedCaptions.logs = [];
        };
        /**
      * Resets underlying CaptionStream
      * @see m2ts/caption-stream.js
     **/ this.resetCaptionStream = function() {
            if (!this.isInitialized()) return null;
            captionStream.reset();
        };
        /**
      * Convenience method to clear all captions flushed from the
      * CaptionStream and still being parsed
      * @see m2ts/caption-stream.js
     **/ this.clearAllCaptions = function() {
            this.clearParsedCaptions();
            this.resetCaptionStream();
        };
        /**
      * Reset caption parser
     **/ this.reset = function() {
            segmentCache = [];
            trackId = null;
            timescale = null;
            if (!parsedCaptions) parsedCaptions = {
                captions: [],
                // CC1, CC2, CC3, CC4
                captionStreams: {},
                logs: []
            };
            else this.clearParsedCaptions();
            this.resetCaptionStream();
        };
        this.reset();
    };
    var captionParser = CaptionParser;
    const { parseTfdt: parseTfdt } = mp4Inspector;
    const findBox = findBox_1;
    const { getTimescaleFromMediaHeader: getTimescaleFromMediaHeader } = probe$2;
    const { parseSamples: parseSamples, getMdatTrafPairs: getMdatTrafPairs } = samples;
    /**
   * Module for parsing WebVTT text and styles from FMP4 segments.
   * Based on the ISO/IEC 14496-30.
   */ const WebVttParser = function() {
        // default timescale to 90k
        let timescale = 90e3;
        /**
     * Parses the timescale from the init segment.
     * @param {Array<Uint8Array>} segment The initialization segment to parse the timescale from.
     */ this.init = function(segment) {
            // We just need the timescale from the init segment.
            const mdhd = findBox(segment, [
                'moov',
                'trak',
                'mdia',
                'mdhd'
            ])[0];
            if (mdhd) timescale = getTimescaleFromMediaHeader(mdhd);
        };
        /**
     * Parses a WebVTT FMP4 segment.
     * @param {Array<Uint8Array>} segment The content segment to parse the WebVTT cues from.
     * @returns The WebVTT cue text, styling, and timing info as an array of cue objects.
     */ this.parseSegment = function(segment) {
            const vttCues = [];
            const mdatTrafPairs = getMdatTrafPairs(segment);
            let baseMediaDecodeTime = 0;
            mdatTrafPairs.forEach(function(pair) {
                const mdatBox = pair.mdat;
                const trafBox = pair.traf; // zero or one.
                const tfdtBox = findBox(trafBox, [
                    'tfdt'
                ])[0]; // zero or one.
                const tfhdBox = findBox(trafBox, [
                    'tfhd'
                ])[0]; // zero or more.
                const trunBoxes = findBox(trafBox, [
                    'trun'
                ]);
                if (tfdtBox) {
                    const tfdt = parseTfdt(tfdtBox);
                    baseMediaDecodeTime = tfdt.baseMediaDecodeTime;
                }
                if (trunBoxes.length && tfhdBox) {
                    const samples = parseSamples(trunBoxes, baseMediaDecodeTime, tfhdBox);
                    let mdatOffset = 0;
                    samples.forEach(function(sample) {
                        // decode utf8 payload
                        const UTF_8 = 'utf-8';
                        const textDecoder = new TextDecoder(UTF_8); // extract sample data from the mdat box.
                        // WebVTT Sample format:
                        // Exactly one VTTEmptyCueBox box
                        // OR one or more VTTCueBox boxes.
                        const sampleData = mdatBox.slice(mdatOffset, mdatOffset + sample.size); // single vtte box.
                        const vtteBox = findBox(sampleData, [
                            'vtte'
                        ])[0]; // empty box
                        if (vtteBox) {
                            mdatOffset += sample.size;
                            return;
                        } // TODO: Support 'vtta' boxes.
                        // VTTAdditionalTextBoxes can be interleaved between VTTCueBoxes.
                        const vttcBoxes = findBox(sampleData, [
                            'vttc'
                        ]);
                        vttcBoxes.forEach(function(vttcBox) {
                            // mandatory payload box.
                            const paylBox = findBox(vttcBox, [
                                'payl'
                            ])[0]; // optional settings box
                            const sttgBox = findBox(vttcBox, [
                                'sttg'
                            ])[0];
                            const start = sample.pts / timescale;
                            const end = (sample.pts + sample.duration) / timescale;
                            let cueText, settings; // contains cue text.
                            if (paylBox) try {
                                cueText = textDecoder.decode(paylBox);
                            } catch (e) {
                                console.error(e);
                            }
                             // settings box contains styling.
                            if (sttgBox) try {
                                settings = textDecoder.decode(sttgBox);
                            } catch (e) {
                                console.error(e);
                            }
                            if (sample.duration && cueText) vttCues.push({
                                cueText: cueText,
                                start: start,
                                end: end,
                                settings: settings
                            });
                        });
                        mdatOffset += sample.size;
                    });
                }
            });
            return vttCues;
        };
    };
    var webvttParser = WebVttParser;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Utilities to detect basic properties and metadata about TS Segments.
   */ var StreamTypes$1 = streamTypes;
    var parsePid = function(packet) {
        var pid = packet[1] & 0x1f;
        pid <<= 8;
        pid |= packet[2];
        return pid;
    };
    var parsePayloadUnitStartIndicator = function(packet) {
        return !!(packet[1] & 0x40);
    };
    var parseAdaptionField = function(packet) {
        var offset = 0; // if an adaption field is present, its length is specified by the
        // fifth byte of the TS packet header. The adaptation field is
        // used to add stuffing to PES packets that don't fill a complete
        // TS packet, and to specify some forms of timing and control data
        // that we do not currently use.
        if ((packet[3] & 0x30) >>> 4 > 0x01) offset += packet[4] + 1;
        return offset;
    };
    var parseType = function(packet, pmtPid) {
        var pid = parsePid(packet);
        if (pid === 0) return 'pat';
        else if (pid === pmtPid) return 'pmt';
        else if (pmtPid) return 'pes';
        return null;
    };
    var parsePat = function(packet) {
        var pusi = parsePayloadUnitStartIndicator(packet);
        var offset = 4 + parseAdaptionField(packet);
        if (pusi) offset += packet[offset] + 1;
        return (packet[offset + 10] & 0x1f) << 8 | packet[offset + 11];
    };
    var parsePmt = function(packet) {
        var programMapTable = {};
        var pusi = parsePayloadUnitStartIndicator(packet);
        var payloadOffset = 4 + parseAdaptionField(packet);
        if (pusi) payloadOffset += packet[payloadOffset] + 1;
         // PMTs can be sent ahead of the time when they should actually
        // take effect. We don't believe this should ever be the case
        // for HLS but we'll ignore "forward" PMT declarations if we see
        // them. Future PMT declarations have the current_next_indicator
        // set to zero.
        if (!(packet[payloadOffset + 5] & 0x01)) return;
        var sectionLength, tableEnd, programInfoLength; // the mapping table ends at the end of the current section
        sectionLength = (packet[payloadOffset + 1] & 0x0f) << 8 | packet[payloadOffset + 2];
        tableEnd = 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
        // long the program info descriptors are
        programInfoLength = (packet[payloadOffset + 10] & 0x0f) << 8 | packet[payloadOffset + 11]; // advance the offset to the first entry in the mapping table
        var offset = 12 + programInfoLength;
        while(offset < tableEnd){
            var i = payloadOffset + offset; // add an entry that maps the elementary_pid to the stream_type
            programMapTable[(packet[i + 1] & 0x1F) << 8 | packet[i + 2]] = packet[i]; // move to the next table entry
            // skip past the elementary stream descriptors, if present
            offset += ((packet[i + 3] & 0x0F) << 8 | packet[i + 4]) + 5;
        }
        return programMapTable;
    };
    var parsePesType = function(packet, programMapTable) {
        var pid = parsePid(packet);
        var type = programMapTable[pid];
        switch(type){
            case StreamTypes$1.H264_STREAM_TYPE:
                return 'video';
            case StreamTypes$1.ADTS_STREAM_TYPE:
                return 'audio';
            case StreamTypes$1.METADATA_STREAM_TYPE:
                return 'timed-metadata';
            default:
                return null;
        }
    };
    var parsePesTime = function(packet) {
        var pusi = parsePayloadUnitStartIndicator(packet);
        if (!pusi) return null;
        var offset = 4 + parseAdaptionField(packet);
        if (offset >= packet.byteLength) // From the H 222.0 MPEG-TS spec
        // "For transport stream packets carrying PES packets, stuffing is needed when there
        //  is insufficient PES packet data to completely fill the transport stream packet
        //  payload bytes. Stuffing is accomplished by defining an adaptation field longer than
        //  the sum of the lengths of the data elements in it, so that the payload bytes
        //  remaining after the adaptation field exactly accommodates the available PES packet
        //  data."
        //
        // If the offset is >= the length of the packet, then the packet contains no data
        // and instead is just adaption field stuffing bytes
        return null;
        var pes = null;
        var ptsDtsFlags; // PES packets may be annotated with a PTS value, or a PTS value
        // and a DTS value. Determine what combination of values is
        // available to work with.
        ptsDtsFlags = packet[offset + 7]; // PTS and DTS are normally stored as a 33-bit number.  Javascript
        // performs all bitwise operations on 32-bit integers but javascript
        // supports a much greater range (52-bits) of integer using standard
        // mathematical operations.
        // We construct a 31-bit value using bitwise operators over the 31
        // most significant bits and then multiply by 4 (equal to a left-shift
        // of 2) before we add the final 2 least significant bits of the
        // timestamp (equal to an OR.)
        if (ptsDtsFlags & 0xC0) {
            pes = {}; // the PTS and DTS are not written out directly. For information
            // on how they are encoded, see
            // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
            pes.pts = (packet[offset + 9] & 0x0E) << 27 | (packet[offset + 10] & 0xFF) << 20 | (packet[offset + 11] & 0xFE) << 12 | (packet[offset + 12] & 0xFF) << 5 | (packet[offset + 13] & 0xFE) >>> 3;
            pes.pts *= 4; // Left shift by 2
            pes.pts += (packet[offset + 13] & 0x06) >>> 1; // OR by the two LSBs
            pes.dts = pes.pts;
            if (ptsDtsFlags & 0x40) {
                pes.dts = (packet[offset + 14] & 0x0E) << 27 | (packet[offset + 15] & 0xFF) << 20 | (packet[offset + 16] & 0xFE) << 12 | (packet[offset + 17] & 0xFF) << 5 | (packet[offset + 18] & 0xFE) >>> 3;
                pes.dts *= 4; // Left shift by 2
                pes.dts += (packet[offset + 18] & 0x06) >>> 1; // OR by the two LSBs
            }
        }
        return pes;
    };
    var parseNalUnitType = function(type) {
        switch(type){
            case 0x05:
                return 'slice_layer_without_partitioning_rbsp_idr';
            case 0x06:
                return 'sei_rbsp';
            case 0x07:
                return 'seq_parameter_set_rbsp';
            case 0x08:
                return 'pic_parameter_set_rbsp';
            case 0x09:
                return 'access_unit_delimiter_rbsp';
            default:
                return null;
        }
    };
    var videoPacketContainsKeyFrame = function(packet) {
        var offset = 4 + parseAdaptionField(packet);
        var frameBuffer = packet.subarray(offset);
        var frameI = 0;
        var frameSyncPoint = 0;
        var foundKeyFrame = false;
        var nalType; // advance the sync point to a NAL start, if necessary
        for(; frameSyncPoint < frameBuffer.byteLength - 3; frameSyncPoint++)if (frameBuffer[frameSyncPoint + 2] === 1) {
            // the sync point is properly aligned
            frameI = frameSyncPoint + 5;
            break;
        }
        while(frameI < frameBuffer.byteLength)// look at the current byte to determine if we've hit the end of
        // a NAL unit boundary
        switch(frameBuffer[frameI]){
            case 0:
                // skip past non-sync sequences
                if (frameBuffer[frameI - 1] !== 0) {
                    frameI += 2;
                    break;
                } else if (frameBuffer[frameI - 2] !== 0) {
                    frameI++;
                    break;
                }
                if (frameSyncPoint + 3 !== frameI - 2) {
                    nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
                    if (nalType === 'slice_layer_without_partitioning_rbsp_idr') foundKeyFrame = true;
                } // drop trailing zeroes
                do frameI++;
                while (frameBuffer[frameI] !== 1 && frameI < frameBuffer.length);
                frameSyncPoint = frameI - 2;
                frameI += 3;
                break;
            case 1:
                // skip past non-sync sequences
                if (frameBuffer[frameI - 1] !== 0 || frameBuffer[frameI - 2] !== 0) {
                    frameI += 3;
                    break;
                }
                nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
                if (nalType === 'slice_layer_without_partitioning_rbsp_idr') foundKeyFrame = true;
                frameSyncPoint = frameI - 2;
                frameI += 3;
                break;
            default:
                // the current byte isn't a one or zero, so it cannot be part
                // of a sync sequence
                frameI += 3;
                break;
        }
        frameBuffer = frameBuffer.subarray(frameSyncPoint);
        frameI -= frameSyncPoint;
        frameSyncPoint = 0; // parse the final nal
        if (frameBuffer && frameBuffer.byteLength > 3) {
            nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
            if (nalType === 'slice_layer_without_partitioning_rbsp_idr') foundKeyFrame = true;
        }
        return foundKeyFrame;
    };
    var probe$1 = {
        parseType: parseType,
        parsePat: parsePat,
        parsePmt: parsePmt,
        parsePayloadUnitStartIndicator: parsePayloadUnitStartIndicator,
        parsePesType: parsePesType,
        parsePesTime: parsePesTime,
        videoPacketContainsKeyFrame: videoPacketContainsKeyFrame
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Parse mpeg2 transport stream packets to extract basic timing information
   */ var StreamTypes = streamTypes;
    var handleRollover = timestampRolloverStream.handleRollover;
    var probe = {};
    probe.ts = probe$1;
    probe.aac = utils;
    var ONE_SECOND_IN_TS = clock$2.ONE_SECOND_IN_TS;
    var MP2T_PACKET_LENGTH = 188, // bytes
    SYNC_BYTE = 0x47;
    /**
   * walks through segment data looking for pat and pmt packets to parse out
   * program map table information
   */ var parsePsi_ = function(bytes, pmt) {
        var startIndex = 0, endIndex = MP2T_PACKET_LENGTH, packet, type;
        while(endIndex < bytes.byteLength){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case 'pat':
                        pmt.pid = probe.ts.parsePat(packet);
                        break;
                    case 'pmt':
                        var table = probe.ts.parsePmt(packet);
                        pmt.table = pmt.table || {};
                        Object.keys(table).forEach(function(key) {
                            pmt.table[key] = table[key];
                        });
                        break;
                }
                startIndex += MP2T_PACKET_LENGTH;
                endIndex += MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex++;
            endIndex++;
        }
    };
    /**
   * walks through the segment data from the start and end to get timing information
   * for the first and last audio pes packets
   */ var parseAudioPes_ = function(bytes, pmt, result) {
        var startIndex = 0, endIndex = MP2T_PACKET_LENGTH, packet, type, pesType, pusi, parsed;
        var endLoop = false; // Start walking from start of segment to get first audio packet
        while(endIndex <= bytes.byteLength){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case 'pes':
                        pesType = probe.ts.parsePesType(packet, pmt.table);
                        pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
                        if (pesType === 'audio' && pusi) {
                            parsed = probe.ts.parsePesTime(packet);
                            if (parsed) {
                                parsed.type = 'audio';
                                result.audio.push(parsed);
                                endLoop = true;
                            }
                        }
                        break;
                }
                if (endLoop) break;
                startIndex += MP2T_PACKET_LENGTH;
                endIndex += MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex++;
            endIndex++;
        } // Start walking from end of segment to get last audio packet
        endIndex = bytes.byteLength;
        startIndex = endIndex - MP2T_PACKET_LENGTH;
        endLoop = false;
        while(startIndex >= 0){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case 'pes':
                        pesType = probe.ts.parsePesType(packet, pmt.table);
                        pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
                        if (pesType === 'audio' && pusi) {
                            parsed = probe.ts.parsePesTime(packet);
                            if (parsed) {
                                parsed.type = 'audio';
                                result.audio.push(parsed);
                                endLoop = true;
                            }
                        }
                        break;
                }
                if (endLoop) break;
                startIndex -= MP2T_PACKET_LENGTH;
                endIndex -= MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex--;
            endIndex--;
        }
    };
    /**
   * walks through the segment data from the start and end to get timing information
   * for the first and last video pes packets as well as timing information for the first
   * key frame.
   */ var parseVideoPes_ = function(bytes, pmt, result) {
        var startIndex = 0, endIndex = MP2T_PACKET_LENGTH, packet, type, pesType, pusi, parsed, frame, i, pes;
        var endLoop = false;
        var currentFrame = {
            data: [],
            size: 0
        }; // Start walking from start of segment to get first video packet
        while(endIndex < bytes.byteLength){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case 'pes':
                        pesType = probe.ts.parsePesType(packet, pmt.table);
                        pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
                        if (pesType === 'video') {
                            if (pusi && !endLoop) {
                                parsed = probe.ts.parsePesTime(packet);
                                if (parsed) {
                                    parsed.type = 'video';
                                    result.video.push(parsed);
                                    endLoop = true;
                                }
                            }
                            if (!result.firstKeyFrame) {
                                if (pusi) {
                                    if (currentFrame.size !== 0) {
                                        frame = new Uint8Array(currentFrame.size);
                                        i = 0;
                                        while(currentFrame.data.length){
                                            pes = currentFrame.data.shift();
                                            frame.set(pes, i);
                                            i += pes.byteLength;
                                        }
                                        if (probe.ts.videoPacketContainsKeyFrame(frame)) {
                                            var firstKeyFrame = probe.ts.parsePesTime(frame); // PTS/DTS may not be available. Simply *not* setting
                                            // the keyframe seems to work fine with HLS playback
                                            // and definitely preferable to a crash with TypeError...
                                            if (firstKeyFrame) {
                                                result.firstKeyFrame = firstKeyFrame;
                                                result.firstKeyFrame.type = 'video';
                                            } else // eslint-disable-next-line
                                            console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                                        }
                                        currentFrame.size = 0;
                                    }
                                }
                                currentFrame.data.push(packet);
                                currentFrame.size += packet.byteLength;
                            }
                        }
                        break;
                }
                if (endLoop && result.firstKeyFrame) break;
                startIndex += MP2T_PACKET_LENGTH;
                endIndex += MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex++;
            endIndex++;
        } // Start walking from end of segment to get last video packet
        endIndex = bytes.byteLength;
        startIndex = endIndex - MP2T_PACKET_LENGTH;
        endLoop = false;
        while(startIndex >= 0){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case 'pes':
                        pesType = probe.ts.parsePesType(packet, pmt.table);
                        pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
                        if (pesType === 'video' && pusi) {
                            parsed = probe.ts.parsePesTime(packet);
                            if (parsed) {
                                parsed.type = 'video';
                                result.video.push(parsed);
                                endLoop = true;
                            }
                        }
                        break;
                }
                if (endLoop) break;
                startIndex -= MP2T_PACKET_LENGTH;
                endIndex -= MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex--;
            endIndex--;
        }
    };
    /**
   * Adjusts the timestamp information for the segment to account for
   * rollover and convert to seconds based on pes packet timescale (90khz clock)
   */ var adjustTimestamp_ = function(segmentInfo, baseTimestamp) {
        if (segmentInfo.audio && segmentInfo.audio.length) {
            var audioBaseTimestamp = baseTimestamp;
            if (typeof audioBaseTimestamp === 'undefined' || isNaN(audioBaseTimestamp)) audioBaseTimestamp = segmentInfo.audio[0].dts;
            segmentInfo.audio.forEach(function(info) {
                info.dts = handleRollover(info.dts, audioBaseTimestamp);
                info.pts = handleRollover(info.pts, audioBaseTimestamp); // time in seconds
                info.dtsTime = info.dts / ONE_SECOND_IN_TS;
                info.ptsTime = info.pts / ONE_SECOND_IN_TS;
            });
        }
        if (segmentInfo.video && segmentInfo.video.length) {
            var videoBaseTimestamp = baseTimestamp;
            if (typeof videoBaseTimestamp === 'undefined' || isNaN(videoBaseTimestamp)) videoBaseTimestamp = segmentInfo.video[0].dts;
            segmentInfo.video.forEach(function(info) {
                info.dts = handleRollover(info.dts, videoBaseTimestamp);
                info.pts = handleRollover(info.pts, videoBaseTimestamp); // time in seconds
                info.dtsTime = info.dts / ONE_SECOND_IN_TS;
                info.ptsTime = info.pts / ONE_SECOND_IN_TS;
            });
            if (segmentInfo.firstKeyFrame) {
                var frame = segmentInfo.firstKeyFrame;
                frame.dts = handleRollover(frame.dts, videoBaseTimestamp);
                frame.pts = handleRollover(frame.pts, videoBaseTimestamp); // time in seconds
                frame.dtsTime = frame.dts / ONE_SECOND_IN_TS;
                frame.ptsTime = frame.pts / ONE_SECOND_IN_TS;
            }
        }
    };
    /**
   * inspects the aac data stream for start and end time information
   */ var inspectAac_ = function(bytes) {
        var endLoop = false, audioCount = 0, sampleRate = null, timestamp = null, frameSize = 0, byteIndex = 0, packet;
        while(bytes.length - byteIndex >= 3){
            var type = probe.aac.parseType(bytes, byteIndex);
            switch(type){
                case 'timed-metadata':
                    // Exit early because we don't have enough to parse
                    // the ID3 tag header
                    if (bytes.length - byteIndex < 10) {
                        endLoop = true;
                        break;
                    }
                    frameSize = probe.aac.parseId3TagSize(bytes, byteIndex); // Exit early if we don't have enough in the buffer
                    // to emit a full packet
                    if (frameSize > bytes.length) {
                        endLoop = true;
                        break;
                    }
                    if (timestamp === null) {
                        packet = bytes.subarray(byteIndex, byteIndex + frameSize);
                        timestamp = probe.aac.parseAacTimestamp(packet);
                    }
                    byteIndex += frameSize;
                    break;
                case 'audio':
                    // Exit early because we don't have enough to parse
                    // the ADTS frame header
                    if (bytes.length - byteIndex < 7) {
                        endLoop = true;
                        break;
                    }
                    frameSize = probe.aac.parseAdtsSize(bytes, byteIndex); // Exit early if we don't have enough in the buffer
                    // to emit a full packet
                    if (frameSize > bytes.length) {
                        endLoop = true;
                        break;
                    }
                    if (sampleRate === null) {
                        packet = bytes.subarray(byteIndex, byteIndex + frameSize);
                        sampleRate = probe.aac.parseSampleRate(packet);
                    }
                    audioCount++;
                    byteIndex += frameSize;
                    break;
                default:
                    byteIndex++;
                    break;
            }
            if (endLoop) return null;
        }
        if (sampleRate === null || timestamp === null) return null;
        var audioTimescale = ONE_SECOND_IN_TS / sampleRate;
        var result = {
            audio: [
                {
                    type: 'audio',
                    dts: timestamp,
                    pts: timestamp
                },
                {
                    type: 'audio',
                    dts: timestamp + audioCount * 1024 * audioTimescale,
                    pts: timestamp + audioCount * 1024 * audioTimescale
                }
            ]
        };
        return result;
    };
    /**
   * inspects the transport stream segment data for start and end time information
   * of the audio and video tracks (when present) as well as the first key frame's
   * start time.
   */ var inspectTs_ = function(bytes) {
        var pmt = {
            pid: null,
            table: null
        };
        var result = {};
        parsePsi_(bytes, pmt);
        for(var pid in pmt.table)if (pmt.table.hasOwnProperty(pid)) {
            var type = pmt.table[pid];
            switch(type){
                case StreamTypes.H264_STREAM_TYPE:
                    result.video = [];
                    parseVideoPes_(bytes, pmt, result);
                    if (result.video.length === 0) delete result.video;
                    break;
                case StreamTypes.ADTS_STREAM_TYPE:
                    result.audio = [];
                    parseAudioPes_(bytes, pmt, result);
                    if (result.audio.length === 0) delete result.audio;
                    break;
            }
        }
        return result;
    };
    /**
   * Inspects segment byte data and returns an object with start and end timing information
   *
   * @param {Uint8Array} bytes The segment byte data
   * @param {Number} baseTimestamp Relative reference timestamp used when adjusting frame
   *  timestamps for rollover. This value must be in 90khz clock.
   * @return {Object} Object containing start and end frame timing info of segment.
   */ var inspect = function(bytes, baseTimestamp) {
        var isAacData = probe.aac.isLikelyAacData(bytes);
        var result;
        if (isAacData) result = inspectAac_(bytes);
        else result = inspectTs_(bytes);
        if (!result || !result.audio && !result.video) return null;
        adjustTimestamp_(result, baseTimestamp);
        return result;
    };
    var tsInspector = {
        inspect: inspect,
        parseAudioPes_: parseAudioPes_
    };
    /* global self */ /**
   * Re-emits transmuxer events by converting them into messages to the
   * world outside the worker.
   *
   * @param {Object} transmuxer the transmuxer to wire events on
   * @private
   */ const wireTransmuxerEvents = function(self1, transmuxer) {
        transmuxer.on('data', function(segment) {
            // transfer ownership of the underlying ArrayBuffer
            // instead of doing a copy to save memory
            // ArrayBuffers are transferable but generic TypedArrays are not
            // @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers#Passing_data_by_transferring_ownership_(transferable_objects)
            const initArray = segment.initSegment;
            segment.initSegment = {
                data: initArray.buffer,
                byteOffset: initArray.byteOffset,
                byteLength: initArray.byteLength
            };
            const typedArray = segment.data;
            segment.data = typedArray.buffer;
            self1.postMessage({
                action: 'data',
                segment: segment,
                byteOffset: typedArray.byteOffset,
                byteLength: typedArray.byteLength
            }, [
                segment.data
            ]);
        });
        transmuxer.on('done', function(data) {
            self1.postMessage({
                action: 'done'
            });
        });
        transmuxer.on('gopInfo', function(gopInfo) {
            self1.postMessage({
                action: 'gopInfo',
                gopInfo: gopInfo
            });
        });
        transmuxer.on('videoSegmentTimingInfo', function(timingInfo) {
            const videoSegmentTimingInfo = {
                start: {
                    decode: clock$2.videoTsToSeconds(timingInfo.start.dts),
                    presentation: clock$2.videoTsToSeconds(timingInfo.start.pts)
                },
                end: {
                    decode: clock$2.videoTsToSeconds(timingInfo.end.dts),
                    presentation: clock$2.videoTsToSeconds(timingInfo.end.pts)
                },
                baseMediaDecodeTime: clock$2.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
            };
            if (timingInfo.prependedContentDuration) videoSegmentTimingInfo.prependedContentDuration = clock$2.videoTsToSeconds(timingInfo.prependedContentDuration);
            self1.postMessage({
                action: 'videoSegmentTimingInfo',
                videoSegmentTimingInfo: videoSegmentTimingInfo
            });
        });
        transmuxer.on('audioSegmentTimingInfo', function(timingInfo) {
            // Note that all times for [audio/video]SegmentTimingInfo events are in video clock
            const audioSegmentTimingInfo = {
                start: {
                    decode: clock$2.videoTsToSeconds(timingInfo.start.dts),
                    presentation: clock$2.videoTsToSeconds(timingInfo.start.pts)
                },
                end: {
                    decode: clock$2.videoTsToSeconds(timingInfo.end.dts),
                    presentation: clock$2.videoTsToSeconds(timingInfo.end.pts)
                },
                baseMediaDecodeTime: clock$2.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
            };
            if (timingInfo.prependedContentDuration) audioSegmentTimingInfo.prependedContentDuration = clock$2.videoTsToSeconds(timingInfo.prependedContentDuration);
            self1.postMessage({
                action: 'audioSegmentTimingInfo',
                audioSegmentTimingInfo: audioSegmentTimingInfo
            });
        });
        transmuxer.on('id3Frame', function(id3Frame) {
            self1.postMessage({
                action: 'id3Frame',
                id3Frame: id3Frame
            });
        });
        transmuxer.on('caption', function(caption) {
            self1.postMessage({
                action: 'caption',
                caption: caption
            });
        });
        transmuxer.on('trackinfo', function(trackInfo) {
            self1.postMessage({
                action: 'trackinfo',
                trackInfo: trackInfo
            });
        });
        transmuxer.on('audioTimingInfo', function(audioTimingInfo) {
            // convert to video TS since we prioritize video time over audio
            self1.postMessage({
                action: 'audioTimingInfo',
                audioTimingInfo: {
                    start: clock$2.videoTsToSeconds(audioTimingInfo.start),
                    end: clock$2.videoTsToSeconds(audioTimingInfo.end)
                }
            });
        });
        transmuxer.on('videoTimingInfo', function(videoTimingInfo) {
            self1.postMessage({
                action: 'videoTimingInfo',
                videoTimingInfo: {
                    start: clock$2.videoTsToSeconds(videoTimingInfo.start),
                    end: clock$2.videoTsToSeconds(videoTimingInfo.end)
                }
            });
        });
        transmuxer.on('log', function(log) {
            self1.postMessage({
                action: 'log',
                log: log
            });
        });
    };
    /**
   * All incoming messages route through this hash. If no function exists
   * to handle an incoming message, then we ignore the message.
   *
   * @class MessageHandlers
   * @param {Object} options the options to initialize with
   */ class MessageHandlers {
        constructor(self1, options){
            this.options = options || {};
            this.self = self1;
            this.init();
        }
        /**
     * initialize our web worker and wire all the events.
     */ init() {
            if (this.transmuxer) this.transmuxer.dispose();
            this.transmuxer = new transmuxer.Transmuxer(this.options);
            wireTransmuxerEvents(this.self, this.transmuxer);
        }
        pushMp4Captions(data) {
            if (!this.captionParser) {
                this.captionParser = new captionParser();
                this.captionParser.init();
            }
            const segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
            const parsed = this.captionParser.parse(segment, data.trackIds, data.timescales);
            this.self.postMessage({
                action: 'mp4Captions',
                captions: parsed && parsed.captions || [],
                logs: parsed && parsed.logs || [],
                data: segment.buffer
            }, [
                segment.buffer
            ]);
        }
        /**
     * Initializes the WebVttParser and passes the init segment.
     *
     * @param {Uint8Array} data mp4 boxed WebVTT init segment data
     */ initMp4WebVttParser(data) {
            if (!this.webVttParser) this.webVttParser = new webvttParser();
            const segment = new Uint8Array(data.data, data.byteOffset, data.byteLength); // Set the timescale for the parser.
            // This can be called repeatedly in order to set and re-set the timescale.
            this.webVttParser.init(segment);
        }
        /**
     * Parse an mp4 encapsulated WebVTT segment and return an array of cues.
     *
     * @param {Uint8Array} data a text/webvtt segment
     * @return {Object[]} an array of parsed cue objects
     */ getMp4WebVttText(data) {
            if (!this.webVttParser) // timescale might not be set yet if the parser is created before an init segment is passed.
            // default timescale is 90k.
            this.webVttParser = new webvttParser();
            const segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
            const parsed = this.webVttParser.parseSegment(segment);
            this.self.postMessage({
                action: 'getMp4WebVttText',
                mp4VttCues: parsed || [],
                data: segment.buffer
            }, [
                segment.buffer
            ]);
        }
        probeMp4StartTime({ timescales: timescales, data: data }) {
            const startTime = probe$2.startTime(timescales, data);
            this.self.postMessage({
                action: 'probeMp4StartTime',
                startTime: startTime,
                data: data
            }, [
                data.buffer
            ]);
        }
        probeMp4Tracks({ data: data }) {
            const tracks = probe$2.tracks(data);
            this.self.postMessage({
                action: 'probeMp4Tracks',
                tracks: tracks,
                data: data
            }, [
                data.buffer
            ]);
        }
        /**
     * Probes an mp4 segment for EMSG boxes containing ID3 data.
     * https://aomediacodec.github.io/id3-emsg/
     *
     * @param {Uint8Array} data segment data
     * @param {number} offset segment start time
     * @return {Object[]} an array of ID3 frames
     */ probeEmsgID3({ data: data, offset: offset }) {
            const id3Frames = probe$2.getEmsgID3(data, offset);
            this.self.postMessage({
                action: 'probeEmsgID3',
                id3Frames: id3Frames,
                emsgData: data
            }, [
                data.buffer
            ]);
        }
        /**
     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
     * internal "media time," as well as whether it contains video and/or audio.
     *
     * @private
     * @param {Uint8Array} bytes - segment bytes
     * @param {number} baseStartTime
     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
     *        This value should be in seconds, as it's converted to a 90khz clock within the
     *        function body.
     * @return {Object} The start time of the current segment in "media time" as well as
     *                  whether it contains video and/or audio
     */ probeTs({ data: data, baseStartTime: baseStartTime }) {
            const tsStartTime = typeof baseStartTime === 'number' && !isNaN(baseStartTime) ? baseStartTime * clock$2.ONE_SECOND_IN_TS : void 0;
            const timeInfo = tsInspector.inspect(data, tsStartTime);
            let result = null;
            if (timeInfo) {
                result = {
                    // each type's time info comes back as an array of 2 times, start and end
                    hasVideo: timeInfo.video && timeInfo.video.length === 2 || false,
                    hasAudio: timeInfo.audio && timeInfo.audio.length === 2 || false
                };
                if (result.hasVideo) result.videoStart = timeInfo.video[0].ptsTime;
                if (result.hasAudio) result.audioStart = timeInfo.audio[0].ptsTime;
            }
            this.self.postMessage({
                action: 'probeTs',
                result: result,
                data: data
            }, [
                data.buffer
            ]);
        }
        clearAllMp4Captions() {
            if (this.captionParser) this.captionParser.clearAllCaptions();
        }
        clearParsedMp4Captions() {
            if (this.captionParser) this.captionParser.clearParsedCaptions();
        }
        /**
     * Adds data (a ts segment) to the start of the transmuxer pipeline for
     * processing.
     *
     * @param {ArrayBuffer} data data to push into the muxer
     */ push(data) {
            // Cast array buffer to correct type for transmuxer
            const segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
            this.transmuxer.push(segment);
        }
        /**
     * Recreate the transmuxer so that the next segment added via `push`
     * start with a fresh transmuxer.
     */ reset() {
            this.transmuxer.reset();
        }
        /**
     * Set the value that will be used as the `baseMediaDecodeTime` time for the
     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
     * set relative to the first based on the PTS values.
     *
     * @param {Object} data used to set the timestamp offset in the muxer
     */ setTimestampOffset(data) {
            const timestampOffset = data.timestampOffset || 0;
            this.transmuxer.setBaseMediaDecodeTime(Math.round(clock$2.secondsToVideoTs(timestampOffset)));
        }
        setAudioAppendStart(data) {
            this.transmuxer.setAudioAppendStart(Math.ceil(clock$2.secondsToVideoTs(data.appendStart)));
        }
        setRemux(data) {
            this.transmuxer.setRemux(data.remux);
        }
        /**
     * Forces the pipeline to finish processing the last segment and emit it's
     * results.
     *
     * @param {Object} data event data, not really used
     */ flush(data) {
            this.transmuxer.flush(); // transmuxed done action is fired after both audio/video pipelines are flushed
            self.postMessage({
                action: 'done',
                type: 'transmuxed'
            });
        }
        endTimeline() {
            this.transmuxer.endTimeline(); // transmuxed endedtimeline action is fired after both audio/video pipelines end their
            // timelines
            self.postMessage({
                action: 'endedtimeline',
                type: 'transmuxed'
            });
        }
        alignGopsWith(data) {
            this.transmuxer.alignGopsWith(data.gopsToAlignWith.slice());
        }
    }
    /**
   * Our web worker interface so that things can talk to mux.js
   * that will be running in a web worker. the scope is passed to this by
   * webworkify.
   *
   * @param {Object} self the scope for the web worker
   */ self.onmessage = function(event) {
        if (event.data.action === 'init' && event.data.options) {
            this.messageHandlers = new MessageHandlers(self, event.data.options);
            return;
        }
        if (!this.messageHandlers) this.messageHandlers = new MessageHandlers(self);
        if (event.data && event.data.action && event.data.action !== 'init') {
            if (this.messageHandlers[event.data.action]) this.messageHandlers[event.data.action](event.data);
        }
    };
}));
var $86defbb4e95ebb07$var$TransmuxWorker = $86defbb4e95ebb07$var$factory($86defbb4e95ebb07$var$workerCode$1);
/* rollup-plugin-worker-factory end for worker!/Users/srimron-soutter/repos/github/vjs/http-streaming/src/transmuxer-worker.js */ const $86defbb4e95ebb07$var$handleData_ = (event, transmuxedData, callback)=>{
    const { type: type, initSegment: initSegment, captions: captions, captionStreams: captionStreams, metadata: metadata, videoFrameDtsTime: videoFrameDtsTime, videoFramePtsTime: videoFramePtsTime } = event.data.segment;
    transmuxedData.buffer.push({
        captions: captions,
        captionStreams: captionStreams,
        metadata: metadata
    });
    const boxes = event.data.segment.boxes || {
        data: event.data.segment.data
    };
    const result = {
        type: type,
        // cast ArrayBuffer to TypedArray
        data: new Uint8Array(boxes.data, boxes.data.byteOffset, boxes.data.byteLength),
        initSegment: new Uint8Array(initSegment.data, initSegment.byteOffset, initSegment.byteLength)
    };
    if (typeof videoFrameDtsTime !== 'undefined') result.videoFrameDtsTime = videoFrameDtsTime;
    if (typeof videoFramePtsTime !== 'undefined') result.videoFramePtsTime = videoFramePtsTime;
    callback(result);
};
const $86defbb4e95ebb07$var$handleDone_ = ({ transmuxedData: transmuxedData, callback: callback })=>{
    // Previously we only returned data on data events,
    // not on done events. Clear out the buffer to keep that consistent.
    transmuxedData.buffer = []; // all buffers should have been flushed from the muxer, so start processing anything we
    // have received
    callback(transmuxedData);
};
const $86defbb4e95ebb07$var$handleGopInfo_ = (event, transmuxedData)=>{
    transmuxedData.gopInfo = event.data.gopInfo;
};
const $86defbb4e95ebb07$var$processTransmux = (options)=>{
    const { transmuxer: transmuxer, bytes: bytes, audioAppendStart: audioAppendStart, gopsToAlignWith: gopsToAlignWith, remux: remux, onData: onData, onTrackInfo: onTrackInfo, onAudioTimingInfo: onAudioTimingInfo, onVideoTimingInfo: onVideoTimingInfo, onVideoSegmentTimingInfo: onVideoSegmentTimingInfo, onAudioSegmentTimingInfo: onAudioSegmentTimingInfo, onId3: onId3, onCaptions: onCaptions, onDone: onDone, onEndedTimeline: onEndedTimeline, onTransmuxerLog: onTransmuxerLog, isEndOfTimeline: isEndOfTimeline, segment: segment, triggerSegmentEventFn: triggerSegmentEventFn } = options;
    const transmuxedData = {
        buffer: []
    };
    let waitForEndedTimelineEvent = isEndOfTimeline;
    const handleMessage = (event)=>{
        if (transmuxer.currentTransmux !== options) // disposed
        return;
        if (event.data.action === 'data') $86defbb4e95ebb07$var$handleData_(event, transmuxedData, onData);
        if (event.data.action === 'trackinfo') onTrackInfo(event.data.trackInfo);
        if (event.data.action === 'gopInfo') $86defbb4e95ebb07$var$handleGopInfo_(event, transmuxedData);
        if (event.data.action === 'audioTimingInfo') onAudioTimingInfo(event.data.audioTimingInfo);
        if (event.data.action === 'videoTimingInfo') onVideoTimingInfo(event.data.videoTimingInfo);
        if (event.data.action === 'videoSegmentTimingInfo') onVideoSegmentTimingInfo(event.data.videoSegmentTimingInfo);
        if (event.data.action === 'audioSegmentTimingInfo') onAudioSegmentTimingInfo(event.data.audioSegmentTimingInfo);
        if (event.data.action === 'id3Frame') onId3([
            event.data.id3Frame
        ], event.data.id3Frame.dispatchType);
        if (event.data.action === 'caption') onCaptions(event.data.caption);
        if (event.data.action === 'endedtimeline') {
            waitForEndedTimelineEvent = false;
            onEndedTimeline();
        }
        if (event.data.action === 'log') onTransmuxerLog(event.data.log);
         // wait for the transmuxed event since we may have audio and video
        if (event.data.type !== 'transmuxed') return;
         // If the "endedtimeline" event has not yet fired, and this segment represents the end
        // of a timeline, that means there may still be data events before the segment
        // processing can be considerred complete. In that case, the final event should be
        // an "endedtimeline" event with the type "transmuxed."
        if (waitForEndedTimelineEvent) return;
        transmuxer.onmessage = null;
        $86defbb4e95ebb07$var$handleDone_({
            transmuxedData: transmuxedData,
            callback: onDone
        });
        /* eslint-disable no-use-before-define */ $86defbb4e95ebb07$var$dequeue(transmuxer);
    /* eslint-enable */ };
    const handleError = ()=>{
        const error = {
            message: 'Received an error message from the transmuxer worker',
            metadata: {
                errorType: $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.StreamingFailedToTransmuxSegment,
                segmentInfo: $86defbb4e95ebb07$var$segmentInfoPayload({
                    segment: segment
                })
            }
        };
        onDone(null, error);
    };
    transmuxer.onmessage = handleMessage;
    transmuxer.onerror = handleError;
    if (audioAppendStart) transmuxer.postMessage({
        action: 'setAudioAppendStart',
        appendStart: audioAppendStart
    });
     // allow empty arrays to be passed to clear out GOPs
    if (Array.isArray(gopsToAlignWith)) transmuxer.postMessage({
        action: 'alignGopsWith',
        gopsToAlignWith: gopsToAlignWith
    });
    if (typeof remux !== 'undefined') transmuxer.postMessage({
        action: 'setRemux',
        remux: remux
    });
    if (bytes.byteLength) {
        const buffer = bytes instanceof ArrayBuffer ? bytes : bytes.buffer;
        const byteOffset = bytes instanceof ArrayBuffer ? 0 : bytes.byteOffset;
        triggerSegmentEventFn({
            type: 'segmenttransmuxingstart',
            segment: segment
        });
        transmuxer.postMessage({
            action: 'push',
            // Send the typed-array of data as an ArrayBuffer so that
            // it can be sent as a "Transferable" and avoid the costly
            // memory copy
            data: buffer,
            byteOffset: // To recreate the original typed-array, we need information
            // about what portion of the ArrayBuffer it was a view into
            byteOffset,
            byteLength: bytes.byteLength
        }, [
            buffer
        ]);
    }
    if (isEndOfTimeline) transmuxer.postMessage({
        action: 'endTimeline'
    });
     // even if we didn't push any bytes, we have to make sure we flush in case we reached
    // the end of the segment
    transmuxer.postMessage({
        action: 'flush'
    });
};
const $86defbb4e95ebb07$var$dequeue = (transmuxer)=>{
    transmuxer.currentTransmux = null;
    if (transmuxer.transmuxQueue.length) {
        transmuxer.currentTransmux = transmuxer.transmuxQueue.shift();
        if (typeof transmuxer.currentTransmux === 'function') transmuxer.currentTransmux();
        else $86defbb4e95ebb07$var$processTransmux(transmuxer.currentTransmux);
    }
};
const $86defbb4e95ebb07$var$processAction = (transmuxer, action)=>{
    transmuxer.postMessage({
        action: action
    });
    $86defbb4e95ebb07$var$dequeue(transmuxer);
};
const $86defbb4e95ebb07$var$enqueueAction = (action, transmuxer)=>{
    if (!transmuxer.currentTransmux) {
        transmuxer.currentTransmux = action;
        $86defbb4e95ebb07$var$processAction(transmuxer, action);
        return;
    }
    transmuxer.transmuxQueue.push($86defbb4e95ebb07$var$processAction.bind(null, transmuxer, action));
};
const $86defbb4e95ebb07$var$reset = (transmuxer)=>{
    $86defbb4e95ebb07$var$enqueueAction('reset', transmuxer);
};
const $86defbb4e95ebb07$var$endTimeline = (transmuxer)=>{
    $86defbb4e95ebb07$var$enqueueAction('endTimeline', transmuxer);
};
const $86defbb4e95ebb07$var$transmux = (options)=>{
    if (!options.transmuxer.currentTransmux) {
        options.transmuxer.currentTransmux = options;
        $86defbb4e95ebb07$var$processTransmux(options);
        return;
    }
    options.transmuxer.transmuxQueue.push(options);
};
const $86defbb4e95ebb07$var$createTransmuxer = (options)=>{
    const transmuxer = new $86defbb4e95ebb07$var$TransmuxWorker();
    transmuxer.currentTransmux = null;
    transmuxer.transmuxQueue = [];
    const term = transmuxer.terminate;
    transmuxer.terminate = ()=>{
        transmuxer.currentTransmux = null;
        transmuxer.transmuxQueue.length = 0;
        return term.call(transmuxer);
    };
    transmuxer.postMessage({
        action: 'init',
        options: options
    });
    return transmuxer;
};
var $86defbb4e95ebb07$var$segmentTransmuxer = {
    reset: $86defbb4e95ebb07$var$reset,
    endTimeline: $86defbb4e95ebb07$var$endTimeline,
    transmux: $86defbb4e95ebb07$var$transmux,
    createTransmuxer: $86defbb4e95ebb07$var$createTransmuxer
};
const $86defbb4e95ebb07$var$workerCallback = function(options) {
    const transmuxer = options.transmuxer;
    const endAction = options.endAction || options.action;
    const callback = options.callback;
    const message = (0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, options, {
        endAction: null,
        transmuxer: null,
        callback: null
    });
    const listenForEndEvent = (event)=>{
        if (event.data.action !== endAction) return;
        transmuxer.removeEventListener('message', listenForEndEvent); // transfer ownership of bytes back to us.
        if (event.data.data) {
            event.data.data = new Uint8Array(event.data.data, options.byteOffset || 0, options.byteLength || event.data.data.byteLength);
            if (options.data) options.data = event.data.data;
        }
        callback(event.data);
    };
    transmuxer.addEventListener('message', listenForEndEvent);
    if (options.data) {
        const isArrayBuffer = options.data instanceof ArrayBuffer;
        message.byteOffset = isArrayBuffer ? 0 : options.data.byteOffset;
        message.byteLength = options.data.byteLength;
        const transfers = [
            isArrayBuffer ? options.data : options.data.buffer
        ];
        transmuxer.postMessage(message, transfers);
    } else transmuxer.postMessage(message);
};
const $86defbb4e95ebb07$var$REQUEST_ERRORS = {
    FAILURE: 2,
    TIMEOUT: -101,
    ABORTED: -102
};
const $86defbb4e95ebb07$var$WEB_VTT_CODEC = 'wvtt';
/**
 * Abort all requests
 *
 * @param {Object} activeXhrs - an object that tracks all XHR requests
 */ const $86defbb4e95ebb07$var$abortAll = (activeXhrs)=>{
    activeXhrs.forEach((xhr)=>{
        xhr.abort();
    });
};
/**
 * Gather important bandwidth stats once a request has completed
 *
 * @param {Object} request - the XHR request from which to gather stats
 */ const $86defbb4e95ebb07$var$getRequestStats = (request)=>{
    return {
        bandwidth: request.bandwidth,
        bytesReceived: request.bytesReceived || 0,
        roundTripTime: request.roundTripTime || 0
    };
};
/**
 * If possible gather bandwidth stats as a request is in
 * progress
 *
 * @param {Event} progressEvent - an event object from an XHR's progress event
 */ const $86defbb4e95ebb07$var$getProgressStats = (progressEvent)=>{
    const request = progressEvent.target;
    const roundTripTime = Date.now() - request.requestTime;
    const stats = {
        bandwidth: Infinity,
        bytesReceived: 0,
        roundTripTime: roundTripTime || 0
    };
    stats.bytesReceived = progressEvent.loaded; // This can result in Infinity if stats.roundTripTime is 0 but that is ok
    // because we should only use bandwidth stats on progress to determine when
    // abort a request early due to insufficient bandwidth
    stats.bandwidth = Math.floor(stats.bytesReceived / stats.roundTripTime * 8000);
    return stats;
};
/**
 * Handle all error conditions in one place and return an object
 * with all the information
 *
 * @param {Error|null} error - if non-null signals an error occured with the XHR
 * @param {Object} request -  the XHR request that possibly generated the error
 */ const $86defbb4e95ebb07$var$handleErrors = (error, request)=>{
    const { requestType: requestType } = request;
    const metadata = $86defbb4e95ebb07$var$getStreamingNetworkErrorMetadata({
        requestType: requestType,
        request: request,
        error: error
    });
    if (request.timedout) return {
        status: request.status,
        message: 'HLS request timed-out at URL: ' + request.uri,
        code: $86defbb4e95ebb07$var$REQUEST_ERRORS.TIMEOUT,
        xhr: request,
        metadata: metadata
    };
    if (request.aborted) return {
        status: request.status,
        message: 'HLS request aborted at URL: ' + request.uri,
        code: $86defbb4e95ebb07$var$REQUEST_ERRORS.ABORTED,
        xhr: request,
        metadata: metadata
    };
    if (error) return {
        status: request.status,
        message: 'HLS request errored at URL: ' + request.uri,
        code: $86defbb4e95ebb07$var$REQUEST_ERRORS.FAILURE,
        xhr: request,
        metadata: metadata
    };
    if (request.responseType === 'arraybuffer' && request.response.byteLength === 0) return {
        status: request.status,
        message: 'Empty HLS response at URL: ' + request.uri,
        code: $86defbb4e95ebb07$var$REQUEST_ERRORS.FAILURE,
        xhr: request,
        metadata: metadata
    };
    return null;
};
/**
 * Handle responses for key data and convert the key data to the correct format
 * for the decryption step later
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Array} objects - objects to add the key bytes to.
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */ const $86defbb4e95ebb07$var$handleKeyResponse = (segment, objects, finishProcessingFn, triggerSegmentEventFn)=>(error, request)=>{
        const response = request.response;
        const errorObj = $86defbb4e95ebb07$var$handleErrors(error, request);
        if (errorObj) return finishProcessingFn(errorObj, segment);
        if (response.byteLength !== 16) return finishProcessingFn({
            status: request.status,
            message: 'Invalid HLS key at URL: ' + request.uri,
            code: $86defbb4e95ebb07$var$REQUEST_ERRORS.FAILURE,
            xhr: request
        }, segment);
        const view = new DataView(response);
        const bytes = new Uint32Array([
            view.getUint32(0),
            view.getUint32(4),
            view.getUint32(8),
            view.getUint32(12)
        ]);
        for(let i = 0; i < objects.length; i++)objects[i].bytes = bytes;
        const keyInfo = {
            uri: request.uri
        };
        triggerSegmentEventFn({
            type: 'segmentkeyloadcomplete',
            segment: segment,
            keyInfo: keyInfo
        });
        return finishProcessingFn(null, segment);
    };
/**
 * Processes an mp4 init segment depending on the codec through the transmuxer.
 *
 * @param {Object} segment init segment to process
 * @param {string} codec the codec of the text segments
 */ const $86defbb4e95ebb07$var$initMp4Text = (segment, codec)=>{
    if (codec === $86defbb4e95ebb07$var$WEB_VTT_CODEC) segment.transmuxer.postMessage({
        action: 'initMp4WebVttParser',
        data: segment.map.bytes
    });
};
/**
 * Parses an mp4 text segment with the transmuxer and calls the doneFn from
 * the segment loader.
 *
 * @param {Object} segment the text segment to parse
 * @param {string} codec the codec of the text segment
 * @param {Function} doneFn the doneFn passed from the segment loader
 */ const $86defbb4e95ebb07$var$parseMp4TextSegment = (segment, codec, doneFn)=>{
    if (codec === $86defbb4e95ebb07$var$WEB_VTT_CODEC) $86defbb4e95ebb07$var$workerCallback({
        action: 'getMp4WebVttText',
        data: segment.bytes,
        transmuxer: segment.transmuxer,
        callback: ({ data: data, mp4VttCues: mp4VttCues })=>{
            segment.bytes = data;
            doneFn(null, segment, {
                mp4VttCues: mp4VttCues
            });
        }
    });
};
const $86defbb4e95ebb07$var$parseInitSegment = (segment, callback)=>{
    const type = (0, $7483119daf318a41$export$894319e75ed840c3)(segment.map.bytes); // TODO: We should also handle ts init segments here, but we
    // only know how to parse mp4 init segments at the moment
    if (type !== 'mp4') {
        const uri = segment.map.resolvedUri || segment.map.uri;
        const mediaType = type || 'unknown';
        return callback({
            internal: true,
            message: `Found unsupported ${mediaType} container for initialization segment at URL: ${uri}`,
            code: $86defbb4e95ebb07$var$REQUEST_ERRORS.FAILURE,
            metadata: {
                mediaType: mediaType
            }
        });
    }
    $86defbb4e95ebb07$var$workerCallback({
        action: 'probeMp4Tracks',
        data: segment.map.bytes,
        transmuxer: segment.transmuxer,
        callback: ({ tracks: tracks, data: data })=>{
            // transfer bytes back to us
            segment.map.bytes = data;
            tracks.forEach(function(track) {
                segment.map.tracks = segment.map.tracks || {}; // only support one track of each type for now
                if (segment.map.tracks[track.type]) return;
                segment.map.tracks[track.type] = track;
                if (typeof track.id === 'number' && track.timescale) {
                    segment.map.timescales = segment.map.timescales || {};
                    segment.map.timescales[track.id] = track.timescale;
                }
                if (track.type === 'text') $86defbb4e95ebb07$var$initMp4Text(segment, track.codec);
            });
            return callback(null);
        }
    });
};
/**
 * Handle init-segment responses
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */ const $86defbb4e95ebb07$var$handleInitSegmentResponse = ({ segment: segment, finishProcessingFn: finishProcessingFn, triggerSegmentEventFn: triggerSegmentEventFn })=>(error, request)=>{
        const errorObj = $86defbb4e95ebb07$var$handleErrors(error, request);
        if (errorObj) return finishProcessingFn(errorObj, segment);
        const bytes = new Uint8Array(request.response);
        triggerSegmentEventFn({
            type: 'segmentloaded',
            segment: segment
        }); // init segment is encypted, we will have to wait
        // until the key request is done to decrypt.
        if (segment.map.key) {
            segment.map.encryptedBytes = bytes;
            return finishProcessingFn(null, segment);
        }
        segment.map.bytes = bytes;
        $86defbb4e95ebb07$var$parseInitSegment(segment, function(parseError) {
            if (parseError) {
                parseError.xhr = request;
                parseError.status = request.status;
                return finishProcessingFn(parseError, segment);
            }
            finishProcessingFn(null, segment);
        });
    };
/**
 * Response handler for segment-requests being sure to set the correct
 * property depending on whether the segment is encryped or not
 * Also records and keeps track of stats that are used for ABR purposes
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */ const $86defbb4e95ebb07$var$handleSegmentResponse = ({ segment: segment, finishProcessingFn: finishProcessingFn, responseType: responseType, triggerSegmentEventFn: triggerSegmentEventFn })=>(error, request)=>{
        const errorObj = $86defbb4e95ebb07$var$handleErrors(error, request);
        if (errorObj) return finishProcessingFn(errorObj, segment);
        triggerSegmentEventFn({
            type: 'segmentloaded',
            segment: segment
        });
        const newBytes = // although responseText "should" exist, this guard serves to prevent an error being
        // thrown for two primary cases:
        // 1. the mime type override stops working, or is not implemented for a specific
        //    browser
        // 2. when using mock XHR libraries like sinon that do not allow the override behavior
        responseType === 'arraybuffer' || !request.responseText ? request.response : $86defbb4e95ebb07$var$stringToArrayBuffer(request.responseText.substring(segment.lastReachedChar || 0));
        segment.stats = $86defbb4e95ebb07$var$getRequestStats(request);
        if (segment.key) segment.encryptedBytes = new Uint8Array(newBytes);
        else segment.bytes = new Uint8Array(newBytes);
        return finishProcessingFn(null, segment);
    };
const $86defbb4e95ebb07$var$transmuxAndNotify = ({ segment: segment, bytes: bytes, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog, triggerSegmentEventFn: triggerSegmentEventFn })=>{
    const fmp4Tracks = segment.map && segment.map.tracks || {};
    const isMuxed = Boolean(fmp4Tracks.audio && fmp4Tracks.video); // Keep references to each function so we can null them out after we're done with them.
    // One reason for this is that in the case of full segments, we want to trust start
    // times from the probe, rather than the transmuxer.
    let audioStartFn = timingInfoFn.bind(null, segment, 'audio', 'start');
    const audioEndFn = timingInfoFn.bind(null, segment, 'audio', 'end');
    let videoStartFn = timingInfoFn.bind(null, segment, 'video', 'start');
    const videoEndFn = timingInfoFn.bind(null, segment, 'video', 'end');
    const finish = ()=>$86defbb4e95ebb07$var$transmux({
            bytes: bytes,
            transmuxer: segment.transmuxer,
            audioAppendStart: segment.audioAppendStart,
            gopsToAlignWith: segment.gopsToAlignWith,
            remux: isMuxed,
            onData: (result)=>{
                result.type = result.type === 'combined' ? 'video' : result.type;
                dataFn(segment, result);
            },
            onTrackInfo: (trackInfo)=>{
                if (trackInfoFn) {
                    if (isMuxed) trackInfo.isMuxed = true;
                    trackInfoFn(segment, trackInfo);
                }
            },
            onAudioTimingInfo: (audioTimingInfo)=>{
                // we only want the first start value we encounter
                if (audioStartFn && typeof audioTimingInfo.start !== 'undefined') {
                    audioStartFn(audioTimingInfo.start);
                    audioStartFn = null;
                } // we want to continually update the end time
                if (audioEndFn && typeof audioTimingInfo.end !== 'undefined') audioEndFn(audioTimingInfo.end);
            },
            onVideoTimingInfo: (videoTimingInfo)=>{
                // we only want the first start value we encounter
                if (videoStartFn && typeof videoTimingInfo.start !== 'undefined') {
                    videoStartFn(videoTimingInfo.start);
                    videoStartFn = null;
                } // we want to continually update the end time
                if (videoEndFn && typeof videoTimingInfo.end !== 'undefined') videoEndFn(videoTimingInfo.end);
            },
            onVideoSegmentTimingInfo: (videoSegmentTimingInfo)=>{
                const timingInfo = {
                    pts: {
                        start: videoSegmentTimingInfo.start.presentation,
                        end: videoSegmentTimingInfo.end.presentation
                    },
                    dts: {
                        start: videoSegmentTimingInfo.start.decode,
                        end: videoSegmentTimingInfo.end.decode
                    }
                };
                triggerSegmentEventFn({
                    type: 'segmenttransmuxingtiminginfoavailable',
                    segment: segment,
                    timingInfo: timingInfo
                });
                videoSegmentTimingInfoFn(videoSegmentTimingInfo);
            },
            onAudioSegmentTimingInfo: (audioSegmentTimingInfo)=>{
                const timingInfo = {
                    pts: {
                        start: audioSegmentTimingInfo.start.pts,
                        end: audioSegmentTimingInfo.end.pts
                    },
                    dts: {
                        start: audioSegmentTimingInfo.start.dts,
                        end: audioSegmentTimingInfo.end.dts
                    }
                };
                triggerSegmentEventFn({
                    type: 'segmenttransmuxingtiminginfoavailable',
                    segment: segment,
                    timingInfo: timingInfo
                });
                audioSegmentTimingInfoFn(audioSegmentTimingInfo);
            },
            onId3: (id3Frames, dispatchType)=>{
                id3Fn(segment, id3Frames, dispatchType);
            },
            onCaptions: (captions)=>{
                captionsFn(segment, [
                    captions
                ]);
            },
            isEndOfTimeline: isEndOfTimeline,
            onEndedTimeline: ()=>{
                endedTimelineFn();
            },
            onTransmuxerLog: onTransmuxerLog,
            onDone: (result, error)=>{
                if (!doneFn) return;
                result.type = result.type === 'combined' ? 'video' : result.type;
                triggerSegmentEventFn({
                    type: 'segmenttransmuxingcomplete',
                    segment: segment
                });
                doneFn(error, segment, result);
            },
            segment: segment,
            triggerSegmentEventFn: triggerSegmentEventFn
        }); // In the transmuxer, we don't yet have the ability to extract a "proper" start time.
    // Meaning cached frame data may corrupt our notion of where this segment
    // really starts. To get around this, probe for the info needed.
    $86defbb4e95ebb07$var$workerCallback({
        action: 'probeTs',
        transmuxer: segment.transmuxer,
        data: bytes,
        baseStartTime: segment.baseStartTime,
        callback: (data)=>{
            segment.bytes = bytes = data.data;
            const probeResult = data.result;
            if (probeResult) {
                trackInfoFn(segment, {
                    hasAudio: probeResult.hasAudio,
                    hasVideo: probeResult.hasVideo,
                    isMuxed: isMuxed
                });
                trackInfoFn = null;
            }
            finish();
        }
    });
};
const $86defbb4e95ebb07$var$handleSegmentBytes = ({ segment: segment, bytes: bytes, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog, triggerSegmentEventFn: triggerSegmentEventFn })=>{
    let bytesAsUint8Array = new Uint8Array(bytes); // TODO:
    // We should have a handler that fetches the number of bytes required
    // to check if something is fmp4. This will allow us to save bandwidth
    // because we can only exclude a playlist and abort requests
    // by codec after trackinfo triggers.
    if ((0, $7483119daf318a41$export$7d0b693bd7ec7827)(bytesAsUint8Array)) {
        segment.isFmp4 = true;
        const { tracks: tracks } = segment.map;
        const isMp4TextSegment = tracks.text && (!tracks.audio || !tracks.video);
        if (isMp4TextSegment) {
            dataFn(segment, {
                data: bytesAsUint8Array,
                type: 'text'
            });
            $86defbb4e95ebb07$var$parseMp4TextSegment(segment, tracks.text.codec, doneFn);
            return;
        }
        const trackInfo = {
            isFmp4: true,
            hasVideo: !!tracks.video,
            hasAudio: !!tracks.audio
        }; // if we have a audio track, with a codec that is not set to
        // encrypted audio
        if (tracks.audio && tracks.audio.codec && tracks.audio.codec !== 'enca') trackInfo.audioCodec = tracks.audio.codec;
         // if we have a video track, with a codec that is not set to
        // encrypted video
        if (tracks.video && tracks.video.codec && tracks.video.codec !== 'encv') trackInfo.videoCodec = tracks.video.codec;
        if (tracks.video && tracks.audio) trackInfo.isMuxed = true;
         // since we don't support appending fmp4 data on progress, we know we have the full
        // segment here
        trackInfoFn(segment, trackInfo); // The probe doesn't provide the segment end time, so only callback with the start
        // time. The end time can be roughly calculated by the receiver using the duration.
        //
        // Note that the start time returned by the probe reflects the baseMediaDecodeTime, as
        // that is the true start of the segment (where the playback engine should begin
        // decoding).
        const finishLoading = (captions, id3Frames)=>{
            // if the track still has audio at this point it is only possible
            // for it to be audio only. See `tracks.video && tracks.audio` if statement
            // above.
            // we make sure to use segment.bytes here as that
            dataFn(segment, {
                data: bytesAsUint8Array,
                type: trackInfo.hasAudio && !trackInfo.isMuxed ? 'audio' : 'video'
            });
            if (id3Frames && id3Frames.length) id3Fn(segment, id3Frames);
            if (captions && captions.length) captionsFn(segment, captions);
            doneFn(null, segment, {});
        };
        $86defbb4e95ebb07$var$workerCallback({
            action: 'probeMp4StartTime',
            timescales: segment.map.timescales,
            data: bytesAsUint8Array,
            transmuxer: segment.transmuxer,
            callback: ({ data: data, startTime: startTime })=>{
                // transfer bytes back to us
                bytes = data.buffer;
                segment.bytes = bytesAsUint8Array = data;
                if (trackInfo.hasAudio && !trackInfo.isMuxed) timingInfoFn(segment, 'audio', 'start', startTime);
                if (trackInfo.hasVideo) timingInfoFn(segment, 'video', 'start', startTime);
                $86defbb4e95ebb07$var$workerCallback({
                    action: 'probeEmsgID3',
                    data: bytesAsUint8Array,
                    transmuxer: segment.transmuxer,
                    offset: startTime,
                    callback: ({ emsgData: emsgData, id3Frames: id3Frames })=>{
                        // transfer bytes back to us
                        bytes = emsgData.buffer;
                        segment.bytes = bytesAsUint8Array = emsgData; // Run through the CaptionParser in case there are captions.
                        // Initialize CaptionParser if it hasn't been yet
                        if (!tracks.video || !emsgData.byteLength || !segment.transmuxer) {
                            finishLoading(undefined, id3Frames);
                            return;
                        }
                        $86defbb4e95ebb07$var$workerCallback({
                            action: 'pushMp4Captions',
                            endAction: 'mp4Captions',
                            transmuxer: segment.transmuxer,
                            data: bytesAsUint8Array,
                            timescales: segment.map.timescales,
                            trackIds: [
                                tracks.video.id
                            ],
                            callback: (message)=>{
                                // transfer bytes back to us
                                bytes = message.data.buffer;
                                segment.bytes = bytesAsUint8Array = message.data;
                                message.logs.forEach(function(log) {
                                    onTransmuxerLog($86defbb4e95ebb07$var$merge(log, {
                                        stream: 'mp4CaptionParser'
                                    }));
                                });
                                finishLoading(message.captions, id3Frames);
                            }
                        });
                    }
                });
            }
        });
        return;
    } // VTT or other segments that don't need processing
    if (!segment.transmuxer) {
        doneFn(null, segment, {});
        return;
    }
    if (typeof segment.container === 'undefined') segment.container = (0, $7483119daf318a41$export$894319e75ed840c3)(bytesAsUint8Array);
    if (segment.container !== 'ts' && segment.container !== 'aac') {
        trackInfoFn(segment, {
            hasAudio: false,
            hasVideo: false
        });
        doneFn(null, segment, {});
        return;
    } // ts or aac
    $86defbb4e95ebb07$var$transmuxAndNotify({
        segment: segment,
        bytes: bytes,
        trackInfoFn: trackInfoFn,
        timingInfoFn: timingInfoFn,
        videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
        audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
        id3Fn: id3Fn,
        captionsFn: captionsFn,
        isEndOfTimeline: isEndOfTimeline,
        endedTimelineFn: endedTimelineFn,
        dataFn: dataFn,
        doneFn: doneFn,
        onTransmuxerLog: onTransmuxerLog,
        triggerSegmentEventFn: triggerSegmentEventFn
    });
};
const $86defbb4e95ebb07$var$decrypt = function({ id: id, key: key, encryptedBytes: encryptedBytes, decryptionWorker: decryptionWorker, segment: segment, doneFn: doneFn }, callback) {
    const decryptionHandler = (event)=>{
        if (event.data.source === id) {
            decryptionWorker.removeEventListener('message', decryptionHandler);
            const decrypted = event.data.decrypted;
            callback(new Uint8Array(decrypted.bytes, decrypted.byteOffset, decrypted.byteLength));
        }
    };
    decryptionWorker.onerror = ()=>{
        const message = 'An error occurred in the decryption worker';
        const segmentInfo = $86defbb4e95ebb07$var$segmentInfoPayload({
            segment: segment
        });
        const decryptError = {
            message: message,
            metadata: {
                error: new Error(message),
                errorType: $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.StreamingFailedToDecryptSegment,
                segmentInfo: segmentInfo,
                keyInfo: {
                    uri: segment.key.resolvedUri || segment.map.key.resolvedUri
                }
            }
        };
        doneFn(decryptError, segment);
    };
    decryptionWorker.addEventListener('message', decryptionHandler);
    let keyBytes;
    if (key.bytes.slice) keyBytes = key.bytes.slice();
    else keyBytes = new Uint32Array(Array.prototype.slice.call(key.bytes));
     // incrementally decrypt the bytes
    decryptionWorker.postMessage($86defbb4e95ebb07$var$createTransferableMessage({
        source: id,
        encrypted: encryptedBytes,
        key: keyBytes,
        iv: key.iv
    }), [
        encryptedBytes.buffer,
        keyBytes.buffer
    ]);
};
/**
 * Decrypt the segment via the decryption web worker
 *
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
 *                                       routines
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Function} doneFn - a callback that is executed after decryption has completed
 */ const $86defbb4e95ebb07$var$decryptSegment = ({ decryptionWorker: decryptionWorker, segment: segment, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog, triggerSegmentEventFn: triggerSegmentEventFn })=>{
    triggerSegmentEventFn({
        type: 'segmentdecryptionstart'
    });
    $86defbb4e95ebb07$var$decrypt({
        id: segment.requestId,
        key: segment.key,
        encryptedBytes: segment.encryptedBytes,
        decryptionWorker: decryptionWorker,
        segment: segment,
        doneFn: doneFn
    }, (decryptedBytes)=>{
        segment.bytes = decryptedBytes;
        triggerSegmentEventFn({
            type: 'segmentdecryptioncomplete',
            segment: segment
        });
        $86defbb4e95ebb07$var$handleSegmentBytes({
            segment: segment,
            bytes: segment.bytes,
            trackInfoFn: trackInfoFn,
            timingInfoFn: timingInfoFn,
            videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
            audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
            id3Fn: id3Fn,
            captionsFn: captionsFn,
            isEndOfTimeline: isEndOfTimeline,
            endedTimelineFn: endedTimelineFn,
            dataFn: dataFn,
            doneFn: doneFn,
            onTransmuxerLog: onTransmuxerLog,
            triggerSegmentEventFn: triggerSegmentEventFn
        });
    });
};
/**
 * This function waits for all XHRs to finish (with either success or failure)
 * before continueing processing via it's callback. The function gathers errors
 * from each request into a single errors array so that the error status for
 * each request can be examined later.
 *
 * @param {Object} activeXhrs - an object that tracks all XHR requests
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
 *                                       routines
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} id3Fn - a callback that receives ID3 metadata
 * @param {Function} captionsFn - a callback that receives captions
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Function} doneFn - a callback that is executed after all resources have been
 *                            downloaded and any decryption completed
 */ const $86defbb4e95ebb07$var$waitForCompletion = ({ activeXhrs: activeXhrs, decryptionWorker: decryptionWorker, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog, triggerSegmentEventFn: triggerSegmentEventFn })=>{
    let count = 0;
    let didError = false;
    return (error, segment)=>{
        if (didError) return;
        if (error) {
            didError = true; // If there are errors, we have to abort any outstanding requests
            $86defbb4e95ebb07$var$abortAll(activeXhrs); // Even though the requests above are aborted, and in theory we could wait until we
            // handle the aborted events from those requests, there are some cases where we may
            // never get an aborted event. For instance, if the network connection is lost and
            // there were two requests, the first may have triggered an error immediately, while
            // the second request remains unsent. In that case, the aborted algorithm will not
            // trigger an abort: see https://xhr.spec.whatwg.org/#the-abort()-method
            //
            // We also can't rely on the ready state of the XHR, since the request that
            // triggered the connection error may also show as a ready state of 0 (unsent).
            // Therefore, we have to finish this group of requests immediately after the first
            // seen error.
            return doneFn(error, segment);
        }
        count += 1;
        if (count === activeXhrs.length) {
            const segmentFinish = function() {
                if (segment.encryptedBytes) return $86defbb4e95ebb07$var$decryptSegment({
                    decryptionWorker: decryptionWorker,
                    segment: segment,
                    trackInfoFn: trackInfoFn,
                    timingInfoFn: timingInfoFn,
                    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
                    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
                    id3Fn: id3Fn,
                    captionsFn: captionsFn,
                    isEndOfTimeline: isEndOfTimeline,
                    endedTimelineFn: endedTimelineFn,
                    dataFn: dataFn,
                    doneFn: doneFn,
                    onTransmuxerLog: onTransmuxerLog,
                    triggerSegmentEventFn: triggerSegmentEventFn
                });
                 // Otherwise, everything is ready just continue
                $86defbb4e95ebb07$var$handleSegmentBytes({
                    segment: segment,
                    bytes: segment.bytes,
                    trackInfoFn: trackInfoFn,
                    timingInfoFn: timingInfoFn,
                    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
                    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
                    id3Fn: id3Fn,
                    captionsFn: captionsFn,
                    isEndOfTimeline: isEndOfTimeline,
                    endedTimelineFn: endedTimelineFn,
                    dataFn: dataFn,
                    doneFn: doneFn,
                    onTransmuxerLog: onTransmuxerLog,
                    triggerSegmentEventFn: triggerSegmentEventFn
                });
            }; // Keep track of when *all* of the requests have completed
            segment.endOfAllRequests = Date.now();
            if (segment.map && segment.map.encryptedBytes && !segment.map.bytes) {
                triggerSegmentEventFn({
                    type: 'segmentdecryptionstart',
                    segment: segment
                });
                return $86defbb4e95ebb07$var$decrypt({
                    decryptionWorker: decryptionWorker,
                    // add -init to the "id" to differentiate between segment
                    // and init segment decryption, just in case they happen
                    // at the same time at some point in the future.
                    id: segment.requestId + '-init',
                    encryptedBytes: segment.map.encryptedBytes,
                    key: segment.map.key,
                    segment: segment,
                    doneFn: doneFn
                }, (decryptedBytes)=>{
                    segment.map.bytes = decryptedBytes;
                    triggerSegmentEventFn({
                        type: 'segmentdecryptioncomplete',
                        segment: segment
                    });
                    $86defbb4e95ebb07$var$parseInitSegment(segment, (parseError)=>{
                        if (parseError) {
                            $86defbb4e95ebb07$var$abortAll(activeXhrs);
                            return doneFn(parseError, segment);
                        }
                        segmentFinish();
                    });
                });
            }
            segmentFinish();
        }
    };
};
/**
 * Calls the abort callback if any request within the batch was aborted. Will only call
 * the callback once per batch of requests, even if multiple were aborted.
 *
 * @param {Object} loadendState - state to check to see if the abort function was called
 * @param {Function} abortFn - callback to call for abort
 */ const $86defbb4e95ebb07$var$handleLoadEnd = ({ loadendState: loadendState, abortFn: abortFn })=>(event)=>{
        const request = event.target;
        if (request.aborted && abortFn && !loadendState.calledAbortFn) {
            abortFn();
            loadendState.calledAbortFn = true;
        }
    };
/**
 * Simple progress event callback handler that gathers some stats before
 * executing a provided callback with the `segment` object
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} progressFn - a callback that is executed each time a progress event
 *                                is received
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Event} event - the progress event object from XMLHttpRequest
 */ const $86defbb4e95ebb07$var$handleProgress = ({ segment: segment, progressFn: progressFn, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn })=>(event)=>{
        const request = event.target;
        if (request.aborted) return;
        segment.stats = $86defbb4e95ebb07$var$merge(segment.stats, $86defbb4e95ebb07$var$getProgressStats(event)); // record the time that we receive the first byte of data
        if (!segment.stats.firstBytesReceivedAt && segment.stats.bytesReceived) segment.stats.firstBytesReceivedAt = Date.now();
        return progressFn(event, segment);
    };
/**
 * Load all resources and does any processing necessary for a media-segment
 *
 * Features:
 *   decrypts the media-segment if it has a key uri and an iv
 *   aborts *all* requests if *any* one request fails
 *
 * The segment object, at minimum, has the following format:
 * {
 *   resolvedUri: String,
 *   [transmuxer]: Object,
 *   [byterange]: {
 *     offset: Number,
 *     length: Number
 *   },
 *   [key]: {
 *     resolvedUri: String
 *     [byterange]: {
 *       offset: Number,
 *       length: Number
 *     },
 *     iv: {
 *       bytes: Uint32Array
 *     }
 *   },
 *   [map]: {
 *     resolvedUri: String,
 *     [byterange]: {
 *       offset: Number,
 *       length: Number
 *     },
 *     [bytes]: Uint8Array
 *   }
 * }
 * ...where [name] denotes optional properties
 *
 * @param {Function} xhr - an instance of the xhr wrapper in xhr.js
 * @param {Object} xhrOptions - the base options to provide to all xhr requests
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128
 *                                       decryption routines
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} abortFn - a callback called (only once) if any piece of a request was
 *                             aborted
 * @param {Function} progressFn - a callback that receives progress events from the main
 *                                segment's xhr request
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} id3Fn - a callback that receives ID3 metadata
 * @param {Function} captionsFn - a callback that receives captions
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that receives data from the main segment's xhr
 *                            request, transmuxed if needed
 * @param {Function} doneFn - a callback that is executed only once all requests have
 *                            succeeded or failed
 * @return {Function} a function that, when invoked, immediately aborts all
 *                     outstanding requests
 */ const $86defbb4e95ebb07$var$mediaSegmentRequest = ({ xhr: xhr, xhrOptions: xhrOptions, decryptionWorker: decryptionWorker, segment: segment, abortFn: abortFn, progressFn: progressFn, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog, triggerSegmentEventFn: triggerSegmentEventFn })=>{
    const activeXhrs = [];
    const finishProcessingFn = $86defbb4e95ebb07$var$waitForCompletion({
        activeXhrs: activeXhrs,
        decryptionWorker: decryptionWorker,
        trackInfoFn: trackInfoFn,
        timingInfoFn: timingInfoFn,
        videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
        audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
        id3Fn: id3Fn,
        captionsFn: captionsFn,
        isEndOfTimeline: isEndOfTimeline,
        endedTimelineFn: endedTimelineFn,
        dataFn: dataFn,
        doneFn: doneFn,
        onTransmuxerLog: onTransmuxerLog,
        triggerSegmentEventFn: triggerSegmentEventFn
    }); // optionally, request the decryption key
    if (segment.key && !segment.key.bytes) {
        const objects = [
            segment.key
        ];
        if (segment.map && !segment.map.bytes && segment.map.key && segment.map.key.resolvedUri === segment.key.resolvedUri) objects.push(segment.map.key);
        const keyRequestOptions = $86defbb4e95ebb07$var$merge(xhrOptions, {
            uri: segment.key.resolvedUri,
            responseType: 'arraybuffer',
            requestType: 'segment-key'
        });
        const keyRequestCallback = $86defbb4e95ebb07$var$handleKeyResponse(segment, objects, finishProcessingFn, triggerSegmentEventFn);
        const keyInfo = {
            uri: segment.key.resolvedUri
        };
        triggerSegmentEventFn({
            type: 'segmentkeyloadstart',
            segment: segment,
            keyInfo: keyInfo
        });
        const keyXhr = xhr(keyRequestOptions, keyRequestCallback);
        activeXhrs.push(keyXhr);
    } // optionally, request the associated media init segment
    if (segment.map && !segment.map.bytes) {
        const differentMapKey = segment.map.key && (!segment.key || segment.key.resolvedUri !== segment.map.key.resolvedUri);
        if (differentMapKey) {
            const mapKeyRequestOptions = $86defbb4e95ebb07$var$merge(xhrOptions, {
                uri: segment.map.key.resolvedUri,
                responseType: 'arraybuffer',
                requestType: 'segment-key'
            });
            const mapKeyRequestCallback = $86defbb4e95ebb07$var$handleKeyResponse(segment, [
                segment.map.key
            ], finishProcessingFn, triggerSegmentEventFn);
            const keyInfo = {
                uri: segment.map.key.resolvedUri
            };
            triggerSegmentEventFn({
                type: 'segmentkeyloadstart',
                segment: segment,
                keyInfo: keyInfo
            });
            const mapKeyXhr = xhr(mapKeyRequestOptions, mapKeyRequestCallback);
            activeXhrs.push(mapKeyXhr);
        }
        const initSegmentOptions = $86defbb4e95ebb07$var$merge(xhrOptions, {
            uri: segment.map.resolvedUri,
            responseType: 'arraybuffer',
            headers: $86defbb4e95ebb07$var$segmentXhrHeaders(segment.map),
            requestType: 'segment-media-initialization'
        });
        const initSegmentRequestCallback = $86defbb4e95ebb07$var$handleInitSegmentResponse({
            segment: segment,
            finishProcessingFn: finishProcessingFn,
            triggerSegmentEventFn: triggerSegmentEventFn
        });
        triggerSegmentEventFn({
            type: 'segmentloadstart',
            segment: segment
        });
        const initSegmentXhr = xhr(initSegmentOptions, initSegmentRequestCallback);
        activeXhrs.push(initSegmentXhr);
    }
    const segmentRequestOptions = $86defbb4e95ebb07$var$merge(xhrOptions, {
        uri: segment.part && segment.part.resolvedUri || segment.resolvedUri,
        responseType: 'arraybuffer',
        headers: $86defbb4e95ebb07$var$segmentXhrHeaders(segment),
        requestType: 'segment'
    });
    const segmentRequestCallback = $86defbb4e95ebb07$var$handleSegmentResponse({
        segment: segment,
        finishProcessingFn: finishProcessingFn,
        responseType: segmentRequestOptions.responseType,
        triggerSegmentEventFn: triggerSegmentEventFn
    });
    triggerSegmentEventFn({
        type: 'segmentloadstart',
        segment: segment
    });
    const segmentXhr = xhr(segmentRequestOptions, segmentRequestCallback);
    segmentXhr.addEventListener('progress', $86defbb4e95ebb07$var$handleProgress({
        segment: segment,
        progressFn: progressFn,
        trackInfoFn: trackInfoFn,
        timingInfoFn: timingInfoFn,
        videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
        audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
        id3Fn: id3Fn,
        captionsFn: captionsFn,
        isEndOfTimeline: isEndOfTimeline,
        endedTimelineFn: endedTimelineFn,
        dataFn: dataFn
    }));
    activeXhrs.push(segmentXhr); // since all parts of the request must be considered, but should not make callbacks
    // multiple times, provide a shared state object
    const loadendState = {};
    activeXhrs.forEach((activeXhr)=>{
        activeXhr.addEventListener('loadend', $86defbb4e95ebb07$var$handleLoadEnd({
            loadendState: loadendState,
            abortFn: abortFn
        }));
    });
    return ()=>$86defbb4e95ebb07$var$abortAll(activeXhrs);
};
const $86defbb4e95ebb07$var$logFn = $86defbb4e95ebb07$var$logger('PlaylistSelector');
const $86defbb4e95ebb07$var$representationToString = function(representation) {
    if (!representation || !representation.playlist) return;
    const playlist = representation.playlist;
    return JSON.stringify({
        id: playlist.id,
        bandwidth: representation.bandwidth,
        width: representation.width,
        height: representation.height,
        codecs: playlist.attributes && playlist.attributes.CODECS || ''
    });
}; // Utilities
/**
 * Returns the CSS value for the specified property on an element
 * using `getComputedStyle`. Firefox has a long-standing issue where
 * getComputedStyle() may return null when running in an iframe with
 * `display: none`.
 *
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 * @param {HTMLElement} el the htmlelement to work on
 * @param {string} the proprety to get the style for
 */ const $86defbb4e95ebb07$var$safeGetComputedStyle = function(el, property) {
    if (!el) return '';
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).getComputedStyle(el);
    if (!result) return '';
    return result[property];
};
/**
 * Resuable stable sort function
 *
 * @param {Playlists} array
 * @param {Function} sortFn Different comparators
 * @function stableSort
 */ const $86defbb4e95ebb07$var$stableSort = function(array, sortFn) {
    const newArray = array.slice();
    array.sort(function(left, right) {
        const cmp = sortFn(left, right);
        if (cmp === 0) return newArray.indexOf(left) - newArray.indexOf(right);
        return cmp;
    });
};
/**
 * A comparator function to sort two playlist object by bandwidth.
 *
 * @param {Object} left a media playlist object
 * @param {Object} right a media playlist object
 * @return {number} Greater than zero if the bandwidth attribute of
 * left is greater than the corresponding attribute of right. Less
 * than zero if the bandwidth of right is greater than left and
 * exactly zero if the two are equal.
 */ const $86defbb4e95ebb07$var$comparePlaylistBandwidth = function(left, right) {
    let leftBandwidth;
    let rightBandwidth;
    if (left.attributes.BANDWIDTH) leftBandwidth = left.attributes.BANDWIDTH;
    leftBandwidth = leftBandwidth || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Number.MAX_VALUE;
    if (right.attributes.BANDWIDTH) rightBandwidth = right.attributes.BANDWIDTH;
    rightBandwidth = rightBandwidth || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Number.MAX_VALUE;
    return leftBandwidth - rightBandwidth;
};
/**
 * A comparator function to sort two playlist object by resolution (width).
 *
 * @param {Object} left a media playlist object
 * @param {Object} right a media playlist object
 * @return {number} Greater than zero if the resolution.width attribute of
 * left is greater than the corresponding attribute of right. Less
 * than zero if the resolution.width of right is greater than left and
 * exactly zero if the two are equal.
 */ const $86defbb4e95ebb07$var$comparePlaylistResolution = function(left, right) {
    let leftWidth;
    let rightWidth;
    if (left.attributes.RESOLUTION && left.attributes.RESOLUTION.width) leftWidth = left.attributes.RESOLUTION.width;
    leftWidth = leftWidth || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Number.MAX_VALUE;
    if (right.attributes.RESOLUTION && right.attributes.RESOLUTION.width) rightWidth = right.attributes.RESOLUTION.width;
    rightWidth = rightWidth || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Number.MAX_VALUE; // NOTE - Fallback to bandwidth sort as appropriate in cases where multiple renditions
    // have the same media dimensions/ resolution
    if (leftWidth === rightWidth && left.attributes.BANDWIDTH && right.attributes.BANDWIDTH) return left.attributes.BANDWIDTH - right.attributes.BANDWIDTH;
    return leftWidth - rightWidth;
};
/**
 * Chooses the appropriate media playlist based on bandwidth and player size
 *
 * @param {Object} settings
 *        Object of information required to use this selector
 * @param {Object} settings.main
 *        Object representation of the main manifest
 * @param {number} settings.bandwidth
 *        Current calculated bandwidth of the player
 * @param {number} settings.playerWidth
 *        Current width of the player element (should account for the device pixel ratio)
 * @param {number} settings.playerHeight
 *        Current height of the player element (should account for the device pixel ratio)
 * @param {number} settings.playerObjectFit
 *        Current value of the video element's object-fit CSS property. Allows taking into
 *        account that the video might be scaled up to cover the media element when selecting
 *        media playlists based on player size.
 * @param {boolean} settings.limitRenditionByPlayerDimensions
 *        True if the player width and height should be used during the selection, false otherwise
 * @param {Object} settings.playlistController
 *        the current playlistController object
 * @return {Playlist} the highest bitrate playlist less than the
 * currently detected bandwidth, accounting for some amount of
 * bandwidth variance
 */ let $86defbb4e95ebb07$var$simpleSelector = function(settings) {
    const { main: main, bandwidth: playerBandwidth, playerWidth: playerWidth, playerHeight: playerHeight, playerObjectFit: playerObjectFit, limitRenditionByPlayerDimensions: limitRenditionByPlayerDimensions, playlistController: playlistController } = settings; // If we end up getting called before `main` is available, exit early
    if (!main) return;
    const options = {
        bandwidth: playerBandwidth,
        width: playerWidth,
        height: playerHeight,
        limitRenditionByPlayerDimensions: limitRenditionByPlayerDimensions
    };
    let playlists = main.playlists; // if playlist is audio only, select between currently active audio group playlists.
    if ($86defbb4e95ebb07$var$Playlist.isAudioOnly(main)) {
        playlists = playlistController.getAudioTrackPlaylists_(); // add audioOnly to options so that we log audioOnly: true
        // at the buttom of this function for debugging.
        options.audioOnly = true;
    } // convert the playlists to an intermediary representation to make comparisons easier
    let sortedPlaylistReps = playlists.map((playlist)=>{
        let bandwidth;
        const width = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.width;
        const height = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height;
        bandwidth = playlist.attributes && playlist.attributes.BANDWIDTH;
        bandwidth = bandwidth || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).Number.MAX_VALUE;
        return {
            bandwidth: bandwidth,
            width: width,
            height: height,
            playlist: playlist
        };
    });
    $86defbb4e95ebb07$var$stableSort(sortedPlaylistReps, (left, right)=>left.bandwidth - right.bandwidth); // filter out any playlists that have been excluded due to
    // incompatible configurations
    sortedPlaylistReps = sortedPlaylistReps.filter((rep)=>!$86defbb4e95ebb07$var$Playlist.isIncompatible(rep.playlist)); // filter out any playlists that have been disabled manually through the representations
    // api or excluded temporarily due to playback errors.
    let enabledPlaylistReps = sortedPlaylistReps.filter((rep)=>$86defbb4e95ebb07$var$Playlist.isEnabled(rep.playlist));
    if (!enabledPlaylistReps.length) // if there are no enabled playlists, then they have all been excluded or disabled
    // by the user through the representations api. In this case, ignore exclusion and
    // fallback to what the user wants by using playlists the user has not disabled.
    enabledPlaylistReps = sortedPlaylistReps.filter((rep)=>!$86defbb4e95ebb07$var$Playlist.isDisabled(rep.playlist));
     // filter out any variant that has greater effective bitrate
    // than the current estimated bandwidth
    const bandwidthPlaylistReps = enabledPlaylistReps.filter((rep)=>rep.bandwidth * $86defbb4e95ebb07$var$Config.BANDWIDTH_VARIANCE < playerBandwidth);
    let highestRemainingBandwidthRep = bandwidthPlaylistReps[bandwidthPlaylistReps.length - 1]; // get all of the renditions with the same (highest) bandwidth
    // and then taking the very first element
    const bandwidthBestRep = bandwidthPlaylistReps.filter((rep)=>rep.bandwidth === highestRemainingBandwidthRep.bandwidth)[0]; // if we're not going to limit renditions by player size, make an early decision.
    if (limitRenditionByPlayerDimensions === false) {
        const chosenRep = bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
        if (chosenRep && chosenRep.playlist) {
            let type = 'sortedPlaylistReps';
            if (bandwidthBestRep) type = 'bandwidthBestRep';
            if (enabledPlaylistReps[0]) type = 'enabledPlaylistReps';
            $86defbb4e95ebb07$var$logFn(`choosing ${$86defbb4e95ebb07$var$representationToString(chosenRep)} using ${type} with options`, options);
            return chosenRep.playlist;
        }
        $86defbb4e95ebb07$var$logFn('could not choose a playlist with options', options);
        return null;
    } // filter out playlists without resolution information
    const haveResolution = bandwidthPlaylistReps.filter((rep)=>rep.width && rep.height); // sort variants by resolution
    $86defbb4e95ebb07$var$stableSort(haveResolution, (left, right)=>left.width - right.width); // if we have the exact resolution as the player use it
    const resolutionBestRepList = haveResolution.filter((rep)=>rep.width === playerWidth && rep.height === playerHeight);
    highestRemainingBandwidthRep = resolutionBestRepList[resolutionBestRepList.length - 1]; // ensure that we pick the highest bandwidth variant that have exact resolution
    const resolutionBestRep = resolutionBestRepList.filter((rep)=>rep.bandwidth === highestRemainingBandwidthRep.bandwidth)[0];
    let resolutionPlusOneList;
    let resolutionPlusOneSmallest;
    let resolutionPlusOneRep; // find the smallest variant that is larger than the player
    // if there is no match of exact resolution
    if (!resolutionBestRep) {
        resolutionPlusOneList = haveResolution.filter((rep)=>{
            if (playerObjectFit === 'cover') // video will be scaled up to cover the player. We need to
            // make sure rendition is at least as wide and as high as the
            // player.
            return rep.width > playerWidth && rep.height > playerHeight;
             // video will be scaled down to fit inside the player soon as
            // its resolution exceeds player size in at least one dimension.
            return rep.width > playerWidth || rep.height > playerHeight;
        }); // find all the variants have the same smallest resolution
        resolutionPlusOneSmallest = resolutionPlusOneList.filter((rep)=>rep.width === resolutionPlusOneList[0].width && rep.height === resolutionPlusOneList[0].height); // ensure that we also pick the highest bandwidth variant that
        // is just-larger-than the video player
        highestRemainingBandwidthRep = resolutionPlusOneSmallest[resolutionPlusOneSmallest.length - 1];
        resolutionPlusOneRep = resolutionPlusOneSmallest.filter((rep)=>rep.bandwidth === highestRemainingBandwidthRep.bandwidth)[0];
    }
    let leastPixelDiffRep; // If this selector proves to be better than others,
    // resolutionPlusOneRep and resolutionBestRep and all
    // the code involving them should be removed.
    if (playlistController.leastPixelDiffSelector) {
        // find the variant that is closest to the player's pixel size
        const leastPixelDiffList = haveResolution.map((rep)=>{
            rep.pixelDiff = Math.abs(rep.width - playerWidth) + Math.abs(rep.height - playerHeight);
            return rep;
        }); // get the highest bandwidth, closest resolution playlist
        $86defbb4e95ebb07$var$stableSort(leastPixelDiffList, (left, right)=>{
            // sort by highest bandwidth if pixelDiff is the same
            if (left.pixelDiff === right.pixelDiff) return right.bandwidth - left.bandwidth;
            return left.pixelDiff - right.pixelDiff;
        });
        leastPixelDiffRep = leastPixelDiffList[0];
    } // fallback chain of variants
    const chosenRep = leastPixelDiffRep || resolutionPlusOneRep || resolutionBestRep || bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
    if (chosenRep && chosenRep.playlist) {
        let type = 'sortedPlaylistReps';
        if (leastPixelDiffRep) type = 'leastPixelDiffRep';
        else if (resolutionPlusOneRep) type = 'resolutionPlusOneRep';
        else if (resolutionBestRep) type = 'resolutionBestRep';
        else if (bandwidthBestRep) type = 'bandwidthBestRep';
        else if (enabledPlaylistReps[0]) type = 'enabledPlaylistReps';
        $86defbb4e95ebb07$var$logFn(`choosing ${$86defbb4e95ebb07$var$representationToString(chosenRep)} using ${type} with options`, options);
        return chosenRep.playlist;
    }
    $86defbb4e95ebb07$var$logFn('could not choose a playlist with options', options);
    return null;
};
/**
 * Chooses the appropriate media playlist based on the most recent
 * bandwidth estimate and the player size.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @return {Playlist} the highest bitrate playlist less than the
 * currently detected bandwidth, accounting for some amount of
 * bandwidth variance
 */ const $86defbb4e95ebb07$var$lastBandwidthSelector = function() {
    let pixelRatio = this.useDevicePixelRatio ? (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).devicePixelRatio || 1 : 1;
    if (!isNaN(this.customPixelRatio)) pixelRatio = this.customPixelRatio;
    return $86defbb4e95ebb07$var$simpleSelector({
        main: this.playlists.main,
        bandwidth: this.systemBandwidth,
        playerWidth: parseInt($86defbb4e95ebb07$var$safeGetComputedStyle(this.tech_.el(), 'width'), 10) * pixelRatio,
        playerHeight: parseInt($86defbb4e95ebb07$var$safeGetComputedStyle(this.tech_.el(), 'height'), 10) * pixelRatio,
        playerObjectFit: this.usePlayerObjectFit ? $86defbb4e95ebb07$var$safeGetComputedStyle(this.tech_.el(), 'objectFit') : '',
        limitRenditionByPlayerDimensions: this.limitRenditionByPlayerDimensions,
        playlistController: this.playlistController_
    });
};
/**
 * Chooses the appropriate media playlist based on an
 * exponential-weighted moving average of the bandwidth after
 * filtering for player size.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @param {number} decay - a number between 0 and 1. Higher values of
 * this parameter will cause previous bandwidth estimates to lose
 * significance more quickly.
 * @return {Function} a function which can be invoked to create a new
 * playlist selector function.
 * @see https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 */ const $86defbb4e95ebb07$var$movingAverageBandwidthSelector = function(decay) {
    let average = -1;
    let lastSystemBandwidth = -1;
    if (decay < 0 || decay > 1) throw new Error('Moving average bandwidth decay must be between 0 and 1.');
    return function() {
        let pixelRatio = this.useDevicePixelRatio ? (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).devicePixelRatio || 1 : 1;
        if (!isNaN(this.customPixelRatio)) pixelRatio = this.customPixelRatio;
        if (average < 0) {
            average = this.systemBandwidth;
            lastSystemBandwidth = this.systemBandwidth;
        } // stop the average value from decaying for every 250ms
        // when the systemBandwidth is constant
        // and
        // stop average from setting to a very low value when the
        // systemBandwidth becomes 0 in case of chunk cancellation
        if (this.systemBandwidth > 0 && this.systemBandwidth !== lastSystemBandwidth) {
            average = decay * this.systemBandwidth + (1 - decay) * average;
            lastSystemBandwidth = this.systemBandwidth;
        }
        return $86defbb4e95ebb07$var$simpleSelector({
            main: this.playlists.main,
            bandwidth: average,
            playerWidth: parseInt($86defbb4e95ebb07$var$safeGetComputedStyle(this.tech_.el(), 'width'), 10) * pixelRatio,
            playerHeight: parseInt($86defbb4e95ebb07$var$safeGetComputedStyle(this.tech_.el(), 'height'), 10) * pixelRatio,
            playerObjectFit: this.usePlayerObjectFit ? $86defbb4e95ebb07$var$safeGetComputedStyle(this.tech_.el(), 'objectFit') : '',
            limitRenditionByPlayerDimensions: this.limitRenditionByPlayerDimensions,
            playlistController: this.playlistController_
        });
    };
};
/**
 * Chooses the appropriate media playlist based on the potential to rebuffer
 *
 * @param {Object} settings
 *        Object of information required to use this selector
 * @param {Object} settings.main
 *        Object representation of the main manifest
 * @param {number} settings.currentTime
 *        The current time of the player
 * @param {number} settings.bandwidth
 *        Current measured bandwidth
 * @param {number} settings.duration
 *        Duration of the media
 * @param {number} settings.segmentDuration
 *        Segment duration to be used in round trip time calculations
 * @param {number} settings.timeUntilRebuffer
 *        Time left in seconds until the player has to rebuffer
 * @param {number} settings.currentTimeline
 *        The current timeline segments are being loaded from
 * @param {SyncController} settings.syncController
 *        SyncController for determining if we have a sync point for a given playlist
 * @return {Object|null}
 *         {Object} return.playlist
 *         The highest bandwidth playlist with the least amount of rebuffering
 *         {Number} return.rebufferingImpact
 *         The amount of time in seconds switching to this playlist will rebuffer. A
 *         negative value means that switching will cause zero rebuffering.
 */ const $86defbb4e95ebb07$var$minRebufferMaxBandwidthSelector = function(settings) {
    const { main: main, currentTime: currentTime, bandwidth: bandwidth, duration: duration, segmentDuration: segmentDuration, timeUntilRebuffer: timeUntilRebuffer, currentTimeline: currentTimeline, syncController: syncController } = settings; // filter out any playlists that have been excluded due to
    // incompatible configurations
    const compatiblePlaylists = main.playlists.filter((playlist)=>!$86defbb4e95ebb07$var$Playlist.isIncompatible(playlist)); // filter out any playlists that have been disabled manually through the representations
    // api or excluded temporarily due to playback errors.
    let enabledPlaylists = compatiblePlaylists.filter($86defbb4e95ebb07$var$Playlist.isEnabled);
    if (!enabledPlaylists.length) // if there are no enabled playlists, then they have all been excluded or disabled
    // by the user through the representations api. In this case, ignore exclusion and
    // fallback to what the user wants by using playlists the user has not disabled.
    enabledPlaylists = compatiblePlaylists.filter((playlist)=>!$86defbb4e95ebb07$var$Playlist.isDisabled(playlist));
    const bandwidthPlaylists = enabledPlaylists.filter($86defbb4e95ebb07$var$Playlist.hasAttribute.bind(null, 'BANDWIDTH'));
    const rebufferingEstimates = bandwidthPlaylists.map((playlist)=>{
        const syncPoint = syncController.getSyncPoint(playlist, duration, currentTimeline, currentTime); // If there is no sync point for this playlist, switching to it will require a
        // sync request first. This will double the request time
        const numRequests = syncPoint ? 1 : 2;
        const requestTimeEstimate = $86defbb4e95ebb07$var$Playlist.estimateSegmentRequestTime(segmentDuration, bandwidth, playlist);
        const rebufferingImpact = requestTimeEstimate * numRequests - timeUntilRebuffer;
        return {
            playlist: playlist,
            rebufferingImpact: rebufferingImpact
        };
    });
    const noRebufferingPlaylists = rebufferingEstimates.filter((estimate)=>estimate.rebufferingImpact <= 0); // Sort by bandwidth DESC
    $86defbb4e95ebb07$var$stableSort(noRebufferingPlaylists, (a, b)=>$86defbb4e95ebb07$var$comparePlaylistBandwidth(b.playlist, a.playlist));
    if (noRebufferingPlaylists.length) return noRebufferingPlaylists[0];
    $86defbb4e95ebb07$var$stableSort(rebufferingEstimates, (a, b)=>a.rebufferingImpact - b.rebufferingImpact);
    return rebufferingEstimates[0] || null;
};
/**
 * Chooses the appropriate media playlist, which in this case is the lowest bitrate
 * one with video.  If no renditions with video exist, return the lowest audio rendition.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @return {Object|null}
 *         {Object} return.playlist
 *         The lowest bitrate playlist that contains a video codec.  If no such rendition
 *         exists pick the lowest audio rendition.
 */ const $86defbb4e95ebb07$var$lowestBitrateCompatibleVariantSelector = function() {
    // filter out any playlists that have been excluded due to
    // incompatible configurations or playback errors
    const playlists = this.playlists.main.playlists.filter($86defbb4e95ebb07$var$Playlist.isEnabled); // Sort ascending by bitrate
    $86defbb4e95ebb07$var$stableSort(playlists, (a, b)=>$86defbb4e95ebb07$var$comparePlaylistBandwidth(a, b)); // Parse and assume that playlists with no video codec have no video
    // (this is not necessarily true, although it is generally true).
    //
    // If an entire manifest has no valid videos everything will get filtered
    // out.
    const playlistsWithVideo = playlists.filter((playlist)=>!!$86defbb4e95ebb07$var$codecsForPlaylist(this.playlists.main, playlist).video);
    return playlistsWithVideo[0] || null;
};
/**
 * Combine all segments into a single Uint8Array
 *
 * @param {Object} segmentObj
 * @return {Uint8Array} concatenated bytes
 * @private
 */ const $86defbb4e95ebb07$var$concatSegments = (segmentObj)=>{
    let offset = 0;
    let tempBuffer;
    if (segmentObj.bytes) {
        tempBuffer = new Uint8Array(segmentObj.bytes); // combine the individual segments into one large typed-array
        segmentObj.segments.forEach((segment)=>{
            tempBuffer.set(segment, offset);
            offset += segment.byteLength;
        });
    }
    return tempBuffer;
};
/**
 * Example:
 * https://host.com/path1/path2/path3/segment.ts?arg1=val1
 * -->
 * path3/segment.ts
 *
 * @param resolvedUri
 * @return {string}
 */ function $86defbb4e95ebb07$var$compactSegmentUrlDescription(resolvedUri) {
    try {
        return new URL(resolvedUri).pathname.split('/').slice(-2).join('/');
    } catch (e) {
        return '';
    }
}
/**
 * @file text-tracks.js
 */ /**
 * Create captions text tracks on video.js if they do not exist
 *
 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
 * @param {Object} tech the video.js tech
 * @param {Object} captionStream the caption stream to create
 * @private
 */ const $86defbb4e95ebb07$var$createCaptionsTrackIfNotExists = function(inbandTextTracks, tech, captionStream) {
    if (!inbandTextTracks[captionStream]) {
        tech.trigger({
            type: 'usage',
            name: 'vhs-608'
        });
        let instreamId = captionStream; // we need to translate SERVICEn for 708 to how mux.js currently labels them
        if (/^cc708_/.test(captionStream)) instreamId = 'SERVICE' + captionStream.split('_')[1];
        const track = tech.textTracks().getTrackById(instreamId);
        if (track) // Resuse an existing track with a CC# id because this was
        // very likely created by videojs-contrib-hls from information
        // in the m3u8 for us to use
        inbandTextTracks[captionStream] = track;
        else {
            // This section gets called when we have caption services that aren't specified in the manifest.
            // Manifest level caption services are handled in media-groups.js under CLOSED-CAPTIONS.
            const captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
            let label = captionStream;
            let language = captionStream;
            let def = false;
            const captionService = captionServices[instreamId];
            if (captionService) {
                label = captionService.label;
                language = captionService.language;
                def = captionService.default;
            } // Otherwise, create a track with the default `CC#` label and
            // without a language
            inbandTextTracks[captionStream] = tech.addRemoteTextTrack({
                kind: 'captions',
                id: instreamId,
                // TODO: investigate why this doesn't seem to turn the caption on by default
                default: def,
                label: label,
                language: language
            }, false).track;
        }
    }
};
/**
 * Add caption text track data to a source handler given an array of captions
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {number} timestampOffset the timestamp offset of the source buffer
 *   @param {Array} captionArray an array of caption data
 * @private
 */ const $86defbb4e95ebb07$var$addCaptionData = function({ inbandTextTracks: inbandTextTracks, captionArray: captionArray, timestampOffset: timestampOffset }) {
    if (!captionArray) return;
    const Cue = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebKitDataCue || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).VTTCue;
    captionArray.forEach((caption)=>{
        const track = caption.stream; // in CEA 608 captions, video.js/mux.js sends a content array
        // with positioning data
        if (caption.content) caption.content.forEach((value)=>{
            const cue = new Cue(caption.startTime + timestampOffset, caption.endTime + timestampOffset, value.text);
            cue.line = value.line;
            cue.align = 'left';
            cue.position = value.position;
            cue.positionAlign = 'line-left';
            inbandTextTracks[track].addCue(cue);
        });
        else // otherwise, a text value with combined captions is sent
        inbandTextTracks[track].addCue(new Cue(caption.startTime + timestampOffset, caption.endTime + timestampOffset, caption.text));
    });
};
/**
 * Define properties on a cue for backwards compatability,
 * but warn the user that the way that they are using it
 * is depricated and will be removed at a later date.
 *
 * @param {Cue} cue the cue to add the properties on
 * @private
 */ const $86defbb4e95ebb07$var$deprecateOldCue = function(cue) {
    Object.defineProperties(cue.frame, {
        id: {
            get () {
                $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn('cue.frame.id is deprecated. Use cue.value.key instead.');
                return cue.value.key;
            }
        },
        value: {
            get () {
                $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn('cue.frame.value is deprecated. Use cue.value.data instead.');
                return cue.value.data;
            }
        },
        privateData: {
            get () {
                $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn('cue.frame.privateData is deprecated. Use cue.value.data instead.');
                return cue.value.data;
            }
        }
    });
};
/**
 * Add metadata text track data to a source handler given an array of metadata
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {Array} metadataArray an array of meta data
 *   @param {number} timestampOffset the timestamp offset of the source buffer
 *   @param {number} videoDuration the duration of the video
 * @private
 */ const $86defbb4e95ebb07$var$addMetadata = ({ inbandTextTracks: inbandTextTracks, metadataArray: metadataArray, timestampOffset: timestampOffset, videoDuration: videoDuration })=>{
    if (!metadataArray) return;
    const Cue = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebKitDataCue || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).VTTCue;
    const metadataTrack = inbandTextTracks.metadataTrack_;
    if (!metadataTrack) return;
    metadataArray.forEach((metadata)=>{
        const time = metadata.cueTime + timestampOffset; // if time isn't a finite number between 0 and Infinity, like NaN,
        // ignore this bit of metadata.
        // This likely occurs when you have an non-timed ID3 tag like TIT2,
        // which is the "Title/Songname/Content description" frame
        if (typeof time !== 'number' || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).isNaN(time) || time < 0 || !(time < Infinity)) return;
         // If we have no frames, we can't create a cue.
        if (!metadata.frames || !metadata.frames.length) return;
        metadata.frames.forEach((frame)=>{
            const cue = new Cue(time, time, frame.value || frame.url || frame.data || '');
            cue.frame = frame;
            cue.value = frame;
            $86defbb4e95ebb07$var$deprecateOldCue(cue);
            metadataTrack.addCue(cue);
        });
    });
    if (!metadataTrack.cues || !metadataTrack.cues.length) return;
     // Updating the metadeta cues so that
    // the endTime of each cue is the startTime of the next cue
    // the endTime of last cue is the duration of the video
    const cues = metadataTrack.cues;
    const cuesArray = []; // Create a copy of the TextTrackCueList...
    // ...disregarding cues with a falsey value
    for(let i = 0; i < cues.length; i++)if (cues[i]) cuesArray.push(cues[i]);
     // Group cues by their startTime value
    const cuesGroupedByStartTime = cuesArray.reduce((obj, cue)=>{
        const timeSlot = obj[cue.startTime] || [];
        timeSlot.push(cue);
        obj[cue.startTime] = timeSlot;
        return obj;
    }, {}); // Sort startTimes by ascending order
    const sortedStartTimes = Object.keys(cuesGroupedByStartTime).sort((a, b)=>Number(a) - Number(b)); // Map each cue group's endTime to the next group's startTime
    sortedStartTimes.forEach((startTime, idx)=>{
        const cueGroup = cuesGroupedByStartTime[startTime];
        const finiteDuration = isFinite(videoDuration) ? videoDuration : startTime;
        const nextTime = Number(sortedStartTimes[idx + 1]) || finiteDuration; // Map each cue's endTime the next group's startTime
        cueGroup.forEach((cue)=>{
            cue.endTime = nextTime;
        });
    });
}; // object for mapping daterange attributes
const $86defbb4e95ebb07$var$dateRangeAttr = {
    id: 'ID',
    class: 'CLASS',
    startDate: 'START-DATE',
    duration: 'DURATION',
    endDate: 'END-DATE',
    endOnNext: 'END-ON-NEXT',
    plannedDuration: 'PLANNED-DURATION',
    scte35Out: 'SCTE35-OUT',
    scte35In: 'SCTE35-IN'
};
const $86defbb4e95ebb07$var$dateRangeKeysToOmit = new Set([
    'id',
    'class',
    'startDate',
    'duration',
    'endDate',
    'endOnNext',
    'startTime',
    'endTime',
    'processDateRange'
]);
/**
 * Add DateRange metadata text track to a source handler given an array of metadata
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {Array} dateRanges parsed media playlist
 * @private
 */ const $86defbb4e95ebb07$var$addDateRangeMetadata = ({ inbandTextTracks: inbandTextTracks, dateRanges: dateRanges })=>{
    const metadataTrack = inbandTextTracks.metadataTrack_;
    if (!metadataTrack) return;
    const Cue = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebKitDataCue || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).VTTCue;
    dateRanges.forEach((dateRange)=>{
        // we generate multiple cues for each date range with different attributes
        for (const key of Object.keys(dateRange)){
            if ($86defbb4e95ebb07$var$dateRangeKeysToOmit.has(key)) continue;
            const cue = new Cue(dateRange.startTime, dateRange.endTime, '');
            cue.id = dateRange.id;
            cue.type = 'com.apple.quicktime.HLS';
            cue.value = {
                key: $86defbb4e95ebb07$var$dateRangeAttr[key],
                data: dateRange[key]
            };
            if (key === 'scte35Out' || key === 'scte35In') cue.value.data = new Uint8Array(cue.value.data.match(/[\da-f]{2}/gi)).buffer;
            metadataTrack.addCue(cue);
        }
        dateRange.processDateRange();
    });
};
/**
 * Create metadata text track on video.js if it does not exist
 *
 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
 * @param {string} dispatchType the inband metadata track dispatch type
 * @param {Object} tech the video.js tech
 * @private
 */ const $86defbb4e95ebb07$var$createMetadataTrackIfNotExists = (inbandTextTracks, dispatchType, tech)=>{
    if (inbandTextTracks.metadataTrack_) return;
    inbandTextTracks.metadataTrack_ = tech.addRemoteTextTrack({
        kind: 'metadata',
        label: 'Timed Metadata'
    }, false).track;
    if (!$86defbb4e95ebb07$export$2e2bcd8739ae039.browser.IS_ANY_SAFARI) inbandTextTracks.metadataTrack_.inBandMetadataTrackDispatchType = dispatchType;
};
/**
 * Remove cues from a track on video.js.
 *
 * @param {Double} start start of where we should remove the cue
 * @param {Double} end end of where the we should remove the cue
 * @param {Object} track the text track to remove the cues from
 * @private
 */ const $86defbb4e95ebb07$var$removeCuesFromTrack = function(start, end, track) {
    let i;
    let cue;
    if (!track) return;
    if (!track.cues) return;
    i = track.cues.length;
    while(i--){
        cue = track.cues[i]; // Remove any cue within the provided start and end time
        if (cue.startTime >= start && cue.endTime <= end) track.removeCue(cue);
    }
};
/**
 * Remove duplicate cues from a track on video.js (a cue is considered a
 * duplicate if it has the same time interval and text as another)
 *
 * @param {Object} track the text track to remove the duplicate cues from
 * @private
 */ const $86defbb4e95ebb07$var$removeDuplicateCuesFromTrack = function(track) {
    const cues = track.cues;
    if (!cues) return;
    const uniqueCues = {};
    for(let i = cues.length - 1; i >= 0; i--){
        const cue = cues[i];
        const cueKey = `${cue.startTime}-${cue.endTime}-${cue.text}`;
        if (uniqueCues[cueKey]) track.removeCue(cue);
        else uniqueCues[cueKey] = cue;
    }
};
/**
 * Returns a list of gops in the buffer that have a pts value of 3 seconds or more in
 * front of current time.
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {number} currentTime
 *        The current time
 * @param {Double} mapping
 *        Offset to map display time to stream presentation time
 * @return {Array}
 *         List of gops considered safe to append over
 */ const $86defbb4e95ebb07$var$gopsSafeToAlignWith = (buffer, currentTime, mapping)=>{
    if (typeof currentTime === 'undefined' || currentTime === null || !buffer.length) return [];
     // pts value for current time + 3 seconds to give a bit more wiggle room
    const currentTimePts = Math.ceil((currentTime - mapping + 3) * (0, $22231c6dfc449553$exports.ONE_SECOND_IN_TS));
    let i;
    for(i = 0; i < buffer.length; i++){
        if (buffer[i].pts > currentTimePts) break;
    }
    return buffer.slice(i);
};
/**
 * Appends gop information (timing and byteLength) received by the transmuxer for the
 * gops appended in the last call to appendBuffer
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {Array} gops
 *        List of new gop information
 * @param {boolean} replace
 *        If true, replace the buffer with the new gop information. If false, append the
 *        new gop information to the buffer in the right location of time.
 * @return {Array}
 *         Updated list of gop information
 */ const $86defbb4e95ebb07$var$updateGopBuffer = (buffer, gops, replace)=>{
    if (!gops.length) return buffer;
    if (replace) // If we are in safe append mode, then completely overwrite the gop buffer
    // with the most recent appeneded data. This will make sure that when appending
    // future segments, we only try to align with gops that are both ahead of current
    // time and in the last segment appended.
    return gops.slice();
    const start = gops[0].pts;
    let i = 0;
    for(i; i < buffer.length; i++){
        if (buffer[i].pts >= start) break;
    }
    return buffer.slice(0, i).concat(gops);
};
/**
 * Removes gop information in buffer that overlaps with provided start and end
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {Double} start
 *        position to start the remove at
 * @param {Double} end
 *        position to end the remove at
 * @param {Double} mapping
 *        Offset to map display time to stream presentation time
 */ const $86defbb4e95ebb07$var$removeGopBuffer = (buffer, start, end, mapping)=>{
    const startPts = Math.ceil((start - mapping) * (0, $22231c6dfc449553$exports.ONE_SECOND_IN_TS));
    const endPts = Math.ceil((end - mapping) * (0, $22231c6dfc449553$exports.ONE_SECOND_IN_TS));
    const updatedBuffer = buffer.slice();
    let i = buffer.length;
    while(i--){
        if (buffer[i].pts <= endPts) break;
    }
    if (i === -1) // no removal because end of remove range is before start of buffer
    return updatedBuffer;
    let j = i + 1;
    while(j--){
        if (buffer[j].pts <= startPts) break;
    } // clamp remove range start to 0 index
    j = Math.max(j, 0);
    updatedBuffer.splice(j, i - j + 1);
    return updatedBuffer;
};
const $86defbb4e95ebb07$var$shallowEqual = function(a, b) {
    // if both are undefined
    // or one or the other is undefined
    // they are not equal
    if (!a && !b || !a && b || a && !b) return false;
     // they are the same object and thus, equal
    if (a === b) return true;
     // sort keys so we can make sure they have
    // all the same keys later.
    const akeys = Object.keys(a).sort();
    const bkeys = Object.keys(b).sort(); // different number of keys, not equal
    if (akeys.length !== bkeys.length) return false;
    for(let i = 0; i < akeys.length; i++){
        const key = akeys[i]; // different sorted keys, not equal
        if (key !== bkeys[i]) return false;
         // different values, not equal
        if (a[key] !== b[key]) return false;
    }
    return true;
};
/**
 * The segment loader has no recourse except to fetch a segment in the
 * current playlist and use the internal timestamps in that segment to
 * generate a syncPoint. This function returns a good candidate index
 * for that process.
 *
 * @param {Array} segments - the segments array from a playlist.
 * @return {number} An index of a segment from the playlist to load
 */ const $86defbb4e95ebb07$var$getSyncSegmentCandidate = function(currentTimeline, segments, targetTime) {
    segments = segments || [];
    const timelineSegments = [];
    let time = 0;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        if (currentTimeline === segment.timeline) {
            timelineSegments.push(i);
            time += segment.duration;
            if (time > targetTime) return i;
        }
    }
    if (timelineSegments.length === 0) return 0;
     // default to the last timeline segment
    return timelineSegments[timelineSegments.length - 1];
}; // In the event of a quota exceeded error, keep at least one second of back buffer. This
// number was arbitrarily chosen and may be updated in the future, but seemed reasonable
// as a start to prevent any potential issues with removing content too close to the
// playhead.
const $86defbb4e95ebb07$var$MIN_BACK_BUFFER = 1; // in ms
const $86defbb4e95ebb07$var$CHECK_BUFFER_DELAY = 500;
const $86defbb4e95ebb07$var$finite = (num)=>typeof num === 'number' && isFinite(num); // With most content hovering around 30fps, if a segment has a duration less than a half
// frame at 30fps or one frame at 60fps, the bandwidth and throughput calculations will
// not accurately reflect the rest of the content.
const $86defbb4e95ebb07$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS = 1 / 60;
const $86defbb4e95ebb07$var$illegalMediaSwitch = (loaderType, startingMedia, trackInfo)=>{
    // Although these checks should most likely cover non 'main' types, for now it narrows
    // the scope of our checks.
    if (loaderType !== 'main' || !startingMedia || !trackInfo) return null;
    if (!trackInfo.hasAudio && !trackInfo.hasVideo) return 'Neither audio nor video found in segment.';
    if (startingMedia.hasVideo && !trackInfo.hasVideo) return "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest.";
    if (!startingMedia.hasVideo && trackInfo.hasVideo) return "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest.";
    return null;
};
/**
 * Calculates a time value that is safe to remove from the back buffer without interrupting
 * playback.
 *
 * @param {TimeRange} seekable
 *        The current seekable range
 * @param {number} currentTime
 *        The current time of the player
 * @param {number} targetDuration
 *        The target duration of the current playlist
 * @return {number}
 *         Time that is safe to remove from the back buffer without interrupting playback
 */ const $86defbb4e95ebb07$var$safeBackBufferTrimTime = (seekable, currentTime, targetDuration)=>{
    // 30 seconds before the playhead provides a safe default for trimming.
    //
    // Choosing a reasonable default is particularly important for high bitrate content and
    // VOD videos/live streams with large windows, as the buffer may end up overfilled and
    // throw an APPEND_BUFFER_ERR.
    let trimTime = currentTime - $86defbb4e95ebb07$var$Config.BACK_BUFFER_LENGTH;
    if (seekable.length) // Some live playlists may have a shorter window of content than the full allowed back
    // buffer. For these playlists, don't save content that's no longer within the window.
    trimTime = Math.max(trimTime, seekable.start(0));
     // Don't remove within target duration of the current time to avoid the possibility of
    // removing the GOP currently being played, as removing it can cause playback stalls.
    const maxTrimTime = currentTime - targetDuration;
    return Math.min(maxTrimTime, trimTime);
};
const $86defbb4e95ebb07$var$segmentInfoString = (segmentInfo)=>{
    const { startOfSegment: startOfSegment, duration: duration, segment: segment, part: part, playlist: { mediaSequence: seq, id: id, segments: segments = [] }, mediaIndex: index, partIndex: partIndex, timeline: timeline } = segmentInfo;
    const segmentLen = segments.length - 1;
    let selection = 'mediaIndex/partIndex increment';
    if (segmentInfo.getMediaInfoForTime) selection = `getMediaInfoForTime (${segmentInfo.getMediaInfoForTime})`;
    else if (segmentInfo.isSyncRequest) selection = 'getSyncSegmentCandidate (isSyncRequest)';
    if (segmentInfo.independent) selection += ` with independent ${segmentInfo.independent}`;
    const hasPartIndex = typeof partIndex === 'number';
    const name = segmentInfo.segment.uri ? 'segment' : 'pre-segment';
    const zeroBasedPartCount = hasPartIndex ? $86defbb4e95ebb07$var$getKnownPartCount({
        preloadSegment: segment
    }) - 1 : 0;
    return `${name} [${seq + index}/${seq + segmentLen}]` + (hasPartIndex ? ` part [${partIndex}/${zeroBasedPartCount}]` : '') + ` segment start/end [${segment.start} => ${segment.end}]` + (hasPartIndex ? ` part start/end [${part.start} => ${part.end}]` : '') + ` startOfSegment [${startOfSegment}]` + ` duration [${duration}]` + ` timeline [${timeline}]` + ` selected by [${selection}]` + ` playlist [${id}]`;
};
const $86defbb4e95ebb07$var$timingInfoPropertyForMedia = (mediaType)=>`${mediaType}TimingInfo`;
/**
 * Returns the timestamp offset to use for the segment.
 *
 * @param {number} segmentTimeline
 *        The timeline of the segment
 * @param {number} currentTimeline
 *        The timeline currently being followed by the loader
 * @param {number} startOfSegment
 *        The estimated segment start
 * @param {TimeRange[]} buffered
 *        The loader's buffer
 * @param {boolean} overrideCheck
 *        If true, no checks are made to see if the timestamp offset value should be set,
 *        but sets it directly to a value.
 *
 * @return {number|null}
 *         Either a number representing a new timestamp offset, or null if the segment is
 *         part of the same timeline
 */ const $86defbb4e95ebb07$var$timestampOffsetForSegment = ({ segmentTimeline: segmentTimeline, currentTimeline: currentTimeline, startOfSegment: startOfSegment, buffered: buffered, overrideCheck: overrideCheck })=>{
    // Check to see if we are crossing a discontinuity to see if we need to set the
    // timestamp offset on the transmuxer and source buffer.
    //
    // Previously, we changed the timestampOffset if the start of this segment was less than
    // the currently set timestampOffset, but this isn't desirable as it can produce bad
    // behavior, especially around long running live streams.
    if (!overrideCheck && segmentTimeline === currentTimeline) return null;
     // When changing renditions, it's possible to request a segment on an older timeline. For
    // instance, given two renditions with the following:
    //
    // #EXTINF:10
    // segment1
    // #EXT-X-DISCONTINUITY
    // #EXTINF:10
    // segment2
    // #EXTINF:10
    // segment3
    //
    // And the current player state:
    //
    // current time: 8
    // buffer: 0 => 20
    //
    // The next segment on the current rendition would be segment3, filling the buffer from
    // 20s onwards. However, if a rendition switch happens after segment2 was requested,
    // then the next segment to be requested will be segment1 from the new rendition in
    // order to fill time 8 and onwards. Using the buffered end would result in repeated
    // content (since it would position segment1 of the new rendition starting at 20s). This
    // case can be identified when the new segment's timeline is a prior value. Instead of
    // using the buffered end, the startOfSegment can be used, which, hopefully, will be
    // more accurate to the actual start time of the segment.
    if (segmentTimeline < currentTimeline) return startOfSegment;
     // segmentInfo.startOfSegment used to be used as the timestamp offset, however, that
    // value uses the end of the last segment if it is available. While this value
    // should often be correct, it's better to rely on the buffered end, as the new
    // content post discontinuity should line up with the buffered end as if it were
    // time 0 for the new content.
    return buffered.length ? buffered.end(buffered.length - 1) : startOfSegment;
};
/**
 * Returns whether or not the loader should wait for a timeline change from the timeline
 * change controller before processing the segment.
 *
 * Primary timing in VHS goes by video. This is different from most media players, as
 * audio is more often used as the primary timing source. For the foreseeable future, VHS
 * will continue to use video as the primary timing source, due to the current logic and
 * expectations built around it.

 * Since the timing follows video, in order to maintain sync, the video loader is
 * responsible for setting both audio and video source buffer timestamp offsets.
 *
 * Setting different values for audio and video source buffers could lead to
 * desyncing. The following examples demonstrate some of the situations where this
 * distinction is important. Note that all of these cases involve demuxed content. When
 * content is muxed, the audio and video are packaged together, therefore syncing
 * separate media playlists is not an issue.
 *
 * CASE 1: Audio prepares to load a new timeline before video:
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:                     ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader              ^
 *
 * In the above example, the audio loader is preparing to load the 6th segment, the first
 * after a discontinuity, while the video loader is still loading the 5th segment, before
 * the discontinuity.
 *
 * If the audio loader goes ahead and loads and appends the 6th segment before the video
 * loader crosses the discontinuity, then when appended, the 6th audio segment will use
 * the timestamp offset from timeline 0. This will likely lead to desyncing. In addition,
 * the audio loader must provide the audioAppendStart value to trim the content in the
 * transmuxer, and that value relies on the audio timestamp offset. Since the audio
 * timestamp offset is set by the video (main) loader, the audio loader shouldn't load the
 * segment until that value is provided.
 *
 * CASE 2: Video prepares to load a new timeline before audio:
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:             ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader                      ^
 *
 * In the above example, the video loader is preparing to load the 6th segment, the first
 * after a discontinuity, while the audio loader is still loading the 5th segment, before
 * the discontinuity.
 *
 * If the video loader goes ahead and loads and appends the 6th segment, then once the
 * segment is loaded and processed, both the video and audio timestamp offsets will be
 * set, since video is used as the primary timing source. This is to ensure content lines
 * up appropriately, as any modifications to the video timing are reflected by audio when
 * the video loader sets the audio and video timestamp offsets to the same value. However,
 * setting the timestamp offset for audio before audio has had a chance to change
 * timelines will likely lead to desyncing, as the audio loader will append segment 5 with
 * a timestamp intended to apply to segments from timeline 1 rather than timeline 0.
 *
 * CASE 3: When seeking, audio prepares to load a new timeline before video
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:           ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader            ^
 *
 * In the above example, both audio and video loaders are loading segments from timeline
 * 0, but imagine that the seek originated from timeline 1.
 *
 * When seeking to a new timeline, the timestamp offset will be set based on the expected
 * segment start of the loaded video segment. In order to maintain sync, the audio loader
 * must wait for the video loader to load its segment and update both the audio and video
 * timestamp offsets before it may load and append its own segment. This is the case
 * whether the seek results in a mismatched segment request (e.g., the audio loader
 * chooses to load segment 3 and the video loader chooses to load segment 4) or the
 * loaders choose to load the same segment index from each playlist, as the segments may
 * not be aligned perfectly, even for matching segment indexes.
 *
 * @param {Object} timelinechangeController
 * @param {number} currentTimeline
 *        The timeline currently being followed by the loader
 * @param {number} segmentTimeline
 *        The timeline of the segment being loaded
 * @param {('main'|'audio')} loaderType
 *        The loader type
 * @param {boolean} audioDisabled
 *        Whether the audio is disabled for the loader. This should only be true when the
 *        loader may have muxed audio in its segment, but should not append it, e.g., for
 *        the main loader when an alternate audio playlist is active.
 *
 * @return {boolean}
 *         Whether the loader should wait for a timeline change from the timeline change
 *         controller before processing the segment
 */ const $86defbb4e95ebb07$var$shouldWaitForTimelineChange = ({ timelineChangeController: timelineChangeController, currentTimeline: currentTimeline, segmentTimeline: segmentTimeline, loaderType: loaderType, audioDisabled: audioDisabled })=>{
    if (currentTimeline === segmentTimeline) return false;
    if (loaderType === 'audio') {
        const lastMainTimelineChange = timelineChangeController.lastTimelineChange({
            type: 'main'
        }); // Audio loader should wait if:
        //
        // * main hasn't had a timeline change yet (thus has not loaded its first segment)
        // * main hasn't yet changed to the timeline audio is looking to load
        return !lastMainTimelineChange || lastMainTimelineChange.to !== segmentTimeline;
    } // The main loader only needs to wait for timeline changes if there's demuxed audio.
    // Otherwise, there's nothing to wait for, since audio would be muxed into the main
    // loader's segments (or the content is audio/video only and handled by the main
    // loader).
    if (loaderType === 'main' && audioDisabled) {
        const pendingAudioTimelineChange = timelineChangeController.pendingTimelineChange({
            type: 'audio'
        }); // Main loader should wait for the audio loader if audio is not pending a timeline
        // change to the current timeline.
        //
        // Since the main loader is responsible for setting the timestamp offset for both
        // audio and video, the main loader must wait for audio to be about to change to its
        // timeline before setting the offset, otherwise, if audio is behind in loading,
        // segments from the previous timeline would be adjusted by the new timestamp offset.
        //
        // This requirement means that video will not cross a timeline until the audio is
        // about to cross to it, so that way audio and video will always cross the timeline
        // together.
        //
        // In addition to normal timeline changes, these rules also apply to the start of a
        // stream (going from a non-existent timeline, -1, to timeline 0). It's important
        // that these rules apply to the first timeline change because if they did not, it's
        // possible that the main loader will cross two timelines before the audio loader has
        // crossed one. Logic may be implemented to handle the startup as a special case, but
        // it's easier to simply treat all timeline changes the same.
        if (pendingAudioTimelineChange && pendingAudioTimelineChange.to === segmentTimeline) return false;
        return true;
    }
    return false;
};
const $86defbb4e95ebb07$var$shouldFixBadTimelineChanges = (timelineChangeController)=>{
    if (!timelineChangeController) return false;
    const pendingAudioTimelineChange = timelineChangeController.pendingTimelineChange({
        type: 'audio'
    });
    const pendingMainTimelineChange = timelineChangeController.pendingTimelineChange({
        type: 'main'
    });
    const hasPendingTimelineChanges = pendingAudioTimelineChange && pendingMainTimelineChange;
    const differentPendingChanges = hasPendingTimelineChanges && pendingAudioTimelineChange.to !== pendingMainTimelineChange.to;
    const isNotInitialPendingTimelineChange = hasPendingTimelineChanges && pendingAudioTimelineChange.from !== -1 && pendingMainTimelineChange.from !== -1;
    if (isNotInitialPendingTimelineChange && differentPendingChanges) return true;
    return false;
};
/**
 * Check if the pending audio timeline change is behind the
 * pending main timeline change.
 *
 * @param {SegmentLoader} segmentLoader
 * @return {boolean}
 */ const $86defbb4e95ebb07$var$isAudioTimelineBehind = (segmentLoader)=>{
    const pendingAudioTimelineChange = segmentLoader.timelineChangeController_.pendingTimelineChange({
        type: 'audio'
    });
    const pendingMainTimelineChange = segmentLoader.timelineChangeController_.pendingTimelineChange({
        type: 'main'
    });
    const hasPendingTimelineChanges = pendingAudioTimelineChange && pendingMainTimelineChange;
    return hasPendingTimelineChanges && pendingAudioTimelineChange.to < pendingMainTimelineChange.to;
};
/**
 * A method to check if the player is waiting for a timeline change, and fixes
 * certain scenarios where the timelines need to be updated.
 *
 * @param {SegmentLoader} segmentLoader
 */ const $86defbb4e95ebb07$var$checkAndFixTimelines = (segmentLoader)=>{
    const segmentInfo = segmentLoader.pendingSegment_;
    if (!segmentInfo) return;
    const waitingForTimelineChange = $86defbb4e95ebb07$var$shouldWaitForTimelineChange({
        timelineChangeController: segmentLoader.timelineChangeController_,
        currentTimeline: segmentLoader.currentTimeline_,
        segmentTimeline: segmentInfo.timeline,
        loaderType: segmentLoader.loaderType_,
        audioDisabled: segmentLoader.audioDisabled_
    });
    if (waitingForTimelineChange && $86defbb4e95ebb07$var$shouldFixBadTimelineChanges(segmentLoader.timelineChangeController_)) {
        if ($86defbb4e95ebb07$var$isAudioTimelineBehind(segmentLoader)) {
            segmentLoader.timelineChangeController_.trigger('audioTimelineBehind');
            return;
        }
        segmentLoader.timelineChangeController_.trigger('fixBadTimelineChange');
    }
};
const $86defbb4e95ebb07$var$mediaDuration = (timingInfos)=>{
    let maxDuration = 0;
    [
        'video',
        'audio'
    ].forEach(function(type) {
        const typeTimingInfo = timingInfos[`${type}TimingInfo`];
        if (!typeTimingInfo) return;
        const { start: start, end: end } = typeTimingInfo;
        let duration;
        if (typeof start === 'bigint' || typeof end === 'bigint') duration = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(end) - (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).BigInt(start);
        else if (typeof start === 'number' && typeof end === 'number') duration = end - start;
        if (typeof duration !== 'undefined' && duration > maxDuration) maxDuration = duration;
    }); // convert back to a number if it is lower than MAX_SAFE_INTEGER
    // as we only need BigInt when we are above that.
    if (typeof maxDuration === 'bigint' && maxDuration < Number.MAX_SAFE_INTEGER) maxDuration = Number(maxDuration);
    return maxDuration;
};
const $86defbb4e95ebb07$var$segmentTooLong = ({ segmentDuration: segmentDuration, maxDuration: maxDuration })=>{
    // 0 duration segments are most likely due to metadata only segments or a lack of
    // information.
    if (!segmentDuration) return false;
     // For HLS:
    //
    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1
    // The EXTINF duration of each Media Segment in the Playlist
    // file, when rounded to the nearest integer, MUST be less than or equal
    // to the target duration; longer segments can trigger playback stalls
    // or other errors.
    //
    // For DASH, the mpd-parser uses the largest reported segment duration as the target
    // duration. Although that reported duration is occasionally approximate (i.e., not
    // exact), a strict check may report that a segment is too long more often in DASH.
    return Math.round(segmentDuration) > maxDuration + $86defbb4e95ebb07$var$TIME_FUDGE_FACTOR;
};
const $86defbb4e95ebb07$var$getTroublesomeSegmentDurationMessage = (segmentInfo, sourceType)=>{
    // Right now we aren't following DASH's timing model exactly, so only perform
    // this check for HLS content.
    if (sourceType !== 'hls') return null;
    const segmentDuration = $86defbb4e95ebb07$var$mediaDuration({
        audioTimingInfo: segmentInfo.audioTimingInfo,
        videoTimingInfo: segmentInfo.videoTimingInfo
    }); // Don't report if we lack information.
    //
    // If the segment has a duration of 0 it is either a lack of information or a
    // metadata only segment and shouldn't be reported here.
    if (!segmentDuration) return null;
    const targetDuration = segmentInfo.playlist.targetDuration;
    const isSegmentWayTooLong = $86defbb4e95ebb07$var$segmentTooLong({
        segmentDuration: segmentDuration,
        maxDuration: targetDuration * 2
    });
    const isSegmentSlightlyTooLong = $86defbb4e95ebb07$var$segmentTooLong({
        segmentDuration: segmentDuration,
        maxDuration: targetDuration
    });
    const segmentTooLongMessage = `Segment with index ${segmentInfo.mediaIndex} ` + `from playlist ${segmentInfo.playlist.id} ` + `has a duration of ${segmentDuration} ` + `when the reported duration is ${segmentInfo.duration} ` + `and the target duration is ${targetDuration}. ` + 'For HLS content, a duration in excess of the target duration may result in ' + 'playback issues. See the HLS specification section on EXT-X-TARGETDURATION for ' + 'more details: ' + 'https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1';
    if (isSegmentWayTooLong || isSegmentSlightlyTooLong) return {
        severity: isSegmentWayTooLong ? 'warn' : 'info',
        message: segmentTooLongMessage
    };
    return null;
};
/**
 *
 * @param {Object} options type of segment loader and segment either segmentInfo or simple segment
 * @return a segmentInfo payload for events or errors.
 */ const $86defbb4e95ebb07$var$segmentInfoPayload = ({ type: type, segment: segment })=>{
    if (!segment) return;
    const isEncrypted = Boolean(segment.key || segment.map && segment.map.ke);
    const isMediaInitialization = Boolean(segment.map && !segment.map.bytes);
    const start = segment.startOfSegment === undefined ? segment.start : segment.startOfSegment;
    return {
        type: type || segment.type,
        uri: segment.resolvedUri || segment.uri,
        start: start,
        duration: segment.duration,
        isEncrypted: isEncrypted,
        isMediaInitialization: isMediaInitialization
    };
};
/**
 * An object that manages segment loading and appending.
 *
 * @class SegmentLoader
 * @param {Object} options required and optional options
 * @extends videojs.EventTarget
 */ class $86defbb4e95ebb07$var$SegmentLoader extends $86defbb4e95ebb07$export$2e2bcd8739ae039.EventTarget {
    constructor(settings, options = {}){
        super(); // check pre-conditions
        if (!settings) throw new TypeError('Initialization settings are required');
        if (typeof settings.currentTime !== 'function') throw new TypeError('No currentTime getter specified');
        if (!settings.mediaSource) throw new TypeError('No MediaSource specified');
         // public properties
        this.bandwidth = settings.bandwidth;
        this.throughput = {
            rate: 0,
            count: 0
        };
        this.roundTrip = NaN;
        this.resetStats_();
        this.mediaIndex = null;
        this.partIndex = null; // private settings
        this.hasPlayed_ = settings.hasPlayed;
        this.currentTime_ = settings.currentTime;
        this.seekable_ = settings.seekable;
        this.seeking_ = settings.seeking;
        this.duration_ = settings.duration;
        this.mediaSource_ = settings.mediaSource;
        this.vhs_ = settings.vhs;
        this.loaderType_ = settings.loaderType;
        this.currentMediaInfo_ = void 0;
        this.startingMediaInfo_ = void 0;
        this.segmentMetadataTrack_ = settings.segmentMetadataTrack;
        this.goalBufferLength_ = settings.goalBufferLength;
        this.sourceType_ = settings.sourceType;
        this.sourceUpdater_ = settings.sourceUpdater;
        this.inbandTextTracks_ = settings.inbandTextTracks;
        this.state_ = 'INIT';
        this.timelineChangeController_ = settings.timelineChangeController;
        this.shouldSaveSegmentTimingInfo_ = true;
        this.parse708captions_ = settings.parse708captions;
        this.useDtsForTimestampOffset_ = settings.useDtsForTimestampOffset;
        this.captionServices_ = settings.captionServices;
        this.exactManifestTimings = settings.exactManifestTimings;
        this.addMetadataToTextTrack = settings.addMetadataToTextTrack; // private instance variables
        this.checkBufferTimeout_ = null;
        this.error_ = void 0;
        this.currentTimeline_ = -1;
        this.shouldForceTimestampOffsetAfterResync_ = false;
        this.pendingSegment_ = null;
        this.xhrOptions_ = null;
        this.pendingSegments_ = [];
        this.audioDisabled_ = false;
        this.isPendingTimestampOffset_ = false; // TODO possibly move gopBuffer and timeMapping info to a separate controller
        this.gopBuffer_ = [];
        this.timeMapping_ = 0;
        this.safeAppend_ = false;
        this.appendInitSegment_ = {
            audio: true,
            video: true
        };
        this.playlistOfLastInitSegment_ = {
            audio: null,
            video: null
        };
        this.callQueue_ = []; // If the segment loader prepares to load a segment, but does not have enough
        // information yet to start the loading process (e.g., if the audio loader wants to
        // load a segment from the next timeline but the main loader hasn't yet crossed that
        // timeline), then the load call will be added to the queue until it is ready to be
        // processed.
        this.loadQueue_ = [];
        this.metadataQueue_ = {
            id3: [],
            caption: []
        };
        this.waitingOnRemove_ = false;
        this.quotaExceededErrorRetryTimeout_ = null; // Fragmented mp4 playback
        this.activeInitSegmentId_ = null;
        this.initSegments_ = {}; // HLSe playback
        this.cacheEncryptionKeys_ = settings.cacheEncryptionKeys;
        this.keyCache_ = {};
        this.decrypter_ = settings.decrypter; // Manages the tracking and generation of sync-points, mappings
        // between a time in the display time and a segment index within
        // a playlist
        this.syncController_ = settings.syncController;
        this.syncPoint_ = {
            segmentIndex: 0,
            time: 0
        };
        this.transmuxer_ = this.createTransmuxer_();
        this.triggerSyncInfoUpdate_ = ()=>this.trigger('syncinfoupdate');
        this.syncController_.on('syncinfoupdate', this.triggerSyncInfoUpdate_);
        this.mediaSource_.addEventListener('sourceopen', ()=>{
            if (!this.isEndOfStream_()) this.ended_ = false;
        }); // ...for determining the fetch location
        this.fetchAtBuffer_ = false;
        this.logger_ = $86defbb4e95ebb07$var$logger(`SegmentLoader[${this.loaderType_}]`);
        Object.defineProperty(this, 'state', {
            get () {
                return this.state_;
            },
            set (newState) {
                if (newState !== this.state_) {
                    this.logger_(`${this.state_} -> ${newState}`);
                    this.state_ = newState;
                    this.trigger('statechange');
                }
            }
        });
        this.sourceUpdater_.on('ready', ()=>{
            if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
            else $86defbb4e95ebb07$var$checkAndFixTimelines(this);
        });
        this.sourceUpdater_.on('codecschange', (metadata)=>{
            this.trigger((0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({
                type: 'codecschange'
            }, metadata));
        }); // Only the main loader needs to listen for pending timeline changes, as the main
        // loader should wait for audio to be ready to change its timeline so that both main
        // and audio timelines change together. For more details, see the
        // shouldWaitForTimelineChange function.
        if (this.loaderType_ === 'main') this.timelineChangeController_.on('pendingtimelinechange', ()=>{
            if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
            else $86defbb4e95ebb07$var$checkAndFixTimelines(this);
        });
         // The main loader only listens on pending timeline changes, but the audio loader,
        // since its loads follow main, needs to listen on timeline changes. For more details,
        // see the shouldWaitForTimelineChange function.
        if (this.loaderType_ === 'audio') this.timelineChangeController_.on('timelinechange', (metadata)=>{
            this.trigger((0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({
                type: 'timelinechange'
            }, metadata));
            if (this.hasEnoughInfoToLoad_()) this.processLoadQueue_();
            else $86defbb4e95ebb07$var$checkAndFixTimelines(this);
            if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
            else $86defbb4e95ebb07$var$checkAndFixTimelines(this);
        });
    }
    /**
   * TODO: Current sync controller consists of many hls-specific strategies
   * media sequence sync is also hls-specific, and we would like to be protocol-agnostic on this level
   * this should be a part of the sync-controller and sync controller should expect different strategy list based on the protocol.
   *
   * @return {MediaSequenceSync|null}
   * @private
   */ get mediaSequenceSync_() {
        return this.syncController_.getMediaSequenceSync(this.loaderType_);
    }
    createTransmuxer_() {
        return $86defbb4e95ebb07$var$segmentTransmuxer.createTransmuxer({
            remux: false,
            alignGopsAtEnd: this.safeAppend_,
            keepOriginalTimestamps: true,
            parse708captions: this.parse708captions_,
            captionServices: this.captionServices_
        });
    }
    /**
   * reset all of our media stats
   *
   * @private
   */ resetStats_() {
        this.mediaBytesTransferred = 0;
        this.mediaRequests = 0;
        this.mediaRequestsAborted = 0;
        this.mediaRequestsTimedout = 0;
        this.mediaRequestsErrored = 0;
        this.mediaTransferDuration = 0;
        this.mediaSecondsLoaded = 0;
        this.mediaAppends = 0;
    }
    /**
   * dispose of the SegmentLoader and reset to the default state
   */ dispose() {
        this.trigger('dispose');
        this.state = 'DISPOSED';
        this.pause();
        this.abort_();
        if (this.transmuxer_) this.transmuxer_.terminate();
        this.resetStats_();
        if (this.checkBufferTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.checkBufferTimeout_);
        if (this.syncController_ && this.triggerSyncInfoUpdate_) this.syncController_.off('syncinfoupdate', this.triggerSyncInfoUpdate_);
        this.off();
    }
    setAudio(enable) {
        this.audioDisabled_ = !enable;
        if (enable) this.appendInitSegment_.audio = true;
        else // remove current track audio if it gets disabled
        this.sourceUpdater_.removeAudio(0, this.duration_());
    }
    /**
   * abort anything that is currently doing on with the SegmentLoader
   * and reset to a default state
   */ abort() {
        if (this.state !== 'WAITING') {
            if (this.pendingSegment_) this.pendingSegment_ = null;
            this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
            return;
        }
        this.abort_(); // We aborted the requests we were waiting on, so reset the loader's state to READY
        // since we are no longer "waiting" on any requests. XHR callback is not always run
        // when the request is aborted. This will prevent the loader from being stuck in the
        // WAITING state indefinitely.
        this.state = 'READY'; // don't wait for buffer check timeouts to begin fetching the
        // next segment
        if (!this.paused()) this.monitorBuffer_();
    }
    /**
   * abort all pending xhr requests and null any pending segements
   *
   * @private
   */ abort_() {
        if (this.pendingSegment_ && this.pendingSegment_.abortRequests) this.pendingSegment_.abortRequests();
         // clear out the segment being processed
        this.pendingSegment_ = null;
        this.callQueue_ = [];
        this.loadQueue_ = [];
        this.metadataQueue_.id3 = [];
        this.metadataQueue_.caption = [];
        this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
        this.waitingOnRemove_ = false;
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.quotaExceededErrorRetryTimeout_);
        this.quotaExceededErrorRetryTimeout_ = null;
    }
    checkForAbort_(requestId) {
        // If the state is APPENDING, then aborts will not modify the state, meaning the first
        // callback that happens should reset the state to READY so that loading can continue.
        if (this.state === 'APPENDING' && !this.pendingSegment_) {
            this.state = 'READY';
            return true;
        }
        if (!this.pendingSegment_ || this.pendingSegment_.requestId !== requestId) return true;
        return false;
    }
    /**
   * set an error on the segment loader and null out any pending segements
   *
   * @param {Error} error the error to set on the SegmentLoader
   * @return {Error} the error that was set or that is currently set
   */ error(error) {
        if (typeof error !== 'undefined') {
            this.logger_('error occurred:', error);
            this.error_ = error;
        }
        this.pendingSegment_ = null;
        return this.error_;
    }
    endOfStream() {
        this.ended_ = true;
        if (this.transmuxer_) // need to clear out any cached data to prepare for the new segment
        $86defbb4e95ebb07$var$segmentTransmuxer.reset(this.transmuxer_);
        this.gopBuffer_.length = 0;
        this.pause();
        this.trigger('ended');
    }
    /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */ buffered_() {
        const trackInfo = this.getMediaInfo_();
        if (!this.sourceUpdater_ || !trackInfo) return $86defbb4e95ebb07$var$createTimeRanges();
        if (this.loaderType_ === 'main') {
            const { hasAudio: hasAudio, hasVideo: hasVideo, isMuxed: isMuxed } = trackInfo;
            if (hasVideo && hasAudio && !this.audioDisabled_ && !isMuxed) return this.sourceUpdater_.buffered();
            if (hasVideo) return this.sourceUpdater_.videoBuffered();
        } // One case that can be ignored for now is audio only with alt audio,
        // as we don't yet have proper support for that.
        return this.sourceUpdater_.audioBuffered();
    }
    /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */ initSegmentForMap(map, set = false) {
        if (!map) return null;
        const id = $86defbb4e95ebb07$var$initSegmentId(map);
        let storedMap = this.initSegments_[id];
        if (set && !storedMap && map.bytes) this.initSegments_[id] = storedMap = {
            resolvedUri: map.resolvedUri,
            byterange: map.byterange,
            bytes: map.bytes,
            tracks: map.tracks,
            timescales: map.timescales
        };
        return storedMap || map;
    }
    /**
   * Gets and sets key for the provided key
   *
   * @param {Object} key
   *        The key object representing the key to get or set
   * @param {boolean=} set
   *        If true, the key for the provided key should be saved
   * @return {Object}
   *         Key object for desired key
   */ segmentKey(key, set = false) {
        if (!key) return null;
        const id = $86defbb4e95ebb07$var$segmentKeyId(key);
        let storedKey = this.keyCache_[id]; // TODO: We should use the HTTP Expires header to invalidate our cache per
        // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-6.2.3
        if (this.cacheEncryptionKeys_ && set && !storedKey && key.bytes) this.keyCache_[id] = storedKey = {
            resolvedUri: key.resolvedUri,
            bytes: key.bytes
        };
        const result = {
            resolvedUri: (storedKey || key).resolvedUri
        };
        if (storedKey) result.bytes = storedKey.bytes;
        return result;
    }
    /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */ couldBeginLoading_() {
        return this.playlist_ && !this.paused();
    }
    /**
   * load a playlist and start to fill the buffer
   */ load() {
        // un-pause
        this.monitorBuffer_(); // if we don't have a playlist yet, keep waiting for one to be
        // specified
        if (!this.playlist_) return;
         // if all the configuration is ready, initialize and begin loading
        if (this.state === 'INIT' && this.couldBeginLoading_()) return this.init_();
         // if we're in the middle of processing a segment already, don't
        // kick off an additional segment request
        if (!this.couldBeginLoading_() || this.state !== 'READY' && this.state !== 'INIT') return;
        this.state = 'READY';
    }
    /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */ init_() {
        this.state = 'READY'; // if this is the audio segment loader, and it hasn't been inited before, then any old
        // audio data from the muxed content should be removed
        this.resetEverything();
        return this.monitorBuffer_();
    }
    /**
   * set a playlist on the segment loader
   *
   * @param {PlaylistLoader} media the playlist to set on the segment loader
   */ playlist(newPlaylist, options = {}) {
        if (!newPlaylist) return;
        if (this.playlist_ && this.playlist_.endList && newPlaylist.endList && this.playlist_.uri === newPlaylist.uri) // skip update if both prev and new are vod and have the same URI
        return;
        const oldPlaylist = this.playlist_;
        const segmentInfo = this.pendingSegment_;
        this.playlist_ = newPlaylist;
        this.xhrOptions_ = options; // when we haven't started playing yet, the start of a live playlist
        // is always our zero-time so force a sync update each time the playlist
        // is refreshed from the server
        //
        // Use the INIT state to determine if playback has started, as the playlist sync info
        // should be fixed once requests begin (as sync points are generated based on sync
        // info), but not before then.
        if (this.state === 'INIT') {
            newPlaylist.syncInfo = {
                mediaSequence: newPlaylist.mediaSequence,
                time: 0
            }; // Setting the date time mapping means mapping the program date time (if available)
            // to time 0 on the player's timeline. The playlist's syncInfo serves a similar
            // purpose, mapping the initial mediaSequence to time zero. Since the syncInfo can
            // be updated as the playlist is refreshed before the loader starts loading, the
            // program date time mapping needs to be updated as well.
            //
            // This mapping is only done for the main loader because a program date time should
            // map equivalently between playlists.
            if (this.loaderType_ === 'main') this.syncController_.setDateTimeMappingForStart(newPlaylist);
        }
        let oldId = null;
        if (oldPlaylist) {
            if (oldPlaylist.id) oldId = oldPlaylist.id;
            else if (oldPlaylist.uri) oldId = oldPlaylist.uri;
        }
        this.logger_(`playlist update [${oldId} => ${newPlaylist.id || newPlaylist.uri}]`);
        if (this.mediaSequenceSync_) {
            this.mediaSequenceSync_.update(newPlaylist, this.currentTime_());
            this.logger_(`Playlist update:
currentTime: ${this.currentTime_()}
bufferedEnd: ${$86defbb4e95ebb07$var$lastBufferedEnd(this.buffered_())}
`, this.mediaSequenceSync_.diagnostics);
        } // in VOD, this is always a rendition switch (or we updated our syncInfo above)
        // in LIVE, we always want to update with new playlists (including refreshes)
        this.trigger('syncinfoupdate'); // if we were unpaused but waiting for a playlist, start
        // buffering now
        if (this.state === 'INIT' && this.couldBeginLoading_()) return this.init_();
        if (!oldPlaylist || oldPlaylist.uri !== newPlaylist.uri) {
            if (this.mediaIndex !== null) {
                // we must reset/resync the segment loader when we switch renditions and
                // the segment loader is already synced to the previous rendition
                // We only want to reset the loader here for LLHLS playback, as resetLoader sets fetchAtBuffer_
                // to false, resulting in fetching segments at currentTime and causing repeated
                // same-segment requests on playlist change. This erroneously drives up the playback watcher
                // stalled segment count, as re-requesting segments at the currentTime or browser cached segments
                // will not change the buffer.
                // Reference for LLHLS fixes: https://github.com/videojs/http-streaming/pull/1201
                const isLLHLS = !newPlaylist.endList && typeof newPlaylist.partTargetDuration === 'number';
                if (isLLHLS) this.resetLoader();
                else this.resyncLoader();
            }
            this.currentMediaInfo_ = void 0;
            this.trigger('playlistupdate'); // the rest of this function depends on `oldPlaylist` being defined
            return;
        } // we reloaded the same playlist so we are in a live scenario
        // and we will likely need to adjust the mediaIndex
        const mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence;
        this.logger_(`live window shift [${mediaSequenceDiff}]`); // update the mediaIndex on the SegmentLoader
        // this is important because we can abort a request and this value must be
        // equal to the last appended mediaIndex
        if (this.mediaIndex !== null) {
            this.mediaIndex -= mediaSequenceDiff; // this can happen if we are going to load the first segment, but get a playlist
            // update during that. mediaIndex would go from 0 to -1 if mediaSequence in the
            // new playlist was incremented by 1.
            if (this.mediaIndex < 0) {
                this.mediaIndex = null;
                this.partIndex = null;
            } else {
                const segment = this.playlist_.segments[this.mediaIndex]; // partIndex should remain the same for the same segment
                // unless parts fell off of the playlist for this segment.
                // In that case we need to reset partIndex and resync
                if (this.partIndex && (!segment.parts || !segment.parts.length || !segment.parts[this.partIndex])) {
                    const mediaIndex = this.mediaIndex;
                    this.logger_(`currently processing part (index ${this.partIndex}) no longer exists.`);
                    this.resetLoader(); // We want to throw away the partIndex and the data associated with it,
                    // as the part was dropped from our current playlists segment.
                    // The mediaIndex will still be valid so keep that around.
                    this.mediaIndex = mediaIndex;
                }
            }
        } // update the mediaIndex on the SegmentInfo object
        // this is important because we will update this.mediaIndex with this value
        // in `handleAppendsDone_` after the segment has been successfully appended
        if (segmentInfo) {
            segmentInfo.mediaIndex -= mediaSequenceDiff;
            if (segmentInfo.mediaIndex < 0) {
                segmentInfo.mediaIndex = null;
                segmentInfo.partIndex = null;
            } else {
                // we need to update the referenced segment so that timing information is
                // saved for the new playlist's segment, however, if the segment fell off the
                // playlist, we can leave the old reference and just lose the timing info
                if (segmentInfo.mediaIndex >= 0) segmentInfo.segment = newPlaylist.segments[segmentInfo.mediaIndex];
                if (segmentInfo.partIndex >= 0 && segmentInfo.segment.parts) segmentInfo.part = segmentInfo.segment.parts[segmentInfo.partIndex];
            }
        }
        this.syncController_.saveExpiredSegmentInfo(oldPlaylist, newPlaylist);
    }
    /**
   * Prevent the loader from fetching additional segments. If there
   * is a segment request outstanding, it will finish processing
   * before the loader halts. A segment loader can be unpaused by
   * calling load().
   */ pause() {
        if (this.checkBufferTimeout_) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.checkBufferTimeout_);
            this.checkBufferTimeout_ = null;
        }
    }
    /**
   * Returns whether the segment loader is fetching additional
   * segments when given the opportunity. This property can be
   * modified through calls to pause() and load().
   */ paused() {
        return this.checkBufferTimeout_ === null;
    }
    /**
   * Delete all the buffered data and reset the SegmentLoader
   *
   * @param {Function} [done] an optional callback to be executed when the remove
   * operation is complete
   */ resetEverything(done) {
        this.ended_ = false;
        this.activeInitSegmentId_ = null;
        this.appendInitSegment_ = {
            audio: true,
            video: true
        };
        this.resetLoader(); // remove from 0, the earliest point, to Infinity, to signify removal of everything.
        // VTT Segment Loader doesn't need to do anything but in the regular SegmentLoader,
        // we then clamp the value to duration if necessary.
        this.remove(0, Infinity, done); // clears fmp4 captions
        if (this.transmuxer_) {
            this.transmuxer_.postMessage({
                action: 'clearAllMp4Captions'
            }); // reset the cache in the transmuxer
            this.transmuxer_.postMessage({
                action: 'reset'
            });
        }
    }
    /**
   * Force the SegmentLoader to resync and start loading around the currentTime instead
   * of starting at the end of the buffer
   *
   * Useful for fast quality changes
   */ resetLoader() {
        this.fetchAtBuffer_ = false;
        if (this.mediaSequenceSync_) this.mediaSequenceSync_.resetAppendedStatus();
        this.resyncLoader();
    }
    /**
   * Force the SegmentLoader to restart synchronization and make a conservative guess
   * before returning to the simple walk-forward method
   */ resyncLoader() {
        if (this.transmuxer_) // need to clear out any cached data to prepare for the new segment
        $86defbb4e95ebb07$var$segmentTransmuxer.reset(this.transmuxer_);
        this.mediaIndex = null;
        this.partIndex = null;
        this.syncPoint_ = null;
        this.isPendingTimestampOffset_ = false; // this is mainly to sync timing-info when switching between renditions with and without timestamp-rollover,
        // so we don't want it for DASH or fragmented mp4 segments.
        const isFmp4 = this.currentMediaInfo_ && this.currentMediaInfo_.isFmp4;
        const isHlsTs = this.sourceType_ === 'hls' && !isFmp4;
        if (isHlsTs) this.shouldForceTimestampOffsetAfterResync_ = true;
        this.callQueue_ = [];
        this.loadQueue_ = [];
        this.metadataQueue_.id3 = [];
        this.metadataQueue_.caption = [];
        this.abort();
        if (this.transmuxer_) this.transmuxer_.postMessage({
            action: 'clearParsedMp4Captions'
        });
    }
    /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   * @param {Function} [done] - an optional callback to be executed when the remove
   * @param {boolean} force - force all remove operations to happen
   * operation is complete
   */ remove(start, end, done = ()=>{}, force = false) {
        // clamp end to duration if we need to remove everything.
        // This is due to a browser bug that causes issues if we remove to Infinity.
        // videojs/videojs-contrib-hls#1225
        if (end === Infinity) end = this.duration_();
         // skip removes that would throw an error
        // commonly happens during a rendition switch at the start of a video
        // from start 0 to end 0
        if (end <= start) {
            this.logger_('skipping remove because end ${end} is <= start ${start}');
            return;
        }
        if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
            this.logger_('skipping remove because no source updater or starting media info'); // nothing to remove if we haven't processed any media
            return;
        } // set it to one to complete this function's removes
        let removesRemaining = 1;
        const removeFinished = ()=>{
            removesRemaining--;
            if (removesRemaining === 0) done();
        };
        if (force || !this.audioDisabled_) {
            removesRemaining++;
            this.sourceUpdater_.removeAudio(start, end, removeFinished);
        } // While it would be better to only remove video if the main loader has video, this
        // should be safe with audio only as removeVideo will call back even if there's no
        // video buffer.
        //
        // In theory we can check to see if there's video before calling the remove, but in
        // the event that we're switching between renditions and from video to audio only
        // (when we add support for that), we may need to clear the video contents despite
        // what the new media will contain.
        if (force || this.loaderType_ === 'main') {
            this.gopBuffer_ = $86defbb4e95ebb07$var$removeGopBuffer(this.gopBuffer_, start, end, this.timeMapping_);
            removesRemaining++;
            this.sourceUpdater_.removeVideo(start, end, removeFinished);
        } // remove any captions and ID3 tags
        for(const track in this.inbandTextTracks_)$86defbb4e95ebb07$var$removeCuesFromTrack(start, end, this.inbandTextTracks_[track]);
        $86defbb4e95ebb07$var$removeCuesFromTrack(start, end, this.segmentMetadataTrack_); // finished this function's removes
        removeFinished();
    }
    /**
   * (re-)schedule monitorBufferTick_ to run as soon as possible
   *
   * @private
   */ monitorBuffer_() {
        if (this.checkBufferTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.checkBufferTimeout_);
        this.checkBufferTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(this.monitorBufferTick_.bind(this), 1);
    }
    /**
   * As long as the SegmentLoader is in the READY state, periodically
   * invoke fillBuffer_().
   *
   * @private
   */ monitorBufferTick_() {
        if (this.state === 'READY') this.fillBuffer_();
        if (this.checkBufferTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.checkBufferTimeout_);
        this.checkBufferTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(this.monitorBufferTick_.bind(this), $86defbb4e95ebb07$var$CHECK_BUFFER_DELAY);
    }
    /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */ fillBuffer_() {
        // TODO since the source buffer maintains a queue, and we shouldn't call this function
        // except when we're ready for the next segment, this check can most likely be removed
        if (this.sourceUpdater_.updating()) return;
         // see if we need to begin loading immediately
        const segmentInfo = this.chooseNextRequest_();
        if (!segmentInfo) return;
        const metadata = {
            segmentInfo: $86defbb4e95ebb07$var$segmentInfoPayload({
                type: this.loaderType_,
                segment: segmentInfo
            })
        };
        this.trigger({
            type: 'segmentselected',
            metadata: metadata
        });
        if (typeof segmentInfo.timestampOffset === 'number') {
            this.isPendingTimestampOffset_ = false;
            this.timelineChangeController_.pendingTimelineChange({
                type: this.loaderType_,
                from: this.currentTimeline_,
                to: segmentInfo.timeline
            });
        }
        this.loadSegment_(segmentInfo);
    }
    /**
   * Determines if we should call endOfStream on the media source based
   * on the state of the buffer or if appened segment was the final
   * segment in the playlist.
   *
   * @param {number} [mediaIndex] the media index of segment we last appended
   * @param {Object} [playlist] a media playlist object
   * @return {boolean} do we need to call endOfStream on the MediaSource
   */ isEndOfStream_(mediaIndex = this.mediaIndex, playlist = this.playlist_, partIndex = this.partIndex) {
        if (!playlist || !this.mediaSource_) return false;
        const segment = typeof mediaIndex === 'number' && playlist.segments[mediaIndex]; // mediaIndex is zero based but length is 1 based
        const appendedLastSegment = mediaIndex + 1 === playlist.segments.length; // true if there are no parts, or this is the last part.
        const appendedLastPart = !segment || !segment.parts || partIndex + 1 === segment.parts.length; // if we've buffered to the end of the video, we need to call endOfStream
        // so that MediaSources can trigger the `ended` event when it runs out of
        // buffered data instead of waiting for me
        return playlist.endList && this.mediaSource_.readyState === 'open' && appendedLastSegment && appendedLastPart;
    }
    /**
   * Determines what request should be made given current segment loader state.
   *
   * @return {Object} a request object that describes the segment/part to load
   */ chooseNextRequest_() {
        const buffered = this.buffered_();
        const bufferedEnd = $86defbb4e95ebb07$var$lastBufferedEnd(buffered) || 0;
        const bufferedTime = $86defbb4e95ebb07$var$timeAheadOf(buffered, this.currentTime_());
        const preloaded = !this.hasPlayed_() && bufferedTime >= 1;
        const haveEnoughBuffer = bufferedTime >= this.goalBufferLength_();
        const segments = this.playlist_.segments; // return no segment if:
        // 1. we don't have segments
        // 2. The video has not yet played and we already downloaded a segment
        // 3. we already have enough buffered time
        if (!segments.length || preloaded || haveEnoughBuffer) return null;
        this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_(), this.loaderType_);
        const next = {
            partIndex: null,
            mediaIndex: null,
            startOfSegment: null,
            playlist: this.playlist_,
            isSyncRequest: Boolean(!this.syncPoint_)
        };
        if (next.isSyncRequest) {
            next.mediaIndex = $86defbb4e95ebb07$var$getSyncSegmentCandidate(this.currentTimeline_, segments, bufferedEnd);
            this.logger_(`choose next request. Can not find sync point. Fallback to media Index: ${next.mediaIndex}`);
        } else if (this.mediaIndex !== null) {
            const segment = segments[this.mediaIndex];
            const partIndex = typeof this.partIndex === 'number' ? this.partIndex : -1;
            next.startOfSegment = segment.end ? segment.end : bufferedEnd;
            if (segment.parts && segment.parts[partIndex + 1]) {
                next.mediaIndex = this.mediaIndex;
                next.partIndex = partIndex + 1;
            } else next.mediaIndex = this.mediaIndex + 1;
        } else {
            let segmentIndex;
            let partIndex;
            let startTime;
            const targetTime = this.fetchAtBuffer_ ? bufferedEnd : this.currentTime_();
            if (this.mediaSequenceSync_) this.logger_(`chooseNextRequest_ request after Quality Switch:
For TargetTime: ${targetTime}.
CurrentTime: ${this.currentTime_()}
BufferedEnd: ${bufferedEnd}
Fetch At Buffer: ${this.fetchAtBuffer_}
`, this.mediaSequenceSync_.diagnostics);
            if (this.mediaSequenceSync_ && this.mediaSequenceSync_.isReliable) {
                const syncInfo = this.getSyncInfoFromMediaSequenceSync_(targetTime);
                if (!syncInfo) {
                    const message = 'No sync info found while using media sequence sync';
                    this.error({
                        message: message,
                        metadata: {
                            errorType: $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.StreamingFailedToSelectNextSegment,
                            error: new Error(message)
                        }
                    });
                    this.logger_('chooseNextRequest_ - no sync info found using media sequence sync'); // no match
                    return null;
                }
                this.logger_(`chooseNextRequest_ mediaSequence syncInfo (${syncInfo.start} --> ${syncInfo.end})`);
                segmentIndex = syncInfo.segmentIndex;
                partIndex = syncInfo.partIndex;
                startTime = syncInfo.start;
            } else {
                this.logger_('chooseNextRequest_ - fallback to a regular segment selection algorithm, based on a syncPoint.'); // fallback
                const mediaInfoForTime = $86defbb4e95ebb07$var$Playlist.getMediaInfoForTime({
                    exactManifestTimings: this.exactManifestTimings,
                    playlist: this.playlist_,
                    currentTime: targetTime,
                    startingPartIndex: this.syncPoint_.partIndex,
                    startingSegmentIndex: this.syncPoint_.segmentIndex,
                    startTime: this.syncPoint_.time
                });
                segmentIndex = mediaInfoForTime.segmentIndex;
                partIndex = mediaInfoForTime.partIndex;
                startTime = mediaInfoForTime.startTime;
            }
            next.getMediaInfoForTime = this.fetchAtBuffer_ ? `bufferedEnd ${targetTime}` : `currentTime ${targetTime}`;
            next.mediaIndex = segmentIndex;
            next.startOfSegment = startTime;
            next.partIndex = partIndex;
            this.logger_(`choose next request. Playlist switched and we have a sync point. Media Index: ${next.mediaIndex} `);
        }
        const nextSegment = segments[next.mediaIndex];
        let nextPart = nextSegment && typeof next.partIndex === 'number' && nextSegment.parts && nextSegment.parts[next.partIndex]; // if the next segment index is invalid or
        // the next partIndex is invalid do not choose a next segment.
        if (!nextSegment || typeof next.partIndex === 'number' && !nextPart) return null;
         // if the next segment has parts, and we don't have a partIndex.
        // Set partIndex to 0
        if (typeof next.partIndex !== 'number' && nextSegment.parts) {
            next.partIndex = 0;
            nextPart = nextSegment.parts[0];
        } // independentSegments applies to every segment in a playlist. If independentSegments appears in a main playlist,
        // it applies to each segment in each media playlist.
        // https://datatracker.ietf.org/doc/html/draft-pantos-http-live-streaming-23#section-4.3.5.1
        const hasIndependentSegments = this.vhs_.playlists && this.vhs_.playlists.main && this.vhs_.playlists.main.independentSegments || this.playlist_.independentSegments; // if we have no buffered data then we need to make sure
        // that the next part we append is "independent" if possible.
        // So we check if the previous part is independent, and request
        // it if it is.
        if (!bufferedTime && nextPart && !hasIndependentSegments && !nextPart.independent) {
            if (next.partIndex === 0) {
                const lastSegment = segments[next.mediaIndex - 1];
                const lastSegmentLastPart = lastSegment.parts && lastSegment.parts.length && lastSegment.parts[lastSegment.parts.length - 1];
                if (lastSegmentLastPart && lastSegmentLastPart.independent) {
                    next.mediaIndex -= 1;
                    next.partIndex = lastSegment.parts.length - 1;
                    next.independent = 'previous segment';
                }
            } else if (nextSegment.parts[next.partIndex - 1].independent) {
                next.partIndex -= 1;
                next.independent = 'previous part';
            }
        }
        const ended = this.mediaSource_ && this.mediaSource_.readyState === 'ended'; // do not choose a next segment if all of the following:
        // 1. this is the last segment in the playlist
        // 2. end of stream has been called on the media source already
        // 3. the player is not seeking
        if (next.mediaIndex >= segments.length - 1 && ended && !this.seeking_()) return null;
        if (this.shouldForceTimestampOffsetAfterResync_) {
            this.shouldForceTimestampOffsetAfterResync_ = false;
            next.forceTimestampOffset = true;
            this.logger_('choose next request. Force timestamp offset after loader resync');
        }
        return this.generateSegmentInfo_(next);
    }
    getSyncInfoFromMediaSequenceSync_(targetTime) {
        if (!this.mediaSequenceSync_) return null;
         // we should pull the target time to the least available time if we drop out of sync for any reason
        const finalTargetTime = Math.max(targetTime, this.mediaSequenceSync_.start);
        if (targetTime !== finalTargetTime) this.logger_(`getSyncInfoFromMediaSequenceSync_. Pulled target time from ${targetTime} to ${finalTargetTime}`);
        const mediaSequenceSyncInfo = this.mediaSequenceSync_.getSyncInfoForTime(finalTargetTime);
        if (!mediaSequenceSyncInfo) // no match at all
        return null;
        if (!mediaSequenceSyncInfo.isAppended) // has a perfect match
        return mediaSequenceSyncInfo;
         // has match, but segment was already appended.
        // attempt to auto-advance to the nearest next segment:
        const nextMediaSequenceSyncInfo = this.mediaSequenceSync_.getSyncInfoForTime(mediaSequenceSyncInfo.end);
        if (!nextMediaSequenceSyncInfo) // no match at all
        return null;
        if (nextMediaSequenceSyncInfo.isAppended) this.logger_('getSyncInfoFromMediaSequenceSync_: We encounter unexpected scenario where next media sequence sync info is also appended!');
         // got match with the nearest next segment
        return nextMediaSequenceSyncInfo;
    }
    generateSegmentInfo_(options) {
        const { independent: independent, playlist: playlist, mediaIndex: mediaIndex, startOfSegment: startOfSegment, isSyncRequest: isSyncRequest, partIndex: partIndex, forceTimestampOffset: forceTimestampOffset, getMediaInfoForTime: getMediaInfoForTime } = options;
        const segment = playlist.segments[mediaIndex];
        const part = typeof partIndex === 'number' && segment.parts[partIndex];
        const segmentInfo = {
            requestId: 'segment-loader-' + Math.random(),
            // resolve the segment URL relative to the playlist
            uri: part && part.resolvedUri || segment.resolvedUri,
            mediaIndex: // the segment's mediaIndex at the time it was requested
            mediaIndex,
            partIndex: part ? partIndex : null,
            isSyncRequest: // whether or not to update the SegmentLoader's state with this
            // segment's mediaIndex
            isSyncRequest,
            startOfSegment: startOfSegment,
            playlist: // the segment's playlist
            playlist,
            // unencrypted bytes of the segment
            bytes: null,
            // when a key is defined for this segment, the encrypted bytes
            encryptedBytes: null,
            // The target timestampOffset for this segment when we append it
            // to the source buffer
            timestampOffset: null,
            // The timeline that the segment is in
            timeline: segment.timeline,
            // The expected duration of the segment in seconds
            duration: part && part.duration || segment.duration,
            segment: // retain the segment in case the playlist updates while doing an async process
            segment,
            part: part,
            byteLength: 0,
            transmuxer: this.transmuxer_,
            getMediaInfoForTime: // type of getMediaInfoForTime that was used to get this segment
            getMediaInfoForTime,
            independent: independent
        };
        const overrideCheck = typeof forceTimestampOffset !== 'undefined' ? forceTimestampOffset : this.isPendingTimestampOffset_;
        segmentInfo.timestampOffset = this.timestampOffsetForSegment_({
            segmentTimeline: segment.timeline,
            currentTimeline: this.currentTimeline_,
            startOfSegment: startOfSegment,
            buffered: this.buffered_(),
            overrideCheck: overrideCheck
        });
        const audioBufferedEnd = $86defbb4e95ebb07$var$lastBufferedEnd(this.sourceUpdater_.audioBuffered());
        if (typeof audioBufferedEnd === 'number') // since the transmuxer is using the actual timing values, but the buffer is
        // adjusted by the timestamp offset, we must adjust the value here
        segmentInfo.audioAppendStart = audioBufferedEnd - this.sourceUpdater_.audioTimestampOffset();
        if (this.sourceUpdater_.videoBuffered().length) segmentInfo.gopsToAlignWith = $86defbb4e95ebb07$var$gopsSafeToAlignWith(this.gopBuffer_, // since the transmuxer is using the actual timing values, but the time is
        // adjusted by the timestmap offset, we must adjust the value here
        this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(), this.timeMapping_);
        return segmentInfo;
    }
    // added so that vtt segment loader can override and prevent
    // adding timestamp offsets.
    timestampOffsetForSegment_(options) {
        return $86defbb4e95ebb07$var$timestampOffsetForSegment(options);
    }
    /**
   * Determines if the network has enough bandwidth to complete the current segment
   * request in a timely manner. If not, the request will be aborted early and bandwidth
   * updated to trigger a playlist switch.
   *
   * @param {Object} stats
   *        Object containing stats about the request timing and size
   * @private
   */ earlyAbortWhenNeeded_(stats) {
        if (this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
        // TODO: Replace using timeout with a boolean indicating whether this playlist is
        //       the lowestEnabledRendition.
        !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
        !this.playlist_.attributes.BANDWIDTH) return;
         // Wait at least 1 second since the first byte of data has been received before
        // using the calculated bandwidth from the progress event to allow the bitrate
        // to stabilize
        if (Date.now() - (stats.firstBytesReceivedAt || Date.now()) < 1000) return;
        const currentTime = this.currentTime_();
        const measuredBandwidth = stats.bandwidth;
        const segmentDuration = this.pendingSegment_.duration;
        const requestTimeRemaining = $86defbb4e95ebb07$var$Playlist.estimateSegmentRequestTime(segmentDuration, measuredBandwidth, this.playlist_, stats.bytesReceived); // Subtract 1 from the timeUntilRebuffer so we still consider an early abort
        // if we are only left with less than 1 second when the request completes.
        // A negative timeUntilRebuffering indicates we are already rebuffering
        const timeUntilRebuffer$1 = $86defbb4e95ebb07$var$timeUntilRebuffer(this.buffered_(), currentTime, this.vhs_.tech_.playbackRate()) - 1; // Only consider aborting early if the estimated time to finish the download
        // is larger than the estimated time until the player runs out of forward buffer
        if (requestTimeRemaining <= timeUntilRebuffer$1) return;
        const switchCandidate = $86defbb4e95ebb07$var$minRebufferMaxBandwidthSelector({
            main: this.vhs_.playlists.main,
            currentTime: currentTime,
            bandwidth: measuredBandwidth,
            duration: this.duration_(),
            segmentDuration: segmentDuration,
            timeUntilRebuffer: timeUntilRebuffer$1,
            currentTimeline: this.currentTimeline_,
            syncController: this.syncController_
        });
        if (!switchCandidate) return;
        const rebufferingImpact = requestTimeRemaining - timeUntilRebuffer$1;
        const timeSavedBySwitching = rebufferingImpact - switchCandidate.rebufferingImpact;
        let minimumTimeSaving = 0.5; // If we are already rebuffering, increase the amount of variance we add to the
        // potential round trip time of the new request so that we are not too aggressive
        // with switching to a playlist that might save us a fraction of a second.
        if (timeUntilRebuffer$1 <= $86defbb4e95ebb07$var$TIME_FUDGE_FACTOR) minimumTimeSaving = 1;
        if (!switchCandidate.playlist || switchCandidate.playlist.uri === this.playlist_.uri || timeSavedBySwitching < minimumTimeSaving) return;
         // set the bandwidth to that of the desired playlist being sure to scale by
        // BANDWIDTH_VARIANCE and add one so the playlist selector does not exclude it
        // don't trigger a bandwidthupdate as the bandwidth is artifial
        this.bandwidth = switchCandidate.playlist.attributes.BANDWIDTH * $86defbb4e95ebb07$var$Config.BANDWIDTH_VARIANCE + 1;
        this.trigger('earlyabort');
    }
    handleAbort_(segmentInfo) {
        this.logger_(`Aborting ${$86defbb4e95ebb07$var$segmentInfoString(segmentInfo)}`);
        this.mediaRequestsAborted += 1;
    }
    /**
   * XHR `progress` event handler
   *
   * @param {Event}
   *        The XHR `progress` event
   * @param {Object} simpleSegment
   *        A simplified segment object copy
   * @private
   */ handleProgress_(event, simpleSegment) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
        this.trigger('progress');
    }
    handleTrackInfo_(simpleSegment, trackInfo) {
        const { hasAudio: hasAudio, hasVideo: hasVideo } = trackInfo;
        const metadata = {
            segmentInfo: $86defbb4e95ebb07$var$segmentInfoPayload({
                type: this.loaderType_,
                segment: simpleSegment
            }),
            trackInfo: {
                hasAudio: hasAudio,
                hasVideo: hasVideo
            }
        };
        this.trigger({
            type: 'segmenttransmuxingtrackinfoavailable',
            metadata: metadata
        });
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
        if (this.checkForIllegalMediaSwitch(trackInfo)) return;
        trackInfo = trackInfo || {}; // When we have track info, determine what media types this loader is dealing with.
        // Guard against cases where we're not getting track info at all until we are
        // certain that all streams will provide it.
        if (!$86defbb4e95ebb07$var$shallowEqual(this.currentMediaInfo_, trackInfo)) {
            this.appendInitSegment_ = {
                audio: true,
                video: true
            };
            this.startingMediaInfo_ = trackInfo;
            this.currentMediaInfo_ = trackInfo;
            this.logger_('trackinfo update', trackInfo);
            this.trigger('trackinfo');
        } // trackinfo may cause an abort if the trackinfo
        // causes a codec change to an unsupported codec.
        if (this.checkForAbort_(simpleSegment.requestId)) return;
         // set trackinfo on the pending segment so that
        // it can append.
        this.pendingSegment_.trackInfo = trackInfo; // check if any calls were waiting on the track info
        if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
        else $86defbb4e95ebb07$var$checkAndFixTimelines(this);
    }
    handleTimingInfo_(simpleSegment, mediaType, timeType, time) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
        const segmentInfo = this.pendingSegment_;
        const timingInfoProperty = $86defbb4e95ebb07$var$timingInfoPropertyForMedia(mediaType);
        segmentInfo[timingInfoProperty] = segmentInfo[timingInfoProperty] || {};
        segmentInfo[timingInfoProperty][timeType] = time;
        this.logger_(`timinginfo: ${mediaType} - ${timeType} - ${time}`); // check if any calls were waiting on the timing info
        if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
        else $86defbb4e95ebb07$var$checkAndFixTimelines(this);
    }
    handleCaptions_(simpleSegment, captionData) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
         // This could only happen with fmp4 segments, but
        // should still not happen in general
        if (captionData.length === 0) {
            this.logger_('SegmentLoader received no captions from a caption event');
            return;
        }
        const segmentInfo = this.pendingSegment_; // Wait until we have some video data so that caption timing
        // can be adjusted by the timestamp offset
        if (!segmentInfo.hasAppendedData_) {
            this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, simpleSegment, captionData));
            return;
        }
        const timestampOffset = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
        const captionTracks = {}; // get total start/end and captions for each track/stream
        captionData.forEach((caption)=>{
            // caption.stream is actually a track name...
            // set to the existing values in tracks or default values
            captionTracks[caption.stream] = captionTracks[caption.stream] || {
                // Infinity, as any other value will be less than this
                startTime: Infinity,
                captions: [],
                // 0 as an other value will be more than this
                endTime: 0
            };
            const captionTrack = captionTracks[caption.stream];
            captionTrack.startTime = Math.min(captionTrack.startTime, caption.startTime + timestampOffset);
            captionTrack.endTime = Math.max(captionTrack.endTime, caption.endTime + timestampOffset);
            captionTrack.captions.push(caption);
        });
        Object.keys(captionTracks).forEach((trackName)=>{
            const { startTime: startTime, endTime: endTime, captions: captions } = captionTracks[trackName];
            const inbandTextTracks = this.inbandTextTracks_;
            this.logger_(`adding cues from ${startTime} -> ${endTime} for ${trackName}`);
            $86defbb4e95ebb07$var$createCaptionsTrackIfNotExists(inbandTextTracks, this.vhs_.tech_, trackName); // clear out any cues that start and end at the same time period for the same track.
            // We do this because a rendition change that also changes the timescale for captions
            // will result in captions being re-parsed for certain segments. If we add them again
            // without clearing we will have two of the same captions visible.
            $86defbb4e95ebb07$var$removeCuesFromTrack(startTime, endTime, inbandTextTracks[trackName]);
            $86defbb4e95ebb07$var$addCaptionData({
                captionArray: captions,
                inbandTextTracks: inbandTextTracks,
                timestampOffset: timestampOffset
            });
        }); // Reset stored captions since we added parsed
        // captions to a text track at this point
        if (this.transmuxer_) this.transmuxer_.postMessage({
            action: 'clearParsedMp4Captions'
        });
    }
    handleId3_(simpleSegment, id3Frames, dispatchType) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
        const segmentInfo = this.pendingSegment_; // we need to have appended data in order for the timestamp offset to be set
        if (!segmentInfo.hasAppendedData_) {
            this.metadataQueue_.id3.push(this.handleId3_.bind(this, simpleSegment, id3Frames, dispatchType));
            return;
        }
        this.addMetadataToTextTrack(dispatchType, id3Frames, this.duration_());
    }
    processMetadataQueue_() {
        this.metadataQueue_.id3.forEach((fn)=>fn());
        this.metadataQueue_.caption.forEach((fn)=>fn());
        this.metadataQueue_.id3 = [];
        this.metadataQueue_.caption = [];
    }
    processCallQueue_() {
        const callQueue = this.callQueue_; // Clear out the queue before the queued functions are run, since some of the
        // functions may check the length of the load queue and default to pushing themselves
        // back onto the queue.
        this.callQueue_ = [];
        callQueue.forEach((fun)=>fun());
    }
    processLoadQueue_() {
        const loadQueue = this.loadQueue_; // Clear out the queue before the queued functions are run, since some of the
        // functions may check the length of the load queue and default to pushing themselves
        // back onto the queue.
        this.loadQueue_ = [];
        loadQueue.forEach((fun)=>fun());
    }
    /**
   * Determines whether the loader has enough info to load the next segment.
   *
   * @return {boolean}
   *         Whether or not the loader has enough info to load the next segment
   */ hasEnoughInfoToLoad_() {
        // Since primary timing goes by video, only the audio loader potentially needs to wait
        // to load.
        if (this.loaderType_ !== 'audio') return true;
        const segmentInfo = this.pendingSegment_; // A fill buffer must have already run to establish a pending segment before there's
        // enough info to load.
        if (!segmentInfo) return false;
         // The first segment can and should be loaded immediately so that source buffers are
        // created together (before appending). Source buffer creation uses the presence of
        // audio and video data to determine whether to create audio/video source buffers, and
        // uses processed (transmuxed or parsed) media to determine the types required.
        if (!this.getCurrentMediaInfo_()) return true;
        if (// Technically, instead of waiting to load a segment on timeline changes, a segment
        // can be requested and downloaded and only wait before it is transmuxed or parsed.
        // But in practice, there are a few reasons why it is better to wait until a loader
        // is ready to append that segment before requesting and downloading:
        //
        // 1. Because audio and main loaders cross discontinuities together, if this loader
        //    is waiting for the other to catch up, then instead of requesting another
        //    segment and using up more bandwidth, by not yet loading, more bandwidth is
        //    allotted to the loader currently behind.
        // 2. media-segment-request doesn't have to have logic to consider whether a segment
        // is ready to be processed or not, isolating the queueing behavior to the loader.
        // 3. The audio loader bases some of its segment properties on timing information
        //    provided by the main loader, meaning that, if the logic for waiting on
        //    processing was in media-segment-request, then it would also need to know how
        //    to re-generate the segment information after the main loader caught up.
        $86defbb4e95ebb07$var$shouldWaitForTimelineChange({
            timelineChangeController: this.timelineChangeController_,
            currentTimeline: this.currentTimeline_,
            segmentTimeline: segmentInfo.timeline,
            loaderType: this.loaderType_,
            audioDisabled: this.audioDisabled_
        })) return false;
        return true;
    }
    getCurrentMediaInfo_(segmentInfo = this.pendingSegment_) {
        return segmentInfo && segmentInfo.trackInfo || this.currentMediaInfo_;
    }
    getMediaInfo_(segmentInfo = this.pendingSegment_) {
        return this.getCurrentMediaInfo_(segmentInfo) || this.startingMediaInfo_;
    }
    getPendingSegmentPlaylist() {
        return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
    }
    hasEnoughInfoToAppend_() {
        if (!this.sourceUpdater_.ready()) return false;
         // If content needs to be removed or the loader is waiting on an append reattempt,
        // then no additional content should be appended until the prior append is resolved.
        if (this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_) return false;
        const segmentInfo = this.pendingSegment_;
        const trackInfo = this.getCurrentMediaInfo_(); // no segment to append any data for or
        // we do not have information on this specific
        // segment yet
        if (!segmentInfo || !trackInfo) return false;
        const { hasAudio: hasAudio, hasVideo: hasVideo, isMuxed: isMuxed } = trackInfo;
        if (hasVideo && !segmentInfo.videoTimingInfo) return false;
         // muxed content only relies on video timing information for now.
        if (hasAudio && !this.audioDisabled_ && !isMuxed && !segmentInfo.audioTimingInfo) return false;
         // we need to allow an append here even if we're moving to different timelines.
        if ($86defbb4e95ebb07$var$shouldWaitForTimelineChange({
            timelineChangeController: this.timelineChangeController_,
            currentTimeline: this.currentTimeline_,
            segmentTimeline: segmentInfo.timeline,
            loaderType: this.loaderType_,
            audioDisabled: this.audioDisabled_
        })) return false;
        return true;
    }
    handleData_(simpleSegment, result) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
         // If there's anything in the call queue, then this data came later and should be
        // executed after the calls currently queued.
        if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
            $86defbb4e95ebb07$var$checkAndFixTimelines(this);
            this.callQueue_.push(this.handleData_.bind(this, simpleSegment, result));
            return;
        }
        const segmentInfo = this.pendingSegment_; // update the time mapping so we can translate from display time to media time
        this.setTimeMapping_(segmentInfo.timeline); // for tracking overall stats
        this.updateMediaSecondsLoaded_(segmentInfo.part || segmentInfo.segment); // Note that the state isn't changed from loading to appending. This is because abort
        // logic may change behavior depending on the state, and changing state too early may
        // inflate our estimates of bandwidth. In the future this should be re-examined to
        // note more granular states.
        // don't process and append data if the mediaSource is closed
        if (this.mediaSource_.readyState === 'closed') return;
         // if this request included an initialization segment, save that data
        // to the initSegment cache
        if (simpleSegment.map) {
            simpleSegment.map = this.initSegmentForMap(simpleSegment.map, true); // move over init segment properties to media request
            segmentInfo.segment.map = simpleSegment.map;
        } // if this request included a segment key, save that data in the cache
        if (simpleSegment.key) this.segmentKey(simpleSegment.key, true);
        segmentInfo.isFmp4 = simpleSegment.isFmp4;
        segmentInfo.timingInfo = segmentInfo.timingInfo || {};
        if (segmentInfo.isFmp4) {
            this.trigger('fmp4');
            segmentInfo.timingInfo.start = segmentInfo[$86defbb4e95ebb07$var$timingInfoPropertyForMedia(result.type)].start;
        } else {
            const trackInfo = this.getCurrentMediaInfo_();
            const useVideoTimingInfo = this.loaderType_ === 'main' && trackInfo && trackInfo.hasVideo;
            let firstVideoFrameTimeForData;
            if (useVideoTimingInfo) firstVideoFrameTimeForData = segmentInfo.videoTimingInfo.start;
             // Segment loader knows more about segment timing than the transmuxer (in certain
            // aspects), so make any changes required for a more accurate start time.
            // Don't set the end time yet, as the segment may not be finished processing.
            segmentInfo.timingInfo.start = this.trueSegmentStart_({
                currentStart: segmentInfo.timingInfo.start,
                playlist: segmentInfo.playlist,
                mediaIndex: segmentInfo.mediaIndex,
                currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
                useVideoTimingInfo: useVideoTimingInfo,
                firstVideoFrameTimeForData: firstVideoFrameTimeForData,
                videoTimingInfo: segmentInfo.videoTimingInfo,
                audioTimingInfo: segmentInfo.audioTimingInfo
            });
        } // Init segments for audio and video only need to be appended in certain cases. Now
        // that data is about to be appended, we can check the final cases to determine
        // whether we should append an init segment.
        this.updateAppendInitSegmentStatus(segmentInfo, result.type); // Timestamp offset should be updated once we get new data and have its timing info,
        // as we use the start of the segment to offset the best guess (playlist provided)
        // timestamp offset.
        this.updateSourceBufferTimestampOffset_(segmentInfo); // if this is a sync request we need to determine whether it should
        // be appended or not.
        if (segmentInfo.isSyncRequest) {
            // first save/update our timing info for this segment.
            // this is what allows us to choose an accurate segment
            // and the main reason we make a sync request.
            this.updateTimingInfoEnd_(segmentInfo);
            this.syncController_.saveSegmentTimingInfo({
                segmentInfo: segmentInfo,
                shouldSaveTimelineMapping: this.loaderType_ === 'main'
            });
            const next = this.chooseNextRequest_(); // If the sync request isn't the segment that would be requested next
            // after taking into account its timing info, do not append it.
            if (next.mediaIndex !== segmentInfo.mediaIndex || next.partIndex !== segmentInfo.partIndex) {
                this.logger_('sync segment was incorrect, not appending');
                return;
            } // otherwise append it like any other segment as our guess was correct.
            this.logger_('sync segment was correct, appending');
        } // Save some state so that in the future anything waiting on first append (and/or
        // timestamp offset(s)) can process immediately. While the extra state isn't optimal,
        // we need some notion of whether the timestamp offset or other relevant information
        // has had a chance to be set.
        segmentInfo.hasAppendedData_ = true; // Now that the timestamp offset should be set, we can append any waiting ID3 tags.
        this.processMetadataQueue_();
        this.appendData_(segmentInfo, result);
    }
    updateAppendInitSegmentStatus(segmentInfo, type) {
        // alt audio doesn't manage timestamp offset
        if (this.loaderType_ === 'main' && typeof segmentInfo.timestampOffset === 'number' && // in the case that we're handling partial data, we don't want to append an init
        // segment for each chunk
        !segmentInfo.changedTimestampOffset) // if the timestamp offset changed, the timeline may have changed, so we have to re-
        // append init segments
        this.appendInitSegment_ = {
            audio: true,
            video: true
        };
        if (this.playlistOfLastInitSegment_[type] !== segmentInfo.playlist) // make sure we append init segment on playlist changes, in case the media config
        // changed
        this.appendInitSegment_[type] = true;
    }
    getInitSegmentAndUpdateState_({ type: type, initSegment: initSegment, map: map, playlist: playlist }) {
        // "The EXT-X-MAP tag specifies how to obtain the Media Initialization Section
        // (Section 3) required to parse the applicable Media Segments.  It applies to every
        // Media Segment that appears after it in the Playlist until the next EXT-X-MAP tag
        // or until the end of the playlist."
        // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.5
        if (map) {
            const id = $86defbb4e95ebb07$var$initSegmentId(map);
            if (this.activeInitSegmentId_ === id) // don't need to re-append the init segment if the ID matches
            return null;
             // a map-specified init segment takes priority over any transmuxed (or otherwise
            // obtained) init segment
            //
            // this also caches the init segment for later use
            initSegment = this.initSegmentForMap(map, true).bytes;
            this.activeInitSegmentId_ = id;
        } // We used to always prepend init segments for video, however, that shouldn't be
        // necessary. Instead, we should only append on changes, similar to what we've always
        // done for audio. This is more important (though may not be that important) for
        // frame-by-frame appending for LHLS, simply because of the increased quantity of
        // appends.
        if (initSegment && this.appendInitSegment_[type]) {
            // Make sure we track the playlist that we last used for the init segment, so that
            // we can re-append the init segment in the event that we get data from a new
            // playlist. Discontinuities and track changes are handled in other sections.
            this.playlistOfLastInitSegment_[type] = playlist; // Disable future init segment appends for this type. Until a change is necessary.
            this.appendInitSegment_[type] = false; // we need to clear out the fmp4 active init segment id, since
            // we are appending the muxer init segment
            this.activeInitSegmentId_ = null;
            return initSegment;
        }
        return null;
    }
    handleQuotaExceededError_({ segmentInfo: segmentInfo, type: type, bytes: bytes }, error) {
        const audioBuffered = this.sourceUpdater_.audioBuffered();
        const videoBuffered = this.sourceUpdater_.videoBuffered(); // For now we're ignoring any notion of gaps in the buffer, but they, in theory,
        // should be cleared out during the buffer removals. However, log in case it helps
        // debug.
        if (audioBuffered.length > 1) this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: ' + $86defbb4e95ebb07$var$timeRangesToArray(audioBuffered).join(', '));
        if (videoBuffered.length > 1) this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: ' + $86defbb4e95ebb07$var$timeRangesToArray(videoBuffered).join(', '));
        const audioBufferStart = audioBuffered.length ? audioBuffered.start(0) : 0;
        const audioBufferEnd = audioBuffered.length ? audioBuffered.end(audioBuffered.length - 1) : 0;
        const videoBufferStart = videoBuffered.length ? videoBuffered.start(0) : 0;
        const videoBufferEnd = videoBuffered.length ? videoBuffered.end(videoBuffered.length - 1) : 0;
        if (audioBufferEnd - audioBufferStart <= $86defbb4e95ebb07$var$MIN_BACK_BUFFER && videoBufferEnd - videoBufferStart <= $86defbb4e95ebb07$var$MIN_BACK_BUFFER) {
            // Can't remove enough buffer to make room for new segment (or the browser doesn't
            // allow for appends of segments this size). In the future, it may be possible to
            // split up the segment and append in pieces, but for now, error out this playlist
            // in an attempt to switch to a more manageable rendition.
            this.logger_("On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. " + `Appended byte length: ${bytes.byteLength}, ` + `audio buffer: ${$86defbb4e95ebb07$var$timeRangesToArray(audioBuffered).join(', ')}, ` + `video buffer: ${$86defbb4e95ebb07$var$timeRangesToArray(videoBuffered).join(', ')}, `);
            this.error({
                message: 'Quota exceeded error with append of a single segment of content',
                excludeUntil: Infinity
            });
            this.trigger('error');
            return;
        } // To try to resolve the quota exceeded error, clear back buffer and retry. This means
        // that the segment-loader should block on future events until this one is handled, so
        // that it doesn't keep moving onto further segments. Adding the call to the call
        // queue will prevent further appends until waitingOnRemove_ and
        // quotaExceededErrorRetryTimeout_ are cleared.
        //
        // Note that this will only block the current loader. In the case of demuxed content,
        // the other load may keep filling as fast as possible. In practice, this should be
        // OK, as it is a rare case when either audio has a high enough bitrate to fill up a
        // source buffer, or video fills without enough room for audio to append (and without
        // the availability of clearing out seconds of back buffer to make room for audio).
        // But it might still be good to handle this case in the future as a TODO.
        this.waitingOnRemove_ = true;
        this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
            segmentInfo: segmentInfo,
            type: type,
            bytes: bytes
        }));
        const currentTime = this.currentTime_(); // Try to remove as much audio and video as possible to make room for new content
        // before retrying.
        const timeToRemoveUntil = currentTime - $86defbb4e95ebb07$var$MIN_BACK_BUFFER;
        this.logger_(`On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to ${timeToRemoveUntil}`);
        this.remove(0, timeToRemoveUntil, ()=>{
            this.logger_(`On QUOTA_EXCEEDED_ERR, retrying append in ${$86defbb4e95ebb07$var$MIN_BACK_BUFFER}s`);
            this.waitingOnRemove_ = false; // wait the length of time alotted in the back buffer to prevent wasted
            // attempts (since we can't clear less than the minimum)
            this.quotaExceededErrorRetryTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>{
                this.logger_('On QUOTA_EXCEEDED_ERR, re-processing call queue');
                this.quotaExceededErrorRetryTimeout_ = null;
                this.processCallQueue_();
            }, $86defbb4e95ebb07$var$MIN_BACK_BUFFER * 1000);
        }, true);
    }
    handleAppendError_({ segmentInfo: segmentInfo, type: type, bytes: bytes }, error) {
        // if there's no error, nothing to do
        if (!error) return;
        if (error.code === $86defbb4e95ebb07$var$QUOTA_EXCEEDED_ERR) {
            this.handleQuotaExceededError_({
                segmentInfo: segmentInfo,
                type: type,
                bytes: bytes
            }); // A quota exceeded error should be recoverable with a future re-append, so no need
            // to trigger an append error.
            return;
        }
        this.logger_('Received non QUOTA_EXCEEDED_ERR on append', error); // If an append errors, we often can't recover.
        // (see https://w3c.github.io/media-source/#sourcebuffer-append-error).
        //
        // Trigger a special error so that it can be handled separately from normal,
        // recoverable errors.
        this.error({
            message: `${type} append of ${bytes.length}b failed for segment ` + `#${segmentInfo.mediaIndex} in playlist ${segmentInfo.playlist.id}`,
            metadata: {
                errorType: $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.StreamingFailedToAppendSegment
            }
        });
        this.trigger('appenderror');
    }
    appendToSourceBuffer_({ segmentInfo: segmentInfo, type: type, initSegment: initSegment, data: data, bytes: bytes }) {
        // If this is a re-append, bytes were already created and don't need to be recreated
        if (!bytes) {
            const segments = [
                data
            ];
            let byteLength = data.byteLength;
            if (initSegment) {
                // if the media initialization segment is changing, append it before the content
                // segment
                segments.unshift(initSegment);
                byteLength += initSegment.byteLength;
            } // Technically we should be OK appending the init segment separately, however, we
            // haven't yet tested that, and prepending is how we have always done things.
            bytes = $86defbb4e95ebb07$var$concatSegments({
                bytes: byteLength,
                segments: segments
            });
        }
        const metadata = {
            segmentInfo: $86defbb4e95ebb07$var$segmentInfoPayload({
                type: this.loaderType_,
                segment: segmentInfo
            })
        };
        this.trigger({
            type: 'segmentappendstart',
            metadata: metadata
        });
        this.sourceUpdater_.appendBuffer({
            segmentInfo: segmentInfo,
            type: type,
            bytes: bytes
        }, this.handleAppendError_.bind(this, {
            segmentInfo: segmentInfo,
            type: type,
            bytes: bytes
        }));
    }
    handleSegmentTimingInfo_(type, requestId, segmentTimingInfo) {
        if (!this.pendingSegment_ || requestId !== this.pendingSegment_.requestId) return;
        const segment = this.pendingSegment_.segment;
        const timingInfoProperty = `${type}TimingInfo`;
        if (!segment[timingInfoProperty]) segment[timingInfoProperty] = {};
        segment[timingInfoProperty].transmuxerPrependedSeconds = segmentTimingInfo.prependedContentDuration || 0;
        segment[timingInfoProperty].transmuxedPresentationStart = segmentTimingInfo.start.presentation;
        segment[timingInfoProperty].transmuxedDecodeStart = segmentTimingInfo.start.decode;
        segment[timingInfoProperty].transmuxedPresentationEnd = segmentTimingInfo.end.presentation;
        segment[timingInfoProperty].transmuxedDecodeEnd = segmentTimingInfo.end.decode; // mainly used as a reference for debugging
        segment[timingInfoProperty].baseMediaDecodeTime = segmentTimingInfo.baseMediaDecodeTime;
    }
    appendData_(segmentInfo, result) {
        const { type: type, data: data } = result;
        if (!data || !data.byteLength) return;
        if (type === 'audio' && this.audioDisabled_) return;
        const initSegment = this.getInitSegmentAndUpdateState_({
            type: type,
            initSegment: result.initSegment,
            playlist: segmentInfo.playlist,
            map: segmentInfo.isFmp4 ? segmentInfo.segment.map : null
        });
        this.appendToSourceBuffer_({
            segmentInfo: segmentInfo,
            type: type,
            initSegment: initSegment,
            data: data
        });
    }
    /**
   * load a specific segment from a request into the buffer
   *
   * @private
   */ loadSegment_(segmentInfo) {
        this.state = 'WAITING';
        this.pendingSegment_ = segmentInfo;
        this.trimBackBuffer_(segmentInfo);
        if (typeof segmentInfo.timestampOffset === 'number') {
            if (this.transmuxer_) this.transmuxer_.postMessage({
                action: 'clearAllMp4Captions'
            });
        }
        if (!this.hasEnoughInfoToLoad_()) {
            $86defbb4e95ebb07$var$checkAndFixTimelines(this);
            this.loadQueue_.push(()=>{
                // regenerate the audioAppendStart, timestampOffset, etc as they
                // may have changed since this function was added to the queue.
                const options = (0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, segmentInfo, {
                    forceTimestampOffset: true
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))(segmentInfo, this.generateSegmentInfo_(options));
                this.isPendingTimestampOffset_ = false;
                this.updateTransmuxerAndRequestSegment_(segmentInfo);
            });
            return;
        }
        this.updateTransmuxerAndRequestSegment_(segmentInfo);
    }
    updateTransmuxerAndRequestSegment_(segmentInfo) {
        // We'll update the source buffer's timestamp offset once we have transmuxed data, but
        // the transmuxer still needs to be updated before then.
        //
        // Even though keepOriginalTimestamps is set to true for the transmuxer, timestamp
        // offset must be passed to the transmuxer for stream correcting adjustments.
        if (this.shouldUpdateTransmuxerTimestampOffset_(segmentInfo.timestampOffset)) {
            this.gopBuffer_.length = 0; // gopsToAlignWith was set before the GOP buffer was cleared
            segmentInfo.gopsToAlignWith = [];
            this.timeMapping_ = 0; // reset values in the transmuxer since a discontinuity should start fresh
            this.transmuxer_.postMessage({
                action: 'reset'
            });
            this.transmuxer_.postMessage({
                action: 'setTimestampOffset',
                timestampOffset: segmentInfo.timestampOffset
            });
        }
        const simpleSegment = this.createSimplifiedSegmentObj_(segmentInfo);
        const isEndOfStream = this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex);
        const isWalkingForward = this.mediaIndex !== null;
        const isDiscontinuity = segmentInfo.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
        // the first timeline
        segmentInfo.timeline > 0;
        const isEndOfTimeline = isEndOfStream || isWalkingForward && isDiscontinuity;
        this.logger_(`Requesting
${$86defbb4e95ebb07$var$compactSegmentUrlDescription(segmentInfo.uri)}
${$86defbb4e95ebb07$var$segmentInfoString(segmentInfo)}`); // If there's an init segment associated with this segment, but it is not cached (identified by a lack of bytes),
        // then this init segment has never been seen before and should be appended.
        //
        // At this point the content type (audio/video or both) is not yet known, but it should be safe to set
        // both to true and leave the decision of whether to append the init segment to append time.
        if (simpleSegment.map && !simpleSegment.map.bytes) {
            this.logger_('going to request init segment.');
            this.appendInitSegment_ = {
                video: true,
                audio: true
            };
        }
        segmentInfo.abortRequests = $86defbb4e95ebb07$var$mediaSegmentRequest({
            xhr: this.vhs_.xhr,
            xhrOptions: this.xhrOptions_,
            decryptionWorker: this.decrypter_,
            segment: simpleSegment,
            abortFn: this.handleAbort_.bind(this, segmentInfo),
            progressFn: this.handleProgress_.bind(this),
            trackInfoFn: this.handleTrackInfo_.bind(this),
            timingInfoFn: this.handleTimingInfo_.bind(this),
            videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, 'video', segmentInfo.requestId),
            audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, 'audio', segmentInfo.requestId),
            captionsFn: this.handleCaptions_.bind(this),
            isEndOfTimeline: isEndOfTimeline,
            endedTimelineFn: ()=>{
                this.logger_('received endedtimeline callback');
            },
            id3Fn: this.handleId3_.bind(this),
            dataFn: this.handleData_.bind(this),
            doneFn: this.segmentRequestFinished_.bind(this),
            onTransmuxerLog: ({ message: message, level: level, stream: stream })=>{
                this.logger_(`${$86defbb4e95ebb07$var$segmentInfoString(segmentInfo)} logged from transmuxer stream ${stream} as a ${level}: ${message}`);
            },
            triggerSegmentEventFn: ({ type: type, segment: segment, keyInfo: keyInfo, trackInfo: trackInfo, timingInfo: timingInfo })=>{
                const segInfo = $86defbb4e95ebb07$var$segmentInfoPayload({
                    segment: segment
                });
                const metadata = {
                    segmentInfo: segInfo
                }; // add other properties if necessary.
                if (keyInfo) metadata.keyInfo = keyInfo;
                if (trackInfo) metadata.trackInfo = trackInfo;
                if (timingInfo) metadata.timingInfo = timingInfo;
                this.trigger({
                    type: type,
                    metadata: metadata
                });
            }
        });
    }
    /**
   * trim the back buffer so that we don't have too much data
   * in the source buffer
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   */ trimBackBuffer_(segmentInfo) {
        const removeToTime = $86defbb4e95ebb07$var$safeBackBufferTrimTime(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10); // Chrome has a hard limit of 150MB of
        // buffer and a very conservative "garbage collector"
        // We manually clear out the old buffer to ensure
        // we don't trigger the QuotaExceeded error
        // on the source buffer during subsequent appends
        if (removeToTime > 0) this.remove(0, removeToTime);
    }
    /**
   * created a simplified copy of the segment object with just the
   * information necessary to perform the XHR and decryption
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   * @return {Object} a simplified segment object copy
   */ createSimplifiedSegmentObj_(segmentInfo) {
        const segment = segmentInfo.segment;
        const part = segmentInfo.part;
        const isEncrypted = segmentInfo.segment.key || segmentInfo.segment.map && segmentInfo.segment.map.key;
        const isMediaInitialization = segmentInfo.segment.map && !segmentInfo.segment.map.bytes;
        const simpleSegment = {
            resolvedUri: part ? part.resolvedUri : segment.resolvedUri,
            byterange: part ? part.byterange : segment.byterange,
            requestId: segmentInfo.requestId,
            transmuxer: segmentInfo.transmuxer,
            audioAppendStart: segmentInfo.audioAppendStart,
            gopsToAlignWith: segmentInfo.gopsToAlignWith,
            part: segmentInfo.part,
            type: this.loaderType_,
            start: segmentInfo.startOfSegment,
            duration: segmentInfo.duration,
            isEncrypted: isEncrypted,
            isMediaInitialization: isMediaInitialization
        };
        const previousSegment = segmentInfo.playlist.segments[segmentInfo.mediaIndex - 1];
        if (previousSegment && previousSegment.timeline === segment.timeline) {
            // The baseStartTime of a segment is used to handle rollover when probing the TS
            // segment to retrieve timing information. Since the probe only looks at the media's
            // times (e.g., PTS and DTS values of the segment), and doesn't consider the
            // player's time (e.g., player.currentTime()), baseStartTime should reflect the
            // media time as well. transmuxedDecodeEnd represents the end time of a segment, in
            // seconds of media time, so should be used here. The previous segment is used since
            // the end of the previous segment should represent the beginning of the current
            // segment, so long as they are on the same timeline.
            if (previousSegment.videoTimingInfo) simpleSegment.baseStartTime = previousSegment.videoTimingInfo.transmuxedDecodeEnd;
            else if (previousSegment.audioTimingInfo) simpleSegment.baseStartTime = previousSegment.audioTimingInfo.transmuxedDecodeEnd;
        }
        if (segment.key) {
            // if the media sequence is greater than 2^32, the IV will be incorrect
            // assuming 10s segments, that would be about 1300 years
            const iv = segment.key.iv || new Uint32Array([
                0,
                0,
                0,
                segmentInfo.mediaIndex + segmentInfo.playlist.mediaSequence
            ]);
            simpleSegment.key = this.segmentKey(segment.key);
            simpleSegment.key.iv = iv;
        }
        if (segment.map) simpleSegment.map = this.initSegmentForMap(segment.map);
        return simpleSegment;
    }
    saveTransferStats_(stats) {
        // every request counts as a media request even if it has been aborted
        // or canceled due to a timeout
        this.mediaRequests += 1;
        if (stats) {
            this.mediaBytesTransferred += stats.bytesReceived;
            this.mediaTransferDuration += stats.roundTripTime;
        }
    }
    saveBandwidthRelatedStats_(duration, stats) {
        // byteLength will be used for throughput, and should be based on bytes receieved,
        // which we only know at the end of the request and should reflect total bytes
        // downloaded rather than just bytes processed from components of the segment
        this.pendingSegment_.byteLength = stats.bytesReceived;
        if (duration < $86defbb4e95ebb07$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
            this.logger_(`Ignoring segment's bandwidth because its duration of ${duration}` + ` is less than the min to record ${$86defbb4e95ebb07$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS}`);
            return;
        }
        const metadata = {
            bandwidthInfo: {
                from: this.bandwidth,
                to: stats.bandwidth
            }
        }; // player event with payload
        this.trigger({
            type: 'bandwidthupdated',
            metadata: metadata
        });
        this.bandwidth = stats.bandwidth;
        this.roundTrip = stats.roundTripTime;
    }
    handleTimeout_() {
        // although the VTT segment loader bandwidth isn't really used, it's good to
        // maintain functinality between segment loaders
        this.mediaRequestsTimedout += 1;
        this.bandwidth = 1;
        this.roundTrip = NaN;
        this.trigger('bandwidthupdate');
        this.trigger('timeout');
    }
    /**
   * Handle the callback from the segmentRequest function and set the
   * associated SegmentLoader state and errors if necessary
   *
   * @private
   */ segmentRequestFinished_(error, simpleSegment, result) {
        // TODO handle special cases, e.g., muxed audio/video but only audio in the segment
        // check the call queue directly since this function doesn't need to deal with any
        // data, and can continue even if the source buffers are not set up and we didn't get
        // any data from the segment
        if (this.callQueue_.length) {
            this.callQueue_.push(this.segmentRequestFinished_.bind(this, error, simpleSegment, result));
            return;
        }
        this.saveTransferStats_(simpleSegment.stats); // The request was aborted and the SegmentLoader has already been reset
        if (!this.pendingSegment_) return;
         // the request was aborted and the SegmentLoader has already started
        // another request. this can happen when the timeout for an aborted
        // request triggers due to a limitation in the XHR library
        // do not count this as any sort of request or we risk double-counting
        if (simpleSegment.requestId !== this.pendingSegment_.requestId) return;
         // an error occurred from the active pendingSegment_ so reset everything
        if (error) {
            this.pendingSegment_ = null;
            this.state = 'READY'; // aborts are not a true error condition and nothing corrective needs to be done
            if (error.code === $86defbb4e95ebb07$var$REQUEST_ERRORS.ABORTED) return;
            this.pause(); // the error is really just that at least one of the requests timed-out
            // set the bandwidth to a very low value and trigger an ABR switch to
            // take emergency action
            if (error.code === $86defbb4e95ebb07$var$REQUEST_ERRORS.TIMEOUT) {
                this.handleTimeout_();
                return;
            } // if control-flow has arrived here, then the error is real
            // emit an error event to exclude the current playlist
            this.mediaRequestsErrored += 1;
            this.error(error);
            this.trigger('error');
            return;
        }
        const segmentInfo = this.pendingSegment_; // the response was a success so set any bandwidth stats the request
        // generated for ABR purposes
        this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats);
        segmentInfo.endOfAllRequests = simpleSegment.endOfAllRequests;
        if (result.gopInfo) this.gopBuffer_ = $86defbb4e95ebb07$var$updateGopBuffer(this.gopBuffer_, result.gopInfo, this.safeAppend_);
         // Although we may have already started appending on progress, we shouldn't switch the
        // state away from loading until we are officially done loading the segment data.
        this.state = 'APPENDING'; // used for testing
        this.trigger('appending');
        this.waitForAppendsToComplete_(segmentInfo);
    }
    setTimeMapping_(timeline) {
        const timelineMapping = this.syncController_.mappingForTimeline(timeline);
        if (timelineMapping !== null) this.timeMapping_ = timelineMapping;
    }
    updateMediaSecondsLoaded_(segment) {
        if (typeof segment.start === 'number' && typeof segment.end === 'number') this.mediaSecondsLoaded += segment.end - segment.start;
        else this.mediaSecondsLoaded += segment.duration;
    }
    shouldUpdateTransmuxerTimestampOffset_(timestampOffset) {
        if (timestampOffset === null) return false;
         // note that we're potentially using the same timestamp offset for both video and
        // audio
        if (this.loaderType_ === 'main' && timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) return true;
        if (!this.audioDisabled_ && timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) return true;
        return false;
    }
    trueSegmentStart_({ currentStart: currentStart, playlist: playlist, mediaIndex: mediaIndex, firstVideoFrameTimeForData: firstVideoFrameTimeForData, currentVideoTimestampOffset: currentVideoTimestampOffset, useVideoTimingInfo: useVideoTimingInfo, videoTimingInfo: videoTimingInfo, audioTimingInfo: audioTimingInfo }) {
        if (typeof currentStart !== 'undefined') // if start was set once, keep using it
        return currentStart;
        if (!useVideoTimingInfo) return audioTimingInfo.start;
        const previousSegment = playlist.segments[mediaIndex - 1]; // The start of a segment should be the start of the first full frame contained
        // within that segment. Since the transmuxer maintains a cache of incomplete data
        // from and/or the last frame seen, the start time may reflect a frame that starts
        // in the previous segment. Check for that case and ensure the start time is
        // accurate for the segment.
        if (mediaIndex === 0 || !previousSegment || typeof previousSegment.start === 'undefined' || previousSegment.end !== firstVideoFrameTimeForData + currentVideoTimestampOffset) return firstVideoFrameTimeForData;
        return videoTimingInfo.start;
    }
    waitForAppendsToComplete_(segmentInfo) {
        const trackInfo = this.getCurrentMediaInfo_(segmentInfo);
        if (!trackInfo) {
            this.error({
                message: 'No starting media returned, likely due to an unsupported media format.',
                playlistExclusionDuration: Infinity
            });
            this.trigger('error');
            return;
        } // Although transmuxing is done, appends may not yet be finished. Throw a marker
        // on each queue this loader is responsible for to ensure that the appends are
        // complete.
        const { hasAudio: hasAudio, hasVideo: hasVideo, isMuxed: isMuxed } = trackInfo;
        const waitForVideo = this.loaderType_ === 'main' && hasVideo;
        const waitForAudio = !this.audioDisabled_ && hasAudio && !isMuxed;
        segmentInfo.waitingOnAppends = 0; // segments with no data
        if (!segmentInfo.hasAppendedData_) {
            if (!segmentInfo.timingInfo && typeof segmentInfo.timestampOffset === 'number') // When there's no audio or video data in the segment, there's no audio or video
            // timing information.
            //
            // If there's no audio or video timing information, then the timestamp offset
            // can't be adjusted to the appropriate value for the transmuxer and source
            // buffers.
            //
            // Therefore, the next segment should be used to set the timestamp offset.
            this.isPendingTimestampOffset_ = true;
             // override settings for metadata only segments
            segmentInfo.timingInfo = {
                start: 0
            };
            segmentInfo.waitingOnAppends++;
            if (!this.isPendingTimestampOffset_) {
                // update the timestampoffset
                this.updateSourceBufferTimestampOffset_(segmentInfo); // make sure the metadata queue is processed even though we have
                // no video/audio data.
                this.processMetadataQueue_();
            } // append is "done" instantly with no data.
            this.checkAppendsDone_(segmentInfo);
            return;
        } // Since source updater could call back synchronously, do the increments first.
        if (waitForVideo) segmentInfo.waitingOnAppends++;
        if (waitForAudio) segmentInfo.waitingOnAppends++;
        if (waitForVideo) this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
        if (waitForAudio) this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
    }
    checkAppendsDone_(segmentInfo) {
        if (this.checkForAbort_(segmentInfo.requestId)) return;
        segmentInfo.waitingOnAppends--;
        if (segmentInfo.waitingOnAppends === 0) this.handleAppendsDone_();
    }
    checkForIllegalMediaSwitch(trackInfo) {
        const illegalMediaSwitchError = $86defbb4e95ebb07$var$illegalMediaSwitch(this.loaderType_, this.getCurrentMediaInfo_(), trackInfo);
        if (illegalMediaSwitchError) {
            this.error({
                message: illegalMediaSwitchError,
                playlistExclusionDuration: Infinity
            });
            this.trigger('error');
            return true;
        }
        return false;
    }
    updateSourceBufferTimestampOffset_(segmentInfo) {
        if (segmentInfo.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
        // priority, timing-wise, so we must wait
        typeof segmentInfo.timingInfo.start !== 'number' || // already updated the timestamp offset for this segment
        segmentInfo.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
        this.loaderType_ !== 'main') return;
        let didChange = false; // Primary timing goes by video, and audio is trimmed in the transmuxer, meaning that
        // the timing info here comes from video. In the event that the audio is longer than
        // the video, this will trim the start of the audio.
        // This also trims any offset from 0 at the beginning of the media
        segmentInfo.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
            videoTimingInfo: segmentInfo.segment.videoTimingInfo,
            audioTimingInfo: segmentInfo.segment.audioTimingInfo,
            timingInfo: segmentInfo.timingInfo
        }); // In the event that there are part segment downloads, each will try to update the
        // timestamp offset. Retaining this bit of state prevents us from updating in the
        // future (within the same segment), however, there may be a better way to handle it.
        segmentInfo.changedTimestampOffset = true;
        if (segmentInfo.timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) {
            this.sourceUpdater_.videoTimestampOffset(segmentInfo.timestampOffset);
            didChange = true;
        }
        if (segmentInfo.timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) {
            this.sourceUpdater_.audioTimestampOffset(segmentInfo.timestampOffset);
            didChange = true;
        }
        if (didChange) this.trigger('timestampoffset');
    }
    getSegmentStartTimeForTimestampOffsetCalculation_({ videoTimingInfo: videoTimingInfo, audioTimingInfo: audioTimingInfo, timingInfo: timingInfo }) {
        if (!this.useDtsForTimestampOffset_) return timingInfo.start;
        if (videoTimingInfo && typeof videoTimingInfo.transmuxedDecodeStart === 'number') return videoTimingInfo.transmuxedDecodeStart;
         // handle audio only
        if (audioTimingInfo && typeof audioTimingInfo.transmuxedDecodeStart === 'number') return audioTimingInfo.transmuxedDecodeStart;
         // handle content not transmuxed (e.g., MP4)
        return timingInfo.start;
    }
    updateTimingInfoEnd_(segmentInfo) {
        segmentInfo.timingInfo = segmentInfo.timingInfo || {};
        const trackInfo = this.getMediaInfo_();
        const useVideoTimingInfo = this.loaderType_ === 'main' && trackInfo && trackInfo.hasVideo;
        const prioritizedTimingInfo = useVideoTimingInfo && segmentInfo.videoTimingInfo ? segmentInfo.videoTimingInfo : segmentInfo.audioTimingInfo;
        if (!prioritizedTimingInfo) return;
        segmentInfo.timingInfo.end = typeof prioritizedTimingInfo.end === 'number' ? // End time may not exist in a case where we aren't parsing the full segment (one
        // current example is the case of fmp4), so use the rough duration to calculate an
        // end time.
        prioritizedTimingInfo.end : prioritizedTimingInfo.start + segmentInfo.duration;
    }
    /**
   * callback to run when appendBuffer is finished. detects if we are
   * in a good state to do things with the data we got, or if we need
   * to wait for more
   *
   * @private
   */ handleAppendsDone_() {
        // appendsdone can cause an abort
        if (this.pendingSegment_) {
            const metadata = {
                segmentInfo: $86defbb4e95ebb07$var$segmentInfoPayload({
                    type: this.loaderType_,
                    segment: this.pendingSegment_
                })
            };
            this.trigger({
                type: 'appendsdone',
                metadata: metadata
            });
        }
        if (!this.pendingSegment_) {
            this.state = 'READY'; // TODO should this move into this.checkForAbort to speed up requests post abort in
            // all appending cases?
            if (!this.paused()) this.monitorBuffer_();
            return;
        }
        const segmentInfo = this.pendingSegment_;
        if (segmentInfo.part && segmentInfo.part.syncInfo) // low-latency flow
        segmentInfo.part.syncInfo.markAppended();
        else if (segmentInfo.segment.syncInfo) // normal flow
        segmentInfo.segment.syncInfo.markAppended();
         // Now that the end of the segment has been reached, we can set the end time. It's
        // best to wait until all appends are done so we're sure that the primary media is
        // finished (and we have its end time).
        this.updateTimingInfoEnd_(segmentInfo);
        if (this.shouldSaveSegmentTimingInfo_) // Timeline mappings should only be saved for the main loader. This is for multiple
        // reasons:
        //
        // 1) Only one mapping is saved per timeline, meaning that if both the audio loader
        //    and the main loader try to save the timeline mapping, whichever comes later
        //    will overwrite the first. In theory this is OK, as the mappings should be the
        //    same, however, it breaks for (2)
        // 2) In the event of a live stream, the initial live point will make for a somewhat
        //    arbitrary mapping. If audio and video streams are not perfectly in-sync, then
        //    the mapping will be off for one of the streams, dependent on which one was
        //    first saved (see (1)).
        // 3) Primary timing goes by video in VHS, so the mapping should be video.
        //
        // Since the audio loader will wait for the main loader to load the first segment,
        // the main loader will save the first timeline mapping, and ensure that there won't
        // be a case where audio loads two segments without saving a mapping (thus leading
        // to missing segment timing info).
        this.syncController_.saveSegmentTimingInfo({
            segmentInfo: segmentInfo,
            shouldSaveTimelineMapping: this.loaderType_ === 'main'
        });
        const segmentDurationMessage = $86defbb4e95ebb07$var$getTroublesomeSegmentDurationMessage(segmentInfo, this.sourceType_);
        if (segmentDurationMessage) {
            if (segmentDurationMessage.severity === 'warn') $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn(segmentDurationMessage.message);
            else this.logger_(segmentDurationMessage.message);
        }
        this.recordThroughput_(segmentInfo);
        this.pendingSegment_ = null;
        this.state = 'READY';
        if (segmentInfo.isSyncRequest) {
            this.trigger('syncinfoupdate'); // if the sync request was not appended
            // then it was not the correct segment.
            // throw it away and use the data it gave us
            // to get the correct one.
            if (!segmentInfo.hasAppendedData_) {
                this.logger_(`Throwing away un-appended sync request ${$86defbb4e95ebb07$var$segmentInfoString(segmentInfo)}`);
                return;
            }
        }
        this.logger_(`Appended ${$86defbb4e95ebb07$var$segmentInfoString(segmentInfo)}`);
        this.addSegmentMetadataCue_(segmentInfo);
        this.fetchAtBuffer_ = true;
        if (this.currentTimeline_ !== segmentInfo.timeline) {
            this.timelineChangeController_.lastTimelineChange({
                type: this.loaderType_,
                from: this.currentTimeline_,
                to: segmentInfo.timeline
            }); // If audio is not disabled, the main segment loader is responsible for updating
            // the audio timeline as well. If the content is video only, this won't have any
            // impact.
            if (this.loaderType_ === 'main' && !this.audioDisabled_) this.timelineChangeController_.lastTimelineChange({
                type: 'audio',
                from: this.currentTimeline_,
                to: segmentInfo.timeline
            });
        }
        this.currentTimeline_ = segmentInfo.timeline; // We must update the syncinfo to recalculate the seekable range before
        // the following conditional otherwise it may consider this a bad "guess"
        // and attempt to resync when the post-update seekable window and live
        // point would mean that this was the perfect segment to fetch
        this.trigger('syncinfoupdate');
        const segment = segmentInfo.segment;
        const part = segmentInfo.part;
        const badSegmentGuess = segment.end && this.currentTime_() - segment.end > segmentInfo.playlist.targetDuration * 3;
        const badPartGuess = part && part.end && this.currentTime_() - part.end > segmentInfo.playlist.partTargetDuration * 3; // If we previously appended a segment/part that ends more than 3 part/targetDurations before
        // the currentTime_ that means that our conservative guess was too conservative.
        // In that case, reset the loader state so that we try to use any information gained
        // from the previous request to create a new, more accurate, sync-point.
        if (badSegmentGuess || badPartGuess) {
            this.logger_(`bad ${badSegmentGuess ? 'segment' : 'part'} ${$86defbb4e95ebb07$var$segmentInfoString(segmentInfo)}`);
            this.resetEverything();
            return;
        }
        const isWalkingForward = this.mediaIndex !== null; // Don't do a rendition switch unless we have enough time to get a sync segment
        // and conservatively guess
        if (isWalkingForward) this.trigger('bandwidthupdate');
        this.trigger('progress');
        this.mediaIndex = segmentInfo.mediaIndex;
        this.partIndex = segmentInfo.partIndex; // any time an update finishes and the last segment is in the
        // buffer, end the stream. this ensures the "ended" event will
        // fire if playback reaches that point.
        if (this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex)) this.endOfStream();
         // used for testing
        this.trigger('appended');
        if (segmentInfo.hasAppendedData_) this.mediaAppends++;
        if (!this.paused()) this.monitorBuffer_();
    }
    /**
   * Records the current throughput of the decrypt, transmux, and append
   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
   * moving average of the throughput. `throughput.count` is the number of
   * data points in the average.
   *
   * @private
   * @param {Object} segmentInfo the object returned by loadSegment
   */ recordThroughput_(segmentInfo) {
        if (segmentInfo.duration < $86defbb4e95ebb07$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
            this.logger_(`Ignoring segment's throughput because its duration of ${segmentInfo.duration}` + ` is less than the min to record ${$86defbb4e95ebb07$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS}`);
            return;
        }
        const rate = this.throughput.rate; // Add one to the time to ensure that we don't accidentally attempt to divide
        // by zero in the case where the throughput is ridiculously high
        const segmentProcessingTime = Date.now() - segmentInfo.endOfAllRequests + 1; // Multiply by 8000 to convert from bytes/millisecond to bits/second
        const segmentProcessingThroughput = Math.floor(segmentInfo.byteLength / segmentProcessingTime * 8000); // This is just a cumulative moving average calculation:
        //   newAvg = oldAvg + (sample - oldAvg) / (sampleCount + 1)
        this.throughput.rate += (segmentProcessingThroughput - rate) / ++this.throughput.count;
    }
    /**
   * Adds a cue to the segment-metadata track with some metadata information about the
   * segment
   *
   * @private
   * @param {Object} segmentInfo
   *        the object returned by loadSegment
   * @method addSegmentMetadataCue_
   */ addSegmentMetadataCue_(segmentInfo) {
        if (!this.segmentMetadataTrack_) return;
        const segment = segmentInfo.segment;
        const start = segment.start;
        const end = segment.end; // Do not try adding the cue if the start and end times are invalid.
        if (!$86defbb4e95ebb07$var$finite(start) || !$86defbb4e95ebb07$var$finite(end)) return;
        $86defbb4e95ebb07$var$removeCuesFromTrack(start, end, this.segmentMetadataTrack_);
        const Cue = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebKitDataCue || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).VTTCue;
        const value = {
            custom: segment.custom,
            dateTimeObject: segment.dateTimeObject,
            dateTimeString: segment.dateTimeString,
            programDateTime: segment.programDateTime,
            bandwidth: segmentInfo.playlist.attributes.BANDWIDTH,
            resolution: segmentInfo.playlist.attributes.RESOLUTION,
            codecs: segmentInfo.playlist.attributes.CODECS,
            byteLength: segmentInfo.byteLength,
            uri: segmentInfo.uri,
            timeline: segmentInfo.timeline,
            playlist: segmentInfo.playlist.id,
            start: start,
            end: end
        };
        const data = JSON.stringify(value);
        const cue = new Cue(start, end, data); // Attach the metadata to the value property of the cue to keep consistency between
        // the differences of WebKitDataCue in safari and VTTCue in other browsers
        cue.value = value;
        this.segmentMetadataTrack_.addCue(cue);
    }
}
function $86defbb4e95ebb07$var$noop() {}
const $86defbb4e95ebb07$var$toTitleCase = function(string) {
    if (typeof string !== 'string') return string;
    return string.replace(/./, (w)=>w.toUpperCase());
};
/**
 * @file source-updater.js
 */ const $86defbb4e95ebb07$var$bufferTypes = [
    'video',
    'audio'
];
const $86defbb4e95ebb07$var$updating = (type, sourceUpdater)=>{
    const sourceBuffer = sourceUpdater[`${type}Buffer`];
    return sourceBuffer && sourceBuffer.updating || sourceUpdater.queuePending[type];
};
const $86defbb4e95ebb07$var$nextQueueIndexOfType = (type, queue)=>{
    for(let i = 0; i < queue.length; i++){
        const queueEntry = queue[i];
        if (queueEntry.type === 'mediaSource') // If the next entry is a media source entry (uses multiple source buffers), block
        // processing to allow it to go through first.
        return null;
        if (queueEntry.type === type) return i;
    }
    return null;
};
const $86defbb4e95ebb07$var$shiftQueue = (type, sourceUpdater)=>{
    if (sourceUpdater.queue.length === 0) return;
    let queueIndex = 0;
    let queueEntry = sourceUpdater.queue[queueIndex];
    if (queueEntry.type === 'mediaSource') {
        if (!sourceUpdater.updating() && sourceUpdater.mediaSource.readyState !== 'closed') {
            sourceUpdater.queue.shift();
            queueEntry.action(sourceUpdater);
            if (queueEntry.doneFn) queueEntry.doneFn();
             // Only specific source buffer actions must wait for async updateend events. Media
            // Source actions process synchronously. Therefore, both audio and video source
            // buffers are now clear to process the next queue entries.
            $86defbb4e95ebb07$var$shiftQueue('audio', sourceUpdater);
            $86defbb4e95ebb07$var$shiftQueue('video', sourceUpdater);
        } // Media Source actions require both source buffers, so if the media source action
        // couldn't process yet (because one or both source buffers are busy), block other
        // queue actions until both are available and the media source action can process.
        return;
    }
    if (type === 'mediaSource') // If the queue was shifted by a media source action (this happens when pushing a
    // media source action onto the queue), then it wasn't from an updateend event from an
    // audio or video source buffer, so there's no change from previous state, and no
    // processing should be done.
    return;
     // Media source queue entries don't need to consider whether the source updater is
    // started (i.e., source buffers are created) as they don't need the source buffers, but
    // source buffer queue entries do.
    if (!sourceUpdater.ready() || sourceUpdater.mediaSource.readyState === 'closed' || $86defbb4e95ebb07$var$updating(type, sourceUpdater)) return;
    if (queueEntry.type !== type) {
        queueIndex = $86defbb4e95ebb07$var$nextQueueIndexOfType(type, sourceUpdater.queue);
        if (queueIndex === null) // Either there's no queue entry that uses this source buffer type in the queue, or
        // there's a media source queue entry before the next entry of this type, in which
        // case wait for that action to process first.
        return;
        queueEntry = sourceUpdater.queue[queueIndex];
    }
    sourceUpdater.queue.splice(queueIndex, 1); // Keep a record that this source buffer type is in use.
    //
    // The queue pending operation must be set before the action is performed in the event
    // that the action results in a synchronous event that is acted upon. For instance, if
    // an exception is thrown that can be handled, it's possible that new actions will be
    // appended to an empty queue and immediately executed, but would not have the correct
    // pending information if this property was set after the action was performed.
    sourceUpdater.queuePending[type] = queueEntry;
    queueEntry.action(type, sourceUpdater);
    if (!queueEntry.doneFn) {
        // synchronous operation, process next entry
        sourceUpdater.queuePending[type] = null;
        $86defbb4e95ebb07$var$shiftQueue(type, sourceUpdater);
        return;
    }
};
const $86defbb4e95ebb07$var$cleanupBuffer = (type, sourceUpdater)=>{
    const buffer = sourceUpdater[`${type}Buffer`];
    const titleType = $86defbb4e95ebb07$var$toTitleCase(type);
    if (!buffer) return;
    buffer.removeEventListener('updateend', sourceUpdater[`on${titleType}UpdateEnd_`]);
    buffer.removeEventListener('error', sourceUpdater[`on${titleType}Error_`]);
    sourceUpdater.codecs[type] = null;
    sourceUpdater[`${type}Buffer`] = null;
};
const $86defbb4e95ebb07$var$inSourceBuffers = (mediaSource, sourceBuffer)=>mediaSource && sourceBuffer && Array.prototype.indexOf.call(mediaSource.sourceBuffers, sourceBuffer) !== -1;
const $86defbb4e95ebb07$var$actions = {
    appendBuffer: (bytes, segmentInfo, onError)=>(type, sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`]; // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$86defbb4e95ebb07$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`Appending segment ${segmentInfo.mediaIndex}'s ${bytes.length} bytes to ${type}Buffer`);
            try {
                sourceBuffer.appendBuffer(bytes);
            } catch (e) {
                sourceUpdater.logger_(`Error with code ${e.code} ` + (e.code === $86defbb4e95ebb07$var$QUOTA_EXCEEDED_ERR ? '(QUOTA_EXCEEDED_ERR) ' : '') + `when appending segment ${segmentInfo.mediaIndex} to ${type}Buffer`);
                sourceUpdater.queuePending[type] = null;
                onError(e);
            }
        },
    remove: (start, end)=>(type, sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`]; // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$86defbb4e95ebb07$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`Removing ${start} to ${end} from ${type}Buffer`);
            try {
                sourceBuffer.remove(start, end);
            } catch (e) {
                sourceUpdater.logger_(`Remove ${start} to ${end} from ${type}Buffer failed`);
            }
        },
    timestampOffset: (offset)=>(type, sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`]; // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$86defbb4e95ebb07$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`Setting ${type}timestampOffset to ${offset}`);
            sourceBuffer.timestampOffset = offset;
        },
    callback: (callback)=>(type, sourceUpdater)=>{
            callback();
        },
    endOfStream: (error)=>(sourceUpdater)=>{
            if (sourceUpdater.mediaSource.readyState !== 'open') return;
            sourceUpdater.logger_(`Calling mediaSource endOfStream(${error || ''})`);
            try {
                sourceUpdater.mediaSource.endOfStream(error);
            } catch (e) {
                $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn('Failed to call media source endOfStream', e);
            }
        },
    duration: (duration)=>(sourceUpdater)=>{
            sourceUpdater.logger_(`Setting mediaSource duration to ${duration}`);
            try {
                sourceUpdater.mediaSource.duration = duration;
            } catch (e) {
                $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn('Failed to set media source duration', e);
            }
        },
    abort: ()=>(type, sourceUpdater)=>{
            if (sourceUpdater.mediaSource.readyState !== 'open') return;
            const sourceBuffer = sourceUpdater[`${type}Buffer`]; // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$86defbb4e95ebb07$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`calling abort on ${type}Buffer`);
            try {
                sourceBuffer.abort();
            } catch (e) {
                $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn(`Failed to abort on ${type}Buffer`, e);
            }
        },
    addSourceBuffer: (type, codec)=>(sourceUpdater)=>{
            const titleType = $86defbb4e95ebb07$var$toTitleCase(type);
            const mime = (0, $34bf5acfb37ee851$export$4b64fc0a026b9981)(codec);
            sourceUpdater.logger_(`Adding ${type}Buffer with codec ${codec} to mediaSource`);
            const sourceBuffer = sourceUpdater.mediaSource.addSourceBuffer(mime);
            sourceBuffer.addEventListener('updateend', sourceUpdater[`on${titleType}UpdateEnd_`]);
            sourceBuffer.addEventListener('error', sourceUpdater[`on${titleType}Error_`]);
            sourceUpdater.codecs[type] = codec;
            sourceUpdater[`${type}Buffer`] = sourceBuffer;
        },
    removeSourceBuffer: (type)=>(sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`];
            $86defbb4e95ebb07$var$cleanupBuffer(type, sourceUpdater); // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$86defbb4e95ebb07$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`Removing ${type}Buffer with codec ${sourceUpdater.codecs[type]} from mediaSource`);
            try {
                sourceUpdater.mediaSource.removeSourceBuffer(sourceBuffer);
            } catch (e) {
                $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn(`Failed to removeSourceBuffer ${type}Buffer`, e);
            }
        },
    changeType: (codec)=>(type, sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`];
            const mime = (0, $34bf5acfb37ee851$export$4b64fc0a026b9981)(codec); // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$86defbb4e95ebb07$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
             // do not update codec if we don't need to.
            // Only update if we change the codec base.
            // For example, going from avc1.640028 to avc1.64001f does not require a changeType call.
            const newCodecBase = codec.substring(0, codec.indexOf('.'));
            const oldCodec = sourceUpdater.codecs[type];
            const oldCodecBase = oldCodec.substring(0, oldCodec.indexOf('.'));
            if (oldCodecBase === newCodecBase) return;
            const metadata = {
                codecsChangeInfo: {
                    from: oldCodec,
                    to: codec
                }
            };
            sourceUpdater.trigger({
                type: 'codecschange',
                metadata: metadata
            });
            sourceUpdater.logger_(`changing ${type}Buffer codec from ${oldCodec} to ${codec}`); // check if change to the provided type is supported
            try {
                sourceBuffer.changeType(mime);
                sourceUpdater.codecs[type] = codec;
            } catch (e) {
                metadata.errorType = $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.StreamingCodecsChangeError;
                metadata.error = e;
                e.metadata = metadata;
                sourceUpdater.error_ = e;
                sourceUpdater.trigger('error');
                $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn(`Failed to changeType on ${type}Buffer`, e);
            }
        }
};
const $86defbb4e95ebb07$var$pushQueue = ({ type: type, sourceUpdater: sourceUpdater, action: action, doneFn: doneFn, name: name })=>{
    sourceUpdater.queue.push({
        type: type,
        action: action,
        doneFn: doneFn,
        name: name
    });
    $86defbb4e95ebb07$var$shiftQueue(type, sourceUpdater);
};
const $86defbb4e95ebb07$var$onUpdateend = (type, sourceUpdater)=>(e)=>{
        // Although there should, in theory, be a pending action for any updateend receieved,
        // there are some actions that may trigger updateend events without set definitions in
        // the w3c spec. For instance, setting the duration on the media source may trigger
        // updateend events on source buffers. This does not appear to be in the spec. As such,
        // if we encounter an updateend without a corresponding pending action from our queue
        // for that source buffer type, process the next action.
        const bufferedRangesForType = sourceUpdater[`${type}Buffered`]();
        const descriptiveString = $86defbb4e95ebb07$var$bufferedRangesToString(bufferedRangesForType);
        sourceUpdater.logger_(`received "updateend" event for ${type} Source Buffer: `, descriptiveString);
        if (sourceUpdater.queuePending[type]) {
            const doneFn = sourceUpdater.queuePending[type].doneFn;
            sourceUpdater.queuePending[type] = null;
            if (doneFn) // if there's an error, report it
            doneFn(sourceUpdater[`${type}Error_`]);
        }
        $86defbb4e95ebb07$var$shiftQueue(type, sourceUpdater);
    };
/**
 * A queue of callbacks to be serialized and applied when a
 * MediaSource and its associated SourceBuffers are not in the
 * updating state. It is used by the segment loader to update the
 * underlying SourceBuffers when new data is loaded, for instance.
 *
 * @class SourceUpdater
 * @param {MediaSource} mediaSource the MediaSource to create the SourceBuffer from
 * @param {string} mimeType the desired MIME type of the underlying SourceBuffer
 */ class $86defbb4e95ebb07$var$SourceUpdater extends $86defbb4e95ebb07$export$2e2bcd8739ae039.EventTarget {
    constructor(mediaSource){
        super();
        this.mediaSource = mediaSource;
        this.sourceopenListener_ = ()=>$86defbb4e95ebb07$var$shiftQueue('mediaSource', this);
        this.mediaSource.addEventListener('sourceopen', this.sourceopenListener_);
        this.logger_ = $86defbb4e95ebb07$var$logger('SourceUpdater'); // initial timestamp offset is 0
        this.audioTimestampOffset_ = 0;
        this.videoTimestampOffset_ = 0;
        this.queue = [];
        this.queuePending = {
            audio: null,
            video: null
        };
        this.delayedAudioAppendQueue_ = [];
        this.videoAppendQueued_ = false;
        this.codecs = {};
        this.onVideoUpdateEnd_ = $86defbb4e95ebb07$var$onUpdateend('video', this);
        this.onAudioUpdateEnd_ = $86defbb4e95ebb07$var$onUpdateend('audio', this);
        this.onVideoError_ = (e)=>{
            // used for debugging
            this.videoError_ = e;
        };
        this.onAudioError_ = (e)=>{
            // used for debugging
            this.audioError_ = e;
        };
        this.createdSourceBuffers_ = false;
        this.initializedEme_ = false;
        this.triggeredReady_ = false;
    }
    initializedEme() {
        this.initializedEme_ = true;
        this.triggerReady();
    }
    hasCreatedSourceBuffers() {
        // if false, likely waiting on one of the segment loaders to get enough data to create
        // source buffers
        return this.createdSourceBuffers_;
    }
    hasInitializedAnyEme() {
        return this.initializedEme_;
    }
    ready() {
        return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
    }
    createSourceBuffers(codecs) {
        if (this.hasCreatedSourceBuffers()) // already created them before
        return;
         // the intial addOrChangeSourceBuffers will always be
        // two add buffers.
        this.addOrChangeSourceBuffers(codecs);
        this.createdSourceBuffers_ = true;
        this.trigger('createdsourcebuffers');
        this.triggerReady();
    }
    triggerReady() {
        // only allow ready to be triggered once, this prevents the case
        // where:
        // 1. we trigger createdsourcebuffers
        // 2. ie 11 synchronously initializates eme
        // 3. the synchronous initialization causes us to trigger ready
        // 4. We go back to the ready check in createSourceBuffers and ready is triggered again.
        if (this.ready() && !this.triggeredReady_) {
            this.triggeredReady_ = true;
            this.trigger('ready');
        }
    }
    /**
   * Add a type of source buffer to the media source.
   *
   * @param {string} type
   *        The type of source buffer to add.
   *
   * @param {string} codec
   *        The codec to add the source buffer with.
   */ addSourceBuffer(type, codec) {
        $86defbb4e95ebb07$var$pushQueue({
            type: 'mediaSource',
            sourceUpdater: this,
            action: $86defbb4e95ebb07$var$actions.addSourceBuffer(type, codec),
            name: 'addSourceBuffer'
        });
    }
    /**
   * call abort on a source buffer.
   *
   * @param {string} type
   *        The type of source buffer to call abort on.
   */ abort(type) {
        $86defbb4e95ebb07$var$pushQueue({
            type: type,
            sourceUpdater: this,
            action: $86defbb4e95ebb07$var$actions.abort(type),
            name: 'abort'
        });
    }
    /**
   * Call removeSourceBuffer and remove a specific type
   * of source buffer on the mediaSource.
   *
   * @param {string} type
   *        The type of source buffer to remove.
   */ removeSourceBuffer(type) {
        if (!this.canRemoveSourceBuffer()) {
            $86defbb4e95ebb07$export$2e2bcd8739ae039.log.error('removeSourceBuffer is not supported!');
            return;
        }
        $86defbb4e95ebb07$var$pushQueue({
            type: 'mediaSource',
            sourceUpdater: this,
            action: $86defbb4e95ebb07$var$actions.removeSourceBuffer(type),
            name: 'removeSourceBuffer'
        });
    }
    /**
   * Whether or not the removeSourceBuffer function is supported
   * on the mediaSource.
   *
   * @return {boolean}
   *          if removeSourceBuffer can be called.
   */ canRemoveSourceBuffer() {
        // As of Firefox 83 removeSourceBuffer
        // throws errors, so we report that it does not support this.
        return !$86defbb4e95ebb07$export$2e2bcd8739ae039.browser.IS_FIREFOX && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).MediaSource && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).MediaSource.prototype && typeof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).MediaSource.prototype.removeSourceBuffer === 'function';
    }
    /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */ static canChangeType() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).SourceBuffer && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).SourceBuffer.prototype && typeof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).SourceBuffer.prototype.changeType === 'function';
    }
    /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */ canChangeType() {
        return this.constructor.canChangeType();
    }
    /**
   * Call the changeType function on a source buffer, given the code and type.
   *
   * @param {string} type
   *        The type of source buffer to call changeType on.
   *
   * @param {string} codec
   *        The codec string to change type with on the source buffer.
   */ changeType(type, codec) {
        if (!this.canChangeType()) {
            $86defbb4e95ebb07$export$2e2bcd8739ae039.log.error('changeType is not supported!');
            return;
        }
        $86defbb4e95ebb07$var$pushQueue({
            type: type,
            sourceUpdater: this,
            action: $86defbb4e95ebb07$var$actions.changeType(codec),
            name: 'changeType'
        });
    }
    /**
   * Add source buffers with a codec or, if they are already created,
   * call changeType on source buffers using changeType.
   *
   * @param {Object} codecs
   *        Codecs to switch to
   */ addOrChangeSourceBuffers(codecs) {
        if (!codecs || typeof codecs !== 'object' || Object.keys(codecs).length === 0) throw new Error('Cannot addOrChangeSourceBuffers to undefined codecs');
        Object.keys(codecs).forEach((type)=>{
            const codec = codecs[type];
            if (!this.hasCreatedSourceBuffers()) return this.addSourceBuffer(type, codec);
            if (this.canChangeType()) this.changeType(type, codec);
        });
    }
    /**
   * Queue an update to append an ArrayBuffer.
   *
   * @param {MediaObject} object containing audioBytes and/or videoBytes
   * @param {Function} done the function to call when done
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
   */ appendBuffer(options, doneFn) {
        const { segmentInfo: segmentInfo, type: type, bytes: bytes } = options;
        this.processedAppend_ = true;
        if (type === 'audio' && this.videoBuffer && !this.videoAppendQueued_) {
            this.delayedAudioAppendQueue_.push([
                options,
                doneFn
            ]);
            this.logger_(`delayed audio append of ${bytes.length} until video append`);
            return;
        } // In the case of certain errors, for instance, QUOTA_EXCEEDED_ERR, updateend will
        // not be fired. This means that the queue will be blocked until the next action
        // taken by the segment-loader. Provide a mechanism for segment-loader to handle
        // these errors by calling the doneFn with the specific error.
        const onError = doneFn;
        $86defbb4e95ebb07$var$pushQueue({
            type: type,
            sourceUpdater: this,
            action: $86defbb4e95ebb07$var$actions.appendBuffer(bytes, segmentInfo || {
                mediaIndex: -1
            }, onError),
            doneFn: doneFn,
            name: 'appendBuffer'
        });
        if (type === 'video') {
            this.videoAppendQueued_ = true;
            if (!this.delayedAudioAppendQueue_.length) return;
            const queue = this.delayedAudioAppendQueue_.slice();
            this.logger_(`queuing delayed audio ${queue.length} appendBuffers`);
            this.delayedAudioAppendQueue_.length = 0;
            queue.forEach((que)=>{
                this.appendBuffer.apply(this, que);
            });
        }
    }
    /**
   * Get the audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The audio buffer's buffered time range
   */ audioBuffered() {
        // no media source/source buffer or it isn't in the media sources
        // source buffer list
        if (!$86defbb4e95ebb07$var$inSourceBuffers(this.mediaSource, this.audioBuffer)) return $86defbb4e95ebb07$var$createTimeRanges();
        return this.audioBuffer.buffered ? this.audioBuffer.buffered : $86defbb4e95ebb07$var$createTimeRanges();
    }
    /**
   * Get the video buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The video buffer's buffered time range
   */ videoBuffered() {
        // no media source/source buffer or it isn't in the media sources
        // source buffer list
        if (!$86defbb4e95ebb07$var$inSourceBuffers(this.mediaSource, this.videoBuffer)) return $86defbb4e95ebb07$var$createTimeRanges();
        return this.videoBuffer.buffered ? this.videoBuffer.buffered : $86defbb4e95ebb07$var$createTimeRanges();
    }
    /**
   * Get a combined video/audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         the combined time range
   */ buffered() {
        const video = $86defbb4e95ebb07$var$inSourceBuffers(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null;
        const audio = $86defbb4e95ebb07$var$inSourceBuffers(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
        if (audio && !video) return this.audioBuffered();
        if (video && !audio) return this.videoBuffered();
        return $86defbb4e95ebb07$var$bufferIntersection(this.audioBuffered(), this.videoBuffered());
    }
    /**
   * Add a callback to the queue that will set duration on the mediaSource.
   *
   * @param {number} duration
   *        The duration to set
   *
   * @param {Function} [doneFn]
   *        function to run after duration has been set.
   */ setDuration(duration, doneFn = $86defbb4e95ebb07$var$noop) {
        // In order to set the duration on the media source, it's necessary to wait for all
        // source buffers to no longer be updating. "If the updating attribute equals true on
        // any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
        // abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
        $86defbb4e95ebb07$var$pushQueue({
            type: 'mediaSource',
            sourceUpdater: this,
            action: $86defbb4e95ebb07$var$actions.duration(duration),
            name: 'duration',
            doneFn: doneFn
        });
    }
    /**
   * Add a mediaSource endOfStream call to the queue
   *
   * @param {Error} [error]
   *        Call endOfStream with an error
   *
   * @param {Function} [doneFn]
   *        A function that should be called when the
   *        endOfStream call has finished.
   */ endOfStream(error = null, doneFn = $86defbb4e95ebb07$var$noop) {
        if (typeof error !== 'string') error = undefined;
         // In order to set the duration on the media source, it's necessary to wait for all
        // source buffers to no longer be updating. "If the updating attribute equals true on
        // any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
        // abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
        $86defbb4e95ebb07$var$pushQueue({
            type: 'mediaSource',
            sourceUpdater: this,
            action: $86defbb4e95ebb07$var$actions.endOfStream(error),
            name: 'endOfStream',
            doneFn: doneFn
        });
    }
    /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */ removeAudio(start, end, done = $86defbb4e95ebb07$var$noop) {
        if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
            done();
            return;
        }
        $86defbb4e95ebb07$var$pushQueue({
            type: 'audio',
            sourceUpdater: this,
            action: $86defbb4e95ebb07$var$actions.remove(start, end),
            doneFn: done,
            name: 'remove'
        });
    }
    /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */ removeVideo(start, end, done = $86defbb4e95ebb07$var$noop) {
        if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
            done();
            return;
        }
        $86defbb4e95ebb07$var$pushQueue({
            type: 'video',
            sourceUpdater: this,
            action: $86defbb4e95ebb07$var$actions.remove(start, end),
            doneFn: done,
            name: 'remove'
        });
    }
    /**
   * Whether the underlying sourceBuffer is updating or not
   *
   * @return {boolean} the updating status of the SourceBuffer
   */ updating() {
        // the audio/video source buffer is updating
        if ($86defbb4e95ebb07$var$updating('audio', this) || $86defbb4e95ebb07$var$updating('video', this)) return true;
        return false;
    }
    /**
   * Set/get the timestampoffset on the audio SourceBuffer
   *
   * @return {number} the timestamp offset
   */ audioTimestampOffset(offset) {
        if (typeof offset !== 'undefined' && this.audioBuffer && // no point in updating if it's the same
        this.audioTimestampOffset_ !== offset) {
            $86defbb4e95ebb07$var$pushQueue({
                type: 'audio',
                sourceUpdater: this,
                action: $86defbb4e95ebb07$var$actions.timestampOffset(offset),
                name: 'timestampOffset'
            });
            this.audioTimestampOffset_ = offset;
        }
        return this.audioTimestampOffset_;
    }
    /**
   * Set/get the timestampoffset on the video SourceBuffer
   *
   * @return {number} the timestamp offset
   */ videoTimestampOffset(offset) {
        if (typeof offset !== 'undefined' && this.videoBuffer && // no point in updating if it's the same
        this.videoTimestampOffset_ !== offset) {
            $86defbb4e95ebb07$var$pushQueue({
                type: 'video',
                sourceUpdater: this,
                action: $86defbb4e95ebb07$var$actions.timestampOffset(offset),
                name: 'timestampOffset'
            });
            this.videoTimestampOffset_ = offset;
        }
        return this.videoTimestampOffset_;
    }
    /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the audio queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */ audioQueueCallback(callback) {
        if (!this.audioBuffer) return;
        $86defbb4e95ebb07$var$pushQueue({
            type: 'audio',
            sourceUpdater: this,
            action: $86defbb4e95ebb07$var$actions.callback(callback),
            name: 'callback'
        });
    }
    /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the video queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */ videoQueueCallback(callback) {
        if (!this.videoBuffer) return;
        $86defbb4e95ebb07$var$pushQueue({
            type: 'video',
            sourceUpdater: this,
            action: $86defbb4e95ebb07$var$actions.callback(callback),
            name: 'callback'
        });
    }
    /**
   * dispose of the source updater and the underlying sourceBuffer
   */ dispose() {
        this.trigger('dispose');
        $86defbb4e95ebb07$var$bufferTypes.forEach((type)=>{
            this.abort(type);
            if (this.canRemoveSourceBuffer()) this.removeSourceBuffer(type);
            else this[`${type}QueueCallback`](()=>$86defbb4e95ebb07$var$cleanupBuffer(type, this));
        });
        this.videoAppendQueued_ = false;
        this.delayedAudioAppendQueue_.length = 0;
        if (this.sourceopenListener_) this.mediaSource.removeEventListener('sourceopen', this.sourceopenListener_);
        this.off();
    }
}
const $86defbb4e95ebb07$var$uint8ToUtf8 = (uintArray)=>decodeURIComponent(escape(String.fromCharCode.apply(null, uintArray)));
const $86defbb4e95ebb07$var$bufferToHexString = (buffer)=>{
    const uInt8Buffer = new Uint8Array(buffer);
    return Array.from(uInt8Buffer).map((byte)=>byte.toString(16).padStart(2, '0')).join('');
};
/**
 * @file vtt-segment-loader.js
 */ const $86defbb4e95ebb07$var$VTT_LINE_TERMINATORS = new Uint8Array('\n\n'.split('').map((char)=>char.charCodeAt(0)));
class $86defbb4e95ebb07$var$NoVttJsError extends Error {
    constructor(){
        super('Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.');
    }
}
/**
 * An object that manages segment loading and appending.
 *
 * @class VTTSegmentLoader
 * @param {Object} options required and optional options
 * @extends videojs.EventTarget
 */ class $86defbb4e95ebb07$var$VTTSegmentLoader extends $86defbb4e95ebb07$var$SegmentLoader {
    constructor(settings, options = {}){
        super(settings, options); // SegmentLoader requires a MediaSource be specified or it will throw an error;
        // however, VTTSegmentLoader has no need of a media source, so delete the reference
        this.mediaSource_ = null;
        this.subtitlesTrack_ = null;
        this.featuresNativeTextTracks_ = settings.featuresNativeTextTracks;
        this.loadVttJs = settings.loadVttJs; // The VTT segment will have its own time mappings. Saving VTT segment timing info in
        // the sync controller leads to improper behavior.
        this.shouldSaveSegmentTimingInfo_ = false;
    }
    /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */ buffered_() {
        if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length) return $86defbb4e95ebb07$var$createTimeRanges();
        const cues = this.subtitlesTrack_.cues;
        const start = cues[0].startTime;
        const end = cues[cues.length - 1].startTime;
        return $86defbb4e95ebb07$var$createTimeRanges([
            [
                start,
                end
            ]
        ]);
    }
    /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */ initSegmentForMap(map, set = false) {
        if (!map) return null;
        const id = $86defbb4e95ebb07$var$initSegmentId(map);
        let storedMap = this.initSegments_[id];
        if (set && !storedMap && map.bytes) {
            // append WebVTT line terminators to the media initialization segment if it exists
            // to follow the WebVTT spec (https://w3c.github.io/webvtt/#file-structure) that
            // requires two or more WebVTT line terminators between the WebVTT header and the
            // rest of the file
            const combinedByteLength = $86defbb4e95ebb07$var$VTT_LINE_TERMINATORS.byteLength + map.bytes.byteLength;
            const combinedSegment = new Uint8Array(combinedByteLength);
            combinedSegment.set(map.bytes);
            combinedSegment.set($86defbb4e95ebb07$var$VTT_LINE_TERMINATORS, map.bytes.byteLength);
            this.initSegments_[id] = storedMap = {
                resolvedUri: map.resolvedUri,
                byterange: map.byterange,
                bytes: combinedSegment
            };
        }
        return storedMap || map;
    }
    /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */ couldBeginLoading_() {
        return this.playlist_ && this.subtitlesTrack_ && !this.paused();
    }
    /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */ init_() {
        this.state = 'READY';
        this.resetEverything();
        return this.monitorBuffer_();
    }
    /**
   * Set a subtitle track on the segment loader to add subtitles to
   *
   * @param {TextTrack=} track
   *        The text track to add loaded subtitles to
   * @return {TextTrack}
   *        Returns the subtitles track
   */ track(track) {
        if (typeof track === 'undefined') return this.subtitlesTrack_;
        this.subtitlesTrack_ = track; // if we were unpaused but waiting for a sourceUpdater, start
        // buffering now
        if (this.state === 'INIT' && this.couldBeginLoading_()) this.init_();
        return this.subtitlesTrack_;
    }
    /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   */ remove(start, end) {
        $86defbb4e95ebb07$var$removeCuesFromTrack(start, end, this.subtitlesTrack_);
    }
    /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */ fillBuffer_() {
        // see if we need to begin loading immediately
        const segmentInfo = this.chooseNextRequest_();
        if (!segmentInfo) return;
        if (this.syncController_.timestampOffsetForTimeline(segmentInfo.timeline) === null) {
            // We don't have the timestamp offset that we need to sync subtitles.
            // Rerun on a timestamp offset or user interaction.
            const checkTimestampOffset = ()=>{
                this.state = 'READY';
                if (!this.paused()) // if not paused, queue a buffer check as soon as possible
                this.monitorBuffer_();
            };
            this.syncController_.one('timestampoffset', checkTimestampOffset);
            this.state = 'WAITING_ON_TIMELINE';
            return;
        }
        this.loadSegment_(segmentInfo);
    }
    timestampOffsetForSegment_() {
        return null;
    }
    chooseNextRequest_() {
        return this.skipEmptySegments_(super.chooseNextRequest_());
    }
    /**
   * Prevents the segment loader from requesting segments we know contain no subtitles
   * by walking forward until we find the next segment that we don't know whether it is
   * empty or not.
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @return {Object}
   *         a segment info object that describes the current segment
   */ skipEmptySegments_(segmentInfo) {
        while(segmentInfo && segmentInfo.segment.empty){
            // stop at the last possible segmentInfo
            if (segmentInfo.mediaIndex + 1 >= segmentInfo.playlist.segments.length) {
                segmentInfo = null;
                break;
            }
            segmentInfo = this.generateSegmentInfo_({
                playlist: segmentInfo.playlist,
                mediaIndex: segmentInfo.mediaIndex + 1,
                startOfSegment: segmentInfo.startOfSegment + segmentInfo.duration,
                isSyncRequest: segmentInfo.isSyncRequest
            });
        }
        return segmentInfo;
    }
    stopForError(error) {
        this.error(error);
        this.state = 'READY';
        this.pause();
        this.trigger('error');
    }
    /**
   * append a decrypted segement to the SourceBuffer through a SourceUpdater
   *
   * @private
   */ segmentRequestFinished_(error, simpleSegment, result) {
        if (!this.subtitlesTrack_) {
            this.state = 'READY';
            return;
        }
        this.saveTransferStats_(simpleSegment.stats); // the request was aborted
        if (!this.pendingSegment_) {
            this.state = 'READY';
            this.mediaRequestsAborted += 1;
            return;
        }
        if (error) {
            if (error.code === $86defbb4e95ebb07$var$REQUEST_ERRORS.TIMEOUT) this.handleTimeout_();
            if (error.code === $86defbb4e95ebb07$var$REQUEST_ERRORS.ABORTED) this.mediaRequestsAborted += 1;
            else this.mediaRequestsErrored += 1;
            this.stopForError(error);
            return;
        }
        const segmentInfo = this.pendingSegment_;
        const isMp4WebVttSegmentWithCues = result.mp4VttCues && result.mp4VttCues.length;
        if (isMp4WebVttSegmentWithCues) segmentInfo.mp4VttCues = result.mp4VttCues;
         // although the VTT segment loader bandwidth isn't really used, it's good to
        // maintain functionality between segment loaders
        this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats); // if this request included a segment key, save that data in the cache
        if (simpleSegment.key) this.segmentKey(simpleSegment.key, true);
        this.state = 'APPENDING'; // used for tests
        this.trigger('appending');
        const segment = segmentInfo.segment;
        if (segment.map) segment.map.bytes = simpleSegment.map.bytes;
        segmentInfo.bytes = simpleSegment.bytes; // Make sure that vttjs has loaded, otherwise, load it and wait till it finished loading
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT !== 'function' && typeof this.loadVttJs === 'function') {
            this.state = 'WAITING_ON_VTTJS'; // should be fine to call multiple times
            // script will be loaded once but multiple listeners will be added to the queue, which is expected.
            this.loadVttJs().then(()=>this.segmentRequestFinished_(error, simpleSegment, result), ()=>this.stopForError({
                    message: 'Error loading vtt.js'
                }));
            return;
        }
        segment.requested = true;
        try {
            this.parseVTTCues_(segmentInfo);
        } catch (e) {
            this.stopForError({
                message: e.message,
                metadata: {
                    errorType: $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.StreamingVttParserError,
                    error: e
                }
            });
            return;
        }
        if (!isMp4WebVttSegmentWithCues) this.updateTimeMapping_(segmentInfo, this.syncController_.timelines[segmentInfo.timeline], this.playlist_);
        if (segmentInfo.cues.length) segmentInfo.timingInfo = {
            start: segmentInfo.cues[0].startTime,
            end: segmentInfo.cues[segmentInfo.cues.length - 1].endTime
        };
        else segmentInfo.timingInfo = {
            start: segmentInfo.startOfSegment,
            end: segmentInfo.startOfSegment + segmentInfo.duration
        };
        if (segmentInfo.isSyncRequest) {
            this.trigger('syncinfoupdate');
            this.pendingSegment_ = null;
            this.state = 'READY';
            return;
        }
        segmentInfo.byteLength = segmentInfo.bytes.byteLength;
        this.mediaSecondsLoaded += segment.duration; // Create VTTCue instances for each cue in the new segment and add them to
        // the subtitle track
        segmentInfo.cues.forEach((cue)=>{
            this.subtitlesTrack_.addCue(this.featuresNativeTextTracks_ ? new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).VTTCue(cue.startTime, cue.endTime, cue.text) : cue);
        }); // Remove any duplicate cues from the subtitle track. The WebVTT spec allows
        // cues to have identical time-intervals, but if the text is also identical
        // we can safely assume it is a duplicate that can be removed (ex. when a cue
        // "overlaps" VTT segments)
        $86defbb4e95ebb07$var$removeDuplicateCuesFromTrack(this.subtitlesTrack_);
        this.handleAppendsDone_();
    }
    handleData_(simpleSegment, result) {
        const isVttType = simpleSegment && simpleSegment.type === 'vtt';
        const isTextResult = result && result.type === 'text';
        const isFmp4VttSegment = isVttType && isTextResult; // handle segment data for fmp4 encapsulated webvtt
        if (isFmp4VttSegment) super.handleData_(simpleSegment, result);
    }
    updateTimingInfoEnd_() {}
    /**
   * Utility function for converting mp4 webvtt cue objects into VTTCues.
   *
   * @param {Object} segmentInfo with mp4 webvtt cues for parsing into VTTCue objecs
   */ parseMp4VttCues_(segmentInfo) {
        const timestampOffset = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
        segmentInfo.mp4VttCues.forEach((cue)=>{
            const start = cue.start + timestampOffset;
            const end = cue.end + timestampOffset;
            const vttCue = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).VTTCue(start, end, cue.cueText);
            if (cue.settings) cue.settings.split(' ').forEach((cueSetting)=>{
                const keyValString = cueSetting.split(':');
                const key = keyValString[0];
                const value = keyValString[1];
                vttCue[key] = isNaN(value) ? value : Number(value);
            });
            segmentInfo.cues.push(vttCue);
        });
    }
    /**
   * Uses the WebVTT parser to parse the segment response
   *
   * @throws NoVttJsError
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @private
   */ parseVTTCues_(segmentInfo) {
        let decoder;
        let decodeBytesToString = false;
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT !== 'function') // caller is responsible for exception handling.
        throw new $86defbb4e95ebb07$var$NoVttJsError();
        segmentInfo.cues = [];
        segmentInfo.timestampmap = {
            MPEGTS: 0,
            LOCAL: 0
        };
        if (segmentInfo.mp4VttCues) {
            this.parseMp4VttCues_(segmentInfo);
            return;
        }
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).TextDecoder === 'function') decoder = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).TextDecoder('utf8');
        else {
            decoder = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT.StringDecoder();
            decodeBytesToString = true;
        }
        const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).WebVTT.Parser((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))), (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).vttjs, decoder);
        parser.oncue = segmentInfo.cues.push.bind(segmentInfo.cues);
        parser.ontimestampmap = (map)=>{
            segmentInfo.timestampmap = map;
        };
        parser.onparsingerror = (error)=>{
            $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn('Error encountered when parsing cues: ' + error.message);
        };
        if (segmentInfo.segment.map) {
            let mapData = segmentInfo.segment.map.bytes;
            if (decodeBytesToString) mapData = $86defbb4e95ebb07$var$uint8ToUtf8(mapData);
            parser.parse(mapData);
        }
        let segmentData = segmentInfo.bytes;
        if (decodeBytesToString) segmentData = $86defbb4e95ebb07$var$uint8ToUtf8(segmentData);
        parser.parse(segmentData);
        parser.flush();
    }
    /**
   * Updates the start and end times of any cues parsed by the WebVTT parser using
   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
   * from the SyncController
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @param {Object} mappingObj
   *        object containing a mapping from TS to media time
   * @param {Object} playlist
   *        the playlist object containing the segment
   * @private
   */ updateTimeMapping_(segmentInfo, mappingObj, playlist) {
        const segment = segmentInfo.segment;
        if (!mappingObj) // If the sync controller does not have a mapping of TS to Media Time for the
        // timeline, then we don't have enough information to update the cue
        // start/end times
        return;
        if (!segmentInfo.cues.length) {
            // If there are no cues, we also do not have enough information to figure out
            // segment timing. Mark that the segment contains no cues so we don't re-request
            // an empty segment.
            segment.empty = true;
            return;
        }
        const { MPEGTS: MPEGTS, LOCAL: LOCAL } = segmentInfo.timestampmap;
        /**
     * From the spec:
     * The MPEGTS media timestamp MUST use a 90KHz timescale,
     * even when non-WebVTT Media Segments use a different timescale.
     */ const mpegTsInSeconds = MPEGTS / (0, $22231c6dfc449553$exports.ONE_SECOND_IN_TS);
        const diff = mpegTsInSeconds - LOCAL + mappingObj.mapping;
        segmentInfo.cues.forEach((cue)=>{
            const duration = cue.endTime - cue.startTime;
            const startTime = this.handleRollover_(cue.startTime + diff, mappingObj.time);
            cue.startTime = Math.max(startTime, 0);
            cue.endTime = Math.max(startTime + duration, 0);
        });
        if (!playlist.syncInfo) {
            const firstStart = segmentInfo.cues[0].startTime;
            const lastStart = segmentInfo.cues[segmentInfo.cues.length - 1].startTime;
            playlist.syncInfo = {
                mediaSequence: playlist.mediaSequence + segmentInfo.mediaIndex,
                time: Math.min(firstStart, lastStart - segment.duration)
            };
        }
    }
    /**
   * MPEG-TS PES timestamps are limited to 2^33.
   * Once they reach 2^33, they roll over to 0.
   * mux.js handles PES timestamp rollover for the following scenarios:
   * [forward rollover(right)] ->
   *    PES timestamps monotonically increase, and once they reach 2^33, they roll over to 0
   * [backward rollover(left)] -->
   *    we seek back to position before rollover.
   *
   * According to the HLS SPEC:
   * When synchronizing WebVTT with PES timestamps, clients SHOULD account
   * for cases where the 33-bit PES timestamps have wrapped and the WebVTT
   * cue times have not.  When the PES timestamp wraps, the WebVTT Segment
   * SHOULD have a X-TIMESTAMP-MAP header that maps the current WebVTT
   * time to the new (low valued) PES timestamp.
   *
   * So we want to handle rollover here and align VTT Cue start/end time to the player's time.
   */ handleRollover_(value, reference) {
        if (reference === null) return value;
        let valueIn90khz = value * (0, $22231c6dfc449553$exports.ONE_SECOND_IN_TS);
        const referenceIn90khz = reference * (0, $22231c6dfc449553$exports.ONE_SECOND_IN_TS);
        let offset;
        if (referenceIn90khz < valueIn90khz) // - 2^33
        offset = -8589934592;
        else // + 2^33
        offset = 8589934592;
         // distance(value - reference) > 2^32
        while(Math.abs(valueIn90khz - referenceIn90khz) > 4294967296)valueIn90khz += offset;
        return valueIn90khz / (0, $22231c6dfc449553$exports.ONE_SECOND_IN_TS);
    }
}
/**
 * @file ad-cue-tags.js
 */ /**
 * Searches for an ad cue that overlaps with the given mediaTime
 *
 * @param {Object} track
 *        the track to find the cue for
 *
 * @param {number} mediaTime
 *        the time to find the cue at
 *
 * @return {Object|null}
 *         the found cue or null
 */ const $86defbb4e95ebb07$var$findAdCue = function(track, mediaTime) {
    const cues = track.cues;
    for(let i = 0; i < cues.length; i++){
        const cue = cues[i];
        if (mediaTime >= cue.adStartTime && mediaTime <= cue.adEndTime) return cue;
    }
    return null;
};
const $86defbb4e95ebb07$var$updateAdCues = function(media, track, offset = 0) {
    if (!media.segments) return;
    let mediaTime = offset;
    let cue;
    for(let i = 0; i < media.segments.length; i++){
        const segment = media.segments[i];
        if (!cue) // Since the cues will span for at least the segment duration, adding a fudge
        // factor of half segment duration will prevent duplicate cues from being
        // created when timing info is not exact (e.g. cue start time initialized
        // at 10.006677, but next call mediaTime is 10.003332 )
        cue = $86defbb4e95ebb07$var$findAdCue(track, mediaTime + segment.duration / 2);
        if (cue) {
            if ('cueIn' in segment) {
                // Found a CUE-IN so end the cue
                cue.endTime = mediaTime;
                cue.adEndTime = mediaTime;
                mediaTime += segment.duration;
                cue = null;
                continue;
            }
            if (mediaTime < cue.endTime) {
                // Already processed this mediaTime for this cue
                mediaTime += segment.duration;
                continue;
            } // otherwise extend cue until a CUE-IN is found
            cue.endTime += segment.duration;
        } else {
            if ('cueOut' in segment) {
                cue = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).VTTCue(mediaTime, mediaTime + segment.duration, segment.cueOut);
                cue.adStartTime = mediaTime; // Assumes tag format to be
                // #EXT-X-CUE-OUT:30
                cue.adEndTime = mediaTime + parseFloat(segment.cueOut);
                track.addCue(cue);
            }
            if ('cueOutCont' in segment) {
                // Entered into the middle of an ad cue
                // Assumes tag formate to be
                // #EXT-X-CUE-OUT-CONT:10/30
                const [adOffset, adTotal] = segment.cueOutCont.split('/').map(parseFloat);
                cue = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).VTTCue(mediaTime, mediaTime + segment.duration, '');
                cue.adStartTime = mediaTime - adOffset;
                cue.adEndTime = cue.adStartTime + adTotal;
                track.addCue(cue);
            }
        }
        mediaTime += segment.duration;
    }
};
class $86defbb4e95ebb07$var$SyncInfo {
    /**
   * @param {number} start - media sequence start
   * @param {number} end - media sequence end
   * @param {number} segmentIndex - index for associated segment
   * @param {number|null} [partIndex] - index for associated part
   * @param {boolean} [appended] - appended indicator
   *
   */ constructor({ start: start, end: end, segmentIndex: segmentIndex, partIndex: partIndex = null, appended: appended = false }){
        this.start_ = start;
        this.end_ = end;
        this.segmentIndex_ = segmentIndex;
        this.partIndex_ = partIndex;
        this.appended_ = appended;
    }
    isInRange(targetTime) {
        return targetTime >= this.start && targetTime < this.end;
    }
    markAppended() {
        this.appended_ = true;
    }
    resetAppendedStatus() {
        this.appended_ = false;
    }
    get isAppended() {
        return this.appended_;
    }
    get start() {
        return this.start_;
    }
    get end() {
        return this.end_;
    }
    get segmentIndex() {
        return this.segmentIndex_;
    }
    get partIndex() {
        return this.partIndex_;
    }
}
class $86defbb4e95ebb07$var$SyncInfoData {
    /**
   *
   * @param {SyncInfo} segmentSyncInfo - sync info for a given segment
   * @param {Array<SyncInfo>} [partsSyncInfo] - sync infos for a list of parts for a given segment
   */ constructor(segmentSyncInfo, partsSyncInfo = []){
        this.segmentSyncInfo_ = segmentSyncInfo;
        this.partsSyncInfo_ = partsSyncInfo;
    }
    get segmentSyncInfo() {
        return this.segmentSyncInfo_;
    }
    get partsSyncInfo() {
        return this.partsSyncInfo_;
    }
    get hasPartsSyncInfo() {
        return this.partsSyncInfo_.length > 0;
    }
    resetAppendStatus() {
        this.segmentSyncInfo_.resetAppendedStatus();
        this.partsSyncInfo_.forEach((partSyncInfo)=>partSyncInfo.resetAppendedStatus());
    }
}
class $86defbb4e95ebb07$var$MediaSequenceSync {
    constructor(){
        /**
     * @type {Map<number, SyncInfoData>}
     * @protected
     */ this.storage_ = new Map();
        this.diagnostics_ = '';
        this.isReliable_ = false;
        this.start_ = -Infinity;
        this.end_ = Infinity;
    }
    get start() {
        return this.start_;
    }
    get end() {
        return this.end_;
    }
    get diagnostics() {
        return this.diagnostics_;
    }
    get isReliable() {
        return this.isReliable_;
    }
    resetAppendedStatus() {
        this.storage_.forEach((syncInfoData)=>syncInfoData.resetAppendStatus());
    }
    /**
   * update sync storage
   *
   * @param {Object} playlist
   * @param {number} currentTime
   *
   * @return {void}
   */ update(playlist, currentTime) {
        const { mediaSequence: mediaSequence, segments: segments } = playlist;
        this.isReliable_ = this.isReliablePlaylist_(mediaSequence, segments);
        if (!this.isReliable_) return;
        return this.updateStorage_(segments, mediaSequence, this.calculateBaseTime_(mediaSequence, segments, currentTime));
    }
    /**
   * @param {number} targetTime
   * @return {SyncInfo|null}
   */ getSyncInfoForTime(targetTime) {
        for (const { segmentSyncInfo: segmentSyncInfo, partsSyncInfo: partsSyncInfo } of this.storage_.values()){
            // Normal segment flow:
            if (!partsSyncInfo.length) {
                if (segmentSyncInfo.isInRange(targetTime)) return segmentSyncInfo;
            } else // Low latency flow:
            for (const partSyncInfo of partsSyncInfo){
                if (partSyncInfo.isInRange(targetTime)) return partSyncInfo;
            }
        }
        return null;
    }
    getSyncInfoForMediaSequence(mediaSequence) {
        return this.storage_.get(mediaSequence);
    }
    updateStorage_(segments, startingMediaSequence, startingTime) {
        const newStorage = new Map();
        let newDiagnostics = '\n';
        let currentStart = startingTime;
        let currentMediaSequence = startingMediaSequence;
        this.start_ = currentStart;
        segments.forEach((segment, segmentIndex)=>{
            const prevSyncInfoData = this.storage_.get(currentMediaSequence);
            const segmentStart = currentStart;
            const segmentEnd = segmentStart + segment.duration;
            const segmentIsAppended = Boolean(prevSyncInfoData && prevSyncInfoData.segmentSyncInfo && prevSyncInfoData.segmentSyncInfo.isAppended);
            const segmentSyncInfo = new $86defbb4e95ebb07$var$SyncInfo({
                start: segmentStart,
                end: segmentEnd,
                appended: segmentIsAppended,
                segmentIndex: segmentIndex
            });
            segment.syncInfo = segmentSyncInfo;
            let currentPartStart = currentStart;
            const partsSyncInfo = (segment.parts || []).map((part, partIndex)=>{
                const partStart = currentPartStart;
                const partEnd = currentPartStart + part.duration;
                const partIsAppended = Boolean(prevSyncInfoData && prevSyncInfoData.partsSyncInfo && prevSyncInfoData.partsSyncInfo[partIndex] && prevSyncInfoData.partsSyncInfo[partIndex].isAppended);
                const partSyncInfo = new $86defbb4e95ebb07$var$SyncInfo({
                    start: partStart,
                    end: partEnd,
                    appended: partIsAppended,
                    segmentIndex: segmentIndex,
                    partIndex: partIndex
                });
                currentPartStart = partEnd;
                newDiagnostics += `Media Sequence: ${currentMediaSequence}.${partIndex} | Range: ${partStart} --> ${partEnd} | Appended: ${partIsAppended}\n`;
                part.syncInfo = partSyncInfo;
                return partSyncInfo;
            });
            newStorage.set(currentMediaSequence, new $86defbb4e95ebb07$var$SyncInfoData(segmentSyncInfo, partsSyncInfo));
            newDiagnostics += `${$86defbb4e95ebb07$var$compactSegmentUrlDescription(segment.resolvedUri)} | Media Sequence: ${currentMediaSequence} | Range: ${segmentStart} --> ${segmentEnd} | Appended: ${segmentIsAppended}\n`;
            currentMediaSequence++;
            currentStart = segmentEnd;
        });
        this.end_ = currentStart;
        this.storage_ = newStorage;
        this.diagnostics_ = newDiagnostics;
    }
    calculateBaseTime_(mediaSequence, segments, fallback) {
        if (!this.storage_.size) // Initial setup flow.
        return 0;
        if (this.storage_.has(mediaSequence)) // Normal flow.
        return this.storage_.get(mediaSequence).segmentSyncInfo.start;
        const minMediaSequenceFromStorage = Math.min(...this.storage_.keys()); // This case captures a race condition that can occur if we switch to a new media playlist that is out of date
        // and still has an older Media Sequence. If this occurs, we extrapolate backwards to get the base time.
        if (mediaSequence < minMediaSequenceFromStorage) {
            const mediaSequenceDiff = minMediaSequenceFromStorage - mediaSequence;
            let baseTime = this.storage_.get(minMediaSequenceFromStorage).segmentSyncInfo.start;
            for(let i = 0; i < mediaSequenceDiff; i++){
                const segment = segments[i];
                baseTime -= segment.duration;
            }
            return baseTime;
        } // Fallback flow.
        // There is a gap between last recorded playlist and a new one received.
        return fallback;
    }
    isReliablePlaylist_(mediaSequence, segments) {
        return mediaSequence !== undefined && mediaSequence !== null && Array.isArray(segments) && segments.length;
    }
}
class $86defbb4e95ebb07$var$DependantMediaSequenceSync extends $86defbb4e95ebb07$var$MediaSequenceSync {
    constructor(parent){
        super();
        this.parent_ = parent;
    }
    calculateBaseTime_(mediaSequence, segments, fallback) {
        if (!this.storage_.size) {
            const info = this.parent_.getSyncInfoForMediaSequence(mediaSequence);
            if (info) return info.segmentSyncInfo.start;
            return 0;
        }
        return super.calculateBaseTime_(mediaSequence, segments, fallback);
    }
}
/**
 * @file sync-controller.js
 */ // synchronize expired playlist segments.
// the max media sequence diff is 48 hours of live stream
// content with two second segments. Anything larger than that
// will likely be invalid.
const $86defbb4e95ebb07$var$MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC = 86400;
const $86defbb4e95ebb07$var$syncPointStrategies = [
    // Stategy "VOD": Handle the VOD-case where the sync-point is *always*
    //                the equivalence display-time 0 === segment-index 0
    {
        name: 'VOD',
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            if (duration !== Infinity) {
                const syncPoint = {
                    time: 0,
                    segmentIndex: 0,
                    partIndex: null
                };
                return syncPoint;
            }
            return null;
        }
    },
    {
        name: 'MediaSequence',
        /**
   * run media sequence strategy
   *
   * @param {SyncController} syncController
   * @param {Object} playlist
   * @param {number} duration
   * @param {number} currentTimeline
   * @param {number} currentTime
   * @param {string} type
   */ run: (syncController, playlist, duration, currentTimeline, currentTime, type)=>{
            const mediaSequenceSync = syncController.getMediaSequenceSync(type);
            if (!mediaSequenceSync) return null;
            if (!mediaSequenceSync.isReliable) return null;
            const syncInfo = mediaSequenceSync.getSyncInfoForTime(currentTime);
            if (!syncInfo) return null;
            return {
                time: syncInfo.start,
                partIndex: syncInfo.partIndex,
                segmentIndex: syncInfo.segmentIndex
            };
        }
    },
    // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
    {
        name: 'ProgramDateTime',
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            if (!Object.keys(syncController.timelineToDatetimeMappings).length) return null;
            let syncPoint = null;
            let lastDistance = null;
            const partsAndSegments = $86defbb4e95ebb07$var$getPartsAndSegments(playlist);
            currentTime = currentTime || 0;
            for(let i = 0; i < partsAndSegments.length; i++){
                // start from the end and loop backwards for live
                // or start from the front and loop forwards for non-live
                const index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
                const partAndSegment = partsAndSegments[index];
                const segment = partAndSegment.segment;
                const datetimeMapping = syncController.timelineToDatetimeMappings[segment.timeline];
                if (!datetimeMapping || !segment.dateTimeObject) continue;
                const segmentTime = segment.dateTimeObject.getTime() / 1000;
                let start = segmentTime + datetimeMapping; // take part duration into account.
                if (segment.parts && typeof partAndSegment.partIndex === 'number') for(let z = 0; z < partAndSegment.partIndex; z++)start += segment.parts[z].duration;
                const distance = Math.abs(currentTime - start); // Once the distance begins to increase, or if distance is 0, we have passed
                // currentTime and can stop looking for better candidates
                if (lastDistance !== null && (distance === 0 || lastDistance < distance)) break;
                lastDistance = distance;
                syncPoint = {
                    time: start,
                    segmentIndex: partAndSegment.segmentIndex,
                    partIndex: partAndSegment.partIndex
                };
            }
            return syncPoint;
        }
    },
    // Stategy "Segment": We have a known time mapping for a timeline and a
    //                    segment in the current timeline with timing data
    {
        name: 'Segment',
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            let syncPoint = null;
            let lastDistance = null;
            currentTime = currentTime || 0;
            const partsAndSegments = $86defbb4e95ebb07$var$getPartsAndSegments(playlist);
            for(let i = 0; i < partsAndSegments.length; i++){
                // start from the end and loop backwards for live
                // or start from the front and loop forwards for non-live
                const index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
                const partAndSegment = partsAndSegments[index];
                const segment = partAndSegment.segment;
                const start = partAndSegment.part && partAndSegment.part.start || segment && segment.start;
                if (segment.timeline === currentTimeline && typeof start !== 'undefined') {
                    const distance = Math.abs(currentTime - start); // Once the distance begins to increase, we have passed
                    // currentTime and can stop looking for better candidates
                    if (lastDistance !== null && lastDistance < distance) break;
                    if (!syncPoint || lastDistance === null || lastDistance >= distance) {
                        lastDistance = distance;
                        syncPoint = {
                            time: start,
                            segmentIndex: partAndSegment.segmentIndex,
                            partIndex: partAndSegment.partIndex
                        };
                    }
                }
            }
            return syncPoint;
        }
    },
    // Stategy "Discontinuity": We have a discontinuity with a known
    //                          display-time
    {
        name: 'Discontinuity',
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            let syncPoint = null;
            currentTime = currentTime || 0;
            if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
                let lastDistance = null;
                for(let i = 0; i < playlist.discontinuityStarts.length; i++){
                    const segmentIndex = playlist.discontinuityStarts[i];
                    const discontinuity = playlist.discontinuitySequence + i + 1;
                    const discontinuitySync = syncController.discontinuities[discontinuity];
                    if (discontinuitySync) {
                        const distance = Math.abs(currentTime - discontinuitySync.time); // Once the distance begins to increase, we have passed
                        // currentTime and can stop looking for better candidates
                        if (lastDistance !== null && lastDistance < distance) break;
                        if (!syncPoint || lastDistance === null || lastDistance >= distance) {
                            lastDistance = distance;
                            syncPoint = {
                                time: discontinuitySync.time,
                                segmentIndex: segmentIndex,
                                partIndex: null
                            };
                        }
                    }
                }
            }
            return syncPoint;
        }
    },
    // Stategy "Playlist": We have a playlist with a known mapping of
    //                     segment index to display time
    {
        name: 'Playlist',
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            if (playlist.syncInfo) {
                const syncPoint = {
                    time: playlist.syncInfo.time,
                    segmentIndex: playlist.syncInfo.mediaSequence - playlist.mediaSequence,
                    partIndex: null
                };
                return syncPoint;
            }
            return null;
        }
    }
];
class $86defbb4e95ebb07$var$SyncController extends $86defbb4e95ebb07$export$2e2bcd8739ae039.EventTarget {
    constructor(options = {}){
        super(); // ...for synching across variants
        this.timelines = [];
        this.discontinuities = [];
        this.timelineToDatetimeMappings = {}; // TODO: this map should be only available for HLS. Since only HLS has MediaSequence.
        //  For some reason this map helps with syncing between quality switch for MPEG-DASH as well.
        //  Moreover if we disable this map for MPEG-DASH - quality switch will be broken.
        //  MPEG-DASH should have its own separate sync strategy
        const main = new $86defbb4e95ebb07$var$MediaSequenceSync();
        const audio = new $86defbb4e95ebb07$var$DependantMediaSequenceSync(main);
        const vtt = new $86defbb4e95ebb07$var$DependantMediaSequenceSync(main);
        this.mediaSequenceStorage_ = {
            main: main,
            audio: audio,
            vtt: vtt
        };
        this.logger_ = $86defbb4e95ebb07$var$logger('SyncController');
    }
    /**
   *
   * @param {string} loaderType
   * @return {MediaSequenceSync|null}
   */ getMediaSequenceSync(loaderType) {
        return this.mediaSequenceStorage_[loaderType] || null;
    }
    /**
   * Find a sync-point for the playlist specified
   *
   * A sync-point is defined as a known mapping from display-time to
   * a segment-index in the current playlist.
   *
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinite if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Object}
   *          A sync-point object
   */ getSyncPoint(playlist, duration, currentTimeline, currentTime, type) {
        // Always use VOD sync point for VOD
        if (duration !== Infinity) {
            const vodSyncPointStrategy = $86defbb4e95ebb07$var$syncPointStrategies.find(({ name: name })=>name === 'VOD');
            return vodSyncPointStrategy.run(this, playlist, duration);
        }
        const syncPoints = this.runStrategies_(playlist, duration, currentTimeline, currentTime, type);
        if (!syncPoints.length) // Signal that we need to attempt to get a sync-point manually
        // by fetching a segment in the playlist and constructing
        // a sync-point from that information
        return null;
         // If we have exact match just return it instead of finding the nearest distance
        for (const syncPointInfo of syncPoints){
            const { syncPoint: syncPoint, strategy: strategy } = syncPointInfo;
            const { segmentIndex: segmentIndex, time: time } = syncPoint;
            if (segmentIndex < 0) continue;
            const selectedSegment = playlist.segments[segmentIndex];
            const start = time;
            const end = start + selectedSegment.duration;
            this.logger_(`Strategy: ${strategy}. Current time: ${currentTime}. selected segment: ${segmentIndex}. Time: [${start} -> ${end}]}`);
            if (currentTime >= start && currentTime < end) {
                this.logger_('Found sync point with exact match: ', syncPoint);
                return syncPoint;
            }
        } // Now find the sync-point that is closest to the currentTime because
        // that should result in the most accurate guess about which segment
        // to fetch
        return this.selectSyncPoint_(syncPoints, {
            key: 'time',
            value: currentTime
        });
    }
    /**
   * Calculate the amount of time that has expired off the playlist during playback
   *
   * @param {Playlist} playlist
   *        Playlist object to calculate expired from
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playling a live source)
   * @return {number|null}
   *          The amount of time that has expired off the playlist during playback. Null
   *          if no sync-points for the playlist can be found.
   */ getExpiredTime(playlist, duration) {
        if (!playlist || !playlist.segments) return null;
        const syncPoints = this.runStrategies_(playlist, duration, playlist.discontinuitySequence, 0); // Without sync-points, there is not enough information to determine the expired time
        if (!syncPoints.length) return null;
        const syncPoint = this.selectSyncPoint_(syncPoints, {
            key: 'segmentIndex',
            value: 0
        }); // If the sync-point is beyond the start of the playlist, we want to subtract the
        // duration from index 0 to syncPoint.segmentIndex instead of adding.
        if (syncPoint.segmentIndex > 0) syncPoint.time *= -1;
        return Math.abs(syncPoint.time + $86defbb4e95ebb07$var$sumDurations({
            defaultDuration: playlist.targetDuration,
            durationList: playlist.segments,
            startIndex: syncPoint.segmentIndex,
            endIndex: 0
        }));
    }
    /**
   * Runs each sync-point strategy and returns a list of sync-points returned by the
   * strategies
   *
   * @private
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Array}
   *          A list of sync-point objects
   */ runStrategies_(playlist, duration, currentTimeline, currentTime, type) {
        const syncPoints = []; // Try to find a sync-point in by utilizing various strategies...
        for(let i = 0; i < $86defbb4e95ebb07$var$syncPointStrategies.length; i++){
            const strategy = $86defbb4e95ebb07$var$syncPointStrategies[i];
            const syncPoint = strategy.run(this, playlist, duration, currentTimeline, currentTime, type);
            if (syncPoint) {
                syncPoint.strategy = strategy.name;
                syncPoints.push({
                    strategy: strategy.name,
                    syncPoint: syncPoint
                });
            }
        }
        return syncPoints;
    }
    /**
   * Selects the sync-point nearest the specified target
   *
   * @private
   * @param {Array} syncPoints
   *        List of sync-points to select from
   * @param {Object} target
   *        Object specifying the property and value we are targeting
   * @param {string} target.key
   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
   * @param {number} target.value
   *        The value to target for the specified key.
   * @return {Object}
   *          The sync-point nearest the target
   */ selectSyncPoint_(syncPoints, target) {
        let bestSyncPoint = syncPoints[0].syncPoint;
        let bestDistance = Math.abs(syncPoints[0].syncPoint[target.key] - target.value);
        let bestStrategy = syncPoints[0].strategy;
        for(let i = 1; i < syncPoints.length; i++){
            const newDistance = Math.abs(syncPoints[i].syncPoint[target.key] - target.value);
            if (newDistance < bestDistance) {
                bestDistance = newDistance;
                bestSyncPoint = syncPoints[i].syncPoint;
                bestStrategy = syncPoints[i].strategy;
            }
        }
        this.logger_(`syncPoint for [${target.key}: ${target.value}] chosen with strategy` + ` [${bestStrategy}]: [time:${bestSyncPoint.time},` + ` segmentIndex:${bestSyncPoint.segmentIndex}` + (typeof bestSyncPoint.partIndex === 'number' ? `,partIndex:${bestSyncPoint.partIndex}` : '') + ']');
        return bestSyncPoint;
    }
    /**
   * Save any meta-data present on the segments when segments leave
   * the live window to the playlist to allow for synchronization at the
   * playlist level later.
   *
   * @param {Playlist} oldPlaylist - The previous active playlist
   * @param {Playlist} newPlaylist - The updated and most current playlist
   */ saveExpiredSegmentInfo(oldPlaylist, newPlaylist) {
        const mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence; // Ignore large media sequence gaps
        if (mediaSequenceDiff > $86defbb4e95ebb07$var$MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC) {
            $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn(`Not saving expired segment info. Media sequence gap ${mediaSequenceDiff} is too large.`);
            return;
        } // When a segment expires from the playlist and it has a start time
        // save that information as a possible sync-point reference in future
        for(let i = mediaSequenceDiff - 1; i >= 0; i--){
            const lastRemovedSegment = oldPlaylist.segments[i];
            if (lastRemovedSegment && typeof lastRemovedSegment.start !== 'undefined') {
                newPlaylist.syncInfo = {
                    mediaSequence: oldPlaylist.mediaSequence + i,
                    time: lastRemovedSegment.start
                };
                this.logger_(`playlist refresh sync: [time:${newPlaylist.syncInfo.time},` + ` mediaSequence: ${newPlaylist.syncInfo.mediaSequence}]`);
                this.trigger('syncinfoupdate');
                break;
            }
        }
    }
    /**
   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
   * before segments start to load.
   *
   * @param {Playlist} playlist - The currently active playlist
   */ setDateTimeMappingForStart(playlist) {
        // It's possible for the playlist to be updated before playback starts, meaning time
        // zero is not yet set. If, during these playlist refreshes, a discontinuity is
        // crossed, then the old time zero mapping (for the prior timeline) would be retained
        // unless the mappings are cleared.
        this.timelineToDatetimeMappings = {};
        if (playlist.segments && playlist.segments.length && playlist.segments[0].dateTimeObject) {
            const firstSegment = playlist.segments[0];
            const playlistTimestamp = firstSegment.dateTimeObject.getTime() / 1000;
            this.timelineToDatetimeMappings[firstSegment.timeline] = -playlistTimestamp;
        }
    }
    /**
   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
   * based on the latest timing information.
   *
   * @param {Object} options
   *        Options object
   * @param {SegmentInfo} options.segmentInfo
   *        The current active request information
   * @param {boolean} options.shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved for timeline mapping and program date time mappings.
   */ saveSegmentTimingInfo({ segmentInfo: segmentInfo, shouldSaveTimelineMapping: shouldSaveTimelineMapping }) {
        const didCalculateSegmentTimeMapping = this.calculateSegmentTimeMapping_(segmentInfo, segmentInfo.timingInfo, shouldSaveTimelineMapping);
        const segment = segmentInfo.segment;
        if (didCalculateSegmentTimeMapping) {
            this.saveDiscontinuitySyncInfo_(segmentInfo); // If the playlist does not have sync information yet, record that information
            // now with segment timing information
            if (!segmentInfo.playlist.syncInfo) segmentInfo.playlist.syncInfo = {
                mediaSequence: segmentInfo.playlist.mediaSequence + segmentInfo.mediaIndex,
                time: segment.start
            };
        }
        const dateTime = segment.dateTimeObject;
        if (segment.discontinuity && shouldSaveTimelineMapping && dateTime) this.timelineToDatetimeMappings[segment.timeline] = -(dateTime.getTime() / 1000);
    }
    timestampOffsetForTimeline(timeline) {
        if (typeof this.timelines[timeline] === 'undefined') return null;
        return this.timelines[timeline].time;
    }
    mappingForTimeline(timeline) {
        if (typeof this.timelines[timeline] === 'undefined') return null;
        return this.timelines[timeline].mapping;
    }
    /**
   * Use the "media time" for a segment to generate a mapping to "display time" and
   * save that display time to the segment.
   *
   * @private
   * @param {SegmentInfo} segmentInfo
   *        The current active request information
   * @param {Object} timingInfo
   *        The start and end time of the current segment in "media time"
   * @param {boolean} shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved in timelines.
   * @return {boolean}
   *          Returns false if segment time mapping could not be calculated
   */ calculateSegmentTimeMapping_(segmentInfo, timingInfo, shouldSaveTimelineMapping) {
        // TODO: remove side effects
        const segment = segmentInfo.segment;
        const part = segmentInfo.part;
        let mappingObj = this.timelines[segmentInfo.timeline];
        let start;
        let end;
        if (typeof segmentInfo.timestampOffset === 'number') {
            mappingObj = {
                time: segmentInfo.startOfSegment,
                mapping: segmentInfo.startOfSegment - timingInfo.start
            };
            if (shouldSaveTimelineMapping) {
                this.timelines[segmentInfo.timeline] = mappingObj;
                this.trigger('timestampoffset');
                this.logger_(`time mapping for timeline ${segmentInfo.timeline}: ` + `[time: ${mappingObj.time}] [mapping: ${mappingObj.mapping}]`);
            }
            start = segmentInfo.startOfSegment;
            end = timingInfo.end + mappingObj.mapping;
        } else if (mappingObj) {
            start = timingInfo.start + mappingObj.mapping;
            end = timingInfo.end + mappingObj.mapping;
        } else return false;
        if (part) {
            part.start = start;
            part.end = end;
        } // If we don't have a segment start yet or the start value we got
        // is less than our current segment.start value, save a new start value.
        // We have to do this because parts will have segment timing info saved
        // multiple times and we want segment start to be the earliest part start
        // value for that segment.
        if (!segment.start || start < segment.start) segment.start = start;
        segment.end = end;
        return true;
    }
    /**
   * Each time we have discontinuity in the playlist, attempt to calculate the location
   * in display of the start of the discontinuity and save that. We also save an accuracy
   * value so that we save values with the most accuracy (closest to 0.)
   *
   * @private
   * @param {SegmentInfo} segmentInfo - The current active request information
   */ saveDiscontinuitySyncInfo_(segmentInfo) {
        const playlist = segmentInfo.playlist;
        const segment = segmentInfo.segment; // If the current segment is a discontinuity then we know exactly where
        // the start of the range and it's accuracy is 0 (greater accuracy values
        // mean more approximation)
        if (segment.discontinuity) this.discontinuities[segment.timeline] = {
            time: segment.start,
            accuracy: 0
        };
        else if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) // Search for future discontinuities that we can provide better timing
        // information for and save that information for sync purposes
        for(let i = 0; i < playlist.discontinuityStarts.length; i++){
            const segmentIndex = playlist.discontinuityStarts[i];
            const discontinuity = playlist.discontinuitySequence + i + 1;
            const mediaIndexDiff = segmentIndex - segmentInfo.mediaIndex;
            const accuracy = Math.abs(mediaIndexDiff);
            if (!this.discontinuities[discontinuity] || this.discontinuities[discontinuity].accuracy > accuracy) {
                let time;
                if (mediaIndexDiff < 0) time = segment.start - $86defbb4e95ebb07$var$sumDurations({
                    defaultDuration: playlist.targetDuration,
                    durationList: playlist.segments,
                    startIndex: segmentInfo.mediaIndex,
                    endIndex: segmentIndex
                });
                else time = segment.end + $86defbb4e95ebb07$var$sumDurations({
                    defaultDuration: playlist.targetDuration,
                    durationList: playlist.segments,
                    startIndex: segmentInfo.mediaIndex + 1,
                    endIndex: segmentIndex
                });
                this.discontinuities[discontinuity] = {
                    time: time,
                    accuracy: accuracy
                };
            }
        }
    }
    dispose() {
        this.trigger('dispose');
        this.off();
    }
}
/**
 * The TimelineChangeController acts as a source for segment loaders to listen for and
 * keep track of latest and pending timeline changes. This is useful to ensure proper
 * sync, as each loader may need to make a consideration for what timeline the other
 * loader is on before making changes which could impact the other loader's media.
 *
 * @class TimelineChangeController
 * @extends videojs.EventTarget
 */ class $86defbb4e95ebb07$var$TimelineChangeController extends $86defbb4e95ebb07$export$2e2bcd8739ae039.EventTarget {
    constructor(){
        super();
        this.pendingTimelineChanges_ = {};
        this.lastTimelineChanges_ = {};
    }
    clearPendingTimelineChange(type) {
        this.pendingTimelineChanges_[type] = null;
        this.trigger('pendingtimelinechange');
    }
    pendingTimelineChange({ type: type, from: from, to: to }) {
        if (typeof from === 'number' && typeof to === 'number') {
            this.pendingTimelineChanges_[type] = {
                type: type,
                from: from,
                to: to
            };
            this.trigger('pendingtimelinechange');
        }
        return this.pendingTimelineChanges_[type];
    }
    lastTimelineChange({ type: type, from: from, to: to }) {
        if (typeof from === 'number' && typeof to === 'number') {
            this.lastTimelineChanges_[type] = {
                type: type,
                from: from,
                to: to
            };
            delete this.pendingTimelineChanges_[type];
            const metadata = {
                timelineChangeInfo: {
                    from: from,
                    to: to
                }
            };
            this.trigger({
                type: 'timelinechange',
                metadata: metadata
            });
        }
        return this.lastTimelineChanges_[type];
    }
    dispose() {
        this.trigger('dispose');
        this.pendingTimelineChanges_ = {};
        this.lastTimelineChanges_ = {};
        this.off();
    }
}
/* rollup-plugin-worker-factory start for worker!/Users/srimron-soutter/repos/github/vjs/http-streaming/src/decrypter-worker.js */ const $86defbb4e95ebb07$var$workerCode = $86defbb4e95ebb07$var$transform($86defbb4e95ebb07$var$getWorkerString(function() {
    /**
   * @file stream.js
   */ /**
   * A lightweight readable stream implemention that handles event dispatching.
   *
   * @class Stream
   */ var Stream = /*#__PURE__*/ function() {
        function Stream() {
            this.listeners = {};
        }
        /**
     * Add a listener for a specified event type.
     *
     * @param {string} type the event name
     * @param {Function} listener the callback to be invoked when an event of
     * the specified type occurs
     */ var _proto = Stream.prototype;
        _proto.on = function on(type, listener) {
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push(listener);
        };
        _proto.off = function off(type, listener) {
            if (!this.listeners[type]) return false;
            var index = this.listeners[type].indexOf(listener); // TODO: which is better?
            // In Video.js we slice listener functions
            // on trigger so that it does not mess up the order
            // while we loop through.
            //
            // Here we slice on off so that the loop in trigger
            // can continue using it's old reference to loop without
            // messing up the order.
            this.listeners[type] = this.listeners[type].slice(0);
            this.listeners[type].splice(index, 1);
            return index > -1;
        };
        _proto.trigger = function trigger(type) {
            var callbacks = this.listeners[type];
            if (!callbacks) return;
             // Slicing the arguments on every invocation of this method
            // can add a significant amount of overhead. Avoid the
            // intermediate object creation for the common case of a
            // single callback argument
            if (arguments.length === 2) {
                var length = callbacks.length;
                for(var i = 0; i < length; ++i)callbacks[i].call(this, arguments[1]);
            } else {
                var args = Array.prototype.slice.call(arguments, 1);
                var _length = callbacks.length;
                for(var _i = 0; _i < _length; ++_i)callbacks[_i].apply(this, args);
            }
        };
        _proto.dispose = function dispose() {
            this.listeners = {};
        };
        _proto.pipe = function pipe(destination) {
            this.on('data', function(data) {
                destination.push(data);
            });
        };
        return Stream;
    }();
    /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */ /**
   * Returns the subarray of a Uint8Array without PKCS#7 padding.
   *
   * @param padded {Uint8Array} unencrypted bytes that have been padded
   * @return {Uint8Array} the unpadded bytes
   * @see http://tools.ietf.org/html/rfc5652
   */ function unpad(padded) {
        return padded.subarray(0, padded.byteLength - padded[padded.byteLength - 1]);
    }
    /*! @name aes-decrypter @version 4.0.2 @license Apache-2.0 */ /**
   * @file aes.js
   *
   * This file contains an adaptation of the AES decryption algorithm
   * from the Standford Javascript Cryptography Library. That work is
   * covered by the following copyright and permissions notice:
   *
   * Copyright 2009-2010 Emily Stark, Mike Hamburg, Dan Boneh.
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without
   * modification, are permitted provided that the following conditions are
   * met:
   *
   * 1. Redistributions of source code must retain the above copyright
   *    notice, this list of conditions and the following disclaimer.
   *
   * 2. Redistributions in binary form must reproduce the above
   *    copyright notice, this list of conditions and the following
   *    disclaimer in the documentation and/or other materials provided
   *    with the distribution.
   *
   * THIS SOFTWARE IS PROVIDED BY THE AUTHORS ``AS IS'' AND ANY EXPRESS OR
   * IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
   * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
   * DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> OR CONTRIBUTORS BE
   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
   * BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
   * WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
   * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
   * IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   *
   * The views and conclusions contained in the software and documentation
   * are those of the authors and should not be interpreted as representing
   * official policies, either expressed or implied, of the authors.
   */ /**
   * Expand the S-box tables.
   *
   * @private
   */ const precompute = function() {
        const tables = [
            [
                [],
                [],
                [],
                [],
                []
            ],
            [
                [],
                [],
                [],
                [],
                []
            ]
        ];
        const encTable = tables[0];
        const decTable = tables[1];
        const sbox = encTable[4];
        const sboxInv = decTable[4];
        let i;
        let x;
        let xInv;
        const d = [];
        const th = [];
        let x2;
        let x4;
        let x8;
        let s;
        let tEnc;
        let tDec; // Compute double and third tables
        for(i = 0; i < 256; i++)th[(d[i] = i << 1 ^ (i >> 7) * 283) ^ i] = i;
        for(x = xInv = 0; !sbox[x]; x ^= x2 || 1, xInv = th[xInv] || 1){
            // Compute sbox
            s = xInv ^ xInv << 1 ^ xInv << 2 ^ xInv << 3 ^ xInv << 4;
            s = s >> 8 ^ s & 255 ^ 99;
            sbox[x] = s;
            sboxInv[s] = x; // Compute MixColumns
            x8 = d[x4 = d[x2 = d[x]]];
            tDec = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
            tEnc = d[s] * 0x101 ^ s * 0x1010100;
            for(i = 0; i < 4; i++){
                encTable[i][x] = tEnc = tEnc << 24 ^ tEnc >>> 8;
                decTable[i][s] = tDec = tDec << 24 ^ tDec >>> 8;
            }
        } // Compactify. Considerable speedup on Firefox.
        for(i = 0; i < 5; i++){
            encTable[i] = encTable[i].slice(0);
            decTable[i] = decTable[i].slice(0);
        }
        return tables;
    };
    let aesTables = null;
    /**
   * Schedule out an AES key for both encryption and decryption. This
   * is a low-level class. Use a cipher mode to do bulk encryption.
   *
   * @class AES
   * @param key {Array} The key as an array of 4, 6 or 8 words.
   */ class AES {
        constructor(key){
            /**
      * The expanded S-box and inverse S-box tables. These will be computed
      * on the client so that we don't have to send them down the wire.
      *
      * There are two tables, _tables[0] is for encryption and
      * _tables[1] is for decryption.
      *
      * The first 4 sub-tables are the expanded S-box with MixColumns. The
      * last (_tables[01][4]) is the S-box itself.
      *
      * @private
      */ // if we have yet to precompute the S-box tables
            // do so now
            if (!aesTables) aesTables = precompute();
             // then make a copy of that object for use
            this._tables = [
                [
                    aesTables[0][0].slice(),
                    aesTables[0][1].slice(),
                    aesTables[0][2].slice(),
                    aesTables[0][3].slice(),
                    aesTables[0][4].slice()
                ],
                [
                    aesTables[1][0].slice(),
                    aesTables[1][1].slice(),
                    aesTables[1][2].slice(),
                    aesTables[1][3].slice(),
                    aesTables[1][4].slice()
                ]
            ];
            let i;
            let j;
            let tmp;
            const sbox = this._tables[0][4];
            const decTable = this._tables[1];
            const keyLen = key.length;
            let rcon = 1;
            if (keyLen !== 4 && keyLen !== 6 && keyLen !== 8) throw new Error('Invalid aes key size');
            const encKey = key.slice(0);
            const decKey = [];
            this._key = [
                encKey,
                decKey
            ]; // schedule encryption keys
            for(i = keyLen; i < 4 * keyLen + 28; i++){
                tmp = encKey[i - 1]; // apply sbox
                if (i % keyLen === 0 || keyLen === 8 && i % keyLen === 4) {
                    tmp = sbox[tmp >>> 24] << 24 ^ sbox[tmp >> 16 & 255] << 16 ^ sbox[tmp >> 8 & 255] << 8 ^ sbox[tmp & 255]; // shift rows and add rcon
                    if (i % keyLen === 0) {
                        tmp = tmp << 8 ^ tmp >>> 24 ^ rcon << 24;
                        rcon = rcon << 1 ^ (rcon >> 7) * 283;
                    }
                }
                encKey[i] = encKey[i - keyLen] ^ tmp;
            } // schedule decryption keys
            for(j = 0; i; j++, i--){
                tmp = encKey[j & 3 ? i : i - 4];
                if (i <= 4 || j < 4) decKey[j] = tmp;
                else decKey[j] = decTable[0][sbox[tmp >>> 24]] ^ decTable[1][sbox[tmp >> 16 & 255]] ^ decTable[2][sbox[tmp >> 8 & 255]] ^ decTable[3][sbox[tmp & 255]];
            }
        }
        /**
     * Decrypt 16 bytes, specified as four 32-bit words.
     *
     * @param {number} encrypted0 the first word to decrypt
     * @param {number} encrypted1 the second word to decrypt
     * @param {number} encrypted2 the third word to decrypt
     * @param {number} encrypted3 the fourth word to decrypt
     * @param {Int32Array} out the array to write the decrypted words
     * into
     * @param {number} offset the offset into the output array to start
     * writing results
     * @return {Array} The plaintext.
     */ decrypt(encrypted0, encrypted1, encrypted2, encrypted3, out, offset) {
            const key = this._key[1]; // state variables a,b,c,d are loaded with pre-whitened data
            let a = encrypted0 ^ key[0];
            let b = encrypted3 ^ key[1];
            let c = encrypted2 ^ key[2];
            let d = encrypted1 ^ key[3];
            let a2;
            let b2;
            let c2; // key.length === 2 ?
            const nInnerRounds = key.length / 4 - 2;
            let i;
            let kIndex = 4;
            const table = this._tables[1]; // load up the tables
            const table0 = table[0];
            const table1 = table[1];
            const table2 = table[2];
            const table3 = table[3];
            const sbox = table[4]; // Inner rounds. Cribbed from OpenSSL.
            for(i = 0; i < nInnerRounds; i++){
                a2 = table0[a >>> 24] ^ table1[b >> 16 & 255] ^ table2[c >> 8 & 255] ^ table3[d & 255] ^ key[kIndex];
                b2 = table0[b >>> 24] ^ table1[c >> 16 & 255] ^ table2[d >> 8 & 255] ^ table3[a & 255] ^ key[kIndex + 1];
                c2 = table0[c >>> 24] ^ table1[d >> 16 & 255] ^ table2[a >> 8 & 255] ^ table3[b & 255] ^ key[kIndex + 2];
                d = table0[d >>> 24] ^ table1[a >> 16 & 255] ^ table2[b >> 8 & 255] ^ table3[c & 255] ^ key[kIndex + 3];
                kIndex += 4;
                a = a2;
                b = b2;
                c = c2;
            } // Last round.
            for(i = 0; i < 4; i++){
                out[(3 & -i) + offset] = sbox[a >>> 24] << 24 ^ sbox[b >> 16 & 255] << 16 ^ sbox[c >> 8 & 255] << 8 ^ sbox[d & 255] ^ key[kIndex++];
                a2 = a;
                a = b;
                b = c;
                c = d;
                d = a2;
            }
        }
    }
    /**
   * @file async-stream.js
   */ /**
   * A wrapper around the Stream class to use setTimeout
   * and run stream "jobs" Asynchronously
   *
   * @class AsyncStream
   * @extends Stream
   */ class AsyncStream extends Stream {
        constructor(){
            super(Stream);
            this.jobs = [];
            this.delay = 1;
            this.timeout_ = null;
        }
        /**
     * process an async job
     *
     * @private
     */ processJob_() {
            this.jobs.shift()();
            if (this.jobs.length) this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
            else this.timeout_ = null;
        }
        /**
     * push a job into the stream
     *
     * @param {Function} job the job to push into the stream
     */ push(job) {
            this.jobs.push(job);
            if (!this.timeout_) this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
        }
    }
    /**
   * @file decrypter.js
   *
   * An asynchronous implementation of AES-128 CBC decryption with
   * PKCS#7 padding.
   */ /**
   * Convert network-order (big-endian) bytes into their little-endian
   * representation.
   */ const ntoh = function(word) {
        return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
    };
    /**
   * Decrypt bytes using AES-128 with CBC and PKCS#7 padding.
   *
   * @param {Uint8Array} encrypted the encrypted bytes
   * @param {Uint32Array} key the bytes of the decryption key
   * @param {Uint32Array} initVector the initialization vector (IV) to
   * use for the first round of CBC.
   * @return {Uint8Array} the decrypted bytes
   *
   * @see http://en.wikipedia.org/wiki/Advanced_Encryption_Standard
   * @see http://en.wikipedia.org/wiki/Block_cipher_mode_of_operation#Cipher_Block_Chaining_.28CBC.29
   * @see https://tools.ietf.org/html/rfc2315
   */ const decrypt = function(encrypted, key, initVector) {
        // word-level access to the encrypted bytes
        const encrypted32 = new Int32Array(encrypted.buffer, encrypted.byteOffset, encrypted.byteLength >> 2);
        const decipher = new AES(Array.prototype.slice.call(key)); // byte and word-level access for the decrypted output
        const decrypted = new Uint8Array(encrypted.byteLength);
        const decrypted32 = new Int32Array(decrypted.buffer); // temporary variables for working with the IV, encrypted, and
        // decrypted data
        let init0;
        let init1;
        let init2;
        let init3;
        let encrypted0;
        let encrypted1;
        let encrypted2;
        let encrypted3; // iteration variable
        let wordIx; // pull out the words of the IV to ensure we don't modify the
        // passed-in reference and easier access
        init0 = initVector[0];
        init1 = initVector[1];
        init2 = initVector[2];
        init3 = initVector[3]; // decrypt four word sequences, applying cipher-block chaining (CBC)
        // to each decrypted block
        for(wordIx = 0; wordIx < encrypted32.length; wordIx += 4){
            // convert big-endian (network order) words into little-endian
            // (javascript order)
            encrypted0 = ntoh(encrypted32[wordIx]);
            encrypted1 = ntoh(encrypted32[wordIx + 1]);
            encrypted2 = ntoh(encrypted32[wordIx + 2]);
            encrypted3 = ntoh(encrypted32[wordIx + 3]); // decrypt the block
            decipher.decrypt(encrypted0, encrypted1, encrypted2, encrypted3, decrypted32, wordIx); // XOR with the IV, and restore network byte-order to obtain the
            // plaintext
            decrypted32[wordIx] = ntoh(decrypted32[wordIx] ^ init0);
            decrypted32[wordIx + 1] = ntoh(decrypted32[wordIx + 1] ^ init1);
            decrypted32[wordIx + 2] = ntoh(decrypted32[wordIx + 2] ^ init2);
            decrypted32[wordIx + 3] = ntoh(decrypted32[wordIx + 3] ^ init3); // setup the IV for the next round
            init0 = encrypted0;
            init1 = encrypted1;
            init2 = encrypted2;
            init3 = encrypted3;
        }
        return decrypted;
    };
    /**
   * The `Decrypter` class that manages decryption of AES
   * data through `AsyncStream` objects and the `decrypt`
   * function
   *
   * @param {Uint8Array} encrypted the encrypted bytes
   * @param {Uint32Array} key the bytes of the decryption key
   * @param {Uint32Array} initVector the initialization vector (IV) to
   * @param {Function} done the function to run when done
   * @class Decrypter
   */ class Decrypter {
        constructor(encrypted, key, initVector, done){
            const step = Decrypter.STEP;
            const encrypted32 = new Int32Array(encrypted.buffer);
            const decrypted = new Uint8Array(encrypted.byteLength);
            let i = 0;
            this.asyncStream_ = new AsyncStream(); // split up the encryption job and do the individual chunks asynchronously
            this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
            for(i = step; i < encrypted32.length; i += step){
                initVector = new Uint32Array([
                    ntoh(encrypted32[i - 4]),
                    ntoh(encrypted32[i - 3]),
                    ntoh(encrypted32[i - 2]),
                    ntoh(encrypted32[i - 1])
                ]);
                this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
            } // invoke the done() callback when everything is finished
            this.asyncStream_.push(function() {
                // remove pkcs#7 padding from the decrypted bytes
                done(null, unpad(decrypted));
            });
        }
        /**
     * a getter for step the maximum number of bytes to process at one time
     *
     * @return {number} the value of step 32000
     */ static get STEP() {
            // 4 * 8000;
            return 32000;
        }
        /**
     * @private
     */ decryptChunk_(encrypted, key, initVector, decrypted) {
            return function() {
                const bytes = decrypt(encrypted, key, initVector);
                decrypted.set(bytes, encrypted.byteOffset);
            };
        }
    }
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
    var win;
    if (typeof window !== "undefined") win = window;
    else if (typeof commonjsGlobal !== "undefined") win = commonjsGlobal;
    else if (typeof self !== "undefined") win = self;
    else win = {};
    var window_1 = win;
    var isArrayBufferView = function isArrayBufferView(obj) {
        if (ArrayBuffer.isView === 'function') return ArrayBuffer.isView(obj);
        return obj && obj.buffer instanceof ArrayBuffer;
    };
    var BigInt = window_1.BigInt || Number;
    BigInt('0x1'), BigInt('0x100'), BigInt('0x10000'), BigInt('0x1000000'), BigInt('0x100000000'), BigInt('0x10000000000'), BigInt('0x1000000000000'), BigInt('0x100000000000000'), BigInt('0x10000000000000000');
    (function() {
        var a = new Uint16Array([
            0xFFCC
        ]);
        var b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
        if (b[0] === 0xFF) return 'big';
        if (b[0] === 0xCC) return 'little';
        return 'unknown';
    })();
    /**
   * Creates an object for sending to a web worker modifying properties that are TypedArrays
   * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
   *
   * @param {Object} message
   *        Object of properties and values to send to the web worker
   * @return {Object}
   *         Modified message with TypedArray values expanded
   * @function createTransferableMessage
   */ const createTransferableMessage = function(message) {
        const transferable = {};
        Object.keys(message).forEach((key)=>{
            const value = message[key];
            if (isArrayBufferView(value)) transferable[key] = {
                bytes: value.buffer,
                byteOffset: value.byteOffset,
                byteLength: value.byteLength
            };
            else transferable[key] = value;
        });
        return transferable;
    };
    /* global self */ /**
   * Our web worker interface so that things can talk to aes-decrypter
   * that will be running in a web worker. the scope is passed to this by
   * webworkify.
   */ self.onmessage = function(event) {
        const data = event.data;
        const encrypted = new Uint8Array(data.encrypted.bytes, data.encrypted.byteOffset, data.encrypted.byteLength);
        const key = new Uint32Array(data.key.bytes, data.key.byteOffset, data.key.byteLength / 4);
        const iv = new Uint32Array(data.iv.bytes, data.iv.byteOffset, data.iv.byteLength / 4);
        /* eslint-disable no-new, handle-callback-err */ new Decrypter(encrypted, key, iv, function(err, bytes) {
            self.postMessage(createTransferableMessage({
                source: data.source,
                decrypted: bytes
            }), [
                bytes.buffer
            ]);
        });
    /* eslint-enable */ };
}));
var $86defbb4e95ebb07$var$Decrypter = $86defbb4e95ebb07$var$factory($86defbb4e95ebb07$var$workerCode);
/* rollup-plugin-worker-factory end for worker!/Users/srimron-soutter/repos/github/vjs/http-streaming/src/decrypter-worker.js */ /**
 * Convert the properties of an HLS track into an audioTrackKind.
 *
 * @private
 */ const $86defbb4e95ebb07$var$audioTrackKind_ = (properties)=>{
    let kind = properties.default ? 'main' : 'alternative';
    if (properties.characteristics && properties.characteristics.indexOf('public.accessibility.describes-video') >= 0) kind = 'main-desc';
    return kind;
};
/**
 * Pause provided segment loader and playlist loader if active
 *
 * @param {SegmentLoader} segmentLoader
 *        SegmentLoader to pause
 * @param {Object} mediaType
 *        Active media type
 * @function stopLoaders
 */ const $86defbb4e95ebb07$var$stopLoaders = (segmentLoader, mediaType)=>{
    segmentLoader.abort();
    segmentLoader.pause();
    if (mediaType && mediaType.activePlaylistLoader) {
        mediaType.activePlaylistLoader.pause();
        mediaType.activePlaylistLoader = null;
    }
};
/**
 * Start loading provided segment loader and playlist loader
 *
 * @param {PlaylistLoader} playlistLoader
 *        PlaylistLoader to start loading
 * @param {Object} mediaType
 *        Active media type
 * @function startLoaders
 */ const $86defbb4e95ebb07$var$startLoaders = (playlistLoader, mediaType)=>{
    // Segment loader will be started after `loadedmetadata` or `loadedplaylist` from the
    // playlist loader
    mediaType.activePlaylistLoader = playlistLoader;
    playlistLoader.load();
};
/**
 * Returns a function to be called when the media group changes. It performs a
 * non-destructive (preserve the buffer) resync of the SegmentLoader. This is because a
 * change of group is merely a rendition switch of the same content at another encoding,
 * rather than a change of content, such as switching audio from English to Spanish.
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Handler for a non-destructive resync of SegmentLoader when the active media
 *         group changes.
 * @function onGroupChanged
 */ const $86defbb4e95ebb07$var$onGroupChanged = (type, settings)=>()=>{
        const { segmentLoaders: { [type]: segmentLoader, main: mainSegmentLoader }, mediaTypes: { [type]: mediaType } } = settings;
        const activeTrack = mediaType.activeTrack();
        const activeGroup = mediaType.getActiveGroup();
        const previousActiveLoader = mediaType.activePlaylistLoader;
        const lastGroup = mediaType.lastGroup_; // the group did not change do nothing
        if (activeGroup && lastGroup && activeGroup.id === lastGroup.id) return;
        mediaType.lastGroup_ = activeGroup;
        mediaType.lastTrack_ = activeTrack;
        $86defbb4e95ebb07$var$stopLoaders(segmentLoader, mediaType);
        if (!activeGroup || activeGroup.isMainPlaylist) // there is no group active or active group is a main playlist and won't change
        return;
        if (!activeGroup.playlistLoader) {
            if (previousActiveLoader) // The previous group had a playlist loader but the new active group does not
            // this means we are switching from demuxed to muxed audio. In this case we want to
            // do a destructive reset of the main segment loader and not restart the audio
            // loaders.
            mainSegmentLoader.resetEverything();
            return;
        } // Non-destructive resync
        segmentLoader.resyncLoader();
        $86defbb4e95ebb07$var$startLoaders(activeGroup.playlistLoader, mediaType);
    };
const $86defbb4e95ebb07$var$onGroupChanging = (type, settings)=>()=>{
        const { segmentLoaders: { [type]: segmentLoader }, mediaTypes: { [type]: mediaType } } = settings;
        mediaType.lastGroup_ = null;
        segmentLoader.abort();
        segmentLoader.pause();
    };
/**
 * Returns a function to be called when the media track changes. It performs a
 * destructive reset of the SegmentLoader to ensure we start loading as close to
 * currentTime as possible.
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Handler for a destructive reset of SegmentLoader when the active media
 *         track changes.
 * @function onTrackChanged
 */ const $86defbb4e95ebb07$var$onTrackChanged = (type, settings)=>()=>{
        const { mainPlaylistLoader: mainPlaylistLoader, segmentLoaders: { [type]: segmentLoader, main: mainSegmentLoader }, mediaTypes: { [type]: mediaType } } = settings;
        const activeTrack = mediaType.activeTrack();
        const activeGroup = mediaType.getActiveGroup();
        const previousActiveLoader = mediaType.activePlaylistLoader;
        const lastTrack = mediaType.lastTrack_; // track did not change, do nothing
        if (lastTrack && activeTrack && lastTrack.id === activeTrack.id) return;
        mediaType.lastGroup_ = activeGroup;
        mediaType.lastTrack_ = activeTrack;
        $86defbb4e95ebb07$var$stopLoaders(segmentLoader, mediaType);
        if (!activeGroup) // there is no group active so we do not want to restart loaders
        return;
        if (activeGroup.isMainPlaylist) {
            // track did not change, do nothing
            if (!activeTrack || !lastTrack || activeTrack.id === lastTrack.id) return;
            const pc = settings.vhs.playlistController_;
            const newPlaylist = pc.selectPlaylist(); // media will not change do nothing
            if (pc.media() === newPlaylist) return;
            mediaType.logger_(`track change. Switching main audio from ${lastTrack.id} to ${activeTrack.id}`);
            mainPlaylistLoader.pause();
            mainSegmentLoader.resetEverything();
            pc.fastQualityChange_(newPlaylist);
            return;
        }
        if (type === 'AUDIO') {
            if (!activeGroup.playlistLoader) {
                // when switching from demuxed audio/video to muxed audio/video (noted by no
                // playlist loader for the audio group), we want to do a destructive reset of the
                // main segment loader and not restart the audio loaders
                mainSegmentLoader.setAudio(true); // don't have to worry about disabling the audio of the audio segment loader since
                // it should be stopped
                mainSegmentLoader.resetEverything();
                return;
            } // although the segment loader is an audio segment loader, call the setAudio
            // function to ensure it is prepared to re-append the init segment (or handle other
            // config changes)
            segmentLoader.setAudio(true);
            mainSegmentLoader.setAudio(false);
        }
        if (previousActiveLoader === activeGroup.playlistLoader) {
            // Nothing has actually changed. This can happen because track change events can fire
            // multiple times for a "single" change. One for enabling the new active track, and
            // one for disabling the track that was active
            $86defbb4e95ebb07$var$startLoaders(activeGroup.playlistLoader, mediaType);
            return;
        }
        if (segmentLoader.track) // For WebVTT, set the new text track in the segmentloader
        segmentLoader.track(activeTrack);
         // destructive reset
        segmentLoader.resetEverything();
        $86defbb4e95ebb07$var$startLoaders(activeGroup.playlistLoader, mediaType);
    };
const $86defbb4e95ebb07$var$onError = {
    /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning (or error if the playlist is excluded) to
   *         console and switches back to default audio track.
   * @function onError.AUDIO
   */ AUDIO: (type, settings)=>()=>{
            const { mediaTypes: { [type]: mediaType }, excludePlaylist: excludePlaylist } = settings; // switch back to default audio track
            const activeTrack = mediaType.activeTrack();
            const activeGroup = mediaType.activeGroup();
            const id = (activeGroup.filter((group)=>group.default)[0] || activeGroup[0]).id;
            const defaultTrack = mediaType.tracks[id];
            if (activeTrack === defaultTrack) {
                // Default track encountered an error. All we can do now is exclude the current
                // rendition and hope another will switch audio groups
                excludePlaylist({
                    error: {
                        message: 'Problem encountered loading the default audio track.'
                    }
                });
                return;
            }
            $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
            for(const trackId in mediaType.tracks)mediaType.tracks[trackId].enabled = mediaType.tracks[trackId] === defaultTrack;
            mediaType.onTrackChanged();
        },
    /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning to console and disables the active subtitle track
   * @function onError.SUBTITLES
   */ SUBTITLES: (type, settings)=>()=>{
            const { mediaTypes: { [type]: mediaType } } = settings;
            $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track.");
            const track = mediaType.activeTrack();
            if (track) track.mode = 'disabled';
            mediaType.onTrackChanged();
        }
};
const $86defbb4e95ebb07$var$setupListeners = {
    /**
   * Setup event listeners for audio playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.AUDIO
   */ AUDIO: (type, playlistLoader, settings)=>{
        if (!playlistLoader) // no playlist loader means audio will be muxed with the video
        return;
        const { tech: tech, requestOptions: requestOptions, segmentLoaders: { [type]: segmentLoader } } = settings;
        playlistLoader.on('loadedmetadata', ()=>{
            const media = playlistLoader.media();
            segmentLoader.playlist(media, requestOptions); // if the video is already playing, or if this isn't a live video and preload
            // permits, start downloading segments
            if (!tech.paused() || media.endList && tech.preload() !== 'none') segmentLoader.load();
        });
        playlistLoader.on('loadedplaylist', ()=>{
            segmentLoader.playlist(playlistLoader.media(), requestOptions); // If the player isn't paused, ensure that the segment loader is running
            if (!tech.paused()) segmentLoader.load();
        });
        playlistLoader.on('error', $86defbb4e95ebb07$var$onError[type](type, settings));
    },
    /**
   * Setup event listeners for subtitle playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.SUBTITLES
   */ SUBTITLES: (type, playlistLoader, settings)=>{
        const { tech: tech, requestOptions: requestOptions, segmentLoaders: { [type]: segmentLoader }, mediaTypes: { [type]: mediaType } } = settings;
        playlistLoader.on('loadedmetadata', ()=>{
            const media = playlistLoader.media();
            segmentLoader.playlist(media, requestOptions);
            segmentLoader.track(mediaType.activeTrack()); // if the video is already playing, or if this isn't a live video and preload
            // permits, start downloading segments
            if (!tech.paused() || media.endList && tech.preload() !== 'none') segmentLoader.load();
        });
        playlistLoader.on('loadedplaylist', ()=>{
            segmentLoader.playlist(playlistLoader.media(), requestOptions); // If the player isn't paused, ensure that the segment loader is running
            if (!tech.paused()) segmentLoader.load();
        });
        playlistLoader.on('error', $86defbb4e95ebb07$var$onError[type](type, settings));
    }
};
const $86defbb4e95ebb07$var$initialize = {
    /**
   * Setup PlaylistLoaders and AudioTracks for the audio groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.AUDIO
   */ 'AUDIO': (type, settings)=>{
        const { vhs: vhs, sourceType: sourceType, segmentLoaders: { [type]: segmentLoader }, requestOptions: requestOptions, main: { mediaGroups: mediaGroups }, mediaTypes: { [type]: { groups: groups, tracks: tracks, logger_: logger_ } }, mainPlaylistLoader: mainPlaylistLoader } = settings;
        const audioOnlyMain = $86defbb4e95ebb07$var$isAudioOnly(mainPlaylistLoader.main); // force a default if we have none
        if (!mediaGroups[type] || Object.keys(mediaGroups[type]).length === 0) {
            mediaGroups[type] = {
                main: {
                    default: {
                        default: true
                    }
                }
            };
            if (audioOnlyMain) mediaGroups[type].main.default.playlists = mainPlaylistLoader.main.playlists;
        }
        for(const groupId in mediaGroups[type]){
            if (!groups[groupId]) groups[groupId] = [];
            for(const variantLabel in mediaGroups[type][groupId]){
                let properties = mediaGroups[type][groupId][variantLabel];
                let playlistLoader;
                if (audioOnlyMain) {
                    logger_(`AUDIO group '${groupId}' label '${variantLabel}' is a main playlist`);
                    properties.isMainPlaylist = true;
                    playlistLoader = null; // if vhs-json was provided as the source, and the media playlist was resolved,
                // use the resolved media playlist object
                } else if (sourceType === 'vhs-json' && properties.playlists) playlistLoader = new $86defbb4e95ebb07$var$PlaylistLoader(properties.playlists[0], vhs, requestOptions);
                else if (properties.resolvedUri) playlistLoader = new $86defbb4e95ebb07$var$PlaylistLoader(properties.resolvedUri, vhs, requestOptions); // TODO: dash isn't the only type with properties.playlists
                else if (properties.playlists && sourceType === 'dash') playlistLoader = new $86defbb4e95ebb07$var$DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, mainPlaylistLoader);
                else // no resolvedUri means the audio is muxed with the video when using this
                // audio track
                playlistLoader = null;
                properties = $86defbb4e95ebb07$var$merge({
                    id: variantLabel,
                    playlistLoader: playlistLoader
                }, properties);
                $86defbb4e95ebb07$var$setupListeners[type](type, properties.playlistLoader, settings);
                groups[groupId].push(properties);
                if (typeof tracks[variantLabel] === 'undefined') {
                    const track = new $86defbb4e95ebb07$export$2e2bcd8739ae039.AudioTrack({
                        id: variantLabel,
                        kind: $86defbb4e95ebb07$var$audioTrackKind_(properties),
                        enabled: false,
                        language: properties.language,
                        default: properties.default,
                        label: variantLabel
                    });
                    tracks[variantLabel] = track;
                }
            }
        } // setup single error event handler for the segment loader
        segmentLoader.on('error', $86defbb4e95ebb07$var$onError[type](type, settings));
    },
    /**
   * Setup PlaylistLoaders and TextTracks for the subtitle groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.SUBTITLES
   */ 'SUBTITLES': (type, settings)=>{
        const { tech: tech, vhs: vhs, sourceType: sourceType, segmentLoaders: { [type]: segmentLoader }, requestOptions: requestOptions, main: { mediaGroups: mediaGroups }, mediaTypes: { [type]: { groups: groups, tracks: tracks } }, mainPlaylistLoader: mainPlaylistLoader } = settings;
        for(const groupId in mediaGroups[type]){
            if (!groups[groupId]) groups[groupId] = [];
            for(const variantLabel in mediaGroups[type][groupId]){
                if (!vhs.options_.useForcedSubtitles && mediaGroups[type][groupId][variantLabel].forced) continue;
                let properties = mediaGroups[type][groupId][variantLabel];
                let playlistLoader;
                if (sourceType === 'hls') playlistLoader = new $86defbb4e95ebb07$var$PlaylistLoader(properties.resolvedUri, vhs, requestOptions);
                else if (sourceType === 'dash') {
                    const playlists = properties.playlists.filter((p)=>p.excludeUntil !== Infinity);
                    if (!playlists.length) return;
                    playlistLoader = new $86defbb4e95ebb07$var$DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, mainPlaylistLoader);
                } else if (sourceType === 'vhs-json') playlistLoader = new $86defbb4e95ebb07$var$PlaylistLoader(// if the vhs-json object included the media playlist, use the media playlist
                // as provided, otherwise use the resolved URI to load the playlist
                properties.playlists ? properties.playlists[0] : properties.resolvedUri, vhs, requestOptions);
                properties = $86defbb4e95ebb07$var$merge({
                    id: variantLabel,
                    playlistLoader: playlistLoader
                }, properties);
                $86defbb4e95ebb07$var$setupListeners[type](type, properties.playlistLoader, settings);
                groups[groupId].push(properties);
                if (typeof tracks[variantLabel] === 'undefined') {
                    const track = tech.addRemoteTextTrack({
                        id: variantLabel,
                        kind: 'subtitles',
                        default: properties.default && properties.autoselect,
                        language: properties.language,
                        label: variantLabel
                    }, false).track;
                    tracks[variantLabel] = track;
                }
            }
        } // setup single error event handler for the segment loader
        segmentLoader.on('error', $86defbb4e95ebb07$var$onError[type](type, settings));
    },
    /**
   * Setup TextTracks for the closed-caption groups
   *
   * @param {String} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize['CLOSED-CAPTIONS']
   */ 'CLOSED-CAPTIONS': (type, settings)=>{
        const { tech: tech, main: { mediaGroups: mediaGroups }, mediaTypes: { [type]: { groups: groups, tracks: tracks } } } = settings;
        for(const groupId in mediaGroups[type]){
            if (!groups[groupId]) groups[groupId] = [];
            for(const variantLabel in mediaGroups[type][groupId]){
                const properties = mediaGroups[type][groupId][variantLabel]; // Look for either 608 (CCn) or 708 (SERVICEn) caption services
                if (!/^(?:CC|SERVICE)/.test(properties.instreamId)) continue;
                const captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
                let newProps = {
                    label: variantLabel,
                    language: properties.language,
                    instreamId: properties.instreamId,
                    default: properties.default && properties.autoselect
                };
                if (captionServices[newProps.instreamId]) newProps = $86defbb4e95ebb07$var$merge(newProps, captionServices[newProps.instreamId]);
                if (newProps.default === undefined) delete newProps.default;
                 // No PlaylistLoader is required for Closed-Captions because the captions are
                // embedded within the video stream
                groups[groupId].push($86defbb4e95ebb07$var$merge({
                    id: variantLabel
                }, properties));
                if (typeof tracks[variantLabel] === 'undefined') {
                    const track = tech.addRemoteTextTrack({
                        id: newProps.instreamId,
                        kind: 'captions',
                        default: newProps.default,
                        language: newProps.language,
                        label: newProps.label
                    }, false).track;
                    tracks[variantLabel] = track;
                }
            }
        }
    }
};
const $86defbb4e95ebb07$var$groupMatch = (list, media)=>{
    for(let i = 0; i < list.length; i++){
        if ($86defbb4e95ebb07$var$playlistMatch(media, list[i])) return true;
        if (list[i].playlists && $86defbb4e95ebb07$var$groupMatch(list[i].playlists, media)) return true;
    }
    return false;
};
/**
 * Returns a function used to get the active group of the provided type
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Function that returns the active media group for the provided type. Takes an
 *         optional parameter {TextTrack} track. If no track is provided, a list of all
 *         variants in the group, otherwise the variant corresponding to the provided
 *         track is returned.
 * @function activeGroup
 */ const $86defbb4e95ebb07$var$activeGroup = (type, settings)=>(track)=>{
        const { mainPlaylistLoader: mainPlaylistLoader, mediaTypes: { [type]: { groups: groups } } } = settings;
        const media = mainPlaylistLoader.media();
        if (!media) return null;
        let variants = null; // set to variants to main media active group
        if (media.attributes[type]) variants = groups[media.attributes[type]];
        const groupKeys = Object.keys(groups);
        if (!variants) {
            // find the mainPlaylistLoader media
            // that is in a media group if we are dealing
            // with audio only
            if (type === 'AUDIO' && groupKeys.length > 1 && $86defbb4e95ebb07$var$isAudioOnly(settings.main)) for(let i = 0; i < groupKeys.length; i++){
                const groupPropertyList = groups[groupKeys[i]];
                if ($86defbb4e95ebb07$var$groupMatch(groupPropertyList, media)) {
                    variants = groupPropertyList;
                    break;
                }
            } // use the main group if it exists
            else if (groups.main) variants = groups.main; // only one group, use that one
            else if (groupKeys.length === 1) variants = groups[groupKeys[0]];
        }
        if (typeof track === 'undefined') return variants;
        if (track === null || !variants) // An active track was specified so a corresponding group is expected. track === null
        // means no track is currently active so there is no corresponding group
        return null;
        return variants.filter((props)=>props.id === track.id)[0] || null;
    };
const $86defbb4e95ebb07$var$activeTrack = {
    /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.AUDIO
   */ AUDIO: (type, settings)=>()=>{
            const { mediaTypes: { [type]: { tracks: tracks } } } = settings;
            for(const id in tracks){
                if (tracks[id].enabled) return tracks[id];
            }
            return null;
        },
    /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.SUBTITLES
   */ SUBTITLES: (type, settings)=>()=>{
            const { mediaTypes: { [type]: { tracks: tracks } } } = settings;
            for(const id in tracks){
                if (tracks[id].mode === 'showing' || tracks[id].mode === 'hidden') return tracks[id];
            }
            return null;
        }
};
const $86defbb4e95ebb07$var$getActiveGroup = (type, { mediaTypes: mediaTypes })=>()=>{
        const activeTrack_ = mediaTypes[type].activeTrack();
        if (!activeTrack_) return null;
        return mediaTypes[type].activeGroup(activeTrack_);
    };
/**
 * Setup PlaylistLoaders and Tracks for media groups (Audio, Subtitles,
 * Closed-Captions) specified in the main manifest.
 *
 * @param {Object} settings
 *        Object containing required information for setting up the media groups
 * @param {Tech} settings.tech
 *        The tech of the player
 * @param {Object} settings.requestOptions
 *        XHR request options used by the segment loaders
 * @param {PlaylistLoader} settings.mainPlaylistLoader
 *        PlaylistLoader for the main source
 * @param {VhsHandler} settings.vhs
 *        VHS SourceHandler
 * @param {Object} settings.main
 *        The parsed main manifest
 * @param {Object} settings.mediaTypes
 *        Object to store the loaders, tracks, and utility methods for each media type
 * @param {Function} settings.excludePlaylist
 *        Excludes the current rendition and forces a rendition switch.
 * @function setupMediaGroups
 */ const $86defbb4e95ebb07$var$setupMediaGroups = (settings)=>{
    [
        'AUDIO',
        'SUBTITLES',
        'CLOSED-CAPTIONS'
    ].forEach((type)=>{
        $86defbb4e95ebb07$var$initialize[type](type, settings);
    });
    const { mediaTypes: mediaTypes, mainPlaylistLoader: mainPlaylistLoader, tech: tech, vhs: vhs, segmentLoaders: { ['AUDIO']: audioSegmentLoader, main: mainSegmentLoader } } = settings; // setup active group and track getters and change event handlers
    [
        'AUDIO',
        'SUBTITLES'
    ].forEach((type)=>{
        mediaTypes[type].activeGroup = $86defbb4e95ebb07$var$activeGroup(type, settings);
        mediaTypes[type].activeTrack = $86defbb4e95ebb07$var$activeTrack[type](type, settings);
        mediaTypes[type].onGroupChanged = $86defbb4e95ebb07$var$onGroupChanged(type, settings);
        mediaTypes[type].onGroupChanging = $86defbb4e95ebb07$var$onGroupChanging(type, settings);
        mediaTypes[type].onTrackChanged = $86defbb4e95ebb07$var$onTrackChanged(type, settings);
        mediaTypes[type].getActiveGroup = $86defbb4e95ebb07$var$getActiveGroup(type, settings);
    }); // DO NOT enable the default subtitle or caption track.
    // DO enable the default audio track
    const audioGroup = mediaTypes.AUDIO.activeGroup();
    if (audioGroup) {
        const groupId = (audioGroup.filter((group)=>group.default)[0] || audioGroup[0]).id;
        mediaTypes.AUDIO.tracks[groupId].enabled = true;
        mediaTypes.AUDIO.onGroupChanged();
        mediaTypes.AUDIO.onTrackChanged();
        const activeAudioGroup = mediaTypes.AUDIO.getActiveGroup(); // a similar check for handling setAudio on each loader is run again each time the
        // track is changed, but needs to be handled here since the track may not be considered
        // changed on the first call to onTrackChanged
        if (!activeAudioGroup.playlistLoader) // either audio is muxed with video or the stream is audio only
        mainSegmentLoader.setAudio(true);
        else {
            // audio is demuxed
            mainSegmentLoader.setAudio(false);
            audioSegmentLoader.setAudio(true);
        }
    }
    mainPlaylistLoader.on('mediachange', ()=>{
        [
            'AUDIO',
            'SUBTITLES'
        ].forEach((type)=>mediaTypes[type].onGroupChanged());
    });
    mainPlaylistLoader.on('mediachanging', ()=>{
        [
            'AUDIO',
            'SUBTITLES'
        ].forEach((type)=>mediaTypes[type].onGroupChanging());
    }); // custom audio track change event handler for usage event
    const onAudioTrackChanged = ()=>{
        mediaTypes.AUDIO.onTrackChanged();
        tech.trigger({
            type: 'usage',
            name: 'vhs-audio-change'
        });
    };
    tech.audioTracks().addEventListener('change', onAudioTrackChanged);
    tech.remoteTextTracks().addEventListener('change', mediaTypes.SUBTITLES.onTrackChanged);
    vhs.on('dispose', ()=>{
        tech.audioTracks().removeEventListener('change', onAudioTrackChanged);
        tech.remoteTextTracks().removeEventListener('change', mediaTypes.SUBTITLES.onTrackChanged);
    }); // clear existing audio tracks and add the ones we just created
    tech.clearTracks('audio');
    for(const id in mediaTypes.AUDIO.tracks)tech.audioTracks().addTrack(mediaTypes.AUDIO.tracks[id]);
};
/**
 * Creates skeleton object used to store the loaders, tracks, and utility methods for each
 * media type
 *
 * @return {Object}
 *         Object to store the loaders, tracks, and utility methods for each media type
 * @function createMediaTypes
 */ const $86defbb4e95ebb07$var$createMediaTypes = ()=>{
    const mediaTypes = {};
    [
        'AUDIO',
        'SUBTITLES',
        'CLOSED-CAPTIONS'
    ].forEach((type)=>{
        mediaTypes[type] = {
            groups: {},
            tracks: {},
            activePlaylistLoader: null,
            activeGroup: $86defbb4e95ebb07$var$noop,
            activeTrack: $86defbb4e95ebb07$var$noop,
            getActiveGroup: $86defbb4e95ebb07$var$noop,
            onGroupChanged: $86defbb4e95ebb07$var$noop,
            onTrackChanged: $86defbb4e95ebb07$var$noop,
            lastTrack_: null,
            logger_: $86defbb4e95ebb07$var$logger(`MediaGroups[${type}]`)
        };
    });
    return mediaTypes;
};
/**
 * A utility class for setting properties and maintaining the state of the content steering manifest.
 *
 * Content Steering manifest format:
 * VERSION: number (required) currently only version 1 is supported.
 * TTL: number in seconds (optional) until the next content steering manifest reload.
 * RELOAD-URI: string (optional) uri to fetch the next content steering manifest.
 * SERVICE-LOCATION-PRIORITY or PATHWAY-PRIORITY a non empty array of unique string values.
 * PATHWAY-CLONES: array (optional) (HLS only) pathway clone objects to copy from other playlists.
 */ class $86defbb4e95ebb07$var$SteeringManifest {
    constructor(){
        this.priority_ = [];
        this.pathwayClones_ = new Map();
    }
    set version(number) {
        // Only version 1 is currently supported for both DASH and HLS.
        if (number === 1) this.version_ = number;
    }
    set ttl(seconds) {
        // TTL = time-to-live, default = 300 seconds.
        this.ttl_ = seconds || 300;
    }
    set reloadUri(uri) {
        if (uri) // reload URI can be relative to the previous reloadUri.
        this.reloadUri_ = $86defbb4e95ebb07$var$resolveUrl(this.reloadUri_, uri);
    }
    set priority(array) {
        // priority must be non-empty and unique values.
        if (array && array.length) this.priority_ = array;
    }
    set pathwayClones(array) {
        // pathwayClones must be non-empty.
        if (array && array.length) this.pathwayClones_ = new Map(array.map((clone)=>[
                clone.ID,
                clone
            ]));
    }
    get version() {
        return this.version_;
    }
    get ttl() {
        return this.ttl_;
    }
    get reloadUri() {
        return this.reloadUri_;
    }
    get priority() {
        return this.priority_;
    }
    get pathwayClones() {
        return this.pathwayClones_;
    }
}
/**
 * This class represents a content steering manifest and associated state. See both HLS and DASH specifications.
 * HLS: https://developer.apple.com/streaming/HLSContentSteeringSpecification.pdf and
 * https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/ section 4.4.6.6.
 * DASH: https://dashif.org/docs/DASH-IF-CTS-00XX-Content-Steering-Community-Review.pdf
 *
 * @param {function} xhr for making a network request from the browser.
 * @param {function} bandwidth for fetching the current bandwidth from the main segment loader.
 */ class $86defbb4e95ebb07$var$ContentSteeringController extends $86defbb4e95ebb07$export$2e2bcd8739ae039.EventTarget {
    constructor(xhr, bandwidth){
        super();
        this.currentPathway = null;
        this.defaultPathway = null;
        this.queryBeforeStart = false;
        this.availablePathways_ = new Set();
        this.steeringManifest = new $86defbb4e95ebb07$var$SteeringManifest();
        this.proxyServerUrl_ = null;
        this.manifestType_ = null;
        this.ttlTimeout_ = null;
        this.request_ = null;
        this.currentPathwayClones = new Map();
        this.nextPathwayClones = new Map();
        this.excludedSteeringManifestURLs = new Set();
        this.logger_ = $86defbb4e95ebb07$var$logger('Content Steering');
        this.xhr_ = xhr;
        this.getBandwidth_ = bandwidth;
    }
    /**
   * Assigns the content steering tag properties to the steering controller
   *
   * @param {string} baseUrl the baseURL from the main manifest for resolving the steering manifest url
   * @param {Object} steeringTag the content steering tag from the main manifest
   */ assignTagProperties(baseUrl, steeringTag) {
        this.manifestType_ = steeringTag.serverUri ? 'HLS' : 'DASH'; // serverUri is HLS serverURL is DASH
        const steeringUri = steeringTag.serverUri || steeringTag.serverURL;
        if (!steeringUri) {
            this.logger_(`steering manifest URL is ${steeringUri}, cannot request steering manifest.`);
            this.trigger('error');
            return;
        } // Content steering manifests can be encoded as a data URI. We can decode, parse and return early if that's the case.
        if (steeringUri.startsWith('data:')) {
            this.decodeDataUriManifest_(steeringUri.substring(steeringUri.indexOf(',') + 1));
            return;
        } // reloadUri is the resolution of the main manifest URL and steering URL.
        this.steeringManifest.reloadUri = $86defbb4e95ebb07$var$resolveUrl(baseUrl, steeringUri); // pathwayId is HLS defaultServiceLocation is DASH
        this.defaultPathway = steeringTag.pathwayId || steeringTag.defaultServiceLocation; // currently only DASH supports the following properties on <ContentSteering> tags.
        this.queryBeforeStart = steeringTag.queryBeforeStart;
        this.proxyServerUrl_ = steeringTag.proxyServerURL; // trigger a steering event if we have a pathway from the content steering tag.
        // this tells VHS which segment pathway to start with.
        // If queryBeforeStart is true we need to wait for the steering manifest response.
        if (this.defaultPathway && !this.queryBeforeStart) this.trigger('content-steering');
    }
    /**
   * Requests the content steering manifest and parse the response. This should only be called after
   * assignTagProperties was called with a content steering tag.
   *
   * @param {string} initialUri The optional uri to make the request with.
   *    If set, the request should be made with exactly what is passed in this variable.
   *    This scenario should only happen once on initalization.
   */ requestSteeringManifest(initial) {
        const reloadUri = this.steeringManifest.reloadUri;
        if (!reloadUri) return;
         // We currently don't support passing MPD query parameters directly to the content steering URL as this requires
        // ExtUrlQueryInfo tag support. See the DASH content steering spec section 8.1.
        // This request URI accounts for manifest URIs that have been excluded.
        const uri = initial ? reloadUri : this.getRequestURI(reloadUri); // If there are no valid manifest URIs, we should stop content steering.
        if (!uri) {
            this.logger_('No valid content steering manifest URIs. Stopping content steering.');
            this.trigger('error');
            this.dispose();
            return;
        }
        const metadata = {
            contentSteeringInfo: {
                uri: uri
            }
        };
        this.trigger({
            type: 'contentsteeringloadstart',
            metadata: metadata
        });
        this.request_ = this.xhr_({
            uri: uri,
            requestType: 'content-steering-manifest'
        }, (error, errorInfo)=>{
            if (error) {
                // If the client receives HTTP 410 Gone in response to a manifest request,
                // it MUST NOT issue another request for that URI for the remainder of the
                // playback session. It MAY continue to use the most-recently obtained set
                // of Pathways.
                if (errorInfo.status === 410) {
                    this.logger_(`manifest request 410 ${error}.`);
                    this.logger_(`There will be no more content steering requests to ${uri} this session.`);
                    this.excludedSteeringManifestURLs.add(uri);
                    return;
                } // If the client receives HTTP 429 Too Many Requests with a Retry-After
                // header in response to a manifest request, it SHOULD wait until the time
                // specified by the Retry-After header to reissue the request.
                if (errorInfo.status === 429) {
                    const retrySeconds = errorInfo.responseHeaders['retry-after'];
                    this.logger_(`manifest request 429 ${error}.`);
                    this.logger_(`content steering will retry in ${retrySeconds} seconds.`);
                    this.startTTLTimeout_(parseInt(retrySeconds, 10));
                    return;
                } // If the Steering Manifest cannot be loaded and parsed correctly, the
                // client SHOULD continue to use the previous values and attempt to reload
                // it after waiting for the previously-specified TTL (or 5 minutes if
                // none).
                this.logger_(`manifest failed to load ${error}.`);
                this.startTTLTimeout_();
                return;
            }
            this.trigger({
                type: 'contentsteeringloadcomplete',
                metadata: metadata
            });
            let steeringManifestJson;
            try {
                steeringManifestJson = JSON.parse(this.request_.responseText);
            } catch (parseError) {
                const errorMetadata = {
                    errorType: $86defbb4e95ebb07$export$2e2bcd8739ae039.Error.StreamingContentSteeringParserError,
                    error: parseError
                };
                this.trigger({
                    type: 'error',
                    metadata: errorMetadata
                });
            }
            this.assignSteeringProperties_(steeringManifestJson);
            const parsedMetadata = {
                contentSteeringInfo: metadata.contentSteeringInfo,
                contentSteeringManifest: {
                    version: this.steeringManifest.version,
                    reloadUri: this.steeringManifest.reloadUri,
                    priority: this.steeringManifest.priority
                }
            };
            this.trigger({
                type: 'contentsteeringparsed',
                metadata: parsedMetadata
            });
            this.startTTLTimeout_();
        });
    }
    /**
   * Set the proxy server URL and add the steering manifest url as a URI encoded parameter.
   *
   * @param {string} steeringUrl the steering manifest url
   * @return the steering manifest url to a proxy server with all parameters set
   */ setProxyServerUrl_(steeringUrl) {
        const steeringUrlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).URL(steeringUrl);
        const proxyServerUrlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).URL(this.proxyServerUrl_);
        proxyServerUrlObject.searchParams.set('url', encodeURI(steeringUrlObject.toString()));
        return this.setSteeringParams_(proxyServerUrlObject.toString());
    }
    /**
   * Decodes and parses the data uri encoded steering manifest
   *
   * @param {string} dataUri the data uri to be decoded and parsed.
   */ decodeDataUriManifest_(dataUri) {
        const steeringManifestJson = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).atob(dataUri));
        this.assignSteeringProperties_(steeringManifestJson);
    }
    /**
   * Set the HLS or DASH content steering manifest request query parameters. For example:
   * _HLS_pathway="<CURRENT-PATHWAY-ID>" and _HLS_throughput=<THROUGHPUT>
   * _DASH_pathway and _DASH_throughput
   *
   * @param {string} uri to add content steering server parameters to.
   * @return a new uri as a string with the added steering query parameters.
   */ setSteeringParams_(url) {
        const urlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).URL(url);
        const path = this.getPathway();
        const networkThroughput = this.getBandwidth_();
        if (path) {
            const pathwayKey = `_${this.manifestType_}_pathway`;
            urlObject.searchParams.set(pathwayKey, path);
        }
        if (networkThroughput) {
            const throughputKey = `_${this.manifestType_}_throughput`;
            urlObject.searchParams.set(throughputKey, networkThroughput);
        }
        return urlObject.toString();
    }
    /**
   * Assigns the current steering manifest properties and to the SteeringManifest object
   *
   * @param {Object} steeringJson the raw JSON steering manifest
   */ assignSteeringProperties_(steeringJson) {
        this.steeringManifest.version = steeringJson.VERSION;
        if (!this.steeringManifest.version) {
            this.logger_(`manifest version is ${steeringJson.VERSION}, which is not supported.`);
            this.trigger('error');
            return;
        }
        this.steeringManifest.ttl = steeringJson.TTL;
        this.steeringManifest.reloadUri = steeringJson['RELOAD-URI']; // HLS = PATHWAY-PRIORITY required. DASH = SERVICE-LOCATION-PRIORITY optional
        this.steeringManifest.priority = steeringJson['PATHWAY-PRIORITY'] || steeringJson['SERVICE-LOCATION-PRIORITY']; // Pathway clones to be created/updated in HLS.
        // See section 7.2 https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/
        this.steeringManifest.pathwayClones = steeringJson['PATHWAY-CLONES'];
        this.nextPathwayClones = this.steeringManifest.pathwayClones; // 1. apply first pathway from the array.
        // 2. if first pathway doesn't exist in manifest, try next pathway.
        //    a. if all pathways are exhausted, ignore the steering manifest priority.
        // 3. if segments fail from an established pathway, try all variants/renditions, then exclude the failed pathway.
        //    a. exclude a pathway for a minimum of the last TTL duration. Meaning, from the next steering response,
        //       the excluded pathway will be ignored.
        //       See excludePathway usage in excludePlaylist().
        // If there are no available pathways, we need to stop content steering.
        if (!this.availablePathways_.size) {
            this.logger_('There are no available pathways for content steering. Ending content steering.');
            this.trigger('error');
            this.dispose();
        }
        const chooseNextPathway = (pathwaysByPriority)=>{
            for (const path of pathwaysByPriority){
                if (this.availablePathways_.has(path)) return path;
            } // If no pathway matches, ignore the manifest and choose the first available.
            return [
                ...this.availablePathways_
            ][0];
        };
        const nextPathway = chooseNextPathway(this.steeringManifest.priority);
        if (this.currentPathway !== nextPathway) {
            this.currentPathway = nextPathway;
            this.trigger('content-steering');
        }
    }
    /**
   * Returns the pathway to use for steering decisions
   *
   * @return {string} returns the current pathway or the default
   */ getPathway() {
        return this.currentPathway || this.defaultPathway;
    }
    /**
   * Chooses the manifest request URI based on proxy URIs and server URLs.
   * Also accounts for exclusion on certain manifest URIs.
   *
   * @param {string} reloadUri the base uri before parameters
   *
   * @return {string} the final URI for the request to the manifest server.
   */ getRequestURI(reloadUri) {
        if (!reloadUri) return null;
        const isExcluded = (uri)=>this.excludedSteeringManifestURLs.has(uri);
        if (this.proxyServerUrl_) {
            const proxyURI = this.setProxyServerUrl_(reloadUri);
            if (!isExcluded(proxyURI)) return proxyURI;
        }
        const steeringURI = this.setSteeringParams_(reloadUri);
        if (!isExcluded(steeringURI)) return steeringURI;
         // Return nothing if all valid manifest URIs are excluded.
        return null;
    }
    /**
   * Start the timeout for re-requesting the steering manifest at the TTL interval.
   *
   * @param {number} ttl time in seconds of the timeout. Defaults to the
   *        ttl interval in the steering manifest
   */ startTTLTimeout_(ttl = this.steeringManifest.ttl) {
        // 300 (5 minutes) is the default value.
        const ttlMS = ttl * 1000;
        this.ttlTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(()=>{
            this.requestSteeringManifest();
        }, ttlMS);
    }
    /**
   * Clear the TTL timeout if necessary.
   */ clearTTLTimeout_() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.ttlTimeout_);
        this.ttlTimeout_ = null;
    }
    /**
   * aborts any current steering xhr and sets the current request object to null
   */ abort() {
        if (this.request_) this.request_.abort();
        this.request_ = null;
    }
    /**
   * aborts steering requests clears the ttl timeout and resets all properties.
   */ dispose() {
        this.off('content-steering');
        this.off('error');
        this.abort();
        this.clearTTLTimeout_();
        this.currentPathway = null;
        this.defaultPathway = null;
        this.queryBeforeStart = null;
        this.proxyServerUrl_ = null;
        this.manifestType_ = null;
        this.ttlTimeout_ = null;
        this.request_ = null;
        this.excludedSteeringManifestURLs = new Set();
        this.availablePathways_ = new Set();
        this.steeringManifest = new $86defbb4e95ebb07$var$SteeringManifest();
    }
    /**
   * adds a pathway to the available pathways set
   *
   * @param {string} pathway the pathway string to add
   */ addAvailablePathway(pathway) {
        if (pathway) this.availablePathways_.add(pathway);
    }
    /**
   * Clears all pathways from the available pathways set
   */ clearAvailablePathways() {
        this.availablePathways_.clear();
    }
    /**
   * Removes a pathway from the available pathways set.
   */ excludePathway(pathway) {
        return this.availablePathways_.delete(pathway);
    }
    /**
   * Checks the refreshed DASH manifest content steering tag for changes.
   *
   * @param {string} baseURL new steering tag on DASH manifest refresh
   * @param {Object} newTag the new tag to check for changes
   * @return a true or false whether the new tag has different values
   */ didDASHTagChange(baseURL, newTag) {
        return !newTag && this.steeringManifest.reloadUri || newTag && ($86defbb4e95ebb07$var$resolveUrl(baseURL, newTag.serverURL) !== this.steeringManifest.reloadUri || newTag.defaultServiceLocation !== this.defaultPathway || newTag.queryBeforeStart !== this.queryBeforeStart || newTag.proxyServerURL !== this.proxyServerUrl_);
    }
    getAvailablePathways() {
        return this.availablePathways_;
    }
}
const $86defbb4e95ebb07$var$debounce = (callback, wait)=>{
    let timeoutId = null;
    return (...args)=>{
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            callback.apply(null, args);
        }, wait);
    };
};
const $86defbb4e95ebb07$var$ABORT_EARLY_EXCLUSION_SECONDS = 10;
let $86defbb4e95ebb07$var$Vhs$1; // SegmentLoader stats that need to have each loader's
// values summed to calculate the final value
const $86defbb4e95ebb07$var$loaderStats = [
    'mediaRequests',
    'mediaRequestsAborted',
    'mediaRequestsTimedout',
    'mediaRequestsErrored',
    'mediaTransferDuration',
    'mediaBytesTransferred',
    'mediaAppends'
];
const $86defbb4e95ebb07$var$sumLoaderStat = function(stat) {
    return this.audioSegmentLoader_[stat] + this.mainSegmentLoader_[stat];
};
const $86defbb4e95ebb07$var$shouldSwitchToMedia = function({ currentPlaylist: currentPlaylist, buffered: buffered, currentTime: currentTime, nextPlaylist: nextPlaylist, bufferLowWaterLine: bufferLowWaterLine, bufferHighWaterLine: bufferHighWaterLine, duration: duration, bufferBasedABR: bufferBasedABR, log: log }) {
    // we have no other playlist to switch to
    if (!nextPlaylist) {
        $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn('We received no playlist to switch to. Please check your stream.');
        return false;
    }
    const sharedLogLine = `allowing switch ${currentPlaylist && currentPlaylist.id || 'null'} -> ${nextPlaylist.id}`;
    if (!currentPlaylist) {
        log(`${sharedLogLine} as current playlist is not set`);
        return true;
    } // no need to switch if playlist is the same
    if (nextPlaylist.id === currentPlaylist.id) return false;
     // determine if current time is in a buffered range.
    const isBuffered = Boolean($86defbb4e95ebb07$var$findRange(buffered, currentTime).length); // If the playlist is live, then we want to not take low water line into account.
    // This is because in LIVE, the player plays 3 segments from the end of the
    // playlist, and if `BUFFER_LOW_WATER_LINE` is greater than the duration availble
    // in those segments, a viewer will never experience a rendition upswitch.
    if (!currentPlaylist.endList) {
        // For LLHLS live streams, don't switch renditions before playback has started, as it almost
        // doubles the time to first playback.
        if (!isBuffered && typeof currentPlaylist.partTargetDuration === 'number') {
            log(`not ${sharedLogLine} as current playlist is live llhls, but currentTime isn't in buffered.`);
            return false;
        }
        log(`${sharedLogLine} as current playlist is live`);
        return true;
    }
    const forwardBuffer = $86defbb4e95ebb07$var$timeAheadOf(buffered, currentTime);
    const maxBufferLowWaterLine = bufferBasedABR ? $86defbb4e95ebb07$var$Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : $86defbb4e95ebb07$var$Config.MAX_BUFFER_LOW_WATER_LINE; // For the same reason as LIVE, we ignore the low water line when the VOD
    // duration is below the max potential low water line
    if (duration < maxBufferLowWaterLine) {
        log(`${sharedLogLine} as duration < max low water line (${duration} < ${maxBufferLowWaterLine})`);
        return true;
    }
    const nextBandwidth = nextPlaylist.attributes.BANDWIDTH;
    const currBandwidth = currentPlaylist.attributes.BANDWIDTH; // when switching down, if our buffer is lower than the high water line,
    // we can switch down
    if (nextBandwidth < currBandwidth && (!bufferBasedABR || forwardBuffer < bufferHighWaterLine)) {
        let logLine = `${sharedLogLine} as next bandwidth < current bandwidth (${nextBandwidth} < ${currBandwidth})`;
        if (bufferBasedABR) logLine += ` and forwardBuffer < bufferHighWaterLine (${forwardBuffer} < ${bufferHighWaterLine})`;
        log(logLine);
        return true;
    } // and if our buffer is higher than the low water line,
    // we can switch up
    if ((!bufferBasedABR || nextBandwidth > currBandwidth) && forwardBuffer >= bufferLowWaterLine) {
        let logLine = `${sharedLogLine} as forwardBuffer >= bufferLowWaterLine (${forwardBuffer} >= ${bufferLowWaterLine})`;
        if (bufferBasedABR) logLine += ` and next bandwidth > current bandwidth (${nextBandwidth} > ${currBandwidth})`;
        log(logLine);
        return true;
    }
    log(`not ${sharedLogLine} as no switching criteria met`);
    return false;
};
/**
 * the main playlist controller controller all interactons
 * between playlists and segmentloaders. At this time this mainly
 * involves a main playlist and a series of audio playlists
 * if they are available
 *
 * @class PlaylistController
 * @extends videojs.EventTarget
 */ class $86defbb4e95ebb07$var$PlaylistController extends $86defbb4e95ebb07$export$2e2bcd8739ae039.EventTarget {
    constructor(options){
        super(); // Adding a slight debounce to avoid duplicate calls during rapid quality changes, for example:
        // When selecting quality from the quality list,
        // where we may have multiple bandwidth profiles for the same vertical resolution.
        this.fastQualityChange_ = $86defbb4e95ebb07$var$debounce(this.fastQualityChange_.bind(this), 100);
        const { src: src, withCredentials: withCredentials, tech: tech, bandwidth: bandwidth, externVhs: externVhs, useCueTags: useCueTags, playlistExclusionDuration: playlistExclusionDuration, enableLowInitialPlaylist: enableLowInitialPlaylist, sourceType: sourceType, cacheEncryptionKeys: cacheEncryptionKeys, bufferBasedABR: bufferBasedABR, leastPixelDiffSelector: leastPixelDiffSelector, captionServices: captionServices, experimentalUseMMS: experimentalUseMMS } = options;
        if (!src) throw new Error('A non-empty playlist URL or JSON manifest string is required');
        let { maxPlaylistRetries: maxPlaylistRetries } = options;
        if (maxPlaylistRetries === null || typeof maxPlaylistRetries === 'undefined') maxPlaylistRetries = Infinity;
        $86defbb4e95ebb07$var$Vhs$1 = externVhs;
        this.bufferBasedABR = Boolean(bufferBasedABR);
        this.leastPixelDiffSelector = Boolean(leastPixelDiffSelector);
        this.withCredentials = withCredentials;
        this.tech_ = tech;
        this.vhs_ = tech.vhs;
        this.player_ = options.player_;
        this.sourceType_ = sourceType;
        this.useCueTags_ = useCueTags;
        this.playlistExclusionDuration = playlistExclusionDuration;
        this.maxPlaylistRetries = maxPlaylistRetries;
        this.enableLowInitialPlaylist = enableLowInitialPlaylist;
        this.usingManagedMediaSource_ = false;
        if (this.useCueTags_) {
            this.cueTagsTrack_ = this.tech_.addTextTrack('metadata', 'ad-cues');
            this.cueTagsTrack_.inBandMetadataTrackDispatchType = '';
        }
        this.requestOptions_ = {
            withCredentials: withCredentials,
            maxPlaylistRetries: maxPlaylistRetries,
            timeout: null
        };
        this.on('error', this.pauseLoading);
        this.mediaTypes_ = $86defbb4e95ebb07$var$createMediaTypes();
        if (experimentalUseMMS && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).ManagedMediaSource) {
            // Airplay source not yet implemented. Remote playback must be disabled.
            this.tech_.el_.disableRemotePlayback = true;
            this.mediaSource = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).ManagedMediaSource();
            this.usingManagedMediaSource_ = true;
            $86defbb4e95ebb07$export$2e2bcd8739ae039.log('Using ManagedMediaSource');
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).MediaSource) this.mediaSource = new (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).MediaSource();
        this.handleDurationChange_ = this.handleDurationChange_.bind(this);
        this.handleSourceOpen_ = this.handleSourceOpen_.bind(this);
        this.handleSourceEnded_ = this.handleSourceEnded_.bind(this);
        this.load = this.load.bind(this);
        this.pause = this.pause.bind(this);
        this.mediaSource.addEventListener('durationchange', this.handleDurationChange_); // load the media source into the player
        this.mediaSource.addEventListener('sourceopen', this.handleSourceOpen_);
        this.mediaSource.addEventListener('sourceended', this.handleSourceEnded_);
        this.mediaSource.addEventListener('startstreaming', this.load);
        this.mediaSource.addEventListener('endstreaming', this.pause); // we don't have to handle sourceclose since dispose will handle termination of
        // everything, and the MediaSource should not be detached without a proper disposal
        this.seekable_ = $86defbb4e95ebb07$var$createTimeRanges();
        this.hasPlayed_ = false;
        this.syncController_ = new $86defbb4e95ebb07$var$SyncController(options);
        this.segmentMetadataTrack_ = tech.addRemoteTextTrack({
            kind: 'metadata',
            label: 'segment-metadata'
        }, false).track;
        this.segmentMetadataTrack_.mode = 'hidden';
        this.decrypter_ = new $86defbb4e95ebb07$var$Decrypter();
        this.sourceUpdater_ = new $86defbb4e95ebb07$var$SourceUpdater(this.mediaSource);
        this.inbandTextTracks_ = {};
        this.timelineChangeController_ = new $86defbb4e95ebb07$var$TimelineChangeController();
        this.keyStatusMap_ = new Map();
        const segmentLoaderSettings = {
            vhs: this.vhs_,
            parse708captions: options.parse708captions,
            useDtsForTimestampOffset: options.useDtsForTimestampOffset,
            captionServices: captionServices,
            mediaSource: this.mediaSource,
            currentTime: this.tech_.currentTime.bind(this.tech_),
            seekable: ()=>this.seekable(),
            seeking: ()=>this.tech_.seeking(),
            duration: ()=>this.duration(),
            hasPlayed: ()=>this.hasPlayed_,
            goalBufferLength: ()=>this.goalBufferLength(),
            bandwidth: bandwidth,
            syncController: this.syncController_,
            decrypter: this.decrypter_,
            sourceType: this.sourceType_,
            inbandTextTracks: this.inbandTextTracks_,
            cacheEncryptionKeys: cacheEncryptionKeys,
            sourceUpdater: this.sourceUpdater_,
            timelineChangeController: this.timelineChangeController_,
            exactManifestTimings: options.exactManifestTimings,
            addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
        }; // The source type check not only determines whether a special DASH playlist loader
        // should be used, but also covers the case where the provided src is a vhs-json
        // manifest object (instead of a URL). In the case of vhs-json, the default
        // PlaylistLoader should be used.
        this.mainPlaylistLoader_ = this.sourceType_ === 'dash' ? new $86defbb4e95ebb07$var$DashPlaylistLoader(src, this.vhs_, $86defbb4e95ebb07$var$merge(this.requestOptions_, {
            addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
        })) : new $86defbb4e95ebb07$var$PlaylistLoader(src, this.vhs_, $86defbb4e95ebb07$var$merge(this.requestOptions_, {
            addDateRangesToTextTrack: this.addDateRangesToTextTrack_.bind(this)
        }));
        this.setupMainPlaylistLoaderListeners_(); // setup segment loaders
        // combined audio/video or just video when alternate audio track is selected
        this.mainSegmentLoader_ = new $86defbb4e95ebb07$var$SegmentLoader($86defbb4e95ebb07$var$merge(segmentLoaderSettings, {
            segmentMetadataTrack: this.segmentMetadataTrack_,
            loaderType: 'main'
        }), options); // alternate audio track
        this.audioSegmentLoader_ = new $86defbb4e95ebb07$var$SegmentLoader($86defbb4e95ebb07$var$merge(segmentLoaderSettings, {
            loaderType: 'audio'
        }), options);
        this.subtitleSegmentLoader_ = new $86defbb4e95ebb07$var$VTTSegmentLoader($86defbb4e95ebb07$var$merge(segmentLoaderSettings, {
            loaderType: 'vtt',
            featuresNativeTextTracks: this.tech_.featuresNativeTextTracks,
            loadVttJs: ()=>new Promise((resolve, reject)=>{
                    function onLoad() {
                        tech.off('vttjserror', onError);
                        resolve();
                    }
                    function onError() {
                        tech.off('vttjsloaded', onLoad);
                        reject();
                    }
                    tech.one('vttjsloaded', onLoad);
                    tech.one('vttjserror', onError); // safe to call multiple times, script will be loaded only once:
                    tech.addWebVttScript_();
                })
        }), options);
        const getBandwidth = ()=>{
            return this.mainSegmentLoader_.bandwidth;
        };
        this.contentSteeringController_ = new $86defbb4e95ebb07$var$ContentSteeringController(this.vhs_.xhr, getBandwidth);
        this.setupSegmentLoaderListeners_();
        if (this.bufferBasedABR) {
            this.mainPlaylistLoader_.one('loadedplaylist', ()=>this.startABRTimer_());
            this.tech_.on('pause', ()=>this.stopABRTimer_());
            this.tech_.on('play', ()=>this.startABRTimer_());
        } // Create SegmentLoader stat-getters
        // mediaRequests_
        // mediaRequestsAborted_
        // mediaRequestsTimedout_
        // mediaRequestsErrored_
        // mediaTransferDuration_
        // mediaBytesTransferred_
        // mediaAppends_
        $86defbb4e95ebb07$var$loaderStats.forEach((stat)=>{
            this[stat + '_'] = $86defbb4e95ebb07$var$sumLoaderStat.bind(this, stat);
        });
        this.logger_ = $86defbb4e95ebb07$var$logger('pc');
        this.triggeredFmp4Usage = false;
        if (this.tech_.preload() === 'none') {
            this.loadOnPlay_ = ()=>{
                this.loadOnPlay_ = null;
                this.mainPlaylistLoader_.load();
            };
            this.tech_.one('play', this.loadOnPlay_);
        } else this.mainPlaylistLoader_.load();
        this.timeToLoadedData__ = -1;
        this.mainAppendsToLoadedData__ = -1;
        this.audioAppendsToLoadedData__ = -1;
        const event = this.tech_.preload() === 'none' ? 'play' : 'loadstart'; // start the first frame timer on loadstart or play (for preload none)
        this.tech_.one(event, ()=>{
            const timeToLoadedDataStart = Date.now();
            this.tech_.one('loadeddata', ()=>{
                this.timeToLoadedData__ = Date.now() - timeToLoadedDataStart;
                this.mainAppendsToLoadedData__ = this.mainSegmentLoader_.mediaAppends;
                this.audioAppendsToLoadedData__ = this.audioSegmentLoader_.mediaAppends;
            });
        });
    }
    mainAppendsToLoadedData_() {
        return this.mainAppendsToLoadedData__;
    }
    audioAppendsToLoadedData_() {
        return this.audioAppendsToLoadedData__;
    }
    appendsToLoadedData_() {
        const main = this.mainAppendsToLoadedData_();
        const audio = this.audioAppendsToLoadedData_();
        if (main === -1 || audio === -1) return -1;
        return main + audio;
    }
    timeToLoadedData_() {
        return this.timeToLoadedData__;
    }
    /**
   * Run selectPlaylist and switch to the new playlist if we should
   *
   * @param {string} [reason=abr] a reason for why the ABR check is made
   * @private
   */ checkABR_(reason = 'abr') {
        const nextPlaylist = this.selectPlaylist();
        if (nextPlaylist && this.shouldSwitchToMedia_(nextPlaylist)) this.switchMedia_(nextPlaylist, reason);
    }
    switchMedia_(playlist, cause, delay) {
        const oldMedia = this.media();
        const oldId = oldMedia && (oldMedia.id || oldMedia.uri);
        const newId = playlist && (playlist.id || playlist.uri);
        if (oldId && oldId !== newId) {
            this.logger_(`switch media ${oldId} -> ${newId} from ${cause}`);
            const metadata = {
                renditionInfo: {
                    id: newId,
                    bandwidth: playlist.attributes.BANDWIDTH,
                    resolution: playlist.attributes.RESOLUTION,
                    codecs: playlist.attributes.CODECS
                },
                cause: cause
            };
            this.trigger({
                type: 'renditionselected',
                metadata: metadata
            });
            this.tech_.trigger({
                type: 'usage',
                name: `vhs-rendition-change-${cause}`
            });
        }
        this.mainPlaylistLoader_.media(playlist, delay);
    }
    /**
   * A function that ensures we switch our playlists inside of `mediaTypes`
   * to match the current `serviceLocation` provided by the contentSteering controller.
   * We want to check media types of `AUDIO`, `SUBTITLES`, and `CLOSED-CAPTIONS`.
   *
   * This should only be called on a DASH playback scenario while using content steering.
   * This is necessary due to differences in how media in HLS manifests are generally tied to
   * a video playlist, where in DASH that is not always the case.
   */ switchMediaForDASHContentSteering_() {
        [
            'AUDIO',
            'SUBTITLES',
            'CLOSED-CAPTIONS'
        ].forEach((type)=>{
            const mediaType = this.mediaTypes_[type];
            const activeGroup = mediaType ? mediaType.activeGroup() : null;
            const pathway = this.contentSteeringController_.getPathway();
            if (activeGroup && pathway) {
                // activeGroup can be an array or a single group
                const mediaPlaylists = activeGroup.length ? activeGroup[0].playlists : activeGroup.playlists;
                const dashMediaPlaylists = mediaPlaylists.filter((p)=>p.attributes.serviceLocation === pathway); // Switch the current active playlist to the correct CDN
                if (dashMediaPlaylists.length) this.mediaTypes_[type].activePlaylistLoader.media(dashMediaPlaylists[0]);
            }
        });
    }
    /**
   * Start a timer that periodically calls checkABR_
   *
   * @private
   */ startABRTimer_() {
        this.stopABRTimer_();
        this.abrTimer_ = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setInterval(()=>this.checkABR_(), 250);
    }
    /**
   * Stop the timer that periodically calls checkABR_
   *
   * @private
   */ stopABRTimer_() {
        // if we're scrubbing, we don't need to pause.
        // This getter will be added to Video.js in version 7.11.
        if (this.tech_.scrubbing && this.tech_.scrubbing()) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearInterval(this.abrTimer_);
        this.abrTimer_ = null;
    }
    /**
   * Get a list of playlists for the currently selected audio playlist
   *
   * @return {Array} the array of audio playlists
   */ getAudioTrackPlaylists_() {
        const main = this.main();
        const defaultPlaylists = main && main.playlists || []; // if we don't have any audio groups then we can only
        // assume that the audio tracks are contained in main
        // playlist array, use that or an empty array.
        if (!main || !main.mediaGroups || !main.mediaGroups.AUDIO) return defaultPlaylists;
        const AUDIO = main.mediaGroups.AUDIO;
        const groupKeys = Object.keys(AUDIO);
        let track; // get the current active track
        if (Object.keys(this.mediaTypes_.AUDIO.groups).length) track = this.mediaTypes_.AUDIO.activeTrack(); // or get the default track from main if mediaTypes_ isn't setup yet
        else {
            // default group is `main` or just the first group.
            const defaultGroup = AUDIO.main || groupKeys.length && AUDIO[groupKeys[0]];
            for(const label in defaultGroup)if (defaultGroup[label].default) {
                track = {
                    label: label
                };
                break;
            }
        } // no active track no playlists.
        if (!track) return defaultPlaylists;
        const playlists = []; // get all of the playlists that are possible for the
        // active track.
        for(const group in AUDIO)if (AUDIO[group][track.label]) {
            const properties = AUDIO[group][track.label];
            if (properties.playlists && properties.playlists.length) playlists.push.apply(playlists, properties.playlists);
            else if (properties.uri) playlists.push(properties);
            else if (main.playlists.length) // if an audio group does not have a uri
            // see if we have main playlists that use it as a group.
            // if we do then add those to the playlists list.
            for(let i = 0; i < main.playlists.length; i++){
                const playlist = main.playlists[i];
                if (playlist.attributes && playlist.attributes.AUDIO && playlist.attributes.AUDIO === group) playlists.push(playlist);
            }
        }
        if (!playlists.length) return defaultPlaylists;
        return playlists;
    }
    /**
   * Register event handlers on the main playlist loader. A helper
   * function for construction time.
   *
   * @private
   */ setupMainPlaylistLoaderListeners_() {
        this.mainPlaylistLoader_.on('loadedmetadata', ()=>{
            const media = this.mainPlaylistLoader_.media();
            const requestTimeout = media.targetDuration * 1500; // If we don't have any more available playlists, we don't want to
            // timeout the request.
            if ($86defbb4e95ebb07$var$isLowestEnabledRendition(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media())) this.requestOptions_.timeout = 0;
            else this.requestOptions_.timeout = requestTimeout;
             // if this isn't a live video and preload permits, start
            // downloading segments
            if (media.endList && this.tech_.preload() !== 'none') {
                this.mainSegmentLoader_.playlist(media, this.requestOptions_);
                this.mainSegmentLoader_.load();
            }
            $86defbb4e95ebb07$var$setupMediaGroups({
                sourceType: this.sourceType_,
                segmentLoaders: {
                    AUDIO: this.audioSegmentLoader_,
                    SUBTITLES: this.subtitleSegmentLoader_,
                    main: this.mainSegmentLoader_
                },
                tech: this.tech_,
                requestOptions: this.requestOptions_,
                mainPlaylistLoader: this.mainPlaylistLoader_,
                vhs: this.vhs_,
                main: this.main(),
                mediaTypes: this.mediaTypes_,
                excludePlaylist: this.excludePlaylist.bind(this)
            });
            this.triggerPresenceUsage_(this.main(), media);
            this.setupFirstPlay();
            if (!this.mediaTypes_.AUDIO.activePlaylistLoader || this.mediaTypes_.AUDIO.activePlaylistLoader.media()) this.trigger('selectedinitialmedia');
            else // We must wait for the active audio playlist loader to
            // finish setting up before triggering this event so the
            // representations API and EME setup is correct
            this.mediaTypes_.AUDIO.activePlaylistLoader.one('loadedmetadata', ()=>{
                this.trigger('selectedinitialmedia');
            });
        });
        this.mainPlaylistLoader_.on('loadedplaylist', ()=>{
            if (this.loadOnPlay_) this.tech_.off('play', this.loadOnPlay_);
            let updatedPlaylist = this.mainPlaylistLoader_.media();
            if (!updatedPlaylist) {
                // Add content steering listeners on first load and init.
                this.attachContentSteeringListeners_();
                this.initContentSteeringController_(); // exclude any variants that are not supported by the browser before selecting
                // an initial media as the playlist selectors do not consider browser support
                this.excludeUnsupportedVariants_();
                let selectedMedia;
                if (this.enableLowInitialPlaylist) selectedMedia = this.selectInitialPlaylist();
                if (!selectedMedia) selectedMedia = this.selectPlaylist();
                if (!selectedMedia || !this.shouldSwitchToMedia_(selectedMedia)) return;
                this.initialMedia_ = selectedMedia;
                this.switchMedia_(this.initialMedia_, 'initial'); // Under the standard case where a source URL is provided, loadedplaylist will
                // fire again since the playlist will be requested. In the case of vhs-json
                // (where the manifest object is provided as the source), when the media
                // playlist's `segments` list is already available, a media playlist won't be
                // requested, and loadedplaylist won't fire again, so the playlist handler must be
                // called on its own here.
                const haveJsonSource = this.sourceType_ === 'vhs-json' && this.initialMedia_.segments;
                if (!haveJsonSource) return;
                updatedPlaylist = this.initialMedia_;
            }
            this.handleUpdatedMediaPlaylist(updatedPlaylist);
        });
        this.mainPlaylistLoader_.on('error', ()=>{
            const error = this.mainPlaylistLoader_.error;
            this.excludePlaylist({
                playlistToExclude: error.playlist,
                error: error
            });
        });
        this.mainPlaylistLoader_.on('mediachanging', ()=>{
            this.mainSegmentLoader_.abort();
            this.mainSegmentLoader_.pause();
        });
        this.mainPlaylistLoader_.on('mediachange', ()=>{
            const media = this.mainPlaylistLoader_.media();
            const requestTimeout = media.targetDuration * 1500; // If we don't have any more available playlists, we don't want to
            // timeout the request.
            if ($86defbb4e95ebb07$var$isLowestEnabledRendition(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media())) this.requestOptions_.timeout = 0;
            else this.requestOptions_.timeout = requestTimeout;
            if (this.sourceType_ === 'dash') // we don't want to re-request the same hls playlist right after it was changed
            // Initially it was implemented as workaround to restart playlist loader for live
            // when playlist loader is paused because of playlist exclusions:
            // see: https://github.com/videojs/http-streaming/pull/1339
            // but this introduces duplicate "loadedplaylist" event.
            // Ideally we want to re-think playlist loader life-cycle events,
            // but simply checking "paused" state should help a lot
            {
                if (this.mainPlaylistLoader_.isPaused) this.mainPlaylistLoader_.load();
            } // TODO: Create a new event on the PlaylistLoader that signals
            // that the segments have changed in some way and use that to
            // update the SegmentLoader instead of doing it twice here and
            // on `loadedplaylist`
            this.mainSegmentLoader_.pause();
            this.mainSegmentLoader_.playlist(media, this.requestOptions_);
            if (this.waitingForFastQualityPlaylistReceived_) this.runFastQualitySwitch_();
            else this.mainSegmentLoader_.load();
            this.tech_.trigger({
                type: 'mediachange',
                bubbles: true
            });
        });
        this.mainPlaylistLoader_.on('playlistunchanged', ()=>{
            const updatedPlaylist = this.mainPlaylistLoader_.media(); // ignore unchanged playlists that have already been
            // excluded for not-changing. We likely just have a really slowly updating
            // playlist.
            if (updatedPlaylist.lastExcludeReason_ === 'playlist-unchanged') return;
            const playlistOutdated = this.stuckAtPlaylistEnd_(updatedPlaylist);
            if (playlistOutdated) {
                // Playlist has stopped updating and we're stuck at its end. Try to
                // exclude it and switch to another playlist in the hope that that
                // one is updating (and give the player a chance to re-adjust to the
                // safe live point).
                this.excludePlaylist({
                    error: {
                        message: 'Playlist no longer updating.',
                        reason: 'playlist-unchanged'
                    }
                }); // useful for monitoring QoS
                this.tech_.trigger('playliststuck');
            }
        });
        this.mainPlaylistLoader_.on('renditiondisabled', ()=>{
            this.tech_.trigger({
                type: 'usage',
                name: 'vhs-rendition-disabled'
            });
        });
        this.mainPlaylistLoader_.on('renditionenabled', ()=>{
            this.tech_.trigger({
                type: 'usage',
                name: 'vhs-rendition-enabled'
            });
        });
        const playlistLoaderEvents = [
            'manifestrequeststart',
            'manifestrequestcomplete',
            'manifestparsestart',
            'manifestparsecomplete',
            'playlistrequeststart',
            'playlistrequestcomplete',
            'playlistparsestart',
            'playlistparsecomplete',
            'renditiondisabled',
            'renditionenabled'
        ];
        playlistLoaderEvents.forEach((eventName)=>{
            this.mainPlaylistLoader_.on(eventName, (metadata)=>{
                // trigger directly on the player to ensure early events are fired.
                this.player_.trigger((0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, metadata));
            });
        });
    }
    /**
   * Given an updated media playlist (whether it was loaded for the first time, or
   * refreshed for live playlists), update any relevant properties and state to reflect
   * changes in the media that should be accounted for (e.g., cues and duration).
   *
   * @param {Object} updatedPlaylist the updated media playlist object
   *
   * @private
   */ handleUpdatedMediaPlaylist(updatedPlaylist) {
        if (this.useCueTags_) this.updateAdCues_(updatedPlaylist);
         // TODO: Create a new event on the PlaylistLoader that signals
        // that the segments have changed in some way and use that to
        // update the SegmentLoader instead of doing it twice here and
        // on `mediachange`
        this.mainSegmentLoader_.pause();
        this.mainSegmentLoader_.playlist(updatedPlaylist, this.requestOptions_);
        if (this.waitingForFastQualityPlaylistReceived_) this.runFastQualitySwitch_();
        this.updateDuration(!updatedPlaylist.endList); // If the player isn't paused, ensure that the segment loader is running,
        // as it is possible that it was temporarily stopped while waiting for
        // a playlist (e.g., in case the playlist errored and we re-requested it).
        if (!this.tech_.paused()) {
            this.mainSegmentLoader_.load();
            if (this.audioSegmentLoader_) this.audioSegmentLoader_.load();
        }
    }
    /**
   * A helper function for triggerring presence usage events once per source
   *
   * @private
   */ triggerPresenceUsage_(main, media) {
        const mediaGroups = main.mediaGroups || {};
        let defaultDemuxed = true;
        const audioGroupKeys = Object.keys(mediaGroups.AUDIO);
        for(const mediaGroup in mediaGroups.AUDIO)for(const label in mediaGroups.AUDIO[mediaGroup]){
            const properties = mediaGroups.AUDIO[mediaGroup][label];
            if (!properties.uri) defaultDemuxed = false;
        }
        if (defaultDemuxed) this.tech_.trigger({
            type: 'usage',
            name: 'vhs-demuxed'
        });
        if (Object.keys(mediaGroups.SUBTITLES).length) this.tech_.trigger({
            type: 'usage',
            name: 'vhs-webvtt'
        });
        if ($86defbb4e95ebb07$var$Vhs$1.Playlist.isAes(media)) this.tech_.trigger({
            type: 'usage',
            name: 'vhs-aes'
        });
        if (audioGroupKeys.length && Object.keys(mediaGroups.AUDIO[audioGroupKeys[0]]).length > 1) this.tech_.trigger({
            type: 'usage',
            name: 'vhs-alternate-audio'
        });
        if (this.useCueTags_) this.tech_.trigger({
            type: 'usage',
            name: 'vhs-playlist-cue-tags'
        });
    }
    shouldSwitchToMedia_(nextPlaylist) {
        const currentPlaylist = this.mainPlaylistLoader_.media() || this.mainPlaylistLoader_.pendingMedia_;
        const currentTime = this.tech_.currentTime();
        const bufferLowWaterLine = this.bufferLowWaterLine();
        const bufferHighWaterLine = this.bufferHighWaterLine();
        const buffered = this.tech_.buffered();
        return $86defbb4e95ebb07$var$shouldSwitchToMedia({
            buffered: buffered,
            currentTime: currentTime,
            currentPlaylist: currentPlaylist,
            nextPlaylist: nextPlaylist,
            bufferLowWaterLine: bufferLowWaterLine,
            bufferHighWaterLine: bufferHighWaterLine,
            duration: this.duration(),
            bufferBasedABR: this.bufferBasedABR,
            log: this.logger_
        });
    }
    /**
   * Register event handlers on the segment loaders. A helper function
   * for construction time.
   *
   * @private
   */ setupSegmentLoaderListeners_() {
        this.mainSegmentLoader_.on('bandwidthupdate', ()=>{
            // Whether or not buffer based ABR or another ABR is used, on a bandwidth change it's
            // useful to check to see if a rendition switch should be made.
            this.checkABR_('bandwidthupdate');
            this.tech_.trigger('bandwidthupdate');
        });
        this.mainSegmentLoader_.on('timeout', ()=>{
            if (this.bufferBasedABR) // If a rendition change is needed, then it would've be done on `bandwidthupdate`.
            // Here the only consideration is that for buffer based ABR there's no guarantee
            // of an immediate switch (since the bandwidth is averaged with a timeout
            // bandwidth value of 1), so force a load on the segment loader to keep it going.
            this.mainSegmentLoader_.load();
        }); // `progress` events are not reliable enough of a bandwidth measure to trigger buffer
        // based ABR.
        if (!this.bufferBasedABR) this.mainSegmentLoader_.on('progress', ()=>{
            this.trigger('progress');
        });
        this.mainSegmentLoader_.on('error', ()=>{
            const error = this.mainSegmentLoader_.error();
            this.excludePlaylist({
                playlistToExclude: error.playlist,
                error: error
            });
        });
        this.mainSegmentLoader_.on('appenderror', ()=>{
            this.error = this.mainSegmentLoader_.error_;
            this.trigger('error');
        });
        this.mainSegmentLoader_.on('syncinfoupdate', ()=>{
            this.onSyncInfoUpdate_();
        });
        this.mainSegmentLoader_.on('timestampoffset', ()=>{
            this.tech_.trigger({
                type: 'usage',
                name: 'vhs-timestamp-offset'
            });
        });
        this.audioSegmentLoader_.on('syncinfoupdate', ()=>{
            this.onSyncInfoUpdate_();
        });
        this.audioSegmentLoader_.on('appenderror', ()=>{
            this.error = this.audioSegmentLoader_.error_;
            this.trigger('error');
        });
        this.mainSegmentLoader_.on('ended', ()=>{
            this.logger_('main segment loader ended');
            this.onEndOfStream();
        }); // There is the possibility of the video segment and the audio segment
        // at a current time to be on different timelines. When this occurs, the player
        // forwards playback to a point where these two segment types are back on the same
        // timeline. This time will be just after the end of the audio segment that is on
        // a previous timeline.
        this.timelineChangeController_.on('audioTimelineBehind', ()=>{
            const segmentInfo = this.audioSegmentLoader_.pendingSegment_;
            if (!segmentInfo || !segmentInfo.segment || !segmentInfo.segment.syncInfo) return;
             // Update the current time to just after the faulty audio segment.
            // This moves playback to a spot where both audio and video segments
            // are on the same timeline.
            const newTime = segmentInfo.segment.syncInfo.end + 0.01;
            this.tech_.setCurrentTime(newTime);
        });
        this.timelineChangeController_.on('fixBadTimelineChange', ()=>{
            // pause, reset-everything and load for all segment-loaders
            this.logger_('Fix bad timeline change. Restarting al segment loaders...');
            this.mainSegmentLoader_.pause();
            this.mainSegmentLoader_.resetEverything();
            if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
                this.audioSegmentLoader_.pause();
                this.audioSegmentLoader_.resetEverything();
            }
            if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
                this.subtitleSegmentLoader_.pause();
                this.subtitleSegmentLoader_.resetEverything();
            } // start segment loader loading in case they are paused
            this.load();
        });
        this.mainSegmentLoader_.on('earlyabort', (event)=>{
            // never try to early abort with the new ABR algorithm
            if (this.bufferBasedABR) return;
            this.delegateLoaders_('all', [
                'abort'
            ]);
            this.excludePlaylist({
                error: {
                    message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
                },
                playlistExclusionDuration: $86defbb4e95ebb07$var$ABORT_EARLY_EXCLUSION_SECONDS
            });
        });
        const updateCodecs = ()=>{
            if (!this.sourceUpdater_.hasCreatedSourceBuffers()) return this.tryToCreateSourceBuffers_();
            const codecs = this.getCodecsOrExclude_(); // no codecs means that the playlist was excluded
            if (!codecs) return;
            this.sourceUpdater_.addOrChangeSourceBuffers(codecs);
        };
        this.mainSegmentLoader_.on('trackinfo', updateCodecs);
        this.audioSegmentLoader_.on('trackinfo', updateCodecs);
        this.mainSegmentLoader_.on('fmp4', ()=>{
            if (!this.triggeredFmp4Usage) {
                this.tech_.trigger({
                    type: 'usage',
                    name: 'vhs-fmp4'
                });
                this.triggeredFmp4Usage = true;
            }
        });
        this.audioSegmentLoader_.on('fmp4', ()=>{
            if (!this.triggeredFmp4Usage) {
                this.tech_.trigger({
                    type: 'usage',
                    name: 'vhs-fmp4'
                });
                this.triggeredFmp4Usage = true;
            }
        });
        this.audioSegmentLoader_.on('ended', ()=>{
            this.logger_('audioSegmentLoader ended');
            this.onEndOfStream();
        });
        const segmentLoaderEvents = [
            'segmentselected',
            'segmentloadstart',
            'segmentloaded',
            'segmentkeyloadstart',
            'segmentkeyloadcomplete',
            'segmentdecryptionstart',
            'segmentdecryptioncomplete',
            'segmenttransmuxingstart',
            'segmenttransmuxingcomplete',
            'segmenttransmuxingtrackinfoavailable',
            'segmenttransmuxingtiminginfoavailable',
            'segmentappendstart',
            'appendsdone',
            'bandwidthupdated',
            'timelinechange',
            'codecschange'
        ];
        segmentLoaderEvents.forEach((eventName)=>{
            this.mainSegmentLoader_.on(eventName, (metadata)=>{
                this.player_.trigger((0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, metadata));
            });
            this.audioSegmentLoader_.on(eventName, (metadata)=>{
                this.player_.trigger((0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, metadata));
            });
            this.subtitleSegmentLoader_.on(eventName, (metadata)=>{
                this.player_.trigger((0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, metadata));
            });
        });
    }
    mediaSecondsLoaded_() {
        return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
    }
    /**
   * Call load on our SegmentLoaders
   */ load() {
        this.mainSegmentLoader_.load();
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) this.audioSegmentLoader_.load();
        if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) this.subtitleSegmentLoader_.load();
    }
    /**
   * Call pause on our SegmentLoaders
   */ pause() {
        this.mainSegmentLoader_.pause();
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) this.audioSegmentLoader_.pause();
        if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) this.subtitleSegmentLoader_.pause();
    }
    /**
   * Re-tune playback quality level for the current player
   * conditions. This method will perform destructive actions like removing
   * already buffered content in order to readjust the currently active
   * playlist quickly. This is good for manual quality changes
   *
   * @private
   */ fastQualityChange_(media = this.selectPlaylist()) {
        if (media && media === this.mainPlaylistLoader_.media()) {
            this.logger_('skipping fastQualityChange because new media is same as old');
            return;
        }
        this.switchMedia_(media, 'fast-quality'); // we would like to avoid race condition when we call fastQuality,
        // reset everything and start loading segments from prev segments instead of new because new playlist is not received yet
        this.waitingForFastQualityPlaylistReceived_ = true;
    }
    runFastQualitySwitch_() {
        this.waitingForFastQualityPlaylistReceived_ = false;
        this.mainSegmentLoader_.pause();
        this.mainSegmentLoader_.resetEverything();
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
            this.audioSegmentLoader_.pause();
            this.audioSegmentLoader_.resetEverything();
        }
        if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
            this.subtitleSegmentLoader_.pause();
            this.subtitleSegmentLoader_.resetEverything();
        } // start segment loader loading in case they are paused
        this.load();
    }
    /**
   * Begin playback.
   */ play() {
        if (this.setupFirstPlay()) return;
        if (this.tech_.ended()) this.tech_.setCurrentTime(0);
        if (this.hasPlayed_) this.load();
        const seekable = this.tech_.seekable(); // if the viewer has paused and we fell out of the live window,
        // seek forward to the live point
        if (this.tech_.duration() === Infinity) {
            if (this.tech_.currentTime() < seekable.start(0)) return this.tech_.setCurrentTime(seekable.end(seekable.length - 1));
        }
    }
    /**
   * Seek to the latest media position if this is a live video and the
   * player and video are loaded and initialized.
   */ setupFirstPlay() {
        const media = this.mainPlaylistLoader_.media(); // Check that everything is ready to begin buffering for the first call to play
        //  If 1) there is no active media
        //     2) the player is paused
        //     3) the first play has already been setup
        // then exit early
        if (!media || this.tech_.paused() || this.hasPlayed_) return false;
         // when the video is a live stream and/or has a start time
        if (!media.endList || media.start) {
            const seekable = this.seekable();
            if (!seekable.length) // without a seekable range, the player cannot seek to begin buffering at the
            // live or start point
            return false;
            const seekableEnd = seekable.end(0);
            let startPoint = seekableEnd;
            if (media.start) {
                const offset = media.start.timeOffset;
                if (offset < 0) {
                    // Per HLS spec, negative TIME-OFFSET is from the end of the last Media Segment.
                    // For live streams, seekableEnd already has liveEdgeDelay subtracted,
                    // so we need to add it back to get the actual playlist end.
                    // Clamp to seekableEnd to avoid seeking into the unsafe live edge zone.
                    const main = this.mainPlaylistLoader_.main;
                    const liveEdgeDelay = $86defbb4e95ebb07$var$Vhs$1.Playlist.liveEdgeDelay(main, media);
                    const actualPlaylistEnd = seekableEnd + liveEdgeDelay;
                    startPoint = Math.max(Math.min(actualPlaylistEnd + offset, seekableEnd), seekable.start(0));
                } else startPoint = Math.min(seekableEnd, offset);
            } // trigger firstplay to inform the source handler to ignore the next seek event
            this.trigger('firstplay'); // seek to the live point
            this.tech_.setCurrentTime(startPoint);
        }
        this.hasPlayed_ = true; // we can begin loading now that everything is ready
        this.load();
        return true;
    }
    /**
   * handle the sourceopen event on the MediaSource
   *
   * @private
   */ handleSourceOpen_() {
        // Only attempt to create the source buffer if none already exist.
        // handleSourceOpen is also called when we are "re-opening" a source buffer
        // after `endOfStream` has been called (in response to a seek for instance)
        this.tryToCreateSourceBuffers_(); // if autoplay is enabled, begin playback. This is duplicative of
        // code in video.js but is required because play() must be invoked
        // *after* the media source has opened.
        if (this.tech_.autoplay()) {
            const playPromise = this.tech_.play(); // Catch/silence error when a pause interrupts a play request
            // on browsers which return a promise
            if (typeof playPromise !== 'undefined' && typeof playPromise.then === 'function') playPromise.then(null, (e)=>{});
        }
        this.trigger('sourceopen');
    }
    /**
   * handle the sourceended event on the MediaSource
   *
   * @private
   */ handleSourceEnded_() {
        if (!this.inbandTextTracks_.metadataTrack_) return;
        const cues = this.inbandTextTracks_.metadataTrack_.cues;
        if (!cues || !cues.length) return;
        const duration = this.duration();
        cues[cues.length - 1].endTime = isNaN(duration) || Math.abs(duration) === Infinity ? Number.MAX_VALUE : duration;
    }
    /**
   * handle the durationchange event on the MediaSource
   *
   * @private
   */ handleDurationChange_() {
        this.tech_.trigger('durationchange');
    }
    /**
   * Calls endOfStream on the media source when all active stream types have called
   * endOfStream
   *
   * @param {string} streamType
   *        Stream type of the segment loader that called endOfStream
   * @private
   */ onEndOfStream() {
        let isEndOfStream = this.mainSegmentLoader_.ended_;
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
            const mainMediaInfo = this.mainSegmentLoader_.getCurrentMediaInfo_(); // if the audio playlist loader exists, then alternate audio is active
            if (!mainMediaInfo || mainMediaInfo.hasVideo) // if we do not know if the main segment loader contains video yet or if we
            // definitively know the main segment loader contains video, then we need to wait
            // for both main and audio segment loaders to call endOfStream
            isEndOfStream = isEndOfStream && this.audioSegmentLoader_.ended_;
            else // otherwise just rely on the audio loader
            isEndOfStream = this.audioSegmentLoader_.ended_;
        }
        if (!isEndOfStream) return;
        this.stopABRTimer_();
        this.sourceUpdater_.endOfStream();
    }
    /**
   * Check if a playlist has stopped being updated
   *
   * @param {Object} playlist the media playlist object
   * @return {boolean} whether the playlist has stopped being updated or not
   */ stuckAtPlaylistEnd_(playlist) {
        const seekable = this.seekable();
        if (!seekable.length) // playlist doesn't have enough information to determine whether we are stuck
        return false;
        const expired = this.syncController_.getExpiredTime(playlist, this.duration());
        if (expired === null) return false;
         // does not use the safe live end to calculate playlist end, since we
        // don't want to say we are stuck while there is still content
        const absolutePlaylistEnd = $86defbb4e95ebb07$var$Vhs$1.Playlist.playlistEnd(playlist, expired);
        const currentTime = this.tech_.currentTime();
        const buffered = this.tech_.buffered();
        if (!buffered.length) // return true if the playhead reached the absolute end of the playlist
        return absolutePlaylistEnd - currentTime <= $86defbb4e95ebb07$var$SAFE_TIME_DELTA;
        const bufferedEnd = buffered.end(buffered.length - 1); // return true if there is too little buffer left and buffer has reached absolute
        // end of playlist
        return bufferedEnd - currentTime <= $86defbb4e95ebb07$var$SAFE_TIME_DELTA && absolutePlaylistEnd - bufferedEnd <= $86defbb4e95ebb07$var$SAFE_TIME_DELTA;
    }
    /**
   * Exclude a playlist for a set amount of time, making it unavailable for selection by
   * the rendition selection algorithm, then force a new playlist (rendition) selection.
   *
   * @param {Object=} playlistToExclude
   *                  the playlist to exclude, defaults to the currently selected playlist
   * @param {Object=} error
   *                  an optional error
   * @param {number=} playlistExclusionDuration
   *                  an optional number of seconds to exclude the playlist
   */ excludePlaylist({ playlistToExclude: playlistToExclude = this.mainPlaylistLoader_.media(), error: error = {}, playlistExclusionDuration: playlistExclusionDuration }) {
        // If the `error` was generated by the playlist loader, it will contain
        // the playlist we were trying to load (but failed) and that should be
        // excluded instead of the currently selected playlist which is likely
        // out-of-date in this scenario
        playlistToExclude = playlistToExclude || this.mainPlaylistLoader_.media();
        playlistExclusionDuration = playlistExclusionDuration || error.playlistExclusionDuration || this.playlistExclusionDuration; // If there is no current playlist, then an error occurred while we were
        // trying to load the main OR while we were disposing of the tech
        if (!playlistToExclude) {
            this.error = error;
            if (this.mediaSource.readyState !== 'open') this.trigger('error');
            else this.sourceUpdater_.endOfStream('network');
            return;
        }
        playlistToExclude.playlistErrors_++;
        const playlists = this.mainPlaylistLoader_.main.playlists;
        const enabledPlaylists = playlists.filter($86defbb4e95ebb07$var$isEnabled);
        const isFinalRendition = enabledPlaylists.length === 1 && enabledPlaylists[0] === playlistToExclude; // Don't exclude the only playlist unless it was excluded
        // forever
        if (playlists.length === 1 && playlistExclusionDuration !== Infinity) {
            $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn(`Problem encountered with playlist ${playlistToExclude.id}. ` + 'Trying again since it is the only playlist.');
            this.tech_.trigger('retryplaylist'); // if this is a final rendition, we should delay
            return this.mainPlaylistLoader_.load(isFinalRendition);
        }
        if (isFinalRendition) {
            // If we're content steering, try other pathways.
            if (this.main().contentSteering) {
                const pathway = this.pathwayAttribute_(playlistToExclude); // Ignore at least 1 steering manifest refresh.
                const reIncludeDelay = this.contentSteeringController_.steeringManifest.ttl * 1000;
                this.contentSteeringController_.excludePathway(pathway);
                this.excludeThenChangePathway_();
                setTimeout(()=>{
                    this.contentSteeringController_.addAvailablePathway(pathway);
                }, reIncludeDelay);
                return;
            } // Since we're on the final non-excluded playlist, and we're about to exclude
            // it, instead of erring the player or retrying this playlist, clear out the current
            // exclusion list. This allows other playlists to be attempted in case any have been
            // fixed.
            let reincluded = false;
            playlists.forEach((playlist)=>{
                // skip current playlist which is about to be excluded
                if (playlist === playlistToExclude) return;
                const excludeUntil = playlist.excludeUntil; // a playlist cannot be reincluded if it wasn't excluded to begin with.
                if (typeof excludeUntil !== 'undefined' && excludeUntil !== Infinity) {
                    reincluded = true;
                    delete playlist.excludeUntil;
                }
            });
            if (reincluded) {
                $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."); // Technically we are retrying a playlist, in that we are simply retrying a previous
                // playlist. This is needed for users relying on the retryplaylist event to catch a
                // case where the player might be stuck and looping through "dead" playlists.
                this.tech_.trigger('retryplaylist');
            }
        } // Exclude this playlist
        let excludeUntil;
        if (playlistToExclude.playlistErrors_ > this.maxPlaylistRetries) excludeUntil = Infinity;
        else excludeUntil = Date.now() + playlistExclusionDuration * 1000;
        playlistToExclude.excludeUntil = excludeUntil;
        if (error.reason) playlistToExclude.lastExcludeReason_ = error.reason;
        this.tech_.trigger('excludeplaylist');
        this.tech_.trigger({
            type: 'usage',
            name: 'vhs-rendition-excluded'
        }); // TODO: only load a new playlist if we're excluding the current playlist
        // If this function was called with a playlist that's not the current active playlist
        // (e.g., media().id !== playlistToExclude.id),
        // then a new playlist should not be selected and loaded, as there's nothing wrong with the current playlist.
        const nextPlaylist = this.selectPlaylist();
        if (!nextPlaylist) {
            this.error = 'Playback cannot continue. No available working or supported playlists.';
            this.trigger('error');
            return;
        }
        const logFn = error.internal ? this.logger_ : $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn;
        const errorMessage = error.message ? ' ' + error.message : '';
        logFn(`${error.internal ? 'Internal problem' : 'Problem'} encountered with playlist ${playlistToExclude.id}.` + `${errorMessage} Switching to playlist ${nextPlaylist.id}.`); // if audio group changed reset audio loaders
        if (nextPlaylist.attributes.AUDIO !== playlistToExclude.attributes.AUDIO) this.delegateLoaders_('audio', [
            'abort',
            'pause'
        ]);
         // if subtitle group changed reset subtitle loaders
        if (nextPlaylist.attributes.SUBTITLES !== playlistToExclude.attributes.SUBTITLES) this.delegateLoaders_('subtitle', [
            'abort',
            'pause'
        ]);
        this.delegateLoaders_('main', [
            'abort',
            'pause'
        ]);
        const delayDuration = nextPlaylist.targetDuration / 2 * 1000 || 5000;
        const shouldDelay = typeof nextPlaylist.lastRequest === 'number' && Date.now() - nextPlaylist.lastRequest <= delayDuration; // delay if it's a final rendition or if the last refresh is sooner than half targetDuration
        return this.switchMedia_(nextPlaylist, 'exclude', isFinalRendition || shouldDelay);
    }
    /**
   * Pause all segment/playlist loaders
   */ pauseLoading() {
        this.delegateLoaders_('all', [
            'abort',
            'pause'
        ]);
        this.stopABRTimer_();
    }
    /**
   * Call a set of functions in order on playlist loaders, segment loaders,
   * or both types of loaders.
   *
   * @param {string} filter
   *        Filter loaders that should call fnNames using a string. Can be:
   *        * all - run on all loaders
   *        * audio - run on all audio loaders
   *        * subtitle - run on all subtitle loaders
   *        * main - run on the main loaders
   *
   * @param {Array|string} fnNames
   *        A string or array of function names to call.
   */ delegateLoaders_(filter, fnNames) {
        const loaders = [];
        const dontFilterPlaylist = filter === 'all';
        if (dontFilterPlaylist || filter === 'main') loaders.push(this.mainPlaylistLoader_);
        const mediaTypes = [];
        if (dontFilterPlaylist || filter === 'audio') mediaTypes.push('AUDIO');
        if (dontFilterPlaylist || filter === 'subtitle') {
            mediaTypes.push('CLOSED-CAPTIONS');
            mediaTypes.push('SUBTITLES');
        }
        mediaTypes.forEach((mediaType)=>{
            const loader = this.mediaTypes_[mediaType] && this.mediaTypes_[mediaType].activePlaylistLoader;
            if (loader) loaders.push(loader);
        });
        [
            'main',
            'audio',
            'subtitle'
        ].forEach((name)=>{
            const loader = this[`${name}SegmentLoader_`];
            if (loader && (filter === name || filter === 'all')) loaders.push(loader);
        });
        loaders.forEach((loader)=>fnNames.forEach((fnName)=>{
                if (typeof loader[fnName] === 'function') loader[fnName]();
            }));
    }
    /**
   * set the current time on all segment loaders
   *
   * @param {TimeRange} currentTime the current time to set
   * @return {TimeRange} the current time
   */ setCurrentTime(currentTime) {
        const buffered = $86defbb4e95ebb07$var$findRange(this.tech_.buffered(), currentTime);
        if (!(this.mainPlaylistLoader_ && this.mainPlaylistLoader_.media())) // return immediately if the metadata is not ready yet
        return 0;
         // it's clearly an edge-case but don't thrown an error if asked to
        // seek within an empty playlist
        if (!this.mainPlaylistLoader_.media().segments) return 0;
         // if the seek location is already buffered, continue buffering as usual
        if (buffered && buffered.length) return currentTime;
         // cancel outstanding requests so we begin buffering at the new
        // location
        this.mainSegmentLoader_.pause();
        this.mainSegmentLoader_.resetEverything();
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
            this.audioSegmentLoader_.pause();
            this.audioSegmentLoader_.resetEverything();
        }
        if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
            this.subtitleSegmentLoader_.pause();
            this.subtitleSegmentLoader_.resetEverything();
        } // start segment loader loading in case they are paused
        this.load();
    }
    /**
   * get the current duration
   *
   * @return {TimeRange} the duration
   */ duration() {
        if (!this.mainPlaylistLoader_) return 0;
        const media = this.mainPlaylistLoader_.media();
        if (!media) // no playlists loaded yet, so can't determine a duration
        return 0;
         // Don't rely on the media source for duration in the case of a live playlist since
        // setting the native MediaSource's duration to infinity ends up with consequences to
        // seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
        //
        // This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
        // however, few browsers have support for setLiveSeekableRange()
        // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
        //
        // Until a time when the duration of the media source can be set to infinity, and a
        // seekable range specified across browsers, just return Infinity.
        if (!media.endList) return Infinity;
         // Since this is a VOD video, it is safe to rely on the media source's duration (if
        // available). If it's not available, fall back to a playlist-calculated estimate.
        if (this.mediaSource) return this.mediaSource.duration;
        return $86defbb4e95ebb07$var$Vhs$1.Playlist.duration(media);
    }
    /**
   * check the seekable range
   *
   * @return {TimeRange} the seekable range
   */ seekable() {
        return this.seekable_;
    }
    getSeekableRange_(playlistLoader, mediaType) {
        const media = playlistLoader.media();
        if (!media) return null;
        const mediaSequenceSync = this.syncController_.getMediaSequenceSync(mediaType);
        if (mediaSequenceSync && mediaSequenceSync.isReliable) {
            const start = mediaSequenceSync.start;
            const end = mediaSequenceSync.end;
            if (!isFinite(start) || !isFinite(end)) return null;
            const liveEdgeDelay = $86defbb4e95ebb07$var$Vhs$1.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, media); // Make sure our seekable end is not less than the seekable start
            const calculatedEnd = Math.max(start, end - liveEdgeDelay);
            return $86defbb4e95ebb07$var$createTimeRanges([
                [
                    start,
                    calculatedEnd
                ]
            ]);
        }
        const expired = this.syncController_.getExpiredTime(media, this.duration());
        if (expired === null) return null;
        const seekable = $86defbb4e95ebb07$var$Vhs$1.Playlist.seekable(media, expired, $86defbb4e95ebb07$var$Vhs$1.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, media));
        return seekable.length ? seekable : null;
    }
    computeFinalSeekable_(mainSeekable, audioSeekable) {
        if (!audioSeekable) return mainSeekable;
        const mainStart = mainSeekable.start(0);
        const mainEnd = mainSeekable.end(0);
        const audioStart = audioSeekable.start(0);
        const audioEnd = audioSeekable.end(0);
        if (audioStart > mainEnd || mainStart > audioEnd) // Seekables are far apart, rely on main
        return mainSeekable;
         // Return the overlapping seekable range
        return $86defbb4e95ebb07$var$createTimeRanges([
            [
                Math.max(mainStart, audioStart),
                Math.min(mainEnd, audioEnd)
            ]
        ]);
    }
    onSyncInfoUpdate_() {
        // TODO check for creation of both source buffers before updating seekable
        //
        // A fix was made to this function where a check for
        // this.sourceUpdater_.hasCreatedSourceBuffers
        // was added to ensure that both source buffers were created before seekable was
        // updated. However, it originally had a bug where it was checking for a true and
        // returning early instead of checking for false. Setting it to check for false to
        // return early though created other issues. A call to play() would check for seekable
        // end without verifying that a seekable range was present. In addition, even checking
        // for that didn't solve some issues, as handleFirstPlay is sometimes worked around
        // due to a media update calling load on the segment loaders, skipping a seek to live,
        // thereby starting live streams at the beginning of the stream rather than at the end.
        //
        // This conditional should be fixed to wait for the creation of two source buffers at
        // the same time as the other sections of code are fixed to properly seek to live and
        // not throw an error due to checking for a seekable end when no seekable range exists.
        //
        // For now, fall back to the older behavior, with the understanding that the seekable
        // range may not be completely correct, leading to a suboptimal initial live point.
        if (!this.mainPlaylistLoader_) return;
        const mainSeekable = this.getSeekableRange_(this.mainPlaylistLoader_, 'main');
        if (!mainSeekable) return;
        let audioSeekable;
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
            audioSeekable = this.getSeekableRange_(this.mediaTypes_.AUDIO.activePlaylistLoader, 'audio');
            if (!audioSeekable) return;
        }
        const oldSeekable = this.seekable_;
        this.seekable_ = this.computeFinalSeekable_(mainSeekable, audioSeekable);
        if (!this.seekable_) return;
        if (oldSeekable && oldSeekable.length && this.seekable_.length) {
            if (oldSeekable.start(0) === this.seekable_.start(0) && oldSeekable.end(0) === this.seekable_.end(0)) // Seekable range hasn't changed
            return;
        }
        this.logger_(`seekable updated [${$86defbb4e95ebb07$var$printableRange(this.seekable_)}]`);
        const metadata = {
            seekableRanges: this.seekable_
        };
        this.trigger({
            type: 'seekablerangeschanged',
            metadata: metadata
        });
        this.tech_.trigger('seekablechanged');
    }
    /**
   * Update the player duration
   */ updateDuration(isLive) {
        if (this.updateDuration_) {
            this.mediaSource.removeEventListener('sourceopen', this.updateDuration_);
            this.updateDuration_ = null;
        }
        if (this.mediaSource.readyState !== 'open') {
            this.updateDuration_ = this.updateDuration.bind(this, isLive);
            this.mediaSource.addEventListener('sourceopen', this.updateDuration_);
            return;
        }
        if (isLive) {
            const seekable = this.seekable();
            if (!seekable.length) return;
             // Even in the case of a live playlist, the native MediaSource's duration should not
            // be set to Infinity (even though this would be expected for a live playlist), since
            // setting the native MediaSource's duration to infinity ends up with consequences to
            // seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
            //
            // This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
            // however, few browsers have support for setLiveSeekableRange()
            // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
            //
            // Until a time when the duration of the media source can be set to infinity, and a
            // seekable range specified across browsers, the duration should be greater than or
            // equal to the last possible seekable value.
            // MediaSource duration starts as NaN
            // It is possible (and probable) that this case will never be reached for many
            // sources, since the MediaSource reports duration as the highest value without
            // accounting for timestamp offset. For example, if the timestamp offset is -100 and
            // we buffered times 0 to 100 with real times of 100 to 200, even though current
            // time will be between 0 and 100, the native media source may report the duration
            // as 200. However, since we report duration separate from the media source (as
            // Infinity), and as long as the native media source duration value is greater than
            // our reported seekable range, seeks will work as expected. The large number as
            // duration for live is actually a strategy used by some players to work around the
            // issue of live seekable ranges cited above.
            if (isNaN(this.mediaSource.duration) || this.mediaSource.duration < seekable.end(seekable.length - 1)) this.sourceUpdater_.setDuration(seekable.end(seekable.length - 1));
            return;
        }
        const buffered = this.tech_.buffered();
        let duration = $86defbb4e95ebb07$var$Vhs$1.Playlist.duration(this.mainPlaylistLoader_.media());
        if (buffered.length > 0) duration = Math.max(duration, buffered.end(buffered.length - 1));
        if (this.mediaSource.duration !== duration) this.sourceUpdater_.setDuration(duration);
    }
    /**
   * dispose of the PlaylistController and everything
   * that it controls
   */ dispose() {
        this.trigger('dispose');
        this.decrypter_.terminate();
        this.mainPlaylistLoader_.dispose();
        this.mainSegmentLoader_.dispose();
        this.contentSteeringController_.dispose();
        this.keyStatusMap_.clear();
        if (this.loadOnPlay_) this.tech_.off('play', this.loadOnPlay_);
        [
            'AUDIO',
            'SUBTITLES'
        ].forEach((type)=>{
            const groups = this.mediaTypes_[type].groups;
            for(const id in groups)groups[id].forEach((group)=>{
                if (group.playlistLoader) group.playlistLoader.dispose();
            });
        });
        this.audioSegmentLoader_.dispose();
        this.subtitleSegmentLoader_.dispose();
        this.sourceUpdater_.dispose();
        this.timelineChangeController_.dispose();
        this.stopABRTimer_();
        if (this.updateDuration_) this.mediaSource.removeEventListener('sourceopen', this.updateDuration_);
        this.mediaSource.removeEventListener('durationchange', this.handleDurationChange_); // load the media source into the player
        this.mediaSource.removeEventListener('sourceopen', this.handleSourceOpen_);
        this.mediaSource.removeEventListener('sourceended', this.handleSourceEnded_);
        this.off();
    }
    /**
   * return the main playlist object if we have one
   *
   * @return {Object} the main playlist object that we parsed
   */ main() {
        return this.mainPlaylistLoader_.main;
    }
    /**
   * return the currently selected playlist
   *
   * @return {Object} the currently selected playlist object that we parsed
   */ media() {
        // playlist loader will not return media if it has not been fully loaded
        return this.mainPlaylistLoader_.media() || this.initialMedia_;
    }
    areMediaTypesKnown_() {
        const usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
        const hasMainMediaInfo = !!this.mainSegmentLoader_.getCurrentMediaInfo_(); // if we are not using an audio loader, then we have audio media info
        // otherwise check on the segment loader.
        const hasAudioMediaInfo = !usingAudioLoader ? true : !!this.audioSegmentLoader_.getCurrentMediaInfo_(); // one or both loaders has not loaded sufficently to get codecs
        if (!hasMainMediaInfo || !hasAudioMediaInfo) return false;
        return true;
    }
    getCodecsOrExclude_() {
        const media = {
            main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
            audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
        };
        const playlist = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media(); // set "main" media equal to video
        media.video = media.main;
        const playlistCodecs = $86defbb4e95ebb07$var$codecsForPlaylist(this.main(), playlist);
        const codecs = {};
        const usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
        if (media.main.hasVideo) codecs.video = playlistCodecs.video || media.main.videoCodec || (0, $34bf5acfb37ee851$export$77d6196664053611);
        if (media.main.isMuxed) codecs.video += `,${playlistCodecs.audio || media.main.audioCodec || (0, $34bf5acfb37ee851$export$615de1d7b49571dc)}`;
        if (media.main.hasAudio && !media.main.isMuxed || media.audio.hasAudio || usingAudioLoader) {
            codecs.audio = playlistCodecs.audio || media.main.audioCodec || media.audio.audioCodec || (0, $34bf5acfb37ee851$export$615de1d7b49571dc); // set audio isFmp4 so we use the correct "supports" function below
            media.audio.isFmp4 = media.main.hasAudio && !media.main.isMuxed ? media.main.isFmp4 : media.audio.isFmp4;
        } // no codecs, no playback.
        if (!codecs.audio && !codecs.video) {
            this.excludePlaylist({
                playlistToExclude: playlist,
                error: {
                    message: 'Could not determine codecs for playlist.'
                },
                playlistExclusionDuration: Infinity
            });
            return;
        } // fmp4 relies on browser support, while ts relies on muxer support
        const supportFunction = (isFmp4, codec)=>isFmp4 ? (0, $34bf5acfb37ee851$export$3ee949df8fbc592f)(codec, this.usingManagedMediaSource_) : (0, $34bf5acfb37ee851$export$614fda2d02e4a9d7)(codec);
        const unsupportedCodecs = {};
        let unsupportedAudio;
        [
            'video',
            'audio'
        ].forEach(function(type) {
            if (codecs.hasOwnProperty(type) && !supportFunction(media[type].isFmp4, codecs[type])) {
                const supporter = media[type].isFmp4 ? 'browser' : 'muxer';
                unsupportedCodecs[supporter] = unsupportedCodecs[supporter] || [];
                unsupportedCodecs[supporter].push(codecs[type]);
                if (type === 'audio') unsupportedAudio = supporter;
            }
        });
        if (usingAudioLoader && unsupportedAudio && playlist.attributes.AUDIO) {
            const audioGroup = playlist.attributes.AUDIO;
            this.main().playlists.forEach((variant)=>{
                const variantAudioGroup = variant.attributes && variant.attributes.AUDIO;
                if (variantAudioGroup === audioGroup && variant !== playlist) variant.excludeUntil = Infinity;
            });
            this.logger_(`excluding audio group ${audioGroup} as ${unsupportedAudio} does not support codec(s): "${codecs.audio}"`);
        } // if we have any unsupported codecs exclude this playlist.
        if (Object.keys(unsupportedCodecs).length) {
            const message = Object.keys(unsupportedCodecs).reduce((acc, supporter)=>{
                if (acc) acc += ', ';
                acc += `${supporter} does not support codec(s): "${unsupportedCodecs[supporter].join(',')}"`;
                return acc;
            }, '') + '.';
            this.excludePlaylist({
                playlistToExclude: playlist,
                error: {
                    internal: true,
                    message: message
                },
                playlistExclusionDuration: Infinity
            });
            return;
        } // check if codec switching is happening
        if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
            const switchMessages = [];
            [
                'video',
                'audio'
            ].forEach((type)=>{
                const newCodec = ((0, $34bf5acfb37ee851$export$56679b562aa2891c)(this.sourceUpdater_.codecs[type] || '')[0] || {}).type;
                const oldCodec = ((0, $34bf5acfb37ee851$export$56679b562aa2891c)(codecs[type] || '')[0] || {}).type;
                if (newCodec && oldCodec && newCodec.toLowerCase() !== oldCodec.toLowerCase()) switchMessages.push(`"${this.sourceUpdater_.codecs[type]}" -> "${codecs[type]}"`);
            });
            if (switchMessages.length) {
                this.excludePlaylist({
                    playlistToExclude: playlist,
                    error: {
                        message: `Codec switching not supported: ${switchMessages.join(', ')}.`,
                        internal: true
                    },
                    playlistExclusionDuration: Infinity
                });
                return;
            }
        } // TODO: when using the muxer shouldn't we just return
        // the codecs that the muxer outputs?
        return codecs;
    }
    /**
   * Create source buffers and exlude any incompatible renditions.
   *
   * @private
   */ tryToCreateSourceBuffers_() {
        // media source is not ready yet or sourceBuffers are already
        // created.
        if (this.mediaSource.readyState !== 'open' || this.sourceUpdater_.hasCreatedSourceBuffers()) return;
        if (!this.areMediaTypesKnown_()) return;
        const codecs = this.getCodecsOrExclude_(); // no codecs means that the playlist was excluded
        if (!codecs) return;
        this.sourceUpdater_.createSourceBuffers(codecs);
        const codecString = [
            codecs.video,
            codecs.audio
        ].filter(Boolean).join(',');
        this.excludeIncompatibleVariants_(codecString);
    }
    /**
   * Excludes playlists with codecs that are unsupported by the muxer and browser.
   */ excludeUnsupportedVariants_() {
        const playlists = this.main().playlists;
        const ids = []; // TODO: why don't we have a property to loop through all
        // playlist? Why did we ever mix indexes and keys?
        Object.keys(playlists).forEach((key)=>{
            const variant = playlists[key]; // check if we already processed this playlist.
            if (ids.indexOf(variant.id) !== -1) return;
            ids.push(variant.id);
            const codecs = $86defbb4e95ebb07$var$codecsForPlaylist(this.main, variant);
            const unsupported = [];
            if (codecs.audio && !(0, $34bf5acfb37ee851$export$614fda2d02e4a9d7)(codecs.audio) && !(0, $34bf5acfb37ee851$export$3ee949df8fbc592f)(codecs.audio, this.usingManagedMediaSource_)) unsupported.push(`audio codec ${codecs.audio}`);
            if (codecs.video && !(0, $34bf5acfb37ee851$export$614fda2d02e4a9d7)(codecs.video) && !(0, $34bf5acfb37ee851$export$3ee949df8fbc592f)(codecs.video, this.usingManagedMediaSource_)) unsupported.push(`video codec ${codecs.video}`);
            if (codecs.text && codecs.text === 'stpp.ttml.im1t') unsupported.push(`text codec ${codecs.text}`);
            if (unsupported.length) {
                variant.excludeUntil = Infinity;
                this.logger_(`excluding ${variant.id} for unsupported: ${unsupported.join(', ')}`);
            }
        });
    }
    /**
   * Exclude playlists that are known to be codec or
   * stream-incompatible with the SourceBuffer configuration. For
   * instance, Media Source Extensions would cause the video element to
   * stall waiting for video data if you switched from a variant with
   * video and audio to an audio-only one.
   *
   * @param {Object} media a media playlist compatible with the current
   * set of SourceBuffers. Variants in the current main playlist that
   * do not appear to have compatible codec or stream configurations
   * will be excluded from the default playlist selection algorithm
   * indefinitely.
   * @private
   */ excludeIncompatibleVariants_(codecString) {
        const ids = [];
        const playlists = this.main().playlists;
        const codecs = $86defbb4e95ebb07$var$unwrapCodecList((0, $34bf5acfb37ee851$export$56679b562aa2891c)(codecString));
        const codecCount_ = $86defbb4e95ebb07$var$codecCount(codecs);
        const videoDetails = codecs.video && (0, $34bf5acfb37ee851$export$56679b562aa2891c)(codecs.video)[0] || null;
        const audioDetails = codecs.audio && (0, $34bf5acfb37ee851$export$56679b562aa2891c)(codecs.audio)[0] || null;
        Object.keys(playlists).forEach((key)=>{
            const variant = playlists[key]; // check if we already processed this playlist.
            // or it if it is already excluded forever.
            if (ids.indexOf(variant.id) !== -1 || variant.excludeUntil === Infinity) return;
            ids.push(variant.id);
            const exclusionReasons = []; // get codecs from the playlist for this variant
            const variantCodecs = $86defbb4e95ebb07$var$codecsForPlaylist(this.mainPlaylistLoader_.main, variant);
            const variantCodecCount = $86defbb4e95ebb07$var$codecCount(variantCodecs); // if no codecs are listed, we cannot determine that this
            // variant is incompatible. Wait for mux.js to probe
            if (!variantCodecs.audio && !variantCodecs.video) return;
             // TODO: we can support this by removing the
            // old media source and creating a new one, but it will take some work.
            // The number of streams cannot change
            if (variantCodecCount !== codecCount_) exclusionReasons.push(`codec count "${variantCodecCount}" !== "${codecCount_}"`);
             // only exclude playlists by codec change, if codecs cannot switch
            // during playback.
            if (!this.sourceUpdater_.canChangeType()) {
                const variantVideoDetails = variantCodecs.video && (0, $34bf5acfb37ee851$export$56679b562aa2891c)(variantCodecs.video)[0] || null;
                const variantAudioDetails = variantCodecs.audio && (0, $34bf5acfb37ee851$export$56679b562aa2891c)(variantCodecs.audio)[0] || null; // the video codec cannot change
                if (variantVideoDetails && videoDetails && variantVideoDetails.type.toLowerCase() !== videoDetails.type.toLowerCase()) exclusionReasons.push(`video codec "${variantVideoDetails.type}" !== "${videoDetails.type}"`);
                 // the audio codec cannot change
                if (variantAudioDetails && audioDetails && variantAudioDetails.type.toLowerCase() !== audioDetails.type.toLowerCase()) exclusionReasons.push(`audio codec "${variantAudioDetails.type}" !== "${audioDetails.type}"`);
            }
            if (exclusionReasons.length) {
                variant.excludeUntil = Infinity;
                this.logger_(`excluding ${variant.id}: ${exclusionReasons.join(' && ')}`);
            }
        });
    }
    updateAdCues_(media) {
        let offset = 0;
        const seekable = this.seekable();
        if (seekable.length) offset = seekable.start(0);
        $86defbb4e95ebb07$var$updateAdCues(media, this.cueTagsTrack_, offset);
    }
    /**
   * Calculates the desired forward buffer length based on current time
   *
   * @return {number} Desired forward buffer length in seconds
   */ goalBufferLength() {
        const currentTime = this.tech_.currentTime();
        const initial = $86defbb4e95ebb07$var$Config.GOAL_BUFFER_LENGTH;
        const rate = $86defbb4e95ebb07$var$Config.GOAL_BUFFER_LENGTH_RATE;
        const max = Math.max(initial, $86defbb4e95ebb07$var$Config.MAX_GOAL_BUFFER_LENGTH);
        return Math.min(initial + currentTime * rate, max);
    }
    /**
   * Calculates the desired buffer low water line based on current time
   *
   * @return {number} Desired buffer low water line in seconds
   */ bufferLowWaterLine() {
        const currentTime = this.tech_.currentTime();
        const initial = $86defbb4e95ebb07$var$Config.BUFFER_LOW_WATER_LINE;
        const rate = $86defbb4e95ebb07$var$Config.BUFFER_LOW_WATER_LINE_RATE;
        const max = Math.max(initial, $86defbb4e95ebb07$var$Config.MAX_BUFFER_LOW_WATER_LINE);
        const newMax = Math.max(initial, $86defbb4e95ebb07$var$Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
        return Math.min(initial + currentTime * rate, this.bufferBasedABR ? newMax : max);
    }
    bufferHighWaterLine() {
        return $86defbb4e95ebb07$var$Config.BUFFER_HIGH_WATER_LINE;
    }
    addDateRangesToTextTrack_(dateRanges) {
        $86defbb4e95ebb07$var$createMetadataTrackIfNotExists(this.inbandTextTracks_, 'com.apple.streaming', this.tech_);
        $86defbb4e95ebb07$var$addDateRangeMetadata({
            inbandTextTracks: this.inbandTextTracks_,
            dateRanges: dateRanges
        });
    }
    addMetadataToTextTrack(dispatchType, metadataArray, videoDuration) {
        const timestampOffset = this.sourceUpdater_.videoBuffer ? this.sourceUpdater_.videoTimestampOffset() : this.sourceUpdater_.audioTimestampOffset(); // There's potentially an issue where we could double add metadata if there's a muxed
        // audio/video source with a metadata track, and an alt audio with a metadata track.
        // However, this probably won't happen, and if it does it can be handled then.
        $86defbb4e95ebb07$var$createMetadataTrackIfNotExists(this.inbandTextTracks_, dispatchType, this.tech_);
        $86defbb4e95ebb07$var$addMetadata({
            inbandTextTracks: this.inbandTextTracks_,
            metadataArray: metadataArray,
            timestampOffset: timestampOffset,
            videoDuration: videoDuration
        });
    }
    /**
   * Utility for getting the pathway or service location from an HLS or DASH playlist.
   *
   * @param {Object} playlist for getting pathway from.
   * @return the pathway attribute of a playlist
   */ pathwayAttribute_(playlist) {
        return playlist.attributes['PATHWAY-ID'] || playlist.attributes.serviceLocation;
    }
    /**
   * Initialize available pathways and apply the tag properties.
   */ initContentSteeringController_() {
        const main = this.main();
        if (!main.contentSteering) return;
        for (const playlist of main.playlists)this.contentSteeringController_.addAvailablePathway(this.pathwayAttribute_(playlist));
        this.contentSteeringController_.assignTagProperties(main.uri, main.contentSteering); // request the steering manifest immediately if queryBeforeStart is set.
        if (this.contentSteeringController_.queryBeforeStart) {
            // When queryBeforeStart is true, initial request should omit steering parameters.
            this.contentSteeringController_.requestSteeringManifest(true);
            return;
        } // otherwise start content steering after playback starts
        this.tech_.one('canplay', ()=>{
            this.contentSteeringController_.requestSteeringManifest();
        });
    }
    /**
   * Reset the content steering controller and re-init.
   */ resetContentSteeringController_() {
        this.contentSteeringController_.clearAvailablePathways();
        this.contentSteeringController_.dispose();
        this.initContentSteeringController_();
    }
    /**
   * Attaches the listeners for content steering.
   */ attachContentSteeringListeners_() {
        this.contentSteeringController_.on('content-steering', this.excludeThenChangePathway_.bind(this));
        const contentSteeringEvents = [
            'contentsteeringloadstart',
            'contentsteeringloadcomplete',
            'contentsteeringparsed'
        ];
        contentSteeringEvents.forEach((eventName)=>{
            this.contentSteeringController_.on(eventName, (metadata)=>{
                this.trigger((0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, metadata));
            });
        });
        if (this.sourceType_ === 'dash') this.mainPlaylistLoader_.on('loadedplaylist', ()=>{
            const main = this.main(); // check if steering tag or pathways changed.
            const didDashTagChange = this.contentSteeringController_.didDASHTagChange(main.uri, main.contentSteering);
            const didPathwaysChange = ()=>{
                const availablePathways = this.contentSteeringController_.getAvailablePathways();
                const newPathways = [];
                for (const playlist of main.playlists){
                    const serviceLocation = playlist.attributes.serviceLocation;
                    if (serviceLocation) {
                        newPathways.push(serviceLocation);
                        if (!availablePathways.has(serviceLocation)) return true;
                    }
                } // If we have no new serviceLocations and previously had availablePathways
                if (!newPathways.length && availablePathways.size) return true;
                return false;
            };
            if (didDashTagChange || didPathwaysChange()) this.resetContentSteeringController_();
        });
    }
    /**
   * Simple exclude and change playlist logic for content steering.
   */ excludeThenChangePathway_() {
        const currentPathway = this.contentSteeringController_.getPathway();
        if (!currentPathway) return;
        this.handlePathwayClones_();
        const main = this.main();
        const playlists = main.playlists;
        const ids = new Set();
        let didEnablePlaylists = false;
        Object.keys(playlists).forEach((key)=>{
            const variant = playlists[key];
            const pathwayId = this.pathwayAttribute_(variant);
            const differentPathwayId = pathwayId && currentPathway !== pathwayId;
            const steeringExclusion = variant.excludeUntil === Infinity && variant.lastExcludeReason_ === 'content-steering';
            if (steeringExclusion && !differentPathwayId) {
                delete variant.excludeUntil;
                delete variant.lastExcludeReason_;
                didEnablePlaylists = true;
            }
            const noExcludeUntil = !variant.excludeUntil && variant.excludeUntil !== Infinity;
            const shouldExclude = !ids.has(variant.id) && differentPathwayId && noExcludeUntil;
            if (!shouldExclude) return;
            ids.add(variant.id);
            variant.excludeUntil = Infinity;
            variant.lastExcludeReason_ = 'content-steering'; // TODO: kind of spammy, maybe move this.
            this.logger_(`excluding ${variant.id} for ${variant.lastExcludeReason_}`);
        });
        if (this.contentSteeringController_.manifestType_ === 'DASH') Object.keys(this.mediaTypes_).forEach((key)=>{
            const type = this.mediaTypes_[key];
            if (type.activePlaylistLoader) {
                const currentPlaylist = type.activePlaylistLoader.media_; // Check if the current media playlist matches the current CDN
                if (currentPlaylist && currentPlaylist.attributes.serviceLocation !== currentPathway) didEnablePlaylists = true;
            }
        });
        if (didEnablePlaylists) this.changeSegmentPathway_();
    }
    /**
   * Add, update, or delete playlists and media groups for
   * the pathway clones for HLS Content Steering.
   *
   * See https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/
   *
   * NOTE: Pathway cloning does not currently support the `PER_VARIANT_URIS` and
   * `PER_RENDITION_URIS` as we do not handle `STABLE-VARIANT-ID` or
   * `STABLE-RENDITION-ID` values.
   */ handlePathwayClones_() {
        const main = this.main();
        const playlists = main.playlists;
        const currentPathwayClones = this.contentSteeringController_.currentPathwayClones;
        const nextPathwayClones = this.contentSteeringController_.nextPathwayClones;
        const hasClones = currentPathwayClones && currentPathwayClones.size || nextPathwayClones && nextPathwayClones.size;
        if (!hasClones) return;
        for (const [id, clone] of currentPathwayClones.entries()){
            const newClone = nextPathwayClones.get(id); // Delete the old pathway clone.
            if (!newClone) {
                this.mainPlaylistLoader_.updateOrDeleteClone(clone);
                this.contentSteeringController_.excludePathway(id);
            }
        }
        for (const [id, clone] of nextPathwayClones.entries()){
            const oldClone = currentPathwayClones.get(id); // Create a new pathway if it is a new pathway clone object.
            if (!oldClone) {
                const playlistsToClone = playlists.filter((p)=>{
                    return p.attributes['PATHWAY-ID'] === clone['BASE-ID'];
                });
                playlistsToClone.forEach((p)=>{
                    this.mainPlaylistLoader_.addClonePathway(clone, p);
                });
                this.contentSteeringController_.addAvailablePathway(id);
                continue;
            } // There have not been changes to the pathway clone object, so skip.
            if (this.equalPathwayClones_(oldClone, clone)) continue;
             // Update a preexisting cloned pathway.
            // True is set for the update flag.
            this.mainPlaylistLoader_.updateOrDeleteClone(clone, true);
            this.contentSteeringController_.addAvailablePathway(id);
        } // Deep copy contents of next to current pathways.
        this.contentSteeringController_.currentPathwayClones = new Map(JSON.parse(JSON.stringify([
            ...nextPathwayClones
        ])));
    }
    /**
   * Determines whether two pathway clone objects are equivalent.
   *
   * @param {Object} a The first pathway clone object.
   * @param {Object} b The second pathway clone object.
   * @return {boolean} True if the pathway clone objects are equal, false otherwise.
   */ equalPathwayClones_(a, b) {
        if (a['BASE-ID'] !== b['BASE-ID'] || a.ID !== b.ID || a['URI-REPLACEMENT'].HOST !== b['URI-REPLACEMENT'].HOST) return false;
        const aParams = a['URI-REPLACEMENT'].PARAMS;
        const bParams = b['URI-REPLACEMENT'].PARAMS; // We need to iterate through both lists of params because one could be
        // missing a parameter that the other has.
        for(const p in aParams){
            if (aParams[p] !== bParams[p]) return false;
        }
        for(const p in bParams){
            if (aParams[p] !== bParams[p]) return false;
        }
        return true;
    }
    /**
   * Changes the current playlists for audio, video and subtitles after a new pathway
   * is chosen from content steering.
   */ changeSegmentPathway_() {
        const nextPlaylist = this.selectPlaylist();
        this.pauseLoading(); // Switch audio and text track playlists if necessary in DASH
        if (this.contentSteeringController_.manifestType_ === 'DASH') this.switchMediaForDASHContentSteering_();
        this.switchMedia_(nextPlaylist, 'content-steering');
    }
    /**
   * Iterates through playlists and check their keyId set and compare with the
   * keyStatusMap, only enable playlists that have a usable key. If the playlist
   * has no keyId leave it enabled by default.
   */ excludeNonUsablePlaylistsByKeyId_() {
        if (!this.mainPlaylistLoader_ || !this.mainPlaylistLoader_.main) return;
        let nonUsableKeyStatusCount = 0;
        const NON_USABLE = 'non-usable';
        this.mainPlaylistLoader_.main.playlists.forEach((playlist)=>{
            const keyIdSet = this.mainPlaylistLoader_.getKeyIdSet(playlist); // If the playlist doesn't have keyIDs lets not exclude it.
            if (!keyIdSet || !keyIdSet.size) return;
            keyIdSet.forEach((key)=>{
                const USABLE = 'usable';
                const hasUsableKeyStatus = this.keyStatusMap_.has(key) && this.keyStatusMap_.get(key) === USABLE;
                const nonUsableExclusion = playlist.lastExcludeReason_ === NON_USABLE && playlist.excludeUntil === Infinity;
                if (!hasUsableKeyStatus) {
                    // Only exclude playlists that haven't already been excluded as non-usable.
                    if (playlist.excludeUntil !== Infinity && playlist.lastExcludeReason_ !== NON_USABLE) {
                        playlist.excludeUntil = Infinity;
                        playlist.lastExcludeReason_ = NON_USABLE;
                        this.logger_(`excluding playlist ${playlist.id} because the key ID ${key} doesn't exist in the keyStatusMap or is not ${USABLE}`);
                    } // count all nonUsableKeyStatus
                    nonUsableKeyStatusCount++;
                } else if (hasUsableKeyStatus && nonUsableExclusion) {
                    delete playlist.excludeUntil;
                    delete playlist.lastExcludeReason_;
                    this.logger_(`enabling playlist ${playlist.id} because key ID ${key} is ${USABLE}`);
                }
            });
        }); // If for whatever reason every playlist has a non usable key status. Lets try re-including the SD renditions as a failsafe.
        if (nonUsableKeyStatusCount >= this.mainPlaylistLoader_.main.playlists.length) this.mainPlaylistLoader_.main.playlists.forEach((playlist)=>{
            const isNonHD = playlist && playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height < 720;
            const excludedForNonUsableKey = playlist.excludeUntil === Infinity && playlist.lastExcludeReason_ === NON_USABLE;
            if (isNonHD && excludedForNonUsableKey) {
                // Only delete the excludeUntil so we don't try and re-exclude these playlists.
                delete playlist.excludeUntil;
                $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn(`enabling non-HD playlist ${playlist.id} because all playlists were excluded due to ${NON_USABLE} key IDs`);
            }
        });
    }
    /**
   * Adds a keystatus to the keystatus map, tries to convert to string if necessary.
   *
   * @param {any} keyId the keyId to add a status for
   * @param {string} status the status of the keyId
   */ addKeyStatus_(keyId, status) {
        const isString = typeof keyId === 'string';
        const keyIdHexString = isString ? keyId : $86defbb4e95ebb07$var$bufferToHexString(keyId);
        const formattedKeyIdString = keyIdHexString.slice(0, 32).toLowerCase();
        this.logger_(`KeyStatus '${status}' with key ID ${formattedKeyIdString} added to the keyStatusMap`);
        this.keyStatusMap_.set(formattedKeyIdString, status);
    }
    /**
   * Utility function for adding key status to the keyStatusMap and filtering usable encrypted playlists.
   *
   * @param {any} keyId the keyId from the keystatuschange event
   * @param {string} status the key status string
   */ updatePlaylistByKeyStatus(keyId, status) {
        this.addKeyStatus_(keyId, status);
        if (!this.waitingForFastQualityPlaylistReceived_) this.excludeNonUsableThenChangePlaylist_();
         // Listen to loadedplaylist with a single listener and check for new contentProtection elements when a playlist is updated.
        this.mainPlaylistLoader_.off('loadedplaylist', this.excludeNonUsableThenChangePlaylist_.bind(this));
        this.mainPlaylistLoader_.on('loadedplaylist', this.excludeNonUsableThenChangePlaylist_.bind(this));
    }
    excludeNonUsableThenChangePlaylist_() {
        this.excludeNonUsablePlaylistsByKeyId_();
        this.fastQualityChange_();
    }
}
/**
 * Returns a function that acts as the Enable/disable playlist function.
 *
 * @param {PlaylistLoader} loader - The main playlist loader
 * @param {string} playlistID - id of the playlist
 * @param {Function} changePlaylistFn - A function to be called after a
 * playlist's enabled-state has been changed. Will NOT be called if a
 * playlist's enabled-state is unchanged
 * @param {boolean=} enable - Value to set the playlist enabled-state to
 * or if undefined returns the current enabled-state for the playlist
 * @return {Function} Function for setting/getting enabled
 */ const $86defbb4e95ebb07$var$enableFunction = (loader, playlistID, changePlaylistFn)=>(enable)=>{
        const playlist = loader.main.playlists[playlistID];
        const incompatible = $86defbb4e95ebb07$var$isIncompatible(playlist);
        const currentlyEnabled = $86defbb4e95ebb07$var$isEnabled(playlist);
        if (typeof enable === 'undefined') return currentlyEnabled;
        if (enable) delete playlist.disabled;
        else playlist.disabled = true;
        const metadata = {
            renditionInfo: {
                id: playlistID,
                bandwidth: playlist.attributes.BANDWIDTH,
                resolution: playlist.attributes.RESOLUTION,
                codecs: playlist.attributes.CODECS
            },
            cause: 'fast-quality'
        };
        if (enable !== currentlyEnabled && !incompatible) {
            // Ensure the outside world knows about our changes
            if (enable) {
                // call fast quality change only when the playlist is enabled
                changePlaylistFn(playlist);
                loader.trigger({
                    type: 'renditionenabled',
                    metadata: metadata
                });
            } else loader.trigger({
                type: 'renditiondisabled',
                metadata: metadata
            });
        }
        return enable;
    };
/**
 * The representation object encapsulates the publicly visible information
 * in a media playlist along with a setter/getter-type function (enabled)
 * for changing the enabled-state of a particular playlist entry
 *
 * @class Representation
 */ class $86defbb4e95ebb07$var$Representation {
    constructor(vhsHandler, playlist, id){
        const { playlistController_: pc } = vhsHandler;
        const qualityChangeFunction = pc.fastQualityChange_.bind(pc); // some playlist attributes are optional
        if (playlist.attributes) {
            const resolution = playlist.attributes.RESOLUTION;
            this.width = resolution && resolution.width;
            this.height = resolution && resolution.height;
            this.bandwidth = playlist.attributes.BANDWIDTH;
            this.frameRate = playlist.attributes['FRAME-RATE'];
        }
        this.codecs = $86defbb4e95ebb07$var$codecsForPlaylist(pc.main(), playlist);
        this.playlist = playlist; // The id is simply the ordinality of the media playlist
        // within the main playlist
        this.id = id; // Partially-apply the enableFunction to create a playlist-
        // specific variant
        this.enabled = $86defbb4e95ebb07$var$enableFunction(vhsHandler.playlists, playlist.id, qualityChangeFunction);
    }
}
/**
 * A mixin function that adds the `representations` api to an instance
 * of the VhsHandler class
 *
 * @param {VhsHandler} vhsHandler - An instance of VhsHandler to add the
 * representation API into
 */ const $86defbb4e95ebb07$var$renditionSelectionMixin = function(vhsHandler) {
    // Add a single API-specific function to the VhsHandler instance
    vhsHandler.representations = ()=>{
        const main = vhsHandler.playlistController_.main();
        const playlists = $86defbb4e95ebb07$var$isAudioOnly(main) ? vhsHandler.playlistController_.getAudioTrackPlaylists_() : main.playlists;
        if (!playlists) return [];
        return playlists.filter((media)=>!$86defbb4e95ebb07$var$isIncompatible(media)).map((e, i)=>new $86defbb4e95ebb07$var$Representation(vhsHandler, e, e.id));
    };
};
/**
 * @file playback-watcher.js
 *
 * Playback starts, and now my watch begins. It shall not end until my death. I shall
 * take no wait, hold no uncleared timeouts, father no bad seeks. I shall wear no crowns
 * and win no glory. I shall live and die at my post. I am the corrector of the underflow.
 * I am the watcher of gaps. I am the shield that guards the realms of seekable. I pledge
 * my life and honor to the Playback Watch, for this Player and all the Players to come.
 */ const $86defbb4e95ebb07$var$timerCancelEvents = [
    'seeking',
    'seeked',
    'pause',
    'playing',
    'error'
];
/**
 * @class PlaybackWatcher
 */ class $86defbb4e95ebb07$var$PlaybackWatcher extends $86defbb4e95ebb07$export$2e2bcd8739ae039.EventTarget {
    /**
   * Represents an PlaybackWatcher object.
   *
   * @class
   * @param {Object} options an object that includes the tech and settings
   */ constructor(options){
        super();
        this.playlistController_ = options.playlistController;
        this.tech_ = options.tech;
        this.seekable = options.seekable;
        this.allowSeeksWithinUnsafeLiveWindow = options.allowSeeksWithinUnsafeLiveWindow;
        this.liveRangeSafeTimeDelta = options.liveRangeSafeTimeDelta;
        this.media = options.media;
        this.playedRanges_ = [];
        this.consecutiveUpdates = 0;
        this.lastRecordedTime = null;
        this.checkCurrentTimeTimeout_ = null;
        this.logger_ = $86defbb4e95ebb07$var$logger('PlaybackWatcher');
        this.logger_('initialize');
        const playHandler = ()=>this.monitorCurrentTime_();
        const canPlayHandler = ()=>this.monitorCurrentTime_();
        const waitingHandler = ()=>this.techWaiting_();
        const cancelTimerHandler = ()=>this.resetTimeUpdate_();
        const pc = this.playlistController_;
        const loaderTypes = [
            'main',
            'subtitle',
            'audio'
        ];
        const loaderChecks = {};
        loaderTypes.forEach((type)=>{
            loaderChecks[type] = {
                reset: ()=>this.resetSegmentDownloads_(type),
                updateend: ()=>this.checkSegmentDownloads_(type)
            };
            pc[`${type}SegmentLoader_`].on('appendsdone', loaderChecks[type].updateend); // If a rendition switch happens during a playback stall where the buffer
            // isn't changing we want to reset. We cannot assume that the new rendition
            // will also be stalled, until after new appends.
            pc[`${type}SegmentLoader_`].on('playlistupdate', loaderChecks[type].reset); // Playback stalls should not be detected right after seeking.
            // This prevents one segment playlists (single vtt or single segment content)
            // from being detected as stalling. As the buffer will not change in those cases, since
            // the buffer is the entire video duration.
            this.tech_.on([
                'seeked',
                'seeking'
            ], loaderChecks[type].reset);
        });
        /**
     * We check if a seek was into a gap through the following steps:
     * 1. We get a seeking event and we do not get a seeked event. This means that
     *    a seek was attempted but not completed.
     * 2. We run `fixesBadSeeks_` on segment loader appends. This means that we already
     *    removed everything from our buffer and appended a segment, and should be ready
     *    to check for gaps.
     */ const setSeekingHandlers = (fn)=>{
            [
                'main',
                'audio'
            ].forEach((type)=>{
                pc[`${type}SegmentLoader_`][fn]('appended', this.seekingAppendCheck_);
            });
        };
        this.seekingAppendCheck_ = ()=>{
            if (this.fixesBadSeeks_()) {
                this.consecutiveUpdates = 0;
                this.lastRecordedTime = this.tech_.currentTime();
                setSeekingHandlers('off');
            }
        };
        this.clearSeekingAppendCheck_ = ()=>setSeekingHandlers('off');
        this.watchForBadSeeking_ = ()=>{
            this.clearSeekingAppendCheck_();
            setSeekingHandlers('on');
        };
        this.tech_.on('seeked', this.clearSeekingAppendCheck_);
        this.tech_.on('seeking', this.watchForBadSeeking_);
        this.tech_.on('waiting', waitingHandler);
        this.tech_.on($86defbb4e95ebb07$var$timerCancelEvents, cancelTimerHandler);
        this.tech_.on('canplay', canPlayHandler);
        /*
      An edge case exists that results in gaps not being skipped when they exist at the beginning of a stream. This case
      is surfaced in one of two ways:
       1)  The `waiting` event is fired before the player has buffered content, making it impossible
          to find or skip the gap. The `waiting` event is followed by a `play` event. On first play
          we can check if playback is stalled due to a gap, and skip the gap if necessary.
      2)  A source with a gap at the beginning of the stream is loaded programatically while the player
          is in a playing state. To catch this case, it's important that our one-time play listener is setup
          even if the player is in a playing state
    */ this.tech_.one('play', playHandler); // Define the dispose function to clean up our events
        this.dispose = ()=>{
            this.clearSeekingAppendCheck_();
            this.logger_('dispose');
            this.tech_.off('waiting', waitingHandler);
            this.tech_.off($86defbb4e95ebb07$var$timerCancelEvents, cancelTimerHandler);
            this.tech_.off('canplay', canPlayHandler);
            this.tech_.off('play', playHandler);
            this.tech_.off('seeking', this.watchForBadSeeking_);
            this.tech_.off('seeked', this.clearSeekingAppendCheck_);
            loaderTypes.forEach((type)=>{
                pc[`${type}SegmentLoader_`].off('appendsdone', loaderChecks[type].updateend);
                pc[`${type}SegmentLoader_`].off('playlistupdate', loaderChecks[type].reset);
                this.tech_.off([
                    'seeked',
                    'seeking'
                ], loaderChecks[type].reset);
            });
            if (this.checkCurrentTimeTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.checkCurrentTimeTimeout_);
            this.resetTimeUpdate_();
        };
    }
    /**
   * Periodically check current time to see if playback stopped
   *
   * @private
   */ monitorCurrentTime_() {
        this.checkCurrentTime_();
        if (this.checkCurrentTimeTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).clearTimeout(this.checkCurrentTimeTimeout_);
         // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
        this.checkCurrentTimeTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).setTimeout(this.monitorCurrentTime_.bind(this), 250);
    }
    /**
   * Reset stalled download stats for a specific type of loader
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#playlistupdate
   * @listens Tech#seeking
   * @listens Tech#seeked
   */ resetSegmentDownloads_(type) {
        const loader = this.playlistController_[`${type}SegmentLoader_`];
        if (this[`${type}StalledDownloads_`] > 0) this.logger_(`resetting possible stalled download count for ${type} loader`);
        this[`${type}StalledDownloads_`] = 0;
        this[`${type}Buffered_`] = loader.buffered_();
    }
    /**
   * Checks on every segment `appendsdone` to see
   * if segment appends are making progress. If they are not
   * and we are still downloading bytes. We exclude the playlist.
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#appendsdone
   */ checkSegmentDownloads_(type) {
        const pc = this.playlistController_;
        const loader = pc[`${type}SegmentLoader_`];
        const buffered = loader.buffered_();
        const isBufferedDifferent = $86defbb4e95ebb07$var$isRangeDifferent(this[`${type}Buffered_`], buffered);
        this[`${type}Buffered_`] = buffered; // if another watcher is going to fix the issue or
        // the buffered value for this loader changed
        // appends are working
        if (isBufferedDifferent) {
            const metadata = {
                bufferedRanges: buffered
            };
            pc.trigger({
                type: 'bufferedrangeschanged',
                metadata: metadata
            });
            this.resetSegmentDownloads_(type);
            return;
        }
        this[`${type}StalledDownloads_`]++;
        this.logger_(`found #${this[`${type}StalledDownloads_`]} ${type} appends that did not increase buffer (possible stalled download)`, {
            playlistId: loader.playlist_ && loader.playlist_.id,
            buffered: $86defbb4e95ebb07$var$timeRangesToArray(buffered)
        }); // after 10 possibly stalled appends with no reset, exclude
        if (this[`${type}StalledDownloads_`] < 10) return;
        this.logger_(`${type} loader stalled download exclusion`);
        this.resetSegmentDownloads_(type);
        this.tech_.trigger({
            type: 'usage',
            name: `vhs-${type}-download-exclusion`
        });
        if (type === 'subtitle') return;
         // TODO: should we exclude audio tracks rather than main tracks
        // when type is audio?
        pc.excludePlaylist({
            error: {
                message: `Excessive ${type} segment downloading detected.`
            },
            playlistExclusionDuration: Infinity
        });
    }
    /**
   * The purpose of this function is to emulate the "waiting" event on
   * browsers that do not emit it when they are waiting for more
   * data to continue playback
   *
   * @private
   */ checkCurrentTime_() {
        if (this.tech_.paused() || this.tech_.seeking()) return;
        const currentTime = this.tech_.currentTime();
        const buffered = this.tech_.buffered();
        if (this.lastRecordedTime === currentTime && (!buffered.length || currentTime + $86defbb4e95ebb07$var$SAFE_TIME_DELTA >= buffered.end(buffered.length - 1))) // If current time is at the end of the final buffered region, then any playback
        // stall is most likely caused by buffering in a low bandwidth environment. The tech
        // should fire a `waiting` event in this scenario, but due to browser and tech
        // inconsistencies. Calling `techWaiting_` here allows us to simulate
        // responding to a native `waiting` event when the tech fails to emit one.
        return this.techWaiting_();
        if (this.consecutiveUpdates >= 5 && currentTime === this.lastRecordedTime) {
            this.consecutiveUpdates++;
            this.waiting_();
        } else if (currentTime === this.lastRecordedTime) this.consecutiveUpdates++;
        else {
            this.playedRanges_.push($86defbb4e95ebb07$var$createTimeRanges([
                this.lastRecordedTime,
                currentTime
            ]));
            const metadata = {
                playedRanges: this.playedRanges_
            };
            this.playlistController_.trigger({
                type: 'playedrangeschanged',
                metadata: metadata
            });
            this.consecutiveUpdates = 0;
            this.lastRecordedTime = currentTime;
        }
    }
    /**
   * Resets the 'timeupdate' mechanism designed to detect that we are stalled
   *
   * @private
   */ resetTimeUpdate_() {
        this.consecutiveUpdates = 0;
    }
    /**
   * Fixes situations where there's a bad seek
   *
   * @return {boolean} whether an action was taken to fix the seek
   * @private
   */ fixesBadSeeks_() {
        const seeking = this.tech_.seeking();
        if (!seeking) return false;
         // TODO: It's possible that these seekable checks should be moved out of this function
        // and into a function that runs on seekablechange. It's also possible that we only need
        // afterSeekableWindow as the buffered check at the bottom is good enough to handle before
        // seekable range.
        const seekable = this.seekable();
        const currentTime = this.tech_.currentTime();
        const isAfterSeekableRange = this.afterSeekableWindow_(seekable, currentTime, this.media(), this.allowSeeksWithinUnsafeLiveWindow);
        let seekTo;
        if (isAfterSeekableRange) {
            const seekableEnd = seekable.end(seekable.length - 1); // sync to live point (if VOD, our seekable was updated and we're simply adjusting)
            seekTo = seekableEnd;
        }
        if (this.beforeSeekableWindow_(seekable, currentTime)) {
            const seekableStart = seekable.start(0); // sync to the beginning of the live window
            // provide a buffer of .1 seconds to handle rounding/imprecise numbers
            seekTo = seekableStart + // if the playlist is too short and the seekable range is an exact time (can
            // happen in live with a 3 segment playlist), then don't use a time delta
            (seekableStart === seekable.end(0) ? 0 : $86defbb4e95ebb07$var$SAFE_TIME_DELTA);
        }
        if (typeof seekTo !== 'undefined') {
            this.logger_(`Trying to seek outside of seekable at time ${currentTime} with ` + `seekable range ${$86defbb4e95ebb07$var$printableRange(seekable)}. Seeking to ` + `${seekTo}.`);
            this.tech_.setCurrentTime(seekTo);
            return true;
        }
        const sourceUpdater = this.playlistController_.sourceUpdater_;
        const buffered = this.tech_.buffered();
        const audioBuffered = sourceUpdater.audioBuffer ? sourceUpdater.audioBuffered() : null;
        const videoBuffered = sourceUpdater.videoBuffer ? sourceUpdater.videoBuffered() : null;
        const media = this.media(); // verify that at least two segment durations or one part duration have been
        // appended before checking for a gap.
        const minAppendedDuration = media.partTargetDuration ? media.partTargetDuration : (media.targetDuration - $86defbb4e95ebb07$var$TIME_FUDGE_FACTOR) * 2; // verify that at least two segment durations have been
        // appended before checking for a gap.
        const bufferedToCheck = [
            audioBuffered,
            videoBuffered
        ];
        for(let i = 0; i < bufferedToCheck.length; i++){
            // skip null buffered
            if (!bufferedToCheck[i]) continue;
            const timeAhead = $86defbb4e95ebb07$var$timeAheadOf(bufferedToCheck[i], currentTime); // if we are less than two video/audio segment durations or one part
            // duration behind we haven't appended enough to call this a bad seek.
            if (timeAhead < minAppendedDuration) return false;
        }
        const nextRange = $86defbb4e95ebb07$var$findNextRange(buffered, currentTime); // we have appended enough content, but we don't have anything buffered
        // to seek over the gap
        if (nextRange.length === 0) return false;
        seekTo = nextRange.start(0) + $86defbb4e95ebb07$var$SAFE_TIME_DELTA;
        this.logger_(`Buffered region starts (${nextRange.start(0)}) ` + ` just beyond seek point (${currentTime}). Seeking to ${seekTo}.`);
        this.tech_.setCurrentTime(seekTo);
        return true;
    }
    /**
   * Handler for situations when we determine the player is waiting.
   *
   * @private
   */ waiting_() {
        if (this.techWaiting_()) return;
         // All tech waiting checks failed. Use last resort correction
        const currentTime = this.tech_.currentTime();
        const buffered = this.tech_.buffered();
        const currentRange = $86defbb4e95ebb07$var$findRange(buffered, currentTime); // Sometimes the player can stall for unknown reasons within a contiguous buffered
        // region with no indication that anything is amiss (seen in Firefox). Seeking to
        // currentTime is usually enough to kickstart the player. This checks that the player
        // is currently within a buffered region before attempting a corrective seek.
        // Chrome does not appear to continue `timeupdate` events after a `waiting` event
        // until there is ~ 3 seconds of forward buffer available. PlaybackWatcher should also
        // make sure there is ~3 seconds of forward buffer before taking any corrective action
        // to avoid triggering an `unknownwaiting` event when the network is slow.
        if (currentRange.length && currentTime + 3 <= currentRange.end(0)) {
            this.resetTimeUpdate_();
            this.tech_.setCurrentTime(currentTime);
            this.logger_(`Stopped at ${currentTime} while inside a buffered region ` + `[${currentRange.start(0)} -> ${currentRange.end(0)}]. Attempting to resume ` + 'playback by seeking to the current time.'); // unknown waiting corrections may be useful for monitoring QoS
            this.tech_.trigger({
                type: 'usage',
                name: 'vhs-unknown-waiting'
            });
            return;
        }
    }
    /**
   * Handler for situations when the tech fires a `waiting` event
   *
   * @return {boolean}
   *         True if an action (or none) was needed to correct the waiting. False if no
   *         checks passed
   * @private
   */ techWaiting_() {
        const seekable = this.seekable();
        const currentTime = this.tech_.currentTime();
        if (this.tech_.seeking()) // Tech is seeking or already waiting on another action, no action needed
        return true;
        if (this.beforeSeekableWindow_(seekable, currentTime)) {
            const livePoint = seekable.end(seekable.length - 1);
            this.logger_(`Fell out of live window at time ${currentTime}. Seeking to ` + `live point (seekable end) ${livePoint}`);
            this.resetTimeUpdate_();
            this.tech_.setCurrentTime(livePoint); // live window resyncs may be useful for monitoring QoS
            this.tech_.trigger({
                type: 'usage',
                name: 'vhs-live-resync'
            });
            return true;
        }
        const sourceUpdater = this.tech_.vhs.playlistController_.sourceUpdater_;
        const buffered = this.tech_.buffered();
        const videoUnderflow = this.videoUnderflow_({
            audioBuffered: sourceUpdater.audioBuffered(),
            videoBuffered: sourceUpdater.videoBuffered(),
            currentTime: currentTime
        });
        if (videoUnderflow) {
            // Even though the video underflowed and was stuck in a gap, the audio overplayed
            // the gap, leading currentTime into a buffered range. Seeking to currentTime
            // allows the video to catch up to the audio position without losing any audio
            // (only suffering ~3 seconds of frozen video and a pause in audio playback).
            this.resetTimeUpdate_();
            this.tech_.setCurrentTime(currentTime); // video underflow may be useful for monitoring QoS
            this.tech_.trigger({
                type: 'usage',
                name: 'vhs-video-underflow'
            });
            return true;
        }
        const nextRange = $86defbb4e95ebb07$var$findNextRange(buffered, currentTime); // check for gap
        if (nextRange.length > 0) {
            this.logger_(`Stopped at ${currentTime} and seeking to ${nextRange.start(0)}`);
            this.resetTimeUpdate_();
            this.skipTheGap_(currentTime);
            return true;
        } // All checks failed. Returning false to indicate failure to correct waiting
        return false;
    }
    afterSeekableWindow_(seekable, currentTime, playlist, allowSeeksWithinUnsafeLiveWindow = false) {
        if (!seekable.length) // we can't make a solid case if there's no seekable, default to false
        return false;
        let allowedEnd = seekable.end(seekable.length - 1) + $86defbb4e95ebb07$var$SAFE_TIME_DELTA;
        const isLive = !playlist.endList;
        const isLLHLS = typeof playlist.partTargetDuration === 'number';
        if (isLive && (isLLHLS || allowSeeksWithinUnsafeLiveWindow)) allowedEnd = seekable.end(seekable.length - 1) + playlist.targetDuration * 3;
        if (currentTime > allowedEnd) return true;
        return false;
    }
    beforeSeekableWindow_(seekable, currentTime) {
        if (seekable.length && // can't fall before 0 and 0 seekable start identifies VOD stream
        seekable.start(0) > 0 && currentTime < seekable.start(0) - this.liveRangeSafeTimeDelta) return true;
        return false;
    }
    videoUnderflow_({ videoBuffered: videoBuffered, audioBuffered: audioBuffered, currentTime: currentTime }) {
        // audio only content will not have video underflow :)
        if (!videoBuffered) return;
        let gap; // find a gap in demuxed content.
        if (videoBuffered.length && audioBuffered.length) {
            // in Chrome audio will continue to play for ~3s when we run out of video
            // so we have to check that the video buffer did have some buffer in the
            // past.
            const lastVideoRange = $86defbb4e95ebb07$var$findRange(videoBuffered, currentTime - 3);
            const videoRange = $86defbb4e95ebb07$var$findRange(videoBuffered, currentTime);
            const audioRange = $86defbb4e95ebb07$var$findRange(audioBuffered, currentTime);
            if (audioRange.length && !videoRange.length && lastVideoRange.length) gap = {
                start: lastVideoRange.end(0),
                end: audioRange.end(0)
            };
             // find a gap in muxed content.
        } else {
            const nextRange = $86defbb4e95ebb07$var$findNextRange(videoBuffered, currentTime); // Even if there is no available next range, there is still a possibility we are
            // stuck in a gap due to video underflow.
            if (!nextRange.length) gap = this.gapFromVideoUnderflow_(videoBuffered, currentTime);
        }
        if (gap) {
            this.logger_(`Encountered a gap in video from ${gap.start} to ${gap.end}. ` + `Seeking to current time ${currentTime}`);
            return true;
        }
        return false;
    }
    /**
   * Timer callback. If playback still has not proceeded, then we seek
   * to the start of the next buffered region.
   *
   * @private
   */ skipTheGap_(scheduledCurrentTime) {
        const buffered = this.tech_.buffered();
        const currentTime = this.tech_.currentTime();
        const nextRange = $86defbb4e95ebb07$var$findNextRange(buffered, currentTime);
        this.resetTimeUpdate_();
        if (nextRange.length === 0 || currentTime !== scheduledCurrentTime) return;
        this.logger_('skipTheGap_:', 'currentTime:', currentTime, 'scheduled currentTime:', scheduledCurrentTime, 'nextRange start:', nextRange.start(0)); // only seek if we still have not played
        this.tech_.setCurrentTime(nextRange.start(0) + $86defbb4e95ebb07$var$TIME_FUDGE_FACTOR);
        const metadata = {
            gapInfo: {
                from: currentTime,
                to: nextRange.start(0)
            }
        };
        this.playlistController_.trigger({
            type: 'gapjumped',
            metadata: metadata
        });
        this.tech_.trigger({
            type: 'usage',
            name: 'vhs-gap-skip'
        });
    }
    gapFromVideoUnderflow_(buffered, currentTime) {
        // At least in Chrome, if there is a gap in the video buffer, the audio will continue
        // playing for ~3 seconds after the video gap starts. This is done to account for
        // video buffer underflow/underrun (note that this is not done when there is audio
        // buffer underflow/underrun -- in that case the video will stop as soon as it
        // encounters the gap, as audio stalls are more noticeable/jarring to a user than
        // video stalls). The player's time will reflect the playthrough of audio, so the
        // time will appear as if we are in a buffered region, even if we are stuck in a
        // "gap."
        //
        // Example:
        // video buffer:   0 => 10.1, 10.2 => 20
        // audio buffer:   0 => 20
        // overall buffer: 0 => 10.1, 10.2 => 20
        // current time: 13
        //
        // Chrome's video froze at 10 seconds, where the video buffer encountered the gap,
        // however, the audio continued playing until it reached ~3 seconds past the gap
        // (13 seconds), at which point it stops as well. Since current time is past the
        // gap, findNextRange will return no ranges.
        //
        // To check for this issue, we see if there is a gap that starts somewhere within
        // a 3 second range (3 seconds +/- 1 second) back from our current time.
        const gaps = $86defbb4e95ebb07$var$findGaps(buffered);
        for(let i = 0; i < gaps.length; i++){
            const start = gaps.start(i);
            const end = gaps.end(i); // gap is starts no more than 4 seconds back
            if (currentTime - start < 4 && currentTime - start > 2) return {
                start: start,
                end: end
            };
        }
        return null;
    }
}
const $86defbb4e95ebb07$var$defaultOptions = {
    errorInterval: 30,
    getSource (next) {
        const tech = this.tech({
            IWillNotUseThisInPlugins: true
        });
        const sourceObj = tech.currentSource_ || this.currentSource();
        return next(sourceObj);
    }
};
/**
 * Main entry point for the plugin
 *
 * @param {Player} player a reference to a videojs Player instance
 * @param {Object} [options] an object with plugin options
 * @private
 */ const $86defbb4e95ebb07$var$initPlugin = function(player, options) {
    let lastCalled = 0;
    let seekTo = 0;
    const localOptions = $86defbb4e95ebb07$var$merge($86defbb4e95ebb07$var$defaultOptions, options);
    player.ready(()=>{
        player.trigger({
            type: 'usage',
            name: 'vhs-error-reload-initialized'
        });
    });
    /**
   * Player modifications to perform that must wait until `loadedmetadata`
   * has been triggered
   *
   * @private
   */ const loadedMetadataHandler = function() {
        if (seekTo) player.currentTime(seekTo);
    };
    /**
   * Set the source on the player element, play, and seek if necessary
   *
   * @param {Object} sourceObj An object specifying the source url and mime-type to play
   * @private
   */ const setSource = function(sourceObj) {
        if (sourceObj === null || sourceObj === undefined) return;
        seekTo = player.duration() !== Infinity && player.currentTime() || 0;
        player.one('loadedmetadata', loadedMetadataHandler);
        player.src(sourceObj);
        player.trigger({
            type: 'usage',
            name: 'vhs-error-reload'
        });
        player.play();
    };
    /**
   * Attempt to get a source from either the built-in getSource function
   * or a custom function provided via the options
   *
   * @private
   */ const errorHandler = function() {
        // Do not attempt to reload the source if a source-reload occurred before
        // 'errorInterval' time has elapsed since the last source-reload
        if (Date.now() - lastCalled < localOptions.errorInterval * 1000) {
            player.trigger({
                type: 'usage',
                name: 'vhs-error-reload-canceled'
            });
            return;
        }
        if (!localOptions.getSource || typeof localOptions.getSource !== 'function') {
            $86defbb4e95ebb07$export$2e2bcd8739ae039.log.error('ERROR: reloadSourceOnError - The option getSource must be a function!');
            return;
        }
        lastCalled = Date.now();
        return localOptions.getSource.call(player, setSource);
    };
    /**
   * Unbind any event handlers that were bound by the plugin
   *
   * @private
   */ const cleanupEvents = function() {
        player.off('loadedmetadata', loadedMetadataHandler);
        player.off('error', errorHandler);
        player.off('dispose', cleanupEvents);
    };
    /**
   * Cleanup before re-initializing the plugin
   *
   * @param {Object} [newOptions] an object with plugin options
   * @private
   */ const reinitPlugin = function(newOptions) {
        cleanupEvents();
        $86defbb4e95ebb07$var$initPlugin(player, newOptions);
    };
    player.on('error', errorHandler);
    player.on('dispose', cleanupEvents); // Overwrite the plugin function so that we can correctly cleanup before
    // initializing the plugin
    player.reloadSourceOnError = reinitPlugin;
};
/**
 * Reload the source when an error is detected as long as there
 * wasn't an error previously within the last 30 seconds
 *
 * @param {Object} [options] an object with plugin options
 */ const $86defbb4e95ebb07$var$reloadSourceOnError = function(options) {
    $86defbb4e95ebb07$var$initPlugin(this, options);
};
var $86defbb4e95ebb07$var$version$4 = "3.17.5";
var $86defbb4e95ebb07$var$version$3 = "7.1.0";
var $86defbb4e95ebb07$var$version$2 = "1.4.0";
var $86defbb4e95ebb07$var$version$1 = "7.2.0";
var $86defbb4e95ebb07$var$version = "4.0.2";
const $86defbb4e95ebb07$var$Vhs = {
    PlaylistLoader: $86defbb4e95ebb07$var$PlaylistLoader,
    Playlist: $86defbb4e95ebb07$var$Playlist,
    utils: $86defbb4e95ebb07$var$utils,
    STANDARD_PLAYLIST_SELECTOR: $86defbb4e95ebb07$var$lastBandwidthSelector,
    INITIAL_PLAYLIST_SELECTOR: $86defbb4e95ebb07$var$lowestBitrateCompatibleVariantSelector,
    lastBandwidthSelector: $86defbb4e95ebb07$var$lastBandwidthSelector,
    movingAverageBandwidthSelector: $86defbb4e95ebb07$var$movingAverageBandwidthSelector,
    comparePlaylistBandwidth: $86defbb4e95ebb07$var$comparePlaylistBandwidth,
    comparePlaylistResolution: $86defbb4e95ebb07$var$comparePlaylistResolution,
    xhr: $86defbb4e95ebb07$var$xhrFactory()
}; // Define getter/setters for config properties
Object.keys($86defbb4e95ebb07$var$Config).forEach((prop)=>{
    Object.defineProperty($86defbb4e95ebb07$var$Vhs, prop, {
        get () {
            $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn(`using Vhs.${prop} is UNSAFE be sure you know what you are doing`);
            return $86defbb4e95ebb07$var$Config[prop];
        },
        set (value) {
            $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn(`using Vhs.${prop} is UNSAFE be sure you know what you are doing`);
            if (typeof value !== 'number' || value < 0) {
                $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn(`value of Vhs.${prop} must be greater than or equal to 0`);
                return;
            }
            $86defbb4e95ebb07$var$Config[prop] = value;
        }
    });
});
const $86defbb4e95ebb07$var$LOCAL_STORAGE_KEY = 'videojs-vhs';
/**
 * Updates the selectedIndex of the QualityLevelList when a mediachange happens in vhs.
 *
 * @param {QualityLevelList} qualityLevels The QualityLevelList to update.
 * @param {PlaylistLoader} playlistLoader PlaylistLoader containing the new media info.
 * @function handleVhsMediaChange
 */ const $86defbb4e95ebb07$var$handleVhsMediaChange = function(qualityLevels, playlistLoader) {
    const newPlaylist = playlistLoader.media();
    let selectedIndex = -1;
    for(let i = 0; i < qualityLevels.length; i++)if (qualityLevels[i].id === newPlaylist.id) {
        selectedIndex = i;
        break;
    }
    qualityLevels.selectedIndex_ = selectedIndex;
    qualityLevels.trigger({
        selectedIndex: selectedIndex,
        type: 'change'
    });
};
/**
 * Adds quality levels to list once playlist metadata is available
 *
 * @param {QualityLevelList} qualityLevels The QualityLevelList to attach events to.
 * @param {Object} vhs Vhs object to listen to for media events.
 * @function handleVhsLoadedMetadata
 */ const $86defbb4e95ebb07$var$handleVhsLoadedMetadata = function(qualityLevels, vhs) {
    vhs.representations().forEach((rep)=>{
        qualityLevels.addQualityLevel(rep);
    });
    $86defbb4e95ebb07$var$handleVhsMediaChange(qualityLevels, vhs.playlists);
}; // VHS is a source handler, not a tech. Make sure attempts to use it
// as one do not cause exceptions.
$86defbb4e95ebb07$var$Vhs.canPlaySource = function() {
    return $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
const $86defbb4e95ebb07$var$emeKeySystems = (keySystemOptions, mainPlaylist, audioPlaylist)=>{
    if (!keySystemOptions) return keySystemOptions;
    let codecs = {};
    if (mainPlaylist && mainPlaylist.attributes && mainPlaylist.attributes.CODECS) codecs = $86defbb4e95ebb07$var$unwrapCodecList((0, $34bf5acfb37ee851$export$56679b562aa2891c)(mainPlaylist.attributes.CODECS));
    if (audioPlaylist && audioPlaylist.attributes && audioPlaylist.attributes.CODECS) codecs.audio = audioPlaylist.attributes.CODECS;
    const videoContentType = (0, $34bf5acfb37ee851$export$4b64fc0a026b9981)(codecs.video);
    const audioContentType = (0, $34bf5acfb37ee851$export$4b64fc0a026b9981)(codecs.audio); // upsert the content types based on the selected playlist
    const keySystemContentTypes = {};
    for(const keySystem in keySystemOptions){
        keySystemContentTypes[keySystem] = {};
        if (audioContentType) keySystemContentTypes[keySystem].audioContentType = audioContentType;
        if (videoContentType) keySystemContentTypes[keySystem].videoContentType = videoContentType;
         // Default to using the video playlist's PSSH even though they may be different, as
        // videojs-contrib-eme will only accept one in the options.
        //
        // This shouldn't be an issue for most cases as early intialization will handle all
        // unique PSSH values, and if they aren't, then encrypted events should have the
        // specific information needed for the unique license.
        if (mainPlaylist.contentProtection && mainPlaylist.contentProtection[keySystem] && mainPlaylist.contentProtection[keySystem].pssh) keySystemContentTypes[keySystem].pssh = mainPlaylist.contentProtection[keySystem].pssh;
         // videojs-contrib-eme accepts the option of specifying: 'com.some.cdm': 'url'
        // so we need to prevent overwriting the URL entirely
        if (typeof keySystemOptions[keySystem] === 'string') keySystemContentTypes[keySystem].url = keySystemOptions[keySystem];
    }
    return $86defbb4e95ebb07$var$merge(keySystemOptions, keySystemContentTypes);
};
/**
 * @typedef {Object} KeySystems
 *
 * keySystems configuration for https://github.com/videojs/videojs-contrib-eme
 * Note: not all options are listed here.
 *
 * @property {Uint8Array} [pssh]
 *           Protection System Specific Header
 */ /**
 * Goes through all the playlists and collects an array of KeySystems options objects
 * containing each playlist's keySystems and their pssh values, if available.
 *
 * @param {Object[]} playlists
 *        The playlists to look through
 * @param {string[]} keySystems
 *        The keySystems to collect pssh values for
 *
 * @return {KeySystems[]}
 *         An array of KeySystems objects containing available key systems and their
 *         pssh values
 */ const $86defbb4e95ebb07$var$getAllPsshKeySystemsOptions = (playlists, keySystems)=>{
    return playlists.reduce((keySystemsArr, playlist)=>{
        if (!playlist.contentProtection) return keySystemsArr;
        const keySystemsOptions = keySystems.reduce((keySystemsObj, keySystem)=>{
            const keySystemOptions = playlist.contentProtection[keySystem];
            if (keySystemOptions && keySystemOptions.pssh) keySystemsObj[keySystem] = {
                pssh: keySystemOptions.pssh
            };
            return keySystemsObj;
        }, {});
        if (Object.keys(keySystemsOptions).length) keySystemsArr.push(keySystemsOptions);
        return keySystemsArr;
    }, []);
};
/**
 * Returns a promise that waits for the
 * [eme plugin](https://github.com/videojs/videojs-contrib-eme) to create a key session.
 *
 * Works around https://bugs.chromium.org/p/chromium/issues/detail?id=895449 in non-IE11
 * browsers.
 *
 * As per the above ticket, this is particularly important for Chrome, where, if
 * unencrypted content is appended before encrypted content and the key session has not
 * been created, a MEDIA_ERR_DECODE will be thrown once the encrypted content is reached
 * during playback.
 *
 * @param {Object} player
 *        The player instance
 * @param {Object[]} sourceKeySystems
 *        The key systems options from the player source
 * @param {Object} [audioMedia]
 *        The active audio media playlist (optional)
 * @param {Object[]} mainPlaylists
 *        The playlists found on the main playlist object
 *
 * @return {Object}
 *         Promise that resolves when the key session has been created
 */ const $86defbb4e95ebb07$var$waitForKeySessionCreation = ({ player: player, sourceKeySystems: sourceKeySystems, audioMedia: audioMedia, mainPlaylists: mainPlaylists })=>{
    if (!player.eme.initializeMediaKeys) return Promise.resolve();
     // TODO should all audio PSSH values be initialized for DRM?
    //
    // All unique video rendition pssh values are initialized for DRM, but here only
    // the initial audio playlist license is initialized. In theory, an encrypted
    // event should be fired if the user switches to an alternative audio playlist
    // where a license is required, but this case hasn't yet been tested. In addition, there
    // may be many alternate audio playlists unlikely to be used (e.g., multiple different
    // languages).
    const playlists = audioMedia ? mainPlaylists.concat([
        audioMedia
    ]) : mainPlaylists;
    const keySystemsOptionsArr = $86defbb4e95ebb07$var$getAllPsshKeySystemsOptions(playlists, Object.keys(sourceKeySystems));
    const initializationFinishedPromises = [];
    const keySessionCreatedPromises = []; // Since PSSH values are interpreted as initData, EME will dedupe any duplicates. The
    // only place where it should not be deduped is for ms-prefixed APIs, but
    // the existence of modern EME APIs in addition to
    // ms-prefixed APIs on Edge should prevent this from being a concern.
    // initializeMediaKeys also won't use the webkit-prefixed APIs.
    keySystemsOptionsArr.forEach((keySystemsOptions)=>{
        keySessionCreatedPromises.push(new Promise((resolve, reject)=>{
            player.tech_.one('keysessioncreated', resolve);
        }));
        initializationFinishedPromises.push(new Promise((resolve, reject)=>{
            player.eme.initializeMediaKeys({
                keySystems: keySystemsOptions
            }, (err)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve();
            });
        }));
    }); // The reasons Promise.race is chosen over Promise.any:
    //
    // * Promise.any is only available in Safari 14+.
    // * None of these promises are expected to reject. If they do reject, it might be
    //   better here for the race to surface the rejection, rather than mask it by using
    //   Promise.any.
    return Promise.race([
        // If a session was previously created, these will all finish resolving without
        // creating a new session, otherwise it will take until the end of all license
        // requests, which is why the key session check is used (to make setup much faster).
        Promise.all(initializationFinishedPromises),
        // Once a single session is created, the browser knows DRM will be used.
        Promise.race(keySessionCreatedPromises)
    ]);
};
/**
 * If the [eme](https://github.com/videojs/videojs-contrib-eme) plugin is available, and
 * there are keySystems on the source, sets up source options to prepare the source for
 * eme.
 *
 * @param {Object} player
 *        The player instance
 * @param {Object[]} sourceKeySystems
 *        The key systems options from the player source
 * @param {Object} media
 *        The active media playlist
 * @param {Object} [audioMedia]
 *        The active audio media playlist (optional)
 *
 * @return {boolean}
 *         Whether or not options were configured and EME is available
 */ const $86defbb4e95ebb07$var$setupEmeOptions = ({ player: player, sourceKeySystems: sourceKeySystems, media: media, audioMedia: audioMedia })=>{
    const sourceOptions = $86defbb4e95ebb07$var$emeKeySystems(sourceKeySystems, media, audioMedia);
    if (!sourceOptions) return false;
    player.currentSource().keySystems = sourceOptions; // eme handles the rest of the setup, so if it is missing
    // do nothing.
    if (sourceOptions && !player.eme) {
        $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn('DRM encrypted source cannot be decrypted without a DRM plugin');
        return false;
    }
    return true;
};
const $86defbb4e95ebb07$var$getVhsLocalStorage = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).localStorage) return null;
    const storedObject = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).localStorage.getItem($86defbb4e95ebb07$var$LOCAL_STORAGE_KEY);
    if (!storedObject) return null;
    try {
        return JSON.parse(storedObject);
    } catch (e) {
        // someone may have tampered with the value
        return null;
    }
};
const $86defbb4e95ebb07$var$updateVhsLocalStorage = (options)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).localStorage) return false;
    let objectToStore = $86defbb4e95ebb07$var$getVhsLocalStorage();
    objectToStore = objectToStore ? $86defbb4e95ebb07$var$merge(objectToStore, options) : options;
    try {
        (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).localStorage.setItem($86defbb4e95ebb07$var$LOCAL_STORAGE_KEY, JSON.stringify(objectToStore));
    } catch (e) {
        // Throws if storage is full (e.g., always on iOS 5+ Safari private mode, where
        // storage is set to 0).
        // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem#Exceptions
        // No need to perform any operation.
        return false;
    }
    return objectToStore;
};
/**
 * Parses VHS-supported media types from data URIs. See
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
 * for information on data URIs.
 *
 * @param {string} dataUri
 *        The data URI
 *
 * @return {string|Object}
 *         The parsed object/string, or the original string if no supported media type
 *         was found
 */ const $86defbb4e95ebb07$var$expandDataUri = (dataUri)=>{
    if (dataUri.toLowerCase().indexOf('data:application/vnd.videojs.vhs+json,') === 0) return JSON.parse(dataUri.substring(dataUri.indexOf(',') + 1));
     // no known case for this data URI, return the string as-is
    return dataUri;
};
/**
 * Adds a request hook to an xhr object
 *
 * @param {Object} xhr object to add the onRequest hook to
 * @param {function} callback hook function for an xhr request
 */ const $86defbb4e95ebb07$var$addOnRequestHook = (xhr, callback)=>{
    if (!xhr._requestCallbackSet) xhr._requestCallbackSet = new Set();
    xhr._requestCallbackSet.add(callback);
};
/**
 * Adds a response hook to an xhr object
 *
 * @param {Object} xhr object to add the onResponse hook to
 * @param {function} callback hook function for an xhr response
 */ const $86defbb4e95ebb07$var$addOnResponseHook = (xhr, callback)=>{
    if (!xhr._responseCallbackSet) xhr._responseCallbackSet = new Set();
    xhr._responseCallbackSet.add(callback);
};
/**
 * Removes a request hook on an xhr object, deletes the onRequest set if empty.
 *
 * @param {Object} xhr object to remove the onRequest hook from
 * @param {function} callback hook function to remove
 */ const $86defbb4e95ebb07$var$removeOnRequestHook = (xhr, callback)=>{
    if (!xhr._requestCallbackSet) return;
    xhr._requestCallbackSet.delete(callback);
    if (!xhr._requestCallbackSet.size) delete xhr._requestCallbackSet;
};
/**
 * Removes a response hook on an xhr object, deletes the onResponse set if empty.
 *
 * @param {Object} xhr object to remove the onResponse hook from
 * @param {function} callback hook function to remove
 */ const $86defbb4e95ebb07$var$removeOnResponseHook = (xhr, callback)=>{
    if (!xhr._responseCallbackSet) return;
    xhr._responseCallbackSet.delete(callback);
    if (!xhr._responseCallbackSet.size) delete xhr._responseCallbackSet;
};
/**
 * Whether the browser has built-in HLS support.
 */ $86defbb4e95ebb07$var$Vhs.supportsNativeHls = function() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($01r8O))) || !(0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement) return false;
    const video = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('video'); // native HLS is definitely not supported if HTML5 video isn't
    if (!$86defbb4e95ebb07$export$2e2bcd8739ae039.getTech('Html5').isSupported()) return false;
     // HLS manifests can go by many mime-types
    const canPlay = [
        // Apple santioned
        'application/vnd.apple.mpegurl',
        // Apple sanctioned for backwards compatibility
        'audio/mpegurl',
        // Very common
        'audio/x-mpegurl',
        // Very common
        'application/x-mpegurl',
        // Included for completeness
        'video/x-mpegurl',
        'video/mpegurl',
        'application/mpegurl'
    ];
    return canPlay.some(function(canItPlay) {
        return /maybe|probably/i.test(video.canPlayType(canItPlay));
    });
}();
$86defbb4e95ebb07$var$Vhs.supportsNativeDash = function() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($01r8O))) || !(0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement || !$86defbb4e95ebb07$export$2e2bcd8739ae039.getTech('Html5').isSupported()) return false;
    return /maybe|probably/i.test((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).createElement('video').canPlayType('application/dash+xml'));
}();
$86defbb4e95ebb07$var$Vhs.supportsTypeNatively = (type)=>{
    if (type === 'hls') return $86defbb4e95ebb07$var$Vhs.supportsNativeHls;
    if (type === 'dash') return $86defbb4e95ebb07$var$Vhs.supportsNativeDash;
    return false;
};
/**
 * VHS is a source handler, not a tech. Make sure attempts to use it
 * as one do not cause exceptions.
 */ $86defbb4e95ebb07$var$Vhs.isSupported = function() {
    return $86defbb4e95ebb07$export$2e2bcd8739ae039.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
/**
 * A global function for setting an onRequest hook
 *
 * @param {function} callback for request modifiction
 */ $86defbb4e95ebb07$var$Vhs.xhr.onRequest = function(callback) {
    $86defbb4e95ebb07$var$addOnRequestHook($86defbb4e95ebb07$var$Vhs.xhr, callback);
};
/**
 * A global function for setting an onResponse hook
 *
 * @param {callback} callback for response data retrieval
 */ $86defbb4e95ebb07$var$Vhs.xhr.onResponse = function(callback) {
    $86defbb4e95ebb07$var$addOnResponseHook($86defbb4e95ebb07$var$Vhs.xhr, callback);
};
/**
 * Deletes a global onRequest callback if it exists
 *
 * @param {function} callback to delete from the global set
 */ $86defbb4e95ebb07$var$Vhs.xhr.offRequest = function(callback) {
    $86defbb4e95ebb07$var$removeOnRequestHook($86defbb4e95ebb07$var$Vhs.xhr, callback);
};
/**
 * Deletes a global onResponse callback if it exists
 *
 * @param {function} callback to delete from the global set
 */ $86defbb4e95ebb07$var$Vhs.xhr.offResponse = function(callback) {
    $86defbb4e95ebb07$var$removeOnResponseHook($86defbb4e95ebb07$var$Vhs.xhr, callback);
};
const $86defbb4e95ebb07$var$Component = $86defbb4e95ebb07$export$2e2bcd8739ae039.getComponent('Component');
/**
 * The Vhs Handler object, where we orchestrate all of the parts
 * of VHS to interact with video.js
 *
 * @class VhsHandler
 * @extends videojs.Component
 * @param {Object} source the soruce object
 * @param {Tech} tech the parent tech object
 * @param {Object} options optional and required options
 */ class $86defbb4e95ebb07$var$VhsHandler extends $86defbb4e95ebb07$var$Component {
    constructor(source, tech, options){
        super(tech, options.vhs); // if a tech level `initialBandwidth` option was passed
        // use that over the VHS level `bandwidth` option
        if (typeof options.initialBandwidth === 'number') this.options_.bandwidth = options.initialBandwidth;
        this.logger_ = $86defbb4e95ebb07$var$logger('VhsHandler'); // we need access to the player in some cases,
        // so, get it from Video.js via the `playerId`
        if (tech.options_ && tech.options_.playerId) {
            const _player = $86defbb4e95ebb07$export$2e2bcd8739ae039.getPlayer(tech.options_.playerId);
            this.player_ = _player;
        }
        this.tech_ = tech;
        this.source_ = source;
        this.stats = {};
        this.ignoreNextSeekingEvent_ = false;
        this.setOptions_();
        if (this.options_.overrideNative && tech.overrideNativeAudioTracks && tech.overrideNativeVideoTracks) {
            tech.overrideNativeAudioTracks(true);
            tech.overrideNativeVideoTracks(true);
        } else if (this.options_.overrideNative && (tech.featuresNativeVideoTracks || tech.featuresNativeAudioTracks)) // overriding native VHS only works if audio tracks have been emulated
        // error early if we're misconfigured
        throw new Error("Overriding native VHS requires emulated tracks. See https://git.io/vMpjB");
         // listen for fullscreenchange events for this player so that we
        // can adjust our quality selection quickly
        this.on((0, (/*@__PURE__*/$parcel$interopDefault($01r8O))), [
            'fullscreenchange',
            'webkitfullscreenchange',
            'mozfullscreenchange',
            'MSFullscreenChange'
        ], (event)=>{
            const fullscreenElement = (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).fullscreenElement || (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).webkitFullscreenElement || (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).mozFullScreenElement || (0, (/*@__PURE__*/$parcel$interopDefault($01r8O))).msFullscreenElement;
            if (fullscreenElement && fullscreenElement.contains(this.tech_.el())) this.playlistController_.fastQualityChange_();
            else // When leaving fullscreen, since the in page pixel dimensions should be smaller
            // than full screen, see if there should be a rendition switch down to preserve
            // bandwidth.
            this.playlistController_.checkABR_();
        });
        this.on(this.tech_, 'seeking', function() {
            if (this.ignoreNextSeekingEvent_) {
                this.ignoreNextSeekingEvent_ = false;
                return;
            }
            this.setCurrentTime(this.tech_.currentTime());
        });
        this.on(this.tech_, 'error', function() {
            // verify that the error was real and we are loaded
            // enough to have pc loaded.
            if (this.tech_.error() && this.playlistController_) this.playlistController_.pauseLoading();
        });
        this.on(this.tech_, 'play', this.play);
    }
    /**
   * Set VHS options based on options from configuration, as well as partial
   * options to be passed at a later time.
   *
   * @param {Object} options A partial chunk of config options
   */ setOptions_(options = {}) {
        this.options_ = $86defbb4e95ebb07$var$merge(this.options_, options); // defaults
        this.options_.withCredentials = this.options_.withCredentials || false;
        this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions === false ? false : true;
        this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || false;
        this.options_.usePlayerObjectFit = this.options_.usePlayerObjectFit || false;
        this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage !== 'undefined' ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || false;
        this.options_.useForcedSubtitles = this.options_.useForcedSubtitles || false;
        this.options_.useNetworkInformationApi = typeof this.options_.useNetworkInformationApi !== 'undefined' ? this.options_.useNetworkInformationApi : true;
        this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || false;
        this.options_.customTagParsers = this.options_.customTagParsers || [];
        this.options_.customTagMappers = this.options_.customTagMappers || [];
        this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || false;
        this.options_.llhls = this.options_.llhls === false ? false : true;
        this.options_.bufferBasedABR = this.options_.bufferBasedABR || false;
        if (typeof this.options_.playlistExclusionDuration !== 'number') this.options_.playlistExclusionDuration = 60;
        if (typeof this.options_.bandwidth !== 'number') {
            if (this.options_.useBandwidthFromLocalStorage) {
                const storedObject = $86defbb4e95ebb07$var$getVhsLocalStorage();
                if (storedObject && storedObject.bandwidth) {
                    this.options_.bandwidth = storedObject.bandwidth;
                    this.tech_.trigger({
                        type: 'usage',
                        name: 'vhs-bandwidth-from-local-storage'
                    });
                }
                if (storedObject && storedObject.throughput) {
                    this.options_.throughput = storedObject.throughput;
                    this.tech_.trigger({
                        type: 'usage',
                        name: 'vhs-throughput-from-local-storage'
                    });
                }
            }
        } // if bandwidth was not set by options or pulled from local storage, start playlist
        // selection at a reasonable bandwidth
        if (typeof this.options_.bandwidth !== 'number') this.options_.bandwidth = $86defbb4e95ebb07$var$Config.INITIAL_BANDWIDTH;
         // If the bandwidth number is unchanged from the initial setting
        // then this takes precedence over the enableLowInitialPlaylist option
        this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === $86defbb4e95ebb07$var$Config.INITIAL_BANDWIDTH; // grab options passed to player.src
        [
            'withCredentials',
            'useDevicePixelRatio',
            'usePlayerObjectFit',
            'customPixelRatio',
            'limitRenditionByPlayerDimensions',
            'bandwidth',
            'customTagParsers',
            'customTagMappers',
            'cacheEncryptionKeys',
            'playlistSelector',
            'initialPlaylistSelector',
            'bufferBasedABR',
            'liveRangeSafeTimeDelta',
            'llhls',
            'useForcedSubtitles',
            'useNetworkInformationApi',
            'useDtsForTimestampOffset',
            'exactManifestTimings',
            'leastPixelDiffSelector'
        ].forEach((option)=>{
            if (typeof this.source_[option] !== 'undefined') this.options_[option] = this.source_[option];
        });
        this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions;
        this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
        this.usePlayerObjectFit = this.options_.usePlayerObjectFit;
        const customPixelRatio = this.options_.customPixelRatio; // Ensure the custom pixel ratio is a number greater than or equal to 0
        if (typeof customPixelRatio === 'number' && customPixelRatio >= 0) this.customPixelRatio = customPixelRatio;
    }
    setOptions(options = {}) {
        this.setOptions_(options);
    }
    /**
   * called when player.src gets called, handle a new source
   *
   * @param {Object} src the source object to handle
   */ src(src, type) {
        // do nothing if the src is falsey
        if (!src) return;
        this.setOptions_(); // add main playlist controller options
        this.options_.src = $86defbb4e95ebb07$var$expandDataUri(this.source_.src);
        this.options_.tech = this.tech_;
        this.options_.externVhs = $86defbb4e95ebb07$var$Vhs;
        this.options_.sourceType = (0, $fd4a1d4c2e8fc2b7$export$c4f0bf48244d4c05)(type); // Whenever we seek internally, we should update the tech
        this.options_.seekTo = (time)=>{
            this.tech_.setCurrentTime(time);
        }; // pass player to allow for player level eventing on construction.
        this.options_.player_ = this.player_;
        this.playlistController_ = new $86defbb4e95ebb07$var$PlaylistController(this.options_);
        const playbackWatcherOptions = $86defbb4e95ebb07$var$merge({
            liveRangeSafeTimeDelta: $86defbb4e95ebb07$var$SAFE_TIME_DELTA
        }, this.options_, {
            seekable: ()=>this.seekable(),
            media: ()=>this.playlistController_.media(),
            playlistController: this.playlistController_
        });
        this.playbackWatcher_ = new $86defbb4e95ebb07$var$PlaybackWatcher(playbackWatcherOptions);
        this.attachStreamingEventListeners_();
        this.playlistController_.on('error', ()=>{
            const player = $86defbb4e95ebb07$export$2e2bcd8739ae039.players[this.tech_.options_.playerId];
            let error = this.playlistController_.error;
            if (typeof error === 'object' && !error.code) error.code = 3;
            else if (typeof error === 'string') error = {
                message: error,
                code: 3
            };
            player.error(error);
        });
        const defaultSelector = this.options_.bufferBasedABR ? $86defbb4e95ebb07$var$Vhs.movingAverageBandwidthSelector(0.55) : $86defbb4e95ebb07$var$Vhs.STANDARD_PLAYLIST_SELECTOR; // `this` in selectPlaylist should be the VhsHandler for backwards
        // compatibility with < v2
        this.playlistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : defaultSelector.bind(this);
        this.playlistController_.selectInitialPlaylist = $86defbb4e95ebb07$var$Vhs.INITIAL_PLAYLIST_SELECTOR.bind(this); // re-expose some internal objects for backwards compatibility with < v2
        this.playlists = this.playlistController_.mainPlaylistLoader_;
        this.mediaSource = this.playlistController_.mediaSource; // Proxy assignment of some properties to the main playlist
        // controller. Using a custom property for backwards compatibility
        // with < v2
        Object.defineProperties(this, {
            selectPlaylist: {
                get () {
                    return this.playlistController_.selectPlaylist;
                },
                set (selectPlaylist) {
                    this.playlistController_.selectPlaylist = selectPlaylist.bind(this);
                }
            },
            throughput: {
                get () {
                    return this.playlistController_.mainSegmentLoader_.throughput.rate;
                },
                set (throughput) {
                    this.playlistController_.mainSegmentLoader_.throughput.rate = throughput; // By setting `count` to 1 the throughput value becomes the starting value
                    // for the cumulative average
                    this.playlistController_.mainSegmentLoader_.throughput.count = 1;
                }
            },
            bandwidth: {
                get () {
                    let playerBandwidthEst = this.playlistController_.mainSegmentLoader_.bandwidth;
                    const networkInformation = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).navigator.connection || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).navigator.mozConnection || (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).navigator.webkitConnection;
                    const tenMbpsAsBitsPerSecond = 10e6;
                    if (this.options_.useNetworkInformationApi && networkInformation) {
                        // downlink returns Mbps
                        // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/downlink
                        const networkInfoBandwidthEstBitsPerSec = networkInformation.downlink * 1000000; // downlink maxes out at 10 Mbps. In the event that both networkInformationApi and the player
                        // estimate a bandwidth greater than 10 Mbps, use the larger of the two estimates to ensure that
                        // high quality streams are not filtered out.
                        if (networkInfoBandwidthEstBitsPerSec >= tenMbpsAsBitsPerSecond && playerBandwidthEst >= tenMbpsAsBitsPerSecond) playerBandwidthEst = Math.max(playerBandwidthEst, networkInfoBandwidthEstBitsPerSec);
                        else playerBandwidthEst = networkInfoBandwidthEstBitsPerSec;
                    }
                    return playerBandwidthEst;
                },
                set (bandwidth) {
                    this.playlistController_.mainSegmentLoader_.bandwidth = bandwidth; // setting the bandwidth manually resets the throughput counter
                    // `count` is set to zero that current value of `rate` isn't included
                    // in the cumulative average
                    this.playlistController_.mainSegmentLoader_.throughput = {
                        rate: 0,
                        count: 0
                    };
                }
            },
            /**
       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
       * the entire process after that - decryption, transmuxing, and appending - provided
       * by `throughput`.
       *
       * Since the two process are serial, the overall system bandwidth is given by:
       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
       */ systemBandwidth: {
                get () {
                    const invBandwidth = 1 / (this.bandwidth || 1);
                    let invThroughput;
                    if (this.throughput > 0) invThroughput = 1 / this.throughput;
                    else invThroughput = 0;
                    const systemBitrate = Math.floor(1 / (invBandwidth + invThroughput));
                    return systemBitrate;
                },
                set () {
                    $86defbb4e95ebb07$export$2e2bcd8739ae039.log.error('The "systemBandwidth" property is read-only');
                }
            }
        });
        if (this.options_.bandwidth) this.bandwidth = this.options_.bandwidth;
        if (this.options_.throughput) this.throughput = this.options_.throughput;
        Object.defineProperties(this.stats, {
            bandwidth: {
                get: ()=>this.bandwidth || 0,
                enumerable: true
            },
            mediaRequests: {
                get: ()=>this.playlistController_.mediaRequests_() || 0,
                enumerable: true
            },
            mediaRequestsAborted: {
                get: ()=>this.playlistController_.mediaRequestsAborted_() || 0,
                enumerable: true
            },
            mediaRequestsTimedout: {
                get: ()=>this.playlistController_.mediaRequestsTimedout_() || 0,
                enumerable: true
            },
            mediaRequestsErrored: {
                get: ()=>this.playlistController_.mediaRequestsErrored_() || 0,
                enumerable: true
            },
            mediaTransferDuration: {
                get: ()=>this.playlistController_.mediaTransferDuration_() || 0,
                enumerable: true
            },
            mediaBytesTransferred: {
                get: ()=>this.playlistController_.mediaBytesTransferred_() || 0,
                enumerable: true
            },
            mediaSecondsLoaded: {
                get: ()=>this.playlistController_.mediaSecondsLoaded_() || 0,
                enumerable: true
            },
            mediaAppends: {
                get: ()=>this.playlistController_.mediaAppends_() || 0,
                enumerable: true
            },
            mainAppendsToLoadedData: {
                get: ()=>this.playlistController_.mainAppendsToLoadedData_() || 0,
                enumerable: true
            },
            audioAppendsToLoadedData: {
                get: ()=>this.playlistController_.audioAppendsToLoadedData_() || 0,
                enumerable: true
            },
            appendsToLoadedData: {
                get: ()=>this.playlistController_.appendsToLoadedData_() || 0,
                enumerable: true
            },
            timeToLoadedData: {
                get: ()=>this.playlistController_.timeToLoadedData_() || 0,
                enumerable: true
            },
            buffered: {
                get: ()=>$86defbb4e95ebb07$var$timeRangesToArray(this.tech_.buffered()),
                enumerable: true
            },
            currentTime: {
                get: ()=>this.tech_.currentTime(),
                enumerable: true
            },
            currentSource: {
                get: ()=>this.tech_.currentSource_,
                enumerable: true
            },
            currentTech: {
                get: ()=>this.tech_.name_,
                enumerable: true
            },
            duration: {
                get: ()=>this.tech_.duration(),
                enumerable: true
            },
            main: {
                get: ()=>this.playlists.main,
                enumerable: true
            },
            playerDimensions: {
                get: ()=>this.tech_.currentDimensions(),
                enumerable: true
            },
            seekable: {
                get: ()=>$86defbb4e95ebb07$var$timeRangesToArray(this.tech_.seekable()),
                enumerable: true
            },
            timestamp: {
                get: ()=>Date.now(),
                enumerable: true
            },
            videoPlaybackQuality: {
                get: ()=>this.tech_.getVideoPlaybackQuality(),
                enumerable: true
            }
        });
        this.tech_.one('canplay', this.playlistController_.setupFirstPlay.bind(this.playlistController_));
        this.tech_.on('bandwidthupdate', ()=>{
            if (this.options_.useBandwidthFromLocalStorage) $86defbb4e95ebb07$var$updateVhsLocalStorage({
                bandwidth: this.bandwidth,
                throughput: Math.round(this.throughput)
            });
        });
        this.playlistController_.on('selectedinitialmedia', ()=>{
            // Add the manual rendition mix-in to VhsHandler
            $86defbb4e95ebb07$var$renditionSelectionMixin(this);
        });
        this.playlistController_.sourceUpdater_.on('createdsourcebuffers', ()=>{
            this.setupEme_();
        }); // the bandwidth of the primary segment loader is our best
        // estimate of overall bandwidth
        this.on(this.playlistController_, 'progress', function() {
            this.tech_.trigger('progress');
        }); // In the live case, we need to ignore the very first `seeking` event since
        // that will be the result of the seek-to-live behavior
        this.on(this.playlistController_, 'firstplay', function() {
            this.ignoreNextSeekingEvent_ = true;
        });
        this.setupQualityLevels_(); // do nothing if the tech has been disposed already
        // this can occur if someone sets the src in player.ready(), for instance
        if (!this.tech_.el()) return;
        this.mediaSourceUrl_ = (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).URL.createObjectURL(this.playlistController_.mediaSource); // If we are playing HLS with MSE in Safari, add source elements for both the blob and manifest URLs.
        // The latter will enable Airplay playback on receiver devices.
        if (($86defbb4e95ebb07$export$2e2bcd8739ae039.browser.IS_ANY_SAFARI || $86defbb4e95ebb07$export$2e2bcd8739ae039.browser.IS_IOS) && this.options_.overrideNative && this.options_.sourceType === 'hls' && typeof this.tech_.addSourceElement === 'function') {
            this.tech_.addSourceElement(this.mediaSourceUrl_);
            this.tech_.addSourceElement(this.source_.src);
        } else this.tech_.src(this.mediaSourceUrl_);
    }
    createKeySessions_() {
        const audioPlaylistLoader = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
        this.logger_('waiting for EME key session creation');
        $86defbb4e95ebb07$var$waitForKeySessionCreation({
            player: this.player_,
            sourceKeySystems: this.source_.keySystems,
            audioMedia: audioPlaylistLoader && audioPlaylistLoader.media(),
            mainPlaylists: this.playlists.main.playlists
        }).then(()=>{
            this.logger_('created EME key session');
            this.playlistController_.sourceUpdater_.initializedEme();
        }).catch((err)=>{
            this.logger_('error while creating EME key session', err);
            this.player_.error({
                message: 'Failed to initialize media keys for EME',
                code: 3
            });
        });
    }
    handleWaitingForKey_() {
        // If waitingforkey is fired, it's possible that the data that's necessary to retrieve
        // the key is in the manifest. While this should've happened on initial source load, it
        // may happen again in live streams where the keys change, and the manifest info
        // reflects the update.
        //
        // Because videojs-contrib-eme compares the PSSH data we send to that of PSSH data it's
        // already requested keys for, we don't have to worry about this generating extraneous
        // requests.
        this.logger_('waitingforkey fired, attempting to create any new key sessions');
        this.createKeySessions_();
    }
    /**
   * If necessary and EME is available, sets up EME options and waits for key session
   * creation.
   *
   * This function also updates the source updater so taht it can be used, as for some
   * browsers, EME must be configured before content is appended (if appending unencrypted
   * content before encrypted content).
   */ setupEme_() {
        const audioPlaylistLoader = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
        const didSetupEmeOptions = $86defbb4e95ebb07$var$setupEmeOptions({
            player: this.player_,
            sourceKeySystems: this.source_.keySystems,
            media: this.playlists.media(),
            audioMedia: audioPlaylistLoader && audioPlaylistLoader.media()
        });
        this.player_.tech_.on('keystatuschange', (e)=>{
            this.playlistController_.updatePlaylistByKeyStatus(e.keyId, e.status);
        });
        this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this);
        this.player_.tech_.on('waitingforkey', this.handleWaitingForKey_);
        if (!didSetupEmeOptions) {
            // If EME options were not set up, we've done all we could to initialize EME.
            this.playlistController_.sourceUpdater_.initializedEme();
            return;
        }
        this.createKeySessions_();
    }
    /**
   * Initializes the quality levels and sets listeners to update them.
   *
   * @method setupQualityLevels_
   * @private
   */ setupQualityLevels_() {
        const player = $86defbb4e95ebb07$export$2e2bcd8739ae039.players[this.tech_.options_.playerId]; // if there isn't a player or there isn't a qualityLevels plugin
        // or qualityLevels_ listeners have already been setup, do nothing.
        if (!player || !player.qualityLevels || this.qualityLevels_) return;
        this.qualityLevels_ = player.qualityLevels();
        this.playlistController_.on('selectedinitialmedia', ()=>{
            $86defbb4e95ebb07$var$handleVhsLoadedMetadata(this.qualityLevels_, this);
        });
        this.playlists.on('mediachange', ()=>{
            $86defbb4e95ebb07$var$handleVhsMediaChange(this.qualityLevels_, this.playlists);
        });
    }
    /**
   * return the version
   */ static version() {
        return {
            '@videojs/http-streaming': $86defbb4e95ebb07$var$version$4,
            'mux.js': $86defbb4e95ebb07$var$version$3,
            'mpd-parser': $86defbb4e95ebb07$var$version$2,
            'm3u8-parser': $86defbb4e95ebb07$var$version$1,
            'aes-decrypter': $86defbb4e95ebb07$var$version
        };
    }
    /**
   * return the version
   */ version() {
        return this.constructor.version();
    }
    canChangeType() {
        return $86defbb4e95ebb07$var$SourceUpdater.canChangeType();
    }
    /**
   * Begin playing the video.
   */ play() {
        this.playlistController_.play();
    }
    /**
   * a wrapper around the function in PlaylistController
   */ setCurrentTime(currentTime) {
        this.playlistController_.setCurrentTime(currentTime);
    }
    /**
   * a wrapper around the function in PlaylistController
   */ duration() {
        return this.playlistController_.duration();
    }
    /**
   * a wrapper around the function in PlaylistController
   */ seekable() {
        return this.playlistController_.seekable();
    }
    /**
   * Abort all outstanding work and cleanup.
   */ dispose() {
        if (this.playbackWatcher_) this.playbackWatcher_.dispose();
        if (this.playlistController_) this.playlistController_.dispose();
        if (this.qualityLevels_) this.qualityLevels_.dispose();
        if (this.tech_ && this.tech_.vhs) delete this.tech_.vhs;
        if (this.mediaSourceUrl_ && (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).URL.revokeObjectURL) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hYfPi))).URL.revokeObjectURL(this.mediaSourceUrl_);
            this.mediaSourceUrl_ = null;
        }
        if (this.tech_) this.tech_.off('waitingforkey', this.handleWaitingForKey_);
        super.dispose();
    }
    convertToProgramTime(time, callback) {
        return $86defbb4e95ebb07$var$getProgramTime({
            playlist: this.playlistController_.media(),
            time: time,
            callback: callback
        });
    }
    seekToProgramTime(programTime, callback, pauseAfterSeek = true, retryCount = 2) {
        return $86defbb4e95ebb07$var$seekToProgramTime({
            programTime: programTime,
            playlist: this.playlistController_.media(),
            retryCount: retryCount,
            pauseAfterSeek: pauseAfterSeek,
            seekTo: this.options_.seekTo,
            tech: this.options_.tech,
            callback: callback
        });
    }
    /**
   * Adds the onRequest, onResponse, offRequest and offResponse functions
   * to the VhsHandler xhr Object.
   */ setupXhrHooks_() {
        /**
     * A player function for setting an onRequest hook
     *
     * @param {function} callback for request modifiction
     */ this.xhr.onRequest = (callback)=>{
            $86defbb4e95ebb07$var$addOnRequestHook(this.xhr, callback);
        };
        /**
     * A player function for setting an onResponse hook
     *
     * @param {callback} callback for response data retrieval
     */ this.xhr.onResponse = (callback)=>{
            $86defbb4e95ebb07$var$addOnResponseHook(this.xhr, callback);
        };
        /**
     * Deletes a player onRequest callback if it exists
     *
     * @param {function} callback to delete from the player set
     */ this.xhr.offRequest = (callback)=>{
            $86defbb4e95ebb07$var$removeOnRequestHook(this.xhr, callback);
        };
        /**
     * Deletes a player onResponse callback if it exists
     *
     * @param {function} callback to delete from the player set
     */ this.xhr.offResponse = (callback)=>{
            $86defbb4e95ebb07$var$removeOnResponseHook(this.xhr, callback);
        }; // Trigger an event on the player to notify the user that vhs is ready to set xhr hooks.
        // This allows hooks to be set before the source is set to vhs when handleSource is called.
        this.player_.trigger('xhr-hooks-ready');
    }
    attachStreamingEventListeners_() {
        const playlistControllerEvents = [
            'seekablerangeschanged',
            'bufferedrangeschanged',
            'contentsteeringloadstart',
            'contentsteeringloadcomplete',
            'contentsteeringparsed'
        ];
        const playbackWatcher = [
            'gapjumped',
            'playedrangeschanged'
        ]; // re-emit streaming events and payloads on the player.
        playlistControllerEvents.forEach((eventName)=>{
            this.playlistController_.on(eventName, (metadata)=>{
                this.player_.trigger((0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, metadata));
            });
        });
        playbackWatcher.forEach((eventName)=>{
            this.playbackWatcher_.on(eventName, (metadata)=>{
                this.player_.trigger((0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, metadata));
            });
        });
    }
}
/**
 * The Source Handler object, which informs video.js what additional
 * MIME types are supported and sets up playback. It is registered
 * automatically to the appropriate tech based on the capabilities of
 * the browser it is running in. It is not necessary to use or modify
 * this object in normal usage.
 */ const $86defbb4e95ebb07$var$VhsSourceHandler = {
    name: 'videojs-http-streaming',
    VERSION: $86defbb4e95ebb07$var$version$4,
    canHandleSource (srcObj, options = {}) {
        const localOptions = $86defbb4e95ebb07$var$merge($86defbb4e95ebb07$export$2e2bcd8739ae039.options, options); // If not opting to experimentalUseMMS, and playback is only supported with MediaSource, cannot handle source
        if (!localOptions.vhs.experimentalUseMMS && !(0, $34bf5acfb37ee851$export$3ee949df8fbc592f)('avc1.4d400d,mp4a.40.2', false)) return false;
        return $86defbb4e95ebb07$var$VhsSourceHandler.canPlayType(srcObj.type, localOptions);
    },
    handleSource (source, tech, options = {}) {
        const localOptions = $86defbb4e95ebb07$var$merge($86defbb4e95ebb07$export$2e2bcd8739ae039.options, options);
        tech.vhs = new $86defbb4e95ebb07$var$VhsHandler(source, tech, localOptions);
        tech.vhs.xhr = $86defbb4e95ebb07$var$xhrFactory();
        tech.vhs.setupXhrHooks_();
        tech.vhs.src(source.src, source.type);
        return tech.vhs;
    },
    canPlayType (type, options) {
        const simpleType = (0, $fd4a1d4c2e8fc2b7$export$c4f0bf48244d4c05)(type);
        if (!simpleType) return '';
        const overrideNative = $86defbb4e95ebb07$var$VhsSourceHandler.getOverrideNative(options);
        const supportsTypeNatively = $86defbb4e95ebb07$var$Vhs.supportsTypeNatively(simpleType);
        const canUseMsePlayback = !supportsTypeNatively || overrideNative;
        return canUseMsePlayback ? 'maybe' : '';
    },
    getOverrideNative (options = {}) {
        const { vhs: vhs = {} } = options;
        const defaultOverrideNative = !($86defbb4e95ebb07$export$2e2bcd8739ae039.browser.IS_ANY_SAFARI || $86defbb4e95ebb07$export$2e2bcd8739ae039.browser.IS_IOS);
        const { overrideNative: overrideNative = defaultOverrideNative } = vhs;
        return overrideNative;
    }
};
/**
 * Check to see if either the native MediaSource or ManagedMediaSource
 * objectx exist and support an MP4 container with both H.264 video
 * and AAC-LC audio.
 *
 * @return {boolean} if  native media sources are supported
 */ const $86defbb4e95ebb07$var$supportsNativeMediaSources = ()=>{
    return (0, $34bf5acfb37ee851$export$3ee949df8fbc592f)('avc1.4d400d,mp4a.40.2', true);
}; // register source handlers with the appropriate techs
if ($86defbb4e95ebb07$var$supportsNativeMediaSources()) $86defbb4e95ebb07$export$2e2bcd8739ae039.getTech('Html5').registerSourceHandler($86defbb4e95ebb07$var$VhsSourceHandler, 0);
$86defbb4e95ebb07$export$2e2bcd8739ae039.VhsHandler = $86defbb4e95ebb07$var$VhsHandler;
$86defbb4e95ebb07$export$2e2bcd8739ae039.VhsSourceHandler = $86defbb4e95ebb07$var$VhsSourceHandler;
$86defbb4e95ebb07$export$2e2bcd8739ae039.Vhs = $86defbb4e95ebb07$var$Vhs;
if (!$86defbb4e95ebb07$export$2e2bcd8739ae039.use) $86defbb4e95ebb07$export$2e2bcd8739ae039.registerComponent('Vhs', $86defbb4e95ebb07$var$Vhs);
$86defbb4e95ebb07$export$2e2bcd8739ae039.options.vhs = $86defbb4e95ebb07$export$2e2bcd8739ae039.options.vhs || {};
if (!$86defbb4e95ebb07$export$2e2bcd8739ae039.getPlugin || !$86defbb4e95ebb07$export$2e2bcd8739ae039.getPlugin('reloadSourceOnError')) $86defbb4e95ebb07$export$2e2bcd8739ae039.registerPlugin('reloadSourceOnError', $86defbb4e95ebb07$var$reloadSourceOnError);



const $dacfefa78c1d95df$var$playerOptions = {
    width: 800,
    aspectRatio: '16:9',
    controls: true,
    controlsBar: {
        /** devo disattivare eslint perchè il setting viene rispettato
     * da videojs solo se tra apici
     */ // eslint-disable-next-line prettier/prettier
        'pictureInPictureToggle': false
    },
    liveui: true,
    autoplay: 'muted',
    muted: true,
    bigPlayButton: false
};
let $dacfefa78c1d95df$var$mainPlayer;
const $dacfefa78c1d95df$export$99fc290d1cb78a6 = ()=>{
    const videoDiv = document.querySelector('.video-js');
    $dacfefa78c1d95df$var$mainPlayer = (0, $86defbb4e95ebb07$export$2e2bcd8739ae039)(videoDiv, $dacfefa78c1d95df$var$playerOptions, ()=>{
        $dacfefa78c1d95df$var$mainPlayer.src('https://ilsole24ore-d360.akamaized.net/hls/live/2035173/primoround-live-2022/master.m3u8');
        $dacfefa78c1d95df$var$mainPlayer.play();
    });
};
const $dacfefa78c1d95df$export$67c39cca4e2f1c45 = ()=>{
    $dacfefa78c1d95df$var$mainPlayer.dispose();
};
const $dacfefa78c1d95df$export$7f96353fc4f89f6b = ()=>{
    if ($dacfefa78c1d95df$var$mainPlayer && $dacfefa78c1d95df$var$mainPlayer.isFullscreen()) $dacfefa78c1d95df$var$mainPlayer.exitFullscreen();
};


/**
 * Nasconde l'area del countdown
 */ const $e66ab61078edf79f$var$hideCountdown = ()=>{
    const countdownDiv = document.querySelector('div.countdown__wrapper');
    // Prendo il player interno e lo metto in pausa
    const video = countdownDiv.querySelector('video.embed-responsive-item');
    if (countdownDiv) {
        video.pause();
        countdownDiv.classList.add('d-none');
    }
};
/**
 * Questa funzione attiva la modalità live mostrando il video della diretta.
 * return @void
 */ const $e66ab61078edf79f$var$showDiretta = ()=>{
    const direttaLive = document.querySelector('div.diretta__video');
    const contentHead = document.querySelector('div.tf22-content-head');
    const helperText = document.querySelector('div.helper-text .tf22-stream-info');
    if (direttaLive && contentHead) {
        direttaLive.classList.remove('d-none');
        helperText.classList.remove('d-none');
        direttaLive.parentElement.classList.add('tf22-content--stream');
        contentHead.classList.remove('tf22-content-head--sep');
    }
};
/**
 * Nasconde il video della diretta riattivando quello con gli adv
 */ const $e66ab61078edf79f$var$switchOff = ()=>{
    const direttaLive = document.querySelector('div.diretta__video');
    const contentHead = document.querySelector('div.tf22-content-head');
    const countdownArea = document.querySelector('div.countdown__wrapper');
    const helperText = document.querySelector('div.helper-text .tf22-stream-info');
    if (direttaLive && contentHead) {
        direttaLive.classList.add('d-none');
        helperText.classList.add('d-none');
        direttaLive.parentElement.classList.remove('tf22-content--stream');
        contentHead.classList.add('tf22-content-head--sep');
        (0, $dacfefa78c1d95df$export$67c39cca4e2f1c45)();
        // Riattivo la sezione con il video adv rimuovendo l'area countdown
        countdownArea.classList.remove('d-none');
        const countdown = countdownArea.querySelector('.col-lg-7');
        const advVideo = countdownArea.querySelector('.col-lg-5');
        if (countdown && advVideo) {
            countdown.classList.add('d-none');
            advVideo.classList.remove('col-lg-5');
            advVideo.classList.add('col-lg-12');
            // avvio il video con gli adv
            advVideo.querySelector('video').play();
        }
    }
    // Come ultima azione interrompo analytics
    (0, $705ced8733abd5af$export$2e2bcd8739ae039).stopAnalytics();
};
var $e66ab61078edf79f$export$2e2bcd8739ae039 = {
    hideCountdown: $e66ab61078edf79f$var$hideCountdown,
    showDiretta: $e66ab61078edf79f$var$showDiretta,
    switchOff: $e66ab61078edf79f$var$switchOff
};





function $da07a47066bdb9ee$export$2287e3d29250119e(date, amount, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    _date.setTime(_date.getTime() + amount * (0, $6e9d8fa85a388a89$export$91246f0b9bd9beff));
    return _date;
}
var // Fallback for modularized imports:
$da07a47066bdb9ee$export$2e2bcd8739ae039 = $da07a47066bdb9ee$export$2287e3d29250119e;


function $198142539796f4cf$export$d7deef7a3738e19d(date, interval, options) {
    const time = +(0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const [startTime, endTime] = [
        +(0, $5806bcec89744c32$export$e67a095c620b86fe)(interval.start, options?.in),
        +(0, $5806bcec89744c32$export$e67a095c620b86fe)(interval.end, options?.in)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}
var // Fallback for modularized imports:
$198142539796f4cf$export$2e2bcd8739ae039 = $198142539796f4cf$export$d7deef7a3738e19d;


function $33cc6b4550a5ebd0$export$e12a970efb73fce5(date, amount, options) {
    return (0, $da07a47066bdb9ee$export$2287e3d29250119e)(date, -amount, options);
}
var // Fallback for modularized imports:
$33cc6b4550a5ebd0$export$2e2bcd8739ae039 = $33cc6b4550a5ebd0$export$e12a970efb73fce5;





const $a111a280e7a3f1fa$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $a111a280e7a3f1fa$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $a111a280e7a3f1fa$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $a111a280e7a3f1fa$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $a111a280e7a3f1fa$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $a111a280e7a3f1fa$var$timeLongFormatter(timePattern, formatLong));
};
const $a111a280e7a3f1fa$export$70cc8fd02856fd58 = {
    p: $a111a280e7a3f1fa$var$timeLongFormatter,
    P: $a111a280e7a3f1fa$var$dateTimeLongFormatter
};


const $8b24592752d42d9c$var$dayOfYearTokenRE = /^D+$/;
const $8b24592752d42d9c$var$weekYearTokenRE = /^Y+$/;
const $8b24592752d42d9c$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $8b24592752d42d9c$export$c6cc36aa33304772(token) {
    return $8b24592752d42d9c$var$dayOfYearTokenRE.test(token);
}
function $8b24592752d42d9c$export$c6b49d6dceb604a1(token) {
    return $8b24592752d42d9c$var$weekYearTokenRE.test(token);
}
function $8b24592752d42d9c$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $8b24592752d42d9c$var$message(token, format, input);
    console.warn(_message);
    if ($8b24592752d42d9c$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $8b24592752d42d9c$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}




function $d1a080689c5f0d40$export$430a3269e24b912e() {
    return Object.assign({}, (0, $7d20c1ccd7dd6a35$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$d1a080689c5f0d40$export$2e2bcd8739ae039 = $d1a080689c5f0d40$export$430a3269e24b912e;





function $bd4de27a1b5e78ee$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $bd4de27a1b5e78ee$var$isConstructor(constructor) ? new constructor(0) : (0, $94e2600e6614cc67$export$ead8a1812b171991)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $bd4de27a1b5e78ee$var$isConstructor(constructor) {
    return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}
var // Fallback for modularized imports:
$bd4de27a1b5e78ee$export$2e2bcd8739ae039 = $bd4de27a1b5e78ee$export$9cb09a71b7d66923;


const $41f765bb200d544a$var$TIMEZONE_UNIT_PRIORITY = 10;
class $41f765bb200d544a$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $41f765bb200d544a$export$9a09e32dd4990fd5 extends $41f765bb200d544a$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $41f765bb200d544a$export$8be15fe85ad72f86 extends $41f765bb200d544a$export$81d53e3678089a6 {
    priority = $41f765bb200d544a$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    constructor(context, reference){
        super();
        this.context = context || ((date)=>(0, $94e2600e6614cc67$export$ead8a1812b171991)(reference, date));
    }
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $94e2600e6614cc67$export$ead8a1812b171991)(date, (0, $bd4de27a1b5e78ee$export$9cb09a71b7d66923)(date, this.context));
    }
}



class $2fd1b3fa9f226a10$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $41f765bb200d544a$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}


class $c5c58c2bcedebbf1$export$8e5a1d3f85a9688 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}




const $ab634ba02f4ef166$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $ab634ba02f4ef166$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $98d7b6d1a647224d$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $98d7b6d1a647224d$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $98d7b6d1a647224d$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $6e9d8fa85a388a89$export$7f72910d6dfd237a) + minutes * (0, $6e9d8fa85a388a89$export$91246f0b9bd9beff) + seconds * (0, $6e9d8fa85a388a89$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $98d7b6d1a647224d$export$d931c43c4608a164(dateString) {
    return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $ab634ba02f4ef166$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $98d7b6d1a647224d$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $ab634ba02f4ef166$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $ab634ba02f4ef166$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $ab634ba02f4ef166$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $ab634ba02f4ef166$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $98d7b6d1a647224d$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $ab634ba02f4ef166$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $ab634ba02f4ef166$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $ab634ba02f4ef166$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $ab634ba02f4ef166$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $98d7b6d1a647224d$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $98d7b6d1a647224d$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $98d7b6d1a647224d$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


class $fe26312ae949d7e7$export$48d352de7cd4a988 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)((0, $98d7b6d1a647224d$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)((0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $98d7b6d1a647224d$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}






function $19bc147add1de659$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $7d20c1ccd7dd6a35$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$19bc147add1de659$export$2e2bcd8739ae039 = $19bc147add1de659$export$42c81a444fbfb5d4;



function $9f2d4df197546c06$export$12d572480ceb6e58(date, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $7d20c1ccd7dd6a35$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $94e2600e6614cc67$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $19bc147add1de659$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $94e2600e6614cc67$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $19bc147add1de659$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$9f2d4df197546c06$export$2e2bcd8739ae039 = $9f2d4df197546c06$export$12d572480ceb6e58;





class $d771005d0eb7eeef$export$b8ef38dfcf05d5db extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)((0, $98d7b6d1a647224d$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)((0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $9f2d4df197546c06$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $98d7b6d1a647224d$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $19bc147add1de659$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $19bc147add1de659$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}



function $f922ea67b098f800$export$6173213f95a4431e(date, options) {
    return (0, $19bc147add1de659$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$f922ea67b098f800$export$2e2bcd8739ae039 = $f922ea67b098f800$export$6173213f95a4431e;





class $faf6774c01432c8e$export$951d1df011fde06f extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $98d7b6d1a647224d$export$2c9307b2e29c533c)(4, dateString);
        return (0, $98d7b6d1a647224d$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $94e2600e6614cc67$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $f922ea67b098f800$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $3972f5f650221d84$export$bad9d2ea38e8f1a extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $98d7b6d1a647224d$export$2c9307b2e29c533c)(4, dateString);
        return (0, $98d7b6d1a647224d$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $98904429aa0b094e$export$5cb0f701186dde1d extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $606c40b7cb50bbb6$export$300c0c2990e20e6d extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $346eaf77891cc3e0$export$400dd8b40ef138a3 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)((0, $98d7b6d1a647224d$export$cc7cc9e2a3ff9388)((0, $ab634ba02f4ef166$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)((0, $98d7b6d1a647224d$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}





class $40f90cc8b2f5c9e4$export$1d7eaa53eaa5deba extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)((0, $98d7b6d1a647224d$export$cc7cc9e2a3ff9388)((0, $ab634ba02f4ef166$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)((0, $98d7b6d1a647224d$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}








function $6d7445628bc657f6$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $7d20c1ccd7dd6a35$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $9f2d4df197546c06$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $94e2600e6614cc67$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $19bc147add1de659$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$6d7445628bc657f6$export$2e2bcd8739ae039 = $6d7445628bc657f6$export$bb7b45bb8e74da0f;



function $3c6a47f4b80291d0$export$efe19b760242b2fc(date, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $19bc147add1de659$export$42c81a444fbfb5d4)(_date, options) - +(0, $6d7445628bc657f6$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $6e9d8fa85a388a89$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$3c6a47f4b80291d0$export$2e2bcd8739ae039 = $3c6a47f4b80291d0$export$efe19b760242b2fc;



function $0f037b8b4b46fb5c$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $3c6a47f4b80291d0$export$efe19b760242b2fc)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $5806bcec89744c32$export$e67a095c620b86fe)(date_, options?.in);
}
var // Fallback for modularized imports:
$0f037b8b4b46fb5c$export$2e2bcd8739ae039 = $0f037b8b4b46fb5c$export$4b3066ce4afafd88;






class $47f449e66c13a265$export$c4005ffc174e07c0 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $98d7b6d1a647224d$export$cc7cc9e2a3ff9388)((0, $ab634ba02f4ef166$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $19bc147add1de659$export$42c81a444fbfb5d4)((0, $0f037b8b4b46fb5c$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}








function $a36a67fbf4e7f789$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $94e2600e6614cc67$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $f922ea67b098f800$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $94e2600e6614cc67$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $f922ea67b098f800$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$a36a67fbf4e7f789$export$2e2bcd8739ae039 = $a36a67fbf4e7f789$export$3dbc52535f6f8fcc;



function $1390bfa921613bda$export$236bdfa374eb69a9(date, options) {
    const year = (0, $a36a67fbf4e7f789$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $94e2600e6614cc67$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $f922ea67b098f800$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$1390bfa921613bda$export$2e2bcd8739ae039 = $1390bfa921613bda$export$236bdfa374eb69a9;



function $c7378692dfd4ab30$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $f922ea67b098f800$export$6173213f95a4431e)(_date) - +(0, $1390bfa921613bda$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $6e9d8fa85a388a89$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$c7378692dfd4ab30$export$2e2bcd8739ae039 = $c7378692dfd4ab30$export$7cabdc5698b63e2f;



function $7176460089065355$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $c7378692dfd4ab30$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$7176460089065355$export$2e2bcd8739ae039 = $7176460089065355$export$6542bebf6be94082;






class $6160d0faa8efda89$export$6fc8dbedd560a6af extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $98d7b6d1a647224d$export$cc7cc9e2a3ff9388)((0, $ab634ba02f4ef166$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $f922ea67b098f800$export$6173213f95a4431e)((0, $7176460089065355$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}





const $ecc5be5b264591cb$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $ecc5be5b264591cb$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $ecc5be5b264591cb$export$e8d4b28a20981dd2 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $98d7b6d1a647224d$export$cc7cc9e2a3ff9388)((0, $ab634ba02f4ef166$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $98d7b6d1a647224d$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $ecc5be5b264591cb$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $ecc5be5b264591cb$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $52e613ff70efeac9$export$6cfe0d613455f615 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $98d7b6d1a647224d$export$cc7cc9e2a3ff9388)((0, $ab634ba02f4ef166$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $98d7b6d1a647224d$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





function $f562977a5bac0984$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $94e2600e6614cc67$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$f562977a5bac0984$export$2e2bcd8739ae039 = $f562977a5bac0984$export$dd412b56f1e4d8aa;



function $b21eebce3582ac56$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $7d20c1ccd7dd6a35$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const date_ = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $f562977a5bac0984$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$b21eebce3582ac56$export$2e2bcd8739ae039 = $b21eebce3582ac56$export$b04fdcda82decc6c;



class $68344ccfc1ac5f7d$export$1b03c8b76262f7bd extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $b21eebce3582ac56$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $efc5673231dedfdd$export$44d1c127ab42c480 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)((0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $b21eebce3582ac56$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}





class $6da51fe9d8b20690$export$e447a647caaaec1d extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)((0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $b21eebce3582ac56$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}




function $14581097cfa3b846$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$14581097cfa3b846$export$2e2bcd8739ae039 = $14581097cfa3b846$export$c514f4c1a8ed5e9e;



function $99b16b62472d13b2$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = (0, $14581097cfa3b846$export$c514f4c1a8ed5e9e)(date_, options);
    const diff = day - currentDay;
    return (0, $f562977a5bac0984$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$99b16b62472d13b2$export$2e2bcd8739ae039 = $99b16b62472d13b2$export$1fd9df65adb0d1aa;




class $fdc76c097f6cd68b$export$693fb1e525095b2a extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $99b16b62472d13b2$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $dc88239c6feac6f3$export$8d1e08492351df91 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $98d7b6d1a647224d$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $a10c9f024d5ae86e$export$73ca2bd0a17d273 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $98d7b6d1a647224d$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $91b560efdd3bae18$export$bb9212adf05373db extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $98d7b6d1a647224d$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}





class $3fdef242ab121039$export$8a04050a727a1756 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $98d7b6d1a647224d$export$cc7cc9e2a3ff9388)((0, $ab634ba02f4ef166$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $b348ddc307375f53$export$e56f4dea2c3e56dd extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $98d7b6d1a647224d$export$cc7cc9e2a3ff9388)((0, $ab634ba02f4ef166$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $1de6b8c9767b7cf2$export$cbbe855312f87d77 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $98d7b6d1a647224d$export$cc7cc9e2a3ff9388)((0, $ab634ba02f4ef166$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}





class $7a7606d1d349befa$export$6008046d2b34b6a5 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $98d7b6d1a647224d$export$cc7cc9e2a3ff9388)((0, $ab634ba02f4ef166$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}





class $8b8dce150b01caf0$export$2b52670d9e2be53 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $98d7b6d1a647224d$export$cc7cc9e2a3ff9388)((0, $ab634ba02f4ef166$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}





class $53c7803a7379f0da$export$94d46d540cf1366a extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $98d7b6d1a647224d$export$cc7cc9e2a3ff9388)((0, $ab634ba02f4ef166$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}




class $7faab384a61dd982$export$b8e6f8b2d70893b1 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $98d7b6d1a647224d$export$4f84e3a82c7b538)((0, $98d7b6d1a647224d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}







class $bafff02f6dd76726$export$104d901d49fea29b extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $98d7b6d1a647224d$export$6497f4c0ecdfba8e)((0, $ab634ba02f4ef166$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $98d7b6d1a647224d$export$6497f4c0ecdfba8e)((0, $ab634ba02f4ef166$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $98d7b6d1a647224d$export$6497f4c0ecdfba8e)((0, $ab634ba02f4ef166$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $98d7b6d1a647224d$export$6497f4c0ecdfba8e)((0, $ab634ba02f4ef166$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $98d7b6d1a647224d$export$6497f4c0ecdfba8e)((0, $ab634ba02f4ef166$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $94e2600e6614cc67$export$ead8a1812b171991)(date, date.getTime() - (0, $bf76c6c68c67552d$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}







class $2fa25724cac045ce$export$12910e5204b52b9 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $98d7b6d1a647224d$export$6497f4c0ecdfba8e)((0, $ab634ba02f4ef166$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $98d7b6d1a647224d$export$6497f4c0ecdfba8e)((0, $ab634ba02f4ef166$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $98d7b6d1a647224d$export$6497f4c0ecdfba8e)((0, $ab634ba02f4ef166$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $98d7b6d1a647224d$export$6497f4c0ecdfba8e)((0, $ab634ba02f4ef166$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $98d7b6d1a647224d$export$6497f4c0ecdfba8e)((0, $ab634ba02f4ef166$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $94e2600e6614cc67$export$ead8a1812b171991)(date, date.getTime() - (0, $bf76c6c68c67552d$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}





class $03378c78aec26a94$export$2cd8bf877a05e96 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 40;
    parse(dateString) {
        return (0, $98d7b6d1a647224d$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $94e2600e6614cc67$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}





class $454d372c89c9485d$export$6d8f69c6906d6368 extends (0, $2fd1b3fa9f226a10$export$7acfa6ed01010e37) {
    priority = 20;
    parse(dateString) {
        return (0, $98d7b6d1a647224d$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $94e2600e6614cc67$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}


const $ef7f6e5e784e4fa2$export$19131010e7fd8373 = {
    G: new (0, $c5c58c2bcedebbf1$export$8e5a1d3f85a9688)(),
    y: new (0, $fe26312ae949d7e7$export$48d352de7cd4a988)(),
    Y: new (0, $d771005d0eb7eeef$export$b8ef38dfcf05d5db)(),
    R: new (0, $faf6774c01432c8e$export$951d1df011fde06f)(),
    u: new (0, $3972f5f650221d84$export$bad9d2ea38e8f1a)(),
    Q: new (0, $98904429aa0b094e$export$5cb0f701186dde1d)(),
    q: new (0, $606c40b7cb50bbb6$export$300c0c2990e20e6d)(),
    M: new (0, $346eaf77891cc3e0$export$400dd8b40ef138a3)(),
    L: new (0, $40f90cc8b2f5c9e4$export$1d7eaa53eaa5deba)(),
    w: new (0, $47f449e66c13a265$export$c4005ffc174e07c0)(),
    I: new (0, $6160d0faa8efda89$export$6fc8dbedd560a6af)(),
    d: new (0, $ecc5be5b264591cb$export$e8d4b28a20981dd2)(),
    D: new (0, $52e613ff70efeac9$export$6cfe0d613455f615)(),
    E: new (0, $68344ccfc1ac5f7d$export$1b03c8b76262f7bd)(),
    e: new (0, $efc5673231dedfdd$export$44d1c127ab42c480)(),
    c: new (0, $6da51fe9d8b20690$export$e447a647caaaec1d)(),
    i: new (0, $fdc76c097f6cd68b$export$693fb1e525095b2a)(),
    a: new (0, $dc88239c6feac6f3$export$8d1e08492351df91)(),
    b: new (0, $a10c9f024d5ae86e$export$73ca2bd0a17d273)(),
    B: new (0, $91b560efdd3bae18$export$bb9212adf05373db)(),
    h: new (0, $3fdef242ab121039$export$8a04050a727a1756)(),
    H: new (0, $b348ddc307375f53$export$e56f4dea2c3e56dd)(),
    K: new (0, $1de6b8c9767b7cf2$export$cbbe855312f87d77)(),
    k: new (0, $7a7606d1d349befa$export$6008046d2b34b6a5)(),
    m: new (0, $8b8dce150b01caf0$export$2b52670d9e2be53)(),
    s: new (0, $53c7803a7379f0da$export$94d46d540cf1366a)(),
    S: new (0, $7faab384a61dd982$export$b8e6f8b2d70893b1)(),
    X: new (0, $bafff02f6dd76726$export$104d901d49fea29b)(),
    x: new (0, $2fa25724cac045ce$export$12910e5204b52b9)(),
    t: new (0, $03378c78aec26a94$export$2cd8bf877a05e96)(),
    T: new (0, $454d372c89c9485d$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $cdb1f8eb83af40fb$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $cdb1f8eb83af40fb$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $cdb1f8eb83af40fb$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $cdb1f8eb83af40fb$var$doubleQuoteRegExp = /''/g;
const $cdb1f8eb83af40fb$var$notWhitespaceRegExp = /\S/;
const $cdb1f8eb83af40fb$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $cdb1f8eb83af40fb$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const invalidDate = ()=>(0, $94e2600e6614cc67$export$ead8a1812b171991)(options?.in || referenceDate, NaN);
    const defaultOptions = (0, $d1a080689c5f0d40$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $df2dd90e7c50f6a9$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $5806bcec89744c32$export$e67a095c620b86fe)(referenceDate, options?.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $41f765bb200d544a$export$8be15fe85ad72f86)(options?.in, referenceDate)
    ];
    const tokens = formatStr.match($cdb1f8eb83af40fb$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $a111a280e7a3f1fa$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $a111a280e7a3f1fa$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($cdb1f8eb83af40fb$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $8b24592752d42d9c$export$c6b49d6dceb604a1)(token)) (0, $8b24592752d42d9c$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $8b24592752d42d9c$export$c6cc36aa33304772)(token)) (0, $8b24592752d42d9c$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $ef7f6e5e784e4fa2$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($cdb1f8eb83af40fb$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $cdb1f8eb83af40fb$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $cdb1f8eb83af40fb$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(referenceDate, options?.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $cdb1f8eb83af40fb$var$cleanEscapedString(input) {
    return input.match($cdb1f8eb83af40fb$var$escapedStringRegExp)[1].replace($cdb1f8eb83af40fb$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$cdb1f8eb83af40fb$export$2e2bcd8739ae039 = $cdb1f8eb83af40fb$export$98e6a39c04603d36;








function $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$eb904f8e2d8bb2b8$export$2e2bcd8739ae039 = $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2;


function $b60d0a59df25f16c$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $8ed334072e1c80b3$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $bf76c6c68c67552d$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $bf76c6c68c67552d$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $6e9d8fa85a388a89$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$b60d0a59df25f16c$export$2e2bcd8739ae039 = $b60d0a59df25f16c$export$4a02e9c37dab4871;



function $70a914b2bfa6cf87$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$70a914b2bfa6cf87$export$2e2bcd8739ae039 = $70a914b2bfa6cf87$export$f91e89d3d0406102;



function $db8aceab23c59713$export$d3b42cd8452deec(date, options) {
    const _date = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $b60d0a59df25f16c$export$4a02e9c37dab4871)(_date, (0, $70a914b2bfa6cf87$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$db8aceab23c59713$export$2e2bcd8739ae039 = $db8aceab23c59713$export$d3b42cd8452deec;






function $6c7b80446273fbf1$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $f530ec37dbf8665a$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $a61424cc6e7370c5$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $a61424cc6e7370c5$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $9f2d4df197546c06$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $a36a67fbf4e7f789$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $3c6a47f4b80291d0$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $c7378692dfd4ab30$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $db8aceab23c59713$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $f530ec37dbf8665a$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $a61424cc6e7370c5$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $a61424cc6e7370c5$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $a61424cc6e7370c5$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $a61424cc6e7370c5$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $a61424cc6e7370c5$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(minutes, 2);
}
function $a61424cc6e7370c5$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $a61424cc6e7370c5$var$formatTimezone(offset, delimiter);
}
function $a61424cc6e7370c5$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $6c7b80446273fbf1$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}




/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $3a7c1ce5b86d595e$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$3a7c1ce5b86d595e$export$2e2bcd8739ae039 = $3a7c1ce5b86d595e$export$871608497c498473;



function $3feef11dde2315db$export$1ea939691cdc45b8(date) {
    return !(!(0, $3a7c1ce5b86d595e$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $5806bcec89744c32$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$3feef11dde2315db$export$2e2bcd8739ae039 = $3feef11dde2315db$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $d1f6d53b6dcbe5f6$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $d1f6d53b6dcbe5f6$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $d1f6d53b6dcbe5f6$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $d1f6d53b6dcbe5f6$var$doubleQuoteRegExp = /''/g;
const $d1f6d53b6dcbe5f6$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $d1f6d53b6dcbe5f6$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $7d20c1ccd7dd6a35$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $df2dd90e7c50f6a9$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $5806bcec89744c32$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $3feef11dde2315db$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($d1f6d53b6dcbe5f6$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $a111a280e7a3f1fa$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($d1f6d53b6dcbe5f6$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $d1f6d53b6dcbe5f6$var$cleanEscapedString(substring)
        };
        if ((0, $a61424cc6e7370c5$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($d1f6d53b6dcbe5f6$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $8b24592752d42d9c$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $8b24592752d42d9c$export$c6cc36aa33304772)(token)) (0, $8b24592752d42d9c$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $a61424cc6e7370c5$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $d1f6d53b6dcbe5f6$var$cleanEscapedString(input) {
    const matched = input.match($d1f6d53b6dcbe5f6$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($d1f6d53b6dcbe5f6$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$d1f6d53b6dcbe5f6$export$2e2bcd8739ae039 = $d1f6d53b6dcbe5f6$export$d9468344d3651243;



function $42b17b11307caa95$export$90e6cdae187a86ac(length, date, options) {
    const defaultOptions = (0, $d1a080689c5f0d40$export$430a3269e24b912e)();
    const dtf = $42b17b11307caa95$var$getDTF(length, options.timeZone, options.locale ?? defaultOptions.locale);
    return 'formatToParts' in dtf ? $42b17b11307caa95$var$partsTimeZone(dtf, date) : $42b17b11307caa95$var$hackyTimeZone(dtf, date);
}
function $42b17b11307caa95$var$partsTimeZone(dtf, date) {
    const formatted = dtf.formatToParts(date);
    for(let i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
    return undefined;
}
function $42b17b11307caa95$var$hackyTimeZone(dtf, date) {
    const formatted = dtf.format(date).replace(/\u200E/g, '');
    const tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $42b17b11307caa95$var$getDTF(length, timeZone, locale) {
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}


/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $2b7865430f321497$export$6f7bba78170cdfff(date, timeZone) {
    const dtf = $2b7865430f321497$var$getDateTimeFormat(timeZone);
    return 'formatToParts' in dtf ? $2b7865430f321497$var$partsOffset(dtf, date) : $2b7865430f321497$var$hackyOffset(dtf, date);
}
const $2b7865430f321497$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $2b7865430f321497$var$partsOffset(dtf, date) {
    try {
        const formatted = dtf.formatToParts(date);
        const filled = [];
        for(let i = 0; i < formatted.length; i++){
            const pos = $2b7865430f321497$var$typeToPos[formatted[i].type];
            if (pos !== undefined) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $2b7865430f321497$var$hackyOffset(dtf, date) {
    const formatted = dtf.format(date);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // const [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parseInt(parsed[3], 10),
        parseInt(parsed[1], 10),
        parseInt(parsed[2], 10),
        parseInt(parsed[4], 10),
        parseInt(parsed[5], 10),
        parseInt(parsed[6], 10)
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
const $2b7865430f321497$var$dtfCache = {};
// New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
const $2b7865430f321497$var$testDateFormatted = new Intl.DateTimeFormat('en-US', {
    hourCycle: 'h23',
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
}).format(new Date('2014-06-25T04:00:00.123Z'));
const $2b7865430f321497$var$hourCycleSupported = $2b7865430f321497$var$testDateFormatted === '06/25/2014, 00:00:00' || $2b7865430f321497$var$testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
function $2b7865430f321497$var$getDateTimeFormat(timeZone) {
    if (!$2b7865430f321497$var$dtfCache[timeZone]) $2b7865430f321497$var$dtfCache[timeZone] = $2b7865430f321497$var$hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
        hourCycle: 'h23',
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }) : new Intl.DateTimeFormat('en-US', {
        hour12: false,
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
    return $2b7865430f321497$var$dtfCache[timeZone];
}


/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $96c90c1aba4060a2$export$461165d00818234e(fullYear, month, day, hour, minute, second, millisecond) {
    const utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}


const $0e90e1307f8b40e4$var$MILLISECONDS_IN_HOUR = 3600000;
const $0e90e1307f8b40e4$var$MILLISECONDS_IN_MINUTE = 60000;
const $0e90e1307f8b40e4$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $0e90e1307f8b40e4$export$57649162eea44a93(timezoneString, date, isUtcDate) {
    // Empty string
    if (!timezoneString) return 0;
    // Z
    let token = $0e90e1307f8b40e4$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    let hours;
    let absoluteOffset;
    // ±hh
    token = $0e90e1307f8b40e4$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$0e90e1307f8b40e4$var$validateTimezone(hours)) return NaN;
        return -(hours * $0e90e1307f8b40e4$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $0e90e1307f8b40e4$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        const minutes = parseInt(token[3], 10);
        if (!$0e90e1307f8b40e4$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $0e90e1307f8b40e4$var$MILLISECONDS_IN_HOUR + minutes * $0e90e1307f8b40e4$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($0e90e1307f8b40e4$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        const utcDate = isUtcDate ? date : $0e90e1307f8b40e4$var$toUtcDate(date);
        const offset = $0e90e1307f8b40e4$var$calcOffset(utcDate, timezoneString);
        const fixedOffset = isUtcDate ? offset : $0e90e1307f8b40e4$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $0e90e1307f8b40e4$var$toUtcDate(date) {
    return (0, $96c90c1aba4060a2$export$461165d00818234e)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $0e90e1307f8b40e4$var$calcOffset(date, timezoneString) {
    const tokens = (0, $2b7865430f321497$export$6f7bba78170cdfff)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    const asUTC = (0, $96c90c1aba4060a2$export$461165d00818234e)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    let asTS = date.getTime();
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $0e90e1307f8b40e4$var$fixOffset(date, offset, timezoneString) {
    const localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    let utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    const o2 = $0e90e1307f8b40e4$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    const o3 = $0e90e1307f8b40e4$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $0e90e1307f8b40e4$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
const $0e90e1307f8b40e4$var$validIANATimezoneCache = {};
function $0e90e1307f8b40e4$var$isValidTimezoneIANAString(timeZoneString) {
    if ($0e90e1307f8b40e4$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $0e90e1307f8b40e4$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}


const $75397b95bd056ec8$var$MILLISECONDS_IN_MINUTE = 60000;
const $75397b95bd056ec8$export$fe98a034cfb96d55 = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, options) {
        const timezoneOffset = $75397b95bd056ec8$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $75397b95bd056ec8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $75397b95bd056ec8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $75397b95bd056ec8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, options) {
        const timezoneOffset = $75397b95bd056ec8$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $75397b95bd056ec8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $75397b95bd056ec8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $75397b95bd056ec8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, options) {
        const timezoneOffset = $75397b95bd056ec8$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $75397b95bd056ec8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $75397b95bd056ec8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $42b17b11307caa95$export$90e6cdae187a86ac)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $42b17b11307caa95$export$90e6cdae187a86ac)('long', date, options);
        }
    }
};
function $75397b95bd056ec8$var$getTimeZoneOffset(timeZone, originalDate) {
    const timeZoneOffset = timeZone ? (0, $0e90e1307f8b40e4$export$57649162eea44a93)(timeZone, originalDate, true) / $75397b95bd056ec8$var$MILLISECONDS_IN_MINUTE : originalDate?.getTimezoneOffset() ?? 0;
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $75397b95bd056ec8$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? '-' : '';
    let output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $75397b95bd056ec8$var$formatTimezone(offset, delimiter = '') {
    const sign = offset > 0 ? '-' : '+';
    const absOffset = Math.abs(offset);
    const hours = $75397b95bd056ec8$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    const minutes = $75397b95bd056ec8$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimiter + minutes;
}
function $75397b95bd056ec8$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? '-' : '+';
        return sign + $75397b95bd056ec8$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $75397b95bd056ec8$var$formatTimezone(offset, delimiter);
}
function $75397b95bd056ec8$var$formatTimezoneShort(offset, delimiter = '') {
    const sign = offset > 0 ? '-' : '+';
    const absOffset = Math.abs(offset);
    const hours = Math.floor(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + $75397b95bd056ec8$var$addLeadingZeros(minutes, 2);
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $bef409ee3eb39487$export$113002b5eff6e430(date) {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return +date - +utcDate;
}



/** Regex to identify the presence of a time zone specifier in a date string */ const $f9a0cd8a687d8af8$export$a859e97a80802e41 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;


const $6b0cd02ed6451f72$var$MILLISECONDS_IN_HOUR = 3600000;
const $6b0cd02ed6451f72$var$MILLISECONDS_IN_MINUTE = 60000;
const $6b0cd02ed6451f72$var$DEFAULT_ADDITIONAL_DIGITS = 2;
const $6b0cd02ed6451f72$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $f9a0cd8a687d8af8$export$a859e97a80802e41)
};
function $6b0cd02ed6451f72$export$e67a095c620b86fe(argument, options = {}) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    const additionalDigits = options.additionalDigits == null ? $6b0cd02ed6451f72$var$DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    const dateStrings = $6b0cd02ed6451f72$var$splitDateString(argument);
    const { year: year, restDateString: restDateString } = $6b0cd02ed6451f72$var$parseYear(dateStrings.date, additionalDigits);
    const date = $6b0cd02ed6451f72$var$parseDate(restDateString, year);
    if (date === null || isNaN(date.getTime())) return new Date(NaN);
    if (date) {
        const timestamp = date.getTime();
        let time = 0;
        let offset;
        if (dateStrings.time) {
            time = $6b0cd02ed6451f72$var$parseTime(dateStrings.time);
            if (time === null || isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $0e90e1307f8b40e4$export$57649162eea44a93)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, $bef409ee3eb39487$export$113002b5eff6e430)(new Date(timestamp + time));
            offset = (0, $bef409ee3eb39487$export$113002b5eff6e430)(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $6b0cd02ed6451f72$var$splitDateString(dateString) {
    const dateStrings = {};
    let parts = $6b0cd02ed6451f72$var$patterns.dateTimePattern.exec(dateString);
    let timeString;
    if (!parts) {
        parts = $6b0cd02ed6451f72$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        const token = $6b0cd02ed6451f72$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $6b0cd02ed6451f72$var$parseYear(dateString, additionalDigits) {
    if (dateString) {
        const patternYYY = $6b0cd02ed6451f72$var$patterns.YYY[additionalDigits];
        const patternYYYYY = $6b0cd02ed6451f72$var$patterns.YYYYY[additionalDigits];
        // YYYY or ±YYYYY
        let token = $6b0cd02ed6451f72$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            const yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        // YY or ±YYY
        token = $6b0cd02ed6451f72$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            const centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $6b0cd02ed6451f72$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    let date;
    let month;
    let week;
    // YYYY
    if (!dateString || !dateString.length) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    let token = $6b0cd02ed6451f72$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$6b0cd02ed6451f72$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $6b0cd02ed6451f72$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        const dayOfYear = parseInt(token[1], 10);
        if (!$6b0cd02ed6451f72$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $6b0cd02ed6451f72$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        const day = parseInt(token[2], 10);
        if (!$6b0cd02ed6451f72$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $6b0cd02ed6451f72$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$6b0cd02ed6451f72$var$validateWeekDate(week)) return new Date(NaN);
        return $6b0cd02ed6451f72$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $6b0cd02ed6451f72$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        const dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$6b0cd02ed6451f72$var$validateWeekDate(week, dayOfWeek)) return new Date(NaN);
        return $6b0cd02ed6451f72$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $6b0cd02ed6451f72$var$parseTime(timeString) {
    let hours;
    let minutes;
    // hh
    let token = $6b0cd02ed6451f72$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$6b0cd02ed6451f72$var$validateTime(hours)) return NaN;
        return hours % 24 * $6b0cd02ed6451f72$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $6b0cd02ed6451f72$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$6b0cd02ed6451f72$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $6b0cd02ed6451f72$var$MILLISECONDS_IN_HOUR + minutes * $6b0cd02ed6451f72$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $6b0cd02ed6451f72$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        const seconds = parseFloat(token[3].replace(',', '.'));
        if (!$6b0cd02ed6451f72$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $6b0cd02ed6451f72$var$MILLISECONDS_IN_HOUR + minutes * $6b0cd02ed6451f72$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $6b0cd02ed6451f72$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
const $6b0cd02ed6451f72$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $6b0cd02ed6451f72$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $6b0cd02ed6451f72$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $6b0cd02ed6451f72$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        const isLeapYear = $6b0cd02ed6451f72$var$isLeapYearIndex(year);
        if (isLeapYear && date > $6b0cd02ed6451f72$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $6b0cd02ed6451f72$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $6b0cd02ed6451f72$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    const isLeapYear = $6b0cd02ed6451f72$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $6b0cd02ed6451f72$var$validateWeekDate(week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $6b0cd02ed6451f72$var$validateTime(hours, minutes, seconds) {
    if (hours < 0 || hours >= 25) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}


const $3aa79ebf3e2d6dab$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $3aa79ebf3e2d6dab$export$d9468344d3651243(date, formatStr, options = {}) {
    formatStr = String(formatStr);
    const matches = formatStr.match($3aa79ebf3e2d6dab$var$tzFormattingTokensRegExp);
    if (matches) {
        const d = (0, $6b0cd02ed6451f72$export$e67a095c620b86fe)(options.originalDate || date, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result; // This is a quoted portion, matched only to ensure we don't match inside it
            const pos = result.indexOf(token);
            const precededByQuotedSection = result[pos - 1] === "'";
            const replaced = result.replace(token, "'" + (0, $75397b95bd056ec8$export$fe98a034cfb96d55)[token[0]](d, token, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, $d1f6d53b6dcbe5f6$export$d9468344d3651243)(date, formatStr, options);
}





function $1ac9ce7983f26363$export$3ee79d090bac6d33(date, timeZone, options) {
    date = (0, $6b0cd02ed6451f72$export$e67a095c620b86fe)(date, options);
    const offsetMilliseconds = (0, $0e90e1307f8b40e4$export$57649162eea44a93)(timeZone, date, true);
    const d = new Date(date.getTime() - offsetMilliseconds);
    const resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}


function $20d6ded5c93e1459$export$b3ea52468069e196(date, timeZone, formatStr, options) {
    options = {
        ...options,
        timeZone: timeZone,
        originalDate: date
    };
    return (0, $3aa79ebf3e2d6dab$export$d9468344d3651243)((0, $1ac9ce7983f26363$export$3ee79d090bac6d33)(date, timeZone, {
        timeZone: options.timeZone
    }), formatStr, options);
}






function $952ed55040a5dee1$export$7e1e8af4bb294f2b(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, $f9a0cd8a687d8af8$export$a859e97a80802e41))) return (0, $6b0cd02ed6451f72$export$e67a095c620b86fe)(date, {
        ...options,
        timeZone: timeZone
    });
    date = (0, $6b0cd02ed6451f72$export$e67a095c620b86fe)(date, options);
    const utc = (0, $96c90c1aba4060a2$export$461165d00818234e)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()).getTime();
    const offsetMilliseconds = (0, $0e90e1307f8b40e4$export$57649162eea44a93)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}




function $749a358805504027$export$4c9db454e2785fd9(timeZone, date) {
    return -(0, $0e90e1307f8b40e4$export$57649162eea44a93)(timeZone, date);
}






/**
 * Ritorna un'oggetto Date shiftato
 * di un delta random di max +/-5 minuti
 *
 * @param string time Tempo del check, da intendersi come ora locale.
 * @param Date referenceDate oggetto Date per recuperare le info non presenti nella stringa time.
 *
 * @returns Date
 */ const $6195a837cf7f7d69$var$getDeltaDate = (time, referenceDate)=>{
    // Creo un oggetto Date che abbia l'orario del verifyTime
    const itaDate = (0, $cdb1f8eb83af40fb$export$98e6a39c04603d36)(time, 'HH:mm', referenceDate);
    // La data creata è relativa al timezone italiano, la converto nel timezone locale
    let localDate = (0, $952ed55040a5dee1$export$7e1e8af4bb294f2b)(itaDate, 'Europe/Rome');
    let delta = Math.floor(Math.random() * 6);
    delta *= Math.round(Math.random()) ? 1 : -1;
    return (0, $da07a47066bdb9ee$export$2287e3d29250119e)(localDate, delta);
};
const $6195a837cf7f7d69$var$getVerifyTimes = (currentTime)=>{
    console.error('Verify times not set!');
    $9409895355f874f2$exports.captureException(new Error('verify times not set'));
    const timesArray = "".split(';');
    return timesArray.reduce((carry, check, index)=>{
        carry[`check${index + 1}`] = $6195a837cf7f7d69$var$getDeltaDate(check, currentTime);
        return carry;
    }, {});
};
var $6195a837cf7f7d69$export$2e2bcd8739ae039 = {
    getVerifyTimes: $6195a837cf7f7d69$var$getVerifyTimes
};




let $adf35b2a0ed830d0$var$currentUserId;
let $adf35b2a0ed830d0$var$currentVid;
let $adf35b2a0ed830d0$var$modal;
let $adf35b2a0ed830d0$var$modalTimeout;
let $adf35b2a0ed830d0$var$verifyBtn;
/**
 * Funzione che imposta i check per la verifica delle presenze.
 */ const $adf35b2a0ed830d0$var$setTimeoutChecks = ()=>{
    const now = new Date();
    const verifyTimes = (0, $6195a837cf7f7d69$export$2e2bcd8739ae039).getVerifyTimes(now);
    (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', `scheduled checks are ${verifyTimes}`);
    (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', verifyTimes);
    Object.keys(verifyTimes).forEach((vid)=>{
        if (!(0, $829d18796c975ba8$export$fc5014aa3db48558)(verifyTimes[vid])) {
            const diffInMilliseconds = (0, $80c50a0a80ea8dc0$export$7be94d13716b4bf6)(verifyTimes[vid], now.getTime());
            setTimeout(()=>{
                $adf35b2a0ed830d0$var$showModal(vid, verifyTimes[vid]);
            }, diffInMilliseconds);
        }
    });
    (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', 'Timeout checks enabled.');
};
/**
 * Fa apparire la modale.
 */ const $adf35b2a0ed830d0$var$showModal = (vid, checkDate)=>{
    const currentTime = new Date();
    const infOffsetTime = (0, $33cc6b4550a5ebd0$export$e12a970efb73fce5)(checkDate, 1);
    const supOffsetTime = (0, $da07a47066bdb9ee$export$2287e3d29250119e)(checkDate, 2);
    /**
   * Questo check serve ad evitare l'apparizione modale
   * su Safari Mobile che triggera eventi che dovrebbero essere
   * expired quando si mette in evidenza la pagina (ad esempio cambio tag oppure uscendo dalla sospensione).
   *
   * Dato che il trigger non parte nell'esatto momento indicato dal check,
   * ma può partire qualche millisecondo prima o dopo, devo prevedere
   * un intervallo tra 1 min prima e 2 min dopo il tempo del check.
   *
   * Quest'ultima accortezza garantisce che la modale appaia quando la pagina è in evidenza.
   */ const isWithinTwoMinutes = (0, $198142539796f4cf$export$d7deef7a3738e19d)(currentTime, {
        start: infOffsetTime,
        end: supOffsetTime
    });
    if (!$adf35b2a0ed830d0$var$modal || !isWithinTwoMinutes) {
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', `modal not showed for check ${vid} because modal does not exists or check not within two minutes interval`);
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', `current time: ${currentTime}`);
        (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', `check trigger time: ${checkDate}`);
        return;
    }
    (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', `showing modal for check ${vid}`);
    $9409895355f874f2$exports.addBreadcrumb({
        category: 'analytics',
        message: `enabled modal for check ${vid}`,
        level: 'info'
    });
    // tolgo il fullscreen se presente.
    (0, $dacfefa78c1d95df$export$7f96353fc4f89f6b)();
    $adf35b2a0ed830d0$var$currentVid = vid;
    $adf35b2a0ed830d0$var$modal.classList.add('show');
    // Imposto la chiusura della modale in un minuto:
    $adf35b2a0ed830d0$var$modalTimeout = setTimeout($adf35b2a0ed830d0$var$hideModal, 60000);
};
/**
 * Chiude la modale.
 */ const $adf35b2a0ed830d0$var$hideModal = ()=>{
    if (!$adf35b2a0ed830d0$var$modal) return;
    $adf35b2a0ed830d0$var$modal.classList.remove('show');
    (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', 'closing modal...');
    $9409895355f874f2$exports.addBreadcrumb({
        category: 'analytics',
        message: 'closing modal...',
        level: 'info'
    });
    clearTimeout($adf35b2a0ed830d0$var$modalTimeout);
};
/**
 * Invia al server il check utente.
 */ const $adf35b2a0ed830d0$var$sendVerify = async ()=>{
    try {
        $adf35b2a0ed830d0$var$verifyBtn.disabled = true;
        await (0, $5926607b0b06e94b$export$2e2bcd8739ae039).confirmPresence($adf35b2a0ed830d0$var$currentUserId, $adf35b2a0ed830d0$var$currentVid);
    } catch (error) {
        console.error(error.message);
    } finally{
        $adf35b2a0ed830d0$var$verifyBtn.disabled = false;
        $adf35b2a0ed830d0$var$hideModal();
    }
};
/**
 * Inizializza il modulo.
 */ const $adf35b2a0ed830d0$var$init = (userId)=>{
    $adf35b2a0ed830d0$var$currentUserId = userId;
    $adf35b2a0ed830d0$var$modal = document.querySelector('.check__modal');
    if ($adf35b2a0ed830d0$var$modal) {
        $adf35b2a0ed830d0$var$verifyBtn = $adf35b2a0ed830d0$var$modal.querySelector('button.btn');
        if ($adf35b2a0ed830d0$var$verifyBtn) $adf35b2a0ed830d0$var$verifyBtn.addEventListener('click', $adf35b2a0ed830d0$var$sendVerify);
    }
    $adf35b2a0ed830d0$var$setTimeoutChecks();
};
var $adf35b2a0ed830d0$export$2e2bcd8739ae039 = {
    init: $adf35b2a0ed830d0$var$init
};



const $a7a70c556a5854d0$var$ONE_DAY = 86400;
const $a7a70c556a5854d0$var$ONE_HOUR = 3600;
const $a7a70c556a5854d0$var$ONE_MINUTE = 60;
let $a7a70c556a5854d0$var$timerInterval;
let $a7a70c556a5854d0$var$DEADLINE;
try {
    /**
   * Se sono in dev setto lo start_event ad un minuto dalla data di accesso
   * utente e lo switchoff a 12 minuti dalla data di accesso
   */ $a7a70c556a5854d0$var$DEADLINE = (0, $7dcb966690c372e6$export$4393d2ccbbedb219)("2026-09-24T07:00:00.000Z");
} catch (err) {
    $9409895355f874f2$exports.captureException(err);
    (0, $36980ba006f5b698$export$2e2bcd8739ae039)('error', err);
    // Se fallisce setto io la deadline
    $a7a70c556a5854d0$var$DEADLINE = new Date(2022, 5, 15, 9, 0, 0);
}
var $a7a70c556a5854d0$var$newDate;
const $a7a70c556a5854d0$var$startTimer = (userId, endEvent)=>{
    try {
        const clockDiv = document.querySelector('.tf22-wait-clock');
        const daysDiv = clockDiv.querySelector('.clock--days');
        const hoursDiv = clockDiv.querySelector('.clock--hours');
        const minutesDiv = clockDiv.querySelector('.clock--minutes');
        const secondsDiv = clockDiv.querySelector('.clock--seconds');
        // Setup del currentTime
        const currentTime = new Date().getTime();
        // Prendo la differenza in secondi tra le 2 date
        const diffInSeconds = (0, $55000f1a72ca0916$export$c1889aec51783710)($a7a70c556a5854d0$var$DEADLINE, currentTime);
        if (diffInSeconds <= 0) {
            // faccio il clearInterval e lo switch delle risorse
            daysDiv.innerHTML = '0';
            hoursDiv.innerHTML = '0';
            minutesDiv.innerHTML = '0';
            secondsDiv.innerHTML = '0';
            clearInterval($a7a70c556a5854d0$var$timerInterval);
            (0, $e66ab61078edf79f$export$2e2bcd8739ae039).hideCountdown();
            (0, $e66ab61078edf79f$export$2e2bcd8739ae039).showDiretta();
            window.analyticsJob = (0, $705ced8733abd5af$export$2e2bcd8739ae039).init(userId, endEvent);
        }
        const days = Math.floor(diffInSeconds / $a7a70c556a5854d0$var$ONE_DAY);
        const hours = Math.floor((diffInSeconds - days * $a7a70c556a5854d0$var$ONE_DAY) / $a7a70c556a5854d0$var$ONE_HOUR);
        const minutes = Math.floor((diffInSeconds - days * $a7a70c556a5854d0$var$ONE_DAY - hours * $a7a70c556a5854d0$var$ONE_HOUR) / $a7a70c556a5854d0$var$ONE_MINUTE);
        const seconds = diffInSeconds - days * $a7a70c556a5854d0$var$ONE_DAY - hours * $a7a70c556a5854d0$var$ONE_HOUR - minutes * $a7a70c556a5854d0$var$ONE_MINUTE;
        daysDiv.innerHTML = days <= 9 ? `0${days}` : days;
        hoursDiv.innerHTML = hours <= 9 ? `0${hours}` : hours;
        minutesDiv.innerHTML = minutes <= 9 ? `0${minutes}` : minutes;
        secondsDiv.innerHTML = seconds <= 9 ? `0${seconds}` : seconds;
    } catch  {
        // Catch per gestire eventuali errori durante il countdown
        clearInterval($a7a70c556a5854d0$var$timerInterval);
        if (!(0, $55000f1a72ca0916$export$c1889aec51783710)($a7a70c556a5854d0$var$DEADLINE, new Date().getTime()) > 0) {
            // Se il tempo non è scaduto, provo a rieseguire il countdown
            $a7a70c556a5854d0$var$init(userId, endEvent);
            return;
        }
        // Se il tempo è scaduto e l'analytics non è partito, lo avvio
        if (!window.analyticsJob) window.analyticsJob = (0, $705ced8733abd5af$export$2e2bcd8739ae039).init(userId, endEvent);
    }
};
const $a7a70c556a5854d0$var$init = (userId, endEvent)=>{
    $a7a70c556a5854d0$var$timerInterval = setInterval($a7a70c556a5854d0$var$startTimer, 1000, userId, endEvent);
};
var $a7a70c556a5854d0$export$2e2bcd8739ae039 = {
    init: $a7a70c556a5854d0$var$init
};





const $0026cc5aa8359700$var$REDIRECT_LINK = `${"https://eventotelefisco.ilsole24ore.com/index.html"}?error=true&ErrMsg=Utente+non+valido`;
let $0026cc5aa8359700$var$START_EVENT;
let $0026cc5aa8359700$var$END_EVENT;
try {
    /**
   * Se sono in dev setto lo start_event ad un minuto dalla data di accesso
   * utente e lo switchoff a 12 minuti dalla data di accesso
   */ const currentDate = new Date();
    $0026cc5aa8359700$var$START_EVENT = (0, $7dcb966690c372e6$export$4393d2ccbbedb219)("2026-09-24T07:00:00.000Z");
    $0026cc5aa8359700$var$END_EVENT = (0, $7dcb966690c372e6$export$4393d2ccbbedb219)("2026-09-24T12:00:00.000Z");
} catch (err) {
    $9409895355f874f2$exports.captureException(err);
    (0, $36980ba006f5b698$export$2e2bcd8739ae039)('error', err);
    // Se fallisce qualcosa setto io le date
    $0026cc5aa8359700$var$START_EVENT = new Date(2022, 5, 15, 9, 0, 0);
    $0026cc5aa8359700$var$END_EVENT = new Date(2022, 5, 15, 13, 0, 0, 0);
}
(0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', `Event will go live at ${$0026cc5aa8359700$var$START_EVENT}`);
(0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', `Event will go off at ${$0026cc5aa8359700$var$END_EVENT}`);
let $0026cc5aa8359700$var$switchOffTimeout = null;
var $0026cc5aa8359700$var$endDate;
$f692584d7e6adcb2$export$2cd8252107eb640b({
    dsn: "https://038a6ef96a00458e8a17df4a40845ae2@o234395.ingest.sentry.io/6145941",
    integrations: [
        $dbc03a1d427b8584$export$b4109253475213e9()
    ],
    tracesSampleRate: 0,
    environment: "Prod",
    release: "90a2b1516a81c829763f03367e23d0dac9c0b265",
    denyUrls: [
        'local-streaming.ilsole24ore.com'
    ]
});
const $0026cc5aa8359700$var$setSwitchOffTimeout = (endDate)=>{
    const now = new Date();
    const diffInMilliseconds = (0, $80c50a0a80ea8dc0$export$7be94d13716b4bf6)(endDate, now.getTime());
    const formattedDistance = (0, $4794d0aab3c34b75$export$e4be225b8ee0a759)(now, endDate, {
        unit: 'minute'
    });
    (0, $36980ba006f5b698$export$2e2bcd8739ae039)('debug', `END EVENT is at ${endDate}, switching off in ${formattedDistance} (${diffInMilliseconds} milliseconds)`);
    $0026cc5aa8359700$var$switchOffTimeout = setTimeout((0, $e66ab61078edf79f$export$2e2bcd8739ae039).switchOff, diffInMilliseconds);
};
const $0026cc5aa8359700$var$initApp = async ()=>{
    window.analyticsJob = null;
    let userId;
    try {
        // Faccio il check dell'utente
        $9409895355f874f2$exports.addBreadcrumb({
            category: 'auth',
            message: 'App ready, checking user auth...',
            level: 'info'
        });
        userId = await (0, $5926607b0b06e94b$export$2e2bcd8739ae039).getUserId();
        if (!userId) {
            // Utente non valido, lo butto fuori.
            $9409895355f874f2$exports.addBreadcrumb({
                category: 'auth',
                message: 'Invalid user, bail out...',
                level: 'warning'
            });
            (0, $36980ba006f5b698$export$2e2bcd8739ae039)('warn', `Invalid user, bail out...`);
            window.location = $0026cc5aa8359700$var$REDIRECT_LINK;
            return;
        }
        // Setto lo user su Sentry
        $9409895355f874f2$exports.addBreadcrumb({
            category: 'auth',
            message: 'The user is valid, starting Analytics...',
            level: 'info'
        });
        $9409895355f874f2$exports.setUser({
            id: userId
        });
        // Faccio il setup del player
        (0, $dacfefa78c1d95df$export$99fc290d1cb78a6)();
        if ((0, $829d18796c975ba8$export$fc5014aa3db48558)($0026cc5aa8359700$var$END_EVENT)) {
            // L'evento è concluso faccio solo switchoff
            (0, $e66ab61078edf79f$export$2e2bcd8739ae039).switchOff();
            return;
        }
        if (!(0, $829d18796c975ba8$export$fc5014aa3db48558)($0026cc5aa8359700$var$START_EVENT)) {
            // Sono in waitingRoom, faccio partire countdown + video embed
            (0, $a7a70c556a5854d0$export$2e2bcd8739ae039).init(userId, $0026cc5aa8359700$var$END_EVENT);
            if (!(0, $829d18796c975ba8$export$fc5014aa3db48558)($0026cc5aa8359700$var$END_EVENT)) // Faccio il setup per lo switchoff dell'evento
            $0026cc5aa8359700$var$setSwitchOffTimeout($0026cc5aa8359700$var$END_EVENT);
            return;
        }
        // Non sono in waitingRoom, carico iframe streaming
        (0, $e66ab61078edf79f$export$2e2bcd8739ae039).hideCountdown();
        (0, $e66ab61078edf79f$export$2e2bcd8739ae039).showDiretta();
        // Parte il cron degli analytics
        window.analyticsJob = (0, $705ced8733abd5af$export$2e2bcd8739ae039).init(userId, $0026cc5aa8359700$var$END_EVENT);
        if (!(0, $829d18796c975ba8$export$fc5014aa3db48558)($0026cc5aa8359700$var$END_EVENT)) // Faccio il setup per lo switchoff dell'evento
        $0026cc5aa8359700$var$setSwitchOffTimeout($0026cc5aa8359700$var$END_EVENT);
    } catch (err) {
        $9409895355f874f2$exports.captureException(err);
        // Se l'id non è definito, faccio redirect alla pagina di iscrizione
        if (!userId) {
            window.location = $0026cc5aa8359700$var$REDIRECT_LINK;
            return;
        }
        // Nel caso il job non sia partito o si sia interrotto, lo faccio ripartire
        if (!window.analyticsJob) $0026cc5aa8359700$var$initApp();
    }
};
document.addEventListener('DOMContentLoaded', $0026cc5aa8359700$var$initApp);

})();
//# sourceMappingURL=main.js.map
